import React, { createElement, useRef, useState, useEffect } from 'react';

// Encode a number in Base 62
function base62Encode(num, alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789") {
    if (num === 0)
        return alphabet[0];
    let arr = [];
    const base = alphabet.length;
    while (num > 0) {
        let rem = num % base;
        num = Math.floor(num / base);
        arr.push(alphabet[rem]);
    }
    return arr.reverse().join("");
}
// Generate a semi-readable unique ID
function generateRandomId(timestampLength = 8, randomLength = 4) {
    // Encode current time to base62
    const now = new Date().getTime();
    const timestampPart = base62Encode(now).slice(-timestampLength);
    // Generate random alphanumeric string
    const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let randomPart = "";
    for (let i = 0; i < randomLength; i++) {
        randomPart += characters.charAt(Math.floor(Math.random() * characters.length));
    }
    return timestampPart + randomPart;
}
function checkFunctionId(id) {
    return /^[a-z0-9\-]{3,32}\/[a-z0-9\-]{1,32}\/[a-zA-Z0-9:\-\s]{2,32}$/.test(id);
}

let Context$2 = class Context {
    project;
    assetMap;
    dependencies;
    warnings;
    // A map of runtime nodes keyed on the node id.
    runtimeNodes;
    // A mpa of initializer functions keyed on the fully qualified function id.
    initializers;
    portValues;
    clientId;
    instanceId;
    constructor(project, assetMap, dependencies) {
        this.project = project;
        this.assetMap = assetMap;
        this.dependencies = dependencies;
        this.warnings = [];
        this.runtimeNodes = new Map();
        this.initializers = new Map();
        this.portValues = new Map();
        this.clientId = generateRandomId();
        this.instanceId = 0;
    }
    generateId() {
        return `${this.clientId}:${this.instanceId++}`;
    }
    lookupItemByName(fqId) {
        if (!checkFunctionId(fqId)) {
            throw new Error(`Invalid function id: ${fqId}`);
        }
        const [userId, projectId, itemName] = fqId.split("/");
        let project;
        if (userId === "self" && projectId === "self") {
            project = this.project;
        }
        else {
            project = this.dependencies.get(`${userId}/${projectId}`);
        }
        if (!project) {
            throw new Error(`Dependency not found: ${fqId}`);
        }
        const item = project.items.find((item) => item.name === itemName);
        return item;
    }
    lookupItemById(fqId) {
        if (!checkFunctionId(fqId)) {
            throw new Error(`Invalid function id: ${fqId}`);
        }
        const [userId, projectId, itemId] = fqId.split("/");
        let project;
        if (userId === "self" && projectId === "self") {
            project = this.project;
        }
        else {
            project = this.dependencies.get(`${userId}/${projectId}`);
        }
        if (!project) {
            throw new Error(`Dependency not found: ${fqId}`);
        }
        const item = project.items.find((item) => item.id === itemId);
        if (!item) {
            throw new Error(`Item not found: ${fqId}`);
        }
        return item;
    }
};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

var dist$2 = {exports: {}};

var dist$1 = dist$2.exports;

var hasRequiredDist;

function requireDist () {
	if (hasRequiredDist) return dist$2.exports;
	hasRequiredDist = 1;
	(function (module, exports) {
		(function (global, factory) {
		  module.exports = factory() ;
		})(dist$1, function () {

		  function createCommonjsModule(fn, module) {
		    return module = {
		      exports: {}
		    }, fn(module, module.exports), module.exports;
		  }
		  var _global = createCommonjsModule(function (module) {
		    // https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
		    var global = module.exports = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self
		    // eslint-disable-next-line no-new-func
		    : Function('return this')();
		    if (typeof __g == 'number') {
		      __g = global;
		    } // eslint-disable-line no-undef
		  });
		  var _core = createCommonjsModule(function (module) {
		    var core = module.exports = {
		      version: '2.6.5'
		    };
		    if (typeof __e == 'number') {
		      __e = core;
		    } // eslint-disable-line no-undef
		  });
		  _core.version;
		  var _isObject = function (it) {
		    return typeof it === 'object' ? it !== null : typeof it === 'function';
		  };
		  var _anObject = function (it) {
		    if (!_isObject(it)) {
		      throw TypeError(it + ' is not an object!');
		    }
		    return it;
		  };
		  var _fails = function (exec) {
		    try {
		      return !!exec();
		    } catch (e) {
		      return true;
		    }
		  };

		  // Thank's IE8 for his funny defineProperty
		  var _descriptors = !_fails(function () {
		    return Object.defineProperty({}, 'a', {
		      get: function () {
		        return 7;
		      }
		    }).a != 7;
		  });
		  var document = _global.document;
		  // typeof document.createElement is 'object' in old IE
		  var is = _isObject(document) && _isObject(document.createElement);
		  var _domCreate = function (it) {
		    return is ? document.createElement(it) : {};
		  };
		  var _ie8DomDefine = !_descriptors && !_fails(function () {
		    return Object.defineProperty(_domCreate('div'), 'a', {
		      get: function () {
		        return 7;
		      }
		    }).a != 7;
		  });

		  // 7.1.1 ToPrimitive(input [, PreferredType])

		  // instead of the ES6 spec version, we didn't implement @@toPrimitive case
		  // and the second argument - flag - preferred type is a string
		  var _toPrimitive = function (it, S) {
		    if (!_isObject(it)) {
		      return it;
		    }
		    var fn, val;
		    if (typeof (fn = it.toString) == 'function' && !_isObject(val = fn.call(it))) {
		      return val;
		    }
		    if (typeof (fn = it.valueOf) == 'function' && !_isObject(val = fn.call(it))) {
		      return val;
		    }
		    throw TypeError("Can't convert object to primitive value");
		  };
		  var dP = Object.defineProperty;
		  var f = _descriptors ? Object.defineProperty : function defineProperty(O, P, Attributes) {
		    _anObject(O);
		    P = _toPrimitive(P);
		    _anObject(Attributes);
		    if (_ie8DomDefine) {
		      try {
		        return dP(O, P, Attributes);
		      } catch (e) {/* empty */}
		    }
		    if ('get' in Attributes || 'set' in Attributes) {
		      throw TypeError('Accessors not supported!');
		    }
		    if ('value' in Attributes) {
		      O[P] = Attributes.value;
		    }
		    return O;
		  };
		  var _objectDp = {
		    f: f
		  };
		  var _propertyDesc = function (bitmap, value) {
		    return {
		      enumerable: false,
		      configurable: true,
		      writable: true,
		      value: value
		    };
		  };
		  var _hide = _descriptors ? function (object, key, value) {
		    return _objectDp.f(object, key, _propertyDesc(1, value));
		  } : function (object, key, value) {
		    object[key] = value;
		    return object;
		  };
		  var hasOwnProperty = {}.hasOwnProperty;
		  var _has = function (it, key) {
		    return hasOwnProperty.call(it, key);
		  };
		  var id = 0;
		  var px = Math.random();
		  var _uid = function (key) {
		    return 'Symbol('.concat(key, ')_', (++id + px).toString(36));
		  };
		  var _shared = createCommonjsModule(function (module) {
		    var SHARED = '__core-js_shared__';
		    var store = _global[SHARED] || (_global[SHARED] = {});
		    (module.exports = function (key, value) {
		      return store[key] || (store[key] = value !== undefined ? value : {});
		    })('versions', []).push({
		      version: _core.version,
		      mode: 'global',
		      copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
		    });
		  });
		  var _functionToString = _shared('native-function-to-string', Function.toString);
		  var _redefine = createCommonjsModule(function (module) {
		    var SRC = _uid('src');
		    var TO_STRING = 'toString';
		    var TPL = ('' + _functionToString).split(TO_STRING);
		    _core.inspectSource = function (it) {
		      return _functionToString.call(it);
		    };
		    (module.exports = function (O, key, val, safe) {
		      var isFunction = typeof val == 'function';
		      if (isFunction) {
		        _has(val, 'name') || _hide(val, 'name', key);
		      }
		      if (O[key] === val) {
		        return;
		      }
		      if (isFunction) {
		        _has(val, SRC) || _hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
		      }
		      if (O === _global) {
		        O[key] = val;
		      } else if (!safe) {
		        delete O[key];
		        _hide(O, key, val);
		      } else if (O[key]) {
		        O[key] = val;
		      } else {
		        _hide(O, key, val);
		      }
		      // add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
		    })(Function.prototype, TO_STRING, function toString() {
		      return typeof this == 'function' && this[SRC] || _functionToString.call(this);
		    });
		  });
		  var _aFunction = function (it) {
		    if (typeof it != 'function') {
		      throw TypeError(it + ' is not a function!');
		    }
		    return it;
		  };

		  // optional / simple context binding

		  var _ctx = function (fn, that, length) {
		    _aFunction(fn);
		    if (that === undefined) {
		      return fn;
		    }
		    switch (length) {
		      case 1:
		        return function (a) {
		          return fn.call(that, a);
		        };
		      case 2:
		        return function (a, b) {
		          return fn.call(that, a, b);
		        };
		      case 3:
		        return function (a, b, c) {
		          return fn.call(that, a, b, c);
		        };
		    }
		    return function /* ...args */
		    () {
		      return fn.apply(that, arguments);
		    };
		  };
		  var PROTOTYPE = 'prototype';
		  var $export = function (type, name, source) {
		    var IS_FORCED = type & $export.F;
		    var IS_GLOBAL = type & $export.G;
		    var IS_STATIC = type & $export.S;
		    var IS_PROTO = type & $export.P;
		    var IS_BIND = type & $export.B;
		    var target = IS_GLOBAL ? _global : IS_STATIC ? _global[name] || (_global[name] = {}) : (_global[name] || {})[PROTOTYPE];
		    var exports = IS_GLOBAL ? _core : _core[name] || (_core[name] = {});
		    var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
		    var key, own, out, exp;
		    if (IS_GLOBAL) {
		      source = name;
		    }
		    for (key in source) {
		      // contains in native
		      own = !IS_FORCED && target && target[key] !== undefined;
		      // export native or passed
		      out = (own ? target : source)[key];
		      // bind timers to global for call from export context
		      exp = IS_BIND && own ? _ctx(out, _global) : IS_PROTO && typeof out == 'function' ? _ctx(Function.call, out) : out;
		      // extend global
		      if (target) {
		        _redefine(target, key, out, type & $export.U);
		      }
		      // export
		      if (exports[key] != out) {
		        _hide(exports, key, exp);
		      }
		      if (IS_PROTO && expProto[key] != out) {
		        expProto[key] = out;
		      }
		    }
		  };
		  _global.core = _core;
		  // type bitmap
		  $export.F = 1; // forced
		  $export.G = 2; // global
		  $export.S = 4; // static
		  $export.P = 8; // proto
		  $export.B = 16; // bind
		  $export.W = 32; // wrap
		  $export.U = 64; // safe
		  $export.R = 128; // real proto method for `library`
		  var _export = $export;

		  // 7.1.4 ToInteger
		  var ceil = Math.ceil;
		  var floor = Math.floor;
		  var _toInteger = function (it) {
		    return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
		  };

		  // 7.2.1 RequireObjectCoercible(argument)
		  var _defined = function (it) {
		    if (it == undefined) {
		      throw TypeError("Can't call method on  " + it);
		    }
		    return it;
		  };

		  // true  -> String#at
		  // false -> String#codePointAt
		  var _stringAt = function (TO_STRING) {
		    return function (that, pos) {
		      var s = String(_defined(that));
		      var i = _toInteger(pos);
		      var l = s.length;
		      var a, b;
		      if (i < 0 || i >= l) {
		        return undefined;
		      }
		      a = s.charCodeAt(i);
		      return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff ? a : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
		    };
		  };
		  var $at = _stringAt();
		  _export(_export.P, 'String', {
		    // 21.1.3.3 String.prototype.codePointAt(pos)
		    codePointAt: function codePointAt(pos) {
		      return $at(this, pos);
		    }
		  });
		  _core.String.codePointAt;
		  var max = Math.max;
		  var min = Math.min;
		  var _toAbsoluteIndex = function (index, length) {
		    index = _toInteger(index);
		    return index < 0 ? max(index + length, 0) : min(index, length);
		  };
		  var fromCharCode = String.fromCharCode;
		  var $fromCodePoint = String.fromCodePoint;

		  // length should be 1, old FF problem
		  _export(_export.S + _export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
		    // 21.1.2.2 String.fromCodePoint(...codePoints)
		    fromCodePoint: function fromCodePoint(x) {
		      var arguments$1 = arguments;
		      // eslint-disable-line no-unused-vars
		      var res = [];
		      var aLen = arguments.length;
		      var i = 0;
		      var code;
		      while (aLen > i) {
		        code = +arguments$1[i++];
		        if (_toAbsoluteIndex(code, 0x10ffff) !== code) {
		          throw RangeError(code + ' is not a valid code point');
		        }
		        res.push(code < 0x10000 ? fromCharCode(code) : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00));
		      }
		      return res.join('');
		    }
		  });
		  _core.String.fromCodePoint;

		  // This is a generated file. Do not edit.
		  var Space_Separator = /[\u1680\u2000-\u200A\u202F\u205F\u3000]/;
		  var ID_Start = /[\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312E\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FEA\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD40-\uDD74\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF2D-\uDF4A\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2]|\uD804[\uDC03-\uDC37\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE2B\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE80-\uDEAA\uDF00-\uDF19]|\uD806[\uDCA0-\uDCDF\uDCFF\uDE00\uDE0B-\uDE32\uDE3A\uDE50\uDE5C-\uDE83\uDE86-\uDE89\uDEC0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC72-\uDC8F\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD30\uDD46]|\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC80-\uDD43]|[\uD80C\uD81C-\uD820\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDF00-\uDF44\uDF50\uDF93-\uDF9F\uDFE0\uDFE1]|\uD821[\uDC00-\uDFEC]|\uD822[\uDC00-\uDEF2]|\uD82C[\uDC00-\uDD1E\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD83A[\uDC00-\uDCC4\uDD00-\uDD43]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0]|\uD87E[\uDC00-\uDE1D]/;
		  var ID_Continue = /[\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0300-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u0483-\u0487\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u05D0-\u05EA\u05F0-\u05F2\u0610-\u061A\u0620-\u0669\u066E-\u06D3\u06D5-\u06DC\u06DF-\u06E8\u06EA-\u06FC\u06FF\u0710-\u074A\u074D-\u07B1\u07C0-\u07F5\u07FA\u0800-\u082D\u0840-\u085B\u0860-\u086A\u08A0-\u08B4\u08B6-\u08BD\u08D4-\u08E1\u08E3-\u0963\u0966-\u096F\u0971-\u0983\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BC-\u09C4\u09C7\u09C8\u09CB-\u09CE\u09D7\u09DC\u09DD\u09DF-\u09E3\u09E6-\u09F1\u09FC\u0A01-\u0A03\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A59-\u0A5C\u0A5E\u0A66-\u0A75\u0A81-\u0A83\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABC-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AD0\u0AE0-\u0AE3\u0AE6-\u0AEF\u0AF9-\u0AFF\u0B01-\u0B03\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3C-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B56\u0B57\u0B5C\u0B5D\u0B5F-\u0B63\u0B66-\u0B6F\u0B71\u0B82\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD0\u0BD7\u0BE6-\u0BEF\u0C00-\u0C03\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C58-\u0C5A\u0C60-\u0C63\u0C66-\u0C6F\u0C80-\u0C83\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBC-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CDE\u0CE0-\u0CE3\u0CE6-\u0CEF\u0CF1\u0CF2\u0D00-\u0D03\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D44\u0D46-\u0D48\u0D4A-\u0D4E\u0D54-\u0D57\u0D5F-\u0D63\u0D66-\u0D6F\u0D7A-\u0D7F\u0D82\u0D83\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DE6-\u0DEF\u0DF2\u0DF3\u0E01-\u0E3A\u0E40-\u0E4E\u0E50-\u0E59\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB9\u0EBB-\u0EBD\u0EC0-\u0EC4\u0EC6\u0EC8-\u0ECD\u0ED0-\u0ED9\u0EDC-\u0EDF\u0F00\u0F18\u0F19\u0F20-\u0F29\u0F35\u0F37\u0F39\u0F3E-\u0F47\u0F49-\u0F6C\u0F71-\u0F84\u0F86-\u0F97\u0F99-\u0FBC\u0FC6\u1000-\u1049\u1050-\u109D\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u135D-\u135F\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1714\u1720-\u1734\u1740-\u1753\u1760-\u176C\u176E-\u1770\u1772\u1773\u1780-\u17D3\u17D7\u17DC\u17DD\u17E0-\u17E9\u180B-\u180D\u1810-\u1819\u1820-\u1877\u1880-\u18AA\u18B0-\u18F5\u1900-\u191E\u1920-\u192B\u1930-\u193B\u1946-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u19D0-\u19D9\u1A00-\u1A1B\u1A20-\u1A5E\u1A60-\u1A7C\u1A7F-\u1A89\u1A90-\u1A99\u1AA7\u1AB0-\u1ABD\u1B00-\u1B4B\u1B50-\u1B59\u1B6B-\u1B73\u1B80-\u1BF3\u1C00-\u1C37\u1C40-\u1C49\u1C4D-\u1C7D\u1C80-\u1C88\u1CD0-\u1CD2\u1CD4-\u1CF9\u1D00-\u1DF9\u1DFB-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u203F\u2040\u2054\u2071\u207F\u2090-\u209C\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D7F-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2DE0-\u2DFF\u2E2F\u3005-\u3007\u3021-\u302F\u3031-\u3035\u3038-\u303C\u3041-\u3096\u3099\u309A\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312E\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FEA\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA62B\uA640-\uA66F\uA674-\uA67D\uA67F-\uA6F1\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA827\uA840-\uA873\uA880-\uA8C5\uA8D0-\uA8D9\uA8E0-\uA8F7\uA8FB\uA8FD\uA900-\uA92D\uA930-\uA953\uA960-\uA97C\uA980-\uA9C0\uA9CF-\uA9D9\uA9E0-\uA9FE\uAA00-\uAA36\uAA40-\uAA4D\uAA50-\uAA59\uAA60-\uAA76\uAA7A-\uAAC2\uAADB-\uAADD\uAAE0-\uAAEF\uAAF2-\uAAF6\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABEA\uABEC\uABED\uABF0-\uABF9\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE00-\uFE0F\uFE20-\uFE2F\uFE33\uFE34\uFE4D-\uFE4F\uFE70-\uFE74\uFE76-\uFEFC\uFF10-\uFF19\uFF21-\uFF3A\uFF3F\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD40-\uDD74\uDDFD\uDE80-\uDE9C\uDEA0-\uDED0\uDEE0\uDF00-\uDF1F\uDF2D-\uDF4A\uDF50-\uDF7A\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDCA0-\uDCA9\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00-\uDE03\uDE05\uDE06\uDE0C-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE38-\uDE3A\uDE3F\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE6\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2]|\uD804[\uDC00-\uDC46\uDC66-\uDC6F\uDC7F-\uDCBA\uDCD0-\uDCE8\uDCF0-\uDCF9\uDD00-\uDD34\uDD36-\uDD3F\uDD50-\uDD73\uDD76\uDD80-\uDDC4\uDDCA-\uDDCC\uDDD0-\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE37\uDE3E\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEEA\uDEF0-\uDEF9\uDF00-\uDF03\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3C-\uDF44\uDF47\uDF48\uDF4B-\uDF4D\uDF50\uDF57\uDF5D-\uDF63\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC00-\uDC4A\uDC50-\uDC59\uDC80-\uDCC5\uDCC7\uDCD0-\uDCD9\uDD80-\uDDB5\uDDB8-\uDDC0\uDDD8-\uDDDD\uDE00-\uDE40\uDE44\uDE50-\uDE59\uDE80-\uDEB7\uDEC0-\uDEC9\uDF00-\uDF19\uDF1D-\uDF2B\uDF30-\uDF39]|\uD806[\uDCA0-\uDCE9\uDCFF\uDE00-\uDE3E\uDE47\uDE50-\uDE83\uDE86-\uDE99\uDEC0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC36\uDC38-\uDC40\uDC50-\uDC59\uDC72-\uDC8F\uDC92-\uDCA7\uDCA9-\uDCB6\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD36\uDD3A\uDD3C\uDD3D\uDD3F-\uDD47\uDD50-\uDD59]|\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC80-\uDD43]|[\uD80C\uD81C-\uD820\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE60-\uDE69\uDED0-\uDEED\uDEF0-\uDEF4\uDF00-\uDF36\uDF40-\uDF43\uDF50-\uDF59\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDF00-\uDF44\uDF50-\uDF7E\uDF8F-\uDF9F\uDFE0\uDFE1]|\uD821[\uDC00-\uDFEC]|\uD822[\uDC00-\uDEF2]|\uD82C[\uDC00-\uDD1E\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99\uDC9D\uDC9E]|\uD834[\uDD65-\uDD69\uDD6D-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB\uDFCE-\uDFFF]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A]|\uD83A[\uDC00-\uDCC4\uDCD0-\uDCD6\uDD00-\uDD4A\uDD50-\uDD59]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0]|\uD87E[\uDC00-\uDE1D]|\uDB40[\uDD00-\uDDEF]/;
		  var unicode = {
		    Space_Separator: Space_Separator,
		    ID_Start: ID_Start,
		    ID_Continue: ID_Continue
		  };
		  var util = {
		    isSpaceSeparator: function isSpaceSeparator(c) {
		      return typeof c === 'string' && unicode.Space_Separator.test(c);
		    },
		    isIdStartChar: function isIdStartChar(c) {
		      return typeof c === 'string' && (c >= 'a' && c <= 'z' || c >= 'A' && c <= 'Z' || c === '$' || c === '_' || unicode.ID_Start.test(c));
		    },
		    isIdContinueChar: function isIdContinueChar(c) {
		      return typeof c === 'string' && (c >= 'a' && c <= 'z' || c >= 'A' && c <= 'Z' || c >= '0' && c <= '9' || c === '$' || c === '_' || c === '\u200C' || c === '\u200D' || unicode.ID_Continue.test(c));
		    },
		    isDigit: function isDigit(c) {
		      return typeof c === 'string' && /[0-9]/.test(c);
		    },
		    isHexDigit: function isHexDigit(c) {
		      return typeof c === 'string' && /[0-9A-Fa-f]/.test(c);
		    }
		  };
		  var source;
		  var parseState;
		  var stack;
		  var pos;
		  var line;
		  var column;
		  var token;
		  var key;
		  var root;
		  var parse = function parse(text, reviver) {
		    source = String(text);
		    parseState = 'start';
		    stack = [];
		    pos = 0;
		    line = 1;
		    column = 0;
		    token = undefined;
		    key = undefined;
		    root = undefined;
		    do {
		      token = lex();

		      // This code is unreachable.
		      // if (!parseStates[parseState]) {
		      //     throw invalidParseState()
		      // }

		      parseStates[parseState]();
		    } while (token.type !== 'eof');
		    if (typeof reviver === 'function') {
		      return internalize({
		        '': root
		      }, '', reviver);
		    }
		    return root;
		  };
		  function internalize(holder, name, reviver) {
		    var value = holder[name];
		    if (value != null && typeof value === 'object') {
		      if (Array.isArray(value)) {
		        for (var i = 0; i < value.length; i++) {
		          var key = String(i);
		          var replacement = internalize(value, key, reviver);
		          if (replacement === undefined) {
		            delete value[key];
		          } else {
		            Object.defineProperty(value, key, {
		              value: replacement,
		              writable: true,
		              enumerable: true,
		              configurable: true
		            });
		          }
		        }
		      } else {
		        for (var key$1 in value) {
		          var replacement$1 = internalize(value, key$1, reviver);
		          if (replacement$1 === undefined) {
		            delete value[key$1];
		          } else {
		            Object.defineProperty(value, key$1, {
		              value: replacement$1,
		              writable: true,
		              enumerable: true,
		              configurable: true
		            });
		          }
		        }
		      }
		    }
		    return reviver.call(holder, name, value);
		  }
		  var lexState;
		  var buffer;
		  var doubleQuote;
		  var sign;
		  var c;
		  function lex() {
		    lexState = 'default';
		    buffer = '';
		    doubleQuote = false;
		    sign = 1;
		    for (;;) {
		      c = peek();

		      // This code is unreachable.
		      // if (!lexStates[lexState]) {
		      //     throw invalidLexState(lexState)
		      // }

		      var token = lexStates[lexState]();
		      if (token) {
		        return token;
		      }
		    }
		  }
		  function peek() {
		    if (source[pos]) {
		      return String.fromCodePoint(source.codePointAt(pos));
		    }
		  }
		  function read() {
		    var c = peek();
		    if (c === '\n') {
		      line++;
		      column = 0;
		    } else if (c) {
		      column += c.length;
		    } else {
		      column++;
		    }
		    if (c) {
		      pos += c.length;
		    }
		    return c;
		  }
		  var lexStates = {
		    default: function default$1() {
		      switch (c) {
		        case '\t':
		        case '\v':
		        case '\f':
		        case ' ':
		        case '\u00A0':
		        case '\uFEFF':
		        case '\n':
		        case '\r':
		        case '\u2028':
		        case '\u2029':
		          read();
		          return;
		        case '/':
		          read();
		          lexState = 'comment';
		          return;
		        case undefined:
		          read();
		          return newToken('eof');
		      }
		      if (util.isSpaceSeparator(c)) {
		        read();
		        return;
		      }

		      // This code is unreachable.
		      // if (!lexStates[parseState]) {
		      //     throw invalidLexState(parseState)
		      // }

		      return lexStates[parseState]();
		    },
		    comment: function comment() {
		      switch (c) {
		        case '*':
		          read();
		          lexState = 'multiLineComment';
		          return;
		        case '/':
		          read();
		          lexState = 'singleLineComment';
		          return;
		      }
		      throw invalidChar(read());
		    },
		    multiLineComment: function multiLineComment() {
		      switch (c) {
		        case '*':
		          read();
		          lexState = 'multiLineCommentAsterisk';
		          return;
		        case undefined:
		          throw invalidChar(read());
		      }
		      read();
		    },
		    multiLineCommentAsterisk: function multiLineCommentAsterisk() {
		      switch (c) {
		        case '*':
		          read();
		          return;
		        case '/':
		          read();
		          lexState = 'default';
		          return;
		        case undefined:
		          throw invalidChar(read());
		      }
		      read();
		      lexState = 'multiLineComment';
		    },
		    singleLineComment: function singleLineComment() {
		      switch (c) {
		        case '\n':
		        case '\r':
		        case '\u2028':
		        case '\u2029':
		          read();
		          lexState = 'default';
		          return;
		        case undefined:
		          read();
		          return newToken('eof');
		      }
		      read();
		    },
		    value: function value() {
		      switch (c) {
		        case '{':
		        case '[':
		          return newToken('punctuator', read());
		        case 'n':
		          read();
		          literal('ull');
		          return newToken('null', null);
		        case 't':
		          read();
		          literal('rue');
		          return newToken('boolean', true);
		        case 'f':
		          read();
		          literal('alse');
		          return newToken('boolean', false);
		        case '-':
		        case '+':
		          if (read() === '-') {
		            sign = -1;
		          }
		          lexState = 'sign';
		          return;
		        case '.':
		          buffer = read();
		          lexState = 'decimalPointLeading';
		          return;
		        case '0':
		          buffer = read();
		          lexState = 'zero';
		          return;
		        case '1':
		        case '2':
		        case '3':
		        case '4':
		        case '5':
		        case '6':
		        case '7':
		        case '8':
		        case '9':
		          buffer = read();
		          lexState = 'decimalInteger';
		          return;
		        case 'I':
		          read();
		          literal('nfinity');
		          return newToken('numeric', Infinity);
		        case 'N':
		          read();
		          literal('aN');
		          return newToken('numeric', NaN);
		        case '"':
		        case "'":
		          doubleQuote = read() === '"';
		          buffer = '';
		          lexState = 'string';
		          return;
		      }
		      throw invalidChar(read());
		    },
		    identifierNameStartEscape: function identifierNameStartEscape() {
		      if (c !== 'u') {
		        throw invalidChar(read());
		      }
		      read();
		      var u = unicodeEscape();
		      switch (u) {
		        case '$':
		        case '_':
		          break;
		        default:
		          if (!util.isIdStartChar(u)) {
		            throw invalidIdentifier();
		          }
		          break;
		      }
		      buffer += u;
		      lexState = 'identifierName';
		    },
		    identifierName: function identifierName() {
		      switch (c) {
		        case '$':
		        case '_':
		        case '\u200C':
		        case '\u200D':
		          buffer += read();
		          return;
		        case '\\':
		          read();
		          lexState = 'identifierNameEscape';
		          return;
		      }
		      if (util.isIdContinueChar(c)) {
		        buffer += read();
		        return;
		      }
		      return newToken('identifier', buffer);
		    },
		    identifierNameEscape: function identifierNameEscape() {
		      if (c !== 'u') {
		        throw invalidChar(read());
		      }
		      read();
		      var u = unicodeEscape();
		      switch (u) {
		        case '$':
		        case '_':
		        case '\u200C':
		        case '\u200D':
		          break;
		        default:
		          if (!util.isIdContinueChar(u)) {
		            throw invalidIdentifier();
		          }
		          break;
		      }
		      buffer += u;
		      lexState = 'identifierName';
		    },
		    sign: function sign$1() {
		      switch (c) {
		        case '.':
		          buffer = read();
		          lexState = 'decimalPointLeading';
		          return;
		        case '0':
		          buffer = read();
		          lexState = 'zero';
		          return;
		        case '1':
		        case '2':
		        case '3':
		        case '4':
		        case '5':
		        case '6':
		        case '7':
		        case '8':
		        case '9':
		          buffer = read();
		          lexState = 'decimalInteger';
		          return;
		        case 'I':
		          read();
		          literal('nfinity');
		          return newToken('numeric', sign * Infinity);
		        case 'N':
		          read();
		          literal('aN');
		          return newToken('numeric', NaN);
		      }
		      throw invalidChar(read());
		    },
		    zero: function zero() {
		      switch (c) {
		        case '.':
		          buffer += read();
		          lexState = 'decimalPoint';
		          return;
		        case 'e':
		        case 'E':
		          buffer += read();
		          lexState = 'decimalExponent';
		          return;
		        case 'x':
		        case 'X':
		          buffer += read();
		          lexState = 'hexadecimal';
		          return;
		      }
		      return newToken('numeric', sign * 0);
		    },
		    decimalInteger: function decimalInteger() {
		      switch (c) {
		        case '.':
		          buffer += read();
		          lexState = 'decimalPoint';
		          return;
		        case 'e':
		        case 'E':
		          buffer += read();
		          lexState = 'decimalExponent';
		          return;
		      }
		      if (util.isDigit(c)) {
		        buffer += read();
		        return;
		      }
		      return newToken('numeric', sign * Number(buffer));
		    },
		    decimalPointLeading: function decimalPointLeading() {
		      if (util.isDigit(c)) {
		        buffer += read();
		        lexState = 'decimalFraction';
		        return;
		      }
		      throw invalidChar(read());
		    },
		    decimalPoint: function decimalPoint() {
		      switch (c) {
		        case 'e':
		        case 'E':
		          buffer += read();
		          lexState = 'decimalExponent';
		          return;
		      }
		      if (util.isDigit(c)) {
		        buffer += read();
		        lexState = 'decimalFraction';
		        return;
		      }
		      return newToken('numeric', sign * Number(buffer));
		    },
		    decimalFraction: function decimalFraction() {
		      switch (c) {
		        case 'e':
		        case 'E':
		          buffer += read();
		          lexState = 'decimalExponent';
		          return;
		      }
		      if (util.isDigit(c)) {
		        buffer += read();
		        return;
		      }
		      return newToken('numeric', sign * Number(buffer));
		    },
		    decimalExponent: function decimalExponent() {
		      switch (c) {
		        case '+':
		        case '-':
		          buffer += read();
		          lexState = 'decimalExponentSign';
		          return;
		      }
		      if (util.isDigit(c)) {
		        buffer += read();
		        lexState = 'decimalExponentInteger';
		        return;
		      }
		      throw invalidChar(read());
		    },
		    decimalExponentSign: function decimalExponentSign() {
		      if (util.isDigit(c)) {
		        buffer += read();
		        lexState = 'decimalExponentInteger';
		        return;
		      }
		      throw invalidChar(read());
		    },
		    decimalExponentInteger: function decimalExponentInteger() {
		      if (util.isDigit(c)) {
		        buffer += read();
		        return;
		      }
		      return newToken('numeric', sign * Number(buffer));
		    },
		    hexadecimal: function hexadecimal() {
		      if (util.isHexDigit(c)) {
		        buffer += read();
		        lexState = 'hexadecimalInteger';
		        return;
		      }
		      throw invalidChar(read());
		    },
		    hexadecimalInteger: function hexadecimalInteger() {
		      if (util.isHexDigit(c)) {
		        buffer += read();
		        return;
		      }
		      return newToken('numeric', sign * Number(buffer));
		    },
		    string: function string() {
		      switch (c) {
		        case '\\':
		          read();
		          buffer += escape();
		          return;
		        case '"':
		          if (doubleQuote) {
		            read();
		            return newToken('string', buffer);
		          }
		          buffer += read();
		          return;
		        case "'":
		          if (!doubleQuote) {
		            read();
		            return newToken('string', buffer);
		          }
		          buffer += read();
		          return;
		        case '\n':
		        case '\r':
		          throw invalidChar(read());
		        case '\u2028':
		        case '\u2029':
		          separatorChar(c);
		          break;
		        case undefined:
		          throw invalidChar(read());
		      }
		      buffer += read();
		    },
		    start: function start() {
		      switch (c) {
		        case '{':
		        case '[':
		          return newToken('punctuator', read());

		        // This code is unreachable since the default lexState handles eof.
		        // case undefined:
		        //     return newToken('eof')
		      }
		      lexState = 'value';
		    },
		    beforePropertyName: function beforePropertyName() {
		      switch (c) {
		        case '$':
		        case '_':
		          buffer = read();
		          lexState = 'identifierName';
		          return;
		        case '\\':
		          read();
		          lexState = 'identifierNameStartEscape';
		          return;
		        case '}':
		          return newToken('punctuator', read());
		        case '"':
		        case "'":
		          doubleQuote = read() === '"';
		          lexState = 'string';
		          return;
		      }
		      if (util.isIdStartChar(c)) {
		        buffer += read();
		        lexState = 'identifierName';
		        return;
		      }
		      throw invalidChar(read());
		    },
		    afterPropertyName: function afterPropertyName() {
		      if (c === ':') {
		        return newToken('punctuator', read());
		      }
		      throw invalidChar(read());
		    },
		    beforePropertyValue: function beforePropertyValue() {
		      lexState = 'value';
		    },
		    afterPropertyValue: function afterPropertyValue() {
		      switch (c) {
		        case ',':
		        case '}':
		          return newToken('punctuator', read());
		      }
		      throw invalidChar(read());
		    },
		    beforeArrayValue: function beforeArrayValue() {
		      if (c === ']') {
		        return newToken('punctuator', read());
		      }
		      lexState = 'value';
		    },
		    afterArrayValue: function afterArrayValue() {
		      switch (c) {
		        case ',':
		        case ']':
		          return newToken('punctuator', read());
		      }
		      throw invalidChar(read());
		    },
		    end: function end() {
		      // This code is unreachable since it's handled by the default lexState.
		      // if (c === undefined) {
		      //     read()
		      //     return newToken('eof')
		      // }

		      throw invalidChar(read());
		    }
		  };
		  function newToken(type, value) {
		    return {
		      type: type,
		      value: value,
		      line: line,
		      column: column
		    };
		  }
		  function literal(s) {
		    for (var i = 0, list = s; i < list.length; i += 1) {
		      var c = list[i];
		      var p = peek();
		      if (p !== c) {
		        throw invalidChar(read());
		      }
		      read();
		    }
		  }
		  function escape() {
		    var c = peek();
		    switch (c) {
		      case 'b':
		        read();
		        return '\b';
		      case 'f':
		        read();
		        return '\f';
		      case 'n':
		        read();
		        return '\n';
		      case 'r':
		        read();
		        return '\r';
		      case 't':
		        read();
		        return '\t';
		      case 'v':
		        read();
		        return '\v';
		      case '0':
		        read();
		        if (util.isDigit(peek())) {
		          throw invalidChar(read());
		        }
		        return '\0';
		      case 'x':
		        read();
		        return hexEscape();
		      case 'u':
		        read();
		        return unicodeEscape();
		      case '\n':
		      case '\u2028':
		      case '\u2029':
		        read();
		        return '';
		      case '\r':
		        read();
		        if (peek() === '\n') {
		          read();
		        }
		        return '';
		      case '1':
		      case '2':
		      case '3':
		      case '4':
		      case '5':
		      case '6':
		      case '7':
		      case '8':
		      case '9':
		        throw invalidChar(read());
		      case undefined:
		        throw invalidChar(read());
		    }
		    return read();
		  }
		  function hexEscape() {
		    var buffer = '';
		    var c = peek();
		    if (!util.isHexDigit(c)) {
		      throw invalidChar(read());
		    }
		    buffer += read();
		    c = peek();
		    if (!util.isHexDigit(c)) {
		      throw invalidChar(read());
		    }
		    buffer += read();
		    return String.fromCodePoint(parseInt(buffer, 16));
		  }
		  function unicodeEscape() {
		    var buffer = '';
		    var count = 4;
		    while (count-- > 0) {
		      var c = peek();
		      if (!util.isHexDigit(c)) {
		        throw invalidChar(read());
		      }
		      buffer += read();
		    }
		    return String.fromCodePoint(parseInt(buffer, 16));
		  }
		  var parseStates = {
		    start: function start() {
		      if (token.type === 'eof') {
		        throw invalidEOF();
		      }
		      push();
		    },
		    beforePropertyName: function beforePropertyName() {
		      switch (token.type) {
		        case 'identifier':
		        case 'string':
		          key = token.value;
		          parseState = 'afterPropertyName';
		          return;
		        case 'punctuator':
		          // This code is unreachable since it's handled by the lexState.
		          // if (token.value !== '}') {
		          //     throw invalidToken()
		          // }

		          pop();
		          return;
		        case 'eof':
		          throw invalidEOF();
		      }

		      // This code is unreachable since it's handled by the lexState.
		      // throw invalidToken()
		    },
		    afterPropertyName: function afterPropertyName() {
		      // This code is unreachable since it's handled by the lexState.
		      // if (token.type !== 'punctuator' || token.value !== ':') {
		      //     throw invalidToken()
		      // }

		      if (token.type === 'eof') {
		        throw invalidEOF();
		      }
		      parseState = 'beforePropertyValue';
		    },
		    beforePropertyValue: function beforePropertyValue() {
		      if (token.type === 'eof') {
		        throw invalidEOF();
		      }
		      push();
		    },
		    beforeArrayValue: function beforeArrayValue() {
		      if (token.type === 'eof') {
		        throw invalidEOF();
		      }
		      if (token.type === 'punctuator' && token.value === ']') {
		        pop();
		        return;
		      }
		      push();
		    },
		    afterPropertyValue: function afterPropertyValue() {
		      // This code is unreachable since it's handled by the lexState.
		      // if (token.type !== 'punctuator') {
		      //     throw invalidToken()
		      // }

		      if (token.type === 'eof') {
		        throw invalidEOF();
		      }
		      switch (token.value) {
		        case ',':
		          parseState = 'beforePropertyName';
		          return;
		        case '}':
		          pop();
		      }

		      // This code is unreachable since it's handled by the lexState.
		      // throw invalidToken()
		    },
		    afterArrayValue: function afterArrayValue() {
		      // This code is unreachable since it's handled by the lexState.
		      // if (token.type !== 'punctuator') {
		      //     throw invalidToken()
		      // }

		      if (token.type === 'eof') {
		        throw invalidEOF();
		      }
		      switch (token.value) {
		        case ',':
		          parseState = 'beforeArrayValue';
		          return;
		        case ']':
		          pop();
		      }

		      // This code is unreachable since it's handled by the lexState.
		      // throw invalidToken()
		    },
		    end: function end() {
		      // This code is unreachable since it's handled by the lexState.
		      // if (token.type !== 'eof') {
		      //     throw invalidToken()
		      // }
		    }
		  };
		  function push() {
		    var value;
		    switch (token.type) {
		      case 'punctuator':
		        switch (token.value) {
		          case '{':
		            value = {};
		            break;
		          case '[':
		            value = [];
		            break;
		        }
		        break;
		      case 'null':
		      case 'boolean':
		      case 'numeric':
		      case 'string':
		        value = token.value;
		        break;

		      // This code is unreachable.
		      // default:
		      //     throw invalidToken()
		    }
		    if (root === undefined) {
		      root = value;
		    } else {
		      var parent = stack[stack.length - 1];
		      if (Array.isArray(parent)) {
		        parent.push(value);
		      } else {
		        Object.defineProperty(parent, key, {
		          value: value,
		          writable: true,
		          enumerable: true,
		          configurable: true
		        });
		      }
		    }
		    if (value !== null && typeof value === 'object') {
		      stack.push(value);
		      if (Array.isArray(value)) {
		        parseState = 'beforeArrayValue';
		      } else {
		        parseState = 'beforePropertyName';
		      }
		    } else {
		      var current = stack[stack.length - 1];
		      if (current == null) {
		        parseState = 'end';
		      } else if (Array.isArray(current)) {
		        parseState = 'afterArrayValue';
		      } else {
		        parseState = 'afterPropertyValue';
		      }
		    }
		  }
		  function pop() {
		    stack.pop();
		    var current = stack[stack.length - 1];
		    if (current == null) {
		      parseState = 'end';
		    } else if (Array.isArray(current)) {
		      parseState = 'afterArrayValue';
		    } else {
		      parseState = 'afterPropertyValue';
		    }
		  }

		  // This code is unreachable.
		  // function invalidParseState () {
		  //     return new Error(`JSON5: invalid parse state '${parseState}'`)
		  // }

		  // This code is unreachable.
		  // function invalidLexState (state) {
		  //     return new Error(`JSON5: invalid lex state '${state}'`)
		  // }

		  function invalidChar(c) {
		    if (c === undefined) {
		      return syntaxError("JSON5: invalid end of input at " + line + ":" + column);
		    }
		    return syntaxError("JSON5: invalid character '" + formatChar(c) + "' at " + line + ":" + column);
		  }
		  function invalidEOF() {
		    return syntaxError("JSON5: invalid end of input at " + line + ":" + column);
		  }

		  // This code is unreachable.
		  // function invalidToken () {
		  //     if (token.type === 'eof') {
		  //         return syntaxError(`JSON5: invalid end of input at ${line}:${column}`)
		  //     }

		  //     const c = String.fromCodePoint(token.value.codePointAt(0))
		  //     return syntaxError(`JSON5: invalid character '${formatChar(c)}' at ${line}:${column}`)
		  // }

		  function invalidIdentifier() {
		    column -= 5;
		    return syntaxError("JSON5: invalid identifier character at " + line + ":" + column);
		  }
		  function separatorChar(c) {
		    console.warn("JSON5: '" + formatChar(c) + "' in strings is not valid ECMAScript; consider escaping");
		  }
		  function formatChar(c) {
		    var replacements = {
		      "'": "\\'",
		      '"': '\\"',
		      '\\': '\\\\',
		      '\b': '\\b',
		      '\f': '\\f',
		      '\n': '\\n',
		      '\r': '\\r',
		      '\t': '\\t',
		      '\v': '\\v',
		      '\0': '\\0',
		      '\u2028': '\\u2028',
		      '\u2029': '\\u2029'
		    };
		    if (replacements[c]) {
		      return replacements[c];
		    }
		    if (c < ' ') {
		      var hexString = c.charCodeAt(0).toString(16);
		      return '\\x' + ('00' + hexString).substring(hexString.length);
		    }
		    return c;
		  }
		  function syntaxError(message) {
		    var err = new SyntaxError(message);
		    err.lineNumber = line;
		    err.columnNumber = column;
		    return err;
		  }
		  var stringify = function stringify(value, replacer, space) {
		    var stack = [];
		    var indent = '';
		    var propertyList;
		    var replacerFunc;
		    var gap = '';
		    var quote;
		    if (replacer != null && typeof replacer === 'object' && !Array.isArray(replacer)) {
		      space = replacer.space;
		      quote = replacer.quote;
		      replacer = replacer.replacer;
		    }
		    if (typeof replacer === 'function') {
		      replacerFunc = replacer;
		    } else if (Array.isArray(replacer)) {
		      propertyList = [];
		      for (var i = 0, list = replacer; i < list.length; i += 1) {
		        var v = list[i];
		        var item = void 0;
		        if (typeof v === 'string') {
		          item = v;
		        } else if (typeof v === 'number' || v instanceof String || v instanceof Number) {
		          item = String(v);
		        }
		        if (item !== undefined && propertyList.indexOf(item) < 0) {
		          propertyList.push(item);
		        }
		      }
		    }
		    if (space instanceof Number) {
		      space = Number(space);
		    } else if (space instanceof String) {
		      space = String(space);
		    }
		    if (typeof space === 'number') {
		      if (space > 0) {
		        space = Math.min(10, Math.floor(space));
		        gap = '          '.substr(0, space);
		      }
		    } else if (typeof space === 'string') {
		      gap = space.substr(0, 10);
		    }
		    return serializeProperty('', {
		      '': value
		    });
		    function serializeProperty(key, holder) {
		      var value = holder[key];
		      if (value != null) {
		        if (typeof value.toJSON5 === 'function') {
		          value = value.toJSON5(key);
		        } else if (typeof value.toJSON === 'function') {
		          value = value.toJSON(key);
		        }
		      }
		      if (replacerFunc) {
		        value = replacerFunc.call(holder, key, value);
		      }
		      if (value instanceof Number) {
		        value = Number(value);
		      } else if (value instanceof String) {
		        value = String(value);
		      } else if (value instanceof Boolean) {
		        value = value.valueOf();
		      }
		      switch (value) {
		        case null:
		          return 'null';
		        case true:
		          return 'true';
		        case false:
		          return 'false';
		      }
		      if (typeof value === 'string') {
		        return quoteString(value);
		      }
		      if (typeof value === 'number') {
		        return String(value);
		      }
		      if (typeof value === 'object') {
		        return Array.isArray(value) ? serializeArray(value) : serializeObject(value);
		      }
		      return undefined;
		    }
		    function quoteString(value) {
		      var quotes = {
		        "'": 0.1,
		        '"': 0.2
		      };
		      var replacements = {
		        "'": "\\'",
		        '"': '\\"',
		        '\\': '\\\\',
		        '\b': '\\b',
		        '\f': '\\f',
		        '\n': '\\n',
		        '\r': '\\r',
		        '\t': '\\t',
		        '\v': '\\v',
		        '\0': '\\0',
		        '\u2028': '\\u2028',
		        '\u2029': '\\u2029'
		      };
		      var product = '';
		      for (var i = 0; i < value.length; i++) {
		        var c = value[i];
		        switch (c) {
		          case "'":
		          case '"':
		            quotes[c]++;
		            product += c;
		            continue;
		          case '\0':
		            if (util.isDigit(value[i + 1])) {
		              product += '\\x00';
		              continue;
		            }
		        }
		        if (replacements[c]) {
		          product += replacements[c];
		          continue;
		        }
		        if (c < ' ') {
		          var hexString = c.charCodeAt(0).toString(16);
		          product += '\\x' + ('00' + hexString).substring(hexString.length);
		          continue;
		        }
		        product += c;
		      }
		      var quoteChar = quote || Object.keys(quotes).reduce(function (a, b) {
		        return quotes[a] < quotes[b] ? a : b;
		      });
		      product = product.replace(new RegExp(quoteChar, 'g'), replacements[quoteChar]);
		      return quoteChar + product + quoteChar;
		    }
		    function serializeObject(value) {
		      if (stack.indexOf(value) >= 0) {
		        throw TypeError('Converting circular structure to JSON5');
		      }
		      stack.push(value);
		      var stepback = indent;
		      indent = indent + gap;
		      var keys = propertyList || Object.keys(value);
		      var partial = [];
		      for (var i = 0, list = keys; i < list.length; i += 1) {
		        var key = list[i];
		        var propertyString = serializeProperty(key, value);
		        if (propertyString !== undefined) {
		          var member = serializeKey(key) + ':';
		          if (gap !== '') {
		            member += ' ';
		          }
		          member += propertyString;
		          partial.push(member);
		        }
		      }
		      var final;
		      if (partial.length === 0) {
		        final = '{}';
		      } else {
		        var properties;
		        if (gap === '') {
		          properties = partial.join(',');
		          final = '{' + properties + '}';
		        } else {
		          var separator = ',\n' + indent;
		          properties = partial.join(separator);
		          final = '{\n' + indent + properties + ',\n' + stepback + '}';
		        }
		      }
		      stack.pop();
		      indent = stepback;
		      return final;
		    }
		    function serializeKey(key) {
		      if (key.length === 0) {
		        return quoteString(key);
		      }
		      var firstChar = String.fromCodePoint(key.codePointAt(0));
		      if (!util.isIdStartChar(firstChar)) {
		        return quoteString(key);
		      }
		      for (var i = firstChar.length; i < key.length; i++) {
		        if (!util.isIdContinueChar(String.fromCodePoint(key.codePointAt(i)))) {
		          return quoteString(key);
		        }
		      }
		      return key;
		    }
		    function serializeArray(value) {
		      if (stack.indexOf(value) >= 0) {
		        throw TypeError('Converting circular structure to JSON5');
		      }
		      stack.push(value);
		      var stepback = indent;
		      indent = indent + gap;
		      var partial = [];
		      for (var i = 0; i < value.length; i++) {
		        var propertyString = serializeProperty(String(i), value);
		        partial.push(propertyString !== undefined ? propertyString : 'null');
		      }
		      var final;
		      if (partial.length === 0) {
		        final = '[]';
		      } else {
		        if (gap === '') {
		          var properties = partial.join(',');
		          final = '[' + properties + ']';
		        } else {
		          var separator = ',\n' + indent;
		          var properties$1 = partial.join(separator);
		          final = '[\n' + indent + properties$1 + ',\n' + stepback + ']';
		        }
		      }
		      stack.pop();
		      indent = stepback;
		      return final;
		    }
		  };
		  var JSON5 = {
		    parse: parse,
		    stringify: stringify
		  };
		  var lib = JSON5;
		  var es5 = lib;
		  return es5;
		}); 
	} (dist$2));
	return dist$2.exports;
}

var distExports = requireDist();
var JSON5 = /*@__PURE__*/getDefaultExportFromCjs(distExports);

function item_isFunctionItem(item) {
    return item.type === "FUNCTION";
}
function item_isNetwork(item) {
    return item.type === "NETWORK";
}
var ConnectionType;
(function (ConnectionType) {
    ConnectionType["NodeToNode"] = "NODE_TO_NODE";
    ConnectionType["InletToNode"] = "INLET_TO_NODE";
    ConnectionType["NodeToOutlet"] = "NODE_TO_OUTLET";
})(ConnectionType || (ConnectionType = {}));
var PortType;
(function (PortType) {
    PortType["Invalid"] = "INVALID";
    PortType["Series"] = "SERIES";
    PortType["Shape"] = "SHAPE";
    PortType["Spec"] = "SPEC";
    PortType["Table"] = "TABLE";
})(PortType || (PortType = {}));
var ParameterType;
(function (ParameterType) {
    ParameterType["Number"] = "NUMBER";
    ParameterType["String"] = "STRING";
    ParameterType["Boolean"] = "BOOLEAN";
    ParameterType["Point"] = "POINT";
    ParameterType["Color"] = "COLOR";
    ParameterType["File"] = "FILE";
    ParameterType["Choice"] = "CHOICE";
})(ParameterType || (ParameterType = {}));
var WidgetType;
(function (WidgetType) {
    WidgetType["Number"] = "NUMBER";
    WidgetType["String"] = "STRING";
    WidgetType["Text"] = "TEXT";
    WidgetType["Boolean"] = "BOOLEAN";
    WidgetType["Point"] = "POINT";
    WidgetType["Color"] = "COLOR";
    WidgetType["File"] = "FILE";
    WidgetType["Choice"] = "CHOICE";
})(WidgetType || (WidgetType = {}));

function startCase(str) {
    if (!str)
        return "";
    const words = str
        .replace(/([A-Z])/g, " $1")
        .trim()
        .split(" ")
        .map((word) => {
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    });
    return words.join(" ");
}
/**
 * Replaces {{key}} in a template string with values[key].
 *
 * @param template  The string containing {{ placeholders }}.
 * @param values    A map from placeholder names to their replacement strings.
 * @returns         A new string with all placeholders substituted.
 */
function evalTemplate(template, values) {
    return template.replace(/\{\{\s*([^{}\s]+)\s*\}\}/g, (_match, key) => {
        if (!(key in values)) {
            throw new Error(`Missing template value for key "${key}"`);
        }
        return String(values[key]);
    });
}

function parseExpression$1(s) {
    const fn = new Function("context", `with (context) { return ${s}; }`);
    return { fn };
}
function evaluateExpression(expression, context) {
    let expr;
    if (typeof expression === "string") {
        expr = parseExpression$1(expression);
    }
    else {
        expr = expression;
    }
    return expr.fn(context || {});
}

let Point$1 = class Point {
  x;
  y;
  constructor(x, y) {
    this.x = x;
    this.y = y;
  }
  clone() {
    return new Point(this.x, this.y);
  }
  getBounds() {
    return {
      left: this.x,
      right: this.x,
      top: this.y,
      bottom: this.y,
      centerX: this.x,
      centerY: this.y
    };
  }
};
let Transform$1 = class Transform {
  matrix;
  bounds;
  "pivot-mode";
  "pivot-point";
  static matrixIsIdentity(matrix) {
    return matrix[0] === 1 && matrix[1] === 0 && matrix[2] === 0 && matrix[3] === 1 && matrix[4] === 0 && matrix[5] === 0;
  }
  static multiplyMatrices(m1, m2) {
    const [a1, b1, c1, d1, e1, f1] = m1;
    const [a2, b2, c2, d2, e2, f2] = m2;
    return new Float32Array([a1 * a2 + c1 * b2, b1 * a2 + d1 * b2, a1 * c2 + c1 * d2, b1 * c2 + d1 * d2, a1 * e2 + c1 * f2 + e1, b1 * e2 + d1 * f2 + f1]);
  }
  constructor(matrix) {
    this.matrix = matrix ? new Float32Array(matrix) : new Float32Array([1, 0, 0, 1, 0, 0]);
  }
  static fromSvgTransform(s) {
    function makeMatrix(type, values) {
      switch (type) {
        case "translate":
          return [1, 0, 0, 1, values[0], values[1] || 0];
        case "rotate":
          const angle = -(values[0] * Math.PI) / 180;
          return [Math.cos(angle), -Math.sin(angle), Math.sin(angle), Math.cos(angle), 0, 0];
        case "scale":
          return [values[0], 0, 0, values[1] || values[0], 0, 0];
        default:
          return [1, 0, 0, 1, 0, 0];
      }
    }
    function combine(m1, m2) {
      return [m1[0] * m2[0] + m1[2] * m2[1], m1[1] * m2[0] + m1[3] * m2[1], m1[0] * m2[2] + m1[2] * m2[3], m1[1] * m2[2] + m1[3] * m2[3], m1[0] * m2[4] + m1[2] * m2[5] + m1[4], m1[1] * m2[4] + m1[3] * m2[5] + m1[5]];
    }
    // Initialize the transformation matrix as identity matrix
    let matrix = [1, 0, 0, 1, 0, 0]; // Initial identity matrix
    const transforms = s.match(/(\w+\((\-?\d+\.?\d*(e[\+\-]?\d+)?,?\s*)+\))/gi);
    if (transforms) {
      transforms.forEach(trans => {
        const [type, values] = trans.match(/(\w+)\((.*)\)/).slice(1);
        const nums = values.split(/[\s,]+/).map(Number);
        matrix = combine(matrix, makeMatrix(type, nums));
      });
    }
    return new Transform(new Float32Array(matrix)); // Use the updated constructor
  }
  clone() {
    return new Transform(this.matrix); // Use the updated constructor
  }
  isIdentity() {
    return this.matrix[0] === 1 && this.matrix[1] === 0 && this.matrix[2] === 0 && this.matrix[3] === 1 && this.matrix[4] === 0 && this.matrix[5] === 0;
  }
  translate(tx, ty) {
    this.matrix[4] += tx;
    this.matrix[5] += ty;
    return this;
  }
  rotate(angle, around = new Point$1(0, 0)) {
    const cos = Math.cos(angle);
    const sin = Math.sin(angle);
    const [a, b, c, d, e, f] = this.matrix; // Assuming the matrix is 3x2 for translation purposes
    // Translate point to origin (subtract around.x and around.y)
    const tx = around.x;
    const ty = around.y;
    // Apply rotation
    this.matrix[0] = a * cos - b * sin;
    this.matrix[1] = a * sin + b * cos;
    this.matrix[2] = c * cos - d * sin;
    this.matrix[3] = c * sin + d * cos;
    // Apply translation back to the original point
    this.matrix[4] += tx - (tx * cos - ty * sin);
    this.matrix[5] += ty - (tx * sin + ty * cos);
    return this;
  }
  rotateDegrees(angle, around = new Point$1(0, 0)) {
    angle = angle * Math.PI / 180;
    return this.rotate(angle, around);
  }
  scale(sx, sy, around = new Point$1(0, 0)) {
    const tx = around.x;
    const ty = around.y;
    this.translate(-tx, -ty);
    this.matrix[0] *= sx;
    this.matrix[1] *= sy;
    this.matrix[2] *= sx;
    this.matrix[3] *= sy;
    this.matrix[4] *= sx;
    this.matrix[5] *= sy;
    this.translate(tx, ty);
    return this;
  }
  combine(other) {
    const a = this.matrix;
    const b = other.matrix;
    const result = [a[0] * b[0] + a[2] * b[1], a[1] * b[0] + a[3] * b[1], a[0] * b[2] + a[2] * b[3], a[1] * b[2] + a[3] * b[3], a[0] * b[4] + a[2] * b[5] + a[4], a[1] * b[4] + a[3] * b[5] + a[5]];
    this.matrix.set(result);
    this["pivot-mode"] = other["pivot-mode"];
    this["pivot-point"] = other["pivot-point"];
    return this;
  }
  multiply(other) {
    const [a1, b1, c1, d1, e1, f1] = this.matrix;
    const [a2, b2, c2, d2, e2, f2] = other;
    return new Float32Array([a1 * a2 + c1 * b2, b1 * a2 + d1 * b2, a1 * c2 + c1 * d2, b1 * c2 + d1 * d2, a1 * e2 + c1 * f2 + e1, b1 * e2 + d1 * f2 + f1]);
  }
  transform(tx, ty, sx, sy, angle, around = new Point$1(0, 0)) {
    return this.translate(tx, ty).scale(sx, sy, around).rotate(angle, around);
  }
  transformPoint(point) {
    const {
      x,
      y
    } = point;
    const {
      matrix
    } = this;
    return new Point$1(matrix[0] * x + matrix[2] * y + matrix[4], matrix[1] * x + matrix[3] * y + matrix[5]);
  }
  toMatrixString() {
    const m = this.matrix;
    return `matrix(${m[0]},${m[1]},${m[2]},${m[3]},${m[4]},${m[5]})`;
  }
  static applyMatrixTransform(x, y, matrix) {
    const [a, b, c, d, e, f] = matrix;
    return {
      x: a * x + c * y + e,
      y: b * x + d * y + f
    };
  }
};
function define$1(constructor, factory, prototype) {
  constructor.prototype = factory.prototype = prototype;
  prototype.constructor = constructor;
}
function extend$2(parent, definition) {
  var prototype = Object.create(parent.prototype);
  for (var key in definition) prototype[key] = definition[key];
  return prototype;
}
function Color$1() {}
var darker$1 = 0.7;
var brighter$1 = 1 / darker$1;
var reI$1 = "\\s*([+-]?\\d+)\\s*",
  reN$1 = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*",
  reP$1 = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*",
  reHex$1 = /^#([0-9a-f]{3,8})$/,
  reRgbInteger$1 = new RegExp(`^rgb\\(${reI$1},${reI$1},${reI$1}\\)$`),
  reRgbPercent$1 = new RegExp(`^rgb\\(${reP$1},${reP$1},${reP$1}\\)$`),
  reRgbaInteger$1 = new RegExp(`^rgba\\(${reI$1},${reI$1},${reI$1},${reN$1}\\)$`),
  reRgbaPercent$1 = new RegExp(`^rgba\\(${reP$1},${reP$1},${reP$1},${reN$1}\\)$`),
  reHslPercent$1 = new RegExp(`^hsl\\(${reN$1},${reP$1},${reP$1}\\)$`),
  reHslaPercent$1 = new RegExp(`^hsla\\(${reN$1},${reP$1},${reP$1},${reN$1}\\)$`);
var named$1 = {
  aliceblue: 0xf0f8ff,
  antiquewhite: 0xfaebd7,
  aqua: 0x00ffff,
  aquamarine: 0x7fffd4,
  azure: 0xf0ffff,
  beige: 0xf5f5dc,
  bisque: 0xffe4c4,
  black: 0x000000,
  blanchedalmond: 0xffebcd,
  blue: 0x0000ff,
  blueviolet: 0x8a2be2,
  brown: 0xa52a2a,
  burlywood: 0xdeb887,
  cadetblue: 0x5f9ea0,
  chartreuse: 0x7fff00,
  chocolate: 0xd2691e,
  coral: 0xff7f50,
  cornflowerblue: 0x6495ed,
  cornsilk: 0xfff8dc,
  crimson: 0xdc143c,
  cyan: 0x00ffff,
  darkblue: 0x00008b,
  darkcyan: 0x008b8b,
  darkgoldenrod: 0xb8860b,
  darkgray: 0xa9a9a9,
  darkgreen: 0x006400,
  darkgrey: 0xa9a9a9,
  darkkhaki: 0xbdb76b,
  darkmagenta: 0x8b008b,
  darkolivegreen: 0x556b2f,
  darkorange: 0xff8c00,
  darkorchid: 0x9932cc,
  darkred: 0x8b0000,
  darksalmon: 0xe9967a,
  darkseagreen: 0x8fbc8f,
  darkslateblue: 0x483d8b,
  darkslategray: 0x2f4f4f,
  darkslategrey: 0x2f4f4f,
  darkturquoise: 0x00ced1,
  darkviolet: 0x9400d3,
  deeppink: 0xff1493,
  deepskyblue: 0x00bfff,
  dimgray: 0x696969,
  dimgrey: 0x696969,
  dodgerblue: 0x1e90ff,
  firebrick: 0xb22222,
  floralwhite: 0xfffaf0,
  forestgreen: 0x228b22,
  fuchsia: 0xff00ff,
  gainsboro: 0xdcdcdc,
  ghostwhite: 0xf8f8ff,
  gold: 0xffd700,
  goldenrod: 0xdaa520,
  gray: 0x808080,
  green: 0x008000,
  greenyellow: 0xadff2f,
  grey: 0x808080,
  honeydew: 0xf0fff0,
  hotpink: 0xff69b4,
  indianred: 0xcd5c5c,
  indigo: 0x4b0082,
  ivory: 0xfffff0,
  khaki: 0xf0e68c,
  lavender: 0xe6e6fa,
  lavenderblush: 0xfff0f5,
  lawngreen: 0x7cfc00,
  lemonchiffon: 0xfffacd,
  lightblue: 0xadd8e6,
  lightcoral: 0xf08080,
  lightcyan: 0xe0ffff,
  lightgoldenrodyellow: 0xfafad2,
  lightgray: 0xd3d3d3,
  lightgreen: 0x90ee90,
  lightgrey: 0xd3d3d3,
  lightpink: 0xffb6c1,
  lightsalmon: 0xffa07a,
  lightseagreen: 0x20b2aa,
  lightskyblue: 0x87cefa,
  lightslategray: 0x778899,
  lightslategrey: 0x778899,
  lightsteelblue: 0xb0c4de,
  lightyellow: 0xffffe0,
  lime: 0x00ff00,
  limegreen: 0x32cd32,
  linen: 0xfaf0e6,
  magenta: 0xff00ff,
  maroon: 0x800000,
  mediumaquamarine: 0x66cdaa,
  mediumblue: 0x0000cd,
  mediumorchid: 0xba55d3,
  mediumpurple: 0x9370db,
  mediumseagreen: 0x3cb371,
  mediumslateblue: 0x7b68ee,
  mediumspringgreen: 0x00fa9a,
  mediumturquoise: 0x48d1cc,
  mediumvioletred: 0xc71585,
  midnightblue: 0x191970,
  mintcream: 0xf5fffa,
  mistyrose: 0xffe4e1,
  moccasin: 0xffe4b5,
  navajowhite: 0xffdead,
  navy: 0x000080,
  oldlace: 0xfdf5e6,
  olive: 0x808000,
  olivedrab: 0x6b8e23,
  orange: 0xffa500,
  orangered: 0xff4500,
  orchid: 0xda70d6,
  palegoldenrod: 0xeee8aa,
  palegreen: 0x98fb98,
  paleturquoise: 0xafeeee,
  palevioletred: 0xdb7093,
  papayawhip: 0xffefd5,
  peachpuff: 0xffdab9,
  peru: 0xcd853f,
  pink: 0xffc0cb,
  plum: 0xdda0dd,
  powderblue: 0xb0e0e6,
  purple: 0x800080,
  rebeccapurple: 0x663399,
  red: 0xff0000,
  rosybrown: 0xbc8f8f,
  royalblue: 0x4169e1,
  saddlebrown: 0x8b4513,
  salmon: 0xfa8072,
  sandybrown: 0xf4a460,
  seagreen: 0x2e8b57,
  seashell: 0xfff5ee,
  sienna: 0xa0522d,
  silver: 0xc0c0c0,
  skyblue: 0x87ceeb,
  slateblue: 0x6a5acd,
  slategray: 0x708090,
  slategrey: 0x708090,
  snow: 0xfffafa,
  springgreen: 0x00ff7f,
  steelblue: 0x4682b4,
  tan: 0xd2b48c,
  teal: 0x008080,
  thistle: 0xd8bfd8,
  tomato: 0xff6347,
  turquoise: 0x40e0d0,
  violet: 0xee82ee,
  wheat: 0xf5deb3,
  white: 0xffffff,
  whitesmoke: 0xf5f5f5,
  yellow: 0xffff00,
  yellowgreen: 0x9acd32
};
define$1(Color$1, color$3, {
  copy(channels) {
    return Object.assign(new this.constructor(), this, channels);
  },
  displayable() {
    return this.rgb().displayable();
  },
  hex: color_formatHex$1,
  // Deprecated! Use color.formatHex.
  formatHex: color_formatHex$1,
  formatHex8: color_formatHex8$1,
  formatHsl: color_formatHsl$1,
  formatRgb: color_formatRgb$1,
  toString: color_formatRgb$1
});
function color_formatHex$1() {
  return this.rgb().formatHex();
}
function color_formatHex8$1() {
  return this.rgb().formatHex8();
}
function color_formatHsl$1() {
  return hslConvert$1(this).formatHsl();
}
function color_formatRgb$1() {
  return this.rgb().formatRgb();
}
function color$3(format) {
  var m, l;
  format = (format + "").trim().toLowerCase();
  return (m = reHex$1.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn$1(m) // #ff0000
  : l === 3 ? new Rgb$1(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
  : l === 8 ? rgba$1(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
  : l === 4 ? rgba$1(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
  : null // invalid hex
  ) : (m = reRgbInteger$1.exec(format)) ? new Rgb$1(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
  : (m = reRgbPercent$1.exec(format)) ? new Rgb$1(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
  : (m = reRgbaInteger$1.exec(format)) ? rgba$1(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
  : (m = reRgbaPercent$1.exec(format)) ? rgba$1(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
  : (m = reHslPercent$1.exec(format)) ? hsla$1(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
  : (m = reHslaPercent$1.exec(format)) ? hsla$1(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
  : named$1.hasOwnProperty(format) ? rgbn$1(named$1[format]) // eslint-disable-line no-prototype-builtins
  : format === "transparent" ? new Rgb$1(NaN, NaN, NaN, 0) : null;
}
function rgbn$1(n) {
  return new Rgb$1(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function rgba$1(r, g, b, a) {
  if (a <= 0) r = g = b = NaN;
  return new Rgb$1(r, g, b, a);
}
function rgbConvert$1(o) {
  if (!(o instanceof Color$1)) o = color$3(o);
  if (!o) return new Rgb$1();
  o = o.rgb();
  return new Rgb$1(o.r, o.g, o.b, o.opacity);
}
function rgb$2(r, g, b, opacity) {
  return arguments.length === 1 ? rgbConvert$1(r) : new Rgb$1(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb$1(r, g, b, opacity) {
  this.r = +r;
  this.g = +g;
  this.b = +b;
  this.opacity = +opacity;
}
define$1(Rgb$1, rgb$2, extend$2(Color$1, {
  brighter(k) {
    k = k == null ? brighter$1 : Math.pow(brighter$1, k);
    return new Rgb$1(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  darker(k) {
    k = k == null ? darker$1 : Math.pow(darker$1, k);
    return new Rgb$1(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  rgb() {
    return this;
  },
  clamp() {
    return new Rgb$1(clampi$1(this.r), clampi$1(this.g), clampi$1(this.b), clampa$1(this.opacity));
  },
  displayable() {
    return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
  },
  hex: rgb_formatHex$1,
  // Deprecated! Use color.formatHex.
  formatHex: rgb_formatHex$1,
  formatHex8: rgb_formatHex8$1,
  formatRgb: rgb_formatRgb$1,
  toString: rgb_formatRgb$1
}));
function rgb_formatHex$1() {
  return `#${hex$1(this.r)}${hex$1(this.g)}${hex$1(this.b)}`;
}
function rgb_formatHex8$1() {
  return `#${hex$1(this.r)}${hex$1(this.g)}${hex$1(this.b)}${hex$1((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function rgb_formatRgb$1() {
  const a = clampa$1(this.opacity);
  return `${a === 1 ? "rgb(" : "rgba("}${clampi$1(this.r)}, ${clampi$1(this.g)}, ${clampi$1(this.b)}${a === 1 ? ")" : `, ${a})`}`;
}
function clampa$1(opacity) {
  return isNaN(opacity) ? 1 : Math.max(0, Math.min(1, opacity));
}
function clampi$1(value) {
  return Math.max(0, Math.min(255, Math.round(value) || 0));
}
function hex$1(value) {
  value = clampi$1(value);
  return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla$1(h, s, l, a) {
  if (a <= 0) h = s = l = NaN;else if (l <= 0 || l >= 1) h = s = NaN;else if (s <= 0) h = NaN;
  return new Hsl$1(h, s, l, a);
}
function hslConvert$1(o) {
  if (o instanceof Hsl$1) return new Hsl$1(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof Color$1)) o = color$3(o);
  if (!o) return new Hsl$1();
  if (o instanceof Hsl$1) return o;
  o = o.rgb();
  var r = o.r / 255,
    g = o.g / 255,
    b = o.b / 255,
    min = Math.min(r, g, b),
    max = Math.max(r, g, b),
    h = NaN,
    s = max - min,
    l = (max + min) / 2;
  if (s) {
    if (r === max) h = (g - b) / s + (g < b) * 6;else if (g === max) h = (b - r) / s + 2;else h = (r - g) / s + 4;
    s /= l < 0.5 ? max + min : 2 - max - min;
    h *= 60;
  } else {
    s = l > 0 && l < 1 ? 0 : h;
  }
  return new Hsl$1(h, s, l, o.opacity);
}
function hsl$3(h, s, l, opacity) {
  return arguments.length === 1 ? hslConvert$1(h) : new Hsl$1(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl$1(h, s, l, opacity) {
  this.h = +h;
  this.s = +s;
  this.l = +l;
  this.opacity = +opacity;
}
define$1(Hsl$1, hsl$3, extend$2(Color$1, {
  brighter(k) {
    k = k == null ? brighter$1 : Math.pow(brighter$1, k);
    return new Hsl$1(this.h, this.s, this.l * k, this.opacity);
  },
  darker(k) {
    k = k == null ? darker$1 : Math.pow(darker$1, k);
    return new Hsl$1(this.h, this.s, this.l * k, this.opacity);
  },
  rgb() {
    var h = this.h % 360 + (this.h < 0) * 360,
      s = isNaN(h) || isNaN(this.s) ? 0 : this.s,
      l = this.l,
      m2 = l + (l < 0.5 ? l : 1 - l) * s,
      m1 = 2 * l - m2;
    return new Rgb$1(hsl2rgb$1(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb$1(h, m1, m2), hsl2rgb$1(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
  },
  clamp() {
    return new Hsl$1(clamph$1(this.h), clampt$1(this.s), clampt$1(this.l), clampa$1(this.opacity));
  },
  displayable() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
  },
  formatHsl() {
    const a = clampa$1(this.opacity);
    return `${a === 1 ? "hsl(" : "hsla("}${clamph$1(this.h)}, ${clampt$1(this.s) * 100}%, ${clampt$1(this.l) * 100}%${a === 1 ? ")" : `, ${a})`}`;
  }
}));
function clamph$1(value) {
  value = (value || 0) % 360;
  return value < 0 ? value + 360 : value;
}
function clampt$1(value) {
  return Math.max(0, Math.min(1, value || 0));
}

/* From FvD 13.37, CSS Color Module Level 3 */
function hsl2rgb$1(h, m1, m2) {
  return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}
function fToHex(value) {
  return Math.round(value * 255).toString(16).padStart(2, "0");
}
class Paint {
  static unset() {
    return new UnsetPaint();
  }
  static none() {
    return new NonePaint();
  }
  static solid(r, g, b, a = 1) {
    return new SolidPaint(r, g, b, a);
  }
  static transparent() {
    return new SolidPaint(0, 0, 0, 0);
  }
  static black() {
    return new SolidPaint(0, 0, 0);
  }
  static white() {
    return new SolidPaint(1, 1, 1);
  }
  static lightGray() {
    return new SolidPaint(0.75, 0.75, 0.75);
  }
  static darkGray() {
    return new SolidPaint(0.15, 0.15, 0.15);
  }
  static linearGradient(stops, x1 = 0, y1 = 0, x2 = 1, y2 = 0) {
    return new LinearGradientPaint(stops, x1, y1, x2, y2);
  }
  static radialGradient(stops, cx = 0.5, cy = 0.5, r = 0.5, fx, fy) {
    return new RadialGradientPaint(stops, cx, cy, r, fx, fy);
  }
  // Parse from string (SVG format)
  static parse(value) {
    if (value === "none") {
      return Paint.none();
    }
    if (value instanceof SolidPaint) {
      return value;
    }
    if (typeof value === "object" && "gradient" in value) {
      const gradient = value;
      const stops = gradient.stops.map(stop => ({
        offset: stop.offset,
        color: SolidPaint.parse(stop.color)
      }));
      if (gradient.gradient === "linear") {
        let {
          x1 = 0,
          y1 = 0,
          x2 = 1,
          y2 = 0
        } = gradient;
        return new LinearGradientPaint(stops, x1, y1, x2, y2);
      } else if (gradient.gradient === "radial") {
        const {
          x1 = 0,
          y1 = 0,
          r1 = 0,
          x2 = 1,
          y2 = 0,
          r2 = 1
        } = gradient;
        // FIXME: Conversion from Vega gradients to SVG gradients
        return new RadialGradientPaint(stops, x1, y1, r1, x2, y2);
      } else {
        console.error(`Unknown gradient type: ${value.gradient}`);
        return Paint.none();
      }
    }
    if (typeof value === "object" && "r" in value && "g" in value && "b" in value) {
      const {
        r,
        g,
        b,
        a = 1
      } = value;
      return new SolidPaint(r, g, b, a);
    }
    if (typeof value === "string") {
      if (value === "transparent") {
        return Paint.transparent();
      }
      let clr = color$3(value);
      if (clr === null) {
        return new SolidPaint(0, 0, 0);
      } else if ("opacity" in clr && clr.opacity === 0) {
        return new SolidPaint(0, 0, 0, 0);
      } else if ("r" in clr) {
        clr = clr;
        return new SolidPaint(clr.r / 255, clr.g / 255, clr.b / 255, clr.opacity);
      } else if ("h" in clr) {
        clr = clr;
        clr = rgb$2(clr);
        return new SolidPaint(clr.r / 255, clr.g / 255, clr.b / 255, clr.opacity);
      } else {
        // This shouldn't happen, so return a solid purple color (this is a reference to the "missing texture" in game assets)
        return new SolidPaint(1, 0, 1);
      }
    }
    return new SolidPaint(0, 0, 0);
  }
}
class UnsetPaint extends Paint {
  type = "unset";
  toString() {
    return "unset";
  }
  clone() {
    return new UnsetPaint();
  }
  isTransparent() {
    return true;
  }
  toObject() {
    return {
      type: "unset"
    };
  }
}
class NonePaint extends Paint {
  type = "none";
  toString() {
    return "none";
  }
  clone() {
    return new NonePaint();
  }
  isTransparent() {
    return true;
  }
  toObject() {
    return {
      type: "none"
    };
  }
}
class SolidPaint extends Paint {
  r;
  g;
  b;
  a;
  type = "solid";
  constructor(r, g, b, a = 1) {
    super();
    this.r = r;
    this.g = g;
    this.b = b;
    this.a = a;
  }
  clone() {
    return new SolidPaint(this.r, this.g, this.b, this.a);
  }
  toString() {
    const r = Math.round(this.r * 255);
    const g = Math.round(this.g * 255);
    const b = Math.round(this.b * 255);
    if (this.a === 1.0) {
      return `#${fToHex(this.r)}${fToHex(this.g)}${fToHex(this.b)}`;
    } else if (this.r === 0.0 && this.g === 0.0 && this.b === 0 && this.a === 0.0) {
      return "transparent";
    } else {
      return `rgba(${r}, ${g}, ${b}, ${this.a})`;
    }
  }
  toHex(withOpacity = false) {
    const r = fToHex(this.r);
    const g = fToHex(this.g);
    const b = fToHex(this.b);
    const a = fToHex(this.a);
    return withOpacity ? `#${r}${g}${b}${a}` : `#${r}${g}${b}`;
  }
  isTransparent() {
    return this.a === 0;
  }
  toObject() {
    return {
      type: "solid",
      r: this.r,
      g: this.g,
      b: this.b,
      a: this.a
    };
  }
}
class LinearGradientPaint extends Paint {
  stops;
  x1;
  y1;
  x2;
  y2;
  id = `gradient-${Math.floor(Math.random() * 1e8)}`;
  type = "linearGradient";
  constructor(stops, x1 = 0, y1 = 0, x2 = 1, y2 = 0) {
    super();
    this.stops = stops;
    this.x1 = x1;
    this.y1 = y1;
    this.x2 = x2;
    this.y2 = y2;
  }
  toString() {
    const coords = `${this.x1} ${this.y1} ${this.x2} ${this.y2}`;
    const stops = this.stops.map(stop => `${stop.color.toString()} ${stop.offset * 100}%`).join(", ");
    return `linearGradient(${coords}, ${stops})`;
  }
  clone() {
    return new LinearGradientPaint(this.stops.map(stop => ({
      offset: stop.offset,
      color: stop.color.clone()
    })), this.x1, this.y1, this.x2, this.y2);
  }
  isTransparent() {
    return this.stops.every(stop => stop.color.isTransparent());
  }
  toObject() {
    return {
      type: "linearGradient",
      stops: this.stops,
      x1: this.x1,
      y1: this.y1,
      x2: this.x2,
      y2: this.y2
    };
  }
}
class RadialGradientPaint extends Paint {
  stops;
  cx;
  cy;
  r;
  fx;
  fy;
  id = `gradient-${Math.floor(Math.random() * 1e8)}`;
  type = "radialGradient";
  constructor(stops, cx = 0.5, cy = 0.5, r = 0.5, fx, fy) {
    super();
    this.stops = stops;
    this.cx = cx;
    this.cy = cy;
    this.r = r;
    this.fx = fx;
    this.fy = fy;
  }
  toString() {
    const focal = this.fx !== undefined && this.fy !== undefined ? `${this.fx} ${this.fy} ` : "";
    const coords = `${this.cx} ${this.cy} ${this.r} ${focal}`;
    const stops = this.stops.map(stop => `${stop.color.toString()} ${stop.offset * 100}%`).join(", ");
    return `radialGradient(${coords}, ${stops})`;
  }
  clone() {
    return new RadialGradientPaint(this.stops.map(stop => ({
      offset: stop.offset,
      color: stop.color.clone()
    })), this.cx, this.cy, this.r, this.fx, this.fy);
  }
  isTransparent() {
    return this.stops.every(stop => stop.color.isTransparent());
  }
  toObject() {
    return {
      type: "radialGradient",
      stops: this.stops,
      cx: this.cx,
      cy: this.cy,
      r: this.r,
      fx: this.fx,
      fy: this.fy
    };
  }
}
// static fromHex(hex: string): Color {
//   if (hex.length === 7 && hex[0] === "#") {
//     const r = parseInt(hex.slice(1, 3), 16);
//     const g = parseInt(hex.slice(3, 5), 16);
//     const b = parseInt(hex.slice(5, 7), 16);
//     return new Color(r / 255, g / 255, b / 255);
//   } else if (hex.length === 9 && hex[0] === "#") {
//     const r = parseInt(hex.slice(1, 3), 16);
//     const g = parseInt(hex.slice(3, 5), 16);
//     const b = parseInt(hex.slice(5, 7), 16);
//     const a = parseInt(hex.slice(7, 9), 16);
//     return new Color(r / 255, g / 255, b / 255, a / 255);
//   }
//   return new Color(0, 0, 0);
// }
// toHex(withOpacity: Boolean = true): string {
//   const r = fToHex(this.r);
//   const g = fToHex(this.g);
//   const b = fToHex(this.b);
//   const a = fToHex(this.a);
//   return withOpacity ? `#${r}${g}${b}${a}` : `#${r}${g}${b}`;
// }

class ClipPath {
  id;
  shape;
  constructor(id, shape) {
    this.id = id;
    this.shape = shape;
  }
}
var ShapeType;
(function (ShapeType) {
  ShapeType["Ellipse"] = "ELLIPSE";
  ShapeType["Circle"] = "CIRCLE";
  ShapeType["Line"] = "LINE";
  ShapeType["Rect"] = "RECT";
  ShapeType["Path"] = "PATH";
  ShapeType["Group"] = "GROUP";
  ShapeType["Text"] = "TEXT";
})(ShapeType || (ShapeType = {}));
let Shape$1 = class Shape {
  id;
  type;
  transform;
  fill;
  stroke;
  strokeWidth;
  opacity;
  tags;
  clipPath;
  constructor(type) {
    this.type = type;
    this.transform = new Transform$1();
    this.fill = Paint.unset();
    this.stroke = Paint.unset();
    this.strokeWidth = 1;
    this.opacity = 1;
    this.tags = [];
  }
  applyTransform(m) {
    this.transform.combine(m);
  }
  clip(clipPath) {
    const id = `clip-${Math.floor(Math.random() * 1e8)}`;
    this.clipPath = new ClipPath(id, clipPath);
  }
  _cloneAttributes(other) {
    if (typeof other.fill === "string" || other.fill === undefined) {
      this.fill = other.fill;
    } else {
      this.fill = other.fill.clone();
    }
    if (typeof other.stroke === "string" || other.stroke === undefined) {
      this.stroke = other.stroke;
    } else {
      this.stroke = other.stroke.clone();
    }
    this.strokeWidth = other.strokeWidth;
    this.opacity = other.opacity;
    this.transform.matrix.set(other.transform.matrix);
    this.tags = other.tags;
  }
  _getAttributes(context) {
    return {
      ...this._getFill(context),
      ...this._getStroke(context),
      ...this._getTransform(),
      ...this._getOpacity(),
      ...this._getTags(),
      ...this._getClipPath()
    };
  }
  _getFill(context) {
    if (!this.fill) {
      return {
        fill: "none"
      };
    }
    switch (this.fill.type) {
      case "unset":
        return {};
      case "none":
        return {
          fill: "none"
        };
      case "solid":
        const solid = this.fill;
        const attrs = {
          fill: solid.toHex()
        };
        if (solid.a < 1) {
          attrs.fillOpacity = solid.a;
        }
        return attrs;
      case "linearGradient":
        const linearGradient = this.fill;
        context && context.addLinearGradient(linearGradient);
        return {
          fill: `url(#${linearGradient.id})`
        };
      case "radialGradient":
        const radialGradient = this.fill;
        context && context.addRadialGradient(radialGradient);
        return {
          fill: `url(#${radialGradient.id})`
        };
    }
  }
  _getStroke(context) {
    if (!this.stroke) {
      return {
        stroke: "none"
      };
    }
    switch (this.stroke.type) {
      case "unset":
        return {};
      case "none":
        return {
          stroke: "none"
        };
      case "solid":
        const solid = this.stroke;
        const attrs = {
          stroke: solid.toHex(false),
          strokeWidth: this.strokeWidth
        };
        if (solid.a < 1) {
          attrs.strokeOpacity = solid.a;
        }
        return attrs;
      case "linearGradient":
        const linearGradient = this.stroke;
        context && context.addLinearGradient(linearGradient);
        return {
          stroke: `url(#${linearGradient.id})`,
          strokeWidth: this.strokeWidth
        };
      case "radialGradient":
        const radialGradient = this.stroke;
        context && context.addRadialGradient(radialGradient);
        return {
          stroke: `url(#${radialGradient.id})`,
          strokeWidth: this.strokeWidth
        };
    }
  }
  _getTransform() {
    if (this.transform.isIdentity()) {
      return {};
    }
    return {
      transform: this.transform.toMatrixString()
    };
  }
  _getOpacity() {
    if (this.opacity >= 1) {
      return {};
    }
    return {
      opacity: this.opacity
    };
  }
  _getTags() {
    if (!Array.isArray(this.tags) || this.tags.length === 0) {
      return {};
    }
    return {
      className: this.tags.join(" ")
    };
  }
  _getClipPath() {
    if (!this.clipPath) {
      return {};
    }
    return {
      clipPath: `url(#${this.clipPath.id})`
    };
  }
  _updateAttributes(updates) {
    Object.entries(updates).forEach(([key, value]) => {
      if (value !== undefined) {
        this[key] = value;
      }
    });
  }
  getBounds() {
    return {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
      centerX: 0,
      centerY: 0
    };
  }
  matchesTags(tagsIn) {
    if (tagsIn.length === 0 || tagsIn.length === 1 && tagsIn[0] === "") {
      return true;
    }
    const posTagMatch = tagsIn.filter(tag => !tag.startsWith("!"));
    const negTagMatch = tagsIn.filter(tag => tag.startsWith("!")).map(tag => tag.replace("!", ""));
    if (posTagMatch.length > 0 && !posTagMatch.some(tag => this.tags.includes(tag))) {
      return false;
    }
    if (negTagMatch.some(tag => this.tags.includes(tag))) {
      return false;
    }
    return false;
  }
};
class Circle extends Shape$1 {
  cx;
  cy;
  radius;
  constructor(cx, cy, radius) {
    super(ShapeType.Circle);
    this.cx = cx;
    this.cy = cy;
    this.radius = radius;
    this.fill = Paint.black();
  }
  clone() {
    const circle = new Circle(this.cx, this.cy, this.radius);
    circle._cloneAttributes(this);
    return circle;
  }
  getBounds() {
    const strokeWidth = this.strokeWidth || 0;
    // Calculate the key points on the ellipse boundary
    const points = [{
      x: this.cx + this.radius + strokeWidth / 2,
      y: this.cy
    },
    // Right-most point
    {
      x: this.cx - this.radius - strokeWidth / 2,
      y: this.cy
    },
    // Left-most point
    {
      x: this.cx,
      y: this.cy + this.radius + strokeWidth / 2
    },
    // Bottom-most point
    {
      x: this.cx,
      y: this.cy - this.radius - strokeWidth / 2
    } // Top-most point
    ];
    // Apply the transformation matrix to each of these points
    const transformedPoints = points.map(point => Transform$1.applyMatrixTransform(point.x, point.y, this.transform.matrix));
    // Find the min and max of the transformed points for the bounding box
    const left = Math.min(...transformedPoints.map(p => p.x));
    const right = Math.max(...transformedPoints.map(p => p.x));
    const top = Math.min(...transformedPoints.map(p => p.y));
    const bottom = Math.max(...transformedPoints.map(p => p.y));
    // Calculate the center based on the new bounding box
    const centerX = (left + right) / 2;
    const centerY = (top + bottom) / 2;
    return {
      left,
      right,
      top,
      bottom,
      centerX,
      centerY
    };
  }
  _transformed(applyTransform, parentMatrix) {
    if (!applyTransform) {
      return {
        cx: this.cx,
        cy: this.cy,
        radius: this.radius
      };
    }
    const matrix = parentMatrix ? Transform$1.multiplyMatrices(parentMatrix, this.transform.matrix) : this.transform.matrix;
    if (Transform$1.matrixIsIdentity(matrix)) {
      return {
        cx: this.cx,
        cy: this.cy,
        radius: this.radius
      };
    }
    const {
      x,
      y
    } = Transform$1.applyMatrixTransform(this.cx, this.cy, matrix);
    const scaleX = Math.hypot(matrix[0], matrix[1]);
    const scaleY = Math.hypot(matrix[2], matrix[3]);
    const scale = (scaleX + scaleY) / 2;
    return {
      cx: x,
      cy: y,
      radius: this.radius * scale
    };
  }
  bakeTransform(parentMatrix) {
    const {
      cx,
      cy,
      radius
    } = this._transformed(true, parentMatrix);
    this.cx = cx;
    this.cy = cy;
    this.radius = radius;
    this.transform = new Transform$1();
  }
  toPathData(applyTransform, parentMatrix) {
    const {
      cx,
      cy,
      radius
    } = this._transformed(applyTransform, parentMatrix);
    return `M ${cx - radius}, ${cy} a ${radius}, ${radius} 0 1, 0 ${radius * 2}, 0 a ${radius}, ${radius} 0 1, 0 ${-radius * 2}, 0`;
  }
}
let Context$1 = class Context {
  clipPaths = [];
  gradients = [];
  constructor() {}
  addLinearGradient(gradient) {
    this.gradients.push(gradient);
  }
  addRadialGradient(gradient) {
    this.gradients.push(gradient);
  }
};
let Group$1 = class Group extends Shape$1 {
  children;
  height;
  width;
  viewBox;
  constructor() {
    super(ShapeType.Group);
    this.children = [];
  }
  [Symbol.iterator]() {
    let index = -1;
    const children = this.children;
    return {
      next: () => ({
        value: children[++index],
        done: index >= children.length
      })
    };
  }
  clone() {
    const group = new Group();
    group.children = this.children.map(child => child.clone());
    group._cloneAttributes(this);
    return group;
  }
  add(shape) {
    this.children.push(shape);
  }
  push(shape) {
    this.children.push(shape);
  }
  getBounds() {
    if (this.children.length === 0) {
      return {
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        centerX: 0,
        centerY: 0
      };
    }
    let left_ = Infinity;
    let right_ = -Infinity;
    let top_ = Infinity;
    let bottom_ = -Infinity;
    this.children.forEach(child => {
      if (typeof child.getBounds === "function") {
        const bounds = child.getBounds();
        left_ = Math.min(left_, bounds.left);
        right_ = Math.max(right_, bounds.right);
        top_ = Math.min(top_, bounds.top);
        bottom_ = Math.max(bottom_, bounds.bottom);
      }
    });
    const topLeft = Transform$1.applyMatrixTransform(left_, top_, this.transform.matrix);
    const topRight = Transform$1.applyMatrixTransform(right_, top_, this.transform.matrix);
    const bottomLeft = Transform$1.applyMatrixTransform(left_, bottom_, this.transform.matrix);
    const bottomRight = Transform$1.applyMatrixTransform(right_, bottom_, this.transform.matrix);
    const left = Math.min(topLeft.x, topRight.x, bottomLeft.x, bottomRight.x);
    const right = Math.max(topLeft.x, topRight.x, bottomLeft.x, bottomRight.x);
    const top = Math.min(topLeft.y, topRight.y, bottomLeft.y, bottomRight.y);
    const bottom = Math.max(topLeft.y, topRight.y, bottomLeft.y, bottomRight.y);
    const centerX = (left + right) / 2;
    const centerY = (top + bottom) / 2;
    return {
      left,
      right,
      top,
      bottom,
      centerX,
      centerY
    };
  }
  traverse(tagsIn, callback) {
    if (tagsIn.length === 1 && tagsIn[0] == "") tagsIn = [];
    const tags = Array.isArray(tagsIn) ? tagsIn : [tagsIn];
    const posTagMatch = tags.filter(tag => !tag.startsWith("!"));
    const negTagMatch = tags.filter(tag => tag.startsWith("!")).map(tag => tag.replace("!", ""));
    const matchesTags = item => {
      const itemTags = item.tags || [];
      if (posTagMatch.length === 0 && negTagMatch.length === 0) {
        return true;
      }
      if (posTagMatch.length > 0 && !posTagMatch.some(tag => itemTags.includes(tag))) {
        return false;
      }
      if (negTagMatch.some(tag => itemTags.includes(tag))) {
        return false;
      }
      return true;
    };
    // Check current group
    if (matchesTags(this)) {
      callback(this);
    }
    // Process children
    this.children.forEach(child => {
      if ("traverse" in child) {
        // Recursively process groups
        child.traverse(tags, callback);
      } else if (matchesTags(child)) {
        callback(child);
      }
    });
  }
  selectShapes(tagsIn) {
    if (tagsIn.length === 0 || tagsIn.length === 1 && tagsIn[0] === "") {
      return this.clone();
    }
    const posTagMatch = tagsIn.filter(tag => !tag.startsWith("!"));
    const negTagMatch = tagsIn.filter(tag => tag.startsWith("!")).map(tag => tag.replace("!", ""));
    const matchesTags = item => {
      const itemTags = item.tags || [];
      if (posTagMatch.length > 0 && !posTagMatch.some(tag => itemTags.includes(tag))) {
        return false;
      }
      if (negTagMatch.some(tag => itemTags.includes(tag))) {
        return false;
      }
      return true;
    };
    const filtered = this.clone();
    filtered.children = filtered.children.filter(child => {
      if ("traverse" in child) {
        if (child.tags && negTagMatch.some(tag => child.tags.includes(tag))) {
          return false;
        }
        if (posTagMatch.length > 0 && child.tags && posTagMatch.some(tag => child.tags.includes(tag))) {
          return true;
        }
        return child.selectShapes(tagsIn).children.length > 0;
      } else {
        return matchesTags(child);
      }
    }).map(child => {
      if ("traverse" in child) {
        if (posTagMatch.length > 0 && child.tags && posTagMatch.some(tag => child.tags.includes(tag))) {
          return child.clone();
        }
        return child.selectShapes(tagsIn);
      }
      return child;
    });
    return filtered;
  }
  _updateAttributes(updates) {
    Object.entries(updates).forEach(([key, value]) => {
      if (value !== undefined) {
        this[key] = value;
      }
    });
  }
  bakeTransform(parentMatrix) {
    const matrix = parentMatrix ? Transform$1.multiplyMatrices(parentMatrix, this.transform.matrix) : this.transform.matrix;
    this.children.forEach(child => {
      child.bakeTransform(matrix);
    });
    this.transform = new Transform$1();
  }
  toPathData(applyTransform, parentMatrix) {
    const matrix = parentMatrix ? Transform$1.multiplyMatrices(parentMatrix, this.transform.matrix) : this.transform.matrix;
    let d = "";
    this.children.forEach(child => {
      d += child.toPathData(applyTransform, matrix);
    });
    return d;
  }
};
class Line extends Shape$1 {
  x1;
  y1;
  x2;
  y2;
  constructor(x1, y1, x2, y2) {
    super(ShapeType.Line);
    this.x1 = x1;
    this.y1 = y1;
    this.x2 = x2;
    this.y2 = y2;
    this.stroke = Paint.black();
  }
  clone() {
    const clonedLine = new Line(this.x1, this.y1, this.x2, this.y2);
    clonedLine._cloneAttributes(this);
    return clonedLine;
  }
  getBounds() {
    const strokeWidth = this.strokeWidth || 0;
    // Apply transformation to the line endpoints
    const start = Transform$1.applyMatrixTransform(this.x1, this.y1, this.transform.matrix);
    const end = Transform$1.applyMatrixTransform(this.x2, this.y2, this.transform.matrix);
    // Adjust bounds to account for stroke width
    const left = Math.min(start.x, end.x) - strokeWidth / 2;
    const right = Math.max(start.x, end.x) + strokeWidth / 2;
    const top = Math.min(start.y, end.y) - strokeWidth / 2;
    const bottom = Math.max(start.y, end.y) + strokeWidth / 2;
    // Calculate the center point
    const centerX = (left + right) / 2;
    const centerY = (top + bottom) / 2;
    return {
      left,
      right,
      top,
      bottom,
      centerX,
      centerY
    };
  }
  _transformed(applyTransform, parentMatrix) {
    if (!applyTransform) {
      return {
        start: {
          x: this.x1,
          y: this.y1
        },
        end: {
          x: this.x2,
          y: this.y2
        }
      };
    }
    const matrix = parentMatrix ? Transform$1.multiplyMatrices(parentMatrix, this.transform.matrix) : this.transform.matrix;
    const start = Transform$1.applyMatrixTransform(this.x1, this.y1, matrix);
    const end = Transform$1.applyMatrixTransform(this.x2, this.y2, matrix);
    return {
      start,
      end
    };
  }
  bakeTransform(parentMatrix) {
    const {
      start,
      end
    } = this._transformed(true, parentMatrix);
    this.x1 = start.x;
    this.y1 = start.y;
    this.x2 = end.x;
    this.y2 = end.y;
    this.transform = new Transform$1();
  }
  toPathData(applyTransform, parentMatrix) {
    const {
      start,
      end
    } = this._transformed(applyTransform, parentMatrix);
    return `M ${start.x} ${start.y} L ${end.x} ${end.y}`;
  }
}
var Verb;
(function (Verb) {
  Verb["Move"] = "M";
  Verb["Line"] = "L";
  Verb["Quad"] = "Q";
  Verb["Cubic"] = "C";
  Verb["Close"] = "Z";
})(Verb || (Verb = {}));
// prettier-ignore
const PARAM_COUNTS = {
  A: 7,
  a: 7,
  C: 6,
  c: 6,
  H: 1,
  h: 1,
  L: 2,
  l: 2,
  M: 2,
  m: 2,
  Q: 4,
  q: 4,
  S: 4,
  s: 4,
  T: 2,
  t: 2,
  V: 1,
  v: 1,
  Z: 0,
  z: 0
};
function pathDataToSegments(pathData) {
  // Ensure spaces between letters and numbers
  // Otherwise 0-.227 would be parsed as [0, 0.227]
  pathData = pathData.replace(/([^\se])-/g, "$1 -");
  const tokens = pathData.match(/[a-zA-Z]|[-+]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][-+]?\d+)?|[-+]?\.\d+(?:[eE][-+]?\d+)?/g);
  if (!tokens) {
    return [];
  }
  let index = 0;
  let mode = "BOD";
  let token = tokens[index];
  const segments = [];
  while (token !== undefined) {
    let paramCount = 0;
    let params = [];
    if (mode === "BOD") {
      // Beginning of a path, only "M" and "m" commands are allowed
      if (token === "M" || token === "m") {
        index++;
        paramCount = PARAM_COUNTS[token];
        mode = token;
      } else {
        throw new Error("Invalid path data: path must begin with a moveto command");
      }
    } else if (/[a-zA-Z]/.test(token)) {
      // The token is a command, so we're switching modes
      index++;
      mode = token;
      paramCount = PARAM_COUNTS[token];
    } else {
      // The token is a number, so we're continuing with the current mode
      paramCount = PARAM_COUNTS[mode];
    }
    if (index + paramCount > tokens.length) {
      throw new Error(`Invalid path data: not enough parameters for command ${mode}`);
    }
    for (let i = index; i < index + paramCount; i++) {
      params.push(+tokens[i]);
    }
    const segment = {
      command: mode,
      params
    };
    segments.push(segment);
    index += paramCount;
    token = tokens[index];
    if (mode === "M") mode = "L";
    if (mode === "m") mode = "l";
  }
  return segments;
}
function arcToBezier(x1, y1, x4, y4, rx, ry, xAxisRotation, largeArcFlag, sweepFlag) {
  // Ensure non-zero radii
  if (rx === 0 || ry === 0) {
    return []; // Return empty array to indicate straight line
  }
  // Convert rotation angle from degrees to radians
  const phi = xAxisRotation * Math.PI / 180;
  const sinPhi = Math.sin(phi);
  const cosPhi = Math.cos(phi);
  // Step 1: Compute (x1′, y1′)
  const x1p = cosPhi * (x1 - x4) / 2 + sinPhi * (y1 - y4) / 2;
  const y1p = -sinPhi * (x1 - x4) / 2 + cosPhi * (y1 - y4) / 2;
  // Step 2: Compute (cx′, cy′)
  let rxSq = rx * rx;
  let rySq = ry * ry;
  const x1pSq = x1p * x1p;
  const y1pSq = y1p * y1p;
  // Check if the radii are too small and scale them if necessary
  const radiiScale = x1pSq / rxSq + y1pSq / rySq;
  if (radiiScale > 1) {
    rx *= Math.sqrt(radiiScale);
    ry *= Math.sqrt(radiiScale);
    rxSq = rx * rx;
    rySq = ry * ry;
  }
  const sign = largeArcFlag === sweepFlag ? -1 : 1;
  const sq = Math.max((rxSq * rySq - rxSq * y1pSq - rySq * x1pSq) / (rxSq * y1pSq + rySq * x1pSq), 0);
  const coef = sign * Math.sqrt(sq);
  const cxp = coef * (rx * y1p / ry);
  const cyp = coef * (-(ry * x1p) / rx);
  // Step 3: Compute (cx, cy) from (cx′, cy′)
  const cx = cosPhi * cxp - sinPhi * cyp + (x1 + x4) / 2;
  const cy = sinPhi * cxp + cosPhi * cyp + (y1 + y4) / 2;
  // Step 4: Compute the angleStart and angleExtent
  const ux = (x1p - cxp) / rx;
  const uy = (y1p - cyp) / ry;
  const vx = (-x1p - cxp) / rx;
  const vy = (-y1p - cyp) / ry;
  const angleStart = Math.atan2(uy, ux);
  let angleExtent = Math.atan2(vy, vx) - angleStart;
  // Ensure angleExtent is in the correct direction
  if (!sweepFlag && angleExtent > 0) {
    angleExtent -= 2 * Math.PI;
  } else if (sweepFlag && angleExtent < 0) {
    angleExtent += 2 * Math.PI;
  }
  // The maximum angle for a single cubic Bézier curve to approximate an arc
  const MAX_ANGLE = Math.PI / 2;
  // Split arc into multiple segments if angle is too large
  const segments = Math.max(Math.ceil(Math.abs(angleExtent) / MAX_ANGLE), 1);
  const deltaAngle = angleExtent / segments;
  const curves = [];
  for (let i = 0; i < segments; i++) {
    const angle = angleStart + i * deltaAngle;
    const nextAngle = angle + deltaAngle;
    // Length of the tangent for the cubic Bézier approximation
    // This magic number gives the best approximation for circular arcs
    const alpha = Math.sin(deltaAngle) * (Math.sqrt(4 + 3 * Math.pow(Math.tan(deltaAngle / 2), 2)) - 1) / 3;
    // Calculate points and control points
    const sinAngle = Math.sin(angle);
    const cosAngle = Math.cos(angle);
    const sinAngleNext = Math.sin(nextAngle);
    const cosAngleNext = Math.cos(nextAngle);
    // Start point
    const p1x = cx + (cosPhi * rx * cosAngle - sinPhi * ry * sinAngle);
    const p1y = cy + (sinPhi * rx * cosAngle + cosPhi * ry * sinAngle);
    // End point
    const p2x = cx + (cosPhi * rx * cosAngleNext - sinPhi * ry * sinAngleNext);
    const p2y = cy + (sinPhi * rx * cosAngleNext + cosPhi * ry * sinAngleNext);
    // Control points
    const c1x = p1x - alpha * (cosPhi * rx * sinAngle + sinPhi * ry * cosAngle);
    const c1y = p1y - alpha * (sinPhi * rx * sinAngle - cosPhi * ry * cosAngle);
    const c2x = p2x + alpha * (cosPhi * rx * sinAngleNext + sinPhi * ry * cosAngleNext);
    const c2y = p2y + alpha * (sinPhi * rx * sinAngleNext - cosPhi * ry * cosAngleNext);
    curves.push(new Point$1(c1x, c1y), new Point$1(c2x, c2y), new Point$1(p2x, p2y));
  }
  return curves;
}
let Path$2 = class Path extends Shape$1 {
  verbs;
  points;
  constructor() {
    super(ShapeType.Path);
    this.verbs = new Array();
    this.points = new Array();
    this.fill = Paint.black();
  }
  clone() {
    const path = new Path();
    path.verbs = this.verbs.slice();
    path.points = this.points.map(point => point.clone());
    path._cloneAttributes(this);
    return path;
  }
  _updateAttributes(updates) {
    Object.entries(updates).forEach(([key, value]) => {
      if (value !== undefined) {
        this[key] = value;
      }
    });
    return;
  }
  static rect(x, y, width, height) {
    const path = new Path();
    path.moveTo(x, y);
    path.lineTo(x + width, y);
    path.lineTo(x + width, y + height);
    path.lineTo(x, y + height);
    path.close();
    return path;
  }
  /**
   * Parse the given path data string and return a new Path object.
   * If the path data string is invalid, an empty path is returned.
   * @param pathData The SVG path data string
   * @returns A new Path object
   */
  static fromPathData(pathData) {
    const path = new Path();
    const tokens = pathData.match(/[a-zA-Z]|[\-+]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][\-+]?\d+)?|\.\d+(?:[eE][\-+]?\d+)?/g);
    if (!tokens) {
      return new Path();
    }
    let segments = pathDataToSegments(pathData);
    let currentX = 0;
    let currentY = 0;
    let startX = 0;
    let startY = 0;
    let prevControlX, prevControlY;
    for (const {
      command,
      params
    } of segments) {
      switch (command) {
        case "M":
          [currentX, currentY] = params;
          [startX, startY] = params;
          path.verbs.push(Verb.Move);
          path.points.push(new Point$1(currentX, currentY));
          break;
        case "m":
          currentX += params[0];
          currentY += params[1];
          [startX, startY] = [currentX, currentY];
          path.verbs.push(Verb.Move);
          path.points.push(new Point$1(currentX, currentY));
          break;
        case "L":
          [currentX, currentY] = params;
          path.verbs.push(Verb.Line);
          path.points.push(new Point$1(currentX, currentY));
          break;
        case "l":
          currentX += params[0];
          currentY += params[1];
          path.verbs.push(Verb.Line);
          path.points.push(new Point$1(currentX, currentY));
          break;
        case "H":
          currentX = params[0];
          path.verbs.push(Verb.Line);
          path.points.push(new Point$1(currentX, currentY));
          break;
        case "h":
          currentX += params[0];
          path.verbs.push(Verb.Line);
          path.points.push(new Point$1(currentX, currentY));
          break;
        case "V":
          currentY = params[0];
          path.verbs.push(Verb.Line);
          path.points.push(new Point$1(currentX, currentY));
          break;
        case "v":
          currentY += params[0];
          path.verbs.push(Verb.Line);
          path.points.push(new Point$1(currentX, currentY));
          break;
        case "Z":
        case "z":
          currentX = startX;
          currentY = startY;
          path.verbs.push(Verb.Close);
          break;
        case "Q":
          path.verbs.push(Verb.Quad);
          path.points.push(new Point$1(params[0], params[1]));
          path.points.push(new Point$1(params[2], params[3]));
          currentX = params[2];
          currentY = params[3];
          break;
        case "q":
          path.verbs.push(Verb.Quad);
          path.points.push(new Point$1(currentX + params[0], currentY + params[1]));
          path.points.push(new Point$1(currentX + params[2], currentY + params[3]));
          currentX += params[2];
          currentY += params[3];
          break;
        case "T":
          // Get previous control point
          prevControlX = currentX;
          prevControlY = currentY;
          if (path.verbs[path.verbs.length - 1] === Verb.Quad) {
            const lastPoint = path.points[path.points.length - 1];
            const lastControl = path.points[path.points.length - 2];
            prevControlX = 2 * lastPoint.x - lastControl.x;
            prevControlY = 2 * lastPoint.y - lastControl.y;
          }
          path.verbs.push(Verb.Quad);
          path.points.push(new Point$1(prevControlX, prevControlY));
          path.points.push(new Point$1(params[0], params[1]));
          currentX = params[0];
          currentY = params[1];
          break;
        case "t":
          // Get previous control point
          prevControlX = currentX;
          prevControlY = currentY;
          if (path.verbs[path.verbs.length - 1] === Verb.Quad) {
            const lastPoint = path.points[path.points.length - 1];
            const lastControl = path.points[path.points.length - 2];
            prevControlX = 2 * lastPoint.x - lastControl.x;
            prevControlY = 2 * lastPoint.y - lastControl.y;
          }
          path.verbs.push(Verb.Quad);
          path.points.push(new Point$1(prevControlX, prevControlY));
          path.points.push(new Point$1(currentX + params[0], currentY + params[1]));
          currentX += params[0];
          currentY += params[1];
          break;
        case "C":
          path.verbs.push(Verb.Cubic);
          path.points.push(new Point$1(params[0], params[1]));
          path.points.push(new Point$1(params[2], params[3]));
          path.points.push(new Point$1(params[4], params[5]));
          currentX = params[4];
          currentY = params[5];
          break;
        case "c":
          path.verbs.push(Verb.Cubic);
          path.points.push(new Point$1(currentX + params[0], currentY + params[1]));
          path.points.push(new Point$1(currentX + params[2], currentY + params[3]));
          path.points.push(new Point$1(currentX + params[4], currentY + params[5]));
          currentX += params[4];
          currentY += params[5];
          break;
        case "S":
          // Get previous control point
          prevControlX = currentX;
          prevControlY = currentY;
          if (path.verbs[path.verbs.length - 1] === Verb.Cubic) {
            const lastPoint = path.points[path.points.length - 1];
            const lastControl = path.points[path.points.length - 2];
            prevControlX = 2 * lastPoint.x - lastControl.x;
            prevControlY = 2 * lastPoint.y - lastControl.y;
          }
          path.verbs.push(Verb.Cubic);
          path.points.push(new Point$1(prevControlX, prevControlY));
          path.points.push(new Point$1(params[0], params[1]));
          path.points.push(new Point$1(params[2], params[3]));
          currentX = params[2];
          currentY = params[3];
          break;
        case "s":
          // Get previous control point
          prevControlX = currentX;
          prevControlY = currentY;
          if (path.verbs[path.verbs.length - 1] === Verb.Cubic) {
            const lastPoint = path.points[path.points.length - 1];
            const lastControl = path.points[path.points.length - 2];
            prevControlX = 2 * lastPoint.x - lastControl.x;
            prevControlY = 2 * lastPoint.y - lastControl.y;
          }
          path.verbs.push(Verb.Cubic);
          path.points.push(new Point$1(prevControlX, prevControlY));
          path.points.push(new Point$1(currentX + params[0], currentY + params[1]));
          path.points.push(new Point$1(currentX + params[2], currentY + params[3]));
          currentX += params[2];
          currentY += params[3];
          break;
        case "A":
          {
            const rx = params[0];
            const ry = params[1];
            const xAxisRotation = params[2];
            const largeArcFlag = params[3] === 1;
            const sweepFlag = params[4] === 1;
            const x = params[5];
            const y = params[6];
            const curves = arcToBezier(currentX, currentY, x, y, rx, ry, xAxisRotation, largeArcFlag, sweepFlag);
            for (let j = 0; j < curves.length; j += 3) {
              path.verbs.push(Verb.Cubic);
              path.points.push(curves[j]);
              path.points.push(curves[j + 1]);
              path.points.push(curves[j + 2]);
            }
            currentX = x;
            currentY = y;
          }
          break;
        case "a":
          {
            const rx = params[0];
            const ry = params[1];
            const xAxisRotation = params[2];
            const largeArcFlag = params[3] === 1;
            const sweepFlag = params[4] === 1;
            const x = currentX + params[5];
            const y = currentY + params[6];
            const curves = arcToBezier(currentX, currentY, x, y, rx, ry, xAxisRotation, largeArcFlag, sweepFlag);
            for (let j = 0; j < curves.length; j += 3) {
              path.verbs.push(Verb.Cubic);
              path.points.push(curves[j]);
              path.points.push(curves[j + 1]);
              path.points.push(curves[j + 2]);
            }
            currentX = x;
            currentY = y;
          }
          break;
      }
    }
    return path;
  }
  toPathData(applyTransform, parentMatrix) {
    function _apply(x, y) {
      if (!applyTransform || isIdentity) {
        return {
          x,
          y
        };
      } else {
        return Transform$1.applyMatrixTransform(x, y, matrix);
      }
    }
    const matrix = parentMatrix ? Transform$1.multiplyMatrices(parentMatrix, this.transform.matrix) : this.transform.matrix;
    const isIdentity = Transform$1.matrixIsIdentity(matrix);
    const parts = [];
    let pointIndex = 0;
    const len = this.verbs.length;
    for (let i = 0; i < len; i++) {
      const verb = this.verbs[i];
      switch (verb) {
        case "M":
        case "L":
          {
            const {
              x,
              y
            } = _apply(this.points[pointIndex].x, this.points[pointIndex].y);
            parts.push(verb, x, y);
            pointIndex++;
          }
          break;
        case "C":
          {
            const {
              x: x1,
              y: y1
            } = _apply(this.points[pointIndex].x, this.points[pointIndex].y);
            const {
              x: x2,
              y: y2
            } = _apply(this.points[pointIndex + 1].x, this.points[pointIndex + 1].y);
            const {
              x: x3,
              y: y3
            } = _apply(this.points[pointIndex + 2].x, this.points[pointIndex + 2].y);
            parts.push(verb, x1, y1, x2, y2, x3, y3);
            pointIndex += 3;
          }
          break;
        case "Z":
          parts.push(verb);
          break;
        default:
          console.warn("Unsupported path command:", verb);
      }
    }
    return parts.join(" ");
  }
  moveTo(x, y) {
    this.verbs.push(Verb.Move);
    this.points.push(new Point$1(x, y));
  }
  lineTo(x, y) {
    this.verbs.push(Verb.Line);
    this.points.push(new Point$1(x, y));
  }
  quadTo(x1, y1, x, y) {
    this.verbs.push(Verb.Quad);
    this.points.push(new Point$1(x1, y1));
    this.points.push(new Point$1(x, y));
  }
  cubicTo(x1, y1, x2, y2, x, y) {
    this.verbs.push(Verb.Cubic);
    this.points.push(new Point$1(x1, y1));
    this.points.push(new Point$1(x2, y2));
    this.points.push(new Point$1(x, y));
  }
  curveTo(x1, y1, x2, y2, x, y) {
    this.cubicTo(x1, y1, x2, y2, x, y);
  }
  bezierCurveTo(x1, y1, x2, y2, x, y) {
    this.cubicTo(x1, y1, x2, y2, x, y);
  }
  close() {
    this.verbs.push(Verb.Close);
  }
  closePath() {
    this.verbs.push(Verb.Close);
  }
  rect(x, y, width, height) {
    this.moveTo(x, y);
    this.lineTo(x + width, y);
    this.lineTo(x + width, y + height);
    this.lineTo(x, y + height);
    this.close();
  }
  circle(cx, cy, radius) {
    // The magic number 0.552284749831 is calculated as 4/3 * tan(π/8)
    // This gives the best approximation of a circle using 4 cubic Bézier curves
    const offset = radius * 0.552284749831;
    // Start at rightmost point
    this.moveTo(cx + radius, cy);
    // Draw four cubic Bézier curves, one for each quarter of the circle
    // First quadrant (right to bottom)
    this.cubicTo(cx + radius, cy + offset,
    // First control point
    cx + offset, cy + radius,
    // Second control point
    cx, cy + radius);
    // Second quadrant (bottom to left)
    this.cubicTo(cx - offset, cy + radius,
    // First control point
    cx - radius, cy + offset,
    // Second control point
    cx - radius, cy);
    // Third quadrant (left to top)
    this.cubicTo(cx - radius, cy - offset,
    // First control point
    cx - offset, cy - radius,
    // Second control point
    cx, cy - radius);
    // Fourth quadrant (top to right)
    this.cubicTo(cx + offset, cy - radius,
    // First control point
    cx + radius, cy - offset,
    // Second control point
    cx + radius, cy);
    // Close the path
    this.close();
  }
  // Usage example:
  // const path = new Path();
  // circle(path, 100, 100, 50); // Draws a circle at (100,100) with radius 50
  //
  arc(x, y, radius, startAngle, endAngle) {
    // Make sure the start is at the top
    startAngle -= Math.PI / 2;
    endAngle -= Math.PI / 2;
    // Normalize angles
    while (endAngle <= startAngle) {
      endAngle += 2 * Math.PI;
    }
    const isFullCircle = Math.abs(endAngle - startAngle - 2 * Math.PI) < 1e-6;
    if (isFullCircle) {
      this.moveTo(x + radius, y);
      this.drawFullCircle(x, y, radius, true);
    } else {
      const startSin = Math.sin(startAngle);
      const startCos = Math.cos(startAngle);
      const endSin = Math.sin(endAngle);
      const endCos = Math.cos(endAngle);
      const start = new Point$1(x + startCos * radius, y + startSin * radius);
      const end = new Point$1(x + endCos * radius, y + endSin * radius);
      this.moveTo(start.x, start.y);
      this.drawArcSegment(start.x, start.y, end.x, end.y, radius, endAngle - startAngle > Math.PI, true);
      this.lineTo(x, y);
    }
    this.close();
  }
  complexArc(x, y, innerRadius, outerRadius, startAngle, endAngle) {
    startAngle -= Math.PI / 2;
    endAngle -= Math.PI / 2;
    // Step 1: Normalize angles
    while (endAngle <= startAngle) {
      endAngle += 2 * Math.PI;
    }
    // Step 2: Check if we're drawing a full circle
    const isFullCircle = Math.abs(endAngle - startAngle - 2 * Math.PI) < 1e-6;
    // Step 3: Calculate start/end points for the arc
    if (isFullCircle) {
      // Step 4a: Handle full circle case
      if (innerRadius > 0) {
        // Draw outer circle
        this.moveTo(x + outerRadius, y);
        this.drawFullCircle(x, y, outerRadius, true);
        // Draw inner circle
        this.moveTo(x + innerRadius, y);
        this.drawFullCircle(x, y, innerRadius, false);
      } else {
        // Draw simple full circle
        this.moveTo(x + outerRadius, y);
        this.drawFullCircle(x, y, outerRadius, true);
      }
    } else {
      // Step 4b: Handle partial arc case
      const startSin = Math.sin(startAngle);
      const startCos = Math.cos(startAngle);
      const endSin = Math.sin(endAngle);
      const endCos = Math.cos(endAngle);
      const outerStart = new Point$1(x + startCos * outerRadius, y + startSin * outerRadius);
      const outerEnd = new Point$1(x + endCos * outerRadius, y + endSin * outerRadius);
      this.moveTo(outerStart.x, outerStart.y);
      if (innerRadius > 0) {
        // Draw outer arc
        this.drawArcSegment(outerStart.x, outerStart.y, outerEnd.x, outerEnd.y, outerRadius, endAngle - startAngle > Math.PI, true);
        // Draw inner arc
        const innerStart = new Point$1(x + endCos * innerRadius, y + endSin * innerRadius);
        const innerEnd = new Point$1(x + startCos * innerRadius, y + startSin * innerRadius);
        this.lineTo(innerStart.x, innerStart.y);
        this.drawArcSegment(innerStart.x, innerStart.y, innerEnd.x, innerEnd.y, innerRadius, endAngle - startAngle > Math.PI, false);
      } else {
        // Draw simple arc
        this.drawArcSegment(outerStart.x, outerStart.y, outerEnd.x, outerEnd.y, outerRadius, endAngle - startAngle > Math.PI, true);
        this.lineTo(x, y);
      }
    }
    this.close();
  }
  drawFullCircle(x, y, radius, clockwise) {
    // Split circle into two semicircles for better numerical stability
    const startPoint = new Point$1(x + radius, y); // Point at 0 degrees
    const midPoint = new Point$1(x - radius, y); // Point at 180 degrees
    this.drawArcSegment(startPoint.x, startPoint.y, midPoint.x, midPoint.y, radius, true, clockwise);
    this.drawArcSegment(midPoint.x, midPoint.y, startPoint.x, startPoint.y, radius, true, clockwise);
  }
  drawArcSegment(startX, startY, endX, endY, radius, largeArc, clockwise) {
    const curves = arcToBezier(startX, startY, endX, endY, radius, radius, 0, largeArc, clockwise);
    for (let i = 0; i < curves.length; i += 3) {
      this.cubicTo(curves[i].x, curves[i].y, curves[i + 1].x, curves[i + 1].y, curves[i + 2].x, curves[i + 2].y);
    }
  }
  getBounds() {
    if (this.points.length === 0) {
      return {
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        centerX: 0,
        centerY: 0
      };
    }
    const strokeWidth = this.strokeWidth || 0;
    // Transform all points in the path
    const matrix = this.transform.matrix;
    let transformedPoints = this.points.map(point => Transform$1.applyMatrixTransform(point.x, point.y, matrix));
    // Compute the bounding box for transformed points
    let left = transformedPoints[0].x;
    let right = transformedPoints[0].x;
    let top = transformedPoints[0].y;
    let bottom = transformedPoints[0].y;
    for (const point of transformedPoints) {
      left = Math.min(left, point.x);
      right = Math.max(right, point.x);
      top = Math.min(top, point.y);
      bottom = Math.max(bottom, point.y);
    }
    // Apply transformation to the strokeWidth (assuming uniform scaling)
    const scaleFactor = Math.sqrt(matrix[0] * matrix[0] + matrix[1] * matrix[1]);
    const transformedStrokeWidth = strokeWidth * scaleFactor;
    left -= transformedStrokeWidth / 2;
    right += transformedStrokeWidth / 2;
    top -= transformedStrokeWidth / 2;
    bottom += transformedStrokeWidth / 2;
    const centerX = (left + right) / 2;
    const centerY = (top + bottom) / 2;
    return {
      left,
      right,
      top,
      bottom,
      centerX,
      centerY
    };
  }
  bakeTransform(parentMatrix) {
    const matrix = parentMatrix ? Transform$1.multiplyMatrices(parentMatrix, this.transform.matrix) : this.transform.matrix;
    const t = new Transform$1(matrix);
    this.points = this.points.map(t.transformPoint.bind(t));
    this.transform = new Transform$1();
  }
};
class Rect extends Shape$1 {
  x;
  y;
  width;
  height;
  constructor(x, y, width, height) {
    super(ShapeType.Rect);
    this.x = x;
    this.y = y;
    this.width = width;
    this.height = height;
    this.fill = Paint.black();
  }
  clone() {
    const rect = new Rect(this.x, this.y, this.width, this.height);
    rect._cloneAttributes(this);
    return rect;
  }
  getBounds() {
    const strokeWidth = this.strokeWidth || 0;
    const left_ = this.x - strokeWidth / 2;
    const right_ = this.x + this.width + strokeWidth / 2;
    const top_ = this.y - strokeWidth / 2;
    const bottom_ = this.y + this.height + strokeWidth / 2;
    const topLeft = Transform$1.applyMatrixTransform(left_, top_, this.transform.matrix);
    const topRight = Transform$1.applyMatrixTransform(right_, top_, this.transform.matrix);
    const bottomLeft = Transform$1.applyMatrixTransform(left_, bottom_, this.transform.matrix);
    const bottomRight = Transform$1.applyMatrixTransform(right_, bottom_, this.transform.matrix);
    // Find the min and max of the transformed corners for bounding box
    const left = Math.min(topLeft.x, topRight.x, bottomLeft.x, bottomRight.x);
    const right = Math.max(topLeft.x, topRight.x, bottomLeft.x, bottomRight.x);
    const top = Math.min(topLeft.y, topRight.y, bottomLeft.y, bottomRight.y);
    const bottom = Math.max(topLeft.y, topRight.y, bottomLeft.y, bottomRight.y);
    // Center points can be calculated based on the new bounding box
    const centerX = (left + right) / 2;
    const centerY = (top + bottom) / 2;
    return {
      left,
      right,
      top,
      bottom,
      centerX,
      centerY
    };
  }
  _transformed(applyTransform, parentMatrix) {
    if (!applyTransform) {
      return {
        x: this.x,
        y: this.y,
        width: this.width,
        height: this.height
      };
    }
    const matrix = parentMatrix ? Transform$1.multiplyMatrices(parentMatrix, this.transform.matrix) : this.transform.matrix;
    const topLeft = Transform$1.applyMatrixTransform(this.x, this.y, matrix);
    const topRight = Transform$1.applyMatrixTransform(this.x + this.width, this.y, matrix);
    const bottomLeft = Transform$1.applyMatrixTransform(this.x, this.y + this.height, matrix);
    const bottomRight = Transform$1.applyMatrixTransform(this.x + this.width, this.y + this.height, matrix);
    const left = Math.min(topLeft.x, topRight.x, bottomLeft.x, bottomRight.x);
    const right = Math.max(topLeft.x, topRight.x, bottomLeft.x, bottomRight.x);
    const top = Math.min(topLeft.y, topRight.y, bottomLeft.y, bottomRight.y);
    const bottom = Math.max(topLeft.y, topRight.y, bottomLeft.y, bottomRight.y);
    return {
      x: left,
      y: top,
      width: right - left,
      height: bottom - top
    };
  }
  bakeTransform(parentMatrix) {
    const {
      x,
      y,
      width,
      height
    } = this._transformed(true, parentMatrix);
    this.x = x;
    this.y = y;
    this.width = width;
    this.height = height;
    this.transform = new Transform$1();
  }
  toPathData(applyTransform, parentMatrix) {
    const {
      x,
      y,
      width,
      height
    } = this._transformed(applyTransform, parentMatrix);
    return `M ${x}, ${y} h ${width} v ${height} h ${-width} Z`;
  }
}
let _measureCtx = null;
if (typeof document !== "undefined") {
  const _measureCanvas = document.createElement("canvas");
  _measureCtx = _measureCanvas.getContext("2d");
}
class Text extends Shape$1 {
  x;
  y;
  text;
  fontSize;
  fontFamily;
  fontWeight;
  textAnchor;
  fill;
  _cachedFont = null;
  _cachedText = null;
  _cachedMetrics = null;
  constructor(text, x, y, fontSize, fontFamily, fontWeight = "normal", textAnchor = "start", fill = Paint.black()) {
    super(ShapeType.Text);
    this.text = text;
    this.x = x;
    this.y = y;
    this.fontSize = fontSize;
    this.fontFamily = fontFamily;
    this.fontWeight = fontWeight || "normal";
    this.textAnchor = textAnchor || "start";
    this.fill = fill;
  }
  clone() {
    const text = new Text(this.text, this.x, this.y, this.fontSize, this.fontFamily, this.fontWeight, this.textAnchor, this.fill);
    text._cloneAttributes(this);
    return text;
  }
  getBounds() {
    return this.getTransformedBounds();
    //   const metrics = this.measureTextDimensions(this.text, this.fontSize, this.fontFamily);
    //   let left = this.x;
    //   let right = this.x;
    //   let top = this.y - metrics.height / (metrics.descent || 1);
    //   let bottom = this.y;
    //   let base = top + metrics.height;
    //   switch (this.textAnchor) {
    //     case "start":
    //       right = left + metrics.width;
    //       break;
    //     case "end":
    //       left = this.x - metrics.width;
    //       right = this.x;
    //       break;
    //     case "middle":
    //       left -= metrics.width / 2;
    //       right += metrics.width / 2;
    //       break;
    //   }
    //   const centerX = (left + right) / 2;
    //   const centerY = (top + bottom) / 2;
    //   return { left, right, top, bottom: base, centerX, centerY, base };
  }
  measureTextDimensions(text, fontSize, fontFamily) {
    if (!_measureCtx) {
      return {
        width: 0,
        height: 0,
        descent: 0
      };
    }
    const font = `${fontSize}px ${fontFamily}`;
    if (this._cachedFont === font && this._cachedText === text && this._cachedMetrics) {
      return this._cachedMetrics;
    }
    if (this._cachedFont !== font) {
      _measureCtx.font = font;
      this._cachedFont = font;
    }
    const metrics = _measureCtx.measureText(text);
    this._cachedText = text;
    this._cachedMetrics = {
      width: metrics.width,
      height: parseFloat(fontSize) * 1.12,
      descent: (metrics.fontBoundingBoxAscent + metrics.fontBoundingBoxDescent) / metrics.fontBoundingBoxAscent
    };
    return this._cachedMetrics;
  }
  getTransformedBounds(useTransform = true) {
    const metrics = this.measureTextDimensions(this.text, this.fontSize, this.fontFamily);
    // Adjust initial bounds based on textAnchor
    let left = this.x;
    let right = this.x;
    let top = this.y - metrics.height / (metrics.descent || 1); // Estimate ascent based on height and descent ratio
    this.y;
    let base = top + metrics.height;
    switch (this.textAnchor) {
      case "start":
        right = left + metrics.width;
        break;
      case "end":
        left = this.x - metrics.width;
        right = this.x;
        break;
      case "middle":
        left -= metrics.width / 2;
        right += metrics.width / 2;
        break;
    }
    // Now transform all four corners of the bounding box
    let matrix;
    if (useTransform) {
      matrix = this.transform.matrix;
    } else {
      matrix = new Transform$1().matrix;
    }
    // Apply matrix transformation to each corner
    const topLeft = Transform$1.applyMatrixTransform(left, top, matrix);
    const topRight = Transform$1.applyMatrixTransform(right, top, matrix);
    const bottomLeft = Transform$1.applyMatrixTransform(left, base, matrix);
    const bottomRight = Transform$1.applyMatrixTransform(right, base, matrix);
    // Find the min/max for the transformed bounding box
    const transformedLeft = Math.min(topLeft.x, topRight.x, bottomLeft.x, bottomRight.x);
    const transformedRight = Math.max(topLeft.x, topRight.x, bottomLeft.x, bottomRight.x);
    const transformedTop = Math.min(topLeft.y, topRight.y, bottomLeft.y, bottomRight.y);
    const transformedBottom = Math.max(topLeft.y, topRight.y, bottomLeft.y, bottomRight.y);
    // Calculate the transformed center
    const transformedCenterX = (transformedLeft + transformedRight) / 2;
    const transformedCenterY = (transformedTop + transformedBottom) / 2;
    return {
      left: transformedLeft,
      right: transformedRight,
      top: transformedTop,
      bottom: transformedBottom,
      centerX: transformedCenterX,
      centerY: transformedCenterY
    };
  }
  bakeTransform(parentMatrix) {
    const matrix = parentMatrix ? Transform$1.multiplyMatrices(parentMatrix, this.transform.matrix) : this.transform.matrix;
    const {
      x,
      y
    } = Transform$1.applyMatrixTransform(this.x, this.y, matrix);
    const scaleX = Math.hypot(matrix[0], matrix[1]);
    const scaleY = Math.hypot(matrix[2], matrix[3]);
    const scale = (scaleX + scaleY) / 2;
    this.x = x;
    this.y = y;
    const fontSizeMatch = this.fontSize.match(/^([\d.]+)([a-z%]*)$/);
    if (fontSizeMatch) {
      const fontSizeValue = parseFloat(fontSizeMatch[1]);
      const fontSizeUnit = fontSizeMatch[2] || "px";
      const newFontSizeValue = fontSizeValue * scale;
      this.fontSize = `${newFontSizeValue}${fontSizeUnit}`;
    }
    this.transform = new Transform$1();
  }
  toPathData(applyTransform, parentMatrix) {
    return "";
  }
}

function parseChoices$1(choices) {
    if (choices.length === 0)
        return [];
    if (typeof choices[0] === "string") {
        return choices.map((name) => ({ name, label: startCase(name) }));
    }
    else {
        return choices.map(([name, label]) => ({ name, label }));
    }
}
function defaultValueForType(type) {
    if (type === ParameterType.Number) {
        return 0;
    }
    else if (type === ParameterType.String || type === ParameterType.File) {
        return "";
    }
    else if (type === ParameterType.Boolean) {
        return false;
    }
    else if (type === ParameterType.Point) {
        return { x: 0, y: 0 };
    }
    else if (type === ParameterType.Color) {
        return { r: 0, g: 0, b: 0, a: 1 };
    }
    else {
        throw new Error(`Invalid parameter type: ${type}`);
    }
}
function defaultWidgetForType(type) {
    return type;
}
function createExpressionContext(_cx, globals) {
    const networkProxy = new Proxy(globals.network, {
        get(target, prop) {
            if (target.hasOwnProperty(prop)) {
                return target[prop];
            }
            const param = target.parameters.find((p) => p.name === prop);
            if (param) {
                if (globals.values && globals.values.hasOwnProperty(prop)) {
                    return globals.values[prop];
                }
                else {
                    return param.defaultValue;
                }
            }
        },
    });
    return { network: networkProxy, values: globals.values };
}
class Parameter {
    node;
    type;
    widget;
    name;
    label;
    section;
    defaultValue;
    choices;
    min;
    max;
    step;
    constructor(node, name, type, defaultValue = undefined, choices) {
        this.node = node;
        this.type = type;
        this.widget = defaultWidgetForType(type);
        this.name = name;
        this.label = startCase(name);
        this.defaultValue = typeof defaultValue !== "undefined" ? defaultValue : defaultValueForType(type);
        this.choices = choices;
        this.min = -Infinity;
        this.max = Infinity;
        this.step = 1;
        this.section = undefined;
    }
    get value() {
        const nodeValue = this.node.values?.[this.name];
        if (nodeValue !== undefined) {
            if (nodeValue.type === "VALUE") {
                if (this.type === ParameterType.Color) {
                    return Paint.parse(nodeValue.value);
                }
                return nodeValue.value;
            }
            else {
                // HACK This is to make network expressions work, without breaking the example plot projects
                if (nodeValue.expression.startsWith("network.")) {
                    const ctx = this.node.globals;
                    let result = evaluateExpression(nodeValue.expression, ctx);
                    if (this.type === ParameterType.Color) {
                        result = Paint.parse(result);
                    }
                    return result;
                }
                else {
                    return nodeValue.expression;
                }
            }
        }
        else {
            return this.defaultValue;
        }
    }
    get fn() {
        return (d) => {
            const nodeValue = this.node.values?.[this.name];
            if (nodeValue === undefined)
                return this.defaultValue;
            if (nodeValue.type === "VALUE") {
                if (this.type === ParameterType.Color) {
                    return Paint.parse(nodeValue.value);
                }
                return nodeValue.value;
            }
            else {
                const ctx = { ...d, ...this.node.globals };
                let result = evaluateExpression(nodeValue.expression, ctx);
                if (this.type === ParameterType.Color) {
                    result = Paint.parse(result);
                }
                return result;
            }
        };
    }
    get timeDependent() {
        const nodeValue = this.node.values?.[this.name];
        if (nodeValue === undefined)
            return false;
        return nodeValue.type === "EXPRESSION" && /(\$FRAME|\$TIME|\$NOW|osc)/.test(nodeValue.expression);
    }
}
class Port {
    node;
    type;
    name;
    _value;
    constructor(node, name, type) {
        this.node = node;
        this.name = name;
        this.type = type;
        this._value = null;
    }
    get value() {
        const portValue = this.node.cx.portValues.get(`${this.node.nodeId}/${this.name}`);
        if (portValue !== undefined)
            return portValue;
        return this._value;
    }
    set(value) {
        this._value = value;
    }
}
class RuntimeNode {
    cx;
    nodeId;
    nodeFn;
    inputPorts;
    outputPorts;
    parameters;
    values;
    _timeDependent;
    dirty;
    globals;
    sections;
    _currentSection;
    message;
    constructor(cx, nodeId, nodeFn) {
        this.cx = cx;
        this.nodeId = nodeId;
        this.nodeFn = nodeFn;
        this.inputPorts = [];
        this.outputPorts = [];
        this.parameters = [];
        this.values = {};
        this._timeDependent = false;
        this.dirty = true;
        this.globals = null;
        this.sections = [];
        this._currentSection = undefined;
    }
    get timeDependent() {
        if (this._timeDependent) {
            return true;
        }
        return this.parameters.some((p) => p.timeDependent);
    }
    set timeDependent(value) {
        this._timeDependent = value;
    }
    numberIn({ name, value, min, max, step, }) {
        const parameter = new Parameter(this, name, ParameterType.Number, value);
        parameter.section = this._currentSection;
        if (min !== undefined) {
            parameter.min = min;
        }
        if (max !== undefined) {
            parameter.max = max;
        }
        if (step !== undefined) {
            parameter.step = step;
        }
        this.parameters.push(parameter);
        return parameter;
    }
    stringIn({ name, value, widget, choices, }) {
        const parameter = new Parameter(this, name, ParameterType.String, value);
        parameter.section = this._currentSection;
        if (widget) {
            parameter.widget = widget;
        }
        if (choices) {
            let realChoices = parseChoices$1(choices);
            parameter.choices = realChoices;
        }
        this.parameters.push(parameter);
        return parameter;
    }
    booleanIn({ name, value }) {
        const parameter = new Parameter(this, name, ParameterType.Boolean, value);
        parameter.section = this._currentSection;
        this.parameters.push(parameter);
        return parameter;
    }
    colorIn({ name, value }) {
        if (typeof value === "string") {
            value = Paint.parse(value);
        }
        const parameter = new Parameter(this, name, ParameterType.Color, value);
        parameter.section = this._currentSection;
        this.parameters.push(parameter);
        return parameter;
    }
    choiceIn({ name, value, choices }) {
        const parameter = new Parameter(this, name, ParameterType.Choice, value, choices);
        parameter.section = this._currentSection;
        this.parameters.push(parameter);
        return parameter;
    }
    fileIn({ name, value }) {
        const parameter = new Parameter(this, name, ParameterType.File, value);
        parameter.section = this._currentSection;
        this.parameters.push(parameter);
        return parameter;
    }
    tableIn({ name }) {
        const port = new Port(this, name, PortType.Table);
        this.inputPorts.push(port);
        return port;
    }
    shapeIn({ name }) {
        const port = new Port(this, name, PortType.Shape);
        this.inputPorts.push(port);
        return port;
    }
    specIn({ name }) {
        const port = new Port(this, name, PortType.Spec);
        this.inputPorts.push(port);
        return port;
    }
    tableOut({ name }) {
        const port = new Port(this, name, PortType.Table);
        this.outputPorts.push(port);
        return port;
    }
    shapeOut({ name }) {
        const port = new Port(this, name, PortType.Shape);
        this.outputPorts.push(port);
        return port;
    }
    specOut({ name }) {
        const port = new Port(this, name, PortType.Spec);
        this.outputPorts.push(port);
        return port;
    }
    pushSection({ name, collapsed = false }) {
        if (this._currentSection) {
            throw new Error(`Section ${this._currentSection} is not closed`);
        }
        this.sections.push({ name, collapsed });
        this._currentSection = name;
    }
    popSection() {
        this._currentSection = undefined;
    }
    onRender(_cx) {
        throw new Error("Not implemented");
    }
    onChange(_cx, _parameterName) { }
}

// rename updateFormatVersion -> upgrades
// Define a constant for the latest supported format version.
const LATEST_FORMAT_VERSION = 4;
function queryProjectItems(project, query, subQuery) {
    const items = project.items;
    const childOrConnection = Object.keys(subQuery)[0];
    const domain = subQuery[childOrConnection];
    const ret = [];
    const resultArray = items.filter((item) => Object.keys(query).every((key) => item[key] === query[key]));
    resultArray.forEach((el) => {
        ret.push(...el[childOrConnection].filter((item) => Object.keys(domain).every((key) => item[key] === domain[key])));
    });
    return ret;
}
/**
 * Sets the current format version on the project to the latest supported version,
 * ensuring compatibility and integrity of the project's format.
 *
 * @param project The project object to be updated.
 * @returns The updated project object with the correct format version.
 * @throws Error if the project's version is newer than supported.
 */
function updateFormatVersion(project, formatVersion = LATEST_FORMAT_VERSION) {
    // Check if the project format version is undefined and initialize it to 1.
    if (project.formatVersion === undefined) {
        project.formatVersion = 1;
    }
    // If the project's version is already the latest, return the project as-is.
    if (project.formatVersion === formatVersion) {
        return project;
    }
    // If the project's version is greater than the latest supported version,
    // throw an error indicating that this version is actually not possible in the online version.
    if (project.formatVersion > formatVersion) {
        throw new Error("Invalid project format version. You might want to retry later on.");
    }
    // Upgrade the project format version incrementally until it reaches the latest version.
    while (project.formatVersion < formatVersion) {
        if (project.formatVersion === 1) {
            // Version 2: Update load-csv to import-data
            queryProjectItems(project, { type: "NETWORK" }, { children: { fn: "core/g/load-csv" } }).forEach((el) => {
                el.fn = "core/g/import-data";
                // Use replace to keep sequence numbers.
                el.name = el.name.replace(/load-csv/g, "import-data");
            });
        }
        else if (project.formatVersion === 2) {
            // Version 3: Add "outputPorts": [] to project > items
            project.items.forEach((el) => {
                if (!el["outputPorts"])
                    el["outputPorts"] = [];
            });
        }
        else if (project.formatVersion === 3) {
            // Version 4: Rename all core nodes from "names-with-dashes" to "Names With Spaces"
            // So for example "core/g/filter-data" becomes "core/g/Filter Data".
            // Also rename the node's name if it starts with the old name.
            for (const item of project.items) {
                if (item.type === "NETWORK") {
                    for (const child of item.children) {
                        if (child.type === "NODE") {
                            const node = child;
                            const functionName = node.fn;
                            const parts = functionName.split("/");
                            const userProjectPart = parts.slice(0, parts.length - 1).join("/");
                            if (userProjectPart !== "core/g")
                                continue;
                            const namePart = parts[parts.length - 1];
                            const namePartWords = namePart.split("-");
                            const newName = namePartWords.map((w) => w.charAt(0).toUpperCase() + w.slice(1)).join(" ");
                            node.fn = `${userProjectPart}/${newName}`;
                            if (node.name.startsWith(namePart)) {
                                node.name = node.name.replace(namePart, newName);
                            }
                        }
                    }
                }
            }
        }
        // if (project.formatVersion === 3) {
        //   // Version 4: Add dependency
        //   if (!project.dependencies["core/plot"]) {
        //     project.dependencies["core/plot"] = "dev";
        //   }
        // }
        project.formatVersion++;
    }
    // Return the project after potentially upgrading it.
    return project;
}

var TokenType;
(function (TokenType) {
    TokenType["STRING"] = "STRING";
    TokenType["COMMENT"] = "COMMENT";
    TokenType["IDENTIFIER"] = "IDENTIFIER";
    TokenType["PUNCTUATION"] = "PUNCTUATION";
    TokenType["WHITESPACE"] = "WHITESPACE";
    TokenType["OTHER"] = "OTHER";
    TokenType["NUMBER"] = "NUMBER";
})(TokenType || (TokenType = {}));
function lexer(source) {
    const tokens = [];
    let i = 0;
    while (i < source.length) {
        let char = source[i];
        if (char === '"' || char === "'") {
            let value = char;
            const quote = char;
            i++;
            while (i < source.length && source[i] !== quote) {
                if (source[i] === "\\" && i + 1 < source.length) {
                    value += source[i] + source[i + 1];
                    i += 2;
                }
                else {
                    value += source[i];
                    i++;
                }
            }
            if (i < source.length) {
                value += source[i];
                i++;
            }
            tokens.push({ type: TokenType.STRING, value });
        }
        else if (char === "/" && source[i + 1] === "/") {
            let value = "//";
            i += 2;
            while (i < source.length && source[i] !== "\n") {
                value += source[i];
                i++;
            }
            tokens.push({ type: TokenType.COMMENT, value });
        }
        else if (char === "/" && source[i + 1] === "*") {
            let value = "/*";
            i += 2;
            while (i < source.length && !(source[i] === "*" && source[i + 1] === "/")) {
                value += source[i];
                i++;
            }
            if (i < source.length) {
                value += "*/";
                i += 2;
            }
            tokens.push({ type: TokenType.COMMENT, value });
        }
        else if (/[a-zA-Z_$]/.test(char)) {
            let value = "";
            while (i < source.length && /[a-zA-Z0-9_$]/.test(source[i])) {
                value += source[i];
                i++;
            }
            tokens.push({ type: TokenType.IDENTIFIER, value });
        }
        else if (/[0-9]/.test(char) || (char === "." && /[0-9]/.test(source[i + 1]))) {
            let value = "";
            while (i < source.length && /[0-9.]/.test(source[i])) {
                value += source[i];
                i++;
            }
            tokens.push({ type: TokenType.NUMBER, value });
        }
        else if (/[(){};,.:=+\-*/%<>!&|^~]/.test(char)) {
            tokens.push({ type: TokenType.PUNCTUATION, value: char });
            i++;
        }
        else if (/\s/.test(char)) {
            let value = "";
            while (i < source.length && /\s/.test(source[i])) {
                value += source[i];
                i++;
            }
            tokens.push({ type: TokenType.WHITESPACE, value });
        }
        else {
            tokens.push({ type: TokenType.OTHER, value: char });
            i++;
        }
    }
    return tokens;
}
function findNodeStatements(source) {
    const tokens = lexer(source);
    const statements = [];
    let currentStatement = "";
    let bracketCount = 0;
    let inNodeStatement = false;
    for (let i = 0; i < tokens.length; i++) {
        const token = tokens[i];
        const nextToken = tokens[i + 1];
        const nextNextToken = tokens[i + 2];
        if (!inNodeStatement &&
            token.type === TokenType.IDENTIFIER &&
            token.value === "node" &&
            nextToken?.type === TokenType.PUNCTUATION &&
            nextToken.value === "." &&
            nextNextToken?.type === TokenType.IDENTIFIER &&
            !nextNextToken.value.startsWith("on")) {
            inNodeStatement = true;
            currentStatement = "";
        }
        if (inNodeStatement) {
            currentStatement += token.value;
            if (token.type === TokenType.PUNCTUATION) {
                if (token.value === "(" || token.value === "{" || token.value === "[") {
                    bracketCount++;
                }
                else if (token.value === ")" || token.value === "}" || token.value === "]") {
                    bracketCount--;
                    if (bracketCount === 0) {
                        statements.push(currentStatement.trim());
                        inNodeStatement = false;
                        currentStatement = "";
                    }
                }
            }
        }
    }
    // Handle case where the last statement is incomplete
    if (inNodeStatement && currentStatement.trim() !== "") {
        statements.push(currentStatement.trim());
    }
    return statements;
}

async function loadProjectThroughApi(url) {
    const token = localStorage.getItem("token");
    const response = await fetch(url, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token || ""}`,
        },
    });
    if (!response.ok) {
        try {
            const result = await response.json();
            return result;
        }
        catch (e) {
            return { status: "error", message: response.statusText };
        }
    }
    try {
        const result = await response.json();
        return result;
    }
    catch (e) {
        return { status: "error", message: "Failed to parse response" };
    }
}
async function loadProjectDirectly(url) {
    try {
        const response = await fetch(url);
        if (!response.ok) {
            try {
                const errBody = await response.json();
                return {
                    status: "error",
                    message: errBody?.message || response.statusText,
                };
            }
            catch {
                return { status: "error", message: response.statusText };
            }
        }
        try {
            const data = await response.json();
            return { status: "ok", project: data };
        }
        catch (e) {
            return {
                status: "error",
                message: "Failed to parse JSON: " + String(e),
            };
        }
    }
    catch (e) {
        return { status: "error", message: String(e) };
    }
}
const envType = typeof window === "undefined" ? "node" : "browser";
const config = {
    apiRoot: "https://new.nodebox.live",
    publishedUrlTemplate: "https://new.nodebox.live/api/published/{{ userId }}/{{ projectId }}",
    // Template for asset URLs
    assetsUrlTemplate: "https://new.nodebox.live/api/assets/{{ userId }}/{{ projectId }}/blobs/{{ hash }}",
    // Template for library URLs
    libUrlTemplate: "https://new.nodebox.live/api/fn/{{ userId }}/{{ projectId }}/{{ file }}.js",
    // Used to replace @ndbx/g with https://esm.sh/@ndbx/g
    bareImportReplacer: (name) => `https://esm.sh/${name}`,
};
async function loadMainProject(userId, projectId, version) {
    const projectKey = `${userId}/${projectId}`;
    const loader = { assetMap: new Map(), projectMap: new Map() };
    const project = await loadProject(userId, projectId, version, loader);
    const dependencies = structuredClone(loader.projectMap);
    dependencies.delete(projectKey);
    const cx = new Context$2(project, loader.assetMap, dependencies);
    //   await Promise.all(project.items.map((item: Item) => loadItem(cx, projectKey, item)));
    return cx;
}
async function loadProject(userId, projectId, version, loader) {
    const projectKey = `${userId}/${projectId}`;
    if (loader.projectMap.has(projectKey)) {
        return loader.projectMap.get(projectKey);
    }
    let result;
    if (version !== "published") {
        // If it's not a published project, we're going through the API
        const projectUrl = `${config.apiRoot}/api/projects/${userId}/${projectId}/${version}`;
        result = await loadProjectThroughApi(projectUrl);
    }
    else {
        // If it is a published project, we'll use the publishedRoot prefix.
        // Note that this is not an API call! We'll just receive the project.json, so we can't check `result.status`.
        const projectUrl = evalTemplate(config.publishedUrlTemplate, { userId, projectId });
        result = await loadProjectDirectly(projectUrl);
    }
    if (result.status !== "ok") {
        throw new Error(`Error loading project '${userId}/${projectId}': ${result.message}`);
    }
    if (result.assetsUrlTemplate) {
        config.assetsUrlTemplate = result.assetsUrlTemplate;
    }
    const project = result.project;
    if (project === undefined) {
        throw new Error(`Failed to load project ${userId}/${projectId}@${version}: ${result.message}`);
    }
    const loadedProject = updateFormatVersion(project);
    setMetaDataForItems(project);
    analyzeFunctions(loadedProject);
    loader.projectMap.set(projectKey, loadedProject);
    await loadAssets(userId, projectId, loadedProject, loader);
    await loadDependencies(loadedProject, loader);
    return loadedProject;
}
function setMetaDataForItems(project) {
    for (const item of project.items) {
        item.width = item.width || 1000;
        item.height = item.height || 1000;
    }
}
function analyzeFunctions(project) {
    if (project === undefined)
        return;
    for (const item of project.items) {
        if (item.type === "FUNCTION") {
            const nodeStatements = findNodeStatements(item.source);
            const { parameters, sections, inputPorts, outputPorts } = parseNodeStatements(nodeStatements);
            item.parameters = parameters;
            item.sections = sections;
            item.inputPorts = inputPorts;
            item.outputPorts = outputPorts;
            const itemDoc = extractJSDoc(item.source);
            item.description = itemDoc.description;
            item.category = itemDoc.category;
        }
    }
}
function parseNodeStatements(statements) {
    let currentSection = undefined;
    const parameters = [];
    const sections = [];
    const inputPorts = [];
    const outputPorts = [];
    const PARAMETER_TYPE_MAP = new Map([
        ["numberIn", ParameterType.Number],
        ["stringIn", ParameterType.String],
        ["booleanIn", ParameterType.Boolean],
        ["pointIn", ParameterType.Point],
        ["colorIn", ParameterType.Color],
        ["fileIn", ParameterType.File],
        ["choiceIn", ParameterType.Choice],
    ]);
    const INPUT_TYPE_MAP = new Map([
        ["tableIn", PortType.Table],
        ["shapeIn", PortType.Shape],
        ["specIn", PortType.Spec],
    ]);
    const OUTPUT_TYPE_MAP = new Map([
        ["tableOut", PortType.Table],
        ["shapeOut", PortType.Shape],
        ["specOut", PortType.Spec],
    ]);
    for (const statement of statements) {
        const match = statement.match(/node\.(\w+)\s*\(/);
        if (!match)
            continue;
        const [, methodName] = match;
        const argsString = statement.slice(statement.indexOf("(") + 1, statement.lastIndexOf(")"));
        const args = parseArgs(argsString);
        if (PARAMETER_TYPE_MAP.has(methodName)) {
            const type = PARAMETER_TYPE_MAP.get(methodName);
            parameters.push(createParameter(type, args, currentSection?.name));
        }
        else if (INPUT_TYPE_MAP.has(methodName)) {
            inputPorts.push(createPort(methodName, args, INPUT_TYPE_MAP));
        }
        else if (OUTPUT_TYPE_MAP.has(methodName)) {
            outputPorts.push(createPort(methodName, args, OUTPUT_TYPE_MAP));
        }
        else if (methodName === "pushSection") {
            currentSection = createSection(args);
            sections.push(currentSection);
        }
        else if (methodName === "popSection") {
            currentSection = undefined;
        }
        else if (methodName === "error") ;
        else {
            console.warn(`Unknown method: ${methodName}`);
        }
    }
    return { parameters, sections, inputPorts, outputPorts };
}
function parseArgs(argsString) {
    if (argsString === "")
        return {};
    try {
        return JSON5.parse(argsString);
    }
    catch (error) {
        console.error(`Failed to parse arguments: \`${argsString}\``);
        throw error;
    }
}
function parseChoices(choices) {
    if (choices.length === 0)
        return [];
    if (typeof choices[0] === "string") {
        return choices.map((name) => ({ name, label: startCase(name) }));
    }
    else {
        return choices.map(([name, label]) => ({ name, label }));
    }
}
function createSection(args) {
    return {
        name: args.name,
        collapsed: args.collapsed || false,
    };
}
function createParameter(type, args, section) {
    return {
        name: args.name,
        type: type,
        widget: args.widget || defaultWidgetForType(type),
        label: args.label || convertToLabel(args.name),
        section,
        defaultValue: args.value ?? defaultValueForType(type),
        choices: args.choices && parseChoices(args.choices),
        min: args.min ?? -Infinity,
        max: args.max ?? Infinity,
        step: args.step || 1,
    };
}
function createPort(methodName, args, typeMap) {
    return {
        name: args.name,
        type: typeMap.get(methodName),
    };
}
function extractJSDoc(sourceCode) {
    const commentRegex = /\/\*\*([\s\S]*?)\*\//;
    const match = sourceCode.match(commentRegex);
    if (!match) {
        return { description: "", category: "" };
    }
    const lines = match[1].split("\n").map((l) => l.trim().replace(/^\*\s*/, ""));
    const firstTagIndex = lines.findIndex((l) => l.startsWith("@"));
    const description = lines.slice(0, firstTagIndex).join("\n");
    const tagMap = new Map();
    for (const line of lines.slice(firstTagIndex)) {
        if (!line.startsWith("@"))
            continue;
        const [tag, ...name] = line.split(" ");
        tagMap.set(tag.slice(1), name.join(" "));
    }
    return {
        description: description.trim(),
        category: tagMap.get("category") ?? "",
    };
}
function loadAssets(userId, projectId, project, loader) {
    if (project === undefined)
        return;
    if (typeof project.assets !== "object")
        return;
    const loaders = Object.entries(project.assets).map(([filename, hash]) => {
        return _loadAsset(userId, projectId, filename, hash).then((asset) => {
            loader.assetMap.set(filename, asset);
        });
    });
    return Promise.all(loaders);
}
const TEXT_BASED_FILE_EXTENSIONS = new Set([
    ".csv",
    ".txt",
    ".json",
    ".html",
    ".svg",
    ".xml",
    ".css",
    ".geojson",
    ".log",
    ".mdf",
    ".yaml",
]);
function assetUrl(userId, projectId, hash) {
    return evalTemplate(config.assetsUrlTemplate, { userId, projectId, hash });
}
async function loadAsset(cx, userId, projectId, filename) {
    const asset = await _loadAsset(userId, projectId, filename, filename);
    cx.assetMap.set(filename, asset);
    return asset;
}
async function _loadAsset(userId, projectId, filename, hash) {
    const url = assetUrl(userId, projectId, hash);
    const ext = fileExtension(filename).toLowerCase();
    if (ext === ".jpg" || ext === ".png") {
        return loadImage(url);
    }
    else if (ext === ".js") {
        return loadScript(url);
    }
    else if (TEXT_BASED_FILE_EXTENSIONS.has(ext)) {
        const res = await fetch(url);
        const text = await res.text();
        return text;
    }
    else {
        const res = await fetch(url);
        const buffer = await res.arrayBuffer();
        return buffer;
    }
}
function fileExtension(filename) {
    const parts = filename.split("/");
    const baseName = parts[parts.length - 1];
    const dot = baseName.lastIndexOf(".");
    if (dot === -1)
        return "";
    return filename.substring(dot);
}
async function loadImage(url) {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = "Anonymous";
        img.onload = () => resolve(img);
        img.onerror = reject;
        img.src = url;
    });
}
async function loadScript(url) {
    return new Promise((resolve, reject) => {
        const script = document.createElement("script");
        script.onload = () => resolve();
        script.onerror = reject;
        script.src = url;
        document.body.appendChild(script);
    });
}
function loadDependencies(project, loader) {
    if (project === undefined)
        return;
    const loaders = Object.keys(project.dependencies).map((key) => {
        const [userId, projectId] = key.split("/");
        // Dependencies always load the published version of the project
        return loadProject(userId, projectId, "published", loader);
    });
    return Promise.all(loaders);
}
async function loadItem(cx, item, itemKey) {
    if (item.type === "FUNCTION") {
        await loadFunction(cx, item, itemKey);
    }
}
async function loadFunction(cx, item, itemKey) {
    if (cx.initializers.has(itemKey)) {
        return;
    }
    const itemName = itemKey.split("/").pop();
    if (envType === "browser") {
        const source = fixupSource(item.source, itemKey);
        const blob = new Blob([source], { type: "application/javascript" });
        const url = URL.createObjectURL(blob);
        let error;
        try {
            const module = await import(/* @vite-ignore */ url);
            cx.initializers.set(itemKey, module.default || makeEmptyModule(module, itemName));
        }
        catch (e) {
            console.error(`Failed to load function ${itemKey}: ${e}`);
            cx.warnings.push(`Failed to load function ${itemKey}: ${e}`);
            error = e;
        }
        finally {
            URL.revokeObjectURL(url);
        }
        if (error) {
            throw error;
        }
    }
    else if (envType === "node") {
        try {
            const importSource = `data:text/javascript,${encodeURIComponent(item.source)}`;
            const module = await import(/* @vite-ignore */ importSource);
            cx.initializers.set(itemKey, module.default);
        }
        catch (error) {
            console.error(`Failed to load function ${itemKey}: ${error}`);
            cx.warnings.push(`Failed to load function ${itemKey}: ${error}`);
        }
    }
}
function makeEmptyModule(module, itemName) {
    return (node) => {
        node.onRender = () => {
            let md = "";
            md += "This module does not contain a default export and is treated as a utility module.\n";
            md += "The following exports are available:\n\n";
            md += "```text\n";
            for (const key in module) {
                md += `- ${key}\n`;
            }
            md += "```\n\n";
            md += "Import it into another function like this:\n";
            md += "```javascript\n";
            md += `import * as util from 'project:${itemName}';\n`;
            md += "```\n\n";
            if (Object.keys(module).length > 0) {
                md += "Or import a specific item like this:\n";
                const firstKey = Object.keys(module)[0];
                md += "```javascript\n";
                md += `import { ${firstKey} } from 'project:${itemName}';\n`;
                md += "```\n\n";
            }
            md += "If you expected this code to work as a node, make sure it looks like this:\n";
            md += "```javascript\n";
            md += "export default function(node) {\n";
            md += "  node.onRender = () => {\n";
            md += "    // your code here\n";
            md += "  }\n";
            md += "}\n";
            node.message = md;
        };
    };
}
function fixupSource(source, itemKey) {
    const graphicsImportRe = /import\s+(?:\{\s*[\w\s,]+\s*\}|\*\s+as\s+\w+)\s+from\s+"(@ndbx\/g)";/g;
    source = source.replace(graphicsImportRe, (match, graphicsLibrary) => {
        return match.replace(`"${graphicsLibrary}"`, `"${config.bareImportReplacer(graphicsLibrary)}"`);
    });
    if (!source.includes('from "project:')) {
        return source;
    }
    let [userId, projectId, _] = itemKey.split("/");
    if (userId === "self" && projectId === "self") {
        userId = document.location.pathname.split("/")[1];
        projectId = document.location.pathname.split("/")[2];
    }
    const regex = /from "project:(.*?)"/g;
    const libraryName = regex.exec(source)[1].toLowerCase().replaceAll(" ", "-");
    const libUrl = evalTemplate(config.libUrlTemplate, { userId, projectId, file: libraryName });
    source = source.replace(regex, `from "${libUrl}"`);
    return source;
}
function convertToLabel(parameterName) {
    // Replace camelCase with space between words
    const spaced = parameterName.replace(/([a-z])([A-Z])/g, "$1 $2");
    // Capitalize the first letter and convert the rest to lowercase
    return spaced.charAt(0).toUpperCase() + spaced.slice(1).toLowerCase();
}

function accessor(fn, fields, name) {
  fn.fields = fields || [];
  fn.fname = name;
  return fn;
}
function accessorName(fn) {
  return fn == null ? null : fn.fname;
}
function accessorFields(fn) {
  return fn == null ? null : fn.fields;
}
function getter$1(path) {
  return path.length === 1 ? get1(path[0]) : getN(path);
}
const get1 = field => function (obj) {
  return obj[field];
};
const getN = path => {
  const len = path.length;
  return function (obj) {
    for (let i = 0; i < len; ++i) {
      obj = obj[path[i]];
    }
    return obj;
  };
};
function error(message) {
  throw Error(message);
}
function splitAccessPath(p) {
  const path = [],
    n = p.length;
  let q = null,
    b = 0,
    s = '',
    i,
    j,
    c;
  p = p + '';
  function push() {
    path.push(s + p.substring(i, j));
    s = '';
    i = j + 1;
  }
  for (i = j = 0; j < n; ++j) {
    c = p[j];
    if (c === '\\') {
      s += p.substring(i, j++);
      i = j;
    } else if (c === q) {
      push();
      q = null;
      b = -1;
    } else if (q) {
      continue;
    } else if (i === b && c === '"') {
      i = j + 1;
      q = c;
    } else if (i === b && c === "'") {
      i = j + 1;
      q = c;
    } else if (c === '.' && !b) {
      if (j > i) {
        push();
      } else {
        i = j + 1;
      }
    } else if (c === '[') {
      if (j > i) push();
      b = i = j + 1;
    } else if (c === ']') {
      if (!b) error('Access path missing open bracket: ' + p);
      if (b > 0) push();
      b = 0;
      i = j + 1;
    }
  }
  if (b) error('Access path missing closing bracket: ' + p);
  if (q) error('Access path missing closing quote: ' + p);
  if (j > i) {
    j++;
    push();
  }
  return path;
}
function field$1(field, name, opt) {
  const path = splitAccessPath(field);
  field = path.length === 1 ? path[0] : field;
  return accessor((opt && opt.get || getter$1)(path), [field], name || field);
}
const id = field$1('id');
const identity$6 = accessor(_ => _, [], 'identity');
const zero$3 = accessor(() => 0, [], 'zero');
const one$2 = accessor(() => 1, [], 'one');
const truthy = accessor(() => true, [], 'true');
const falsy = accessor(() => false, [], 'false');
function log$1$1(method, level, input) {
  const args = [level].concat([].slice.call(input));
  console[method].apply(console, args); // eslint-disable-line no-console
}
const None$2 = 0;
const Error$1 = 1;
const Warn = 2;
const Info = 3;
const Debug = 4;
function logger(_, method) {
  let handler = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : log$1$1;
  let level = _ || None$2;
  return {
    level(_) {
      if (arguments.length) {
        level = +_;
        return this;
      } else {
        return level;
      }
    },
    error() {
      if (level >= Error$1) handler('error', 'ERROR', arguments);
      return this;
    },
    warn() {
      if (level >= Warn) handler('warn', 'WARN', arguments);
      return this;
    },
    info() {
      if (level >= Info) handler('log', 'INFO', arguments);
      return this;
    },
    debug() {
      if (level >= Debug) handler('log', 'DEBUG', arguments);
      return this;
    }
  };
}
var isArray = Array.isArray;
function isObject(_) {
  return _ === Object(_);
}
const isLegalKey = key => key !== '__proto__';
function mergeConfig() {
  for (var _len = arguments.length, configs = new Array(_len), _key = 0; _key < _len; _key++) {
    configs[_key] = arguments[_key];
  }
  return configs.reduce((out, source) => {
    for (const key in source) {
      if (key === 'signals') {
        // for signals, we merge the signals arrays
        // source signals take precedence over
        // existing signals with the same name
        out.signals = mergeNamed(out.signals, source.signals);
      } else {
        // otherwise, merge objects subject to recursion constraints
        // for legend block, recurse for the layout entry only
        // for style block, recurse for all properties
        // otherwise, no recursion: objects overwrite, no merging
        const r = key === 'legend' ? {
          layout: 1
        } : key === 'style' ? true : null;
        writeConfig(out, key, source[key], r);
      }
    }
    return out;
  }, {});
}
function writeConfig(output, key, value, recurse) {
  if (!isLegalKey(key)) return;
  let k, o;
  if (isObject(value) && !isArray(value)) {
    o = isObject(output[key]) ? output[key] : output[key] = {};
    for (k in value) {
      if (recurse && (recurse === true || recurse[k])) {
        writeConfig(o, k, value[k]);
      } else if (isLegalKey(k)) {
        o[k] = value[k];
      }
    }
  } else {
    output[key] = value;
  }
}
function mergeNamed(a, b) {
  if (a == null) return b;
  const map = {},
    out = [];
  function add(_) {
    if (!map[_.name]) {
      map[_.name] = 1;
      out.push(_);
    }
  }
  b.forEach(add);
  a.forEach(add);
  return out;
}
function peek$1(array) {
  return array[array.length - 1];
}
function toNumber(_) {
  return _ == null || _ === '' ? null : +_;
}
const exp$2 = sign => x => sign * Math.exp(x);
const log$4 = sign => x => Math.log(sign * x);
const symlog$1 = c => x => Math.sign(x) * Math.log1p(Math.abs(x / c));
const symexp = c => x => Math.sign(x) * Math.expm1(Math.abs(x)) * c;
const pow$4 = exponent => x => x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
function pan(domain, delta, lift, ground) {
  const d0 = lift(domain[0]),
    d1 = lift(peek$1(domain)),
    dd = (d1 - d0) * delta;
  return [ground(d0 - dd), ground(d1 - dd)];
}
function panLinear(domain, delta) {
  return pan(domain, delta, toNumber, identity$6);
}
function panLog(domain, delta) {
  var sign = Math.sign(domain[0]);
  return pan(domain, delta, log$4(sign), exp$2(sign));
}
function panPow(domain, delta, exponent) {
  return pan(domain, delta, pow$4(exponent), pow$4(1 / exponent));
}
function panSymlog(domain, delta, constant) {
  return pan(domain, delta, symlog$1(constant), symexp(constant));
}
function zoom$1(domain, anchor, scale, lift, ground) {
  const d0 = lift(domain[0]),
    d1 = lift(peek$1(domain)),
    da = anchor != null ? lift(anchor) : (d0 + d1) / 2;
  return [ground(da + (d0 - da) * scale), ground(da + (d1 - da) * scale)];
}
function zoomLinear(domain, anchor, scale) {
  return zoom$1(domain, anchor, scale, toNumber, identity$6);
}
function zoomLog(domain, anchor, scale) {
  const sign = Math.sign(domain[0]);
  return zoom$1(domain, anchor, scale, log$4(sign), exp$2(sign));
}
function zoomPow(domain, anchor, scale, exponent) {
  return zoom$1(domain, anchor, scale, pow$4(exponent), pow$4(1 / exponent));
}
function zoomSymlog(domain, anchor, scale, constant) {
  return zoom$1(domain, anchor, scale, symlog$1(constant), symexp(constant));
}
function quarter(date) {
  return 1 + ~~(new Date(date).getMonth() / 3);
}
function utcquarter(date) {
  return 1 + ~~(new Date(date).getUTCMonth() / 3);
}
function array$5(_) {
  return _ != null ? isArray(_) ? _ : [_] : [];
}

/**
 * Span-preserving range clamp. If the span of the input range is less
 * than (max - min) and an endpoint exceeds either the min or max value,
 * the range is translated such that the span is preserved and one
 * endpoint touches the boundary of the min/max range.
 * If the span exceeds (max - min), the range [min, max] is returned.
 */
function clampRange(range, min, max) {
  let lo = range[0],
    hi = range[1],
    span;
  if (hi < lo) {
    span = hi;
    hi = lo;
    lo = span;
  }
  span = hi - lo;
  return span >= max - min ? [min, max] : [lo = Math.min(Math.max(lo, min), max - span), lo + span];
}
function isFunction(_) {
  return typeof _ === 'function';
}
const DESCENDING = 'descending';
function compare$1(fields, orders, opt) {
  opt = opt || {};
  orders = array$5(orders) || [];
  const ord = [],
    get = [],
    fmap = {},
    gen = opt.comparator || comparator;
  array$5(fields).forEach((f, i) => {
    if (f == null) return;
    ord.push(orders[i] === DESCENDING ? -1 : 1);
    get.push(f = isFunction(f) ? f : field$1(f, null, opt));
    (accessorFields(f) || []).forEach(_ => fmap[_] = 1);
  });
  return get.length === 0 ? null : accessor(gen(get, ord), Object.keys(fmap));
}
const ascending$2 = (u, v) => (u < v || u == null) && v != null ? -1 : (u > v || v == null) && u != null ? 1 : (v = v instanceof Date ? +v : v, u = u instanceof Date ? +u : u) !== u && v === v ? -1 : v !== v && u === u ? 1 : 0;
const comparator = (fields, orders) => fields.length === 1 ? compare1(fields[0], orders[0]) : compareN(fields, orders, fields.length);
const compare1 = (field, order) => function (a, b) {
  return ascending$2(field(a), field(b)) * order;
};
const compareN = (fields, orders, n) => {
  orders.push(0); // pad zero for convenient lookup
  return function (a, b) {
    let f,
      c = 0,
      i = -1;
    while (c === 0 && ++i < n) {
      f = fields[i];
      c = ascending$2(f(a), f(b));
    }
    return c * orders[i];
  };
};
function constant$5(_) {
  return isFunction(_) ? _ : () => _;
}
function debounce(delay, handler) {
  let tid;
  return e => {
    if (tid) clearTimeout(tid);
    tid = setTimeout(() => (handler(e), tid = null), delay);
  };
}
function extend$1(_) {
  for (let x, k, i = 1, len = arguments.length; i < len; ++i) {
    x = arguments[i];
    for (k in x) {
      _[k] = x[k];
    }
  }
  return _;
}

/**
 * Return an array with minimum and maximum values, in the
 * form [min, max]. Ignores null, undefined, and NaN values.
 */
function extent(array, f) {
  let i = 0,
    n,
    v,
    min,
    max;
  if (array && (n = array.length)) {
    if (f == null) {
      // find first valid value
      for (v = array[i]; i < n && (v == null || v !== v); v = array[++i]);
      min = max = v;

      // visit all other values
      for (; i < n; ++i) {
        v = array[i];
        // skip null/undefined; NaN will fail all comparisons
        if (v != null) {
          if (v < min) min = v;
          if (v > max) max = v;
        }
      }
    } else {
      // find first valid value
      for (v = f(array[i]); i < n && (v == null || v !== v); v = f(array[++i]));
      min = max = v;

      // visit all other values
      for (; i < n; ++i) {
        v = f(array[i]);
        // skip null/undefined; NaN will fail all comparisons
        if (v != null) {
          if (v < min) min = v;
          if (v > max) max = v;
        }
      }
    }
  }
  return [min, max];
}
function extentIndex(array, f) {
  const n = array.length;
  let i = -1,
    a,
    b,
    c,
    u,
    v;
  if (f == null) {
    while (++i < n) {
      b = array[i];
      if (b != null && b >= b) {
        a = c = b;
        break;
      }
    }
    if (i === n) return [-1, -1];
    u = v = i;
    while (++i < n) {
      b = array[i];
      if (b != null) {
        if (a > b) {
          a = b;
          u = i;
        }
        if (c < b) {
          c = b;
          v = i;
        }
      }
    }
  } else {
    while (++i < n) {
      b = f(array[i], i, array);
      if (b != null && b >= b) {
        a = c = b;
        break;
      }
    }
    if (i === n) return [-1, -1];
    u = v = i;
    while (++i < n) {
      b = f(array[i], i, array);
      if (b != null) {
        if (a > b) {
          a = b;
          u = i;
        }
        if (c < b) {
          c = b;
          v = i;
        }
      }
    }
  }
  return [u, v];
}
const hop = Object.prototype.hasOwnProperty;
function has$1(object, property) {
  return hop.call(object, property);
}
const NULL = {};
function fastmap(input) {
  let obj = {},
    test;
  function has$1$1(key) {
    return has$1(obj, key) && obj[key] !== NULL;
  }
  const map = {
    size: 0,
    empty: 0,
    object: obj,
    has: has$1$1,
    get(key) {
      return has$1$1(key) ? obj[key] : undefined;
    },
    set(key, value) {
      if (!has$1$1(key)) {
        ++map.size;
        if (obj[key] === NULL) --map.empty;
      }
      obj[key] = value;
      return this;
    },
    delete(key) {
      if (has$1$1(key)) {
        --map.size;
        ++map.empty;
        obj[key] = NULL;
      }
      return this;
    },
    clear() {
      map.size = map.empty = 0;
      map.object = obj = {};
    },
    test(_) {
      if (arguments.length) {
        test = _;
        return map;
      } else {
        return test;
      }
    },
    clean() {
      const next = {};
      let size = 0;
      for (const key in obj) {
        const value = obj[key];
        if (value !== NULL && (!test || !test(value))) {
          next[key] = value;
          ++size;
        }
      }
      map.size = size;
      map.empty = 0;
      map.object = obj = next;
    }
  };
  if (input) Object.keys(input).forEach(key => {
    map.set(key, input[key]);
  });
  return map;
}
function flush(range, value, threshold, left, right, center) {
  if (!threshold && threshold !== 0) return center;
  const t = +threshold;
  let a = range[0],
    b = peek$1(range),
    l;

  // swap endpoints if range is reversed
  if (b < a) {
    l = a;
    a = b;
    b = l;
  }

  // compare value to endpoints
  l = Math.abs(value - a);
  const r = Math.abs(b - value);

  // adjust if value is within threshold distance of endpoint
  return l < r && l <= t ? left : r <= t ? right : center;
}
function inherits(child, parent, members) {
  const proto = child.prototype = Object.create(parent.prototype);
  Object.defineProperty(proto, 'constructor', {
    value: child,
    writable: true,
    enumerable: true,
    configurable: true
  });
  return extend$1(proto, members);
}

/**
 * Predicate that returns true if the value lies within the span
 * of the given range. The left and right flags control the use
 * of inclusive (true) or exclusive (false) comparisons.
 */
function inrange(value, range, left, right) {
  let r0 = range[0],
    r1 = range[range.length - 1],
    t;
  if (r0 > r1) {
    t = r0;
    r0 = r1;
    r1 = t;
  }
  left = left === undefined || left;
  right = right === undefined || right;
  return (left ? r0 <= value : r0 < value) && (right ? value <= r1 : value < r1);
}
function isBoolean$1(_) {
  return typeof _ === 'boolean';
}
function isDate$1(_) {
  return Object.prototype.toString.call(_) === '[object Date]';
}
function isIterable(_) {
  return _ && isFunction(_[Symbol.iterator]);
}
function isNumber$1(_) {
  return typeof _ === 'number';
}
function isRegExp(_) {
  return Object.prototype.toString.call(_) === '[object RegExp]';
}
function isString(_) {
  return typeof _ === 'string';
}
function key(fields, flat, opt) {
  if (fields) {
    fields = flat ? array$5(fields).map(f => f.replace(/\\(.)/g, '$1')) : array$5(fields);
  }
  const len = fields && fields.length,
    gen = opt && opt.get || getter$1,
    map = f => gen(flat ? [f] : splitAccessPath(f));
  let fn;
  if (!len) {
    fn = function () {
      return '';
    };
  } else if (len === 1) {
    const get = map(fields[0]);
    fn = function (_) {
      return '' + get(_);
    };
  } else {
    const get = fields.map(map);
    fn = function (_) {
      let s = '' + get[0](_),
        i = 0;
      while (++i < len) s += '|' + get[i](_);
      return s;
    };
  }
  return accessor(fn, fields, 'key');
}
function lerp(array, frac) {
  const lo = array[0],
    hi = peek$1(array),
    f = +frac;
  return !f ? lo : f === 1 ? hi : lo + f * (hi - lo);
}
const DEFAULT_MAX_SIZE = 10000;

// adapted from https://github.com/dominictarr/hashlru/ (MIT License)
function lruCache(maxsize) {
  maxsize = +maxsize || DEFAULT_MAX_SIZE;
  let curr, prev, size;
  const clear = () => {
    curr = {};
    prev = {};
    size = 0;
  };
  const update = (key, value) => {
    if (++size > maxsize) {
      prev = curr;
      curr = {};
      size = 1;
    }
    return curr[key] = value;
  };
  clear();
  return {
    clear,
    has: key => has$1(curr, key) || has$1(prev, key),
    get: key => has$1(curr, key) ? curr[key] : has$1(prev, key) ? update(key, prev[key]) : undefined,
    set: (key, value) => has$1(curr, key) ? curr[key] = value : update(key, value)
  };
}
function merge$3(compare, array0, array1, output) {
  const n0 = array0.length,
    n1 = array1.length;
  if (!n1) return array0;
  if (!n0) return array1;
  const merged = output || new array0.constructor(n0 + n1);
  let i0 = 0,
    i1 = 0,
    i = 0;
  for (; i0 < n0 && i1 < n1; ++i) {
    merged[i] = compare(array0[i0], array1[i1]) > 0 ? array1[i1++] : array0[i0++];
  }
  for (; i0 < n0; ++i0, ++i) {
    merged[i] = array0[i0];
  }
  for (; i1 < n1; ++i1, ++i) {
    merged[i] = array1[i1];
  }
  return merged;
}
function repeat(str, reps) {
  let s = '';
  while (--reps >= 0) s += str;
  return s;
}
function pad$2(str, length, padchar, align) {
  const c = padchar || ' ',
    s = str + '',
    n = length - s.length;
  return n <= 0 ? s : align === 'left' ? repeat(c, n) + s : align === 'center' ? repeat(c, ~~(n / 2)) + s + repeat(c, Math.ceil(n / 2)) : s + repeat(c, n);
}

/**
 * Return the numerical span of an array: the difference between
 * the last and first values.
 */
function span(array) {
  return array && peek$1(array) - array[0] || 0;
}
function $(x) {
  return isArray(x) ? '[' + x.map($) + ']' : isObject(x) || isString(x) ?
  // Output valid JSON and JS source strings.
  // See http://timelessrepo.com/json-isnt-a-javascript-subset
  JSON.stringify(x).replace('\u2028', '\\u2028').replace('\u2029', '\\u2029') : x;
}
function toBoolean(_) {
  return _ == null || _ === '' ? null : !_ || _ === 'false' || _ === '0' ? false : !!_;
}
const defaultParser = _ => isNumber$1(_) ? _ : isDate$1(_) ? _ : Date.parse(_);
function toDate(_, parser) {
  parser = parser || defaultParser;
  return _ == null || _ === '' ? null : parser(_);
}
function toString(_) {
  return _ == null || _ === '' ? null : _ + '';
}
function toSet(_) {
  const s = {},
    n = _.length;
  for (let i = 0; i < n; ++i) s[_[i]] = true;
  return s;
}
function truncate$1(str, length, align, ellipsis) {
  const e = ellipsis != null ? ellipsis : '\u2026',
    s = str + '',
    n = s.length,
    l = Math.max(0, length - e.length);
  return n <= length ? s : align === 'left' ? e + s.slice(n - l) : align === 'center' ? s.slice(0, Math.ceil(l / 2)) + e + s.slice(n - ~~(l / 2)) : s.slice(0, l) + e;
}
function visitArray(array, filter, visitor) {
  if (array) {
    if (filter) {
      const n = array.length;
      for (let i = 0; i < n; ++i) {
        const t = filter(array[i]);
        if (t) visitor(t, i, array);
      }
    } else {
      array.forEach(visitor);
    }
  }
}

var EOL = {},
  EOF = {},
  QUOTE = 34,
  NEWLINE = 10,
  RETURN = 13;
function objectConverter(columns) {
  return new Function("d", "return {" + columns.map(function (name, i) {
    return JSON.stringify(name) + ": d[" + i + "] || \"\"";
  }).join(",") + "}");
}
function customConverter(columns, f) {
  var object = objectConverter(columns);
  return function (row, i) {
    return f(object(row), i, columns);
  };
}

// Compute unique columns in order of discovery.
function inferColumns(rows) {
  var columnSet = Object.create(null),
    columns = [];
  rows.forEach(function (row) {
    for (var column in row) {
      if (!(column in columnSet)) {
        columns.push(columnSet[column] = column);
      }
    }
  });
  return columns;
}
function pad$1(value, width) {
  var s = value + "",
    length = s.length;
  return length < width ? new Array(width - length + 1).join(0) + s : s;
}
function formatYear$1(year) {
  return year < 0 ? "-" + pad$1(-year, 6) : year > 9999 ? "+" + pad$1(year, 6) : pad$1(year, 4);
}
function formatDate(date) {
  var hours = date.getUTCHours(),
    minutes = date.getUTCMinutes(),
    seconds = date.getUTCSeconds(),
    milliseconds = date.getUTCMilliseconds();
  return isNaN(date) ? "Invalid Date" : formatYear$1(date.getUTCFullYear()) + "-" + pad$1(date.getUTCMonth() + 1, 2) + "-" + pad$1(date.getUTCDate(), 2) + (milliseconds ? "T" + pad$1(hours, 2) + ":" + pad$1(minutes, 2) + ":" + pad$1(seconds, 2) + "." + pad$1(milliseconds, 3) + "Z" : seconds ? "T" + pad$1(hours, 2) + ":" + pad$1(minutes, 2) + ":" + pad$1(seconds, 2) + "Z" : minutes || hours ? "T" + pad$1(hours, 2) + ":" + pad$1(minutes, 2) + "Z" : "");
}
function dsvFormat (delimiter) {
  var reFormat = new RegExp("[\"" + delimiter + "\n\r]"),
    DELIMITER = delimiter.charCodeAt(0);
  function parse(text, f) {
    var convert,
      columns,
      rows = parseRows(text, function (row, i) {
        if (convert) return convert(row, i - 1);
        columns = row, convert = f ? customConverter(row, f) : objectConverter(row);
      });
    rows.columns = columns || [];
    return rows;
  }
  function parseRows(text, f) {
    var rows = [],
      // output rows
      N = text.length,
      I = 0,
      // current character index
      n = 0,
      // current line number
      t,
      // current token
      eof = N <= 0,
      // current token followed by EOF?
      eol = false; // current token followed by EOL?

    // Strip the trailing newline.
    if (text.charCodeAt(N - 1) === NEWLINE) --N;
    if (text.charCodeAt(N - 1) === RETURN) --N;
    function token() {
      if (eof) return EOF;
      if (eol) return eol = false, EOL;

      // Unescape quotes.
      var i,
        j = I,
        c;
      if (text.charCodeAt(j) === QUOTE) {
        while (I++ < N && text.charCodeAt(I) !== QUOTE || text.charCodeAt(++I) === QUOTE);
        if ((i = I) >= N) eof = true;else if ((c = text.charCodeAt(I++)) === NEWLINE) eol = true;else if (c === RETURN) {
          eol = true;
          if (text.charCodeAt(I) === NEWLINE) ++I;
        }
        return text.slice(j + 1, i - 1).replace(/""/g, "\"");
      }

      // Find next delimiter or newline.
      while (I < N) {
        if ((c = text.charCodeAt(i = I++)) === NEWLINE) eol = true;else if (c === RETURN) {
          eol = true;
          if (text.charCodeAt(I) === NEWLINE) ++I;
        } else if (c !== DELIMITER) continue;
        return text.slice(j, i);
      }

      // Return last token before EOF.
      return eof = true, text.slice(j, N);
    }
    while ((t = token()) !== EOF) {
      var row = [];
      while (t !== EOL && t !== EOF) row.push(t), t = token();
      if (f && (row = f(row, n++)) == null) continue;
      rows.push(row);
    }
    return rows;
  }
  function preformatBody(rows, columns) {
    return rows.map(function (row) {
      return columns.map(function (column) {
        return formatValue(row[column]);
      }).join(delimiter);
    });
  }
  function format(rows, columns) {
    if (columns == null) columns = inferColumns(rows);
    return [columns.map(formatValue).join(delimiter)].concat(preformatBody(rows, columns)).join("\n");
  }
  function formatBody(rows, columns) {
    if (columns == null) columns = inferColumns(rows);
    return preformatBody(rows, columns).join("\n");
  }
  function formatRows(rows) {
    return rows.map(formatRow).join("\n");
  }
  function formatRow(row) {
    return row.map(formatValue).join(delimiter);
  }
  function formatValue(value) {
    return value == null ? "" : value instanceof Date ? formatDate(value) : reFormat.test(value += "") ? "\"" + value.replace(/"/g, "\"\"") + "\"" : value;
  }
  return {
    parse: parse,
    parseRows: parseRows,
    format: format,
    formatBody: formatBody,
    formatRows: formatRows,
    formatRow: formatRow,
    formatValue: formatValue
  };
}

function identity$5 (x) {
  return x;
}

function transform$3 (transform) {
  if (transform == null) return identity$5;
  var x0,
    y0,
    kx = transform.scale[0],
    ky = transform.scale[1],
    dx = transform.translate[0],
    dy = transform.translate[1];
  return function (input, i) {
    if (!i) x0 = y0 = 0;
    var j = 2,
      n = input.length,
      output = new Array(n);
    output[0] = (x0 += input[0]) * kx + dx;
    output[1] = (y0 += input[1]) * ky + dy;
    while (j < n) output[j] = input[j], ++j;
    return output;
  };
}

function reverse$1 (array, n) {
  var t,
    j = array.length,
    i = j - n;
  while (i < --j) t = array[i], array[i++] = array[j], array[j] = t;
}

function feature (topology, o) {
  if (typeof o === "string") o = topology.objects[o];
  return o.type === "GeometryCollection" ? {
    type: "FeatureCollection",
    features: o.geometries.map(function (o) {
      return feature$1(topology, o);
    })
  } : feature$1(topology, o);
}
function feature$1(topology, o) {
  var id = o.id,
    bbox = o.bbox,
    properties = o.properties == null ? {} : o.properties,
    geometry = object$1(topology, o);
  return id == null && bbox == null ? {
    type: "Feature",
    properties: properties,
    geometry: geometry
  } : bbox == null ? {
    type: "Feature",
    id: id,
    properties: properties,
    geometry: geometry
  } : {
    type: "Feature",
    id: id,
    bbox: bbox,
    properties: properties,
    geometry: geometry
  };
}
function object$1(topology, o) {
  var transformPoint = transform$3(topology.transform),
    arcs = topology.arcs;
  function arc(i, points) {
    if (points.length) points.pop();
    for (var a = arcs[i < 0 ? ~i : i], k = 0, n = a.length; k < n; ++k) {
      points.push(transformPoint(a[k], k));
    }
    if (i < 0) reverse$1(points, n);
  }
  function point(p) {
    return transformPoint(p);
  }
  function line(arcs) {
    var points = [];
    for (var i = 0, n = arcs.length; i < n; ++i) arc(arcs[i], points);
    if (points.length < 2) points.push(points[0]); // This should never happen per the specification.
    return points;
  }
  function ring(arcs) {
    var points = line(arcs);
    while (points.length < 4) points.push(points[0]); // This may happen if an arc has only two points.
    return points;
  }
  function polygon(arcs) {
    return arcs.map(ring);
  }
  function geometry(o) {
    var type = o.type,
      coordinates;
    switch (type) {
      case "GeometryCollection":
        return {
          type: type,
          geometries: o.geometries.map(geometry)
        };
      case "Point":
        coordinates = point(o.coordinates);
        break;
      case "MultiPoint":
        coordinates = o.coordinates.map(point);
        break;
      case "LineString":
        coordinates = line(o.arcs);
        break;
      case "MultiLineString":
        coordinates = o.arcs.map(line);
        break;
      case "Polygon":
        coordinates = polygon(o.arcs);
        break;
      case "MultiPolygon":
        coordinates = o.arcs.map(polygon);
        break;
      default:
        return null;
    }
    return {
      type: type,
      coordinates: coordinates
    };
  }
  return geometry(o);
}

function stitch (topology, arcs) {
  var stitchedArcs = {},
    fragmentByStart = {},
    fragmentByEnd = {},
    fragments = [],
    emptyIndex = -1;

  // Stitch empty arcs first, since they may be subsumed by other arcs.
  arcs.forEach(function (i, j) {
    var arc = topology.arcs[i < 0 ? ~i : i],
      t;
    if (arc.length < 3 && !arc[1][0] && !arc[1][1]) {
      t = arcs[++emptyIndex], arcs[emptyIndex] = i, arcs[j] = t;
    }
  });
  arcs.forEach(function (i) {
    var e = ends(i),
      start = e[0],
      end = e[1],
      f,
      g;
    if (f = fragmentByEnd[start]) {
      delete fragmentByEnd[f.end];
      f.push(i);
      f.end = end;
      if (g = fragmentByStart[end]) {
        delete fragmentByStart[g.start];
        var fg = g === f ? f : f.concat(g);
        fragmentByStart[fg.start = f.start] = fragmentByEnd[fg.end = g.end] = fg;
      } else {
        fragmentByStart[f.start] = fragmentByEnd[f.end] = f;
      }
    } else if (f = fragmentByStart[end]) {
      delete fragmentByStart[f.start];
      f.unshift(i);
      f.start = start;
      if (g = fragmentByEnd[start]) {
        delete fragmentByEnd[g.end];
        var gf = g === f ? f : g.concat(f);
        fragmentByStart[gf.start = g.start] = fragmentByEnd[gf.end = f.end] = gf;
      } else {
        fragmentByStart[f.start] = fragmentByEnd[f.end] = f;
      }
    } else {
      f = [i];
      fragmentByStart[f.start = start] = fragmentByEnd[f.end = end] = f;
    }
  });
  function ends(i) {
    var arc = topology.arcs[i < 0 ? ~i : i],
      p0 = arc[0],
      p1;
    if (topology.transform) p1 = [0, 0], arc.forEach(function (dp) {
      p1[0] += dp[0], p1[1] += dp[1];
    });else p1 = arc[arc.length - 1];
    return i < 0 ? [p1, p0] : [p0, p1];
  }
  function flush(fragmentByEnd, fragmentByStart) {
    for (var k in fragmentByEnd) {
      var f = fragmentByEnd[k];
      delete fragmentByStart[f.start];
      delete f.start;
      delete f.end;
      f.forEach(function (i) {
        stitchedArcs[i < 0 ? ~i : i] = 1;
      });
      fragments.push(f);
    }
  }
  flush(fragmentByEnd, fragmentByStart);
  flush(fragmentByStart, fragmentByEnd);
  arcs.forEach(function (i) {
    if (!stitchedArcs[i < 0 ? ~i : i]) fragments.push([i]);
  });
  return fragments;
}

function mesh (topology) {
  return object$1(topology, meshArcs.apply(this, arguments));
}
function meshArcs(topology, object, filter) {
  var arcs, i, n;
  if (arguments.length > 1) arcs = extractArcs(topology, object, filter);else for (i = 0, arcs = new Array(n = topology.arcs.length); i < n; ++i) arcs[i] = i;
  return {
    type: "MultiLineString",
    arcs: stitch(topology, arcs)
  };
}
function extractArcs(topology, object, filter) {
  var arcs = [],
    geomsByArc = [],
    geom;
  function extract0(i) {
    var j = i < 0 ? ~i : i;
    (geomsByArc[j] || (geomsByArc[j] = [])).push({
      i: i,
      g: geom
    });
  }
  function extract1(arcs) {
    arcs.forEach(extract0);
  }
  function extract2(arcs) {
    arcs.forEach(extract1);
  }
  function extract3(arcs) {
    arcs.forEach(extract2);
  }
  function geometry(o) {
    switch (geom = o, o.type) {
      case "GeometryCollection":
        o.geometries.forEach(geometry);
        break;
      case "LineString":
        extract1(o.arcs);
        break;
      case "MultiLineString":
      case "Polygon":
        extract2(o.arcs);
        break;
      case "MultiPolygon":
        extract3(o.arcs);
        break;
    }
  }
  geometry(object);
  geomsByArc.forEach(filter == null ? function (geoms) {
    arcs.push(geoms[0].i);
  } : function (geoms) {
    if (filter(geoms[0].g, geoms[geoms.length - 1].g)) arcs.push(geoms[0].i);
  });
  return arcs;
}

function ascending$1(a, b) {
  return a == null || b == null ? NaN : a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

function descending$1(a, b) {
  return a == null || b == null ? NaN : b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}

function bisector(f) {
  let compare1, compare2, delta;

  // If an accessor is specified, promote it to a comparator. In this case we
  // can test whether the search value is (self-) comparable. We can’t do this
  // for a comparator (except for specific, known comparators) because we can’t
  // tell if the comparator is symmetric, and an asymmetric comparator can’t be
  // used to test whether a single value is comparable.
  if (f.length !== 2) {
    compare1 = ascending$1;
    compare2 = (d, x) => ascending$1(f(d), x);
    delta = (d, x) => f(d) - x;
  } else {
    compare1 = f === ascending$1 || f === descending$1 ? f : zero$2;
    compare2 = f;
    delta = f;
  }
  function left(a, x, lo = 0, hi = a.length) {
    if (lo < hi) {
      if (compare1(x, x) !== 0) return hi;
      do {
        const mid = lo + hi >>> 1;
        if (compare2(a[mid], x) < 0) lo = mid + 1;else hi = mid;
      } while (lo < hi);
    }
    return lo;
  }
  function right(a, x, lo = 0, hi = a.length) {
    if (lo < hi) {
      if (compare1(x, x) !== 0) return hi;
      do {
        const mid = lo + hi >>> 1;
        if (compare2(a[mid], x) <= 0) lo = mid + 1;else hi = mid;
      } while (lo < hi);
    }
    return lo;
  }
  function center(a, x, lo = 0, hi = a.length) {
    const i = left(a, x, lo, hi - 1);
    return i > lo && delta(a[i - 1], x) > -delta(a[i], x) ? i - 1 : i;
  }
  return {
    left,
    center,
    right
  };
}
function zero$2() {
  return 0;
}

function number$6(x) {
  return x === null ? NaN : +x;
}
function* numbers$2(values, valueof) {
  if (valueof === undefined) {
    for (let value of values) {
      if (value != null && (value = +value) >= value) {
        yield value;
      }
    }
  } else {
    let index = -1;
    for (let value of values) {
      if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) {
        yield value;
      }
    }
  }
}

const ascendingBisect = bisector(ascending$1);
const bisectRight$1 = ascendingBisect.right;
const bisectLeft$1 = ascendingBisect.left;
bisector(number$6).center;

function variance(values, valueof) {
  let count = 0;
  let delta;
  let mean = 0;
  let sum = 0;
  if (valueof === undefined) {
    for (let value of values) {
      if (value != null && (value = +value) >= value) {
        delta = value - mean;
        mean += delta / ++count;
        sum += delta * (value - mean);
      }
    }
  } else {
    let index = -1;
    for (let value of values) {
      if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) {
        delta = value - mean;
        mean += delta / ++count;
        sum += delta * (value - mean);
      }
    }
  }
  if (count > 1) return sum / (count - 1);
}

function deviation(values, valueof) {
  const v = variance(values, valueof);
  return v ? Math.sqrt(v) : v;
}

// https://github.com/python/cpython/blob/a74eea238f5baba15797e2e8b570d153bc8690a7/Modules/mathmodule.c#L1423
class Adder {
  constructor() {
    this._partials = new Float64Array(32);
    this._n = 0;
  }
  add(x) {
    const p = this._partials;
    let i = 0;
    for (let j = 0; j < this._n && j < 32; j++) {
      const y = p[j],
        hi = x + y,
        lo = Math.abs(x) < Math.abs(y) ? x - (hi - y) : y - (hi - x);
      if (lo) p[i++] = lo;
      x = hi;
    }
    p[i] = x;
    this._n = i + 1;
    return this;
  }
  valueOf() {
    const p = this._partials;
    let n = this._n,
      x,
      y,
      lo,
      hi = 0;
    if (n > 0) {
      hi = p[--n];
      while (n > 0) {
        x = hi;
        y = p[--n];
        hi = x + y;
        lo = y - (hi - x);
        if (lo) break;
      }
      if (n > 0 && (lo < 0 && p[n - 1] < 0 || lo > 0 && p[n - 1] > 0)) {
        y = lo * 2;
        x = hi + y;
        if (y == x - hi) hi = x;
      }
    }
    return hi;
  }
}

class InternMap extends Map {
  constructor(entries, key = keyof) {
    super();
    Object.defineProperties(this, {
      _intern: {
        value: new Map()
      },
      _key: {
        value: key
      }
    });
    if (entries != null) for (const [key, value] of entries) this.set(key, value);
  }
  get(key) {
    return super.get(intern_get(this, key));
  }
  has(key) {
    return super.has(intern_get(this, key));
  }
  set(key, value) {
    return super.set(intern_set(this, key), value);
  }
  delete(key) {
    return super.delete(intern_delete(this, key));
  }
}
class InternSet extends Set {
  constructor(values, key = keyof) {
    super();
    Object.defineProperties(this, {
      _intern: {
        value: new Map()
      },
      _key: {
        value: key
      }
    });
    if (values != null) for (const value of values) this.add(value);
  }
  has(value) {
    return super.has(intern_get(this, value));
  }
  add(value) {
    return super.add(intern_set(this, value));
  }
  delete(value) {
    return super.delete(intern_delete(this, value));
  }
}
function intern_get({
  _intern,
  _key
}, value) {
  const key = _key(value);
  return _intern.has(key) ? _intern.get(key) : value;
}
function intern_set({
  _intern,
  _key
}, value) {
  const key = _key(value);
  if (_intern.has(key)) return _intern.get(key);
  _intern.set(key, value);
  return value;
}
function intern_delete({
  _intern,
  _key
}, value) {
  const key = _key(value);
  if (_intern.has(key)) {
    value = _intern.get(key);
    _intern.delete(key);
  }
  return value;
}
function keyof(value) {
  return value !== null && typeof value === "object" ? value.valueOf() : value;
}

function permute(source, keys) {
  return Array.from(keys, key => source[key]);
}

function compareDefined(compare = ascending$1) {
  if (compare === ascending$1) return ascendingDefined;
  if (typeof compare !== "function") throw new TypeError("compare is not a function");
  return (a, b) => {
    const x = compare(a, b);
    if (x || x === 0) return x;
    return (compare(b, b) === 0) - (compare(a, a) === 0);
  };
}
function ascendingDefined(a, b) {
  return (a == null || !(a >= a)) - (b == null || !(b >= b)) || (a < b ? -1 : a > b ? 1 : 0);
}

const e10 = Math.sqrt(50),
  e5 = Math.sqrt(10),
  e2 = Math.sqrt(2);
function tickSpec(start, stop, count) {
  const step = (stop - start) / Math.max(0, count),
    power = Math.floor(Math.log10(step)),
    error = step / Math.pow(10, power),
    factor = error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1;
  let i1, i2, inc;
  if (power < 0) {
    inc = Math.pow(10, -power) / factor;
    i1 = Math.round(start * inc);
    i2 = Math.round(stop * inc);
    if (i1 / inc < start) ++i1;
    if (i2 / inc > stop) --i2;
    inc = -inc;
  } else {
    inc = Math.pow(10, power) * factor;
    i1 = Math.round(start / inc);
    i2 = Math.round(stop / inc);
    if (i1 * inc < start) ++i1;
    if (i2 * inc > stop) --i2;
  }
  if (i2 < i1 && 0.5 <= count && count < 2) return tickSpec(start, stop, count * 2);
  return [i1, i2, inc];
}
function ticks(start, stop, count) {
  stop = +stop, start = +start, count = +count;
  if (!(count > 0)) return [];
  if (start === stop) return [start];
  const reverse = stop < start,
    [i1, i2, inc] = reverse ? tickSpec(stop, start, count) : tickSpec(start, stop, count);
  if (!(i2 >= i1)) return [];
  const n = i2 - i1 + 1,
    ticks = new Array(n);
  if (reverse) {
    if (inc < 0) for (let i = 0; i < n; ++i) ticks[i] = (i2 - i) / -inc;else for (let i = 0; i < n; ++i) ticks[i] = (i2 - i) * inc;
  } else {
    if (inc < 0) for (let i = 0; i < n; ++i) ticks[i] = (i1 + i) / -inc;else for (let i = 0; i < n; ++i) ticks[i] = (i1 + i) * inc;
  }
  return ticks;
}
function tickIncrement(start, stop, count) {
  stop = +stop, start = +start, count = +count;
  return tickSpec(start, stop, count)[2];
}
function tickStep(start, stop, count) {
  stop = +stop, start = +start, count = +count;
  const reverse = stop < start,
    inc = reverse ? tickIncrement(stop, start, count) : tickIncrement(start, stop, count);
  return (reverse ? -1 : 1) * (inc < 0 ? 1 / -inc : inc);
}

function max$2(values, valueof) {
  let max;
  if (valueof === undefined) {
    for (const value of values) {
      if (value != null && (max < value || max === undefined && value >= value)) {
        max = value;
      }
    }
  } else {
    let index = -1;
    for (let value of values) {
      if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) {
        max = value;
      }
    }
  }
  return max;
}

function min$2(values, valueof) {
  let min;
  if (valueof === undefined) {
    for (const value of values) {
      if (value != null && (min > value || min === undefined && value >= value)) {
        min = value;
      }
    }
  } else {
    let index = -1;
    for (let value of values) {
      if ((value = valueof(value, ++index, values)) != null && (min > value || min === undefined && value >= value)) {
        min = value;
      }
    }
  }
  return min;
}

// Based on https://github.com/mourner/quickselect
// ISC license, Copyright 2018 Vladimir Agafonkin.
function quickselect(array, k, left = 0, right = Infinity, compare) {
  k = Math.floor(k);
  left = Math.floor(Math.max(0, left));
  right = Math.floor(Math.min(array.length - 1, right));
  if (!(left <= k && k <= right)) return array;
  compare = compare === undefined ? ascendingDefined : compareDefined(compare);
  while (right > left) {
    if (right - left > 600) {
      const n = right - left + 1;
      const m = k - left + 1;
      const z = Math.log(n);
      const s = 0.5 * Math.exp(2 * z / 3);
      const sd = 0.5 * Math.sqrt(z * s * (n - s) / n) * (m - n / 2 < 0 ? -1 : 1);
      const newLeft = Math.max(left, Math.floor(k - m * s / n + sd));
      const newRight = Math.min(right, Math.floor(k + (n - m) * s / n + sd));
      quickselect(array, k, newLeft, newRight, compare);
    }
    const t = array[k];
    let i = left;
    let j = right;
    swap$1(array, left, k);
    if (compare(array[right], t) > 0) swap$1(array, left, right);
    while (i < j) {
      swap$1(array, i, j), ++i, --j;
      while (compare(array[i], t) < 0) ++i;
      while (compare(array[j], t) > 0) --j;
    }
    if (compare(array[left], t) === 0) swap$1(array, left, j);else ++j, swap$1(array, j, right);
    if (j <= k) left = j + 1;
    if (k <= j) right = j - 1;
  }
  return array;
}
function swap$1(array, i, j) {
  const t = array[i];
  array[i] = array[j];
  array[j] = t;
}

function quantile$1(values, p, valueof) {
  values = Float64Array.from(numbers$2(values, valueof));
  if (!(n = values.length) || isNaN(p = +p)) return;
  if (p <= 0 || n < 2) return min$2(values);
  if (p >= 1) return max$2(values);
  var n,
    i = (n - 1) * p,
    i0 = Math.floor(i),
    value0 = max$2(quickselect(values, i0).subarray(0, i0 + 1)),
    value1 = min$2(values.subarray(i0 + 1));
  return value0 + (value1 - value0) * (i - i0);
}
function quantileSorted(values, p, valueof = number$6) {
  if (!(n = values.length) || isNaN(p = +p)) return;
  if (p <= 0 || n < 2) return +valueof(values[0], 0, values);
  if (p >= 1) return +valueof(values[n - 1], n - 1, values);
  var n,
    i = (n - 1) * p,
    i0 = Math.floor(i),
    value0 = +valueof(values[i0], i0, values),
    value1 = +valueof(values[i0 + 1], i0 + 1, values);
  return value0 + (value1 - value0) * (i - i0);
}

function mean(values, valueof) {
  let count = 0;
  let sum = 0;
  if (valueof === undefined) {
    for (let value of values) {
      if (value != null && (value = +value) >= value) {
        ++count, sum += value;
      }
    }
  } else {
    let index = -1;
    for (let value of values) {
      if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) {
        ++count, sum += value;
      }
    }
  }
  if (count) return sum / count;
}

function median(values, valueof) {
  return quantile$1(values, 0.5, valueof);
}

function* flatten(arrays) {
  for (const array of arrays) {
    yield* array;
  }
}
function merge$2(arrays) {
  return Array.from(flatten(arrays));
}

function range$3(start, stop, step) {
  start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
  var i = -1,
    n = Math.max(0, Math.ceil((stop - start) / step)) | 0,
    range = new Array(n);
  while (++i < n) {
    range[i] = start + i * step;
  }
  return range;
}

function sum$1(values, valueof) {
  let sum = 0;
  {
    for (let value of values) {
      if (value = +value) {
        sum += value;
      }
    }
  }
  return sum;
}

function intersection(values, ...others) {
  values = new InternSet(values);
  others = others.map(set$4);
  out: for (const value of values) {
    for (const other of others) {
      if (!other.has(value)) {
        values.delete(value);
        continue out;
      }
    }
  }
  return values;
}
function set$4(values) {
  return values instanceof InternSet ? values : new InternSet(values);
}

function union(...others) {
  const set = new InternSet();
  for (const other of others) {
    for (const o of other) {
      set.add(o);
    }
  }
  return set;
}

function formatDecimal (x) {
  return Math.abs(x = Math.round(x)) >= 1e21 ? x.toLocaleString("en").replace(/,/g, "") : x.toString(10);
}

// Computes the decimal coefficient and exponent of the specified number x with
// significant digits p, where x is positive and p is in [1, 21] or undefined.
// For example, formatDecimalParts(1.23) returns ["123", 0].
function formatDecimalParts(x, p) {
  if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
  var i,
    coefficient = x.slice(0, i);

  // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
  // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
  return [coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient, +x.slice(i + 1)];
}

function exponent (x) {
  return x = formatDecimalParts(Math.abs(x)), x ? x[1] : NaN;
}

function formatGroup (grouping, thousands) {
  return function (value, width) {
    var i = value.length,
      t = [],
      j = 0,
      g = grouping[0],
      length = 0;
    while (i > 0 && g > 0) {
      if (length + g + 1 > width) g = Math.max(1, width - length);
      t.push(value.substring(i -= g, i + g));
      if ((length += g + 1) > width) break;
      g = grouping[j = (j + 1) % grouping.length];
    }
    return t.reverse().join(thousands);
  };
}

function formatNumerals (numerals) {
  return function (value) {
    return value.replace(/[0-9]/g, function (i) {
      return numerals[+i];
    });
  };
}

// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
var re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function formatSpecifier(specifier) {
  if (!(match = re.exec(specifier))) throw new Error("invalid format: " + specifier);
  var match;
  return new FormatSpecifier({
    fill: match[1],
    align: match[2],
    sign: match[3],
    symbol: match[4],
    zero: match[5],
    width: match[6],
    comma: match[7],
    precision: match[8] && match[8].slice(1),
    trim: match[9],
    type: match[10]
  });
}
formatSpecifier.prototype = FormatSpecifier.prototype; // instanceof

function FormatSpecifier(specifier) {
  this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
  this.align = specifier.align === undefined ? ">" : specifier.align + "";
  this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
  this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
  this.zero = !!specifier.zero;
  this.width = specifier.width === undefined ? undefined : +specifier.width;
  this.comma = !!specifier.comma;
  this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
  this.trim = !!specifier.trim;
  this.type = specifier.type === undefined ? "" : specifier.type + "";
}
FormatSpecifier.prototype.toString = function () {
  return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === undefined ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};

// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
function formatTrim (s) {
  out: for (var n = s.length, i = 1, i0 = -1, i1; i < n; ++i) {
    switch (s[i]) {
      case ".":
        i0 = i1 = i;
        break;
      case "0":
        if (i0 === 0) i0 = i;
        i1 = i;
        break;
      default:
        if (!+s[i]) break out;
        if (i0 > 0) i0 = 0;
        break;
    }
  }
  return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
}

var prefixExponent;
function formatPrefixAuto (x, p) {
  var d = formatDecimalParts(x, p);
  if (!d) return x + "";
  var coefficient = d[0],
    exponent = d[1],
    i = exponent - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1,
    n = coefficient.length;
  return i === n ? coefficient : i > n ? coefficient + new Array(i - n + 1).join("0") : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i) : "0." + new Array(1 - i).join("0") + formatDecimalParts(x, Math.max(0, p + i - 1))[0]; // less than 1y!
}

function formatRounded (x, p) {
  var d = formatDecimalParts(x, p);
  if (!d) return x + "";
  var coefficient = d[0],
    exponent = d[1];
  return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1) : coefficient + new Array(exponent - coefficient.length + 2).join("0");
}

var formatTypes = {
  "%": (x, p) => (x * 100).toFixed(p),
  "b": x => Math.round(x).toString(2),
  "c": x => x + "",
  "d": formatDecimal,
  "e": (x, p) => x.toExponential(p),
  "f": (x, p) => x.toFixed(p),
  "g": (x, p) => x.toPrecision(p),
  "o": x => Math.round(x).toString(8),
  "p": (x, p) => formatRounded(x * 100, p),
  "r": formatRounded,
  "s": formatPrefixAuto,
  "X": x => Math.round(x).toString(16).toUpperCase(),
  "x": x => Math.round(x).toString(16)
};

function identity$4 (x) {
  return x;
}

var map$1 = Array.prototype.map,
  prefixes = ["y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"];
function formatLocale$1 (locale) {
  var group = locale.grouping === undefined || locale.thousands === undefined ? identity$4 : formatGroup(map$1.call(locale.grouping, Number), locale.thousands + ""),
    currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "",
    currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "",
    decimal = locale.decimal === undefined ? "." : locale.decimal + "",
    numerals = locale.numerals === undefined ? identity$4 : formatNumerals(map$1.call(locale.numerals, String)),
    percent = locale.percent === undefined ? "%" : locale.percent + "",
    minus = locale.minus === undefined ? "−" : locale.minus + "",
    nan = locale.nan === undefined ? "NaN" : locale.nan + "";
  function newFormat(specifier) {
    specifier = formatSpecifier(specifier);
    var fill = specifier.fill,
      align = specifier.align,
      sign = specifier.sign,
      symbol = specifier.symbol,
      zero = specifier.zero,
      width = specifier.width,
      comma = specifier.comma,
      precision = specifier.precision,
      trim = specifier.trim,
      type = specifier.type;

    // The "n" type is an alias for ",g".
    if (type === "n") comma = true, type = "g";

    // The "" type, and any invalid type, is an alias for ".12~g".
    else if (!formatTypes[type]) precision === undefined && (precision = 12), trim = true, type = "g";

    // If zero fill is specified, padding goes after sign and before digits.
    if (zero || fill === "0" && align === "=") zero = true, fill = "0", align = "=";

    // Compute the prefix and suffix.
    // For SI-prefix, the suffix is lazily computed.
    var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "",
      suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : "";

    // What format function should we use?
    // Is this an integer type?
    // Can this type generate exponential notation?
    var formatType = formatTypes[type],
      maybeSuffix = /[defgprs%]/.test(type);

    // Set the default precision if not specified,
    // or clamp the specified precision to the supported range.
    // For significant precision, it must be in [1, 21].
    // For fixed precision, it must be in [0, 20].
    precision = precision === undefined ? 6 : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));
    function format(value) {
      var valuePrefix = prefix,
        valueSuffix = suffix,
        i,
        n,
        c;
      if (type === "c") {
        valueSuffix = formatType(value) + valueSuffix;
        value = "";
      } else {
        value = +value;

        // Determine the sign. -0 is not less than 0, but 1 / -0 is!
        var valueNegative = value < 0 || 1 / value < 0;

        // Perform the initial formatting.
        value = isNaN(value) ? nan : formatType(Math.abs(value), precision);

        // Trim insignificant zeros.
        if (trim) value = formatTrim(value);

        // If a negative value rounds to zero after formatting, and no explicit positive sign is requested, hide the sign.
        if (valueNegative && +value === 0 && sign !== "+") valueNegative = false;

        // Compute the prefix and suffix.
        valuePrefix = (valueNegative ? sign === "(" ? sign : minus : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
        valueSuffix = (type === "s" ? prefixes[8 + prefixExponent / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");

        // Break the formatted value into the integer “value” part that can be
        // grouped, and fractional or exponential “suffix” part that is not.
        if (maybeSuffix) {
          i = -1, n = value.length;
          while (++i < n) {
            if (c = value.charCodeAt(i), 48 > c || c > 57) {
              valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
              value = value.slice(0, i);
              break;
            }
          }
        }
      }

      // If the fill character is not "0", grouping is applied before padding.
      if (comma && !zero) value = group(value, Infinity);

      // Compute the padding.
      var length = valuePrefix.length + value.length + valueSuffix.length,
        padding = length < width ? new Array(width - length + 1).join(fill) : "";

      // If the fill character is "0", grouping is applied after padding.
      if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";

      // Reconstruct the final output based on the desired alignment.
      switch (align) {
        case "<":
          value = valuePrefix + value + valueSuffix + padding;
          break;
        case "=":
          value = valuePrefix + padding + value + valueSuffix;
          break;
        case "^":
          value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
          break;
        default:
          value = padding + valuePrefix + value + valueSuffix;
          break;
      }
      return numerals(value);
    }
    format.toString = function () {
      return specifier + "";
    };
    return format;
  }
  function formatPrefix(specifier, value) {
    var f = newFormat((specifier = formatSpecifier(specifier), specifier.type = "f", specifier)),
      e = Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3,
      k = Math.pow(10, -e),
      prefix = prefixes[8 + e / 3];
    return function (value) {
      return f(k * value) + prefix;
    };
  }
  return {
    format: newFormat,
    formatPrefix: formatPrefix
  };
}

var locale$2;
var format$3;
var formatPrefix;
defaultLocale$2({
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
});
function defaultLocale$2(definition) {
  locale$2 = formatLocale$1(definition);
  format$3 = locale$2.format;
  formatPrefix = locale$2.formatPrefix;
  return locale$2;
}

function precisionFixed (step) {
  return Math.max(0, -exponent(Math.abs(step)));
}

function precisionPrefix (step, value) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3 - exponent(Math.abs(step)));
}

function precisionRound (step, max) {
  step = Math.abs(step), max = Math.abs(max) - step;
  return Math.max(0, exponent(max) - exponent(step)) + 1;
}

const t0$2 = new Date(),
  t1$1 = new Date();
function timeInterval$1(floori, offseti, count, field) {
  function interval(date) {
    return floori(date = arguments.length === 0 ? new Date() : new Date(+date)), date;
  }
  interval.floor = date => {
    return floori(date = new Date(+date)), date;
  };
  interval.ceil = date => {
    return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
  };
  interval.round = date => {
    const d0 = interval(date),
      d1 = interval.ceil(date);
    return date - d0 < d1 - date ? d0 : d1;
  };
  interval.offset = (date, step) => {
    return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
  };
  interval.range = (start, stop, step) => {
    const range = [];
    start = interval.ceil(start);
    step = step == null ? 1 : Math.floor(step);
    if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
    let previous;
    do range.push(previous = new Date(+start)), offseti(start, step), floori(start); while (previous < start && start < stop);
    return range;
  };
  interval.filter = test => {
    return timeInterval$1(date => {
      if (date >= date) while (floori(date), !test(date)) date.setTime(date - 1);
    }, (date, step) => {
      if (date >= date) {
        if (step < 0) while (++step <= 0) {
          while (offseti(date, -1), !test(date)) {} // eslint-disable-line no-empty
        } else while (--step >= 0) {
          while (offseti(date, 1), !test(date)) {} // eslint-disable-line no-empty
        }
      }
    });
  };
  if (count) {
    interval.count = (start, end) => {
      t0$2.setTime(+start), t1$1.setTime(+end);
      floori(t0$2), floori(t1$1);
      return Math.floor(count(t0$2, t1$1));
    };
    interval.every = step => {
      step = Math.floor(step);
      return !isFinite(step) || !(step > 0) ? null : !(step > 1) ? interval : interval.filter(field ? d => field(d) % step === 0 : d => interval.count(0, d) % step === 0);
    };
  }
  return interval;
}

const millisecond = timeInterval$1(() => {
  // noop
}, (date, step) => {
  date.setTime(+date + step);
}, (start, end) => {
  return end - start;
});

// An optimized implementation for this simple case.
millisecond.every = k => {
  k = Math.floor(k);
  if (!isFinite(k) || !(k > 0)) return null;
  if (!(k > 1)) return millisecond;
  return timeInterval$1(date => {
    date.setTime(Math.floor(date / k) * k);
  }, (date, step) => {
    date.setTime(+date + step * k);
  }, (start, end) => {
    return (end - start) / k;
  });
};
millisecond.range;

const durationSecond$1 = 1000;
const durationMinute$1 = durationSecond$1 * 60;
const durationHour$1 = durationMinute$1 * 60;
const durationDay$1 = durationHour$1 * 24;
const durationWeek$1 = durationDay$1 * 7;
const durationMonth$1 = durationDay$1 * 30;
const durationYear$1 = durationDay$1 * 365;

const second = timeInterval$1(date => {
  date.setTime(date - date.getMilliseconds());
}, (date, step) => {
  date.setTime(+date + step * durationSecond$1);
}, (start, end) => {
  return (end - start) / durationSecond$1;
}, date => {
  return date.getUTCSeconds();
});
second.range;

const timeMinute = timeInterval$1(date => {
  date.setTime(date - date.getMilliseconds() - date.getSeconds() * durationSecond$1);
}, (date, step) => {
  date.setTime(+date + step * durationMinute$1);
}, (start, end) => {
  return (end - start) / durationMinute$1;
}, date => {
  return date.getMinutes();
});
timeMinute.range;
const utcMinute = timeInterval$1(date => {
  date.setUTCSeconds(0, 0);
}, (date, step) => {
  date.setTime(+date + step * durationMinute$1);
}, (start, end) => {
  return (end - start) / durationMinute$1;
}, date => {
  return date.getUTCMinutes();
});
utcMinute.range;

const timeHour = timeInterval$1(date => {
  date.setTime(date - date.getMilliseconds() - date.getSeconds() * durationSecond$1 - date.getMinutes() * durationMinute$1);
}, (date, step) => {
  date.setTime(+date + step * durationHour$1);
}, (start, end) => {
  return (end - start) / durationHour$1;
}, date => {
  return date.getHours();
});
timeHour.range;
const utcHour = timeInterval$1(date => {
  date.setUTCMinutes(0, 0, 0);
}, (date, step) => {
  date.setTime(+date + step * durationHour$1);
}, (start, end) => {
  return (end - start) / durationHour$1;
}, date => {
  return date.getUTCHours();
});
utcHour.range;

const timeDay = timeInterval$1(date => date.setHours(0, 0, 0, 0), (date, step) => date.setDate(date.getDate() + step), (start, end) => (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute$1) / durationDay$1, date => date.getDate() - 1);
timeDay.range;
const utcDay = timeInterval$1(date => {
  date.setUTCHours(0, 0, 0, 0);
}, (date, step) => {
  date.setUTCDate(date.getUTCDate() + step);
}, (start, end) => {
  return (end - start) / durationDay$1;
}, date => {
  return date.getUTCDate() - 1;
});
utcDay.range;
const unixDay = timeInterval$1(date => {
  date.setUTCHours(0, 0, 0, 0);
}, (date, step) => {
  date.setUTCDate(date.getUTCDate() + step);
}, (start, end) => {
  return (end - start) / durationDay$1;
}, date => {
  return Math.floor(date / durationDay$1);
});
unixDay.range;

function timeWeekday(i) {
  return timeInterval$1(date => {
    date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
    date.setHours(0, 0, 0, 0);
  }, (date, step) => {
    date.setDate(date.getDate() + step * 7);
  }, (start, end) => {
    return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute$1) / durationWeek$1;
  });
}
const timeSunday = timeWeekday(0);
const timeMonday = timeWeekday(1);
const timeTuesday = timeWeekday(2);
const timeWednesday = timeWeekday(3);
const timeThursday = timeWeekday(4);
const timeFriday = timeWeekday(5);
const timeSaturday = timeWeekday(6);
timeSunday.range;
timeMonday.range;
timeTuesday.range;
timeWednesday.range;
timeThursday.range;
timeFriday.range;
timeSaturday.range;
function utcWeekday(i) {
  return timeInterval$1(date => {
    date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
    date.setUTCHours(0, 0, 0, 0);
  }, (date, step) => {
    date.setUTCDate(date.getUTCDate() + step * 7);
  }, (start, end) => {
    return (end - start) / durationWeek$1;
  });
}
const utcSunday = utcWeekday(0);
const utcMonday = utcWeekday(1);
const utcTuesday = utcWeekday(2);
const utcWednesday = utcWeekday(3);
const utcThursday = utcWeekday(4);
const utcFriday = utcWeekday(5);
const utcSaturday = utcWeekday(6);
utcSunday.range;
utcMonday.range;
utcTuesday.range;
utcWednesday.range;
utcThursday.range;
utcFriday.range;
utcSaturday.range;

const timeMonth = timeInterval$1(date => {
  date.setDate(1);
  date.setHours(0, 0, 0, 0);
}, (date, step) => {
  date.setMonth(date.getMonth() + step);
}, (start, end) => {
  return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, date => {
  return date.getMonth();
});
timeMonth.range;
const utcMonth = timeInterval$1(date => {
  date.setUTCDate(1);
  date.setUTCHours(0, 0, 0, 0);
}, (date, step) => {
  date.setUTCMonth(date.getUTCMonth() + step);
}, (start, end) => {
  return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, date => {
  return date.getUTCMonth();
});
utcMonth.range;

const timeYear = timeInterval$1(date => {
  date.setMonth(0, 1);
  date.setHours(0, 0, 0, 0);
}, (date, step) => {
  date.setFullYear(date.getFullYear() + step);
}, (start, end) => {
  return end.getFullYear() - start.getFullYear();
}, date => {
  return date.getFullYear();
});

// An optimized implementation for this simple case.
timeYear.every = k => {
  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : timeInterval$1(date => {
    date.setFullYear(Math.floor(date.getFullYear() / k) * k);
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
  }, (date, step) => {
    date.setFullYear(date.getFullYear() + step * k);
  });
};
timeYear.range;
const utcYear = timeInterval$1(date => {
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
}, (date, step) => {
  date.setUTCFullYear(date.getUTCFullYear() + step);
}, (start, end) => {
  return end.getUTCFullYear() - start.getUTCFullYear();
}, date => {
  return date.getUTCFullYear();
});

// An optimized implementation for this simple case.
utcYear.every = k => {
  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : timeInterval$1(date => {
    date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
  }, (date, step) => {
    date.setUTCFullYear(date.getUTCFullYear() + step * k);
  });
};
utcYear.range;

function ticker(year, month, week, day, hour, minute) {
  const tickIntervals = [[second, 1, durationSecond$1], [second, 5, 5 * durationSecond$1], [second, 15, 15 * durationSecond$1], [second, 30, 30 * durationSecond$1], [minute, 1, durationMinute$1], [minute, 5, 5 * durationMinute$1], [minute, 15, 15 * durationMinute$1], [minute, 30, 30 * durationMinute$1], [hour, 1, durationHour$1], [hour, 3, 3 * durationHour$1], [hour, 6, 6 * durationHour$1], [hour, 12, 12 * durationHour$1], [day, 1, durationDay$1], [day, 2, 2 * durationDay$1], [week, 1, durationWeek$1], [month, 1, durationMonth$1], [month, 3, 3 * durationMonth$1], [year, 1, durationYear$1]];
  function ticks(start, stop, count) {
    const reverse = stop < start;
    if (reverse) [start, stop] = [stop, start];
    const interval = count && typeof count.range === "function" ? count : tickInterval(start, stop, count);
    const ticks = interval ? interval.range(start, +stop + 1) : []; // inclusive stop
    return reverse ? ticks.reverse() : ticks;
  }
  function tickInterval(start, stop, count) {
    const target = Math.abs(stop - start) / count;
    const i = bisector(([,, step]) => step).right(tickIntervals, target);
    if (i === tickIntervals.length) return year.every(tickStep(start / durationYear$1, stop / durationYear$1, count));
    if (i === 0) return millisecond.every(Math.max(tickStep(start, stop, count), 1));
    const [t, step] = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
    return t.every(step);
  }
  return [ticks, tickInterval];
}
const [utcTicks, utcTickInterval] = ticker(utcYear, utcMonth, utcSunday, unixDay, utcHour, utcMinute);
const [timeTicks, timeTickInterval] = ticker(timeYear, timeMonth, timeSunday, timeDay, timeHour, timeMinute);

const YEAR = 'year';
const QUARTER = 'quarter';
const MONTH = 'month';
const WEEK = 'week';
const DATE = 'date';
const DAY = 'day';
const DAYOFYEAR = 'dayofyear';
const HOURS = 'hours';
const MINUTES = 'minutes';
const SECONDS = 'seconds';
const MILLISECONDS = 'milliseconds';
const TIME_UNITS = [YEAR, QUARTER, MONTH, WEEK, DATE, DAY, DAYOFYEAR, HOURS, MINUTES, SECONDS, MILLISECONDS];
const UNITS = TIME_UNITS.reduce((o, u, i) => (o[u] = 1 + i, o), {});
function timeUnits(units) {
  const u = array$5(units).slice(),
    m = {};

  // check validity
  if (!u.length) error('Missing time unit.');
  u.forEach(unit => {
    if (has$1(UNITS, unit)) {
      m[unit] = 1;
    } else {
      error(`Invalid time unit: ${unit}.`);
    }
  });
  const numTypes = (m[WEEK] || m[DAY] ? 1 : 0) + (m[QUARTER] || m[MONTH] || m[DATE] ? 1 : 0) + (m[DAYOFYEAR] ? 1 : 0);
  if (numTypes > 1) {
    error(`Incompatible time units: ${units}`);
  }

  // ensure proper sort order
  u.sort((a, b) => UNITS[a] - UNITS[b]);
  return u;
}
const defaultSpecifiers = {
  [YEAR]: '%Y ',
  [QUARTER]: 'Q%q ',
  [MONTH]: '%b ',
  [DATE]: '%d ',
  [WEEK]: 'W%U ',
  [DAY]: '%a ',
  [DAYOFYEAR]: '%j ',
  [HOURS]: '%H:00',
  [MINUTES]: '00:%M',
  [SECONDS]: ':%S',
  [MILLISECONDS]: '.%L',
  [`${YEAR}-${MONTH}`]: '%Y-%m ',
  [`${YEAR}-${MONTH}-${DATE}`]: '%Y-%m-%d ',
  [`${HOURS}-${MINUTES}`]: '%H:%M'
};
function timeUnitSpecifier(units, specifiers) {
  const s = extend$1({}, defaultSpecifiers, specifiers),
    u = timeUnits(units),
    n = u.length;
  let fmt = '',
    start = 0,
    end,
    key;
  for (start = 0; start < n;) {
    for (end = u.length; end > start; --end) {
      key = u.slice(start, end).join('-');
      if (s[key] != null) {
        fmt += s[key];
        start = end;
        break;
      }
    }
  }
  return fmt.trim();
}
const t0$1 = new Date();
function localYear(y) {
  t0$1.setFullYear(y);
  t0$1.setMonth(0);
  t0$1.setDate(1);
  t0$1.setHours(0, 0, 0, 0);
  return t0$1;
}
function dayofyear(d) {
  return localDayOfYear(new Date(d));
}
function week(d) {
  return localWeekNum(new Date(d));
}
function localDayOfYear(d) {
  return timeDay.count(localYear(d.getFullYear()) - 1, d);
}
function localWeekNum(d) {
  return timeSunday.count(localYear(d.getFullYear()) - 1, d);
}
function localFirst(y) {
  return localYear(y).getDay();
}
function localDate$1(y, m, d, H, M, S, L) {
  if (0 <= y && y < 100) {
    const date = new Date(-1, m, d, H, M, S, L);
    date.setFullYear(y);
    return date;
  }
  return new Date(y, m, d, H, M, S, L);
}
function utcdayofyear(d) {
  return utcDayOfYear(new Date(d));
}
function utcweek(d) {
  return utcWeekNum(new Date(d));
}
function utcDayOfYear(d) {
  const y = Date.UTC(d.getUTCFullYear(), 0, 1);
  return utcDay.count(y - 1, d);
}
function utcWeekNum(d) {
  const y = Date.UTC(d.getUTCFullYear(), 0, 1);
  return utcSunday.count(y - 1, d);
}
function utcFirst(y) {
  t0$1.setTime(Date.UTC(y, 0, 1));
  return t0$1.getUTCDay();
}
function utcDate$1(y, m, d, H, M, S, L) {
  if (0 <= y && y < 100) {
    const date = new Date(Date.UTC(-1, m, d, H, M, S, L));
    date.setUTCFullYear(d.y);
    return date;
  }
  return new Date(Date.UTC(y, m, d, H, M, S, L));
}
function floor(units, step, get, inv, newDate) {
  const s = step || 1,
    b = peek$1(units),
    _ = (unit, p, key) => {
      key = key || unit;
      return getUnit(get[key], inv[key], unit === b && s, p);
    };
  const t = new Date(),
    u = toSet(units),
    y = u[YEAR] ? _(YEAR) : constant$5(2012),
    m = u[MONTH] ? _(MONTH) : u[QUARTER] ? _(QUARTER) : zero$3,
    d = u[WEEK] && u[DAY] ? _(DAY, 1, WEEK + DAY) : u[WEEK] ? _(WEEK, 1) : u[DAY] ? _(DAY, 1) : u[DATE] ? _(DATE, 1) : u[DAYOFYEAR] ? _(DAYOFYEAR, 1) : one$2,
    H = u[HOURS] ? _(HOURS) : zero$3,
    M = u[MINUTES] ? _(MINUTES) : zero$3,
    S = u[SECONDS] ? _(SECONDS) : zero$3,
    L = u[MILLISECONDS] ? _(MILLISECONDS) : zero$3;
  return function (v) {
    t.setTime(+v);
    const year = y(t);
    return newDate(year, m(t), d(t, year), H(t), M(t), S(t), L(t));
  };
}
function getUnit(f, inv, step, phase) {
  const u = step <= 1 ? f : phase ? (d, y) => phase + step * Math.floor((f(d, y) - phase) / step) : (d, y) => step * Math.floor(f(d, y) / step);
  return inv ? (d, y) => inv(u(d, y), y) : u;
}

// returns the day of the year based on week number, day of week,
// and the day of the week for the first day of the year
function weekday(week, day, firstDay) {
  return day + week * 7 - (firstDay + 6) % 7;
}

// -- LOCAL TIME --

const localGet = {
  [YEAR]: d => d.getFullYear(),
  [QUARTER]: d => Math.floor(d.getMonth() / 3),
  [MONTH]: d => d.getMonth(),
  [DATE]: d => d.getDate(),
  [HOURS]: d => d.getHours(),
  [MINUTES]: d => d.getMinutes(),
  [SECONDS]: d => d.getSeconds(),
  [MILLISECONDS]: d => d.getMilliseconds(),
  [DAYOFYEAR]: d => localDayOfYear(d),
  [WEEK]: d => localWeekNum(d),
  [WEEK + DAY]: (d, y) => weekday(localWeekNum(d), d.getDay(), localFirst(y)),
  [DAY]: (d, y) => weekday(1, d.getDay(), localFirst(y))
};
const localInv = {
  [QUARTER]: q => 3 * q,
  [WEEK]: (w, y) => weekday(w, 0, localFirst(y))
};
function timeFloor(units, step) {
  return floor(units, step || 1, localGet, localInv, localDate$1);
}

// -- UTC TIME --

const utcGet = {
  [YEAR]: d => d.getUTCFullYear(),
  [QUARTER]: d => Math.floor(d.getUTCMonth() / 3),
  [MONTH]: d => d.getUTCMonth(),
  [DATE]: d => d.getUTCDate(),
  [HOURS]: d => d.getUTCHours(),
  [MINUTES]: d => d.getUTCMinutes(),
  [SECONDS]: d => d.getUTCSeconds(),
  [MILLISECONDS]: d => d.getUTCMilliseconds(),
  [DAYOFYEAR]: d => utcDayOfYear(d),
  [WEEK]: d => utcWeekNum(d),
  [DAY]: (d, y) => weekday(1, d.getUTCDay(), utcFirst(y)),
  [WEEK + DAY]: (d, y) => weekday(utcWeekNum(d), d.getUTCDay(), utcFirst(y))
};
const utcInv = {
  [QUARTER]: q => 3 * q,
  [WEEK]: (w, y) => weekday(w, 0, utcFirst(y))
};
function utcFloor(units, step) {
  return floor(units, step || 1, utcGet, utcInv, utcDate$1);
}
const timeIntervals = {
  [YEAR]: timeYear,
  [QUARTER]: timeMonth.every(3),
  [MONTH]: timeMonth,
  [WEEK]: timeSunday,
  [DATE]: timeDay,
  [DAY]: timeDay,
  [DAYOFYEAR]: timeDay,
  [HOURS]: timeHour,
  [MINUTES]: timeMinute,
  [SECONDS]: second,
  [MILLISECONDS]: millisecond
};
const utcIntervals = {
  [YEAR]: utcYear,
  [QUARTER]: utcMonth.every(3),
  [MONTH]: utcMonth,
  [WEEK]: utcSunday,
  [DATE]: utcDay,
  [DAY]: utcDay,
  [DAYOFYEAR]: utcDay,
  [HOURS]: utcHour,
  [MINUTES]: utcMinute,
  [SECONDS]: second,
  [MILLISECONDS]: millisecond
};
function timeInterval(unit) {
  return timeIntervals[unit];
}
function utcInterval(unit) {
  return utcIntervals[unit];
}
function offset$3(ival, date, step) {
  return ival ? ival.offset(date, step) : undefined;
}
function timeOffset(unit, date, step) {
  return offset$3(timeInterval(unit), date, step);
}
function utcOffset(unit, date, step) {
  return offset$3(utcInterval(unit), date, step);
}
function sequence$1(ival, start, stop, step) {
  return ival ? ival.range(start, stop, step) : undefined;
}
function timeSequence(unit, start, stop, step) {
  return sequence$1(timeInterval(unit), start, stop, step);
}
function utcSequence(unit, start, stop, step) {
  return sequence$1(utcInterval(unit), start, stop, step);
}
const durationSecond = 1000,
  durationMinute = durationSecond * 60,
  durationHour = durationMinute * 60,
  durationDay = durationHour * 24,
  durationWeek = durationDay * 7,
  durationMonth = durationDay * 30,
  durationYear = durationDay * 365;
const Milli = [YEAR, MONTH, DATE, HOURS, MINUTES, SECONDS, MILLISECONDS],
  Seconds = Milli.slice(0, -1),
  Minutes = Seconds.slice(0, -1),
  Hours = Minutes.slice(0, -1),
  Day = Hours.slice(0, -1),
  Week = [YEAR, WEEK],
  Month = [YEAR, MONTH],
  Year = [YEAR];
const intervals = [[Seconds, 1, durationSecond], [Seconds, 5, 5 * durationSecond], [Seconds, 15, 15 * durationSecond], [Seconds, 30, 30 * durationSecond], [Minutes, 1, durationMinute], [Minutes, 5, 5 * durationMinute], [Minutes, 15, 15 * durationMinute], [Minutes, 30, 30 * durationMinute], [Hours, 1, durationHour], [Hours, 3, 3 * durationHour], [Hours, 6, 6 * durationHour], [Hours, 12, 12 * durationHour], [Day, 1, durationDay], [Week, 1, durationWeek], [Month, 1, durationMonth], [Month, 3, 3 * durationMonth], [Year, 1, durationYear]];
function bin$1(opt) {
  const ext = opt.extent,
    max = opt.maxbins || 40,
    target = Math.abs(span(ext)) / max;
  let i = bisector(i => i[2]).right(intervals, target),
    units,
    step;
  if (i === intervals.length) {
    units = Year, step = tickStep(ext[0] / durationYear, ext[1] / durationYear, max);
  } else if (i) {
    i = intervals[target / intervals[i - 1][2] < intervals[i][2] / target ? i - 1 : i];
    units = i[0];
    step = i[1];
  } else {
    units = Milli;
    step = Math.max(tickStep(ext[0], ext[1], max), 1);
  }
  return {
    units,
    step
  };
}

function localDate(d) {
  if (0 <= d.y && d.y < 100) {
    var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
    date.setFullYear(d.y);
    return date;
  }
  return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}
function utcDate(d) {
  if (0 <= d.y && d.y < 100) {
    var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
    date.setUTCFullYear(d.y);
    return date;
  }
  return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}
function newDate(y, m, d) {
  return {
    y: y,
    m: m,
    d: d,
    H: 0,
    M: 0,
    S: 0,
    L: 0
  };
}
function formatLocale(locale) {
  var locale_dateTime = locale.dateTime,
    locale_date = locale.date,
    locale_time = locale.time,
    locale_periods = locale.periods,
    locale_weekdays = locale.days,
    locale_shortWeekdays = locale.shortDays,
    locale_months = locale.months,
    locale_shortMonths = locale.shortMonths;
  var periodRe = formatRe(locale_periods),
    periodLookup = formatLookup(locale_periods),
    weekdayRe = formatRe(locale_weekdays),
    weekdayLookup = formatLookup(locale_weekdays),
    shortWeekdayRe = formatRe(locale_shortWeekdays),
    shortWeekdayLookup = formatLookup(locale_shortWeekdays),
    monthRe = formatRe(locale_months),
    monthLookup = formatLookup(locale_months),
    shortMonthRe = formatRe(locale_shortMonths),
    shortMonthLookup = formatLookup(locale_shortMonths);
  var formats = {
    "a": formatShortWeekday,
    "A": formatWeekday,
    "b": formatShortMonth,
    "B": formatMonth,
    "c": null,
    "d": formatDayOfMonth,
    "e": formatDayOfMonth,
    "f": formatMicroseconds,
    "g": formatYearISO,
    "G": formatFullYearISO,
    "H": formatHour24,
    "I": formatHour12,
    "j": formatDayOfYear,
    "L": formatMilliseconds,
    "m": formatMonthNumber,
    "M": formatMinutes,
    "p": formatPeriod,
    "q": formatQuarter,
    "Q": formatUnixTimestamp,
    "s": formatUnixTimestampSeconds,
    "S": formatSeconds,
    "u": formatWeekdayNumberMonday,
    "U": formatWeekNumberSunday,
    "V": formatWeekNumberISO,
    "w": formatWeekdayNumberSunday,
    "W": formatWeekNumberMonday,
    "x": null,
    "X": null,
    "y": formatYear,
    "Y": formatFullYear,
    "Z": formatZone,
    "%": formatLiteralPercent
  };
  var utcFormats = {
    "a": formatUTCShortWeekday,
    "A": formatUTCWeekday,
    "b": formatUTCShortMonth,
    "B": formatUTCMonth,
    "c": null,
    "d": formatUTCDayOfMonth,
    "e": formatUTCDayOfMonth,
    "f": formatUTCMicroseconds,
    "g": formatUTCYearISO,
    "G": formatUTCFullYearISO,
    "H": formatUTCHour24,
    "I": formatUTCHour12,
    "j": formatUTCDayOfYear,
    "L": formatUTCMilliseconds,
    "m": formatUTCMonthNumber,
    "M": formatUTCMinutes,
    "p": formatUTCPeriod,
    "q": formatUTCQuarter,
    "Q": formatUnixTimestamp,
    "s": formatUnixTimestampSeconds,
    "S": formatUTCSeconds,
    "u": formatUTCWeekdayNumberMonday,
    "U": formatUTCWeekNumberSunday,
    "V": formatUTCWeekNumberISO,
    "w": formatUTCWeekdayNumberSunday,
    "W": formatUTCWeekNumberMonday,
    "x": null,
    "X": null,
    "y": formatUTCYear,
    "Y": formatUTCFullYear,
    "Z": formatUTCZone,
    "%": formatLiteralPercent
  };
  var parses = {
    "a": parseShortWeekday,
    "A": parseWeekday,
    "b": parseShortMonth,
    "B": parseMonth,
    "c": parseLocaleDateTime,
    "d": parseDayOfMonth,
    "e": parseDayOfMonth,
    "f": parseMicroseconds,
    "g": parseYear,
    "G": parseFullYear,
    "H": parseHour24,
    "I": parseHour24,
    "j": parseDayOfYear,
    "L": parseMilliseconds,
    "m": parseMonthNumber,
    "M": parseMinutes,
    "p": parsePeriod,
    "q": parseQuarter,
    "Q": parseUnixTimestamp,
    "s": parseUnixTimestampSeconds,
    "S": parseSeconds,
    "u": parseWeekdayNumberMonday,
    "U": parseWeekNumberSunday,
    "V": parseWeekNumberISO,
    "w": parseWeekdayNumberSunday,
    "W": parseWeekNumberMonday,
    "x": parseLocaleDate,
    "X": parseLocaleTime,
    "y": parseYear,
    "Y": parseFullYear,
    "Z": parseZone,
    "%": parseLiteralPercent
  };

  // These recursive directive definitions must be deferred.
  formats.x = newFormat(locale_date, formats);
  formats.X = newFormat(locale_time, formats);
  formats.c = newFormat(locale_dateTime, formats);
  utcFormats.x = newFormat(locale_date, utcFormats);
  utcFormats.X = newFormat(locale_time, utcFormats);
  utcFormats.c = newFormat(locale_dateTime, utcFormats);
  function newFormat(specifier, formats) {
    return function (date) {
      var string = [],
        i = -1,
        j = 0,
        n = specifier.length,
        c,
        pad,
        format;
      if (!(date instanceof Date)) date = new Date(+date);
      while (++i < n) {
        if (specifier.charCodeAt(i) === 37) {
          string.push(specifier.slice(j, i));
          if ((pad = pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);else pad = c === "e" ? " " : "0";
          if (format = formats[c]) c = format(date, pad);
          string.push(c);
          j = i + 1;
        }
      }
      string.push(specifier.slice(j, i));
      return string.join("");
    };
  }
  function newParse(specifier, Z) {
    return function (string) {
      var d = newDate(1900, undefined, 1),
        i = parseSpecifier(d, specifier, string += "", 0),
        week,
        day;
      if (i != string.length) return null;

      // If a UNIX timestamp is specified, return it.
      if ("Q" in d) return new Date(d.Q);
      if ("s" in d) return new Date(d.s * 1000 + ("L" in d ? d.L : 0));

      // If this is utcParse, never use the local timezone.
      if (Z && !("Z" in d)) d.Z = 0;

      // The am-pm flag is 0 for AM, and 1 for PM.
      if ("p" in d) d.H = d.H % 12 + d.p * 12;

      // If the month was not specified, inherit from the quarter.
      if (d.m === undefined) d.m = "q" in d ? d.q : 0;

      // Convert day-of-week and week-of-year to day-of-year.
      if ("V" in d) {
        if (d.V < 1 || d.V > 53) return null;
        if (!("w" in d)) d.w = 1;
        if ("Z" in d) {
          week = utcDate(newDate(d.y, 0, 1)), day = week.getUTCDay();
          week = day > 4 || day === 0 ? utcMonday.ceil(week) : utcMonday(week);
          week = utcDay.offset(week, (d.V - 1) * 7);
          d.y = week.getUTCFullYear();
          d.m = week.getUTCMonth();
          d.d = week.getUTCDate() + (d.w + 6) % 7;
        } else {
          week = localDate(newDate(d.y, 0, 1)), day = week.getDay();
          week = day > 4 || day === 0 ? timeMonday.ceil(week) : timeMonday(week);
          week = timeDay.offset(week, (d.V - 1) * 7);
          d.y = week.getFullYear();
          d.m = week.getMonth();
          d.d = week.getDate() + (d.w + 6) % 7;
        }
      } else if ("W" in d || "U" in d) {
        if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
        day = "Z" in d ? utcDate(newDate(d.y, 0, 1)).getUTCDay() : localDate(newDate(d.y, 0, 1)).getDay();
        d.m = 0;
        d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
      }

      // If a time zone is specified, all fields are interpreted as UTC and then
      // offset according to the specified time zone.
      if ("Z" in d) {
        d.H += d.Z / 100 | 0;
        d.M += d.Z % 100;
        return utcDate(d);
      }

      // Otherwise, all fields are in local time.
      return localDate(d);
    };
  }
  function parseSpecifier(d, specifier, string, j) {
    var i = 0,
      n = specifier.length,
      m = string.length,
      c,
      parse;
    while (i < n) {
      if (j >= m) return -1;
      c = specifier.charCodeAt(i++);
      if (c === 37) {
        c = specifier.charAt(i++);
        parse = parses[c in pads ? specifier.charAt(i++) : c];
        if (!parse || (j = parse(d, string, j)) < 0) return -1;
      } else if (c != string.charCodeAt(j++)) {
        return -1;
      }
    }
    return j;
  }
  function parsePeriod(d, string, i) {
    var n = periodRe.exec(string.slice(i));
    return n ? (d.p = periodLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
  }
  function parseShortWeekday(d, string, i) {
    var n = shortWeekdayRe.exec(string.slice(i));
    return n ? (d.w = shortWeekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
  }
  function parseWeekday(d, string, i) {
    var n = weekdayRe.exec(string.slice(i));
    return n ? (d.w = weekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
  }
  function parseShortMonth(d, string, i) {
    var n = shortMonthRe.exec(string.slice(i));
    return n ? (d.m = shortMonthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
  }
  function parseMonth(d, string, i) {
    var n = monthRe.exec(string.slice(i));
    return n ? (d.m = monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
  }
  function parseLocaleDateTime(d, string, i) {
    return parseSpecifier(d, locale_dateTime, string, i);
  }
  function parseLocaleDate(d, string, i) {
    return parseSpecifier(d, locale_date, string, i);
  }
  function parseLocaleTime(d, string, i) {
    return parseSpecifier(d, locale_time, string, i);
  }
  function formatShortWeekday(d) {
    return locale_shortWeekdays[d.getDay()];
  }
  function formatWeekday(d) {
    return locale_weekdays[d.getDay()];
  }
  function formatShortMonth(d) {
    return locale_shortMonths[d.getMonth()];
  }
  function formatMonth(d) {
    return locale_months[d.getMonth()];
  }
  function formatPeriod(d) {
    return locale_periods[+(d.getHours() >= 12)];
  }
  function formatQuarter(d) {
    return 1 + ~~(d.getMonth() / 3);
  }
  function formatUTCShortWeekday(d) {
    return locale_shortWeekdays[d.getUTCDay()];
  }
  function formatUTCWeekday(d) {
    return locale_weekdays[d.getUTCDay()];
  }
  function formatUTCShortMonth(d) {
    return locale_shortMonths[d.getUTCMonth()];
  }
  function formatUTCMonth(d) {
    return locale_months[d.getUTCMonth()];
  }
  function formatUTCPeriod(d) {
    return locale_periods[+(d.getUTCHours() >= 12)];
  }
  function formatUTCQuarter(d) {
    return 1 + ~~(d.getUTCMonth() / 3);
  }
  return {
    format: function (specifier) {
      var f = newFormat(specifier += "", formats);
      f.toString = function () {
        return specifier;
      };
      return f;
    },
    parse: function (specifier) {
      var p = newParse(specifier += "", false);
      p.toString = function () {
        return specifier;
      };
      return p;
    },
    utcFormat: function (specifier) {
      var f = newFormat(specifier += "", utcFormats);
      f.toString = function () {
        return specifier;
      };
      return f;
    },
    utcParse: function (specifier) {
      var p = newParse(specifier += "", true);
      p.toString = function () {
        return specifier;
      };
      return p;
    }
  };
}
var pads = {
    "-": "",
    "_": " ",
    "0": "0"
  },
  numberRe = /^\s*\d+/,
  // note: ignores next directive
  percentRe = /^%/,
  requoteRe = /[\\^$*+?|[\]().{}]/g;
function pad(value, fill, width) {
  var sign = value < 0 ? "-" : "",
    string = (sign ? -value : value) + "",
    length = string.length;
  return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}
function requote(s) {
  return s.replace(requoteRe, "\\$&");
}
function formatRe(names) {
  return new RegExp("^(?:" + names.map(requote).join("|") + ")", "i");
}
function formatLookup(names) {
  return new Map(names.map((name, i) => [name.toLowerCase(), i]));
}
function parseWeekdayNumberSunday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 1));
  return n ? (d.w = +n[0], i + n[0].length) : -1;
}
function parseWeekdayNumberMonday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 1));
  return n ? (d.u = +n[0], i + n[0].length) : -1;
}
function parseWeekNumberSunday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.U = +n[0], i + n[0].length) : -1;
}
function parseWeekNumberISO(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.V = +n[0], i + n[0].length) : -1;
}
function parseWeekNumberMonday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.W = +n[0], i + n[0].length) : -1;
}
function parseFullYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 4));
  return n ? (d.y = +n[0], i + n[0].length) : -1;
}
function parseYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}
function parseZone(d, string, i) {
  var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
  return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}
function parseQuarter(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 1));
  return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
}
function parseMonthNumber(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}
function parseDayOfMonth(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.d = +n[0], i + n[0].length) : -1;
}
function parseDayOfYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 3));
  return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}
function parseHour24(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.H = +n[0], i + n[0].length) : -1;
}
function parseMinutes(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.M = +n[0], i + n[0].length) : -1;
}
function parseSeconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.S = +n[0], i + n[0].length) : -1;
}
function parseMilliseconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 3));
  return n ? (d.L = +n[0], i + n[0].length) : -1;
}
function parseMicroseconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 6));
  return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
}
function parseLiteralPercent(d, string, i) {
  var n = percentRe.exec(string.slice(i, i + 1));
  return n ? i + n[0].length : -1;
}
function parseUnixTimestamp(d, string, i) {
  var n = numberRe.exec(string.slice(i));
  return n ? (d.Q = +n[0], i + n[0].length) : -1;
}
function parseUnixTimestampSeconds(d, string, i) {
  var n = numberRe.exec(string.slice(i));
  return n ? (d.s = +n[0], i + n[0].length) : -1;
}
function formatDayOfMonth(d, p) {
  return pad(d.getDate(), p, 2);
}
function formatHour24(d, p) {
  return pad(d.getHours(), p, 2);
}
function formatHour12(d, p) {
  return pad(d.getHours() % 12 || 12, p, 2);
}
function formatDayOfYear(d, p) {
  return pad(1 + timeDay.count(timeYear(d), d), p, 3);
}
function formatMilliseconds(d, p) {
  return pad(d.getMilliseconds(), p, 3);
}
function formatMicroseconds(d, p) {
  return formatMilliseconds(d, p) + "000";
}
function formatMonthNumber(d, p) {
  return pad(d.getMonth() + 1, p, 2);
}
function formatMinutes(d, p) {
  return pad(d.getMinutes(), p, 2);
}
function formatSeconds(d, p) {
  return pad(d.getSeconds(), p, 2);
}
function formatWeekdayNumberMonday(d) {
  var day = d.getDay();
  return day === 0 ? 7 : day;
}
function formatWeekNumberSunday(d, p) {
  return pad(timeSunday.count(timeYear(d) - 1, d), p, 2);
}
function dISO(d) {
  var day = d.getDay();
  return day >= 4 || day === 0 ? timeThursday(d) : timeThursday.ceil(d);
}
function formatWeekNumberISO(d, p) {
  d = dISO(d);
  return pad(timeThursday.count(timeYear(d), d) + (timeYear(d).getDay() === 4), p, 2);
}
function formatWeekdayNumberSunday(d) {
  return d.getDay();
}
function formatWeekNumberMonday(d, p) {
  return pad(timeMonday.count(timeYear(d) - 1, d), p, 2);
}
function formatYear(d, p) {
  return pad(d.getFullYear() % 100, p, 2);
}
function formatYearISO(d, p) {
  d = dISO(d);
  return pad(d.getFullYear() % 100, p, 2);
}
function formatFullYear(d, p) {
  return pad(d.getFullYear() % 10000, p, 4);
}
function formatFullYearISO(d, p) {
  var day = d.getDay();
  d = day >= 4 || day === 0 ? timeThursday(d) : timeThursday.ceil(d);
  return pad(d.getFullYear() % 10000, p, 4);
}
function formatZone(d) {
  var z = d.getTimezoneOffset();
  return (z > 0 ? "-" : (z *= -1, "+")) + pad(z / 60 | 0, "0", 2) + pad(z % 60, "0", 2);
}
function formatUTCDayOfMonth(d, p) {
  return pad(d.getUTCDate(), p, 2);
}
function formatUTCHour24(d, p) {
  return pad(d.getUTCHours(), p, 2);
}
function formatUTCHour12(d, p) {
  return pad(d.getUTCHours() % 12 || 12, p, 2);
}
function formatUTCDayOfYear(d, p) {
  return pad(1 + utcDay.count(utcYear(d), d), p, 3);
}
function formatUTCMilliseconds(d, p) {
  return pad(d.getUTCMilliseconds(), p, 3);
}
function formatUTCMicroseconds(d, p) {
  return formatUTCMilliseconds(d, p) + "000";
}
function formatUTCMonthNumber(d, p) {
  return pad(d.getUTCMonth() + 1, p, 2);
}
function formatUTCMinutes(d, p) {
  return pad(d.getUTCMinutes(), p, 2);
}
function formatUTCSeconds(d, p) {
  return pad(d.getUTCSeconds(), p, 2);
}
function formatUTCWeekdayNumberMonday(d) {
  var dow = d.getUTCDay();
  return dow === 0 ? 7 : dow;
}
function formatUTCWeekNumberSunday(d, p) {
  return pad(utcSunday.count(utcYear(d) - 1, d), p, 2);
}
function UTCdISO(d) {
  var day = d.getUTCDay();
  return day >= 4 || day === 0 ? utcThursday(d) : utcThursday.ceil(d);
}
function formatUTCWeekNumberISO(d, p) {
  d = UTCdISO(d);
  return pad(utcThursday.count(utcYear(d), d) + (utcYear(d).getUTCDay() === 4), p, 2);
}
function formatUTCWeekdayNumberSunday(d) {
  return d.getUTCDay();
}
function formatUTCWeekNumberMonday(d, p) {
  return pad(utcMonday.count(utcYear(d) - 1, d), p, 2);
}
function formatUTCYear(d, p) {
  return pad(d.getUTCFullYear() % 100, p, 2);
}
function formatUTCYearISO(d, p) {
  d = UTCdISO(d);
  return pad(d.getUTCFullYear() % 100, p, 2);
}
function formatUTCFullYear(d, p) {
  return pad(d.getUTCFullYear() % 10000, p, 4);
}
function formatUTCFullYearISO(d, p) {
  var day = d.getUTCDay();
  d = day >= 4 || day === 0 ? utcThursday(d) : utcThursday.ceil(d);
  return pad(d.getUTCFullYear() % 10000, p, 4);
}
function formatUTCZone() {
  return "+0000";
}
function formatLiteralPercent() {
  return "%";
}
function formatUnixTimestamp(d) {
  return +d;
}
function formatUnixTimestampSeconds(d) {
  return Math.floor(+d / 1000);
}

var locale$1;
var timeFormat$1;
var timeParse$1;
var utcFormat$1;
var utcParse$1;
defaultLocale$1({
  dateTime: "%x, %X",
  date: "%-m/%-d/%Y",
  time: "%-I:%M:%S %p",
  periods: ["AM", "PM"],
  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
});
function defaultLocale$1(definition) {
  locale$1 = formatLocale(definition);
  timeFormat$1 = locale$1.format;
  timeParse$1 = locale$1.parse;
  utcFormat$1 = locale$1.utcFormat;
  utcParse$1 = locale$1.utcParse;
  return locale$1;
}

function memoize(method) {
  const cache = {};
  return spec => cache[spec] || (cache[spec] = method(spec));
}
function trimZeroes(numberFormat, decimalChar) {
  return x => {
    const str = numberFormat(x),
      dec = str.indexOf(decimalChar);
    if (dec < 0) return str;
    let idx = rightmostDigit(str, dec);
    const end = idx < str.length ? str.slice(idx) : '';
    while (--idx > dec) if (str[idx] !== '0') {
      ++idx;
      break;
    }
    return str.slice(0, idx) + end;
  };
}
function rightmostDigit(str, dec) {
  let i = str.lastIndexOf('e'),
    c;
  if (i > 0) return i;
  for (i = str.length; --i > dec;) {
    c = str.charCodeAt(i);
    if (c >= 48 && c <= 57) return i + 1; // is digit
  }
}
function numberLocale(locale) {
  const format = memoize(locale.format),
    formatPrefix = locale.formatPrefix;
  return {
    format,
    formatPrefix,
    formatFloat(spec) {
      const s = formatSpecifier(spec || ',');
      if (s.precision == null) {
        s.precision = 12;
        switch (s.type) {
          case '%':
            s.precision -= 2;
            break;
          case 'e':
            s.precision -= 1;
            break;
        }
        return trimZeroes(format(s),
        // number format
        format('.1f')(1)[1] // decimal point character
        );
      } else {
        return format(s);
      }
    },
    formatSpan(start, stop, count, specifier) {
      specifier = formatSpecifier(specifier == null ? ',f' : specifier);
      const step = tickStep(start, stop, count),
        value = Math.max(Math.abs(start), Math.abs(stop));
      let precision;
      if (specifier.precision == null) {
        switch (specifier.type) {
          case 's':
            {
              if (!isNaN(precision = precisionPrefix(step, value))) {
                specifier.precision = precision;
              }
              return formatPrefix(specifier, value);
            }
          case '':
          case 'e':
          case 'g':
          case 'p':
          case 'r':
            {
              if (!isNaN(precision = precisionRound(step, value))) {
                specifier.precision = precision - (specifier.type === 'e');
              }
              break;
            }
          case 'f':
          case '%':
            {
              if (!isNaN(precision = precisionFixed(step))) {
                specifier.precision = precision - (specifier.type === '%') * 2;
              }
              break;
            }
        }
      }
      return format(specifier);
    }
  };
}
let defaultNumberLocale;
resetNumberFormatDefaultLocale();
function resetNumberFormatDefaultLocale() {
  return defaultNumberLocale = numberLocale({
    format: format$3,
    formatPrefix: formatPrefix
  });
}
function numberFormatLocale(definition) {
  return numberLocale(formatLocale$1(definition));
}
function numberFormatDefaultLocale(definition) {
  return arguments.length ? defaultNumberLocale = numberFormatLocale(definition) : defaultNumberLocale;
}
function timeMultiFormat(format, interval, spec) {
  spec = spec || {};
  if (!isObject(spec)) {
    error(`Invalid time multi-format specifier: ${spec}`);
  }
  const second = interval(SECONDS),
    minute = interval(MINUTES),
    hour = interval(HOURS),
    day = interval(DATE),
    week = interval(WEEK),
    month = interval(MONTH),
    quarter = interval(QUARTER),
    year = interval(YEAR),
    L = format(spec[MILLISECONDS] || '.%L'),
    S = format(spec[SECONDS] || ':%S'),
    M = format(spec[MINUTES] || '%I:%M'),
    H = format(spec[HOURS] || '%I %p'),
    d = format(spec[DATE] || spec[DAY] || '%a %d'),
    w = format(spec[WEEK] || '%b %d'),
    m = format(spec[MONTH] || '%B'),
    q = format(spec[QUARTER] || '%B'),
    y = format(spec[YEAR] || '%Y');
  return date => (second(date) < date ? L : minute(date) < date ? S : hour(date) < date ? M : day(date) < date ? H : month(date) < date ? week(date) < date ? d : w : year(date) < date ? quarter(date) < date ? m : q : y)(date);
}
function timeLocale(locale) {
  const timeFormat = memoize(locale.format),
    utcFormat = memoize(locale.utcFormat);
  return {
    timeFormat: spec => isString(spec) ? timeFormat(spec) : timeMultiFormat(timeFormat, timeInterval, spec),
    utcFormat: spec => isString(spec) ? utcFormat(spec) : timeMultiFormat(utcFormat, utcInterval, spec),
    timeParse: memoize(locale.parse),
    utcParse: memoize(locale.utcParse)
  };
}
let defaultTimeLocale;
resetTimeFormatDefaultLocale();
function resetTimeFormatDefaultLocale() {
  return defaultTimeLocale = timeLocale({
    format: timeFormat$1,
    parse: timeParse$1,
    utcFormat: utcFormat$1,
    utcParse: utcParse$1
  });
}
function timeFormatLocale(definition) {
  return timeLocale(formatLocale(definition));
}
function timeFormatDefaultLocale(definition) {
  return arguments.length ? defaultTimeLocale = timeFormatLocale(definition) : defaultTimeLocale;
}
const createLocale = (number, time) => extend$1({}, number, time);
function locale(numberSpec, timeSpec) {
  const number = numberSpec ? numberFormatLocale(numberSpec) : numberFormatDefaultLocale();
  const time = timeSpec ? timeFormatLocale(timeSpec) : timeFormatDefaultLocale();
  return createLocale(number, time);
}
function defaultLocale(numberSpec, timeSpec) {
  const args = arguments.length;
  if (args && args !== 2) {
    error('defaultLocale expects either zero or two arguments.');
  }
  return args ? createLocale(numberFormatDefaultLocale(numberSpec), timeFormatDefaultLocale(timeSpec)) : createLocale(numberFormatDefaultLocale(), timeFormatDefaultLocale());
}

// Matches absolute URLs with optional protocol
//   https://...    file://...    //...
const protocol_re = /^(data:|([A-Za-z]+:)?\/\/)/;

// Matches allowed URIs. From https://github.com/cure53/DOMPurify/blob/master/src/regexp.js with added file://
const allowed_re = /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|cid|xmpp|file|data):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i; // eslint-disable-line no-useless-escape
const whitespace_re = /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205f\u3000]/g; // eslint-disable-line no-control-regex

// Special treatment in node.js for the file: protocol
const fileProtocol = 'file://';

/**
 * Factory for a loader constructor that provides methods for requesting
 * files from either the network or disk, and for sanitizing request URIs.
 * @param {function} fetch - The Fetch API for HTTP network requests.
 *   If null or undefined, HTTP loading will be disabled.
 * @param {object} fs - The file system interface for file loading.
 *   If null or undefined, local file loading will be disabled.
 * @return {function} A loader constructor with the following signature:
 *   param {object} [options] - Optional default loading options to use.
 *   return {object} - A new loader instance.
 */
function loaderFactory(fetch, fs) {
  return options => ({
    options: options || {},
    sanitize: sanitize,
    load: load$1,
    fileAccess: false,
    file: fileLoader(fs),
    http: httpLoader(fetch)
  });
}

/**
 * Load an external resource, typically either from the web or from the local
 * filesystem. This function uses {@link sanitize} to first sanitize the uri,
 * then calls either {@link http} (for web requests) or {@link file} (for
 * filesystem loading).
 * @param {string} uri - The resource indicator (e.g., URL or filename).
 * @param {object} [options] - Optional loading options. These options will
 *   override any existing default options.
 * @return {Promise} - A promise that resolves to the loaded content.
 */
async function load$1(uri, options) {
  const opt = await this.sanitize(uri, options),
    url = opt.href;
  return opt.localFile ? this.file(url) : this.http(url, options);
}

/**
 * URI sanitizer function.
 * @param {string} uri - The uri (url or filename) to check.
 * @param {object} options - An options hash.
 * @return {Promise} - A promise that resolves to an object containing
 *  sanitized uri data, or rejects it the input uri is deemed invalid.
 *  The properties of the resolved object are assumed to be
 *  valid attributes for an HTML 'a' tag. The sanitized uri *must* be
 *  provided by the 'href' property of the returned object.
 */
async function sanitize(uri, options) {
  options = extend$1({}, this.options, options);
  const fileAccess = this.fileAccess,
    result = {
      href: null
    };
  let isFile, loadFile, base;
  const isAllowed = allowed_re.test(uri.replace(whitespace_re, ''));
  if (uri == null || typeof uri !== 'string' || !isAllowed) {
    error('Sanitize failure, invalid URI: ' + $(uri));
  }
  const hasProtocol = protocol_re.test(uri);

  // if relative url (no protocol/host), prepend baseURL
  if ((base = options.baseURL) && !hasProtocol) {
    // Ensure that there is a slash between the baseURL (e.g. hostname) and url
    if (!uri.startsWith('/') && !base.endsWith('/')) {
      uri = '/' + uri;
    }
    uri = base + uri;
  }

  // should we load from file system?
  loadFile = (isFile = uri.startsWith(fileProtocol)) || options.mode === 'file' || options.mode !== 'http' && !hasProtocol && fileAccess;
  if (isFile) {
    // strip file protocol
    uri = uri.slice(fileProtocol.length);
  } else if (uri.startsWith('//')) {
    if (options.defaultProtocol === 'file') {
      // if is file, strip protocol and set loadFile flag
      uri = uri.slice(2);
      loadFile = true;
    } else {
      // if relative protocol (starts with '//'), prepend default protocol
      uri = (options.defaultProtocol || 'http') + ':' + uri;
    }
  }

  // set non-enumerable mode flag to indicate local file load
  Object.defineProperty(result, 'localFile', {
    value: !!loadFile
  });

  // set uri
  result.href = uri;

  // set default result target, if specified
  if (options.target) {
    result.target = options.target + '';
  }

  // set default result rel, if specified (#1542)
  if (options.rel) {
    result.rel = options.rel + '';
  }

  // provide control over cross-origin image handling (#2238)
  // https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image
  if (options.context === 'image' && options.crossOrigin) {
    result.crossOrigin = options.crossOrigin + '';
  }

  // return
  return result;
}

/**
 * File system loader factory.
 * @param {object} fs - The file system interface.
 * @return {function} - A file loader with the following signature:
 *   param {string} filename - The file system path to load.
 *   param {string} filename - The file system path to load.
 *   return {Promise} A promise that resolves to the file contents.
 */
function fileLoader(fs) {
  return fs ? filename => new Promise((accept, reject) => {
    fs.readFile(filename, (error, data) => {
      if (error) reject(error);else accept(data);
    });
  }) : fileReject;
}

/**
 * Default file system loader that simply rejects.
 */
async function fileReject() {
  error('No file system access.');
}

/**
 * HTTP request handler factory.
 * @param {function} fetch - The Fetch API method.
 * @return {function} - An http loader with the following signature:
 *   param {string} url - The url to request.
 *   param {object} options - An options hash.
 *   return {Promise} - A promise that resolves to the file contents.
 */
function httpLoader(fetch) {
  return fetch ? async function (url, options) {
    const opt = extend$1({}, this.options.http, options),
      type = options && options.response,
      response = await fetch(url, opt);
    return !response.ok ? error(response.status + '' + response.statusText) : isFunction(response[type]) ? response[type]() : response.text();
  } : httpReject;
}

/**
 * Default http request handler that simply rejects.
 */
async function httpReject() {
  error('No HTTP fetch method available.');
}
const isValid = _ => _ != null && _ === _;
const isBoolean = _ => _ === 'true' || _ === 'false' || _ === true || _ === false;
const isDate = _ => !Number.isNaN(Date.parse(_));
const isNumber = _ => !Number.isNaN(+_) && !(_ instanceof Date);
const isInteger = _ => isNumber(_) && Number.isInteger(+_);
const typeParsers = {
  boolean: toBoolean,
  integer: toNumber,
  number: toNumber,
  date: toDate,
  string: toString,
  unknown: identity$6
};
const typeTests = [isBoolean, isInteger, isNumber, isDate];
const typeList = ['boolean', 'integer', 'number', 'date'];
function inferType(values, field) {
  if (!values || !values.length) return 'unknown';
  const n = values.length,
    m = typeTests.length,
    a = typeTests.map((_, i) => i + 1);
  for (let i = 0, t = 0, j, value; i < n; ++i) {
    value = field ? values[i][field] : values[i];
    for (j = 0; j < m; ++j) {
      if (a[j] && isValid(value) && !typeTests[j](value)) {
        a[j] = 0;
        ++t;
        if (t === typeTests.length) return 'string';
      }
    }
  }
  return typeList[a.reduce((u, v) => u === 0 ? v : u, 0) - 1];
}
function inferTypes(data, fields) {
  return fields.reduce((types, field) => {
    types[field] = inferType(data, field);
    return types;
  }, {});
}
function delimitedFormat(delimiter) {
  const parse = function (data, format) {
    const delim = {
      delimiter: delimiter
    };
    return dsv(data, format ? extend$1(format, delim) : delim);
  };
  parse.responseType = 'text';
  return parse;
}
function dsv(data, format) {
  if (format.header) {
    data = format.header.map($).join(format.delimiter) + '\n' + data;
  }
  return dsvFormat(format.delimiter).parse(data + '');
}
dsv.responseType = 'text';
function isBuffer(_) {
  return typeof Buffer === 'function' && isFunction(Buffer.isBuffer) ? Buffer.isBuffer(_) : false;
}
function json(data, format) {
  const prop = format && format.property ? field$1(format.property) : identity$6;
  return isObject(data) && !isBuffer(data) ? parseJSON(prop(data), format) : prop(JSON.parse(data));
}
json.responseType = 'json';
function parseJSON(data, format) {
  if (!isArray(data) && isIterable(data)) {
    data = [...data];
  }
  return format && format.copy ? JSON.parse(JSON.stringify(data)) : data;
}
const filters = {
  interior: (a, b) => a !== b,
  exterior: (a, b) => a === b
};
function topojson(data, format) {
  let method, object, property, filter;
  data = json(data, format);
  if (format && format.feature) {
    method = feature;
    property = format.feature;
  } else if (format && format.mesh) {
    method = mesh;
    property = format.mesh;
    filter = filters[format.filter];
  } else {
    error('Missing TopoJSON feature or mesh parameter.');
  }
  object = (object = data.objects[property]) ? method(data, object, filter) : error('Invalid TopoJSON object: ' + property);
  return object && object.features || [object];
}
topojson.responseType = 'json';
const format$2 = {
  dsv: dsv,
  csv: delimitedFormat(','),
  tsv: delimitedFormat('\t'),
  json: json,
  topojson: topojson
};
function formats$1(name, reader) {
  if (arguments.length > 1) {
    format$2[name] = reader;
    return this;
  } else {
    return has$1(format$2, name) ? format$2[name] : null;
  }
}
function responseType(type) {
  const f = formats$1(type);
  return f && f.responseType || 'text';
}
function read(data, schema, timeParser, utcParser) {
  schema = schema || {};
  const reader = formats$1(schema.type || 'json');
  if (!reader) error('Unknown data format type: ' + schema.type);
  data = reader(data, schema);
  if (schema.parse) parse$6(data, schema.parse, timeParser, utcParser);
  if (has$1(data, 'columns')) delete data.columns;
  return data;
}
function parse$6(data, types, timeParser, utcParser) {
  if (!data.length) return; // early exit for empty data

  const locale = timeFormatDefaultLocale();
  timeParser = timeParser || locale.timeParse;
  utcParser = utcParser || locale.utcParse;
  let fields = data.columns || Object.keys(data[0]),
    datum,
    field,
    i,
    j,
    n,
    m;
  if (types === 'auto') types = inferTypes(data, fields);
  fields = Object.keys(types);
  const parsers = fields.map(field => {
    const type = types[field];
    let parts, pattern;
    if (type && (type.startsWith('date:') || type.startsWith('utc:'))) {
      parts = type.split(/:(.+)?/, 2); // split on first :
      pattern = parts[1];
      if (pattern[0] === '\'' && pattern[pattern.length - 1] === '\'' || pattern[0] === '"' && pattern[pattern.length - 1] === '"') {
        pattern = pattern.slice(1, -1);
      }
      const parse = parts[0] === 'utc' ? utcParser : timeParser;
      return parse(pattern);
    }
    if (!typeParsers[type]) {
      throw Error('Illegal format pattern: ' + field + ':' + type);
    }
    return typeParsers[type];
  });
  for (i = 0, n = data.length, m = fields.length; i < n; ++i) {
    datum = data[i];
    for (j = 0; j < m; ++j) {
      field = fields[j];
      datum[field] = parsers[j](datum[field]);
    }
  }
}
const loader = loaderFactory(typeof fetch !== 'undefined' && fetch,
// use built-in fetch API
null // no file system access
);

function UniqueList(idFunc) {
  const $ = idFunc || identity$6,
    list = [],
    ids = {};
  list.add = _ => {
    const id = $(_);
    if (!ids[id]) {
      ids[id] = 1;
      list.push(_);
    }
    return list;
  };
  list.remove = _ => {
    const id = $(_);
    if (ids[id]) {
      ids[id] = 0;
      const idx = list.indexOf(_);
      if (idx >= 0) list.splice(idx, 1);
    }
    return list;
  };
  return list;
}

/**
 * Invoke and await a potentially async callback function. If
 * an error occurs, trap it and route to Dataflow.error.
 * @param {Dataflow} df - The dataflow instance
 * @param {function} callback - A callback function to invoke
 *   and then await. The dataflow will be passed as the single
 *   argument to the function.
 */
async function asyncCallback(df, callback) {
  try {
    await callback(df);
  } catch (err) {
    df.error(err);
  }
}
const TUPLE_ID_KEY = Symbol('vega_id');
let TUPLE_ID = 1;

/**
 * Checks if an input value is a registered tuple.
 * @param {*} t - The value to check.
 * @return {boolean} True if the input is a tuple, false otherwise.
 */
function isTuple(t) {
  return !!(t && tupleid(t));
}

/**
 * Returns the id of a tuple.
 * @param {object} t - The input tuple.
 * @return {*} the tuple id.
 */
function tupleid(t) {
  return t[TUPLE_ID_KEY];
}

/**
 * Sets the id of a tuple.
 * @param {object} t - The input tuple.
 * @param {*} id - The id value to set.
 * @return {object} the input tuple.
 */
function setid(t, id) {
  t[TUPLE_ID_KEY] = id;
  return t;
}

/**
 * Ingest an object or value as a data tuple.
 * If the input value is an object, an id field will be added to it. For
 * efficiency, the input object is modified directly. A copy is not made.
 * If the input value is a literal, it will be wrapped in a new object
 * instance, with the value accessible as the 'data' property.
 * @param datum - The value to ingest.
 * @return {object} The ingested data tuple.
 */
function ingest$1(datum) {
  const t = datum === Object(datum) ? datum : {
    data: datum
  };
  return tupleid(t) ? t : setid(t, TUPLE_ID++);
}

/**
 * Given a source tuple, return a derived copy.
 * @param {object} t - The source tuple.
 * @return {object} The derived tuple.
 */
function derive(t) {
  return rederive(t, ingest$1({}));
}

/**
 * Rederive a derived tuple by copying values from the source tuple.
 * @param {object} t - The source tuple.
 * @param {object} d - The derived tuple.
 * @return {object} The derived tuple.
 */
function rederive(t, d) {
  for (const k in t) d[k] = t[k];
  return d;
}

/**
 * Replace an existing tuple with a new tuple.
 * @param {object} t - The existing data tuple.
 * @param {object} d - The new tuple that replaces the old.
 * @return {object} The new tuple.
 */
function replace$1(t, d) {
  return setid(d, tupleid(t));
}

/**
 * Generate an augmented comparator function that provides stable
 * sorting by tuple id when the given comparator produces ties.
 * @param {function} cmp - The comparator to augment.
 * @param {function} [f] - Optional tuple accessor function.
 * @return {function} An augmented comparator function.
 */
function stableCompare(cmp, f) {
  return !cmp ? null : f ? (a, b) => cmp(a, b) || tupleid(f(a)) - tupleid(f(b)) : (a, b) => cmp(a, b) || tupleid(a) - tupleid(b);
}
function isChangeSet(v) {
  return v && v.constructor === changeset;
}
function changeset() {
  const add = [],
    // insert tuples
    rem = [],
    // remove tuples
    mod = [],
    // modify tuples
    remp = [],
    // remove by predicate
    modp = []; // modify by predicate
  let clean = null,
    reflow = false;
  return {
    constructor: changeset,
    insert(t) {
      const d = array$5(t),
        n = d.length;
      for (let i = 0; i < n; ++i) add.push(d[i]);
      return this;
    },
    remove(t) {
      const a = isFunction(t) ? remp : rem,
        d = array$5(t),
        n = d.length;
      for (let i = 0; i < n; ++i) a.push(d[i]);
      return this;
    },
    modify(t, field, value) {
      const m = {
        field: field,
        value: constant$5(value)
      };
      if (isFunction(t)) {
        m.filter = t;
        modp.push(m);
      } else {
        m.tuple = t;
        mod.push(m);
      }
      return this;
    },
    encode(t, set) {
      if (isFunction(t)) modp.push({
        filter: t,
        field: set
      });else mod.push({
        tuple: t,
        field: set
      });
      return this;
    },
    clean(value) {
      clean = value;
      return this;
    },
    reflow() {
      reflow = true;
      return this;
    },
    pulse(pulse, tuples) {
      const cur = {},
        out = {};
      let i, n, m, f, t, id;

      // build lookup table of current tuples
      for (i = 0, n = tuples.length; i < n; ++i) {
        cur[tupleid(tuples[i])] = 1;
      }

      // process individual tuples to remove
      for (i = 0, n = rem.length; i < n; ++i) {
        t = rem[i];
        cur[tupleid(t)] = -1;
      }

      // process predicate-based removals
      for (i = 0, n = remp.length; i < n; ++i) {
        f = remp[i];
        tuples.forEach(t => {
          if (f(t)) cur[tupleid(t)] = -1;
        });
      }

      // process all add tuples
      for (i = 0, n = add.length; i < n; ++i) {
        t = add[i];
        id = tupleid(t);
        if (cur[id]) {
          // tuple already resides in dataset
          // if flagged for both add and remove, cancel
          cur[id] = 1;
        } else {
          // tuple does not reside in dataset, add
          pulse.add.push(ingest$1(add[i]));
        }
      }

      // populate pulse rem list
      for (i = 0, n = tuples.length; i < n; ++i) {
        t = tuples[i];
        if (cur[tupleid(t)] < 0) pulse.rem.push(t);
      }

      // modify helper method
      function modify(t, f, v) {
        if (v) {
          t[f] = v(t);
        } else {
          pulse.encode = f;
        }
        if (!reflow) out[tupleid(t)] = t;
      }

      // process individual tuples to modify
      for (i = 0, n = mod.length; i < n; ++i) {
        m = mod[i];
        t = m.tuple;
        f = m.field;
        id = cur[tupleid(t)];
        if (id > 0) {
          modify(t, f, m.value);
          pulse.modifies(f);
        }
      }

      // process predicate-based modifications
      for (i = 0, n = modp.length; i < n; ++i) {
        m = modp[i];
        f = m.filter;
        tuples.forEach(t => {
          if (f(t) && cur[tupleid(t)] > 0) {
            modify(t, m.field, m.value);
          }
        });
        pulse.modifies(m.field);
      }

      // upon reflow request, populate mod with all non-removed tuples
      // otherwise, populate mod with modified tuples only
      if (reflow) {
        pulse.mod = rem.length || remp.length ? tuples.filter(t => cur[tupleid(t)] > 0) : tuples.slice();
      } else {
        for (id in out) pulse.mod.push(out[id]);
      }

      // set pulse garbage collection request
      if (clean || clean == null && (rem.length || remp.length)) {
        pulse.clean(true);
      }
      return pulse;
    }
  };
}
const CACHE = '_:mod:_';

/**
 * Hash that tracks modifications to assigned values.
 * Callers *must* use the set method to update values.
 */
function Parameters() {
  Object.defineProperty(this, CACHE, {
    writable: true,
    value: {}
  });
}
Parameters.prototype = {
  /**
   * Set a parameter value. If the parameter value changes, the parameter
   * will be recorded as modified.
   * @param {string} name - The parameter name.
   * @param {number} index - The index into an array-value parameter. Ignored if
   *   the argument is undefined, null or less than zero.
   * @param {*} value - The parameter value to set.
   * @param {boolean} [force=false] - If true, records the parameter as modified
   *   even if the value is unchanged.
   * @return {Parameters} - This parameter object.
   */
  set(name, index, value, force) {
    const o = this,
      v = o[name],
      mod = o[CACHE];
    if (index != null && index >= 0) {
      if (v[index] !== value || force) {
        v[index] = value;
        mod[index + ':' + name] = -1;
        mod[name] = -1;
      }
    } else if (v !== value || force) {
      o[name] = value;
      mod[name] = isArray(value) ? 1 + value.length : -1;
    }
    return o;
  },
  /**
   * Tests if one or more parameters has been modified. If invoked with no
   * arguments, returns true if any parameter value has changed. If the first
   * argument is array, returns trues if any parameter name in the array has
   * changed. Otherwise, tests if the given name and optional array index has
   * changed.
   * @param {string} name - The parameter name to test.
   * @param {number} [index=undefined] - The parameter array index to test.
   * @return {boolean} - Returns true if a queried parameter was modified.
   */
  modified(name, index) {
    const mod = this[CACHE];
    if (!arguments.length) {
      for (const k in mod) {
        if (mod[k]) return true;
      }
      return false;
    } else if (isArray(name)) {
      for (let k = 0; k < name.length; ++k) {
        if (mod[name[k]]) return true;
      }
      return false;
    }
    return index != null && index >= 0 ? index + 1 < mod[name] || !!mod[index + ':' + name] : !!mod[name];
  },
  /**
   * Clears the modification records. After calling this method,
   * all parameters are considered unmodified.
   */
  clear() {
    this[CACHE] = {};
    return this;
  }
};
let OP_ID = 0;
const PULSE = 'pulse',
  NO_PARAMS = new Parameters();

// Boolean Flags
const SKIP$1$1 = 1,
  MODIFIED = 2;

/**
 * An Operator is a processing node in a dataflow graph.
 * Each operator stores a value and an optional value update function.
 * Operators can accept a hash of named parameters. Parameter values can
 * either be direct (JavaScript literals, arrays, objects) or indirect
 * (other operators whose values will be pulled dynamically). Operators
 * included as parameters will have this operator added as a dependency.
 * @constructor
 * @param {*} [init] - The initial value for this operator.
 * @param {function(object, Pulse)} [update] - An update function. Upon
 *   evaluation of this operator, the update function will be invoked and the
 *   return value will be used as the new value of this operator.
 * @param {object} [params] - The parameters for this operator.
 * @param {boolean} [react=true] - Flag indicating if this operator should
 *   listen for changes to upstream operators included as parameters.
 * @see parameters
 */
function Operator(init, update, params, react) {
  this.id = ++OP_ID;
  this.value = init;
  this.stamp = -1;
  this.rank = -1;
  this.qrank = -1;
  this.flags = 0;
  if (update) {
    this._update = update;
  }
  if (params) this.parameters(params, react);
}
function flag(bit) {
  return function (state) {
    const f = this.flags;
    if (arguments.length === 0) return !!(f & bit);
    this.flags = state ? f | bit : f & ~bit;
    return this;
  };
}
Operator.prototype = {
  /**
   * Returns a list of target operators dependent on this operator.
   * If this list does not exist, it is created and then returned.
   * @return {UniqueList}
   */
  targets() {
    return this._targets || (this._targets = UniqueList(id));
  },
  /**
   * Sets the value of this operator.
   * @param {*} value - the value to set.
   * @return {Number} Returns 1 if the operator value has changed
   *   according to strict equality, returns 0 otherwise.
   */
  set(value) {
    if (this.value !== value) {
      this.value = value;
      return 1;
    } else {
      return 0;
    }
  },
  /**
   * Indicates that operator evaluation should be skipped on the next pulse.
   * This operator will still propagate incoming pulses, but its update function
   * will not be invoked. The skip flag is reset after every pulse, so calling
   * this method will affect processing of the next pulse only.
   */
  skip: flag(SKIP$1$1),
  /**
   * Indicates that this operator's value has been modified on its most recent
   * pulse. Normally modification is checked via strict equality; however, in
   * some cases it is more efficient to update the internal state of an object.
   * In those cases, the modified flag can be used to trigger propagation. Once
   * set, the modification flag persists across pulses until unset. The flag can
   * be used with the last timestamp to test if a modification is recent.
   */
  modified: flag(MODIFIED),
  /**
   * Sets the parameters for this operator. The parameter values are analyzed for
   * operator instances. If found, this operator will be added as a dependency
   * of the parameterizing operator. Operator values are dynamically marshalled
   * from each operator parameter prior to evaluation. If a parameter value is
   * an array, the array will also be searched for Operator instances. However,
   * the search does not recurse into sub-arrays or object properties.
   * @param {object} params - A hash of operator parameters.
   * @param {boolean} [react=true] - A flag indicating if this operator should
   *   automatically update (react) when parameter values change. In other words,
   *   this flag determines if the operator registers itself as a listener on
   *   any upstream operators included in the parameters.
   * @param {boolean} [initonly=false] - A flag indicating if this operator
   *   should calculate an update only upon its initial evaluation, then
   *   deregister dependencies and suppress all future update invocations.
   * @return {Operator[]} - An array of upstream dependencies.
   */
  parameters(params, react, initonly) {
    react = react !== false;
    const argval = this._argval = this._argval || new Parameters(),
      argops = this._argops = this._argops || [],
      deps = [];
    let name, value, n, i;
    const add = (name, index, value) => {
      if (value instanceof Operator) {
        if (value !== this) {
          if (react) value.targets().add(this);
          deps.push(value);
        }
        argops.push({
          op: value,
          name: name,
          index: index
        });
      } else {
        argval.set(name, index, value);
      }
    };
    for (name in params) {
      value = params[name];
      if (name === PULSE) {
        array$5(value).forEach(op => {
          if (!(op instanceof Operator)) {
            error('Pulse parameters must be operator instances.');
          } else if (op !== this) {
            op.targets().add(this);
            deps.push(op);
          }
        });
        this.source = value;
      } else if (isArray(value)) {
        argval.set(name, -1, Array(n = value.length));
        for (i = 0; i < n; ++i) add(name, i, value[i]);
      } else {
        add(name, -1, value);
      }
    }
    this.marshall().clear(); // initialize values
    if (initonly) argops.initonly = true;
    return deps;
  },
  /**
   * Internal method for marshalling parameter values.
   * Visits each operator dependency to pull the latest value.
   * @return {Parameters} A Parameters object to pass to the update function.
   */
  marshall(stamp) {
    const argval = this._argval || NO_PARAMS,
      argops = this._argops;
    let item, i, op, mod;
    if (argops) {
      const n = argops.length;
      for (i = 0; i < n; ++i) {
        item = argops[i];
        op = item.op;
        mod = op.modified() && op.stamp === stamp;
        argval.set(item.name, item.index, op.value, mod);
      }
      if (argops.initonly) {
        for (i = 0; i < n; ++i) {
          item = argops[i];
          item.op.targets().remove(this);
        }
        this._argops = null;
        this._update = null;
      }
    }
    return argval;
  },
  /**
   * Detach this operator from the dataflow.
   * Unregisters listeners on upstream dependencies.
   */
  detach() {
    const argops = this._argops;
    let i, n, item, op;
    if (argops) {
      for (i = 0, n = argops.length; i < n; ++i) {
        item = argops[i];
        op = item.op;
        if (op._targets) {
          op._targets.remove(this);
        }
      }
    }

    // remove references to the source and pulse object,
    // if present, to prevent memory leaks of old data.
    this.pulse = null;
    this.source = null;
  },
  /**
   * Delegate method to perform operator processing.
   * Subclasses can override this method to perform custom processing.
   * By default, it marshalls parameters and calls the update function
   * if that function is defined. If the update function does not
   * change the operator value then StopPropagation is returned.
   * If no update function is defined, this method does nothing.
   * @param {Pulse} pulse - the current dataflow pulse.
   * @return The output pulse or StopPropagation. A falsy return value
   *   (including undefined) will let the input pulse pass through.
   */
  evaluate(pulse) {
    const update = this._update;
    if (update) {
      const params = this.marshall(pulse.stamp),
        v = update.call(this, params, pulse);
      params.clear();
      if (v !== this.value) {
        this.value = v;
      } else if (!this.modified()) {
        return pulse.StopPropagation;
      }
    }
  },
  /**
   * Run this operator for the current pulse. If this operator has already
   * been run at (or after) the pulse timestamp, returns StopPropagation.
   * Internally, this method calls {@link evaluate} to perform processing.
   * If {@link evaluate} returns a falsy value, the input pulse is returned.
   * This method should NOT be overridden, instead overrride {@link evaluate}.
   * @param {Pulse} pulse - the current dataflow pulse.
   * @return the output pulse for this operator (or StopPropagation)
   */
  run(pulse) {
    if (pulse.stamp < this.stamp) return pulse.StopPropagation;
    let rv;
    if (this.skip()) {
      this.skip(false);
      rv = 0;
    } else {
      rv = this.evaluate(pulse);
    }
    return this.pulse = rv || pulse;
  }
};

/**
 * Add an operator to the dataflow graph. This function accepts a
 * variety of input argument types. The basic signature supports an
 * initial value, update function and parameters. If the first parameter
 * is an Operator instance, it will be added directly. If it is a
 * constructor for an Operator subclass, a new instance will be instantiated.
 * Otherwise, if the first parameter is a function instance, it will be used
 * as the update function and a null initial value is assumed.
 * @param {*} init - One of: the operator to add, the initial value of
 *   the operator, an operator class to instantiate, or an update function.
 * @param {function} [update] - The operator update function.
 * @param {object} [params] - The operator parameters.
 * @param {boolean} [react=true] - Flag indicating if this operator should
 *   listen for changes to upstream operators included as parameters.
 * @return {Operator} - The added operator.
 */
function add$3(init, update, params, react) {
  let shift = 1,
    op;
  if (init instanceof Operator) {
    op = init;
  } else if (init && init.prototype instanceof Operator) {
    op = new init();
  } else if (isFunction(init)) {
    op = new Operator(null, init);
  } else {
    shift = 0;
    op = new Operator(init, update);
  }
  this.rank(op);
  if (shift) {
    react = params;
    params = update;
  }
  if (params) this.connect(op, op.parameters(params, react));
  this.touch(op);
  return op;
}

/**
 * Connect a target operator as a dependent of source operators.
 * If necessary, this method will rerank the target operator and its
 * dependents to ensure propagation proceeds in a topologically sorted order.
 * @param {Operator} target - The target operator.
 * @param {Array<Operator>} - The source operators that should propagate
 *   to the target operator.
 */
function connect(target, sources) {
  const targetRank = target.rank,
    n = sources.length;
  for (let i = 0; i < n; ++i) {
    if (targetRank < sources[i].rank) {
      this.rerank(target);
      return;
    }
  }
}
let STREAM_ID = 0;

/**
 * Models an event stream.
 * @constructor
 * @param {function(Object, number): boolean} [filter] - Filter predicate.
 *   Events pass through when truthy, events are suppressed when falsy.
 * @param {function(Object): *} [apply] - Applied to input events to produce
 *   new event values.
 * @param {function(Object)} [receive] - Event callback function to invoke
 *   upon receipt of a new event. Use to override standard event processing.
 */
function EventStream(filter, apply, receive) {
  this.id = ++STREAM_ID;
  this.value = null;
  if (receive) this.receive = receive;
  if (filter) this._filter = filter;
  if (apply) this._apply = apply;
}

/**
 * Creates a new event stream instance with the provided
 * (optional) filter, apply and receive functions.
 * @param {function(Object, number): boolean} [filter] - Filter predicate.
 *   Events pass through when truthy, events are suppressed when falsy.
 * @param {function(Object): *} [apply] - Applied to input events to produce
 *   new event values.
 * @see EventStream
 */
function stream(filter, apply, receive) {
  return new EventStream(filter, apply, receive);
}
EventStream.prototype = {
  _filter: truthy,
  _apply: identity$6,
  targets() {
    return this._targets || (this._targets = UniqueList(id));
  },
  consume(_) {
    if (!arguments.length) return !!this._consume;
    this._consume = !!_;
    return this;
  },
  receive(evt) {
    if (this._filter(evt)) {
      const val = this.value = this._apply(evt),
        trg = this._targets,
        n = trg ? trg.length : 0;
      for (let i = 0; i < n; ++i) trg[i].receive(val);
      if (this._consume) {
        evt.preventDefault();
        evt.stopPropagation();
      }
    }
  },
  filter(filter) {
    const s = stream(filter);
    this.targets().add(s);
    return s;
  },
  apply(apply) {
    const s = stream(null, apply);
    this.targets().add(s);
    return s;
  },
  merge() {
    const s = stream();
    this.targets().add(s);
    for (let i = 0, n = arguments.length; i < n; ++i) {
      arguments[i].targets().add(s);
    }
    return s;
  },
  throttle(pause) {
    let t = -1;
    return this.filter(() => {
      const now = Date.now();
      if (now - t > pause) {
        t = now;
        return 1;
      } else {
        return 0;
      }
    });
  },
  debounce(delay) {
    const s = stream();
    this.targets().add(stream(null, null, debounce(delay, e => {
      const df = e.dataflow;
      s.receive(e);
      if (df && df.run) df.run();
    })));
    return s;
  },
  between(a, b) {
    let active = false;
    a.targets().add(stream(null, null, () => active = true));
    b.targets().add(stream(null, null, () => active = false));
    return this.filter(() => active);
  },
  detach() {
    // ensures compatibility with operators (#2753)
    // remove references to other streams and filter functions that may
    // be bound to subcontexts that need to be garbage collected.
    this._filter = truthy;
    this._targets = null;
  }
};

/**
 * Create a new event stream from an event source.
 * @param {object} source - The event source to monitor. The input must
 *  support the addEventListener method.
 * @param {string} type - The event type.
 * @param {function(object): boolean} [filter] - Event filter function.
 * @param {function(object): *} [apply] - Event application function.
 *   If provided, this function will be invoked and the result will be
 *   used as the downstream event value.
 * @return {EventStream}
 */
function events$1(source, type, filter, apply) {
  const df = this,
    s = stream(filter, apply),
    send = function (e) {
      e.dataflow = df;
      try {
        s.receive(e);
      } catch (error) {
        df.error(error);
      } finally {
        df.run();
      }
    };
  let sources;
  if (typeof source === 'string' && typeof document !== 'undefined') {
    sources = document.querySelectorAll(source);
  } else {
    sources = array$5(source);
  }
  const n = sources.length;
  for (let i = 0; i < n; ++i) {
    sources[i].addEventListener(type, send);
  }
  return s;
}
function parse$5(data, format) {
  const locale = this.locale();
  return read(data, format, locale.timeParse, locale.utcParse);
}

/**
 * Ingests new data into the dataflow. First parses the data using the
 * vega-loader read method, then pulses a changeset to the target operator.
 * @param {Operator} target - The Operator to target with ingested data,
 *   typically a Collect transform instance.
 * @param {*} data - The input data, prior to parsing. For JSON this may
 *   be a string or an object. For CSV, TSV, etc should be a string.
 * @param {object} format - The data format description for parsing
 *   loaded data. This object is passed to the vega-loader read method.
 * @returns {Dataflow}
 */
function ingest(target, data, format) {
  data = this.parse(data, format);
  return this.pulse(target, this.changeset().insert(data));
}

/**
 * Request data from an external source, parse it, and return a Promise.
 * @param {string} url - The URL from which to load the data. This string
 *   is passed to the vega-loader load method.
 * @param {object} [format] - The data format description for parsing
 *   loaded data. This object is passed to the vega-loader read method.
 * @return {Promise} A Promise that resolves upon completion of the request.
 *   The resolved object contains the following properties:
 *   - data: an array of parsed data (or null upon error)
 *   - status: a code for success (0), load fail (-1), or parse fail (-2)
 */
async function request(url, format) {
  const df = this;
  let status = 0,
    data;
  try {
    data = await df.loader().load(url, {
      context: 'dataflow',
      response: responseType(format && format.type)
    });
    try {
      data = df.parse(data, format);
    } catch (err) {
      status = -2;
      df.warn('Data ingestion failed', url, err);
    }
  } catch (err) {
    status = -1;
    df.warn('Loading failed', url, err);
  }
  return {
    data,
    status
  };
}
async function preload(target, url, format) {
  const df = this,
    pending = df._pending || loadPending(df);
  pending.requests += 1;
  const res = await df.request(url, format);
  df.pulse(target, df.changeset().remove(truthy).insert(res.data || []));
  pending.done();
  return res;
}
function loadPending(df) {
  let accept;
  const pending = new Promise(a => accept = a);
  pending.requests = 0;
  pending.done = () => {
    if (--pending.requests === 0) {
      df._pending = null;
      accept(df);
    }
  };
  return df._pending = pending;
}
const SKIP$2 = {
  skip: true
};

/**
 * Perform operator updates in response to events. Applies an
 * update function to compute a new operator value. If the update function
 * returns a {@link ChangeSet}, the operator will be pulsed with those tuple
 * changes. Otherwise, the operator value will be updated to the return value.
 * @param {EventStream|Operator} source - The event source to react to.
 *   This argument can be either an EventStream or an Operator.
 * @param {Operator|function(object):Operator} target - The operator to update.
 *   This argument can either be an Operator instance or (if the source
 *   argument is an EventStream), a function that accepts an event object as
 *   input and returns an Operator to target.
 * @param {function(Parameters,Event): *} [update] - Optional update function
 *   to compute the new operator value, or a literal value to set. Update
 *   functions expect to receive a parameter object and event as arguments.
 *   This function can either return a new operator value or (if the source
 *   argument is an EventStream) a {@link ChangeSet} instance to pulse
 *   the target operator with tuple changes.
 * @param {object} [params] - The update function parameters.
 * @param {object} [options] - Additional options hash. If not overridden,
 *   updated operators will be skipped by default.
 * @param {boolean} [options.skip] - If true, the operator will
 *  be skipped: it will not be evaluated, but its dependents will be.
 * @param {boolean} [options.force] - If true, the operator will
 *   be re-evaluated even if its value has not changed.
 * @return {Dataflow}
 */
function on(source, target, update, params, options) {
  const fn = source instanceof Operator ? onOperator : onStream;
  fn(this, source, target, update, params, options);
  return this;
}
function onStream(df, stream, target, update, params, options) {
  const opt = extend$1({}, options, SKIP$2);
  let func, op;
  if (!isFunction(target)) target = constant$5(target);
  if (update === undefined) {
    func = e => df.touch(target(e));
  } else if (isFunction(update)) {
    op = new Operator(null, update, params, false);
    func = e => {
      op.evaluate(e);
      const t = target(e),
        v = op.value;
      isChangeSet(v) ? df.pulse(t, v, options) : df.update(t, v, opt);
    };
  } else {
    func = e => df.update(target(e), update, opt);
  }
  stream.apply(func);
}
function onOperator(df, source, target, update, params, options) {
  if (update === undefined) {
    source.targets().add(target);
  } else {
    const opt = options || {},
      op = new Operator(null, updater(target, update), params, false);
    op.modified(opt.force);
    op.rank = source.rank; // immediately follow source
    source.targets().add(op); // add dependency

    if (target) {
      op.skip(true); // skip first invocation
      op.value = target.value; // initialize value
      op.targets().add(target); // chain dependencies
      df.connect(target, [op]); // rerank as needed, #1672
    }
  }
}
function updater(target, update) {
  update = isFunction(update) ? update : constant$5(update);
  return target ? function (_, pulse) {
    const value = update(_, pulse);
    if (!target.skip()) {
      target.skip(value !== this.value).value = value;
    }
    return value;
  } : update;
}

/**
 * Assigns a rank to an operator. Ranks are assigned in increasing order
 * by incrementing an internal rank counter.
 * @param {Operator} op - The operator to assign a rank.
 */
function rank(op) {
  op.rank = ++this._rank;
}

/**
 * Re-ranks an operator and all downstream target dependencies. This
 * is necessary when upstream dependencies of higher rank are added to
 * a target operator.
 * @param {Operator} op - The operator to re-rank.
 */
function rerank(op) {
  const queue = [op];
  let cur, list, i;
  while (queue.length) {
    this.rank(cur = queue.pop());
    if (list = cur._targets) {
      for (i = list.length; --i >= 0;) {
        queue.push(cur = list[i]);
        if (cur === op) error('Cycle detected in dataflow graph.');
      }
    }
  }
}

/**
 * Sentinel value indicating pulse propagation should stop.
 */
const StopPropagation = {};

// Pulse visit type flags
const ADD = 1 << 0,
  REM = 1 << 1,
  MOD$1 = 1 << 2,
  ADD_REM = ADD | REM,
  ADD_MOD = ADD | MOD$1,
  ALL = ADD | REM | MOD$1,
  REFLOW = 1 << 3,
  SOURCE = 1 << 4,
  NO_SOURCE = 1 << 5,
  NO_FIELDS = 1 << 6;

/**
 * A Pulse enables inter-operator communication during a run of the
 * dataflow graph. In addition to the current timestamp, a pulse may also
 * contain a change-set of added, removed or modified data tuples, as well as
 * a pointer to a full backing data source. Tuple change sets may not
 * be fully materialized; for example, to prevent needless array creation
 * a change set may include larger arrays and corresponding filter functions.
 * The pulse provides a {@link visit} method to enable proper and efficient
 * iteration over requested data tuples.
 *
 * In addition, each pulse can track modification flags for data tuple fields.
 * Responsible transform operators should call the {@link modifies} method to
 * indicate changes to data fields. The {@link modified} method enables
 * querying of this modification state.
 *
 * @constructor
 * @param {Dataflow} dataflow - The backing dataflow instance.
 * @param {number} stamp - The current propagation timestamp.
 * @param {string} [encode] - An optional encoding set name, which is then
 *   accessible as Pulse.encode. Operators can respond to (or ignore) this
 *   setting as appropriate. This parameter can be used in conjunction with
 *   the Encode transform in the vega-encode module.
 */
function Pulse(dataflow, stamp, encode) {
  this.dataflow = dataflow;
  this.stamp = stamp == null ? -1 : stamp;
  this.add = [];
  this.rem = [];
  this.mod = [];
  this.fields = null;
  this.encode = encode || null;
}
function materialize(data, filter) {
  const out = [];
  visitArray(data, filter, _ => out.push(_));
  return out;
}
function filter$1(pulse, flags) {
  const map = {};
  pulse.visit(flags, t => {
    map[tupleid(t)] = 1;
  });
  return t => map[tupleid(t)] ? null : t;
}
function addFilter(a, b) {
  return a ? (t, i) => a(t, i) && b(t, i) : b;
}
Pulse.prototype = {
  /**
   * Sentinel value indicating pulse propagation should stop.
   */
  StopPropagation,
  /**
   * Boolean flag indicating ADD (added) tuples.
   */
  ADD,
  /**
   * Boolean flag indicating REM (removed) tuples.
   */
  REM,
  /**
   * Boolean flag indicating MOD (modified) tuples.
   */
  MOD: MOD$1,
  /**
   * Boolean flag indicating ADD (added) and REM (removed) tuples.
   */
  ADD_REM,
  /**
   * Boolean flag indicating ADD (added) and MOD (modified) tuples.
   */
  ADD_MOD,
  /**
   * Boolean flag indicating ADD, REM and MOD tuples.
   */
  ALL,
  /**
   * Boolean flag indicating all tuples in a data source
   * except for the ADD, REM and MOD tuples.
   */
  REFLOW,
  /**
   * Boolean flag indicating a 'pass-through' to a
   * backing data source, ignoring ADD, REM and MOD tuples.
   */
  SOURCE,
  /**
   * Boolean flag indicating that source data should be
   * suppressed when creating a forked pulse.
   */
  NO_SOURCE,
  /**
   * Boolean flag indicating that field modifications should be
   * suppressed when creating a forked pulse.
   */
  NO_FIELDS,
  /**
   * Creates a new pulse based on the values of this pulse.
   * The dataflow, time stamp and field modification values are copied over.
   * By default, new empty ADD, REM and MOD arrays are created.
   * @param {number} flags - Integer of boolean flags indicating which (if any)
   *   tuple arrays should be copied to the new pulse. The supported flag values
   *   are ADD, REM and MOD. Array references are copied directly: new array
   *   instances are not created.
   * @return {Pulse} - The forked pulse instance.
   * @see init
   */
  fork(flags) {
    return new Pulse(this.dataflow).init(this, flags);
  },
  /**
   * Creates a copy of this pulse with new materialized array
   * instances for the ADD, REM, MOD, and SOURCE arrays.
   * The dataflow, time stamp and field modification values are copied over.
   * @return {Pulse} - The cloned pulse instance.
   * @see init
   */
  clone() {
    const p = this.fork(ALL);
    p.add = p.add.slice();
    p.rem = p.rem.slice();
    p.mod = p.mod.slice();
    if (p.source) p.source = p.source.slice();
    return p.materialize(ALL | SOURCE);
  },
  /**
   * Returns a pulse that adds all tuples from a backing source. This is
   * useful for cases where operators are added to a dataflow after an
   * upstream data pipeline has already been processed, ensuring that
   * new operators can observe all tuples within a stream.
   * @return {Pulse} - A pulse instance with all source tuples included
   *   in the add array. If the current pulse already has all source
   *   tuples in its add array, it is returned directly. If the current
   *   pulse does not have a backing source, it is returned directly.
   */
  addAll() {
    let p = this;
    const reuse = !p.source || p.add === p.rem // special case for indexed set (e.g., crossfilter)
    || !p.rem.length && p.source.length === p.add.length;
    if (reuse) {
      return p;
    } else {
      p = new Pulse(this.dataflow).init(this);
      p.add = p.source;
      p.rem = []; // new operators can ignore rem #2769
      return p;
    }
  },
  /**
   * Initialize this pulse based on the values of another pulse. This method
   * is used internally by {@link fork} to initialize a new forked tuple.
   * The dataflow, time stamp and field modification values are copied over.
   * By default, new empty ADD, REM and MOD arrays are created.
   * @param {Pulse} src - The source pulse to copy from.
   * @param {number} flags - Integer of boolean flags indicating which (if any)
   *   tuple arrays should be copied to the new pulse. The supported flag values
   *   are ADD, REM and MOD. Array references are copied directly: new array
   *   instances are not created. By default, source data arrays are copied
   *   to the new pulse. Use the NO_SOURCE flag to enforce a null source.
   * @return {Pulse} - Returns this Pulse instance.
   */
  init(src, flags) {
    const p = this;
    p.stamp = src.stamp;
    p.encode = src.encode;
    if (src.fields && !(flags & NO_FIELDS)) {
      p.fields = src.fields;
    }
    if (flags & ADD) {
      p.addF = src.addF;
      p.add = src.add;
    } else {
      p.addF = null;
      p.add = [];
    }
    if (flags & REM) {
      p.remF = src.remF;
      p.rem = src.rem;
    } else {
      p.remF = null;
      p.rem = [];
    }
    if (flags & MOD$1) {
      p.modF = src.modF;
      p.mod = src.mod;
    } else {
      p.modF = null;
      p.mod = [];
    }
    if (flags & NO_SOURCE) {
      p.srcF = null;
      p.source = null;
    } else {
      p.srcF = src.srcF;
      p.source = src.source;
      if (src.cleans) p.cleans = src.cleans;
    }
    return p;
  },
  /**
   * Schedules a function to run after pulse propagation completes.
   * @param {function} func - The function to run.
   */
  runAfter(func) {
    this.dataflow.runAfter(func);
  },
  /**
   * Indicates if tuples have been added, removed or modified.
   * @param {number} [flags] - The tuple types (ADD, REM or MOD) to query.
   *   Defaults to ALL, returning true if any tuple type has changed.
   * @return {boolean} - Returns true if one or more queried tuple types have
   *   changed, false otherwise.
   */
  changed(flags) {
    const f = flags || ALL;
    return f & ADD && this.add.length || f & REM && this.rem.length || f & MOD$1 && this.mod.length;
  },
  /**
   * Forces a "reflow" of tuple values, such that all tuples in the backing
   * source are added to the MOD set, unless already present in the ADD set.
   * @param {boolean} [fork=false] - If true, returns a forked copy of this
   *   pulse, and invokes reflow on that derived pulse.
   * @return {Pulse} - The reflowed pulse instance.
   */
  reflow(fork) {
    if (fork) return this.fork(ALL).reflow();
    const len = this.add.length,
      src = this.source && this.source.length;
    if (src && src !== len) {
      this.mod = this.source;
      if (len) this.filter(MOD$1, filter$1(this, ADD));
    }
    return this;
  },
  /**
   * Get/set metadata to pulse requesting garbage collection
   * to reclaim currently unused resources.
   */
  clean(value) {
    if (arguments.length) {
      this.cleans = !!value;
      return this;
    } else {
      return this.cleans;
    }
  },
  /**
   * Marks one or more data field names as modified to assist dependency
   * tracking and incremental processing by transform operators.
   * @param {string|Array<string>} _ - The field(s) to mark as modified.
   * @return {Pulse} - This pulse instance.
   */
  modifies(_) {
    const hash = this.fields || (this.fields = {});
    if (isArray(_)) {
      _.forEach(f => hash[f] = true);
    } else {
      hash[_] = true;
    }
    return this;
  },
  /**
   * Checks if one or more data fields have been modified during this pulse
   * propagation timestamp.
   * @param {string|Array<string>} _ - The field(s) to check for modified.
   * @param {boolean} nomod - If true, will check the modified flag even if
   *   no mod tuples exist. If false (default), mod tuples must be present.
   * @return {boolean} - Returns true if any of the provided fields has been
   *   marked as modified, false otherwise.
   */
  modified(_, nomod) {
    const fields = this.fields;
    return !((nomod || this.mod.length) && fields) ? false : !arguments.length ? !!fields : isArray(_) ? _.some(f => fields[f]) : fields[_];
  },
  /**
   * Adds a filter function to one more tuple sets. Filters are applied to
   * backing tuple arrays, to determine the actual set of tuples considered
   * added, removed or modified. They can be used to delay materialization of
   * a tuple set in order to avoid expensive array copies. In addition, the
   * filter functions can serve as value transformers: unlike standard predicate
   * function (which return boolean values), Pulse filters should return the
   * actual tuple value to process. If a tuple set is already filtered, the
   * new filter function will be appended into a conjuntive ('and') query.
   * @param {number} flags - Flags indicating the tuple set(s) to filter.
   * @param {function(*):object} filter - Filter function that will be applied
   *   to the tuple set array, and should return a data tuple if the value
   *   should be included in the tuple set, and falsy (or null) otherwise.
   * @return {Pulse} - Returns this pulse instance.
   */
  filter(flags, filter) {
    const p = this;
    if (flags & ADD) p.addF = addFilter(p.addF, filter);
    if (flags & REM) p.remF = addFilter(p.remF, filter);
    if (flags & MOD$1) p.modF = addFilter(p.modF, filter);
    if (flags & SOURCE) p.srcF = addFilter(p.srcF, filter);
    return p;
  },
  /**
   * Materialize one or more tuple sets in this pulse. If the tuple set(s) have
   * a registered filter function, it will be applied and the tuple set(s) will
   * be replaced with materialized tuple arrays.
   * @param {number} flags - Flags indicating the tuple set(s) to materialize.
   * @return {Pulse} - Returns this pulse instance.
   */
  materialize(flags) {
    flags = flags || ALL;
    const p = this;
    if (flags & ADD && p.addF) {
      p.add = materialize(p.add, p.addF);
      p.addF = null;
    }
    if (flags & REM && p.remF) {
      p.rem = materialize(p.rem, p.remF);
      p.remF = null;
    }
    if (flags & MOD$1 && p.modF) {
      p.mod = materialize(p.mod, p.modF);
      p.modF = null;
    }
    if (flags & SOURCE && p.srcF) {
      p.source = p.source.filter(p.srcF);
      p.srcF = null;
    }
    return p;
  },
  /**
   * Visit one or more tuple sets in this pulse.
   * @param {number} flags - Flags indicating the tuple set(s) to visit.
   *   Legal values are ADD, REM, MOD and SOURCE (if a backing data source
   *   has been set).
   * @param {function(object):*} - Visitor function invoked per-tuple.
   * @return {Pulse} - Returns this pulse instance.
   */
  visit(flags, visitor) {
    const p = this,
      v = visitor;
    if (flags & SOURCE) {
      visitArray(p.source, p.srcF, v);
      return p;
    }
    if (flags & ADD) visitArray(p.add, p.addF, v);
    if (flags & REM) visitArray(p.rem, p.remF, v);
    if (flags & MOD$1) visitArray(p.mod, p.modF, v);
    const src = p.source;
    if (flags & REFLOW && src) {
      const sum = p.add.length + p.mod.length;
      if (sum === src.length) ;else if (sum) {
        visitArray(src, filter$1(p, ADD_MOD), v);
      } else {
        // if no add/rem/mod tuples, visit source
        visitArray(src, p.srcF, v);
      }
    }
    return p;
  }
};

/**
 * Represents a set of multiple pulses. Used as input for operators
 * that accept multiple pulses at a time. Contained pulses are
 * accessible via the public "pulses" array property. This pulse doe
 * not carry added, removed or modified tuples directly. However,
 * the visit method can be used to traverse all such tuples contained
 * in sub-pulses with a timestamp matching this parent multi-pulse.
 * @constructor
 * @param {Dataflow} dataflow - The backing dataflow instance.
 * @param {number} stamp - The timestamp.
 * @param {Array<Pulse>} pulses - The sub-pulses for this multi-pulse.
 */
function MultiPulse(dataflow, stamp, pulses, encode) {
  const p = this;
  let c = 0;
  this.dataflow = dataflow;
  this.stamp = stamp;
  this.fields = null;
  this.encode = encode || null;
  this.pulses = pulses;
  for (const pulse of pulses) {
    if (pulse.stamp !== stamp) continue;
    if (pulse.fields) {
      const hash = p.fields || (p.fields = {});
      for (const f in pulse.fields) {
        hash[f] = 1;
      }
    }
    if (pulse.changed(p.ADD)) c |= p.ADD;
    if (pulse.changed(p.REM)) c |= p.REM;
    if (pulse.changed(p.MOD)) c |= p.MOD;
  }
  this.changes = c;
}
inherits(MultiPulse, Pulse, {
  /**
   * Creates a new pulse based on the values of this pulse.
   * The dataflow, time stamp and field modification values are copied over.
   * @return {Pulse}
   */
  fork(flags) {
    const p = new Pulse(this.dataflow).init(this, flags & this.NO_FIELDS);
    if (flags !== undefined) {
      if (flags & p.ADD) this.visit(p.ADD, t => p.add.push(t));
      if (flags & p.REM) this.visit(p.REM, t => p.rem.push(t));
      if (flags & p.MOD) this.visit(p.MOD, t => p.mod.push(t));
    }
    return p;
  },
  changed(flags) {
    return this.changes & flags;
  },
  modified(_) {
    const p = this,
      fields = p.fields;
    return !(fields && p.changes & p.MOD) ? 0 : isArray(_) ? _.some(f => fields[f]) : fields[_];
  },
  filter() {
    error('MultiPulse does not support filtering.');
  },
  materialize() {
    error('MultiPulse does not support materialization.');
  },
  visit(flags, visitor) {
    const p = this,
      pulses = p.pulses,
      n = pulses.length;
    let i = 0;
    if (flags & p.SOURCE) {
      for (; i < n; ++i) {
        pulses[i].visit(flags, visitor);
      }
    } else {
      for (; i < n; ++i) {
        if (pulses[i].stamp === p.stamp) {
          pulses[i].visit(flags, visitor);
        }
      }
    }
    return p;
  }
});

/* eslint-disable require-atomic-updates */

/**
 * Evaluates the dataflow and returns a Promise that resolves when pulse
 * propagation completes. This method will increment the current timestamp
 * and process all updated, pulsed and touched operators. When invoked for
 * the first time, all registered operators will be processed. This method
 * should not be invoked by third-party clients, use {@link runAsync} or
 * {@link run} instead.
 * @param {string} [encode] - The name of an encoding set to invoke during
 *   propagation. This value is added to generated Pulse instances;
 *   operators can then respond to (or ignore) this setting as appropriate.
 *   This parameter can be used in conjunction with the Encode transform in
 *   the vega-encode package.
 * @param {function} [prerun] - An optional callback function to invoke
 *   immediately before dataflow evaluation commences.
 * @param {function} [postrun] - An optional callback function to invoke
 *   after dataflow evaluation completes. The callback will be invoked
 *   after those registered via {@link runAfter}.
 * @return {Promise} - A promise that resolves to this dataflow after
 *   evaluation completes.
 */
async function evaluate(encode, prerun, postrun) {
  const df = this,
    async = [];

  // if the pulse value is set, this is a re-entrant call
  if (df._pulse) return reentrant(df);

  // wait for pending datasets to load
  if (df._pending) await df._pending;

  // invoke prerun function, if provided
  if (prerun) await asyncCallback(df, prerun);

  // exit early if there are no updates
  if (!df._touched.length) {
    df.debug('Dataflow invoked, but nothing to do.');
    return df;
  }

  // increment timestamp clock
  const stamp = ++df._clock;

  // set the current pulse
  df._pulse = new Pulse(df, stamp, encode);

  // initialize priority queue, reset touched operators
  df._touched.forEach(op => df._enqueue(op, true));
  df._touched = UniqueList(id);
  let count = 0,
    op,
    next,
    error;
  try {
    while (df._heap.size() > 0) {
      // dequeue operator with highest priority
      op = df._heap.pop();

      // re-queue if rank changed
      if (op.rank !== op.qrank) {
        df._enqueue(op, true);
        continue;
      }

      // otherwise, evaluate the operator
      next = op.run(df._getPulse(op, encode));
      if (next.then) {
        // await if operator returns a promise directly
        next = await next;
      } else if (next.async) {
        // queue parallel asynchronous execution
        async.push(next.async);
        next = StopPropagation;
      }

      // propagate evaluation, enqueue dependent operators
      if (next !== StopPropagation) {
        if (op._targets) op._targets.forEach(op => df._enqueue(op));
      }

      // increment visit counter
      ++count;
    }
  } catch (err) {
    df._heap.clear();
    error = err;
  }

  // reset pulse map
  df._input = {};
  df._pulse = null;
  df.debug(`Pulse ${stamp}: ${count} operators`);
  if (error) {
    df._postrun = [];
    df.error(error);
  }

  // invoke callbacks queued via runAfter
  if (df._postrun.length) {
    const pr = df._postrun.sort((a, b) => b.priority - a.priority);
    df._postrun = [];
    for (let i = 0; i < pr.length; ++i) {
      await asyncCallback(df, pr[i].callback);
    }
  }

  // invoke postrun function, if provided
  if (postrun) await asyncCallback(df, postrun);

  // handle non-blocking asynchronous callbacks
  if (async.length) {
    Promise.all(async).then(cb => df.runAsync(null, () => {
      cb.forEach(f => {
        try {
          f(df);
        } catch (err) {
          df.error(err);
        }
      });
    }));
  }
  return df;
}

/**
 * Queues dataflow evaluation to run once any other queued evaluations have
 * completed and returns a Promise that resolves when the queued pulse
 * propagation completes. If provided, a callback function will be invoked
 * immediately before evaluation commences. This method will ensure a
 * separate evaluation is invoked for each time it is called.
 * @param {string} [encode] - The name of an encoding set to invoke during
 *   propagation. This value is added to generated Pulse instances;
 *   operators can then respond to (or ignore) this setting as appropriate.
 *   This parameter can be used in conjunction with the Encode transform in
 *   the vega-encode package.
 * @param {function} [prerun] - An optional callback function to invoke
 *   immediately before dataflow evaluation commences.
 * @param {function} [postrun] - An optional callback function to invoke
 *   after dataflow evaluation completes. The callback will be invoked
 *   after those registered via {@link runAfter}.
 * @return {Promise} - A promise that resolves to this dataflow after
 *   evaluation completes.
 */
async function runAsync(encode, prerun, postrun) {
  // await previously queued functions
  while (this._running) await this._running;

  // run dataflow, manage running promise
  const clear = () => this._running = null;
  (this._running = this.evaluate(encode, prerun, postrun)).then(clear, clear);
  return this._running;
}

/**
 * Requests dataflow evaluation and the immediately returns this dataflow
 * instance. If there are pending data loading or other asynchronous
 * operations, the dataflow will evaluate asynchronously after this method
 * has been invoked. To track when dataflow evaluation completes, use the
 * {@link runAsync} method instead. This method will raise an error if
 * invoked while the dataflow is already in the midst of evaluation.
 * @param {string} [encode] - The name of an encoding set to invoke during
 *   propagation. This value is added to generated Pulse instances;
 *   operators can then respond to (or ignore) this setting as appropriate.
 *   This parameter can be used in conjunction with the Encode transform in
 *   the vega-encode module.
 * @param {function} [prerun] - An optional callback function to invoke
 *   immediately before dataflow evaluation commences.
 * @param {function} [postrun] - An optional callback function to invoke
 *   after dataflow evaluation completes. The callback will be invoked
 *   after those registered via {@link runAfter}.
 * @return {Dataflow} - This dataflow instance.
 */
function run(encode, prerun, postrun) {
  return this._pulse ? reentrant(this) : (this.evaluate(encode, prerun, postrun), this);
}

/**
 * Schedules a callback function to be invoked after the current pulse
 * propagation completes. If no propagation is currently occurring,
 * the function is invoked immediately. Callbacks scheduled via runAfter
 * are invoked immediately upon completion of the current cycle, before
 * any request queued via runAsync. This method is primarily intended for
 * internal use. Third-party callers using runAfter to schedule a callback
 * that invokes {@link run} or {@link runAsync} should not use this method,
 * but instead use {@link runAsync} with prerun or postrun arguments.
 * @param {function(Dataflow)} callback - The callback function to run.
 *   The callback will be invoked with this Dataflow instance as its
 *   sole argument.
 * @param {boolean} enqueue - A boolean flag indicating that the
 *   callback should be queued up to run after the next propagation
 *   cycle, suppressing immediate invocation when propagation is not
 *   currently occurring.
 * @param {number} [priority] - A priority value used to sort registered
 *   callbacks to determine execution order. This argument is intended
 *   for internal Vega use only.
 */
function runAfter(callback, enqueue, priority) {
  if (this._pulse || enqueue) {
    // pulse propagation is currently running, queue to run after
    this._postrun.push({
      priority: priority || 0,
      callback: callback
    });
  } else {
    // pulse propagation already complete, invoke immediately
    try {
      callback(this);
    } catch (err) {
      this.error(err);
    }
  }
}

/**
 * Raise an error for re-entrant dataflow evaluation.
 */
function reentrant(df) {
  df.error('Dataflow already running. Use runAsync() to chain invocations.');
  return df;
}

/**
 * Enqueue an operator into the priority queue for evaluation. The operator
 * will be enqueued if it has no registered pulse for the current cycle, or if
 * the force argument is true. Upon enqueue, this method also sets the
 * operator's qrank to the current rank value.
 * @param {Operator} op - The operator to enqueue.
 * @param {boolean} [force] - A flag indicating if the operator should be
 *   forceably added to the queue, even if it has already been previously
 *   enqueued during the current pulse propagation. This is useful when the
 *   dataflow graph is dynamically modified and the operator rank changes.
 */
function enqueue(op, force) {
  const q = op.stamp < this._clock;
  if (q) op.stamp = this._clock;
  if (q || force) {
    op.qrank = op.rank;
    this._heap.push(op);
  }
}

/**
 * Provide a correct pulse for evaluating an operator. If the operator has an
 * explicit source operator, we will try to pull the pulse(s) from it.
 * If there is an array of source operators, we build a multi-pulse.
 * Otherwise, we return a current pulse with correct source data.
 * If the pulse is the pulse map has an explicit target set, we use that.
 * Else if the pulse on the upstream source operator is current, we use that.
 * Else we use the pulse from the pulse map, but copy the source tuple array.
 * @param {Operator} op - The operator for which to get an input pulse.
 * @param {string} [encode] - An (optional) encoding set name with which to
 *   annotate the returned pulse. See {@link run} for more information.
 */
function getPulse(op, encode) {
  const s = op.source,
    stamp = this._clock;
  return s && isArray(s) ? new MultiPulse(this, stamp, s.map(_ => _.pulse), encode) : this._input[op.id] || singlePulse(this._pulse, s && s.pulse);
}
function singlePulse(p, s) {
  if (s && s.stamp === p.stamp) {
    return s;
  }
  p = p.fork();
  if (s && s !== StopPropagation) {
    p.source = s.source;
  }
  return p;
}
const NO_OPT = {
  skip: false,
  force: false
};

/**
 * Touches an operator, scheduling it to be evaluated. If invoked outside of
 * a pulse propagation, the operator will be evaluated the next time this
 * dataflow is run. If invoked in the midst of pulse propagation, the operator
 * will be queued for evaluation if and only if the operator has not yet been
 * evaluated on the current propagation timestamp.
 * @param {Operator} op - The operator to touch.
 * @param {object} [options] - Additional options hash.
 * @param {boolean} [options.skip] - If true, the operator will
 *   be skipped: it will not be evaluated, but its dependents will be.
 * @return {Dataflow}
 */
function touch(op, options) {
  const opt = options || NO_OPT;
  if (this._pulse) {
    // if in midst of propagation, add to priority queue
    this._enqueue(op);
  } else {
    // otherwise, queue for next propagation
    this._touched.add(op);
  }
  if (opt.skip) op.skip(true);
  return this;
}

/**
 * Updates the value of the given operator.
 * @param {Operator} op - The operator to update.
 * @param {*} value - The value to set.
 * @param {object} [options] - Additional options hash.
 * @param {boolean} [options.force] - If true, the operator will
 *   be re-evaluated even if its value has not changed.
 * @param {boolean} [options.skip] - If true, the operator will
 *   be skipped: it will not be evaluated, but its dependents will be.
 * @return {Dataflow}
 */
function update$6(op, value, options) {
  const opt = options || NO_OPT;
  if (op.set(value) || opt.force) {
    this.touch(op, opt);
  }
  return this;
}

/**
 * Pulses an operator with a changeset of tuples. If invoked outside of
 * a pulse propagation, the pulse will be applied the next time this
 * dataflow is run. If invoked in the midst of pulse propagation, the pulse
 * will be added to the set of active pulses and will be applied if and
 * only if the target operator has not yet been evaluated on the current
 * propagation timestamp.
 * @param {Operator} op - The operator to pulse.
 * @param {ChangeSet} value - The tuple changeset to apply.
 * @param {object} [options] - Additional options hash.
 * @param {boolean} [options.skip] - If true, the operator will
 *   be skipped: it will not be evaluated, but its dependents will be.
 * @return {Dataflow}
 */
function pulse(op, changeset, options) {
  this.touch(op, options || NO_OPT);
  const p = new Pulse(this, this._clock + (this._pulse ? 0 : 1)),
    t = op.pulse && op.pulse.source || [];
  p.target = op;
  this._input[op.id] = changeset.pulse(p, t);
  return this;
}
function Heap(cmp) {
  let nodes = [];
  return {
    clear: () => nodes = [],
    size: () => nodes.length,
    peek: () => nodes[0],
    push: x => {
      nodes.push(x);
      return siftdown(nodes, 0, nodes.length - 1, cmp);
    },
    pop: () => {
      const last = nodes.pop();
      let item;
      if (nodes.length) {
        item = nodes[0];
        nodes[0] = last;
        siftup(nodes, 0, cmp);
      } else {
        item = last;
      }
      return item;
    }
  };
}
function siftdown(array, start, idx, cmp) {
  let parent, pidx;
  const item = array[idx];
  while (idx > start) {
    pidx = idx - 1 >> 1;
    parent = array[pidx];
    if (cmp(item, parent) < 0) {
      array[idx] = parent;
      idx = pidx;
      continue;
    }
    break;
  }
  return array[idx] = item;
}
function siftup(array, idx, cmp) {
  const start = idx,
    end = array.length,
    item = array[idx];
  let cidx = (idx << 1) + 1,
    ridx;
  while (cidx < end) {
    ridx = cidx + 1;
    if (ridx < end && cmp(array[cidx], array[ridx]) >= 0) {
      cidx = ridx;
    }
    array[idx] = array[cidx];
    idx = cidx;
    cidx = (idx << 1) + 1;
  }
  array[idx] = item;
  return siftdown(array, start, idx, cmp);
}

/**
 * A dataflow graph for reactive processing of data streams.
 * @constructor
 */
function Dataflow() {
  this.logger(logger());
  this.logLevel(Error$1);
  this._clock = 0;
  this._rank = 0;
  this._locale = defaultLocale();
  try {
    this._loader = loader();
  } catch (e) {
    // do nothing if loader module is unavailable
  }
  this._touched = UniqueList(id);
  this._input = {};
  this._pulse = null;
  this._heap = Heap((a, b) => a.qrank - b.qrank);
  this._postrun = [];
}
function logMethod(method) {
  return function () {
    return this._log[method].apply(this, arguments);
  };
}
Dataflow.prototype = {
  /**
   * The current timestamp of this dataflow. This value reflects the
   * timestamp of the previous dataflow run. The dataflow is initialized
   * with a stamp value of 0. The initial run of the dataflow will have
   * a timestap of 1, and so on. This value will match the
   * {@link Pulse.stamp} property.
   * @return {number} - The current timestamp value.
   */
  stamp() {
    return this._clock;
  },
  /**
   * Gets or sets the loader instance to use for data file loading. A
   * loader object must provide a "load" method for loading files and a
   * "sanitize" method for checking URL/filename validity. Both methods
   * should accept a URI and options hash as arguments, and return a Promise
   * that resolves to the loaded file contents (load) or a hash containing
   * sanitized URI data with the sanitized url assigned to the "href" property
   * (sanitize).
   * @param {object} _ - The loader instance to use.
   * @return {object|Dataflow} - If no arguments are provided, returns
   *   the current loader instance. Otherwise returns this Dataflow instance.
   */
  loader(_) {
    if (arguments.length) {
      this._loader = _;
      return this;
    } else {
      return this._loader;
    }
  },
  /**
   * Gets or sets the locale instance to use for formatting and parsing
   * string values. The locale object should be provided by the
   * vega-format library, and include methods such as format, timeFormat,
   * utcFormat, timeParse, and utcParse.
   * @param {object} _ - The locale instance to use.
   * @return {object|Dataflow} - If no arguments are provided, returns
   *   the current locale instance. Otherwise returns this Dataflow instance.
   */
  locale(_) {
    if (arguments.length) {
      this._locale = _;
      return this;
    } else {
      return this._locale;
    }
  },
  /**
   * Get or set the logger instance used to log messages. If no arguments are
   * provided, returns the current logger instance. Otherwise, sets the logger
   * and return this Dataflow instance. Provided loggers must support the full
   * API of logger objects generated by the vega-util logger method. Note that
   * by default the log level of the new logger will be used; use the logLevel
   * method to adjust the log level as needed.
   */
  logger(logger) {
    if (arguments.length) {
      this._log = logger;
      return this;
    } else {
      return this._log;
    }
  },
  /**
   * Logs an error message. By default, logged messages are written to console
   * output. The message will only be logged if the current log level is high
   * enough to permit error messages.
   */
  error: logMethod('error'),
  /**
   * Logs a warning message. By default, logged messages are written to console
   * output. The message will only be logged if the current log level is high
   * enough to permit warning messages.
   */
  warn: logMethod('warn'),
  /**
   * Logs a information message. By default, logged messages are written to
   * console output. The message will only be logged if the current log level is
   * high enough to permit information messages.
   */
  info: logMethod('info'),
  /**
   * Logs a debug message. By default, logged messages are written to console
   * output. The message will only be logged if the current log level is high
   * enough to permit debug messages.
   */
  debug: logMethod('debug'),
  /**
   * Get or set the current log level. If an argument is provided, it
   * will be used as the new log level.
   * @param {number} [level] - Should be one of None, Warn, Info
   * @return {number} - The current log level.
   */
  logLevel: logMethod('level'),
  /**
   * Empty entry threshold for garbage cleaning. Map data structures will
   * perform cleaning once the number of empty entries exceeds this value.
   */
  cleanThreshold: 1e4,
  // OPERATOR REGISTRATION
  add: add$3,
  connect,
  rank,
  rerank,
  // OPERATOR UPDATES
  pulse,
  touch,
  update: update$6,
  changeset,
  // DATA LOADING
  ingest,
  parse: parse$5,
  preload,
  request,
  // EVENT HANDLING
  events: events$1,
  on,
  // PULSE PROPAGATION
  evaluate,
  run,
  runAsync,
  runAfter,
  _enqueue: enqueue,
  _getPulse: getPulse
};

/**
 * Abstract class for operators that process data tuples.
 * Subclasses must provide a {@link transform} method for operator processing.
 * @constructor
 * @param {*} [init] - The initial value for this operator.
 * @param {object} [params] - The parameters for this operator.
 * @param {Operator} [source] - The operator from which to receive pulses.
 */
function Transform(init, params) {
  Operator.call(this, init, null, params);
}
inherits(Transform, Operator, {
  /**
   * Overrides {@link Operator.evaluate} for transform operators.
   * Internally, this method calls {@link evaluate} to perform processing.
   * If {@link evaluate} returns a falsy value, the input pulse is returned.
   * This method should NOT be overridden, instead overrride {@link evaluate}.
   * @param {Pulse} pulse - the current dataflow pulse.
   * @return the output pulse for this operator (or StopPropagation)
   */
  run(pulse) {
    if (pulse.stamp < this.stamp) return pulse.StopPropagation;
    let rv;
    if (this.skip()) {
      this.skip(false);
    } else {
      rv = this.evaluate(pulse);
    }
    rv = rv || pulse;
    if (rv.then) {
      rv = rv.then(_ => this.pulse = _);
    } else if (rv !== pulse.StopPropagation) {
      this.pulse = rv;
    }
    return rv;
  },
  /**
   * Overrides {@link Operator.evaluate} for transform operators.
   * Marshalls parameter values and then invokes {@link transform}.
   * @param {Pulse} pulse - the current dataflow pulse.
   * @return {Pulse} The output pulse (or StopPropagation). A falsy return
       value (including undefined) will let the input pulse pass through.
  */
  evaluate(pulse) {
    const params = this.marshall(pulse.stamp),
      out = this.transform(params, pulse);
    params.clear();
    return out;
  },
  /**
   * Process incoming pulses.
   * Subclasses should override this method to implement transforms.
   * @param {Parameters} _ - The operator parameter values.
   * @param {Pulse} pulse - The current dataflow pulse.
   * @return {Pulse} The output pulse (or StopPropagation). A falsy return
   *   value (including undefined) will let the input pulse pass through.
   */
  transform() {}
});
const transforms = {};
function definition$1(type) {
  const t = transform$2(type);
  return t && t.Definition || null;
}
function transform$2(type) {
  type = type && type.toLowerCase();
  return has$1(transforms, type) ? transforms[type] : null;
}

function* numbers$1(values, valueof) {
  if (valueof == null) {
    for (let value of values) {
      if (value != null && value !== '' && (value = +value) >= value) {
        yield value;
      }
    }
  } else {
    let index = -1;
    for (let value of values) {
      value = valueof(value, ++index, values);
      if (value != null && value !== '' && (value = +value) >= value) {
        yield value;
      }
    }
  }
}
function quantiles(array, p, f) {
  const values = Float64Array.from(numbers$1(array, f));

  // don't depend on return value from typed array sort call
  // protects against undefined sort results in Safari (vega/vega-lite#4964)
  values.sort(ascending$1);
  return p.map(_ => quantileSorted(values, _));
}
function quartiles(array, f) {
  return quantiles(array, [0.25, 0.50, 0.75], f);
}

// Scott, D. W. (1992) Multivariate Density Estimation:
// Theory, Practice, and Visualization. Wiley.
function estimateBandwidth(array, f) {
  const n = array.length,
    d = deviation(array, f),
    q = quartiles(array, f),
    h = (q[2] - q[0]) / 1.34,
    v = Math.min(d, h) || d || Math.abs(q[0]) || 1;
  return 1.06 * v * Math.pow(n, -0.2);
}
function bin(_) {
  // determine range
  const maxb = _.maxbins || 20,
    base = _.base || 10,
    logb = Math.log(base),
    div = _.divide || [5, 2];
  let min = _.extent[0],
    max = _.extent[1],
    step,
    level,
    minstep,
    v,
    i,
    n;
  const span = _.span || max - min || Math.abs(min) || 1;
  if (_.step) {
    // if step size is explicitly given, use that
    step = _.step;
  } else if (_.steps) {
    // if provided, limit choice to acceptable step sizes
    v = span / maxb;
    for (i = 0, n = _.steps.length; i < n && _.steps[i] < v; ++i);
    step = _.steps[Math.max(0, i - 1)];
  } else {
    // else use span to determine step size
    level = Math.ceil(Math.log(maxb) / logb);
    minstep = _.minstep || 0;
    step = Math.max(minstep, Math.pow(base, Math.round(Math.log(span) / logb) - level));

    // increase step size if too many bins
    while (Math.ceil(span / step) > maxb) {
      step *= base;
    }

    // decrease step size if allowed
    for (i = 0, n = div.length; i < n; ++i) {
      v = step / div[i];
      if (v >= minstep && span / v <= maxb) step = v;
    }
  }

  // update precision, min and max
  v = Math.log(step);
  const precision = v >= 0 ? 0 : ~~(-v / logb) + 1,
    eps = Math.pow(base, -precision - 1);
  if (_.nice || _.nice === undefined) {
    v = Math.floor(min / step + eps) * step;
    min = min < v ? v - step : v;
    max = Math.ceil(max / step) * step;
  }
  return {
    start: min,
    stop: max === min ? min + step : max,
    step: step
  };
}
var random = Math.random;
function bootstrapCI(array, samples, alpha, f) {
  if (!array.length) return [undefined, undefined];
  const values = Float64Array.from(numbers$1(array, f)),
    n = values.length,
    m = samples;
  let a, i, j, mu;
  for (j = 0, mu = Array(m); j < m; ++j) {
    for (a = 0, i = 0; i < n; ++i) {
      a += values[~~(random() * n)];
    }
    mu[j] = a / n;
  }
  mu.sort(ascending$1);
  return [quantile$1(mu, alpha / 2), quantile$1(mu, 1 - alpha / 2)];
}

// Dot density binning for dot plot construction.
// Based on Leland Wilkinson, Dot Plots, The American Statistician, 1999.
// https://www.cs.uic.edu/~wilkinson/Publications/dotplots.pdf
function dotbin(array, step, smooth, f) {
  f = f || (_ => _);
  const n = array.length,
    v = new Float64Array(n);
  let i = 0,
    j = 1,
    a = f(array[0]),
    b = a,
    w = a + step,
    x;
  for (; j < n; ++j) {
    x = f(array[j]);
    if (x >= w) {
      b = (a + b) / 2;
      for (; i < j; ++i) v[i] = b;
      w = x + step;
      a = x;
    }
    b = x;
  }
  b = (a + b) / 2;
  for (; i < j; ++i) v[i] = b;
  return smooth ? smoothing(v, step + step / 4) : v;
}

// perform smoothing to reduce variance
// swap points between "adjacent" stacks
// Wilkinson defines adjacent as within step/4 units
function smoothing(v, thresh) {
  const n = v.length;
  let a = 0,
    b = 1,
    c,
    d;

  // get left stack
  while (v[a] === v[b]) ++b;
  while (b < n) {
    // get right stack
    c = b + 1;
    while (v[b] === v[c]) ++c;

    // are stacks adjacent?
    // if so, compare sizes and swap as needed
    if (v[b] - v[b - 1] < thresh) {
      d = b + (a + c - b - b >> 1);
      while (d < b) v[d++] = v[b];
      while (d > b) v[d--] = v[a];
    }

    // update left stack indices
    a = b;
    b = c;
  }
  return v;
}
const SQRT2PI = Math.sqrt(2 * Math.PI);
const SQRT2 = Math.SQRT2;
let nextSample = NaN;
function sampleNormal(mean, stdev) {
  mean = mean || 0;
  stdev = stdev == null ? 1 : stdev;
  let x = 0,
    y = 0,
    rds,
    c;
  if (nextSample === nextSample) {
    x = nextSample;
    nextSample = NaN;
  } else {
    do {
      x = random() * 2 - 1;
      y = random() * 2 - 1;
      rds = x * x + y * y;
    } while (rds === 0 || rds > 1);
    c = Math.sqrt(-2 * Math.log(rds) / rds); // Box-Muller transform
    x *= c;
    nextSample = y * c;
  }
  return mean + x * stdev;
}
function densityNormal(value, mean, stdev) {
  stdev = stdev == null ? 1 : stdev;
  const z = (value - (mean || 0)) / stdev;
  return Math.exp(-0.5 * z * z) / (stdev * SQRT2PI);
}

// Approximation from West (2009)
// Better Approximations to Cumulative Normal Functions
function cumulativeNormal(value, mean, stdev) {
  mean = mean || 0;
  stdev = stdev == null ? 1 : stdev;
  const z = (value - mean) / stdev,
    Z = Math.abs(z);
  let cd;
  if (Z > 37) {
    cd = 0;
  } else {
    const exp = Math.exp(-Z * Z / 2);
    let sum;
    if (Z < 7.07106781186547) {
      sum = 3.52624965998911e-02 * Z + 0.700383064443688;
      sum = sum * Z + 6.37396220353165;
      sum = sum * Z + 33.912866078383;
      sum = sum * Z + 112.079291497871;
      sum = sum * Z + 221.213596169931;
      sum = sum * Z + 220.206867912376;
      cd = exp * sum;
      sum = 8.83883476483184e-02 * Z + 1.75566716318264;
      sum = sum * Z + 16.064177579207;
      sum = sum * Z + 86.7807322029461;
      sum = sum * Z + 296.564248779674;
      sum = sum * Z + 637.333633378831;
      sum = sum * Z + 793.826512519948;
      sum = sum * Z + 440.413735824752;
      cd = cd / sum;
    } else {
      sum = Z + 0.65;
      sum = Z + 4 / sum;
      sum = Z + 3 / sum;
      sum = Z + 2 / sum;
      sum = Z + 1 / sum;
      cd = exp / sum / 2.506628274631;
    }
  }
  return z > 0 ? 1 - cd : cd;
}

// Approximation of Probit function using inverse error function.
function quantileNormal(p, mean, stdev) {
  if (p < 0 || p > 1) return NaN;
  return (mean || 0) + (stdev == null ? 1 : stdev) * SQRT2 * erfinv(2 * p - 1);
}

// Approximate inverse error function. Implementation from "Approximating
// the erfinv function" by Mike Giles, GPU Computing Gems, volume 2, 2010.
// Ported from Apache Commons Math, http://www.apache.org/licenses/LICENSE-2.0
function erfinv(x) {
  // beware that the logarithm argument must be
  // commputed as (1.0 - x) * (1.0 + x),
  // it must NOT be simplified as 1.0 - x * x as this
  // would induce rounding errors near the boundaries +/-1
  let w = -Math.log((1 - x) * (1 + x)),
    p;
  if (w < 6.25) {
    w -= 3.125;
    p = -364441206401782e-35;
    p = -16850591381820166e-35 + p * w;
    p = 1.2858480715256400167e-18 + p * w;
    p = 1.115787767802518096e-17 + p * w;
    p = -1333171662854621e-31 + p * w;
    p = 2.0972767875968561637e-17 + p * w;
    p = 6.6376381343583238325e-15 + p * w;
    p = -4054566272975207e-29 + p * w;
    p = -8151934197605472e-29 + p * w;
    p = 2.6335093153082322977e-12 + p * w;
    p = -12975133253453532e-27 + p * w;
    p = -5415412054294628e-26 + p * w;
    p = 1.051212273321532285e-09 + p * w;
    p = -4.112633980346984e-9 + p * w;
    p = -2.9070369957882005e-8 + p * w;
    p = 4.2347877827932403518e-07 + p * w;
    p = -13654692000834679e-22 + p * w;
    p = -13882523362786469e-21 + p * w;
    p = 0.0001867342080340571352 + p * w;
    p = -740702534166267e-18 + p * w;
    p = -0.006033670871430149 + p * w;
    p = 0.24015818242558961693 + p * w;
    p = 1.6536545626831027356 + p * w;
  } else if (w < 16.0) {
    w = Math.sqrt(w) - 3.25;
    p = 2.2137376921775787049e-09;
    p = 9.0756561938885390979e-08 + p * w;
    p = -2.7517406297064545e-7 + p * w;
    p = 1.8239629214389227755e-08 + p * w;
    p = 1.5027403968909827627e-06 + p * w;
    p = -4013867526981546e-21 + p * w;
    p = 2.9234449089955446044e-06 + p * w;
    p = 1.2475304481671778723e-05 + p * w;
    p = -47318229009055734e-21 + p * w;
    p = 6.8284851459573175448e-05 + p * w;
    p = 2.4031110387097893999e-05 + p * w;
    p = -3550375203628475e-19 + p * w;
    p = 0.00095328937973738049703 + p * w;
    p = -0.0016882755560235047 + p * w;
    p = 0.0024914420961078508066 + p * w;
    p = -0.003751208507569241 + p * w;
    p = 0.005370914553590063617 + p * w;
    p = 1.0052589676941592334 + p * w;
    p = 3.0838856104922207635 + p * w;
  } else if (Number.isFinite(w)) {
    w = Math.sqrt(w) - 5.0;
    p = -27109920616438573e-27;
    p = -2555641816996525e-25 + p * w;
    p = 1.5076572693500548083e-09 + p * w;
    p = -3.789465440126737e-9 + p * w;
    p = 7.6157012080783393804e-09 + p * w;
    p = -1.496002662714924e-8 + p * w;
    p = 2.9147953450901080826e-08 + p * w;
    p = -6.771199775845234e-8 + p * w;
    p = 2.2900482228026654717e-07 + p * w;
    p = -9.9298272942317e-7 + p * w;
    p = 4.5260625972231537039e-06 + p * w;
    p = -1968177810553167e-20 + p * w;
    p = 7.5995277030017761139e-05 + p * w;
    p = -21503011930044477e-20 + p * w;
    p = -13871931833623122e-20 + p * w;
    p = 1.0103004648645343977 + p * w;
    p = 4.8499064014085844221 + p * w;
  } else {
    p = Infinity;
  }
  return p * x;
}
function gaussian(mean, stdev) {
  let mu, sigma;
  const dist = {
    mean(_) {
      if (arguments.length) {
        mu = _ || 0;
        return dist;
      } else {
        return mu;
      }
    },
    stdev(_) {
      if (arguments.length) {
        sigma = _ == null ? 1 : _;
        return dist;
      } else {
        return sigma;
      }
    },
    sample: () => sampleNormal(mu, sigma),
    pdf: value => densityNormal(value, mu, sigma),
    cdf: value => cumulativeNormal(value, mu, sigma),
    icdf: p => quantileNormal(p, mu, sigma)
  };
  return dist.mean(mean).stdev(stdev);
}
function kde(support, bandwidth) {
  const kernel = gaussian();
  let n = 0;
  const dist = {
    data(_) {
      if (arguments.length) {
        support = _;
        n = _ ? _.length : 0;
        return dist.bandwidth(bandwidth);
      } else {
        return support;
      }
    },
    bandwidth(_) {
      if (!arguments.length) return bandwidth;
      bandwidth = _;
      if (!bandwidth && support) bandwidth = estimateBandwidth(support);
      return dist;
    },
    sample() {
      return support[~~(random() * n)] + bandwidth * kernel.sample();
    },
    pdf(x) {
      let y = 0,
        i = 0;
      for (; i < n; ++i) {
        y += kernel.pdf((x - support[i]) / bandwidth);
      }
      return y / bandwidth / n;
    },
    cdf(x) {
      let y = 0,
        i = 0;
      for (; i < n; ++i) {
        y += kernel.cdf((x - support[i]) / bandwidth);
      }
      return y / n;
    },
    icdf() {
      throw Error('KDE icdf not supported.');
    }
  };
  return dist.data(support);
}
function sampleLogNormal(mean, stdev) {
  mean = mean || 0;
  stdev = stdev == null ? 1 : stdev;
  return Math.exp(mean + sampleNormal() * stdev);
}
function densityLogNormal(value, mean, stdev) {
  if (value <= 0) return 0;
  mean = mean || 0;
  stdev = stdev == null ? 1 : stdev;
  const z = (Math.log(value) - mean) / stdev;
  return Math.exp(-0.5 * z * z) / (stdev * SQRT2PI * value);
}
function cumulativeLogNormal(value, mean, stdev) {
  return cumulativeNormal(Math.log(value), mean, stdev);
}
function quantileLogNormal(p, mean, stdev) {
  return Math.exp(quantileNormal(p, mean, stdev));
}
function lognormal(mean, stdev) {
  let mu, sigma;
  const dist = {
    mean(_) {
      if (arguments.length) {
        mu = _ || 0;
        return dist;
      } else {
        return mu;
      }
    },
    stdev(_) {
      if (arguments.length) {
        sigma = _ == null ? 1 : _;
        return dist;
      } else {
        return sigma;
      }
    },
    sample: () => sampleLogNormal(mu, sigma),
    pdf: value => densityLogNormal(value, mu, sigma),
    cdf: value => cumulativeLogNormal(value, mu, sigma),
    icdf: p => quantileLogNormal(p, mu, sigma)
  };
  return dist.mean(mean).stdev(stdev);
}
function mixture$1(dists, weights) {
  let m = 0,
    w;
  function normalize(x) {
    const w = [];
    let sum = 0,
      i;
    for (i = 0; i < m; ++i) {
      sum += w[i] = x[i] == null ? 1 : +x[i];
    }
    for (i = 0; i < m; ++i) {
      w[i] /= sum;
    }
    return w;
  }
  const dist = {
    weights(_) {
      if (arguments.length) {
        w = normalize(weights = _ || []);
        return dist;
      }
      return weights;
    },
    distributions(_) {
      if (arguments.length) {
        if (_) {
          m = _.length;
          dists = _;
        } else {
          m = 0;
          dists = [];
        }
        return dist.weights(weights);
      }
      return dists;
    },
    sample() {
      const r = random();
      let d = dists[m - 1],
        v = w[0],
        i = 0;

      // first select distribution
      for (; i < m - 1; v += w[++i]) {
        if (r < v) {
          d = dists[i];
          break;
        }
      }
      // then sample from it
      return d.sample();
    },
    pdf(x) {
      let p = 0,
        i = 0;
      for (; i < m; ++i) {
        p += w[i] * dists[i].pdf(x);
      }
      return p;
    },
    cdf(x) {
      let p = 0,
        i = 0;
      for (; i < m; ++i) {
        p += w[i] * dists[i].cdf(x);
      }
      return p;
    },
    icdf() {
      throw Error('Mixture icdf not supported.');
    }
  };
  return dist.distributions(dists).weights(weights);
}
function sampleUniform(min, max) {
  if (max == null) {
    max = min == null ? 1 : min;
    min = 0;
  }
  return min + (max - min) * random();
}
function densityUniform(value, min, max) {
  if (max == null) {
    max = min == null ? 1 : min;
    min = 0;
  }
  return value >= min && value <= max ? 1 / (max - min) : 0;
}
function cumulativeUniform(value, min, max) {
  if (max == null) {
    max = min == null ? 1 : min;
    min = 0;
  }
  return value < min ? 0 : value > max ? 1 : (value - min) / (max - min);
}
function quantileUniform(p, min, max) {
  if (max == null) {
    max = min == null ? 1 : min;
    min = 0;
  }
  return p >= 0 && p <= 1 ? min + p * (max - min) : NaN;
}
function uniform(min, max) {
  let a, b;
  const dist = {
    min(_) {
      if (arguments.length) {
        a = _ || 0;
        return dist;
      } else {
        return a;
      }
    },
    max(_) {
      if (arguments.length) {
        b = _ == null ? 1 : _;
        return dist;
      } else {
        return b;
      }
    },
    sample: () => sampleUniform(a, b),
    pdf: value => densityUniform(value, a, b),
    cdf: value => cumulativeUniform(value, a, b),
    icdf: p => quantileUniform(p, a, b)
  };
  if (max == null) {
    max = min == null ? 1 : min;
    min = 0;
  }
  return dist.min(min).max(max);
}
function constant$4(data, x, y) {
  let mean = 0,
    n = 0;
  for (const d of data) {
    const val = y(d);
    if (x(d) == null || val == null || isNaN(val)) continue;
    mean += (val - mean) / ++n;
  }
  return {
    coef: [mean],
    predict: () => mean,
    rSquared: 0
  };
}

// Ordinary Least Squares
function ols(uX, uY, uXY, uX2) {
  const delta = uX2 - uX * uX,
    slope = Math.abs(delta) < 1e-24 ? 0 : (uXY - uX * uY) / delta,
    intercept = uY - slope * uX;
  return [intercept, slope];
}
function points(data, x, y, sort) {
  data = data.filter(d => {
    let u = x(d),
      v = y(d);
    return u != null && (u = +u) >= u && v != null && (v = +v) >= v;
  });
  if (sort) {
    data.sort((a, b) => x(a) - x(b));
  }
  const n = data.length,
    X = new Float64Array(n),
    Y = new Float64Array(n);

  // extract values, calculate means
  let i = 0,
    ux = 0,
    uy = 0,
    xv,
    yv,
    d;
  for (d of data) {
    X[i] = xv = +x(d);
    Y[i] = yv = +y(d);
    ++i;
    ux += (xv - ux) / i;
    uy += (yv - uy) / i;
  }

  // mean center the data
  for (i = 0; i < n; ++i) {
    X[i] -= ux;
    Y[i] -= uy;
  }
  return [X, Y, ux, uy];
}
function visitPoints(data, x, y, callback) {
  let i = -1,
    u,
    v;
  for (const d of data) {
    u = x(d);
    v = y(d);
    if (u != null && (u = +u) >= u && v != null && (v = +v) >= v) {
      callback(u, v, ++i);
    }
  }
}

// Adapted from d3-regression by Harry Stevens
// License: https://github.com/HarryStevens/d3-regression/blob/master/LICENSE
function rSquared(data, x, y, uY, predict) {
  let SSE = 0,
    SST = 0;
  visitPoints(data, x, y, (dx, dy) => {
    const sse = dy - predict(dx),
      sst = dy - uY;
    SSE += sse * sse;
    SST += sst * sst;
  });
  return 1 - SSE / SST;
}

// Adapted from d3-regression by Harry Stevens
// License: https://github.com/HarryStevens/d3-regression/blob/master/LICENSE
function linear$2(data, x, y) {
  let X = 0,
    Y = 0,
    XY = 0,
    X2 = 0,
    n = 0;
  visitPoints(data, x, y, (dx, dy) => {
    ++n;
    X += (dx - X) / n;
    Y += (dy - Y) / n;
    XY += (dx * dy - XY) / n;
    X2 += (dx * dx - X2) / n;
  });
  const coef = ols(X, Y, XY, X2),
    predict = x => coef[0] + coef[1] * x;
  return {
    coef: coef,
    predict: predict,
    rSquared: rSquared(data, x, y, Y, predict)
  };
}

// Adapted from d3-regression by Harry Stevens
// License: https://github.com/HarryStevens/d3-regression/blob/master/LICENSE
function log$3(data, x, y) {
  let X = 0,
    Y = 0,
    XY = 0,
    X2 = 0,
    n = 0;
  visitPoints(data, x, y, (dx, dy) => {
    ++n;
    dx = Math.log(dx);
    X += (dx - X) / n;
    Y += (dy - Y) / n;
    XY += (dx * dy - XY) / n;
    X2 += (dx * dx - X2) / n;
  });
  const coef = ols(X, Y, XY, X2),
    predict = x => coef[0] + coef[1] * Math.log(x);
  return {
    coef: coef,
    predict: predict,
    rSquared: rSquared(data, x, y, Y, predict)
  };
}
function exp$1(data, x, y) {
  // eslint-disable-next-line no-unused-vars
  const [xv, yv, ux, uy] = points(data, x, y);
  let YL = 0,
    XY = 0,
    XYL = 0,
    X2Y = 0,
    n = 0,
    dx,
    ly,
    xy;
  visitPoints(data, x, y, (_, dy) => {
    dx = xv[n++];
    ly = Math.log(dy);
    xy = dx * dy;
    YL += (dy * ly - YL) / n;
    XY += (xy - XY) / n;
    XYL += (xy * ly - XYL) / n;
    X2Y += (dx * xy - X2Y) / n;
  });
  const [c0, c1] = ols(XY / uy, YL / uy, XYL / uy, X2Y / uy),
    predict = x => Math.exp(c0 + c1 * (x - ux));
  return {
    coef: [Math.exp(c0 - c1 * ux), c1],
    predict: predict,
    rSquared: rSquared(data, x, y, uy, predict)
  };
}

// Adapted from d3-regression by Harry Stevens
// License: https://github.com/HarryStevens/d3-regression/blob/master/LICENSE
function pow$3(data, x, y) {
  let X = 0,
    Y = 0,
    XY = 0,
    X2 = 0,
    YS = 0,
    n = 0;
  visitPoints(data, x, y, (dx, dy) => {
    const lx = Math.log(dx),
      ly = Math.log(dy);
    ++n;
    X += (lx - X) / n;
    Y += (ly - Y) / n;
    XY += (lx * ly - XY) / n;
    X2 += (lx * lx - X2) / n;
    YS += (dy - YS) / n;
  });
  const coef = ols(X, Y, XY, X2),
    predict = x => coef[0] * Math.pow(x, coef[1]);
  coef[0] = Math.exp(coef[0]);
  return {
    coef: coef,
    predict: predict,
    rSquared: rSquared(data, x, y, YS, predict)
  };
}
function quad(data, x, y) {
  const [xv, yv, ux, uy] = points(data, x, y),
    n = xv.length;
  let X2 = 0,
    X3 = 0,
    X4 = 0,
    XY = 0,
    X2Y = 0,
    i,
    dx,
    dy,
    x2;
  for (i = 0; i < n;) {
    dx = xv[i];
    dy = yv[i++];
    x2 = dx * dx;
    X2 += (x2 - X2) / i;
    X3 += (x2 * dx - X3) / i;
    X4 += (x2 * x2 - X4) / i;
    XY += (dx * dy - XY) / i;
    X2Y += (x2 * dy - X2Y) / i;
  }
  const X2X2 = X4 - X2 * X2,
    d = X2 * X2X2 - X3 * X3,
    a = (X2Y * X2 - XY * X3) / d,
    b = (XY * X2X2 - X2Y * X3) / d,
    c = -a * X2,
    predict = x => {
      x = x - ux;
      return a * x * x + b * x + c + uy;
    };

  // transform coefficients back from mean-centered space
  return {
    coef: [c - b * ux + a * ux * ux + uy, b - 2 * a * ux, a],
    predict: predict,
    rSquared: rSquared(data, x, y, uy, predict)
  };
}

// Adapted from d3-regression by Harry Stevens
// License: https://github.com/HarryStevens/d3-regression/blob/master/LICENSE
// ... which was adapted from regression-js by Tom Alexander
// Source: https://github.com/Tom-Alexander/regression-js/blob/master/src/regression.js#L246
// License: https://github.com/Tom-Alexander/regression-js/blob/master/LICENSE
function poly(data, x, y, order) {
  // use more efficient methods for lower orders
  if (order === 0) return constant$4(data, x, y);
  if (order === 1) return linear$2(data, x, y);
  if (order === 2) return quad(data, x, y);
  const [xv, yv, ux, uy] = points(data, x, y),
    n = xv.length,
    lhs = [],
    rhs = [],
    k = order + 1;
  let i, j, l, v, c;
  for (i = 0; i < k; ++i) {
    for (l = 0, v = 0; l < n; ++l) {
      v += Math.pow(xv[l], i) * yv[l];
    }
    lhs.push(v);
    c = new Float64Array(k);
    for (j = 0; j < k; ++j) {
      for (l = 0, v = 0; l < n; ++l) {
        v += Math.pow(xv[l], i + j);
      }
      c[j] = v;
    }
    rhs.push(c);
  }
  rhs.push(lhs);
  const coef = gaussianElimination(rhs),
    predict = x => {
      x -= ux;
      let y = uy + coef[0] + coef[1] * x + coef[2] * x * x;
      for (i = 3; i < k; ++i) y += coef[i] * Math.pow(x, i);
      return y;
    };
  return {
    coef: uncenter(k, coef, -ux, uy),
    predict: predict,
    rSquared: rSquared(data, x, y, uy, predict)
  };
}
function uncenter(k, a, x, y) {
  const z = Array(k);
  let i, j, v, c;

  // initialize to zero
  for (i = 0; i < k; ++i) z[i] = 0;

  // polynomial expansion
  for (i = k - 1; i >= 0; --i) {
    v = a[i];
    c = 1;
    z[i] += v;
    for (j = 1; j <= i; ++j) {
      c *= (i + 1 - j) / j; // binomial coefficent
      z[i - j] += v * Math.pow(x, j) * c;
    }
  }

  // bias term
  z[0] += y;
  return z;
}

// Given an array for a two-dimensional matrix and the polynomial order,
// solve A * x = b using Gaussian elimination.
function gaussianElimination(matrix) {
  const n = matrix.length - 1,
    coef = [];
  let i, j, k, r, t;
  for (i = 0; i < n; ++i) {
    r = i; // max row
    for (j = i + 1; j < n; ++j) {
      if (Math.abs(matrix[i][j]) > Math.abs(matrix[i][r])) {
        r = j;
      }
    }
    for (k = i; k < n + 1; ++k) {
      t = matrix[k][i];
      matrix[k][i] = matrix[k][r];
      matrix[k][r] = t;
    }
    for (j = i + 1; j < n; ++j) {
      for (k = n; k >= i; k--) {
        matrix[k][j] -= matrix[k][i] * matrix[i][j] / matrix[i][i];
      }
    }
  }
  for (j = n - 1; j >= 0; --j) {
    t = 0;
    for (k = j + 1; k < n; ++k) {
      t += matrix[k][j] * coef[k];
    }
    coef[j] = (matrix[n][j] - t) / matrix[j][j];
  }
  return coef;
}
const maxiters = 2,
  epsilon$6 = 1e-12;

// Adapted from science.js by Jason Davies
// Source: https://github.com/jasondavies/science.js/blob/master/src/stats/loess.js
// License: https://github.com/jasondavies/science.js/blob/master/LICENSE
function loess(data, x, y, bandwidth) {
  const [xv, yv, ux, uy] = points(data, x, y, true),
    n = xv.length,
    bw = Math.max(2, ~~(bandwidth * n)),
    // # nearest neighbors
    yhat = new Float64Array(n),
    residuals = new Float64Array(n),
    robustWeights = new Float64Array(n).fill(1);
  for (let iter = -1; ++iter <= maxiters;) {
    const interval = [0, bw - 1];
    for (let i = 0; i < n; ++i) {
      const dx = xv[i],
        i0 = interval[0],
        i1 = interval[1],
        edge = dx - xv[i0] > xv[i1] - dx ? i0 : i1;
      let W = 0,
        X = 0,
        Y = 0,
        XY = 0,
        X2 = 0;
      const denom = 1 / Math.abs(xv[edge] - dx || 1); // avoid singularity!

      for (let k = i0; k <= i1; ++k) {
        const xk = xv[k],
          yk = yv[k],
          w = tricube(Math.abs(dx - xk) * denom) * robustWeights[k],
          xkw = xk * w;
        W += w;
        X += xkw;
        Y += yk * w;
        XY += yk * xkw;
        X2 += xk * xkw;
      }

      // linear regression fit
      const [a, b] = ols(X / W, Y / W, XY / W, X2 / W);
      yhat[i] = a + b * dx;
      residuals[i] = Math.abs(yv[i] - yhat[i]);
      updateInterval(xv, i + 1, interval);
    }
    if (iter === maxiters) {
      break;
    }
    const medianResidual = median(residuals);
    if (Math.abs(medianResidual) < epsilon$6) break;
    for (let i = 0, arg, w; i < n; ++i) {
      arg = residuals[i] / (6 * medianResidual);
      // default to epsilon (rather than zero) for large deviations
      // keeping weights tiny but non-zero prevents singularites
      robustWeights[i] = arg >= 1 ? epsilon$6 : (w = 1 - arg * arg) * w;
    }
  }
  return output$1(xv, yhat, ux, uy);
}

// weighting kernel for local regression
function tricube(x) {
  return (x = 1 - x * x * x) * x * x;
}

// advance sliding window interval of nearest neighbors
function updateInterval(xv, i, interval) {
  const val = xv[i];
  let left = interval[0],
    right = interval[1] + 1;
  if (right >= xv.length) return;

  // step right if distance to new right edge is <= distance to old left edge
  // step when distance is equal to ensure movement over duplicate x values
  while (i > left && xv[right] - val <= val - xv[left]) {
    interval[0] = ++left;
    interval[1] = right;
    ++right;
  }
}

// generate smoothed output points
// average points with repeated x values
function output$1(xv, yhat, ux, uy) {
  const n = xv.length,
    out = [];
  let i = 0,
    cnt = 0,
    prev = [],
    v;
  for (; i < n; ++i) {
    v = xv[i] + ux;
    if (prev[0] === v) {
      // average output values via online update
      prev[1] += (yhat[i] - prev[1]) / ++cnt;
    } else {
      // add new output point
      cnt = 0;
      prev[1] += uy;
      prev = [v, yhat[i]];
      out.push(prev);
    }
  }
  prev[1] += uy;
  return out;
}

// subdivide up to accuracy of 0.5 degrees
const MIN_RADIANS = 0.5 * Math.PI / 180;

// Adaptively sample an interpolated function over a domain extent
function sampleCurve(f, extent, minSteps, maxSteps) {
  minSteps = minSteps || 25;
  maxSteps = Math.max(minSteps, maxSteps || 200);
  const point = x => [x, f(x)],
    minX = extent[0],
    maxX = extent[1],
    span = maxX - minX,
    stop = span / maxSteps,
    prev = [point(minX)],
    next = [];
  if (minSteps === maxSteps) {
    // no adaptation, sample uniform grid directly and return
    for (let i = 1; i < maxSteps; ++i) {
      prev.push(point(minX + i / minSteps * span));
    }
    prev.push(point(maxX));
    return prev;
  } else {
    // sample minimum points on uniform grid
    // then move on to perform adaptive refinement
    next.push(point(maxX));
    for (let i = minSteps; --i > 0;) {
      next.push(point(minX + i / minSteps * span));
    }
  }
  let p0 = prev[0];
  let p1 = next[next.length - 1];
  const sx = 1 / span;
  const sy = scaleY(p0[1], next);
  while (p1) {
    // midpoint for potential curve subdivision
    const pm = point((p0[0] + p1[0]) / 2);
    const dx = pm[0] - p0[0] >= stop;
    if (dx && angleDelta(p0, pm, p1, sx, sy) > MIN_RADIANS) {
      // maximum resolution has not yet been met, and
      // subdivision midpoint is sufficiently different from endpoint
      // save subdivision, push midpoint onto the visitation stack
      next.push(pm);
    } else {
      // subdivision midpoint sufficiently similar to endpoint
      // skip subdivision, store endpoint, move to next point on the stack
      p0 = p1;
      prev.push(p1);
      next.pop();
    }
    p1 = next[next.length - 1];
  }
  return prev;
}
function scaleY(init, points) {
  let ymin = init;
  let ymax = init;
  const n = points.length;
  for (let i = 0; i < n; ++i) {
    const y = points[i][1];
    if (y < ymin) ymin = y;
    if (y > ymax) ymax = y;
  }
  return 1 / (ymax - ymin);
}
function angleDelta(p, q, r, sx, sy) {
  const a0 = Math.atan2(sy * (r[1] - p[1]), sx * (r[0] - p[0])),
    a1 = Math.atan2(sy * (q[1] - p[1]), sx * (q[0] - p[0]));
  return Math.abs(a0 - a1);
}

function multikey(f) {
  return x => {
    const n = f.length;
    let i = 1,
      k = String(f[0](x));
    for (; i < n; ++i) {
      k += '|' + f[i](x);
    }
    return k;
  };
}
function groupkey(fields) {
  return !fields || !fields.length ? function () {
    return '';
  } : fields.length === 1 ? fields[0] : multikey(fields);
}
function measureName(op, field, as) {
  return as || op + (!field ? '' : '_' + field);
}
const noop$4 = () => {};
const base_op = {
  init: noop$4,
  add: noop$4,
  rem: noop$4,
  idx: 0
};
const AggregateOps = {
  values: {
    init: m => m.cell.store = true,
    value: m => m.cell.data.values(),
    idx: -1
  },
  count: {
    value: m => m.cell.num
  },
  __count__: {
    value: m => m.missing + m.valid
  },
  missing: {
    value: m => m.missing
  },
  valid: {
    value: m => m.valid
  },
  sum: {
    init: m => m.sum = 0,
    value: m => m.valid ? m.sum : undefined,
    add: (m, v) => m.sum += +v,
    rem: (m, v) => m.sum -= v
  },
  product: {
    init: m => m.product = 1,
    value: m => m.valid ? m.product : undefined,
    add: (m, v) => m.product *= v,
    rem: (m, v) => m.product /= v
  },
  mean: {
    init: m => m.mean = 0,
    value: m => m.valid ? m.mean : undefined,
    add: (m, v) => (m.mean_d = v - m.mean, m.mean += m.mean_d / m.valid),
    rem: (m, v) => (m.mean_d = v - m.mean, m.mean -= m.valid ? m.mean_d / m.valid : m.mean)
  },
  average: {
    value: m => m.valid ? m.mean : undefined,
    req: ['mean'],
    idx: 1
  },
  variance: {
    init: m => m.dev = 0,
    value: m => m.valid > 1 ? m.dev / (m.valid - 1) : undefined,
    add: (m, v) => m.dev += m.mean_d * (v - m.mean),
    rem: (m, v) => m.dev -= m.mean_d * (v - m.mean),
    req: ['mean'],
    idx: 1
  },
  variancep: {
    value: m => m.valid > 1 ? m.dev / m.valid : undefined,
    req: ['variance'],
    idx: 2
  },
  stdev: {
    value: m => m.valid > 1 ? Math.sqrt(m.dev / (m.valid - 1)) : undefined,
    req: ['variance'],
    idx: 2
  },
  stdevp: {
    value: m => m.valid > 1 ? Math.sqrt(m.dev / m.valid) : undefined,
    req: ['variance'],
    idx: 2
  },
  stderr: {
    value: m => m.valid > 1 ? Math.sqrt(m.dev / (m.valid * (m.valid - 1))) : undefined,
    req: ['variance'],
    idx: 2
  },
  distinct: {
    value: m => m.cell.data.distinct(m.get),
    req: ['values'],
    idx: 3
  },
  ci0: {
    value: m => m.cell.data.ci0(m.get),
    req: ['values'],
    idx: 3
  },
  ci1: {
    value: m => m.cell.data.ci1(m.get),
    req: ['values'],
    idx: 3
  },
  median: {
    value: m => m.cell.data.q2(m.get),
    req: ['values'],
    idx: 3
  },
  q1: {
    value: m => m.cell.data.q1(m.get),
    req: ['values'],
    idx: 3
  },
  q3: {
    value: m => m.cell.data.q3(m.get),
    req: ['values'],
    idx: 3
  },
  min: {
    init: m => m.min = undefined,
    value: m => m.min = Number.isNaN(m.min) ? m.cell.data.min(m.get) : m.min,
    add: (m, v) => {
      if (v < m.min || m.min === undefined) m.min = v;
    },
    rem: (m, v) => {
      if (v <= m.min) m.min = NaN;
    },
    req: ['values'],
    idx: 4
  },
  max: {
    init: m => m.max = undefined,
    value: m => m.max = Number.isNaN(m.max) ? m.cell.data.max(m.get) : m.max,
    add: (m, v) => {
      if (v > m.max || m.max === undefined) m.max = v;
    },
    rem: (m, v) => {
      if (v >= m.max) m.max = NaN;
    },
    req: ['values'],
    idx: 4
  },
  argmin: {
    init: m => m.argmin = undefined,
    value: m => m.argmin || m.cell.data.argmin(m.get),
    add: (m, v, t) => {
      if (v < m.min) m.argmin = t;
    },
    rem: (m, v) => {
      if (v <= m.min) m.argmin = undefined;
    },
    req: ['min', 'values'],
    idx: 3
  },
  argmax: {
    init: m => m.argmax = undefined,
    value: m => m.argmax || m.cell.data.argmax(m.get),
    add: (m, v, t) => {
      if (v > m.max) m.argmax = t;
    },
    rem: (m, v) => {
      if (v >= m.max) m.argmax = undefined;
    },
    req: ['max', 'values'],
    idx: 3
  },
  exponential: {
    init: (m, r) => {
      m.exp = 0;
      m.exp_r = r;
    },
    value: m => m.valid ? m.exp * (1 - m.exp_r) / (1 - m.exp_r ** m.valid) : undefined,
    add: (m, v) => m.exp = m.exp_r * m.exp + v,
    rem: (m, v) => m.exp = (m.exp - v / m.exp_r ** (m.valid - 1)) / m.exp_r
  },
  exponentialb: {
    value: m => m.valid ? m.exp * (1 - m.exp_r) : undefined,
    req: ['exponential'],
    idx: 1
  }
};
const ValidAggregateOps = Object.keys(AggregateOps).filter(d => d !== '__count__');
function measure(key, value) {
  return (out, aggregate_param) => extend$1({
    name: key,
    aggregate_param: aggregate_param,
    out: out || key
  }, base_op, value);
}
[...ValidAggregateOps, '__count__'].forEach(key => {
  AggregateOps[key] = measure(key, AggregateOps[key]);
});
function createMeasure(op, param, name) {
  return AggregateOps[op](name, param);
}
function compareIndex(a, b) {
  return a.idx - b.idx;
}
function resolve(agg) {
  const map = {};
  agg.forEach(a => map[a.name] = a);
  const getreqs = a => {
    if (!a.req) return;
    a.req.forEach(key => {
      if (!map[key]) getreqs(map[key] = AggregateOps[key]());
    });
  };
  agg.forEach(getreqs);
  return Object.values(map).sort(compareIndex);
}
function init() {
  this.valid = 0;
  this.missing = 0;
  this._ops.forEach(op => op.aggregate_param == null ? op.init(this) : op.init(this, op.aggregate_param));
}
function add$2(v, t) {
  if (v == null || v === '') {
    ++this.missing;
    return;
  }
  if (v !== v) return;
  ++this.valid;
  this._ops.forEach(op => op.add(this, v, t));
}
function rem(v, t) {
  if (v == null || v === '') {
    --this.missing;
    return;
  }
  if (v !== v) return;
  --this.valid;
  this._ops.forEach(op => op.rem(this, v, t));
}
function set$3(t) {
  this._out.forEach(op => t[op.out] = op.value(this));
  return t;
}
function compileMeasures(agg, field) {
  const get = field || identity$6,
    ops = resolve(agg),
    out = agg.slice().sort(compareIndex);
  function ctr(cell) {
    this._ops = ops;
    this._out = out;
    this.cell = cell;
    this.init();
  }
  ctr.prototype.init = init;
  ctr.prototype.add = add$2;
  ctr.prototype.rem = rem;
  ctr.prototype.set = set$3;
  ctr.prototype.get = get;
  ctr.fields = agg.map(op => op.out);
  return ctr;
}
function TupleStore(key) {
  this._key = key ? field$1(key) : tupleid;
  this.reset();
}
const prototype$1 = TupleStore.prototype;
prototype$1.reset = function () {
  this._add = [];
  this._rem = [];
  this._ext = null;
  this._get = null;
  this._q = null;
};
prototype$1.add = function (v) {
  this._add.push(v);
};
prototype$1.rem = function (v) {
  this._rem.push(v);
};
prototype$1.values = function () {
  this._get = null;
  if (this._rem.length === 0) return this._add;
  const a = this._add,
    r = this._rem,
    k = this._key,
    n = a.length,
    m = r.length,
    x = Array(n - m),
    map = {};
  let i, j, v;

  // use unique key field to clear removed values
  for (i = 0; i < m; ++i) {
    map[k(r[i])] = 1;
  }
  for (i = 0, j = 0; i < n; ++i) {
    if (map[k(v = a[i])]) {
      map[k(v)] = 0;
    } else {
      x[j++] = v;
    }
  }
  this._rem = [];
  return this._add = x;
};

// memoizing statistics methods

prototype$1.distinct = function (get) {
  const v = this.values(),
    map = {};
  let n = v.length,
    count = 0,
    s;
  while (--n >= 0) {
    s = get(v[n]) + '';
    if (!has$1(map, s)) {
      map[s] = 1;
      ++count;
    }
  }
  return count;
};
prototype$1.extent = function (get) {
  if (this._get !== get || !this._ext) {
    const v = this.values(),
      i = extentIndex(v, get);
    this._ext = [v[i[0]], v[i[1]]];
    this._get = get;
  }
  return this._ext;
};
prototype$1.argmin = function (get) {
  return this.extent(get)[0] || {};
};
prototype$1.argmax = function (get) {
  return this.extent(get)[1] || {};
};
prototype$1.min = function (get) {
  const m = this.extent(get)[0];
  return m != null ? get(m) : undefined;
};
prototype$1.max = function (get) {
  const m = this.extent(get)[1];
  return m != null ? get(m) : undefined;
};
prototype$1.quartile = function (get) {
  if (this._get !== get || !this._q) {
    this._q = quartiles(this.values(), get);
    this._get = get;
  }
  return this._q;
};
prototype$1.q1 = function (get) {
  return this.quartile(get)[0];
};
prototype$1.q2 = function (get) {
  return this.quartile(get)[1];
};
prototype$1.q3 = function (get) {
  return this.quartile(get)[2];
};
prototype$1.ci = function (get) {
  if (this._get !== get || !this._ci) {
    this._ci = bootstrapCI(this.values(), 1000, 0.05, get);
    this._get = get;
  }
  return this._ci;
};
prototype$1.ci0 = function (get) {
  return this.ci(get)[0];
};
prototype$1.ci1 = function (get) {
  return this.ci(get)[1];
};

/**
 * Group-by aggregation operator.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {Array<function(object): *>} [params.groupby] - An array of accessors to groupby.
 * @param {Array<function(object): *>} [params.fields] - An array of accessors to aggregate.
 * @param {Array<string>} [params.ops] - An array of strings indicating aggregation operations.
 * @param {Array<number>} [params.aggregate_params] - An optional array of parameters for aggregation operations.
 * @param {Array<string>} [params.as] - An array of output field names for aggregated values.
 * @param {boolean} [params.cross=false] - A flag indicating that the full
 *   cross-product of groupby values should be generated, including empty cells.
 *   If true, the drop parameter is ignored and empty cells are retained.
 * @param {boolean} [params.drop=true] - A flag indicating if empty cells should be removed.
 */
function Aggregate$1(params) {
  Transform.call(this, null, params);
  this._adds = []; // array of added output tuples
  this._mods = []; // array of modified output tuples
  this._alen = 0; // number of active added tuples
  this._mlen = 0; // number of active modified tuples
  this._drop = true; // should empty aggregation cells be removed
  this._cross = false; // produce full cross-product of group-by values

  this._dims = []; // group-by dimension accessors
  this._dnames = []; // group-by dimension names

  this._measures = []; // collection of aggregation monoids
  this._countOnly = false; // flag indicating only count aggregation
  this._counts = null; // collection of count fields
  this._prev = null; // previous aggregation cells

  this._inputs = null; // array of dependent input tuple field names
  this._outputs = null; // array of output tuple field names
}
Aggregate$1.Definition = {
  'type': 'Aggregate',
  'metadata': {
    'generates': true,
    'changes': true
  },
  'params': [{
    'name': 'groupby',
    'type': 'field',
    'array': true
  }, {
    'name': 'ops',
    'type': 'enum',
    'array': true,
    'values': ValidAggregateOps
  }, {
    'name': 'aggregate_params',
    'type': 'number',
    'null': true,
    'array': true
  }, {
    'name': 'fields',
    'type': 'field',
    'null': true,
    'array': true
  }, {
    'name': 'as',
    'type': 'string',
    'null': true,
    'array': true
  }, {
    'name': 'drop',
    'type': 'boolean',
    'default': true
  }, {
    'name': 'cross',
    'type': 'boolean',
    'default': false
  }, {
    'name': 'key',
    'type': 'field'
  }]
};
inherits(Aggregate$1, Transform, {
  transform(_, pulse) {
    const aggr = this,
      out = pulse.fork(pulse.NO_SOURCE | pulse.NO_FIELDS),
      mod = _.modified();
    aggr.stamp = out.stamp;
    if (aggr.value && (mod || pulse.modified(aggr._inputs, true))) {
      aggr._prev = aggr.value;
      aggr.value = mod ? aggr.init(_) : Object.create(null);
      pulse.visit(pulse.SOURCE, t => aggr.add(t));
    } else {
      aggr.value = aggr.value || aggr.init(_);
      pulse.visit(pulse.REM, t => aggr.rem(t));
      pulse.visit(pulse.ADD, t => aggr.add(t));
    }

    // Indicate output fields and return aggregate tuples.
    out.modifies(aggr._outputs);

    // Should empty cells be dropped?
    aggr._drop = _.drop !== false;

    // If domain cross-product requested, generate empty cells as needed
    // and ensure that empty cells are not dropped
    if (_.cross && aggr._dims.length > 1) {
      aggr._drop = false;
      aggr.cross();
    }
    if (pulse.clean() && aggr._drop) {
      out.clean(true).runAfter(() => this.clean());
    }
    return aggr.changes(out);
  },
  cross() {
    const aggr = this,
      curr = aggr.value,
      dims = aggr._dnames,
      vals = dims.map(() => ({})),
      n = dims.length;

    // collect all group-by domain values
    function collect(cells) {
      let key, i, t, v;
      for (key in cells) {
        t = cells[key].tuple;
        for (i = 0; i < n; ++i) {
          vals[i][v = t[dims[i]]] = v;
        }
      }
    }
    collect(aggr._prev);
    collect(curr);

    // iterate over key cross-product, create cells as needed
    function generate(base, tuple, index) {
      const name = dims[index],
        v = vals[index++];
      for (const k in v) {
        const key = base ? base + '|' + k : k;
        tuple[name] = v[k];
        if (index < n) generate(key, tuple, index);else if (!curr[key]) aggr.cell(key, tuple);
      }
    }
    generate('', {}, 0);
  },
  init(_) {
    // initialize input and output fields
    const inputs = this._inputs = [],
      outputs = this._outputs = [],
      inputMap = {};
    function inputVisit(get) {
      const fields = array$5(accessorFields(get)),
        n = fields.length;
      let i = 0,
        f;
      for (; i < n; ++i) {
        if (!inputMap[f = fields[i]]) {
          inputMap[f] = 1;
          inputs.push(f);
        }
      }
    }

    // initialize group-by dimensions
    this._dims = array$5(_.groupby);
    this._dnames = this._dims.map(d => {
      const dname = accessorName(d);
      inputVisit(d);
      outputs.push(dname);
      return dname;
    });
    this.cellkey = _.key ? _.key : groupkey(this._dims);

    // initialize aggregate measures
    this._countOnly = true;
    this._counts = [];
    this._measures = [];
    const fields = _.fields || [null],
      ops = _.ops || ['count'],
      aggregate_params = _.aggregate_params || [null],
      as = _.as || [],
      n = fields.length,
      map = {};
    let field, op, aggregate_param, m, mname, outname, i;
    if (n !== ops.length) {
      error('Unmatched number of fields and aggregate ops.');
    }
    for (i = 0; i < n; ++i) {
      field = fields[i];
      op = ops[i];
      aggregate_param = aggregate_params[i] || null;
      if (field == null && op !== 'count') {
        error('Null aggregate field specified.');
      }
      mname = accessorName(field);
      outname = measureName(op, mname, as[i]);
      outputs.push(outname);
      if (op === 'count') {
        this._counts.push(outname);
        continue;
      }
      m = map[mname];
      if (!m) {
        inputVisit(field);
        m = map[mname] = [];
        m.field = field;
        this._measures.push(m);
      }
      if (op !== 'count') this._countOnly = false;
      m.push(createMeasure(op, aggregate_param, outname));
    }
    this._measures = this._measures.map(m => compileMeasures(m, m.field));
    return Object.create(null); // aggregation cells (this.value)
  },
  // -- Cell Management -----

  cellkey: groupkey(),
  cell(key, t) {
    let cell = this.value[key];
    if (!cell) {
      cell = this.value[key] = this.newcell(key, t);
      this._adds[this._alen++] = cell;
    } else if (cell.num === 0 && this._drop && cell.stamp < this.stamp) {
      cell.stamp = this.stamp;
      this._adds[this._alen++] = cell;
    } else if (cell.stamp < this.stamp) {
      cell.stamp = this.stamp;
      this._mods[this._mlen++] = cell;
    }
    return cell;
  },
  newcell(key, t) {
    const cell = {
      key: key,
      num: 0,
      agg: null,
      tuple: this.newtuple(t, this._prev && this._prev[key]),
      stamp: this.stamp,
      store: false
    };
    if (!this._countOnly) {
      const measures = this._measures,
        n = measures.length;
      cell.agg = Array(n);
      for (let i = 0; i < n; ++i) {
        cell.agg[i] = new measures[i](cell);
      }
    }
    if (cell.store) {
      cell.data = new TupleStore();
    }
    return cell;
  },
  newtuple(t, p) {
    const names = this._dnames,
      dims = this._dims,
      n = dims.length,
      x = {};
    for (let i = 0; i < n; ++i) {
      x[names[i]] = dims[i](t);
    }
    return p ? replace$1(p.tuple, x) : ingest$1(x);
  },
  clean() {
    const cells = this.value;
    for (const key in cells) {
      if (cells[key].num === 0) {
        delete cells[key];
      }
    }
  },
  // -- Process Tuples -----

  add(t) {
    const key = this.cellkey(t),
      cell = this.cell(key, t);
    cell.num += 1;
    if (this._countOnly) return;
    if (cell.store) cell.data.add(t);
    const agg = cell.agg;
    for (let i = 0, n = agg.length; i < n; ++i) {
      agg[i].add(agg[i].get(t), t);
    }
  },
  rem(t) {
    const key = this.cellkey(t),
      cell = this.cell(key, t);
    cell.num -= 1;
    if (this._countOnly) return;
    if (cell.store) cell.data.rem(t);
    const agg = cell.agg;
    for (let i = 0, n = agg.length; i < n; ++i) {
      agg[i].rem(agg[i].get(t), t);
    }
  },
  celltuple(cell) {
    const tuple = cell.tuple,
      counts = this._counts;

    // consolidate stored values
    if (cell.store) {
      cell.data.values();
    }

    // update tuple properties
    for (let i = 0, n = counts.length; i < n; ++i) {
      tuple[counts[i]] = cell.num;
    }
    if (!this._countOnly) {
      const agg = cell.agg;
      for (let i = 0, n = agg.length; i < n; ++i) {
        agg[i].set(tuple);
      }
    }
    return tuple;
  },
  changes(out) {
    const adds = this._adds,
      mods = this._mods,
      prev = this._prev,
      drop = this._drop,
      add = out.add,
      rem = out.rem,
      mod = out.mod;
    let cell, key, i, n;
    if (prev) for (key in prev) {
      cell = prev[key];
      if (!drop || cell.num) rem.push(cell.tuple);
    }
    for (i = 0, n = this._alen; i < n; ++i) {
      add.push(this.celltuple(adds[i]));
      adds[i] = null; // for garbage collection
    }
    for (i = 0, n = this._mlen; i < n; ++i) {
      cell = mods[i];
      (cell.num === 0 && drop ? rem : mod).push(this.celltuple(cell));
      mods[i] = null; // for garbage collection
    }
    this._alen = this._mlen = 0; // reset list of active cells
    this._prev = null;
    return out;
  }
});

// epsilon bias to offset floating point error (#1737)
const EPSILON$1 = 1e-14;

/**
 * Generates a binning function for discretizing data.
 * @constructor
 * @param {object} params - The parameters for this operator. The
 *   provided values should be valid options for the {@link bin} function.
 * @param {function(object): *} params.field - The data field to bin.
 */
function Bin(params) {
  Transform.call(this, null, params);
}
Bin.Definition = {
  'type': 'Bin',
  'metadata': {
    'modifies': true
  },
  'params': [{
    'name': 'field',
    'type': 'field',
    'required': true
  }, {
    'name': 'interval',
    'type': 'boolean',
    'default': true
  }, {
    'name': 'anchor',
    'type': 'number'
  }, {
    'name': 'maxbins',
    'type': 'number',
    'default': 20
  }, {
    'name': 'base',
    'type': 'number',
    'default': 10
  }, {
    'name': 'divide',
    'type': 'number',
    'array': true,
    'default': [5, 2]
  }, {
    'name': 'extent',
    'type': 'number',
    'array': true,
    'length': 2,
    'required': true
  }, {
    'name': 'span',
    'type': 'number'
  }, {
    'name': 'step',
    'type': 'number'
  }, {
    'name': 'steps',
    'type': 'number',
    'array': true
  }, {
    'name': 'minstep',
    'type': 'number',
    'default': 0
  }, {
    'name': 'nice',
    'type': 'boolean',
    'default': true
  }, {
    'name': 'name',
    'type': 'string'
  }, {
    'name': 'as',
    'type': 'string',
    'array': true,
    'length': 2,
    'default': ['bin0', 'bin1']
  }]
};
inherits(Bin, Transform, {
  transform(_, pulse) {
    const band = _.interval !== false,
      bins = this._bins(_),
      start = bins.start,
      step = bins.step,
      as = _.as || ['bin0', 'bin1'],
      b0 = as[0],
      b1 = as[1];
    let flag;
    if (_.modified()) {
      pulse = pulse.reflow(true);
      flag = pulse.SOURCE;
    } else {
      flag = pulse.modified(accessorFields(_.field)) ? pulse.ADD_MOD : pulse.ADD;
    }
    pulse.visit(flag, band ? t => {
      const v = bins(t);
      // minimum bin value (inclusive)
      t[b0] = v;
      // maximum bin value (exclusive)
      // use convoluted math for better floating point agreement
      // see https://github.com/vega/vega/issues/830
      // infinite values propagate through this formula! #2227
      t[b1] = v == null ? null : start + step * (1 + (v - start) / step);
    } : t => t[b0] = bins(t));
    return pulse.modifies(band ? as : b0);
  },
  _bins(_) {
    if (this.value && !_.modified()) {
      return this.value;
    }
    const field = _.field,
      bins = bin(_),
      step = bins.step;
    let start = bins.start,
      stop = start + Math.ceil((bins.stop - start) / step) * step,
      a,
      d;
    if ((a = _.anchor) != null) {
      d = a - (start + step * Math.floor((a - start) / step));
      start += d;
      stop += d;
    }
    const f = function (t) {
      let v = toNumber(field(t));
      return v == null ? null : v < start ? -Infinity : v > stop ? +Infinity : (v = Math.max(start, Math.min(v, stop - step)), start + step * Math.floor(EPSILON$1 + (v - start) / step));
    };
    f.start = start;
    f.stop = bins.stop;
    f.step = step;
    return this.value = accessor(f, accessorFields(field), _.name || 'bin_' + accessorName(field));
  }
});
function SortedList(idFunc, source, input) {
  const $ = idFunc;
  let data = source || [],
    add = input || [],
    rem = {},
    cnt = 0;
  return {
    add: t => add.push(t),
    remove: t => rem[$(t)] = ++cnt,
    size: () => data.length,
    data: (compare, resort) => {
      if (cnt) {
        data = data.filter(t => !rem[$(t)]);
        rem = {};
        cnt = 0;
      }
      if (resort && compare) {
        data.sort(compare);
      }
      if (add.length) {
        data = compare ? merge$3(compare, data, add.sort(compare)) : data.concat(add);
        add = [];
      }
      return data;
    }
  };
}

/**
 * Collects all data tuples that pass through this operator.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {function(*,*): number} [params.sort] - An optional
 *   comparator function for additionally sorting the collected tuples.
 */
function Collect$1(params) {
  Transform.call(this, [], params);
}
Collect$1.Definition = {
  'type': 'Collect',
  'metadata': {
    'source': true
  },
  'params': [{
    'name': 'sort',
    'type': 'compare'
  }]
};
inherits(Collect$1, Transform, {
  transform(_, pulse) {
    const out = pulse.fork(pulse.ALL),
      list = SortedList(tupleid, this.value, out.materialize(out.ADD).add),
      sort = _.sort,
      mod = pulse.changed() || sort && (_.modified('sort') || pulse.modified(sort.fields));
    out.visit(out.REM, list.remove);
    this.modified(mod);
    this.value = out.source = list.data(stableCompare(sort), mod);

    // propagate tree root if defined
    if (pulse.source && pulse.source.root) {
      this.value.root = pulse.source.root;
    }
    return out;
  }
});

/**
 * Generates a comparator function.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {Array<string|function>} params.fields - The fields to compare.
 * @param {Array<string>} [params.orders] - The sort orders.
 *   Each entry should be one of "ascending" (default) or "descending".
 */
function Compare$1(params) {
  Operator.call(this, null, update$5, params);
}
inherits(Compare$1, Operator);
function update$5(_) {
  return this.value && !_.modified() ? this.value : compare$1(_.fields, _.orders);
}

/**
 * Count regexp-defined pattern occurrences in a text field.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {function(object): *} params.field - An accessor for the text field.
 * @param {string} [params.pattern] - RegExp string defining the text pattern.
 * @param {string} [params.case] - One of 'lower', 'upper' or null (mixed) case.
 * @param {string} [params.stopwords] - RegExp string of words to ignore.
 */
function CountPattern(params) {
  Transform.call(this, null, params);
}
CountPattern.Definition = {
  'type': 'CountPattern',
  'metadata': {
    'generates': true,
    'changes': true
  },
  'params': [{
    'name': 'field',
    'type': 'field',
    'required': true
  }, {
    'name': 'case',
    'type': 'enum',
    'values': ['upper', 'lower', 'mixed'],
    'default': 'mixed'
  }, {
    'name': 'pattern',
    'type': 'string',
    'default': '[\\w"]+'
  }, {
    'name': 'stopwords',
    'type': 'string',
    'default': ''
  }, {
    'name': 'as',
    'type': 'string',
    'array': true,
    'length': 2,
    'default': ['text', 'count']
  }]
};
function tokenize(text, tcase, match) {
  switch (tcase) {
    case 'upper':
      text = text.toUpperCase();
      break;
    case 'lower':
      text = text.toLowerCase();
      break;
  }
  return text.match(match);
}
inherits(CountPattern, Transform, {
  transform(_, pulse) {
    const process = update => tuple => {
      var tokens = tokenize(get(tuple), _.case, match) || [],
        t;
      for (var i = 0, n = tokens.length; i < n; ++i) {
        if (!stop.test(t = tokens[i])) update(t);
      }
    };
    const init = this._parameterCheck(_, pulse),
      counts = this._counts,
      match = this._match,
      stop = this._stop,
      get = _.field,
      as = _.as || ['text', 'count'],
      add = process(t => counts[t] = 1 + (counts[t] || 0)),
      rem = process(t => counts[t] -= 1);
    if (init) {
      pulse.visit(pulse.SOURCE, add);
    } else {
      pulse.visit(pulse.ADD, add);
      pulse.visit(pulse.REM, rem);
    }
    return this._finish(pulse, as); // generate output tuples
  },
  _parameterCheck(_, pulse) {
    let init = false;
    if (_.modified('stopwords') || !this._stop) {
      this._stop = new RegExp('^' + (_.stopwords || '') + '$', 'i');
      init = true;
    }
    if (_.modified('pattern') || !this._match) {
      this._match = new RegExp(_.pattern || '[\\w\']+', 'g');
      init = true;
    }
    if (_.modified('field') || pulse.modified(_.field.fields)) {
      init = true;
    }
    if (init) this._counts = {};
    return init;
  },
  _finish(pulse, as) {
    const counts = this._counts,
      tuples = this._tuples || (this._tuples = {}),
      text = as[0],
      count = as[1],
      out = pulse.fork(pulse.NO_SOURCE | pulse.NO_FIELDS);
    let w, t, c;
    for (w in counts) {
      t = tuples[w];
      c = counts[w] || 0;
      if (!t && c) {
        tuples[w] = t = ingest$1({});
        t[text] = w;
        t[count] = c;
        out.add.push(t);
      } else if (c === 0) {
        if (t) out.rem.push(t);
        counts[w] = null;
        tuples[w] = null;
      } else if (t[count] !== c) {
        t[count] = c;
        out.mod.push(t);
      }
    }
    return out.modifies(as);
  }
});

/**
 * Perform a cross-product of a tuple stream with itself.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {function(object):boolean} [params.filter] - An optional filter
 *   function for selectively including tuples in the cross product.
 * @param {Array<string>} [params.as] - The names of the output fields.
 */
function Cross(params) {
  Transform.call(this, null, params);
}
Cross.Definition = {
  'type': 'Cross',
  'metadata': {
    'generates': true
  },
  'params': [{
    'name': 'filter',
    'type': 'expr'
  }, {
    'name': 'as',
    'type': 'string',
    'array': true,
    'length': 2,
    'default': ['a', 'b']
  }]
};
inherits(Cross, Transform, {
  transform(_, pulse) {
    const out = pulse.fork(pulse.NO_SOURCE),
      as = _.as || ['a', 'b'],
      a = as[0],
      b = as[1],
      reset = !this.value || pulse.changed(pulse.ADD_REM) || _.modified('as') || _.modified('filter');
    let data = this.value;
    if (reset) {
      if (data) out.rem = data;
      data = pulse.materialize(pulse.SOURCE).source;
      out.add = this.value = cross(data, a, b, _.filter || truthy);
    } else {
      out.mod = data;
    }
    out.source = this.value;
    return out.modifies(as);
  }
});
function cross(input, a, b, filter) {
  var data = [],
    t = {},
    n = input.length,
    i = 0,
    j,
    left;
  for (; i < n; ++i) {
    t[a] = left = input[i];
    for (j = 0; j < n; ++j) {
      t[b] = input[j];
      if (filter(t)) {
        data.push(ingest$1(t));
        t = {};
        t[a] = left;
      }
    }
  }
  return data;
}
const Distributions = {
  kde: kde,
  mixture: mixture$1,
  normal: gaussian,
  lognormal: lognormal,
  uniform: uniform
};
const DISTRIBUTIONS = 'distributions',
  FUNCTION = 'function',
  FIELD = 'field';

/**
 * Parse a parameter object for a probability distribution.
 * @param {object} def - The distribution parameter object.
 * @param {function():Array<object>} - A method for requesting
 *   source data. Used for distributions (such as KDE) that
 *   require sample data points. This method will only be
 *   invoked if the 'from' parameter for a target data source
 *   is not provided. Typically this method returns backing
 *   source data for a Pulse object.
 * @return {object} - The output distribution object.
 */
function parse$4(def, data) {
  const func = def[FUNCTION];
  if (!has$1(Distributions, func)) {
    error('Unknown distribution function: ' + func);
  }
  const d = Distributions[func]();
  for (const name in def) {
    // if data field, extract values
    if (name === FIELD) {
      d.data((def.from || data()).map(def[name]));
    }

    // if distribution mixture, recurse to parse each definition
    else if (name === DISTRIBUTIONS) {
      d[name](def[name].map(_ => parse$4(_, data)));
    }

    // otherwise, simply set the parameter
    else if (typeof d[name] === FUNCTION) {
      d[name](def[name]);
    }
  }
  return d;
}

/**
 * Grid sample points for a probability density. Given a distribution and
 * a sampling extent, will generate points suitable for plotting either
 * PDF (probability density function) or CDF (cumulative distribution
 * function) curves.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {object} params.distribution - The probability distribution. This
 *   is an object parameter dependent on the distribution type.
 * @param {string} [params.method='pdf'] - The distribution method to sample.
 *   One of 'pdf' or 'cdf'.
 * @param {Array<number>} [params.extent] - The [min, max] extent over which
 *   to sample the distribution. This argument is required in most cases, but
 *   can be omitted if the distribution (e.g., 'kde') supports a 'data' method
 *   that returns numerical sample points from which the extent can be deduced.
 * @param {number} [params.minsteps=25] - The minimum number of curve samples
 *   for plotting the density.
 * @param {number} [params.maxsteps=200] - The maximum number of curve samples
 *   for plotting the density.
 * @param {number} [params.steps] - The exact number of curve samples for
 *   plotting the density. If specified, overrides both minsteps and maxsteps
 *   to set an exact number of uniform samples. Useful in conjunction with
 *   a fixed extent to ensure consistent sample points for stacked densities.
 */
function Density(params) {
  Transform.call(this, null, params);
}
const distributions = [{
  'key': {
    'function': 'normal'
  },
  'params': [{
    'name': 'mean',
    'type': 'number',
    'default': 0
  }, {
    'name': 'stdev',
    'type': 'number',
    'default': 1
  }]
}, {
  'key': {
    'function': 'lognormal'
  },
  'params': [{
    'name': 'mean',
    'type': 'number',
    'default': 0
  }, {
    'name': 'stdev',
    'type': 'number',
    'default': 1
  }]
}, {
  'key': {
    'function': 'uniform'
  },
  'params': [{
    'name': 'min',
    'type': 'number',
    'default': 0
  }, {
    'name': 'max',
    'type': 'number',
    'default': 1
  }]
}, {
  'key': {
    'function': 'kde'
  },
  'params': [{
    'name': 'field',
    'type': 'field',
    'required': true
  }, {
    'name': 'from',
    'type': 'data'
  }, {
    'name': 'bandwidth',
    'type': 'number',
    'default': 0
  }]
}];
const mixture = {
  'key': {
    'function': 'mixture'
  },
  'params': [{
    'name': 'distributions',
    'type': 'param',
    'array': true,
    'params': distributions
  }, {
    'name': 'weights',
    'type': 'number',
    'array': true
  }]
};
Density.Definition = {
  'type': 'Density',
  'metadata': {
    'generates': true
  },
  'params': [{
    'name': 'extent',
    'type': 'number',
    'array': true,
    'length': 2
  }, {
    'name': 'steps',
    'type': 'number'
  }, {
    'name': 'minsteps',
    'type': 'number',
    'default': 25
  }, {
    'name': 'maxsteps',
    'type': 'number',
    'default': 200
  }, {
    'name': 'method',
    'type': 'string',
    'default': 'pdf',
    'values': ['pdf', 'cdf']
  }, {
    'name': 'distribution',
    'type': 'param',
    'params': distributions.concat(mixture)
  }, {
    'name': 'as',
    'type': 'string',
    'array': true,
    'default': ['value', 'density']
  }]
};
inherits(Density, Transform, {
  transform(_, pulse) {
    const out = pulse.fork(pulse.NO_SOURCE | pulse.NO_FIELDS);
    if (!this.value || pulse.changed() || _.modified()) {
      const dist = parse$4(_.distribution, source$1(pulse)),
        minsteps = _.steps || _.minsteps || 25,
        maxsteps = _.steps || _.maxsteps || 200;
      let method = _.method || 'pdf';
      if (method !== 'pdf' && method !== 'cdf') {
        error('Invalid density method: ' + method);
      }
      if (!_.extent && !dist.data) {
        error('Missing density extent parameter.');
      }
      method = dist[method];
      const as = _.as || ['value', 'density'],
        domain = _.extent || extent(dist.data()),
        values = sampleCurve(method, domain, minsteps, maxsteps).map(v => {
          const tuple = {};
          tuple[as[0]] = v[0];
          tuple[as[1]] = v[1];
          return ingest$1(tuple);
        });
      if (this.value) out.rem = this.value;
      this.value = out.add = out.source = values;
    }
    return out;
  }
});
function source$1(pulse) {
  return () => pulse.materialize(pulse.SOURCE).source;
}

// use either provided alias or accessor field name
function fieldNames(fields, as) {
  if (!fields) return null;
  return fields.map((f, i) => as[i] || accessorName(f));
}
function partition$1$1(data, groupby, field) {
  const groups = [],
    get = f => f(t);
  let map, i, n, t, k, g;

  // partition data points into groups
  if (groupby == null) {
    groups.push(data.map(field));
  } else {
    for (map = {}, i = 0, n = data.length; i < n; ++i) {
      t = data[i];
      k = groupby.map(get);
      g = map[k];
      if (!g) {
        map[k] = g = [];
        g.dims = k;
        groups.push(g);
      }
      g.push(field(t));
    }
  }
  return groups;
}
const Output$5 = 'bin';

/**
 * Dot density binning for dot plot construction.
 * Based on Leland Wilkinson, Dot Plots, The American Statistician, 1999.
 * https://www.cs.uic.edu/~wilkinson/Publications/dotplots.pdf
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {function(object): *} params.field - The value field to bin.
 * @param {Array<function(object): *>} [params.groupby] - An array of accessors to groupby.
 * @param {number} [params.step] - The step size (bin width) within which dots should be
 *   stacked. Defaults to 1/30 of the extent of the data *field*.
 * @param {boolean} [params.smooth=false] - A boolean flag indicating if dot density
 *   stacks should be smoothed to reduce variance.
 */
function DotBin(params) {
  Transform.call(this, null, params);
}
DotBin.Definition = {
  'type': 'DotBin',
  'metadata': {
    'modifies': true
  },
  'params': [{
    'name': 'field',
    'type': 'field',
    'required': true
  }, {
    'name': 'groupby',
    'type': 'field',
    'array': true
  }, {
    'name': 'step',
    'type': 'number'
  }, {
    'name': 'smooth',
    'type': 'boolean',
    'default': false
  }, {
    'name': 'as',
    'type': 'string',
    'default': Output$5
  }]
};
const autostep = (data, field) => span(extent(data, field)) / 30;
inherits(DotBin, Transform, {
  transform(_, pulse) {
    if (this.value && !(_.modified() || pulse.changed())) {
      return pulse; // early exit
    }
    const source = pulse.materialize(pulse.SOURCE).source,
      groups = partition$1$1(pulse.source, _.groupby, identity$6),
      smooth = _.smooth || false,
      field = _.field,
      step = _.step || autostep(source, field),
      sort = stableCompare((a, b) => field(a) - field(b)),
      as = _.as || Output$5,
      n = groups.length;

    // compute dotplot bins per group
    let min = Infinity,
      max = -Infinity,
      i = 0,
      j;
    for (; i < n; ++i) {
      const g = groups[i].sort(sort);
      j = -1;
      for (const v of dotbin(g, step, smooth, field)) {
        if (v < min) min = v;
        if (v > max) max = v;
        g[++j][as] = v;
      }
    }
    this.value = {
      start: min,
      stop: max,
      step: step
    };
    return pulse.reflow(true).modifies(as);
  }
});

/**
 * Wraps an expression function with access to external parameters.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {function} params.expr - The expression function. The
 *  function should accept both a datum and a parameter object.
 *  This operator's value will be a new function that wraps the
 *  expression function with access to this operator's parameters.
 */
function Expression$1(params) {
  Operator.call(this, null, update$4, params);
  this.modified(true);
}
inherits(Expression$1, Operator);
function update$4(_) {
  const expr = _.expr;
  return this.value && !_.modified('expr') ? this.value : accessor(datum => expr(datum, _), accessorFields(expr), accessorName(expr));
}

/**
 * Computes extents (min/max) for a data field.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {function(object): *} params.field - The field over which to compute extends.
 */
function Extent(params) {
  Transform.call(this, [undefined, undefined], params);
}
Extent.Definition = {
  'type': 'Extent',
  'metadata': {},
  'params': [{
    'name': 'field',
    'type': 'field',
    'required': true
  }]
};
inherits(Extent, Transform, {
  transform(_, pulse) {
    const extent = this.value,
      field = _.field,
      mod = pulse.changed() || pulse.modified(field.fields) || _.modified('field');
    let min = extent[0],
      max = extent[1];
    if (mod || min == null) {
      min = +Infinity;
      max = -Infinity;
    }
    pulse.visit(mod ? pulse.SOURCE : pulse.ADD, t => {
      const v = toNumber(field(t));
      if (v != null) {
        // NaNs will fail all comparisons!
        if (v < min) min = v;
        if (v > max) max = v;
      }
    });
    if (!Number.isFinite(min) || !Number.isFinite(max)) {
      let name = accessorName(field);
      if (name) name = ` for field "${name}"`;
      pulse.dataflow.warn(`Infinite extent${name}: [${min}, ${max}]`);
      min = max = undefined;
    }
    this.value = [min, max];
  }
});

/**
 * Provides a bridge between a parent transform and a target subflow that
 * consumes only a subset of the tuples that pass through the parent.
 * @constructor
 * @param {Pulse} pulse - A pulse to use as the value of this operator.
 * @param {Transform} parent - The parent transform (typically a Facet instance).
 */
function Subflow(pulse, parent) {
  Operator.call(this, pulse);
  this.parent = parent;
  this.count = 0;
}
inherits(Subflow, Operator, {
  /**
   * Routes pulses from this subflow to a target transform.
   * @param {Transform} target - A transform that receives the subflow of tuples.
   */
  connect(target) {
    this.detachSubflow = target.detachSubflow;
    this.targets().add(target);
    return target.source = this;
  },
  /**
   * Add an 'add' tuple to the subflow pulse.
   * @param {Tuple} t - The tuple being added.
   */
  add(t) {
    this.count += 1;
    this.value.add.push(t);
  },
  /**
   * Add a 'rem' tuple to the subflow pulse.
   * @param {Tuple} t - The tuple being removed.
   */
  rem(t) {
    this.count -= 1;
    this.value.rem.push(t);
  },
  /**
   * Add a 'mod' tuple to the subflow pulse.
   * @param {Tuple} t - The tuple being modified.
   */
  mod(t) {
    this.value.mod.push(t);
  },
  /**
   * Re-initialize this operator's pulse value.
   * @param {Pulse} pulse - The pulse to copy from.
   * @see Pulse.init
   */
  init(pulse) {
    this.value.init(pulse, pulse.NO_SOURCE);
  },
  /**
   * Evaluate this operator. This method overrides the
   * default behavior to simply return the contained pulse value.
   * @return {Pulse}
   */
  evaluate() {
    // assert: this.value.stamp === pulse.stamp
    return this.value;
  }
});

/**
 * Facets a dataflow into a set of subflows based on a key.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {function(Dataflow, string): Operator} params.subflow - A function
 *   that generates a subflow of operators and returns its root operator.
 * @param {function(object): *} params.key - The key field to facet by.
 */
function Facet$1(params) {
  Transform.call(this, {}, params);
  this._keys = fastmap(); // cache previously calculated key values

  // keep track of active subflows, use as targets array for listeners
  // this allows us to limit propagation to only updated subflows
  const a = this._targets = [];
  a.active = 0;
  a.forEach = f => {
    for (let i = 0, n = a.active; i < n; ++i) {
      f(a[i], i, a);
    }
  };
}
inherits(Facet$1, Transform, {
  activate(flow) {
    this._targets[this._targets.active++] = flow;
  },
  // parent argument provided by PreFacet subclass
  subflow(key, flow, pulse, parent) {
    const flows = this.value;
    let sf = has$1(flows, key) && flows[key],
      df,
      p;
    if (!sf) {
      p = parent || (p = this._group[key]) && p.tuple;
      df = pulse.dataflow;
      sf = new Subflow(pulse.fork(pulse.NO_SOURCE), this);
      df.add(sf).connect(flow(df, key, p));
      flows[key] = sf;
      this.activate(sf);
    } else if (sf.value.stamp < pulse.stamp) {
      sf.init(pulse);
      this.activate(sf);
    }
    return sf;
  },
  clean() {
    const flows = this.value;
    let detached = 0;
    for (const key in flows) {
      if (flows[key].count === 0) {
        const detach = flows[key].detachSubflow;
        if (detach) detach();
        delete flows[key];
        ++detached;
      }
    }

    // remove inactive targets from the active targets array
    if (detached) {
      const active = this._targets.filter(sf => sf && sf.count > 0);
      this.initTargets(active);
    }
  },
  initTargets(act) {
    const a = this._targets,
      n = a.length,
      m = act ? act.length : 0;
    let i = 0;
    for (; i < m; ++i) {
      a[i] = act[i];
    }
    for (; i < n && a[i] != null; ++i) {
      a[i] = null; // ensure old flows can be garbage collected
    }
    a.active = m;
  },
  transform(_, pulse) {
    const df = pulse.dataflow,
      key = _.key,
      flow = _.subflow,
      cache = this._keys,
      rekey = _.modified('key'),
      subflow = key => this.subflow(key, flow, pulse);
    this._group = _.group || {};
    this.initTargets(); // reset list of active subflows

    pulse.visit(pulse.REM, t => {
      const id = tupleid(t),
        k = cache.get(id);
      if (k !== undefined) {
        cache.delete(id);
        subflow(k).rem(t);
      }
    });
    pulse.visit(pulse.ADD, t => {
      const k = key(t);
      cache.set(tupleid(t), k);
      subflow(k).add(t);
    });
    if (rekey || pulse.modified(key.fields)) {
      pulse.visit(pulse.MOD, t => {
        const id = tupleid(t),
          k0 = cache.get(id),
          k1 = key(t);
        if (k0 === k1) {
          subflow(k1).mod(t);
        } else {
          cache.set(id, k1);
          subflow(k0).rem(t);
          subflow(k1).add(t);
        }
      });
    } else if (pulse.changed(pulse.MOD)) {
      pulse.visit(pulse.MOD, t => {
        subflow(cache.get(tupleid(t))).mod(t);
      });
    }
    if (rekey) {
      pulse.visit(pulse.REFLOW, t => {
        const id = tupleid(t),
          k0 = cache.get(id),
          k1 = key(t);
        if (k0 !== k1) {
          cache.set(id, k1);
          subflow(k0).rem(t);
          subflow(k1).add(t);
        }
      });
    }
    if (pulse.clean()) {
      df.runAfter(() => {
        this.clean();
        cache.clean();
      });
    } else if (cache.empty > df.cleanThreshold) {
      df.runAfter(cache.clean);
    }
    return pulse;
  }
});

/**
 * Generates one or more field accessor functions.
 * If the 'name' parameter is an array, an array of field accessors
 * will be created and the 'as' parameter will be ignored.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {string} params.name - The field name(s) to access.
 * @param {string} params.as - The accessor function name.
 */
function Field$1(params) {
  Operator.call(this, null, update$3, params);
}
inherits(Field$1, Operator);
function update$3(_) {
  return this.value && !_.modified() ? this.value : isArray(_.name) ? array$5(_.name).map(f => field$1(f)) : field$1(_.name, _.as);
}

/**
 * Filters data tuples according to a predicate function.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {function(object): *} params.expr - The predicate expression function
 *   that determines a tuple's filter status. Truthy values pass the filter.
 */
function Filter(params) {
  Transform.call(this, fastmap(), params);
}
Filter.Definition = {
  'type': 'Filter',
  'metadata': {
    'changes': true
  },
  'params': [{
    'name': 'expr',
    'type': 'expr',
    'required': true
  }]
};
inherits(Filter, Transform, {
  transform(_, pulse) {
    const df = pulse.dataflow,
      cache = this.value,
      // cache ids of filtered tuples
      output = pulse.fork(),
      add = output.add,
      rem = output.rem,
      mod = output.mod,
      test = _.expr;
    let isMod = true;
    pulse.visit(pulse.REM, t => {
      const id = tupleid(t);
      if (!cache.has(id)) rem.push(t);else cache.delete(id);
    });
    pulse.visit(pulse.ADD, t => {
      if (test(t, _)) add.push(t);else cache.set(tupleid(t), 1);
    });
    function revisit(t) {
      const id = tupleid(t),
        b = test(t, _),
        s = cache.get(id);
      if (b && s) {
        cache.delete(id);
        add.push(t);
      } else if (!b && !s) {
        cache.set(id, 1);
        rem.push(t);
      } else if (isMod && b && !s) {
        mod.push(t);
      }
    }
    pulse.visit(pulse.MOD, revisit);
    if (_.modified()) {
      isMod = false;
      pulse.visit(pulse.REFLOW, revisit);
    }
    if (cache.empty > df.cleanThreshold) df.runAfter(cache.clean);
    return output;
  }
});

/**
 * Flattens array-typed field values into new data objects.
 * If multiple fields are specified, they are treated as parallel arrays,
 * with output values included for each matching index (or null if missing).
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {Array<function(object): *>} params.fields - An array of field
 *   accessors for the tuple fields that should be flattened.
 * @param {string} [params.index] - Optional output field name for index
 *   value. If unspecified, no index field is included in the output.
 * @param {Array<string>} [params.as] - Output field names for flattened
 *   array fields. Any unspecified fields will use the field name provided
 *   by the fields accessors.
 */
function Flatten(params) {
  Transform.call(this, [], params);
}
Flatten.Definition = {
  'type': 'Flatten',
  'metadata': {
    'generates': true
  },
  'params': [{
    'name': 'fields',
    'type': 'field',
    'array': true,
    'required': true
  }, {
    'name': 'index',
    'type': 'string'
  }, {
    'name': 'as',
    'type': 'string',
    'array': true
  }]
};
inherits(Flatten, Transform, {
  transform(_, pulse) {
    const out = pulse.fork(pulse.NO_SOURCE),
      fields = _.fields,
      as = fieldNames(fields, _.as || []),
      index = _.index || null,
      m = as.length;

    // remove any previous results
    out.rem = this.value;

    // generate flattened tuples
    pulse.visit(pulse.SOURCE, t => {
      const arrays = fields.map(f => f(t)),
        maxlen = arrays.reduce((l, a) => Math.max(l, a.length), 0);
      let i = 0,
        j,
        d,
        v;
      for (; i < maxlen; ++i) {
        d = derive(t);
        for (j = 0; j < m; ++j) {
          d[as[j]] = (v = arrays[j][i]) == null ? null : v;
        }
        if (index) {
          d[index] = i;
        }
        out.add.push(d);
      }
    });
    this.value = out.source = out.add;
    if (index) out.modifies(index);
    return out.modifies(as);
  }
});

/**
 * Folds one more tuple fields into multiple tuples in which the field
 * name and values are available under new 'key' and 'value' fields.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {function(object): *} params.fields - An array of field accessors
 *   for the tuple fields that should be folded.
 * @param {Array<string>} [params.as] - Output field names for folded key
 *   and value fields, defaults to ['key', 'value'].
 */
function Fold(params) {
  Transform.call(this, [], params);
}
Fold.Definition = {
  'type': 'Fold',
  'metadata': {
    'generates': true
  },
  'params': [{
    'name': 'fields',
    'type': 'field',
    'array': true,
    'required': true
  }, {
    'name': 'as',
    'type': 'string',
    'array': true,
    'length': 2,
    'default': ['key', 'value']
  }]
};
inherits(Fold, Transform, {
  transform(_, pulse) {
    const out = pulse.fork(pulse.NO_SOURCE),
      fields = _.fields,
      fnames = fields.map(accessorName),
      as = _.as || ['key', 'value'],
      k = as[0],
      v = as[1],
      n = fields.length;
    out.rem = this.value;
    pulse.visit(pulse.SOURCE, t => {
      for (let i = 0, d; i < n; ++i) {
        d = derive(t);
        d[k] = fnames[i];
        d[v] = fields[i](t);
        out.add.push(d);
      }
    });
    this.value = out.source = out.add;
    return out.modifies(as);
  }
});

/**
 * Invokes a function for each data tuple and saves the results as a new field.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {function(object): *} params.expr - The formula function to invoke for each tuple.
 * @param {string} params.as - The field name under which to save the result.
 * @param {boolean} [params.initonly=false] - If true, the formula is applied to
 *   added tuples only, and does not update in response to modifications.
 */
function Formula(params) {
  Transform.call(this, null, params);
}
Formula.Definition = {
  'type': 'Formula',
  'metadata': {
    'modifies': true
  },
  'params': [{
    'name': 'expr',
    'type': 'expr',
    'required': true
  }, {
    'name': 'as',
    'type': 'string',
    'required': true
  }, {
    'name': 'initonly',
    'type': 'boolean'
  }]
};
inherits(Formula, Transform, {
  transform(_, pulse) {
    const func = _.expr,
      as = _.as,
      mod = _.modified(),
      flag = _.initonly ? pulse.ADD : mod ? pulse.SOURCE : pulse.modified(func.fields) || pulse.modified(as) ? pulse.ADD_MOD : pulse.ADD;
    if (mod) {
      // parameters updated, need to reflow
      pulse = pulse.materialize().reflow(true);
    }
    if (!_.initonly) {
      pulse.modifies(as);
    }
    return pulse.visit(flag, t => t[as] = func(t, _));
  }
});

/**
 * Generates data tuples using a provided generator function.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {function(Parameters): object} params.generator - A tuple generator
 *   function. This function is given the operator parameters as input.
 *   Changes to any additional parameters will not trigger re-calculation
 *   of previously generated tuples. Only future tuples are affected.
 * @param {number} params.size - The number of tuples to produce.
 */
function Generate(params) {
  Transform.call(this, [], params);
}
inherits(Generate, Transform, {
  transform(_, pulse) {
    const out = pulse.fork(pulse.ALL),
      gen = _.generator;
    let data = this.value,
      num = _.size - data.length,
      add,
      rem,
      t;
    if (num > 0) {
      // need more tuples, generate and add
      for (add = []; --num >= 0;) {
        add.push(t = ingest$1(gen(_)));
        data.push(t);
      }
      out.add = out.add.length ? out.materialize(out.ADD).add.concat(add) : add;
    } else {
      // need fewer tuples, remove
      rem = data.slice(0, -num);
      out.rem = out.rem.length ? out.materialize(out.REM).rem.concat(rem) : rem;
      data = data.slice(-num);
    }
    out.source = this.value = data;
    return out;
  }
});
const Methods$1 = {
  value: 'value',
  median: median,
  mean: mean,
  min: min$2,
  max: max$2
};
const Empty$1 = [];

/**
 * Impute missing values.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {function(object): *} params.field - The value field to impute.
 * @param {Array<function(object): *>} [params.groupby] - An array of
 *   accessors to determine series within which to perform imputation.
 * @param {function(object): *} params.key - An accessor for a key value.
 *   Each key value should be unique within a group. New tuples will be
 *   imputed for any key values that are not found within a group.
 * @param {Array<*>} [params.keyvals] - Optional array of required key
 *   values. New tuples will be imputed for any key values that are not
 *   found within a group. In addition, these values will be automatically
 *   augmented with the key values observed in the input data.
 * @param {string} [method='value'] - The imputation method to use. One of
 *   'value', 'mean', 'median', 'max', 'min'.
 * @param {*} [value=0] - The constant value to use for imputation
 *   when using method 'value'.
 */
function Impute(params) {
  Transform.call(this, [], params);
}
Impute.Definition = {
  'type': 'Impute',
  'metadata': {
    'changes': true
  },
  'params': [{
    'name': 'field',
    'type': 'field',
    'required': true
  }, {
    'name': 'key',
    'type': 'field',
    'required': true
  }, {
    'name': 'keyvals',
    'array': true
  }, {
    'name': 'groupby',
    'type': 'field',
    'array': true
  }, {
    'name': 'method',
    'type': 'enum',
    'default': 'value',
    'values': ['value', 'mean', 'median', 'max', 'min']
  }, {
    'name': 'value',
    'default': 0
  }]
};
function getValue$1(_) {
  var m = _.method || Methods$1.value,
    v;
  if (Methods$1[m] == null) {
    error('Unrecognized imputation method: ' + m);
  } else if (m === Methods$1.value) {
    v = _.value !== undefined ? _.value : 0;
    return () => v;
  } else {
    return Methods$1[m];
  }
}
function getField$1(_) {
  const f = _.field;
  return t => t ? f(t) : NaN;
}
inherits(Impute, Transform, {
  transform(_, pulse) {
    var out = pulse.fork(pulse.ALL),
      impute = getValue$1(_),
      field = getField$1(_),
      fName = accessorName(_.field),
      kName = accessorName(_.key),
      gNames = (_.groupby || []).map(accessorName),
      groups = partition$4(pulse.source, _.groupby, _.key, _.keyvals),
      curr = [],
      prev = this.value,
      m = groups.domain.length,
      group,
      value,
      gVals,
      kVal,
      g,
      i,
      j,
      l,
      n,
      t;
    for (g = 0, l = groups.length; g < l; ++g) {
      group = groups[g];
      gVals = group.values;
      value = NaN;

      // add tuples for missing values
      for (j = 0; j < m; ++j) {
        if (group[j] != null) continue;
        kVal = groups.domain[j];
        t = {
          _impute: true
        };
        for (i = 0, n = gVals.length; i < n; ++i) t[gNames[i]] = gVals[i];
        t[kName] = kVal;
        t[fName] = Number.isNaN(value) ? value = impute(group, field) : value;
        curr.push(ingest$1(t));
      }
    }

    // update pulse with imputed tuples
    if (curr.length) out.add = out.materialize(out.ADD).add.concat(curr);
    if (prev.length) out.rem = out.materialize(out.REM).rem.concat(prev);
    this.value = curr;
    return out;
  }
});
function partition$4(data, groupby, key, keyvals) {
  var get = f => f(t),
    groups = [],
    domain = keyvals ? keyvals.slice() : [],
    kMap = {},
    gMap = {},
    gVals,
    gKey,
    group,
    i,
    j,
    k,
    n,
    t;
  domain.forEach((k, i) => kMap[k] = i + 1);
  for (i = 0, n = data.length; i < n; ++i) {
    t = data[i];
    k = key(t);
    j = kMap[k] || (kMap[k] = domain.push(k));
    gKey = (gVals = groupby ? groupby.map(get) : Empty$1) + '';
    if (!(group = gMap[gKey])) {
      group = gMap[gKey] = [];
      groups.push(group);
      group.values = gVals;
    }
    group[j - 1] = t;
  }
  groups.domain = domain;
  return groups;
}

/**
 * Extend input tuples with aggregate values.
 * Calcuates aggregate values and joins them with the input stream.
 * @constructor
 */
function JoinAggregate(params) {
  Aggregate$1.call(this, params);
}
JoinAggregate.Definition = {
  'type': 'JoinAggregate',
  'metadata': {
    'modifies': true
  },
  'params': [{
    'name': 'groupby',
    'type': 'field',
    'array': true
  }, {
    'name': 'fields',
    'type': 'field',
    'null': true,
    'array': true
  }, {
    'name': 'ops',
    'type': 'enum',
    'array': true,
    'values': ValidAggregateOps
  }, {
    'name': 'as',
    'type': 'string',
    'null': true,
    'array': true
  }, {
    'name': 'key',
    'type': 'field'
  }]
};
inherits(JoinAggregate, Aggregate$1, {
  transform(_, pulse) {
    const aggr = this,
      mod = _.modified();
    let cells;

    // process all input tuples to calculate aggregates
    if (aggr.value && (mod || pulse.modified(aggr._inputs, true))) {
      cells = aggr.value = mod ? aggr.init(_) : {};
      pulse.visit(pulse.SOURCE, t => aggr.add(t));
    } else {
      cells = aggr.value = aggr.value || this.init(_);
      pulse.visit(pulse.REM, t => aggr.rem(t));
      pulse.visit(pulse.ADD, t => aggr.add(t));
    }

    // update aggregation cells
    aggr.changes();

    // write aggregate values to input tuples
    pulse.visit(pulse.SOURCE, t => {
      extend$1(t, cells[aggr.cellkey(t)].tuple);
    });
    return pulse.reflow(mod).modifies(this._outputs);
  },
  changes() {
    const adds = this._adds,
      mods = this._mods;
    let i, n;
    for (i = 0, n = this._alen; i < n; ++i) {
      this.celltuple(adds[i]);
      adds[i] = null; // for garbage collection
    }
    for (i = 0, n = this._mlen; i < n; ++i) {
      this.celltuple(mods[i]);
      mods[i] = null; // for garbage collection
    }
    this._alen = this._mlen = 0; // reset list of active cells
  }
});

/**
 * Compute kernel density estimates (KDE) for one or more data groups.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {Array<function(object): *>} [params.groupby] - An array of accessors
 *   to groupby.
 * @param {function(object): *} params.field - An accessor for the data field
 *   to estimate.
 * @param {number} [params.bandwidth=0] - The KDE kernel bandwidth.
 *   If zero or unspecified, the bandwidth is automatically determined.
 * @param {boolean} [params.counts=false] - A boolean flag indicating if the
 *   output values should be probability estimates (false, default) or
 *   smoothed counts (true).
 * @param {string} [params.cumulative=false] - A boolean flag indicating if a
 *   density (false) or cumulative distribution (true) should be generated.
 * @param {Array<number>} [params.extent] - The domain extent over which to
 *   plot the density. If unspecified, the [min, max] data extent is used.
 * @param {string} [params.resolve='independent'] - Indicates how parameters for
 *   multiple densities should be resolved. If "independent" (the default), each
 *   density may have its own domain extent and dynamic number of curve sample
 *   steps. If "shared", the KDE transform will ensure that all densities are
 *   defined over a shared domain and curve steps, enabling stacking.
 * @param {number} [params.minsteps=25] - The minimum number of curve samples
 *   for plotting the density.
 * @param {number} [params.maxsteps=200] - The maximum number of curve samples
 *   for plotting the density.
 * @param {number} [params.steps] - The exact number of curve samples for
 *   plotting the density. If specified, overrides both minsteps and maxsteps
 *   to set an exact number of uniform samples. Useful in conjunction with
 *   a fixed extent to ensure consistent sample points for stacked densities.
 */
function KDE(params) {
  Transform.call(this, null, params);
}
KDE.Definition = {
  'type': 'KDE',
  'metadata': {
    'generates': true
  },
  'params': [{
    'name': 'groupby',
    'type': 'field',
    'array': true
  }, {
    'name': 'field',
    'type': 'field',
    'required': true
  }, {
    'name': 'cumulative',
    'type': 'boolean',
    'default': false
  }, {
    'name': 'counts',
    'type': 'boolean',
    'default': false
  }, {
    'name': 'bandwidth',
    'type': 'number',
    'default': 0
  }, {
    'name': 'extent',
    'type': 'number',
    'array': true,
    'length': 2
  }, {
    'name': 'resolve',
    'type': 'enum',
    'values': ['shared', 'independent'],
    'default': 'independent'
  }, {
    'name': 'steps',
    'type': 'number'
  }, {
    'name': 'minsteps',
    'type': 'number',
    'default': 25
  }, {
    'name': 'maxsteps',
    'type': 'number',
    'default': 200
  }, {
    'name': 'as',
    'type': 'string',
    'array': true,
    'default': ['value', 'density']
  }]
};
inherits(KDE, Transform, {
  transform(_, pulse) {
    const out = pulse.fork(pulse.NO_SOURCE | pulse.NO_FIELDS);
    if (!this.value || pulse.changed() || _.modified()) {
      const source = pulse.materialize(pulse.SOURCE).source,
        groups = partition$1$1(source, _.groupby, _.field),
        names = (_.groupby || []).map(accessorName),
        bandwidth = _.bandwidth,
        method = _.cumulative ? 'cdf' : 'pdf',
        as = _.as || ['value', 'density'],
        values = [];
      let domain = _.extent,
        minsteps = _.steps || _.minsteps || 25,
        maxsteps = _.steps || _.maxsteps || 200;
      if (method !== 'pdf' && method !== 'cdf') {
        error('Invalid density method: ' + method);
      }
      if (_.resolve === 'shared') {
        if (!domain) domain = extent(source, _.field);
        minsteps = maxsteps = _.steps || maxsteps;
      }
      groups.forEach(g => {
        const density = kde(g, bandwidth)[method],
          scale = _.counts ? g.length : 1,
          local = domain || extent(g);
        sampleCurve(density, local, minsteps, maxsteps).forEach(v => {
          const t = {};
          for (let i = 0; i < names.length; ++i) {
            t[names[i]] = g.dims[i];
          }
          t[as[0]] = v[0];
          t[as[1]] = v[1] * scale;
          values.push(ingest$1(t));
        });
      });
      if (this.value) out.rem = this.value;
      this.value = out.add = out.source = values;
    }
    return out;
  }
});

/**
 * Generates a key function.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {Array<string>} params.fields - The field name(s) for the key function.
 * @param {boolean} params.flat - A boolean flag indicating if the field names
 *  should be treated as flat property names, side-stepping nested field
 *  lookups normally indicated by dot or bracket notation.
 */
function Key$1(params) {
  Operator.call(this, null, update$2, params);
}
inherits(Key$1, Operator);
function update$2(_) {
  return this.value && !_.modified() ? this.value : key(_.fields, _.flat);
}

/**
 * Load and parse data from an external source. Marshalls parameter
 * values and then invokes the Dataflow request method.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {string} params.url - The URL to load from.
 * @param {object} params.format - The data format options.
 */
function Load$1(params) {
  Transform.call(this, [], params);
  this._pending = null;
}
inherits(Load$1, Transform, {
  transform(_, pulse) {
    const df = pulse.dataflow;
    if (this._pending) {
      // update state and return pulse
      return output(this, pulse, this._pending);
    }
    if (stop(_)) return pulse.StopPropagation;
    if (_.values) {
      // parse and ingest values, return output pulse
      return output(this, pulse, df.parse(_.values, _.format));
    } else if (_.async) {
      // return promise for non-blocking async loading
      const p = df.request(_.url, _.format).then(res => {
        this._pending = array$5(res.data);
        return df => df.touch(this);
      });
      return {
        async: p
      };
    } else {
      // return promise for synchronous loading
      return df.request(_.url, _.format).then(res => output(this, pulse, array$5(res.data)));
    }
  }
});
function stop(_) {
  return _.modified('async') && !(_.modified('values') || _.modified('url') || _.modified('format'));
}
function output(op, pulse, data) {
  data.forEach(ingest$1);
  const out = pulse.fork(pulse.NO_FIELDS & pulse.NO_SOURCE);
  out.rem = op.value;
  op.value = out.source = out.add = data;
  op._pending = null;
  if (out.rem.length) out.clean(true);
  return out;
}

/**
 * Extend tuples by joining them with values from a lookup table.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {Map} params.index - The lookup table map.
 * @param {Array<function(object): *} params.fields - The fields to lookup.
 * @param {Array<string>} params.as - Output field names for each lookup value.
 * @param {*} [params.default] - A default value to use if lookup fails.
 */
function Lookup(params) {
  Transform.call(this, {}, params);
}
Lookup.Definition = {
  'type': 'Lookup',
  'metadata': {
    'modifies': true
  },
  'params': [{
    'name': 'index',
    'type': 'index',
    'params': [{
      'name': 'from',
      'type': 'data',
      'required': true
    }, {
      'name': 'key',
      'type': 'field',
      'required': true
    }]
  }, {
    'name': 'values',
    'type': 'field',
    'array': true
  }, {
    'name': 'fields',
    'type': 'field',
    'array': true,
    'required': true
  }, {
    'name': 'as',
    'type': 'string',
    'array': true
  }, {
    'name': 'default',
    'default': null
  }]
};
inherits(Lookup, Transform, {
  transform(_, pulse) {
    const keys = _.fields,
      index = _.index,
      values = _.values,
      defaultValue = _.default == null ? null : _.default,
      reset = _.modified(),
      n = keys.length;
    let flag = reset ? pulse.SOURCE : pulse.ADD,
      out = pulse,
      as = _.as,
      set,
      m,
      mods;
    if (values) {
      m = values.length;
      if (n > 1 && !as) {
        error('Multi-field lookup requires explicit "as" parameter.');
      }
      if (as && as.length !== n * m) {
        error('The "as" parameter has too few output field names.');
      }
      as = as || values.map(accessorName);
      set = function (t) {
        for (var i = 0, k = 0, j, v; i < n; ++i) {
          v = index.get(keys[i](t));
          if (v == null) for (j = 0; j < m; ++j, ++k) t[as[k]] = defaultValue;else for (j = 0; j < m; ++j, ++k) t[as[k]] = values[j](v);
        }
      };
    } else {
      if (!as) {
        error('Missing output field names.');
      }
      set = function (t) {
        for (var i = 0, v; i < n; ++i) {
          v = index.get(keys[i](t));
          t[as[i]] = v == null ? defaultValue : v;
        }
      };
    }
    if (reset) {
      out = pulse.reflow(true);
    } else {
      mods = keys.some(k => pulse.modified(k.fields));
      flag |= mods ? pulse.MOD : 0;
    }
    pulse.visit(flag, set);
    return out.modifies(as);
  }
});

/**
 * Computes global min/max extents over a collection of extents.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {Array<Array<number>>} params.extents - The input extents.
 */
function MultiExtent$1(params) {
  Operator.call(this, null, update$1, params);
}
inherits(MultiExtent$1, Operator);
function update$1(_) {
  if (this.value && !_.modified()) {
    return this.value;
  }
  const ext = _.extents,
    n = ext.length;
  let min = +Infinity,
    max = -Infinity,
    i,
    e;
  for (i = 0; i < n; ++i) {
    e = ext[i];
    if (e[0] < min) min = e[0];
    if (e[1] > max) max = e[1];
  }
  return [min, max];
}

/**
 * Merge a collection of value arrays.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {Array<Array<*>>} params.values - The input value arrrays.
 */
function MultiValues$1(params) {
  Operator.call(this, null, update, params);
}
inherits(MultiValues$1, Operator);
function update(_) {
  return this.value && !_.modified() ? this.value : _.values.reduce((data, _) => data.concat(_), []);
}

/**
 * Operator whose value is simply its parameter hash. This operator is
 * useful for enabling reactive updates to values of nested objects.
 * @constructor
 * @param {object} params - The parameters for this operator.
 */
function Params$2(params) {
  Transform.call(this, null, params);
}
inherits(Params$2, Transform, {
  transform(_, pulse) {
    this.modified(_.modified());
    this.value = _;
    return pulse.fork(pulse.NO_SOURCE | pulse.NO_FIELDS); // do not pass tuples
  }
});

/**
 * Aggregate and pivot selected field values to become new fields.
 * This operator is useful to construction cross-tabulations.
 * @constructor
 * @param {Array<function(object): *>} [params.groupby] - An array of accessors
 *  to groupby. These fields act just like groupby fields of an Aggregate transform.
 * @param {function(object): *} params.field - The field to pivot on. The unique
 *  values of this field become new field names in the output stream.
 * @param {function(object): *} params.value - The field to populate pivoted fields.
 *  The aggregate values of this field become the values of the new pivoted fields.
 * @param {string} [params.op] - The aggregation operation for the value field,
 *  applied per cell in the output stream. The default is "sum".
 * @param {number} [params.limit] - An optional parameter indicating the maximum
 *  number of pivoted fields to generate. The pivoted field names are sorted in
 *  ascending order prior to enforcing the limit.
 */
function Pivot(params) {
  Aggregate$1.call(this, params);
}
Pivot.Definition = {
  'type': 'Pivot',
  'metadata': {
    'generates': true,
    'changes': true
  },
  'params': [{
    'name': 'groupby',
    'type': 'field',
    'array': true
  }, {
    'name': 'field',
    'type': 'field',
    'required': true
  }, {
    'name': 'value',
    'type': 'field',
    'required': true
  }, {
    'name': 'op',
    'type': 'enum',
    'values': ValidAggregateOps,
    'default': 'sum'
  }, {
    'name': 'limit',
    'type': 'number',
    'default': 0
  }, {
    'name': 'key',
    'type': 'field'
  }]
};
inherits(Pivot, Aggregate$1, {
  _transform: Aggregate$1.prototype.transform,
  transform(_, pulse) {
    return this._transform(aggregateParams(_, pulse), pulse);
  }
});

// Shoehorn a pivot transform into an aggregate transform!
// First collect all unique pivot field values.
// Then generate aggregate fields for each output pivot field.
function aggregateParams(_, pulse) {
  const key = _.field,
    value = _.value,
    op = (_.op === 'count' ? '__count__' : _.op) || 'sum',
    fields = accessorFields(key).concat(accessorFields(value)),
    keys = pivotKeys(key, _.limit || 0, pulse);

  // if data stream content changes, pivot fields may change
  // flag parameter modification to ensure re-initialization
  if (pulse.changed()) _.set('__pivot__', null, null, true);
  return {
    key: _.key,
    groupby: _.groupby,
    ops: keys.map(() => op),
    fields: keys.map(k => get$4(k, key, value, fields)),
    as: keys.map(k => k + ''),
    modified: _.modified.bind(_)
  };
}

// Generate aggregate field accessor.
// Output NaN for non-existent values; aggregator will ignore!
function get$4(k, key, value, fields) {
  return accessor(d => key(d) === k ? value(d) : NaN, fields, k + '');
}

// Collect (and optionally limit) all unique pivot values.
function pivotKeys(key, limit, pulse) {
  const map = {},
    list = [];
  pulse.visit(pulse.SOURCE, t => {
    const k = key(t);
    if (!map[k]) {
      map[k] = 1;
      list.push(k);
    }
  });
  list.sort(ascending$2);
  return limit ? list.slice(0, limit) : list;
}

/**
 * Partitions pre-faceted data into tuple subflows.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {function(Dataflow, string): Operator} params.subflow - A function
 *   that generates a subflow of operators and returns its root operator.
 * @param {function(object): Array<object>} params.field - The field
 *   accessor for an array of subflow tuple objects.
 */
function PreFacet$1(params) {
  Facet$1.call(this, params);
}
inherits(PreFacet$1, Facet$1, {
  transform(_, pulse) {
    const flow = _.subflow,
      field = _.field,
      subflow = t => this.subflow(tupleid(t), flow, pulse, t);
    if (_.modified('field') || field && pulse.modified(accessorFields(field))) {
      error('PreFacet does not support field modification.');
    }
    this.initTargets(); // reset list of active subflows

    if (field) {
      pulse.visit(pulse.MOD, t => {
        const sf = subflow(t);
        field(t).forEach(_ => sf.mod(_));
      });
      pulse.visit(pulse.ADD, t => {
        const sf = subflow(t);
        field(t).forEach(_ => sf.add(ingest$1(_)));
      });
      pulse.visit(pulse.REM, t => {
        const sf = subflow(t);
        field(t).forEach(_ => sf.rem(_));
      });
    } else {
      pulse.visit(pulse.MOD, t => subflow(t).mod(t));
      pulse.visit(pulse.ADD, t => subflow(t).add(t));
      pulse.visit(pulse.REM, t => subflow(t).rem(t));
    }
    if (pulse.clean()) {
      pulse.runAfter(() => this.clean());
    }
    return pulse;
  }
});

/**
 * Performs a relational projection, copying selected fields from source
 * tuples to a new set of derived tuples.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {Array<function(object): *} params.fields - The fields to project,
 *   as an array of field accessors. If unspecified, all fields will be
 *   copied with names unchanged.
 * @param {Array<string>} [params.as] - Output field names for each projected
 *   field. Any unspecified fields will use the field name provided by
 *   the field accessor.
 */
function Project(params) {
  Transform.call(this, null, params);
}
Project.Definition = {
  'type': 'Project',
  'metadata': {
    'generates': true,
    'changes': true
  },
  'params': [{
    'name': 'fields',
    'type': 'field',
    'array': true
  }, {
    'name': 'as',
    'type': 'string',
    'null': true,
    'array': true
  }]
};
inherits(Project, Transform, {
  transform(_, pulse) {
    const out = pulse.fork(pulse.NO_SOURCE),
      fields = _.fields,
      as = fieldNames(_.fields, _.as || []),
      derive = fields ? (s, t) => project(s, t, fields, as) : rederive;
    let lut;
    if (this.value) {
      lut = this.value;
    } else {
      pulse = pulse.addAll();
      lut = this.value = {};
    }
    pulse.visit(pulse.REM, t => {
      const id = tupleid(t);
      out.rem.push(lut[id]);
      lut[id] = null;
    });
    pulse.visit(pulse.ADD, t => {
      const dt = derive(t, ingest$1({}));
      lut[tupleid(t)] = dt;
      out.add.push(dt);
    });
    pulse.visit(pulse.MOD, t => {
      out.mod.push(derive(t, lut[tupleid(t)]));
    });
    return out;
  }
});
function project(s, t, fields, as) {
  for (let i = 0, n = fields.length; i < n; ++i) {
    t[as[i]] = fields[i](s);
  }
  return t;
}

/**
 * Proxy the value of another operator as a pure signal value.
 * Ensures no tuples are propagated.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {*} params.value - The value to proxy, becomes the value of this operator.
 */
function Proxy$2(params) {
  Transform.call(this, null, params);
}
inherits(Proxy$2, Transform, {
  transform(_, pulse) {
    this.value = _.value;
    return _.modified('value') ? pulse.fork(pulse.NO_SOURCE | pulse.NO_FIELDS) : pulse.StopPropagation;
  }
});

/**
 * Generates sample quantile values from an input data stream.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {function(object): *} params.field - An accessor for the data field
 *   over which to calculate quantile values.
 * @param {Array<function(object): *>} [params.groupby] - An array of accessors
 *   to groupby.
 * @param {Array<number>} [params.probs] - An array of probabilities in
 *   the range (0, 1) for which to compute quantile values. If not specified,
 *   the *step* parameter will be used.
 * @param {Array<number>} [params.step=0.01] - A probability step size for
 *   sampling quantile values. All values from one-half the step size up to
 *   1 (exclusive) will be sampled. This parameter is only used if the
 *   *quantiles* parameter is not provided.
 */
function Quantile$1(params) {
  Transform.call(this, null, params);
}
Quantile$1.Definition = {
  'type': 'Quantile',
  'metadata': {
    'generates': true,
    'changes': true
  },
  'params': [{
    'name': 'groupby',
    'type': 'field',
    'array': true
  }, {
    'name': 'field',
    'type': 'field',
    'required': true
  }, {
    'name': 'probs',
    'type': 'number',
    'array': true
  }, {
    'name': 'step',
    'type': 'number',
    'default': 0.01
  }, {
    'name': 'as',
    'type': 'string',
    'array': true,
    'default': ['prob', 'value']
  }]
};
const EPSILON$2 = 1e-14;
inherits(Quantile$1, Transform, {
  transform(_, pulse) {
    const out = pulse.fork(pulse.NO_SOURCE | pulse.NO_FIELDS),
      as = _.as || ['prob', 'value'];
    if (this.value && !_.modified() && !pulse.changed()) {
      out.source = this.value;
      return out;
    }
    const source = pulse.materialize(pulse.SOURCE).source,
      groups = partition$1$1(source, _.groupby, _.field),
      names = (_.groupby || []).map(accessorName),
      values = [],
      step = _.step || 0.01,
      p = _.probs || range$3(step / 2, 1 - EPSILON$2, step),
      n = p.length;
    groups.forEach(g => {
      const q = quantiles(g, p);
      for (let i = 0; i < n; ++i) {
        const t = {};
        for (let i = 0; i < names.length; ++i) {
          t[names[i]] = g.dims[i];
        }
        t[as[0]] = p[i];
        t[as[1]] = q[i];
        values.push(ingest$1(t));
      }
    });
    if (this.value) out.rem = this.value;
    this.value = out.add = out.source = values;
    return out;
  }
});

/**
 * Relays a data stream between data processing pipelines.
 * If the derive parameter is set, this transform will create derived
 * copies of observed tuples. This provides derived data streams in which
 * modifications to the tuples do not pollute an upstream data source.
 * @param {object} params - The parameters for this operator.
 * @param {number} [params.derive=false] - Boolean flag indicating if
 *   the transform should make derived copies of incoming tuples.
 * @constructor
 */
function Relay$1(params) {
  Transform.call(this, null, params);
}
inherits(Relay$1, Transform, {
  transform(_, pulse) {
    let out, lut;
    if (this.value) {
      lut = this.value;
    } else {
      out = pulse = pulse.addAll();
      lut = this.value = {};
    }
    if (_.derive) {
      out = pulse.fork(pulse.NO_SOURCE);
      pulse.visit(pulse.REM, t => {
        const id = tupleid(t);
        out.rem.push(lut[id]);
        lut[id] = null;
      });
      pulse.visit(pulse.ADD, t => {
        const dt = derive(t);
        lut[tupleid(t)] = dt;
        out.add.push(dt);
      });
      pulse.visit(pulse.MOD, t => {
        const dt = lut[tupleid(t)];
        for (const k in t) {
          dt[k] = t[k];
          // down stream writes may overwrite re-derived tuples
          // conservatively mark all source fields as modified
          out.modifies(k);
        }
        out.mod.push(dt);
      });
    }
    return out;
  }
});

/**
 * Samples tuples passing through this operator.
 * Uses reservoir sampling to maintain a representative sample.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {number} [params.size=1000] - The maximum number of samples.
 */
function Sample(params) {
  Transform.call(this, [], params);
  this.count = 0;
}
Sample.Definition = {
  'type': 'Sample',
  'metadata': {},
  'params': [{
    'name': 'size',
    'type': 'number',
    'default': 1000
  }]
};
inherits(Sample, Transform, {
  transform(_, pulse) {
    const out = pulse.fork(pulse.NO_SOURCE),
      mod = _.modified('size'),
      num = _.size,
      map = this.value.reduce((m, t) => (m[tupleid(t)] = 1, m), {});
    let res = this.value,
      cnt = this.count,
      cap = 0;

    // sample reservoir update function
    function update(t) {
      let p, idx;
      if (res.length < num) {
        res.push(t);
      } else {
        idx = ~~((cnt + 1) * random());
        if (idx < res.length && idx >= cap) {
          p = res[idx];
          if (map[tupleid(p)]) out.rem.push(p); // eviction
          res[idx] = t;
        }
      }
      ++cnt;
    }
    if (pulse.rem.length) {
      // find all tuples that should be removed, add to output
      pulse.visit(pulse.REM, t => {
        const id = tupleid(t);
        if (map[id]) {
          map[id] = -1;
          out.rem.push(t);
        }
        --cnt;
      });

      // filter removed tuples out of the sample reservoir
      res = res.filter(t => map[tupleid(t)] !== -1);
    }
    if ((pulse.rem.length || mod) && res.length < num && pulse.source) {
      // replenish sample if backing data source is available
      cap = cnt = res.length;
      pulse.visit(pulse.SOURCE, t => {
        // update, but skip previously sampled tuples
        if (!map[tupleid(t)]) update(t);
      });
      cap = -1;
    }
    if (mod && res.length > num) {
      const n = res.length - num;
      for (let i = 0; i < n; ++i) {
        map[tupleid(res[i])] = -1;
        out.rem.push(res[i]);
      }
      res = res.slice(n);
    }
    if (pulse.mod.length) {
      // propagate modified tuples in the sample reservoir
      pulse.visit(pulse.MOD, t => {
        if (map[tupleid(t)]) out.mod.push(t);
      });
    }
    if (pulse.add.length) {
      // update sample reservoir
      pulse.visit(pulse.ADD, update);
    }
    if (pulse.add.length || cap < 0) {
      // output newly added tuples
      out.add = res.filter(t => !map[tupleid(t)]);
    }
    this.count = cnt;
    this.value = out.source = res;
    return out;
  }
});

/**
 * Generates data tuples for a specified sequence range of numbers.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {number} params.start - The first number in the sequence.
 * @param {number} params.stop - The last number (exclusive) in the sequence.
 * @param {number} [params.step=1] - The step size between numbers in the sequence.
 */
function Sequence(params) {
  Transform.call(this, null, params);
}
Sequence.Definition = {
  'type': 'Sequence',
  'metadata': {
    'generates': true,
    'changes': true
  },
  'params': [{
    'name': 'start',
    'type': 'number',
    'required': true
  }, {
    'name': 'stop',
    'type': 'number',
    'required': true
  }, {
    'name': 'step',
    'type': 'number',
    'default': 1
  }, {
    'name': 'as',
    'type': 'string',
    'default': 'data'
  }]
};
inherits(Sequence, Transform, {
  transform(_, pulse) {
    if (this.value && !_.modified()) return;
    const out = pulse.materialize().fork(pulse.MOD),
      as = _.as || 'data';
    out.rem = this.value ? pulse.rem.concat(this.value) : pulse.rem;
    this.value = range$3(_.start, _.stop, _.step || 1).map(v => {
      const t = {};
      t[as] = v;
      return ingest$1(t);
    });
    out.add = pulse.add.concat(this.value);
    return out;
  }
});

/**
 * Propagates a new pulse without any tuples so long as the input
 * pulse contains some added, removed or modified tuples.
 * @param {object} params - The parameters for this operator.
 * @constructor
 */
function Sieve$1(params) {
  Transform.call(this, null, params);
  this.modified(true); // always treat as modified
}
inherits(Sieve$1, Transform, {
  transform(_, pulse) {
    this.value = pulse.source;
    return pulse.changed() ? pulse.fork(pulse.NO_SOURCE | pulse.NO_FIELDS) : pulse.StopPropagation;
  }
});

/**
 * Discretize dates to specific time units.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {function(object): *} params.field - The data field containing date/time values.
 */
function TimeUnit(params) {
  Transform.call(this, null, params);
}
const OUTPUT = ['unit0', 'unit1'];
TimeUnit.Definition = {
  'type': 'TimeUnit',
  'metadata': {
    'modifies': true
  },
  'params': [{
    'name': 'field',
    'type': 'field',
    'required': true
  }, {
    'name': 'interval',
    'type': 'boolean',
    'default': true
  }, {
    'name': 'units',
    'type': 'enum',
    'values': TIME_UNITS,
    'array': true
  }, {
    'name': 'step',
    'type': 'number',
    'default': 1
  }, {
    'name': 'maxbins',
    'type': 'number',
    'default': 40
  }, {
    'name': 'extent',
    'type': 'date',
    'array': true
  }, {
    'name': 'timezone',
    'type': 'enum',
    'default': 'local',
    'values': ['local', 'utc']
  }, {
    'name': 'as',
    'type': 'string',
    'array': true,
    'length': 2,
    'default': OUTPUT
  }]
};
inherits(TimeUnit, Transform, {
  transform(_, pulse) {
    const field = _.field,
      band = _.interval !== false,
      utc = _.timezone === 'utc',
      floor = this._floor(_, pulse),
      offset = (utc ? utcInterval : timeInterval)(floor.unit).offset,
      as = _.as || OUTPUT,
      u0 = as[0],
      u1 = as[1],
      step = floor.step;
    let min = floor.start || Infinity,
      max = floor.stop || -Infinity,
      flag = pulse.ADD;
    if (_.modified() || pulse.changed(pulse.REM) || pulse.modified(accessorFields(field))) {
      pulse = pulse.reflow(true);
      flag = pulse.SOURCE;
      min = Infinity;
      max = -Infinity;
    }
    pulse.visit(flag, t => {
      const v = field(t);
      let a, b;
      if (v == null) {
        t[u0] = null;
        if (band) t[u1] = null;
      } else {
        t[u0] = a = b = floor(v);
        if (band) t[u1] = b = offset(a, step);
        if (a < min) min = a;
        if (b > max) max = b;
      }
    });
    floor.start = min;
    floor.stop = max;
    return pulse.modifies(band ? as : u0);
  },
  _floor(_, pulse) {
    const utc = _.timezone === 'utc';

    // get parameters
    const {
      units,
      step
    } = _.units ? {
      units: _.units,
      step: _.step || 1
    } : bin$1({
      extent: _.extent || extent(pulse.materialize(pulse.SOURCE).source, _.field),
      maxbins: _.maxbins
    });

    // check / standardize time units
    const tunits = timeUnits(units),
      prev = this.value || {},
      floor = (utc ? utcFloor : timeFloor)(tunits, step);
    floor.unit = peek$1(tunits);
    floor.units = tunits;
    floor.step = step;
    floor.start = prev.start;
    floor.stop = prev.stop;
    return this.value = floor;
  }
});

/**
 * An index that maps from unique, string-coerced, field values to tuples.
 * Assumes that the field serves as a unique key with no duplicate values.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {function(object): *} params.field - The field accessor to index.
 */
function TupleIndex(params) {
  Transform.call(this, fastmap(), params);
}
inherits(TupleIndex, Transform, {
  transform(_, pulse) {
    const df = pulse.dataflow,
      field = _.field,
      index = this.value,
      set = t => index.set(field(t), t);
    let mod = true;
    if (_.modified('field') || pulse.modified(field.fields)) {
      index.clear();
      pulse.visit(pulse.SOURCE, set);
    } else if (pulse.changed()) {
      pulse.visit(pulse.REM, t => index.delete(field(t)));
      pulse.visit(pulse.ADD, set);
    } else {
      mod = false;
    }
    this.modified(mod);
    if (index.empty > df.cleanThreshold) df.runAfter(index.clean);
    return pulse.fork();
  }
});

/**
 * Extracts an array of values. Assumes the source data has already been
 * reduced as needed (e.g., by an upstream Aggregate transform).
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {function(object): *} params.field - The domain field to extract.
 * @param {function(*,*): number} [params.sort] - An optional
 *   comparator function for sorting the values. The comparator will be
 *   applied to backing tuples prior to value extraction.
 */
function Values$1(params) {
  Transform.call(this, null, params);
}
inherits(Values$1, Transform, {
  transform(_, pulse) {
    const run = !this.value || _.modified('field') || _.modified('sort') || pulse.changed() || _.sort && pulse.modified(_.sort.fields);
    if (run) {
      this.value = (_.sort ? pulse.source.slice().sort(stableCompare(_.sort)) : pulse.source).map(_.field);
    }
  }
});
function WindowOp(op, field, param, as) {
  const fn = WindowOps[op](field, param);
  return {
    init: fn.init || zero$3,
    update: function (w, t) {
      t[as] = fn.next(w);
    }
  };
}
const WindowOps = {
  row_number: function () {
    return {
      next: w => w.index + 1
    };
  },
  rank: function () {
    let rank;
    return {
      init: () => rank = 1,
      next: w => {
        const i = w.index,
          data = w.data;
        return i && w.compare(data[i - 1], data[i]) ? rank = i + 1 : rank;
      }
    };
  },
  dense_rank: function () {
    let drank;
    return {
      init: () => drank = 1,
      next: w => {
        const i = w.index,
          d = w.data;
        return i && w.compare(d[i - 1], d[i]) ? ++drank : drank;
      }
    };
  },
  percent_rank: function () {
    const rank = WindowOps.rank(),
      next = rank.next;
    return {
      init: rank.init,
      next: w => (next(w) - 1) / (w.data.length - 1)
    };
  },
  cume_dist: function () {
    let cume;
    return {
      init: () => cume = 0,
      next: w => {
        const d = w.data,
          c = w.compare;
        let i = w.index;
        if (cume < i) {
          while (i + 1 < d.length && !c(d[i], d[i + 1])) ++i;
          cume = i;
        }
        return (1 + cume) / d.length;
      }
    };
  },
  ntile: function (field, num) {
    num = +num;
    if (!(num > 0)) error('ntile num must be greater than zero.');
    const cume = WindowOps.cume_dist(),
      next = cume.next;
    return {
      init: cume.init,
      next: w => Math.ceil(num * next(w))
    };
  },
  lag: function (field, offset) {
    offset = +offset || 1;
    return {
      next: w => {
        const i = w.index - offset;
        return i >= 0 ? field(w.data[i]) : null;
      }
    };
  },
  lead: function (field, offset) {
    offset = +offset || 1;
    return {
      next: w => {
        const i = w.index + offset,
          d = w.data;
        return i < d.length ? field(d[i]) : null;
      }
    };
  },
  first_value: function (field) {
    return {
      next: w => field(w.data[w.i0])
    };
  },
  last_value: function (field) {
    return {
      next: w => field(w.data[w.i1 - 1])
    };
  },
  nth_value: function (field, nth) {
    nth = +nth;
    if (!(nth > 0)) error('nth_value nth must be greater than zero.');
    return {
      next: w => {
        const i = w.i0 + (nth - 1);
        return i < w.i1 ? field(w.data[i]) : null;
      }
    };
  },
  prev_value: function (field) {
    let prev;
    return {
      init: () => prev = null,
      next: w => {
        const v = field(w.data[w.index]);
        return v != null ? prev = v : prev;
      }
    };
  },
  next_value: function (field) {
    let v, i;
    return {
      init: () => (v = null, i = -1),
      next: w => {
        const d = w.data;
        return w.index <= i ? v : (i = find$2(field, d, w.index)) < 0 ? (i = d.length, v = null) : v = field(d[i]);
      }
    };
  }
};
function find$2(field, data, index) {
  for (let n = data.length; index < n; ++index) {
    const v = field(data[index]);
    if (v != null) return index;
  }
  return -1;
}
const ValidWindowOps = Object.keys(WindowOps);
function WindowState(_) {
  const ops = array$5(_.ops),
    fields = array$5(_.fields),
    params = array$5(_.params),
    aggregate_params = array$5(_.aggregate_params),
    as = array$5(_.as),
    outputs = this.outputs = [],
    windows = this.windows = [],
    inputs = {},
    map = {},
    counts = [],
    measures = [];
  let countOnly = true;
  function visitInputs(f) {
    array$5(accessorFields(f)).forEach(_ => inputs[_] = 1);
  }
  visitInputs(_.sort);
  ops.forEach((op, i) => {
    const field = fields[i],
      param = params[i],
      aggregate_param = aggregate_params[i] || null,
      mname = accessorName(field),
      name = measureName(op, mname, as[i]);
    visitInputs(field);
    outputs.push(name);

    // Window operation
    if (has$1(WindowOps, op)) {
      windows.push(WindowOp(op, field, param, name));
    }

    // Aggregate operation
    else {
      if (field == null && op !== 'count') {
        error('Null aggregate field specified.');
      }
      if (op === 'count') {
        counts.push(name);
        return;
      }
      countOnly = false;
      let m = map[mname];
      if (!m) {
        m = map[mname] = [];
        m.field = field;
        measures.push(m);
      }
      m.push(createMeasure(op, aggregate_param, name));
    }
  });
  if (counts.length || measures.length) {
    this.cell = cell(measures, counts, countOnly);
  }
  this.inputs = Object.keys(inputs);
}
const prototype = WindowState.prototype;
prototype.init = function () {
  this.windows.forEach(_ => _.init());
  if (this.cell) this.cell.init();
};
prototype.update = function (w, t) {
  const cell = this.cell,
    wind = this.windows,
    data = w.data,
    m = wind && wind.length;
  let j;
  if (cell) {
    for (j = w.p0; j < w.i0; ++j) cell.rem(data[j]);
    for (j = w.p1; j < w.i1; ++j) cell.add(data[j]);
    cell.set(t);
  }
  for (j = 0; j < m; ++j) wind[j].update(w, t);
};
function cell(measures, counts, countOnly) {
  measures = measures.map(m => compileMeasures(m, m.field));
  const cell = {
    num: 0,
    agg: null,
    store: false,
    count: counts
  };
  if (!countOnly) {
    var n = measures.length,
      a = cell.agg = Array(n),
      i = 0;
    for (; i < n; ++i) a[i] = new measures[i](cell);
  }
  if (cell.store) {
    var store = cell.data = new TupleStore();
  }
  cell.add = function (t) {
    cell.num += 1;
    if (countOnly) return;
    if (store) store.add(t);
    for (let i = 0; i < n; ++i) {
      a[i].add(a[i].get(t), t);
    }
  };
  cell.rem = function (t) {
    cell.num -= 1;
    if (countOnly) return;
    if (store) store.rem(t);
    for (let i = 0; i < n; ++i) {
      a[i].rem(a[i].get(t), t);
    }
  };
  cell.set = function (t) {
    let i, n;

    // consolidate stored values
    if (store) store.values();

    // update tuple properties
    for (i = 0, n = counts.length; i < n; ++i) t[counts[i]] = cell.num;
    if (!countOnly) for (i = 0, n = a.length; i < n; ++i) a[i].set(t);
  };
  cell.init = function () {
    cell.num = 0;
    if (store) store.reset();
    for (let i = 0; i < n; ++i) a[i].init();
  };
  return cell;
}

/**
 * Perform window calculations and write results to the input stream.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {function(*,*): number} [params.sort] - A comparator function for sorting tuples within a window.
 * @param {Array<function(object): *>} [params.groupby] - An array of accessors by which to partition tuples into separate windows.
 * @param {Array<string>} params.ops - An array of strings indicating window operations to perform.
 * @param {Array<function(object): *>} [params.fields] - An array of accessors
 *   for data fields to use as inputs to window operations.
 * @param {Array<*>} [params.params] - An array of parameter values for window operations.
 * @param {Array<number>} [params.aggregate_params] - An optional array of parameter values for aggregation operations.
 * @param {Array<string>} [params.as] - An array of output field names for window operations.
 * @param {Array<number>} [params.frame] - Window frame definition as two-element array.
 * @param {boolean} [params.ignorePeers=false] - If true, base window frame boundaries on row
 *   number alone, ignoring peers with identical sort values. If false (default),
 *   the window boundaries will be adjusted to include peer values.
 */
function Window(params) {
  Transform.call(this, {}, params);
  this._mlen = 0;
  this._mods = [];
}
Window.Definition = {
  'type': 'Window',
  'metadata': {
    'modifies': true
  },
  'params': [{
    'name': 'sort',
    'type': 'compare'
  }, {
    'name': 'groupby',
    'type': 'field',
    'array': true
  }, {
    'name': 'ops',
    'type': 'enum',
    'array': true,
    'values': ValidWindowOps.concat(ValidAggregateOps)
  }, {
    'name': 'params',
    'type': 'number',
    'null': true,
    'array': true
  }, {
    'name': 'aggregate_params',
    'type': 'number',
    'null': true,
    'array': true
  }, {
    'name': 'fields',
    'type': 'field',
    'null': true,
    'array': true
  }, {
    'name': 'as',
    'type': 'string',
    'null': true,
    'array': true
  }, {
    'name': 'frame',
    'type': 'number',
    'null': true,
    'array': true,
    'length': 2,
    'default': [null, 0]
  }, {
    'name': 'ignorePeers',
    'type': 'boolean',
    'default': false
  }]
};
inherits(Window, Transform, {
  transform(_, pulse) {
    this.stamp = pulse.stamp;
    const mod = _.modified(),
      cmp = stableCompare(_.sort),
      key = groupkey(_.groupby),
      group = t => this.group(key(t));

    // initialize window state
    let state = this.state;
    if (!state || mod) {
      state = this.state = new WindowState(_);
    }

    // partition input tuples
    if (mod || pulse.modified(state.inputs)) {
      this.value = {};
      pulse.visit(pulse.SOURCE, t => group(t).add(t));
    } else {
      pulse.visit(pulse.REM, t => group(t).remove(t));
      pulse.visit(pulse.ADD, t => group(t).add(t));
    }

    // perform window calculations for each modified partition
    for (let i = 0, n = this._mlen; i < n; ++i) {
      processPartition(this._mods[i], state, cmp, _);
    }
    this._mlen = 0;
    this._mods = [];

    // TODO don't reflow everything?
    return pulse.reflow(mod).modifies(state.outputs);
  },
  group(key) {
    let group = this.value[key];
    if (!group) {
      group = this.value[key] = SortedList(tupleid);
      group.stamp = -1;
    }
    if (group.stamp < this.stamp) {
      group.stamp = this.stamp;
      this._mods[this._mlen++] = group;
    }
    return group;
  }
});
function processPartition(list, state, cmp, _) {
  const sort = _.sort,
    range = sort && !_.ignorePeers,
    frame = _.frame || [null, 0],
    data = list.data(cmp),
    // use cmp for stable sort
    n = data.length,
    b = range ? bisector(sort) : null,
    w = {
      i0: 0,
      i1: 0,
      p0: 0,
      p1: 0,
      index: 0,
      data: data,
      compare: sort || constant$5(-1)
    };
  state.init();
  for (let i = 0; i < n; ++i) {
    setWindow(w, frame, i, n);
    if (range) adjustRange(w, b);
    state.update(w, data[i]);
  }
}
function setWindow(w, f, i, n) {
  w.p0 = w.i0;
  w.p1 = w.i1;
  w.i0 = f[0] == null ? 0 : Math.max(0, i - Math.abs(f[0]));
  w.i1 = f[1] == null ? n : Math.min(n, i + Math.abs(f[1]) + 1);
  w.index = i;
}

// if frame type is 'range', adjust window for peer values
function adjustRange(w, bisect) {
  const r0 = w.i0,
    r1 = w.i1 - 1,
    c = w.compare,
    d = w.data,
    n = d.length - 1;
  if (r0 > 0 && !c(d[r0], d[r0 - 1])) w.i0 = bisect.left(d, d[r0]);
  if (r1 < n && !c(d[r1], d[r1 + 1])) w.i1 = bisect.right(d, d[r1]);
}

var tx = /*#__PURE__*/Object.freeze({
    __proto__: null,
    aggregate: Aggregate$1,
    bin: Bin,
    collect: Collect$1,
    compare: Compare$1,
    countpattern: CountPattern,
    cross: Cross,
    density: Density,
    dotbin: DotBin,
    expression: Expression$1,
    extent: Extent,
    facet: Facet$1,
    field: Field$1,
    filter: Filter,
    flatten: Flatten,
    fold: Fold,
    formula: Formula,
    generate: Generate,
    impute: Impute,
    joinaggregate: JoinAggregate,
    kde: KDE,
    key: Key$1,
    load: Load$1,
    lookup: Lookup,
    multiextent: MultiExtent$1,
    multivalues: MultiValues$1,
    params: Params$2,
    pivot: Pivot,
    prefacet: PreFacet$1,
    project: Project,
    proxy: Proxy$2,
    quantile: Quantile$1,
    relay: Relay$1,
    sample: Sample,
    sequence: Sequence,
    sieve: Sieve$1,
    subflow: Subflow,
    timeunit: TimeUnit,
    tupleindex: TupleIndex,
    values: Values$1,
    window: Window
});

function constant$3 (x) {
  return function constant() {
    return x;
  };
}

const abs$2 = Math.abs;
const atan2$1 = Math.atan2;
const cos$2 = Math.cos;
const max$1 = Math.max;
const min$1 = Math.min;
const sin$2 = Math.sin;
const sqrt$3 = Math.sqrt;
const epsilon$5 = 1e-12;
const pi$3 = Math.PI;
const halfPi$2 = pi$3 / 2;
const tau$3 = 2 * pi$3;
function acos$1(x) {
  return x > 1 ? 0 : x < -1 ? pi$3 : Math.acos(x);
}
function asin$2(x) {
  return x >= 1 ? halfPi$2 : x <= -1 ? -halfPi$2 : Math.asin(x);
}

const pi$2 = Math.PI,
  tau$2 = 2 * pi$2,
  epsilon$4 = 1e-6,
  tauEpsilon = tau$2 - epsilon$4;
function append$1(strings) {
  this._ += strings[0];
  for (let i = 1, n = strings.length; i < n; ++i) {
    this._ += arguments[i] + strings[i];
  }
}
function appendRound$1(digits) {
  let d = Math.floor(digits);
  if (!(d >= 0)) throw new Error(`invalid digits: ${digits}`);
  if (d > 15) return append$1;
  const k = 10 ** d;
  return function (strings) {
    this._ += strings[0];
    for (let i = 1, n = strings.length; i < n; ++i) {
      this._ += Math.round(arguments[i] * k) / k + strings[i];
    }
  };
}
let Path$1 = class Path {
  constructor(digits) {
    this._x0 = this._y0 =
    // start of current subpath
    this._x1 = this._y1 = null; // end of current subpath
    this._ = "";
    this._append = digits == null ? append$1 : appendRound$1(digits);
  }
  moveTo(x, y) {
    this._append`M${this._x0 = this._x1 = +x},${this._y0 = this._y1 = +y}`;
  }
  closePath() {
    if (this._x1 !== null) {
      this._x1 = this._x0, this._y1 = this._y0;
      this._append`Z`;
    }
  }
  lineTo(x, y) {
    this._append`L${this._x1 = +x},${this._y1 = +y}`;
  }
  quadraticCurveTo(x1, y1, x, y) {
    this._append`Q${+x1},${+y1},${this._x1 = +x},${this._y1 = +y}`;
  }
  bezierCurveTo(x1, y1, x2, y2, x, y) {
    this._append`C${+x1},${+y1},${+x2},${+y2},${this._x1 = +x},${this._y1 = +y}`;
  }
  arcTo(x1, y1, x2, y2, r) {
    x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;

    // Is the radius negative? Error.
    if (r < 0) throw new Error(`negative radius: ${r}`);
    let x0 = this._x1,
      y0 = this._y1,
      x21 = x2 - x1,
      y21 = y2 - y1,
      x01 = x0 - x1,
      y01 = y0 - y1,
      l01_2 = x01 * x01 + y01 * y01;

    // Is this path empty? Move to (x1,y1).
    if (this._x1 === null) {
      this._append`M${this._x1 = x1},${this._y1 = y1}`;
    }

    // Or, is (x1,y1) coincident with (x0,y0)? Do nothing.
    else if (!(l01_2 > epsilon$4)) ;

    // Or, are (x0,y0), (x1,y1) and (x2,y2) collinear?
    // Equivalently, is (x1,y1) coincident with (x2,y2)?
    // Or, is the radius zero? Line to (x1,y1).
    else if (!(Math.abs(y01 * x21 - y21 * x01) > epsilon$4) || !r) {
      this._append`L${this._x1 = x1},${this._y1 = y1}`;
    }

    // Otherwise, draw an arc!
    else {
      let x20 = x2 - x0,
        y20 = y2 - y0,
        l21_2 = x21 * x21 + y21 * y21,
        l20_2 = x20 * x20 + y20 * y20,
        l21 = Math.sqrt(l21_2),
        l01 = Math.sqrt(l01_2),
        l = r * Math.tan((pi$2 - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2),
        t01 = l / l01,
        t21 = l / l21;

      // If the start tangent is not coincident with (x0,y0), line to.
      if (Math.abs(t01 - 1) > epsilon$4) {
        this._append`L${x1 + t01 * x01},${y1 + t01 * y01}`;
      }
      this._append`A${r},${r},0,0,${+(y01 * x20 > x01 * y20)},${this._x1 = x1 + t21 * x21},${this._y1 = y1 + t21 * y21}`;
    }
  }
  arc(x, y, r, a0, a1, ccw) {
    x = +x, y = +y, r = +r, ccw = !!ccw;

    // Is the radius negative? Error.
    if (r < 0) throw new Error(`negative radius: ${r}`);
    let dx = r * Math.cos(a0),
      dy = r * Math.sin(a0),
      x0 = x + dx,
      y0 = y + dy,
      cw = 1 ^ ccw,
      da = ccw ? a0 - a1 : a1 - a0;

    // Is this path empty? Move to (x0,y0).
    if (this._x1 === null) {
      this._append`M${x0},${y0}`;
    }

    // Or, is (x0,y0) not coincident with the previous point? Line to (x0,y0).
    else if (Math.abs(this._x1 - x0) > epsilon$4 || Math.abs(this._y1 - y0) > epsilon$4) {
      this._append`L${x0},${y0}`;
    }

    // Is this arc empty? We’re done.
    if (!r) return;

    // Does the angle go the wrong way? Flip the direction.
    if (da < 0) da = da % tau$2 + tau$2;

    // Is this a complete circle? Draw two arcs to complete the circle.
    if (da > tauEpsilon) {
      this._append`A${r},${r},0,1,${cw},${x - dx},${y - dy}A${r},${r},0,1,${cw},${this._x1 = x0},${this._y1 = y0}`;
    }

    // Is this arc non-empty? Draw an arc!
    else if (da > epsilon$4) {
      this._append`A${r},${r},0,${+(da >= pi$2)},${cw},${this._x1 = x + r * Math.cos(a1)},${this._y1 = y + r * Math.sin(a1)}`;
    }
  }
  rect(x, y, w, h) {
    this._append`M${this._x0 = this._x1 = +x},${this._y0 = this._y1 = +y}h${w = +w}v${+h}h${-w}Z`;
  }
  toString() {
    return this._;
  }
};
function path$3() {
  return new Path$1();
}

// Allow instanceof d3.path
path$3.prototype = Path$1.prototype;

function withPath(shape) {
  let digits = 3;
  shape.digits = function (_) {
    if (!arguments.length) return digits;
    if (_ == null) {
      digits = null;
    } else {
      const d = Math.floor(_);
      if (!(d >= 0)) throw new RangeError(`invalid digits: ${_}`);
      digits = d;
    }
    return shape;
  };
  return () => new Path$1(digits);
}

function arcInnerRadius(d) {
  return d.innerRadius;
}
function arcOuterRadius(d) {
  return d.outerRadius;
}
function arcStartAngle(d) {
  return d.startAngle;
}
function arcEndAngle(d) {
  return d.endAngle;
}
function arcPadAngle(d) {
  return d && d.padAngle; // Note: optional!
}
function intersect$3(x0, y0, x1, y1, x2, y2, x3, y3) {
  var x10 = x1 - x0,
    y10 = y1 - y0,
    x32 = x3 - x2,
    y32 = y3 - y2,
    t = y32 * x10 - x32 * y10;
  if (t * t < epsilon$5) return;
  t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / t;
  return [x0 + t * x10, y0 + t * y10];
}

// Compute perpendicular offset line of length rc.
// http://mathworld.wolfram.com/Circle-LineIntersection.html
function cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
  var x01 = x0 - x1,
    y01 = y0 - y1,
    lo = (cw ? rc : -rc) / sqrt$3(x01 * x01 + y01 * y01),
    ox = lo * y01,
    oy = -lo * x01,
    x11 = x0 + ox,
    y11 = y0 + oy,
    x10 = x1 + ox,
    y10 = y1 + oy,
    x00 = (x11 + x10) / 2,
    y00 = (y11 + y10) / 2,
    dx = x10 - x11,
    dy = y10 - y11,
    d2 = dx * dx + dy * dy,
    r = r1 - rc,
    D = x11 * y10 - x10 * y11,
    d = (dy < 0 ? -1 : 1) * sqrt$3(max$1(0, r * r * d2 - D * D)),
    cx0 = (D * dy - dx * d) / d2,
    cy0 = (-D * dx - dy * d) / d2,
    cx1 = (D * dy + dx * d) / d2,
    cy1 = (-D * dx + dy * d) / d2,
    dx0 = cx0 - x00,
    dy0 = cy0 - y00,
    dx1 = cx1 - x00,
    dy1 = cy1 - y00;

  // Pick the closer of the two intersection points.
  // TODO Is there a faster way to determine which intersection to use?
  if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
  return {
    cx: cx0,
    cy: cy0,
    x01: -ox,
    y01: -oy,
    x11: cx0 * (r1 / r - 1),
    y11: cy0 * (r1 / r - 1)
  };
}
function arc$2$1 () {
  var innerRadius = arcInnerRadius,
    outerRadius = arcOuterRadius,
    cornerRadius = constant$3(0),
    padRadius = null,
    startAngle = arcStartAngle,
    endAngle = arcEndAngle,
    padAngle = arcPadAngle,
    context = null,
    path = withPath(arc);
  function arc() {
    var buffer,
      r,
      r0 = +innerRadius.apply(this, arguments),
      r1 = +outerRadius.apply(this, arguments),
      a0 = startAngle.apply(this, arguments) - halfPi$2,
      a1 = endAngle.apply(this, arguments) - halfPi$2,
      da = abs$2(a1 - a0),
      cw = a1 > a0;
    if (!context) context = buffer = path();

    // Ensure that the outer radius is always larger than the inner radius.
    if (r1 < r0) r = r1, r1 = r0, r0 = r;

    // Is it a point?
    if (!(r1 > epsilon$5)) context.moveTo(0, 0);

    // Or is it a circle or annulus?
    else if (da > tau$3 - epsilon$5) {
      context.moveTo(r1 * cos$2(a0), r1 * sin$2(a0));
      context.arc(0, 0, r1, a0, a1, !cw);
      if (r0 > epsilon$5) {
        context.moveTo(r0 * cos$2(a1), r0 * sin$2(a1));
        context.arc(0, 0, r0, a1, a0, cw);
      }
    }

    // Or is it a circular or annular sector?
    else {
      var a01 = a0,
        a11 = a1,
        a00 = a0,
        a10 = a1,
        da0 = da,
        da1 = da,
        ap = padAngle.apply(this, arguments) / 2,
        rp = ap > epsilon$5 && (padRadius ? +padRadius.apply(this, arguments) : sqrt$3(r0 * r0 + r1 * r1)),
        rc = min$1(abs$2(r1 - r0) / 2, +cornerRadius.apply(this, arguments)),
        rc0 = rc,
        rc1 = rc,
        t0,
        t1;

      // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
      if (rp > epsilon$5) {
        var p0 = asin$2(rp / r0 * sin$2(ap)),
          p1 = asin$2(rp / r1 * sin$2(ap));
        if ((da0 -= p0 * 2) > epsilon$5) p0 *= cw ? 1 : -1, a00 += p0, a10 -= p0;else da0 = 0, a00 = a10 = (a0 + a1) / 2;
        if ((da1 -= p1 * 2) > epsilon$5) p1 *= cw ? 1 : -1, a01 += p1, a11 -= p1;else da1 = 0, a01 = a11 = (a0 + a1) / 2;
      }
      var x01 = r1 * cos$2(a01),
        y01 = r1 * sin$2(a01),
        x10 = r0 * cos$2(a10),
        y10 = r0 * sin$2(a10);

      // Apply rounded corners?
      if (rc > epsilon$5) {
        var x11 = r1 * cos$2(a11),
          y11 = r1 * sin$2(a11),
          x00 = r0 * cos$2(a00),
          y00 = r0 * sin$2(a00),
          oc;

        // Restrict the corner radius according to the sector angle. If this
        // intersection fails, it’s probably because the arc is too small, so
        // disable the corner radius entirely.
        if (da < pi$3) {
          if (oc = intersect$3(x01, y01, x00, y00, x11, y11, x10, y10)) {
            var ax = x01 - oc[0],
              ay = y01 - oc[1],
              bx = x11 - oc[0],
              by = y11 - oc[1],
              kc = 1 / sin$2(acos$1((ax * bx + ay * by) / (sqrt$3(ax * ax + ay * ay) * sqrt$3(bx * bx + by * by))) / 2),
              lc = sqrt$3(oc[0] * oc[0] + oc[1] * oc[1]);
            rc0 = min$1(rc, (r0 - lc) / (kc - 1));
            rc1 = min$1(rc, (r1 - lc) / (kc + 1));
          } else {
            rc0 = rc1 = 0;
          }
        }
      }

      // Is the sector collapsed to a line?
      if (!(da1 > epsilon$5)) context.moveTo(x01, y01);

      // Does the sector’s outer ring have rounded corners?
      else if (rc1 > epsilon$5) {
        t0 = cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
        t1 = cornerTangents(x11, y11, x10, y10, r1, rc1, cw);
        context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01);

        // Have the corners merged?
        if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, atan2$1(t0.y01, t0.x01), atan2$1(t1.y01, t1.x01), !cw);

        // Otherwise, draw the two corners and the ring.
        else {
          context.arc(t0.cx, t0.cy, rc1, atan2$1(t0.y01, t0.x01), atan2$1(t0.y11, t0.x11), !cw);
          context.arc(0, 0, r1, atan2$1(t0.cy + t0.y11, t0.cx + t0.x11), atan2$1(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
          context.arc(t1.cx, t1.cy, rc1, atan2$1(t1.y11, t1.x11), atan2$1(t1.y01, t1.x01), !cw);
        }
      }

      // Or is the outer ring just a circular arc?
      else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);

      // Is there no inner ring, and it’s a circular sector?
      // Or perhaps it’s an annular sector collapsed due to padding?
      if (!(r0 > epsilon$5) || !(da0 > epsilon$5)) context.lineTo(x10, y10);

      // Does the sector’s inner ring (or point) have rounded corners?
      else if (rc0 > epsilon$5) {
        t0 = cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
        t1 = cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);
        context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01);

        // Have the corners merged?
        if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, atan2$1(t0.y01, t0.x01), atan2$1(t1.y01, t1.x01), !cw);

        // Otherwise, draw the two corners and the ring.
        else {
          context.arc(t0.cx, t0.cy, rc0, atan2$1(t0.y01, t0.x01), atan2$1(t0.y11, t0.x11), !cw);
          context.arc(0, 0, r0, atan2$1(t0.cy + t0.y11, t0.cx + t0.x11), atan2$1(t1.cy + t1.y11, t1.cx + t1.x11), cw);
          context.arc(t1.cx, t1.cy, rc0, atan2$1(t1.y11, t1.x11), atan2$1(t1.y01, t1.x01), !cw);
        }
      }

      // Or is the inner ring just a circular arc?
      else context.arc(0, 0, r0, a10, a00, cw);
    }
    context.closePath();
    if (buffer) return context = null, buffer + "" || null;
  }
  arc.centroid = function () {
    var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2,
      a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - pi$3 / 2;
    return [cos$2(a) * r, sin$2(a) * r];
  };
  arc.innerRadius = function (_) {
    return arguments.length ? (innerRadius = typeof _ === "function" ? _ : constant$3(+_), arc) : innerRadius;
  };
  arc.outerRadius = function (_) {
    return arguments.length ? (outerRadius = typeof _ === "function" ? _ : constant$3(+_), arc) : outerRadius;
  };
  arc.cornerRadius = function (_) {
    return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : constant$3(+_), arc) : cornerRadius;
  };
  arc.padRadius = function (_) {
    return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : constant$3(+_), arc) : padRadius;
  };
  arc.startAngle = function (_) {
    return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant$3(+_), arc) : startAngle;
  };
  arc.endAngle = function (_) {
    return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant$3(+_), arc) : endAngle;
  };
  arc.padAngle = function (_) {
    return arguments.length ? (padAngle = typeof _ === "function" ? _ : constant$3(+_), arc) : padAngle;
  };
  arc.context = function (_) {
    return arguments.length ? (context = _ == null ? null : _, arc) : context;
  };
  return arc;
}

function array$4 (x) {
  return typeof x === "object" && "length" in x ? x // Array, TypedArray, NodeList, array-like
  : Array.from(x); // Map, Set, iterable, string, or anything else
}

function Linear$1(context) {
  this._context = context;
}
Linear$1.prototype = {
  areaStart: function () {
    this._line = 0;
  },
  areaEnd: function () {
    this._line = NaN;
  },
  lineStart: function () {
    this._point = 0;
  },
  lineEnd: function () {
    if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function (x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0:
        this._point = 1;
        this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
        break;
      case 1:
        this._point = 2;
      // falls through
      default:
        this._context.lineTo(x, y);
        break;
    }
  }
};
function curveLinear (context) {
  return new Linear$1(context);
}

function x$3(p) {
  return p[0];
}
function y$3(p) {
  return p[1];
}

function line$2$1 (x, y) {
  var defined = constant$3(true),
    context = null,
    curve = curveLinear,
    output = null,
    path = withPath(line);
  x = typeof x === "function" ? x : x === undefined ? x$3 : constant$3(x);
  y = typeof y === "function" ? y : y === undefined ? y$3 : constant$3(y);
  function line(data) {
    var i,
      n = (data = array$4(data)).length,
      d,
      defined0 = false,
      buffer;
    if (context == null) output = curve(buffer = path());
    for (i = 0; i <= n; ++i) {
      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
        if (defined0 = !defined0) output.lineStart();else output.lineEnd();
      }
      if (defined0) output.point(+x(d, i, data), +y(d, i, data));
    }
    if (buffer) return output = null, buffer + "" || null;
  }
  line.x = function (_) {
    return arguments.length ? (x = typeof _ === "function" ? _ : constant$3(+_), line) : x;
  };
  line.y = function (_) {
    return arguments.length ? (y = typeof _ === "function" ? _ : constant$3(+_), line) : y;
  };
  line.defined = function (_) {
    return arguments.length ? (defined = typeof _ === "function" ? _ : constant$3(!!_), line) : defined;
  };
  line.curve = function (_) {
    return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
  };
  line.context = function (_) {
    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
  };
  return line;
}

function area$2$1 (x0, y0, y1) {
  var x1 = null,
    defined = constant$3(true),
    context = null,
    curve = curveLinear,
    output = null,
    path = withPath(area);
  x0 = typeof x0 === "function" ? x0 : x0 === undefined ? x$3 : constant$3(+x0);
  y0 = typeof y0 === "function" ? y0 : y0 === undefined ? constant$3(0) : constant$3(+y0);
  y1 = typeof y1 === "function" ? y1 : y1 === undefined ? y$3 : constant$3(+y1);
  function area(data) {
    var i,
      j,
      k,
      n = (data = array$4(data)).length,
      d,
      defined0 = false,
      buffer,
      x0z = new Array(n),
      y0z = new Array(n);
    if (context == null) output = curve(buffer = path());
    for (i = 0; i <= n; ++i) {
      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
        if (defined0 = !defined0) {
          j = i;
          output.areaStart();
          output.lineStart();
        } else {
          output.lineEnd();
          output.lineStart();
          for (k = i - 1; k >= j; --k) {
            output.point(x0z[k], y0z[k]);
          }
          output.lineEnd();
          output.areaEnd();
        }
      }
      if (defined0) {
        x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
        output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
      }
    }
    if (buffer) return output = null, buffer + "" || null;
  }
  function arealine() {
    return line$2$1().defined(defined).curve(curve).context(context);
  }
  area.x = function (_) {
    return arguments.length ? (x0 = typeof _ === "function" ? _ : constant$3(+_), x1 = null, area) : x0;
  };
  area.x0 = function (_) {
    return arguments.length ? (x0 = typeof _ === "function" ? _ : constant$3(+_), area) : x0;
  };
  area.x1 = function (_) {
    return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : constant$3(+_), area) : x1;
  };
  area.y = function (_) {
    return arguments.length ? (y0 = typeof _ === "function" ? _ : constant$3(+_), y1 = null, area) : y0;
  };
  area.y0 = function (_) {
    return arguments.length ? (y0 = typeof _ === "function" ? _ : constant$3(+_), area) : y0;
  };
  area.y1 = function (_) {
    return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : constant$3(+_), area) : y1;
  };
  area.lineX0 = area.lineY0 = function () {
    return arealine().x(x0).y(y0);
  };
  area.lineY1 = function () {
    return arealine().x(x0).y(y1);
  };
  area.lineX1 = function () {
    return arealine().x(x1).y(y0);
  };
  area.defined = function (_) {
    return arguments.length ? (defined = typeof _ === "function" ? _ : constant$3(!!_), area) : defined;
  };
  area.curve = function (_) {
    return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
  };
  area.context = function (_) {
    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
  };
  return area;
}

var circle = {
  draw(context, size) {
    const r = sqrt$3(size / pi$3);
    context.moveTo(r, 0);
    context.arc(0, 0, r, 0, tau$3);
  }
};

function Symbol$1(type, size) {
  let context = null,
    path = withPath(symbol);
  type = typeof type === "function" ? type : constant$3(type || circle);
  size = typeof size === "function" ? size : constant$3(size === undefined ? 64 : +size);
  function symbol() {
    let buffer;
    if (!context) context = buffer = path();
    type.apply(this, arguments).draw(context, +size.apply(this, arguments));
    if (buffer) return context = null, buffer + "" || null;
  }
  symbol.type = function (_) {
    return arguments.length ? (type = typeof _ === "function" ? _ : constant$3(_), symbol) : type;
  };
  symbol.size = function (_) {
    return arguments.length ? (size = typeof _ === "function" ? _ : constant$3(+_), symbol) : size;
  };
  symbol.context = function (_) {
    return arguments.length ? (context = _ == null ? null : _, symbol) : context;
  };
  return symbol;
}

function noop$3 () {}

function point$5(that, x, y) {
  that._context.bezierCurveTo((2 * that._x0 + that._x1) / 3, (2 * that._y0 + that._y1) / 3, (that._x0 + 2 * that._x1) / 3, (that._y0 + 2 * that._y1) / 3, (that._x0 + 4 * that._x1 + x) / 6, (that._y0 + 4 * that._y1 + y) / 6);
}
function Basis(context) {
  this._context = context;
}
Basis.prototype = {
  areaStart: function () {
    this._line = 0;
  },
  areaEnd: function () {
    this._line = NaN;
  },
  lineStart: function () {
    this._x0 = this._x1 = this._y0 = this._y1 = NaN;
    this._point = 0;
  },
  lineEnd: function () {
    switch (this._point) {
      case 3:
        point$5(this, this._x1, this._y1);
      // falls through
      case 2:
        this._context.lineTo(this._x1, this._y1);
        break;
    }
    if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function (x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0:
        this._point = 1;
        this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3;
        this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6);
      // falls through
      default:
        point$5(this, x, y);
        break;
    }
    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
  }
};
function curveBasis (context) {
  return new Basis(context);
}

function BasisClosed(context) {
  this._context = context;
}
BasisClosed.prototype = {
  areaStart: noop$3,
  areaEnd: noop$3,
  lineStart: function () {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
    this._point = 0;
  },
  lineEnd: function () {
    switch (this._point) {
      case 1:
        {
          this._context.moveTo(this._x2, this._y2);
          this._context.closePath();
          break;
        }
      case 2:
        {
          this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
          this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
          this._context.closePath();
          break;
        }
      case 3:
        {
          this.point(this._x2, this._y2);
          this.point(this._x3, this._y3);
          this.point(this._x4, this._y4);
          break;
        }
    }
  },
  point: function (x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0:
        this._point = 1;
        this._x2 = x, this._y2 = y;
        break;
      case 1:
        this._point = 2;
        this._x3 = x, this._y3 = y;
        break;
      case 2:
        this._point = 3;
        this._x4 = x, this._y4 = y;
        this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6);
        break;
      default:
        point$5(this, x, y);
        break;
    }
    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
  }
};
function curveBasisClosed (context) {
  return new BasisClosed(context);
}

function BasisOpen(context) {
  this._context = context;
}
BasisOpen.prototype = {
  areaStart: function () {
    this._line = 0;
  },
  areaEnd: function () {
    this._line = NaN;
  },
  lineStart: function () {
    this._x0 = this._x1 = this._y0 = this._y1 = NaN;
    this._point = 0;
  },
  lineEnd: function () {
    if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function (x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0:
        this._point = 1;
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3;
        var x0 = (this._x0 + 4 * this._x1 + x) / 6,
          y0 = (this._y0 + 4 * this._y1 + y) / 6;
        this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0);
        break;
      case 3:
        this._point = 4;
      // falls through
      default:
        point$5(this, x, y);
        break;
    }
    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
  }
};
function curveBasisOpen (context) {
  return new BasisOpen(context);
}

function Bundle(context, beta) {
  this._basis = new Basis(context);
  this._beta = beta;
}
Bundle.prototype = {
  lineStart: function () {
    this._x = [];
    this._y = [];
    this._basis.lineStart();
  },
  lineEnd: function () {
    var x = this._x,
      y = this._y,
      j = x.length - 1;
    if (j > 0) {
      var x0 = x[0],
        y0 = y[0],
        dx = x[j] - x0,
        dy = y[j] - y0,
        i = -1,
        t;
      while (++i <= j) {
        t = i / j;
        this._basis.point(this._beta * x[i] + (1 - this._beta) * (x0 + t * dx), this._beta * y[i] + (1 - this._beta) * (y0 + t * dy));
      }
    }
    this._x = this._y = null;
    this._basis.lineEnd();
  },
  point: function (x, y) {
    this._x.push(+x);
    this._y.push(+y);
  }
};
var curveBundle = (function custom(beta) {
  function bundle(context) {
    return beta === 1 ? new Basis(context) : new Bundle(context, beta);
  }
  bundle.beta = function (beta) {
    return custom(+beta);
  };
  return bundle;
})(0.85);

function point$4(that, x, y) {
  that._context.bezierCurveTo(that._x1 + that._k * (that._x2 - that._x0), that._y1 + that._k * (that._y2 - that._y0), that._x2 + that._k * (that._x1 - x), that._y2 + that._k * (that._y1 - y), that._x2, that._y2);
}
function Cardinal(context, tension) {
  this._context = context;
  this._k = (1 - tension) / 6;
}
Cardinal.prototype = {
  areaStart: function () {
    this._line = 0;
  },
  areaEnd: function () {
    this._line = NaN;
  },
  lineStart: function () {
    this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
    this._point = 0;
  },
  lineEnd: function () {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x2, this._y2);
        break;
      case 3:
        point$4(this, this._x1, this._y1);
        break;
    }
    if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function (x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0:
        this._point = 1;
        this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
        break;
      case 1:
        this._point = 2;
        this._x1 = x, this._y1 = y;
        break;
      case 2:
        this._point = 3;
      // falls through
      default:
        point$4(this, x, y);
        break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};
var curveCardinal = (function custom(tension) {
  function cardinal(context) {
    return new Cardinal(context, tension);
  }
  cardinal.tension = function (tension) {
    return custom(+tension);
  };
  return cardinal;
})(0);

function CardinalClosed(context, tension) {
  this._context = context;
  this._k = (1 - tension) / 6;
}
CardinalClosed.prototype = {
  areaStart: noop$3,
  areaEnd: noop$3,
  lineStart: function () {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
    this._point = 0;
  },
  lineEnd: function () {
    switch (this._point) {
      case 1:
        {
          this._context.moveTo(this._x3, this._y3);
          this._context.closePath();
          break;
        }
      case 2:
        {
          this._context.lineTo(this._x3, this._y3);
          this._context.closePath();
          break;
        }
      case 3:
        {
          this.point(this._x3, this._y3);
          this.point(this._x4, this._y4);
          this.point(this._x5, this._y5);
          break;
        }
    }
  },
  point: function (x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0:
        this._point = 1;
        this._x3 = x, this._y3 = y;
        break;
      case 1:
        this._point = 2;
        this._context.moveTo(this._x4 = x, this._y4 = y);
        break;
      case 2:
        this._point = 3;
        this._x5 = x, this._y5 = y;
        break;
      default:
        point$4(this, x, y);
        break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};
var curveCardinalClosed = (function custom(tension) {
  function cardinal(context) {
    return new CardinalClosed(context, tension);
  }
  cardinal.tension = function (tension) {
    return custom(+tension);
  };
  return cardinal;
})(0);

function CardinalOpen(context, tension) {
  this._context = context;
  this._k = (1 - tension) / 6;
}
CardinalOpen.prototype = {
  areaStart: function () {
    this._line = 0;
  },
  areaEnd: function () {
    this._line = NaN;
  },
  lineStart: function () {
    this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
    this._point = 0;
  },
  lineEnd: function () {
    if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function (x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0:
        this._point = 1;
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3;
        this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
        break;
      case 3:
        this._point = 4;
      // falls through
      default:
        point$4(this, x, y);
        break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};
var curveCardinalOpen = (function custom(tension) {
  function cardinal(context) {
    return new CardinalOpen(context, tension);
  }
  cardinal.tension = function (tension) {
    return custom(+tension);
  };
  return cardinal;
})(0);

function point$3(that, x, y) {
  var x1 = that._x1,
    y1 = that._y1,
    x2 = that._x2,
    y2 = that._y2;
  if (that._l01_a > epsilon$5) {
    var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a,
      n = 3 * that._l01_a * (that._l01_a + that._l12_a);
    x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
    y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
  }
  if (that._l23_a > epsilon$5) {
    var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a,
      m = 3 * that._l23_a * (that._l23_a + that._l12_a);
    x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
    y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
  }
  that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
}
function CatmullRom(context, alpha) {
  this._context = context;
  this._alpha = alpha;
}
CatmullRom.prototype = {
  areaStart: function () {
    this._line = 0;
  },
  areaEnd: function () {
    this._line = NaN;
  },
  lineStart: function () {
    this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
    this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
  },
  lineEnd: function () {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x2, this._y2);
        break;
      case 3:
        this.point(this._x2, this._y2);
        break;
    }
    if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function (x, y) {
    x = +x, y = +y;
    if (this._point) {
      var x23 = this._x2 - x,
        y23 = this._y2 - y;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
    }
    switch (this._point) {
      case 0:
        this._point = 1;
        this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3;
      // falls through
      default:
        point$3(this, x, y);
        break;
    }
    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};
var curveCatmullRom = (function custom(alpha) {
  function catmullRom(context) {
    return alpha ? new CatmullRom(context, alpha) : new Cardinal(context, 0);
  }
  catmullRom.alpha = function (alpha) {
    return custom(+alpha);
  };
  return catmullRom;
})(0.5);

function CatmullRomClosed(context, alpha) {
  this._context = context;
  this._alpha = alpha;
}
CatmullRomClosed.prototype = {
  areaStart: noop$3,
  areaEnd: noop$3,
  lineStart: function () {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
    this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
  },
  lineEnd: function () {
    switch (this._point) {
      case 1:
        {
          this._context.moveTo(this._x3, this._y3);
          this._context.closePath();
          break;
        }
      case 2:
        {
          this._context.lineTo(this._x3, this._y3);
          this._context.closePath();
          break;
        }
      case 3:
        {
          this.point(this._x3, this._y3);
          this.point(this._x4, this._y4);
          this.point(this._x5, this._y5);
          break;
        }
    }
  },
  point: function (x, y) {
    x = +x, y = +y;
    if (this._point) {
      var x23 = this._x2 - x,
        y23 = this._y2 - y;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
    }
    switch (this._point) {
      case 0:
        this._point = 1;
        this._x3 = x, this._y3 = y;
        break;
      case 1:
        this._point = 2;
        this._context.moveTo(this._x4 = x, this._y4 = y);
        break;
      case 2:
        this._point = 3;
        this._x5 = x, this._y5 = y;
        break;
      default:
        point$3(this, x, y);
        break;
    }
    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};
var curveCatmullRomClosed = (function custom(alpha) {
  function catmullRom(context) {
    return alpha ? new CatmullRomClosed(context, alpha) : new CardinalClosed(context, 0);
  }
  catmullRom.alpha = function (alpha) {
    return custom(+alpha);
  };
  return catmullRom;
})(0.5);

function CatmullRomOpen(context, alpha) {
  this._context = context;
  this._alpha = alpha;
}
CatmullRomOpen.prototype = {
  areaStart: function () {
    this._line = 0;
  },
  areaEnd: function () {
    this._line = NaN;
  },
  lineStart: function () {
    this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
    this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
  },
  lineEnd: function () {
    if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function (x, y) {
    x = +x, y = +y;
    if (this._point) {
      var x23 = this._x2 - x,
        y23 = this._y2 - y;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
    }
    switch (this._point) {
      case 0:
        this._point = 1;
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3;
        this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
        break;
      case 3:
        this._point = 4;
      // falls through
      default:
        point$3(this, x, y);
        break;
    }
    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};
var curveCatmullRomOpen = (function custom(alpha) {
  function catmullRom(context) {
    return alpha ? new CatmullRomOpen(context, alpha) : new CardinalOpen(context, 0);
  }
  catmullRom.alpha = function (alpha) {
    return custom(+alpha);
  };
  return catmullRom;
})(0.5);

function LinearClosed(context) {
  this._context = context;
}
LinearClosed.prototype = {
  areaStart: noop$3,
  areaEnd: noop$3,
  lineStart: function () {
    this._point = 0;
  },
  lineEnd: function () {
    if (this._point) this._context.closePath();
  },
  point: function (x, y) {
    x = +x, y = +y;
    if (this._point) this._context.lineTo(x, y);else this._point = 1, this._context.moveTo(x, y);
  }
};
function curveLinearClosed (context) {
  return new LinearClosed(context);
}

function sign$1(x) {
  return x < 0 ? -1 : 1;
}

// Calculate the slopes of the tangents (Hermite-type interpolation) based on
// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
// NOV(II), P. 443, 1990.
function slope3(that, x2, y2) {
  var h0 = that._x1 - that._x0,
    h1 = x2 - that._x1,
    s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0),
    s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0),
    p = (s0 * h1 + s1 * h0) / (h0 + h1);
  return (sign$1(s0) + sign$1(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
}

// Calculate a one-sided slope.
function slope2(that, t) {
  var h = that._x1 - that._x0;
  return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
}

// According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
function point$2(that, t0, t1) {
  var x0 = that._x0,
    y0 = that._y0,
    x1 = that._x1,
    y1 = that._y1,
    dx = (x1 - x0) / 3;
  that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
}
function MonotoneX(context) {
  this._context = context;
}
MonotoneX.prototype = {
  areaStart: function () {
    this._line = 0;
  },
  areaEnd: function () {
    this._line = NaN;
  },
  lineStart: function () {
    this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN;
    this._point = 0;
  },
  lineEnd: function () {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x1, this._y1);
        break;
      case 3:
        point$2(this, this._t0, slope2(this, this._t0));
        break;
    }
    if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function (x, y) {
    var t1 = NaN;
    x = +x, y = +y;
    if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
    switch (this._point) {
      case 0:
        this._point = 1;
        this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3;
        point$2(this, slope2(this, t1 = slope3(this, x, y)), t1);
        break;
      default:
        point$2(this, this._t0, t1 = slope3(this, x, y));
        break;
    }
    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
    this._t0 = t1;
  }
};
function MonotoneY(context) {
  this._context = new ReflectContext(context);
}
(MonotoneY.prototype = Object.create(MonotoneX.prototype)).point = function (x, y) {
  MonotoneX.prototype.point.call(this, y, x);
};
function ReflectContext(context) {
  this._context = context;
}
ReflectContext.prototype = {
  moveTo: function (x, y) {
    this._context.moveTo(y, x);
  },
  closePath: function () {
    this._context.closePath();
  },
  lineTo: function (x, y) {
    this._context.lineTo(y, x);
  },
  bezierCurveTo: function (x1, y1, x2, y2, x, y) {
    this._context.bezierCurveTo(y1, x1, y2, x2, y, x);
  }
};
function monotoneX(context) {
  return new MonotoneX(context);
}
function monotoneY(context) {
  return new MonotoneY(context);
}

function Natural(context) {
  this._context = context;
}
Natural.prototype = {
  areaStart: function () {
    this._line = 0;
  },
  areaEnd: function () {
    this._line = NaN;
  },
  lineStart: function () {
    this._x = [];
    this._y = [];
  },
  lineEnd: function () {
    var x = this._x,
      y = this._y,
      n = x.length;
    if (n) {
      this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
      if (n === 2) {
        this._context.lineTo(x[1], y[1]);
      } else {
        var px = controlPoints(x),
          py = controlPoints(y);
        for (var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1) {
          this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
        }
      }
    }
    if (this._line || this._line !== 0 && n === 1) this._context.closePath();
    this._line = 1 - this._line;
    this._x = this._y = null;
  },
  point: function (x, y) {
    this._x.push(+x);
    this._y.push(+y);
  }
};

// See https://www.particleincell.com/2012/bezier-splines/ for derivation.
function controlPoints(x) {
  var i,
    n = x.length - 1,
    m,
    a = new Array(n),
    b = new Array(n),
    r = new Array(n);
  a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
  for (i = 1; i < n - 1; ++i) a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
  a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
  for (i = 1; i < n; ++i) m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
  a[n - 1] = r[n - 1] / b[n - 1];
  for (i = n - 2; i >= 0; --i) a[i] = (r[i] - a[i + 1]) / b[i];
  b[n - 1] = (x[n] + a[n - 1]) / 2;
  for (i = 0; i < n - 1; ++i) b[i] = 2 * x[i + 1] - a[i + 1];
  return [a, b];
}
function curveNatural (context) {
  return new Natural(context);
}

function Step(context, t) {
  this._context = context;
  this._t = t;
}
Step.prototype = {
  areaStart: function () {
    this._line = 0;
  },
  areaEnd: function () {
    this._line = NaN;
  },
  lineStart: function () {
    this._x = this._y = NaN;
    this._point = 0;
  },
  lineEnd: function () {
    if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
    if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
    if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
  },
  point: function (x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0:
        this._point = 1;
        this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
        break;
      case 1:
        this._point = 2;
      // falls through
      default:
        {
          if (this._t <= 0) {
            this._context.lineTo(this._x, y);
            this._context.lineTo(x, y);
          } else {
            var x1 = this._x * (1 - this._t) + x * this._t;
            this._context.lineTo(x1, this._y);
            this._context.lineTo(x1, y);
          }
          break;
        }
    }
    this._x = x, this._y = y;
  }
};
function curveStep (context) {
  return new Step(context, 0.5);
}
function stepBefore(context) {
  return new Step(context, 0);
}
function stepAfter(context) {
  return new Step(context, 1);
}

function domCanvas(w, h) {
  if (typeof document !== 'undefined' && document.createElement) {
    const c = document.createElement('canvas');
    if (c && c.getContext) {
      c.width = w;
      c.height = h;
      return c;
    }
  }
  return null;
}
const domImage = () => typeof Image !== 'undefined' ? Image : null;

function initRange(domain, range) {
  switch (arguments.length) {
    case 0:
      break;
    case 1:
      this.range(domain);
      break;
    default:
      this.range(range).domain(domain);
      break;
  }
  return this;
}
function initInterpolator(domain, interpolator) {
  switch (arguments.length) {
    case 0:
      break;
    case 1:
      {
        if (typeof domain === "function") this.interpolator(domain);else this.range(domain);
        break;
      }
    default:
      {
        this.domain(domain);
        if (typeof interpolator === "function") this.interpolator(interpolator);else this.range(interpolator);
        break;
      }
  }
  return this;
}

const implicit = Symbol("implicit");
function ordinal() {
  var index = new InternMap(),
    domain = [],
    range = [],
    unknown = implicit;
  function scale(d) {
    let i = index.get(d);
    if (i === undefined) {
      if (unknown !== implicit) return unknown;
      index.set(d, i = domain.push(d) - 1);
    }
    return range[i % range.length];
  }
  scale.domain = function (_) {
    if (!arguments.length) return domain.slice();
    domain = [], index = new InternMap();
    for (const value of _) {
      if (index.has(value)) continue;
      index.set(value, domain.push(value) - 1);
    }
    return scale;
  };
  scale.range = function (_) {
    return arguments.length ? (range = Array.from(_), scale) : range.slice();
  };
  scale.unknown = function (_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };
  scale.copy = function () {
    return ordinal(domain, range).unknown(unknown);
  };
  initRange.apply(scale, arguments);
  return scale;
}

function define (constructor, factory, prototype) {
  constructor.prototype = factory.prototype = prototype;
  prototype.constructor = constructor;
}
function extend(parent, definition) {
  var prototype = Object.create(parent.prototype);
  for (var key in definition) prototype[key] = definition[key];
  return prototype;
}

function Color() {}
var darker = 0.7;
var brighter = 1 / darker;
var reI = "\\s*([+-]?\\d+)\\s*",
  reN = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*",
  reP = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*",
  reHex = /^#([0-9a-f]{3,8})$/,
  reRgbInteger = new RegExp(`^rgb\\(${reI},${reI},${reI}\\)$`),
  reRgbPercent = new RegExp(`^rgb\\(${reP},${reP},${reP}\\)$`),
  reRgbaInteger = new RegExp(`^rgba\\(${reI},${reI},${reI},${reN}\\)$`),
  reRgbaPercent = new RegExp(`^rgba\\(${reP},${reP},${reP},${reN}\\)$`),
  reHslPercent = new RegExp(`^hsl\\(${reN},${reP},${reP}\\)$`),
  reHslaPercent = new RegExp(`^hsla\\(${reN},${reP},${reP},${reN}\\)$`);
var named = {
  aliceblue: 0xf0f8ff,
  antiquewhite: 0xfaebd7,
  aqua: 0x00ffff,
  aquamarine: 0x7fffd4,
  azure: 0xf0ffff,
  beige: 0xf5f5dc,
  bisque: 0xffe4c4,
  black: 0x000000,
  blanchedalmond: 0xffebcd,
  blue: 0x0000ff,
  blueviolet: 0x8a2be2,
  brown: 0xa52a2a,
  burlywood: 0xdeb887,
  cadetblue: 0x5f9ea0,
  chartreuse: 0x7fff00,
  chocolate: 0xd2691e,
  coral: 0xff7f50,
  cornflowerblue: 0x6495ed,
  cornsilk: 0xfff8dc,
  crimson: 0xdc143c,
  cyan: 0x00ffff,
  darkblue: 0x00008b,
  darkcyan: 0x008b8b,
  darkgoldenrod: 0xb8860b,
  darkgray: 0xa9a9a9,
  darkgreen: 0x006400,
  darkgrey: 0xa9a9a9,
  darkkhaki: 0xbdb76b,
  darkmagenta: 0x8b008b,
  darkolivegreen: 0x556b2f,
  darkorange: 0xff8c00,
  darkorchid: 0x9932cc,
  darkred: 0x8b0000,
  darksalmon: 0xe9967a,
  darkseagreen: 0x8fbc8f,
  darkslateblue: 0x483d8b,
  darkslategray: 0x2f4f4f,
  darkslategrey: 0x2f4f4f,
  darkturquoise: 0x00ced1,
  darkviolet: 0x9400d3,
  deeppink: 0xff1493,
  deepskyblue: 0x00bfff,
  dimgray: 0x696969,
  dimgrey: 0x696969,
  dodgerblue: 0x1e90ff,
  firebrick: 0xb22222,
  floralwhite: 0xfffaf0,
  forestgreen: 0x228b22,
  fuchsia: 0xff00ff,
  gainsboro: 0xdcdcdc,
  ghostwhite: 0xf8f8ff,
  gold: 0xffd700,
  goldenrod: 0xdaa520,
  gray: 0x808080,
  green: 0x008000,
  greenyellow: 0xadff2f,
  grey: 0x808080,
  honeydew: 0xf0fff0,
  hotpink: 0xff69b4,
  indianred: 0xcd5c5c,
  indigo: 0x4b0082,
  ivory: 0xfffff0,
  khaki: 0xf0e68c,
  lavender: 0xe6e6fa,
  lavenderblush: 0xfff0f5,
  lawngreen: 0x7cfc00,
  lemonchiffon: 0xfffacd,
  lightblue: 0xadd8e6,
  lightcoral: 0xf08080,
  lightcyan: 0xe0ffff,
  lightgoldenrodyellow: 0xfafad2,
  lightgray: 0xd3d3d3,
  lightgreen: 0x90ee90,
  lightgrey: 0xd3d3d3,
  lightpink: 0xffb6c1,
  lightsalmon: 0xffa07a,
  lightseagreen: 0x20b2aa,
  lightskyblue: 0x87cefa,
  lightslategray: 0x778899,
  lightslategrey: 0x778899,
  lightsteelblue: 0xb0c4de,
  lightyellow: 0xffffe0,
  lime: 0x00ff00,
  limegreen: 0x32cd32,
  linen: 0xfaf0e6,
  magenta: 0xff00ff,
  maroon: 0x800000,
  mediumaquamarine: 0x66cdaa,
  mediumblue: 0x0000cd,
  mediumorchid: 0xba55d3,
  mediumpurple: 0x9370db,
  mediumseagreen: 0x3cb371,
  mediumslateblue: 0x7b68ee,
  mediumspringgreen: 0x00fa9a,
  mediumturquoise: 0x48d1cc,
  mediumvioletred: 0xc71585,
  midnightblue: 0x191970,
  mintcream: 0xf5fffa,
  mistyrose: 0xffe4e1,
  moccasin: 0xffe4b5,
  navajowhite: 0xffdead,
  navy: 0x000080,
  oldlace: 0xfdf5e6,
  olive: 0x808000,
  olivedrab: 0x6b8e23,
  orange: 0xffa500,
  orangered: 0xff4500,
  orchid: 0xda70d6,
  palegoldenrod: 0xeee8aa,
  palegreen: 0x98fb98,
  paleturquoise: 0xafeeee,
  palevioletred: 0xdb7093,
  papayawhip: 0xffefd5,
  peachpuff: 0xffdab9,
  peru: 0xcd853f,
  pink: 0xffc0cb,
  plum: 0xdda0dd,
  powderblue: 0xb0e0e6,
  purple: 0x800080,
  rebeccapurple: 0x663399,
  red: 0xff0000,
  rosybrown: 0xbc8f8f,
  royalblue: 0x4169e1,
  saddlebrown: 0x8b4513,
  salmon: 0xfa8072,
  sandybrown: 0xf4a460,
  seagreen: 0x2e8b57,
  seashell: 0xfff5ee,
  sienna: 0xa0522d,
  silver: 0xc0c0c0,
  skyblue: 0x87ceeb,
  slateblue: 0x6a5acd,
  slategray: 0x708090,
  slategrey: 0x708090,
  snow: 0xfffafa,
  springgreen: 0x00ff7f,
  steelblue: 0x4682b4,
  tan: 0xd2b48c,
  teal: 0x008080,
  thistle: 0xd8bfd8,
  tomato: 0xff6347,
  turquoise: 0x40e0d0,
  violet: 0xee82ee,
  wheat: 0xf5deb3,
  white: 0xffffff,
  whitesmoke: 0xf5f5f5,
  yellow: 0xffff00,
  yellowgreen: 0x9acd32
};
define(Color, color$2, {
  copy(channels) {
    return Object.assign(new this.constructor(), this, channels);
  },
  displayable() {
    return this.rgb().displayable();
  },
  hex: color_formatHex,
  // Deprecated! Use color.formatHex.
  formatHex: color_formatHex,
  formatHex8: color_formatHex8,
  formatHsl: color_formatHsl,
  formatRgb: color_formatRgb,
  toString: color_formatRgb
});
function color_formatHex() {
  return this.rgb().formatHex();
}
function color_formatHex8() {
  return this.rgb().formatHex8();
}
function color_formatHsl() {
  return hslConvert(this).formatHsl();
}
function color_formatRgb() {
  return this.rgb().formatRgb();
}
function color$2(format) {
  var m, l;
  format = (format + "").trim().toLowerCase();
  return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
  : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
  : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
  : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
  : null // invalid hex
  ) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
  : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
  : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
  : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
  : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
  : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
  : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
  : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
  return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function rgba(r, g, b, a) {
  if (a <= 0) r = g = b = NaN;
  return new Rgb(r, g, b, a);
}
function rgbConvert(o) {
  if (!(o instanceof Color)) o = color$2(o);
  if (!o) return new Rgb();
  o = o.rgb();
  return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb$1(r, g, b, opacity) {
  return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
  this.r = +r;
  this.g = +g;
  this.b = +b;
  this.opacity = +opacity;
}
define(Rgb, rgb$1, extend(Color, {
  brighter(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  darker(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  rgb() {
    return this;
  },
  clamp() {
    return new Rgb(clampi(this.r), clampi(this.g), clampi(this.b), clampa(this.opacity));
  },
  displayable() {
    return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
  },
  hex: rgb_formatHex,
  // Deprecated! Use color.formatHex.
  formatHex: rgb_formatHex,
  formatHex8: rgb_formatHex8,
  formatRgb: rgb_formatRgb,
  toString: rgb_formatRgb
}));
function rgb_formatHex() {
  return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}`;
}
function rgb_formatHex8() {
  return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}${hex((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function rgb_formatRgb() {
  const a = clampa(this.opacity);
  return `${a === 1 ? "rgb(" : "rgba("}${clampi(this.r)}, ${clampi(this.g)}, ${clampi(this.b)}${a === 1 ? ")" : `, ${a})`}`;
}
function clampa(opacity) {
  return isNaN(opacity) ? 1 : Math.max(0, Math.min(1, opacity));
}
function clampi(value) {
  return Math.max(0, Math.min(255, Math.round(value) || 0));
}
function hex(value) {
  value = clampi(value);
  return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h, s, l, a) {
  if (a <= 0) h = s = l = NaN;else if (l <= 0 || l >= 1) h = s = NaN;else if (s <= 0) h = NaN;
  return new Hsl(h, s, l, a);
}
function hslConvert(o) {
  if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof Color)) o = color$2(o);
  if (!o) return new Hsl();
  if (o instanceof Hsl) return o;
  o = o.rgb();
  var r = o.r / 255,
    g = o.g / 255,
    b = o.b / 255,
    min = Math.min(r, g, b),
    max = Math.max(r, g, b),
    h = NaN,
    s = max - min,
    l = (max + min) / 2;
  if (s) {
    if (r === max) h = (g - b) / s + (g < b) * 6;else if (g === max) h = (b - r) / s + 2;else h = (r - g) / s + 4;
    s /= l < 0.5 ? max + min : 2 - max - min;
    h *= 60;
  } else {
    s = l > 0 && l < 1 ? 0 : h;
  }
  return new Hsl(h, s, l, o.opacity);
}
function hsl$2(h, s, l, opacity) {
  return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
  this.h = +h;
  this.s = +s;
  this.l = +l;
  this.opacity = +opacity;
}
define(Hsl, hsl$2, extend(Color, {
  brighter(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },
  darker(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },
  rgb() {
    var h = this.h % 360 + (this.h < 0) * 360,
      s = isNaN(h) || isNaN(this.s) ? 0 : this.s,
      l = this.l,
      m2 = l + (l < 0.5 ? l : 1 - l) * s,
      m1 = 2 * l - m2;
    return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
  },
  clamp() {
    return new Hsl(clamph(this.h), clampt(this.s), clampt(this.l), clampa(this.opacity));
  },
  displayable() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
  },
  formatHsl() {
    const a = clampa(this.opacity);
    return `${a === 1 ? "hsl(" : "hsla("}${clamph(this.h)}, ${clampt(this.s) * 100}%, ${clampt(this.l) * 100}%${a === 1 ? ")" : `, ${a})`}`;
  }
}));
function clamph(value) {
  value = (value || 0) % 360;
  return value < 0 ? value + 360 : value;
}
function clampt(value) {
  return Math.max(0, Math.min(1, value || 0));
}

/* From FvD 13.37, CSS Color Module Level 3 */
function hsl2rgb(h, m1, m2) {
  return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

const radians$1 = Math.PI / 180;
const degrees$2 = 180 / Math.PI;

// https://observablehq.com/@mbostock/lab-and-rgb
const K = 18,
  Xn = 0.96422,
  Yn = 1,
  Zn = 0.82521,
  t0 = 4 / 29,
  t1 = 6 / 29,
  t2 = 3 * t1 * t1,
  t3 = t1 * t1 * t1;
function labConvert(o) {
  if (o instanceof Lab) return new Lab(o.l, o.a, o.b, o.opacity);
  if (o instanceof Hcl) return hcl2lab(o);
  if (!(o instanceof Rgb)) o = rgbConvert(o);
  var r = rgb2lrgb(o.r),
    g = rgb2lrgb(o.g),
    b = rgb2lrgb(o.b),
    y = xyz2lab((0.2225045 * r + 0.7168786 * g + 0.0606169 * b) / Yn),
    x,
    z;
  if (r === g && g === b) x = z = y;else {
    x = xyz2lab((0.4360747 * r + 0.3850649 * g + 0.1430804 * b) / Xn);
    z = xyz2lab((0.0139322 * r + 0.0971045 * g + 0.7141733 * b) / Zn);
  }
  return new Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
}
function lab$1(l, a, b, opacity) {
  return arguments.length === 1 ? labConvert(l) : new Lab(l, a, b, opacity == null ? 1 : opacity);
}
function Lab(l, a, b, opacity) {
  this.l = +l;
  this.a = +a;
  this.b = +b;
  this.opacity = +opacity;
}
define(Lab, lab$1, extend(Color, {
  brighter(k) {
    return new Lab(this.l + K * (k == null ? 1 : k), this.a, this.b, this.opacity);
  },
  darker(k) {
    return new Lab(this.l - K * (k == null ? 1 : k), this.a, this.b, this.opacity);
  },
  rgb() {
    var y = (this.l + 16) / 116,
      x = isNaN(this.a) ? y : y + this.a / 500,
      z = isNaN(this.b) ? y : y - this.b / 200;
    x = Xn * lab2xyz(x);
    y = Yn * lab2xyz(y);
    z = Zn * lab2xyz(z);
    return new Rgb(lrgb2rgb(3.1338561 * x - 1.6168667 * y - 0.4906146 * z), lrgb2rgb(-0.9787684 * x + 1.9161415 * y + 0.0334540 * z), lrgb2rgb(0.0719453 * x - 0.2289914 * y + 1.4052427 * z), this.opacity);
  }
}));
function xyz2lab(t) {
  return t > t3 ? Math.pow(t, 1 / 3) : t / t2 + t0;
}
function lab2xyz(t) {
  return t > t1 ? t * t * t : t2 * (t - t0);
}
function lrgb2rgb(x) {
  return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
}
function rgb2lrgb(x) {
  return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
}
function hclConvert(o) {
  if (o instanceof Hcl) return new Hcl(o.h, o.c, o.l, o.opacity);
  if (!(o instanceof Lab)) o = labConvert(o);
  if (o.a === 0 && o.b === 0) return new Hcl(NaN, 0 < o.l && o.l < 100 ? 0 : NaN, o.l, o.opacity);
  var h = Math.atan2(o.b, o.a) * degrees$2;
  return new Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
}
function hcl$2(h, c, l, opacity) {
  return arguments.length === 1 ? hclConvert(h) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
}
function Hcl(h, c, l, opacity) {
  this.h = +h;
  this.c = +c;
  this.l = +l;
  this.opacity = +opacity;
}
function hcl2lab(o) {
  if (isNaN(o.h)) return new Lab(o.l, 0, 0, o.opacity);
  var h = o.h * radians$1;
  return new Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
}
define(Hcl, hcl$2, extend(Color, {
  brighter(k) {
    return new Hcl(this.h, this.c, this.l + K * (k == null ? 1 : k), this.opacity);
  },
  darker(k) {
    return new Hcl(this.h, this.c, this.l - K * (k == null ? 1 : k), this.opacity);
  },
  rgb() {
    return hcl2lab(this).rgb();
  }
}));

var A = -0.14861,
  B$1 = 1.78277,
  C$1 = -0.29227,
  D$1 = -0.90649,
  E = 1.97294,
  ED = E * D$1,
  EB = E * B$1,
  BC_DA = B$1 * C$1 - D$1 * A;
function cubehelixConvert(o) {
  if (o instanceof Cubehelix) return new Cubehelix(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof Rgb)) o = rgbConvert(o);
  var r = o.r / 255,
    g = o.g / 255,
    b = o.b / 255,
    l = (BC_DA * b + ED * r - EB * g) / (BC_DA + ED - EB),
    bl = b - l,
    k = (E * (g - l) - C$1 * bl) / D$1,
    s = Math.sqrt(k * k + bl * bl) / (E * l * (1 - l)),
    // NaN if l=0 or l=1
    h = s ? Math.atan2(k, bl) * degrees$2 - 120 : NaN;
  return new Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
}
function cubehelix$2(h, s, l, opacity) {
  return arguments.length === 1 ? cubehelixConvert(h) : new Cubehelix(h, s, l, opacity == null ? 1 : opacity);
}
function Cubehelix(h, s, l, opacity) {
  this.h = +h;
  this.s = +s;
  this.l = +l;
  this.opacity = +opacity;
}
define(Cubehelix, cubehelix$2, extend(Color, {
  brighter(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
  },
  darker(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
  },
  rgb() {
    var h = isNaN(this.h) ? 0 : (this.h + 120) * radians$1,
      l = +this.l,
      a = isNaN(this.s) ? 0 : this.s * l * (1 - l),
      cosh = Math.cos(h),
      sinh = Math.sin(h);
    return new Rgb(255 * (l + a * (A * cosh + B$1 * sinh)), 255 * (l + a * (C$1 * cosh + D$1 * sinh)), 255 * (l + a * (E * cosh)), this.opacity);
  }
}));

function basis(t1, v0, v1, v2, v3) {
  var t2 = t1 * t1,
    t3 = t2 * t1;
  return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
}
function basis$1 (values) {
  var n = values.length - 1;
  return function (t) {
    var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n),
      v1 = values[i],
      v2 = values[i + 1],
      v0 = i > 0 ? values[i - 1] : 2 * v1 - v2,
      v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
    return basis((t - i / n) * n, v0, v1, v2, v3);
  };
}

function basisClosed (values) {
  var n = values.length;
  return function (t) {
    var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n),
      v0 = values[(i + n - 1) % n],
      v1 = values[i % n],
      v2 = values[(i + 1) % n],
      v3 = values[(i + 2) % n];
    return basis((t - i / n) * n, v0, v1, v2, v3);
  };
}

var constant$2 = x => () => x;

function linear$1(a, d) {
  return function (t) {
    return a + t * d;
  };
}
function exponential(a, b, y) {
  return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function (t) {
    return Math.pow(a + t * b, y);
  };
}
function hue$1(a, b) {
  var d = b - a;
  return d ? linear$1(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : constant$2(isNaN(a) ? b : a);
}
function gamma(y) {
  return (y = +y) === 1 ? nogamma : function (a, b) {
    return b - a ? exponential(a, b, y) : constant$2(isNaN(a) ? b : a);
  };
}
function nogamma(a, b) {
  var d = b - a;
  return d ? linear$1(a, d) : constant$2(isNaN(a) ? b : a);
}

var rgb = (function rgbGamma(y) {
  var color = gamma(y);
  function rgb(start, end) {
    var r = color((start = rgb$1(start)).r, (end = rgb$1(end)).r),
      g = color(start.g, end.g),
      b = color(start.b, end.b),
      opacity = nogamma(start.opacity, end.opacity);
    return function (t) {
      start.r = r(t);
      start.g = g(t);
      start.b = b(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }
  rgb.gamma = rgbGamma;
  return rgb;
})(1);
function rgbSpline(spline) {
  return function (colors) {
    var n = colors.length,
      r = new Array(n),
      g = new Array(n),
      b = new Array(n),
      i,
      color;
    for (i = 0; i < n; ++i) {
      color = rgb$1(colors[i]);
      r[i] = color.r || 0;
      g[i] = color.g || 0;
      b[i] = color.b || 0;
    }
    r = spline(r);
    g = spline(g);
    b = spline(b);
    color.opacity = 1;
    return function (t) {
      color.r = r(t);
      color.g = g(t);
      color.b = b(t);
      return color + "";
    };
  };
}
var rgbBasis = rgbSpline(basis$1);
var rgbBasisClosed = rgbSpline(basisClosed);

function numberArray (a, b) {
  if (!b) b = [];
  var n = a ? Math.min(b.length, a.length) : 0,
    c = b.slice(),
    i;
  return function (t) {
    for (i = 0; i < n; ++i) c[i] = a[i] * (1 - t) + b[i] * t;
    return c;
  };
}
function isNumberArray(x) {
  return ArrayBuffer.isView(x) && !(x instanceof DataView);
}

function array$3 (a, b) {
  return (isNumberArray(b) ? numberArray : genericArray)(a, b);
}
function genericArray(a, b) {
  var nb = b ? b.length : 0,
    na = a ? Math.min(nb, a.length) : 0,
    x = new Array(na),
    c = new Array(nb),
    i;
  for (i = 0; i < na; ++i) x[i] = interpolate$1(a[i], b[i]);
  for (; i < nb; ++i) c[i] = b[i];
  return function (t) {
    for (i = 0; i < na; ++i) c[i] = x[i](t);
    return c;
  };
}

function date$1 (a, b) {
  var d = new Date();
  return a = +a, b = +b, function (t) {
    return d.setTime(a * (1 - t) + b * t), d;
  };
}

function interpolateNumber (a, b) {
  return a = +a, b = +b, function (t) {
    return a * (1 - t) + b * t;
  };
}

function object (a, b) {
  var i = {},
    c = {},
    k;
  if (a === null || typeof a !== "object") a = {};
  if (b === null || typeof b !== "object") b = {};
  for (k in b) {
    if (k in a) {
      i[k] = interpolate$1(a[k], b[k]);
    } else {
      c[k] = b[k];
    }
  }
  return function (t) {
    for (k in i) c[k] = i[k](t);
    return c;
  };
}

var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,
  reB = new RegExp(reA.source, "g");
function zero$1(b) {
  return function () {
    return b;
  };
}
function one$1(b) {
  return function (t) {
    return b(t) + "";
  };
}
function string (a, b) {
  var bi = reA.lastIndex = reB.lastIndex = 0,
    // scan index for next number in b
    am,
    // current match in a
    bm,
    // current match in b
    bs,
    // string preceding current number in b, if any
    i = -1,
    // index in s
    s = [],
    // string constants and placeholders
    q = []; // number interpolators

  // Coerce inputs to strings.
  a = a + "", b = b + "";

  // Interpolate pairs of numbers in a & b.
  while ((am = reA.exec(a)) && (bm = reB.exec(b))) {
    if ((bs = bm.index) > bi) {
      // a string precedes the next number in b
      bs = b.slice(bi, bs);
      if (s[i]) s[i] += bs; // coalesce with previous string
      else s[++i] = bs;
    }
    if ((am = am[0]) === (bm = bm[0])) {
      // numbers in a & b match
      if (s[i]) s[i] += bm; // coalesce with previous string
      else s[++i] = bm;
    } else {
      // interpolate non-matching numbers
      s[++i] = null;
      q.push({
        i: i,
        x: interpolateNumber(am, bm)
      });
    }
    bi = reB.lastIndex;
  }

  // Add remains of b.
  if (bi < b.length) {
    bs = b.slice(bi);
    if (s[i]) s[i] += bs; // coalesce with previous string
    else s[++i] = bs;
  }

  // Special optimization for only a single match.
  // Otherwise, interpolate each of the numbers and rejoin the string.
  return s.length < 2 ? q[0] ? one$1(q[0].x) : zero$1(b) : (b = q.length, function (t) {
    for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
    return s.join("");
  });
}

function interpolate$1 (a, b) {
  var t = typeof b,
    c;
  return b == null || t === "boolean" ? constant$2(b) : (t === "number" ? interpolateNumber : t === "string" ? (c = color$2(b)) ? (b = c, rgb) : string : b instanceof color$2 ? rgb : b instanceof Date ? date$1 : isNumberArray(b) ? numberArray : Array.isArray(b) ? genericArray : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? object : interpolateNumber)(a, b);
}

function discrete$1 (range) {
  var n = range.length;
  return function (t) {
    return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
  };
}

function hue (a, b) {
  var i = hue$1(+a, +b);
  return function (t) {
    var x = i(t);
    return x - 360 * Math.floor(x / 360);
  };
}

function interpolateRound (a, b) {
  return a = +a, b = +b, function (t) {
    return Math.round(a * (1 - t) + b * t);
  };
}

var degrees$1 = 180 / Math.PI;
var identity$3 = {
  translateX: 0,
  translateY: 0,
  rotate: 0,
  skewX: 0,
  scaleX: 1,
  scaleY: 1
};
function decompose (a, b, c, d, e, f) {
  var scaleX, scaleY, skewX;
  if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
  if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
  if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
  if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
  return {
    translateX: e,
    translateY: f,
    rotate: Math.atan2(b, a) * degrees$1,
    skewX: Math.atan(skewX) * degrees$1,
    scaleX: scaleX,
    scaleY: scaleY
  };
}

var svgNode;

/* eslint-disable no-undef */
function parseCss(value) {
  const m = new (typeof DOMMatrix === "function" ? DOMMatrix : WebKitCSSMatrix)(value + "");
  return m.isIdentity ? identity$3 : decompose(m.a, m.b, m.c, m.d, m.e, m.f);
}
function parseSvg(value) {
  if (value == null) return identity$3;
  if (!svgNode) svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
  svgNode.setAttribute("transform", value);
  if (!(value = svgNode.transform.baseVal.consolidate())) return identity$3;
  value = value.matrix;
  return decompose(value.a, value.b, value.c, value.d, value.e, value.f);
}

function interpolateTransform(parse, pxComma, pxParen, degParen) {
  function pop(s) {
    return s.length ? s.pop() + " " : "";
  }
  function translate(xa, ya, xb, yb, s, q) {
    if (xa !== xb || ya !== yb) {
      var i = s.push("translate(", null, pxComma, null, pxParen);
      q.push({
        i: i - 4,
        x: interpolateNumber(xa, xb)
      }, {
        i: i - 2,
        x: interpolateNumber(ya, yb)
      });
    } else if (xb || yb) {
      s.push("translate(" + xb + pxComma + yb + pxParen);
    }
  }
  function rotate(a, b, s, q) {
    if (a !== b) {
      if (a - b > 180) b += 360;else if (b - a > 180) a += 360; // shortest path
      q.push({
        i: s.push(pop(s) + "rotate(", null, degParen) - 2,
        x: interpolateNumber(a, b)
      });
    } else if (b) {
      s.push(pop(s) + "rotate(" + b + degParen);
    }
  }
  function skewX(a, b, s, q) {
    if (a !== b) {
      q.push({
        i: s.push(pop(s) + "skewX(", null, degParen) - 2,
        x: interpolateNumber(a, b)
      });
    } else if (b) {
      s.push(pop(s) + "skewX(" + b + degParen);
    }
  }
  function scale(xa, ya, xb, yb, s, q) {
    if (xa !== xb || ya !== yb) {
      var i = s.push(pop(s) + "scale(", null, ",", null, ")");
      q.push({
        i: i - 4,
        x: interpolateNumber(xa, xb)
      }, {
        i: i - 2,
        x: interpolateNumber(ya, yb)
      });
    } else if (xb !== 1 || yb !== 1) {
      s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
  }
  return function (a, b) {
    var s = [],
      // string constants and placeholders
      q = []; // number interpolators
    a = parse(a), b = parse(b);
    translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
    rotate(a.rotate, b.rotate, s, q);
    skewX(a.skewX, b.skewX, s, q);
    scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
    a = b = null; // gc
    return function (t) {
      var i = -1,
        n = q.length,
        o;
      while (++i < n) s[(o = q[i]).i] = o.x(t);
      return s.join("");
    };
  };
}
var interpolateTransformCss = interpolateTransform(parseCss, "px, ", "px)", "deg)");
var interpolateTransformSvg = interpolateTransform(parseSvg, ", ", ")", ")");

var epsilon2$1 = 1e-12;
function cosh(x) {
  return ((x = Math.exp(x)) + 1 / x) / 2;
}
function sinh(x) {
  return ((x = Math.exp(x)) - 1 / x) / 2;
}
function tanh(x) {
  return ((x = Math.exp(2 * x)) - 1) / (x + 1);
}
var zoom = (function zoomRho(rho, rho2, rho4) {
  // p0 = [ux0, uy0, w0]
  // p1 = [ux1, uy1, w1]
  function zoom(p0, p1) {
    var ux0 = p0[0],
      uy0 = p0[1],
      w0 = p0[2],
      ux1 = p1[0],
      uy1 = p1[1],
      w1 = p1[2],
      dx = ux1 - ux0,
      dy = uy1 - uy0,
      d2 = dx * dx + dy * dy,
      i,
      S;

    // Special case for u0 ≅ u1.
    if (d2 < epsilon2$1) {
      S = Math.log(w1 / w0) / rho;
      i = function (t) {
        return [ux0 + t * dx, uy0 + t * dy, w0 * Math.exp(rho * t * S)];
      };
    }

    // General case.
    else {
      var d1 = Math.sqrt(d2),
        b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1),
        b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1),
        r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0),
        r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
      S = (r1 - r0) / rho;
      i = function (t) {
        var s = t * S,
          coshr0 = cosh(r0),
          u = w0 / (rho2 * d1) * (coshr0 * tanh(rho * s + r0) - sinh(r0));
        return [ux0 + u * dx, uy0 + u * dy, w0 * coshr0 / cosh(rho * s + r0)];
      };
    }
    i.duration = S * 1000 * rho / Math.SQRT2;
    return i;
  }
  zoom.rho = function (_) {
    var _1 = Math.max(1e-3, +_),
      _2 = _1 * _1,
      _4 = _2 * _2;
    return zoomRho(_1, _2, _4);
  };
  return zoom;
})(Math.SQRT2, 2, 4);

function hsl(hue) {
  return function (start, end) {
    var h = hue((start = hsl$2(start)).h, (end = hsl$2(end)).h),
      s = nogamma(start.s, end.s),
      l = nogamma(start.l, end.l),
      opacity = nogamma(start.opacity, end.opacity);
    return function (t) {
      start.h = h(t);
      start.s = s(t);
      start.l = l(t);
      start.opacity = opacity(t);
      return start + "";
    };
  };
}
var hsl$1 = hsl(hue$1);
var hslLong = hsl(nogamma);

function lab(start, end) {
  var l = nogamma((start = lab$1(start)).l, (end = lab$1(end)).l),
    a = nogamma(start.a, end.a),
    b = nogamma(start.b, end.b),
    opacity = nogamma(start.opacity, end.opacity);
  return function (t) {
    start.l = l(t);
    start.a = a(t);
    start.b = b(t);
    start.opacity = opacity(t);
    return start + "";
  };
}

function hcl(hue) {
  return function (start, end) {
    var h = hue((start = hcl$2(start)).h, (end = hcl$2(end)).h),
      c = nogamma(start.c, end.c),
      l = nogamma(start.l, end.l),
      opacity = nogamma(start.opacity, end.opacity);
    return function (t) {
      start.h = h(t);
      start.c = c(t);
      start.l = l(t);
      start.opacity = opacity(t);
      return start + "";
    };
  };
}
var hcl$1 = hcl(hue$1);
var hclLong = hcl(nogamma);

function cubehelix(hue) {
  return function cubehelixGamma(y) {
    y = +y;
    function cubehelix(start, end) {
      var h = hue((start = cubehelix$2(start)).h, (end = cubehelix$2(end)).h),
        s = nogamma(start.s, end.s),
        l = nogamma(start.l, end.l),
        opacity = nogamma(start.opacity, end.opacity);
      return function (t) {
        start.h = h(t);
        start.s = s(t);
        start.l = l(Math.pow(t, y));
        start.opacity = opacity(t);
        return start + "";
      };
    }
    cubehelix.gamma = cubehelixGamma;
    return cubehelix;
  }(1);
}
var cubehelix$1 = cubehelix(hue$1);
var cubehelixLong = cubehelix(nogamma);

function piecewise(interpolate, values) {
  if (values === undefined) values = interpolate, interpolate = interpolate$1;
  var i = 0,
    n = values.length - 1,
    v = values[0],
    I = new Array(n < 0 ? 0 : n);
  while (i < n) I[i] = interpolate(v, v = values[++i]);
  return function (t) {
    var i = Math.max(0, Math.min(n - 1, Math.floor(t *= n)));
    return I[i](t - i);
  };
}

function quantize$2 (interpolator, n) {
  var samples = new Array(n);
  for (var i = 0; i < n; ++i) samples[i] = interpolator(i / (n - 1));
  return samples;
}

var $$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    interpolate: interpolate$1,
    interpolateArray: array$3,
    interpolateBasis: basis$1,
    interpolateBasisClosed: basisClosed,
    interpolateCubehelix: cubehelix$1,
    interpolateCubehelixLong: cubehelixLong,
    interpolateDate: date$1,
    interpolateDiscrete: discrete$1,
    interpolateHcl: hcl$1,
    interpolateHclLong: hclLong,
    interpolateHsl: hsl$1,
    interpolateHslLong: hslLong,
    interpolateHue: hue,
    interpolateLab: lab,
    interpolateNumber: interpolateNumber,
    interpolateNumberArray: numberArray,
    interpolateObject: object,
    interpolateRgb: rgb,
    interpolateRgbBasis: rgbBasis,
    interpolateRgbBasisClosed: rgbBasisClosed,
    interpolateRound: interpolateRound,
    interpolateString: string,
    interpolateTransformCss: interpolateTransformCss,
    interpolateTransformSvg: interpolateTransformSvg,
    interpolateZoom: zoom,
    piecewise: piecewise,
    quantize: quantize$2
});

function constants(x) {
  return function () {
    return x;
  };
}

function number$5(x) {
  return +x;
}

var unit = [0, 1];
function identity$2(x) {
  return x;
}
function normalize$1(a, b) {
  return (b -= a = +a) ? function (x) {
    return (x - a) / b;
  } : constants(isNaN(b) ? NaN : 0.5);
}
function clamper(a, b) {
  var t;
  if (a > b) t = a, a = b, b = t;
  return function (x) {
    return Math.max(a, Math.min(b, x));
  };
}

// normalize(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// interpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding range value x in [a,b].
function bimap(domain, range, interpolate) {
  var d0 = domain[0],
    d1 = domain[1],
    r0 = range[0],
    r1 = range[1];
  if (d1 < d0) d0 = normalize$1(d1, d0), r0 = interpolate(r1, r0);else d0 = normalize$1(d0, d1), r0 = interpolate(r0, r1);
  return function (x) {
    return r0(d0(x));
  };
}
function polymap(domain, range, interpolate) {
  var j = Math.min(domain.length, range.length) - 1,
    d = new Array(j),
    r = new Array(j),
    i = -1;

  // Reverse descending domains.
  if (domain[j] < domain[0]) {
    domain = domain.slice().reverse();
    range = range.slice().reverse();
  }
  while (++i < j) {
    d[i] = normalize$1(domain[i], domain[i + 1]);
    r[i] = interpolate(range[i], range[i + 1]);
  }
  return function (x) {
    var i = bisectRight$1(domain, x, 1, j) - 1;
    return r[i](d[i](x));
  };
}
function copy$2(source, target) {
  return target.domain(source.domain()).range(source.range()).interpolate(source.interpolate()).clamp(source.clamp()).unknown(source.unknown());
}
function transformer$3() {
  var domain = unit,
    range = unit,
    interpolate = interpolate$1,
    transform,
    untransform,
    unknown,
    clamp = identity$2,
    piecewise,
    output,
    input;
  function rescale() {
    var n = Math.min(domain.length, range.length);
    if (clamp !== identity$2) clamp = clamper(domain[0], domain[n - 1]);
    piecewise = n > 2 ? polymap : bimap;
    output = input = null;
    return scale;
  }
  function scale(x) {
    return x == null || isNaN(x = +x) ? unknown : (output || (output = piecewise(domain.map(transform), range, interpolate)))(transform(clamp(x)));
  }
  scale.invert = function (y) {
    return clamp(untransform((input || (input = piecewise(range, domain.map(transform), interpolateNumber)))(y)));
  };
  scale.domain = function (_) {
    return arguments.length ? (domain = Array.from(_, number$5), rescale()) : domain.slice();
  };
  scale.range = function (_) {
    return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
  };
  scale.rangeRound = function (_) {
    return range = Array.from(_), interpolate = interpolateRound, rescale();
  };
  scale.clamp = function (_) {
    return arguments.length ? (clamp = _ ? true : identity$2, rescale()) : clamp !== identity$2;
  };
  scale.interpolate = function (_) {
    return arguments.length ? (interpolate = _, rescale()) : interpolate;
  };
  scale.unknown = function (_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };
  return function (t, u) {
    transform = t, untransform = u;
    return rescale();
  };
}
function continuous$1() {
  return transformer$3()(identity$2, identity$2);
}

function tickFormat$1(start, stop, count, specifier) {
  var step = tickStep(start, stop, count),
    precision;
  specifier = formatSpecifier(specifier == null ? ",f" : specifier);
  switch (specifier.type) {
    case "s":
      {
        var value = Math.max(Math.abs(start), Math.abs(stop));
        if (specifier.precision == null && !isNaN(precision = precisionPrefix(step, value))) specifier.precision = precision;
        return formatPrefix(specifier, value);
      }
    case "":
    case "e":
    case "g":
    case "p":
    case "r":
      {
        if (specifier.precision == null && !isNaN(precision = precisionRound(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
        break;
      }
    case "f":
    case "%":
      {
        if (specifier.precision == null && !isNaN(precision = precisionFixed(step))) specifier.precision = precision - (specifier.type === "%") * 2;
        break;
      }
  }
  return format$3(specifier);
}

function linearish(scale) {
  var domain = scale.domain;
  scale.ticks = function (count) {
    var d = domain();
    return ticks(d[0], d[d.length - 1], count == null ? 10 : count);
  };
  scale.tickFormat = function (count, specifier) {
    var d = domain();
    return tickFormat$1(d[0], d[d.length - 1], count == null ? 10 : count, specifier);
  };
  scale.nice = function (count) {
    if (count == null) count = 10;
    var d = domain();
    var i0 = 0;
    var i1 = d.length - 1;
    var start = d[i0];
    var stop = d[i1];
    var prestep;
    var step;
    var maxIter = 10;
    if (stop < start) {
      step = start, start = stop, stop = step;
      step = i0, i0 = i1, i1 = step;
    }
    while (maxIter-- > 0) {
      step = tickIncrement(start, stop, count);
      if (step === prestep) {
        d[i0] = start;
        d[i1] = stop;
        return domain(d);
      } else if (step > 0) {
        start = Math.floor(start / step) * step;
        stop = Math.ceil(stop / step) * step;
      } else if (step < 0) {
        start = Math.ceil(start * step) / step;
        stop = Math.floor(stop * step) / step;
      } else {
        break;
      }
      prestep = step;
    }
    return scale;
  };
  return scale;
}
function linear() {
  var scale = continuous$1();
  scale.copy = function () {
    return copy$2(scale, linear());
  };
  initRange.apply(scale, arguments);
  return linearish(scale);
}

function identity$1(domain) {
  var unknown;
  function scale(x) {
    return x == null || isNaN(x = +x) ? unknown : x;
  }
  scale.invert = scale;
  scale.domain = scale.range = function (_) {
    return arguments.length ? (domain = Array.from(_, number$5), scale) : domain.slice();
  };
  scale.unknown = function (_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };
  scale.copy = function () {
    return identity$1(domain).unknown(unknown);
  };
  domain = arguments.length ? Array.from(domain, number$5) : [0, 1];
  return linearish(scale);
}

function nice(domain, interval) {
  domain = domain.slice();
  var i0 = 0,
    i1 = domain.length - 1,
    x0 = domain[i0],
    x1 = domain[i1],
    t;
  if (x1 < x0) {
    t = i0, i0 = i1, i1 = t;
    t = x0, x0 = x1, x1 = t;
  }
  domain[i0] = interval.floor(x0);
  domain[i1] = interval.ceil(x1);
  return domain;
}

function transformLog(x) {
  return Math.log(x);
}
function transformExp(x) {
  return Math.exp(x);
}
function transformLogn(x) {
  return -Math.log(-x);
}
function transformExpn(x) {
  return -Math.exp(-x);
}
function pow10(x) {
  return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
}
function powp(base) {
  return base === 10 ? pow10 : base === Math.E ? Math.exp : x => Math.pow(base, x);
}
function logp(base) {
  return base === Math.E ? Math.log : base === 10 && Math.log10 || base === 2 && Math.log2 || (base = Math.log(base), x => Math.log(x) / base);
}
function reflect(f) {
  return (x, k) => -f(-x, k);
}
function loggish(transform) {
  const scale = transform(transformLog, transformExp);
  const domain = scale.domain;
  let base = 10;
  let logs;
  let pows;
  function rescale() {
    logs = logp(base), pows = powp(base);
    if (domain()[0] < 0) {
      logs = reflect(logs), pows = reflect(pows);
      transform(transformLogn, transformExpn);
    } else {
      transform(transformLog, transformExp);
    }
    return scale;
  }
  scale.base = function (_) {
    return arguments.length ? (base = +_, rescale()) : base;
  };
  scale.domain = function (_) {
    return arguments.length ? (domain(_), rescale()) : domain();
  };
  scale.ticks = count => {
    const d = domain();
    let u = d[0];
    let v = d[d.length - 1];
    const r = v < u;
    if (r) [u, v] = [v, u];
    let i = logs(u);
    let j = logs(v);
    let k;
    let t;
    const n = count == null ? 10 : +count;
    let z = [];
    if (!(base % 1) && j - i < n) {
      i = Math.floor(i), j = Math.ceil(j);
      if (u > 0) for (; i <= j; ++i) {
        for (k = 1; k < base; ++k) {
          t = i < 0 ? k / pows(-i) : k * pows(i);
          if (t < u) continue;
          if (t > v) break;
          z.push(t);
        }
      } else for (; i <= j; ++i) {
        for (k = base - 1; k >= 1; --k) {
          t = i > 0 ? k / pows(-i) : k * pows(i);
          if (t < u) continue;
          if (t > v) break;
          z.push(t);
        }
      }
      if (z.length * 2 < n) z = ticks(u, v, n);
    } else {
      z = ticks(i, j, Math.min(j - i, n)).map(pows);
    }
    return r ? z.reverse() : z;
  };
  scale.tickFormat = (count, specifier) => {
    if (count == null) count = 10;
    if (specifier == null) specifier = base === 10 ? "s" : ",";
    if (typeof specifier !== "function") {
      if (!(base % 1) && (specifier = formatSpecifier(specifier)).precision == null) specifier.trim = true;
      specifier = format$3(specifier);
    }
    if (count === Infinity) return specifier;
    const k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
    return d => {
      let i = d / pows(Math.round(logs(d)));
      if (i * base < base - 0.5) i *= base;
      return i <= k ? specifier(d) : "";
    };
  };
  scale.nice = () => {
    return domain(nice(domain(), {
      floor: x => pows(Math.floor(logs(x))),
      ceil: x => pows(Math.ceil(logs(x)))
    }));
  };
  return scale;
}
function log$2() {
  const scale = loggish(transformer$3()).domain([1, 10]);
  scale.copy = () => copy$2(scale, log$2()).base(scale.base());
  initRange.apply(scale, arguments);
  return scale;
}

function transformSymlog(c) {
  return function (x) {
    return Math.sign(x) * Math.log1p(Math.abs(x / c));
  };
}
function transformSymexp(c) {
  return function (x) {
    return Math.sign(x) * Math.expm1(Math.abs(x)) * c;
  };
}
function symlogish(transform) {
  var c = 1,
    scale = transform(transformSymlog(c), transformSymexp(c));
  scale.constant = function (_) {
    return arguments.length ? transform(transformSymlog(c = +_), transformSymexp(c)) : c;
  };
  return linearish(scale);
}
function symlog() {
  var scale = symlogish(transformer$3());
  scale.copy = function () {
    return copy$2(scale, symlog()).constant(scale.constant());
  };
  return initRange.apply(scale, arguments);
}

function transformPow(exponent) {
  return function (x) {
    return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
  };
}
function transformSqrt(x) {
  return x < 0 ? -Math.sqrt(-x) : Math.sqrt(x);
}
function transformSquare(x) {
  return x < 0 ? -x * x : x * x;
}
function powish(transform) {
  var scale = transform(identity$2, identity$2),
    exponent = 1;
  function rescale() {
    return exponent === 1 ? transform(identity$2, identity$2) : exponent === 0.5 ? transform(transformSqrt, transformSquare) : transform(transformPow(exponent), transformPow(1 / exponent));
  }
  scale.exponent = function (_) {
    return arguments.length ? (exponent = +_, rescale()) : exponent;
  };
  return linearish(scale);
}
function pow$2() {
  var scale = powish(transformer$3());
  scale.copy = function () {
    return copy$2(scale, pow$2()).exponent(scale.exponent());
  };
  initRange.apply(scale, arguments);
  return scale;
}
function sqrt$2() {
  return pow$2.apply(null, arguments).exponent(0.5);
}

function quantile() {
  var domain = [],
    range = [],
    thresholds = [],
    unknown;
  function rescale() {
    var i = 0,
      n = Math.max(1, range.length);
    thresholds = new Array(n - 1);
    while (++i < n) thresholds[i - 1] = quantileSorted(domain, i / n);
    return scale;
  }
  function scale(x) {
    return x == null || isNaN(x = +x) ? unknown : range[bisectRight$1(thresholds, x)];
  }
  scale.invertExtent = function (y) {
    var i = range.indexOf(y);
    return i < 0 ? [NaN, NaN] : [i > 0 ? thresholds[i - 1] : domain[0], i < thresholds.length ? thresholds[i] : domain[domain.length - 1]];
  };
  scale.domain = function (_) {
    if (!arguments.length) return domain.slice();
    domain = [];
    for (let d of _) if (d != null && !isNaN(d = +d)) domain.push(d);
    domain.sort(ascending$1);
    return rescale();
  };
  scale.range = function (_) {
    return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
  };
  scale.unknown = function (_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };
  scale.quantiles = function () {
    return thresholds.slice();
  };
  scale.copy = function () {
    return quantile().domain(domain).range(range).unknown(unknown);
  };
  return initRange.apply(scale, arguments);
}

function quantize$1() {
  var x0 = 0,
    x1 = 1,
    n = 1,
    domain = [0.5],
    range = [0, 1],
    unknown;
  function scale(x) {
    return x != null && x <= x ? range[bisectRight$1(domain, x, 0, n)] : unknown;
  }
  function rescale() {
    var i = -1;
    domain = new Array(n);
    while (++i < n) domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
    return scale;
  }
  scale.domain = function (_) {
    return arguments.length ? ([x0, x1] = _, x0 = +x0, x1 = +x1, rescale()) : [x0, x1];
  };
  scale.range = function (_) {
    return arguments.length ? (n = (range = Array.from(_)).length - 1, rescale()) : range.slice();
  };
  scale.invertExtent = function (y) {
    var i = range.indexOf(y);
    return i < 0 ? [NaN, NaN] : i < 1 ? [x0, domain[0]] : i >= n ? [domain[n - 1], x1] : [domain[i - 1], domain[i]];
  };
  scale.unknown = function (_) {
    return arguments.length ? (unknown = _, scale) : scale;
  };
  scale.thresholds = function () {
    return domain.slice();
  };
  scale.copy = function () {
    return quantize$1().domain([x0, x1]).range(range).unknown(unknown);
  };
  return initRange.apply(linearish(scale), arguments);
}

function threshold() {
  var domain = [0.5],
    range = [0, 1],
    unknown,
    n = 1;
  function scale(x) {
    return x != null && x <= x ? range[bisectRight$1(domain, x, 0, n)] : unknown;
  }
  scale.domain = function (_) {
    return arguments.length ? (domain = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : domain.slice();
  };
  scale.range = function (_) {
    return arguments.length ? (range = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : range.slice();
  };
  scale.invertExtent = function (y) {
    var i = range.indexOf(y);
    return [domain[i - 1], domain[i]];
  };
  scale.unknown = function (_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };
  scale.copy = function () {
    return threshold().domain(domain).range(range).unknown(unknown);
  };
  return initRange.apply(scale, arguments);
}

function date(t) {
  return new Date(t);
}
function number$4(t) {
  return t instanceof Date ? +t : +new Date(+t);
}
function calendar(ticks, tickInterval, year, month, week, day, hour, minute, second, format) {
  var scale = continuous$1(),
    invert = scale.invert,
    domain = scale.domain;
  var formatMillisecond = format(".%L"),
    formatSecond = format(":%S"),
    formatMinute = format("%I:%M"),
    formatHour = format("%I %p"),
    formatDay = format("%a %d"),
    formatWeek = format("%b %d"),
    formatMonth = format("%B"),
    formatYear = format("%Y");
  function tickFormat(date) {
    return (second(date) < date ? formatMillisecond : minute(date) < date ? formatSecond : hour(date) < date ? formatMinute : day(date) < date ? formatHour : month(date) < date ? week(date) < date ? formatDay : formatWeek : year(date) < date ? formatMonth : formatYear)(date);
  }
  scale.invert = function (y) {
    return new Date(invert(y));
  };
  scale.domain = function (_) {
    return arguments.length ? domain(Array.from(_, number$4)) : domain().map(date);
  };
  scale.ticks = function (interval) {
    var d = domain();
    return ticks(d[0], d[d.length - 1], interval == null ? 10 : interval);
  };
  scale.tickFormat = function (count, specifier) {
    return specifier == null ? tickFormat : format(specifier);
  };
  scale.nice = function (interval) {
    var d = domain();
    if (!interval || typeof interval.range !== "function") interval = tickInterval(d[0], d[d.length - 1], interval == null ? 10 : interval);
    return interval ? domain(nice(d, interval)) : scale;
  };
  scale.copy = function () {
    return copy$2(scale, calendar(ticks, tickInterval, year, month, week, day, hour, minute, second, format));
  };
  return scale;
}
function time$1() {
  return initRange.apply(calendar(timeTicks, timeTickInterval, timeYear, timeMonth, timeSunday, timeDay, timeHour, timeMinute, second, timeFormat$1).domain([new Date(2000, 0, 1), new Date(2000, 0, 2)]), arguments);
}

function utcTime() {
  return initRange.apply(calendar(utcTicks, utcTickInterval, utcYear, utcMonth, utcSunday, utcDay, utcHour, utcMinute, second, utcFormat$1).domain([Date.UTC(2000, 0, 1), Date.UTC(2000, 0, 2)]), arguments);
}

function transformer$2() {
  var x0 = 0,
    x1 = 1,
    t0,
    t1,
    k10,
    transform,
    interpolator = identity$2,
    clamp = false,
    unknown;
  function scale(x) {
    return x == null || isNaN(x = +x) ? unknown : interpolator(k10 === 0 ? 0.5 : (x = (transform(x) - t0) * k10, clamp ? Math.max(0, Math.min(1, x)) : x));
  }
  scale.domain = function (_) {
    return arguments.length ? ([x0, x1] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0), scale) : [x0, x1];
  };
  scale.clamp = function (_) {
    return arguments.length ? (clamp = !!_, scale) : clamp;
  };
  scale.interpolator = function (_) {
    return arguments.length ? (interpolator = _, scale) : interpolator;
  };
  function range(interpolate) {
    return function (_) {
      var r0, r1;
      return arguments.length ? ([r0, r1] = _, interpolator = interpolate(r0, r1), scale) : [interpolator(0), interpolator(1)];
    };
  }
  scale.range = range(interpolate$1);
  scale.rangeRound = range(interpolateRound);
  scale.unknown = function (_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };
  return function (t) {
    transform = t, t0 = t(x0), t1 = t(x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0);
    return scale;
  };
}
function copy$1(source, target) {
  return target.domain(source.domain()).interpolator(source.interpolator()).clamp(source.clamp()).unknown(source.unknown());
}
function sequential() {
  var scale = linearish(transformer$2()(identity$2));
  scale.copy = function () {
    return copy$1(scale, sequential());
  };
  return initInterpolator.apply(scale, arguments);
}
function sequentialLog() {
  var scale = loggish(transformer$2()).domain([1, 10]);
  scale.copy = function () {
    return copy$1(scale, sequentialLog()).base(scale.base());
  };
  return initInterpolator.apply(scale, arguments);
}
function sequentialSymlog() {
  var scale = symlogish(transformer$2());
  scale.copy = function () {
    return copy$1(scale, sequentialSymlog()).constant(scale.constant());
  };
  return initInterpolator.apply(scale, arguments);
}
function sequentialPow() {
  var scale = powish(transformer$2());
  scale.copy = function () {
    return copy$1(scale, sequentialPow()).exponent(scale.exponent());
  };
  return initInterpolator.apply(scale, arguments);
}
function sequentialSqrt() {
  return sequentialPow.apply(null, arguments).exponent(0.5);
}

function transformer$1() {
  var x0 = 0,
    x1 = 0.5,
    x2 = 1,
    s = 1,
    t0,
    t1,
    t2,
    k10,
    k21,
    interpolator = identity$2,
    transform,
    clamp = false,
    unknown;
  function scale(x) {
    return isNaN(x = +x) ? unknown : (x = 0.5 + ((x = +transform(x)) - t1) * (s * x < s * t1 ? k10 : k21), interpolator(clamp ? Math.max(0, Math.min(1, x)) : x));
  }
  scale.domain = function (_) {
    return arguments.length ? ([x0, x1, x2] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), t2 = transform(x2 = +x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1, scale) : [x0, x1, x2];
  };
  scale.clamp = function (_) {
    return arguments.length ? (clamp = !!_, scale) : clamp;
  };
  scale.interpolator = function (_) {
    return arguments.length ? (interpolator = _, scale) : interpolator;
  };
  function range(interpolate) {
    return function (_) {
      var r0, r1, r2;
      return arguments.length ? ([r0, r1, r2] = _, interpolator = piecewise(interpolate, [r0, r1, r2]), scale) : [interpolator(0), interpolator(0.5), interpolator(1)];
    };
  }
  scale.range = range(interpolate$1);
  scale.rangeRound = range(interpolateRound);
  scale.unknown = function (_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };
  return function (t) {
    transform = t, t0 = t(x0), t1 = t(x1), t2 = t(x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1;
    return scale;
  };
}
function diverging() {
  var scale = linearish(transformer$1()(identity$2));
  scale.copy = function () {
    return copy$1(scale, diverging());
  };
  return initInterpolator.apply(scale, arguments);
}
function divergingLog() {
  var scale = loggish(transformer$1()).domain([0.1, 1, 10]);
  scale.copy = function () {
    return copy$1(scale, divergingLog()).base(scale.base());
  };
  return initInterpolator.apply(scale, arguments);
}
function divergingSymlog() {
  var scale = symlogish(transformer$1());
  scale.copy = function () {
    return copy$1(scale, divergingSymlog()).constant(scale.constant());
  };
  return initInterpolator.apply(scale, arguments);
}
function divergingPow() {
  var scale = powish(transformer$1());
  scale.copy = function () {
    return copy$1(scale, divergingPow()).exponent(scale.exponent());
  };
  return initInterpolator.apply(scale, arguments);
}
function divergingSqrt() {
  return divergingPow.apply(null, arguments).exponent(0.5);
}

function colors$1 (specifier) {
  var n = specifier.length / 6 | 0,
    colors = new Array(n),
    i = 0;
  while (i < n) colors[i] = "#" + specifier.slice(i * 6, ++i * 6);
  return colors;
}

var schemeCategory10 = colors$1("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf");

var schemeAccent = colors$1("7fc97fbeaed4fdc086ffff99386cb0f0027fbf5b17666666");

var schemeDark2 = colors$1("1b9e77d95f027570b3e7298a66a61ee6ab02a6761d666666");

var schemeObservable10 = colors$1("4269d0efb118ff725c6cc5b03ca951ff8ab7a463f297bbf59c6b4e9498a0");

var schemePaired = colors$1("a6cee31f78b4b2df8a33a02cfb9a99e31a1cfdbf6fff7f00cab2d66a3d9affff99b15928");

var schemePastel1 = colors$1("fbb4aeb3cde3ccebc5decbe4fed9a6ffffcce5d8bdfddaecf2f2f2");

var schemePastel2 = colors$1("b3e2cdfdcdaccbd5e8f4cae4e6f5c9fff2aef1e2cccccccc");

var schemeSet1 = colors$1("e41a1c377eb84daf4a984ea3ff7f00ffff33a65628f781bf999999");

var schemeSet2 = colors$1("66c2a5fc8d628da0cbe78ac3a6d854ffd92fe5c494b3b3b3");

var schemeSet3 = colors$1("8dd3c7ffffb3bebadafb807280b1d3fdb462b3de69fccde5d9d9d9bc80bdccebc5ffed6f");

function bandSpace(count, paddingInner, paddingOuter) {
  const space = count - paddingInner + paddingOuter * 2;
  return count ? space > 0 ? space : 1 : 0;
}
const Identity = 'identity';
const Linear = 'linear';
const Log = 'log';
const Pow = 'pow';
const Sqrt = 'sqrt';
const Symlog = 'symlog';
const Time = 'time';
const UTC = 'utc';
const Sequential = 'sequential';
const Diverging = 'diverging';
const Quantile = 'quantile';
const Quantize = 'quantize';
const Threshold = 'threshold';
const Ordinal = 'ordinal';
const Point = 'point';
const Band = 'band';
const BinOrdinal = 'bin-ordinal';

// categories
const Continuous = 'continuous';
const Discrete$1 = 'discrete';
const Discretizing = 'discretizing';
const Interpolating = 'interpolating';
const Temporal = 'temporal';
function invertRange(scale) {
  return function (_) {
    let lo = _[0],
      hi = _[1],
      t;
    if (hi < lo) {
      t = lo;
      lo = hi;
      hi = t;
    }
    return [scale.invert(lo), scale.invert(hi)];
  };
}
function invertRangeExtent(scale) {
  return function (_) {
    const range = scale.range();
    let lo = _[0],
      hi = _[1],
      min = -1,
      max,
      t,
      i,
      n;
    if (hi < lo) {
      t = lo;
      lo = hi;
      hi = t;
    }
    for (i = 0, n = range.length; i < n; ++i) {
      if (range[i] >= lo && range[i] <= hi) {
        if (min < 0) min = i;
        max = i;
      }
    }
    if (min < 0) return undefined;
    lo = scale.invertExtent(range[min]);
    hi = scale.invertExtent(range[max]);
    return [lo[0] === undefined ? lo[1] : lo[0], hi[1] === undefined ? hi[0] : hi[1]];
  };
}
function band() {
  const scale = ordinal().unknown(undefined),
    domain = scale.domain,
    ordinalRange = scale.range;
  let range$1 = [0, 1],
    step,
    bandwidth,
    round = false,
    paddingInner = 0,
    paddingOuter = 0,
    align = 0.5;
  delete scale.unknown;
  function rescale() {
    const n = domain().length,
      reverse = range$1[1] < range$1[0],
      stop = range$1[1 - reverse],
      space = bandSpace(n, paddingInner, paddingOuter);
    let start = range$1[reverse - 0];
    step = (stop - start) / (space || 1);
    if (round) {
      step = Math.floor(step);
    }
    start += (stop - start - step * (n - paddingInner)) * align;
    bandwidth = step * (1 - paddingInner);
    if (round) {
      start = Math.round(start);
      bandwidth = Math.round(bandwidth);
    }
    const values = range$3(n).map(i => start + step * i);
    return ordinalRange(reverse ? values.reverse() : values);
  }
  scale.domain = function (_) {
    if (arguments.length) {
      domain(_);
      return rescale();
    } else {
      return domain();
    }
  };
  scale.range = function (_) {
    if (arguments.length) {
      range$1 = [+_[0], +_[1]];
      return rescale();
    } else {
      return range$1.slice();
    }
  };
  scale.rangeRound = function (_) {
    range$1 = [+_[0], +_[1]];
    round = true;
    return rescale();
  };
  scale.bandwidth = function () {
    return bandwidth;
  };
  scale.step = function () {
    return step;
  };
  scale.round = function (_) {
    if (arguments.length) {
      round = !!_;
      return rescale();
    } else {
      return round;
    }
  };
  scale.padding = function (_) {
    if (arguments.length) {
      paddingOuter = Math.max(0, Math.min(1, _));
      paddingInner = paddingOuter;
      return rescale();
    } else {
      return paddingInner;
    }
  };
  scale.paddingInner = function (_) {
    if (arguments.length) {
      paddingInner = Math.max(0, Math.min(1, _));
      return rescale();
    } else {
      return paddingInner;
    }
  };
  scale.paddingOuter = function (_) {
    if (arguments.length) {
      paddingOuter = Math.max(0, Math.min(1, _));
      return rescale();
    } else {
      return paddingOuter;
    }
  };
  scale.align = function (_) {
    if (arguments.length) {
      align = Math.max(0, Math.min(1, _));
      return rescale();
    } else {
      return align;
    }
  };
  scale.invertRange = function (_) {
    // bail if range has null or undefined values
    if (_[0] == null || _[1] == null) return;
    const reverse = range$1[1] < range$1[0],
      values = reverse ? ordinalRange().reverse() : ordinalRange(),
      n = values.length - 1;
    let lo = +_[0],
      hi = +_[1],
      a,
      b,
      t;

    // bail if either range endpoint is invalid
    if (lo !== lo || hi !== hi) return;

    // order range inputs, bail if outside of scale range
    if (hi < lo) {
      t = lo;
      lo = hi;
      hi = t;
    }
    if (hi < values[0] || lo > range$1[1 - reverse]) return;

    // binary search to index into scale range
    a = Math.max(0, bisectRight$1(values, lo) - 1);
    b = lo === hi ? a : bisectRight$1(values, hi) - 1;

    // increment index a if lo is within padding gap
    if (lo - values[a] > bandwidth + 1e-10) ++a;
    if (reverse) {
      // map + swap
      t = a;
      a = n - b;
      b = n - t;
    }
    return a > b ? undefined : domain().slice(a, b + 1);
  };
  scale.invert = function (_) {
    const value = scale.invertRange([_, _]);
    return value ? value[0] : value;
  };
  scale.copy = function () {
    return band().domain(domain()).range(range$1).round(round).paddingInner(paddingInner).paddingOuter(paddingOuter).align(align);
  };
  return rescale();
}
function pointish(scale) {
  const copy = scale.copy;
  scale.padding = scale.paddingOuter;
  delete scale.paddingInner;
  scale.copy = function () {
    return pointish(copy());
  };
  return scale;
}
function point$1() {
  return pointish(band().paddingInner(1));
}
var map = Array.prototype.map;
function numbers(_) {
  return map.call(_, toNumber);
}
const slice$1 = Array.prototype.slice;
function scaleBinOrdinal() {
  let domain = [],
    range = [];
  function scale(x) {
    return x == null || x !== x ? undefined : range[(bisectRight$1(domain, x) - 1) % range.length];
  }
  scale.domain = function (_) {
    if (arguments.length) {
      domain = numbers(_);
      return scale;
    } else {
      return domain.slice();
    }
  };
  scale.range = function (_) {
    if (arguments.length) {
      range = slice$1.call(_);
      return scale;
    } else {
      return range.slice();
    }
  };
  scale.tickFormat = function (count, specifier) {
    return tickFormat$1(domain[0], peek$1(domain), count == null ? 10 : count, specifier);
  };
  scale.copy = function () {
    return scaleBinOrdinal().domain(scale.domain()).range(scale.range());
  };
  return scale;
}

/** Private scale registry: should not be exported */
const scales = new Map();
const VEGA_SCALE = Symbol('vega_scale');
function registerScale(scale) {
  scale[VEGA_SCALE] = true;
  return scale;
}

/**
 * Return true if object was created by a constructor from the vega-scale `scale` function.
 */
function isRegisteredScale(scale) {
  return scale && scale[VEGA_SCALE] === true;
}

/**
 * Augment scales with their type and needed inverse methods.
 */
function create$2(type, constructor, metadata) {
  const ctr = function scale() {
    const s = constructor();
    if (!s.invertRange) {
      s.invertRange = s.invert ? invertRange(s) : s.invertExtent ? invertRangeExtent(s) : undefined;
    }
    s.type = type;
    return registerScale(s);
  };
  ctr.metadata = toSet(array$5(metadata));
  return ctr;
}

/**
 * Registry function for adding and accessing scale constructor functions.
 * The *type* argument is a String indicating the name of the scale type.
 *
 * If the *scale* argument is not specified, this method returns the matching scale constructor in the registry, or `null` if not found.
 * If the *scale* argument is provided, it must be a scale constructor function to add to the registry under the given *type* name.
 * The *metadata* argument provides additional information to guide appropriate use of scales within Vega.
 *
 *  *metadata* can be either a string or string array. The valid string values are:
 * - `"continuous"` - the scale is defined over a continuous-valued domain.
 * - `"discrete"` - the scale is defined over a discrete domain and range.
 * - `"discretizing"` - the scale discretizes a continuous domain to a discrete range.
 * - `"interpolating"` - the scale range is defined using a color interpolator.
 * - `"log"` - the scale performs a logarithmic transform of the continuous domain.
 * - `"temporal"` - the scale domain is defined over date-time values.
 */
function scale$4(type, scale, metadata) {
  if (arguments.length > 1) {
    scales.set(type, create$2(type, scale, metadata));
    return this;
  } else {
    return isValidScaleType(type) ? scales.get(type) : undefined;
  }
}

// identity scale
scale$4(Identity, identity$1);

// continuous scales
scale$4(Linear, linear, Continuous);
scale$4(Log, log$2, [Continuous, Log]);
scale$4(Pow, pow$2, Continuous);
scale$4(Sqrt, sqrt$2, Continuous);
scale$4(Symlog, symlog, Continuous);
scale$4(Time, time$1, [Continuous, Temporal]);
scale$4(UTC, utcTime, [Continuous, Temporal]);

// sequential scales
scale$4(Sequential, sequential, [Continuous, Interpolating]); // backwards compat
scale$4(`${Sequential}-${Linear}`, sequential, [Continuous, Interpolating]);
scale$4(`${Sequential}-${Log}`, sequentialLog, [Continuous, Interpolating, Log]);
scale$4(`${Sequential}-${Pow}`, sequentialPow, [Continuous, Interpolating]);
scale$4(`${Sequential}-${Sqrt}`, sequentialSqrt, [Continuous, Interpolating]);
scale$4(`${Sequential}-${Symlog}`, sequentialSymlog, [Continuous, Interpolating]);

// diverging scales
scale$4(`${Diverging}-${Linear}`, diverging, [Continuous, Interpolating]);
scale$4(`${Diverging}-${Log}`, divergingLog, [Continuous, Interpolating, Log]);
scale$4(`${Diverging}-${Pow}`, divergingPow, [Continuous, Interpolating]);
scale$4(`${Diverging}-${Sqrt}`, divergingSqrt, [Continuous, Interpolating]);
scale$4(`${Diverging}-${Symlog}`, divergingSymlog, [Continuous, Interpolating]);

// discretizing scales
scale$4(Quantile, quantile, [Discretizing, Quantile]);
scale$4(Quantize, quantize$1, Discretizing);
scale$4(Threshold, threshold, Discretizing);

// discrete scales
scale$4(BinOrdinal, scaleBinOrdinal, [Discrete$1, Discretizing]);
scale$4(Ordinal, ordinal, Discrete$1);
scale$4(Band, band, Discrete$1);
scale$4(Point, point$1, Discrete$1);
function isValidScaleType(type) {
  return scales.has(type);
}
function hasType(key, type) {
  const s = scales.get(key);
  return s && s.metadata[type];
}
function isContinuous(key) {
  return hasType(key, Continuous);
}
function isDiscrete(key) {
  return hasType(key, Discrete$1);
}
function isDiscretizing(key) {
  return hasType(key, Discretizing);
}
function isLogarithmic(key) {
  return hasType(key, Log);
}
function isTemporal(key) {
  return hasType(key, Temporal);
}
function isInterpolating(key) {
  return hasType(key, Interpolating);
}
function isQuantile(key) {
  return hasType(key, Quantile);
}
const scaleProps = ['clamp', 'base', 'constant', 'exponent'];
function interpolateRange(interpolator, range) {
  const start = range[0],
    span = peek$1(range) - start;
  return function (i) {
    return interpolator(start + i * span);
  };
}
function interpolateColors(colors, type, gamma) {
  return piecewise(interpolate(type || 'rgb', gamma), colors);
}
function quantizeInterpolator(interpolator, count) {
  const samples = new Array(count),
    n = count + 1;
  for (let i = 0; i < count;) samples[i] = interpolator(++i / n);
  return samples;
}
function scaleFraction(scale$1, min, max) {
  const delta = max - min;
  let i, t, s;
  if (!delta || !Number.isFinite(delta)) {
    return constant$5(0.5);
  } else {
    i = (t = scale$1.type).indexOf('-');
    t = i < 0 ? t : t.slice(i + 1);
    s = scale$4(t)().domain([min, max]).range([0, 1]);
    scaleProps.forEach(m => scale$1[m] ? s[m](scale$1[m]()) : 0);
    return s;
  }
}
function interpolate(type, gamma) {
  const interp = $$1[method(type)];
  return gamma != null && interp && interp.gamma ? interp.gamma(gamma) : interp;
}
function method(type) {
  return 'interpolate' + type.toLowerCase().split('-').map(s => s[0].toUpperCase() + s.slice(1)).join('');
}
const continuous = {
  blues: 'cfe1f2bed8eca8cee58fc1de74b2d75ba3cf4592c63181bd206fb2125ca40a4a90',
  greens: 'd3eecdc0e6baabdda594d3917bc77d60ba6c46ab5e329a512089430e7735036429',
  greys: 'e2e2e2d4d4d4c4c4c4b1b1b19d9d9d8888887575756262624d4d4d3535351e1e1e',
  oranges: 'fdd8b3fdc998fdb87bfda55efc9244f87f2cf06b18e4580bd14904b93d029f3303',
  purples: 'e2e1efd4d4e8c4c5e0b4b3d6a3a0cc928ec3827cb97566ae684ea25c3696501f8c',
  reds: 'fdc9b4fcb49afc9e80fc8767fa7051f6573fec3f2fdc2a25c81b1db21218970b13',
  blueGreen: 'd5efedc1e8e0a7ddd18bd2be70c6a958ba9144ad77319c5d2089460e7736036429',
  bluePurple: 'ccddecbad0e4a8c2dd9ab0d4919cc98d85be8b6db28a55a6873c99822287730f71',
  greenBlue: 'd3eecec5e8c3b1e1bb9bd8bb82cec269c2ca51b2cd3c9fc7288abd1675b10b60a1',
  orangeRed: 'fddcaffdcf9bfdc18afdad77fb9562f67d53ee6545e24932d32d1ebf130da70403',
  purpleBlue: 'dbdaebc8cee4b1c3de97b7d87bacd15b9fc93a90c01e7fb70b70ab056199045281',
  purpleBlueGreen: 'dbd8eac8cee4b0c3de93b7d872acd1549fc83892bb1c88a3097f8702736b016353',
  purpleRed: 'dcc9e2d3b3d7ce9eccd186c0da6bb2e14da0e23189d91e6fc61159ab07498f023a',
  redPurple: 'fccfccfcbec0faa9b8f98faff571a5ec539ddb3695c41b8aa908808d0179700174',
  yellowGreen: 'e4f4acd1eca0b9e2949ed68880c97c62bb6e47aa5e3297502083440e723b036034',
  yellowOrangeBrown: 'feeaa1fedd84fecc63feb746fca031f68921eb7215db5e0bc54c05ab3d038f3204',
  yellowOrangeRed: 'fee087fed16ffebd59fea849fd903efc7335f9522bee3423de1b20ca0b22af0225',
  blueOrange: '134b852f78b35da2cb9dcae1d2e5eff2f0ebfce0bafbbf74e8932fc5690d994a07',
  brownBlueGreen: '704108a0651ac79548e3c78af3e6c6eef1eac9e9e48ed1c74da79e187a72025147',
  purpleGreen: '5b1667834792a67fb6c9aed3e6d6e8eff0efd9efd5aedda971bb75368e490e5e29',
  purpleOrange: '4114696647968f83b7b9b4d6dadbebf3eeeafce0bafbbf74e8932fc5690d994a07',
  redBlue: '8c0d25bf363adf745ef4ae91fbdbc9f2efeed2e5ef9dcae15da2cb2f78b3134b85',
  redGrey: '8c0d25bf363adf745ef4ae91fcdccbfaf4f1e2e2e2c0c0c0969696646464343434',
  yellowGreenBlue: 'eff9bddbf1b4bde5b594d5b969c5be45b4c22c9ec02182b82163aa23479c1c3185',
  redYellowBlue: 'a50026d4322cf16e43fcac64fedd90faf8c1dcf1ecabd6e875abd04a74b4313695',
  redYellowGreen: 'a50026d4322cf16e43fcac63fedd8df9f7aed7ee8ea4d86e64bc6122964f006837',
  pinkYellowGreen: '8e0152c0267edd72adf0b3d6faddedf5f3efe1f2cab6de8780bb474f9125276419',
  spectral: '9e0142d13c4bf0704afcac63fedd8dfbf8b0e0f3a1a9dda269bda94288b55e4fa2',
  viridis: '440154470e61481a6c482575472f7d443a834144873d4e8a39568c35608d31688e2d708e2a788e27818e23888e21918d1f988b1fa08822a8842ab07f35b77943bf7154c56866cc5d7ad1518fd744a5db36bcdf27d2e21be9e51afde725',
  magma: '0000040404130b0924150e3720114b2c11603b0f704a107957157e651a80721f817f24828c29819a2e80a8327db6377ac43c75d1426fde4968e95462f1605df76f5cfa7f5efc8f65fe9f6dfeaf78febf84fece91fddea0fcedaffcfdbf',
  inferno: '0000040403130c0826170c3b240c4f330a5f420a68500d6c5d126e6b176e781c6d86216b932667a12b62ae305cbb3755c73e4cd24644dd513ae65c30ed6925f3771af8850ffb9506fca50afcb519fac62df6d645f2e661f3f484fcffa4',
  plasma: '0d088723069033059742039d5002a25d01a66a00a87801a88405a7900da49c179ea72198b12a90ba3488c33d80cb4779d35171da5a69e16462e76e5bed7953f2834cf68f44fa9a3dfca636fdb32ffec029fcce25f9dc24f5ea27f0f921',
  cividis: '00205100235800265d002961012b65042e670831690d346b11366c16396d1c3c6e213f6e26426e2c456e31476e374a6e3c4d6e42506e47536d4c566d51586e555b6e5a5e6e5e616e62646f66676f6a6a706e6d717270717573727976737c79747f7c75827f758682768985778c8877908b78938e789691789a94789e9778a19b78a59e77a9a177aea575b2a874b6ab73bbaf71c0b26fc5b66dc9b96acebd68d3c065d8c462ddc85fe2cb5ce7cf58ebd355f0d652f3da4ff7de4cfae249fce647',
  rainbow: '6e40aa883eb1a43db3bf3cafd83fa4ee4395fe4b83ff576eff6659ff7847ff8c38f3a130e2b72fcfcc36bee044aff05b8ff4576ff65b52f6673af27828ea8d1ddfa319d0b81cbecb23abd82f96e03d82e14c6edb5a5dd0664dbf6e40aa',
  sinebow: 'ff4040fc582af47218e78d0bd5a703bfbf00a7d5038de70b72f41858fc2a40ff402afc5818f4720be78d03d5a700bfbf03a7d50b8de71872f42a58fc4040ff582afc7218f48d0be7a703d5bf00bfd503a7e70b8df41872fc2a58ff4040',
  turbo: '23171b32204a3e2a71453493493eae4b49c54a53d7485ee44569ee4074f53c7ff8378af93295f72e9ff42ba9ef28b3e926bce125c5d925cdcf27d5c629dcbc2de3b232e9a738ee9d3ff39347f68950f9805afc7765fd6e70fe667cfd5e88fc5795fb51a1f84badf545b9f140c5ec3cd0e637dae034e4d931ecd12ef4c92bfac029ffb626ffad24ffa223ff9821ff8d1fff821dff771cfd6c1af76118f05616e84b14df4111d5380fcb2f0dc0260ab61f07ac1805a313029b0f00950c00910b00',
  browns: 'eedbbdecca96e9b97ae4a865dc9856d18954c7784cc0673fb85536ad44339f3632',
  tealBlues: 'bce4d89dd3d181c3cb65b3c245a2b9368fae347da0306a932c5985',
  teals: 'bbdfdfa2d4d58ac9c975bcbb61b0af4da5a43799982b8b8c1e7f7f127273006667',
  warmGreys: 'dcd4d0cec5c1c0b8b4b3aaa7a59c9998908c8b827f7e7673726866665c5a59504e',
  goldGreen: 'f4d166d5ca60b6c35c98bb597cb25760a6564b9c533f8f4f33834a257740146c36',
  goldOrange: 'f4d166f8be5cf8aa4cf5983bf3852aef701be2621fd65322c54923b142239e3a26',
  goldRed: 'f4d166f6be59f9aa51fc964ef6834bee734ae56249db5247cf4244c43141b71d3e',
  lightGreyRed: 'efe9e6e1dad7d5cbc8c8bdb9bbaea9cd967ddc7b43e15f19df4011dc000b',
  lightGreyTeal: 'e4eaead6dcddc8ced2b7c2c7a6b4bc64b0bf22a6c32295c11f85be1876bc',
  lightMulti: 'e0f1f2c4e9d0b0de9fd0e181f6e072f6c053f3993ef77440ef4a3c',
  lightOrange: 'f2e7daf7d5baf9c499fab184fa9c73f68967ef7860e8645bde515bd43d5b',
  lightTealBlue: 'e3e9e0c0dccf9aceca7abfc859afc0389fb9328dad2f7ca0276b95255988',
  darkBlue: '3232322d46681a5c930074af008cbf05a7ce25c0dd38daed50f3faffffff',
  darkGold: '3c3c3c584b37725e348c7631ae8b2bcfa424ecc31ef9de30fff184ffffff',
  darkGreen: '3a3a3a215748006f4d048942489e4276b340a6c63dd2d836ffeb2cffffaa',
  darkMulti: '3737371f5287197d8c29a86995ce3fffe800ffffff',
  darkRed: '3434347036339e3c38cc4037e75d1eec8620eeab29f0ce32ffeb2c'
};
const discrete = {
  accent: schemeAccent,
  category10: schemeCategory10,
  category20: '1f77b4aec7e8ff7f0effbb782ca02c98df8ad62728ff98969467bdc5b0d58c564bc49c94e377c2f7b6d27f7f7fc7c7c7bcbd22dbdb8d17becf9edae5',
  category20b: '393b795254a36b6ecf9c9ede6379398ca252b5cf6bcedb9c8c6d31bd9e39e7ba52e7cb94843c39ad494ad6616be7969c7b4173a55194ce6dbdde9ed6',
  category20c: '3182bd6baed69ecae1c6dbefe6550dfd8d3cfdae6bfdd0a231a35474c476a1d99bc7e9c0756bb19e9ac8bcbddcdadaeb636363969696bdbdbdd9d9d9',
  dark2: schemeDark2,
  observable10: schemeObservable10,
  paired: schemePaired,
  pastel1: schemePastel1,
  pastel2: schemePastel2,
  set1: schemeSet1,
  set2: schemeSet2,
  set3: schemeSet3,
  tableau10: '4c78a8f58518e4575672b7b254a24beeca3bb279a2ff9da69d755dbab0ac',
  tableau20: '4c78a89ecae9f58518ffbf7954a24b88d27ab79a20f2cf5b43989483bcb6e45756ff9d9879706ebab0acd67195fcbfd2b279a2d6a5c99e765fd8b5a5'
};
function colors(palette) {
  if (isArray(palette)) return palette;
  const n = palette.length / 6 | 0,
    c = new Array(n);
  for (let i = 0; i < n;) {
    c[i] = '#' + palette.slice(i * 6, ++i * 6);
  }
  return c;
}
function apply(_, f) {
  for (const k in _) scheme(k, f(_[k]));
}
const schemes = {};
apply(discrete, colors);
apply(continuous, _ => interpolateColors(colors(_)));
function scheme(name, scheme) {
  name = name && name.toLowerCase();
  if (arguments.length > 1) {
    schemes[name] = scheme;
    return this;
  } else {
    return schemes[name];
  }
}
const SymbolLegend = 'symbol';
const DiscreteLegend = 'discrete';
const GradientLegend = 'gradient';
const defaultFormatter = value => isArray(value) ? value.map(v => String(v)) : String(value);
const ascending = (a, b) => a[1] - b[1];
const descending = (a, b) => b[1] - a[1];

/**
 * Determine the tick count or interval function.
 * @param {Scale} scale - The scale for which to generate tick values.
 * @param {*} count - The desired tick count or interval specifier.
 * @param {number} minStep - The desired minimum step between tick values.
 * @return {*} - The tick count or interval function.
 */
function tickCount(scale, count, minStep) {
  let step;
  if (isNumber$1(count)) {
    if (scale.bins) {
      count = Math.max(count, scale.bins.length);
    }
    if (minStep != null) {
      count = Math.min(count, Math.floor(span(scale.domain()) / minStep || 1) + 1);
    }
  }
  if (isObject(count)) {
    step = count.step;
    count = count.interval;
  }
  if (isString(count)) {
    count = scale.type === Time ? timeInterval(count) : scale.type == UTC ? utcInterval(count) : error('Only time and utc scales accept interval strings.');
    if (step) count = count.every(step);
  }
  return count;
}

/**
 * Filter a set of candidate tick values, ensuring that only tick values
 * that lie within the scale range are included.
 * @param {Scale} scale - The scale for which to generate tick values.
 * @param {Array<*>} ticks - The candidate tick values.
 * @param {*} count - The tick count or interval function.
 * @return {Array<*>} - The filtered tick values.
 */
function validTicks(scale, ticks, count) {
  let range = scale.range(),
    lo = range[0],
    hi = peek$1(range),
    cmp = ascending;
  if (lo > hi) {
    range = hi;
    hi = lo;
    lo = range;
    cmp = descending;
  }
  lo = Math.floor(lo);
  hi = Math.ceil(hi);

  // filter ticks to valid values within the range
  // additionally sort ticks in range order (#2579)
  ticks = ticks.map(v => [v, scale(v)]).filter(_ => lo <= _[1] && _[1] <= hi).sort(cmp).map(_ => _[0]);
  if (count > 0 && ticks.length > 1) {
    const endpoints = [ticks[0], peek$1(ticks)];
    while (ticks.length > count && ticks.length >= 3) {
      ticks = ticks.filter((_, i) => !(i % 2));
    }
    if (ticks.length < 3) {
      ticks = endpoints;
    }
  }
  return ticks;
}

/**
 * Generate tick values for the given scale and approximate tick count or
 * interval value. If the scale has a 'ticks' method, it will be used to
 * generate the ticks, with the count argument passed as a parameter. If the
 * scale lacks a 'ticks' method, the full scale domain will be returned.
 * @param {Scale} scale - The scale for which to generate tick values.
 * @param {*} [count] - The approximate number of desired ticks.
 * @return {Array<*>} - The generated tick values.
 */
function tickValues(scale, count) {
  return scale.bins ? validTicks(scale, scale.bins, count) : scale.ticks ? scale.ticks(count) : scale.domain();
}

/**
 * Generate a label format function for a scale. If the scale has a
 * 'tickFormat' method, it will be used to generate the formatter, with the
 * count and specifier arguments passed as parameters. If the scale lacks a
 * 'tickFormat' method, the returned formatter performs simple string coercion.
 * If the input scale is a logarithmic scale and the format specifier does not
 * indicate a desired decimal precision, a special variable precision formatter
 * that automatically trims trailing zeroes will be generated.
 * @param {Scale} scale - The scale for which to generate the label formatter.
 * @param {*} [count] - The approximate number of desired ticks.
 * @param {string} [specifier] - The format specifier. Must be a legal d3
 *   specifier string (see https://github.com/d3/d3-format#formatSpecifier) or
 *   time multi-format specifier object.
 * @return {function(*):string} - The generated label formatter.
 */
function tickFormat(locale, scale, count, specifier, formatType, noSkip) {
  const type = scale.type;
  let format = defaultFormatter;
  if (type === Time || formatType === Time) {
    format = locale.timeFormat(specifier);
  } else if (type === UTC || formatType === UTC) {
    format = locale.utcFormat(specifier);
  } else if (isLogarithmic(type)) {
    const varfmt = locale.formatFloat(specifier);
    if (noSkip || scale.bins) {
      format = varfmt;
    } else {
      const test = tickLog(scale, count, false);
      format = _ => test(_) ? varfmt(_) : '';
    }
  } else if (scale.tickFormat) {
    // if d3 scale has tickFormat, it must be continuous
    const d = scale.domain();
    format = locale.formatSpan(d[0], d[d.length - 1], count, specifier);
  } else if (specifier) {
    format = locale.format(specifier);
  }
  return format;
}
function tickLog(scale, count, values) {
  const ticks = tickValues(scale, count),
    base = scale.base(),
    logb = Math.log(base),
    k = Math.max(1, base * count / ticks.length);

  // apply d3-scale's log format filter criteria
  const test = d => {
    let i = d / Math.pow(base, Math.round(Math.log(d) / logb));
    if (i * base < base - 0.5) i *= base;
    return i <= k;
  };
  return values ? ticks.filter(test) : test;
}
const symbols$1 = {
  [Quantile]: 'quantiles',
  [Quantize]: 'thresholds',
  [Threshold]: 'domain'
};
const formats = {
  [Quantile]: 'quantiles',
  [Quantize]: 'domain'
};
function labelValues(scale, count) {
  return scale.bins ? binValues(scale.bins) : scale.type === Log ? tickLog(scale, count, true) : symbols$1[scale.type] ? thresholdValues(scale[symbols$1[scale.type]]()) : tickValues(scale, count);
}
function thresholdFormat(locale, scale, specifier) {
  const _ = scale[formats[scale.type]](),
    n = _.length;
  let d = n > 1 ? _[1] - _[0] : _[0],
    i;
  for (i = 1; i < n; ++i) {
    d = Math.min(d, _[i] - _[i - 1]);
  }

  // tickCount = 3 ticks times 10 for increased resolution
  return locale.formatSpan(0, d, 3 * 10, specifier);
}
function thresholdValues(thresholds) {
  const values = [-Infinity].concat(thresholds);
  values.max = +Infinity;
  return values;
}
function binValues(bins) {
  const values = bins.slice(0, -1);
  values.max = peek$1(bins);
  return values;
}
const isDiscreteRange = scale => symbols$1[scale.type] || scale.bins;
function labelFormat(locale, scale, count, type, specifier, formatType, noSkip) {
  const format = formats[scale.type] && formatType !== Time && formatType !== UTC ? thresholdFormat(locale, scale, specifier) : tickFormat(locale, scale, count, specifier, formatType, noSkip);
  return type === SymbolLegend && isDiscreteRange(scale) ? formatRange(format) : type === DiscreteLegend ? formatDiscrete(format) : formatPoint(format);
}
const formatRange = format => (value, index, array) => {
  const limit = get$3(array[index + 1], get$3(array.max, +Infinity)),
    lo = formatValue$1(value, format),
    hi = formatValue$1(limit, format);
  return lo && hi ? lo + ' \u2013 ' + hi : hi ? '< ' + hi : '\u2265 ' + lo;
};
const get$3 = (value, dflt) => value != null ? value : dflt;
const formatDiscrete = format => (value, index) => index ? format(value) : null;
const formatPoint = format => value => format(value);
const formatValue$1 = (value, format) => Number.isFinite(value) ? format(value) : null;
function labelFraction(scale) {
  const domain = scale.domain(),
    count = domain.length - 1;
  let lo = +domain[0],
    hi = +peek$1(domain),
    span = hi - lo;
  if (scale.type === Threshold) {
    const adjust = count ? span / count : 0.1;
    lo -= adjust;
    hi += adjust;
    span = hi - lo;
  }
  return value => (value - lo) / span;
}
function format$1(locale, scale, specifier, formatType) {
  const type = formatType || scale.type;

  // replace abbreviated time specifiers to improve screen reader experience
  if (isString(specifier) && isTemporal(type)) {
    specifier = specifier.replace(/%a/g, '%A').replace(/%b/g, '%B');
  }
  return !specifier && type === Time ? locale.timeFormat('%A, %d %B %Y, %X') : !specifier && type === UTC ? locale.utcFormat('%A, %d %B %Y, %X UTC') : labelFormat(locale, scale, 5, null, specifier, formatType, true);
}
function domainCaption(locale, scale, opt) {
  opt = opt || {};
  const max = Math.max(3, opt.maxlen || 7),
    fmt = format$1(locale, scale, opt.format, opt.formatType);

  // if scale breaks domain into bins, describe boundaries
  if (isDiscretizing(scale.type)) {
    const v = labelValues(scale).slice(1).map(fmt),
      n = v.length;
    return `${n} boundar${n === 1 ? 'y' : 'ies'}: ${v.join(', ')}`;
  }

  // if scale domain is discrete, list values
  else if (isDiscrete(scale.type)) {
    const d = scale.domain(),
      n = d.length,
      v = n > max ? d.slice(0, max - 2).map(fmt).join(', ') + ', ending with ' + d.slice(-1).map(fmt) : d.map(fmt).join(', ');
    return `${n} value${n === 1 ? '' : 's'}: ${v}`;
  }

  // if scale domain is continuous, describe value range
  else {
    const d = scale.domain();
    return `values from ${fmt(d[0])} to ${fmt(peek$1(d))}`;
  }
}

let gradient_id = 0;
const patternPrefix = 'p_';
function isGradient(value) {
  return value && value.gradient;
}
function gradientRef(g, defs, base) {
  const type = g.gradient;
  let id = g.id,
    prefix = type === 'radial' ? patternPrefix : '';

  // check id, assign default values as needed
  if (!id) {
    id = g.id = 'gradient_' + gradient_id++;
    if (type === 'radial') {
      g.x1 = get$2(g.x1, 0.5);
      g.y1 = get$2(g.y1, 0.5);
      g.r1 = get$2(g.r1, 0);
      g.x2 = get$2(g.x2, 0.5);
      g.y2 = get$2(g.y2, 0.5);
      g.r2 = get$2(g.r2, 0.5);
      prefix = patternPrefix;
    } else {
      g.x1 = get$2(g.x1, 0);
      g.y1 = get$2(g.y1, 0);
      g.x2 = get$2(g.x2, 1);
      g.y2 = get$2(g.y2, 0);
    }
  }

  // register definition
  defs[id] = g;

  // return url reference
  return 'url(' + (base || '') + '#' + prefix + id + ')';
}
function get$2(val, def) {
  return val != null ? val : def;
}
function Gradient$1(p0, p1) {
  var stops = [],
    gradient;
  return gradient = {
    gradient: 'linear',
    x1: p0 ? p0[0] : 0,
    y1: p0 ? p0[1] : 0,
    x2: p1 ? p1[0] : 1,
    y2: p1 ? p1[1] : 0,
    stops: stops,
    stop: function (offset, color) {
      stops.push({
        offset: offset,
        color: color
      });
      return gradient;
    }
  };
}
const lookup$4 = {
  'basis': {
    curve: curveBasis
  },
  'basis-closed': {
    curve: curveBasisClosed
  },
  'basis-open': {
    curve: curveBasisOpen
  },
  'bundle': {
    curve: curveBundle,
    tension: 'beta',
    value: 0.85
  },
  'cardinal': {
    curve: curveCardinal,
    tension: 'tension',
    value: 0
  },
  'cardinal-open': {
    curve: curveCardinalOpen,
    tension: 'tension',
    value: 0
  },
  'cardinal-closed': {
    curve: curveCardinalClosed,
    tension: 'tension',
    value: 0
  },
  'catmull-rom': {
    curve: curveCatmullRom,
    tension: 'alpha',
    value: 0.5
  },
  'catmull-rom-closed': {
    curve: curveCatmullRomClosed,
    tension: 'alpha',
    value: 0.5
  },
  'catmull-rom-open': {
    curve: curveCatmullRomOpen,
    tension: 'alpha',
    value: 0.5
  },
  'linear': {
    curve: curveLinear
  },
  'linear-closed': {
    curve: curveLinearClosed
  },
  'monotone': {
    horizontal: monotoneY,
    vertical: monotoneX
  },
  'natural': {
    curve: curveNatural
  },
  'step': {
    curve: curveStep
  },
  'step-after': {
    curve: stepAfter
  },
  'step-before': {
    curve: stepBefore
  }
};
function curves(type, orientation, tension) {
  var entry = has$1(lookup$4, type) && lookup$4[type],
    curve = null;
  if (entry) {
    curve = entry.curve || entry[orientation || 'vertical'];
    if (entry.tension && tension != null) {
      curve = curve[entry.tension](tension);
    }
  }
  return curve;
}
const paramCounts = {
  m: 2,
  l: 2,
  h: 1,
  v: 1,
  z: 0,
  c: 6,
  s: 4,
  q: 4,
  t: 2,
  a: 7
};
const commandPattern = /[mlhvzcsqta]([^mlhvzcsqta]+|$)/gi;
const numberPattern = /^[+-]?(([0-9]*\.[0-9]+)|([0-9]+\.)|([0-9]+))([eE][+-]?[0-9]+)?/;
const spacePattern = /^((\s+,?\s*)|(,\s*))/;
const flagPattern = /^[01]/;
function parse$3(path) {
  const commands = [];
  const matches = path.match(commandPattern) || [];
  matches.forEach(str => {
    let cmd = str[0];
    const type = cmd.toLowerCase();

    // parse parameters
    const paramCount = paramCounts[type];
    const params = parseParams(type, paramCount, str.slice(1).trim());
    const count = params.length;

    // error checking based on parameter count
    if (count < paramCount || count && count % paramCount !== 0) {
      throw Error('Invalid SVG path, incorrect parameter count');
    }

    // register the command
    commands.push([cmd, ...params.slice(0, paramCount)]);

    // exit now if we're done, also handles zero-param 'z'
    if (count === paramCount) {
      return;
    }

    // handle implicit line-to
    if (type === 'm') {
      cmd = cmd === 'M' ? 'L' : 'l';
    }

    // repeat command when given extended param list
    for (let i = paramCount; i < count; i += paramCount) {
      commands.push([cmd, ...params.slice(i, i + paramCount)]);
    }
  });
  return commands;
}
function parseParams(type, paramCount, segment) {
  const params = [];
  for (let index = 0; paramCount && index < segment.length;) {
    for (let i = 0; i < paramCount; ++i) {
      const pattern = type === 'a' && (i === 3 || i === 4) ? flagPattern : numberPattern;
      const match = segment.slice(index).match(pattern);
      if (match === null) {
        throw Error('Invalid SVG path, incorrect parameter type');
      }
      index += match[0].length;
      params.push(+match[0]);
      const ws = segment.slice(index).match(spacePattern);
      if (ws !== null) {
        index += ws[0].length;
      }
    }
  }
  return params;
}
const DegToRad = Math.PI / 180;
const Epsilon = 1e-14;
const HalfPi$1 = Math.PI / 2;
const Tau = Math.PI * 2;
const HalfSqrt3$1 = Math.sqrt(3) / 2;
var segmentCache = {};
var bezierCache = {};
var join$1 = [].join;

// Copied from Inkscape svgtopdf, thanks!
function segments(x, y, rx, ry, large, sweep, rotateX, ox, oy) {
  const key = join$1.call(arguments);
  if (segmentCache[key]) {
    return segmentCache[key];
  }
  const th = rotateX * DegToRad;
  const sin_th = Math.sin(th);
  const cos_th = Math.cos(th);
  rx = Math.abs(rx);
  ry = Math.abs(ry);
  const px = cos_th * (ox - x) * 0.5 + sin_th * (oy - y) * 0.5;
  const py = cos_th * (oy - y) * 0.5 - sin_th * (ox - x) * 0.5;
  let pl = px * px / (rx * rx) + py * py / (ry * ry);
  if (pl > 1) {
    pl = Math.sqrt(pl);
    rx *= pl;
    ry *= pl;
  }
  const a00 = cos_th / rx;
  const a01 = sin_th / rx;
  const a10 = -sin_th / ry;
  const a11 = cos_th / ry;
  const x0 = a00 * ox + a01 * oy;
  const y0 = a10 * ox + a11 * oy;
  const x1 = a00 * x + a01 * y;
  const y1 = a10 * x + a11 * y;
  const d = (x1 - x0) * (x1 - x0) + (y1 - y0) * (y1 - y0);
  let sfactor_sq = 1 / d - 0.25;
  if (sfactor_sq < 0) sfactor_sq = 0;
  let sfactor = Math.sqrt(sfactor_sq);
  if (sweep == large) sfactor = -sfactor;
  const xc = 0.5 * (x0 + x1) - sfactor * (y1 - y0);
  const yc = 0.5 * (y0 + y1) + sfactor * (x1 - x0);
  const th0 = Math.atan2(y0 - yc, x0 - xc);
  const th1 = Math.atan2(y1 - yc, x1 - xc);
  let th_arc = th1 - th0;
  if (th_arc < 0 && sweep === 1) {
    th_arc += Tau;
  } else if (th_arc > 0 && sweep === 0) {
    th_arc -= Tau;
  }
  const segs = Math.ceil(Math.abs(th_arc / (HalfPi$1 + 0.001)));
  const result = [];
  for (let i = 0; i < segs; ++i) {
    const th2 = th0 + i * th_arc / segs;
    const th3 = th0 + (i + 1) * th_arc / segs;
    result[i] = [xc, yc, th2, th3, rx, ry, sin_th, cos_th];
  }
  return segmentCache[key] = result;
}
function bezier(params) {
  const key = join$1.call(params);
  if (bezierCache[key]) {
    return bezierCache[key];
  }
  var cx = params[0],
    cy = params[1],
    th0 = params[2],
    th1 = params[3],
    rx = params[4],
    ry = params[5],
    sin_th = params[6],
    cos_th = params[7];
  const a00 = cos_th * rx;
  const a01 = -sin_th * ry;
  const a10 = sin_th * rx;
  const a11 = cos_th * ry;
  const cos_th0 = Math.cos(th0);
  const sin_th0 = Math.sin(th0);
  const cos_th1 = Math.cos(th1);
  const sin_th1 = Math.sin(th1);
  const th_half = 0.5 * (th1 - th0);
  const sin_th_h2 = Math.sin(th_half * 0.5);
  const t = 8 / 3 * sin_th_h2 * sin_th_h2 / Math.sin(th_half);
  const x1 = cx + cos_th0 - t * sin_th0;
  const y1 = cy + sin_th0 + t * cos_th0;
  const x3 = cx + cos_th1;
  const y3 = cy + sin_th1;
  const x2 = x3 + t * sin_th1;
  const y2 = y3 - t * cos_th1;
  return bezierCache[key] = [a00 * x1 + a01 * y1, a10 * x1 + a11 * y1, a00 * x2 + a01 * y2, a10 * x2 + a11 * y2, a00 * x3 + a01 * y3, a10 * x3 + a11 * y3];
}
const temp = ['l', 0, 0, 0, 0, 0, 0, 0];
function scale$1$1(current, sX, sY) {
  const c = temp[0] = current[0];
  if (c === 'a' || c === 'A') {
    temp[1] = sX * current[1];
    temp[2] = sY * current[2];
    temp[3] = current[3];
    temp[4] = current[4];
    temp[5] = current[5];
    temp[6] = sX * current[6];
    temp[7] = sY * current[7];
  } else if (c === 'h' || c === 'H') {
    temp[1] = sX * current[1];
  } else if (c === 'v' || c === 'V') {
    temp[1] = sY * current[1];
  } else {
    for (var i = 1, n = current.length; i < n; ++i) {
      temp[i] = (i % 2 == 1 ? sX : sY) * current[i];
    }
  }
  return temp;
}
function pathRender(context, path, l, t, sX, sY) {
  var current,
    // current instruction
    previous = null,
    x = 0,
    // current x
    y = 0,
    // current y
    controlX = 0,
    // current control point x
    controlY = 0,
    // current control point y
    tempX,
    tempY,
    tempControlX,
    tempControlY,
    anchorX = 0,
    anchorY = 0;
  if (l == null) l = 0;
  if (t == null) t = 0;
  if (sX == null) sX = 1;
  if (sY == null) sY = sX;
  if (context.beginPath) context.beginPath();
  for (var i = 0, len = path.length; i < len; ++i) {
    current = path[i];
    if (sX !== 1 || sY !== 1) {
      current = scale$1$1(current, sX, sY);
    }
    switch (current[0]) {
      // first letter

      case 'l':
        // lineto, relative
        x += current[1];
        y += current[2];
        context.lineTo(x + l, y + t);
        break;
      case 'L':
        // lineto, absolute
        x = current[1];
        y = current[2];
        context.lineTo(x + l, y + t);
        break;
      case 'h':
        // horizontal lineto, relative
        x += current[1];
        context.lineTo(x + l, y + t);
        break;
      case 'H':
        // horizontal lineto, absolute
        x = current[1];
        context.lineTo(x + l, y + t);
        break;
      case 'v':
        // vertical lineto, relative
        y += current[1];
        context.lineTo(x + l, y + t);
        break;
      case 'V':
        // verical lineto, absolute
        y = current[1];
        context.lineTo(x + l, y + t);
        break;
      case 'm':
        // moveTo, relative
        x += current[1];
        y += current[2];
        anchorX = x;
        anchorY = y;
        context.moveTo(x + l, y + t);
        break;
      case 'M':
        // moveTo, absolute
        x = current[1];
        y = current[2];
        anchorX = x;
        anchorY = y;
        context.moveTo(x + l, y + t);
        break;
      case 'c':
        // bezierCurveTo, relative
        tempX = x + current[5];
        tempY = y + current[6];
        controlX = x + current[3];
        controlY = y + current[4];
        context.bezierCurveTo(x + current[1] + l,
        // x1
        y + current[2] + t,
        // y1
        controlX + l,
        // x2
        controlY + t,
        // y2
        tempX + l, tempY + t);
        x = tempX;
        y = tempY;
        break;
      case 'C':
        // bezierCurveTo, absolute
        x = current[5];
        y = current[6];
        controlX = current[3];
        controlY = current[4];
        context.bezierCurveTo(current[1] + l, current[2] + t, controlX + l, controlY + t, x + l, y + t);
        break;
      case 's':
        // shorthand cubic bezierCurveTo, relative
        // transform to absolute x,y
        tempX = x + current[3];
        tempY = y + current[4];
        // calculate reflection of previous control points
        controlX = 2 * x - controlX;
        controlY = 2 * y - controlY;
        context.bezierCurveTo(controlX + l, controlY + t, x + current[1] + l, y + current[2] + t, tempX + l, tempY + t);

        // set control point to 2nd one of this command
        // the first control point is assumed to be the reflection of
        // the second control point on the previous command relative
        // to the current point.
        controlX = x + current[1];
        controlY = y + current[2];
        x = tempX;
        y = tempY;
        break;
      case 'S':
        // shorthand cubic bezierCurveTo, absolute
        tempX = current[3];
        tempY = current[4];
        // calculate reflection of previous control points
        controlX = 2 * x - controlX;
        controlY = 2 * y - controlY;
        context.bezierCurveTo(controlX + l, controlY + t, current[1] + l, current[2] + t, tempX + l, tempY + t);
        x = tempX;
        y = tempY;
        // set control point to 2nd one of this command
        // the first control point is assumed to be the reflection of
        // the second control point on the previous command relative
        // to the current point.
        controlX = current[1];
        controlY = current[2];
        break;
      case 'q':
        // quadraticCurveTo, relative
        // transform to absolute x,y
        tempX = x + current[3];
        tempY = y + current[4];
        controlX = x + current[1];
        controlY = y + current[2];
        context.quadraticCurveTo(controlX + l, controlY + t, tempX + l, tempY + t);
        x = tempX;
        y = tempY;
        break;
      case 'Q':
        // quadraticCurveTo, absolute
        tempX = current[3];
        tempY = current[4];
        context.quadraticCurveTo(current[1] + l, current[2] + t, tempX + l, tempY + t);
        x = tempX;
        y = tempY;
        controlX = current[1];
        controlY = current[2];
        break;
      case 't':
        // shorthand quadraticCurveTo, relative

        // transform to absolute x,y
        tempX = x + current[1];
        tempY = y + current[2];
        if (previous[0].match(/[QqTt]/) === null) {
          // If there is no previous command or if the previous command was not a Q, q, T or t,
          // assume the control point is coincident with the current point
          controlX = x;
          controlY = y;
        } else if (previous[0] === 't') {
          // calculate reflection of previous control points for t
          controlX = 2 * x - tempControlX;
          controlY = 2 * y - tempControlY;
        } else if (previous[0] === 'q') {
          // calculate reflection of previous control points for q
          controlX = 2 * x - controlX;
          controlY = 2 * y - controlY;
        }
        tempControlX = controlX;
        tempControlY = controlY;
        context.quadraticCurveTo(controlX + l, controlY + t, tempX + l, tempY + t);
        x = tempX;
        y = tempY;
        controlX = x + current[1];
        controlY = y + current[2];
        break;
      case 'T':
        tempX = current[1];
        tempY = current[2];

        // calculate reflection of previous control points
        controlX = 2 * x - controlX;
        controlY = 2 * y - controlY;
        context.quadraticCurveTo(controlX + l, controlY + t, tempX + l, tempY + t);
        x = tempX;
        y = tempY;
        break;
      case 'a':
        drawArc(context, x + l, y + t, [current[1], current[2], current[3], current[4], current[5], current[6] + x + l, current[7] + y + t]);
        x += current[6];
        y += current[7];
        break;
      case 'A':
        drawArc(context, x + l, y + t, [current[1], current[2], current[3], current[4], current[5], current[6] + l, current[7] + t]);
        x = current[6];
        y = current[7];
        break;
      case 'z':
      case 'Z':
        x = anchorX;
        y = anchorY;
        context.closePath();
        break;
    }
    previous = current;
  }
}
function drawArc(context, x, y, coords) {
  const seg = segments(coords[5],
  // end x
  coords[6],
  // end y
  coords[0],
  // radius x
  coords[1],
  // radius y
  coords[3],
  // large flag
  coords[4],
  // sweep flag
  coords[2],
  // rotation
  x, y);
  for (let i = 0; i < seg.length; ++i) {
    const bez = bezier(seg[i]);
    context.bezierCurveTo(bez[0], bez[1], bez[2], bez[3], bez[4], bez[5]);
  }
}
const Tan30$1 = 0.5773502691896257;
const builtins = {
  'circle': {
    draw: function (context, size) {
      const r = Math.sqrt(size) / 2;
      context.moveTo(r, 0);
      context.arc(0, 0, r, 0, Tau);
    }
  },
  'cross': {
    draw: function (context, size) {
      var r = Math.sqrt(size) / 2,
        s = r / 2.5;
      context.moveTo(-r, -s);
      context.lineTo(-r, s);
      context.lineTo(-s, s);
      context.lineTo(-s, r);
      context.lineTo(s, r);
      context.lineTo(s, s);
      context.lineTo(r, s);
      context.lineTo(r, -s);
      context.lineTo(s, -s);
      context.lineTo(s, -r);
      context.lineTo(-s, -r);
      context.lineTo(-s, -s);
      context.closePath();
    }
  },
  'diamond': {
    draw: function (context, size) {
      const r = Math.sqrt(size) / 2;
      context.moveTo(-r, 0);
      context.lineTo(0, -r);
      context.lineTo(r, 0);
      context.lineTo(0, r);
      context.closePath();
    }
  },
  'square': {
    draw: function (context, size) {
      var w = Math.sqrt(size),
        x = -w / 2;
      context.rect(x, x, w, w);
    }
  },
  'arrow': {
    draw: function (context, size) {
      var r = Math.sqrt(size) / 2,
        s = r / 7,
        t = r / 2.5,
        v = r / 8;
      context.moveTo(-s, r);
      context.lineTo(s, r);
      context.lineTo(s, -v);
      context.lineTo(t, -v);
      context.lineTo(0, -r);
      context.lineTo(-t, -v);
      context.lineTo(-s, -v);
      context.closePath();
    }
  },
  'wedge': {
    draw: function (context, size) {
      var r = Math.sqrt(size) / 2,
        h = HalfSqrt3$1 * r,
        o = h - r * Tan30$1,
        b = r / 4;
      context.moveTo(0, -h - o);
      context.lineTo(-b, h - o);
      context.lineTo(b, h - o);
      context.closePath();
    }
  },
  'triangle': {
    draw: function (context, size) {
      var r = Math.sqrt(size) / 2,
        h = HalfSqrt3$1 * r,
        o = h - r * Tan30$1;
      context.moveTo(0, -h - o);
      context.lineTo(-r, h - o);
      context.lineTo(r, h - o);
      context.closePath();
    }
  },
  'triangle-up': {
    draw: function (context, size) {
      var r = Math.sqrt(size) / 2,
        h = HalfSqrt3$1 * r;
      context.moveTo(0, -h);
      context.lineTo(-r, h);
      context.lineTo(r, h);
      context.closePath();
    }
  },
  'triangle-down': {
    draw: function (context, size) {
      var r = Math.sqrt(size) / 2,
        h = HalfSqrt3$1 * r;
      context.moveTo(0, h);
      context.lineTo(-r, -h);
      context.lineTo(r, -h);
      context.closePath();
    }
  },
  'triangle-right': {
    draw: function (context, size) {
      var r = Math.sqrt(size) / 2,
        h = HalfSqrt3$1 * r;
      context.moveTo(h, 0);
      context.lineTo(-h, -r);
      context.lineTo(-h, r);
      context.closePath();
    }
  },
  'triangle-left': {
    draw: function (context, size) {
      var r = Math.sqrt(size) / 2,
        h = HalfSqrt3$1 * r;
      context.moveTo(-h, 0);
      context.lineTo(h, -r);
      context.lineTo(h, r);
      context.closePath();
    }
  },
  'stroke': {
    draw: function (context, size) {
      const r = Math.sqrt(size) / 2;
      context.moveTo(-r, 0);
      context.lineTo(r, 0);
    }
  }
};
function symbols(_) {
  return has$1(builtins, _) ? builtins[_] : customSymbol(_);
}
var custom = {};
function customSymbol(path) {
  if (!has$1(custom, path)) {
    const parsed = parse$3(path);
    custom[path] = {
      draw: function (context, size) {
        pathRender(context, parsed, 0, 0, Math.sqrt(size) / 2);
      }
    };
  }
  return custom[path];
}

// See http://spencermortensen.com/articles/bezier-circle/
const C = 0.448084975506; // C = 1 - c

function rectangleX(d) {
  return d.x;
}
function rectangleY(d) {
  return d.y;
}
function rectangleWidth(d) {
  return d.width;
}
function rectangleHeight(d) {
  return d.height;
}
function number$3(_) {
  return typeof _ === 'function' ? _ : () => +_;
}
function clamp(value, min, max) {
  return Math.max(min, Math.min(value, max));
}
function vg_rect() {
  var x = rectangleX,
    y = rectangleY,
    width = rectangleWidth,
    height = rectangleHeight,
    crTL = number$3(0),
    crTR = crTL,
    crBL = crTL,
    crBR = crTL,
    context = null;
  function rectangle(_, x0, y0) {
    var buffer,
      x1 = x0 != null ? x0 : +x.call(this, _),
      y1 = y0 != null ? y0 : +y.call(this, _),
      w = +width.call(this, _),
      h = +height.call(this, _),
      s = Math.min(w, h) / 2,
      tl = clamp(+crTL.call(this, _), 0, s),
      tr = clamp(+crTR.call(this, _), 0, s),
      bl = clamp(+crBL.call(this, _), 0, s),
      br = clamp(+crBR.call(this, _), 0, s);
    if (!context) context = buffer = path$3();
    if (tl <= 0 && tr <= 0 && bl <= 0 && br <= 0) {
      context.rect(x1, y1, w, h);
    } else {
      var x2 = x1 + w,
        y2 = y1 + h;
      context.moveTo(x1 + tl, y1);
      context.lineTo(x2 - tr, y1);
      context.bezierCurveTo(x2 - C * tr, y1, x2, y1 + C * tr, x2, y1 + tr);
      context.lineTo(x2, y2 - br);
      context.bezierCurveTo(x2, y2 - C * br, x2 - C * br, y2, x2 - br, y2);
      context.lineTo(x1 + bl, y2);
      context.bezierCurveTo(x1 + C * bl, y2, x1, y2 - C * bl, x1, y2 - bl);
      context.lineTo(x1, y1 + tl);
      context.bezierCurveTo(x1, y1 + C * tl, x1 + C * tl, y1, x1 + tl, y1);
      context.closePath();
    }
    if (buffer) {
      context = null;
      return buffer + '' || null;
    }
  }
  rectangle.x = function (_) {
    if (arguments.length) {
      x = number$3(_);
      return rectangle;
    } else {
      return x;
    }
  };
  rectangle.y = function (_) {
    if (arguments.length) {
      y = number$3(_);
      return rectangle;
    } else {
      return y;
    }
  };
  rectangle.width = function (_) {
    if (arguments.length) {
      width = number$3(_);
      return rectangle;
    } else {
      return width;
    }
  };
  rectangle.height = function (_) {
    if (arguments.length) {
      height = number$3(_);
      return rectangle;
    } else {
      return height;
    }
  };
  rectangle.cornerRadius = function (tl, tr, br, bl) {
    if (arguments.length) {
      crTL = number$3(tl);
      crTR = tr != null ? number$3(tr) : crTL;
      crBR = br != null ? number$3(br) : crTL;
      crBL = bl != null ? number$3(bl) : crTR;
      return rectangle;
    } else {
      return crTL;
    }
  };
  rectangle.context = function (_) {
    if (arguments.length) {
      context = _ == null ? null : _;
      return rectangle;
    } else {
      return context;
    }
  };
  return rectangle;
}
function vg_trail() {
  var x,
    y,
    size,
    defined,
    context = null,
    ready,
    x1,
    y1,
    r1;
  function point(x2, y2, w2) {
    const r2 = w2 / 2;
    if (ready) {
      var ux = y1 - y2,
        uy = x2 - x1;
      if (ux || uy) {
        // get normal vector
        var ud = Math.hypot(ux, uy),
          rx = (ux /= ud) * r1,
          ry = (uy /= ud) * r1,
          t = Math.atan2(uy, ux);

        // draw segment
        context.moveTo(x1 - rx, y1 - ry);
        context.lineTo(x2 - ux * r2, y2 - uy * r2);
        context.arc(x2, y2, r2, t - Math.PI, t);
        context.lineTo(x1 + rx, y1 + ry);
        context.arc(x1, y1, r1, t, t + Math.PI);
      } else {
        context.arc(x2, y2, r2, 0, Tau);
      }
      context.closePath();
    } else {
      ready = 1;
    }
    x1 = x2;
    y1 = y2;
    r1 = r2;
  }
  function trail(data) {
    var i,
      n = data.length,
      d,
      defined0 = false,
      buffer;
    if (context == null) context = buffer = path$3();
    for (i = 0; i <= n; ++i) {
      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
        if (defined0 = !defined0) ready = 0;
      }
      if (defined0) point(+x(d, i, data), +y(d, i, data), +size(d, i, data));
    }
    if (buffer) {
      context = null;
      return buffer + '' || null;
    }
  }
  trail.x = function (_) {
    if (arguments.length) {
      x = _;
      return trail;
    } else {
      return x;
    }
  };
  trail.y = function (_) {
    if (arguments.length) {
      y = _;
      return trail;
    } else {
      return y;
    }
  };
  trail.size = function (_) {
    if (arguments.length) {
      size = _;
      return trail;
    } else {
      return size;
    }
  };
  trail.defined = function (_) {
    if (arguments.length) {
      defined = _;
      return trail;
    } else {
      return defined;
    }
  };
  trail.context = function (_) {
    if (arguments.length) {
      if (_ == null) {
        context = null;
      } else {
        context = _;
      }
      return trail;
    } else {
      return context;
    }
  };
  return trail;
}
function value$1(a, b) {
  return a != null ? a : b;
}
const x$2 = item => item.x || 0,
  y$2 = item => item.y || 0,
  w = item => item.width || 0,
  h = item => item.height || 0,
  xw = item => (item.x || 0) + (item.width || 0),
  yh = item => (item.y || 0) + (item.height || 0),
  sa = item => item.startAngle || 0,
  ea = item => item.endAngle || 0,
  pa = item => item.padAngle || 0,
  ir = item => item.innerRadius || 0,
  or = item => item.outerRadius || 0,
  cr = item => item.cornerRadius || 0,
  tl = item => value$1(item.cornerRadiusTopLeft, item.cornerRadius) || 0,
  tr = item => value$1(item.cornerRadiusTopRight, item.cornerRadius) || 0,
  br = item => value$1(item.cornerRadiusBottomRight, item.cornerRadius) || 0,
  bl = item => value$1(item.cornerRadiusBottomLeft, item.cornerRadius) || 0,
  sz = item => value$1(item.size, 64),
  ts = item => item.size || 1,
  def = item => !(item.defined === false),
  type = item => symbols(item.shape || 'circle');
const arcShape = arc$2$1().startAngle(sa).endAngle(ea).padAngle(pa).innerRadius(ir).outerRadius(or).cornerRadius(cr),
  areavShape = area$2$1().x(x$2).y1(y$2).y0(yh).defined(def),
  areahShape = area$2$1().y(y$2).x1(x$2).x0(xw).defined(def),
  lineShape = line$2$1().x(x$2).y(y$2).defined(def),
  rectShape = vg_rect().x(x$2).y(y$2).width(w).height(h).cornerRadius(tl, tr, br, bl),
  symbolShape = Symbol$1().type(type).size(sz),
  trailShape = vg_trail().x(x$2).y(y$2).defined(def).size(ts);
function hasCornerRadius(item) {
  return item.cornerRadius || item.cornerRadiusTopLeft || item.cornerRadiusTopRight || item.cornerRadiusBottomRight || item.cornerRadiusBottomLeft;
}
function arc$1(context, item) {
  return arcShape.context(context)(item);
}
function area$1(context, items) {
  const item = items[0],
    interp = item.interpolate || 'linear';
  return (item.orient === 'horizontal' ? areahShape : areavShape).curve(curves(interp, item.orient, item.tension)).context(context)(items);
}
function line$1(context, items) {
  const item = items[0],
    interp = item.interpolate || 'linear';
  return lineShape.curve(curves(interp, item.orient, item.tension)).context(context)(items);
}
function rectangle(context, item, x, y) {
  return rectShape.context(context)(item, x, y);
}
function shape$1(context, item) {
  return (item.mark.shape || item.shape).context(context)(item);
}
function symbol$1(context, item) {
  return symbolShape.context(context)(item);
}
function trail$1(context, items) {
  return trailShape.context(context)(items);
}
var clip_id = 1;
function clip$1$1(renderer, item, size) {
  var clip = item.clip,
    defs = renderer._defs,
    id = item.clip_id || (item.clip_id = 'clip' + clip_id++),
    c = defs.clipping[id] || (defs.clipping[id] = {
      id: id
    });
  if (isFunction(clip)) {
    c.path = clip(null);
  } else if (hasCornerRadius(size)) {
    c.path = rectangle(null, size, 0, 0);
  } else {
    c.width = size.width || 0;
    c.height = size.height || 0;
  }
  return 'url(#' + id + ')';
}
function Bounds(b) {
  this.clear();
  if (b) this.union(b);
}
Bounds.prototype = {
  clone() {
    return new Bounds(this);
  },
  clear() {
    this.x1 = +Number.MAX_VALUE;
    this.y1 = +Number.MAX_VALUE;
    this.x2 = -Number.MAX_VALUE;
    this.y2 = -Number.MAX_VALUE;
    return this;
  },
  empty() {
    return this.x1 === +Number.MAX_VALUE && this.y1 === +Number.MAX_VALUE && this.x2 === -Number.MAX_VALUE && this.y2 === -Number.MAX_VALUE;
  },
  equals(b) {
    return this.x1 === b.x1 && this.y1 === b.y1 && this.x2 === b.x2 && this.y2 === b.y2;
  },
  set(x1, y1, x2, y2) {
    if (x2 < x1) {
      this.x2 = x1;
      this.x1 = x2;
    } else {
      this.x1 = x1;
      this.x2 = x2;
    }
    if (y2 < y1) {
      this.y2 = y1;
      this.y1 = y2;
    } else {
      this.y1 = y1;
      this.y2 = y2;
    }
    return this;
  },
  add(x, y) {
    if (x < this.x1) this.x1 = x;
    if (y < this.y1) this.y1 = y;
    if (x > this.x2) this.x2 = x;
    if (y > this.y2) this.y2 = y;
    return this;
  },
  expand(d) {
    this.x1 -= d;
    this.y1 -= d;
    this.x2 += d;
    this.y2 += d;
    return this;
  },
  round() {
    this.x1 = Math.floor(this.x1);
    this.y1 = Math.floor(this.y1);
    this.x2 = Math.ceil(this.x2);
    this.y2 = Math.ceil(this.y2);
    return this;
  },
  scale(s) {
    this.x1 *= s;
    this.y1 *= s;
    this.x2 *= s;
    this.y2 *= s;
    return this;
  },
  translate(dx, dy) {
    this.x1 += dx;
    this.x2 += dx;
    this.y1 += dy;
    this.y2 += dy;
    return this;
  },
  rotate(angle, x, y) {
    const p = this.rotatedPoints(angle, x, y);
    return this.clear().add(p[0], p[1]).add(p[2], p[3]).add(p[4], p[5]).add(p[6], p[7]);
  },
  rotatedPoints(angle, x, y) {
    var {
        x1,
        y1,
        x2,
        y2
      } = this,
      cos = Math.cos(angle),
      sin = Math.sin(angle),
      cx = x - x * cos + y * sin,
      cy = y - x * sin - y * cos;
    return [cos * x1 - sin * y1 + cx, sin * x1 + cos * y1 + cy, cos * x1 - sin * y2 + cx, sin * x1 + cos * y2 + cy, cos * x2 - sin * y1 + cx, sin * x2 + cos * y1 + cy, cos * x2 - sin * y2 + cx, sin * x2 + cos * y2 + cy];
  },
  union(b) {
    if (b.x1 < this.x1) this.x1 = b.x1;
    if (b.y1 < this.y1) this.y1 = b.y1;
    if (b.x2 > this.x2) this.x2 = b.x2;
    if (b.y2 > this.y2) this.y2 = b.y2;
    return this;
  },
  intersect(b) {
    if (b.x1 > this.x1) this.x1 = b.x1;
    if (b.y1 > this.y1) this.y1 = b.y1;
    if (b.x2 < this.x2) this.x2 = b.x2;
    if (b.y2 < this.y2) this.y2 = b.y2;
    return this;
  },
  encloses(b) {
    return b && this.x1 <= b.x1 && this.x2 >= b.x2 && this.y1 <= b.y1 && this.y2 >= b.y2;
  },
  alignsWith(b) {
    return b && (this.x1 == b.x1 || this.x2 == b.x2 || this.y1 == b.y1 || this.y2 == b.y2);
  },
  intersects(b) {
    return b && !(this.x2 < b.x1 || this.x1 > b.x2 || this.y2 < b.y1 || this.y1 > b.y2);
  },
  contains(x, y) {
    return !(x < this.x1 || x > this.x2 || y < this.y1 || y > this.y2);
  },
  width() {
    return this.x2 - this.x1;
  },
  height() {
    return this.y2 - this.y1;
  }
};
function Item(mark) {
  this.mark = mark;
  this.bounds = this.bounds || new Bounds();
}
function GroupItem(mark) {
  Item.call(this, mark);
  this.items = this.items || [];
}
inherits(GroupItem, Item);
class ResourceLoader {
  constructor(customLoader) {
    this._pending = 0;
    this._loader = customLoader || loader();
  }
  pending() {
    return this._pending;
  }
  sanitizeURL(uri) {
    const loader = this;
    increment(loader);
    return loader._loader.sanitize(uri, {
      context: 'href'
    }).then(opt => {
      decrement(loader);
      return opt;
    }).catch(() => {
      decrement(loader);
      return null;
    });
  }
  loadImage(uri) {
    const loader = this,
      Image = domImage();
    increment(loader);
    return loader._loader.sanitize(uri, {
      context: 'image'
    }).then(opt => {
      const url = opt.href;
      if (!url || !Image) throw {
        url: url
      };
      const img = new Image();

      // set crossOrigin only if cors is defined; empty string sets anonymous mode
      // https://developer.mozilla.org/en-US/docs/Web/API/HTMLImageElement/crossOrigin
      const cors = has$1(opt, 'crossOrigin') ? opt.crossOrigin : 'anonymous';
      if (cors != null) img.crossOrigin = cors;

      // attempt to load image resource
      img.onload = () => decrement(loader);
      img.onerror = () => decrement(loader);
      img.src = url;
      return img;
    }).catch(e => {
      decrement(loader);
      return {
        complete: false,
        width: 0,
        height: 0,
        src: e && e.url || ''
      };
    });
  }
  ready() {
    const loader = this;
    return new Promise(accept => {
      function poll(value) {
        if (!loader.pending()) accept(value);else setTimeout(() => {
          poll(true);
        }, 10);
      }
      poll(false);
    });
  }
}
function increment(loader) {
  loader._pending += 1;
}
function decrement(loader) {
  loader._pending -= 1;
}
function boundStroke(bounds, item, miter) {
  if (item.stroke && item.opacity !== 0 && item.strokeOpacity !== 0) {
    const sw = item.strokeWidth != null ? +item.strokeWidth : 1;
    bounds.expand(sw + (miter ? miterAdjustment(item, sw) : 0));
  }
  return bounds;
}
function miterAdjustment(item, strokeWidth) {
  // TODO: more sophisticated adjustment? Or miter support in boundContext?
  return item.strokeJoin && item.strokeJoin !== 'miter' ? 0 : strokeWidth;
}
const circleThreshold = Tau - 1e-8;
let bounds, lx, ly, rot, ma, mb, mc, md;
const add$1 = (x, y) => bounds.add(x, y);
const addL = (x, y) => add$1(lx = x, ly = y);
const addX = x => add$1(x, bounds.y1);
const addY = y => add$1(bounds.x1, y);
const px = (x, y) => ma * x + mc * y;
const py = (x, y) => mb * x + md * y;
const addp = (x, y) => add$1(px(x, y), py(x, y));
const addpL = (x, y) => addL(px(x, y), py(x, y));
function boundContext(_, deg) {
  bounds = _;
  if (deg) {
    rot = deg * DegToRad;
    ma = md = Math.cos(rot);
    mb = Math.sin(rot);
    mc = -mb;
  } else {
    ma = md = 1;
    rot = mb = mc = 0;
  }
  return context$1;
}
const context$1 = {
  beginPath() {},
  closePath() {},
  moveTo: addpL,
  lineTo: addpL,
  rect(x, y, w, h) {
    if (rot) {
      addp(x + w, y);
      addp(x + w, y + h);
      addp(x, y + h);
      addpL(x, y);
    } else {
      add$1(x + w, y + h);
      addL(x, y);
    }
  },
  quadraticCurveTo(x1, y1, x2, y2) {
    const px1 = px(x1, y1),
      py1 = py(x1, y1),
      px2 = px(x2, y2),
      py2 = py(x2, y2);
    quadExtrema(lx, px1, px2, addX);
    quadExtrema(ly, py1, py2, addY);
    addL(px2, py2);
  },
  bezierCurveTo(x1, y1, x2, y2, x3, y3) {
    const px1 = px(x1, y1),
      py1 = py(x1, y1),
      px2 = px(x2, y2),
      py2 = py(x2, y2),
      px3 = px(x3, y3),
      py3 = py(x3, y3);
    cubicExtrema(lx, px1, px2, px3, addX);
    cubicExtrema(ly, py1, py2, py3, addY);
    addL(px3, py3);
  },
  arc(cx, cy, r, sa, ea, ccw) {
    sa += rot;
    ea += rot;

    // store last point on path
    lx = r * Math.cos(ea) + cx;
    ly = r * Math.sin(ea) + cy;
    if (Math.abs(ea - sa) > circleThreshold) {
      // treat as full circle
      add$1(cx - r, cy - r);
      add$1(cx + r, cy + r);
    } else {
      const update = a => add$1(r * Math.cos(a) + cx, r * Math.sin(a) + cy);
      let s, i;

      // sample end points
      update(sa);
      update(ea);

      // sample interior points aligned with 90 degrees
      if (ea !== sa) {
        sa = sa % Tau;
        if (sa < 0) sa += Tau;
        ea = ea % Tau;
        if (ea < 0) ea += Tau;
        if (ea < sa) {
          ccw = !ccw; // flip direction
          s = sa;
          sa = ea;
          ea = s; // swap end-points
        }
        if (ccw) {
          ea -= Tau;
          s = sa - sa % HalfPi$1;
          for (i = 0; i < 4 && s > ea; ++i, s -= HalfPi$1) update(s);
        } else {
          s = sa - sa % HalfPi$1 + HalfPi$1;
          for (i = 0; i < 4 && s < ea; ++i, s = s + HalfPi$1) update(s);
        }
      }
    }
  }
};
function quadExtrema(x0, x1, x2, cb) {
  const t = (x0 - x1) / (x0 + x2 - 2 * x1);
  if (0 < t && t < 1) cb(x0 + (x1 - x0) * t);
}
function cubicExtrema(x0, x1, x2, x3, cb) {
  const a = x3 - x0 + 3 * x1 - 3 * x2,
    b = x0 + x2 - 2 * x1,
    c = x0 - x1;
  let t0 = 0,
    t1 = 0,
    r;

  // solve for parameter t
  if (Math.abs(a) > Epsilon) {
    // quadratic equation
    r = b * b + c * a;
    if (r >= 0) {
      r = Math.sqrt(r);
      t0 = (-b + r) / a;
      t1 = (-b - r) / a;
    }
  } else {
    // linear equation
    t0 = 0.5 * c / b;
  }

  // calculate position
  if (0 < t0 && t0 < 1) cb(cubic(t0, x0, x1, x2, x3));
  if (0 < t1 && t1 < 1) cb(cubic(t1, x0, x1, x2, x3));
}
function cubic(t, x0, x1, x2, x3) {
  const s = 1 - t,
    s2 = s * s,
    t2 = t * t;
  return s2 * s * x0 + 3 * s2 * t * x1 + 3 * s * t2 * x2 + t2 * t * x3;
}
var context$2 = (context$2 = domCanvas(1, 1)) ? context$2.getContext('2d') : null;
const b = new Bounds();
function intersectPath(draw) {
  return function (item, brush) {
    // rely on (inaccurate) bounds intersection if no context
    if (!context$2) return true;

    // add path to offscreen graphics context
    draw(context$2, item);

    // get bounds intersection region
    b.clear().union(item.bounds).intersect(brush).round();
    const {
      x1,
      y1,
      x2,
      y2
    } = b;

    // iterate over intersection region
    // perform fine grained inclusion test
    for (let y = y1; y <= y2; ++y) {
      for (let x = x1; x <= x2; ++x) {
        if (context$2.isPointInPath(x, y)) {
          return true;
        }
      }
    }

    // false if no hits in intersection region
    return false;
  };
}
function intersectPoint(item, box) {
  return box.contains(item.x || 0, item.y || 0);
}
function intersectRect(item, box) {
  const x = item.x || 0,
    y = item.y || 0,
    w = item.width || 0,
    h = item.height || 0;
  return box.intersects(b.set(x, y, x + w, y + h));
}
function intersectRule(item, box) {
  const x = item.x || 0,
    y = item.y || 0,
    x2 = item.x2 != null ? item.x2 : x,
    y2 = item.y2 != null ? item.y2 : y;
  return intersectBoxLine(box, x, y, x2, y2);
}
function intersectBoxLine(box, x, y, u, v) {
  const {
      x1,
      y1,
      x2,
      y2
    } = box,
    dx = u - x,
    dy = v - y;
  let t0 = 0,
    t1 = 1,
    p,
    q,
    r,
    e;
  for (e = 0; e < 4; ++e) {
    if (e === 0) {
      p = -dx;
      q = -(x1 - x);
    }
    if (e === 1) {
      p = dx;
      q = x2 - x;
    }
    if (e === 2) {
      p = -dy;
      q = -(y1 - y);
    }
    if (e === 3) {
      p = dy;
      q = y2 - y;
    }
    if (Math.abs(p) < 1e-10 && q < 0) return false;
    r = q / p;
    if (p < 0) {
      if (r > t1) return false;else if (r > t0) t0 = r;
    } else if (p > 0) {
      if (r < t0) return false;else if (r < t1) t1 = r;
    }
  }
  return true;
}
function blend(context, item) {
  context.globalCompositeOperation = item.blend || 'source-over';
}
function value$2(value, dflt) {
  return value == null ? dflt : value;
}
function addStops(gradient, stops) {
  const n = stops.length;
  for (let i = 0; i < n; ++i) {
    gradient.addColorStop(stops[i].offset, stops[i].color);
  }
  return gradient;
}
function gradient$1(context, spec, bounds) {
  const w = bounds.width(),
    h = bounds.height();
  let gradient;
  if (spec.gradient === 'radial') {
    gradient = context.createRadialGradient(bounds.x1 + value$2(spec.x1, 0.5) * w, bounds.y1 + value$2(spec.y1, 0.5) * h, Math.max(w, h) * value$2(spec.r1, 0), bounds.x1 + value$2(spec.x2, 0.5) * w, bounds.y1 + value$2(spec.y2, 0.5) * h, Math.max(w, h) * value$2(spec.r2, 0.5));
  } else {
    // linear gradient
    const x1 = value$2(spec.x1, 0),
      y1 = value$2(spec.y1, 0),
      x2 = value$2(spec.x2, 1),
      y2 = value$2(spec.y2, 0);
    if (x1 === x2 || y1 === y2 || w === h) {
      // axis aligned: use normal gradient
      gradient = context.createLinearGradient(bounds.x1 + x1 * w, bounds.y1 + y1 * h, bounds.x1 + x2 * w, bounds.y1 + y2 * h);
    } else {
      // not axis aligned: render gradient into a pattern (#2365)
      // this allows us to use normalized bounding box coordinates
      const image = domCanvas(Math.ceil(w), Math.ceil(h)),
        ictx = image.getContext('2d');
      ictx.scale(w, h);
      ictx.fillStyle = addStops(ictx.createLinearGradient(x1, y1, x2, y2), spec.stops);
      ictx.fillRect(0, 0, w, h);
      return context.createPattern(image, 'no-repeat');
    }
  }
  return addStops(gradient, spec.stops);
}
function color$1(context, item, value) {
  return isGradient(value) ? gradient$1(context, value, item.bounds) : value;
}
function fill(context, item, opacity) {
  opacity *= item.fillOpacity == null ? 1 : item.fillOpacity;
  if (opacity > 0) {
    context.globalAlpha = opacity;
    context.fillStyle = color$1(context, item, item.fill);
    return true;
  } else {
    return false;
  }
}
var Empty = [];
function stroke(context, item, opacity) {
  var lw = (lw = item.strokeWidth) != null ? lw : 1;
  if (lw <= 0) return false;
  opacity *= item.strokeOpacity == null ? 1 : item.strokeOpacity;
  if (opacity > 0) {
    context.globalAlpha = opacity;
    context.strokeStyle = color$1(context, item, item.stroke);
    context.lineWidth = lw;
    context.lineCap = item.strokeCap || 'butt';
    context.lineJoin = item.strokeJoin || 'miter';
    context.miterLimit = item.strokeMiterLimit || 10;
    if (context.setLineDash) {
      context.setLineDash(item.strokeDash || Empty);
      context.lineDashOffset = item.strokeDashOffset || 0;
    }
    return true;
  } else {
    return false;
  }
}
function compare(a, b) {
  return a.zindex - b.zindex || a.index - b.index;
}
function zorder(scene) {
  if (!scene.zdirty) return scene.zitems;
  var items = scene.items,
    output = [],
    item,
    i,
    n;
  for (i = 0, n = items.length; i < n; ++i) {
    item = items[i];
    item.index = i;
    if (item.zindex) output.push(item);
  }
  scene.zdirty = false;
  return scene.zitems = output.sort(compare);
}
function visit(scene, visitor) {
  var items = scene.items,
    i,
    n;
  if (!items || !items.length) return;
  const zitems = zorder(scene);
  if (zitems && zitems.length) {
    for (i = 0, n = items.length; i < n; ++i) {
      if (!items[i].zindex) visitor(items[i]);
    }
    items = zitems;
  }
  for (i = 0, n = items.length; i < n; ++i) {
    visitor(items[i]);
  }
}
function pickVisit(scene, visitor) {
  var items = scene.items,
    hit,
    i;
  if (!items || !items.length) return null;
  const zitems = zorder(scene);
  if (zitems && zitems.length) items = zitems;
  for (i = items.length; --i >= 0;) {
    if (hit = visitor(items[i])) return hit;
  }
  if (items === zitems) {
    for (items = scene.items, i = items.length; --i >= 0;) {
      if (!items[i].zindex) {
        if (hit = visitor(items[i])) return hit;
      }
    }
  }
  return null;
}
function drawAll(path) {
  return function (context, scene, bounds) {
    visit(scene, item => {
      if (!bounds || bounds.intersects(item.bounds)) {
        drawPath(path, context, item, item);
      }
    });
  };
}
function drawOne(path) {
  return function (context, scene, bounds) {
    if (scene.items.length && (!bounds || bounds.intersects(scene.bounds))) {
      drawPath(path, context, scene.items[0], scene.items);
    }
  };
}
function drawPath(path, context, item, items) {
  var opacity = item.opacity == null ? 1 : item.opacity;
  if (opacity === 0) return;
  if (path(context, items)) return;
  blend(context, item);
  if (item.fill && fill(context, item, opacity)) {
    context.fill();
  }
  if (item.stroke && stroke(context, item, opacity)) {
    context.stroke();
  }
}
function pick$1(test) {
  test = test || truthy;
  return function (context, scene, x, y, gx, gy) {
    x *= context.pixelRatio;
    y *= context.pixelRatio;
    return pickVisit(scene, item => {
      const b = item.bounds;
      // first hit test against bounding box
      if (b && !b.contains(gx, gy) || !b) return;
      // if in bounding box, perform more careful test
      if (test(context, item, x, y, gx, gy)) return item;
    });
  };
}
function hitPath(path, filled) {
  return function (context, o, x, y) {
    var item = Array.isArray(o) ? o[0] : o,
      fill = filled == null ? item.fill : filled,
      stroke = item.stroke && context.isPointInStroke,
      lw,
      lc;
    if (stroke) {
      lw = item.strokeWidth;
      lc = item.strokeCap;
      context.lineWidth = lw != null ? lw : 1;
      context.lineCap = lc != null ? lc : 'butt';
    }
    return path(context, o) ? false : fill && context.isPointInPath(x, y) || stroke && context.isPointInStroke(x, y);
  };
}
function pickPath(path) {
  return pick$1(hitPath(path));
}
function translate$1(x, y) {
  return 'translate(' + x + ',' + y + ')';
}
function rotate(a) {
  return 'rotate(' + a + ')';
}
function scale$3(scaleX, scaleY) {
  return 'scale(' + scaleX + ',' + scaleY + ')';
}
function translateItem(item) {
  return translate$1(item.x || 0, item.y || 0);
}
function rotateItem(item) {
  return translate$1(item.x || 0, item.y || 0) + (item.angle ? ' ' + rotate(item.angle) : '');
}
function transformItem(item) {
  return translate$1(item.x || 0, item.y || 0) + (item.angle ? ' ' + rotate(item.angle) : '') + (item.scaleX || item.scaleY ? ' ' + scale$3(item.scaleX || 1, item.scaleY || 1) : '');
}
function markItemPath(type, shape, isect) {
  function attr(emit, item) {
    emit('transform', rotateItem(item));
    emit('d', shape(null, item));
  }
  function bound(bounds, item) {
    shape(boundContext(bounds, item.angle), item);
    return boundStroke(bounds, item).translate(item.x || 0, item.y || 0);
  }
  function draw(context, item) {
    var x = item.x || 0,
      y = item.y || 0,
      a = item.angle || 0;
    context.translate(x, y);
    if (a) context.rotate(a *= DegToRad);
    context.beginPath();
    shape(context, item);
    if (a) context.rotate(-a);
    context.translate(-x, -y);
  }
  return {
    type: type,
    tag: 'path',
    nested: false,
    attr: attr,
    bound: bound,
    draw: drawAll(draw),
    pick: pickPath(draw),
    isect: isect || intersectPath(draw)
  };
}
var arc$2 = markItemPath('arc', arc$1);
function pickArea(a, p) {
  var v = a[0].orient === 'horizontal' ? p[1] : p[0],
    z = a[0].orient === 'horizontal' ? 'y' : 'x',
    i = a.length,
    min = +Infinity,
    hit,
    d;
  while (--i >= 0) {
    if (a[i].defined === false) continue;
    d = Math.abs(a[i][z] - v);
    if (d < min) {
      min = d;
      hit = a[i];
    }
  }
  return hit;
}
function pickLine(a, p) {
  var t = Math.pow(a[0].strokeWidth || 1, 2),
    i = a.length,
    dx,
    dy,
    dd;
  while (--i >= 0) {
    if (a[i].defined === false) continue;
    dx = a[i].x - p[0];
    dy = a[i].y - p[1];
    dd = dx * dx + dy * dy;
    if (dd < t) return a[i];
  }
  return null;
}
function pickTrail(a, p) {
  var i = a.length,
    dx,
    dy,
    dd;
  while (--i >= 0) {
    if (a[i].defined === false) continue;
    dx = a[i].x - p[0];
    dy = a[i].y - p[1];
    dd = dx * dx + dy * dy;
    dx = a[i].size || 1;
    if (dd < dx * dx) return a[i];
  }
  return null;
}
function markMultiItemPath(type, shape, tip) {
  function attr(emit, item) {
    var items = item.mark.items;
    if (items.length) emit('d', shape(null, items));
  }
  function bound(bounds, mark) {
    var items = mark.items;
    if (items.length === 0) {
      return bounds;
    } else {
      shape(boundContext(bounds), items);
      return boundStroke(bounds, items[0]);
    }
  }
  function draw(context, items) {
    context.beginPath();
    shape(context, items);
  }
  const hit = hitPath(draw);
  function pick(context, scene, x, y, gx, gy) {
    var items = scene.items,
      b = scene.bounds;
    if (!items || !items.length || b && !b.contains(gx, gy)) {
      return null;
    }
    x *= context.pixelRatio;
    y *= context.pixelRatio;
    return hit(context, items, x, y) ? items[0] : null;
  }
  return {
    type: type,
    tag: 'path',
    nested: true,
    attr: attr,
    bound: bound,
    draw: drawOne(draw),
    pick: pick,
    isect: intersectPoint,
    tip: tip
  };
}
var area$2 = markMultiItemPath('area', area$1, pickArea);
function clip$2(context, scene) {
  var clip = scene.clip;
  context.save();
  if (isFunction(clip)) {
    context.beginPath();
    clip(context);
    context.clip();
  } else {
    clipGroup(context, scene.group);
  }
}
function clipGroup(context, group) {
  context.beginPath();
  hasCornerRadius(group) ? rectangle(context, group, 0, 0) : context.rect(0, 0, group.width || 0, group.height || 0);
  context.clip();
}
function offset$1(item) {
  const sw = value$2(item.strokeWidth, 1);
  return item.strokeOffset != null ? item.strokeOffset : item.stroke && sw > 0.5 && sw < 1.5 ? 0.5 - Math.abs(sw - 1) : 0;
}
function attr$5(emit, item) {
  emit('transform', translateItem(item));
}
function emitRectangle(emit, item) {
  const off = offset$1(item);
  emit('d', rectangle(null, item, off, off));
}
function background$1(emit, item) {
  emit('class', 'background');
  emit('aria-hidden', true);
  emitRectangle(emit, item);
}
function foreground(emit, item) {
  emit('class', 'foreground');
  emit('aria-hidden', true);
  if (item.strokeForeground) {
    emitRectangle(emit, item);
  } else {
    emit('d', '');
  }
}
function content(emit, item, renderer) {
  const url = item.clip ? clip$1$1(renderer, item, item) : null;
  emit('clip-path', url);
}
function bound$5(bounds, group) {
  if (!group.clip && group.items) {
    const items = group.items,
      m = items.length;
    for (let j = 0; j < m; ++j) {
      bounds.union(items[j].bounds);
    }
  }
  if ((group.clip || group.width || group.height) && !group.noBound) {
    bounds.add(0, 0).add(group.width || 0, group.height || 0);
  }
  boundStroke(bounds, group);
  return bounds.translate(group.x || 0, group.y || 0);
}
function rectanglePath(context, group, x, y) {
  const off = offset$1(group);
  context.beginPath();
  rectangle(context, group, (x || 0) + off, (y || 0) + off);
}
const hitBackground = hitPath(rectanglePath);
const hitForeground = hitPath(rectanglePath, false);
const hitCorner = hitPath(rectanglePath, true);
function draw$4(context, scene, bounds, markTypes) {
  visit(scene, group => {
    const gx = group.x || 0,
      gy = group.y || 0,
      fore = group.strokeForeground,
      opacity = group.opacity == null ? 1 : group.opacity;

    // draw group background
    if ((group.stroke || group.fill) && opacity) {
      rectanglePath(context, group, gx, gy);
      blend(context, group);
      if (group.fill && fill(context, group, opacity)) {
        context.fill();
      }
      if (group.stroke && !fore && stroke(context, group, opacity)) {
        context.stroke();
      }
    }

    // setup graphics context, set clip and bounds
    context.save();
    context.translate(gx, gy);
    if (group.clip) clipGroup(context, group);
    if (bounds) bounds.translate(-gx, -gy);

    // draw group contents
    visit(group, item => {
      if (item.marktype === 'group' || markTypes == null || markTypes.includes(item.marktype)) {
        this.draw(context, item, bounds, markTypes);
      }
    });

    // restore graphics context
    if (bounds) bounds.translate(gx, gy);
    context.restore();

    // draw group foreground
    if (fore && group.stroke && opacity) {
      rectanglePath(context, group, gx, gy);
      blend(context, group);
      if (stroke(context, group, opacity)) {
        context.stroke();
      }
    }
  });
}
function pick(context, scene, x, y, gx, gy) {
  if (scene.bounds && !scene.bounds.contains(gx, gy) || !scene.items) {
    return null;
  }
  const cx = x * context.pixelRatio,
    cy = y * context.pixelRatio;
  return pickVisit(scene, group => {
    let hit, dx, dy;

    // first hit test bounding box
    const b = group.bounds;
    if (b && !b.contains(gx, gy)) return;

    // passed bounds check, test rectangular clip
    dx = group.x || 0;
    dy = group.y || 0;
    const dw = dx + (group.width || 0),
      dh = dy + (group.height || 0),
      c = group.clip;
    if (c && (gx < dx || gx > dw || gy < dy || gy > dh)) return;

    // adjust coordinate system
    context.save();
    context.translate(dx, dy);
    dx = gx - dx;
    dy = gy - dy;

    // test background for rounded corner clip
    if (c && hasCornerRadius(group) && !hitCorner(context, group, cx, cy)) {
      context.restore();
      return null;
    }
    const fore = group.strokeForeground,
      ix = scene.interactive !== false;

    // hit test against group foreground
    if (ix && fore && group.stroke && hitForeground(context, group, cx, cy)) {
      context.restore();
      return group;
    }

    // hit test against contained marks
    hit = pickVisit(group, mark => pickMark(mark, dx, dy) ? this.pick(mark, x, y, dx, dy) : null);

    // hit test against group background
    if (!hit && ix && (group.fill || !fore && group.stroke) && hitBackground(context, group, cx, cy)) {
      hit = group;
    }

    // restore state and return
    context.restore();
    return hit || null;
  });
}
function pickMark(mark, x, y) {
  return (mark.interactive !== false || mark.marktype === 'group') && mark.bounds && mark.bounds.contains(x, y);
}
var group = {
  type: 'group',
  tag: 'g',
  nested: false,
  attr: attr$5,
  bound: bound$5,
  draw: draw$4,
  pick: pick,
  isect: intersectRect,
  content: content,
  background: background$1,
  foreground: foreground
};
var metadata = {
  'xmlns': 'http://www.w3.org/2000/svg',
  'xmlns:xlink': 'http://www.w3.org/1999/xlink',
  'version': '1.1'
};
function getImage(item, renderer) {
  var image = item.image;
  if (!image || item.url && item.url !== image.url) {
    image = {
      complete: false,
      width: 0,
      height: 0
    };
    renderer.loadImage(item.url).then(image => {
      item.image = image;
      item.image.url = item.url;
    });
  }
  return image;
}
function imageWidth(item, image) {
  return item.width != null ? item.width : !image || !image.width ? 0 : item.aspect !== false && item.height ? item.height * image.width / image.height : image.width;
}
function imageHeight(item, image) {
  return item.height != null ? item.height : !image || !image.height ? 0 : item.aspect !== false && item.width ? item.width * image.height / image.width : image.height;
}
function imageXOffset(align, w) {
  return align === 'center' ? w / 2 : align === 'right' ? w : 0;
}
function imageYOffset(baseline, h) {
  return baseline === 'middle' ? h / 2 : baseline === 'bottom' ? h : 0;
}
function attr$4(emit, item, renderer) {
  const img = getImage(item, renderer),
    w = imageWidth(item, img),
    h = imageHeight(item, img),
    x = (item.x || 0) - imageXOffset(item.align, w),
    y = (item.y || 0) - imageYOffset(item.baseline, h),
    i = !img.src && img.toDataURL ? img.toDataURL() : img.src || '';
  emit('href', i, metadata['xmlns:xlink'], 'xlink:href');
  emit('transform', translate$1(x, y));
  emit('width', w);
  emit('height', h);
  emit('preserveAspectRatio', item.aspect === false ? 'none' : 'xMidYMid');
}
function bound$4(bounds, item) {
  const img = item.image,
    w = imageWidth(item, img),
    h = imageHeight(item, img),
    x = (item.x || 0) - imageXOffset(item.align, w),
    y = (item.y || 0) - imageYOffset(item.baseline, h);
  return bounds.set(x, y, x + w, y + h);
}
function draw$3(context, scene, bounds) {
  visit(scene, item => {
    if (bounds && !bounds.intersects(item.bounds)) return; // bounds check

    const img = getImage(item, this);
    let w = imageWidth(item, img);
    let h = imageHeight(item, img);
    if (w === 0 || h === 0) return; // early exit

    let x = (item.x || 0) - imageXOffset(item.align, w),
      y = (item.y || 0) - imageYOffset(item.baseline, h),
      opacity,
      ar0,
      ar1,
      t;
    if (item.aspect !== false) {
      ar0 = img.width / img.height;
      ar1 = item.width / item.height;
      if (ar0 === ar0 && ar1 === ar1 && ar0 !== ar1) {
        if (ar1 < ar0) {
          t = w / ar0;
          y += (h - t) / 2;
          h = t;
        } else {
          t = h * ar0;
          x += (w - t) / 2;
          w = t;
        }
      }
    }
    if (img.complete || img.toDataURL) {
      blend(context, item);
      context.globalAlpha = (opacity = item.opacity) != null ? opacity : 1;
      context.imageSmoothingEnabled = item.smooth !== false;
      context.drawImage(img, x, y, w, h);
    }
  });
}
var image = {
  type: 'image',
  tag: 'image',
  nested: false,
  attr: attr$4,
  bound: bound$4,
  draw: draw$3,
  pick: pick$1(),
  isect: truthy,
  // bounds check is sufficient
  get: getImage,
  xOffset: imageXOffset,
  yOffset: imageYOffset
};
var line$2 = markMultiItemPath('line', line$1, pickLine);
function attr$3(emit, item) {
  var sx = item.scaleX || 1,
    sy = item.scaleY || 1;
  if (sx !== 1 || sy !== 1) {
    emit('vector-effect', 'non-scaling-stroke');
  }
  emit('transform', transformItem(item));
  emit('d', item.path);
}
function path$1(context, item) {
  var path = item.path;
  if (path == null) return true;
  var x = item.x || 0,
    y = item.y || 0,
    sx = item.scaleX || 1,
    sy = item.scaleY || 1,
    a = (item.angle || 0) * DegToRad,
    cache = item.pathCache;
  if (!cache || cache.path !== path) {
    (item.pathCache = cache = parse$3(path)).path = path;
  }
  if (a && context.rotate && context.translate) {
    context.translate(x, y);
    context.rotate(a);
    pathRender(context, cache, 0, 0, sx, sy);
    context.rotate(-a);
    context.translate(-x, -y);
  } else {
    pathRender(context, cache, x, y, sx, sy);
  }
}
function bound$3(bounds, item) {
  return path$1(boundContext(bounds, item.angle), item) ? bounds.set(0, 0, 0, 0) : boundStroke(bounds, item, true);
}
var path$2 = {
  type: 'path',
  tag: 'path',
  nested: false,
  attr: attr$3,
  bound: bound$3,
  draw: drawAll(path$1),
  pick: pickPath(path$1),
  isect: intersectPath(path$1)
};
function attr$2(emit, item) {
  emit('d', rectangle(null, item));
}
function bound$2(bounds, item) {
  var x, y;
  return boundStroke(bounds.set(x = item.x || 0, y = item.y || 0, x + item.width || 0, y + item.height || 0), item);
}
function draw$2(context, item) {
  context.beginPath();
  rectangle(context, item);
}
var rect = {
  type: 'rect',
  tag: 'path',
  nested: false,
  attr: attr$2,
  bound: bound$2,
  draw: drawAll(draw$2),
  pick: pickPath(draw$2),
  isect: intersectRect
};
function attr$1(emit, item) {
  emit('transform', translateItem(item));
  emit('x2', item.x2 != null ? item.x2 - (item.x || 0) : 0);
  emit('y2', item.y2 != null ? item.y2 - (item.y || 0) : 0);
}
function bound$1(bounds, item) {
  var x1, y1;
  return boundStroke(bounds.set(x1 = item.x || 0, y1 = item.y || 0, item.x2 != null ? item.x2 : x1, item.y2 != null ? item.y2 : y1), item);
}
function path(context, item, opacity) {
  var x1, y1, x2, y2;
  if (item.stroke && stroke(context, item, opacity)) {
    x1 = item.x || 0;
    y1 = item.y || 0;
    x2 = item.x2 != null ? item.x2 : x1;
    y2 = item.y2 != null ? item.y2 : y1;
    context.beginPath();
    context.moveTo(x1, y1);
    context.lineTo(x2, y2);
    return true;
  }
  return false;
}
function draw$1(context, scene, bounds) {
  visit(scene, item => {
    if (bounds && !bounds.intersects(item.bounds)) return; // bounds check
    var opacity = item.opacity == null ? 1 : item.opacity;
    if (opacity && path(context, item, opacity)) {
      blend(context, item);
      context.stroke();
    }
  });
}
function hit$1(context, item, x, y) {
  if (!context.isPointInStroke) return false;
  return path(context, item, 1) && context.isPointInStroke(x, y);
}
var rule$1 = {
  type: 'rule',
  tag: 'line',
  nested: false,
  attr: attr$1,
  bound: bound$1,
  draw: draw$1,
  pick: pick$1(hit$1),
  isect: intersectRule
};
var shape = markItemPath('shape', shape$1);
var symbol = markItemPath('symbol', symbol$1, intersectPoint);

// memoize text width measurement
const widthCache = lruCache();
var textMetrics = {
  height: fontSize,
  measureWidth: measureWidth,
  estimateWidth: estimateWidth,
  width: estimateWidth,
  canvas: useCanvas
};
useCanvas(true);
function useCanvas(use) {
  textMetrics.width = use && context$2 ? measureWidth : estimateWidth;
}

// make simple estimate if no canvas is available
function estimateWidth(item, text) {
  return _estimateWidth(textValue(item, text), fontSize(item));
}
function _estimateWidth(text, currentFontHeight) {
  return ~~(0.8 * text.length * currentFontHeight);
}

// measure text width if canvas is available
function measureWidth(item, text) {
  return fontSize(item) <= 0 || !(text = textValue(item, text)) ? 0 : _measureWidth(text, font(item));
}
function _measureWidth(text, currentFont) {
  const key = `(${currentFont}) ${text}`;
  let width = widthCache.get(key);
  if (width === undefined) {
    context$2.font = currentFont;
    width = context$2.measureText(text).width;
    widthCache.set(key, width);
  }
  return width;
}
function fontSize(item) {
  return item.fontSize != null ? +item.fontSize || 0 : 11;
}
function lineHeight(item) {
  return item.lineHeight != null ? item.lineHeight : fontSize(item) + 2;
}
function lineArray(_) {
  return isArray(_) ? _.length > 1 ? _ : _[0] : _;
}
function textLines(item) {
  return lineArray(item.lineBreak && item.text && !isArray(item.text) ? item.text.split(item.lineBreak) : item.text);
}
function multiLineOffset(item) {
  const tl = textLines(item);
  return (isArray(tl) ? tl.length - 1 : 0) * lineHeight(item);
}
function textValue(item, line) {
  const text = line == null ? '' : (line + '').trim();
  return item.limit > 0 && text.length ? truncate(item, text) : text;
}
function widthGetter(item) {
  if (textMetrics.width === measureWidth) {
    // we are using canvas
    const currentFont = font(item);
    return text => _measureWidth(text, currentFont);
  } else if (textMetrics.width === estimateWidth) {
    // we are relying on estimates
    const currentFontHeight = fontSize(item);
    return text => _estimateWidth(text, currentFontHeight);
  } else {
    // User defined textMetrics.width function in use (e.g. vl-convert)
    return text => textMetrics.width(item, text);
  }
}
function truncate(item, text) {
  var limit = +item.limit,
    width = widthGetter(item);
  if (width(text) < limit) return text;
  var ellipsis = item.ellipsis || '\u2026',
    rtl = item.dir === 'rtl',
    lo = 0,
    hi = text.length,
    mid;
  limit -= width(ellipsis);
  if (rtl) {
    while (lo < hi) {
      mid = lo + hi >>> 1;
      if (width(text.slice(mid)) > limit) lo = mid + 1;else hi = mid;
    }
    return ellipsis + text.slice(lo);
  } else {
    while (lo < hi) {
      mid = 1 + (lo + hi >>> 1);
      if (width(text.slice(0, mid)) < limit) lo = mid;else hi = mid - 1;
    }
    return text.slice(0, lo) + ellipsis;
  }
}
function fontFamily(item, quote) {
  var font = item.font;
  return (font) || 'sans-serif';
}
function font(item, quote) {
  return '' + (item.fontStyle ? item.fontStyle + ' ' : '') + (item.fontVariant ? item.fontVariant + ' ' : '') + (item.fontWeight ? item.fontWeight + ' ' : '') + fontSize(item) + 'px ' + fontFamily(item);
}
function offset$2(item) {
  // perform our own font baseline calculation
  // why? not all browsers support SVG 1.1 'alignment-baseline' :(
  // this also ensures consistent layout across renderers
  var baseline = item.baseline,
    h = fontSize(item);
  return Math.round(baseline === 'top' ? 0.79 * h : baseline === 'middle' ? 0.30 * h : baseline === 'bottom' ? -0.21 * h : baseline === 'line-top' ? 0.29 * h + 0.5 * lineHeight(item) : baseline === 'line-bottom' ? 0.29 * h - 0.5 * lineHeight(item) : 0);
}
const textAlign = {
  'left': 'start',
  'center': 'middle',
  'right': 'end'
};
const tempBounds$1 = new Bounds();
function anchorPoint(item) {
  var x = item.x || 0,
    y = item.y || 0,
    r = item.radius || 0,
    t;
  if (r) {
    t = (item.theta || 0) - HalfPi$1;
    x += r * Math.cos(t);
    y += r * Math.sin(t);
  }
  tempBounds$1.x1 = x;
  tempBounds$1.y1 = y;
  return tempBounds$1;
}
function attr(emit, item) {
  var dx = item.dx || 0,
    dy = (item.dy || 0) + offset$2(item),
    p = anchorPoint(item),
    x = p.x1,
    y = p.y1,
    a = item.angle || 0,
    t;
  emit('text-anchor', textAlign[item.align] || 'start');
  if (a) {
    t = translate$1(x, y) + ' ' + rotate(a);
    if (dx || dy) t += ' ' + translate$1(dx, dy);
  } else {
    t = translate$1(x + dx, y + dy);
  }
  emit('transform', t);
}
function bound(bounds, item, mode) {
  var h = textMetrics.height(item),
    a = item.align,
    p = anchorPoint(item),
    x = p.x1,
    y = p.y1,
    dx = item.dx || 0,
    dy = (item.dy || 0) + offset$2(item) - Math.round(0.8 * h),
    // use 4/5 offset
    tl = textLines(item),
    w;

  // get dimensions
  if (isArray(tl)) {
    // multi-line text
    h += lineHeight(item) * (tl.length - 1);
    w = tl.reduce((w, t) => Math.max(w, textMetrics.width(item, t)), 0);
  } else {
    // single-line text
    w = textMetrics.width(item, tl);
  }

  // horizontal alignment
  if (a === 'center') {
    dx -= w / 2;
  } else if (a === 'right') {
    dx -= w;
  } else ;
  bounds.set(dx += x, dy += y, dx + w, dy + h);
  if (item.angle && !mode) {
    bounds.rotate(item.angle * DegToRad, x, y);
  } else if (mode === 2) {
    return bounds.rotatedPoints(item.angle * DegToRad, x, y);
  }
  return bounds;
}
function draw$5(context, scene, bounds) {
  visit(scene, item => {
    var opacity = item.opacity == null ? 1 : item.opacity,
      p,
      x,
      y,
      i,
      lh,
      tl,
      str;
    if (bounds && !bounds.intersects(item.bounds) ||
    // bounds check
    opacity === 0 || item.fontSize <= 0 || item.text == null || item.text.length === 0) return;
    context.font = font(item);
    context.textAlign = item.align || 'left';
    p = anchorPoint(item);
    x = p.x1, y = p.y1;
    if (item.angle) {
      context.save();
      context.translate(x, y);
      context.rotate(item.angle * DegToRad);
      x = y = 0; // reset x, y
    }
    x += item.dx || 0;
    y += (item.dy || 0) + offset$2(item);
    tl = textLines(item);
    blend(context, item);
    if (isArray(tl)) {
      lh = lineHeight(item);
      for (i = 0; i < tl.length; ++i) {
        str = textValue(item, tl[i]);
        if (item.fill && fill(context, item, opacity)) {
          context.fillText(str, x, y);
        }
        if (item.stroke && stroke(context, item, opacity)) {
          context.strokeText(str, x, y);
        }
        y += lh;
      }
    } else {
      str = textValue(item, tl);
      if (item.fill && fill(context, item, opacity)) {
        context.fillText(str, x, y);
      }
      if (item.stroke && stroke(context, item, opacity)) {
        context.strokeText(str, x, y);
      }
    }
    if (item.angle) context.restore();
  });
}
function hit(context, item, x, y, gx, gy) {
  if (item.fontSize <= 0) return false;
  if (!item.angle) return true; // bounds sufficient if no rotation

  // project point into space of unrotated bounds
  var p = anchorPoint(item),
    ax = p.x1,
    ay = p.y1,
    b = bound(tempBounds$1, item, 1),
    a = -item.angle * DegToRad,
    cos = Math.cos(a),
    sin = Math.sin(a),
    px = cos * gx - sin * gy + (ax - cos * ax + sin * ay),
    py = sin * gx + cos * gy + (ay - sin * ax - cos * ay);
  return b.contains(px, py);
}
function intersectText(item, box) {
  const p = bound(tempBounds$1, item, 2);
  return intersectBoxLine(box, p[0], p[1], p[2], p[3]) || intersectBoxLine(box, p[0], p[1], p[4], p[5]) || intersectBoxLine(box, p[4], p[5], p[6], p[7]) || intersectBoxLine(box, p[2], p[3], p[6], p[7]);
}
var text = {
  type: 'text',
  tag: 'text',
  nested: false,
  attr: attr,
  bound: bound,
  draw: draw$5,
  pick: pick$1(hit),
  isect: intersectText
};
var trail = markMultiItemPath('trail', trail$1, pickTrail);
var Marks = {
  arc: arc$2,
  area: area$2,
  group: group,
  image: image,
  line: line$2,
  path: path$2,
  rect: rect,
  rule: rule$1,
  shape: shape,
  symbol: symbol,
  text: text,
  trail: trail
};
function boundItem$1(item, func, opt) {
  var type = Marks[item.mark.marktype],
    bound = func || type.bound;
  if (type.nested) item = item.mark;
  return bound(item.bounds || (item.bounds = new Bounds()), item, opt);
}
var DUMMY = {
  mark: null
};
function boundMark(mark, bounds, opt) {
  var type = Marks[mark.marktype],
    bound = type.bound,
    items = mark.items,
    hasItems = items && items.length,
    i,
    n,
    item,
    b;
  if (type.nested) {
    if (hasItems) {
      item = items[0];
    } else {
      // no items, fake it
      DUMMY.mark = mark;
      item = DUMMY;
    }
    b = boundItem$1(item, bound, opt);
    bounds = bounds && bounds.union(b) || b;
    return bounds;
  }
  bounds = bounds || mark.bounds && mark.bounds.clear() || new Bounds();
  if (hasItems) {
    for (i = 0, n = items.length; i < n; ++i) {
      bounds.union(boundItem$1(items[i], bound, opt));
    }
  }
  return mark.bounds = bounds;
}
const keys$1 = ['marktype', 'name', 'role', 'interactive', 'clip', 'items', 'zindex', 'x', 'y', 'width', 'height', 'align', 'baseline',
// layout
'fill', 'fillOpacity', 'opacity', 'blend',
// fill
'stroke', 'strokeOpacity', 'strokeWidth', 'strokeCap',
// stroke
'strokeDash', 'strokeDashOffset',
// stroke dash
'strokeForeground', 'strokeOffset',
// group
'startAngle', 'endAngle', 'innerRadius', 'outerRadius',
// arc
'cornerRadius', 'padAngle',
// arc, rect
'cornerRadiusTopLeft', 'cornerRadiusTopRight',
// rect, group
'cornerRadiusBottomLeft', 'cornerRadiusBottomRight', 'interpolate', 'tension', 'orient', 'defined',
// area, line
'url', 'aspect', 'smooth',
// image
'path', 'scaleX', 'scaleY',
// path
'x2', 'y2',
// rule
'size', 'shape',
// symbol
'text', 'angle', 'theta', 'radius', 'dir', 'dx', 'dy',
// text
'ellipsis', 'limit', 'lineBreak', 'lineHeight', 'font', 'fontSize', 'fontWeight', 'fontStyle', 'fontVariant',
// font
'description', 'aria', 'ariaRole', 'ariaRoleDescription' // aria
];
function sceneToJSON(scene, indent) {
  return JSON.stringify(scene, keys$1, indent);
}
function sceneFromJSON(json) {
  const scene = typeof json === 'string' ? JSON.parse(json) : json;
  return initialize$1(scene);
}
function initialize$1(scene) {
  var type = scene.marktype,
    items = scene.items,
    parent,
    i,
    n;
  if (items) {
    for (i = 0, n = items.length; i < n; ++i) {
      parent = type ? 'mark' : 'group';
      items[i][parent] = scene;
      if (items[i].zindex) items[i][parent].zdirty = true;
      if ('group' === (type || parent)) initialize$1(items[i]);
    }
  }
  if (type) boundMark(scene);
  return scene;
}
class Scenegraph {
  constructor(scene) {
    if (arguments.length) {
      this.root = sceneFromJSON(scene);
    } else {
      this.root = createMark({
        marktype: 'group',
        name: 'root',
        role: 'frame'
      });
      this.root.items = [new GroupItem(this.root)];
    }
  }
  toJSON(indent) {
    return sceneToJSON(this.root, indent || 0);
  }
  mark(markdef, group, index) {
    group = group || this.root.items[0];
    const mark = createMark(markdef, group);
    group.items[index] = mark;
    if (mark.zindex) mark.group.zdirty = true;
    return mark;
  }
}
function createMark(def, group) {
  const mark = {
    bounds: new Bounds(),
    clip: !!def.clip,
    group: group,
    interactive: def.interactive === false ? false : true,
    items: [],
    marktype: def.marktype,
    name: def.name || undefined,
    role: def.role || undefined,
    zindex: def.zindex || 0
  };

  // add accessibility properties if defined
  if (def.aria != null) {
    mark.aria = def.aria;
  }
  if (def.description) {
    mark.description = def.description;
  }
  return mark;
}

// create a new DOM element
function domCreate(doc, tag, ns) {
  if (!doc && typeof document !== 'undefined' && document.createElement) {
    doc = document;
  }
  return doc ? ns ? doc.createElementNS(ns, tag) : doc.createElement(tag) : null;
}

// find first child element with matching tag
function domFind(el, tag) {
  tag = tag.toLowerCase();
  var nodes = el.childNodes,
    i = 0,
    n = nodes.length;
  for (; i < n; ++i) if (nodes[i].tagName.toLowerCase() === tag) {
    return nodes[i];
  }
}

// retrieve child element at given index
// create & insert if doesn't exist or if tags do not match
function domChild(el, index, tag, ns) {
  var a = el.childNodes[index],
    b;
  if (!a || a.tagName.toLowerCase() !== tag.toLowerCase()) {
    b = a || null;
    a = domCreate(el.ownerDocument, tag, ns);
    el.insertBefore(a, b);
  }
  return a;
}

// remove all child elements at or above the given index
function domClear(el, index) {
  var nodes = el.childNodes,
    curr = nodes.length;
  while (curr > index) el.removeChild(nodes[--curr]);
  return el;
}

// generate css class name for mark
function cssClass(mark) {
  return 'mark-' + mark.marktype + (mark.role ? ' role-' + mark.role : '') + (mark.name ? ' ' + mark.name : '');
}
function point(event, el) {
  const rect = el.getBoundingClientRect();
  return [event.clientX - rect.left - (el.clientLeft || 0), event.clientY - rect.top - (el.clientTop || 0)];
}
function resolveItem(item, event, el, origin) {
  var mark = item && item.mark,
    mdef,
    p;
  if (mark && (mdef = Marks[mark.marktype]).tip) {
    p = point(event, el);
    p[0] -= origin[0];
    p[1] -= origin[1];
    while (item = item.mark.group) {
      p[0] -= item.x || 0;
      p[1] -= item.y || 0;
    }
    item = mdef.tip(mark.items, p);
  }
  return item;
}
class Handler {
  /**
   * Create a new Handler instance.
   * @param {object} [customLoader] - Optional loader instance for
   *   href URL sanitization. If not specified, a standard loader
   *   instance will be generated.
   * @param {function} [customTooltip] - Optional tooltip handler
   *   function for custom tooltip display.
   * @constructor
   */
  constructor(customLoader, customTooltip) {
    this._active = null;
    this._handlers = {};
    this._loader = customLoader || loader();
    this._tooltip = customTooltip || defaultTooltip$1;
  }

  /**
   * Initialize a new Handler instance.
   * @param {DOMElement} el - The containing DOM element for the display.
   * @param {Array<number>} origin - The origin of the display, in pixels.
   *   The coordinate system will be translated to this point.
   * @param {object} [obj] - Optional context object that should serve as
   *   the "this" context for event callbacks.
   * @return {Handler} - This handler instance.
   */
  initialize(el, origin, obj) {
    this._el = el;
    this._obj = obj || null;
    return this.origin(origin);
  }

  /**
   * Returns the parent container element for a visualization.
   * @return {DOMElement} - The containing DOM element.
   */
  element() {
    return this._el;
  }

  /**
   * Returns the scene element (e.g., canvas or SVG) of the visualization
   * Subclasses must override if the first child is not the scene element.
   * @return {DOMElement} - The scene (e.g., canvas or SVG) element.
   */
  canvas() {
    return this._el && this._el.firstChild;
  }

  /**
   * Get / set the origin coordinates of the visualization.
   */
  origin(origin) {
    if (arguments.length) {
      this._origin = origin || [0, 0];
      return this;
    } else {
      return this._origin.slice();
    }
  }

  /**
   * Get / set the scenegraph root.
   */
  scene(scene) {
    if (!arguments.length) return this._scene;
    this._scene = scene;
    return this;
  }

  /**
   * Add an event handler. Subclasses should override this method.
   */
  on(/*type, handler*/) {}

  /**
   * Remove an event handler. Subclasses should override this method.
   */
  off(/*type, handler*/) {}

  /**
   * Utility method for finding the array index of an event handler.
   * @param {Array} h - An array of registered event handlers.
   * @param {string} type - The event type.
   * @param {function} handler - The event handler instance to find.
   * @return {number} - The handler's array index or -1 if not registered.
   */
  _handlerIndex(h, type, handler) {
    for (let i = h ? h.length : 0; --i >= 0;) {
      if (h[i].type === type && (!handler || h[i].handler === handler)) {
        return i;
      }
    }
    return -1;
  }

  /**
   * Returns an array with registered event handlers.
   * @param {string} [type] - The event type to query. Any annotations
   *   are ignored; for example, for the argument "click.foo", ".foo" will
   *   be ignored and the method returns all "click" handlers. If type is
   *   null or unspecified, this method returns handlers for all types.
   * @return {Array} - A new array containing all registered event handlers.
   */
  handlers(type) {
    const h = this._handlers,
      a = [];
    if (type) {
      a.push(...h[this.eventName(type)]);
    } else {
      for (const k in h) {
        a.push(...h[k]);
      }
    }
    return a;
  }

  /**
   * Parses an event name string to return the specific event type.
   * For example, given "click.foo" returns "click"
   * @param {string} name - The input event type string.
   * @return {string} - A string with the event type only.
   */
  eventName(name) {
    const i = name.indexOf('.');
    return i < 0 ? name : name.slice(0, i);
  }

  /**
   * Handle hyperlink navigation in response to an item.href value.
   * @param {Event} event - The event triggering hyperlink navigation.
   * @param {Item} item - The scenegraph item.
   * @param {string} href - The URL to navigate to.
   */
  handleHref(event, item, href) {
    this._loader.sanitize(href, {
      context: 'href'
    }).then(opt => {
      const e = new MouseEvent(event.type, event),
        a = domCreate(null, 'a');
      for (const name in opt) a.setAttribute(name, opt[name]);
      a.dispatchEvent(e);
    }).catch(() => {});
  }

  /**
   * Handle tooltip display in response to an item.tooltip value.
   * @param {Event} event - The event triggering tooltip display.
   * @param {Item} item - The scenegraph item.
   * @param {boolean} show - A boolean flag indicating whether
   *   to show or hide a tooltip for the given item.
   */
  handleTooltip(event, item, show) {
    if (item && item.tooltip != null) {
      item = resolveItem(item, event, this.canvas(), this._origin);
      const value = show && item && item.tooltip || null;
      this._tooltip.call(this._obj, this, event, item, value);
    }
  }

  /**
   * Returns the size of a scenegraph item and its position relative
   * to the viewport.
   * @param {Item} item - The scenegraph item.
   * @return {object} - A bounding box object (compatible with the
   *   DOMRect type) consisting of x, y, width, heigh, top, left,
   *   right, and bottom properties.
   */
  getItemBoundingClientRect(item) {
    const el = this.canvas();
    if (!el) return;
    const rect = el.getBoundingClientRect(),
      origin = this._origin,
      bounds = item.bounds,
      width = bounds.width(),
      height = bounds.height();
    let x = bounds.x1 + origin[0] + rect.left,
      y = bounds.y1 + origin[1] + rect.top;

    // translate coordinate for each parent group
    while (item.mark && (item = item.mark.group)) {
      x += item.x || 0;
      y += item.y || 0;
    }

    // return DOMRect-compatible bounding box
    return {
      x,
      y,
      width,
      height,
      left: x,
      top: y,
      right: x + width,
      bottom: y + height
    };
  }
}

// The default tooltip display handler.
// Sets the HTML title attribute on the visualization container.
function defaultTooltip$1(handler, event, item, value) {
  handler.element().setAttribute('title', value || '');
}
class Renderer {
  /**
   * Create a new Renderer instance.
   * @param {object} [loader] - Optional loader instance for
   *   image and href URL sanitization. If not specified, a
   *   standard loader instance will be generated.
   * @constructor
   */
  constructor(loader) {
    this._el = null;
    this._bgcolor = null;
    this._loader = new ResourceLoader(loader);
  }

  /**
   * Initialize a new Renderer instance.
   * @param {DOMElement} el - The containing DOM element for the display.
   * @param {number} width - The coordinate width of the display, in pixels.
   * @param {number} height - The coordinate height of the display, in pixels.
   * @param {Array<number>} origin - The origin of the display, in pixels.
   *   The coordinate system will be translated to this point.
   * @param {number} [scaleFactor=1] - Optional scaleFactor by which to multiply
   *   the width and height to determine the final pixel size.
   * @return {Renderer} - This renderer instance.
   */
  initialize(el, width, height, origin, scaleFactor) {
    this._el = el;
    return this.resize(width, height, origin, scaleFactor);
  }

  /**
   * Returns the parent container element for a visualization.
   * @return {DOMElement} - The containing DOM element.
   */
  element() {
    return this._el;
  }

  /**
   * Returns the scene element (e.g., canvas or SVG) of the visualization
   * Subclasses must override if the first child is not the scene element.
   * @return {DOMElement} - The scene (e.g., canvas or SVG) element.
   */
  canvas() {
    return this._el && this._el.firstChild;
  }

  /**
   * Get / set the background color.
   */
  background(bgcolor) {
    if (arguments.length === 0) return this._bgcolor;
    this._bgcolor = bgcolor;
    return this;
  }

  /**
   * Resize the display.
   * @param {number} width - The new coordinate width of the display, in pixels.
   * @param {number} height - The new coordinate height of the display, in pixels.
   * @param {Array<number>} origin - The new origin of the display, in pixels.
   *   The coordinate system will be translated to this point.
   * @param {number} [scaleFactor=1] - Optional scaleFactor by which to multiply
   *   the width and height to determine the final pixel size.
   * @return {Renderer} - This renderer instance;
   */
  resize(width, height, origin, scaleFactor) {
    this._width = width;
    this._height = height;
    this._origin = origin || [0, 0];
    this._scale = scaleFactor || 1;
    return this;
  }

  /**
   * Report a dirty item whose bounds should be redrawn.
   * This base class method does nothing. Subclasses that perform
   * incremental should implement this method.
   * @param {Item} item - The dirty item whose bounds should be redrawn.
   */
  dirty(/*item*/) {}

  /**
   * Render an input scenegraph, potentially with a set of dirty items.
   * This method will perform an immediate rendering with available resources.
   * The renderer may also need to perform image loading to perform a complete
   * render. This process can lead to asynchronous re-rendering of the scene
   * after this method returns. To receive notification when rendering is
   * complete, use the renderAsync method instead.
   * @param {object} scene - The root mark of a scenegraph to render.
   * @param {Array} markTypes - Array of the mark types to render.
   *                            If undefined, render all mark types
   * @return {Renderer} - This renderer instance.
   */
  render(scene, markTypes) {
    const r = this;

    // bind arguments into a render call, and cache it
    // this function may be subsequently called for async redraw
    r._call = function () {
      r._render(scene, markTypes);
    };

    // invoke the renderer
    r._call();

    // clear the cached call for garbage collection
    // async redraws will stash their own copy
    r._call = null;
    return r;
  }

  /**
   * Internal rendering method. Renderer subclasses should override this
   * method to actually perform rendering.
   * @param {object} scene - The root mark of a scenegraph to render.
   * @param {Array} markTypes - Array of the mark types to render.
   *                            If undefined, render all mark types
   */
  _render(/*scene, markTypes*/
  ) {
    // subclasses to override
  }

  /**
   * Asynchronous rendering method. Similar to render, but returns a Promise
   * that resolves when all rendering is completed. Sometimes a renderer must
   * perform image loading to get a complete rendering. The returned
   * Promise will not resolve until this process completes.
   * @param {object} scene - The root mark of a scenegraph to render.
   * @param {Array} markTypes - Array of the mark types to render.
   *                            If undefined, render all mark types
   * @return {Promise} - A Promise that resolves when rendering is complete.
   */
  renderAsync(scene, markTypes) {
    const r = this.render(scene, markTypes);
    return this._ready ? this._ready.then(() => r) : Promise.resolve(r);
  }

  /**
   * Internal method for asynchronous resource loading.
   * Proxies method calls to the ImageLoader, and tracks loading
   * progress to invoke a re-render once complete.
   * @param {string} method - The method name to invoke on the ImageLoader.
   * @param {string} uri - The URI for the requested resource.
   * @return {Promise} - A Promise that resolves to the requested resource.
   */
  _load(method, uri) {
    var r = this,
      p = r._loader[method](uri);
    if (!r._ready) {
      // re-render the scene when loading completes
      const call = r._call;
      r._ready = r._loader.ready().then(redraw => {
        if (redraw) call();
        r._ready = null;
      });
    }
    return p;
  }

  /**
   * Sanitize a URL to include as a hyperlink in the rendered scene.
   * This method proxies a call to ImageLoader.sanitizeURL, but also tracks
   * image loading progress and invokes a re-render once complete.
   * @param {string} uri - The URI string to sanitize.
   * @return {Promise} - A Promise that resolves to the sanitized URL.
   */
  sanitizeURL(uri) {
    return this._load('sanitizeURL', uri);
  }

  /**
   * Requests an image to include in the rendered scene.
   * This method proxies a call to ImageLoader.loadImage, but also tracks
   * image loading progress and invokes a re-render once complete.
   * @param {string} uri - The URI string of the image.
   * @return {Promise} - A Promise that resolves to the loaded Image.
   */
  loadImage(uri) {
    return this._load('loadImage', uri);
  }
}
const KeyDownEvent = 'keydown';
const KeyPressEvent = 'keypress';
const KeyUpEvent = 'keyup';
const DragEnterEvent = 'dragenter';
const DragLeaveEvent = 'dragleave';
const DragOverEvent = 'dragover';
const PointerDownEvent = 'pointerdown';
const PointerUpEvent = 'pointerup';
const PointerMoveEvent = 'pointermove';
const PointerOutEvent = 'pointerout';
const PointerOverEvent = 'pointerover';
const MouseDownEvent = 'mousedown';
const MouseUpEvent = 'mouseup';
const MouseMoveEvent = 'mousemove';
const MouseOutEvent = 'mouseout';
const MouseOverEvent = 'mouseover';
const ClickEvent = 'click';
const DoubleClickEvent = 'dblclick';
const WheelEvent = 'wheel';
const MouseWheelEvent = 'mousewheel';
const TouchStartEvent = 'touchstart';
const TouchMoveEvent = 'touchmove';
const TouchEndEvent = 'touchend';
const Events = [KeyDownEvent, KeyPressEvent, KeyUpEvent, DragEnterEvent, DragLeaveEvent, DragOverEvent, PointerDownEvent, PointerUpEvent, PointerMoveEvent, PointerOutEvent, PointerOverEvent, MouseDownEvent, MouseUpEvent, MouseMoveEvent, MouseOutEvent, MouseOverEvent, ClickEvent, DoubleClickEvent, WheelEvent, MouseWheelEvent, TouchStartEvent, TouchMoveEvent, TouchEndEvent];
const TooltipShowEvent = PointerMoveEvent;
const TooltipHideEvent = MouseOutEvent;
const HrefEvent = ClickEvent;
class CanvasHandler extends Handler {
  constructor(loader, tooltip) {
    super(loader, tooltip);
    this._down = null;
    this._touch = null;
    this._first = true;
    this._events = {};

    // supported events
    this.events = Events;
    this.pointermove = move([PointerMoveEvent, MouseMoveEvent], [PointerOverEvent, MouseOverEvent], [PointerOutEvent, MouseOutEvent]);
    this.dragover = move([DragOverEvent], [DragEnterEvent], [DragLeaveEvent]), this.pointerout = inactive([PointerOutEvent, MouseOutEvent]);
    this.dragleave = inactive([DragLeaveEvent]);
  }
  initialize(el, origin, obj) {
    this._canvas = el && domFind(el, 'canvas');

    // add minimal events required for proper state management
    [ClickEvent, MouseDownEvent, PointerDownEvent, PointerMoveEvent, PointerOutEvent, DragLeaveEvent].forEach(type => eventListenerCheck(this, type));
    return super.initialize(el, origin, obj);
  }

  // return the backing canvas instance
  canvas() {
    return this._canvas;
  }

  // retrieve the current canvas context
  context() {
    return this._canvas.getContext('2d');
  }

  // to keep old versions of firefox happy
  DOMMouseScroll(evt) {
    this.fire(MouseWheelEvent, evt);
  }
  pointerdown(evt) {
    this._down = this._active;
    this.fire(PointerDownEvent, evt);
  }
  mousedown(evt) {
    this._down = this._active;
    this.fire(MouseDownEvent, evt);
  }
  click(evt) {
    if (this._down === this._active) {
      this.fire(ClickEvent, evt);
      this._down = null;
    }
  }
  touchstart(evt) {
    this._touch = this.pickEvent(evt.changedTouches[0]);
    if (this._first) {
      this._active = this._touch;
      this._first = false;
    }
    this.fire(TouchStartEvent, evt, true);
  }
  touchmove(evt) {
    this.fire(TouchMoveEvent, evt, true);
  }
  touchend(evt) {
    this.fire(TouchEndEvent, evt, true);
    this._touch = null;
  }

  // fire an event
  fire(type, evt, touch) {
    const a = touch ? this._touch : this._active,
      h = this._handlers[type];

    // set event type relative to scenegraph items
    evt.vegaType = type;

    // handle hyperlinks and tooltips first
    if (type === HrefEvent && a && a.href) {
      this.handleHref(evt, a, a.href);
    } else if (type === TooltipShowEvent || type === TooltipHideEvent) {
      this.handleTooltip(evt, a, type !== TooltipHideEvent);
    }

    // invoke all registered handlers
    if (h) {
      for (let i = 0, len = h.length; i < len; ++i) {
        h[i].handler.call(this._obj, evt, a);
      }
    }
  }

  // add an event handler
  on(type, handler) {
    const name = this.eventName(type),
      h = this._handlers,
      i = this._handlerIndex(h[name], type, handler);
    if (i < 0) {
      eventListenerCheck(this, type);
      (h[name] || (h[name] = [])).push({
        type: type,
        handler: handler
      });
    }
    return this;
  }

  // remove an event handler
  off(type, handler) {
    const name = this.eventName(type),
      h = this._handlers[name],
      i = this._handlerIndex(h, type, handler);
    if (i >= 0) {
      h.splice(i, 1);
    }
    return this;
  }
  pickEvent(evt) {
    const p = point(evt, this._canvas),
      o = this._origin;
    return this.pick(this._scene, p[0], p[1], p[0] - o[0], p[1] - o[1]);
  }

  // find the scenegraph item at the current pointer position
  // x, y -- the absolute x, y pointer coordinates on the canvas element
  // gx, gy -- the relative coordinates within the current group
  pick(scene, x, y, gx, gy) {
    const g = this.context(),
      mark = Marks[scene.marktype];
    return mark.pick.call(this, g, scene, x, y, gx, gy);
  }
}
const eventBundle = type => type === TouchStartEvent || type === TouchMoveEvent || type === TouchEndEvent ? [TouchStartEvent, TouchMoveEvent, TouchEndEvent] : [type];

// lazily add listeners to the canvas as needed
function eventListenerCheck(handler, type) {
  eventBundle(type).forEach(_ => addEventListener(handler, _));
}
function addEventListener(handler, type) {
  const canvas = handler.canvas();
  if (canvas && !handler._events[type]) {
    handler._events[type] = 1;
    canvas.addEventListener(type, handler[type] ? evt => handler[type](evt) : evt => handler.fire(type, evt));
  }
}
function fireAll(handler, types, event) {
  types.forEach(type => handler.fire(type, event));
}
function move(moveEvents, overEvents, outEvents) {
  return function (evt) {
    const a = this._active,
      p = this.pickEvent(evt);
    if (p === a) {
      // active item and picked item are the same
      fireAll(this, moveEvents, evt); // fire move
    } else {
      // active item and picked item are different
      if (!a || !a.exit) {
        // fire out for prior active item
        // suppress if active item was removed from scene
        fireAll(this, outEvents, evt);
      }
      this._active = p; // set new active item
      fireAll(this, overEvents, evt); // fire over for new active item
      fireAll(this, moveEvents, evt); // fire move for new active item
    }
  };
}
function inactive(types) {
  return function (evt) {
    fireAll(this, types, evt);
    this._active = null;
  };
}
function devicePixelRatio() {
  return typeof window !== 'undefined' ? window.devicePixelRatio || 1 : 1;
}
function resize(canvas, width, height, origin, scaleFactor, opt) {
  const inDOM = typeof HTMLElement !== 'undefined' && canvas instanceof HTMLElement && canvas.parentNode != null,
    context = canvas.getContext('2d'),
    ratio = inDOM ? devicePixelRatio() : scaleFactor;
  canvas.width = width * ratio;
  canvas.height = height * ratio;
  for (const key in opt) {
    context[key] = opt[key];
  }
  if (inDOM && ratio !== 1) {
    canvas.style.width = width + 'px';
    canvas.style.height = height + 'px';
  }
  context.pixelRatio = ratio;
  context.setTransform(ratio, 0, 0, ratio, ratio * origin[0], ratio * origin[1]);
  return canvas;
}
class CanvasRenderer extends Renderer {
  constructor(loader) {
    super(loader);
    this._options = {};
    this._redraw = false;
    this._dirty = new Bounds();
    this._tempb = new Bounds();
  }
  initialize(el, width, height, origin, scaleFactor, options) {
    this._options = options || {};
    this._canvas = this._options.externalContext ? null : domCanvas(1, 1, this._options.type); // instantiate a small canvas

    if (el && this._canvas) {
      domClear(el, 0).appendChild(this._canvas);
      this._canvas.setAttribute('class', 'marks');
    }

    // this method will invoke resize to size the canvas appropriately
    return super.initialize(el, width, height, origin, scaleFactor);
  }
  resize(width, height, origin, scaleFactor) {
    super.resize(width, height, origin, scaleFactor);
    if (this._canvas) {
      // configure canvas size and transform
      resize(this._canvas, this._width, this._height, this._origin, this._scale, this._options.context);
    } else {
      // external context needs to be scaled and positioned to origin
      const ctx = this._options.externalContext;
      if (!ctx) error('CanvasRenderer is missing a valid canvas or context');
      ctx.scale(this._scale, this._scale);
      ctx.translate(this._origin[0], this._origin[1]);
    }
    this._redraw = true;
    return this;
  }
  canvas() {
    return this._canvas;
  }
  context() {
    return this._options.externalContext || (this._canvas ? this._canvas.getContext('2d') : null);
  }
  dirty(item) {
    const b = this._tempb.clear().union(item.bounds);
    let g = item.mark.group;
    while (g) {
      b.translate(g.x || 0, g.y || 0);
      g = g.mark.group;
    }
    this._dirty.union(b);
  }
  _render(scene, markTypes) {
    const g = this.context(),
      o = this._origin,
      w = this._width,
      h = this._height,
      db = this._dirty,
      vb = viewBounds(o, w, h);

    // setup
    g.save();
    const b = this._redraw || db.empty() ? (this._redraw = false, vb.expand(1)) : clipToBounds(g, vb.intersect(db), o);
    this.clear(-o[0], -o[1], w, h);

    // render
    this.draw(g, scene, b, markTypes);

    // takedown
    g.restore();
    db.clear();
    return this;
  }
  draw(ctx, scene, bounds, markTypes) {
    if (scene.marktype !== 'group' && markTypes != null && !markTypes.includes(scene.marktype)) {
      return;
    }
    const mark = Marks[scene.marktype];
    if (scene.clip) clip$2(ctx, scene);
    mark.draw.call(this, ctx, scene, bounds, markTypes);
    if (scene.clip) ctx.restore();
  }
  clear(x, y, w, h) {
    const opt = this._options,
      g = this.context();
    if (opt.type !== 'pdf' && !opt.externalContext) {
      // calling clear rect voids vector output in pdf mode
      // and could remove external context content (#2615)
      g.clearRect(x, y, w, h);
    }
    if (this._bgcolor != null) {
      g.fillStyle = this._bgcolor;
      g.fillRect(x, y, w, h);
    }
  }
}
const viewBounds = (origin, width, height) => new Bounds().set(0, 0, width, height).translate(-origin[0], -origin[1]);
function clipToBounds(g, b, origin) {
  // expand bounds by 1 pixel, then round to pixel boundaries
  b.expand(1).round();

  // align to base pixel grid in case of non-integer scaling (#2425)
  if (g.pixelRatio % 1) {
    b.scale(g.pixelRatio).round().scale(1 / g.pixelRatio);
  }

  // to avoid artifacts translate if origin has fractional pixels
  b.translate(-(origin[0] % 1), -(origin[1] % 1));

  // set clip path
  g.beginPath();
  g.rect(b.x1, b.y1, b.width(), b.height());
  g.clip();
  return b;
}
class SVGHandler extends Handler {
  constructor(loader, tooltip) {
    super(loader, tooltip);
    const h = this;
    h._hrefHandler = listener(h, (evt, item) => {
      if (item && item.href) h.handleHref(evt, item, item.href);
    });
    h._tooltipHandler = listener(h, (evt, item) => {
      h.handleTooltip(evt, item, evt.type !== TooltipHideEvent);
    });
  }
  initialize(el, origin, obj) {
    let svg = this._svg;
    if (svg) {
      svg.removeEventListener(HrefEvent, this._hrefHandler);
      svg.removeEventListener(TooltipShowEvent, this._tooltipHandler);
      svg.removeEventListener(TooltipHideEvent, this._tooltipHandler);
    }
    this._svg = svg = el && domFind(el, 'svg');
    if (svg) {
      svg.addEventListener(HrefEvent, this._hrefHandler);
      svg.addEventListener(TooltipShowEvent, this._tooltipHandler);
      svg.addEventListener(TooltipHideEvent, this._tooltipHandler);
    }
    return super.initialize(el, origin, obj);
  }
  canvas() {
    return this._svg;
  }

  // add an event handler
  on(type, handler) {
    const name = this.eventName(type),
      h = this._handlers,
      i = this._handlerIndex(h[name], type, handler);
    if (i < 0) {
      const x = {
        type,
        handler,
        listener: listener(this, handler)
      };
      (h[name] || (h[name] = [])).push(x);
      if (this._svg) {
        this._svg.addEventListener(name, x.listener);
      }
    }
    return this;
  }

  // remove an event handler
  off(type, handler) {
    const name = this.eventName(type),
      h = this._handlers[name],
      i = this._handlerIndex(h, type, handler);
    if (i >= 0) {
      if (this._svg) {
        this._svg.removeEventListener(name, h[i].listener);
      }
      h.splice(i, 1);
    }
    return this;
  }
}

// wrap an event listener for the SVG DOM
const listener = (context, handler) => evt => {
  let item = evt.target.__data__;
  item = Array.isArray(item) ? item[0] : item;
  evt.vegaType = evt.type;
  handler.call(context._obj, evt, item);
};
const ARIA_HIDDEN = 'aria-hidden';
const ARIA_LABEL = 'aria-label';
const ARIA_ROLE = 'role';
const ARIA_ROLEDESCRIPTION = 'aria-roledescription';
const GRAPHICS_OBJECT = 'graphics-object';
const GRAPHICS_SYMBOL = 'graphics-symbol';
const bundle = (role, roledesc, label) => ({
  [ARIA_ROLE]: role,
  [ARIA_ROLEDESCRIPTION]: roledesc,
  [ARIA_LABEL]: label || undefined
});

// these roles are covered by related roles
// we can ignore them, no need to generate attributes
const AriaIgnore = toSet(['axis-domain', 'axis-grid', 'axis-label', 'axis-tick', 'axis-title', 'legend-band', 'legend-entry', 'legend-gradient', 'legend-label', 'legend-title', 'legend-symbol', 'title']);

// aria attribute generators for guide roles
const AriaGuides = {
  'axis': {
    desc: 'axis',
    caption: axisCaption
  },
  'legend': {
    desc: 'legend',
    caption: legendCaption
  },
  'title-text': {
    desc: 'title',
    caption: item => `Title text '${titleCaption(item)}'`
  },
  'title-subtitle': {
    desc: 'subtitle',
    caption: item => `Subtitle text '${titleCaption(item)}'`
  }
};

// aria properties generated for mark item encoding channels
const AriaEncode = {
  ariaRole: ARIA_ROLE,
  ariaRoleDescription: ARIA_ROLEDESCRIPTION,
  description: ARIA_LABEL
};
function ariaItemAttributes(emit, item) {
  const hide = item.aria === false;
  emit(ARIA_HIDDEN, hide || undefined);
  if (hide || item.description == null) {
    for (const prop in AriaEncode) {
      emit(AriaEncode[prop], undefined);
    }
  } else {
    const type = item.mark.marktype;
    emit(ARIA_LABEL, item.description);
    emit(ARIA_ROLE, item.ariaRole || (type === 'group' ? GRAPHICS_OBJECT : GRAPHICS_SYMBOL));
    emit(ARIA_ROLEDESCRIPTION, item.ariaRoleDescription || `${type} mark`);
  }
}
function ariaMarkAttributes(mark) {
  return mark.aria === false ? {
    [ARIA_HIDDEN]: true
  } : AriaIgnore[mark.role] ? null : AriaGuides[mark.role] ? ariaGuide(mark, AriaGuides[mark.role]) : ariaMark(mark);
}
function ariaMark(mark) {
  const type = mark.marktype;
  const recurse = type === 'group' || type === 'text' || mark.items.some(_ => _.description != null && _.aria !== false);
  return bundle(recurse ? GRAPHICS_OBJECT : GRAPHICS_SYMBOL, `${type} mark container`, mark.description);
}
function ariaGuide(mark, opt) {
  try {
    const item = mark.items[0],
      caption = opt.caption || (() => '');
    return bundle(opt.role || GRAPHICS_SYMBOL, opt.desc, item.description || caption(item));
  } catch (err) {
    return null;
  }
}
function titleCaption(item) {
  return array$5(item.text).join(' ');
}
function axisCaption(item) {
  const datum = item.datum,
    orient = item.orient,
    title = datum.title ? extractTitle(item) : null,
    ctx = item.context,
    scale = ctx.scales[datum.scale].value,
    locale = ctx.dataflow.locale(),
    type = scale.type,
    xy = orient === 'left' || orient === 'right' ? 'Y' : 'X';
  return `${xy}-axis` + (title ? ` titled '${title}'` : '') + ` for a ${isDiscrete(type) ? 'discrete' : type} scale` + ` with ${domainCaption(locale, scale, item)}`;
}
function legendCaption(item) {
  const datum = item.datum,
    title = datum.title ? extractTitle(item) : null,
    type = `${datum.type || ''} legend`.trim(),
    scales = datum.scales,
    props = Object.keys(scales),
    ctx = item.context,
    scale = ctx.scales[scales[props[0]]].value,
    locale = ctx.dataflow.locale();
  return capitalize(type) + (title ? ` titled '${title}'` : '') + ` for ${channelCaption(props)}` + ` with ${domainCaption(locale, scale, item)}`;
}
function extractTitle(item) {
  try {
    return array$5(peek$1(item.items).items[0].text).join(' ');
  } catch (err) {
    return null;
  }
}
function channelCaption(props) {
  props = props.map(p => p + (p === 'fill' || p === 'stroke' ? ' color' : ''));
  return props.length < 2 ? props[0] : props.slice(0, -1).join(', ') + ' and ' + peek$1(props);
}
function capitalize(s) {
  return s.length ? s[0].toUpperCase() + s.slice(1) : s;
}
const innerText = val => (val + '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
const attrText = val => innerText(val).replace(/"/g, '&quot;').replace(/\t/g, '&#x9;').replace(/\n/g, '&#xA;').replace(/\r/g, '&#xD;');
function markup() {
  let buf = '',
    outer = '',
    inner = '';
  const stack = [],
    clear = () => outer = inner = '',
    push = tag => {
      if (outer) {
        buf += `${outer}>${inner}`;
        clear();
      }
      stack.push(tag);
    },
    attr = (name, value) => {
      if (value != null) outer += ` ${name}="${attrText(value)}"`;
      return m;
    },
    m = {
      open(tag) {
        push(tag);
        outer = '<' + tag;
        for (var _len = arguments.length, attrs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          attrs[_key - 1] = arguments[_key];
        }
        for (const set of attrs) {
          for (const key in set) attr(key, set[key]);
        }
        return m;
      },
      close() {
        const tag = stack.pop();
        if (outer) {
          buf += outer + (inner ? `>${inner}</${tag}>` : '/>');
        } else {
          buf += `</${tag}>`;
        }
        clear();
        return m;
      },
      attr,
      text: t => (inner += innerText(t), m),
      toString: () => buf
    };
  return m;
}
const serializeXML = node => _serialize(markup(), node) + '';
function _serialize(m, node) {
  m.open(node.tagName);
  if (node.hasAttributes()) {
    const attrs = node.attributes,
      n = attrs.length;
    for (let i = 0; i < n; ++i) {
      m.attr(attrs[i].name, attrs[i].value);
    }
  }
  if (node.hasChildNodes()) {
    const children = node.childNodes;
    for (const child of children) {
      child.nodeType === 3 // text node
      ? m.text(child.nodeValue) : _serialize(m, child);
    }
  }
  return m.close();
}
const stylesAttr = {
  fill: 'fill',
  fillOpacity: 'fill-opacity',
  stroke: 'stroke',
  strokeOpacity: 'stroke-opacity',
  strokeWidth: 'stroke-width',
  strokeCap: 'stroke-linecap',
  strokeJoin: 'stroke-linejoin',
  strokeDash: 'stroke-dasharray',
  strokeDashOffset: 'stroke-dashoffset',
  strokeMiterLimit: 'stroke-miterlimit',
  opacity: 'opacity'
};
const stylesCss = {
  blend: 'mix-blend-mode'
};

// ensure miter limit default is consistent with canvas (#2498)
const rootAttributes = {
  'fill': 'none',
  'stroke-miterlimit': 10
};
const RootIndex = 0,
  xmlns = 'http://www.w3.org/2000/xmlns/',
  svgns = metadata.xmlns;
class SVGRenderer extends Renderer {
  constructor(loader) {
    super(loader);
    this._dirtyID = 0;
    this._dirty = [];
    this._svg = null;
    this._root = null;
    this._defs = null;
  }

  /**
   * Initialize a new SVGRenderer instance.
   * @param {DOMElement} el - The containing DOM element for the display.
   * @param {number} width - The coordinate width of the display, in pixels.
   * @param {number} height - The coordinate height of the display, in pixels.
   * @param {Array<number>} origin - The origin of the display, in pixels.
   *   The coordinate system will be translated to this point.
   * @param {number} [scaleFactor=1] - Optional scaleFactor by which to multiply
   *   the width and height to determine the final pixel size.
   * @return {SVGRenderer} - This renderer instance.
   */
  initialize(el, width, height, origin, scaleFactor) {
    // create the svg definitions cache
    this._defs = {};
    this._clearDefs();
    if (el) {
      this._svg = domChild(el, 0, 'svg', svgns);
      this._svg.setAttributeNS(xmlns, 'xmlns', svgns);
      this._svg.setAttributeNS(xmlns, 'xmlns:xlink', metadata['xmlns:xlink']);
      this._svg.setAttribute('version', metadata['version']);
      this._svg.setAttribute('class', 'marks');
      domClear(el, 1);

      // set the svg root group
      this._root = domChild(this._svg, RootIndex, 'g', svgns);
      setAttributes(this._root, rootAttributes);

      // ensure no additional child elements
      domClear(this._svg, RootIndex + 1);
    }

    // set background color if defined
    this.background(this._bgcolor);
    return super.initialize(el, width, height, origin, scaleFactor);
  }

  /**
   * Get / set the background color.
   */
  background(bgcolor) {
    if (arguments.length && this._svg) {
      this._svg.style.setProperty('background-color', bgcolor);
    }
    return super.background(...arguments);
  }

  /**
   * Resize the display.
   * @param {number} width - The new coordinate width of the display, in pixels.
   * @param {number} height - The new coordinate height of the display, in pixels.
   * @param {Array<number>} origin - The new origin of the display, in pixels.
   *   The coordinate system will be translated to this point.
   * @param {number} [scaleFactor=1] - Optional scaleFactor by which to multiply
   *   the width and height to determine the final pixel size.
   * @return {SVGRenderer} - This renderer instance;
   */
  resize(width, height, origin, scaleFactor) {
    super.resize(width, height, origin, scaleFactor);
    if (this._svg) {
      setAttributes(this._svg, {
        width: this._width * this._scale,
        height: this._height * this._scale,
        viewBox: `0 0 ${this._width} ${this._height}`
      });
      this._root.setAttribute('transform', `translate(${this._origin})`);
    }
    this._dirty = [];
    return this;
  }

  /**
   * Returns the SVG element of the visualization.
   * @return {DOMElement} - The SVG element.
   */
  canvas() {
    return this._svg;
  }

  /**
   * Returns an SVG text string for the rendered content,
   * or null if this renderer is currently headless.
   */
  svg() {
    const svg = this._svg,
      bg = this._bgcolor;
    if (!svg) return null;
    let node;
    if (bg) {
      svg.removeAttribute('style');
      node = domChild(svg, RootIndex, 'rect', svgns);
      setAttributes(node, {
        width: this._width,
        height: this._height,
        fill: bg
      });
    }
    const text = serializeXML(svg);
    if (bg) {
      svg.removeChild(node);
      this._svg.style.setProperty('background-color', bg);
    }
    return text;
  }

  /**
   * Internal rendering method.
   * @param {object} scene - The root mark of a scenegraph to render.
   * @param {Array} markTypes - Array of the mark types to render.
   *                            If undefined, render all mark types
   */
  _render(scene, markTypes) {
    // perform spot updates and re-render markup
    if (this._dirtyCheck()) {
      if (this._dirtyAll) this._clearDefs();
      this.mark(this._root, scene, undefined, markTypes);
      domClear(this._root, 1);
    }
    this.defs();
    this._dirty = [];
    ++this._dirtyID;
    return this;
  }

  // -- Manage rendering of items marked as dirty --

  /**
   * Flag a mark item as dirty.
   * @param {Item} item - The mark item.
   */
  dirty(item) {
    if (item.dirty !== this._dirtyID) {
      item.dirty = this._dirtyID;
      this._dirty.push(item);
    }
  }

  /**
   * Check if a mark item is considered dirty.
   * @param {Item} item - The mark item.
   */
  isDirty(item) {
    return this._dirtyAll || !item._svg || !item._svg.ownerSVGElement || item.dirty === this._dirtyID;
  }

  /**
   * Internal method to check dirty status and, if possible,
   * make targetted updates without a full rendering pass.
   */
  _dirtyCheck() {
    this._dirtyAll = true;
    const items = this._dirty;
    if (!items.length || !this._dirtyID) return true;
    const id = ++this._dirtyID;
    let item, mark, type, mdef, i, n, o;
    for (i = 0, n = items.length; i < n; ++i) {
      item = items[i];
      mark = item.mark;
      if (mark.marktype !== type) {
        // memoize mark instance lookup
        type = mark.marktype;
        mdef = Marks[type];
      }
      if (mark.zdirty && mark.dirty !== id) {
        this._dirtyAll = false;
        dirtyParents(item, id);
        mark.items.forEach(i => {
          i.dirty = id;
        });
      }
      if (mark.zdirty) continue; // handle in standard drawing pass

      if (item.exit) {
        // EXIT
        if (mdef.nested && mark.items.length) {
          // if nested mark with remaining points, update instead
          o = mark.items[0];
          if (o._svg) this._update(mdef, o._svg, o);
        } else if (item._svg) {
          // otherwise remove from DOM
          o = item._svg.parentNode;
          if (o) o.removeChild(item._svg);
        }
        item._svg = null;
        continue;
      }
      item = mdef.nested ? mark.items[0] : item;
      if (item._update === id) continue; // already visited

      if (!item._svg || !item._svg.ownerSVGElement) {
        // ENTER
        this._dirtyAll = false;
        dirtyParents(item, id);
      } else {
        // IN-PLACE UPDATE
        this._update(mdef, item._svg, item);
      }
      item._update = id;
    }
    return !this._dirtyAll;
  }

  // -- Construct & maintain scenegraph to SVG mapping ---

  /**
   * Render a set of mark items.
   * @param {SVGElement} el - The parent element in the SVG tree.
   * @param {object} scene - The mark parent to render.
   * @param {SVGElement} prev - The previous sibling in the SVG tree.
   * @param {Array} markTypes - Array of the mark types to render.
   *                            If undefined, render all mark types
   */
  mark(el, scene, prev, markTypes) {
    if (!this.isDirty(scene)) {
      return scene._svg;
    }
    const svg = this._svg,
      markType = scene.marktype,
      mdef = Marks[markType],
      events = scene.interactive === false ? 'none' : null,
      isGroup = mdef.tag === 'g';
    const parent = bind$1(scene, el, prev, 'g', svg);
    if (markType !== 'group' && markTypes != null && !markTypes.includes(markType)) {
      domClear(parent, 0);
      return scene._svg;
    }
    parent.setAttribute('class', cssClass(scene));

    // apply aria attributes to parent container element
    const aria = ariaMarkAttributes(scene);
    for (const key in aria) setAttribute(parent, key, aria[key]);
    if (!isGroup) {
      setAttribute(parent, 'pointer-events', events);
    }
    setAttribute(parent, 'clip-path', scene.clip ? clip$1$1(this, scene, scene.group) : null);
    let sibling = null,
      i = 0;
    const process = item => {
      const dirty = this.isDirty(item),
        node = bind$1(item, parent, sibling, mdef.tag, svg);
      if (dirty) {
        this._update(mdef, node, item);
        if (isGroup) recurse(this, node, item, markTypes);
      }
      sibling = node;
      ++i;
    };
    if (mdef.nested) {
      if (scene.items.length) process(scene.items[0]);
    } else {
      visit(scene, process);
    }
    domClear(parent, i);
    return parent;
  }

  /**
   * Update the attributes of an SVG element for a mark item.
   * @param {object} mdef - The mark definition object
   * @param {SVGElement} el - The SVG element.
   * @param {Item} item - The mark item.
   */
  _update(mdef, el, item) {
    // set dom element and values cache
    // provides access to emit method
    element$1 = el;
    values = el.__values__;

    // apply aria-specific properties
    ariaItemAttributes(emit, item);

    // apply svg attributes
    mdef.attr(emit, item, this);

    // some marks need special treatment
    const extra = mark_extras[mdef.type];
    if (extra) extra.call(this, mdef, el, item);

    // apply svg style attributes
    // note: element state may have been modified by 'extra' method
    if (element$1) this.style(element$1, item);
  }

  /**
   * Update the presentation attributes of an SVG element for a mark item.
   * @param {SVGElement} el - The SVG element.
   * @param {Item} item - The mark item.
   */
  style(el, item) {
    if (item == null) return;
    for (const prop in stylesAttr) {
      let value = prop === 'font' ? fontFamily(item) : item[prop];
      if (value === values[prop]) continue;
      const name = stylesAttr[prop];
      if (value == null) {
        el.removeAttribute(name);
      } else {
        if (isGradient(value)) {
          value = gradientRef(value, this._defs.gradient, href());
        }
        el.setAttribute(name, value + '');
      }
      values[prop] = value;
    }
    for (const prop in stylesCss) {
      setStyle(el, stylesCss[prop], item[prop]);
    }
  }

  /**
   * Render SVG defs, as needed.
   * Must be called *after* marks have been processed to ensure the
   * collected state is current and accurate.
   */
  defs() {
    const svg = this._svg,
      defs = this._defs;
    let el = defs.el,
      index = 0;
    for (const id in defs.gradient) {
      if (!el) defs.el = el = domChild(svg, RootIndex + 1, 'defs', svgns);
      index = updateGradient(el, defs.gradient[id], index);
    }
    for (const id in defs.clipping) {
      if (!el) defs.el = el = domChild(svg, RootIndex + 1, 'defs', svgns);
      index = updateClipping(el, defs.clipping[id], index);
    }

    // clean-up
    if (el) {
      index === 0 ? (svg.removeChild(el), defs.el = null) : domClear(el, index);
    }
  }

  /**
   * Clear defs caches.
   */
  _clearDefs() {
    const def = this._defs;
    def.gradient = {};
    def.clipping = {};
  }
}

// mark ancestor chain with a dirty id
function dirtyParents(item, id) {
  for (; item && item.dirty !== id; item = item.mark.group) {
    item.dirty = id;
    if (item.mark && item.mark.dirty !== id) {
      item.mark.dirty = id;
    } else return;
  }
}

// update gradient definitions
function updateGradient(el, grad, index) {
  let i, n, stop;
  if (grad.gradient === 'radial') {
    // SVG radial gradients automatically transform to normalized bbox
    // coordinates, in a way that is cumbersome to replicate in canvas.
    // We wrap the radial gradient in a pattern element, allowing us to
    // maintain a circular gradient that matches what canvas provides.
    let pt = domChild(el, index++, 'pattern', svgns);
    setAttributes(pt, {
      id: patternPrefix + grad.id,
      viewBox: '0,0,1,1',
      width: '100%',
      height: '100%',
      preserveAspectRatio: 'xMidYMid slice'
    });
    pt = domChild(pt, 0, 'rect', svgns);
    setAttributes(pt, {
      width: 1,
      height: 1,
      fill: `url(${href()}#${grad.id})`
    });
    el = domChild(el, index++, 'radialGradient', svgns);
    setAttributes(el, {
      id: grad.id,
      fx: grad.x1,
      fy: grad.y1,
      fr: grad.r1,
      cx: grad.x2,
      cy: grad.y2,
      r: grad.r2
    });
  } else {
    el = domChild(el, index++, 'linearGradient', svgns);
    setAttributes(el, {
      id: grad.id,
      x1: grad.x1,
      x2: grad.x2,
      y1: grad.y1,
      y2: grad.y2
    });
  }
  for (i = 0, n = grad.stops.length; i < n; ++i) {
    stop = domChild(el, i, 'stop', svgns);
    stop.setAttribute('offset', grad.stops[i].offset);
    stop.setAttribute('stop-color', grad.stops[i].color);
  }
  domClear(el, i);
  return index;
}

// update clipping path definitions
function updateClipping(el, clip, index) {
  let mask;
  el = domChild(el, index, 'clipPath', svgns);
  el.setAttribute('id', clip.id);
  if (clip.path) {
    mask = domChild(el, 0, 'path', svgns);
    mask.setAttribute('d', clip.path);
  } else {
    mask = domChild(el, 0, 'rect', svgns);
    setAttributes(mask, {
      x: 0,
      y: 0,
      width: clip.width,
      height: clip.height
    });
  }
  domClear(el, 1);
  return index + 1;
}

// Recursively process group contents.
function recurse(renderer, el, group, markTypes) {
  // child 'g' element is second to last among children (path, g, path)
  // other children here are foreground and background path elements
  el = el.lastChild.previousSibling;
  let prev,
    idx = 0;
  visit(group, item => {
    prev = renderer.mark(el, item, prev, markTypes);
    ++idx;
  });

  // remove any extraneous DOM elements
  domClear(el, 1 + idx);
}

// Bind a scenegraph item to an SVG DOM element.
// Create new SVG elements as needed.
function bind$1(item, el, sibling, tag, svg) {
  let node = item._svg,
    doc;

  // create a new dom node if needed
  if (!node) {
    doc = el.ownerDocument;
    node = domCreate(doc, tag, svgns);
    item._svg = node;
    if (item.mark) {
      node.__data__ = item;
      node.__values__ = {
        fill: 'default'
      };

      // if group, create background, content, and foreground elements
      if (tag === 'g') {
        const bg = domCreate(doc, 'path', svgns);
        node.appendChild(bg);
        bg.__data__ = item;
        const cg = domCreate(doc, 'g', svgns);
        node.appendChild(cg);
        cg.__data__ = item;
        const fg = domCreate(doc, 'path', svgns);
        node.appendChild(fg);
        fg.__data__ = item;
        fg.__values__ = {
          fill: 'default'
        };
      }
    }
  }

  // (re-)insert if (a) not contained in SVG or (b) sibling order has changed
  if (node.ownerSVGElement !== svg || siblingCheck(node, sibling)) {
    el.insertBefore(node, sibling ? sibling.nextSibling : el.firstChild);
  }
  return node;
}

// check if two nodes are ordered siblings
function siblingCheck(node, sibling) {
  return node.parentNode && node.parentNode.childNodes.length > 1 && node.previousSibling != sibling; // treat null/undefined the same
}

// -- Set attributes & styles on SVG elements ---

let element$1 = null,
  // temp var for current SVG element
  values = null; // temp var for current values hash

// Extra configuration for certain mark types
const mark_extras = {
  group(mdef, el, item) {
    const fg = element$1 = el.childNodes[2];
    values = fg.__values__;
    mdef.foreground(emit, item, this);
    values = el.__values__; // use parent's values hash
    element$1 = el.childNodes[1];
    mdef.content(emit, item, this);
    const bg = element$1 = el.childNodes[0];
    mdef.background(emit, item, this);
    const value = item.mark.interactive === false ? 'none' : null;
    if (value !== values.events) {
      setAttribute(fg, 'pointer-events', value);
      setAttribute(bg, 'pointer-events', value);
      values.events = value;
    }
    if (item.strokeForeground && item.stroke) {
      const fill = item.fill;
      setAttribute(fg, 'display', null);

      // set style of background
      this.style(bg, item);
      setAttribute(bg, 'stroke', null);

      // set style of foreground
      if (fill) item.fill = null;
      values = fg.__values__;
      this.style(fg, item);
      if (fill) item.fill = fill;

      // leave element null to prevent downstream styling
      element$1 = null;
    } else {
      // ensure foreground is ignored
      setAttribute(fg, 'display', 'none');
    }
  },
  image(mdef, el, item) {
    if (item.smooth === false) {
      setStyle(el, 'image-rendering', 'optimizeSpeed');
      setStyle(el, 'image-rendering', 'pixelated');
    } else {
      setStyle(el, 'image-rendering', null);
    }
  },
  text(mdef, el, item) {
    const tl = textLines(item);
    let key, value, doc, lh;
    if (isArray(tl)) {
      // multi-line text
      value = tl.map(_ => textValue(item, _));
      key = value.join('\n'); // content cache key

      if (key !== values.text) {
        domClear(el, 0);
        doc = el.ownerDocument;
        lh = lineHeight(item);
        value.forEach((t, i) => {
          const ts = domCreate(doc, 'tspan', svgns);
          ts.__data__ = item; // data binding
          ts.textContent = t;
          if (i) {
            ts.setAttribute('x', 0);
            ts.setAttribute('dy', lh);
          }
          el.appendChild(ts);
        });
        values.text = key;
      }
    } else {
      // single-line text
      value = textValue(item, tl);
      if (value !== values.text) {
        el.textContent = value;
        values.text = value;
      }
    }
    setAttribute(el, 'font-family', fontFamily(item));
    setAttribute(el, 'font-size', fontSize(item) + 'px');
    setAttribute(el, 'font-style', item.fontStyle);
    setAttribute(el, 'font-variant', item.fontVariant);
    setAttribute(el, 'font-weight', item.fontWeight);
  }
};
function emit(name, value, ns) {
  // early exit if value is unchanged
  if (value === values[name]) return;

  // use appropriate method given namespace (ns)
  if (ns) {
    setAttributeNS(element$1, name, value, ns);
  } else {
    setAttribute(element$1, name, value);
  }

  // note current value for future comparison
  values[name] = value;
}
function setStyle(el, name, value) {
  if (value !== values[name]) {
    if (value == null) {
      el.style.removeProperty(name);
    } else {
      el.style.setProperty(name, value + '');
    }
    values[name] = value;
  }
}
function setAttributes(el, attrs) {
  for (const key in attrs) {
    setAttribute(el, key, attrs[key]);
  }
}
function setAttribute(el, name, value) {
  if (value != null) {
    // if value is provided, update DOM attribute
    el.setAttribute(name, value);
  } else {
    // else remove DOM attribute
    el.removeAttribute(name);
  }
}
function setAttributeNS(el, name, value, ns) {
  if (value != null) {
    // if value is provided, update DOM attribute
    el.setAttributeNS(ns, name, value);
  } else {
    // else remove DOM attribute
    el.removeAttributeNS(ns, name);
  }
}
function href() {
  let loc;
  return typeof window === 'undefined' ? '' : (loc = window.location).hash ? loc.href.slice(0, -loc.hash.length) : loc.href;
}
class SVGStringRenderer extends Renderer {
  constructor(loader) {
    super(loader);
    this._text = null;
    this._defs = {
      gradient: {},
      clipping: {}
    };
  }

  /**
   * Returns the rendered SVG text string,
   * or null if rendering has not yet occurred.
   */
  svg() {
    return this._text;
  }

  /**
   * Internal rendering method.
   * @param {object} scene - The root mark of a scenegraph to render.
   */
  _render(scene) {
    const m = markup();

    // svg tag
    m.open('svg', extend$1({}, metadata, {
      class: 'marks',
      width: this._width * this._scale,
      height: this._height * this._scale,
      viewBox: `0 0 ${this._width} ${this._height}`
    }));

    // background, if defined
    const bg = this._bgcolor;
    if (bg && bg !== 'transparent' && bg !== 'none') {
      m.open('rect', {
        width: this._width,
        height: this._height,
        fill: bg
      }).close();
    }

    // root content group
    m.open('g', rootAttributes, {
      transform: 'translate(' + this._origin + ')'
    });
    this.mark(m, scene);
    m.close(); // </g>

    // defs
    this.defs(m);

    // get SVG text string
    this._text = m.close() + '';
    return this;
  }

  /**
   * Render a set of mark items.
   * @param {object} m - The markup context.
   * @param {object} scene - The mark parent to render.
   */
  mark(m, scene) {
    const mdef = Marks[scene.marktype],
      tag = mdef.tag,
      attrList = [ariaItemAttributes, mdef.attr];

    // render opening group tag
    m.open('g', {
      'class': cssClass(scene),
      'clip-path': scene.clip ? clip$1$1(this, scene, scene.group) : null
    }, ariaMarkAttributes(scene), {
      'pointer-events': tag !== 'g' && scene.interactive === false ? 'none' : null
    });

    // render contained elements
    const process = item => {
      const href = this.href(item);
      if (href) m.open('a', href);
      m.open(tag, this.attr(scene, item, attrList, tag !== 'g' ? tag : null));
      if (tag === 'text') {
        const tl = textLines(item);
        if (isArray(tl)) {
          // multi-line text
          const attrs = {
            x: 0,
            dy: lineHeight(item)
          };
          for (let i = 0; i < tl.length; ++i) {
            m.open('tspan', i ? attrs : null).text(textValue(item, tl[i])).close();
          }
        } else {
          // single-line text
          m.text(textValue(item, tl));
        }
      } else if (tag === 'g') {
        const fore = item.strokeForeground,
          fill = item.fill,
          stroke = item.stroke;
        if (fore && stroke) {
          item.stroke = null;
        }
        m.open('path', this.attr(scene, item, mdef.background, 'bgrect')).close();

        // recurse for group content
        m.open('g', this.attr(scene, item, mdef.content));
        visit(item, scene => this.mark(m, scene));
        m.close();
        if (fore && stroke) {
          if (fill) item.fill = null;
          item.stroke = stroke;
          m.open('path', this.attr(scene, item, mdef.foreground, 'bgrect')).close();
          if (fill) item.fill = fill;
        } else {
          m.open('path', this.attr(scene, item, mdef.foreground, 'bgfore')).close();
        }
      }
      m.close(); // </tag>
      if (href) m.close(); // </a>
    };
    if (mdef.nested) {
      if (scene.items && scene.items.length) process(scene.items[0]);
    } else {
      visit(scene, process);
    }

    // render closing group tag
    return m.close(); // </g>
  }

  /**
   * Get href attributes for a hyperlinked mark item.
   * @param {Item} item - The mark item.
   */
  href(item) {
    const href = item.href;
    let attr;
    if (href) {
      if (attr = this._hrefs && this._hrefs[href]) {
        return attr;
      } else {
        this.sanitizeURL(href).then(attr => {
          // rewrite to use xlink namespace
          attr['xlink:href'] = attr.href;
          attr.href = null;
          (this._hrefs || (this._hrefs = {}))[href] = attr;
        });
      }
    }
    return null;
  }

  /**
   * Get an object of SVG attributes for a mark item.
   * @param {object} scene - The mark parent.
   * @param {Item} item - The mark item.
   * @param {array|function} attrs - One or more attribute emitters.
   * @param {string} tag - The tag being rendered.
   */
  attr(scene, item, attrs, tag) {
    const object = {},
      emit = (name, value, ns, prefixed) => {
        object[prefixed || name] = value;
      };

    // apply mark specific attributes
    if (Array.isArray(attrs)) {
      attrs.forEach(fn => fn(emit, item, this));
    } else {
      attrs(emit, item, this);
    }

    // apply style attributes
    if (tag) {
      style(object, item, scene, tag, this._defs);
    }
    return object;
  }

  /**
   * Render SVG defs, as needed.
   * Must be called *after* marks have been processed to ensure the
   * collected state is current and accurate.
   * @param {object} m - The markup context.
   */
  defs(m) {
    const gradient = this._defs.gradient,
      clipping = this._defs.clipping,
      count = Object.keys(gradient).length + Object.keys(clipping).length;
    if (count === 0) return; // nothing to do

    m.open('defs');
    for (const id in gradient) {
      const def = gradient[id],
        stops = def.stops;
      if (def.gradient === 'radial') {
        // SVG radial gradients automatically transform to normalized bbox
        // coordinates, in a way that is cumbersome to replicate in canvas.
        // We wrap the radial gradient in a pattern element, allowing us to
        // maintain a circular gradient that matches what canvas provides.

        m.open('pattern', {
          id: patternPrefix + id,
          viewBox: '0,0,1,1',
          width: '100%',
          height: '100%',
          preserveAspectRatio: 'xMidYMid slice'
        });
        m.open('rect', {
          width: '1',
          height: '1',
          fill: 'url(#' + id + ')'
        }).close();
        m.close(); // </pattern>

        m.open('radialGradient', {
          id: id,
          fx: def.x1,
          fy: def.y1,
          fr: def.r1,
          cx: def.x2,
          cy: def.y2,
          r: def.r2
        });
      } else {
        m.open('linearGradient', {
          id: id,
          x1: def.x1,
          x2: def.x2,
          y1: def.y1,
          y2: def.y2
        });
      }
      for (let i = 0; i < stops.length; ++i) {
        m.open('stop', {
          offset: stops[i].offset,
          'stop-color': stops[i].color
        }).close();
      }
      m.close();
    }
    for (const id in clipping) {
      const def = clipping[id];
      m.open('clipPath', {
        id: id
      });
      if (def.path) {
        m.open('path', {
          d: def.path
        }).close();
      } else {
        m.open('rect', {
          x: 0,
          y: 0,
          width: def.width,
          height: def.height
        }).close();
      }
      m.close();
    }
    m.close();
  }
}

// Helper function for attr for style presentation attributes
function style(s, item, scene, tag, defs) {
  let styleList;
  if (item == null) return s;
  if (tag === 'bgrect' && scene.interactive === false) {
    s['pointer-events'] = 'none';
  }
  if (tag === 'bgfore') {
    if (scene.interactive === false) {
      s['pointer-events'] = 'none';
    }
    s.display = 'none';
    if (item.fill !== null) return s;
  }
  if (tag === 'image' && item.smooth === false) {
    styleList = ['image-rendering: optimizeSpeed;', 'image-rendering: pixelated;'];
  }
  if (tag === 'text') {
    s['font-family'] = fontFamily(item);
    s['font-size'] = fontSize(item) + 'px';
    s['font-style'] = item.fontStyle;
    s['font-variant'] = item.fontVariant;
    s['font-weight'] = item.fontWeight;
  }
  for (const prop in stylesAttr) {
    let value = item[prop];
    const name = stylesAttr[prop];
    if (value === 'transparent' && (name === 'fill' || name === 'stroke')) ;else if (value != null) {
      if (isGradient(value)) {
        value = gradientRef(value, defs.gradient, '');
      }
      s[name] = value;
    }
  }
  for (const prop in stylesCss) {
    const value = item[prop];
    if (value != null) {
      styleList = styleList || [];
      styleList.push(`${stylesCss[prop]}: ${value};`);
    }
  }
  if (styleList) {
    s.style = styleList.join(' ');
  }
  return s;
}

/**
 * @typedef {Object} HybridRendererOptions
 *
 * @property {string[]} [svgMarkTypes=['text']] - An array of SVG mark types to render
 *                                                in the SVG layer. All other mark types
 *                                                will be rendered in the Canvas layer.
 * @property {boolean} [svgOnTop=true] - Flag to determine if SVG should be rendered on top.
 * @property {boolean} [debug=false] - Flag to enable or disable debugging mode. When true,
 *                                     the top layer will be stacked below the bottom layer
 *                                     rather than overlaid on top.
 */

/** @type {HybridRendererOptions} */
const OPTS = {
  svgMarkTypes: ['text']};
class HybridRenderer extends Renderer {
  constructor(loader) {
    super(loader);
    this._svgRenderer = new SVGRenderer(loader);
    this._canvasRenderer = new CanvasRenderer(loader);
  }

  /**
   * Initialize a new HybridRenderer instance.
   * @param {DOMElement} el - The containing DOM element for the display.
   * @param {number} width - The coordinate width of the display, in pixels.
   * @param {number} height - The coordinate height of the display, in pixels.
   * @param {Array<number>} origin - The origin of the display, in pixels.
   *   The coordinate system will be translated to this point.
   * @param {number} [scaleFactor=1] - Optional scaleFactor by which to multiply
   *   the width and height to determine the final pixel size.
   * @return {HybridRenderer} - This renderer instance.
   */
  initialize(el, width, height, origin, scaleFactor) {
    this._root_el = domChild(el, 0, 'div');
    const bottomEl = domChild(this._root_el, 0, 'div');
    const topEl = domChild(this._root_el, 1, 'div');
    this._root_el.style.position = 'relative';

    // Set position absolute to overlay svg on top of canvas
    {
      bottomEl.style.height = '100%';
      topEl.style.position = 'absolute';
      topEl.style.top = '0';
      topEl.style.left = '0';
      topEl.style.height = '100%';
      topEl.style.width = '100%';
    }
    this._svgEl = topEl ;
    this._canvasEl = bottomEl ;

    // pointer-events to none on SVG layer so that canvas gets all events
    this._svgEl.style.pointerEvents = 'none';
    this._canvasRenderer.initialize(this._canvasEl, width, height, origin, scaleFactor);
    this._svgRenderer.initialize(this._svgEl, width, height, origin, scaleFactor);
    return super.initialize(el, width, height, origin, scaleFactor);
  }

  /**
   * Flag a mark item as dirty.
   * @param {Item} item - The mark item.
   */
  dirty(item) {
    if (OPTS.svgMarkTypes.includes(item.mark.marktype)) {
      this._svgRenderer.dirty(item);
    } else {
      this._canvasRenderer.dirty(item);
    }
    return this;
  }

  /**
   * Internal rendering method.
   * @param {object} scene - The root mark of a scenegraph to render.
   * @param {Array} markTypes - Array of the mark types to render.
   *                            If undefined, render all mark types
   */
  _render(scene, markTypes) {
    const allMarkTypes = markTypes ?? ['arc', 'area', 'image', 'line', 'path', 'rect', 'rule', 'shape', 'symbol', 'text', 'trail'];
    const canvasMarkTypes = allMarkTypes.filter(m => !OPTS.svgMarkTypes.includes(m));
    this._svgRenderer.render(scene, OPTS.svgMarkTypes);
    this._canvasRenderer.render(scene, canvasMarkTypes);
  }

  /**
   * Resize the display.
   * @param {number} width - The new coordinate width of the display, in pixels.
   * @param {number} height - The new coordinate height of the display, in pixels.
   * @param {Array<number>} origin - The new origin of the display, in pixels.
   *   The coordinate system will be translated to this point.
   * @param {number} [scaleFactor=1] - Optional scaleFactor by which to multiply
   *   the width and height to determine the final pixel size.
   * @return {SVGRenderer} - This renderer instance;
   */
  resize(width, height, origin, scaleFactor) {
    super.resize(width, height, origin, scaleFactor);
    this._svgRenderer.resize(width, height, origin, scaleFactor);
    this._canvasRenderer.resize(width, height, origin, scaleFactor);
    return this;
  }
  background(bgcolor) {
    // Propagate background color to lower canvas renderer
    {
      this._canvasRenderer.background(bgcolor);
    }
    return this;
  }
}
class HybridHandler extends CanvasHandler {
  constructor(loader, tooltip) {
    super(loader, tooltip);
  }
  initialize(el, origin, obj) {
    const canvas = domChild(domChild(el, 0, 'div'), 0 , 'div');
    return super.initialize(canvas, origin, obj);
  }
}
const Canvas = 'canvas';
const Hybrid = 'hybrid';
const PNG = 'png';
const SVG = 'svg';
const None$1 = 'none';
const RenderType = {
  Canvas: Canvas,
  PNG: PNG,
  SVG: SVG};
const modules = {};
modules[Canvas] = modules[PNG] = {
  renderer: CanvasRenderer,
  headless: CanvasRenderer,
  handler: CanvasHandler
};
modules[SVG] = {
  renderer: SVGRenderer,
  headless: SVGStringRenderer,
  handler: SVGHandler
};
modules[Hybrid] = {
  renderer: HybridRenderer,
  headless: HybridRenderer,
  handler: HybridHandler
};
modules[None$1] = {};
function renderModule(name, _) {
  name = String(name || '').toLowerCase();
  if (arguments.length > 1) {
    modules[name] = _;
    return this;
  } else {
    return modules[name];
  }
}
function intersect$2(scene, bounds, filter) {
  const hits = [],
    // intersection results
    box = new Bounds().union(bounds),
    // defensive copy
    type = scene.marktype;
  return type ? intersectMark(scene, box, filter, hits) : type === 'group' ? intersectGroup(scene, box, filter, hits) : error('Intersect scene must be mark node or group item.');
}
function intersectMark(mark, box, filter, hits) {
  if (visitMark(mark, box, filter)) {
    const items = mark.items,
      type = mark.marktype,
      n = items.length;
    let i = 0;
    if (type === 'group') {
      for (; i < n; ++i) {
        intersectGroup(items[i], box, filter, hits);
      }
    } else {
      for (const test = Marks[type].isect; i < n; ++i) {
        const item = items[i];
        if (intersectItem(item, box, test)) hits.push(item);
      }
    }
  }
  return hits;
}
function visitMark(mark, box, filter) {
  // process if bounds intersect and if
  // (1) mark is a group mark (so we must recurse), or
  // (2) mark is interactive and passes filter
  return mark.bounds && box.intersects(mark.bounds) && (mark.marktype === 'group' || mark.interactive !== false && (!filter || filter(mark)));
}
function intersectGroup(group, box, filter, hits) {
  // test intersect against group
  // skip groups by default unless filter says otherwise
  if (filter && filter(group.mark) && intersectItem(group, box, Marks.group.isect)) {
    hits.push(group);
  }

  // recursively test children marks
  // translate box to group coordinate space
  const marks = group.items,
    n = marks && marks.length;
  if (n) {
    const x = group.x || 0,
      y = group.y || 0;
    box.translate(-x, -y);
    for (let i = 0; i < n; ++i) {
      intersectMark(marks[i], box, filter, hits);
    }
    box.translate(x, y);
  }
  return hits;
}
function intersectItem(item, box, test) {
  // test bounds enclosure, bounds intersection, then detailed test
  const bounds = item.bounds;
  return box.encloses(bounds) || box.intersects(bounds) && test(item, box);
}
const clipBounds = new Bounds();
function boundClip(mark) {
  const clip = mark.clip;
  if (isFunction(clip)) {
    clip(boundContext(clipBounds.clear()));
  } else if (clip) {
    clipBounds.set(0, 0, mark.group.width, mark.group.height);
  } else return;
  mark.bounds.intersect(clipBounds);
}

const Top$1 = 'top';
const Left$1 = 'left';
const Right$1 = 'right';
const Bottom$1 = 'bottom';
const TopLeft = 'top-left';
const TopRight = 'top-right';
const BottomLeft = 'bottom-left';
const BottomRight = 'bottom-right';
const Start$1 = 'start';
const Middle$1 = 'middle';
const End$1 = 'end';
const X = 'x';
const Y = 'y';
const Group = 'group';
const AxisRole$1 = 'axis';
const TitleRole$1 = 'title';
const FrameRole$1 = 'frame';
const ScopeRole$1 = 'scope';
const LegendRole$1 = 'legend';
const RowHeader = 'row-header';
const RowFooter = 'row-footer';
const RowTitle = 'row-title';
const ColHeader = 'column-header';
const ColFooter = 'column-footer';
const ColTitle = 'column-title';
const Padding$1 = 'padding';
const Symbols$1 = 'symbol';
const Fit = 'fit';
const FitX = 'fit-x';
const FitY = 'fit-y';
const Pad = 'pad';
const None = 'none';
const All = 'all';
const Each = 'each';
const Flush = 'flush';
const Column = 'column';
const Row = 'row';

/**
 * Calculate bounding boxes for scenegraph items.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {object} params.mark - The scenegraph mark instance to bound.
 */
function Bound$1(params) {
  Transform.call(this, null, params);
}
inherits(Bound$1, Transform, {
  transform(_, pulse) {
    const view = pulse.dataflow,
      mark = _.mark,
      type = mark.marktype,
      entry = Marks[type],
      bound = entry.bound;
    let markBounds = mark.bounds,
      rebound;
    if (entry.nested) {
      // multi-item marks have a single bounds instance
      if (mark.items.length) view.dirty(mark.items[0]);
      markBounds = boundItem(mark, bound);
      mark.items.forEach(item => {
        item.bounds.clear().union(markBounds);
      });
    } else if (type === Group || _.modified()) {
      // operator parameters modified -> re-bound all items
      // updates group bounds in response to modified group content
      pulse.visit(pulse.MOD, item => view.dirty(item));
      markBounds.clear();
      mark.items.forEach(item => markBounds.union(boundItem(item, bound)));

      // force reflow for axes/legends/titles to propagate any layout changes
      switch (mark.role) {
        case AxisRole$1:
        case LegendRole$1:
        case TitleRole$1:
          pulse.reflow();
      }
    } else {
      // incrementally update bounds, re-bound mark as needed
      rebound = pulse.changed(pulse.REM);
      pulse.visit(pulse.ADD, item => {
        markBounds.union(boundItem(item, bound));
      });
      pulse.visit(pulse.MOD, item => {
        rebound = rebound || markBounds.alignsWith(item.bounds);
        view.dirty(item);
        markBounds.union(boundItem(item, bound));
      });
      if (rebound) {
        markBounds.clear();
        mark.items.forEach(item => markBounds.union(item.bounds));
      }
    }

    // ensure mark bounds do not exceed any clipping region
    boundClip(mark);
    return pulse.modifies('bounds');
  }
});
function boundItem(item, bound, opt) {
  return bound(item.bounds.clear(), item, opt);
}
const COUNTER_NAME = ':vega_identifier:';

/**
 * Adds a unique identifier to all added tuples.
 * This transform creates a new signal that serves as an id counter.
 * As a result, the id counter is shared across all instances of this
 * transform, generating unique ids across multiple data streams. In
 * addition, this signal value can be included in a snapshot of the
 * dataflow state, enabling correct resumption of id allocation.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {string} params.as - The field name for the generated identifier.
 */
function Identifier$1(params) {
  Transform.call(this, 0, params);
}
Identifier$1.Definition = {
  'type': 'Identifier',
  'metadata': {
    'modifies': true
  },
  'params': [{
    'name': 'as',
    'type': 'string',
    'required': true
  }]
};
inherits(Identifier$1, Transform, {
  transform(_, pulse) {
    const counter = getCounter(pulse.dataflow),
      as = _.as;
    let id = counter.value;
    pulse.visit(pulse.ADD, t => t[as] = t[as] || ++id);
    counter.set(this.value = id);
    return pulse;
  }
});
function getCounter(view) {
  return view._signals[COUNTER_NAME] || (view._signals[COUNTER_NAME] = view.add(0));
}

/**
 * Bind scenegraph items to a scenegraph mark instance.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {object} params.markdef - The mark definition for creating the mark.
 *   This is an object of legal scenegraph mark properties which *must* include
 *   the 'marktype' property.
 */
function Mark$1(params) {
  Transform.call(this, null, params);
}
inherits(Mark$1, Transform, {
  transform(_, pulse) {
    let mark = this.value;

    // acquire mark on first invocation, bind context and group
    if (!mark) {
      mark = pulse.dataflow.scenegraph().mark(_.markdef, lookup$1$1(_), _.index);
      mark.group.context = _.context;
      if (!_.context.group) _.context.group = mark.group;
      mark.source = this.source; // point to upstream collector
      mark.clip = _.clip;
      mark.interactive = _.interactive;
      this.value = mark;
    }

    // initialize entering items
    const Init = mark.marktype === Group ? GroupItem : Item;
    pulse.visit(pulse.ADD, item => Init.call(item, mark));

    // update clipping and/or interactive status
    if (_.modified('clip') || _.modified('interactive')) {
      mark.clip = _.clip;
      mark.interactive = !!_.interactive;
      mark.zdirty = true; // force scenegraph re-eval
      pulse.reflow();
    }

    // bind items array to scenegraph mark
    mark.items = pulse.source;
    return pulse;
  }
});
function lookup$1$1(_) {
  const g = _.groups,
    p = _.parent;
  return g && g.size === 1 ? g.get(Object.keys(g.object)[0]) : g && p ? g.lookup(p) : null;
}

/**
 * Analyze items for overlap, changing opacity to hide items with
 * overlapping bounding boxes. This transform will preserve at least
 * two items (e.g., first and last) even if overlap persists.
 * @param {object} params - The parameters for this operator.
 * @param {function(*,*): number} [params.sort] - A comparator
 *   function for sorting items.
 * @param {object} [params.method] - The overlap removal method to apply.
 *   One of 'parity' (default, hide every other item until there is no
 *   more overlap) or 'greedy' (sequentially scan and hide and items that
 *   overlap with the last visible item).
 * @param {object} [params.boundScale] - A scale whose range should be used
 *   to bound the items. Items exceeding the bounds of the scale range
 *   will be treated as overlapping. If null or undefined, no bounds check
 *   will be applied.
 * @param {object} [params.boundOrient] - The orientation of the scale
 *   (top, bottom, left, or right) used to bound items. This parameter is
 *   ignored if boundScale is null or undefined.
 * @param {object} [params.boundTolerance] - The tolerance in pixels for
 *   bound inclusion testing (default 1). This specifies by how many pixels
 *   an item's bounds may exceed the scale range bounds and not be culled.
 * @constructor
 */
function Overlap$1(params) {
  Transform.call(this, null, params);
}
const methods = {
  parity: items => items.filter((item, i) => i % 2 ? item.opacity = 0 : 1),
  greedy: (items, sep) => {
    let a;
    return items.filter((b, i) => !i || !intersect$1(a.bounds, b.bounds, sep) ? (a = b, 1) : b.opacity = 0);
  }
};

// compute bounding box intersection
// including padding pixels of separation
const intersect$1 = (a, b, sep) => sep > Math.max(b.x1 - a.x2, a.x1 - b.x2, b.y1 - a.y2, a.y1 - b.y2);
const hasOverlap = (items, pad) => {
  for (var i = 1, n = items.length, a = items[0].bounds, b; i < n; a = b, ++i) {
    if (intersect$1(a, b = items[i].bounds, pad)) return true;
  }
};
const hasBounds = item => {
  const b = item.bounds;
  return b.width() > 1 && b.height() > 1;
};
const boundTest = (scale, orient, tolerance) => {
  var range = scale.range(),
    b = new Bounds();
  if (orient === Top$1 || orient === Bottom$1) {
    b.set(range[0], -Infinity, range[1], +Infinity);
  } else {
    b.set(-Infinity, range[0], +Infinity, range[1]);
  }
  b.expand(tolerance || 1);
  return item => b.encloses(item.bounds);
};

// reset all items to be fully opaque
const reset = source => {
  source.forEach(item => item.opacity = 1);
  return source;
};

// add all tuples to mod, fork pulse if parameters were modified
// fork prevents cross-stream tuple pollution (e.g., pulse from scale)
const reflow = (pulse, _) => pulse.reflow(_.modified()).modifies('opacity');
inherits(Overlap$1, Transform, {
  transform(_, pulse) {
    const reduce = methods[_.method] || methods.parity,
      sep = _.separation || 0;
    let source = pulse.materialize(pulse.SOURCE).source,
      items,
      test;
    if (!source || !source.length) return;
    if (!_.method) {
      // early exit if method is falsy
      if (_.modified('method')) {
        reset(source);
        pulse = reflow(pulse, _);
      }
      return pulse;
    }

    // skip labels with no content
    source = source.filter(hasBounds);

    // early exit, nothing to do
    if (!source.length) return;
    if (_.sort) {
      source = source.slice().sort(_.sort);
    }
    items = reset(source);
    pulse = reflow(pulse, _);
    if (items.length >= 3 && hasOverlap(items, sep)) {
      do {
        items = reduce(items, sep);
      } while (items.length >= 3 && hasOverlap(items, sep));
      if (items.length < 3 && !peek$1(source).opacity) {
        if (items.length > 1) peek$1(items).opacity = 0;
        peek$1(source).opacity = 1;
      }
    }
    if (_.boundScale && _.boundTolerance >= 0) {
      test = boundTest(_.boundScale, _.boundOrient, +_.boundTolerance);
      source.forEach(item => {
        if (!test(item)) item.opacity = 0;
      });
    }

    // re-calculate mark bounds
    const bounds = items[0].mark.bounds.clear();
    source.forEach(item => {
      if (item.opacity) bounds.union(item.bounds);
    });
    return pulse;
  }
});

/**
 * Queue modified scenegraph items for rendering.
 * @constructor
 */
function Render$1(params) {
  Transform.call(this, null, params);
}
inherits(Render$1, Transform, {
  transform(_, pulse) {
    const view = pulse.dataflow;
    pulse.visit(pulse.ALL, item => view.dirty(item));

    // set z-index dirty flag as needed
    if (pulse.fields && pulse.fields['zindex']) {
      const item = pulse.source && pulse.source[0];
      if (item) item.mark.zdirty = true;
    }
  }
});
const tempBounds = new Bounds();
function set$2(item, property, value) {
  return item[property] === value ? 0 : (item[property] = value, 1);
}
function isYAxis(mark) {
  var orient = mark.items[0].orient;
  return orient === Left$1 || orient === Right$1;
}
function axisIndices(datum) {
  let index = +datum.grid;
  return [datum.ticks ? index++ : -1,
  // ticks index
  datum.labels ? index++ : -1,
  // labels index
  index + +datum.domain // title index
  ];
}
function axisLayout(view, axis, width, height) {
  var item = axis.items[0],
    datum = item.datum,
    delta = item.translate != null ? item.translate : 0.5,
    orient = item.orient,
    indices = axisIndices(datum),
    range = item.range,
    offset = item.offset,
    position = item.position,
    minExtent = item.minExtent,
    maxExtent = item.maxExtent,
    title = datum.title && item.items[indices[2]].items[0],
    titlePadding = item.titlePadding,
    bounds = item.bounds,
    dl = title && multiLineOffset(title),
    x = 0,
    y = 0,
    i,
    s;
  tempBounds.clear().union(bounds);
  bounds.clear();
  if ((i = indices[0]) > -1) bounds.union(item.items[i].bounds);
  if ((i = indices[1]) > -1) bounds.union(item.items[i].bounds);

  // position axis group and title
  switch (orient) {
    case Top$1:
      x = position || 0;
      y = -offset;
      s = Math.max(minExtent, Math.min(maxExtent, -bounds.y1));
      bounds.add(0, -s).add(range, 0);
      if (title) axisTitleLayout(view, title, s, titlePadding, dl, 0, -1, bounds);
      break;
    case Left$1:
      x = -offset;
      y = position || 0;
      s = Math.max(minExtent, Math.min(maxExtent, -bounds.x1));
      bounds.add(-s, 0).add(0, range);
      if (title) axisTitleLayout(view, title, s, titlePadding, dl, 1, -1, bounds);
      break;
    case Right$1:
      x = width + offset;
      y = position || 0;
      s = Math.max(minExtent, Math.min(maxExtent, bounds.x2));
      bounds.add(0, 0).add(s, range);
      if (title) axisTitleLayout(view, title, s, titlePadding, dl, 1, 1, bounds);
      break;
    case Bottom$1:
      x = position || 0;
      y = height + offset;
      s = Math.max(minExtent, Math.min(maxExtent, bounds.y2));
      bounds.add(0, 0).add(range, s);
      if (title) axisTitleLayout(view, title, s, titlePadding, 0, 0, 1, bounds);
      break;
    default:
      x = item.x;
      y = item.y;
  }

  // update bounds
  boundStroke(bounds.translate(x, y), item);
  if (set$2(item, 'x', x + delta) | set$2(item, 'y', y + delta)) {
    item.bounds = tempBounds;
    view.dirty(item);
    item.bounds = bounds;
    view.dirty(item);
  }
  return item.mark.bounds.clear().union(bounds);
}
function axisTitleLayout(view, title, offset, pad, dl, isYAxis, sign, bounds) {
  const b = title.bounds;
  if (title.auto) {
    const v = sign * (offset + dl + pad);
    let dx = 0,
      dy = 0;
    view.dirty(title);
    isYAxis ? dx = (title.x || 0) - (title.x = v) : dy = (title.y || 0) - (title.y = v);
    title.mark.bounds.clear().union(b.translate(-dx, -dy));
    view.dirty(title);
  }
  bounds.union(b);
}

// aggregation functions for grid margin determination
const min = (a, b) => Math.floor(Math.min(a, b));
const max = (a, b) => Math.ceil(Math.max(a, b));
function gridLayoutGroups(group) {
  var groups = group.items,
    n = groups.length,
    i = 0,
    mark,
    items;
  const views = {
    marks: [],
    rowheaders: [],
    rowfooters: [],
    colheaders: [],
    colfooters: [],
    rowtitle: null,
    coltitle: null
  };

  // layout axes, gather legends, collect bounds
  for (; i < n; ++i) {
    mark = groups[i];
    items = mark.items;
    if (mark.marktype === Group) {
      switch (mark.role) {
        case AxisRole$1:
        case LegendRole$1:
        case TitleRole$1:
          break;
        case RowHeader:
          views.rowheaders.push(...items);
          break;
        case RowFooter:
          views.rowfooters.push(...items);
          break;
        case ColHeader:
          views.colheaders.push(...items);
          break;
        case ColFooter:
          views.colfooters.push(...items);
          break;
        case RowTitle:
          views.rowtitle = items[0];
          break;
        case ColTitle:
          views.coltitle = items[0];
          break;
        default:
          views.marks.push(...items);
      }
    }
  }
  return views;
}
function bboxFlush(item) {
  return new Bounds().set(0, 0, item.width || 0, item.height || 0);
}
function bboxFull(item) {
  const b = item.bounds.clone();
  return b.empty() ? b.set(0, 0, 0, 0) : b.translate(-(item.x || 0), -(item.y || 0));
}
function get$1(opt, key, d) {
  const v = isObject(opt) ? opt[key] : opt;
  return v != null ? v : d !== undefined ? d : 0;
}
function offsetValue$1(v) {
  return v < 0 ? Math.ceil(-v) : 0;
}
function gridLayout(view, groups, opt) {
  var dirty = !opt.nodirty,
    bbox = opt.bounds === Flush ? bboxFlush : bboxFull,
    bounds = tempBounds.set(0, 0, 0, 0),
    alignCol = get$1(opt.align, Column),
    alignRow = get$1(opt.align, Row),
    padCol = get$1(opt.padding, Column),
    padRow = get$1(opt.padding, Row),
    ncols = opt.columns || groups.length,
    nrows = ncols <= 0 ? 1 : Math.ceil(groups.length / ncols),
    n = groups.length,
    xOffset = Array(n),
    xExtent = Array(ncols),
    xMax = 0,
    yOffset = Array(n),
    yExtent = Array(nrows),
    yMax = 0,
    dx = Array(n),
    dy = Array(n),
    boxes = Array(n),
    m,
    i,
    c,
    r,
    b,
    g,
    px,
    py,
    x,
    y,
    offset;
  for (i = 0; i < ncols; ++i) xExtent[i] = 0;
  for (i = 0; i < nrows; ++i) yExtent[i] = 0;

  // determine offsets for each group
  for (i = 0; i < n; ++i) {
    g = groups[i];
    b = boxes[i] = bbox(g);
    g.x = g.x || 0;
    dx[i] = 0;
    g.y = g.y || 0;
    dy[i] = 0;
    c = i % ncols;
    r = ~~(i / ncols);
    xMax = Math.max(xMax, px = Math.ceil(b.x2));
    yMax = Math.max(yMax, py = Math.ceil(b.y2));
    xExtent[c] = Math.max(xExtent[c], px);
    yExtent[r] = Math.max(yExtent[r], py);
    xOffset[i] = padCol + offsetValue$1(b.x1);
    yOffset[i] = padRow + offsetValue$1(b.y1);
    if (dirty) view.dirty(groups[i]);
  }

  // set initial alignment offsets
  for (i = 0; i < n; ++i) {
    if (i % ncols === 0) xOffset[i] = 0;
    if (i < ncols) yOffset[i] = 0;
  }

  // enforce column alignment constraints
  if (alignCol === Each) {
    for (c = 1; c < ncols; ++c) {
      for (offset = 0, i = c; i < n; i += ncols) {
        if (offset < xOffset[i]) offset = xOffset[i];
      }
      for (i = c; i < n; i += ncols) {
        xOffset[i] = offset + xExtent[c - 1];
      }
    }
  } else if (alignCol === All) {
    for (offset = 0, i = 0; i < n; ++i) {
      if (i % ncols && offset < xOffset[i]) offset = xOffset[i];
    }
    for (i = 0; i < n; ++i) {
      if (i % ncols) xOffset[i] = offset + xMax;
    }
  } else {
    for (alignCol = false, c = 1; c < ncols; ++c) {
      for (i = c; i < n; i += ncols) {
        xOffset[i] += xExtent[c - 1];
      }
    }
  }

  // enforce row alignment constraints
  if (alignRow === Each) {
    for (r = 1; r < nrows; ++r) {
      for (offset = 0, i = r * ncols, m = i + ncols; i < m; ++i) {
        if (offset < yOffset[i]) offset = yOffset[i];
      }
      for (i = r * ncols; i < m; ++i) {
        yOffset[i] = offset + yExtent[r - 1];
      }
    }
  } else if (alignRow === All) {
    for (offset = 0, i = ncols; i < n; ++i) {
      if (offset < yOffset[i]) offset = yOffset[i];
    }
    for (i = ncols; i < n; ++i) {
      yOffset[i] = offset + yMax;
    }
  } else {
    for (alignRow = false, r = 1; r < nrows; ++r) {
      for (i = r * ncols, m = i + ncols; i < m; ++i) {
        yOffset[i] += yExtent[r - 1];
      }
    }
  }

  // perform horizontal grid layout
  for (x = 0, i = 0; i < n; ++i) {
    x = xOffset[i] + (i % ncols ? x : 0);
    dx[i] += x - groups[i].x;
  }

  // perform vertical grid layout
  for (c = 0; c < ncols; ++c) {
    for (y = 0, i = c; i < n; i += ncols) {
      y += yOffset[i];
      dy[i] += y - groups[i].y;
    }
  }

  // perform horizontal centering
  if (alignCol && get$1(opt.center, Column) && nrows > 1) {
    for (i = 0; i < n; ++i) {
      b = alignCol === All ? xMax : xExtent[i % ncols];
      x = b - boxes[i].x2 - groups[i].x - dx[i];
      if (x > 0) dx[i] += x / 2;
    }
  }

  // perform vertical centering
  if (alignRow && get$1(opt.center, Row) && ncols !== 1) {
    for (i = 0; i < n; ++i) {
      b = alignRow === All ? yMax : yExtent[~~(i / ncols)];
      y = b - boxes[i].y2 - groups[i].y - dy[i];
      if (y > 0) dy[i] += y / 2;
    }
  }

  // position grid relative to anchor
  for (i = 0; i < n; ++i) {
    bounds.union(boxes[i].translate(dx[i], dy[i]));
  }
  x = get$1(opt.anchor, X);
  y = get$1(opt.anchor, Y);
  switch (get$1(opt.anchor, Column)) {
    case End$1:
      x -= bounds.width();
      break;
    case Middle$1:
      x -= bounds.width() / 2;
  }
  switch (get$1(opt.anchor, Row)) {
    case End$1:
      y -= bounds.height();
      break;
    case Middle$1:
      y -= bounds.height() / 2;
  }
  x = Math.round(x);
  y = Math.round(y);

  // update mark positions, bounds, dirty
  bounds.clear();
  for (i = 0; i < n; ++i) {
    groups[i].mark.bounds.clear();
  }
  for (i = 0; i < n; ++i) {
    g = groups[i];
    g.x += dx[i] += x;
    g.y += dy[i] += y;
    bounds.union(g.mark.bounds.union(g.bounds.translate(dx[i], dy[i])));
    if (dirty) view.dirty(g);
  }
  return bounds;
}
function trellisLayout(view, group, opt) {
  var views = gridLayoutGroups(group),
    groups = views.marks,
    bbox = opt.bounds === Flush ? boundFlush : boundFull,
    off = opt.offset,
    ncols = opt.columns || groups.length,
    nrows = ncols <= 0 ? 1 : Math.ceil(groups.length / ncols),
    cells = nrows * ncols,
    x,
    y,
    x2,
    y2,
    anchor,
    band,
    offset;

  // -- initial grid layout
  const bounds = gridLayout(view, groups, opt);
  if (bounds.empty()) bounds.set(0, 0, 0, 0); // empty grid

  // -- layout grid headers and footers --

  // perform row header layout
  if (views.rowheaders) {
    band = get$1(opt.headerBand, Row, null);
    x = layoutHeaders(view, views.rowheaders, groups, ncols, nrows, -get$1(off, 'rowHeader'), min, 0, bbox, 'x1', 0, ncols, 1, band);
  }

  // perform column header layout
  if (views.colheaders) {
    band = get$1(opt.headerBand, Column, null);
    y = layoutHeaders(view, views.colheaders, groups, ncols, ncols, -get$1(off, 'columnHeader'), min, 1, bbox, 'y1', 0, 1, ncols, band);
  }

  // perform row footer layout
  if (views.rowfooters) {
    band = get$1(opt.footerBand, Row, null);
    x2 = layoutHeaders(view, views.rowfooters, groups, ncols, nrows, get$1(off, 'rowFooter'), max, 0, bbox, 'x2', ncols - 1, ncols, 1, band);
  }

  // perform column footer layout
  if (views.colfooters) {
    band = get$1(opt.footerBand, Column, null);
    y2 = layoutHeaders(view, views.colfooters, groups, ncols, ncols, get$1(off, 'columnFooter'), max, 1, bbox, 'y2', cells - ncols, 1, ncols, band);
  }

  // perform row title layout
  if (views.rowtitle) {
    anchor = get$1(opt.titleAnchor, Row);
    offset = get$1(off, 'rowTitle');
    offset = anchor === End$1 ? x2 + offset : x - offset;
    band = get$1(opt.titleBand, Row, 0.5);
    layoutTitle(view, views.rowtitle, offset, 0, bounds, band);
  }

  // perform column title layout
  if (views.coltitle) {
    anchor = get$1(opt.titleAnchor, Column);
    offset = get$1(off, 'columnTitle');
    offset = anchor === End$1 ? y2 + offset : y - offset;
    band = get$1(opt.titleBand, Column, 0.5);
    layoutTitle(view, views.coltitle, offset, 1, bounds, band);
  }
}
function boundFlush(item, field) {
  return field === 'x1' ? item.x || 0 : field === 'y1' ? item.y || 0 : field === 'x2' ? (item.x || 0) + (item.width || 0) : field === 'y2' ? (item.y || 0) + (item.height || 0) : undefined;
}
function boundFull(item, field) {
  return item.bounds[field];
}
function layoutHeaders(view, headers, groups, ncols, limit, offset, agg, isX, bound, bf, start, stride, back, band) {
  var n = groups.length,
    init = 0,
    edge = 0,
    i,
    j,
    k,
    m,
    b,
    h,
    g,
    x,
    y;

  // if no groups, early exit and return 0
  if (!n) return init;

  // compute margin
  for (i = start; i < n; i += stride) {
    if (groups[i]) init = agg(init, bound(groups[i], bf));
  }

  // if no headers, return margin calculation
  if (!headers.length) return init;

  // check if number of headers exceeds number of rows or columns
  if (headers.length > limit) {
    view.warn('Grid headers exceed limit: ' + limit);
    headers = headers.slice(0, limit);
  }

  // apply offset
  init += offset;

  // clear mark bounds for all headers
  for (j = 0, m = headers.length; j < m; ++j) {
    view.dirty(headers[j]);
    headers[j].mark.bounds.clear();
  }

  // layout each header
  for (i = start, j = 0, m = headers.length; j < m; ++j, i += stride) {
    h = headers[j];
    b = h.mark.bounds;

    // search for nearest group to align to
    // necessary if table has empty cells
    for (k = i; k >= 0 && (g = groups[k]) == null; k -= back);

    // assign coordinates and update bounds
    if (isX) {
      x = band == null ? g.x : Math.round(g.bounds.x1 + band * g.bounds.width());
      y = init;
    } else {
      x = init;
      y = band == null ? g.y : Math.round(g.bounds.y1 + band * g.bounds.height());
    }
    b.union(h.bounds.translate(x - (h.x || 0), y - (h.y || 0)));
    h.x = x;
    h.y = y;
    view.dirty(h);

    // update current edge of layout bounds
    edge = agg(edge, b[bf]);
  }
  return edge;
}
function layoutTitle(view, g, offset, isX, bounds, band) {
  if (!g) return;
  view.dirty(g);

  // compute title coordinates
  var x = offset,
    y = offset;
  isX ? x = Math.round(bounds.x1 + band * bounds.width()) : y = Math.round(bounds.y1 + band * bounds.height());

  // assign coordinates and update bounds
  g.bounds.translate(x - (g.x || 0), y - (g.y || 0));
  g.mark.bounds.clear().union(g.bounds);
  g.x = x;
  g.y = y;

  // queue title for redraw
  view.dirty(g);
}

// utility for looking up legend layout configuration
function lookup$3(config, orient) {
  const opt = config[orient] || {};
  return (key, d) => opt[key] != null ? opt[key] : config[key] != null ? config[key] : d;
}

// if legends specify offset directly, use the maximum specified value
function offsets(legends, value) {
  let max = -Infinity;
  legends.forEach(item => {
    if (item.offset != null) max = Math.max(max, item.offset);
  });
  return max > -Infinity ? max : value;
}
function legendParams(g, orient, config, xb, yb, w, h) {
  const _ = lookup$3(config, orient),
    offset = offsets(g, _('offset', 0)),
    anchor = _('anchor', Start$1),
    mult = anchor === End$1 ? 1 : anchor === Middle$1 ? 0.5 : 0;
  const p = {
    align: Each,
    bounds: _('bounds', Flush),
    columns: _('direction') === 'vertical' ? 1 : g.length,
    padding: _('margin', 8),
    center: _('center'),
    nodirty: true
  };
  switch (orient) {
    case Left$1:
      p.anchor = {
        x: Math.floor(xb.x1) - offset,
        column: End$1,
        y: mult * (h || xb.height() + 2 * xb.y1),
        row: anchor
      };
      break;
    case Right$1:
      p.anchor = {
        x: Math.ceil(xb.x2) + offset,
        y: mult * (h || xb.height() + 2 * xb.y1),
        row: anchor
      };
      break;
    case Top$1:
      p.anchor = {
        y: Math.floor(yb.y1) - offset,
        row: End$1,
        x: mult * (w || yb.width() + 2 * yb.x1),
        column: anchor
      };
      break;
    case Bottom$1:
      p.anchor = {
        y: Math.ceil(yb.y2) + offset,
        x: mult * (w || yb.width() + 2 * yb.x1),
        column: anchor
      };
      break;
    case TopLeft:
      p.anchor = {
        x: offset,
        y: offset
      };
      break;
    case TopRight:
      p.anchor = {
        x: w - offset,
        y: offset,
        column: End$1
      };
      break;
    case BottomLeft:
      p.anchor = {
        x: offset,
        y: h - offset,
        row: End$1
      };
      break;
    case BottomRight:
      p.anchor = {
        x: w - offset,
        y: h - offset,
        column: End$1,
        row: End$1
      };
      break;
  }
  return p;
}
function legendLayout(view, legend) {
  var item = legend.items[0],
    datum = item.datum,
    orient = item.orient,
    bounds = item.bounds,
    x = item.x,
    y = item.y,
    w,
    h;

  // cache current bounds for later comparison
  item._bounds ? item._bounds.clear().union(bounds) : item._bounds = bounds.clone();
  bounds.clear();

  // adjust legend to accommodate padding and title
  legendGroupLayout(view, item, item.items[0].items[0]);

  // aggregate bounds to determine size, and include origin
  bounds = legendBounds(item, bounds);
  w = 2 * item.padding;
  h = 2 * item.padding;
  if (!bounds.empty()) {
    w = Math.ceil(bounds.width() + w);
    h = Math.ceil(bounds.height() + h);
  }
  if (datum.type === Symbols$1) {
    legendEntryLayout(item.items[0].items[0].items[0].items);
  }
  if (orient !== None) {
    item.x = x = 0;
    item.y = y = 0;
  }
  item.width = w;
  item.height = h;
  boundStroke(bounds.set(x, y, x + w, y + h), item);
  item.mark.bounds.clear().union(bounds);
  return item;
}
function legendBounds(item, b) {
  // aggregate item bounds
  item.items.forEach(_ => b.union(_.bounds));

  // anchor to legend origin
  b.x1 = item.padding;
  b.y1 = item.padding;
  return b;
}
function legendGroupLayout(view, item, entry) {
  var pad = item.padding,
    ex = pad - entry.x,
    ey = pad - entry.y;
  if (!item.datum.title) {
    if (ex || ey) translate(view, entry, ex, ey);
  } else {
    var title = item.items[1].items[0],
      anchor = title.anchor,
      tpad = item.titlePadding || 0,
      tx = pad - title.x,
      ty = pad - title.y;
    switch (title.orient) {
      case Left$1:
        ex += Math.ceil(title.bounds.width()) + tpad;
        break;
      case Right$1:
      case Bottom$1:
        break;
      default:
        ey += title.bounds.height() + tpad;
    }
    if (ex || ey) translate(view, entry, ex, ey);
    switch (title.orient) {
      case Left$1:
        ty += legendTitleOffset(item, entry, title, anchor, 1, 1);
        break;
      case Right$1:
        tx += legendTitleOffset(item, entry, title, End$1, 0, 0) + tpad;
        ty += legendTitleOffset(item, entry, title, anchor, 1, 1);
        break;
      case Bottom$1:
        tx += legendTitleOffset(item, entry, title, anchor, 0, 0);
        ty += legendTitleOffset(item, entry, title, End$1, -1, 0, 1) + tpad;
        break;
      default:
        tx += legendTitleOffset(item, entry, title, anchor, 0, 0);
    }
    if (tx || ty) translate(view, title, tx, ty);

    // translate legend if title pushes into negative coordinates
    if ((tx = Math.round(title.bounds.x1 - pad)) < 0) {
      translate(view, entry, -tx, 0);
      translate(view, title, -tx, 0);
    }
  }
}
function legendTitleOffset(item, entry, title, anchor, y, lr, noBar) {
  const grad = item.datum.type !== 'symbol',
    vgrad = title.datum.vgrad,
    e = grad && (lr || !vgrad) && !noBar ? entry.items[0] : entry,
    s = e.bounds[y ? 'y2' : 'x2'] - item.padding,
    u = vgrad && lr ? s : 0,
    v = vgrad && lr ? 0 : s,
    o = y <= 0 ? 0 : multiLineOffset(title);
  return Math.round(anchor === Start$1 ? u : anchor === End$1 ? v - o : 0.5 * (s - o));
}
function translate(view, item, dx, dy) {
  item.x += dx;
  item.y += dy;
  item.bounds.translate(dx, dy);
  item.mark.bounds.translate(dx, dy);
  view.dirty(item);
}
function legendEntryLayout(entries) {
  // get max widths for each column
  const widths = entries.reduce((w, g) => {
    w[g.column] = Math.max(g.bounds.x2 - g.x, w[g.column] || 0);
    return w;
  }, {});

  // set dimensions of legend entry groups
  entries.forEach(g => {
    g.width = widths[g.column];
    g.height = g.bounds.y2 - g.y;
  });
}
function titleLayout(view, mark, width, height, viewBounds) {
  var group = mark.items[0],
    frame = group.frame,
    orient = group.orient,
    anchor = group.anchor,
    offset = group.offset,
    padding = group.padding,
    title = group.items[0].items[0],
    subtitle = group.items[1] && group.items[1].items[0],
    end = orient === Left$1 || orient === Right$1 ? height : width,
    start = 0,
    x = 0,
    y = 0,
    sx = 0,
    sy = 0,
    pos;
  if (frame !== Group) {
    orient === Left$1 ? (start = viewBounds.y2, end = viewBounds.y1) : orient === Right$1 ? (start = viewBounds.y1, end = viewBounds.y2) : (start = viewBounds.x1, end = viewBounds.x2);
  } else if (orient === Left$1) {
    start = height, end = 0;
  }
  pos = anchor === Start$1 ? start : anchor === End$1 ? end : (start + end) / 2;
  if (subtitle && subtitle.text) {
    // position subtitle
    switch (orient) {
      case Top$1:
      case Bottom$1:
        sy = title.bounds.height() + padding;
        break;
      case Left$1:
        sx = title.bounds.width() + padding;
        break;
      case Right$1:
        sx = -title.bounds.width() - padding;
        break;
    }
    tempBounds.clear().union(subtitle.bounds);
    tempBounds.translate(sx - (subtitle.x || 0), sy - (subtitle.y || 0));
    if (set$2(subtitle, 'x', sx) | set$2(subtitle, 'y', sy)) {
      view.dirty(subtitle);
      subtitle.bounds.clear().union(tempBounds);
      subtitle.mark.bounds.clear().union(tempBounds);
      view.dirty(subtitle);
    }
    tempBounds.clear().union(subtitle.bounds);
  } else {
    tempBounds.clear();
  }
  tempBounds.union(title.bounds);

  // position title group
  switch (orient) {
    case Top$1:
      x = pos;
      y = viewBounds.y1 - tempBounds.height() - offset;
      break;
    case Left$1:
      x = viewBounds.x1 - tempBounds.width() - offset;
      y = pos;
      break;
    case Right$1:
      x = viewBounds.x2 + tempBounds.width() + offset;
      y = pos;
      break;
    case Bottom$1:
      x = pos;
      y = viewBounds.y2 + offset;
      break;
    default:
      x = group.x;
      y = group.y;
  }
  if (set$2(group, 'x', x) | set$2(group, 'y', y)) {
    tempBounds.translate(x, y);
    view.dirty(group);
    group.bounds.clear().union(tempBounds);
    mark.bounds.clear().union(tempBounds);
    view.dirty(group);
  }
  return group.bounds;
}

/**
 * Layout view elements such as axes and legends.
 * Also performs size adjustments.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {object} params.mark - Scenegraph mark of groups to layout.
 */
function ViewLayout$1(params) {
  Transform.call(this, null, params);
}
inherits(ViewLayout$1, Transform, {
  transform(_, pulse) {
    const view = pulse.dataflow;
    _.mark.items.forEach(group => {
      if (_.layout) trellisLayout(view, group, _.layout);
      layoutGroup(view, group, _);
    });
    return shouldReflow(_.mark.group) ? pulse.reflow() : pulse;
  }
});
function shouldReflow(group) {
  // We typically should reflow if layout is invoked (#2568), as child items
  // may have resized and reflow ensures group bounds are re-calculated.
  // However, legend entries have a special exception to avoid instability.
  // For example, if a selected legend symbol gains a stroke on hover,
  // we don't want to re-position subsequent elements in the legend.
  return group && group.mark.role !== 'legend-entry';
}
function layoutGroup(view, group, _) {
  var items = group.items,
    width = Math.max(0, group.width || 0),
    height = Math.max(0, group.height || 0),
    viewBounds = new Bounds().set(0, 0, width, height),
    xBounds = viewBounds.clone(),
    yBounds = viewBounds.clone(),
    legends = [],
    title,
    mark,
    orient,
    b,
    i,
    n;

  // layout axes, gather legends, collect bounds
  for (i = 0, n = items.length; i < n; ++i) {
    mark = items[i];
    switch (mark.role) {
      case AxisRole$1:
        b = isYAxis(mark) ? xBounds : yBounds;
        b.union(axisLayout(view, mark, width, height));
        break;
      case TitleRole$1:
        title = mark;
        break;
      case LegendRole$1:
        legends.push(legendLayout(view, mark));
        break;
      case FrameRole$1:
      case ScopeRole$1:
      case RowHeader:
      case RowFooter:
      case RowTitle:
      case ColHeader:
      case ColFooter:
      case ColTitle:
        xBounds.union(mark.bounds);
        yBounds.union(mark.bounds);
        break;
      default:
        viewBounds.union(mark.bounds);
    }
  }

  // layout legends, adjust viewBounds
  if (legends.length) {
    // group legends by orient
    const l = {};
    legends.forEach(item => {
      orient = item.orient || Right$1;
      if (orient !== None) (l[orient] || (l[orient] = [])).push(item);
    });

    // perform grid layout for each orient group
    for (const orient in l) {
      const g = l[orient];
      gridLayout(view, g, legendParams(g, orient, _.legends, xBounds, yBounds, width, height));
    }

    // update view bounds
    legends.forEach(item => {
      const b = item.bounds;
      if (!b.equals(item._bounds)) {
        item.bounds = item._bounds;
        view.dirty(item); // dirty previous location
        item.bounds = b;
        view.dirty(item);
      }
      if (_.autosize && (_.autosize.type === Fit || _.autosize.type === FitX || _.autosize.type === FitY)) {
        // For autosize fit, incorporate the orthogonal dimension only.
        // Legends that overrun the chart area will then be clipped;
        // otherwise the chart area gets reduced to nothing!
        switch (item.orient) {
          case Left$1:
          case Right$1:
            viewBounds.add(b.x1, 0).add(b.x2, 0);
            break;
          case Top$1:
          case Bottom$1:
            viewBounds.add(0, b.y1).add(0, b.y2);
        }
      } else {
        viewBounds.union(b);
      }
    });
  }

  // combine bounding boxes
  viewBounds.union(xBounds).union(yBounds);

  // layout title, adjust bounds
  if (title) {
    viewBounds.union(titleLayout(view, title, width, height, viewBounds));
  }

  // override aggregated view bounds if content is clipped
  if (group.clip) {
    viewBounds.set(0, 0, group.width || 0, group.height || 0);
  }

  // perform size adjustment
  viewSizeLayout(view, group, viewBounds, _);
}
function viewSizeLayout(view, group, viewBounds, _) {
  const auto = _.autosize || {},
    type = auto.type;
  if (view._autosize < 1 || !type) return;
  let viewWidth = view._width,
    viewHeight = view._height,
    width = Math.max(0, group.width || 0),
    left = Math.max(0, Math.ceil(-viewBounds.x1)),
    height = Math.max(0, group.height || 0),
    top = Math.max(0, Math.ceil(-viewBounds.y1));
  const right = Math.max(0, Math.ceil(viewBounds.x2 - width)),
    bottom = Math.max(0, Math.ceil(viewBounds.y2 - height));
  if (auto.contains === Padding$1) {
    const padding = view.padding();
    viewWidth -= padding.left + padding.right;
    viewHeight -= padding.top + padding.bottom;
  }
  if (type === None) {
    left = 0;
    top = 0;
    width = viewWidth;
    height = viewHeight;
  } else if (type === Fit) {
    width = Math.max(0, viewWidth - left - right);
    height = Math.max(0, viewHeight - top - bottom);
  } else if (type === FitX) {
    width = Math.max(0, viewWidth - left - right);
    viewHeight = height + top + bottom;
  } else if (type === FitY) {
    viewWidth = width + left + right;
    height = Math.max(0, viewHeight - top - bottom);
  } else if (type === Pad) {
    viewWidth = width + left + right;
    viewHeight = height + top + bottom;
  }
  view._resizeView(viewWidth, viewHeight, width, height, [left, top], auto.resize);
}

var vtx = /*#__PURE__*/Object.freeze({
    __proto__: null,
    bound: Bound$1,
    identifier: Identifier$1,
    mark: Mark$1,
    overlap: Overlap$1,
    render: Render$1,
    viewlayout: ViewLayout$1
});

/**
 * Generates axis ticks for visualizing a spatial scale.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {Scale} params.scale - The scale to generate ticks for.
 * @param {*} [params.count=10] - The approximate number of ticks, or
 *   desired tick interval, to use.
 * @param {Array<*>} [params.values] - The exact tick values to use.
 *   These must be legal domain values for the provided scale.
 *   If provided, the count argument is ignored.
 * @param {function(*):string} [params.formatSpecifier] - A format specifier
 *   to use in conjunction with scale.tickFormat. Legal values are
 *   any valid d3 4.0 format specifier.
 * @param {function(*):string} [params.format] - The format function to use.
 *   If provided, the formatSpecifier argument is ignored.
 */
function AxisTicks$1(params) {
  Transform.call(this, null, params);
}
inherits(AxisTicks$1, Transform, {
  transform(_, pulse) {
    if (this.value && !_.modified()) {
      return pulse.StopPropagation;
    }
    var locale = pulse.dataflow.locale(),
      out = pulse.fork(pulse.NO_SOURCE | pulse.NO_FIELDS),
      ticks = this.value,
      scale = _.scale,
      tally = _.count == null ? _.values ? _.values.length : 10 : _.count,
      count = tickCount(scale, tally, _.minstep),
      format = _.format || tickFormat(locale, scale, count, _.formatSpecifier, _.formatType, !!_.values),
      values = _.values ? validTicks(scale, _.values, count) : tickValues(scale, count);
    if (ticks) out.rem = ticks;
    ticks = values.map((value, i) => ingest$1({
      index: i / (values.length - 1 || 1),
      value: value,
      label: format(value)
    }));
    if (_.extra && ticks.length) {
      // add an extra tick pegged to the initial domain value
      // this is used to generate axes with 'binned' domains
      ticks.push(ingest$1({
        index: -1,
        extra: {
          value: ticks[0].value
        },
        label: ''
      }));
    }
    out.source = ticks;
    out.add = ticks;
    this.value = ticks;
    return out;
  }
});

/**
 * Joins a set of data elements against a set of visual items.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {function(object): object} [params.item] - An item generator function.
 * @param {function(object): *} [params.key] - The key field associating data and visual items.
 */
function DataJoin$1(params) {
  Transform.call(this, null, params);
}
function defaultItemCreate() {
  return ingest$1({});
}
function newMap(key) {
  const map = fastmap().test(t => t.exit);
  map.lookup = t => map.get(key(t));
  return map;
}
inherits(DataJoin$1, Transform, {
  transform(_, pulse) {
    var df = pulse.dataflow,
      out = pulse.fork(pulse.NO_SOURCE | pulse.NO_FIELDS),
      item = _.item || defaultItemCreate,
      key = _.key || tupleid,
      map = this.value;

    // prevent transient (e.g., hover) requests from
    // cascading across marks derived from marks
    if (isArray(out.encode)) {
      out.encode = null;
    }
    if (map && (_.modified('key') || pulse.modified(key))) {
      error('DataJoin does not support modified key function or fields.');
    }
    if (!map) {
      pulse = pulse.addAll();
      this.value = map = newMap(key);
    }
    pulse.visit(pulse.ADD, t => {
      const k = key(t);
      let x = map.get(k);
      if (x) {
        if (x.exit) {
          map.empty--;
          out.add.push(x);
        } else {
          out.mod.push(x);
        }
      } else {
        x = item(t);
        map.set(k, x);
        out.add.push(x);
      }
      x.datum = t;
      x.exit = false;
    });
    pulse.visit(pulse.MOD, t => {
      const k = key(t),
        x = map.get(k);
      if (x) {
        x.datum = t;
        out.mod.push(x);
      }
    });
    pulse.visit(pulse.REM, t => {
      const k = key(t),
        x = map.get(k);
      if (t === x.datum && !x.exit) {
        out.rem.push(x);
        x.exit = true;
        ++map.empty;
      }
    });
    if (pulse.changed(pulse.ADD_MOD)) out.modifies('datum');
    if (pulse.clean() || _.clean && map.empty > df.cleanThreshold) {
      df.runAfter(map.clean);
    }
    return out;
  }
});

/**
 * Invokes encoding functions for visual items.
 * @constructor
 * @param {object} params - The parameters to the encoding functions. This
 *   parameter object will be passed through to all invoked encoding functions.
 * @param {object} [params.mod=false] - Flag indicating if tuples in the input
 *   mod set that are unmodified by encoders should be included in the output.
 * @param {object} param.encoders - The encoding functions
 * @param {function(object, object): boolean} [param.encoders.update] - Update encoding set
 * @param {function(object, object): boolean} [param.encoders.enter] - Enter encoding set
 * @param {function(object, object): boolean} [param.encoders.exit] - Exit encoding set
 */
function Encode$1(params) {
  Transform.call(this, null, params);
}
inherits(Encode$1, Transform, {
  transform(_, pulse) {
    var out = pulse.fork(pulse.ADD_REM),
      fmod = _.mod || false,
      encoders = _.encoders,
      encode = pulse.encode;

    // if an array, the encode directive includes additional sets
    // that must be defined in order for the primary set to be invoked
    // e.g., only run the update set if the hover set is defined
    if (isArray(encode)) {
      if (out.changed() || encode.every(e => encoders[e])) {
        encode = encode[0];
        out.encode = null; // consume targeted encode directive
      } else {
        return pulse.StopPropagation;
      }
    }

    // marshall encoder functions
    var reenter = encode === 'enter',
      update = encoders.update || falsy,
      enter = encoders.enter || falsy,
      exit = encoders.exit || falsy,
      set = (encode && !reenter ? encoders[encode] : update) || falsy;
    if (pulse.changed(pulse.ADD)) {
      pulse.visit(pulse.ADD, t => {
        enter(t, _);
        update(t, _);
      });
      out.modifies(enter.output);
      out.modifies(update.output);
      if (set !== falsy && set !== update) {
        pulse.visit(pulse.ADD, t => {
          set(t, _);
        });
        out.modifies(set.output);
      }
    }
    if (pulse.changed(pulse.REM) && exit !== falsy) {
      pulse.visit(pulse.REM, t => {
        exit(t, _);
      });
      out.modifies(exit.output);
    }
    if (reenter || set !== falsy) {
      const flag = pulse.MOD | (_.modified() ? pulse.REFLOW : 0);
      if (reenter) {
        pulse.visit(flag, t => {
          const mod = enter(t, _) || fmod;
          if (set(t, _) || mod) out.mod.push(t);
        });
        if (out.mod.length) out.modifies(enter.output);
      } else {
        pulse.visit(flag, t => {
          if (set(t, _) || fmod) out.mod.push(t);
        });
      }
      if (out.mod.length) out.modifies(set.output);
    }
    return out.changed() ? out : pulse.StopPropagation;
  }
});

/**
 * Generates legend entries for visualizing a scale.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {Scale} params.scale - The scale to generate items for.
 * @param {*} [params.count=5] - The approximate number of items, or
 *   desired tick interval, to use.
 * @param {*} [params.limit] - The maximum number of entries to
 *   include in a symbol legend.
 * @param {Array<*>} [params.values] - The exact tick values to use.
 *   These must be legal domain values for the provided scale.
 *   If provided, the count argument is ignored.
 * @param {string} [params.formatSpecifier] - A format specifier
 *   to use in conjunction with scale.tickFormat. Legal values are
 *   any valid D3 format specifier string.
 * @param {function(*):string} [params.format] - The format function to use.
 *   If provided, the formatSpecifier argument is ignored.
 */
function LegendEntries$1(params) {
  Transform.call(this, [], params);
}
inherits(LegendEntries$1, Transform, {
  transform(_, pulse) {
    if (this.value != null && !_.modified()) {
      return pulse.StopPropagation;
    }
    var locale = pulse.dataflow.locale(),
      out = pulse.fork(pulse.NO_SOURCE | pulse.NO_FIELDS),
      items = this.value,
      type = _.type || SymbolLegend,
      scale = _.scale,
      limit = +_.limit,
      count = tickCount(scale, _.count == null ? 5 : _.count, _.minstep),
      lskip = !!_.values || type === SymbolLegend,
      format = _.format || labelFormat(locale, scale, count, type, _.formatSpecifier, _.formatType, lskip),
      values = _.values || labelValues(scale, count),
      domain,
      fraction,
      size,
      offset,
      ellipsis;
    if (items) out.rem = items;
    if (type === SymbolLegend) {
      if (limit && values.length > limit) {
        pulse.dataflow.warn('Symbol legend count exceeds limit, filtering items.');
        items = values.slice(0, limit - 1);
        ellipsis = true;
      } else {
        items = values;
      }
      if (isFunction(size = _.size)) {
        // if first value maps to size zero, remove from list (vega#717)
        if (!_.values && scale(items[0]) === 0) {
          items = items.slice(1);
        }
        // compute size offset for legend entries
        offset = items.reduce((max, value) => Math.max(max, size(value, _)), 0);
      } else {
        size = constant$5(offset = size || 8);
      }
      items = items.map((value, index) => ingest$1({
        index: index,
        label: format(value, index, items),
        value: value,
        offset: offset,
        size: size(value, _)
      }));
      if (ellipsis) {
        ellipsis = values[items.length];
        items.push(ingest$1({
          index: items.length,
          label: `\u2026${values.length - items.length} entries`,
          value: ellipsis,
          offset: offset,
          size: size(ellipsis, _)
        }));
      }
    } else if (type === GradientLegend) {
      domain = scale.domain(), fraction = scaleFraction(scale, domain[0], peek$1(domain));

      // if automatic label generation produces 2 or fewer values,
      // use the domain end points instead (fixes vega/vega#1364)
      if (values.length < 3 && !_.values && domain[0] !== peek$1(domain)) {
        values = [domain[0], peek$1(domain)];
      }
      items = values.map((value, index) => ingest$1({
        index: index,
        label: format(value, index, values),
        value: value,
        perc: fraction(value)
      }));
    } else {
      size = values.length - 1;
      fraction = labelFraction(scale);
      items = values.map((value, index) => ingest$1({
        index: index,
        label: format(value, index, values),
        value: value,
        perc: index ? fraction(value) : 0,
        perc2: index === size ? 1 : fraction(values[index + 1])
      }));
    }
    out.source = items;
    out.add = items;
    this.value = items;
    return out;
  }
});
const sourceX = t => t.source.x;
const sourceY = t => t.source.y;
const targetX = t => t.target.x;
const targetY = t => t.target.y;

/**
 * Layout paths linking source and target elements.
 * @constructor
 * @param {object} params - The parameters for this operator.
 */
function LinkPath(params) {
  Transform.call(this, {}, params);
}
LinkPath.Definition = {
  'type': 'LinkPath',
  'metadata': {
    'modifies': true
  },
  'params': [{
    'name': 'sourceX',
    'type': 'field',
    'default': 'source.x'
  }, {
    'name': 'sourceY',
    'type': 'field',
    'default': 'source.y'
  }, {
    'name': 'targetX',
    'type': 'field',
    'default': 'target.x'
  }, {
    'name': 'targetY',
    'type': 'field',
    'default': 'target.y'
  }, {
    'name': 'orient',
    'type': 'enum',
    'default': 'vertical',
    'values': ['horizontal', 'vertical', 'radial']
  }, {
    'name': 'shape',
    'type': 'enum',
    'default': 'line',
    'values': ['line', 'arc', 'curve', 'diagonal', 'orthogonal']
  }, {
    'name': 'require',
    'type': 'signal'
  }, {
    'name': 'as',
    'type': 'string',
    'default': 'path'
  }]
};
inherits(LinkPath, Transform, {
  transform(_, pulse) {
    var sx = _.sourceX || sourceX,
      sy = _.sourceY || sourceY,
      tx = _.targetX || targetX,
      ty = _.targetY || targetY,
      as = _.as || 'path',
      orient = _.orient || 'vertical',
      shape = _.shape || 'line',
      path = Paths.get(shape + '-' + orient) || Paths.get(shape);
    if (!path) {
      error('LinkPath unsupported type: ' + _.shape + (_.orient ? '-' + _.orient : ''));
    }
    pulse.visit(pulse.SOURCE, t => {
      t[as] = path(sx(t), sy(t), tx(t), ty(t));
    });
    return pulse.reflow(_.modified()).modifies(as);
  }
});
const line = (sx, sy, tx, ty) => 'M' + sx + ',' + sy + 'L' + tx + ',' + ty;
const lineR = (sa, sr, ta, tr) => line(sr * Math.cos(sa), sr * Math.sin(sa), tr * Math.cos(ta), tr * Math.sin(ta));
const arc = (sx, sy, tx, ty) => {
  var dx = tx - sx,
    dy = ty - sy,
    rr = Math.hypot(dx, dy) / 2,
    ra = 180 * Math.atan2(dy, dx) / Math.PI;
  return 'M' + sx + ',' + sy + 'A' + rr + ',' + rr + ' ' + ra + ' 0 1' + ' ' + tx + ',' + ty;
};
const arcR = (sa, sr, ta, tr) => arc(sr * Math.cos(sa), sr * Math.sin(sa), tr * Math.cos(ta), tr * Math.sin(ta));
const curve = (sx, sy, tx, ty) => {
  const dx = tx - sx,
    dy = ty - sy,
    ix = 0.2 * (dx + dy),
    iy = 0.2 * (dy - dx);
  return 'M' + sx + ',' + sy + 'C' + (sx + ix) + ',' + (sy + iy) + ' ' + (tx + iy) + ',' + (ty - ix) + ' ' + tx + ',' + ty;
};
const curveR = (sa, sr, ta, tr) => curve(sr * Math.cos(sa), sr * Math.sin(sa), tr * Math.cos(ta), tr * Math.sin(ta));
const orthoX = (sx, sy, tx, ty) => 'M' + sx + ',' + sy + 'V' + ty + 'H' + tx;
const orthoY = (sx, sy, tx, ty) => 'M' + sx + ',' + sy + 'H' + tx + 'V' + ty;
const orthoR = (sa, sr, ta, tr) => {
  const sc = Math.cos(sa),
    ss = Math.sin(sa),
    tc = Math.cos(ta),
    ts = Math.sin(ta),
    sf = Math.abs(ta - sa) > Math.PI ? ta <= sa : ta > sa;
  return 'M' + sr * sc + ',' + sr * ss + 'A' + sr + ',' + sr + ' 0 0,' + (sf ? 1 : 0) + ' ' + sr * tc + ',' + sr * ts + 'L' + tr * tc + ',' + tr * ts;
};
const diagonalX = (sx, sy, tx, ty) => {
  const m = (sx + tx) / 2;
  return 'M' + sx + ',' + sy + 'C' + m + ',' + sy + ' ' + m + ',' + ty + ' ' + tx + ',' + ty;
};
const diagonalY = (sx, sy, tx, ty) => {
  const m = (sy + ty) / 2;
  return 'M' + sx + ',' + sy + 'C' + sx + ',' + m + ' ' + tx + ',' + m + ' ' + tx + ',' + ty;
};
const diagonalR = (sa, sr, ta, tr) => {
  const sc = Math.cos(sa),
    ss = Math.sin(sa),
    tc = Math.cos(ta),
    ts = Math.sin(ta),
    mr = (sr + tr) / 2;
  return 'M' + sr * sc + ',' + sr * ss + 'C' + mr * sc + ',' + mr * ss + ' ' + mr * tc + ',' + mr * ts + ' ' + tr * tc + ',' + tr * ts;
};
const Paths = fastmap({
  'line': line,
  'line-radial': lineR,
  'arc': arc,
  'arc-radial': arcR,
  'curve': curve,
  'curve-radial': curveR,
  'orthogonal-horizontal': orthoX,
  'orthogonal-vertical': orthoY,
  'orthogonal-radial': orthoR,
  'diagonal-horizontal': diagonalX,
  'diagonal-vertical': diagonalY,
  'diagonal-radial': diagonalR
});

/**
 * Pie and donut chart layout.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {function(object): *} params.field - The value field to size pie segments.
 * @param {number} [params.startAngle=0] - The start angle (in radians) of the layout.
 * @param {number} [params.endAngle=2π] - The end angle (in radians) of the layout.
 * @param {boolean} [params.sort] - Boolean flag for sorting sectors by value.
 */
function Pie(params) {
  Transform.call(this, null, params);
}
Pie.Definition = {
  'type': 'Pie',
  'metadata': {
    'modifies': true
  },
  'params': [{
    'name': 'field',
    'type': 'field'
  }, {
    'name': 'startAngle',
    'type': 'number',
    'default': 0
  }, {
    'name': 'endAngle',
    'type': 'number',
    'default': 6.283185307179586
  }, {
    'name': 'sort',
    'type': 'boolean',
    'default': false
  }, {
    'name': 'as',
    'type': 'string',
    'array': true,
    'length': 2,
    'default': ['startAngle', 'endAngle']
  }]
};
inherits(Pie, Transform, {
  transform(_, pulse) {
    var as = _.as || ['startAngle', 'endAngle'],
      startAngle = as[0],
      endAngle = as[1],
      field = _.field || one$2,
      start = _.startAngle || 0,
      stop = _.endAngle != null ? _.endAngle : 2 * Math.PI,
      data = pulse.source,
      values = data.map(field),
      n = values.length,
      a = start,
      k = (stop - start) / sum$1(values),
      index = range$3(n),
      i,
      t,
      v;
    if (_.sort) {
      index.sort((a, b) => values[a] - values[b]);
    }
    for (i = 0; i < n; ++i) {
      v = values[index[i]];
      t = data[index[i]];
      t[startAngle] = a;
      t[endAngle] = a += v * k;
    }
    this.value = values;
    return pulse.reflow(_.modified()).modifies(as);
  }
});
const DEFAULT_COUNT = 5;
function includeZero(scale) {
  const type = scale.type;
  return !scale.bins && (type === Linear || type === Pow || type === Sqrt);
}
function includePad(type) {
  return isContinuous(type) && type !== Sequential;
}
const SKIP$1 = toSet(['set', 'modified', 'clear', 'type', 'scheme', 'schemeExtent', 'schemeCount', 'domain', 'domainMin', 'domainMid', 'domainMax', 'domainRaw', 'domainImplicit', 'nice', 'zero', 'bins', 'range', 'rangeStep', 'round', 'reverse', 'interpolate', 'interpolateGamma']);

/**
 * Maintains a scale function mapping data values to visual channels.
 * @constructor
 * @param {object} params - The parameters for this operator.
 */
function Scale$1(params) {
  Transform.call(this, null, params);
  this.modified(true); // always treat as modified
}
inherits(Scale$1, Transform, {
  transform(_, pulse) {
    var df = pulse.dataflow,
      scale$1 = this.value,
      key = scaleKey(_);
    if (!scale$1 || key !== scale$1.type) {
      this.value = scale$1 = scale$4(key)();
    }
    for (key in _) if (!SKIP$1[key]) {
      // padding is a scale property for band/point but not others
      if (key === 'padding' && includePad(scale$1.type)) continue;
      // invoke scale property setter, raise warning if not found
      isFunction(scale$1[key]) ? scale$1[key](_[key]) : df.warn('Unsupported scale property: ' + key);
    }
    configureRange(scale$1, _, configureBins(scale$1, _, configureDomain(scale$1, _, df)));
    return pulse.fork(pulse.NO_SOURCE | pulse.NO_FIELDS);
  }
});
function scaleKey(_) {
  var t = _.type,
    d = '',
    n;

  // backwards compatibility pre Vega 5.
  if (t === Sequential) return Sequential + '-' + Linear;
  if (isContinuousColor(_)) {
    n = _.rawDomain ? _.rawDomain.length : _.domain ? _.domain.length + +(_.domainMid != null) : 0;
    d = n === 2 ? Sequential + '-' : n === 3 ? Diverging + '-' : '';
  }
  return (d + t || Linear).toLowerCase();
}
function isContinuousColor(_) {
  const t = _.type;
  return isContinuous(t) && t !== Time && t !== UTC && (_.scheme || _.range && _.range.length && _.range.every(isString));
}
function configureDomain(scale, _, df) {
  // check raw domain, if provided use that and exit early
  const raw = rawDomain(scale, _.domainRaw, df);
  if (raw > -1) return raw;
  var domain = _.domain,
    type = scale.type,
    zero = _.zero || _.zero === undefined && includeZero(scale),
    n,
    mid;
  if (!domain) return 0;

  // adjust domain based on zero, min, max settings
  if (zero || _.domainMin != null || _.domainMax != null || _.domainMid != null) {
    n = (domain = domain.slice()).length - 1 || 1;
    if (zero) {
      if (domain[0] > 0) domain[0] = 0;
      if (domain[n] < 0) domain[n] = 0;
    }
    if (_.domainMin != null) domain[0] = _.domainMin;
    if (_.domainMax != null) domain[n] = _.domainMax;
    if (_.domainMid != null) {
      mid = _.domainMid;
      const i = mid > domain[n] ? n + 1 : mid < domain[0] ? 0 : n;
      if (i !== n) df.warn('Scale domainMid exceeds domain min or max.', mid);
      domain.splice(i, 0, mid);
    }
  }

  // adjust continuous domain for minimum pixel padding
  if (includePad(type) && _.padding && domain[0] !== peek$1(domain)) {
    domain = padDomain(type, domain, _.range, _.padding, _.exponent, _.constant);
  }

  // set the scale domain
  scale.domain(domainCheck(type, domain, df));

  // if ordinal scale domain is defined, prevent implicit
  // domain construction as side-effect of scale lookup
  if (type === Ordinal) {
    scale.unknown(_.domainImplicit ? implicit : undefined);
  }

  // perform 'nice' adjustment as requested
  if (_.nice && scale.nice) {
    scale.nice(_.nice !== true && tickCount(scale, _.nice) || null);
  }

  // return the cardinality of the domain
  return domain.length;
}
function rawDomain(scale, raw, df) {
  if (raw) {
    scale.domain(domainCheck(scale.type, raw, df));
    return raw.length;
  } else {
    return -1;
  }
}
function padDomain(type, domain, range, pad, exponent, constant) {
  var span = Math.abs(peek$1(range) - range[0]),
    frac = span / (span - 2 * pad),
    d = type === Log ? zoomLog(domain, null, frac) : type === Sqrt ? zoomPow(domain, null, frac, 0.5) : type === Pow ? zoomPow(domain, null, frac, exponent || 1) : type === Symlog ? zoomSymlog(domain, null, frac, constant || 1) : zoomLinear(domain, null, frac);
  domain = domain.slice();
  domain[0] = d[0];
  domain[domain.length - 1] = d[1];
  return domain;
}
function domainCheck(type, domain, df) {
  if (isLogarithmic(type)) {
    // sum signs of domain values
    // if all pos or all neg, abs(sum) === domain.length
    var s = Math.abs(domain.reduce((s, v) => s + (v < 0 ? -1 : v > 0 ? 1 : 0), 0));
    if (s !== domain.length) {
      df.warn('Log scale domain includes zero: ' + $(domain));
    }
  }
  return domain;
}
function configureBins(scale, _, count) {
  let bins = _.bins;
  if (bins && !isArray(bins)) {
    // generate bin boundary array
    const domain = scale.domain(),
      lo = domain[0],
      hi = peek$1(domain),
      step = bins.step;
    let start = bins.start == null ? lo : bins.start,
      stop = bins.stop == null ? hi : bins.stop;
    if (!step) error('Scale bins parameter missing step property.');
    if (start < lo) start = step * Math.ceil(lo / step);
    if (stop > hi) stop = step * Math.floor(hi / step);
    bins = range$3(start, stop + step / 2, step);
  }
  if (bins) {
    // assign bin boundaries to scale instance
    scale.bins = bins;
  } else if (scale.bins) {
    // no current bins, remove bins if previously set
    delete scale.bins;
  }

  // special handling for bin-ordinal scales
  if (scale.type === BinOrdinal) {
    if (!bins) {
      // the domain specifies the bins
      scale.bins = scale.domain();
    } else if (!_.domain && !_.domainRaw) {
      // the bins specify the domain
      scale.domain(bins);
      count = bins.length;
    }
  }

  // return domain cardinality
  return count;
}
function configureRange(scale, _, count) {
  var type = scale.type,
    round = _.round || false,
    range = _.range;

  // if range step specified, calculate full range extent
  if (_.rangeStep != null) {
    range = configureRangeStep(type, _, count);
  }

  // else if a range scheme is defined, use that
  else if (_.scheme) {
    range = configureScheme(type, _, count);
    if (isFunction(range)) {
      if (scale.interpolator) {
        return scale.interpolator(range);
      } else {
        error(`Scale type ${type} does not support interpolating color schemes.`);
      }
    }
  }

  // given a range array for an interpolating scale, convert to interpolator
  if (range && isInterpolating(type)) {
    return scale.interpolator(interpolateColors(flip(range, _.reverse), _.interpolate, _.interpolateGamma));
  }

  // configure rounding / interpolation
  if (range && _.interpolate && scale.interpolate) {
    scale.interpolate(interpolate(_.interpolate, _.interpolateGamma));
  } else if (isFunction(scale.round)) {
    scale.round(round);
  } else if (isFunction(scale.rangeRound)) {
    scale.interpolate(round ? interpolateRound : interpolate$1);
  }
  if (range) scale.range(flip(range, _.reverse));
}
function configureRangeStep(type, _, count) {
  if (type !== Band && type !== Point) {
    error('Only band and point scales support rangeStep.');
  }

  // calculate full range based on requested step size and padding
  var outer = (_.paddingOuter != null ? _.paddingOuter : _.padding) || 0,
    inner = type === Point ? 1 : (_.paddingInner != null ? _.paddingInner : _.padding) || 0;
  return [0, _.rangeStep * bandSpace(count, inner, outer)];
}
function configureScheme(type, _, count) {
  var extent = _.schemeExtent,
    name,
    scheme$1;
  if (isArray(_.scheme)) {
    scheme$1 = interpolateColors(_.scheme, _.interpolate, _.interpolateGamma);
  } else {
    name = _.scheme.toLowerCase();
    scheme$1 = scheme(name);
    if (!scheme$1) error(`Unrecognized scheme name: ${_.scheme}`);
  }

  // determine size for potential discrete range
  count = type === Threshold ? count + 1 : type === BinOrdinal ? count - 1 : type === Quantile || type === Quantize ? +_.schemeCount || DEFAULT_COUNT : count;

  // adjust and/or quantize scheme as appropriate
  return isInterpolating(type) ? adjustScheme(scheme$1, extent, _.reverse) : isFunction(scheme$1) ? quantizeInterpolator(adjustScheme(scheme$1, extent), count) : type === Ordinal ? scheme$1 : scheme$1.slice(0, count);
}
function adjustScheme(scheme, extent, reverse) {
  return isFunction(scheme) && (extent || reverse) ? interpolateRange(scheme, flip(extent || [0, 1], reverse)) : scheme;
}
function flip(array, reverse) {
  return reverse ? array.slice().reverse() : array;
}

/**
 * Sorts scenegraph items in the pulse source array.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {function(*,*): number} [params.sort] - A comparator
 *   function for sorting tuples.
 */
function SortItems$1(params) {
  Transform.call(this, null, params);
}
inherits(SortItems$1, Transform, {
  transform(_, pulse) {
    const mod = _.modified('sort') || pulse.changed(pulse.ADD) || pulse.modified(_.sort.fields) || pulse.modified('datum');
    if (mod) pulse.source.sort(stableCompare(_.sort));
    this.modified(mod);
    return pulse;
  }
});
const Zero = 'zero',
  Center$1 = 'center',
  Normalize = 'normalize',
  DefOutput = ['y0', 'y1'];

/**
 * Stack layout for visualization elements.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {function(object): *} params.field - The value field to stack.
 * @param {Array<function(object): *>} [params.groupby] - An array of accessors to groupby.
 * @param {function(object,object): number} [params.sort] - A comparator for stack sorting.
 * @param {string} [offset='zero'] - Stack baseline offset. One of 'zero', 'center', 'normalize'.
 */
function Stack(params) {
  Transform.call(this, null, params);
}
Stack.Definition = {
  'type': 'Stack',
  'metadata': {
    'modifies': true
  },
  'params': [{
    'name': 'field',
    'type': 'field'
  }, {
    'name': 'groupby',
    'type': 'field',
    'array': true
  }, {
    'name': 'sort',
    'type': 'compare'
  }, {
    'name': 'offset',
    'type': 'enum',
    'default': Zero,
    'values': [Zero, Center$1, Normalize]
  }, {
    'name': 'as',
    'type': 'string',
    'array': true,
    'length': 2,
    'default': DefOutput
  }]
};
inherits(Stack, Transform, {
  transform(_, pulse) {
    var as = _.as || DefOutput,
      y0 = as[0],
      y1 = as[1],
      sort = stableCompare(_.sort),
      field = _.field || one$2,
      stack = _.offset === Center$1 ? stackCenter : _.offset === Normalize ? stackNormalize : stackZero,
      groups,
      i,
      n,
      max;

    // partition, sum, and sort the stack groups
    groups = partition$3(pulse.source, _.groupby, sort, field);

    // compute stack layouts per group
    for (i = 0, n = groups.length, max = groups.max; i < n; ++i) {
      stack(groups[i], max, field, y0, y1);
    }
    return pulse.reflow(_.modified()).modifies(as);
  }
});
function stackCenter(group, max, field, y0, y1) {
  var last = (max - group.sum) / 2,
    m = group.length,
    j = 0,
    t;
  for (; j < m; ++j) {
    t = group[j];
    t[y0] = last;
    t[y1] = last += Math.abs(field(t));
  }
}
function stackNormalize(group, max, field, y0, y1) {
  var scale = 1 / group.sum,
    last = 0,
    m = group.length,
    j = 0,
    v = 0,
    t;
  for (; j < m; ++j) {
    t = group[j];
    t[y0] = last;
    t[y1] = last = scale * (v += Math.abs(field(t)));
  }
}
function stackZero(group, max, field, y0, y1) {
  var lastPos = 0,
    lastNeg = 0,
    m = group.length,
    j = 0,
    v,
    t;
  for (; j < m; ++j) {
    t = group[j];
    v = +field(t);
    if (v < 0) {
      t[y0] = lastNeg;
      t[y1] = lastNeg += v;
    } else {
      t[y0] = lastPos;
      t[y1] = lastPos += v;
    }
  }
}
function partition$3(data, groupby, sort, field) {
  var groups = [],
    get = f => f(t),
    map,
    i,
    n,
    m,
    t,
    k,
    g,
    s,
    max;

  // partition data points into stack groups
  if (groupby == null) {
    groups.push(data.slice());
  } else {
    for (map = {}, i = 0, n = data.length; i < n; ++i) {
      t = data[i];
      k = groupby.map(get);
      g = map[k];
      if (!g) {
        map[k] = g = [];
        groups.push(g);
      }
      g.push(t);
    }
  }

  // compute sums of groups, sort groups as needed
  for (k = 0, max = 0, m = groups.length; k < m; ++k) {
    g = groups[k];
    for (i = 0, s = 0, n = g.length; i < n; ++i) {
      s += Math.abs(field(g[i]));
    }
    g.sum = s;
    if (s > max) max = s;
    if (sort) g.sort(sort);
  }
  groups.max = max;
  return groups;
}

var encode$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    axisticks: AxisTicks$1,
    datajoin: DataJoin$1,
    encode: Encode$1,
    legendentries: LegendEntries$1,
    linkpath: LinkPath,
    pie: Pie,
    scale: Scale$1,
    sortitems: SortItems$1,
    stack: Stack
});

var epsilon$3 = 1e-6;
var epsilon2 = 1e-12;
var pi$1 = Math.PI;
var halfPi$1 = pi$1 / 2;
var quarterPi = pi$1 / 4;
var tau$1 = pi$1 * 2;
var degrees = 180 / pi$1;
var radians = pi$1 / 180;
var abs$1 = Math.abs;
var atan = Math.atan;
var atan2 = Math.atan2;
var cos$1 = Math.cos;
var ceil = Math.ceil;
var exp = Math.exp;
var hypot = Math.hypot;
var log$1 = Math.log;
var pow$1 = Math.pow;
var sin$1 = Math.sin;
var sign = Math.sign || function (x) {
  return x > 0 ? 1 : x < 0 ? -1 : 0;
};
var sqrt$1 = Math.sqrt;
var tan = Math.tan;
function acos(x) {
  return x > 1 ? 0 : x < -1 ? pi$1 : Math.acos(x);
}
function asin$1(x) {
  return x > 1 ? halfPi$1 : x < -1 ? -halfPi$1 : Math.asin(x);
}

function noop$2() {}

function streamGeometry(geometry, stream) {
  if (geometry && streamGeometryType.hasOwnProperty(geometry.type)) {
    streamGeometryType[geometry.type](geometry, stream);
  }
}
var streamObjectType = {
  Feature: function (object, stream) {
    streamGeometry(object.geometry, stream);
  },
  FeatureCollection: function (object, stream) {
    var features = object.features,
      i = -1,
      n = features.length;
    while (++i < n) streamGeometry(features[i].geometry, stream);
  }
};
var streamGeometryType = {
  Sphere: function (object, stream) {
    stream.sphere();
  },
  Point: function (object, stream) {
    object = object.coordinates;
    stream.point(object[0], object[1], object[2]);
  },
  MultiPoint: function (object, stream) {
    var coordinates = object.coordinates,
      i = -1,
      n = coordinates.length;
    while (++i < n) object = coordinates[i], stream.point(object[0], object[1], object[2]);
  },
  LineString: function (object, stream) {
    streamLine(object.coordinates, stream, 0);
  },
  MultiLineString: function (object, stream) {
    var coordinates = object.coordinates,
      i = -1,
      n = coordinates.length;
    while (++i < n) streamLine(coordinates[i], stream, 0);
  },
  Polygon: function (object, stream) {
    streamPolygon(object.coordinates, stream);
  },
  MultiPolygon: function (object, stream) {
    var coordinates = object.coordinates,
      i = -1,
      n = coordinates.length;
    while (++i < n) streamPolygon(coordinates[i], stream);
  },
  GeometryCollection: function (object, stream) {
    var geometries = object.geometries,
      i = -1,
      n = geometries.length;
    while (++i < n) streamGeometry(geometries[i], stream);
  }
};
function streamLine(coordinates, stream, closed) {
  var i = -1,
    n = coordinates.length - closed,
    coordinate;
  stream.lineStart();
  while (++i < n) coordinate = coordinates[i], stream.point(coordinate[0], coordinate[1], coordinate[2]);
  stream.lineEnd();
}
function streamPolygon(coordinates, stream) {
  var i = -1,
    n = coordinates.length;
  stream.polygonStart();
  while (++i < n) streamLine(coordinates[i], stream, 1);
  stream.polygonEnd();
}
function geoStream (object, stream) {
  if (object && streamObjectType.hasOwnProperty(object.type)) {
    streamObjectType[object.type](object, stream);
  } else {
    streamGeometry(object, stream);
  }
}

var areaRingSum$1 = new Adder();

// hello?

var areaSum$1 = new Adder(),
  lambda00$2,
  phi00$2,
  lambda0$1,
  cosPhi0,
  sinPhi0;
var areaStream$1 = {
  point: noop$2,
  lineStart: noop$2,
  lineEnd: noop$2,
  polygonStart: function () {
    areaRingSum$1 = new Adder();
    areaStream$1.lineStart = areaRingStart$1;
    areaStream$1.lineEnd = areaRingEnd$1;
  },
  polygonEnd: function () {
    var areaRing = +areaRingSum$1;
    areaSum$1.add(areaRing < 0 ? tau$1 + areaRing : areaRing);
    this.lineStart = this.lineEnd = this.point = noop$2;
  },
  sphere: function () {
    areaSum$1.add(tau$1);
  }
};
function areaRingStart$1() {
  areaStream$1.point = areaPointFirst$1;
}
function areaRingEnd$1() {
  areaPoint$1(lambda00$2, phi00$2);
}
function areaPointFirst$1(lambda, phi) {
  areaStream$1.point = areaPoint$1;
  lambda00$2 = lambda, phi00$2 = phi;
  lambda *= radians, phi *= radians;
  lambda0$1 = lambda, cosPhi0 = cos$1(phi = phi / 2 + quarterPi), sinPhi0 = sin$1(phi);
}
function areaPoint$1(lambda, phi) {
  lambda *= radians, phi *= radians;
  phi = phi / 2 + quarterPi; // half the angular distance from south pole

  // Spherical excess E for a spherical triangle with vertices: south pole,
  // previous point, current point.  Uses a formula derived from Cagnoli’s
  // theorem.  See Todhunter, Spherical Trig. (1871), Sec. 103, Eq. (2).
  var dLambda = lambda - lambda0$1,
    sdLambda = dLambda >= 0 ? 1 : -1,
    adLambda = sdLambda * dLambda,
    cosPhi = cos$1(phi),
    sinPhi = sin$1(phi),
    k = sinPhi0 * sinPhi,
    u = cosPhi0 * cosPhi + k * cos$1(adLambda),
    v = k * sdLambda * sin$1(adLambda);
  areaRingSum$1.add(atan2(v, u));

  // Advance the previous points.
  lambda0$1 = lambda, cosPhi0 = cosPhi, sinPhi0 = sinPhi;
}
function geoArea$1 (object) {
  areaSum$1 = new Adder();
  geoStream(object, areaStream$1);
  return areaSum$1 * 2;
}

function spherical(cartesian) {
  return [atan2(cartesian[1], cartesian[0]), asin$1(cartesian[2])];
}
function cartesian(spherical) {
  var lambda = spherical[0],
    phi = spherical[1],
    cosPhi = cos$1(phi);
  return [cosPhi * cos$1(lambda), cosPhi * sin$1(lambda), sin$1(phi)];
}
function cartesianDot(a, b) {
  return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
}
function cartesianCross(a, b) {
  return [a[1] * b[2] - a[2] * b[1], a[2] * b[0] - a[0] * b[2], a[0] * b[1] - a[1] * b[0]];
}

// TODO return a
function cartesianAddInPlace(a, b) {
  a[0] += b[0], a[1] += b[1], a[2] += b[2];
}
function cartesianScale(vector, k) {
  return [vector[0] * k, vector[1] * k, vector[2] * k];
}

// TODO return d
function cartesianNormalizeInPlace(d) {
  var l = sqrt$1(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]);
  d[0] /= l, d[1] /= l, d[2] /= l;
}

var lambda0, phi0, lambda1, phi1,
  // bounds
  lambda2,
  // previous lambda-coordinate
  lambda00$1, phi00$1,
  // first point
  p0,
  // previous 3D point
  deltaSum, ranges, range$2;
var boundsStream$1 = {
  point: boundsPoint$1,
  lineStart: boundsLineStart,
  lineEnd: boundsLineEnd,
  polygonStart: function () {
    boundsStream$1.point = boundsRingPoint;
    boundsStream$1.lineStart = boundsRingStart;
    boundsStream$1.lineEnd = boundsRingEnd;
    deltaSum = new Adder();
    areaStream$1.polygonStart();
  },
  polygonEnd: function () {
    areaStream$1.polygonEnd();
    boundsStream$1.point = boundsPoint$1;
    boundsStream$1.lineStart = boundsLineStart;
    boundsStream$1.lineEnd = boundsLineEnd;
    if (areaRingSum$1 < 0) lambda0 = -(lambda1 = 180), phi0 = -(phi1 = 90);else if (deltaSum > epsilon$3) phi1 = 90;else if (deltaSum < -1e-6) phi0 = -90;
    range$2[0] = lambda0, range$2[1] = lambda1;
  },
  sphere: function () {
    lambda0 = -(lambda1 = 180), phi0 = -(phi1 = 90);
  }
};
function boundsPoint$1(lambda, phi) {
  ranges.push(range$2 = [lambda0 = lambda, lambda1 = lambda]);
  if (phi < phi0) phi0 = phi;
  if (phi > phi1) phi1 = phi;
}
function linePoint(lambda, phi) {
  var p = cartesian([lambda * radians, phi * radians]);
  if (p0) {
    var normal = cartesianCross(p0, p),
      equatorial = [normal[1], -normal[0], 0],
      inflection = cartesianCross(equatorial, normal);
    cartesianNormalizeInPlace(inflection);
    inflection = spherical(inflection);
    var delta = lambda - lambda2,
      sign = delta > 0 ? 1 : -1,
      lambdai = inflection[0] * degrees * sign,
      phii,
      antimeridian = abs$1(delta) > 180;
    if (antimeridian ^ (sign * lambda2 < lambdai && lambdai < sign * lambda)) {
      phii = inflection[1] * degrees;
      if (phii > phi1) phi1 = phii;
    } else if (lambdai = (lambdai + 360) % 360 - 180, antimeridian ^ (sign * lambda2 < lambdai && lambdai < sign * lambda)) {
      phii = -inflection[1] * degrees;
      if (phii < phi0) phi0 = phii;
    } else {
      if (phi < phi0) phi0 = phi;
      if (phi > phi1) phi1 = phi;
    }
    if (antimeridian) {
      if (lambda < lambda2) {
        if (angle(lambda0, lambda) > angle(lambda0, lambda1)) lambda1 = lambda;
      } else {
        if (angle(lambda, lambda1) > angle(lambda0, lambda1)) lambda0 = lambda;
      }
    } else {
      if (lambda1 >= lambda0) {
        if (lambda < lambda0) lambda0 = lambda;
        if (lambda > lambda1) lambda1 = lambda;
      } else {
        if (lambda > lambda2) {
          if (angle(lambda0, lambda) > angle(lambda0, lambda1)) lambda1 = lambda;
        } else {
          if (angle(lambda, lambda1) > angle(lambda0, lambda1)) lambda0 = lambda;
        }
      }
    }
  } else {
    ranges.push(range$2 = [lambda0 = lambda, lambda1 = lambda]);
  }
  if (phi < phi0) phi0 = phi;
  if (phi > phi1) phi1 = phi;
  p0 = p, lambda2 = lambda;
}
function boundsLineStart() {
  boundsStream$1.point = linePoint;
}
function boundsLineEnd() {
  range$2[0] = lambda0, range$2[1] = lambda1;
  boundsStream$1.point = boundsPoint$1;
  p0 = null;
}
function boundsRingPoint(lambda, phi) {
  if (p0) {
    var delta = lambda - lambda2;
    deltaSum.add(abs$1(delta) > 180 ? delta + (delta > 0 ? 360 : -360) : delta);
  } else {
    lambda00$1 = lambda, phi00$1 = phi;
  }
  areaStream$1.point(lambda, phi);
  linePoint(lambda, phi);
}
function boundsRingStart() {
  areaStream$1.lineStart();
}
function boundsRingEnd() {
  boundsRingPoint(lambda00$1, phi00$1);
  areaStream$1.lineEnd();
  if (abs$1(deltaSum) > epsilon$3) lambda0 = -(lambda1 = 180);
  range$2[0] = lambda0, range$2[1] = lambda1;
  p0 = null;
}

// Finds the left-right distance between two longitudes.
// This is almost the same as (lambda1 - lambda0 + 360°) % 360°, except that we want
// the distance between ±180° to be 360°.
function angle(lambda0, lambda1) {
  return (lambda1 -= lambda0) < 0 ? lambda1 + 360 : lambda1;
}
function rangeCompare(a, b) {
  return a[0] - b[0];
}
function rangeContains(range, x) {
  return range[0] <= range[1] ? range[0] <= x && x <= range[1] : x < range[0] || range[1] < x;
}
function geoBounds$1 (feature) {
  var i, n, a, b, merged, deltaMax, delta;
  phi1 = lambda1 = -(lambda0 = phi0 = Infinity);
  ranges = [];
  geoStream(feature, boundsStream$1);

  // First, sort ranges by their minimum longitudes.
  if (n = ranges.length) {
    ranges.sort(rangeCompare);

    // Then, merge any ranges that overlap.
    for (i = 1, a = ranges[0], merged = [a]; i < n; ++i) {
      b = ranges[i];
      if (rangeContains(a, b[0]) || rangeContains(a, b[1])) {
        if (angle(a[0], b[1]) > angle(a[0], a[1])) a[1] = b[1];
        if (angle(b[0], a[1]) > angle(a[0], a[1])) a[0] = b[0];
      } else {
        merged.push(a = b);
      }
    }

    // Finally, find the largest gap between the merged ranges.
    // The final bounding box will be the inverse of this gap.
    for (deltaMax = -Infinity, n = merged.length - 1, i = 0, a = merged[n]; i <= n; a = b, ++i) {
      b = merged[i];
      if ((delta = angle(a[1], b[0])) > deltaMax) deltaMax = delta, lambda0 = b[0], lambda1 = a[1];
    }
  }
  ranges = range$2 = null;
  return lambda0 === Infinity || phi0 === Infinity ? [[NaN, NaN], [NaN, NaN]] : [[lambda0, phi0], [lambda1, phi1]];
}

var W0, W1, X0$1, Y0$1, Z0$1, X1$1, Y1$1, Z1$1, X2$1, Y2$1, Z2$1, lambda00, phi00,
  // first point
  x0$4, y0$4, z0; // previous point

var centroidStream$1 = {
  sphere: noop$2,
  point: centroidPoint$1,
  lineStart: centroidLineStart$1,
  lineEnd: centroidLineEnd$1,
  polygonStart: function () {
    centroidStream$1.lineStart = centroidRingStart$1;
    centroidStream$1.lineEnd = centroidRingEnd$1;
  },
  polygonEnd: function () {
    centroidStream$1.lineStart = centroidLineStart$1;
    centroidStream$1.lineEnd = centroidLineEnd$1;
  }
};

// Arithmetic mean of Cartesian vectors.
function centroidPoint$1(lambda, phi) {
  lambda *= radians, phi *= radians;
  var cosPhi = cos$1(phi);
  centroidPointCartesian(cosPhi * cos$1(lambda), cosPhi * sin$1(lambda), sin$1(phi));
}
function centroidPointCartesian(x, y, z) {
  ++W0;
  X0$1 += (x - X0$1) / W0;
  Y0$1 += (y - Y0$1) / W0;
  Z0$1 += (z - Z0$1) / W0;
}
function centroidLineStart$1() {
  centroidStream$1.point = centroidLinePointFirst;
}
function centroidLinePointFirst(lambda, phi) {
  lambda *= radians, phi *= radians;
  var cosPhi = cos$1(phi);
  x0$4 = cosPhi * cos$1(lambda);
  y0$4 = cosPhi * sin$1(lambda);
  z0 = sin$1(phi);
  centroidStream$1.point = centroidLinePoint;
  centroidPointCartesian(x0$4, y0$4, z0);
}
function centroidLinePoint(lambda, phi) {
  lambda *= radians, phi *= radians;
  var cosPhi = cos$1(phi),
    x = cosPhi * cos$1(lambda),
    y = cosPhi * sin$1(lambda),
    z = sin$1(phi),
    w = atan2(sqrt$1((w = y0$4 * z - z0 * y) * w + (w = z0 * x - x0$4 * z) * w + (w = x0$4 * y - y0$4 * x) * w), x0$4 * x + y0$4 * y + z0 * z);
  W1 += w;
  X1$1 += w * (x0$4 + (x0$4 = x));
  Y1$1 += w * (y0$4 + (y0$4 = y));
  Z1$1 += w * (z0 + (z0 = z));
  centroidPointCartesian(x0$4, y0$4, z0);
}
function centroidLineEnd$1() {
  centroidStream$1.point = centroidPoint$1;
}

// See J. E. Brock, The Inertia Tensor for a Spherical Triangle,
// J. Applied Mechanics 42, 239 (1975).
function centroidRingStart$1() {
  centroidStream$1.point = centroidRingPointFirst;
}
function centroidRingEnd$1() {
  centroidRingPoint(lambda00, phi00);
  centroidStream$1.point = centroidPoint$1;
}
function centroidRingPointFirst(lambda, phi) {
  lambda00 = lambda, phi00 = phi;
  lambda *= radians, phi *= radians;
  centroidStream$1.point = centroidRingPoint;
  var cosPhi = cos$1(phi);
  x0$4 = cosPhi * cos$1(lambda);
  y0$4 = cosPhi * sin$1(lambda);
  z0 = sin$1(phi);
  centroidPointCartesian(x0$4, y0$4, z0);
}
function centroidRingPoint(lambda, phi) {
  lambda *= radians, phi *= radians;
  var cosPhi = cos$1(phi),
    x = cosPhi * cos$1(lambda),
    y = cosPhi * sin$1(lambda),
    z = sin$1(phi),
    cx = y0$4 * z - z0 * y,
    cy = z0 * x - x0$4 * z,
    cz = x0$4 * y - y0$4 * x,
    m = hypot(cx, cy, cz),
    w = asin$1(m),
    // line weight = angle
    v = m && -w / m; // area weight multiplier
  X2$1.add(v * cx);
  Y2$1.add(v * cy);
  Z2$1.add(v * cz);
  W1 += w;
  X1$1 += w * (x0$4 + (x0$4 = x));
  Y1$1 += w * (y0$4 + (y0$4 = y));
  Z1$1 += w * (z0 + (z0 = z));
  centroidPointCartesian(x0$4, y0$4, z0);
}
function geoCentroid$1 (object) {
  W0 = W1 = X0$1 = Y0$1 = Z0$1 = X1$1 = Y1$1 = Z1$1 = 0;
  X2$1 = new Adder();
  Y2$1 = new Adder();
  Z2$1 = new Adder();
  geoStream(object, centroidStream$1);
  var x = +X2$1,
    y = +Y2$1,
    z = +Z2$1,
    m = hypot(x, y, z);

  // If the area-weighted ccentroid is undefined, fall back to length-weighted ccentroid.
  if (m < epsilon2) {
    x = X1$1, y = Y1$1, z = Z1$1;
    // If the feature has zero length, fall back to arithmetic mean of point vectors.
    if (W1 < epsilon$3) x = X0$1, y = Y0$1, z = Z0$1;
    m = hypot(x, y, z);
    // If the feature still has an undefined ccentroid, then return.
    if (m < epsilon2) return [NaN, NaN];
  }
  return [atan2(y, x) * degrees, asin$1(z / m) * degrees];
}

function compose (a, b) {
  function compose(x, y) {
    return x = a(x, y), b(x[0], x[1]);
  }
  if (a.invert && b.invert) compose.invert = function (x, y) {
    return x = b.invert(x, y), x && a.invert(x[0], x[1]);
  };
  return compose;
}

function rotationIdentity(lambda, phi) {
  if (abs$1(lambda) > pi$1) lambda -= Math.round(lambda / tau$1) * tau$1;
  return [lambda, phi];
}
rotationIdentity.invert = rotationIdentity;
function rotateRadians(deltaLambda, deltaPhi, deltaGamma) {
  return (deltaLambda %= tau$1) ? deltaPhi || deltaGamma ? compose(rotationLambda(deltaLambda), rotationPhiGamma(deltaPhi, deltaGamma)) : rotationLambda(deltaLambda) : deltaPhi || deltaGamma ? rotationPhiGamma(deltaPhi, deltaGamma) : rotationIdentity;
}
function forwardRotationLambda(deltaLambda) {
  return function (lambda, phi) {
    lambda += deltaLambda;
    if (abs$1(lambda) > pi$1) lambda -= Math.round(lambda / tau$1) * tau$1;
    return [lambda, phi];
  };
}
function rotationLambda(deltaLambda) {
  var rotation = forwardRotationLambda(deltaLambda);
  rotation.invert = forwardRotationLambda(-deltaLambda);
  return rotation;
}
function rotationPhiGamma(deltaPhi, deltaGamma) {
  var cosDeltaPhi = cos$1(deltaPhi),
    sinDeltaPhi = sin$1(deltaPhi),
    cosDeltaGamma = cos$1(deltaGamma),
    sinDeltaGamma = sin$1(deltaGamma);
  function rotation(lambda, phi) {
    var cosPhi = cos$1(phi),
      x = cos$1(lambda) * cosPhi,
      y = sin$1(lambda) * cosPhi,
      z = sin$1(phi),
      k = z * cosDeltaPhi + x * sinDeltaPhi;
    return [atan2(y * cosDeltaGamma - k * sinDeltaGamma, x * cosDeltaPhi - z * sinDeltaPhi), asin$1(k * cosDeltaGamma + y * sinDeltaGamma)];
  }
  rotation.invert = function (lambda, phi) {
    var cosPhi = cos$1(phi),
      x = cos$1(lambda) * cosPhi,
      y = sin$1(lambda) * cosPhi,
      z = sin$1(phi),
      k = z * cosDeltaGamma - y * sinDeltaGamma;
    return [atan2(y * cosDeltaGamma + z * sinDeltaGamma, x * cosDeltaPhi + k * sinDeltaPhi), asin$1(k * cosDeltaPhi - x * sinDeltaPhi)];
  };
  return rotation;
}
function rotation (rotate) {
  rotate = rotateRadians(rotate[0] * radians, rotate[1] * radians, rotate.length > 2 ? rotate[2] * radians : 0);
  function forward(coordinates) {
    coordinates = rotate(coordinates[0] * radians, coordinates[1] * radians);
    return coordinates[0] *= degrees, coordinates[1] *= degrees, coordinates;
  }
  forward.invert = function (coordinates) {
    coordinates = rotate.invert(coordinates[0] * radians, coordinates[1] * radians);
    return coordinates[0] *= degrees, coordinates[1] *= degrees, coordinates;
  };
  return forward;
}

// Generates a circle centered at [0°, 0°], with a given radius and precision.
function circleStream(stream, radius, delta, direction, t0, t1) {
  if (!delta) return;
  var cosRadius = cos$1(radius),
    sinRadius = sin$1(radius),
    step = direction * delta;
  if (t0 == null) {
    t0 = radius + direction * tau$1;
    t1 = radius - step / 2;
  } else {
    t0 = circleRadius(cosRadius, t0);
    t1 = circleRadius(cosRadius, t1);
    if (direction > 0 ? t0 < t1 : t0 > t1) t0 += direction * tau$1;
  }
  for (var point, t = t0; direction > 0 ? t > t1 : t < t1; t -= step) {
    point = spherical([cosRadius, -sinRadius * cos$1(t), -sinRadius * sin$1(t)]);
    stream.point(point[0], point[1]);
  }
}

// Returns the signed angle of a cartesian point relative to [cosRadius, 0, 0].
function circleRadius(cosRadius, point) {
  point = cartesian(point), point[0] -= cosRadius;
  cartesianNormalizeInPlace(point);
  var radius = acos(-point[1]);
  return ((-point[2] < 0 ? -radius : radius) + tau$1 - epsilon$3) % tau$1;
}

function clipBuffer () {
  var lines = [],
    line;
  return {
    point: function (x, y, m) {
      line.push([x, y, m]);
    },
    lineStart: function () {
      lines.push(line = []);
    },
    lineEnd: noop$2,
    rejoin: function () {
      if (lines.length > 1) lines.push(lines.pop().concat(lines.shift()));
    },
    result: function () {
      var result = lines;
      lines = [];
      line = null;
      return result;
    }
  };
}

function pointEqual (a, b) {
  return abs$1(a[0] - b[0]) < epsilon$3 && abs$1(a[1] - b[1]) < epsilon$3;
}

function Intersection(point, points, other, entry) {
  this.x = point;
  this.z = points;
  this.o = other; // another intersection
  this.e = entry; // is an entry?
  this.v = false; // visited
  this.n = this.p = null; // next & previous
}

// A generalized polygon clipping algorithm: given a polygon that has been cut
// into its visible line segments, and rejoins the segments by interpolating
// along the clip edge.
function clipRejoin (segments, compareIntersection, startInside, interpolate, stream) {
  var subject = [],
    clip = [],
    i,
    n;
  segments.forEach(function (segment) {
    if ((n = segment.length - 1) <= 0) return;
    var n,
      p0 = segment[0],
      p1 = segment[n],
      x;
    if (pointEqual(p0, p1)) {
      if (!p0[2] && !p1[2]) {
        stream.lineStart();
        for (i = 0; i < n; ++i) stream.point((p0 = segment[i])[0], p0[1]);
        stream.lineEnd();
        return;
      }
      // handle degenerate cases by moving the point
      p1[0] += 2 * epsilon$3;
    }
    subject.push(x = new Intersection(p0, segment, null, true));
    clip.push(x.o = new Intersection(p0, null, x, false));
    subject.push(x = new Intersection(p1, segment, null, false));
    clip.push(x.o = new Intersection(p1, null, x, true));
  });
  if (!subject.length) return;
  clip.sort(compareIntersection);
  link(subject);
  link(clip);
  for (i = 0, n = clip.length; i < n; ++i) {
    clip[i].e = startInside = !startInside;
  }
  var start = subject[0],
    points,
    point;
  while (1) {
    // Find first unvisited intersection.
    var current = start,
      isSubject = true;
    while (current.v) if ((current = current.n) === start) return;
    points = current.z;
    stream.lineStart();
    do {
      current.v = current.o.v = true;
      if (current.e) {
        if (isSubject) {
          for (i = 0, n = points.length; i < n; ++i) stream.point((point = points[i])[0], point[1]);
        } else {
          interpolate(current.x, current.n.x, 1, stream);
        }
        current = current.n;
      } else {
        if (isSubject) {
          points = current.p.z;
          for (i = points.length - 1; i >= 0; --i) stream.point((point = points[i])[0], point[1]);
        } else {
          interpolate(current.x, current.p.x, -1, stream);
        }
        current = current.p;
      }
      current = current.o;
      points = current.z;
      isSubject = !isSubject;
    } while (!current.v);
    stream.lineEnd();
  }
}
function link(array) {
  if (!(n = array.length)) return;
  var n,
    i = 0,
    a = array[0],
    b;
  while (++i < n) {
    a.n = b = array[i];
    b.p = a;
    a = b;
  }
  a.n = b = array[0];
  b.p = a;
}

function longitude(point) {
  return abs$1(point[0]) <= pi$1 ? point[0] : sign(point[0]) * ((abs$1(point[0]) + pi$1) % tau$1 - pi$1);
}
function polygonContains (polygon, point) {
  var lambda = longitude(point),
    phi = point[1],
    sinPhi = sin$1(phi),
    normal = [sin$1(lambda), -cos$1(lambda), 0],
    angle = 0,
    winding = 0;
  var sum = new Adder();
  if (sinPhi === 1) phi = halfPi$1 + epsilon$3;else if (sinPhi === -1) phi = -halfPi$1 - epsilon$3;
  for (var i = 0, n = polygon.length; i < n; ++i) {
    if (!(m = (ring = polygon[i]).length)) continue;
    var ring,
      m,
      point0 = ring[m - 1],
      lambda0 = longitude(point0),
      phi0 = point0[1] / 2 + quarterPi,
      sinPhi0 = sin$1(phi0),
      cosPhi0 = cos$1(phi0);
    for (var j = 0; j < m; ++j, lambda0 = lambda1, sinPhi0 = sinPhi1, cosPhi0 = cosPhi1, point0 = point1) {
      var point1 = ring[j],
        lambda1 = longitude(point1),
        phi1 = point1[1] / 2 + quarterPi,
        sinPhi1 = sin$1(phi1),
        cosPhi1 = cos$1(phi1),
        delta = lambda1 - lambda0,
        sign = delta >= 0 ? 1 : -1,
        absDelta = sign * delta,
        antimeridian = absDelta > pi$1,
        k = sinPhi0 * sinPhi1;
      sum.add(atan2(k * sign * sin$1(absDelta), cosPhi0 * cosPhi1 + k * cos$1(absDelta)));
      angle += antimeridian ? delta + sign * tau$1 : delta;

      // Are the longitudes either side of the point’s meridian (lambda),
      // and are the latitudes smaller than the parallel (phi)?
      if (antimeridian ^ lambda0 >= lambda ^ lambda1 >= lambda) {
        var arc = cartesianCross(cartesian(point0), cartesian(point1));
        cartesianNormalizeInPlace(arc);
        var intersection = cartesianCross(normal, arc);
        cartesianNormalizeInPlace(intersection);
        var phiArc = (antimeridian ^ delta >= 0 ? -1 : 1) * asin$1(intersection[2]);
        if (phi > phiArc || phi === phiArc && (arc[0] || arc[1])) {
          winding += antimeridian ^ delta >= 0 ? 1 : -1;
        }
      }
    }
  }

  // First, determine whether the South pole is inside or outside:
  //
  // It is inside if:
  // * the polygon winds around it in a clockwise direction.
  // * the polygon does not (cumulatively) wind around it, but has a negative
  //   (counter-clockwise) area.
  //
  // Second, count the (signed) number of times a segment crosses a lambda
  // from the point to the South pole.  If it is zero, then the point is the
  // same side as the South pole.

  return (angle < -1e-6 || angle < epsilon$3 && sum < -1e-12) ^ winding & 1;
}

function clip$1 (pointVisible, clipLine, interpolate, start) {
  return function (sink) {
    var line = clipLine(sink),
      ringBuffer = clipBuffer(),
      ringSink = clipLine(ringBuffer),
      polygonStarted = false,
      polygon,
      segments,
      ring;
    var clip = {
      point: point,
      lineStart: lineStart,
      lineEnd: lineEnd,
      polygonStart: function () {
        clip.point = pointRing;
        clip.lineStart = ringStart;
        clip.lineEnd = ringEnd;
        segments = [];
        polygon = [];
      },
      polygonEnd: function () {
        clip.point = point;
        clip.lineStart = lineStart;
        clip.lineEnd = lineEnd;
        segments = merge$2(segments);
        var startInside = polygonContains(polygon, start);
        if (segments.length) {
          if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
          clipRejoin(segments, compareIntersection, startInside, interpolate, sink);
        } else if (startInside) {
          if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
          sink.lineStart();
          interpolate(null, null, 1, sink);
          sink.lineEnd();
        }
        if (polygonStarted) sink.polygonEnd(), polygonStarted = false;
        segments = polygon = null;
      },
      sphere: function () {
        sink.polygonStart();
        sink.lineStart();
        interpolate(null, null, 1, sink);
        sink.lineEnd();
        sink.polygonEnd();
      }
    };
    function point(lambda, phi) {
      if (pointVisible(lambda, phi)) sink.point(lambda, phi);
    }
    function pointLine(lambda, phi) {
      line.point(lambda, phi);
    }
    function lineStart() {
      clip.point = pointLine;
      line.lineStart();
    }
    function lineEnd() {
      clip.point = point;
      line.lineEnd();
    }
    function pointRing(lambda, phi) {
      ring.push([lambda, phi]);
      ringSink.point(lambda, phi);
    }
    function ringStart() {
      ringSink.lineStart();
      ring = [];
    }
    function ringEnd() {
      pointRing(ring[0][0], ring[0][1]);
      ringSink.lineEnd();
      var clean = ringSink.clean(),
        ringSegments = ringBuffer.result(),
        i,
        n = ringSegments.length,
        m,
        segment,
        point;
      ring.pop();
      polygon.push(ring);
      ring = null;
      if (!n) return;

      // No intersections.
      if (clean & 1) {
        segment = ringSegments[0];
        if ((m = segment.length - 1) > 0) {
          if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
          sink.lineStart();
          for (i = 0; i < m; ++i) sink.point((point = segment[i])[0], point[1]);
          sink.lineEnd();
        }
        return;
      }

      // Rejoin connected segments.
      // TODO reuse ringBuffer.rejoin()?
      if (n > 1 && clean & 2) ringSegments.push(ringSegments.pop().concat(ringSegments.shift()));
      segments.push(ringSegments.filter(validSegment));
    }
    return clip;
  };
}
function validSegment(segment) {
  return segment.length > 1;
}

// Intersections are sorted along the clip edge. For both antimeridian cutting
// and circle clipping, the same comparison is used.
function compareIntersection(a, b) {
  return ((a = a.x)[0] < 0 ? a[1] - halfPi$1 - epsilon$3 : halfPi$1 - a[1]) - ((b = b.x)[0] < 0 ? b[1] - halfPi$1 - epsilon$3 : halfPi$1 - b[1]);
}

var clipAntimeridian = clip$1(function () {
  return true;
}, clipAntimeridianLine, clipAntimeridianInterpolate, [-pi$1, -halfPi$1]);

// Takes a line and cuts into visible segments. Return values: 0 - there were
// intersections or the line was empty; 1 - no intersections; 2 - there were
// intersections, and the first and last segments should be rejoined.
function clipAntimeridianLine(stream) {
  var lambda0 = NaN,
    phi0 = NaN,
    sign0 = NaN,
    clean; // no intersections

  return {
    lineStart: function () {
      stream.lineStart();
      clean = 1;
    },
    point: function (lambda1, phi1) {
      var sign1 = lambda1 > 0 ? pi$1 : -pi$1,
        delta = abs$1(lambda1 - lambda0);
      if (abs$1(delta - pi$1) < epsilon$3) {
        // line crosses a pole
        stream.point(lambda0, phi0 = (phi0 + phi1) / 2 > 0 ? halfPi$1 : -halfPi$1);
        stream.point(sign0, phi0);
        stream.lineEnd();
        stream.lineStart();
        stream.point(sign1, phi0);
        stream.point(lambda1, phi0);
        clean = 0;
      } else if (sign0 !== sign1 && delta >= pi$1) {
        // line crosses antimeridian
        if (abs$1(lambda0 - sign0) < epsilon$3) lambda0 -= sign0 * epsilon$3; // handle degeneracies
        if (abs$1(lambda1 - sign1) < epsilon$3) lambda1 -= sign1 * epsilon$3;
        phi0 = clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1);
        stream.point(sign0, phi0);
        stream.lineEnd();
        stream.lineStart();
        stream.point(sign1, phi0);
        clean = 0;
      }
      stream.point(lambda0 = lambda1, phi0 = phi1);
      sign0 = sign1;
    },
    lineEnd: function () {
      stream.lineEnd();
      lambda0 = phi0 = NaN;
    },
    clean: function () {
      return 2 - clean; // if intersections, rejoin first and last segments
    }
  };
}
function clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1) {
  var cosPhi0,
    cosPhi1,
    sinLambda0Lambda1 = sin$1(lambda0 - lambda1);
  return abs$1(sinLambda0Lambda1) > epsilon$3 ? atan((sin$1(phi0) * (cosPhi1 = cos$1(phi1)) * sin$1(lambda1) - sin$1(phi1) * (cosPhi0 = cos$1(phi0)) * sin$1(lambda0)) / (cosPhi0 * cosPhi1 * sinLambda0Lambda1)) : (phi0 + phi1) / 2;
}
function clipAntimeridianInterpolate(from, to, direction, stream) {
  var phi;
  if (from == null) {
    phi = direction * halfPi$1;
    stream.point(-pi$1, phi);
    stream.point(0, phi);
    stream.point(pi$1, phi);
    stream.point(pi$1, 0);
    stream.point(pi$1, -phi);
    stream.point(0, -phi);
    stream.point(-pi$1, -phi);
    stream.point(-pi$1, 0);
    stream.point(-pi$1, phi);
  } else if (abs$1(from[0] - to[0]) > epsilon$3) {
    var lambda = from[0] < to[0] ? pi$1 : -pi$1;
    phi = direction * lambda / 2;
    stream.point(-lambda, phi);
    stream.point(0, phi);
    stream.point(lambda, phi);
  } else {
    stream.point(to[0], to[1]);
  }
}

function clipCircle (radius) {
  var cr = cos$1(radius),
    delta = 2 * radians,
    smallRadius = cr > 0,
    notHemisphere = abs$1(cr) > epsilon$3; // TODO optimise for this common case

  function interpolate(from, to, direction, stream) {
    circleStream(stream, radius, delta, direction, from, to);
  }
  function visible(lambda, phi) {
    return cos$1(lambda) * cos$1(phi) > cr;
  }

  // Takes a line and cuts into visible segments. Return values used for polygon
  // clipping: 0 - there were intersections or the line was empty; 1 - no
  // intersections 2 - there were intersections, and the first and last segments
  // should be rejoined.
  function clipLine(stream) {
    var point0,
      // previous point
      c0,
      // code for previous point
      v0,
      // visibility of previous point
      v00,
      // visibility of first point
      clean; // no intersections
    return {
      lineStart: function () {
        v00 = v0 = false;
        clean = 1;
      },
      point: function (lambda, phi) {
        var point1 = [lambda, phi],
          point2,
          v = visible(lambda, phi),
          c = smallRadius ? v ? 0 : code(lambda, phi) : v ? code(lambda + (lambda < 0 ? pi$1 : -pi$1), phi) : 0;
        if (!point0 && (v00 = v0 = v)) stream.lineStart();
        if (v !== v0) {
          point2 = intersect(point0, point1);
          if (!point2 || pointEqual(point0, point2) || pointEqual(point1, point2)) point1[2] = 1;
        }
        if (v !== v0) {
          clean = 0;
          if (v) {
            // outside going in
            stream.lineStart();
            point2 = intersect(point1, point0);
            stream.point(point2[0], point2[1]);
          } else {
            // inside going out
            point2 = intersect(point0, point1);
            stream.point(point2[0], point2[1], 2);
            stream.lineEnd();
          }
          point0 = point2;
        } else if (notHemisphere && point0 && smallRadius ^ v) {
          var t;
          // If the codes for two points are different, or are both zero,
          // and there this segment intersects with the small circle.
          if (!(c & c0) && (t = intersect(point1, point0, true))) {
            clean = 0;
            if (smallRadius) {
              stream.lineStart();
              stream.point(t[0][0], t[0][1]);
              stream.point(t[1][0], t[1][1]);
              stream.lineEnd();
            } else {
              stream.point(t[1][0], t[1][1]);
              stream.lineEnd();
              stream.lineStart();
              stream.point(t[0][0], t[0][1], 3);
            }
          }
        }
        if (v && (!point0 || !pointEqual(point0, point1))) {
          stream.point(point1[0], point1[1]);
        }
        point0 = point1, v0 = v, c0 = c;
      },
      lineEnd: function () {
        if (v0) stream.lineEnd();
        point0 = null;
      },
      // Rejoin first and last segments if there were intersections and the first
      // and last points were visible.
      clean: function () {
        return clean | (v00 && v0) << 1;
      }
    };
  }

  // Intersects the great circle between a and b with the clip circle.
  function intersect(a, b, two) {
    var pa = cartesian(a),
      pb = cartesian(b);

    // We have two planes, n1.p = d1 and n2.p = d2.
    // Find intersection line p(t) = c1 n1 + c2 n2 + t (n1 ⨯ n2).
    var n1 = [1, 0, 0],
      // normal
      n2 = cartesianCross(pa, pb),
      n2n2 = cartesianDot(n2, n2),
      n1n2 = n2[0],
      // cartesianDot(n1, n2),
      determinant = n2n2 - n1n2 * n1n2;

    // Two polar points.
    if (!determinant) return !two && a;
    var c1 = cr * n2n2 / determinant,
      c2 = -cr * n1n2 / determinant,
      n1xn2 = cartesianCross(n1, n2),
      A = cartesianScale(n1, c1),
      B = cartesianScale(n2, c2);
    cartesianAddInPlace(A, B);

    // Solve |p(t)|^2 = 1.
    var u = n1xn2,
      w = cartesianDot(A, u),
      uu = cartesianDot(u, u),
      t2 = w * w - uu * (cartesianDot(A, A) - 1);
    if (t2 < 0) return;
    var t = sqrt$1(t2),
      q = cartesianScale(u, (-w - t) / uu);
    cartesianAddInPlace(q, A);
    q = spherical(q);
    if (!two) return q;

    // Two intersection points.
    var lambda0 = a[0],
      lambda1 = b[0],
      phi0 = a[1],
      phi1 = b[1],
      z;
    if (lambda1 < lambda0) z = lambda0, lambda0 = lambda1, lambda1 = z;
    var delta = lambda1 - lambda0,
      polar = abs$1(delta - pi$1) < epsilon$3,
      meridian = polar || delta < epsilon$3;
    if (!polar && phi1 < phi0) z = phi0, phi0 = phi1, phi1 = z;

    // Check that the first point is between a and b.
    if (meridian ? polar ? phi0 + phi1 > 0 ^ q[1] < (abs$1(q[0] - lambda0) < epsilon$3 ? phi0 : phi1) : phi0 <= q[1] && q[1] <= phi1 : delta > pi$1 ^ (lambda0 <= q[0] && q[0] <= lambda1)) {
      var q1 = cartesianScale(u, (-w + t) / uu);
      cartesianAddInPlace(q1, A);
      return [q, spherical(q1)];
    }
  }

  // Generates a 4-bit vector representing the location of a point relative to
  // the small circle's bounding box.
  function code(lambda, phi) {
    var r = smallRadius ? radius : pi$1 - radius,
      code = 0;
    if (lambda < -r) code |= 1; // left
    else if (lambda > r) code |= 2; // right
    if (phi < -r) code |= 4; // below
    else if (phi > r) code |= 8; // above
    return code;
  }
  return clip$1(visible, clipLine, interpolate, smallRadius ? [0, -radius] : [-pi$1, radius - pi$1]);
}

function clipLine (a, b, x0, y0, x1, y1) {
  var ax = a[0],
    ay = a[1],
    bx = b[0],
    by = b[1],
    t0 = 0,
    t1 = 1,
    dx = bx - ax,
    dy = by - ay,
    r;
  r = x0 - ax;
  if (!dx && r > 0) return;
  r /= dx;
  if (dx < 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  } else if (dx > 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  }
  r = x1 - ax;
  if (!dx && r < 0) return;
  r /= dx;
  if (dx < 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  } else if (dx > 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  }
  r = y0 - ay;
  if (!dy && r > 0) return;
  r /= dy;
  if (dy < 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  } else if (dy > 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  }
  r = y1 - ay;
  if (!dy && r < 0) return;
  r /= dy;
  if (dy < 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  } else if (dy > 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  }
  if (t0 > 0) a[0] = ax + t0 * dx, a[1] = ay + t0 * dy;
  if (t1 < 1) b[0] = ax + t1 * dx, b[1] = ay + t1 * dy;
  return true;
}

var clipMax = 1e9,
  clipMin = -1e9;

// TODO Use d3-polygon’s polygonContains here for the ring check?
// TODO Eliminate duplicate buffering in clipBuffer and polygon.push?

function clipRectangle(x0, y0, x1, y1) {
  function visible(x, y) {
    return x0 <= x && x <= x1 && y0 <= y && y <= y1;
  }
  function interpolate(from, to, direction, stream) {
    var a = 0,
      a1 = 0;
    if (from == null || (a = corner(from, direction)) !== (a1 = corner(to, direction)) || comparePoint(from, to) < 0 ^ direction > 0) {
      do stream.point(a === 0 || a === 3 ? x0 : x1, a > 1 ? y1 : y0); while ((a = (a + direction + 4) % 4) !== a1);
    } else {
      stream.point(to[0], to[1]);
    }
  }
  function corner(p, direction) {
    return abs$1(p[0] - x0) < epsilon$3 ? direction > 0 ? 0 : 3 : abs$1(p[0] - x1) < epsilon$3 ? direction > 0 ? 2 : 1 : abs$1(p[1] - y0) < epsilon$3 ? direction > 0 ? 1 : 0 : direction > 0 ? 3 : 2; // abs(p[1] - y1) < epsilon
  }
  function compareIntersection(a, b) {
    return comparePoint(a.x, b.x);
  }
  function comparePoint(a, b) {
    var ca = corner(a, 1),
      cb = corner(b, 1);
    return ca !== cb ? ca - cb : ca === 0 ? b[1] - a[1] : ca === 1 ? a[0] - b[0] : ca === 2 ? a[1] - b[1] : b[0] - a[0];
  }
  return function (stream) {
    var activeStream = stream,
      bufferStream = clipBuffer(),
      segments,
      polygon,
      ring,
      x__,
      y__,
      v__,
      // first point
      x_,
      y_,
      v_,
      // previous point
      first,
      clean;
    var clipStream = {
      point: point,
      lineStart: lineStart,
      lineEnd: lineEnd,
      polygonStart: polygonStart,
      polygonEnd: polygonEnd
    };
    function point(x, y) {
      if (visible(x, y)) activeStream.point(x, y);
    }
    function polygonInside() {
      var winding = 0;
      for (var i = 0, n = polygon.length; i < n; ++i) {
        for (var ring = polygon[i], j = 1, m = ring.length, point = ring[0], a0, a1, b0 = point[0], b1 = point[1]; j < m; ++j) {
          a0 = b0, a1 = b1, point = ring[j], b0 = point[0], b1 = point[1];
          if (a1 <= y1) {
            if (b1 > y1 && (b0 - a0) * (y1 - a1) > (b1 - a1) * (x0 - a0)) ++winding;
          } else {
            if (b1 <= y1 && (b0 - a0) * (y1 - a1) < (b1 - a1) * (x0 - a0)) --winding;
          }
        }
      }
      return winding;
    }

    // Buffer geometry within a polygon and then clip it en masse.
    function polygonStart() {
      activeStream = bufferStream, segments = [], polygon = [], clean = true;
    }
    function polygonEnd() {
      var startInside = polygonInside(),
        cleanInside = clean && startInside,
        visible = (segments = merge$2(segments)).length;
      if (cleanInside || visible) {
        stream.polygonStart();
        if (cleanInside) {
          stream.lineStart();
          interpolate(null, null, 1, stream);
          stream.lineEnd();
        }
        if (visible) {
          clipRejoin(segments, compareIntersection, startInside, interpolate, stream);
        }
        stream.polygonEnd();
      }
      activeStream = stream, segments = polygon = ring = null;
    }
    function lineStart() {
      clipStream.point = linePoint;
      if (polygon) polygon.push(ring = []);
      first = true;
      v_ = false;
      x_ = y_ = NaN;
    }

    // TODO rather than special-case polygons, simply handle them separately.
    // Ideally, coincident intersection points should be jittered to avoid
    // clipping issues.
    function lineEnd() {
      if (segments) {
        linePoint(x__, y__);
        if (v__ && v_) bufferStream.rejoin();
        segments.push(bufferStream.result());
      }
      clipStream.point = point;
      if (v_) activeStream.lineEnd();
    }
    function linePoint(x, y) {
      var v = visible(x, y);
      if (polygon) ring.push([x, y]);
      if (first) {
        x__ = x, y__ = y, v__ = v;
        first = false;
        if (v) {
          activeStream.lineStart();
          activeStream.point(x, y);
        }
      } else {
        if (v && v_) activeStream.point(x, y);else {
          var a = [x_ = Math.max(clipMin, Math.min(clipMax, x_)), y_ = Math.max(clipMin, Math.min(clipMax, y_))],
            b = [x = Math.max(clipMin, Math.min(clipMax, x)), y = Math.max(clipMin, Math.min(clipMax, y))];
          if (clipLine(a, b, x0, y0, x1, y1)) {
            if (!v_) {
              activeStream.lineStart();
              activeStream.point(a[0], a[1]);
            }
            activeStream.point(b[0], b[1]);
            if (!v) activeStream.lineEnd();
            clean = false;
          } else if (v) {
            activeStream.lineStart();
            activeStream.point(x, y);
            clean = false;
          }
        }
      }
      x_ = x, y_ = y, v_ = v;
    }
    return clipStream;
  };
}

function graticuleX(y0, y1, dy) {
  var y = range$3(y0, y1 - epsilon$3, dy).concat(y1);
  return function (x) {
    return y.map(function (y) {
      return [x, y];
    });
  };
}
function graticuleY(x0, x1, dx) {
  var x = range$3(x0, x1 - epsilon$3, dx).concat(x1);
  return function (y) {
    return x.map(function (x) {
      return [x, y];
    });
  };
}
function graticule() {
  var x1,
    x0,
    X1,
    X0,
    y1,
    y0,
    Y1,
    Y0,
    dx = 10,
    dy = dx,
    DX = 90,
    DY = 360,
    x,
    y,
    X,
    Y,
    precision = 2.5;
  function graticule() {
    return {
      type: "MultiLineString",
      coordinates: lines()
    };
  }
  function lines() {
    return range$3(ceil(X0 / DX) * DX, X1, DX).map(X).concat(range$3(ceil(Y0 / DY) * DY, Y1, DY).map(Y)).concat(range$3(ceil(x0 / dx) * dx, x1, dx).filter(function (x) {
      return abs$1(x % DX) > epsilon$3;
    }).map(x)).concat(range$3(ceil(y0 / dy) * dy, y1, dy).filter(function (y) {
      return abs$1(y % DY) > epsilon$3;
    }).map(y));
  }
  graticule.lines = function () {
    return lines().map(function (coordinates) {
      return {
        type: "LineString",
        coordinates: coordinates
      };
    });
  };
  graticule.outline = function () {
    return {
      type: "Polygon",
      coordinates: [X(X0).concat(Y(Y1).slice(1), X(X1).reverse().slice(1), Y(Y0).reverse().slice(1))]
    };
  };
  graticule.extent = function (_) {
    if (!arguments.length) return graticule.extentMinor();
    return graticule.extentMajor(_).extentMinor(_);
  };
  graticule.extentMajor = function (_) {
    if (!arguments.length) return [[X0, Y0], [X1, Y1]];
    X0 = +_[0][0], X1 = +_[1][0];
    Y0 = +_[0][1], Y1 = +_[1][1];
    if (X0 > X1) _ = X0, X0 = X1, X1 = _;
    if (Y0 > Y1) _ = Y0, Y0 = Y1, Y1 = _;
    return graticule.precision(precision);
  };
  graticule.extentMinor = function (_) {
    if (!arguments.length) return [[x0, y0], [x1, y1]];
    x0 = +_[0][0], x1 = +_[1][0];
    y0 = +_[0][1], y1 = +_[1][1];
    if (x0 > x1) _ = x0, x0 = x1, x1 = _;
    if (y0 > y1) _ = y0, y0 = y1, y1 = _;
    return graticule.precision(precision);
  };
  graticule.step = function (_) {
    if (!arguments.length) return graticule.stepMinor();
    return graticule.stepMajor(_).stepMinor(_);
  };
  graticule.stepMajor = function (_) {
    if (!arguments.length) return [DX, DY];
    DX = +_[0], DY = +_[1];
    return graticule;
  };
  graticule.stepMinor = function (_) {
    if (!arguments.length) return [dx, dy];
    dx = +_[0], dy = +_[1];
    return graticule;
  };
  graticule.precision = function (_) {
    if (!arguments.length) return precision;
    precision = +_;
    x = graticuleX(y0, y1, 90);
    y = graticuleY(x0, x1, precision);
    X = graticuleX(Y0, Y1, 90);
    Y = graticuleY(X0, X1, precision);
    return graticule;
  };
  return graticule.extentMajor([[-180, -90 + epsilon$3], [180, 90 - epsilon$3]]).extentMinor([[-180, -80 - epsilon$3], [180, 80 + epsilon$3]]);
}

var identity = x => x;

var areaSum = new Adder(),
  areaRingSum = new Adder(),
  x00$2,
  y00$2,
  x0$3,
  y0$3;
var areaStream = {
  point: noop$2,
  lineStart: noop$2,
  lineEnd: noop$2,
  polygonStart: function () {
    areaStream.lineStart = areaRingStart;
    areaStream.lineEnd = areaRingEnd;
  },
  polygonEnd: function () {
    areaStream.lineStart = areaStream.lineEnd = areaStream.point = noop$2;
    areaSum.add(abs$1(areaRingSum));
    areaRingSum = new Adder();
  },
  result: function () {
    var area = areaSum / 2;
    areaSum = new Adder();
    return area;
  }
};
function areaRingStart() {
  areaStream.point = areaPointFirst;
}
function areaPointFirst(x, y) {
  areaStream.point = areaPoint;
  x00$2 = x0$3 = x, y00$2 = y0$3 = y;
}
function areaPoint(x, y) {
  areaRingSum.add(y0$3 * x - x0$3 * y);
  x0$3 = x, y0$3 = y;
}
function areaRingEnd() {
  areaPoint(x00$2, y00$2);
}

var x0$2 = Infinity,
  y0$2 = x0$2,
  x1 = -x0$2,
  y1 = x1;
var boundsStream = {
  point: boundsPoint,
  lineStart: noop$2,
  lineEnd: noop$2,
  polygonStart: noop$2,
  polygonEnd: noop$2,
  result: function () {
    var bounds = [[x0$2, y0$2], [x1, y1]];
    x1 = y1 = -(y0$2 = x0$2 = Infinity);
    return bounds;
  }
};
function boundsPoint(x, y) {
  if (x < x0$2) x0$2 = x;
  if (x > x1) x1 = x;
  if (y < y0$2) y0$2 = y;
  if (y > y1) y1 = y;
}

// TODO Enforce positive area for exterior, negative area for interior?

var X0 = 0,
  Y0 = 0,
  Z0 = 0,
  X1 = 0,
  Y1 = 0,
  Z1 = 0,
  X2 = 0,
  Y2 = 0,
  Z2 = 0,
  x00$1,
  y00$1,
  x0$1,
  y0$1;
var centroidStream = {
  point: centroidPoint,
  lineStart: centroidLineStart,
  lineEnd: centroidLineEnd,
  polygonStart: function () {
    centroidStream.lineStart = centroidRingStart;
    centroidStream.lineEnd = centroidRingEnd;
  },
  polygonEnd: function () {
    centroidStream.point = centroidPoint;
    centroidStream.lineStart = centroidLineStart;
    centroidStream.lineEnd = centroidLineEnd;
  },
  result: function () {
    var centroid = Z2 ? [X2 / Z2, Y2 / Z2] : Z1 ? [X1 / Z1, Y1 / Z1] : Z0 ? [X0 / Z0, Y0 / Z0] : [NaN, NaN];
    X0 = Y0 = Z0 = X1 = Y1 = Z1 = X2 = Y2 = Z2 = 0;
    return centroid;
  }
};
function centroidPoint(x, y) {
  X0 += x;
  Y0 += y;
  ++Z0;
}
function centroidLineStart() {
  centroidStream.point = centroidPointFirstLine;
}
function centroidPointFirstLine(x, y) {
  centroidStream.point = centroidPointLine;
  centroidPoint(x0$1 = x, y0$1 = y);
}
function centroidPointLine(x, y) {
  var dx = x - x0$1,
    dy = y - y0$1,
    z = sqrt$1(dx * dx + dy * dy);
  X1 += z * (x0$1 + x) / 2;
  Y1 += z * (y0$1 + y) / 2;
  Z1 += z;
  centroidPoint(x0$1 = x, y0$1 = y);
}
function centroidLineEnd() {
  centroidStream.point = centroidPoint;
}
function centroidRingStart() {
  centroidStream.point = centroidPointFirstRing;
}
function centroidRingEnd() {
  centroidPointRing(x00$1, y00$1);
}
function centroidPointFirstRing(x, y) {
  centroidStream.point = centroidPointRing;
  centroidPoint(x00$1 = x0$1 = x, y00$1 = y0$1 = y);
}
function centroidPointRing(x, y) {
  var dx = x - x0$1,
    dy = y - y0$1,
    z = sqrt$1(dx * dx + dy * dy);
  X1 += z * (x0$1 + x) / 2;
  Y1 += z * (y0$1 + y) / 2;
  Z1 += z;
  z = y0$1 * x - x0$1 * y;
  X2 += z * (x0$1 + x);
  Y2 += z * (y0$1 + y);
  Z2 += z * 3;
  centroidPoint(x0$1 = x, y0$1 = y);
}

function PathContext(context) {
  this._context = context;
}
PathContext.prototype = {
  _radius: 4.5,
  pointRadius: function (_) {
    return this._radius = _, this;
  },
  polygonStart: function () {
    this._line = 0;
  },
  polygonEnd: function () {
    this._line = NaN;
  },
  lineStart: function () {
    this._point = 0;
  },
  lineEnd: function () {
    if (this._line === 0) this._context.closePath();
    this._point = NaN;
  },
  point: function (x, y) {
    switch (this._point) {
      case 0:
        {
          this._context.moveTo(x, y);
          this._point = 1;
          break;
        }
      case 1:
        {
          this._context.lineTo(x, y);
          break;
        }
      default:
        {
          this._context.moveTo(x + this._radius, y);
          this._context.arc(x, y, this._radius, 0, tau$1);
          break;
        }
    }
  },
  result: noop$2
};

var lengthSum = new Adder(),
  lengthRing,
  x00,
  y00,
  x0,
  y0;
var lengthStream = {
  point: noop$2,
  lineStart: function () {
    lengthStream.point = lengthPointFirst;
  },
  lineEnd: function () {
    if (lengthRing) lengthPoint(x00, y00);
    lengthStream.point = noop$2;
  },
  polygonStart: function () {
    lengthRing = true;
  },
  polygonEnd: function () {
    lengthRing = null;
  },
  result: function () {
    var length = +lengthSum;
    lengthSum = new Adder();
    return length;
  }
};
function lengthPointFirst(x, y) {
  lengthStream.point = lengthPoint;
  x00 = x0 = x, y00 = y0 = y;
}
function lengthPoint(x, y) {
  x0 -= x, y0 -= y;
  lengthSum.add(sqrt$1(x0 * x0 + y0 * y0));
  x0 = x, y0 = y;
}

// Simple caching for constant-radius points.
let cacheDigits, cacheAppend, cacheRadius, cacheCircle;
class PathString {
  constructor(digits) {
    this._append = digits == null ? append : appendRound(digits);
    this._radius = 4.5;
    this._ = "";
  }
  pointRadius(_) {
    this._radius = +_;
    return this;
  }
  polygonStart() {
    this._line = 0;
  }
  polygonEnd() {
    this._line = NaN;
  }
  lineStart() {
    this._point = 0;
  }
  lineEnd() {
    if (this._line === 0) this._ += "Z";
    this._point = NaN;
  }
  point(x, y) {
    switch (this._point) {
      case 0:
        {
          this._append`M${x},${y}`;
          this._point = 1;
          break;
        }
      case 1:
        {
          this._append`L${x},${y}`;
          break;
        }
      default:
        {
          this._append`M${x},${y}`;
          if (this._radius !== cacheRadius || this._append !== cacheAppend) {
            const r = this._radius;
            const s = this._;
            this._ = ""; // stash the old string so we can cache the circle path fragment
            this._append`m0,${r}a${r},${r} 0 1,1 0,${ -2 * r}a${r},${r} 0 1,1 0,${2 * r}z`;
            cacheRadius = r;
            cacheAppend = this._append;
            cacheCircle = this._;
            this._ = s;
          }
          this._ += cacheCircle;
          break;
        }
    }
  }
  result() {
    const result = this._;
    this._ = "";
    return result.length ? result : null;
  }
}
function append(strings) {
  let i = 1;
  this._ += strings[0];
  for (const j = strings.length; i < j; ++i) {
    this._ += arguments[i] + strings[i];
  }
}
function appendRound(digits) {
  const d = Math.floor(digits);
  if (!(d >= 0)) throw new RangeError(`invalid digits: ${digits}`);
  if (d > 15) return append;
  if (d !== cacheDigits) {
    const k = 10 ** d;
    cacheDigits = d;
    cacheAppend = function append(strings) {
      let i = 1;
      this._ += strings[0];
      for (const j = strings.length; i < j; ++i) {
        this._ += Math.round(arguments[i] * k) / k + strings[i];
      }
    };
  }
  return cacheAppend;
}

function geoPath (projection, context) {
  let digits = 3,
    pointRadius = 4.5,
    projectionStream,
    contextStream;
  function path(object) {
    if (object) {
      if (typeof pointRadius === "function") contextStream.pointRadius(+pointRadius.apply(this, arguments));
      geoStream(object, projectionStream(contextStream));
    }
    return contextStream.result();
  }
  path.area = function (object) {
    geoStream(object, projectionStream(areaStream));
    return areaStream.result();
  };
  path.measure = function (object) {
    geoStream(object, projectionStream(lengthStream));
    return lengthStream.result();
  };
  path.bounds = function (object) {
    geoStream(object, projectionStream(boundsStream));
    return boundsStream.result();
  };
  path.centroid = function (object) {
    geoStream(object, projectionStream(centroidStream));
    return centroidStream.result();
  };
  path.projection = function (_) {
    if (!arguments.length) return projection;
    projectionStream = _ == null ? (projection = null, identity) : (projection = _).stream;
    return path;
  };
  path.context = function (_) {
    if (!arguments.length) return context;
    contextStream = _ == null ? (context = null, new PathString(digits)) : new PathContext(context = _);
    if (typeof pointRadius !== "function") contextStream.pointRadius(pointRadius);
    return path;
  };
  path.pointRadius = function (_) {
    if (!arguments.length) return pointRadius;
    pointRadius = typeof _ === "function" ? _ : (contextStream.pointRadius(+_), +_);
    return path;
  };
  path.digits = function (_) {
    if (!arguments.length) return digits;
    if (_ == null) digits = null;else {
      const d = Math.floor(_);
      if (!(d >= 0)) throw new RangeError(`invalid digits: ${_}`);
      digits = d;
    }
    if (context === null) contextStream = new PathString(digits);
    return path;
  };
  return path.projection(projection).digits(digits).context(context);
}

function transformer(methods) {
  return function (stream) {
    var s = new TransformStream();
    for (var key in methods) s[key] = methods[key];
    s.stream = stream;
    return s;
  };
}
function TransformStream() {}
TransformStream.prototype = {
  constructor: TransformStream,
  point: function (x, y) {
    this.stream.point(x, y);
  },
  sphere: function () {
    this.stream.sphere();
  },
  lineStart: function () {
    this.stream.lineStart();
  },
  lineEnd: function () {
    this.stream.lineEnd();
  },
  polygonStart: function () {
    this.stream.polygonStart();
  },
  polygonEnd: function () {
    this.stream.polygonEnd();
  }
};

function fit$1(projection, fitBounds, object) {
  var clip = projection.clipExtent && projection.clipExtent();
  projection.scale(150).translate([0, 0]);
  if (clip != null) projection.clipExtent(null);
  geoStream(object, projection.stream(boundsStream));
  fitBounds(boundsStream.result());
  if (clip != null) projection.clipExtent(clip);
  return projection;
}
function fitExtent(projection, extent, object) {
  return fit$1(projection, function (b) {
    var w = extent[1][0] - extent[0][0],
      h = extent[1][1] - extent[0][1],
      k = Math.min(w / (b[1][0] - b[0][0]), h / (b[1][1] - b[0][1])),
      x = +extent[0][0] + (w - k * (b[1][0] + b[0][0])) / 2,
      y = +extent[0][1] + (h - k * (b[1][1] + b[0][1])) / 2;
    projection.scale(150 * k).translate([x, y]);
  }, object);
}
function fitSize(projection, size, object) {
  return fitExtent(projection, [[0, 0], size], object);
}
function fitWidth(projection, width, object) {
  return fit$1(projection, function (b) {
    var w = +width,
      k = w / (b[1][0] - b[0][0]),
      x = (w - k * (b[1][0] + b[0][0])) / 2,
      y = -k * b[0][1];
    projection.scale(150 * k).translate([x, y]);
  }, object);
}
function fitHeight(projection, height, object) {
  return fit$1(projection, function (b) {
    var h = +height,
      k = h / (b[1][1] - b[0][1]),
      x = -k * b[0][0],
      y = (h - k * (b[1][1] + b[0][1])) / 2;
    projection.scale(150 * k).translate([x, y]);
  }, object);
}

var maxDepth = 16,
  // maximum depth of subdivision
  cosMinDistance = cos$1(30 * radians); // cos(minimum angular distance)

function resample (project, delta2) {
  return +delta2 ? resample$1(project, delta2) : resampleNone(project);
}
function resampleNone(project) {
  return transformer({
    point: function (x, y) {
      x = project(x, y);
      this.stream.point(x[0], x[1]);
    }
  });
}
function resample$1(project, delta2) {
  function resampleLineTo(x0, y0, lambda0, a0, b0, c0, x1, y1, lambda1, a1, b1, c1, depth, stream) {
    var dx = x1 - x0,
      dy = y1 - y0,
      d2 = dx * dx + dy * dy;
    if (d2 > 4 * delta2 && depth--) {
      var a = a0 + a1,
        b = b0 + b1,
        c = c0 + c1,
        m = sqrt$1(a * a + b * b + c * c),
        phi2 = asin$1(c /= m),
        lambda2 = abs$1(abs$1(c) - 1) < epsilon$3 || abs$1(lambda0 - lambda1) < epsilon$3 ? (lambda0 + lambda1) / 2 : atan2(b, a),
        p = project(lambda2, phi2),
        x2 = p[0],
        y2 = p[1],
        dx2 = x2 - x0,
        dy2 = y2 - y0,
        dz = dy * dx2 - dx * dy2;
      if (dz * dz / d2 > delta2 // perpendicular projected distance
      || abs$1((dx * dx2 + dy * dy2) / d2 - 0.5) > 0.3 // midpoint close to an end
      || a0 * a1 + b0 * b1 + c0 * c1 < cosMinDistance) {
        // angular distance
        resampleLineTo(x0, y0, lambda0, a0, b0, c0, x2, y2, lambda2, a /= m, b /= m, c, depth, stream);
        stream.point(x2, y2);
        resampleLineTo(x2, y2, lambda2, a, b, c, x1, y1, lambda1, a1, b1, c1, depth, stream);
      }
    }
  }
  return function (stream) {
    var lambda00, x00, y00, a00, b00, c00,
      // first point
      lambda0, x0, y0, a0, b0, c0; // previous point

    var resampleStream = {
      point: point,
      lineStart: lineStart,
      lineEnd: lineEnd,
      polygonStart: function () {
        stream.polygonStart();
        resampleStream.lineStart = ringStart;
      },
      polygonEnd: function () {
        stream.polygonEnd();
        resampleStream.lineStart = lineStart;
      }
    };
    function point(x, y) {
      x = project(x, y);
      stream.point(x[0], x[1]);
    }
    function lineStart() {
      x0 = NaN;
      resampleStream.point = linePoint;
      stream.lineStart();
    }
    function linePoint(lambda, phi) {
      var c = cartesian([lambda, phi]),
        p = project(lambda, phi);
      resampleLineTo(x0, y0, lambda0, a0, b0, c0, x0 = p[0], y0 = p[1], lambda0 = lambda, a0 = c[0], b0 = c[1], c0 = c[2], maxDepth, stream);
      stream.point(x0, y0);
    }
    function lineEnd() {
      resampleStream.point = point;
      stream.lineEnd();
    }
    function ringStart() {
      lineStart();
      resampleStream.point = ringPoint;
      resampleStream.lineEnd = ringEnd;
    }
    function ringPoint(lambda, phi) {
      linePoint(lambda00 = lambda, phi), x00 = x0, y00 = y0, a00 = a0, b00 = b0, c00 = c0;
      resampleStream.point = linePoint;
    }
    function ringEnd() {
      resampleLineTo(x0, y0, lambda0, a0, b0, c0, x00, y00, lambda00, a00, b00, c00, maxDepth, stream);
      resampleStream.lineEnd = lineEnd;
      lineEnd();
    }
    return resampleStream;
  };
}

var transformRadians = transformer({
  point: function (x, y) {
    this.stream.point(x * radians, y * radians);
  }
});
function transformRotate(rotate) {
  return transformer({
    point: function (x, y) {
      var r = rotate(x, y);
      return this.stream.point(r[0], r[1]);
    }
  });
}
function scaleTranslate(k, dx, dy, sx, sy) {
  function transform(x, y) {
    x *= sx;
    y *= sy;
    return [dx + k * x, dy - k * y];
  }
  transform.invert = function (x, y) {
    return [(x - dx) / k * sx, (dy - y) / k * sy];
  };
  return transform;
}
function scaleTranslateRotate(k, dx, dy, sx, sy, alpha) {
  if (!alpha) return scaleTranslate(k, dx, dy, sx, sy);
  var cosAlpha = cos$1(alpha),
    sinAlpha = sin$1(alpha),
    a = cosAlpha * k,
    b = sinAlpha * k,
    ai = cosAlpha / k,
    bi = sinAlpha / k,
    ci = (sinAlpha * dy - cosAlpha * dx) / k,
    fi = (sinAlpha * dx + cosAlpha * dy) / k;
  function transform(x, y) {
    x *= sx;
    y *= sy;
    return [a * x - b * y + dx, dy - b * x - a * y];
  }
  transform.invert = function (x, y) {
    return [sx * (ai * x - bi * y + ci), sy * (fi - bi * x - ai * y)];
  };
  return transform;
}
function projection$1(project) {
  return projectionMutator(function () {
    return project;
  })();
}
function projectionMutator(projectAt) {
  var project,
    k = 150,
    // scale
    x = 480,
    y = 250,
    // translate
    lambda = 0,
    phi = 0,
    // center
    deltaLambda = 0,
    deltaPhi = 0,
    deltaGamma = 0,
    rotate,
    // pre-rotate
    alpha = 0,
    // post-rotate angle
    sx = 1,
    // reflectX
    sy = 1,
    // reflectX
    theta = null,
    preclip = clipAntimeridian,
    // pre-clip angle
    x0 = null,
    y0,
    x1,
    y1,
    postclip = identity,
    // post-clip extent
    delta2 = 0.5,
    // precision
    projectResample,
    projectTransform,
    projectRotateTransform,
    cache,
    cacheStream;
  function projection(point) {
    return projectRotateTransform(point[0] * radians, point[1] * radians);
  }
  function invert(point) {
    point = projectRotateTransform.invert(point[0], point[1]);
    return point && [point[0] * degrees, point[1] * degrees];
  }
  projection.stream = function (stream) {
    return cache && cacheStream === stream ? cache : cache = transformRadians(transformRotate(rotate)(preclip(projectResample(postclip(cacheStream = stream)))));
  };
  projection.preclip = function (_) {
    return arguments.length ? (preclip = _, theta = undefined, reset()) : preclip;
  };
  projection.postclip = function (_) {
    return arguments.length ? (postclip = _, x0 = y0 = x1 = y1 = null, reset()) : postclip;
  };
  projection.clipAngle = function (_) {
    return arguments.length ? (preclip = +_ ? clipCircle(theta = _ * radians) : (theta = null, clipAntimeridian), reset()) : theta * degrees;
  };
  projection.clipExtent = function (_) {
    return arguments.length ? (postclip = _ == null ? (x0 = y0 = x1 = y1 = null, identity) : clipRectangle(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reset()) : x0 == null ? null : [[x0, y0], [x1, y1]];
  };
  projection.scale = function (_) {
    return arguments.length ? (k = +_, recenter()) : k;
  };
  projection.translate = function (_) {
    return arguments.length ? (x = +_[0], y = +_[1], recenter()) : [x, y];
  };
  projection.center = function (_) {
    return arguments.length ? (lambda = _[0] % 360 * radians, phi = _[1] % 360 * radians, recenter()) : [lambda * degrees, phi * degrees];
  };
  projection.rotate = function (_) {
    return arguments.length ? (deltaLambda = _[0] % 360 * radians, deltaPhi = _[1] % 360 * radians, deltaGamma = _.length > 2 ? _[2] % 360 * radians : 0, recenter()) : [deltaLambda * degrees, deltaPhi * degrees, deltaGamma * degrees];
  };
  projection.angle = function (_) {
    return arguments.length ? (alpha = _ % 360 * radians, recenter()) : alpha * degrees;
  };
  projection.reflectX = function (_) {
    return arguments.length ? (sx = _ ? -1 : 1, recenter()) : sx < 0;
  };
  projection.reflectY = function (_) {
    return arguments.length ? (sy = _ ? -1 : 1, recenter()) : sy < 0;
  };
  projection.precision = function (_) {
    return arguments.length ? (projectResample = resample(projectTransform, delta2 = _ * _), reset()) : sqrt$1(delta2);
  };
  projection.fitExtent = function (extent, object) {
    return fitExtent(projection, extent, object);
  };
  projection.fitSize = function (size, object) {
    return fitSize(projection, size, object);
  };
  projection.fitWidth = function (width, object) {
    return fitWidth(projection, width, object);
  };
  projection.fitHeight = function (height, object) {
    return fitHeight(projection, height, object);
  };
  function recenter() {
    var center = scaleTranslateRotate(k, 0, 0, sx, sy, alpha).apply(null, project(lambda, phi)),
      transform = scaleTranslateRotate(k, x - center[0], y - center[1], sx, sy, alpha);
    rotate = rotateRadians(deltaLambda, deltaPhi, deltaGamma);
    projectTransform = compose(project, transform);
    projectRotateTransform = compose(rotate, projectTransform);
    projectResample = resample(projectTransform, delta2);
    return reset();
  }
  function reset() {
    cache = cacheStream = null;
    return projection;
  }
  return function () {
    project = projectAt.apply(this, arguments);
    projection.invert = project.invert && invert;
    return recenter();
  };
}

function conicProjection(projectAt) {
  var phi0 = 0,
    phi1 = pi$1 / 3,
    m = projectionMutator(projectAt),
    p = m(phi0, phi1);
  p.parallels = function (_) {
    return arguments.length ? m(phi0 = _[0] * radians, phi1 = _[1] * radians) : [phi0 * degrees, phi1 * degrees];
  };
  return p;
}

function cylindricalEqualAreaRaw(phi0) {
  var cosPhi0 = cos$1(phi0);
  function forward(lambda, phi) {
    return [lambda * cosPhi0, sin$1(phi) / cosPhi0];
  }
  forward.invert = function (x, y) {
    return [x / cosPhi0, asin$1(y * cosPhi0)];
  };
  return forward;
}

function conicEqualAreaRaw(y0, y1) {
  var sy0 = sin$1(y0),
    n = (sy0 + sin$1(y1)) / 2;

  // Are the parallels symmetrical around the Equator?
  if (abs$1(n) < epsilon$3) return cylindricalEqualAreaRaw(y0);
  var c = 1 + sy0 * (2 * n - sy0),
    r0 = sqrt$1(c) / n;
  function project(x, y) {
    var r = sqrt$1(c - 2 * n * sin$1(y)) / n;
    return [r * sin$1(x *= n), r0 - r * cos$1(x)];
  }
  project.invert = function (x, y) {
    var r0y = r0 - y,
      l = atan2(x, abs$1(r0y)) * sign(r0y);
    if (r0y * n < 0) l -= pi$1 * sign(x) * sign(r0y);
    return [l / n, asin$1((c - (x * x + r0y * r0y) * n * n) / (2 * n))];
  };
  return project;
}
function geoConicEqualArea () {
  return conicProjection(conicEqualAreaRaw).scale(155.424).center([0, 33.6442]);
}

function geoAlbers () {
  return geoConicEqualArea().parallels([29.5, 45.5]).scale(1070).translate([480, 250]).rotate([96, 0]).center([-0.6, 38.7]);
}

// The projections must have mutually exclusive clip regions on the sphere,
// as this will avoid emitting interleaving lines and polygons.
function multiplex(streams) {
  var n = streams.length;
  return {
    point: function (x, y) {
      var i = -1;
      while (++i < n) streams[i].point(x, y);
    },
    sphere: function () {
      var i = -1;
      while (++i < n) streams[i].sphere();
    },
    lineStart: function () {
      var i = -1;
      while (++i < n) streams[i].lineStart();
    },
    lineEnd: function () {
      var i = -1;
      while (++i < n) streams[i].lineEnd();
    },
    polygonStart: function () {
      var i = -1;
      while (++i < n) streams[i].polygonStart();
    },
    polygonEnd: function () {
      var i = -1;
      while (++i < n) streams[i].polygonEnd();
    }
  };
}

// A composite projection for the United States, configured by default for
// 960×500. The projection also works quite well at 960×600 if you change the
// scale to 1285 and adjust the translate accordingly. The set of standard
// parallels for each region comes from USGS, which is published here:
// http://egsc.usgs.gov/isb/pubs/MapProjections/projections.html#albers
function geoAlbersUsa () {
  var cache,
    cacheStream,
    lower48 = geoAlbers(),
    lower48Point,
    alaska = geoConicEqualArea().rotate([154, 0]).center([-2, 58.5]).parallels([55, 65]),
    alaskaPoint,
    // EPSG:3338
    hawaii = geoConicEqualArea().rotate([157, 0]).center([-3, 19.9]).parallels([8, 18]),
    hawaiiPoint,
    // ESRI:102007
    point,
    pointStream = {
      point: function (x, y) {
        point = [x, y];
      }
    };
  function albersUsa(coordinates) {
    var x = coordinates[0],
      y = coordinates[1];
    return point = null, (lower48Point.point(x, y), point) || (alaskaPoint.point(x, y), point) || (hawaiiPoint.point(x, y), point);
  }
  albersUsa.invert = function (coordinates) {
    var k = lower48.scale(),
      t = lower48.translate(),
      x = (coordinates[0] - t[0]) / k,
      y = (coordinates[1] - t[1]) / k;
    return (y >= 0.120 && y < 0.234 && x >= -0.425 && x < -0.214 ? alaska : y >= 0.166 && y < 0.234 && x >= -0.214 && x < -0.115 ? hawaii : lower48).invert(coordinates);
  };
  albersUsa.stream = function (stream) {
    return cache && cacheStream === stream ? cache : cache = multiplex([lower48.stream(cacheStream = stream), alaska.stream(stream), hawaii.stream(stream)]);
  };
  albersUsa.precision = function (_) {
    if (!arguments.length) return lower48.precision();
    lower48.precision(_), alaska.precision(_), hawaii.precision(_);
    return reset();
  };
  albersUsa.scale = function (_) {
    if (!arguments.length) return lower48.scale();
    lower48.scale(_), alaska.scale(_ * 0.35), hawaii.scale(_);
    return albersUsa.translate(lower48.translate());
  };
  albersUsa.translate = function (_) {
    if (!arguments.length) return lower48.translate();
    var k = lower48.scale(),
      x = +_[0],
      y = +_[1];
    lower48Point = lower48.translate(_).clipExtent([[x - 0.455 * k, y - 0.238 * k], [x + 0.455 * k, y + 0.238 * k]]).stream(pointStream);
    alaskaPoint = alaska.translate([x - 0.307 * k, y + 0.201 * k]).clipExtent([[x - 0.425 * k + epsilon$3, y + 0.120 * k + epsilon$3], [x - 0.214 * k - epsilon$3, y + 0.234 * k - epsilon$3]]).stream(pointStream);
    hawaiiPoint = hawaii.translate([x - 0.205 * k, y + 0.212 * k]).clipExtent([[x - 0.214 * k + epsilon$3, y + 0.166 * k + epsilon$3], [x - 0.115 * k - epsilon$3, y + 0.234 * k - epsilon$3]]).stream(pointStream);
    return reset();
  };
  albersUsa.fitExtent = function (extent, object) {
    return fitExtent(albersUsa, extent, object);
  };
  albersUsa.fitSize = function (size, object) {
    return fitSize(albersUsa, size, object);
  };
  albersUsa.fitWidth = function (width, object) {
    return fitWidth(albersUsa, width, object);
  };
  albersUsa.fitHeight = function (height, object) {
    return fitHeight(albersUsa, height, object);
  };
  function reset() {
    cache = cacheStream = null;
    return albersUsa;
  }
  return albersUsa.scale(1070);
}

function azimuthalRaw(scale) {
  return function (x, y) {
    var cx = cos$1(x),
      cy = cos$1(y),
      k = scale(cx * cy);
    if (k === Infinity) return [2, 0];
    return [k * cy * sin$1(x), k * sin$1(y)];
  };
}
function azimuthalInvert(angle) {
  return function (x, y) {
    var z = sqrt$1(x * x + y * y),
      c = angle(z),
      sc = sin$1(c),
      cc = cos$1(c);
    return [atan2(x * sc, z * cc), asin$1(z && y * sc / z)];
  };
}

var azimuthalEqualAreaRaw = azimuthalRaw(function (cxcy) {
  return sqrt$1(2 / (1 + cxcy));
});
azimuthalEqualAreaRaw.invert = azimuthalInvert(function (z) {
  return 2 * asin$1(z / 2);
});
function geoAzimuthalEqualArea () {
  return projection$1(azimuthalEqualAreaRaw).scale(124.75).clipAngle(180 - 1e-3);
}

var azimuthalEquidistantRaw = azimuthalRaw(function (c) {
  return (c = acos(c)) && c / sin$1(c);
});
azimuthalEquidistantRaw.invert = azimuthalInvert(function (z) {
  return z;
});
function geoAzimuthalEquidistant () {
  return projection$1(azimuthalEquidistantRaw).scale(79.4188).clipAngle(180 - 1e-3);
}

function mercatorRaw(lambda, phi) {
  return [lambda, log$1(tan((halfPi$1 + phi) / 2))];
}
mercatorRaw.invert = function (x, y) {
  return [x, 2 * atan(exp(y)) - halfPi$1];
};
function geoMercator () {
  return mercatorProjection(mercatorRaw).scale(961 / tau$1);
}
function mercatorProjection(project) {
  var m = projection$1(project),
    center = m.center,
    scale = m.scale,
    translate = m.translate,
    clipExtent = m.clipExtent,
    x0 = null,
    y0,
    x1,
    y1; // clip extent

  m.scale = function (_) {
    return arguments.length ? (scale(_), reclip()) : scale();
  };
  m.translate = function (_) {
    return arguments.length ? (translate(_), reclip()) : translate();
  };
  m.center = function (_) {
    return arguments.length ? (center(_), reclip()) : center();
  };
  m.clipExtent = function (_) {
    return arguments.length ? (_ == null ? x0 = y0 = x1 = y1 = null : (x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reclip()) : x0 == null ? null : [[x0, y0], [x1, y1]];
  };
  function reclip() {
    var k = pi$1 * scale(),
      t = m(rotation(m.rotate()).invert([0, 0]));
    return clipExtent(x0 == null ? [[t[0] - k, t[1] - k], [t[0] + k, t[1] + k]] : project === mercatorRaw ? [[Math.max(t[0] - k, x0), y0], [Math.min(t[0] + k, x1), y1]] : [[x0, Math.max(t[1] - k, y0)], [x1, Math.min(t[1] + k, y1)]]);
  }
  return reclip();
}

function tany(y) {
  return tan((halfPi$1 + y) / 2);
}
function conicConformalRaw(y0, y1) {
  var cy0 = cos$1(y0),
    n = y0 === y1 ? sin$1(y0) : log$1(cy0 / cos$1(y1)) / log$1(tany(y1) / tany(y0)),
    f = cy0 * pow$1(tany(y0), n) / n;
  if (!n) return mercatorRaw;
  function project(x, y) {
    if (f > 0) {
      if (y < -halfPi$1 + epsilon$3) y = -halfPi$1 + epsilon$3;
    } else {
      if (y > halfPi$1 - epsilon$3) y = halfPi$1 - epsilon$3;
    }
    var r = f / pow$1(tany(y), n);
    return [r * sin$1(n * x), f - r * cos$1(n * x)];
  }
  project.invert = function (x, y) {
    var fy = f - y,
      r = sign(n) * sqrt$1(x * x + fy * fy),
      l = atan2(x, abs$1(fy)) * sign(fy);
    if (fy * n < 0) l -= pi$1 * sign(x) * sign(fy);
    return [l / n, 2 * atan(pow$1(f / r, 1 / n)) - halfPi$1];
  };
  return project;
}
function geoConicConformal () {
  return conicProjection(conicConformalRaw).scale(109.5).parallels([30, 30]);
}

function equirectangularRaw(lambda, phi) {
  return [lambda, phi];
}
equirectangularRaw.invert = equirectangularRaw;
function geoEquirectangular () {
  return projection$1(equirectangularRaw).scale(152.63);
}

function conicEquidistantRaw(y0, y1) {
  var cy0 = cos$1(y0),
    n = y0 === y1 ? sin$1(y0) : (cy0 - cos$1(y1)) / (y1 - y0),
    g = cy0 / n + y0;
  if (abs$1(n) < epsilon$3) return equirectangularRaw;
  function project(x, y) {
    var gy = g - y,
      nx = n * x;
    return [gy * sin$1(nx), g - gy * cos$1(nx)];
  }
  project.invert = function (x, y) {
    var gy = g - y,
      l = atan2(x, abs$1(gy)) * sign(gy);
    if (gy * n < 0) l -= pi$1 * sign(x) * sign(gy);
    return [l / n, g - sign(n) * sqrt$1(x * x + gy * gy)];
  };
  return project;
}
function geoConicEquidistant () {
  return conicProjection(conicEquidistantRaw).scale(131.154).center([0, 13.9389]);
}

var A1 = 1.340264,
  A2 = -0.081106,
  A3 = 0.000893,
  A4 = 0.003796,
  M = sqrt$1(3) / 2,
  iterations = 12;
function equalEarthRaw(lambda, phi) {
  var l = asin$1(M * sin$1(phi)),
    l2 = l * l,
    l6 = l2 * l2 * l2;
  return [lambda * cos$1(l) / (M * (A1 + 3 * A2 * l2 + l6 * (7 * A3 + 9 * A4 * l2))), l * (A1 + A2 * l2 + l6 * (A3 + A4 * l2))];
}
equalEarthRaw.invert = function (x, y) {
  var l = y,
    l2 = l * l,
    l6 = l2 * l2 * l2;
  for (var i = 0, delta, fy, fpy; i < iterations; ++i) {
    fy = l * (A1 + A2 * l2 + l6 * (A3 + A4 * l2)) - y;
    fpy = A1 + 3 * A2 * l2 + l6 * (7 * A3 + 9 * A4 * l2);
    l -= delta = fy / fpy, l2 = l * l, l6 = l2 * l2 * l2;
    if (abs$1(delta) < epsilon2) break;
  }
  return [M * x * (A1 + 3 * A2 * l2 + l6 * (7 * A3 + 9 * A4 * l2)) / cos$1(l), asin$1(sin$1(l) / M)];
};
function geoEqualEarth () {
  return projection$1(equalEarthRaw).scale(177.158);
}

function gnomonicRaw(x, y) {
  var cy = cos$1(y),
    k = cos$1(x) * cy;
  return [cy * sin$1(x) / k, sin$1(y) / k];
}
gnomonicRaw.invert = azimuthalInvert(atan);
function geoGnomonic () {
  return projection$1(gnomonicRaw).scale(144.049).clipAngle(60);
}

function geoIdentity () {
  var k = 1,
    tx = 0,
    ty = 0,
    sx = 1,
    sy = 1,
    // scale, translate and reflect
    alpha = 0,
    ca,
    sa,
    // angle
    x0 = null,
    y0,
    x1,
    y1,
    // clip extent
    kx = 1,
    ky = 1,
    transform = transformer({
      point: function (x, y) {
        var p = projection([x, y]);
        this.stream.point(p[0], p[1]);
      }
    }),
    postclip = identity,
    cache,
    cacheStream;
  function reset() {
    kx = k * sx;
    ky = k * sy;
    cache = cacheStream = null;
    return projection;
  }
  function projection(p) {
    var x = p[0] * kx,
      y = p[1] * ky;
    if (alpha) {
      var t = y * ca - x * sa;
      x = x * ca + y * sa;
      y = t;
    }
    return [x + tx, y + ty];
  }
  projection.invert = function (p) {
    var x = p[0] - tx,
      y = p[1] - ty;
    if (alpha) {
      var t = y * ca + x * sa;
      x = x * ca - y * sa;
      y = t;
    }
    return [x / kx, y / ky];
  };
  projection.stream = function (stream) {
    return cache && cacheStream === stream ? cache : cache = transform(postclip(cacheStream = stream));
  };
  projection.postclip = function (_) {
    return arguments.length ? (postclip = _, x0 = y0 = x1 = y1 = null, reset()) : postclip;
  };
  projection.clipExtent = function (_) {
    return arguments.length ? (postclip = _ == null ? (x0 = y0 = x1 = y1 = null, identity) : clipRectangle(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reset()) : x0 == null ? null : [[x0, y0], [x1, y1]];
  };
  projection.scale = function (_) {
    return arguments.length ? (k = +_, reset()) : k;
  };
  projection.translate = function (_) {
    return arguments.length ? (tx = +_[0], ty = +_[1], reset()) : [tx, ty];
  };
  projection.angle = function (_) {
    return arguments.length ? (alpha = _ % 360 * radians, sa = sin$1(alpha), ca = cos$1(alpha), reset()) : alpha * degrees;
  };
  projection.reflectX = function (_) {
    return arguments.length ? (sx = _ ? -1 : 1, reset()) : sx < 0;
  };
  projection.reflectY = function (_) {
    return arguments.length ? (sy = _ ? -1 : 1, reset()) : sy < 0;
  };
  projection.fitExtent = function (extent, object) {
    return fitExtent(projection, extent, object);
  };
  projection.fitSize = function (size, object) {
    return fitSize(projection, size, object);
  };
  projection.fitWidth = function (width, object) {
    return fitWidth(projection, width, object);
  };
  projection.fitHeight = function (height, object) {
    return fitHeight(projection, height, object);
  };
  return projection;
}

function naturalEarth1Raw(lambda, phi) {
  var phi2 = phi * phi,
    phi4 = phi2 * phi2;
  return [lambda * (0.8707 - 0.131979 * phi2 + phi4 * (-0.013791 + phi4 * (0.003971 * phi2 - 0.001529 * phi4))), phi * (1.007226 + phi2 * (0.015085 + phi4 * (-0.044475 + 0.028874 * phi2 - 0.005916 * phi4)))];
}
naturalEarth1Raw.invert = function (x, y) {
  var phi = y,
    i = 25,
    delta;
  do {
    var phi2 = phi * phi,
      phi4 = phi2 * phi2;
    phi -= delta = (phi * (1.007226 + phi2 * (0.015085 + phi4 * (-0.044475 + 0.028874 * phi2 - 0.005916 * phi4))) - y) / (1.007226 + phi2 * (0.015085 * 3 + phi4 * (-0.044475 * 7 + 0.028874 * 9 * phi2 - 0.005916 * 11 * phi4)));
  } while (abs$1(delta) > epsilon$3 && --i > 0);
  return [x / (0.8707 + (phi2 = phi * phi) * (-0.131979 + phi2 * (-0.013791 + phi2 * phi2 * phi2 * (0.003971 - 0.001529 * phi2)))), phi];
};
function geoNaturalEarth1 () {
  return projection$1(naturalEarth1Raw).scale(175.295);
}

function orthographicRaw(x, y) {
  return [cos$1(y) * sin$1(x), sin$1(y)];
}
orthographicRaw.invert = azimuthalInvert(asin$1);
function geoOrthographic () {
  return projection$1(orthographicRaw).scale(249.5).clipAngle(90 + epsilon$3);
}

function stereographicRaw(x, y) {
  var cy = cos$1(y),
    k = 1 + cos$1(x) * cy;
  return [cy * sin$1(x) / k, sin$1(y) / k];
}
stereographicRaw.invert = azimuthalInvert(function (z) {
  return 2 * atan(z);
});
function geoStereographic () {
  return projection$1(stereographicRaw).scale(250).clipAngle(142);
}

function transverseMercatorRaw(lambda, phi) {
  return [log$1(tan((halfPi$1 + phi) / 2)), -lambda];
}
transverseMercatorRaw.invert = function (x, y) {
  return [-y, 2 * atan(exp(x)) - halfPi$1];
};
function geoTransverseMercator () {
  var m = mercatorProjection(transverseMercatorRaw),
    center = m.center,
    rotate = m.rotate;
  m.center = function (_) {
    return arguments.length ? center([-_[1], _[0]]) : (_ = center(), [_[1], -_[0]]);
  };
  m.rotate = function (_) {
    return arguments.length ? rotate([_[0], _[1], _.length > 2 ? _[2] + 90 : 90]) : (_ = rotate(), [_[0], _[1], _[2] - 90]);
  };
  return rotate([0, 0, 90]).scale(159.155);
}

var abs = Math.abs;
var cos = Math.cos;
var sin = Math.sin;
var epsilon$2 = 1e-6;
var pi = Math.PI;
var halfPi = pi / 2;
var sqrt2 = sqrt(2);
function asin(x) {
  return x > 1 ? halfPi : x < -1 ? -halfPi : Math.asin(x);
}
function sqrt(x) {
  return x > 0 ? Math.sqrt(x) : 0;
}

function mollweideBromleyTheta(cp, phi) {
  var cpsinPhi = cp * sin(phi),
    i = 30,
    delta;
  do phi -= delta = (phi + sin(phi) - cpsinPhi) / (1 + cos(phi)); while (abs(delta) > epsilon$2 && --i > 0);
  return phi / 2;
}
function mollweideBromleyRaw(cx, cy, cp) {
  function forward(lambda, phi) {
    return [cx * lambda * cos(phi = mollweideBromleyTheta(cp, phi)), cy * sin(phi)];
  }
  forward.invert = function (x, y) {
    return y = asin(y / cy), [x / (cx * cos(y)), asin((2 * y + sin(2 * y)) / cp)];
  };
  return forward;
}
var mollweideRaw = mollweideBromleyRaw(sqrt2 / halfPi, sqrt2, pi);
function geoMollweide () {
  return projection$1(mollweideRaw).scale(169.529);
}

const defaultPath = geoPath();
const projectionProperties = [
// standard properties in d3-geo
'clipAngle', 'clipExtent', 'scale', 'translate', 'center', 'rotate', 'parallels', 'precision', 'reflectX', 'reflectY',
// extended properties in d3-geo-projections
'coefficient', 'distance', 'fraction', 'lobes', 'parallel', 'radius', 'ratio', 'spacing', 'tilt'];

/**
 * Augment projections with their type and a copy method.
 */
function create$1(type, constructor) {
  return function projection() {
    const p = constructor();
    p.type = type;
    p.path = geoPath().projection(p);
    p.copy = p.copy || function () {
      const c = projection();
      projectionProperties.forEach(prop => {
        if (p[prop]) c[prop](p[prop]());
      });
      c.path.pointRadius(p.path.pointRadius());
      return c;
    };
    return registerScale(p);
  };
}
function projection(type, proj) {
  if (!type || typeof type !== 'string') {
    throw new Error('Projection type must be a name string.');
  }
  type = type.toLowerCase();
  if (arguments.length > 1) {
    projections[type] = create$1(type, proj);
    return this;
  } else {
    return projections[type] || null;
  }
}
function getProjectionPath(proj) {
  return proj && proj.path || defaultPath;
}
const projections = {
  // base d3-geo projection types
  albers: geoAlbers,
  albersusa: geoAlbersUsa,
  azimuthalequalarea: geoAzimuthalEqualArea,
  azimuthalequidistant: geoAzimuthalEquidistant,
  conicconformal: geoConicConformal,
  conicequalarea: geoConicEqualArea,
  conicequidistant: geoConicEquidistant,
  equalEarth: geoEqualEarth,
  equirectangular: geoEquirectangular,
  gnomonic: geoGnomonic,
  identity: geoIdentity,
  mercator: geoMercator,
  mollweide: geoMollweide,
  naturalEarth1: geoNaturalEarth1,
  orthographic: geoOrthographic,
  stereographic: geoStereographic,
  transversemercator: geoTransverseMercator
};
for (const key in projections) {
  projection(key, projections[key]);
}

function noop$1() {}
const cases = [[], [[[1.0, 1.5], [0.5, 1.0]]], [[[1.5, 1.0], [1.0, 1.5]]], [[[1.5, 1.0], [0.5, 1.0]]], [[[1.0, 0.5], [1.5, 1.0]]], [[[1.0, 1.5], [0.5, 1.0]], [[1.0, 0.5], [1.5, 1.0]]], [[[1.0, 0.5], [1.0, 1.5]]], [[[1.0, 0.5], [0.5, 1.0]]], [[[0.5, 1.0], [1.0, 0.5]]], [[[1.0, 1.5], [1.0, 0.5]]], [[[0.5, 1.0], [1.0, 0.5]], [[1.5, 1.0], [1.0, 1.5]]], [[[1.5, 1.0], [1.0, 0.5]]], [[[0.5, 1.0], [1.5, 1.0]]], [[[1.0, 1.5], [1.5, 1.0]]], [[[0.5, 1.0], [1.0, 1.5]]], []];

// Implementation adapted from d3/d3-contour. Thanks!
function contours() {
  var dx = 1,
    dy = 1,
    smooth = smoothLinear;
  function contours(values, tz) {
    return tz.map(value => contour(values, value));
  }

  // Accumulate, smooth contour rings, assign holes to exterior rings.
  // Based on https://github.com/mbostock/shapefile/blob/v0.6.2/shp/polygon.js
  function contour(values, value) {
    var polygons = [],
      holes = [];
    isorings(values, value, ring => {
      smooth(ring, values, value);
      if (area(ring) > 0) polygons.push([ring]);else holes.push(ring);
    });
    holes.forEach(hole => {
      for (var i = 0, n = polygons.length, polygon; i < n; ++i) {
        if (contains((polygon = polygons[i])[0], hole) !== -1) {
          polygon.push(hole);
          return;
        }
      }
    });
    return {
      type: 'MultiPolygon',
      value: value,
      coordinates: polygons
    };
  }

  // Marching squares with isolines stitched into rings.
  // Based on https://github.com/topojson/topojson-client/blob/v3.0.0/src/stitch.js
  function isorings(values, value, callback) {
    var fragmentByStart = [],
      fragmentByEnd = [],
      x,
      y,
      t0,
      t1,
      t2,
      t3;

    // Special case for the first row (y = -1, t2 = t3 = 0).
    x = y = -1;
    t1 = values[0] >= value;
    cases[t1 << 1].forEach(stitch);
    while (++x < dx - 1) {
      t0 = t1, t1 = values[x + 1] >= value;
      cases[t0 | t1 << 1].forEach(stitch);
    }
    cases[t1 << 0].forEach(stitch);

    // General case for the intermediate rows.
    while (++y < dy - 1) {
      x = -1;
      t1 = values[y * dx + dx] >= value;
      t2 = values[y * dx] >= value;
      cases[t1 << 1 | t2 << 2].forEach(stitch);
      while (++x < dx - 1) {
        t0 = t1, t1 = values[y * dx + dx + x + 1] >= value;
        t3 = t2, t2 = values[y * dx + x + 1] >= value;
        cases[t0 | t1 << 1 | t2 << 2 | t3 << 3].forEach(stitch);
      }
      cases[t1 | t2 << 3].forEach(stitch);
    }

    // Special case for the last row (y = dy - 1, t0 = t1 = 0).
    x = -1;
    t2 = values[y * dx] >= value;
    cases[t2 << 2].forEach(stitch);
    while (++x < dx - 1) {
      t3 = t2, t2 = values[y * dx + x + 1] >= value;
      cases[t2 << 2 | t3 << 3].forEach(stitch);
    }
    cases[t2 << 3].forEach(stitch);
    function stitch(line) {
      var start = [line[0][0] + x, line[0][1] + y],
        end = [line[1][0] + x, line[1][1] + y],
        startIndex = index(start),
        endIndex = index(end),
        f,
        g;
      if (f = fragmentByEnd[startIndex]) {
        if (g = fragmentByStart[endIndex]) {
          delete fragmentByEnd[f.end];
          delete fragmentByStart[g.start];
          if (f === g) {
            f.ring.push(end);
            callback(f.ring);
          } else {
            fragmentByStart[f.start] = fragmentByEnd[g.end] = {
              start: f.start,
              end: g.end,
              ring: f.ring.concat(g.ring)
            };
          }
        } else {
          delete fragmentByEnd[f.end];
          f.ring.push(end);
          fragmentByEnd[f.end = endIndex] = f;
        }
      } else if (f = fragmentByStart[endIndex]) {
        if (g = fragmentByEnd[startIndex]) {
          delete fragmentByStart[f.start];
          delete fragmentByEnd[g.end];
          if (f === g) {
            f.ring.push(end);
            callback(f.ring);
          } else {
            fragmentByStart[g.start] = fragmentByEnd[f.end] = {
              start: g.start,
              end: f.end,
              ring: g.ring.concat(f.ring)
            };
          }
        } else {
          delete fragmentByStart[f.start];
          f.ring.unshift(start);
          fragmentByStart[f.start = startIndex] = f;
        }
      } else {
        fragmentByStart[startIndex] = fragmentByEnd[endIndex] = {
          start: startIndex,
          end: endIndex,
          ring: [start, end]
        };
      }
    }
  }
  function index(point) {
    return point[0] * 2 + point[1] * (dx + 1) * 4;
  }
  function smoothLinear(ring, values, value) {
    ring.forEach(point => {
      var x = point[0],
        y = point[1],
        xt = x | 0,
        yt = y | 0,
        v0,
        v1 = values[yt * dx + xt];
      if (x > 0 && x < dx && xt === x) {
        v0 = values[yt * dx + xt - 1];
        point[0] = x + (value - v0) / (v1 - v0) - 0.5;
      }
      if (y > 0 && y < dy && yt === y) {
        v0 = values[(yt - 1) * dx + xt];
        point[1] = y + (value - v0) / (v1 - v0) - 0.5;
      }
    });
  }
  contours.contour = contour;
  contours.size = function (_) {
    if (!arguments.length) return [dx, dy];
    var _0 = Math.floor(_[0]),
      _1 = Math.floor(_[1]);
    if (!(_0 >= 0 && _1 >= 0)) error('invalid size');
    return dx = _0, dy = _1, contours;
  };
  contours.smooth = function (_) {
    return arguments.length ? (smooth = _ ? smoothLinear : noop$1, contours) : smooth === smoothLinear;
  };
  return contours;
}
function area(ring) {
  var i = 0,
    n = ring.length,
    area = ring[n - 1][1] * ring[0][0] - ring[n - 1][0] * ring[0][1];
  while (++i < n) area += ring[i - 1][1] * ring[i][0] - ring[i - 1][0] * ring[i][1];
  return area;
}
function contains(ring, hole) {
  var i = -1,
    n = hole.length,
    c;
  while (++i < n) if (c = ringContains(ring, hole[i])) return c;
  return 0;
}
function ringContains(ring, point) {
  var x = point[0],
    y = point[1],
    contains = -1;
  for (var i = 0, n = ring.length, j = n - 1; i < n; j = i++) {
    var pi = ring[i],
      xi = pi[0],
      yi = pi[1],
      pj = ring[j],
      xj = pj[0],
      yj = pj[1];
    if (segmentContains(pi, pj, point)) return 0;
    if (yi > y !== yj > y && x < (xj - xi) * (y - yi) / (yj - yi) + xi) contains = -contains;
  }
  return contains;
}
function segmentContains(a, b, c) {
  var i;
  return collinear$1(a, b, c) && within(a[i = +(a[0] === b[0])], c[i], b[i]);
}
function collinear$1(a, b, c) {
  return (b[0] - a[0]) * (c[1] - a[1]) === (c[0] - a[0]) * (b[1] - a[1]);
}
function within(p, q, r) {
  return p <= q && q <= r || r <= q && q <= p;
}
function quantize(k, nice, zero) {
  return function (values) {
    var ex = extent(values),
      start = zero ? Math.min(ex[0], 0) : ex[0],
      stop = ex[1],
      span = stop - start,
      step = nice ? tickStep(start, stop, k) : span / (k + 1);
    return range$3(start + step, stop, step);
  };
}

/**
 * Generate isocontours (level sets) based on input raster grid data.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {function(object): *} [params.field] - The field with raster grid
 *   data. If unspecified, the tuple itself is interpreted as a raster grid.
 * @param {Array<number>} [params.thresholds] - Contour threshold array. If
 *   specified, the levels, nice, resolve, and zero parameters are ignored.
 * @param {number} [params.levels] - The desired number of contour levels.
 * @param {boolean} [params.nice] - Boolean flag indicating if the contour
 *   threshold values should be automatically aligned to "nice"
 *   human-friendly values. Setting this flag may cause the number of
 *   thresholds to deviate from the specified levels.
 * @param {string} [params.resolve] - The method for resolving thresholds
 *   across multiple input grids. If 'independent' (the default), threshold
 *   calculation will be performed separately for each grid. If 'shared', a
 *   single set of threshold values will be used for all input grids.
 * @param {boolean} [params.zero] - Boolean flag indicating if the contour
 *   threshold values should include zero.
 * @param {boolean} [params.smooth] - Boolean flag indicating if the contour
 *   polygons should be smoothed using linear interpolation. The default is
 *   true. The parameter is ignored when using density estimation.
 * @param {boolean} [params.scale] - Optional numerical value by which to
 *   scale the output isocontour coordinates. This parameter can be useful
 *   to scale the contours to match a desired output resolution.
 * @param {string} [params.as='contour'] - The output field in which to store
 *   the generated isocontour data (default 'contour').
 */
function Isocontour(params) {
  Transform.call(this, null, params);
}
Isocontour.Definition = {
  'type': 'Isocontour',
  'metadata': {
    'generates': true
  },
  'params': [{
    'name': 'field',
    'type': 'field'
  }, {
    'name': 'thresholds',
    'type': 'number',
    'array': true
  }, {
    'name': 'levels',
    'type': 'number'
  }, {
    'name': 'nice',
    'type': 'boolean',
    'default': false
  }, {
    'name': 'resolve',
    'type': 'enum',
    'values': ['shared', 'independent'],
    'default': 'independent'
  }, {
    'name': 'zero',
    'type': 'boolean',
    'default': true
  }, {
    'name': 'smooth',
    'type': 'boolean',
    'default': true
  }, {
    'name': 'scale',
    'type': 'number',
    'expr': true
  }, {
    'name': 'translate',
    'type': 'number',
    'array': true,
    'expr': true
  }, {
    'name': 'as',
    'type': 'string',
    'null': true,
    'default': 'contour'
  }]
};
inherits(Isocontour, Transform, {
  transform(_, pulse) {
    if (this.value && !pulse.changed() && !_.modified()) {
      return pulse.StopPropagation;
    }
    var out = pulse.fork(pulse.NO_SOURCE | pulse.NO_FIELDS),
      source = pulse.materialize(pulse.SOURCE).source,
      field = _.field || identity$6,
      contour = contours().smooth(_.smooth !== false),
      tz = _.thresholds || levels(source, field, _),
      as = _.as === null ? null : _.as || 'contour',
      values = [];
    source.forEach(t => {
      const grid = field(t);

      // generate contour paths in GeoJSON format
      const paths = contour.size([grid.width, grid.height])(grid.values, isArray(tz) ? tz : tz(grid.values));

      // adjust contour path coordinates as needed
      transformPaths(paths, grid, t, _);

      // ingest; copy source data properties to output
      paths.forEach(p => {
        values.push(rederive(t, ingest$1(as != null ? {
          [as]: p
        } : p)));
      });
    });
    if (this.value) out.rem = this.value;
    this.value = out.source = out.add = values;
    return out;
  }
});
function levels(values, f, _) {
  const q = quantize(_.levels || 10, _.nice, _.zero !== false);
  return _.resolve !== 'shared' ? q : q(values.map(t => max$2(f(t).values)));
}
function transformPaths(paths, grid, datum, _) {
  let s = _.scale || grid.scale,
    t = _.translate || grid.translate;
  if (isFunction(s)) s = s(datum, _);
  if (isFunction(t)) t = t(datum, _);
  if ((s === 1 || s == null) && !t) return;
  const sx = (isNumber$1(s) ? s : s[0]) || 1,
    sy = (isNumber$1(s) ? s : s[1]) || 1,
    tx = t && t[0] || 0,
    ty = t && t[1] || 0;
  paths.forEach(transform$1(grid, sx, sy, tx, ty));
}
function transform$1(grid, sx, sy, tx, ty) {
  const x1 = grid.x1 || 0,
    y1 = grid.y1 || 0,
    flip = sx * sy < 0;
  function transformPolygon(coordinates) {
    coordinates.forEach(transformRing);
  }
  function transformRing(coordinates) {
    if (flip) coordinates.reverse(); // maintain winding order
    coordinates.forEach(transformPoint);
  }
  function transformPoint(coordinates) {
    coordinates[0] = (coordinates[0] - x1) * sx + tx;
    coordinates[1] = (coordinates[1] - y1) * sy + ty;
  }
  return function (geometry) {
    geometry.coordinates.forEach(transformPolygon);
    return geometry;
  };
}
function radius(bw, data, f) {
  const v = bw >= 0 ? bw : estimateBandwidth(data, f);
  return Math.round((Math.sqrt(4 * v * v + 1) - 1) / 2);
}
function number$2(_) {
  return isFunction(_) ? _ : constant$5(+_);
}

// Implementation adapted from d3/d3-contour. Thanks!
function density2D() {
  var x = d => d[0],
    y = d => d[1],
    weight = one$2,
    bandwidth = [-1, -1],
    dx = 960,
    dy = 500,
    k = 2; // log2(cellSize)

  function density(data, counts) {
    const rx = radius(bandwidth[0], data, x) >> k,
      // blur x-radius
      ry = radius(bandwidth[1], data, y) >> k,
      // blur y-radius
      ox = rx ? rx + 2 : 0,
      // x-offset padding for blur
      oy = ry ? ry + 2 : 0,
      // y-offset padding for blur
      n = 2 * ox + (dx >> k),
      // grid width
      m = 2 * oy + (dy >> k),
      // grid height
      values0 = new Float32Array(n * m),
      values1 = new Float32Array(n * m);
    let values = values0;
    data.forEach(d => {
      const xi = ox + (+x(d) >> k),
        yi = oy + (+y(d) >> k);
      if (xi >= 0 && xi < n && yi >= 0 && yi < m) {
        values0[xi + yi * n] += +weight(d);
      }
    });
    if (rx > 0 && ry > 0) {
      blurX(n, m, values0, values1, rx);
      blurY(n, m, values1, values0, ry);
      blurX(n, m, values0, values1, rx);
      blurY(n, m, values1, values0, ry);
      blurX(n, m, values0, values1, rx);
      blurY(n, m, values1, values0, ry);
    } else if (rx > 0) {
      blurX(n, m, values0, values1, rx);
      blurX(n, m, values1, values0, rx);
      blurX(n, m, values0, values1, rx);
      values = values1;
    } else if (ry > 0) {
      blurY(n, m, values0, values1, ry);
      blurY(n, m, values1, values0, ry);
      blurY(n, m, values0, values1, ry);
      values = values1;
    }

    // scale density estimates
    // density in points per square pixel or probability density
    const s = counts ? Math.pow(2, -2 * k) : 1 / sum$1(values);
    for (let i = 0, sz = n * m; i < sz; ++i) values[i] *= s;
    return {
      values: values,
      scale: 1 << k,
      width: n,
      height: m,
      x1: ox,
      y1: oy,
      x2: ox + (dx >> k),
      y2: oy + (dy >> k)
    };
  }
  density.x = function (_) {
    return arguments.length ? (x = number$2(_), density) : x;
  };
  density.y = function (_) {
    return arguments.length ? (y = number$2(_), density) : y;
  };
  density.weight = function (_) {
    return arguments.length ? (weight = number$2(_), density) : weight;
  };
  density.size = function (_) {
    if (!arguments.length) return [dx, dy];
    var _0 = +_[0],
      _1 = +_[1];
    if (!(_0 >= 0 && _1 >= 0)) error('invalid size');
    return dx = _0, dy = _1, density;
  };
  density.cellSize = function (_) {
    if (!arguments.length) return 1 << k;
    if (!((_ = +_) >= 1)) error('invalid cell size');
    k = Math.floor(Math.log(_) / Math.LN2);
    return density;
  };
  density.bandwidth = function (_) {
    if (!arguments.length) return bandwidth;
    _ = array$5(_);
    if (_.length === 1) _ = [+_[0], +_[0]];
    if (_.length !== 2) error('invalid bandwidth');
    return bandwidth = _, density;
  };
  return density;
}
function blurX(n, m, source, target, r) {
  const w = (r << 1) + 1;
  for (let j = 0; j < m; ++j) {
    for (let i = 0, sr = 0; i < n + r; ++i) {
      if (i < n) {
        sr += source[i + j * n];
      }
      if (i >= r) {
        if (i >= w) {
          sr -= source[i - w + j * n];
        }
        target[i - r + j * n] = sr / Math.min(i + 1, n - 1 + w - i, w);
      }
    }
  }
}
function blurY(n, m, source, target, r) {
  const w = (r << 1) + 1;
  for (let i = 0; i < n; ++i) {
    for (let j = 0, sr = 0; j < m + r; ++j) {
      if (j < m) {
        sr += source[i + j * n];
      }
      if (j >= r) {
        if (j >= w) {
          sr -= source[i + (j - w) * n];
        }
        target[i + (j - r) * n] = sr / Math.min(j + 1, m - 1 + w - j, w);
      }
    }
  }
}

/**
 * Perform 2D kernel-density estimation of point data.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {Array<number>} params.size - The [width, height] extent (in
 *   units of input pixels) over which to perform density estimation.
 * @param {function(object): number} params.x - The x-coordinate accessor.
 * @param {function(object): number} params.y - The y-coordinate accessor.
 * @param {function(object): number} [params.weight] - The weight accessor.
 * @param {Array<function(object): *>} [params.groupby] - An array of accessors
 *   to groupby.
 * @param {number} [params.cellSize] - Contour density calculation cell size.
 *   This parameter determines the level of spatial approximation. For example,
 *   the default value of 4 maps to 2x reductions in both x- and y- dimensions.
 *   A value of 1 will result in an output raster grid whose dimensions exactly
 *   matches the size parameter.
 * @param {Array<number>} [params.bandwidth] - The KDE kernel bandwidths,
 *   in pixels. The input can be a two-element array specifying separate
 *   x and y bandwidths, or a single-element array specifying both. If the
 *   bandwidth is unspecified or less than zero, the bandwidth will be
 *   automatically determined.
 * @param {boolean} [params.counts=false] - A boolean flag indicating if the
 *   output values should be probability estimates (false, default) or
 *   smoothed counts (true).
 * @param {string} [params.as='grid'] - The output field in which to store
 *   the generated raster grid (default 'grid').
 */
function KDE2D(params) {
  Transform.call(this, null, params);
}
KDE2D.Definition = {
  'type': 'KDE2D',
  'metadata': {
    'generates': true
  },
  'params': [{
    'name': 'size',
    'type': 'number',
    'array': true,
    'length': 2,
    'required': true
  }, {
    'name': 'x',
    'type': 'field',
    'required': true
  }, {
    'name': 'y',
    'type': 'field',
    'required': true
  }, {
    'name': 'weight',
    'type': 'field'
  }, {
    'name': 'groupby',
    'type': 'field',
    'array': true
  }, {
    'name': 'cellSize',
    'type': 'number'
  }, {
    'name': 'bandwidth',
    'type': 'number',
    'array': true,
    'length': 2
  }, {
    'name': 'counts',
    'type': 'boolean',
    'default': false
  }, {
    'name': 'as',
    'type': 'string',
    'default': 'grid'
  }]
};
const PARAMS = ['x', 'y', 'weight', 'size', 'cellSize', 'bandwidth'];
function params(obj, _) {
  PARAMS.forEach(param => _[param] != null ? obj[param](_[param]) : 0);
  return obj;
}
inherits(KDE2D, Transform, {
  transform(_, pulse) {
    if (this.value && !pulse.changed() && !_.modified()) return pulse.StopPropagation;
    var out = pulse.fork(pulse.NO_SOURCE | pulse.NO_FIELDS),
      source = pulse.materialize(pulse.SOURCE).source,
      groups = partition$2(source, _.groupby),
      names = (_.groupby || []).map(accessorName),
      kde = params(density2D(), _),
      as = _.as || 'grid',
      values = [];
    function set(t, vals) {
      for (let i = 0; i < names.length; ++i) t[names[i]] = vals[i];
      return t;
    }

    // generate density raster grids
    values = groups.map(g => ingest$1(set({
      [as]: kde(g, _.counts)
    }, g.dims)));
    if (this.value) out.rem = this.value;
    this.value = out.source = out.add = values;
    return out;
  }
});
function partition$2(data, groupby) {
  var groups = [],
    get = f => f(t),
    map,
    i,
    n,
    t,
    k,
    g;

  // partition data points into groups
  if (groupby == null) {
    groups.push(data);
  } else {
    for (map = {}, i = 0, n = data.length; i < n; ++i) {
      t = data[i];
      k = groupby.map(get);
      g = map[k];
      if (!g) {
        map[k] = g = [];
        g.dims = k;
        groups.push(g);
      }
      g.push(t);
    }
  }
  return groups;
}

/**
 * Generate contours based on kernel-density estimation of point data.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {Array<number>} params.size - The dimensions [width, height] over which to compute contours.
 *  If the values parameter is provided, this must be the dimensions of the input data.
 *  If density estimation is performed, this is the output view dimensions in pixels.
 * @param {Array<number>} [params.values] - An array of numeric values representing an
 *  width x height grid of values over which to compute contours. If unspecified, this
 *  transform will instead attempt to compute contours for the kernel density estimate
 *  using values drawn from data tuples in the input pulse.
 * @param {function(object): number} [params.x] - The pixel x-coordinate accessor for density estimation.
 * @param {function(object): number} [params.y] - The pixel y-coordinate accessor for density estimation.
 * @param {function(object): number} [params.weight] - The data point weight accessor for density estimation.
 * @param {number} [params.cellSize] - Contour density calculation cell size.
 * @param {number} [params.bandwidth] - Kernel density estimation bandwidth.
 * @param {Array<number>} [params.thresholds] - Contour threshold array. If
 *   this parameter is set, the count and nice parameters will be ignored.
 * @param {number} [params.count] - The desired number of contours.
 * @param {boolean} [params.nice] - Boolean flag indicating if the contour
 *   threshold values should be automatically aligned to "nice"
 *   human-friendly values. Setting this flag may cause the number of
 *   thresholds to deviate from the specified count.
 * @param {boolean} [params.smooth] - Boolean flag indicating if the contour
 *   polygons should be smoothed using linear interpolation. The default is
 *   true. The parameter is ignored when using density estimation.
 */
function Contour(params) {
  Transform.call(this, null, params);
}
Contour.Definition = {
  'type': 'Contour',
  'metadata': {
    'generates': true
  },
  'params': [{
    'name': 'size',
    'type': 'number',
    'array': true,
    'length': 2,
    'required': true
  }, {
    'name': 'values',
    'type': 'number',
    'array': true
  }, {
    'name': 'x',
    'type': 'field'
  }, {
    'name': 'y',
    'type': 'field'
  }, {
    'name': 'weight',
    'type': 'field'
  }, {
    'name': 'cellSize',
    'type': 'number'
  }, {
    'name': 'bandwidth',
    'type': 'number'
  }, {
    'name': 'count',
    'type': 'number'
  }, {
    'name': 'nice',
    'type': 'boolean',
    'default': false
  }, {
    'name': 'thresholds',
    'type': 'number',
    'array': true
  }, {
    'name': 'smooth',
    'type': 'boolean',
    'default': true
  }]
};
inherits(Contour, Transform, {
  transform(_, pulse) {
    if (this.value && !pulse.changed() && !_.modified()) {
      return pulse.StopPropagation;
    }
    var out = pulse.fork(pulse.NO_SOURCE | pulse.NO_FIELDS),
      contour = contours().smooth(_.smooth !== false),
      values = _.values,
      thresh = _.thresholds || quantize(_.count || 10, _.nice, !!values),
      size = _.size,
      grid,
      post;
    if (!values) {
      values = pulse.materialize(pulse.SOURCE).source;
      grid = params(density2D(), _)(values, true);
      post = transform$1(grid, grid.scale || 1, grid.scale || 1, 0, 0);
      size = [grid.width, grid.height];
      values = grid.values;
    }
    thresh = isArray(thresh) ? thresh : thresh(values);
    values = contour.size(size)(values, thresh);
    if (post) values.forEach(post);
    if (this.value) out.rem = this.value;
    this.value = out.source = out.add = (values || []).map(ingest$1);
    return out;
  }
});
const Feature = 'Feature';
const FeatureCollection = 'FeatureCollection';
const MultiPoint = 'MultiPoint';

/**
 * Consolidate an array of [longitude, latitude] points or GeoJSON features
 * into a combined GeoJSON object. This transform is particularly useful for
 * combining geo data for a Projection's fit argument. The resulting GeoJSON
 * data is available as this transform's value. Input pulses are unchanged.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {Array<function(object): *>} [params.fields] - A two-element array
 *   of field accessors for the longitude and latitude values.
 * @param {function(object): *} params.geojson - A field accessor for
 *   retrieving GeoJSON feature data.
 */
function GeoJSON(params) {
  Transform.call(this, null, params);
}
GeoJSON.Definition = {
  'type': 'GeoJSON',
  'metadata': {},
  'params': [{
    'name': 'fields',
    'type': 'field',
    'array': true,
    'length': 2
  }, {
    'name': 'geojson',
    'type': 'field'
  }]
};
inherits(GeoJSON, Transform, {
  transform(_, pulse) {
    var features = this._features,
      points = this._points,
      fields = _.fields,
      lon = fields && fields[0],
      lat = fields && fields[1],
      geojson = _.geojson || !fields && identity$6,
      flag = pulse.ADD,
      mod;
    mod = _.modified() || pulse.changed(pulse.REM) || pulse.modified(accessorFields(geojson)) || lon && pulse.modified(accessorFields(lon)) || lat && pulse.modified(accessorFields(lat));
    if (!this.value || mod) {
      flag = pulse.SOURCE;
      this._features = features = [];
      this._points = points = [];
    }
    if (geojson) {
      pulse.visit(flag, t => features.push(geojson(t)));
    }
    if (lon && lat) {
      pulse.visit(flag, t => {
        var x = lon(t),
          y = lat(t);
        if (x != null && y != null && (x = +x) === x && (y = +y) === y) {
          points.push([x, y]);
        }
      });
      features = features.concat({
        type: Feature,
        geometry: {
          type: MultiPoint,
          coordinates: points
        }
      });
    }
    this.value = {
      type: FeatureCollection,
      features: features
    };
  }
});

/**
 * Map GeoJSON data to an SVG path string.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {function(number, number): *} params.projection - The cartographic
 *   projection to apply.
 * @param {function(object): *} [params.field] - The field with GeoJSON data,
 *   or null if the tuple itself is a GeoJSON feature.
 * @param {string} [params.as='path'] - The output field in which to store
 *   the generated path data (default 'path').
 */
function GeoPath(params) {
  Transform.call(this, null, params);
}
GeoPath.Definition = {
  'type': 'GeoPath',
  'metadata': {
    'modifies': true
  },
  'params': [{
    'name': 'projection',
    'type': 'projection'
  }, {
    'name': 'field',
    'type': 'field'
  }, {
    'name': 'pointRadius',
    'type': 'number',
    'expr': true
  }, {
    'name': 'as',
    'type': 'string',
    'default': 'path'
  }]
};
inherits(GeoPath, Transform, {
  transform(_, pulse) {
    var out = pulse.fork(pulse.ALL),
      path = this.value,
      field = _.field || identity$6,
      as = _.as || 'path',
      flag = out.SOURCE;
    if (!path || _.modified()) {
      // parameters updated, reset and reflow
      this.value = path = getProjectionPath(_.projection);
      out.materialize().reflow();
    } else {
      flag = field === identity$6 || pulse.modified(field.fields) ? out.ADD_MOD : out.ADD;
    }
    const prev = initPath(path, _.pointRadius);
    out.visit(flag, t => t[as] = path(field(t)));
    path.pointRadius(prev);
    return out.modifies(as);
  }
});
function initPath(path, pointRadius) {
  const prev = path.pointRadius();
  path.context(null);
  if (pointRadius != null) {
    path.pointRadius(pointRadius);
  }
  return prev;
}

/**
 * Geo-code a longitude/latitude point to an x/y coordinate.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {function(number, number): *} params.projection - The cartographic
 *   projection to apply.
 * @param {Array<function(object): *>} params.fields - A two-element array of
 *   field accessors for the longitude and latitude values.
 * @param {Array<string>} [params.as] - A two-element array of field names
 *   under which to store the result. Defaults to ['x','y'].
 */
function GeoPoint(params) {
  Transform.call(this, null, params);
}
GeoPoint.Definition = {
  'type': 'GeoPoint',
  'metadata': {
    'modifies': true
  },
  'params': [{
    'name': 'projection',
    'type': 'projection',
    'required': true
  }, {
    'name': 'fields',
    'type': 'field',
    'array': true,
    'required': true,
    'length': 2
  }, {
    'name': 'as',
    'type': 'string',
    'array': true,
    'length': 2,
    'default': ['x', 'y']
  }]
};
inherits(GeoPoint, Transform, {
  transform(_, pulse) {
    var proj = _.projection,
      lon = _.fields[0],
      lat = _.fields[1],
      as = _.as || ['x', 'y'],
      x = as[0],
      y = as[1],
      mod;
    function set(t) {
      const xy = proj([lon(t), lat(t)]);
      if (xy) {
        t[x] = xy[0];
        t[y] = xy[1];
      } else {
        t[x] = undefined;
        t[y] = undefined;
      }
    }
    if (_.modified()) {
      // parameters updated, reflow
      pulse = pulse.materialize().reflow(true).visit(pulse.SOURCE, set);
    } else {
      mod = pulse.modified(lon.fields) || pulse.modified(lat.fields);
      pulse.visit(mod ? pulse.ADD_MOD : pulse.ADD, set);
    }
    return pulse.modifies(as);
  }
});

/**
 * Annotate items with a geopath shape generator.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {function(number, number): *} params.projection - The cartographic
 *   projection to apply.
 * @param {function(object): *} [params.field] - The field with GeoJSON data,
 *   or null if the tuple itself is a GeoJSON feature.
 * @param {string} [params.as='shape'] - The output field in which to store
 *   the generated path data (default 'shape').
 */
function GeoShape(params) {
  Transform.call(this, null, params);
}
GeoShape.Definition = {
  'type': 'GeoShape',
  'metadata': {
    'modifies': true,
    'nomod': true
  },
  'params': [{
    'name': 'projection',
    'type': 'projection'
  }, {
    'name': 'field',
    'type': 'field',
    'default': 'datum'
  }, {
    'name': 'pointRadius',
    'type': 'number',
    'expr': true
  }, {
    'name': 'as',
    'type': 'string',
    'default': 'shape'
  }]
};
inherits(GeoShape, Transform, {
  transform(_, pulse) {
    var out = pulse.fork(pulse.ALL),
      shape = this.value,
      as = _.as || 'shape',
      flag = out.ADD;
    if (!shape || _.modified()) {
      // parameters updated, reset and reflow
      this.value = shape = shapeGenerator(getProjectionPath(_.projection), _.field || field$1('datum'), _.pointRadius);
      out.materialize().reflow();
      flag = out.SOURCE;
    }
    out.visit(flag, t => t[as] = shape);
    return out.modifies(as);
  }
});
function shapeGenerator(path, field, pointRadius) {
  const shape = pointRadius == null ? _ => path(field(_)) : _ => {
    var prev = path.pointRadius(),
      value = path.pointRadius(pointRadius)(field(_));
    path.pointRadius(prev);
    return value;
  };
  shape.context = _ => {
    path.context(_);
    return shape;
  };
  return shape;
}

/**
 * GeoJSON feature generator for creating graticules.
 * @constructor
 */
function Graticule(params) {
  Transform.call(this, [], params);
  this.generator = graticule();
}
Graticule.Definition = {
  'type': 'Graticule',
  'metadata': {
    'changes': true,
    'generates': true
  },
  'params': [{
    'name': 'extent',
    'type': 'array',
    'array': true,
    'length': 2,
    'content': {
      'type': 'number',
      'array': true,
      'length': 2
    }
  }, {
    'name': 'extentMajor',
    'type': 'array',
    'array': true,
    'length': 2,
    'content': {
      'type': 'number',
      'array': true,
      'length': 2
    }
  }, {
    'name': 'extentMinor',
    'type': 'array',
    'array': true,
    'length': 2,
    'content': {
      'type': 'number',
      'array': true,
      'length': 2
    }
  }, {
    'name': 'step',
    'type': 'number',
    'array': true,
    'length': 2
  }, {
    'name': 'stepMajor',
    'type': 'number',
    'array': true,
    'length': 2,
    'default': [90, 360]
  }, {
    'name': 'stepMinor',
    'type': 'number',
    'array': true,
    'length': 2,
    'default': [10, 10]
  }, {
    'name': 'precision',
    'type': 'number',
    'default': 2.5
  }]
};
inherits(Graticule, Transform, {
  transform(_, pulse) {
    var src = this.value,
      gen = this.generator,
      t;
    if (!src.length || _.modified()) {
      for (const prop in _) {
        if (isFunction(gen[prop])) {
          gen[prop](_[prop]);
        }
      }
    }
    t = gen();
    if (src.length) {
      pulse.mod.push(replace$1(src[0], t));
    } else {
      pulse.add.push(ingest$1(t));
    }
    src[0] = t;
    return pulse;
  }
});

/**
 * Render a heatmap image for input raster grid data.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {function(object): *} [params.field] - The field with raster grid
 *   data. If unspecified, the tuple itself is interpreted as a raster grid.
 * @param {string} [params.color] - A constant color value or function for
 *   individual pixel color. If a function, it will be invoked with an input
 *   object that includes $x, $y, $value, and $max fields for the grid.
 * @param {number} [params.opacity] - A constant opacity value or function for
 *   individual pixel opacity. If a function, it will be invoked with an input
 *   object that includes $x, $y, $value, and $max fields for the grid.
 * @param {string} [params.resolve] - The method for resolving maximum values
 *   across multiple input grids. If 'independent' (the default), maximum
 *   calculation will be performed separately for each grid. If 'shared',
 *   a single global maximum will be used for all input grids.
 * @param {string} [params.as='image'] - The output field in which to store
 *   the generated bitmap canvas images (default 'image').
 */
function Heatmap(params) {
  Transform.call(this, null, params);
}
Heatmap.Definition = {
  'type': 'heatmap',
  'metadata': {
    'modifies': true
  },
  'params': [{
    'name': 'field',
    'type': 'field'
  }, {
    'name': 'color',
    'type': 'string',
    'expr': true
  }, {
    'name': 'opacity',
    'type': 'number',
    'expr': true
  }, {
    'name': 'resolve',
    'type': 'enum',
    'values': ['shared', 'independent'],
    'default': 'independent'
  }, {
    'name': 'as',
    'type': 'string',
    'default': 'image'
  }]
};
inherits(Heatmap, Transform, {
  transform(_, pulse) {
    if (!pulse.changed() && !_.modified()) {
      return pulse.StopPropagation;
    }
    var source = pulse.materialize(pulse.SOURCE).source,
      shared = _.resolve === 'shared',
      field = _.field || identity$6,
      opacity = opacity_(_.opacity, _),
      color = color_(_.color, _),
      as = _.as || 'image',
      obj = {
        $x: 0,
        $y: 0,
        $value: 0,
        $max: shared ? max$2(source.map(t => max$2(field(t).values))) : 0
      };
    source.forEach(t => {
      const v = field(t);

      // build proxy data object
      const o = extend$1({}, t, obj);
      // set maximum value if not globally shared
      if (!shared) o.$max = max$2(v.values || []);

      // generate canvas image
      // optimize color/opacity if not pixel-dependent
      t[as] = toCanvas(v, o, color.dep ? color : constant$5(color(o)), opacity.dep ? opacity : constant$5(opacity(o)));
    });
    return pulse.reflow(true).modifies(as);
  }
});

// get image color function
function color_(color, _) {
  let f;
  if (isFunction(color)) {
    f = obj => rgb$1(color(obj, _));
    f.dep = dependency(color);
  } else {
    // default to mid-grey
    f = constant$5(rgb$1(color || '#888'));
  }
  return f;
}

// get image opacity function
function opacity_(opacity, _) {
  let f;
  if (isFunction(opacity)) {
    f = obj => opacity(obj, _);
    f.dep = dependency(opacity);
  } else if (opacity) {
    f = constant$5(opacity);
  } else {
    // default to [0, max] opacity gradient
    f = obj => obj.$value / obj.$max || 0;
    f.dep = true;
  }
  return f;
}

// check if function depends on individual pixel data
function dependency(f) {
  if (!isFunction(f)) return false;
  const set = toSet(accessorFields(f));
  return set.$x || set.$y || set.$value || set.$max;
}

// render raster grid to canvas
function toCanvas(grid, obj, color, opacity) {
  const n = grid.width,
    m = grid.height,
    x1 = grid.x1 || 0,
    y1 = grid.y1 || 0,
    x2 = grid.x2 || n,
    y2 = grid.y2 || m,
    val = grid.values,
    value = val ? i => val[i] : zero$3,
    can = domCanvas(x2 - x1, y2 - y1),
    ctx = can.getContext('2d'),
    img = ctx.getImageData(0, 0, x2 - x1, y2 - y1),
    pix = img.data;
  for (let j = y1, k = 0; j < y2; ++j) {
    obj.$y = j - y1;
    for (let i = x1, r = j * n; i < x2; ++i, k += 4) {
      obj.$x = i - x1;
      obj.$value = value(i + r);
      const v = color(obj);
      pix[k + 0] = v.r;
      pix[k + 1] = v.g;
      pix[k + 2] = v.b;
      pix[k + 3] = ~~(255 * opacity(obj));
    }
  }
  ctx.putImageData(img, 0, 0);
  return can;
}

/**
 * Maintains a cartographic projection.
 * @constructor
 * @param {object} params - The parameters for this operator.
 */
function Projection$1(params) {
  Transform.call(this, null, params);
  this.modified(true); // always treat as modified
}
inherits(Projection$1, Transform, {
  transform(_, pulse) {
    let proj = this.value;
    if (!proj || _.modified('type')) {
      this.value = proj = create(_.type);
      projectionProperties.forEach(prop => {
        if (_[prop] != null) set$1(proj, prop, _[prop]);
      });
    } else {
      projectionProperties.forEach(prop => {
        if (_.modified(prop)) set$1(proj, prop, _[prop]);
      });
    }
    if (_.pointRadius != null) proj.path.pointRadius(_.pointRadius);
    if (_.fit) fit(proj, _);
    return pulse.fork(pulse.NO_SOURCE | pulse.NO_FIELDS);
  }
});
function fit(proj, _) {
  const data = collectGeoJSON(_.fit);
  _.extent ? proj.fitExtent(_.extent, data) : _.size ? proj.fitSize(_.size, data) : 0;
}
function create(type) {
  const constructor = projection((type || 'mercator').toLowerCase());
  if (!constructor) error('Unrecognized projection type: ' + type);
  return constructor();
}
function set$1(proj, key, value) {
  if (isFunction(proj[key])) proj[key](value);
}
function collectGeoJSON(data) {
  data = array$5(data);
  return data.length === 1 ? data[0] : {
    type: FeatureCollection,
    features: data.reduce((a, f) => a.concat(featurize(f)), [])
  };
}
function featurize(f) {
  return f.type === FeatureCollection ? f.features : array$5(f).filter(d => d != null).map(d => d.type === Feature ? d : {
    type: Feature,
    geometry: d
  });
}

var geo = /*#__PURE__*/Object.freeze({
    __proto__: null,
    contour: Contour,
    geojson: GeoJSON,
    geopath: GeoPath,
    geopoint: GeoPoint,
    geoshape: GeoShape,
    graticule: Graticule,
    heatmap: Heatmap,
    isocontour: Isocontour,
    kde2d: KDE2D,
    projection: Projection$1
});

function forceCenter (x, y) {
  var nodes,
    strength = 1;
  if (x == null) x = 0;
  if (y == null) y = 0;
  function force() {
    var i,
      n = nodes.length,
      node,
      sx = 0,
      sy = 0;
    for (i = 0; i < n; ++i) {
      node = nodes[i], sx += node.x, sy += node.y;
    }
    for (sx = (sx / n - x) * strength, sy = (sy / n - y) * strength, i = 0; i < n; ++i) {
      node = nodes[i], node.x -= sx, node.y -= sy;
    }
  }
  force.initialize = function (_) {
    nodes = _;
  };
  force.x = function (_) {
    return arguments.length ? (x = +_, force) : x;
  };
  force.y = function (_) {
    return arguments.length ? (y = +_, force) : y;
  };
  force.strength = function (_) {
    return arguments.length ? (strength = +_, force) : strength;
  };
  return force;
}

function tree_add (d) {
  const x = +this._x.call(null, d),
    y = +this._y.call(null, d);
  return add(this.cover(x, y), x, y, d);
}
function add(tree, x, y, d) {
  if (isNaN(x) || isNaN(y)) return tree; // ignore invalid points

  var parent,
    node = tree._root,
    leaf = {
      data: d
    },
    x0 = tree._x0,
    y0 = tree._y0,
    x1 = tree._x1,
    y1 = tree._y1,
    xm,
    ym,
    xp,
    yp,
    right,
    bottom,
    i,
    j;

  // If the tree is empty, initialize the root as a leaf.
  if (!node) return tree._root = leaf, tree;

  // Find the existing leaf for the new point, or add it.
  while (node.length) {
    if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm;else x1 = xm;
    if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym;else y1 = ym;
    if (parent = node, !(node = node[i = bottom << 1 | right])) return parent[i] = leaf, tree;
  }

  // Is the new point is exactly coincident with the existing point?
  xp = +tree._x.call(null, node.data);
  yp = +tree._y.call(null, node.data);
  if (x === xp && y === yp) return leaf.next = node, parent ? parent[i] = leaf : tree._root = leaf, tree;

  // Otherwise, split the leaf node until the old and new point are separated.
  do {
    parent = parent ? parent[i] = new Array(4) : tree._root = new Array(4);
    if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm;else x1 = xm;
    if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym;else y1 = ym;
  } while ((i = bottom << 1 | right) === (j = (yp >= ym) << 1 | xp >= xm));
  return parent[j] = node, parent[i] = leaf, tree;
}
function addAll(data) {
  var d,
    i,
    n = data.length,
    x,
    y,
    xz = new Array(n),
    yz = new Array(n),
    x0 = Infinity,
    y0 = Infinity,
    x1 = -Infinity,
    y1 = -Infinity;

  // Compute the points and their extent.
  for (i = 0; i < n; ++i) {
    if (isNaN(x = +this._x.call(null, d = data[i])) || isNaN(y = +this._y.call(null, d))) continue;
    xz[i] = x;
    yz[i] = y;
    if (x < x0) x0 = x;
    if (x > x1) x1 = x;
    if (y < y0) y0 = y;
    if (y > y1) y1 = y;
  }

  // If there were no (valid) points, abort.
  if (x0 > x1 || y0 > y1) return this;

  // Expand the tree to cover the new points.
  this.cover(x0, y0).cover(x1, y1);

  // Add the new points.
  for (i = 0; i < n; ++i) {
    add(this, xz[i], yz[i], data[i]);
  }
  return this;
}

function tree_cover (x, y) {
  if (isNaN(x = +x) || isNaN(y = +y)) return this; // ignore invalid points

  var x0 = this._x0,
    y0 = this._y0,
    x1 = this._x1,
    y1 = this._y1;

  // If the quadtree has no extent, initialize them.
  // Integer extent are necessary so that if we later double the extent,
  // the existing quadrant boundaries don’t change due to floating point error!
  if (isNaN(x0)) {
    x1 = (x0 = Math.floor(x)) + 1;
    y1 = (y0 = Math.floor(y)) + 1;
  }

  // Otherwise, double repeatedly to cover.
  else {
    var z = x1 - x0 || 1,
      node = this._root,
      parent,
      i;
    while (x0 > x || x >= x1 || y0 > y || y >= y1) {
      i = (y < y0) << 1 | x < x0;
      parent = new Array(4), parent[i] = node, node = parent, z *= 2;
      switch (i) {
        case 0:
          x1 = x0 + z, y1 = y0 + z;
          break;
        case 1:
          x0 = x1 - z, y1 = y0 + z;
          break;
        case 2:
          x1 = x0 + z, y0 = y1 - z;
          break;
        case 3:
          x0 = x1 - z, y0 = y1 - z;
          break;
      }
    }
    if (this._root && this._root.length) this._root = node;
  }
  this._x0 = x0;
  this._y0 = y0;
  this._x1 = x1;
  this._y1 = y1;
  return this;
}

function tree_data () {
  var data = [];
  this.visit(function (node) {
    if (!node.length) do data.push(node.data); while (node = node.next);
  });
  return data;
}

function tree_extent (_) {
  return arguments.length ? this.cover(+_[0][0], +_[0][1]).cover(+_[1][0], +_[1][1]) : isNaN(this._x0) ? undefined : [[this._x0, this._y0], [this._x1, this._y1]];
}

function Quad (node, x0, y0, x1, y1) {
  this.node = node;
  this.x0 = x0;
  this.y0 = y0;
  this.x1 = x1;
  this.y1 = y1;
}

function tree_find (x, y, radius) {
  var data,
    x0 = this._x0,
    y0 = this._y0,
    x1,
    y1,
    x2,
    y2,
    x3 = this._x1,
    y3 = this._y1,
    quads = [],
    node = this._root,
    q,
    i;
  if (node) quads.push(new Quad(node, x0, y0, x3, y3));
  if (radius == null) radius = Infinity;else {
    x0 = x - radius, y0 = y - radius;
    x3 = x + radius, y3 = y + radius;
    radius *= radius;
  }
  while (q = quads.pop()) {
    // Stop searching if this quadrant can’t contain a closer node.
    if (!(node = q.node) || (x1 = q.x0) > x3 || (y1 = q.y0) > y3 || (x2 = q.x1) < x0 || (y2 = q.y1) < y0) continue;

    // Bisect the current quadrant.
    if (node.length) {
      var xm = (x1 + x2) / 2,
        ym = (y1 + y2) / 2;
      quads.push(new Quad(node[3], xm, ym, x2, y2), new Quad(node[2], x1, ym, xm, y2), new Quad(node[1], xm, y1, x2, ym), new Quad(node[0], x1, y1, xm, ym));

      // Visit the closest quadrant first.
      if (i = (y >= ym) << 1 | x >= xm) {
        q = quads[quads.length - 1];
        quads[quads.length - 1] = quads[quads.length - 1 - i];
        quads[quads.length - 1 - i] = q;
      }
    }

    // Visit this point. (Visiting coincident points isn’t necessary!)
    else {
      var dx = x - +this._x.call(null, node.data),
        dy = y - +this._y.call(null, node.data),
        d2 = dx * dx + dy * dy;
      if (d2 < radius) {
        var d = Math.sqrt(radius = d2);
        x0 = x - d, y0 = y - d;
        x3 = x + d, y3 = y + d;
        data = node.data;
      }
    }
  }
  return data;
}

function tree_remove (d) {
  if (isNaN(x = +this._x.call(null, d)) || isNaN(y = +this._y.call(null, d))) return this; // ignore invalid points

  var parent,
    node = this._root,
    retainer,
    previous,
    next,
    x0 = this._x0,
    y0 = this._y0,
    x1 = this._x1,
    y1 = this._y1,
    x,
    y,
    xm,
    ym,
    right,
    bottom,
    i,
    j;

  // If the tree is empty, initialize the root as a leaf.
  if (!node) return this;

  // Find the leaf node for the point.
  // While descending, also retain the deepest parent with a non-removed sibling.
  if (node.length) while (true) {
    if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm;else x1 = xm;
    if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym;else y1 = ym;
    if (!(parent = node, node = node[i = bottom << 1 | right])) return this;
    if (!node.length) break;
    if (parent[i + 1 & 3] || parent[i + 2 & 3] || parent[i + 3 & 3]) retainer = parent, j = i;
  }

  // Find the point to remove.
  while (node.data !== d) if (!(previous = node, node = node.next)) return this;
  if (next = node.next) delete node.next;

  // If there are multiple coincident points, remove just the point.
  if (previous) return next ? previous.next = next : delete previous.next, this;

  // If this is the root point, remove it.
  if (!parent) return this._root = next, this;

  // Remove this leaf.
  next ? parent[i] = next : delete parent[i];

  // If the parent now contains exactly one leaf, collapse superfluous parents.
  if ((node = parent[0] || parent[1] || parent[2] || parent[3]) && node === (parent[3] || parent[2] || parent[1] || parent[0]) && !node.length) {
    if (retainer) retainer[j] = node;else this._root = node;
  }
  return this;
}
function removeAll(data) {
  for (var i = 0, n = data.length; i < n; ++i) this.remove(data[i]);
  return this;
}

function tree_root () {
  return this._root;
}

function tree_size () {
  var size = 0;
  this.visit(function (node) {
    if (!node.length) do ++size; while (node = node.next);
  });
  return size;
}

function tree_visit (callback) {
  var quads = [],
    q,
    node = this._root,
    child,
    x0,
    y0,
    x1,
    y1;
  if (node) quads.push(new Quad(node, this._x0, this._y0, this._x1, this._y1));
  while (q = quads.pop()) {
    if (!callback(node = q.node, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1) && node.length) {
      var xm = (x0 + x1) / 2,
        ym = (y0 + y1) / 2;
      if (child = node[3]) quads.push(new Quad(child, xm, ym, x1, y1));
      if (child = node[2]) quads.push(new Quad(child, x0, ym, xm, y1));
      if (child = node[1]) quads.push(new Quad(child, xm, y0, x1, ym));
      if (child = node[0]) quads.push(new Quad(child, x0, y0, xm, ym));
    }
  }
  return this;
}

function tree_visitAfter (callback) {
  var quads = [],
    next = [],
    q;
  if (this._root) quads.push(new Quad(this._root, this._x0, this._y0, this._x1, this._y1));
  while (q = quads.pop()) {
    var node = q.node;
    if (node.length) {
      var child,
        x0 = q.x0,
        y0 = q.y0,
        x1 = q.x1,
        y1 = q.y1,
        xm = (x0 + x1) / 2,
        ym = (y0 + y1) / 2;
      if (child = node[0]) quads.push(new Quad(child, x0, y0, xm, ym));
      if (child = node[1]) quads.push(new Quad(child, xm, y0, x1, ym));
      if (child = node[2]) quads.push(new Quad(child, x0, ym, xm, y1));
      if (child = node[3]) quads.push(new Quad(child, xm, ym, x1, y1));
    }
    next.push(q);
  }
  while (q = next.pop()) {
    callback(q.node, q.x0, q.y0, q.x1, q.y1);
  }
  return this;
}

function defaultX(d) {
  return d[0];
}
function tree_x (_) {
  return arguments.length ? (this._x = _, this) : this._x;
}

function defaultY(d) {
  return d[1];
}
function tree_y (_) {
  return arguments.length ? (this._y = _, this) : this._y;
}

function quadtree(nodes, x, y) {
  var tree = new Quadtree(x == null ? defaultX : x, y == null ? defaultY : y, NaN, NaN, NaN, NaN);
  return nodes == null ? tree : tree.addAll(nodes);
}
function Quadtree(x, y, x0, y0, x1, y1) {
  this._x = x;
  this._y = y;
  this._x0 = x0;
  this._y0 = y0;
  this._x1 = x1;
  this._y1 = y1;
  this._root = undefined;
}
function leaf_copy(leaf) {
  var copy = {
      data: leaf.data
    },
    next = copy;
  while (leaf = leaf.next) next = next.next = {
    data: leaf.data
  };
  return copy;
}
var treeProto = quadtree.prototype = Quadtree.prototype;
treeProto.copy = function () {
  var copy = new Quadtree(this._x, this._y, this._x0, this._y0, this._x1, this._y1),
    node = this._root,
    nodes,
    child;
  if (!node) return copy;
  if (!node.length) return copy._root = leaf_copy(node), copy;
  nodes = [{
    source: node,
    target: copy._root = new Array(4)
  }];
  while (node = nodes.pop()) {
    for (var i = 0; i < 4; ++i) {
      if (child = node.source[i]) {
        if (child.length) nodes.push({
          source: child,
          target: node.target[i] = new Array(4)
        });else node.target[i] = leaf_copy(child);
      }
    }
  }
  return copy;
};
treeProto.add = tree_add;
treeProto.addAll = addAll;
treeProto.cover = tree_cover;
treeProto.data = tree_data;
treeProto.extent = tree_extent;
treeProto.find = tree_find;
treeProto.remove = tree_remove;
treeProto.removeAll = removeAll;
treeProto.root = tree_root;
treeProto.size = tree_size;
treeProto.visit = tree_visit;
treeProto.visitAfter = tree_visitAfter;
treeProto.x = tree_x;
treeProto.y = tree_y;

function constant$1 (x) {
  return function () {
    return x;
  };
}

function jiggle (random) {
  return (random() - 0.5) * 1e-6;
}

function x$1(d) {
  return d.x + d.vx;
}
function y$1(d) {
  return d.y + d.vy;
}
function forceCollide (radius) {
  var nodes,
    radii,
    random,
    strength = 1,
    iterations = 1;
  if (typeof radius !== "function") radius = constant$1(radius == null ? 1 : +radius);
  function force() {
    var i,
      n = nodes.length,
      tree,
      node,
      xi,
      yi,
      ri,
      ri2;
    for (var k = 0; k < iterations; ++k) {
      tree = quadtree(nodes, x$1, y$1).visitAfter(prepare);
      for (i = 0; i < n; ++i) {
        node = nodes[i];
        ri = radii[node.index], ri2 = ri * ri;
        xi = node.x + node.vx;
        yi = node.y + node.vy;
        tree.visit(apply);
      }
    }
    function apply(quad, x0, y0, x1, y1) {
      var data = quad.data,
        rj = quad.r,
        r = ri + rj;
      if (data) {
        if (data.index > node.index) {
          var x = xi - data.x - data.vx,
            y = yi - data.y - data.vy,
            l = x * x + y * y;
          if (l < r * r) {
            if (x === 0) x = jiggle(random), l += x * x;
            if (y === 0) y = jiggle(random), l += y * y;
            l = (r - (l = Math.sqrt(l))) / l * strength;
            node.vx += (x *= l) * (r = (rj *= rj) / (ri2 + rj));
            node.vy += (y *= l) * r;
            data.vx -= x * (r = 1 - r);
            data.vy -= y * r;
          }
        }
        return;
      }
      return x0 > xi + r || x1 < xi - r || y0 > yi + r || y1 < yi - r;
    }
  }
  function prepare(quad) {
    if (quad.data) return quad.r = radii[quad.data.index];
    for (var i = quad.r = 0; i < 4; ++i) {
      if (quad[i] && quad[i].r > quad.r) {
        quad.r = quad[i].r;
      }
    }
  }
  function initialize() {
    if (!nodes) return;
    var i,
      n = nodes.length,
      node;
    radii = new Array(n);
    for (i = 0; i < n; ++i) node = nodes[i], radii[node.index] = +radius(node, i, nodes);
  }
  force.initialize = function (_nodes, _random) {
    nodes = _nodes;
    random = _random;
    initialize();
  };
  force.iterations = function (_) {
    return arguments.length ? (iterations = +_, force) : iterations;
  };
  force.strength = function (_) {
    return arguments.length ? (strength = +_, force) : strength;
  };
  force.radius = function (_) {
    return arguments.length ? (radius = typeof _ === "function" ? _ : constant$1(+_), initialize(), force) : radius;
  };
  return force;
}

function index$1(d) {
  return d.index;
}
function find$1(nodeById, nodeId) {
  var node = nodeById.get(nodeId);
  if (!node) throw new Error("node not found: " + nodeId);
  return node;
}
function forceLink (links) {
  var id = index$1,
    strength = defaultStrength,
    strengths,
    distance = constant$1(30),
    distances,
    nodes,
    count,
    bias,
    random,
    iterations = 1;
  if (links == null) links = [];
  function defaultStrength(link) {
    return 1 / Math.min(count[link.source.index], count[link.target.index]);
  }
  function force(alpha) {
    for (var k = 0, n = links.length; k < iterations; ++k) {
      for (var i = 0, link, source, target, x, y, l, b; i < n; ++i) {
        link = links[i], source = link.source, target = link.target;
        x = target.x + target.vx - source.x - source.vx || jiggle(random);
        y = target.y + target.vy - source.y - source.vy || jiggle(random);
        l = Math.sqrt(x * x + y * y);
        l = (l - distances[i]) / l * alpha * strengths[i];
        x *= l, y *= l;
        target.vx -= x * (b = bias[i]);
        target.vy -= y * b;
        source.vx += x * (b = 1 - b);
        source.vy += y * b;
      }
    }
  }
  function initialize() {
    if (!nodes) return;
    var i,
      n = nodes.length,
      m = links.length,
      nodeById = new Map(nodes.map((d, i) => [id(d, i, nodes), d])),
      link;
    for (i = 0, count = new Array(n); i < m; ++i) {
      link = links[i], link.index = i;
      if (typeof link.source !== "object") link.source = find$1(nodeById, link.source);
      if (typeof link.target !== "object") link.target = find$1(nodeById, link.target);
      count[link.source.index] = (count[link.source.index] || 0) + 1;
      count[link.target.index] = (count[link.target.index] || 0) + 1;
    }
    for (i = 0, bias = new Array(m); i < m; ++i) {
      link = links[i], bias[i] = count[link.source.index] / (count[link.source.index] + count[link.target.index]);
    }
    strengths = new Array(m), initializeStrength();
    distances = new Array(m), initializeDistance();
  }
  function initializeStrength() {
    if (!nodes) return;
    for (var i = 0, n = links.length; i < n; ++i) {
      strengths[i] = +strength(links[i], i, links);
    }
  }
  function initializeDistance() {
    if (!nodes) return;
    for (var i = 0, n = links.length; i < n; ++i) {
      distances[i] = +distance(links[i], i, links);
    }
  }
  force.initialize = function (_nodes, _random) {
    nodes = _nodes;
    random = _random;
    initialize();
  };
  force.links = function (_) {
    return arguments.length ? (links = _, initialize(), force) : links;
  };
  force.id = function (_) {
    return arguments.length ? (id = _, force) : id;
  };
  force.iterations = function (_) {
    return arguments.length ? (iterations = +_, force) : iterations;
  };
  force.strength = function (_) {
    return arguments.length ? (strength = typeof _ === "function" ? _ : constant$1(+_), initializeStrength(), force) : strength;
  };
  force.distance = function (_) {
    return arguments.length ? (distance = typeof _ === "function" ? _ : constant$1(+_), initializeDistance(), force) : distance;
  };
  return force;
}

var noop = {
  value: () => {}
};
function dispatch() {
  for (var i = 0, n = arguments.length, _ = {}, t; i < n; ++i) {
    if (!(t = arguments[i] + "") || t in _ || /[\s.]/.test(t)) throw new Error("illegal type: " + t);
    _[t] = [];
  }
  return new Dispatch(_);
}
function Dispatch(_) {
  this._ = _;
}
function parseTypenames(typenames, types) {
  return typenames.trim().split(/^|\s+/).map(function (t) {
    var name = "",
      i = t.indexOf(".");
    if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
    if (t && !types.hasOwnProperty(t)) throw new Error("unknown type: " + t);
    return {
      type: t,
      name: name
    };
  });
}
Dispatch.prototype = dispatch.prototype = {
  constructor: Dispatch,
  on: function (typename, callback) {
    var _ = this._,
      T = parseTypenames(typename + "", _),
      t,
      i = -1,
      n = T.length;

    // If no callback was specified, return the callback of the given type and name.
    if (arguments.length < 2) {
      while (++i < n) if ((t = (typename = T[i]).type) && (t = get(_[t], typename.name))) return t;
      return;
    }

    // If a type was specified, set the callback for the given type and name.
    // Otherwise, if a null callback was specified, remove callbacks of the given name.
    if (callback != null && typeof callback !== "function") throw new Error("invalid callback: " + callback);
    while (++i < n) {
      if (t = (typename = T[i]).type) _[t] = set(_[t], typename.name, callback);else if (callback == null) for (t in _) _[t] = set(_[t], typename.name, null);
    }
    return this;
  },
  copy: function () {
    var copy = {},
      _ = this._;
    for (var t in _) copy[t] = _[t].slice();
    return new Dispatch(copy);
  },
  call: function (type, that) {
    if ((n = arguments.length - 2) > 0) for (var args = new Array(n), i = 0, n, t; i < n; ++i) args[i] = arguments[i + 2];
    if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
    for (t = this._[type], i = 0, n = t.length; i < n; ++i) t[i].value.apply(that, args);
  },
  apply: function (type, that, args) {
    if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
    for (var t = this._[type], i = 0, n = t.length; i < n; ++i) t[i].value.apply(that, args);
  }
};
function get(type, name) {
  for (var i = 0, n = type.length, c; i < n; ++i) {
    if ((c = type[i]).name === name) {
      return c.value;
    }
  }
}
function set(type, name, callback) {
  for (var i = 0, n = type.length; i < n; ++i) {
    if (type[i].name === name) {
      type[i] = noop, type = type.slice(0, i).concat(type.slice(i + 1));
      break;
    }
  }
  if (callback != null) type.push({
    name: name,
    value: callback
  });
  return type;
}

var frame = 0,
  // is an animation frame pending?
  timeout = 0,
  // is a timeout pending?
  interval$1 = 0,
  // are any timers active?
  pokeDelay = 1000,
  // how frequently we check for clock skew
  taskHead,
  taskTail,
  clockLast = 0,
  clockNow = 0,
  clockSkew = 0,
  clock = typeof performance === "object" && performance.now ? performance : Date,
  setFrame = typeof window === "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function (f) {
    setTimeout(f, 17);
  };
function now() {
  return clockNow || (setFrame(clearNow), clockNow = clock.now() + clockSkew);
}
function clearNow() {
  clockNow = 0;
}
function Timer$1() {
  this._call = this._time = this._next = null;
}
Timer$1.prototype = timer$1.prototype = {
  constructor: Timer$1,
  restart: function (callback, delay, time) {
    if (typeof callback !== "function") throw new TypeError("callback is not a function");
    time = (time == null ? now() : +time) + (delay == null ? 0 : +delay);
    if (!this._next && taskTail !== this) {
      if (taskTail) taskTail._next = this;else taskHead = this;
      taskTail = this;
    }
    this._call = callback;
    this._time = time;
    sleep();
  },
  stop: function () {
    if (this._call) {
      this._call = null;
      this._time = Infinity;
      sleep();
    }
  }
};
function timer$1(callback, delay, time) {
  var t = new Timer$1();
  t.restart(callback, delay, time);
  return t;
}
function timerFlush() {
  now(); // Get the current time, if not already set.
  ++frame; // Pretend we’ve set an alarm, if we haven’t already.
  var t = taskHead,
    e;
  while (t) {
    if ((e = clockNow - t._time) >= 0) t._call.call(undefined, e);
    t = t._next;
  }
  --frame;
}
function wake() {
  clockNow = (clockLast = clock.now()) + clockSkew;
  frame = timeout = 0;
  try {
    timerFlush();
  } finally {
    frame = 0;
    nap();
    clockNow = 0;
  }
}
function poke() {
  var now = clock.now(),
    delay = now - clockLast;
  if (delay > pokeDelay) clockSkew -= delay, clockLast = now;
}
function nap() {
  var t0,
    t1 = taskHead,
    t2,
    time = Infinity;
  while (t1) {
    if (t1._call) {
      if (time > t1._time) time = t1._time;
      t0 = t1, t1 = t1._next;
    } else {
      t2 = t1._next, t1._next = null;
      t1 = t0 ? t0._next = t2 : taskHead = t2;
    }
  }
  taskTail = t0;
  sleep(time);
}
function sleep(time) {
  if (frame) return; // Soonest alarm already set, or will be.
  if (timeout) timeout = clearTimeout(timeout);
  var delay = time - clockNow; // Strictly less than if we recomputed clockNow.
  if (delay > 24) {
    if (time < Infinity) timeout = setTimeout(wake, time - clock.now() - clockSkew);
    if (interval$1) interval$1 = clearInterval(interval$1);
  } else {
    if (!interval$1) clockLast = clock.now(), interval$1 = setInterval(poke, pokeDelay);
    frame = 1, setFrame(wake);
  }
}

function interval (callback, delay, time) {
  var t = new Timer$1(),
    total = delay;
  if (delay == null) return t.restart(callback, delay, time), t;
  t._restart = t.restart;
  t.restart = function (callback, delay, time) {
    delay = +delay, time = time == null ? now() : +time;
    t._restart(function tick(elapsed) {
      elapsed += total;
      t._restart(tick, total += delay, time);
      callback(elapsed);
    }, delay, time);
  };
  t.restart(callback, delay, time);
  return t;
}

// https://en.wikipedia.org/wiki/Linear_congruential_generator#Parameters_in_common_use
const a$1 = 1664525;
const c$1 = 1013904223;
const m$1 = 4294967296; // 2^32

function lcg$1 () {
  let s = 1;
  return () => (s = (a$1 * s + c$1) % m$1) / m$1;
}

function x(d) {
  return d.x;
}
function y(d) {
  return d.y;
}
var initialRadius = 10,
  initialAngle = Math.PI * (3 - Math.sqrt(5));
function forceSimulation (nodes) {
  var simulation,
    alpha = 1,
    alphaMin = 0.001,
    alphaDecay = 1 - Math.pow(alphaMin, 1 / 300),
    alphaTarget = 0,
    velocityDecay = 0.6,
    forces = new Map(),
    stepper = timer$1(step),
    event = dispatch("tick", "end"),
    random = lcg$1();
  if (nodes == null) nodes = [];
  function step() {
    tick();
    event.call("tick", simulation);
    if (alpha < alphaMin) {
      stepper.stop();
      event.call("end", simulation);
    }
  }
  function tick(iterations) {
    var i,
      n = nodes.length,
      node;
    if (iterations === undefined) iterations = 1;
    for (var k = 0; k < iterations; ++k) {
      alpha += (alphaTarget - alpha) * alphaDecay;
      forces.forEach(function (force) {
        force(alpha);
      });
      for (i = 0; i < n; ++i) {
        node = nodes[i];
        if (node.fx == null) node.x += node.vx *= velocityDecay;else node.x = node.fx, node.vx = 0;
        if (node.fy == null) node.y += node.vy *= velocityDecay;else node.y = node.fy, node.vy = 0;
      }
    }
    return simulation;
  }
  function initializeNodes() {
    for (var i = 0, n = nodes.length, node; i < n; ++i) {
      node = nodes[i], node.index = i;
      if (node.fx != null) node.x = node.fx;
      if (node.fy != null) node.y = node.fy;
      if (isNaN(node.x) || isNaN(node.y)) {
        var radius = initialRadius * Math.sqrt(0.5 + i),
          angle = i * initialAngle;
        node.x = radius * Math.cos(angle);
        node.y = radius * Math.sin(angle);
      }
      if (isNaN(node.vx) || isNaN(node.vy)) {
        node.vx = node.vy = 0;
      }
    }
  }
  function initializeForce(force) {
    if (force.initialize) force.initialize(nodes, random);
    return force;
  }
  initializeNodes();
  return simulation = {
    tick: tick,
    restart: function () {
      return stepper.restart(step), simulation;
    },
    stop: function () {
      return stepper.stop(), simulation;
    },
    nodes: function (_) {
      return arguments.length ? (nodes = _, initializeNodes(), forces.forEach(initializeForce), simulation) : nodes;
    },
    alpha: function (_) {
      return arguments.length ? (alpha = +_, simulation) : alpha;
    },
    alphaMin: function (_) {
      return arguments.length ? (alphaMin = +_, simulation) : alphaMin;
    },
    alphaDecay: function (_) {
      return arguments.length ? (alphaDecay = +_, simulation) : +alphaDecay;
    },
    alphaTarget: function (_) {
      return arguments.length ? (alphaTarget = +_, simulation) : alphaTarget;
    },
    velocityDecay: function (_) {
      return arguments.length ? (velocityDecay = 1 - _, simulation) : 1 - velocityDecay;
    },
    randomSource: function (_) {
      return arguments.length ? (random = _, forces.forEach(initializeForce), simulation) : random;
    },
    force: function (name, _) {
      return arguments.length > 1 ? (_ == null ? forces.delete(name) : forces.set(name, initializeForce(_)), simulation) : forces.get(name);
    },
    find: function (x, y, radius) {
      var i = 0,
        n = nodes.length,
        dx,
        dy,
        d2,
        node,
        closest;
      if (radius == null) radius = Infinity;else radius *= radius;
      for (i = 0; i < n; ++i) {
        node = nodes[i];
        dx = x - node.x;
        dy = y - node.y;
        d2 = dx * dx + dy * dy;
        if (d2 < radius) closest = node, radius = d2;
      }
      return closest;
    },
    on: function (name, _) {
      return arguments.length > 1 ? (event.on(name, _), simulation) : event.on(name);
    }
  };
}

function forceManyBody () {
  var nodes,
    node,
    random,
    alpha,
    strength = constant$1(-30),
    strengths,
    distanceMin2 = 1,
    distanceMax2 = Infinity,
    theta2 = 0.81;
  function force(_) {
    var i,
      n = nodes.length,
      tree = quadtree(nodes, x, y).visitAfter(accumulate);
    for (alpha = _, i = 0; i < n; ++i) node = nodes[i], tree.visit(apply);
  }
  function initialize() {
    if (!nodes) return;
    var i,
      n = nodes.length,
      node;
    strengths = new Array(n);
    for (i = 0; i < n; ++i) node = nodes[i], strengths[node.index] = +strength(node, i, nodes);
  }
  function accumulate(quad) {
    var strength = 0,
      q,
      c,
      weight = 0,
      x,
      y,
      i;

    // For internal nodes, accumulate forces from child quadrants.
    if (quad.length) {
      for (x = y = i = 0; i < 4; ++i) {
        if ((q = quad[i]) && (c = Math.abs(q.value))) {
          strength += q.value, weight += c, x += c * q.x, y += c * q.y;
        }
      }
      quad.x = x / weight;
      quad.y = y / weight;
    }

    // For leaf nodes, accumulate forces from coincident quadrants.
    else {
      q = quad;
      q.x = q.data.x;
      q.y = q.data.y;
      do strength += strengths[q.data.index]; while (q = q.next);
    }
    quad.value = strength;
  }
  function apply(quad, x1, _, x2) {
    if (!quad.value) return true;
    var x = quad.x - node.x,
      y = quad.y - node.y,
      w = x2 - x1,
      l = x * x + y * y;

    // Apply the Barnes-Hut approximation if possible.
    // Limit forces for very close nodes; randomize direction if coincident.
    if (w * w / theta2 < l) {
      if (l < distanceMax2) {
        if (x === 0) x = jiggle(random), l += x * x;
        if (y === 0) y = jiggle(random), l += y * y;
        if (l < distanceMin2) l = Math.sqrt(distanceMin2 * l);
        node.vx += x * quad.value * alpha / l;
        node.vy += y * quad.value * alpha / l;
      }
      return true;
    }

    // Otherwise, process points directly.
    else if (quad.length || l >= distanceMax2) return;

    // Limit forces for very close nodes; randomize direction if coincident.
    if (quad.data !== node || quad.next) {
      if (x === 0) x = jiggle(random), l += x * x;
      if (y === 0) y = jiggle(random), l += y * y;
      if (l < distanceMin2) l = Math.sqrt(distanceMin2 * l);
    }
    do if (quad.data !== node) {
      w = strengths[quad.data.index] * alpha / l;
      node.vx += x * w;
      node.vy += y * w;
    } while (quad = quad.next);
  }
  force.initialize = function (_nodes, _random) {
    nodes = _nodes;
    random = _random;
    initialize();
  };
  force.strength = function (_) {
    return arguments.length ? (strength = typeof _ === "function" ? _ : constant$1(+_), initialize(), force) : strength;
  };
  force.distanceMin = function (_) {
    return arguments.length ? (distanceMin2 = _ * _, force) : Math.sqrt(distanceMin2);
  };
  force.distanceMax = function (_) {
    return arguments.length ? (distanceMax2 = _ * _, force) : Math.sqrt(distanceMax2);
  };
  force.theta = function (_) {
    return arguments.length ? (theta2 = _ * _, force) : Math.sqrt(theta2);
  };
  return force;
}

function forceX (x) {
  var strength = constant$1(0.1),
    nodes,
    strengths,
    xz;
  if (typeof x !== "function") x = constant$1(x == null ? 0 : +x);
  function force(alpha) {
    for (var i = 0, n = nodes.length, node; i < n; ++i) {
      node = nodes[i], node.vx += (xz[i] - node.x) * strengths[i] * alpha;
    }
  }
  function initialize() {
    if (!nodes) return;
    var i,
      n = nodes.length;
    strengths = new Array(n);
    xz = new Array(n);
    for (i = 0; i < n; ++i) {
      strengths[i] = isNaN(xz[i] = +x(nodes[i], i, nodes)) ? 0 : +strength(nodes[i], i, nodes);
    }
  }
  force.initialize = function (_) {
    nodes = _;
    initialize();
  };
  force.strength = function (_) {
    return arguments.length ? (strength = typeof _ === "function" ? _ : constant$1(+_), initialize(), force) : strength;
  };
  force.x = function (_) {
    return arguments.length ? (x = typeof _ === "function" ? _ : constant$1(+_), initialize(), force) : x;
  };
  return force;
}

function forceY (y) {
  var strength = constant$1(0.1),
    nodes,
    strengths,
    yz;
  if (typeof y !== "function") y = constant$1(y == null ? 0 : +y);
  function force(alpha) {
    for (var i = 0, n = nodes.length, node; i < n; ++i) {
      node = nodes[i], node.vy += (yz[i] - node.y) * strengths[i] * alpha;
    }
  }
  function initialize() {
    if (!nodes) return;
    var i,
      n = nodes.length;
    strengths = new Array(n);
    yz = new Array(n);
    for (i = 0; i < n; ++i) {
      strengths[i] = isNaN(yz[i] = +y(nodes[i], i, nodes)) ? 0 : +strength(nodes[i], i, nodes);
    }
  }
  force.initialize = function (_) {
    nodes = _;
    initialize();
  };
  force.strength = function (_) {
    return arguments.length ? (strength = typeof _ === "function" ? _ : constant$1(+_), initialize(), force) : strength;
  };
  force.y = function (_) {
    return arguments.length ? (y = typeof _ === "function" ? _ : constant$1(+_), initialize(), force) : y;
  };
  return force;
}

const ForceMap = {
  center: forceCenter,
  collide: forceCollide,
  nbody: forceManyBody,
  link: forceLink,
  x: forceX,
  y: forceY
};
const Forces = 'forces',
  ForceParams = ['alpha', 'alphaMin', 'alphaTarget', 'velocityDecay', 'forces'],
  ForceConfig = ['static', 'iterations'],
  ForceOutput = ['x', 'y', 'vx', 'vy'];

/**
 * Force simulation layout.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {Array<object>} params.forces - The forces to apply.
 */
function Force(params) {
  Transform.call(this, null, params);
}
Force.Definition = {
  'type': 'Force',
  'metadata': {
    'modifies': true
  },
  'params': [{
    'name': 'static',
    'type': 'boolean',
    'default': false
  }, {
    'name': 'restart',
    'type': 'boolean',
    'default': false
  }, {
    'name': 'iterations',
    'type': 'number',
    'default': 300
  }, {
    'name': 'alpha',
    'type': 'number',
    'default': 1
  }, {
    'name': 'alphaMin',
    'type': 'number',
    'default': 0.001
  }, {
    'name': 'alphaTarget',
    'type': 'number',
    'default': 0
  }, {
    'name': 'velocityDecay',
    'type': 'number',
    'default': 0.4
  }, {
    'name': 'forces',
    'type': 'param',
    'array': true,
    'params': [{
      'key': {
        'force': 'center'
      },
      'params': [{
        'name': 'x',
        'type': 'number',
        'default': 0
      }, {
        'name': 'y',
        'type': 'number',
        'default': 0
      }]
    }, {
      'key': {
        'force': 'collide'
      },
      'params': [{
        'name': 'radius',
        'type': 'number',
        'expr': true
      }, {
        'name': 'strength',
        'type': 'number',
        'default': 0.7
      }, {
        'name': 'iterations',
        'type': 'number',
        'default': 1
      }]
    }, {
      'key': {
        'force': 'nbody'
      },
      'params': [{
        'name': 'strength',
        'type': 'number',
        'default': -30,
        'expr': true
      }, {
        'name': 'theta',
        'type': 'number',
        'default': 0.9
      }, {
        'name': 'distanceMin',
        'type': 'number',
        'default': 1
      }, {
        'name': 'distanceMax',
        'type': 'number'
      }]
    }, {
      'key': {
        'force': 'link'
      },
      'params': [{
        'name': 'links',
        'type': 'data'
      }, {
        'name': 'id',
        'type': 'field'
      }, {
        'name': 'distance',
        'type': 'number',
        'default': 30,
        'expr': true
      }, {
        'name': 'strength',
        'type': 'number',
        'expr': true
      }, {
        'name': 'iterations',
        'type': 'number',
        'default': 1
      }]
    }, {
      'key': {
        'force': 'x'
      },
      'params': [{
        'name': 'strength',
        'type': 'number',
        'default': 0.1
      }, {
        'name': 'x',
        'type': 'field'
      }]
    }, {
      'key': {
        'force': 'y'
      },
      'params': [{
        'name': 'strength',
        'type': 'number',
        'default': 0.1
      }, {
        'name': 'y',
        'type': 'field'
      }]
    }]
  }, {
    'name': 'as',
    'type': 'string',
    'array': true,
    'modify': false,
    'default': ForceOutput
  }]
};
inherits(Force, Transform, {
  transform(_, pulse) {
    var sim = this.value,
      change = pulse.changed(pulse.ADD_REM),
      params = _.modified(ForceParams),
      iters = _.iterations || 300;

    // configure simulation
    if (!sim) {
      this.value = sim = simulation(pulse.source, _);
      sim.on('tick', rerun(pulse.dataflow, this));
      if (!_.static) {
        change = true;
        sim.tick(); // ensure we run on init
      }
      pulse.modifies('index');
    } else {
      if (change) {
        pulse.modifies('index');
        sim.nodes(pulse.source);
      }
      if (params || pulse.changed(pulse.MOD)) {
        setup(sim, _, 0, pulse);
      }
    }

    // run simulation
    if (params || change || _.modified(ForceConfig) || pulse.changed() && _.restart) {
      sim.alpha(Math.max(sim.alpha(), _.alpha || 1)).alphaDecay(1 - Math.pow(sim.alphaMin(), 1 / iters));
      if (_.static) {
        for (sim.stop(); --iters >= 0;) sim.tick();
      } else {
        if (sim.stopped()) sim.restart();
        if (!change) return pulse.StopPropagation; // defer to sim ticks
      }
    }
    return this.finish(_, pulse);
  },
  finish(_, pulse) {
    const dataflow = pulse.dataflow;

    // inspect dependencies, touch link source data
    for (let args = this._argops, j = 0, m = args.length, arg; j < m; ++j) {
      arg = args[j];
      if (arg.name !== Forces || arg.op._argval.force !== 'link') {
        continue;
      }
      for (var ops = arg.op._argops, i = 0, n = ops.length, op; i < n; ++i) {
        if (ops[i].name === 'links' && (op = ops[i].op.source)) {
          dataflow.pulse(op, dataflow.changeset().reflow());
          break;
        }
      }
    }

    // reflow all nodes
    return pulse.reflow(_.modified()).modifies(ForceOutput);
  }
});
function rerun(df, op) {
  return () => df.touch(op).run();
}
function simulation(nodes, _) {
  const sim = forceSimulation(nodes),
    stop = sim.stop,
    restart = sim.restart;
  let stopped = false;
  sim.stopped = () => stopped;
  sim.restart = () => (stopped = false, restart());
  sim.stop = () => (stopped = true, stop());
  return setup(sim, _, true).on('end', () => stopped = true);
}
function setup(sim, _, init, pulse) {
  var f = array$5(_.forces),
    i,
    n,
    p,
    name;
  for (i = 0, n = ForceParams.length; i < n; ++i) {
    p = ForceParams[i];
    if (p !== Forces && _.modified(p)) sim[p](_[p]);
  }
  for (i = 0, n = f.length; i < n; ++i) {
    name = Forces + i;
    p = init || _.modified(Forces, i) ? getForce(f[i]) : pulse && modified(f[i], pulse) ? sim.force(name) : null;
    if (p) sim.force(name, p);
  }
  for (n = sim.numForces || 0; i < n; ++i) {
    sim.force(Forces + i, null); // remove
  }
  sim.numForces = f.length;
  return sim;
}
function modified(f, pulse) {
  var k, v;
  for (k in f) {
    if (isFunction(v = f[k]) && pulse.modified(accessorFields(v))) return 1;
  }
  return 0;
}
function getForce(_) {
  var f, p;
  if (!has$1(ForceMap, _.force)) {
    error('Unrecognized force: ' + _.force);
  }
  f = ForceMap[_.force]();
  for (p in _) {
    if (isFunction(f[p])) setForceParam(f[p], _[p], _);
  }
  return f;
}
function setForceParam(f, v, _) {
  f(isFunction(v) ? d => v(d, _) : v);
}

var force = /*#__PURE__*/Object.freeze({
    __proto__: null,
    force: Force
});

function defaultSeparation$2(a, b) {
  return a.parent === b.parent ? 1 : 2;
}
function meanX(children) {
  return children.reduce(meanXReduce, 0) / children.length;
}
function meanXReduce(x, c) {
  return x + c.x;
}
function maxY(children) {
  return 1 + children.reduce(maxYReduce, 0);
}
function maxYReduce(y, c) {
  return Math.max(y, c.y);
}
function leafLeft(node) {
  var children;
  while (children = node.children) node = children[0];
  return node;
}
function leafRight(node) {
  var children;
  while (children = node.children) node = children[children.length - 1];
  return node;
}
function cluster () {
  var separation = defaultSeparation$2,
    dx = 1,
    dy = 1,
    nodeSize = false;
  function cluster(root) {
    var previousNode,
      x = 0;

    // First walk, computing the initial x & y values.
    root.eachAfter(function (node) {
      var children = node.children;
      if (children) {
        node.x = meanX(children);
        node.y = maxY(children);
      } else {
        node.x = previousNode ? x += separation(node, previousNode) : 0;
        node.y = 0;
        previousNode = node;
      }
    });
    var left = leafLeft(root),
      right = leafRight(root),
      x0 = left.x - separation(left, right) / 2,
      x1 = right.x + separation(right, left) / 2;

    // Second walk, normalizing x & y to the desired size.
    return root.eachAfter(nodeSize ? function (node) {
      node.x = (node.x - root.x) * dx;
      node.y = (root.y - node.y) * dy;
    } : function (node) {
      node.x = (node.x - x0) / (x1 - x0) * dx;
      node.y = (1 - (root.y ? node.y / root.y : 1)) * dy;
    });
  }
  cluster.separation = function (x) {
    return arguments.length ? (separation = x, cluster) : separation;
  };
  cluster.size = function (x) {
    return arguments.length ? (nodeSize = false, dx = +x[0], dy = +x[1], cluster) : nodeSize ? null : [dx, dy];
  };
  cluster.nodeSize = function (x) {
    return arguments.length ? (nodeSize = true, dx = +x[0], dy = +x[1], cluster) : nodeSize ? [dx, dy] : null;
  };
  return cluster;
}

function count(node) {
  var sum = 0,
    children = node.children,
    i = children && children.length;
  if (!i) sum = 1;else while (--i >= 0) sum += children[i].value;
  node.value = sum;
}
function node_count () {
  return this.eachAfter(count);
}

function node_each (callback, that) {
  let index = -1;
  for (const node of this) {
    callback.call(that, node, ++index, this);
  }
  return this;
}

function node_eachBefore (callback, that) {
  var node = this,
    nodes = [node],
    children,
    i,
    index = -1;
  while (node = nodes.pop()) {
    callback.call(that, node, ++index, this);
    if (children = node.children) {
      for (i = children.length - 1; i >= 0; --i) {
        nodes.push(children[i]);
      }
    }
  }
  return this;
}

function node_eachAfter (callback, that) {
  var node = this,
    nodes = [node],
    next = [],
    children,
    i,
    n,
    index = -1;
  while (node = nodes.pop()) {
    next.push(node);
    if (children = node.children) {
      for (i = 0, n = children.length; i < n; ++i) {
        nodes.push(children[i]);
      }
    }
  }
  while (node = next.pop()) {
    callback.call(that, node, ++index, this);
  }
  return this;
}

function node_find (callback, that) {
  let index = -1;
  for (const node of this) {
    if (callback.call(that, node, ++index, this)) {
      return node;
    }
  }
}

function node_sum (value) {
  return this.eachAfter(function (node) {
    var sum = +value(node.data) || 0,
      children = node.children,
      i = children && children.length;
    while (--i >= 0) sum += children[i].value;
    node.value = sum;
  });
}

function node_sort (compare) {
  return this.eachBefore(function (node) {
    if (node.children) {
      node.children.sort(compare);
    }
  });
}

function node_path (end) {
  var start = this,
    ancestor = leastCommonAncestor(start, end),
    nodes = [start];
  while (start !== ancestor) {
    start = start.parent;
    nodes.push(start);
  }
  var k = nodes.length;
  while (end !== ancestor) {
    nodes.splice(k, 0, end);
    end = end.parent;
  }
  return nodes;
}
function leastCommonAncestor(a, b) {
  if (a === b) return a;
  var aNodes = a.ancestors(),
    bNodes = b.ancestors(),
    c = null;
  a = aNodes.pop();
  b = bNodes.pop();
  while (a === b) {
    c = a;
    a = aNodes.pop();
    b = bNodes.pop();
  }
  return c;
}

function node_ancestors () {
  var node = this,
    nodes = [node];
  while (node = node.parent) {
    nodes.push(node);
  }
  return nodes;
}

function node_descendants () {
  return Array.from(this);
}

function node_leaves () {
  var leaves = [];
  this.eachBefore(function (node) {
    if (!node.children) {
      leaves.push(node);
    }
  });
  return leaves;
}

function node_links () {
  var root = this,
    links = [];
  root.each(function (node) {
    if (node !== root) {
      // Don’t include the root’s parent, if any.
      links.push({
        source: node.parent,
        target: node
      });
    }
  });
  return links;
}

function* node_iterator () {
  var node = this,
    current,
    next = [node],
    children,
    i,
    n;
  do {
    current = next.reverse(), next = [];
    while (node = current.pop()) {
      yield node;
      if (children = node.children) {
        for (i = 0, n = children.length; i < n; ++i) {
          next.push(children[i]);
        }
      }
    }
  } while (next.length);
}

function hierarchy(data, children) {
  if (data instanceof Map) {
    data = [undefined, data];
    if (children === undefined) children = mapChildren;
  } else if (children === undefined) {
    children = objectChildren;
  }
  var root = new Node$1(data),
    node,
    nodes = [root],
    child,
    childs,
    i,
    n;
  while (node = nodes.pop()) {
    if ((childs = children(node.data)) && (n = (childs = Array.from(childs)).length)) {
      node.children = childs;
      for (i = n - 1; i >= 0; --i) {
        nodes.push(child = childs[i] = new Node$1(childs[i]));
        child.parent = node;
        child.depth = node.depth + 1;
      }
    }
  }
  return root.eachBefore(computeHeight);
}
function node_copy() {
  return hierarchy(this).eachBefore(copyData);
}
function objectChildren(d) {
  return d.children;
}
function mapChildren(d) {
  return Array.isArray(d) ? d[1] : null;
}
function copyData(node) {
  if (node.data.value !== undefined) node.value = node.data.value;
  node.data = node.data.data;
}
function computeHeight(node) {
  var height = 0;
  do node.height = height; while ((node = node.parent) && node.height < ++height);
}
function Node$1(data) {
  this.data = data;
  this.depth = this.height = 0;
  this.parent = null;
}
Node$1.prototype = hierarchy.prototype = {
  constructor: Node$1,
  count: node_count,
  each: node_each,
  eachAfter: node_eachAfter,
  eachBefore: node_eachBefore,
  find: node_find,
  sum: node_sum,
  sort: node_sort,
  path: node_path,
  ancestors: node_ancestors,
  descendants: node_descendants,
  leaves: node_leaves,
  links: node_links,
  copy: node_copy,
  [Symbol.iterator]: node_iterator
};

function optional(f) {
  return f == null ? null : required(f);
}
function required(f) {
  if (typeof f !== "function") throw new Error();
  return f;
}

function constantZero() {
  return 0;
}
function constant (x) {
  return function () {
    return x;
  };
}

// https://en.wikipedia.org/wiki/Linear_congruential_generator#Parameters_in_common_use
const a = 1664525;
const c = 1013904223;
const m = 4294967296; // 2^32

function lcg () {
  let s = 1;
  return () => (s = (a * s + c) % m) / m;
}

function array$2 (x) {
  return typeof x === "object" && "length" in x ? x // Array, TypedArray, NodeList, array-like
  : Array.from(x); // Map, Set, iterable, string, or anything else
}
function shuffle(array, random) {
  let m = array.length,
    t,
    i;
  while (m) {
    i = random() * m-- | 0;
    t = array[m];
    array[m] = array[i];
    array[i] = t;
  }
  return array;
}

function packEncloseRandom(circles, random) {
  var i = 0,
    n = (circles = shuffle(Array.from(circles), random)).length,
    B = [],
    p,
    e;
  while (i < n) {
    p = circles[i];
    if (e && enclosesWeak(e, p)) ++i;else e = encloseBasis(B = extendBasis(B, p)), i = 0;
  }
  return e;
}
function extendBasis(B, p) {
  var i, j;
  if (enclosesWeakAll(p, B)) return [p];

  // If we get here then B must have at least one element.
  for (i = 0; i < B.length; ++i) {
    if (enclosesNot(p, B[i]) && enclosesWeakAll(encloseBasis2(B[i], p), B)) {
      return [B[i], p];
    }
  }

  // If we get here then B must have at least two elements.
  for (i = 0; i < B.length - 1; ++i) {
    for (j = i + 1; j < B.length; ++j) {
      if (enclosesNot(encloseBasis2(B[i], B[j]), p) && enclosesNot(encloseBasis2(B[i], p), B[j]) && enclosesNot(encloseBasis2(B[j], p), B[i]) && enclosesWeakAll(encloseBasis3(B[i], B[j], p), B)) {
        return [B[i], B[j], p];
      }
    }
  }

  // If we get here then something is very wrong.
  throw new Error();
}
function enclosesNot(a, b) {
  var dr = a.r - b.r,
    dx = b.x - a.x,
    dy = b.y - a.y;
  return dr < 0 || dr * dr < dx * dx + dy * dy;
}
function enclosesWeak(a, b) {
  var dr = a.r - b.r + Math.max(a.r, b.r, 1) * 1e-9,
    dx = b.x - a.x,
    dy = b.y - a.y;
  return dr > 0 && dr * dr > dx * dx + dy * dy;
}
function enclosesWeakAll(a, B) {
  for (var i = 0; i < B.length; ++i) {
    if (!enclosesWeak(a, B[i])) {
      return false;
    }
  }
  return true;
}
function encloseBasis(B) {
  switch (B.length) {
    case 1:
      return encloseBasis1(B[0]);
    case 2:
      return encloseBasis2(B[0], B[1]);
    case 3:
      return encloseBasis3(B[0], B[1], B[2]);
  }
}
function encloseBasis1(a) {
  return {
    x: a.x,
    y: a.y,
    r: a.r
  };
}
function encloseBasis2(a, b) {
  var x1 = a.x,
    y1 = a.y,
    r1 = a.r,
    x2 = b.x,
    y2 = b.y,
    r2 = b.r,
    x21 = x2 - x1,
    y21 = y2 - y1,
    r21 = r2 - r1,
    l = Math.sqrt(x21 * x21 + y21 * y21);
  return {
    x: (x1 + x2 + x21 / l * r21) / 2,
    y: (y1 + y2 + y21 / l * r21) / 2,
    r: (l + r1 + r2) / 2
  };
}
function encloseBasis3(a, b, c) {
  var x1 = a.x,
    y1 = a.y,
    r1 = a.r,
    x2 = b.x,
    y2 = b.y,
    r2 = b.r,
    x3 = c.x,
    y3 = c.y,
    r3 = c.r,
    a2 = x1 - x2,
    a3 = x1 - x3,
    b2 = y1 - y2,
    b3 = y1 - y3,
    c2 = r2 - r1,
    c3 = r3 - r1,
    d1 = x1 * x1 + y1 * y1 - r1 * r1,
    d2 = d1 - x2 * x2 - y2 * y2 + r2 * r2,
    d3 = d1 - x3 * x3 - y3 * y3 + r3 * r3,
    ab = a3 * b2 - a2 * b3,
    xa = (b2 * d3 - b3 * d2) / (ab * 2) - x1,
    xb = (b3 * c2 - b2 * c3) / ab,
    ya = (a3 * d2 - a2 * d3) / (ab * 2) - y1,
    yb = (a2 * c3 - a3 * c2) / ab,
    A = xb * xb + yb * yb - 1,
    B = 2 * (r1 + xa * xb + ya * yb),
    C = xa * xa + ya * ya - r1 * r1,
    r = -(Math.abs(A) > 1e-6 ? (B + Math.sqrt(B * B - 4 * A * C)) / (2 * A) : C / B);
  return {
    x: x1 + xa + xb * r,
    y: y1 + ya + yb * r,
    r: r
  };
}

function place(b, a, c) {
  var dx = b.x - a.x,
    x,
    a2,
    dy = b.y - a.y,
    y,
    b2,
    d2 = dx * dx + dy * dy;
  if (d2) {
    a2 = a.r + c.r, a2 *= a2;
    b2 = b.r + c.r, b2 *= b2;
    if (a2 > b2) {
      x = (d2 + b2 - a2) / (2 * d2);
      y = Math.sqrt(Math.max(0, b2 / d2 - x * x));
      c.x = b.x - x * dx - y * dy;
      c.y = b.y - x * dy + y * dx;
    } else {
      x = (d2 + a2 - b2) / (2 * d2);
      y = Math.sqrt(Math.max(0, a2 / d2 - x * x));
      c.x = a.x + x * dx - y * dy;
      c.y = a.y + x * dy + y * dx;
    }
  } else {
    c.x = a.x + c.r;
    c.y = a.y;
  }
}
function intersects(a, b) {
  var dr = a.r + b.r - 1e-6,
    dx = b.x - a.x,
    dy = b.y - a.y;
  return dr > 0 && dr * dr > dx * dx + dy * dy;
}
function score(node) {
  var a = node._,
    b = node.next._,
    ab = a.r + b.r,
    dx = (a.x * b.r + b.x * a.r) / ab,
    dy = (a.y * b.r + b.y * a.r) / ab;
  return dx * dx + dy * dy;
}
function Node(circle) {
  this._ = circle;
  this.next = null;
  this.previous = null;
}
function packSiblingsRandom(circles, random) {
  if (!(n = (circles = array$2(circles)).length)) return 0;
  var a, b, c, n, aa, ca, i, j, k, sj, sk;

  // Place the first circle.
  a = circles[0], a.x = 0, a.y = 0;
  if (!(n > 1)) return a.r;

  // Place the second circle.
  b = circles[1], a.x = -b.r, b.x = a.r, b.y = 0;
  if (!(n > 2)) return a.r + b.r;

  // Place the third circle.
  place(b, a, c = circles[2]);

  // Initialize the front-chain using the first three circles a, b and c.
  a = new Node(a), b = new Node(b), c = new Node(c);
  a.next = c.previous = b;
  b.next = a.previous = c;
  c.next = b.previous = a;

  // Attempt to place each remaining circle…
  pack: for (i = 3; i < n; ++i) {
    place(a._, b._, c = circles[i]), c = new Node(c);

    // Find the closest intersecting circle on the front-chain, if any.
    // “Closeness” is determined by linear distance along the front-chain.
    // “Ahead” or “behind” is likewise determined by linear distance.
    j = b.next, k = a.previous, sj = b._.r, sk = a._.r;
    do {
      if (sj <= sk) {
        if (intersects(j._, c._)) {
          b = j, a.next = b, b.previous = a, --i;
          continue pack;
        }
        sj += j._.r, j = j.next;
      } else {
        if (intersects(k._, c._)) {
          a = k, a.next = b, b.previous = a, --i;
          continue pack;
        }
        sk += k._.r, k = k.previous;
      }
    } while (j !== k.next);

    // Success! Insert the new circle c between a and b.
    c.previous = a, c.next = b, a.next = b.previous = b = c;

    // Compute the new closest circle pair to the centroid.
    aa = score(a);
    while ((c = c.next) !== b) {
      if ((ca = score(c)) < aa) {
        a = c, aa = ca;
      }
    }
    b = a.next;
  }

  // Compute the enclosing circle of the front chain.
  a = [b._], c = b;
  while ((c = c.next) !== b) a.push(c._);
  c = packEncloseRandom(a, random);

  // Translate the circles to put the enclosing circle around the origin.
  for (i = 0; i < n; ++i) a = circles[i], a.x -= c.x, a.y -= c.y;
  return c.r;
}

function defaultRadius(d) {
  return Math.sqrt(d.value);
}
function pack () {
  var radius = null,
    dx = 1,
    dy = 1,
    padding = constantZero;
  function pack(root) {
    const random = lcg();
    root.x = dx / 2, root.y = dy / 2;
    if (radius) {
      root.eachBefore(radiusLeaf(radius)).eachAfter(packChildrenRandom(padding, 0.5, random)).eachBefore(translateChild(1));
    } else {
      root.eachBefore(radiusLeaf(defaultRadius)).eachAfter(packChildrenRandom(constantZero, 1, random)).eachAfter(packChildrenRandom(padding, root.r / Math.min(dx, dy), random)).eachBefore(translateChild(Math.min(dx, dy) / (2 * root.r)));
    }
    return root;
  }
  pack.radius = function (x) {
    return arguments.length ? (radius = optional(x), pack) : radius;
  };
  pack.size = function (x) {
    return arguments.length ? (dx = +x[0], dy = +x[1], pack) : [dx, dy];
  };
  pack.padding = function (x) {
    return arguments.length ? (padding = typeof x === "function" ? x : constant(+x), pack) : padding;
  };
  return pack;
}
function radiusLeaf(radius) {
  return function (node) {
    if (!node.children) {
      node.r = Math.max(0, +radius(node) || 0);
    }
  };
}
function packChildrenRandom(padding, k, random) {
  return function (node) {
    if (children = node.children) {
      var children,
        i,
        n = children.length,
        r = padding(node) * k || 0,
        e;
      if (r) for (i = 0; i < n; ++i) children[i].r += r;
      e = packSiblingsRandom(children, random);
      if (r) for (i = 0; i < n; ++i) children[i].r -= r;
      node.r = e + r;
    }
  };
}
function translateChild(k) {
  return function (node) {
    var parent = node.parent;
    node.r *= k;
    if (parent) {
      node.x = parent.x + k * node.x;
      node.y = parent.y + k * node.y;
    }
  };
}

function roundNode (node) {
  node.x0 = Math.round(node.x0);
  node.y0 = Math.round(node.y0);
  node.x1 = Math.round(node.x1);
  node.y1 = Math.round(node.y1);
}

function treemapDice (parent, x0, y0, x1, y1) {
  var nodes = parent.children,
    node,
    i = -1,
    n = nodes.length,
    k = parent.value && (x1 - x0) / parent.value;
  while (++i < n) {
    node = nodes[i], node.y0 = y0, node.y1 = y1;
    node.x0 = x0, node.x1 = x0 += node.value * k;
  }
}

function partition$1 () {
  var dx = 1,
    dy = 1,
    padding = 0,
    round = false;
  function partition(root) {
    var n = root.height + 1;
    root.x0 = root.y0 = padding;
    root.x1 = dx;
    root.y1 = dy / n;
    root.eachBefore(positionNode(dy, n));
    if (round) root.eachBefore(roundNode);
    return root;
  }
  function positionNode(dy, n) {
    return function (node) {
      if (node.children) {
        treemapDice(node, node.x0, dy * (node.depth + 1) / n, node.x1, dy * (node.depth + 2) / n);
      }
      var x0 = node.x0,
        y0 = node.y0,
        x1 = node.x1 - padding,
        y1 = node.y1 - padding;
      if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
      if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
      node.x0 = x0;
      node.y0 = y0;
      node.x1 = x1;
      node.y1 = y1;
    };
  }
  partition.round = function (x) {
    return arguments.length ? (round = !!x, partition) : round;
  };
  partition.size = function (x) {
    return arguments.length ? (dx = +x[0], dy = +x[1], partition) : [dx, dy];
  };
  partition.padding = function (x) {
    return arguments.length ? (padding = +x, partition) : padding;
  };
  return partition;
}

var preroot = {
    depth: -1
  },
  ambiguous = {},
  imputed = {};
function defaultId(d) {
  return d.id;
}
function defaultParentId(d) {
  return d.parentId;
}
function stratify () {
  var id = defaultId,
    parentId = defaultParentId,
    path;
  function stratify(data) {
    var nodes = Array.from(data),
      currentId = id,
      currentParentId = parentId,
      n,
      d,
      i,
      root,
      parent,
      node,
      nodeId,
      nodeKey,
      nodeByKey = new Map();
    if (path != null) {
      const I = nodes.map((d, i) => normalize(path(d, i, data)));
      const P = I.map(parentof);
      const S = new Set(I).add("");
      for (const i of P) {
        if (!S.has(i)) {
          S.add(i);
          I.push(i);
          P.push(parentof(i));
          nodes.push(imputed);
        }
      }
      currentId = (_, i) => I[i];
      currentParentId = (_, i) => P[i];
    }
    for (i = 0, n = nodes.length; i < n; ++i) {
      d = nodes[i], node = nodes[i] = new Node$1(d);
      if ((nodeId = currentId(d, i, data)) != null && (nodeId += "")) {
        nodeKey = node.id = nodeId;
        nodeByKey.set(nodeKey, nodeByKey.has(nodeKey) ? ambiguous : node);
      }
      if ((nodeId = currentParentId(d, i, data)) != null && (nodeId += "")) {
        node.parent = nodeId;
      }
    }
    for (i = 0; i < n; ++i) {
      node = nodes[i];
      if (nodeId = node.parent) {
        parent = nodeByKey.get(nodeId);
        if (!parent) throw new Error("missing: " + nodeId);
        if (parent === ambiguous) throw new Error("ambiguous: " + nodeId);
        if (parent.children) parent.children.push(node);else parent.children = [node];
        node.parent = parent;
      } else {
        if (root) throw new Error("multiple roots");
        root = node;
      }
    }
    if (!root) throw new Error("no root");

    // When imputing internal nodes, only introduce roots if needed.
    // Then replace the imputed marker data with null.
    if (path != null) {
      while (root.data === imputed && root.children.length === 1) {
        root = root.children[0], --n;
      }
      for (let i = nodes.length - 1; i >= 0; --i) {
        node = nodes[i];
        if (node.data !== imputed) break;
        node.data = null;
      }
    }
    root.parent = preroot;
    root.eachBefore(function (node) {
      node.depth = node.parent.depth + 1;
      --n;
    }).eachBefore(computeHeight);
    root.parent = null;
    if (n > 0) throw new Error("cycle");
    return root;
  }
  stratify.id = function (x) {
    return arguments.length ? (id = optional(x), stratify) : id;
  };
  stratify.parentId = function (x) {
    return arguments.length ? (parentId = optional(x), stratify) : parentId;
  };
  stratify.path = function (x) {
    return arguments.length ? (path = optional(x), stratify) : path;
  };
  return stratify;
}

// To normalize a path, we coerce to a string, strip the trailing slash if any
// (as long as the trailing slash is not immediately preceded by another slash),
// and add leading slash if missing.
function normalize(path) {
  path = `${path}`;
  let i = path.length;
  if (slash(path, i - 1) && !slash(path, i - 2)) path = path.slice(0, -1);
  return path[0] === "/" ? path : `/${path}`;
}

// Walk backwards to find the first slash that is not the leading slash, e.g.:
// "/foo/bar" ⇥ "/foo", "/foo" ⇥ "/", "/" ↦ "". (The root is special-cased
// because the id of the root must be a truthy value.)
function parentof(path) {
  let i = path.length;
  if (i < 2) return "";
  while (--i > 1) if (slash(path, i)) break;
  return path.slice(0, i);
}

// Slashes can be escaped; to determine whether a slash is a path delimiter, we
// count the number of preceding backslashes escaping the forward slash: an odd
// number indicates an escaped forward slash.
function slash(path, i) {
  if (path[i] === "/") {
    let k = 0;
    while (i > 0 && path[--i] === "\\") ++k;
    if ((k & 1) === 0) return true;
  }
  return false;
}

function defaultSeparation$1(a, b) {
  return a.parent === b.parent ? 1 : 2;
}

// function radialSeparation(a, b) {
//   return (a.parent === b.parent ? 1 : 2) / a.depth;
// }

// This function is used to traverse the left contour of a subtree (or
// subforest). It returns the successor of v on this contour. This successor is
// either given by the leftmost child of v or by the thread of v. The function
// returns null if and only if v is on the highest level of its subtree.
function nextLeft(v) {
  var children = v.children;
  return children ? children[0] : v.t;
}

// This function works analogously to nextLeft.
function nextRight(v) {
  var children = v.children;
  return children ? children[children.length - 1] : v.t;
}

// Shifts the current subtree rooted at w+. This is done by increasing
// prelim(w+) and mod(w+) by shift.
function moveSubtree(wm, wp, shift) {
  var change = shift / (wp.i - wm.i);
  wp.c -= change;
  wp.s += shift;
  wm.c += change;
  wp.z += shift;
  wp.m += shift;
}

// All other shifts, applied to the smaller subtrees between w- and w+, are
// performed by this function. To prepare the shifts, we have to adjust
// change(w+), shift(w+), and change(w-).
function executeShifts(v) {
  var shift = 0,
    change = 0,
    children = v.children,
    i = children.length,
    w;
  while (--i >= 0) {
    w = children[i];
    w.z += shift;
    w.m += shift;
    shift += w.s + (change += w.c);
  }
}

// If vi-’s ancestor is a sibling of v, returns vi-’s ancestor. Otherwise,
// returns the specified (default) ancestor.
function nextAncestor(vim, v, ancestor) {
  return vim.a.parent === v.parent ? vim.a : ancestor;
}
function TreeNode(node, i) {
  this._ = node;
  this.parent = null;
  this.children = null;
  this.A = null; // default ancestor
  this.a = this; // ancestor
  this.z = 0; // prelim
  this.m = 0; // mod
  this.c = 0; // change
  this.s = 0; // shift
  this.t = null; // thread
  this.i = i; // number
}
TreeNode.prototype = Object.create(Node$1.prototype);
function treeRoot(root) {
  var tree = new TreeNode(root, 0),
    node,
    nodes = [tree],
    child,
    children,
    i,
    n;
  while (node = nodes.pop()) {
    if (children = node._.children) {
      node.children = new Array(n = children.length);
      for (i = n - 1; i >= 0; --i) {
        nodes.push(child = node.children[i] = new TreeNode(children[i], i));
        child.parent = node;
      }
    }
  }
  (tree.parent = new TreeNode(null, 0)).children = [tree];
  return tree;
}

// Node-link tree diagram using the Reingold-Tilford "tidy" algorithm
function tree$1 () {
  var separation = defaultSeparation$1,
    dx = 1,
    dy = 1,
    nodeSize = null;
  function tree(root) {
    var t = treeRoot(root);

    // Compute the layout using Buchheim et al.’s algorithm.
    t.eachAfter(firstWalk), t.parent.m = -t.z;
    t.eachBefore(secondWalk);

    // If a fixed node size is specified, scale x and y.
    if (nodeSize) root.eachBefore(sizeNode);

    // If a fixed tree size is specified, scale x and y based on the extent.
    // Compute the left-most, right-most, and depth-most nodes for extents.
    else {
      var left = root,
        right = root,
        bottom = root;
      root.eachBefore(function (node) {
        if (node.x < left.x) left = node;
        if (node.x > right.x) right = node;
        if (node.depth > bottom.depth) bottom = node;
      });
      var s = left === right ? 1 : separation(left, right) / 2,
        tx = s - left.x,
        kx = dx / (right.x + s + tx),
        ky = dy / (bottom.depth || 1);
      root.eachBefore(function (node) {
        node.x = (node.x + tx) * kx;
        node.y = node.depth * ky;
      });
    }
    return root;
  }

  // Computes a preliminary x-coordinate for v. Before that, FIRST WALK is
  // applied recursively to the children of v, as well as the function
  // APPORTION. After spacing out the children by calling EXECUTE SHIFTS, the
  // node v is placed to the midpoint of its outermost children.
  function firstWalk(v) {
    var children = v.children,
      siblings = v.parent.children,
      w = v.i ? siblings[v.i - 1] : null;
    if (children) {
      executeShifts(v);
      var midpoint = (children[0].z + children[children.length - 1].z) / 2;
      if (w) {
        v.z = w.z + separation(v._, w._);
        v.m = v.z - midpoint;
      } else {
        v.z = midpoint;
      }
    } else if (w) {
      v.z = w.z + separation(v._, w._);
    }
    v.parent.A = apportion(v, w, v.parent.A || siblings[0]);
  }

  // Computes all real x-coordinates by summing up the modifiers recursively.
  function secondWalk(v) {
    v._.x = v.z + v.parent.m;
    v.m += v.parent.m;
  }

  // The core of the algorithm. Here, a new subtree is combined with the
  // previous subtrees. Threads are used to traverse the inside and outside
  // contours of the left and right subtree up to the highest common level. The
  // vertices used for the traversals are vi+, vi-, vo-, and vo+, where the
  // superscript o means outside and i means inside, the subscript - means left
  // subtree and + means right subtree. For summing up the modifiers along the
  // contour, we use respective variables si+, si-, so-, and so+. Whenever two
  // nodes of the inside contours conflict, we compute the left one of the
  // greatest uncommon ancestors using the function ANCESTOR and call MOVE
  // SUBTREE to shift the subtree and prepare the shifts of smaller subtrees.
  // Finally, we add a new thread (if necessary).
  function apportion(v, w, ancestor) {
    if (w) {
      var vip = v,
        vop = v,
        vim = w,
        vom = vip.parent.children[0],
        sip = vip.m,
        sop = vop.m,
        sim = vim.m,
        som = vom.m,
        shift;
      while (vim = nextRight(vim), vip = nextLeft(vip), vim && vip) {
        vom = nextLeft(vom);
        vop = nextRight(vop);
        vop.a = v;
        shift = vim.z + sim - vip.z - sip + separation(vim._, vip._);
        if (shift > 0) {
          moveSubtree(nextAncestor(vim, v, ancestor), v, shift);
          sip += shift;
          sop += shift;
        }
        sim += vim.m;
        sip += vip.m;
        som += vom.m;
        sop += vop.m;
      }
      if (vim && !nextRight(vop)) {
        vop.t = vim;
        vop.m += sim - sop;
      }
      if (vip && !nextLeft(vom)) {
        vom.t = vip;
        vom.m += sip - som;
        ancestor = v;
      }
    }
    return ancestor;
  }
  function sizeNode(node) {
    node.x *= dx;
    node.y = node.depth * dy;
  }
  tree.separation = function (x) {
    return arguments.length ? (separation = x, tree) : separation;
  };
  tree.size = function (x) {
    return arguments.length ? (nodeSize = false, dx = +x[0], dy = +x[1], tree) : nodeSize ? null : [dx, dy];
  };
  tree.nodeSize = function (x) {
    return arguments.length ? (nodeSize = true, dx = +x[0], dy = +x[1], tree) : nodeSize ? [dx, dy] : null;
  };
  return tree;
}

function treemapSlice (parent, x0, y0, x1, y1) {
  var nodes = parent.children,
    node,
    i = -1,
    n = nodes.length,
    k = parent.value && (y1 - y0) / parent.value;
  while (++i < n) {
    node = nodes[i], node.x0 = x0, node.x1 = x1;
    node.y0 = y0, node.y1 = y0 += node.value * k;
  }
}

var phi = (1 + Math.sqrt(5)) / 2;
function squarifyRatio(ratio, parent, x0, y0, x1, y1) {
  var rows = [],
    nodes = parent.children,
    row,
    nodeValue,
    i0 = 0,
    i1 = 0,
    n = nodes.length,
    dx,
    dy,
    value = parent.value,
    sumValue,
    minValue,
    maxValue,
    newRatio,
    minRatio,
    alpha,
    beta;
  while (i0 < n) {
    dx = x1 - x0, dy = y1 - y0;

    // Find the next non-empty node.
    do sumValue = nodes[i1++].value; while (!sumValue && i1 < n);
    minValue = maxValue = sumValue;
    alpha = Math.max(dy / dx, dx / dy) / (value * ratio);
    beta = sumValue * sumValue * alpha;
    minRatio = Math.max(maxValue / beta, beta / minValue);

    // Keep adding nodes while the aspect ratio maintains or improves.
    for (; i1 < n; ++i1) {
      sumValue += nodeValue = nodes[i1].value;
      if (nodeValue < minValue) minValue = nodeValue;
      if (nodeValue > maxValue) maxValue = nodeValue;
      beta = sumValue * sumValue * alpha;
      newRatio = Math.max(maxValue / beta, beta / minValue);
      if (newRatio > minRatio) {
        sumValue -= nodeValue;
        break;
      }
      minRatio = newRatio;
    }

    // Position and record the row orientation.
    rows.push(row = {
      value: sumValue,
      dice: dx < dy,
      children: nodes.slice(i0, i1)
    });
    if (row.dice) treemapDice(row, x0, y0, x1, value ? y0 += dy * sumValue / value : y1);else treemapSlice(row, x0, y0, value ? x0 += dx * sumValue / value : x1, y1);
    value -= sumValue, i0 = i1;
  }
  return rows;
}
var treemapSquarify = (function custom(ratio) {
  function squarify(parent, x0, y0, x1, y1) {
    squarifyRatio(ratio, parent, x0, y0, x1, y1);
  }
  squarify.ratio = function (x) {
    return custom((x = +x) > 1 ? x : 1);
  };
  return squarify;
})(phi);

function treemap () {
  var tile = treemapSquarify,
    round = false,
    dx = 1,
    dy = 1,
    paddingStack = [0],
    paddingInner = constantZero,
    paddingTop = constantZero,
    paddingRight = constantZero,
    paddingBottom = constantZero,
    paddingLeft = constantZero;
  function treemap(root) {
    root.x0 = root.y0 = 0;
    root.x1 = dx;
    root.y1 = dy;
    root.eachBefore(positionNode);
    paddingStack = [0];
    if (round) root.eachBefore(roundNode);
    return root;
  }
  function positionNode(node) {
    var p = paddingStack[node.depth],
      x0 = node.x0 + p,
      y0 = node.y0 + p,
      x1 = node.x1 - p,
      y1 = node.y1 - p;
    if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
    if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
    node.x0 = x0;
    node.y0 = y0;
    node.x1 = x1;
    node.y1 = y1;
    if (node.children) {
      p = paddingStack[node.depth + 1] = paddingInner(node) / 2;
      x0 += paddingLeft(node) - p;
      y0 += paddingTop(node) - p;
      x1 -= paddingRight(node) - p;
      y1 -= paddingBottom(node) - p;
      if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
      if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
      tile(node, x0, y0, x1, y1);
    }
  }
  treemap.round = function (x) {
    return arguments.length ? (round = !!x, treemap) : round;
  };
  treemap.size = function (x) {
    return arguments.length ? (dx = +x[0], dy = +x[1], treemap) : [dx, dy];
  };
  treemap.tile = function (x) {
    return arguments.length ? (tile = required(x), treemap) : tile;
  };
  treemap.padding = function (x) {
    return arguments.length ? treemap.paddingInner(x).paddingOuter(x) : treemap.paddingInner();
  };
  treemap.paddingInner = function (x) {
    return arguments.length ? (paddingInner = typeof x === "function" ? x : constant(+x), treemap) : paddingInner;
  };
  treemap.paddingOuter = function (x) {
    return arguments.length ? treemap.paddingTop(x).paddingRight(x).paddingBottom(x).paddingLeft(x) : treemap.paddingTop();
  };
  treemap.paddingTop = function (x) {
    return arguments.length ? (paddingTop = typeof x === "function" ? x : constant(+x), treemap) : paddingTop;
  };
  treemap.paddingRight = function (x) {
    return arguments.length ? (paddingRight = typeof x === "function" ? x : constant(+x), treemap) : paddingRight;
  };
  treemap.paddingBottom = function (x) {
    return arguments.length ? (paddingBottom = typeof x === "function" ? x : constant(+x), treemap) : paddingBottom;
  };
  treemap.paddingLeft = function (x) {
    return arguments.length ? (paddingLeft = typeof x === "function" ? x : constant(+x), treemap) : paddingLeft;
  };
  return treemap;
}

function treemapBinary (parent, x0, y0, x1, y1) {
  var nodes = parent.children,
    i,
    n = nodes.length,
    sum,
    sums = new Array(n + 1);
  for (sums[0] = sum = i = 0; i < n; ++i) {
    sums[i + 1] = sum += nodes[i].value;
  }
  partition(0, n, parent.value, x0, y0, x1, y1);
  function partition(i, j, value, x0, y0, x1, y1) {
    if (i >= j - 1) {
      var node = nodes[i];
      node.x0 = x0, node.y0 = y0;
      node.x1 = x1, node.y1 = y1;
      return;
    }
    var valueOffset = sums[i],
      valueTarget = value / 2 + valueOffset,
      k = i + 1,
      hi = j - 1;
    while (k < hi) {
      var mid = k + hi >>> 1;
      if (sums[mid] < valueTarget) k = mid + 1;else hi = mid;
    }
    if (valueTarget - sums[k - 1] < sums[k] - valueTarget && i + 1 < k) --k;
    var valueLeft = sums[k] - valueOffset,
      valueRight = value - valueLeft;
    if (x1 - x0 > y1 - y0) {
      var xk = value ? (x0 * valueRight + x1 * valueLeft) / value : x1;
      partition(i, k, valueLeft, x0, y0, xk, y1);
      partition(k, j, valueRight, xk, y0, x1, y1);
    } else {
      var yk = value ? (y0 * valueRight + y1 * valueLeft) / value : y1;
      partition(i, k, valueLeft, x0, y0, x1, yk);
      partition(k, j, valueRight, x0, yk, x1, y1);
    }
  }
}

function treemapSliceDice (parent, x0, y0, x1, y1) {
  (parent.depth & 1 ? treemapSlice : treemapDice)(parent, x0, y0, x1, y1);
}

var treemapResquarify = (function custom(ratio) {
  function resquarify(parent, x0, y0, x1, y1) {
    if ((rows = parent._squarify) && rows.ratio === ratio) {
      var rows,
        row,
        nodes,
        i,
        j = -1,
        n,
        m = rows.length,
        value = parent.value;
      while (++j < m) {
        row = rows[j], nodes = row.children;
        for (i = row.value = 0, n = nodes.length; i < n; ++i) row.value += nodes[i].value;
        if (row.dice) treemapDice(row, x0, y0, x1, value ? y0 += (y1 - y0) * row.value / value : y1);else treemapSlice(row, x0, y0, value ? x0 += (x1 - x0) * row.value / value : x1, y1);
        value -= row.value;
      }
    } else {
      parent._squarify = rows = squarifyRatio(ratio, parent, x0, y0, x1, y1);
      rows.ratio = ratio;
    }
  }
  resquarify.ratio = function (x) {
    return custom((x = +x) > 1 ? x : 1);
  };
  return resquarify;
})(phi);

// Build lookup table mapping tuple keys to tree node instances
function lookup$2(tree, key, filter) {
  const map = {};
  tree.each(node => {
    const t = node.data;
    if (filter(t)) map[key(t)] = node;
  });
  tree.lookup = map;
  return tree;
}

/**
 * Nest tuples into a tree structure, grouped by key values.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {Array<function(object): *>} params.keys - The key fields to nest by, in order.
 * @param {boolean} [params.generate=false] - A boolean flag indicating if
 *   non-leaf nodes generated by this transform should be included in the
 *   output. The default (false) includes only the input data (leaf nodes)
 *   in the data stream.
 */
function Nest(params) {
  Transform.call(this, null, params);
}
Nest.Definition = {
  'type': 'Nest',
  'metadata': {
    'treesource': true,
    'changes': true
  },
  'params': [{
    'name': 'keys',
    'type': 'field',
    'array': true
  }, {
    'name': 'generate',
    'type': 'boolean'
  }]
};
const children$1 = n => n.values;
inherits(Nest, Transform, {
  transform(_, pulse) {
    if (!pulse.source) {
      error('Nest transform requires an upstream data source.');
    }
    var gen = _.generate,
      mod = _.modified(),
      out = pulse.clone(),
      tree = this.value;
    if (!tree || mod || pulse.changed()) {
      // collect nodes to remove
      if (tree) {
        tree.each(node => {
          if (node.children && isTuple(node.data)) {
            out.rem.push(node.data);
          }
        });
      }

      // generate new tree structure
      this.value = tree = hierarchy({
        values: array$5(_.keys).reduce((n, k) => {
          n.key(k);
          return n;
        }, nest()).entries(out.source)
      }, children$1);

      // collect nodes to add
      if (gen) {
        tree.each(node => {
          if (node.children) {
            node = ingest$1(node.data);
            out.add.push(node);
            out.source.push(node);
          }
        });
      }

      // build lookup table
      lookup$2(tree, tupleid, tupleid);
    }
    out.source.root = tree;
    return out;
  }
});
function nest() {
  const keys = [],
    nest = {
      entries: array => entries(apply(array, 0), 0),
      key: d => (keys.push(d), nest)
    };
  function apply(array, depth) {
    if (depth >= keys.length) {
      return array;
    }
    const n = array.length,
      key = keys[depth++],
      valuesByKey = {},
      result = {};
    let i = -1,
      keyValue,
      value,
      values;
    while (++i < n) {
      keyValue = key(value = array[i]) + '';
      if (values = valuesByKey[keyValue]) {
        values.push(value);
      } else {
        valuesByKey[keyValue] = [value];
      }
    }
    for (keyValue in valuesByKey) {
      result[keyValue] = apply(valuesByKey[keyValue], depth);
    }
    return result;
  }
  function entries(map, depth) {
    if (++depth > keys.length) return map;
    const array = [];
    for (const key in map) {
      array.push({
        key,
        values: entries(map[key], depth)
      });
    }
    return array;
  }
  return nest;
}

/**
 * Abstract class for tree layout.
 * @constructor
 * @param {object} params - The parameters for this operator.
 */
function HierarchyLayout(params) {
  Transform.call(this, null, params);
}
const defaultSeparation = (a, b) => a.parent === b.parent ? 1 : 2;
inherits(HierarchyLayout, Transform, {
  transform(_, pulse) {
    if (!pulse.source || !pulse.source.root) {
      error(this.constructor.name + ' transform requires a backing tree data source.');
    }
    const layout = this.layout(_.method),
      fields = this.fields,
      root = pulse.source.root,
      as = _.as || fields;
    if (_.field) root.sum(_.field);else root.count();
    if (_.sort) root.sort(stableCompare(_.sort, d => d.data));
    setParams(layout, this.params, _);
    if (layout.separation) {
      layout.separation(_.separation !== false ? defaultSeparation : one$2);
    }
    try {
      this.value = layout(root);
    } catch (err) {
      error(err);
    }
    root.each(node => setFields(node, fields, as));
    return pulse.reflow(_.modified()).modifies(as).modifies('leaf');
  }
});
function setParams(layout, params, _) {
  for (let p, i = 0, n = params.length; i < n; ++i) {
    p = params[i];
    if (p in _) layout[p](_[p]);
  }
}
function setFields(node, fields, as) {
  const t = node.data,
    n = fields.length - 1;
  for (let i = 0; i < n; ++i) {
    t[as[i]] = node[fields[i]];
  }
  t[as[n]] = node.children ? node.children.length : 0;
}
const Output$3 = ['x', 'y', 'r', 'depth', 'children'];

/**
 * Packed circle tree layout.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {function(object): *} params.field - The value field to size nodes.
 */
function Pack(params) {
  HierarchyLayout.call(this, params);
}
Pack.Definition = {
  'type': 'Pack',
  'metadata': {
    'tree': true,
    'modifies': true
  },
  'params': [{
    'name': 'field',
    'type': 'field'
  }, {
    'name': 'sort',
    'type': 'compare'
  }, {
    'name': 'padding',
    'type': 'number',
    'default': 0
  }, {
    'name': 'radius',
    'type': 'field',
    'default': null
  }, {
    'name': 'size',
    'type': 'number',
    'array': true,
    'length': 2
  }, {
    'name': 'as',
    'type': 'string',
    'array': true,
    'length': Output$3.length,
    'default': Output$3
  }]
};
inherits(Pack, HierarchyLayout, {
  layout: pack,
  params: ['radius', 'size', 'padding'],
  fields: Output$3
});
const Output$2 = ['x0', 'y0', 'x1', 'y1', 'depth', 'children'];

/**
 * Partition tree layout.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {function(object): *} params.field - The value field to size nodes.
 */
function Partition(params) {
  HierarchyLayout.call(this, params);
}
Partition.Definition = {
  'type': 'Partition',
  'metadata': {
    'tree': true,
    'modifies': true
  },
  'params': [{
    'name': 'field',
    'type': 'field'
  }, {
    'name': 'sort',
    'type': 'compare'
  }, {
    'name': 'padding',
    'type': 'number',
    'default': 0
  }, {
    'name': 'round',
    'type': 'boolean',
    'default': false
  }, {
    'name': 'size',
    'type': 'number',
    'array': true,
    'length': 2
  }, {
    'name': 'as',
    'type': 'string',
    'array': true,
    'length': Output$2.length,
    'default': Output$2
  }]
};
inherits(Partition, HierarchyLayout, {
  layout: partition$1,
  params: ['size', 'round', 'padding'],
  fields: Output$2
});

/**
 * Stratify a collection of tuples into a tree structure based on
 * id and parent id fields.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {function(object): *} params.key - Unique key field for each tuple.
 * @param {function(object): *} params.parentKey - Field with key for parent tuple.
 */
function Stratify(params) {
  Transform.call(this, null, params);
}
Stratify.Definition = {
  'type': 'Stratify',
  'metadata': {
    'treesource': true
  },
  'params': [{
    'name': 'key',
    'type': 'field',
    'required': true
  }, {
    'name': 'parentKey',
    'type': 'field',
    'required': true
  }]
};
inherits(Stratify, Transform, {
  transform(_, pulse) {
    if (!pulse.source) {
      error('Stratify transform requires an upstream data source.');
    }
    let tree = this.value;
    const mod = _.modified(),
      out = pulse.fork(pulse.ALL).materialize(pulse.SOURCE),
      run = !tree || mod || pulse.changed(pulse.ADD_REM) || pulse.modified(_.key.fields) || pulse.modified(_.parentKey.fields);

    // prevent upstream source pollution
    out.source = out.source.slice();
    if (run) {
      tree = out.source.length ? lookup$2(stratify().id(_.key).parentId(_.parentKey)(out.source), _.key, truthy) : lookup$2(stratify()([{}]), _.key, _.key);
    }
    out.source.root = this.value = tree;
    return out;
  }
});
const Layouts = {
  tidy: tree$1,
  cluster: cluster
};
const Output$1$1 = ['x', 'y', 'depth', 'children'];

/**
 * Tree layout. Depending on the method parameter, performs either
 * Reingold-Tilford 'tidy' layout or dendrogram 'cluster' layout.
 * @constructor
 * @param {object} params - The parameters for this operator.
 */
function Tree(params) {
  HierarchyLayout.call(this, params);
}
Tree.Definition = {
  'type': 'Tree',
  'metadata': {
    'tree': true,
    'modifies': true
  },
  'params': [{
    'name': 'field',
    'type': 'field'
  }, {
    'name': 'sort',
    'type': 'compare'
  }, {
    'name': 'method',
    'type': 'enum',
    'default': 'tidy',
    'values': ['tidy', 'cluster']
  }, {
    'name': 'size',
    'type': 'number',
    'array': true,
    'length': 2
  }, {
    'name': 'nodeSize',
    'type': 'number',
    'array': true,
    'length': 2
  }, {
    'name': 'separation',
    'type': 'boolean',
    'default': true
  }, {
    'name': 'as',
    'type': 'string',
    'array': true,
    'length': Output$1$1.length,
    'default': Output$1$1
  }]
};
inherits(Tree, HierarchyLayout, {
  /**
   * Tree layout generator. Supports both 'tidy' and 'cluster' layouts.
   */
  layout(method) {
    const m = method || 'tidy';
    if (has$1(Layouts, m)) return Layouts[m]();else error('Unrecognized Tree layout method: ' + m);
  },
  params: ['size', 'nodeSize'],
  fields: Output$1$1
});

/**
 * Generate tuples representing links between tree nodes.
 * The resulting tuples will contain 'source' and 'target' fields,
 * which point to parent and child node tuples, respectively.
 * @constructor
 * @param {object} params - The parameters for this operator.
 */
function TreeLinks(params) {
  Transform.call(this, [], params);
}
TreeLinks.Definition = {
  'type': 'TreeLinks',
  'metadata': {
    'tree': true,
    'generates': true,
    'changes': true
  },
  'params': []
};
inherits(TreeLinks, Transform, {
  transform(_, pulse) {
    const links = this.value,
      tree = pulse.source && pulse.source.root,
      out = pulse.fork(pulse.NO_SOURCE),
      lut = {};
    if (!tree) error('TreeLinks transform requires a tree data source.');
    if (pulse.changed(pulse.ADD_REM)) {
      // remove previous links
      out.rem = links;

      // build lookup table of valid tuples
      pulse.visit(pulse.SOURCE, t => lut[tupleid(t)] = 1);

      // generate links for all edges incident on valid tuples
      tree.each(node => {
        const t = node.data,
          p = node.parent && node.parent.data;
        if (p && lut[tupleid(t)] && lut[tupleid(p)]) {
          out.add.push(ingest$1({
            source: p,
            target: t
          }));
        }
      });
      this.value = out.add;
    } else if (pulse.changed(pulse.MOD)) {
      // build lookup table of modified tuples
      pulse.visit(pulse.MOD, t => lut[tupleid(t)] = 1);

      // gather links incident on modified tuples
      links.forEach(link => {
        if (lut[tupleid(link.source)] || lut[tupleid(link.target)]) {
          out.mod.push(link);
        }
      });
    }
    return out;
  }
});
const Tiles = {
  binary: treemapBinary,
  dice: treemapDice,
  slice: treemapSlice,
  slicedice: treemapSliceDice,
  squarify: treemapSquarify,
  resquarify: treemapResquarify
};
const Output$4 = ['x0', 'y0', 'x1', 'y1', 'depth', 'children'];

/**
 * Treemap layout.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {function(object): *} params.field - The value field to size nodes.
 */
function Treemap(params) {
  HierarchyLayout.call(this, params);
}
Treemap.Definition = {
  'type': 'Treemap',
  'metadata': {
    'tree': true,
    'modifies': true
  },
  'params': [{
    'name': 'field',
    'type': 'field'
  }, {
    'name': 'sort',
    'type': 'compare'
  }, {
    'name': 'method',
    'type': 'enum',
    'default': 'squarify',
    'values': ['squarify', 'resquarify', 'binary', 'dice', 'slice', 'slicedice']
  }, {
    'name': 'padding',
    'type': 'number',
    'default': 0
  }, {
    'name': 'paddingInner',
    'type': 'number',
    'default': 0
  }, {
    'name': 'paddingOuter',
    'type': 'number',
    'default': 0
  }, {
    'name': 'paddingTop',
    'type': 'number',
    'default': 0
  }, {
    'name': 'paddingRight',
    'type': 'number',
    'default': 0
  }, {
    'name': 'paddingBottom',
    'type': 'number',
    'default': 0
  }, {
    'name': 'paddingLeft',
    'type': 'number',
    'default': 0
  }, {
    'name': 'ratio',
    'type': 'number',
    'default': 1.618033988749895
  }, {
    'name': 'round',
    'type': 'boolean',
    'default': false
  }, {
    'name': 'size',
    'type': 'number',
    'array': true,
    'length': 2
  }, {
    'name': 'as',
    'type': 'string',
    'array': true,
    'length': Output$4.length,
    'default': Output$4
  }]
};
inherits(Treemap, HierarchyLayout, {
  /**
   * Treemap layout generator. Adds 'method' and 'ratio' parameters
   * to configure the underlying tile method.
   */
  layout() {
    const x = treemap();
    x.ratio = _ => {
      const t = x.tile();
      if (t.ratio) x.tile(t.ratio(_));
    };
    x.method = _ => {
      if (has$1(Tiles, _)) x.tile(Tiles[_]);else error('Unrecognized Treemap layout method: ' + _);
    };
    return x;
  },
  params: ['method', 'ratio', 'size', 'round', 'padding', 'paddingInner', 'paddingOuter', 'paddingTop', 'paddingRight', 'paddingBottom', 'paddingLeft'],
  fields: Output$4
});

var tree = /*#__PURE__*/Object.freeze({
    __proto__: null,
    nest: Nest,
    pack: Pack,
    partition: Partition,
    stratify: Stratify,
    tree: Tree,
    treelinks: TreeLinks,
    treemap: Treemap
});

// bit mask for getting first 2 bytes of alpha value
const ALPHA_MASK = 0xff000000;
function baseBitmaps($, data) {
  const bitmap = $.bitmap();
  // when there is no base mark but data points are to be avoided
  (data || []).forEach(d => bitmap.set($(d.boundary[0]), $(d.boundary[3])));
  return [bitmap, undefined];
}
function markBitmaps($, baseMark, avoidMarks, labelInside, isGroupArea) {
  // create canvas
  const width = $.width,
    height = $.height,
    border = labelInside || isGroupArea,
    context = domCanvas(width, height).getContext('2d'),
    baseMarkContext = domCanvas(width, height).getContext('2d'),
    strokeContext = border && domCanvas(width, height).getContext('2d');

  // render all marks to be avoided into canvas
  avoidMarks.forEach(items => draw(context, items, false));
  draw(baseMarkContext, baseMark, false);
  if (border) {
    draw(strokeContext, baseMark, true);
  }

  // get canvas buffer, create bitmaps
  const buffer = getBuffer(context, width, height),
    baseMarkBuffer = getBuffer(baseMarkContext, width, height),
    strokeBuffer = border && getBuffer(strokeContext, width, height),
    layer1 = $.bitmap(),
    layer2 = border && $.bitmap();

  // populate bitmap layers
  let x, y, u, v, index, alpha, strokeAlpha, baseMarkAlpha;
  for (y = 0; y < height; ++y) {
    for (x = 0; x < width; ++x) {
      index = y * width + x;
      alpha = buffer[index] & ALPHA_MASK;
      baseMarkAlpha = baseMarkBuffer[index] & ALPHA_MASK;
      strokeAlpha = border && strokeBuffer[index] & ALPHA_MASK;
      if (alpha || strokeAlpha || baseMarkAlpha) {
        u = $(x);
        v = $(y);
        if (!isGroupArea && (alpha || baseMarkAlpha)) layer1.set(u, v); // update interior bitmap
        if (border && (alpha || strokeAlpha)) layer2.set(u, v); // update border bitmap
      }
    }
  }
  return [layer1, layer2];
}
function getBuffer(context, width, height) {
  return new Uint32Array(context.getImageData(0, 0, width, height).data.buffer);
}
function draw(context, items, interior) {
  if (!items.length) return;
  const type = items[0].mark.marktype;
  if (type === 'group') {
    items.forEach(group => {
      group.items.forEach(mark => draw(context, mark.items, interior));
    });
  } else {
    Marks[type].draw(context, {
      items: interior ? items.map(prepare) : items
    });
  }
}

/**
 * Prepare item before drawing into canvas (setting stroke and opacity)
 * @param {object} source item to be prepared
 * @returns prepared item
 */
function prepare(source) {
  const item = rederive(source, {});
  if (item.stroke && item.strokeOpacity !== 0 || item.fill && item.fillOpacity !== 0) {
    return {
      ...item,
      strokeOpacity: 1,
      stroke: '#000',
      fillOpacity: 0
    };
  }
  return item;
}
const DIV = 5,
  // bit shift from x, y index to bit vector array index
  MOD = 31,
  // bit mask for index lookup within a bit vector
  SIZE = 32,
  // individual bit vector size
  RIGHT0 = new Uint32Array(SIZE + 1),
  // left-anchored bit vectors, full -> 0
  RIGHT1 = new Uint32Array(SIZE + 1); // right-anchored bit vectors, 0 -> full

RIGHT1[0] = 0;
RIGHT0[0] = ~RIGHT1[0];
for (let i = 1; i <= SIZE; ++i) {
  RIGHT1[i] = RIGHT1[i - 1] << 1 | 1;
  RIGHT0[i] = ~RIGHT1[i];
}
function Bitmap(w, h) {
  const array = new Uint32Array(~~((w * h + SIZE) / SIZE));
  function _set(index, mask) {
    array[index] |= mask;
  }
  function _clear(index, mask) {
    array[index] &= mask;
  }
  return {
    array: array,
    get: (x, y) => {
      const index = y * w + x;
      return array[index >>> DIV] & 1 << (index & MOD);
    },
    set: (x, y) => {
      const index = y * w + x;
      _set(index >>> DIV, 1 << (index & MOD));
    },
    clear: (x, y) => {
      const index = y * w + x;
      _clear(index >>> DIV, ~(1 << (index & MOD)));
    },
    getRange: (x, y, x2, y2) => {
      let r = y2,
        start,
        end,
        indexStart,
        indexEnd;
      for (; r >= y; --r) {
        start = r * w + x;
        end = r * w + x2;
        indexStart = start >>> DIV;
        indexEnd = end >>> DIV;
        if (indexStart === indexEnd) {
          if (array[indexStart] & RIGHT0[start & MOD] & RIGHT1[(end & MOD) + 1]) {
            return true;
          }
        } else {
          if (array[indexStart] & RIGHT0[start & MOD]) return true;
          if (array[indexEnd] & RIGHT1[(end & MOD) + 1]) return true;
          for (let i = indexStart + 1; i < indexEnd; ++i) {
            if (array[i]) return true;
          }
        }
      }
      return false;
    },
    setRange: (x, y, x2, y2) => {
      let start, end, indexStart, indexEnd, i;
      for (; y <= y2; ++y) {
        start = y * w + x;
        end = y * w + x2;
        indexStart = start >>> DIV;
        indexEnd = end >>> DIV;
        if (indexStart === indexEnd) {
          _set(indexStart, RIGHT0[start & MOD] & RIGHT1[(end & MOD) + 1]);
        } else {
          _set(indexStart, RIGHT0[start & MOD]);
          _set(indexEnd, RIGHT1[(end & MOD) + 1]);
          for (i = indexStart + 1; i < indexEnd; ++i) _set(i, 0xffffffff);
        }
      }
    },
    clearRange: (x, y, x2, y2) => {
      let start, end, indexStart, indexEnd, i;
      for (; y <= y2; ++y) {
        start = y * w + x;
        end = y * w + x2;
        indexStart = start >>> DIV;
        indexEnd = end >>> DIV;
        if (indexStart === indexEnd) {
          _clear(indexStart, RIGHT1[start & MOD] | RIGHT0[(end & MOD) + 1]);
        } else {
          _clear(indexStart, RIGHT1[start & MOD]);
          _clear(indexEnd, RIGHT0[(end & MOD) + 1]);
          for (i = indexStart + 1; i < indexEnd; ++i) _clear(i, 0);
        }
      }
    },
    outOfBounds: (x, y, x2, y2) => x < 0 || y < 0 || y2 >= h || x2 >= w
  };
}
function scaler(width, height, padding) {
  const ratio = Math.max(1, Math.sqrt(width * height / 1e6)),
    w = ~~((width + 2 * padding + ratio) / ratio),
    h = ~~((height + 2 * padding + ratio) / ratio),
    scale = _ => ~~((_ + padding) / ratio);
  scale.invert = _ => _ * ratio - padding;
  scale.bitmap = () => Bitmap(w, h);
  scale.ratio = ratio;
  scale.padding = padding;
  scale.width = width;
  scale.height = height;
  return scale;
}
function placeAreaLabelNaive($, bitmaps, avoidBaseMark, markIndex) {
  const width = $.width,
    height = $.height;

  // try to place a label within an input area mark
  return function (d) {
    const items = d.datum.datum.items[markIndex].items,
      // area points
      n = items.length,
      // number of points
      textHeight = d.datum.fontSize,
      // label width
      textWidth = textMetrics.width(d.datum, d.datum.text); // label height

    let maxAreaWidth = 0,
      x1,
      x2,
      y1,
      y2,
      x,
      y,
      areaWidth;

    // for each area sample point
    for (let i = 0; i < n; ++i) {
      x1 = items[i].x;
      y1 = items[i].y;
      x2 = items[i].x2 === undefined ? x1 : items[i].x2;
      y2 = items[i].y2 === undefined ? y1 : items[i].y2;
      x = (x1 + x2) / 2;
      y = (y1 + y2) / 2;
      areaWidth = Math.abs(x2 - x1 + y2 - y1);
      if (areaWidth >= maxAreaWidth) {
        maxAreaWidth = areaWidth;
        d.x = x;
        d.y = y;
      }
    }
    x = textWidth / 2;
    y = textHeight / 2;
    x1 = d.x - x;
    x2 = d.x + x;
    y1 = d.y - y;
    y2 = d.y + y;
    d.align = 'center';
    if (x1 < 0 && x2 <= width) {
      d.align = 'left';
    } else if (0 <= x1 && width < x2) {
      d.align = 'right';
    }
    d.baseline = 'middle';
    if (y1 < 0 && y2 <= height) {
      d.baseline = 'top';
    } else if (0 <= y1 && height < y2) {
      d.baseline = 'bottom';
    }
    return true;
  };
}
function outOfBounds(x, y, textWidth, textHeight, width, height) {
  let r = textWidth / 2;
  return x - r < 0 || x + r > width || y - (r = textHeight / 2) < 0 || y + r > height;
}
function collision($, x, y, textHeight, textWidth, h, bm0, bm1) {
  const w = textWidth * h / (textHeight * 2),
    x1 = $(x - w),
    x2 = $(x + w),
    y1 = $(y - (h = h / 2)),
    y2 = $(y + h);
  return bm0.outOfBounds(x1, y1, x2, y2) || bm0.getRange(x1, y1, x2, y2) || bm1 && bm1.getRange(x1, y1, x2, y2);
}
function placeAreaLabelReducedSearch($, bitmaps, avoidBaseMark, markIndex) {
  const width = $.width,
    height = $.height,
    bm0 = bitmaps[0],
    // where labels have been placed
    bm1 = bitmaps[1]; // area outlines

  function tryLabel(_x, _y, maxSize, textWidth, textHeight) {
    const x = $.invert(_x),
      y = $.invert(_y);
    let lo = maxSize,
      hi = height,
      mid;
    if (!outOfBounds(x, y, textWidth, textHeight, width, height) && !collision($, x, y, textHeight, textWidth, lo, bm0, bm1) && !collision($, x, y, textHeight, textWidth, textHeight, bm0, null)) {
      // if the label fits at the current sample point,
      // perform binary search to find the largest font size that fits
      while (hi - lo >= 1) {
        mid = (lo + hi) / 2;
        if (collision($, x, y, textHeight, textWidth, mid, bm0, bm1)) {
          hi = mid;
        } else {
          lo = mid;
        }
      }
      // place label if current lower bound exceeds prior max font size
      if (lo > maxSize) {
        return [x, y, lo, true];
      }
    }
  }

  // try to place a label within an input area mark
  return function (d) {
    const items = d.datum.datum.items[markIndex].items,
      // area points
      n = items.length,
      // number of points
      textHeight = d.datum.fontSize,
      // label width
      textWidth = textMetrics.width(d.datum, d.datum.text); // label height

    let maxSize = avoidBaseMark ? textHeight : 0,
      labelPlaced = false,
      labelPlaced2 = false,
      maxAreaWidth = 0,
      x1,
      x2,
      y1,
      y2,
      x,
      y,
      _x,
      _y,
      _x1,
      _xMid,
      _x2,
      _y1,
      _yMid,
      _y2,
      areaWidth,
      result,
      swapTmp;

    // for each area sample point
    for (let i = 0; i < n; ++i) {
      x1 = items[i].x;
      y1 = items[i].y;
      x2 = items[i].x2 === undefined ? x1 : items[i].x2;
      y2 = items[i].y2 === undefined ? y1 : items[i].y2;
      if (x1 > x2) {
        swapTmp = x1;
        x1 = x2;
        x2 = swapTmp;
      }
      if (y1 > y2) {
        swapTmp = y1;
        y1 = y2;
        y2 = swapTmp;
      }
      _x1 = $(x1);
      _x2 = $(x2);
      _xMid = ~~((_x1 + _x2) / 2);
      _y1 = $(y1);
      _y2 = $(y2);
      _yMid = ~~((_y1 + _y2) / 2);

      // search along the line from mid point between the 2 border to lower border
      for (_x = _xMid; _x >= _x1; --_x) {
        for (_y = _yMid; _y >= _y1; --_y) {
          result = tryLabel(_x, _y, maxSize, textWidth, textHeight);
          if (result) {
            [d.x, d.y, maxSize, labelPlaced] = result;
          }
        }
      }

      // search along the line from mid point between the 2 border to upper border
      for (_x = _xMid; _x <= _x2; ++_x) {
        for (_y = _yMid; _y <= _y2; ++_y) {
          result = tryLabel(_x, _y, maxSize, textWidth, textHeight);
          if (result) {
            [d.x, d.y, maxSize, labelPlaced] = result;
          }
        }
      }

      // place label at slice center if not placed through other means
      // and if we're not avoiding overlap with other areas
      if (!labelPlaced && !avoidBaseMark) {
        // one span is zero, hence we can add
        areaWidth = Math.abs(x2 - x1 + y2 - y1);
        x = (x1 + x2) / 2;
        y = (y1 + y2) / 2;

        // place label if it fits and improves the max area width
        if (areaWidth >= maxAreaWidth && !outOfBounds(x, y, textWidth, textHeight, width, height) && !collision($, x, y, textHeight, textWidth, textHeight, bm0, null)) {
          maxAreaWidth = areaWidth;
          d.x = x;
          d.y = y;
          labelPlaced2 = true;
        }
      }
    }

    // record current label placement information, update label bitmap
    if (labelPlaced || labelPlaced2) {
      x = textWidth / 2;
      y = textHeight / 2;
      bm0.setRange($(d.x - x), $(d.y - y), $(d.x + x), $(d.y + y));
      d.align = 'center';
      d.baseline = 'middle';
      return true;
    } else {
      return false;
    }
  };
}

// pixel direction offsets for flood fill search
const X_DIR = [-1, -1, 1, 1];
const Y_DIR = [-1, 1, -1, 1];
function placeAreaLabelFloodFill($, bitmaps, avoidBaseMark, markIndex) {
  const width = $.width,
    height = $.height,
    bm0 = bitmaps[0],
    // where labels have been placed
    bm1 = bitmaps[1],
    // area outlines
    bm2 = $.bitmap(); // flood-fill visitations

  // try to place a label within an input area mark
  return function (d) {
    const items = d.datum.datum.items[markIndex].items,
      // area points
      n = items.length,
      // number of points
      textHeight = d.datum.fontSize,
      // label width
      textWidth = textMetrics.width(d.datum, d.datum.text),
      // label height
      stack = []; // flood fill stack

    let maxSize = avoidBaseMark ? textHeight : 0,
      labelPlaced = false,
      labelPlaced2 = false,
      maxAreaWidth = 0,
      x1,
      x2,
      y1,
      y2,
      x,
      y,
      _x,
      _y,
      lo,
      hi,
      mid,
      areaWidth;

    // for each area sample point
    for (let i = 0; i < n; ++i) {
      x1 = items[i].x;
      y1 = items[i].y;
      x2 = items[i].x2 === undefined ? x1 : items[i].x2;
      y2 = items[i].y2 === undefined ? y1 : items[i].y2;

      // add scaled center point to stack
      stack.push([$((x1 + x2) / 2), $((y1 + y2) / 2)]);

      // perform flood fill, visit points
      while (stack.length) {
        [_x, _y] = stack.pop();

        // exit if point already marked
        if (bm0.get(_x, _y) || bm1.get(_x, _y) || bm2.get(_x, _y)) continue;

        // mark point in flood fill bitmap
        // add search points for all (in bound) directions
        bm2.set(_x, _y);
        for (let j = 0; j < 4; ++j) {
          x = _x + X_DIR[j];
          y = _y + Y_DIR[j];
          if (!bm2.outOfBounds(x, y, x, y)) stack.push([x, y]);
        }

        // unscale point back to x, y space
        x = $.invert(_x);
        y = $.invert(_y);
        lo = maxSize;
        hi = height; // TODO: make this bound smaller

        if (!outOfBounds(x, y, textWidth, textHeight, width, height) && !collision($, x, y, textHeight, textWidth, lo, bm0, bm1) && !collision($, x, y, textHeight, textWidth, textHeight, bm0, null)) {
          // if the label fits at the current sample point,
          // perform binary search to find the largest font size that fits
          while (hi - lo >= 1) {
            mid = (lo + hi) / 2;
            if (collision($, x, y, textHeight, textWidth, mid, bm0, bm1)) {
              hi = mid;
            } else {
              lo = mid;
            }
          }
          // place label if current lower bound exceeds prior max font size
          if (lo > maxSize) {
            d.x = x;
            d.y = y;
            maxSize = lo;
            labelPlaced = true;
          }
        }
      }

      // place label at slice center if not placed through other means
      // and if we're not avoiding overlap with other areas
      if (!labelPlaced && !avoidBaseMark) {
        // one span is zero, hence we can add
        areaWidth = Math.abs(x2 - x1 + y2 - y1);
        x = (x1 + x2) / 2;
        y = (y1 + y2) / 2;

        // place label if it fits and improves the max area width
        if (areaWidth >= maxAreaWidth && !outOfBounds(x, y, textWidth, textHeight, width, height) && !collision($, x, y, textHeight, textWidth, textHeight, bm0, null)) {
          maxAreaWidth = areaWidth;
          d.x = x;
          d.y = y;
          labelPlaced2 = true;
        }
      }
    }

    // record current label placement information, update label bitmap
    if (labelPlaced || labelPlaced2) {
      x = textWidth / 2;
      y = textHeight / 2;
      bm0.setRange($(d.x - x), $(d.y - y), $(d.x + x), $(d.y + y));
      d.align = 'center';
      d.baseline = 'middle';
      return true;
    } else {
      return false;
    }
  };
}
const Aligns = ['right', 'center', 'left'],
  Baselines = ['bottom', 'middle', 'top'];
function placeMarkLabel($, bitmaps, anchors, offsets) {
  const width = $.width,
    height = $.height,
    bm0 = bitmaps[0],
    bm1 = bitmaps[1],
    n = offsets.length;
  return function (d) {
    const boundary = d.boundary,
      textHeight = d.datum.fontSize;

    // can not be placed if the mark is not visible in the graph bound
    if (boundary[2] < 0 || boundary[5] < 0 || boundary[0] > width || boundary[3] > height) {
      return false;
    }
    let textWidth = d.textWidth ?? 0,
      dx,
      dy,
      isInside,
      sizeFactor,
      insideFactor,
      x1,
      x2,
      y1,
      y2,
      xc,
      yc,
      _x1,
      _x2,
      _y1,
      _y2;

    // for each anchor and offset
    for (let i = 0; i < n; ++i) {
      dx = (anchors[i] & 0x3) - 1;
      dy = (anchors[i] >>> 0x2 & 0x3) - 1;
      isInside = dx === 0 && dy === 0 || offsets[i] < 0;
      sizeFactor = dx && dy ? Math.SQRT1_2 : 1;
      insideFactor = offsets[i] < 0 ? -1 : 1;
      x1 = boundary[1 + dx] + offsets[i] * dx * sizeFactor;
      yc = boundary[4 + dy] + insideFactor * textHeight * dy / 2 + offsets[i] * dy * sizeFactor;
      y1 = yc - textHeight / 2;
      y2 = yc + textHeight / 2;
      _x1 = $(x1);
      _y1 = $(y1);
      _y2 = $(y2);
      if (!textWidth) {
        // to avoid finding width of text label,
        if (!test(_x1, _x1, _y1, _y2, bm0, bm1, x1, x1, y1, y2, boundary, isInside)) {
          // skip this anchor/offset option if we fail to place a label with 1px width
          continue;
        } else {
          // Otherwise, find the label width
          textWidth = textMetrics.width(d.datum, d.datum.text);
        }
      }
      xc = x1 + insideFactor * textWidth * dx / 2;
      x1 = xc - textWidth / 2;
      x2 = xc + textWidth / 2;
      _x1 = $(x1);
      _x2 = $(x2);
      if (test(_x1, _x2, _y1, _y2, bm0, bm1, x1, x2, y1, y2, boundary, isInside)) {
        // place label if the position is placeable
        d.x = !dx ? xc : dx * insideFactor < 0 ? x2 : x1;
        d.y = !dy ? yc : dy * insideFactor < 0 ? y2 : y1;
        d.align = Aligns[dx * insideFactor + 1];
        d.baseline = Baselines[dy * insideFactor + 1];
        bm0.setRange(_x1, _y1, _x2, _y2);
        return true;
      }
    }
    return false;
  };
}

// Test if a label with the given dimensions can be added without overlap
function test(_x1, _x2, _y1, _y2, bm0, bm1, x1, x2, y1, y2, boundary, isInside) {
  return !(bm0.outOfBounds(_x1, _y1, _x2, _y2) || (isInside && bm1 || bm0).getRange(_x1, _y1, _x2, _y2));
}

// 8-bit representation of anchors
const TOP = 0x0,
  MIDDLE = 0x4,
  BOTTOM = 0x8,
  LEFT = 0x0,
  CENTER = 0x1,
  RIGHT = 0x2;

// Mapping from text anchor to number representation
const anchorCode = {
  'top-left': TOP + LEFT,
  'top': TOP + CENTER,
  'top-right': TOP + RIGHT,
  'left': MIDDLE + LEFT,
  'middle': MIDDLE + CENTER,
  'right': MIDDLE + RIGHT,
  'bottom-left': BOTTOM + LEFT,
  'bottom': BOTTOM + CENTER,
  'bottom-right': BOTTOM + RIGHT
};
const placeAreaLabel = {
  'naive': placeAreaLabelNaive,
  'reduced-search': placeAreaLabelReducedSearch,
  'floodfill': placeAreaLabelFloodFill
};
function labelLayout(texts, size, compare, offset, anchor, avoidMarks, avoidBaseMark, lineAnchor, markIndex, padding, method) {
  // early exit for empty data
  if (!texts.length) return texts;
  const positions = Math.max(offset.length, anchor.length),
    offsets = getOffsets(offset, positions),
    anchors = getAnchors(anchor, positions),
    marktype = markType(texts[0].datum),
    grouptype = marktype === 'group' && texts[0].datum.items[markIndex].marktype,
    isGroupArea = grouptype === 'area',
    boundary = markBoundary(marktype, grouptype, lineAnchor, markIndex),
    infPadding = padding === null || padding === Infinity,
    isNaiveGroupArea = isGroupArea && method === 'naive';
  let maxTextWidth = -1,
    maxTextHeight = -1;

  // prepare text mark data for placing
  const data = texts.map(d => {
    const textWidth = infPadding ? textMetrics.width(d, d.text) : undefined;
    maxTextWidth = Math.max(maxTextWidth, textWidth);
    maxTextHeight = Math.max(maxTextHeight, d.fontSize);
    return {
      datum: d,
      opacity: 0,
      x: undefined,
      y: undefined,
      align: undefined,
      baseline: undefined,
      boundary: boundary(d),
      textWidth
    };
  });
  padding = padding === null || padding === Infinity ? Math.max(maxTextWidth, maxTextHeight) + Math.max(...offset) : padding;
  const $ = scaler(size[0], size[1], padding);
  let bitmaps;
  if (!isNaiveGroupArea) {
    // sort labels in priority order, if comparator is provided
    if (compare) {
      data.sort((a, b) => compare(a.datum, b.datum));
    }

    // flag indicating if label can be placed inside its base mark
    let labelInside = false;
    for (let i = 0; i < anchors.length && !labelInside; ++i) {
      // label inside if anchor is at center
      // label inside if offset to be inside the mark bound
      labelInside = anchors[i] === 0x5 || offsets[i] < 0;
    }

    // extract data information from base mark when base mark is to be avoided
    // base mark is implicitly avoided if it is a group area
    const baseMark = (marktype && avoidBaseMark || isGroupArea) && texts.map(d => d.datum);

    // generate bitmaps for layout calculation
    bitmaps = avoidMarks.length || baseMark ? markBitmaps($, baseMark || [], avoidMarks, labelInside, isGroupArea) : baseBitmaps($, avoidBaseMark && data);
  }

  // generate label placement function
  const place = isGroupArea ? placeAreaLabel[method]($, bitmaps, avoidBaseMark, markIndex) : placeMarkLabel($, bitmaps, anchors, offsets);

  // place all labels
  data.forEach(d => d.opacity = +place(d));
  return data;
}
function getOffsets(_, count) {
  const offsets = new Float64Array(count),
    n = _.length;
  for (let i = 0; i < n; ++i) offsets[i] = _[i] || 0;
  for (let i = n; i < count; ++i) offsets[i] = offsets[n - 1];
  return offsets;
}
function getAnchors(_, count) {
  const anchors = new Int8Array(count),
    n = _.length;
  for (let i = 0; i < n; ++i) anchors[i] |= anchorCode[_[i]];
  for (let i = n; i < count; ++i) anchors[i] = anchors[n - 1];
  return anchors;
}
function markType(item) {
  return item && item.mark && item.mark.marktype;
}

/**
 * Factory function for function for getting base mark boundary, depending
 * on mark and group type. When mark type is undefined, line or area: boundary
 * is the coordinate of each data point. When base mark is grouped line,
 * boundary is either at the start or end of the line depending on the
 * value of lineAnchor. Otherwise, use bounds of base mark.
 */
function markBoundary(marktype, grouptype, lineAnchor, markIndex) {
  const xy = d => [d.x, d.x, d.x, d.y, d.y, d.y];
  if (!marktype) {
    return xy; // no reactive geometry
  } else if (marktype === 'line' || marktype === 'area') {
    return d => xy(d.datum);
  } else if (grouptype === 'line') {
    return d => {
      const items = d.datum.items[markIndex].items;
      return xy(items.length ? items[lineAnchor === 'start' ? 0 : items.length - 1] : {
        x: NaN,
        y: NaN
      });
    };
  } else {
    return d => {
      const b = d.datum.bounds;
      return [b.x1, (b.x1 + b.x2) / 2, b.x2, b.y1, (b.y1 + b.y2) / 2, b.y2];
    };
  }
}
const Output$1 = ['x', 'y', 'opacity', 'align', 'baseline'];
const Anchors = ['top-left', 'left', 'bottom-left', 'top', 'bottom', 'top-right', 'right', 'bottom-right'];

/**
 * Compute text label layout to annotate marks.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {Array<number>} params.size - The size of the layout, provided as a [width, height] array.
 * @param {function(*,*): number} [params.sort] - An optional
 *   comparator function for sorting label data in priority order.
 * @param {Array<string>} [params.anchor] - Label anchor points relative to the base mark bounding box.
 *   The available options are 'top-left', 'left', 'bottom-left', 'top',
 *   'bottom', 'top-right', 'right', 'bottom-right', 'middle'.
 * @param {Array<number>} [params.offset] - Label offsets (in pixels) from the base mark bounding box.
 *   This parameter is parallel to the list of anchor points.
 * @param {number | null} [params.padding=0] - The amount (in pixels) that a label may exceed the layout size.
 *   If this parameter is null, a label may exceed the layout size without any boundary.
 * @param {string} [params.lineAnchor='end'] - For group line mark labels only, indicates the anchor
 *   position for labels. One of 'start' or 'end'.
 * @param {string} [params.markIndex=0] - For group mark labels only, an index indicating
 *   which mark within the group should be labeled.
 * @param {Array<number>} [params.avoidMarks] - A list of additional mark names for which the label
 *   layout should avoid overlap.
 * @param {boolean} [params.avoidBaseMark=true] - Boolean flag indicating if labels should avoid
 *   overlap with the underlying base mark being labeled.
 * @param {string} [params.method='naive'] - For area make labels only, a method for
 *   place labels. One of 'naive', 'reduced-search', or 'floodfill'.
 * @param {Array<string>} [params.as] - The output fields written by the transform.
 *   The default is ['x', 'y', 'opacity', 'align', 'baseline'].
 */
function Label$1(params) {
  Transform.call(this, null, params);
}
Label$1.Definition = {
  type: 'Label',
  metadata: {
    modifies: true
  },
  params: [{
    name: 'size',
    type: 'number',
    array: true,
    length: 2,
    required: true
  }, {
    name: 'sort',
    type: 'compare'
  }, {
    name: 'anchor',
    type: 'string',
    array: true,
    default: Anchors
  }, {
    name: 'offset',
    type: 'number',
    array: true,
    default: [1]
  }, {
    name: 'padding',
    type: 'number',
    default: 0,
    null: true
  }, {
    name: 'lineAnchor',
    type: 'string',
    values: ['start', 'end'],
    default: 'end'
  }, {
    name: 'markIndex',
    type: 'number',
    default: 0
  }, {
    name: 'avoidBaseMark',
    type: 'boolean',
    default: true
  }, {
    name: 'avoidMarks',
    type: 'data',
    array: true
  }, {
    name: 'method',
    type: 'string',
    default: 'naive'
  }, {
    name: 'as',
    type: 'string',
    array: true,
    length: Output$1.length,
    default: Output$1
  }]
};
inherits(Label$1, Transform, {
  transform(_, pulse) {
    function modp(param) {
      const p = _[param];
      return isFunction(p) && pulse.modified(p.fields);
    }
    const mod = _.modified();
    if (!(mod || pulse.changed(pulse.ADD_REM) || modp('sort'))) return;
    if (!_.size || _.size.length !== 2) {
      error('Size parameter should be specified as a [width, height] array.');
    }
    const as = _.as || Output$1;

    // run label layout
    labelLayout(pulse.materialize(pulse.SOURCE).source || [], _.size, _.sort, array$5(_.offset == null ? 1 : _.offset), array$5(_.anchor || Anchors), _.avoidMarks || [], _.avoidBaseMark !== false, _.lineAnchor || 'end', _.markIndex || 0, _.padding === undefined ? 0 : _.padding, _.method || 'naive').forEach(l => {
      // write layout results to data stream
      const t = l.datum;
      t[as[0]] = l.x;
      t[as[1]] = l.y;
      t[as[2]] = l.opacity;
      t[as[3]] = l.align;
      t[as[4]] = l.baseline;
    });
    return pulse.reflow(mod).modifies(as);
  }
});

var label = /*#__PURE__*/Object.freeze({
    __proto__: null,
    label: Label$1
});

function partition(data, groupby) {
  var groups = [],
    get = function (f) {
      return f(t);
    },
    map,
    i,
    n,
    t,
    k,
    g;

  // partition data points into stack groups
  if (groupby == null) {
    groups.push(data);
  } else {
    for (map = {}, i = 0, n = data.length; i < n; ++i) {
      t = data[i];
      k = groupby.map(get);
      g = map[k];
      if (!g) {
        map[k] = g = [];
        g.dims = k;
        groups.push(g);
      }
      g.push(t);
    }
  }
  return groups;
}

/**
 * Compute locally-weighted regression fits for one or more data groups.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {function(object): *} params.x - An accessor for the predictor data field.
 * @param {function(object): *} params.y - An accessor for the predicted data field.
 * @param {Array<function(object): *>} [params.groupby] - An array of accessors to groupby.
 * @param {number} [params.bandwidth=0.3] - The loess bandwidth.
 */
function Loess(params) {
  Transform.call(this, null, params);
}
Loess.Definition = {
  'type': 'Loess',
  'metadata': {
    'generates': true
  },
  'params': [{
    'name': 'x',
    'type': 'field',
    'required': true
  }, {
    'name': 'y',
    'type': 'field',
    'required': true
  }, {
    'name': 'groupby',
    'type': 'field',
    'array': true
  }, {
    'name': 'bandwidth',
    'type': 'number',
    'default': 0.3
  }, {
    'name': 'as',
    'type': 'string',
    'array': true
  }]
};
inherits(Loess, Transform, {
  transform(_, pulse) {
    const out = pulse.fork(pulse.NO_SOURCE | pulse.NO_FIELDS);
    if (!this.value || pulse.changed() || _.modified()) {
      const source = pulse.materialize(pulse.SOURCE).source,
        groups = partition(source, _.groupby),
        names = (_.groupby || []).map(accessorName),
        m = names.length,
        as = _.as || [accessorName(_.x), accessorName(_.y)],
        values = [];
      groups.forEach(g => {
        loess(g, _.x, _.y, _.bandwidth || 0.3).forEach(p => {
          const t = {};
          for (let i = 0; i < m; ++i) {
            t[names[i]] = g.dims[i];
          }
          t[as[0]] = p[0];
          t[as[1]] = p[1];
          values.push(ingest$1(t));
        });
      });
      if (this.value) out.rem = this.value;
      this.value = out.add = out.source = values;
    }
    return out;
  }
});
const Methods = {
  constant: constant$4,
  linear: linear$2,
  log: log$3,
  exp: exp$1,
  pow: pow$3,
  quad: quad,
  poly: poly
};
const degreesOfFreedom = (method, order) => method === 'poly' ? order : method === 'quad' ? 2 : 1;

/**
 * Compute regression fits for one or more data groups.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {function(object): *} params.x - An accessor for the predictor data field.
 * @param {function(object): *} params.y - An accessor for the predicted data field.
 * @param {string} [params.method='linear'] - The regression method to apply.
 * @param {Array<function(object): *>} [params.groupby] - An array of accessors to groupby.
 * @param {Array<number>} [params.extent] - The domain extent over which to plot the regression line.
 * @param {number} [params.order=3] - The polynomial order. Only applies to the 'poly' method.
 */
function Regression(params) {
  Transform.call(this, null, params);
}
Regression.Definition = {
  'type': 'Regression',
  'metadata': {
    'generates': true
  },
  'params': [{
    'name': 'x',
    'type': 'field',
    'required': true
  }, {
    'name': 'y',
    'type': 'field',
    'required': true
  }, {
    'name': 'groupby',
    'type': 'field',
    'array': true
  }, {
    'name': 'method',
    'type': 'string',
    'default': 'linear',
    'values': Object.keys(Methods)
  }, {
    'name': 'order',
    'type': 'number',
    'default': 3
  }, {
    'name': 'extent',
    'type': 'number',
    'array': true,
    'length': 2
  }, {
    'name': 'params',
    'type': 'boolean',
    'default': false
  }, {
    'name': 'as',
    'type': 'string',
    'array': true
  }]
};
inherits(Regression, Transform, {
  transform(_, pulse) {
    const out = pulse.fork(pulse.NO_SOURCE | pulse.NO_FIELDS);
    if (!this.value || pulse.changed() || _.modified()) {
      const source = pulse.materialize(pulse.SOURCE).source,
        groups = partition(source, _.groupby),
        names = (_.groupby || []).map(accessorName),
        method = _.method || 'linear',
        order = _.order == null ? 3 : _.order,
        dof = degreesOfFreedom(method, order),
        as = _.as || [accessorName(_.x), accessorName(_.y)],
        fit = Methods[method],
        values = [];
      let domain = _.extent;
      if (!has$1(Methods, method)) {
        error('Invalid regression method: ' + method);
      }
      if (domain != null) {
        if (method === 'log' && domain[0] <= 0) {
          pulse.dataflow.warn('Ignoring extent with values <= 0 for log regression.');
          domain = null;
        }
      }
      groups.forEach(g => {
        const n = g.length;
        if (n <= dof) {
          pulse.dataflow.warn('Skipping regression with more parameters than data points.');
          return;
        }
        const model = fit(g, _.x, _.y, order);
        if (_.params) {
          // if parameter vectors requested return those
          values.push(ingest$1({
            keys: g.dims,
            coef: model.coef,
            rSquared: model.rSquared
          }));
          return;
        }
        const dom = domain || extent(g, _.x),
          add = p => {
            const t = {};
            for (let i = 0; i < names.length; ++i) {
              t[names[i]] = g.dims[i];
            }
            t[as[0]] = p[0];
            t[as[1]] = p[1];
            values.push(ingest$1(t));
          };
        if (method === 'linear' || method === 'constant') {
          // for linear or constant regression we only need the end points
          dom.forEach(x => add([x, model.predict(x)]));
        } else {
          // otherwise return trend line sample points
          sampleCurve(model.predict, dom, 25, 200).forEach(add);
        }
      });
      if (this.value) out.rem = this.value;
      this.value = out.add = out.source = values;
    }
    return out;
  }
});

var reg = /*#__PURE__*/Object.freeze({
    __proto__: null,
    loess: Loess,
    regression: Regression
});

const epsilon$1 = 1.1102230246251565e-16;
const splitter = 134217729;
const resulterrbound = (3 + 8 * epsilon$1) * epsilon$1;

// fast_expansion_sum_zeroelim routine from oritinal code
function sum(elen, e, flen, f, h) {
  let Q, Qnew, hh, bvirt;
  let enow = e[0];
  let fnow = f[0];
  let eindex = 0;
  let findex = 0;
  if (fnow > enow === fnow > -enow) {
    Q = enow;
    enow = e[++eindex];
  } else {
    Q = fnow;
    fnow = f[++findex];
  }
  let hindex = 0;
  if (eindex < elen && findex < flen) {
    if (fnow > enow === fnow > -enow) {
      Qnew = enow + Q;
      hh = Q - (Qnew - enow);
      enow = e[++eindex];
    } else {
      Qnew = fnow + Q;
      hh = Q - (Qnew - fnow);
      fnow = f[++findex];
    }
    Q = Qnew;
    if (hh !== 0) {
      h[hindex++] = hh;
    }
    while (eindex < elen && findex < flen) {
      if (fnow > enow === fnow > -enow) {
        Qnew = Q + enow;
        bvirt = Qnew - Q;
        hh = Q - (Qnew - bvirt) + (enow - bvirt);
        enow = e[++eindex];
      } else {
        Qnew = Q + fnow;
        bvirt = Qnew - Q;
        hh = Q - (Qnew - bvirt) + (fnow - bvirt);
        fnow = f[++findex];
      }
      Q = Qnew;
      if (hh !== 0) {
        h[hindex++] = hh;
      }
    }
  }
  while (eindex < elen) {
    Qnew = Q + enow;
    bvirt = Qnew - Q;
    hh = Q - (Qnew - bvirt) + (enow - bvirt);
    enow = e[++eindex];
    Q = Qnew;
    if (hh !== 0) {
      h[hindex++] = hh;
    }
  }
  while (findex < flen) {
    Qnew = Q + fnow;
    bvirt = Qnew - Q;
    hh = Q - (Qnew - bvirt) + (fnow - bvirt);
    fnow = f[++findex];
    Q = Qnew;
    if (hh !== 0) {
      h[hindex++] = hh;
    }
  }
  if (Q !== 0 || hindex === 0) {
    h[hindex++] = Q;
  }
  return hindex;
}
function estimate(elen, e) {
  let Q = e[0];
  for (let i = 1; i < elen; i++) Q += e[i];
  return Q;
}
function vec(n) {
  return new Float64Array(n);
}

const ccwerrboundA = (3 + 16 * epsilon$1) * epsilon$1;
const ccwerrboundB = (2 + 12 * epsilon$1) * epsilon$1;
const ccwerrboundC = (9 + 64 * epsilon$1) * epsilon$1 * epsilon$1;
const B = vec(4);
const C1 = vec(8);
const C2 = vec(12);
const D = vec(16);
const u = vec(4);
function orient2dadapt(ax, ay, bx, by, cx, cy, detsum) {
  let acxtail, acytail, bcxtail, bcytail;
  let bvirt, c, ahi, alo, bhi, blo, _i, _j, _0, s1, s0, t1, t0, u3;
  const acx = ax - cx;
  const bcx = bx - cx;
  const acy = ay - cy;
  const bcy = by - cy;
  s1 = acx * bcy;
  c = splitter * acx;
  ahi = c - (c - acx);
  alo = acx - ahi;
  c = splitter * bcy;
  bhi = c - (c - bcy);
  blo = bcy - bhi;
  s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
  t1 = acy * bcx;
  c = splitter * acy;
  ahi = c - (c - acy);
  alo = acy - ahi;
  c = splitter * bcx;
  bhi = c - (c - bcx);
  blo = bcx - bhi;
  t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
  _i = s0 - t0;
  bvirt = s0 - _i;
  B[0] = s0 - (_i + bvirt) + (bvirt - t0);
  _j = s1 + _i;
  bvirt = _j - s1;
  _0 = s1 - (_j - bvirt) + (_i - bvirt);
  _i = _0 - t1;
  bvirt = _0 - _i;
  B[1] = _0 - (_i + bvirt) + (bvirt - t1);
  u3 = _j + _i;
  bvirt = u3 - _j;
  B[2] = _j - (u3 - bvirt) + (_i - bvirt);
  B[3] = u3;
  let det = estimate(4, B);
  let errbound = ccwerrboundB * detsum;
  if (det >= errbound || -det >= errbound) {
    return det;
  }
  bvirt = ax - acx;
  acxtail = ax - (acx + bvirt) + (bvirt - cx);
  bvirt = bx - bcx;
  bcxtail = bx - (bcx + bvirt) + (bvirt - cx);
  bvirt = ay - acy;
  acytail = ay - (acy + bvirt) + (bvirt - cy);
  bvirt = by - bcy;
  bcytail = by - (bcy + bvirt) + (bvirt - cy);
  if (acxtail === 0 && acytail === 0 && bcxtail === 0 && bcytail === 0) {
    return det;
  }
  errbound = ccwerrboundC * detsum + resulterrbound * Math.abs(det);
  det += acx * bcytail + bcy * acxtail - (acy * bcxtail + bcx * acytail);
  if (det >= errbound || -det >= errbound) return det;
  s1 = acxtail * bcy;
  c = splitter * acxtail;
  ahi = c - (c - acxtail);
  alo = acxtail - ahi;
  c = splitter * bcy;
  bhi = c - (c - bcy);
  blo = bcy - bhi;
  s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
  t1 = acytail * bcx;
  c = splitter * acytail;
  ahi = c - (c - acytail);
  alo = acytail - ahi;
  c = splitter * bcx;
  bhi = c - (c - bcx);
  blo = bcx - bhi;
  t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
  _i = s0 - t0;
  bvirt = s0 - _i;
  u[0] = s0 - (_i + bvirt) + (bvirt - t0);
  _j = s1 + _i;
  bvirt = _j - s1;
  _0 = s1 - (_j - bvirt) + (_i - bvirt);
  _i = _0 - t1;
  bvirt = _0 - _i;
  u[1] = _0 - (_i + bvirt) + (bvirt - t1);
  u3 = _j + _i;
  bvirt = u3 - _j;
  u[2] = _j - (u3 - bvirt) + (_i - bvirt);
  u[3] = u3;
  const C1len = sum(4, B, 4, u, C1);
  s1 = acx * bcytail;
  c = splitter * acx;
  ahi = c - (c - acx);
  alo = acx - ahi;
  c = splitter * bcytail;
  bhi = c - (c - bcytail);
  blo = bcytail - bhi;
  s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
  t1 = acy * bcxtail;
  c = splitter * acy;
  ahi = c - (c - acy);
  alo = acy - ahi;
  c = splitter * bcxtail;
  bhi = c - (c - bcxtail);
  blo = bcxtail - bhi;
  t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
  _i = s0 - t0;
  bvirt = s0 - _i;
  u[0] = s0 - (_i + bvirt) + (bvirt - t0);
  _j = s1 + _i;
  bvirt = _j - s1;
  _0 = s1 - (_j - bvirt) + (_i - bvirt);
  _i = _0 - t1;
  bvirt = _0 - _i;
  u[1] = _0 - (_i + bvirt) + (bvirt - t1);
  u3 = _j + _i;
  bvirt = u3 - _j;
  u[2] = _j - (u3 - bvirt) + (_i - bvirt);
  u[3] = u3;
  const C2len = sum(C1len, C1, 4, u, C2);
  s1 = acxtail * bcytail;
  c = splitter * acxtail;
  ahi = c - (c - acxtail);
  alo = acxtail - ahi;
  c = splitter * bcytail;
  bhi = c - (c - bcytail);
  blo = bcytail - bhi;
  s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
  t1 = acytail * bcxtail;
  c = splitter * acytail;
  ahi = c - (c - acytail);
  alo = acytail - ahi;
  c = splitter * bcxtail;
  bhi = c - (c - bcxtail);
  blo = bcxtail - bhi;
  t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
  _i = s0 - t0;
  bvirt = s0 - _i;
  u[0] = s0 - (_i + bvirt) + (bvirt - t0);
  _j = s1 + _i;
  bvirt = _j - s1;
  _0 = s1 - (_j - bvirt) + (_i - bvirt);
  _i = _0 - t1;
  bvirt = _0 - _i;
  u[1] = _0 - (_i + bvirt) + (bvirt - t1);
  u3 = _j + _i;
  bvirt = u3 - _j;
  u[2] = _j - (u3 - bvirt) + (_i - bvirt);
  u[3] = u3;
  const Dlen = sum(C2len, C2, 4, u, D);
  return D[Dlen - 1];
}
function orient2d(ax, ay, bx, by, cx, cy) {
  const detleft = (ay - cy) * (bx - cx);
  const detright = (ax - cx) * (by - cy);
  const det = detleft - detright;
  const detsum = Math.abs(detleft + detright);
  if (Math.abs(det) >= ccwerrboundA * detsum) return det;
  return -orient2dadapt(ax, ay, bx, by, cx, cy, detsum);
}

const EPSILON = Math.pow(2, -52);
const EDGE_STACK = new Uint32Array(512);
class Delaunator {
  static from(points, getX = defaultGetX, getY = defaultGetY) {
    const n = points.length;
    const coords = new Float64Array(n * 2);
    for (let i = 0; i < n; i++) {
      const p = points[i];
      coords[2 * i] = getX(p);
      coords[2 * i + 1] = getY(p);
    }
    return new Delaunator(coords);
  }
  constructor(coords) {
    const n = coords.length >> 1;
    if (n > 0 && typeof coords[0] !== 'number') throw new Error('Expected coords to contain numbers.');
    this.coords = coords;

    // arrays that will store the triangulation graph
    const maxTriangles = Math.max(2 * n - 5, 0);
    this._triangles = new Uint32Array(maxTriangles * 3);
    this._halfedges = new Int32Array(maxTriangles * 3);

    // temporary arrays for tracking the edges of the advancing convex hull
    this._hashSize = Math.ceil(Math.sqrt(n));
    this._hullPrev = new Uint32Array(n); // edge to prev edge
    this._hullNext = new Uint32Array(n); // edge to next edge
    this._hullTri = new Uint32Array(n); // edge to adjacent triangle
    this._hullHash = new Int32Array(this._hashSize); // angular edge hash

    // temporary arrays for sorting points
    this._ids = new Uint32Array(n);
    this._dists = new Float64Array(n);
    this.update();
  }
  update() {
    const {
      coords,
      _hullPrev: hullPrev,
      _hullNext: hullNext,
      _hullTri: hullTri,
      _hullHash: hullHash
    } = this;
    const n = coords.length >> 1;

    // populate an array of point indices; calculate input data bbox
    let minX = Infinity;
    let minY = Infinity;
    let maxX = -Infinity;
    let maxY = -Infinity;
    for (let i = 0; i < n; i++) {
      const x = coords[2 * i];
      const y = coords[2 * i + 1];
      if (x < minX) minX = x;
      if (y < minY) minY = y;
      if (x > maxX) maxX = x;
      if (y > maxY) maxY = y;
      this._ids[i] = i;
    }
    const cx = (minX + maxX) / 2;
    const cy = (minY + maxY) / 2;
    let i0, i1, i2;

    // pick a seed point close to the center
    for (let i = 0, minDist = Infinity; i < n; i++) {
      const d = dist(cx, cy, coords[2 * i], coords[2 * i + 1]);
      if (d < minDist) {
        i0 = i;
        minDist = d;
      }
    }
    const i0x = coords[2 * i0];
    const i0y = coords[2 * i0 + 1];

    // find the point closest to the seed
    for (let i = 0, minDist = Infinity; i < n; i++) {
      if (i === i0) continue;
      const d = dist(i0x, i0y, coords[2 * i], coords[2 * i + 1]);
      if (d < minDist && d > 0) {
        i1 = i;
        minDist = d;
      }
    }
    let i1x = coords[2 * i1];
    let i1y = coords[2 * i1 + 1];
    let minRadius = Infinity;

    // find the third point which forms the smallest circumcircle with the first two
    for (let i = 0; i < n; i++) {
      if (i === i0 || i === i1) continue;
      const r = circumradius(i0x, i0y, i1x, i1y, coords[2 * i], coords[2 * i + 1]);
      if (r < minRadius) {
        i2 = i;
        minRadius = r;
      }
    }
    let i2x = coords[2 * i2];
    let i2y = coords[2 * i2 + 1];
    if (minRadius === Infinity) {
      // order collinear points by dx (or dy if all x are identical)
      // and return the list as a hull
      for (let i = 0; i < n; i++) {
        this._dists[i] = coords[2 * i] - coords[0] || coords[2 * i + 1] - coords[1];
      }
      quicksort(this._ids, this._dists, 0, n - 1);
      const hull = new Uint32Array(n);
      let j = 0;
      for (let i = 0, d0 = -Infinity; i < n; i++) {
        const id = this._ids[i];
        const d = this._dists[id];
        if (d > d0) {
          hull[j++] = id;
          d0 = d;
        }
      }
      this.hull = hull.subarray(0, j);
      this.triangles = new Uint32Array(0);
      this.halfedges = new Uint32Array(0);
      return;
    }

    // swap the order of the seed points for counter-clockwise orientation
    if (orient2d(i0x, i0y, i1x, i1y, i2x, i2y) < 0) {
      const i = i1;
      const x = i1x;
      const y = i1y;
      i1 = i2;
      i1x = i2x;
      i1y = i2y;
      i2 = i;
      i2x = x;
      i2y = y;
    }
    const center = circumcenter(i0x, i0y, i1x, i1y, i2x, i2y);
    this._cx = center.x;
    this._cy = center.y;
    for (let i = 0; i < n; i++) {
      this._dists[i] = dist(coords[2 * i], coords[2 * i + 1], center.x, center.y);
    }

    // sort the points by distance from the seed triangle circumcenter
    quicksort(this._ids, this._dists, 0, n - 1);

    // set up the seed triangle as the starting hull
    this._hullStart = i0;
    let hullSize = 3;
    hullNext[i0] = hullPrev[i2] = i1;
    hullNext[i1] = hullPrev[i0] = i2;
    hullNext[i2] = hullPrev[i1] = i0;
    hullTri[i0] = 0;
    hullTri[i1] = 1;
    hullTri[i2] = 2;
    hullHash.fill(-1);
    hullHash[this._hashKey(i0x, i0y)] = i0;
    hullHash[this._hashKey(i1x, i1y)] = i1;
    hullHash[this._hashKey(i2x, i2y)] = i2;
    this.trianglesLen = 0;
    this._addTriangle(i0, i1, i2, -1, -1, -1);
    for (let k = 0, xp, yp; k < this._ids.length; k++) {
      const i = this._ids[k];
      const x = coords[2 * i];
      const y = coords[2 * i + 1];

      // skip near-duplicate points
      if (k > 0 && Math.abs(x - xp) <= EPSILON && Math.abs(y - yp) <= EPSILON) continue;
      xp = x;
      yp = y;

      // skip seed triangle points
      if (i === i0 || i === i1 || i === i2) continue;

      // find a visible edge on the convex hull using edge hash
      let start = 0;
      for (let j = 0, key = this._hashKey(x, y); j < this._hashSize; j++) {
        start = hullHash[(key + j) % this._hashSize];
        if (start !== -1 && start !== hullNext[start]) break;
      }
      start = hullPrev[start];
      let e = start,
        q;
      while (q = hullNext[e], orient2d(x, y, coords[2 * e], coords[2 * e + 1], coords[2 * q], coords[2 * q + 1]) >= 0) {
        e = q;
        if (e === start) {
          e = -1;
          break;
        }
      }
      if (e === -1) continue; // likely a near-duplicate point; skip it

      // add the first triangle from the point
      let t = this._addTriangle(e, i, hullNext[e], -1, -1, hullTri[e]);

      // recursively flip triangles from the point until they satisfy the Delaunay condition
      hullTri[i] = this._legalize(t + 2);
      hullTri[e] = t; // keep track of boundary triangles on the hull
      hullSize++;

      // walk forward through the hull, adding more triangles and flipping recursively
      let n = hullNext[e];
      while (q = hullNext[n], orient2d(x, y, coords[2 * n], coords[2 * n + 1], coords[2 * q], coords[2 * q + 1]) < 0) {
        t = this._addTriangle(n, i, q, hullTri[i], -1, hullTri[n]);
        hullTri[i] = this._legalize(t + 2);
        hullNext[n] = n; // mark as removed
        hullSize--;
        n = q;
      }

      // walk backward from the other side, adding more triangles and flipping
      if (e === start) {
        while (q = hullPrev[e], orient2d(x, y, coords[2 * q], coords[2 * q + 1], coords[2 * e], coords[2 * e + 1]) < 0) {
          t = this._addTriangle(q, i, e, -1, hullTri[e], hullTri[q]);
          this._legalize(t + 2);
          hullTri[q] = t;
          hullNext[e] = e; // mark as removed
          hullSize--;
          e = q;
        }
      }

      // update the hull indices
      this._hullStart = hullPrev[i] = e;
      hullNext[e] = hullPrev[n] = i;
      hullNext[i] = n;

      // save the two new edges in the hash table
      hullHash[this._hashKey(x, y)] = i;
      hullHash[this._hashKey(coords[2 * e], coords[2 * e + 1])] = e;
    }
    this.hull = new Uint32Array(hullSize);
    for (let i = 0, e = this._hullStart; i < hullSize; i++) {
      this.hull[i] = e;
      e = hullNext[e];
    }

    // trim typed triangle mesh arrays
    this.triangles = this._triangles.subarray(0, this.trianglesLen);
    this.halfedges = this._halfedges.subarray(0, this.trianglesLen);
  }
  _hashKey(x, y) {
    return Math.floor(pseudoAngle(x - this._cx, y - this._cy) * this._hashSize) % this._hashSize;
  }
  _legalize(a) {
    const {
      _triangles: triangles,
      _halfedges: halfedges,
      coords
    } = this;
    let i = 0;
    let ar = 0;

    // recursion eliminated with a fixed-size stack
    while (true) {
      const b = halfedges[a];

      /* if the pair of triangles doesn't satisfy the Delaunay condition
       * (p1 is inside the circumcircle of [p0, pl, pr]), flip them,
       * then do the same check/flip recursively for the new pair of triangles
       *
       *           pl                    pl
       *          /||\                  /  \
       *       al/ || \bl            al/    \a
       *        /  ||  \              /      \
       *       /  a||b  \    flip    /___ar___\
       *     p0\   ||   /p1   =>   p0\---bl---/p1
       *        \  ||  /              \      /
       *       ar\ || /br             b\    /br
       *          \||/                  \  /
       *           pr                    pr
       */
      const a0 = a - a % 3;
      ar = a0 + (a + 2) % 3;
      if (b === -1) {
        // convex hull edge
        if (i === 0) break;
        a = EDGE_STACK[--i];
        continue;
      }
      const b0 = b - b % 3;
      const al = a0 + (a + 1) % 3;
      const bl = b0 + (b + 2) % 3;
      const p0 = triangles[ar];
      const pr = triangles[a];
      const pl = triangles[al];
      const p1 = triangles[bl];
      const illegal = inCircle(coords[2 * p0], coords[2 * p0 + 1], coords[2 * pr], coords[2 * pr + 1], coords[2 * pl], coords[2 * pl + 1], coords[2 * p1], coords[2 * p1 + 1]);
      if (illegal) {
        triangles[a] = p1;
        triangles[b] = p0;
        const hbl = halfedges[bl];

        // edge swapped on the other side of the hull (rare); fix the halfedge reference
        if (hbl === -1) {
          let e = this._hullStart;
          do {
            if (this._hullTri[e] === bl) {
              this._hullTri[e] = a;
              break;
            }
            e = this._hullPrev[e];
          } while (e !== this._hullStart);
        }
        this._link(a, hbl);
        this._link(b, halfedges[ar]);
        this._link(ar, bl);
        const br = b0 + (b + 1) % 3;

        // don't worry about hitting the cap: it can only happen on extremely degenerate input
        if (i < EDGE_STACK.length) {
          EDGE_STACK[i++] = br;
        }
      } else {
        if (i === 0) break;
        a = EDGE_STACK[--i];
      }
    }
    return ar;
  }
  _link(a, b) {
    this._halfedges[a] = b;
    if (b !== -1) this._halfedges[b] = a;
  }

  // add a new triangle given vertex indices and adjacent half-edge ids
  _addTriangle(i0, i1, i2, a, b, c) {
    const t = this.trianglesLen;
    this._triangles[t] = i0;
    this._triangles[t + 1] = i1;
    this._triangles[t + 2] = i2;
    this._link(t, a);
    this._link(t + 1, b);
    this._link(t + 2, c);
    this.trianglesLen += 3;
    return t;
  }
}

// monotonically increases with real angle, but doesn't need expensive trigonometry
function pseudoAngle(dx, dy) {
  const p = dx / (Math.abs(dx) + Math.abs(dy));
  return (dy > 0 ? 3 - p : 1 + p) / 4; // [0..1]
}
function dist(ax, ay, bx, by) {
  const dx = ax - bx;
  const dy = ay - by;
  return dx * dx + dy * dy;
}
function inCircle(ax, ay, bx, by, cx, cy, px, py) {
  const dx = ax - px;
  const dy = ay - py;
  const ex = bx - px;
  const ey = by - py;
  const fx = cx - px;
  const fy = cy - py;
  const ap = dx * dx + dy * dy;
  const bp = ex * ex + ey * ey;
  const cp = fx * fx + fy * fy;
  return dx * (ey * cp - bp * fy) - dy * (ex * cp - bp * fx) + ap * (ex * fy - ey * fx) < 0;
}
function circumradius(ax, ay, bx, by, cx, cy) {
  const dx = bx - ax;
  const dy = by - ay;
  const ex = cx - ax;
  const ey = cy - ay;
  const bl = dx * dx + dy * dy;
  const cl = ex * ex + ey * ey;
  const d = 0.5 / (dx * ey - dy * ex);
  const x = (ey * bl - dy * cl) * d;
  const y = (dx * cl - ex * bl) * d;
  return x * x + y * y;
}
function circumcenter(ax, ay, bx, by, cx, cy) {
  const dx = bx - ax;
  const dy = by - ay;
  const ex = cx - ax;
  const ey = cy - ay;
  const bl = dx * dx + dy * dy;
  const cl = ex * ex + ey * ey;
  const d = 0.5 / (dx * ey - dy * ex);
  const x = ax + (ey * bl - dy * cl) * d;
  const y = ay + (dx * cl - ex * bl) * d;
  return {
    x,
    y
  };
}
function quicksort(ids, dists, left, right) {
  if (right - left <= 20) {
    for (let i = left + 1; i <= right; i++) {
      const temp = ids[i];
      const tempDist = dists[temp];
      let j = i - 1;
      while (j >= left && dists[ids[j]] > tempDist) ids[j + 1] = ids[j--];
      ids[j + 1] = temp;
    }
  } else {
    const median = left + right >> 1;
    let i = left + 1;
    let j = right;
    swap(ids, median, i);
    if (dists[ids[left]] > dists[ids[right]]) swap(ids, left, right);
    if (dists[ids[i]] > dists[ids[right]]) swap(ids, i, right);
    if (dists[ids[left]] > dists[ids[i]]) swap(ids, left, i);
    const temp = ids[i];
    const tempDist = dists[temp];
    while (true) {
      do i++; while (dists[ids[i]] < tempDist);
      do j--; while (dists[ids[j]] > tempDist);
      if (j < i) break;
      swap(ids, i, j);
    }
    ids[left + 1] = ids[j];
    ids[j] = temp;
    if (right - i + 1 >= j - left) {
      quicksort(ids, dists, i, right);
      quicksort(ids, dists, left, j - 1);
    } else {
      quicksort(ids, dists, left, j - 1);
      quicksort(ids, dists, i, right);
    }
  }
}
function swap(arr, i, j) {
  const tmp = arr[i];
  arr[i] = arr[j];
  arr[j] = tmp;
}
function defaultGetX(p) {
  return p[0];
}
function defaultGetY(p) {
  return p[1];
}

const epsilon = 1e-6;
class Path {
  constructor() {
    this._x0 = this._y0 =
    // start of current subpath
    this._x1 = this._y1 = null; // end of current subpath
    this._ = "";
  }
  moveTo(x, y) {
    this._ += `M${this._x0 = this._x1 = +x},${this._y0 = this._y1 = +y}`;
  }
  closePath() {
    if (this._x1 !== null) {
      this._x1 = this._x0, this._y1 = this._y0;
      this._ += "Z";
    }
  }
  lineTo(x, y) {
    this._ += `L${this._x1 = +x},${this._y1 = +y}`;
  }
  arc(x, y, r) {
    x = +x, y = +y, r = +r;
    const x0 = x + r;
    const y0 = y;
    if (r < 0) throw new Error("negative radius");
    if (this._x1 === null) this._ += `M${x0},${y0}`;else if (Math.abs(this._x1 - x0) > epsilon || Math.abs(this._y1 - y0) > epsilon) this._ += "L" + x0 + "," + y0;
    if (!r) return;
    this._ += `A${r},${r},0,1,1,${x - r},${y}A${r},${r},0,1,1,${this._x1 = x0},${this._y1 = y0}`;
  }
  rect(x, y, w, h) {
    this._ += `M${this._x0 = this._x1 = +x},${this._y0 = this._y1 = +y}h${+w}v${+h}h${-w}Z`;
  }
  value() {
    return this._ || null;
  }
}

class Polygon {
  constructor() {
    this._ = [];
  }
  moveTo(x, y) {
    this._.push([x, y]);
  }
  closePath() {
    this._.push(this._[0].slice());
  }
  lineTo(x, y) {
    this._.push([x, y]);
  }
  value() {
    return this._.length ? this._ : null;
  }
}

let Voronoi$1 = class Voronoi {
  constructor(delaunay, [xmin, ymin, xmax, ymax] = [0, 0, 960, 500]) {
    if (!((xmax = +xmax) >= (xmin = +xmin)) || !((ymax = +ymax) >= (ymin = +ymin))) throw new Error("invalid bounds");
    this.delaunay = delaunay;
    this._circumcenters = new Float64Array(delaunay.points.length * 2);
    this.vectors = new Float64Array(delaunay.points.length * 2);
    this.xmax = xmax, this.xmin = xmin;
    this.ymax = ymax, this.ymin = ymin;
    this._init();
  }
  update() {
    this.delaunay.update();
    this._init();
    return this;
  }
  _init() {
    const {
      delaunay: {
        points,
        hull,
        triangles
      },
      vectors
    } = this;
    let bx, by; // lazily computed barycenter of the hull

    // Compute circumcenters.
    const circumcenters = this.circumcenters = this._circumcenters.subarray(0, triangles.length / 3 * 2);
    for (let i = 0, j = 0, n = triangles.length, x, y; i < n; i += 3, j += 2) {
      const t1 = triangles[i] * 2;
      const t2 = triangles[i + 1] * 2;
      const t3 = triangles[i + 2] * 2;
      const x1 = points[t1];
      const y1 = points[t1 + 1];
      const x2 = points[t2];
      const y2 = points[t2 + 1];
      const x3 = points[t3];
      const y3 = points[t3 + 1];
      const dx = x2 - x1;
      const dy = y2 - y1;
      const ex = x3 - x1;
      const ey = y3 - y1;
      const ab = (dx * ey - dy * ex) * 2;
      if (Math.abs(ab) < 1e-9) {
        // For a degenerate triangle, the circumcenter is at the infinity, in a
        // direction orthogonal to the halfedge and away from the “center” of
        // the diagram <bx, by>, defined as the hull’s barycenter.
        if (bx === undefined) {
          bx = by = 0;
          for (const i of hull) bx += points[i * 2], by += points[i * 2 + 1];
          bx /= hull.length, by /= hull.length;
        }
        const a = 1e9 * Math.sign((bx - x1) * ey - (by - y1) * ex);
        x = (x1 + x3) / 2 - a * ey;
        y = (y1 + y3) / 2 + a * ex;
      } else {
        const d = 1 / ab;
        const bl = dx * dx + dy * dy;
        const cl = ex * ex + ey * ey;
        x = x1 + (ey * bl - dy * cl) * d;
        y = y1 + (dx * cl - ex * bl) * d;
      }
      circumcenters[j] = x;
      circumcenters[j + 1] = y;
    }

    // Compute exterior cell rays.
    let h = hull[hull.length - 1];
    let p0,
      p1 = h * 4;
    let x0,
      x1 = points[2 * h];
    let y0,
      y1 = points[2 * h + 1];
    vectors.fill(0);
    for (let i = 0; i < hull.length; ++i) {
      h = hull[i];
      p0 = p1, x0 = x1, y0 = y1;
      p1 = h * 4, x1 = points[2 * h], y1 = points[2 * h + 1];
      vectors[p0 + 2] = vectors[p1] = y0 - y1;
      vectors[p0 + 3] = vectors[p1 + 1] = x1 - x0;
    }
  }
  render(context) {
    const buffer = context == null ? context = new Path() : undefined;
    const {
      delaunay: {
        halfedges,
        inedges,
        hull
      },
      circumcenters,
      vectors
    } = this;
    if (hull.length <= 1) return null;
    for (let i = 0, n = halfedges.length; i < n; ++i) {
      const j = halfedges[i];
      if (j < i) continue;
      const ti = Math.floor(i / 3) * 2;
      const tj = Math.floor(j / 3) * 2;
      const xi = circumcenters[ti];
      const yi = circumcenters[ti + 1];
      const xj = circumcenters[tj];
      const yj = circumcenters[tj + 1];
      this._renderSegment(xi, yi, xj, yj, context);
    }
    let h0,
      h1 = hull[hull.length - 1];
    for (let i = 0; i < hull.length; ++i) {
      h0 = h1, h1 = hull[i];
      const t = Math.floor(inedges[h1] / 3) * 2;
      const x = circumcenters[t];
      const y = circumcenters[t + 1];
      const v = h0 * 4;
      const p = this._project(x, y, vectors[v + 2], vectors[v + 3]);
      if (p) this._renderSegment(x, y, p[0], p[1], context);
    }
    return buffer && buffer.value();
  }
  renderBounds(context) {
    const buffer = context == null ? context = new Path() : undefined;
    context.rect(this.xmin, this.ymin, this.xmax - this.xmin, this.ymax - this.ymin);
    return buffer && buffer.value();
  }
  renderCell(i, context) {
    const buffer = context == null ? context = new Path() : undefined;
    const points = this._clip(i);
    if (points === null || !points.length) return;
    context.moveTo(points[0], points[1]);
    let n = points.length;
    while (points[0] === points[n - 2] && points[1] === points[n - 1] && n > 1) n -= 2;
    for (let i = 2; i < n; i += 2) {
      if (points[i] !== points[i - 2] || points[i + 1] !== points[i - 1]) context.lineTo(points[i], points[i + 1]);
    }
    context.closePath();
    return buffer && buffer.value();
  }
  *cellPolygons() {
    const {
      delaunay: {
        points
      }
    } = this;
    for (let i = 0, n = points.length / 2; i < n; ++i) {
      const cell = this.cellPolygon(i);
      if (cell) cell.index = i, yield cell;
    }
  }
  cellPolygon(i) {
    const polygon = new Polygon();
    this.renderCell(i, polygon);
    return polygon.value();
  }
  _renderSegment(x0, y0, x1, y1, context) {
    let S;
    const c0 = this._regioncode(x0, y0);
    const c1 = this._regioncode(x1, y1);
    if (c0 === 0 && c1 === 0) {
      context.moveTo(x0, y0);
      context.lineTo(x1, y1);
    } else if (S = this._clipSegment(x0, y0, x1, y1, c0, c1)) {
      context.moveTo(S[0], S[1]);
      context.lineTo(S[2], S[3]);
    }
  }
  contains(i, x, y) {
    if ((x = +x, x !== x) || (y = +y, y !== y)) return false;
    return this.delaunay._step(i, x, y) === i;
  }
  *neighbors(i) {
    const ci = this._clip(i);
    if (ci) for (const j of this.delaunay.neighbors(i)) {
      const cj = this._clip(j);
      // find the common edge
      if (cj) loop: for (let ai = 0, li = ci.length; ai < li; ai += 2) {
        for (let aj = 0, lj = cj.length; aj < lj; aj += 2) {
          if (ci[ai] === cj[aj] && ci[ai + 1] === cj[aj + 1] && ci[(ai + 2) % li] === cj[(aj + lj - 2) % lj] && ci[(ai + 3) % li] === cj[(aj + lj - 1) % lj]) {
            yield j;
            break loop;
          }
        }
      }
    }
  }
  _cell(i) {
    const {
      circumcenters,
      delaunay: {
        inedges,
        halfedges,
        triangles
      }
    } = this;
    const e0 = inedges[i];
    if (e0 === -1) return null; // coincident point
    const points = [];
    let e = e0;
    do {
      const t = Math.floor(e / 3);
      points.push(circumcenters[t * 2], circumcenters[t * 2 + 1]);
      e = e % 3 === 2 ? e - 2 : e + 1;
      if (triangles[e] !== i) break; // bad triangulation
      e = halfedges[e];
    } while (e !== e0 && e !== -1);
    return points;
  }
  _clip(i) {
    // degenerate case (1 valid point: return the box)
    if (i === 0 && this.delaunay.hull.length === 1) {
      return [this.xmax, this.ymin, this.xmax, this.ymax, this.xmin, this.ymax, this.xmin, this.ymin];
    }
    const points = this._cell(i);
    if (points === null) return null;
    const {
      vectors: V
    } = this;
    const v = i * 4;
    return this._simplify(V[v] || V[v + 1] ? this._clipInfinite(i, points, V[v], V[v + 1], V[v + 2], V[v + 3]) : this._clipFinite(i, points));
  }
  _clipFinite(i, points) {
    const n = points.length;
    let P = null;
    let x0,
      y0,
      x1 = points[n - 2],
      y1 = points[n - 1];
    let c0,
      c1 = this._regioncode(x1, y1);
    let e0,
      e1 = 0;
    for (let j = 0; j < n; j += 2) {
      x0 = x1, y0 = y1, x1 = points[j], y1 = points[j + 1];
      c0 = c1, c1 = this._regioncode(x1, y1);
      if (c0 === 0 && c1 === 0) {
        e0 = e1, e1 = 0;
        if (P) P.push(x1, y1);else P = [x1, y1];
      } else {
        let S, sx0, sy0, sx1, sy1;
        if (c0 === 0) {
          if ((S = this._clipSegment(x0, y0, x1, y1, c0, c1)) === null) continue;
          [sx0, sy0, sx1, sy1] = S;
        } else {
          if ((S = this._clipSegment(x1, y1, x0, y0, c1, c0)) === null) continue;
          [sx1, sy1, sx0, sy0] = S;
          e0 = e1, e1 = this._edgecode(sx0, sy0);
          if (e0 && e1) this._edge(i, e0, e1, P, P.length);
          if (P) P.push(sx0, sy0);else P = [sx0, sy0];
        }
        e0 = e1, e1 = this._edgecode(sx1, sy1);
        if (e0 && e1) this._edge(i, e0, e1, P, P.length);
        if (P) P.push(sx1, sy1);else P = [sx1, sy1];
      }
    }
    if (P) {
      e0 = e1, e1 = this._edgecode(P[0], P[1]);
      if (e0 && e1) this._edge(i, e0, e1, P, P.length);
    } else if (this.contains(i, (this.xmin + this.xmax) / 2, (this.ymin + this.ymax) / 2)) {
      return [this.xmax, this.ymin, this.xmax, this.ymax, this.xmin, this.ymax, this.xmin, this.ymin];
    }
    return P;
  }
  _clipSegment(x0, y0, x1, y1, c0, c1) {
    // for more robustness, always consider the segment in the same order
    const flip = c0 < c1;
    if (flip) [x0, y0, x1, y1, c0, c1] = [x1, y1, x0, y0, c1, c0];
    while (true) {
      if (c0 === 0 && c1 === 0) return flip ? [x1, y1, x0, y0] : [x0, y0, x1, y1];
      if (c0 & c1) return null;
      let x,
        y,
        c = c0 || c1;
      if (c & 0b1000) x = x0 + (x1 - x0) * (this.ymax - y0) / (y1 - y0), y = this.ymax;else if (c & 0b0100) x = x0 + (x1 - x0) * (this.ymin - y0) / (y1 - y0), y = this.ymin;else if (c & 0b0010) y = y0 + (y1 - y0) * (this.xmax - x0) / (x1 - x0), x = this.xmax;else y = y0 + (y1 - y0) * (this.xmin - x0) / (x1 - x0), x = this.xmin;
      if (c0) x0 = x, y0 = y, c0 = this._regioncode(x0, y0);else x1 = x, y1 = y, c1 = this._regioncode(x1, y1);
    }
  }
  _clipInfinite(i, points, vx0, vy0, vxn, vyn) {
    let P = Array.from(points),
      p;
    if (p = this._project(P[0], P[1], vx0, vy0)) P.unshift(p[0], p[1]);
    if (p = this._project(P[P.length - 2], P[P.length - 1], vxn, vyn)) P.push(p[0], p[1]);
    if (P = this._clipFinite(i, P)) {
      for (let j = 0, n = P.length, c0, c1 = this._edgecode(P[n - 2], P[n - 1]); j < n; j += 2) {
        c0 = c1, c1 = this._edgecode(P[j], P[j + 1]);
        if (c0 && c1) j = this._edge(i, c0, c1, P, j), n = P.length;
      }
    } else if (this.contains(i, (this.xmin + this.xmax) / 2, (this.ymin + this.ymax) / 2)) {
      P = [this.xmin, this.ymin, this.xmax, this.ymin, this.xmax, this.ymax, this.xmin, this.ymax];
    }
    return P;
  }
  _edge(i, e0, e1, P, j) {
    while (e0 !== e1) {
      let x, y;
      switch (e0) {
        case 0b0101:
          e0 = 0b0100;
          continue;
        // top-left
        case 0b0100:
          e0 = 0b0110, x = this.xmax, y = this.ymin;
          break;
        // top
        case 0b0110:
          e0 = 0b0010;
          continue;
        // top-right
        case 0b0010:
          e0 = 0b1010, x = this.xmax, y = this.ymax;
          break;
        // right
        case 0b1010:
          e0 = 0b1000;
          continue;
        // bottom-right
        case 0b1000:
          e0 = 0b1001, x = this.xmin, y = this.ymax;
          break;
        // bottom
        case 0b1001:
          e0 = 0b0001;
          continue;
        // bottom-left
        case 0b0001:
          e0 = 0b0101, x = this.xmin, y = this.ymin;
          break;
        // left
      }
      // Note: this implicitly checks for out of bounds: if P[j] or P[j+1] are
      // undefined, the conditional statement will be executed.
      if ((P[j] !== x || P[j + 1] !== y) && this.contains(i, x, y)) {
        P.splice(j, 0, x, y), j += 2;
      }
    }
    return j;
  }
  _project(x0, y0, vx, vy) {
    let t = Infinity,
      c,
      x,
      y;
    if (vy < 0) {
      // top
      if (y0 <= this.ymin) return null;
      if ((c = (this.ymin - y0) / vy) < t) y = this.ymin, x = x0 + (t = c) * vx;
    } else if (vy > 0) {
      // bottom
      if (y0 >= this.ymax) return null;
      if ((c = (this.ymax - y0) / vy) < t) y = this.ymax, x = x0 + (t = c) * vx;
    }
    if (vx > 0) {
      // right
      if (x0 >= this.xmax) return null;
      if ((c = (this.xmax - x0) / vx) < t) x = this.xmax, y = y0 + (t = c) * vy;
    } else if (vx < 0) {
      // left
      if (x0 <= this.xmin) return null;
      if ((c = (this.xmin - x0) / vx) < t) x = this.xmin, y = y0 + (t = c) * vy;
    }
    return [x, y];
  }
  _edgecode(x, y) {
    return (x === this.xmin ? 0b0001 : x === this.xmax ? 0b0010 : 0b0000) | (y === this.ymin ? 0b0100 : y === this.ymax ? 0b1000 : 0b0000);
  }
  _regioncode(x, y) {
    return (x < this.xmin ? 0b0001 : x > this.xmax ? 0b0010 : 0b0000) | (y < this.ymin ? 0b0100 : y > this.ymax ? 0b1000 : 0b0000);
  }
  _simplify(P) {
    if (P && P.length > 4) {
      for (let i = 0; i < P.length; i += 2) {
        const j = (i + 2) % P.length,
          k = (i + 4) % P.length;
        if (P[i] === P[j] && P[j] === P[k] || P[i + 1] === P[j + 1] && P[j + 1] === P[k + 1]) {
          P.splice(j, 2), i -= 2;
        }
      }
      if (!P.length) P = null;
    }
    return P;
  }
};

const tau = 2 * Math.PI,
  pow = Math.pow;
function pointX(p) {
  return p[0];
}
function pointY(p) {
  return p[1];
}

// A triangulation is collinear if all its triangles have a non-null area
function collinear(d) {
  const {
    triangles,
    coords
  } = d;
  for (let i = 0; i < triangles.length; i += 3) {
    const a = 2 * triangles[i],
      b = 2 * triangles[i + 1],
      c = 2 * triangles[i + 2],
      cross = (coords[c] - coords[a]) * (coords[b + 1] - coords[a + 1]) - (coords[b] - coords[a]) * (coords[c + 1] - coords[a + 1]);
    if (cross > 1e-10) return false;
  }
  return true;
}
function jitter(x, y, r) {
  return [x + Math.sin(x + y) * r, y + Math.cos(x - y) * r];
}
class Delaunay {
  static from(points, fx = pointX, fy = pointY, that) {
    return new Delaunay("length" in points ? flatArray(points, fx, fy, that) : Float64Array.from(flatIterable(points, fx, fy, that)));
  }
  constructor(points) {
    this._delaunator = new Delaunator(points);
    this.inedges = new Int32Array(points.length / 2);
    this._hullIndex = new Int32Array(points.length / 2);
    this.points = this._delaunator.coords;
    this._init();
  }
  update() {
    this._delaunator.update();
    this._init();
    return this;
  }
  _init() {
    const d = this._delaunator,
      points = this.points;

    // check for collinear
    if (d.hull && d.hull.length > 2 && collinear(d)) {
      this.collinear = Int32Array.from({
        length: points.length / 2
      }, (_, i) => i).sort((i, j) => points[2 * i] - points[2 * j] || points[2 * i + 1] - points[2 * j + 1]); // for exact neighbors
      const e = this.collinear[0],
        f = this.collinear[this.collinear.length - 1],
        bounds = [points[2 * e], points[2 * e + 1], points[2 * f], points[2 * f + 1]],
        r = 1e-8 * Math.hypot(bounds[3] - bounds[1], bounds[2] - bounds[0]);
      for (let i = 0, n = points.length / 2; i < n; ++i) {
        const p = jitter(points[2 * i], points[2 * i + 1], r);
        points[2 * i] = p[0];
        points[2 * i + 1] = p[1];
      }
      this._delaunator = new Delaunator(points);
    } else {
      delete this.collinear;
    }
    const halfedges = this.halfedges = this._delaunator.halfedges;
    const hull = this.hull = this._delaunator.hull;
    const triangles = this.triangles = this._delaunator.triangles;
    const inedges = this.inedges.fill(-1);
    const hullIndex = this._hullIndex.fill(-1);

    // Compute an index from each point to an (arbitrary) incoming halfedge
    // Used to give the first neighbor of each point; for this reason,
    // on the hull we give priority to exterior halfedges
    for (let e = 0, n = halfedges.length; e < n; ++e) {
      const p = triangles[e % 3 === 2 ? e - 2 : e + 1];
      if (halfedges[e] === -1 || inedges[p] === -1) inedges[p] = e;
    }
    for (let i = 0, n = hull.length; i < n; ++i) {
      hullIndex[hull[i]] = i;
    }

    // degenerate case: 1 or 2 (distinct) points
    if (hull.length <= 2 && hull.length > 0) {
      this.triangles = new Int32Array(3).fill(-1);
      this.halfedges = new Int32Array(3).fill(-1);
      this.triangles[0] = hull[0];
      inedges[hull[0]] = 1;
      if (hull.length === 2) {
        inedges[hull[1]] = 0;
        this.triangles[1] = hull[1];
        this.triangles[2] = hull[1];
      }
    }
  }
  voronoi(bounds) {
    return new Voronoi$1(this, bounds);
  }
  *neighbors(i) {
    const {
      inedges,
      hull,
      _hullIndex,
      halfedges,
      triangles,
      collinear
    } = this;

    // degenerate case with several collinear points
    if (collinear) {
      const l = collinear.indexOf(i);
      if (l > 0) yield collinear[l - 1];
      if (l < collinear.length - 1) yield collinear[l + 1];
      return;
    }
    const e0 = inedges[i];
    if (e0 === -1) return; // coincident point
    let e = e0,
      p0 = -1;
    do {
      yield p0 = triangles[e];
      e = e % 3 === 2 ? e - 2 : e + 1;
      if (triangles[e] !== i) return; // bad triangulation
      e = halfedges[e];
      if (e === -1) {
        const p = hull[(_hullIndex[i] + 1) % hull.length];
        if (p !== p0) yield p;
        return;
      }
    } while (e !== e0);
  }
  find(x, y, i = 0) {
    if ((x = +x, x !== x) || (y = +y, y !== y)) return -1;
    const i0 = i;
    let c;
    while ((c = this._step(i, x, y)) >= 0 && c !== i && c !== i0) i = c;
    return c;
  }
  _step(i, x, y) {
    const {
      inedges,
      hull,
      _hullIndex,
      halfedges,
      triangles,
      points
    } = this;
    if (inedges[i] === -1 || !points.length) return (i + 1) % (points.length >> 1);
    let c = i;
    let dc = pow(x - points[i * 2], 2) + pow(y - points[i * 2 + 1], 2);
    const e0 = inedges[i];
    let e = e0;
    do {
      let t = triangles[e];
      const dt = pow(x - points[t * 2], 2) + pow(y - points[t * 2 + 1], 2);
      if (dt < dc) dc = dt, c = t;
      e = e % 3 === 2 ? e - 2 : e + 1;
      if (triangles[e] !== i) break; // bad triangulation
      e = halfedges[e];
      if (e === -1) {
        e = hull[(_hullIndex[i] + 1) % hull.length];
        if (e !== t) {
          if (pow(x - points[e * 2], 2) + pow(y - points[e * 2 + 1], 2) < dc) return e;
        }
        break;
      }
    } while (e !== e0);
    return c;
  }
  render(context) {
    const buffer = context == null ? context = new Path() : undefined;
    const {
      points,
      halfedges,
      triangles
    } = this;
    for (let i = 0, n = halfedges.length; i < n; ++i) {
      const j = halfedges[i];
      if (j < i) continue;
      const ti = triangles[i] * 2;
      const tj = triangles[j] * 2;
      context.moveTo(points[ti], points[ti + 1]);
      context.lineTo(points[tj], points[tj + 1]);
    }
    this.renderHull(context);
    return buffer && buffer.value();
  }
  renderPoints(context, r) {
    if (r === undefined && (!context || typeof context.moveTo !== "function")) r = context, context = null;
    r = r == undefined ? 2 : +r;
    const buffer = context == null ? context = new Path() : undefined;
    const {
      points
    } = this;
    for (let i = 0, n = points.length; i < n; i += 2) {
      const x = points[i],
        y = points[i + 1];
      context.moveTo(x + r, y);
      context.arc(x, y, r, 0, tau);
    }
    return buffer && buffer.value();
  }
  renderHull(context) {
    const buffer = context == null ? context = new Path() : undefined;
    const {
      hull,
      points
    } = this;
    const h = hull[0] * 2,
      n = hull.length;
    context.moveTo(points[h], points[h + 1]);
    for (let i = 1; i < n; ++i) {
      const h = 2 * hull[i];
      context.lineTo(points[h], points[h + 1]);
    }
    context.closePath();
    return buffer && buffer.value();
  }
  hullPolygon() {
    const polygon = new Polygon();
    this.renderHull(polygon);
    return polygon.value();
  }
  renderTriangle(i, context) {
    const buffer = context == null ? context = new Path() : undefined;
    const {
      points,
      triangles
    } = this;
    const t0 = triangles[i *= 3] * 2;
    const t1 = triangles[i + 1] * 2;
    const t2 = triangles[i + 2] * 2;
    context.moveTo(points[t0], points[t0 + 1]);
    context.lineTo(points[t1], points[t1 + 1]);
    context.lineTo(points[t2], points[t2 + 1]);
    context.closePath();
    return buffer && buffer.value();
  }
  *trianglePolygons() {
    const {
      triangles
    } = this;
    for (let i = 0, n = triangles.length / 3; i < n; ++i) {
      yield this.trianglePolygon(i);
    }
  }
  trianglePolygon(i) {
    const polygon = new Polygon();
    this.renderTriangle(i, polygon);
    return polygon.value();
  }
}
function flatArray(points, fx, fy, that) {
  const n = points.length;
  const array = new Float64Array(n * 2);
  for (let i = 0; i < n; ++i) {
    const p = points[i];
    array[i * 2] = fx.call(that, p, i, points);
    array[i * 2 + 1] = fy.call(that, p, i, points);
  }
  return array;
}
function* flatIterable(points, fx, fy, that) {
  let i = 0;
  for (const p of points) {
    yield fx.call(that, p, i, points);
    yield fy.call(that, p, i, points);
    ++i;
  }
}

function Voronoi(params) {
  Transform.call(this, null, params);
}
Voronoi.Definition = {
  'type': 'Voronoi',
  'metadata': {
    'modifies': true
  },
  'params': [{
    'name': 'x',
    'type': 'field',
    'required': true
  }, {
    'name': 'y',
    'type': 'field',
    'required': true
  }, {
    'name': 'size',
    'type': 'number',
    'array': true,
    'length': 2
  }, {
    'name': 'extent',
    'type': 'array',
    'array': true,
    'length': 2,
    'default': [[-1e5, -1e5], [1e5, 1e5]],
    'content': {
      'type': 'number',
      'array': true,
      'length': 2
    }
  }, {
    'name': 'as',
    'type': 'string',
    'default': 'path'
  }]
};
const defaultExtent = [-1e5, -1e5, 1e5, 1e5];
inherits(Voronoi, Transform, {
  transform(_, pulse) {
    const as = _.as || 'path',
      data = pulse.source;

    // nothing to do if no data
    if (!data || !data.length) return pulse;

    // configure and construct voronoi diagram
    let s = _.size;
    s = s ? [0, 0, s[0], s[1]] : (s = _.extent) ? [s[0][0], s[0][1], s[1][0], s[1][1]] : defaultExtent;
    const voronoi = this.value = Delaunay.from(data, _.x, _.y).voronoi(s);

    // map polygons to paths
    for (let i = 0, n = data.length; i < n; ++i) {
      const polygon = voronoi.cellPolygon(i);
      data[i][as] = polygon && !isPoint(polygon) ? toPathString(polygon) : null;
    }
    return pulse.reflow(_.modified()).modifies(as);
  }
});

// suppress duplicated end point vertices
function toPathString(p) {
  const x = p[0][0],
    y = p[0][1];
  let n = p.length - 1;
  for (; p[n][0] === x && p[n][1] === y; --n);
  return 'M' + p.slice(0, n + 1).join('L') + 'Z';
}
function isPoint(p) {
  return p.length === 2 && p[0][0] === p[1][0] && p[0][1] === p[1][1];
}

var voronoi = /*#__PURE__*/Object.freeze({
    __proto__: null,
    voronoi: Voronoi
});

/*
Copyright (c) 2013, Jason Davies.
All rights reserved.

Redistribution and use in source and binary forms, with or without
modification, are permitted provided that the following conditions are met:

  * Redistributions of source code must retain the above copyright notice, this
    list of conditions and the following disclaimer.

  * Redistributions in binary form must reproduce the above copyright notice,
    this list of conditions and the following disclaimer in the documentation
    and/or other materials provided with the distribution.

  * The name Jason Davies may not be used to endorse or promote products
    derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
DISCLAIMED. IN NO EVENT SHALL JASON DAVIES BE LIABLE FOR ANY DIRECT, INDIRECT,
INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE
OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF
ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

// Word cloud layout by Jason Davies, https://www.jasondavies.com/wordcloud/
// Algorithm due to Jonathan Feinberg, http://static.mrfeinberg.com/bv_ch03.pdf

var cloudRadians = Math.PI / 180,
  cw = 1 << 11 >> 5,
  ch = 1 << 11;
function cloud() {
  var size = [256, 256],
    text,
    font,
    fontSize,
    fontStyle,
    fontWeight,
    rotate,
    padding,
    spiral = archimedeanSpiral,
    words = [],
    random = Math.random,
    cloud = {};
  cloud.layout = function () {
    var contextAndRatio = getContext(domCanvas()),
      board = zeroArray((size[0] >> 5) * size[1]),
      bounds = null,
      n = words.length,
      i = -1,
      tags = [],
      data = words.map(d => ({
        text: text(d),
        font: font(d),
        style: fontStyle(d),
        weight: fontWeight(d),
        rotate: rotate(d),
        size: ~~(fontSize(d) + 1e-14),
        padding: padding(d),
        xoff: 0,
        yoff: 0,
        x1: 0,
        y1: 0,
        x0: 0,
        y0: 0,
        hasText: false,
        sprite: null,
        datum: d
      })).sort((a, b) => b.size - a.size);
    while (++i < n) {
      var d = data[i];
      d.x = size[0] * (random() + .5) >> 1;
      d.y = size[1] * (random() + .5) >> 1;
      cloudSprite(contextAndRatio, d, data, i);
      if (d.hasText && place(board, d, bounds)) {
        tags.push(d);
        if (bounds) cloudBounds(bounds, d);else bounds = [{
          x: d.x + d.x0,
          y: d.y + d.y0
        }, {
          x: d.x + d.x1,
          y: d.y + d.y1
        }];
        // Temporary hack
        d.x -= size[0] >> 1;
        d.y -= size[1] >> 1;
      }
    }
    return tags;
  };
  function getContext(canvas) {
    canvas.width = canvas.height = 1;
    var ratio = Math.sqrt(canvas.getContext('2d').getImageData(0, 0, 1, 1).data.length >> 2);
    canvas.width = (cw << 5) / ratio;
    canvas.height = ch / ratio;
    var context = canvas.getContext('2d');
    context.fillStyle = context.strokeStyle = 'red';
    context.textAlign = 'center';
    return {
      context: context,
      ratio: ratio
    };
  }
  function place(board, tag, bounds) {
    var startX = tag.x,
      startY = tag.y,
      maxDelta = Math.hypot(size[0], size[1]),
      s = spiral(size),
      dt = random() < .5 ? 1 : -1,
      t = -dt,
      dxdy,
      dx,
      dy;
    while (dxdy = s(t += dt)) {
      dx = ~~dxdy[0];
      dy = ~~dxdy[1];
      if (Math.min(Math.abs(dx), Math.abs(dy)) >= maxDelta) break;
      tag.x = startX + dx;
      tag.y = startY + dy;
      if (tag.x + tag.x0 < 0 || tag.y + tag.y0 < 0 || tag.x + tag.x1 > size[0] || tag.y + tag.y1 > size[1]) continue;
      // TODO only check for collisions within current bounds.
      if (!bounds || !cloudCollide(tag, board, size[0])) {
        if (!bounds || collideRects(tag, bounds)) {
          var sprite = tag.sprite,
            w = tag.width >> 5,
            sw = size[0] >> 5,
            lx = tag.x - (w << 4),
            sx = lx & 0x7f,
            msx = 32 - sx,
            h = tag.y1 - tag.y0,
            x = (tag.y + tag.y0) * sw + (lx >> 5),
            last;
          for (var j = 0; j < h; j++) {
            last = 0;
            for (var i = 0; i <= w; i++) {
              board[x + i] |= last << msx | (i < w ? (last = sprite[j * w + i]) >>> sx : 0);
            }
            x += sw;
          }
          tag.sprite = null;
          return true;
        }
      }
    }
    return false;
  }
  cloud.words = function (_) {
    if (arguments.length) {
      words = _;
      return cloud;
    } else {
      return words;
    }
  };
  cloud.size = function (_) {
    if (arguments.length) {
      size = [+_[0], +_[1]];
      return cloud;
    } else {
      return size;
    }
  };
  cloud.font = function (_) {
    if (arguments.length) {
      font = functor(_);
      return cloud;
    } else {
      return font;
    }
  };
  cloud.fontStyle = function (_) {
    if (arguments.length) {
      fontStyle = functor(_);
      return cloud;
    } else {
      return fontStyle;
    }
  };
  cloud.fontWeight = function (_) {
    if (arguments.length) {
      fontWeight = functor(_);
      return cloud;
    } else {
      return fontWeight;
    }
  };
  cloud.rotate = function (_) {
    if (arguments.length) {
      rotate = functor(_);
      return cloud;
    } else {
      return rotate;
    }
  };
  cloud.text = function (_) {
    if (arguments.length) {
      text = functor(_);
      return cloud;
    } else {
      return text;
    }
  };
  cloud.spiral = function (_) {
    if (arguments.length) {
      spiral = spirals[_] || _;
      return cloud;
    } else {
      return spiral;
    }
  };
  cloud.fontSize = function (_) {
    if (arguments.length) {
      fontSize = functor(_);
      return cloud;
    } else {
      return fontSize;
    }
  };
  cloud.padding = function (_) {
    if (arguments.length) {
      padding = functor(_);
      return cloud;
    } else {
      return padding;
    }
  };
  cloud.random = function (_) {
    if (arguments.length) {
      random = _;
      return cloud;
    } else {
      return random;
    }
  };
  return cloud;
}

// Fetches a monochrome sprite bitmap for the specified text.
// Load in batches for speed.
function cloudSprite(contextAndRatio, d, data, di) {
  if (d.sprite) return;
  var c = contextAndRatio.context,
    ratio = contextAndRatio.ratio;
  c.clearRect(0, 0, (cw << 5) / ratio, ch / ratio);
  var x = 0,
    y = 0,
    maxh = 0,
    n = data.length,
    w,
    w32,
    h,
    i,
    j;
  --di;
  while (++di < n) {
    d = data[di];
    c.save();
    c.font = d.style + ' ' + d.weight + ' ' + ~~((d.size + 1) / ratio) + 'px ' + d.font;
    w = c.measureText(d.text + 'm').width * ratio;
    h = d.size << 1;
    if (d.rotate) {
      var sr = Math.sin(d.rotate * cloudRadians),
        cr = Math.cos(d.rotate * cloudRadians),
        wcr = w * cr,
        wsr = w * sr,
        hcr = h * cr,
        hsr = h * sr;
      w = Math.max(Math.abs(wcr + hsr), Math.abs(wcr - hsr)) + 0x1f >> 5 << 5;
      h = ~~Math.max(Math.abs(wsr + hcr), Math.abs(wsr - hcr));
    } else {
      w = w + 0x1f >> 5 << 5;
    }
    if (h > maxh) maxh = h;
    if (x + w >= cw << 5) {
      x = 0;
      y += maxh;
      maxh = 0;
    }
    if (y + h >= ch) break;
    c.translate((x + (w >> 1)) / ratio, (y + (h >> 1)) / ratio);
    if (d.rotate) c.rotate(d.rotate * cloudRadians);
    c.fillText(d.text, 0, 0);
    if (d.padding) {
      c.lineWidth = 2 * d.padding;
      c.strokeText(d.text, 0, 0);
    }
    c.restore();
    d.width = w;
    d.height = h;
    d.xoff = x;
    d.yoff = y;
    d.x1 = w >> 1;
    d.y1 = h >> 1;
    d.x0 = -d.x1;
    d.y0 = -d.y1;
    d.hasText = true;
    x += w;
  }
  var pixels = c.getImageData(0, 0, (cw << 5) / ratio, ch / ratio).data,
    sprite = [];
  while (--di >= 0) {
    d = data[di];
    if (!d.hasText) continue;
    w = d.width;
    w32 = w >> 5;
    h = d.y1 - d.y0;
    // Zero the buffer
    for (i = 0; i < h * w32; i++) sprite[i] = 0;
    x = d.xoff;
    if (x == null) return;
    y = d.yoff;
    var seen = 0,
      seenRow = -1;
    for (j = 0; j < h; j++) {
      for (i = 0; i < w; i++) {
        var k = w32 * j + (i >> 5),
          m = pixels[(y + j) * (cw << 5) + (x + i) << 2] ? 1 << 31 - i % 32 : 0;
        sprite[k] |= m;
        seen |= m;
      }
      if (seen) seenRow = j;else {
        d.y0++;
        h--;
        j--;
        y++;
      }
    }
    d.y1 = d.y0 + seenRow;
    d.sprite = sprite.slice(0, (d.y1 - d.y0) * w32);
  }
}

// Use mask-based collision detection.
function cloudCollide(tag, board, sw) {
  sw >>= 5;
  var sprite = tag.sprite,
    w = tag.width >> 5,
    lx = tag.x - (w << 4),
    sx = lx & 0x7f,
    msx = 32 - sx,
    h = tag.y1 - tag.y0,
    x = (tag.y + tag.y0) * sw + (lx >> 5),
    last;
  for (var j = 0; j < h; j++) {
    last = 0;
    for (var i = 0; i <= w; i++) {
      if ((last << msx | (i < w ? (last = sprite[j * w + i]) >>> sx : 0)) & board[x + i]) return true;
    }
    x += sw;
  }
  return false;
}
function cloudBounds(bounds, d) {
  var b0 = bounds[0],
    b1 = bounds[1];
  if (d.x + d.x0 < b0.x) b0.x = d.x + d.x0;
  if (d.y + d.y0 < b0.y) b0.y = d.y + d.y0;
  if (d.x + d.x1 > b1.x) b1.x = d.x + d.x1;
  if (d.y + d.y1 > b1.y) b1.y = d.y + d.y1;
}
function collideRects(a, b) {
  return a.x + a.x1 > b[0].x && a.x + a.x0 < b[1].x && a.y + a.y1 > b[0].y && a.y + a.y0 < b[1].y;
}
function archimedeanSpiral(size) {
  var e = size[0] / size[1];
  return function (t) {
    return [e * (t *= .1) * Math.cos(t), t * Math.sin(t)];
  };
}
function rectangularSpiral(size) {
  var dy = 4,
    dx = dy * size[0] / size[1],
    x = 0,
    y = 0;
  return function (t) {
    var sign = t < 0 ? -1 : 1;
    // See triangular numbers: T_n = n * (n + 1) / 2.
    switch (Math.sqrt(1 + 4 * sign * t) - sign & 3) {
      case 0:
        x += dx;
        break;
      case 1:
        y += dy;
        break;
      case 2:
        x -= dx;
        break;
      default:
        y -= dy;
        break;
    }
    return [x, y];
  };
}

// TODO reuse arrays?
function zeroArray(n) {
  var a = [],
    i = -1;
  while (++i < n) a[i] = 0;
  return a;
}
function functor(d) {
  return typeof d === 'function' ? d : function () {
    return d;
  };
}
var spirals = {
  archimedean: archimedeanSpiral,
  rectangular: rectangularSpiral
};
const Output = ['x', 'y', 'font', 'fontSize', 'fontStyle', 'fontWeight', 'angle'];
const Params$1 = ['text', 'font', 'rotate', 'fontSize', 'fontStyle', 'fontWeight'];
function Wordcloud(params) {
  Transform.call(this, cloud(), params);
}
Wordcloud.Definition = {
  'type': 'Wordcloud',
  'metadata': {
    'modifies': true
  },
  'params': [{
    'name': 'size',
    'type': 'number',
    'array': true,
    'length': 2
  }, {
    'name': 'font',
    'type': 'string',
    'expr': true,
    'default': 'sans-serif'
  }, {
    'name': 'fontStyle',
    'type': 'string',
    'expr': true,
    'default': 'normal'
  }, {
    'name': 'fontWeight',
    'type': 'string',
    'expr': true,
    'default': 'normal'
  }, {
    'name': 'fontSize',
    'type': 'number',
    'expr': true,
    'default': 14
  }, {
    'name': 'fontSizeRange',
    'type': 'number',
    'array': 'nullable',
    'default': [10, 50]
  }, {
    'name': 'rotate',
    'type': 'number',
    'expr': true,
    'default': 0
  }, {
    'name': 'text',
    'type': 'field'
  }, {
    'name': 'spiral',
    'type': 'string',
    'values': ['archimedean', 'rectangular']
  }, {
    'name': 'padding',
    'type': 'number',
    'expr': true
  }, {
    'name': 'as',
    'type': 'string',
    'array': true,
    'length': 7,
    'default': Output
  }]
};
inherits(Wordcloud, Transform, {
  transform(_, pulse) {
    if (_.size && !(_.size[0] && _.size[1])) {
      error('Wordcloud size dimensions must be non-zero.');
    }
    function modp(param) {
      const p = _[param];
      return isFunction(p) && pulse.modified(p.fields);
    }
    const mod = _.modified();
    if (!(mod || pulse.changed(pulse.ADD_REM) || Params$1.some(modp))) return;
    const data = pulse.materialize(pulse.SOURCE).source,
      layout = this.value,
      as = _.as || Output;
    let fontSize = _.fontSize || 14,
      range;
    isFunction(fontSize) ? range = _.fontSizeRange : fontSize = constant$5(fontSize);

    // create font size scaling function as needed
    if (range) {
      const fsize = fontSize,
        sizeScale = scale$4('sqrt')().domain(extent(data, fsize)).range(range);
      fontSize = x => sizeScale(fsize(x));
    }
    data.forEach(t => {
      t[as[0]] = NaN;
      t[as[1]] = NaN;
      t[as[3]] = 0;
    });

    // configure layout
    const words = layout.words(data).text(_.text).size(_.size || [500, 500]).padding(_.padding || 1).spiral(_.spiral || 'archimedean').rotate(_.rotate || 0).font(_.font || 'sans-serif').fontStyle(_.fontStyle || 'normal').fontWeight(_.fontWeight || 'normal').fontSize(fontSize).random(random).layout();
    const size = layout.size(),
      dx = size[0] >> 1,
      dy = size[1] >> 1,
      n = words.length;
    for (let i = 0, w, t; i < n; ++i) {
      w = words[i];
      t = w.datum;
      t[as[0]] = w.x + dx;
      t[as[1]] = w.y + dy;
      t[as[2]] = w.font;
      t[as[3]] = w.size;
      t[as[4]] = w.style;
      t[as[5]] = w.weight;
      t[as[6]] = w.rotate;
    }
    return pulse.reflow(mod).modifies(as);
  }
});

var wordcloud = /*#__PURE__*/Object.freeze({
    __proto__: null,
    wordcloud: Wordcloud
});

const array8 = n => new Uint8Array(n);
const array16 = n => new Uint16Array(n);
const array32 = n => new Uint32Array(n);

/**
 * Maintains CrossFilter state.
 */
function Bitmaps() {
  let width = 8,
    data = [],
    seen = array32(0),
    curr = array$1(0, width),
    prev = array$1(0, width);
  return {
    data: () => data,
    seen: () => seen = lengthen(seen, data.length),
    add(array) {
      for (let i = 0, j = data.length, n = array.length, t; i < n; ++i) {
        t = array[i];
        t._index = j++;
        data.push(t);
      }
    },
    remove(num, map) {
      // map: index -> boolean (true => remove)
      const n = data.length,
        copy = Array(n - num),
        reindex = data; // reuse old data array for index map
      let t, i, j;

      // seek forward to first removal
      for (i = 0; !map[i] && i < n; ++i) {
        copy[i] = data[i];
        reindex[i] = i;
      }

      // condense arrays
      for (j = i; i < n; ++i) {
        t = data[i];
        if (!map[i]) {
          reindex[i] = j;
          curr[j] = curr[i];
          prev[j] = prev[i];
          copy[j] = t;
          t._index = j++;
        } else {
          reindex[i] = -1;
        }
        curr[i] = 0; // clear unused bits
      }
      data = copy;
      return reindex;
    },
    size: () => data.length,
    curr: () => curr,
    prev: () => prev,
    reset: k => prev[k] = curr[k],
    all: () => width < 0x101 ? 0xff : width < 0x10001 ? 0xffff : 0xffffffff,
    set(k, one) {
      curr[k] |= one;
    },
    clear(k, one) {
      curr[k] &= ~one;
    },
    resize(n, m) {
      const k = curr.length;
      if (n > k || m > width) {
        width = Math.max(m, width);
        curr = array$1(n, width, curr);
        prev = array$1(n, width);
      }
    }
  };
}
function lengthen(array, length, copy) {
  if (array.length >= length) return array;
  copy = copy || new array.constructor(length);
  copy.set(array);
  return copy;
}
function array$1(n, m, array) {
  const copy = (m < 0x101 ? array8 : m < 0x10001 ? array16 : array32)(n);
  if (array) copy.set(array);
  return copy;
}
function Dimension(index, i, query) {
  const bit = 1 << i;
  return {
    one: bit,
    zero: ~bit,
    range: query.slice(),
    bisect: index.bisect,
    index: index.index,
    size: index.size,
    onAdd(added, curr) {
      const dim = this,
        range = dim.bisect(dim.range, added.value),
        idx = added.index,
        lo = range[0],
        hi = range[1],
        n1 = idx.length;
      let i;
      for (i = 0; i < lo; ++i) curr[idx[i]] |= bit;
      for (i = hi; i < n1; ++i) curr[idx[i]] |= bit;
      return dim;
    }
  };
}

/**
 * Maintains a list of values, sorted by key.
 */
function SortedIndex() {
  let index = array32(0),
    value = [],
    size = 0;
  function insert(key, data, base) {
    if (!data.length) return [];
    const n0 = size,
      n1 = data.length,
      addi = array32(n1);
    let addv = Array(n1),
      oldv,
      oldi,
      i;
    for (i = 0; i < n1; ++i) {
      addv[i] = key(data[i]);
      addi[i] = i;
    }
    addv = sort(addv, addi);
    if (n0) {
      oldv = value;
      oldi = index;
      value = Array(n0 + n1);
      index = array32(n0 + n1);
      merge$1(base, oldv, oldi, n0, addv, addi, n1, value, index);
    } else {
      if (base > 0) for (i = 0; i < n1; ++i) {
        addi[i] += base;
      }
      value = addv;
      index = addi;
    }
    size = n0 + n1;
    return {
      index: addi,
      value: addv
    };
  }
  function remove(num, map) {
    // map: index -> remove
    const n = size;
    let idx, i, j;

    // seek forward to first removal
    for (i = 0; !map[index[i]] && i < n; ++i);

    // condense index and value arrays
    for (j = i; i < n; ++i) {
      if (!map[idx = index[i]]) {
        index[j] = idx;
        value[j] = value[i];
        ++j;
      }
    }
    size = n - num;
  }
  function reindex(map) {
    for (let i = 0, n = size; i < n; ++i) {
      index[i] = map[index[i]];
    }
  }
  function bisect(range, array) {
    let n;
    if (array) {
      n = array.length;
    } else {
      array = value;
      n = size;
    }
    return [bisectLeft$1(array, range[0], 0, n), bisectRight$1(array, range[1], 0, n)];
  }
  return {
    insert: insert,
    remove: remove,
    bisect: bisect,
    reindex: reindex,
    index: () => index,
    size: () => size
  };
}
function sort(values, index) {
  values.sort.call(index, (a, b) => {
    const x = values[a],
      y = values[b];
    return x < y ? -1 : x > y ? 1 : 0;
  });
  return permute(values, index);
}
function merge$1(base, value0, index0, n0, value1, index1, n1, value, index) {
  let i0 = 0,
    i1 = 0,
    i;
  for (i = 0; i0 < n0 && i1 < n1; ++i) {
    if (value0[i0] < value1[i1]) {
      value[i] = value0[i0];
      index[i] = index0[i0++];
    } else {
      value[i] = value1[i1];
      index[i] = index1[i1++] + base;
    }
  }
  for (; i0 < n0; ++i0, ++i) {
    value[i] = value0[i0];
    index[i] = index0[i0];
  }
  for (; i1 < n1; ++i1, ++i) {
    value[i] = value1[i1];
    index[i] = index1[i1] + base;
  }
}

/**
 * An indexed multi-dimensional filter.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {Array<function(object): *>} params.fields - An array of dimension accessors to filter.
 * @param {Array} params.query - An array of per-dimension range queries.
 */
function CrossFilter(params) {
  Transform.call(this, Bitmaps(), params);
  this._indices = null;
  this._dims = null;
}
CrossFilter.Definition = {
  'type': 'CrossFilter',
  'metadata': {},
  'params': [{
    'name': 'fields',
    'type': 'field',
    'array': true,
    'required': true
  }, {
    'name': 'query',
    'type': 'array',
    'array': true,
    'required': true,
    'content': {
      'type': 'number',
      'array': true,
      'length': 2
    }
  }]
};
inherits(CrossFilter, Transform, {
  transform(_, pulse) {
    if (!this._dims) {
      return this.init(_, pulse);
    } else {
      var init = _.modified('fields') || _.fields.some(f => pulse.modified(f.fields));
      return init ? this.reinit(_, pulse) : this.eval(_, pulse);
    }
  },
  init(_, pulse) {
    const fields = _.fields,
      query = _.query,
      indices = this._indices = {},
      dims = this._dims = [],
      m = query.length;
    let i = 0,
      key,
      index;

    // instantiate indices and dimensions
    for (; i < m; ++i) {
      key = fields[i].fname;
      index = indices[key] || (indices[key] = SortedIndex());
      dims.push(Dimension(index, i, query[i]));
    }
    return this.eval(_, pulse);
  },
  reinit(_, pulse) {
    const output = pulse.materialize().fork(),
      fields = _.fields,
      query = _.query,
      indices = this._indices,
      dims = this._dims,
      bits = this.value,
      curr = bits.curr(),
      prev = bits.prev(),
      all = bits.all(),
      out = output.rem = output.add,
      mod = output.mod,
      m = query.length,
      adds = {};
    let add, index, key, mods, remMap, modMap, i, n, f;

    // set prev to current state
    prev.set(curr);

    // if pulse has remove tuples, process them first
    if (pulse.rem.length) {
      remMap = this.remove(_, pulse, output);
    }

    // if pulse has added tuples, add them to state
    if (pulse.add.length) {
      bits.add(pulse.add);
    }

    // if pulse has modified tuples, create an index map
    if (pulse.mod.length) {
      modMap = {};
      for (mods = pulse.mod, i = 0, n = mods.length; i < n; ++i) {
        modMap[mods[i]._index] = 1;
      }
    }

    // re-initialize indices as needed, update curr bitmap
    for (i = 0; i < m; ++i) {
      f = fields[i];
      if (!dims[i] || _.modified('fields', i) || pulse.modified(f.fields)) {
        key = f.fname;
        if (!(add = adds[key])) {
          indices[key] = index = SortedIndex();
          adds[key] = add = index.insert(f, pulse.source, 0);
        }
        dims[i] = Dimension(index, i, query[i]).onAdd(add, curr);
      }
    }

    // visit each tuple
    // if filter state changed, push index to add/rem
    // else if in mod and passes a filter, push index to mod
    for (i = 0, n = bits.data().length; i < n; ++i) {
      if (remMap[i]) {
        // skip if removed tuple
        continue;
      } else if (prev[i] !== curr[i]) {
        // add if state changed
        out.push(i);
      } else if (modMap[i] && curr[i] !== all) {
        // otherwise, pass mods through
        mod.push(i);
      }
    }
    bits.mask = (1 << m) - 1;
    return output;
  },
  eval(_, pulse) {
    const output = pulse.materialize().fork(),
      m = this._dims.length;
    let mask = 0;
    if (pulse.rem.length) {
      this.remove(_, pulse, output);
      mask |= (1 << m) - 1;
    }
    if (_.modified('query') && !_.modified('fields')) {
      mask |= this.update(_, pulse, output);
    }
    if (pulse.add.length) {
      this.insert(_, pulse, output);
      mask |= (1 << m) - 1;
    }
    if (pulse.mod.length) {
      this.modify(pulse, output);
      mask |= (1 << m) - 1;
    }
    this.value.mask = mask;
    return output;
  },
  insert(_, pulse, output) {
    const tuples = pulse.add,
      bits = this.value,
      dims = this._dims,
      indices = this._indices,
      fields = _.fields,
      adds = {},
      out = output.add,
      n = bits.size() + tuples.length,
      m = dims.length;
    let k = bits.size(),
      j,
      key,
      add;

    // resize bitmaps and add tuples as needed
    bits.resize(n, m);
    bits.add(tuples);
    const curr = bits.curr(),
      prev = bits.prev(),
      all = bits.all();

    // add to dimensional indices
    for (j = 0; j < m; ++j) {
      key = fields[j].fname;
      add = adds[key] || (adds[key] = indices[key].insert(fields[j], tuples, k));
      dims[j].onAdd(add, curr);
    }

    // set previous filters, output if passes at least one filter
    for (; k < n; ++k) {
      prev[k] = all;
      if (curr[k] !== all) out.push(k);
    }
  },
  modify(pulse, output) {
    const out = output.mod,
      bits = this.value,
      curr = bits.curr(),
      all = bits.all(),
      tuples = pulse.mod;
    let i, n, k;
    for (i = 0, n = tuples.length; i < n; ++i) {
      k = tuples[i]._index;
      if (curr[k] !== all) out.push(k);
    }
  },
  remove(_, pulse, output) {
    const indices = this._indices,
      bits = this.value,
      curr = bits.curr(),
      prev = bits.prev(),
      all = bits.all(),
      map = {},
      out = output.rem,
      tuples = pulse.rem;
    let i, n, k, f;

    // process tuples, output if passes at least one filter
    for (i = 0, n = tuples.length; i < n; ++i) {
      k = tuples[i]._index;
      map[k] = 1; // build index map
      prev[k] = f = curr[k];
      curr[k] = all;
      if (f !== all) out.push(k);
    }

    // remove from dimensional indices
    for (k in indices) {
      indices[k].remove(n, map);
    }
    this.reindex(pulse, n, map);
    return map;
  },
  // reindex filters and indices after propagation completes
  reindex(pulse, num, map) {
    const indices = this._indices,
      bits = this.value;
    pulse.runAfter(() => {
      const indexMap = bits.remove(num, map);
      for (const key in indices) indices[key].reindex(indexMap);
    });
  },
  update(_, pulse, output) {
    const dims = this._dims,
      query = _.query,
      stamp = pulse.stamp,
      m = dims.length;
    let mask = 0,
      i,
      q;

    // survey how many queries have changed
    output.filters = 0;
    for (q = 0; q < m; ++q) {
      if (_.modified('query', q)) {
        i = q;
        ++mask;
      }
    }
    if (mask === 1) {
      // only one query changed, use more efficient update
      mask = dims[i].one;
      this.incrementOne(dims[i], query[i], output.add, output.rem);
    } else {
      // multiple queries changed, perform full record keeping
      for (q = 0, mask = 0; q < m; ++q) {
        if (!_.modified('query', q)) continue;
        mask |= dims[q].one;
        this.incrementAll(dims[q], query[q], stamp, output.add);
        output.rem = output.add; // duplicate add/rem for downstream resolve
      }
    }
    return mask;
  },
  incrementAll(dim, query, stamp, out) {
    const bits = this.value,
      seen = bits.seen(),
      curr = bits.curr(),
      prev = bits.prev(),
      index = dim.index(),
      old = dim.bisect(dim.range),
      range = dim.bisect(query),
      lo1 = range[0],
      hi1 = range[1],
      lo0 = old[0],
      hi0 = old[1],
      one = dim.one;
    let i, j, k;

    // Fast incremental update based on previous lo index.
    if (lo1 < lo0) {
      for (i = lo1, j = Math.min(lo0, hi1); i < j; ++i) {
        k = index[i];
        if (seen[k] !== stamp) {
          prev[k] = curr[k];
          seen[k] = stamp;
          out.push(k);
        }
        curr[k] ^= one;
      }
    } else if (lo1 > lo0) {
      for (i = lo0, j = Math.min(lo1, hi0); i < j; ++i) {
        k = index[i];
        if (seen[k] !== stamp) {
          prev[k] = curr[k];
          seen[k] = stamp;
          out.push(k);
        }
        curr[k] ^= one;
      }
    }

    // Fast incremental update based on previous hi index.
    if (hi1 > hi0) {
      for (i = Math.max(lo1, hi0), j = hi1; i < j; ++i) {
        k = index[i];
        if (seen[k] !== stamp) {
          prev[k] = curr[k];
          seen[k] = stamp;
          out.push(k);
        }
        curr[k] ^= one;
      }
    } else if (hi1 < hi0) {
      for (i = Math.max(lo0, hi1), j = hi0; i < j; ++i) {
        k = index[i];
        if (seen[k] !== stamp) {
          prev[k] = curr[k];
          seen[k] = stamp;
          out.push(k);
        }
        curr[k] ^= one;
      }
    }
    dim.range = query.slice();
  },
  incrementOne(dim, query, add, rem) {
    const bits = this.value,
      curr = bits.curr(),
      index = dim.index(),
      old = dim.bisect(dim.range),
      range = dim.bisect(query),
      lo1 = range[0],
      hi1 = range[1],
      lo0 = old[0],
      hi0 = old[1],
      one = dim.one;
    let i, j, k;

    // Fast incremental update based on previous lo index.
    if (lo1 < lo0) {
      for (i = lo1, j = Math.min(lo0, hi1); i < j; ++i) {
        k = index[i];
        curr[k] ^= one;
        add.push(k);
      }
    } else if (lo1 > lo0) {
      for (i = lo0, j = Math.min(lo1, hi0); i < j; ++i) {
        k = index[i];
        curr[k] ^= one;
        rem.push(k);
      }
    }

    // Fast incremental update based on previous hi index.
    if (hi1 > hi0) {
      for (i = Math.max(lo1, hi0), j = hi1; i < j; ++i) {
        k = index[i];
        curr[k] ^= one;
        add.push(k);
      }
    } else if (hi1 < hi0) {
      for (i = Math.max(lo0, hi1), j = hi0; i < j; ++i) {
        k = index[i];
        curr[k] ^= one;
        rem.push(k);
      }
    }
    dim.range = query.slice();
  }
});

/**
 * Selectively filters tuples by resolving against a filter bitmap.
 * Useful for processing the output of a cross-filter transform.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {object} params.ignore - A bit mask indicating which filters to ignore.
 * @param {object} params.filter - The per-tuple filter bitmaps. Typically this
 *   parameter value is a reference to a {@link CrossFilter} transform.
 */
function ResolveFilter(params) {
  Transform.call(this, null, params);
}
ResolveFilter.Definition = {
  'type': 'ResolveFilter',
  'metadata': {},
  'params': [{
    'name': 'ignore',
    'type': 'number',
    'required': true,
    'description': 'A bit mask indicating which filters to ignore.'
  }, {
    'name': 'filter',
    'type': 'object',
    'required': true,
    'description': 'Per-tuple filter bitmaps from a CrossFilter transform.'
  }]
};
inherits(ResolveFilter, Transform, {
  transform(_, pulse) {
    const ignore = ~(_.ignore || 0),
      // bit mask where zeros -> dims to ignore
      bitmap = _.filter,
      mask = bitmap.mask;

    // exit early if no relevant filter changes
    if ((mask & ignore) === 0) return pulse.StopPropagation;
    const output = pulse.fork(pulse.ALL),
      data = bitmap.data(),
      curr = bitmap.curr(),
      prev = bitmap.prev(),
      pass = k => !(curr[k] & ignore) ? data[k] : null;

    // propagate all mod tuples that pass the filter
    output.filter(output.MOD, pass);

    // determine add & rem tuples via filter functions
    // for efficiency, we do *not* populate new arrays,
    // instead we add filter functions applied downstream

    if (!(mask & mask - 1)) {
      // only one filter changed
      output.filter(output.ADD, pass);
      output.filter(output.REM, k => (curr[k] & ignore) === mask ? data[k] : null);
    } else {
      // multiple filters changed
      output.filter(output.ADD, k => {
        const c = curr[k] & ignore,
          f = !c && c ^ prev[k] & ignore;
        return f ? data[k] : null;
      });
      output.filter(output.REM, k => {
        const c = curr[k] & ignore,
          f = c && !(c ^ (c ^ prev[k] & ignore));
        return f ? data[k] : null;
      });
    }

    // add filter to source data in case of reflow...
    return output.filter(output.SOURCE, t => pass(t._index));
  }
});

var xf = /*#__PURE__*/Object.freeze({
    __proto__: null,
    crossfilter: CrossFilter,
    resolvefilter: ResolveFilter
});

const RawCode = 'RawCode';
const Literal = 'Literal';
const Property = 'Property';
const Identifier = 'Identifier';
const ArrayExpression = 'ArrayExpression';
const BinaryExpression = 'BinaryExpression';
const CallExpression = 'CallExpression';
const ConditionalExpression = 'ConditionalExpression';
const LogicalExpression = 'LogicalExpression';
const MemberExpression = 'MemberExpression';
const ObjectExpression = 'ObjectExpression';
const UnaryExpression = 'UnaryExpression';
function ASTNode(type) {
  this.type = type;
}
ASTNode.prototype.visit = function (visitor) {
  let c, i, n;
  if (visitor(this)) return 1;
  for (c = children(this), i = 0, n = c.length; i < n; ++i) {
    if (c[i].visit(visitor)) return 1;
  }
};
function children(node) {
  switch (node.type) {
    case ArrayExpression:
      return node.elements;
    case BinaryExpression:
    case LogicalExpression:
      return [node.left, node.right];
    case CallExpression:
      return [node.callee].concat(node.arguments);
    case ConditionalExpression:
      return [node.test, node.consequent, node.alternate];
    case MemberExpression:
      return [node.object, node.property];
    case ObjectExpression:
      return node.properties;
    case Property:
      return [node.key, node.value];
    case UnaryExpression:
      return [node.argument];
    case Identifier:
    case Literal:
    case RawCode:
    default:
      return [];
  }
}

/*
  The following expression parser is based on Esprima (http://esprima.org/).
  Original header comment and license for Esprima is included here:

  Copyright (C) 2013 Ariya Hidayat <ariya.hidayat@gmail.com>
  Copyright (C) 2013 Thaddee Tyl <thaddee.tyl@gmail.com>
  Copyright (C) 2013 Mathias Bynens <mathias@qiwi.be>
  Copyright (C) 2012 Ariya Hidayat <ariya.hidayat@gmail.com>
  Copyright (C) 2012 Mathias Bynens <mathias@qiwi.be>
  Copyright (C) 2012 Joost-Wim Boekesteijn <joost-wim@boekesteijn.nl>
  Copyright (C) 2012 Kris Kowal <kris.kowal@cixar.com>
  Copyright (C) 2012 Yusuke Suzuki <utatane.tea@gmail.com>
  Copyright (C) 2012 Arpad Borsos <arpad.borsos@googlemail.com>
  Copyright (C) 2011 Ariya Hidayat <ariya.hidayat@gmail.com>

  Redistribution and use in source and binary forms, with or without
  modification, are permitted provided that the following conditions are met:

    * Redistributions of source code must retain the above copyright
      notice, this list of conditions and the following disclaimer.
    * Redistributions in binary form must reproduce the above copyright
      notice, this list of conditions and the following disclaimer in the
      documentation and/or other materials provided with the distribution.

  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
  AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
  IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
  ARE DISCLAIMED. IN NO EVENT SHALL <COPYRIGHT HOLDER> BE LIABLE FOR ANY
  DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
  (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
  LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
  ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
  (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF
  THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/
var TokenName, source, index, length, lookahead;
var TokenBooleanLiteral = 1,
  TokenEOF = 2,
  TokenIdentifier = 3,
  TokenKeyword = 4,
  TokenNullLiteral = 5,
  TokenNumericLiteral = 6,
  TokenPunctuator = 7,
  TokenStringLiteral = 8,
  TokenRegularExpression = 9;
TokenName = {};
TokenName[TokenBooleanLiteral] = 'Boolean';
TokenName[TokenEOF] = '<end>';
TokenName[TokenIdentifier] = 'Identifier';
TokenName[TokenKeyword] = 'Keyword';
TokenName[TokenNullLiteral] = 'Null';
TokenName[TokenNumericLiteral] = 'Numeric';
TokenName[TokenPunctuator] = 'Punctuator';
TokenName[TokenStringLiteral] = 'String';
TokenName[TokenRegularExpression] = 'RegularExpression';
var SyntaxArrayExpression = 'ArrayExpression',
  SyntaxBinaryExpression = 'BinaryExpression',
  SyntaxCallExpression = 'CallExpression',
  SyntaxConditionalExpression = 'ConditionalExpression',
  SyntaxIdentifier = 'Identifier',
  SyntaxLiteral = 'Literal',
  SyntaxLogicalExpression = 'LogicalExpression',
  SyntaxMemberExpression = 'MemberExpression',
  SyntaxObjectExpression = 'ObjectExpression',
  SyntaxProperty = 'Property',
  SyntaxUnaryExpression = 'UnaryExpression';

// Error messages should be identical to V8.
var MessageUnexpectedToken = 'Unexpected token %0',
  MessageUnexpectedNumber = 'Unexpected number',
  MessageUnexpectedString = 'Unexpected string',
  MessageUnexpectedIdentifier = 'Unexpected identifier',
  MessageUnexpectedReserved = 'Unexpected reserved word',
  MessageUnexpectedEOS = 'Unexpected end of input',
  MessageInvalidRegExp = 'Invalid regular expression',
  MessageUnterminatedRegExp = 'Invalid regular expression: missing /',
  MessageStrictOctalLiteral = 'Octal literals are not allowed in strict mode.',
  MessageStrictDuplicateProperty = 'Duplicate data property in object literal not allowed in strict mode';
var ILLEGAL$1 = 'ILLEGAL',
  DISABLED = 'Disabled.';

// See also tools/generate-unicode-regex.py.
var RegexNonAsciiIdentifierStart = new RegExp('[\\xAA\\xB5\\xBA\\xC0-\\xD6\\xD8-\\xF6\\xF8-\\u02C1\\u02C6-\\u02D1\\u02E0-\\u02E4\\u02EC\\u02EE\\u0370-\\u0374\\u0376\\u0377\\u037A-\\u037D\\u037F\\u0386\\u0388-\\u038A\\u038C\\u038E-\\u03A1\\u03A3-\\u03F5\\u03F7-\\u0481\\u048A-\\u052F\\u0531-\\u0556\\u0559\\u0561-\\u0587\\u05D0-\\u05EA\\u05F0-\\u05F2\\u0620-\\u064A\\u066E\\u066F\\u0671-\\u06D3\\u06D5\\u06E5\\u06E6\\u06EE\\u06EF\\u06FA-\\u06FC\\u06FF\\u0710\\u0712-\\u072F\\u074D-\\u07A5\\u07B1\\u07CA-\\u07EA\\u07F4\\u07F5\\u07FA\\u0800-\\u0815\\u081A\\u0824\\u0828\\u0840-\\u0858\\u08A0-\\u08B2\\u0904-\\u0939\\u093D\\u0950\\u0958-\\u0961\\u0971-\\u0980\\u0985-\\u098C\\u098F\\u0990\\u0993-\\u09A8\\u09AA-\\u09B0\\u09B2\\u09B6-\\u09B9\\u09BD\\u09CE\\u09DC\\u09DD\\u09DF-\\u09E1\\u09F0\\u09F1\\u0A05-\\u0A0A\\u0A0F\\u0A10\\u0A13-\\u0A28\\u0A2A-\\u0A30\\u0A32\\u0A33\\u0A35\\u0A36\\u0A38\\u0A39\\u0A59-\\u0A5C\\u0A5E\\u0A72-\\u0A74\\u0A85-\\u0A8D\\u0A8F-\\u0A91\\u0A93-\\u0AA8\\u0AAA-\\u0AB0\\u0AB2\\u0AB3\\u0AB5-\\u0AB9\\u0ABD\\u0AD0\\u0AE0\\u0AE1\\u0B05-\\u0B0C\\u0B0F\\u0B10\\u0B13-\\u0B28\\u0B2A-\\u0B30\\u0B32\\u0B33\\u0B35-\\u0B39\\u0B3D\\u0B5C\\u0B5D\\u0B5F-\\u0B61\\u0B71\\u0B83\\u0B85-\\u0B8A\\u0B8E-\\u0B90\\u0B92-\\u0B95\\u0B99\\u0B9A\\u0B9C\\u0B9E\\u0B9F\\u0BA3\\u0BA4\\u0BA8-\\u0BAA\\u0BAE-\\u0BB9\\u0BD0\\u0C05-\\u0C0C\\u0C0E-\\u0C10\\u0C12-\\u0C28\\u0C2A-\\u0C39\\u0C3D\\u0C58\\u0C59\\u0C60\\u0C61\\u0C85-\\u0C8C\\u0C8E-\\u0C90\\u0C92-\\u0CA8\\u0CAA-\\u0CB3\\u0CB5-\\u0CB9\\u0CBD\\u0CDE\\u0CE0\\u0CE1\\u0CF1\\u0CF2\\u0D05-\\u0D0C\\u0D0E-\\u0D10\\u0D12-\\u0D3A\\u0D3D\\u0D4E\\u0D60\\u0D61\\u0D7A-\\u0D7F\\u0D85-\\u0D96\\u0D9A-\\u0DB1\\u0DB3-\\u0DBB\\u0DBD\\u0DC0-\\u0DC6\\u0E01-\\u0E30\\u0E32\\u0E33\\u0E40-\\u0E46\\u0E81\\u0E82\\u0E84\\u0E87\\u0E88\\u0E8A\\u0E8D\\u0E94-\\u0E97\\u0E99-\\u0E9F\\u0EA1-\\u0EA3\\u0EA5\\u0EA7\\u0EAA\\u0EAB\\u0EAD-\\u0EB0\\u0EB2\\u0EB3\\u0EBD\\u0EC0-\\u0EC4\\u0EC6\\u0EDC-\\u0EDF\\u0F00\\u0F40-\\u0F47\\u0F49-\\u0F6C\\u0F88-\\u0F8C\\u1000-\\u102A\\u103F\\u1050-\\u1055\\u105A-\\u105D\\u1061\\u1065\\u1066\\u106E-\\u1070\\u1075-\\u1081\\u108E\\u10A0-\\u10C5\\u10C7\\u10CD\\u10D0-\\u10FA\\u10FC-\\u1248\\u124A-\\u124D\\u1250-\\u1256\\u1258\\u125A-\\u125D\\u1260-\\u1288\\u128A-\\u128D\\u1290-\\u12B0\\u12B2-\\u12B5\\u12B8-\\u12BE\\u12C0\\u12C2-\\u12C5\\u12C8-\\u12D6\\u12D8-\\u1310\\u1312-\\u1315\\u1318-\\u135A\\u1380-\\u138F\\u13A0-\\u13F4\\u1401-\\u166C\\u166F-\\u167F\\u1681-\\u169A\\u16A0-\\u16EA\\u16EE-\\u16F8\\u1700-\\u170C\\u170E-\\u1711\\u1720-\\u1731\\u1740-\\u1751\\u1760-\\u176C\\u176E-\\u1770\\u1780-\\u17B3\\u17D7\\u17DC\\u1820-\\u1877\\u1880-\\u18A8\\u18AA\\u18B0-\\u18F5\\u1900-\\u191E\\u1950-\\u196D\\u1970-\\u1974\\u1980-\\u19AB\\u19C1-\\u19C7\\u1A00-\\u1A16\\u1A20-\\u1A54\\u1AA7\\u1B05-\\u1B33\\u1B45-\\u1B4B\\u1B83-\\u1BA0\\u1BAE\\u1BAF\\u1BBA-\\u1BE5\\u1C00-\\u1C23\\u1C4D-\\u1C4F\\u1C5A-\\u1C7D\\u1CE9-\\u1CEC\\u1CEE-\\u1CF1\\u1CF5\\u1CF6\\u1D00-\\u1DBF\\u1E00-\\u1F15\\u1F18-\\u1F1D\\u1F20-\\u1F45\\u1F48-\\u1F4D\\u1F50-\\u1F57\\u1F59\\u1F5B\\u1F5D\\u1F5F-\\u1F7D\\u1F80-\\u1FB4\\u1FB6-\\u1FBC\\u1FBE\\u1FC2-\\u1FC4\\u1FC6-\\u1FCC\\u1FD0-\\u1FD3\\u1FD6-\\u1FDB\\u1FE0-\\u1FEC\\u1FF2-\\u1FF4\\u1FF6-\\u1FFC\\u2071\\u207F\\u2090-\\u209C\\u2102\\u2107\\u210A-\\u2113\\u2115\\u2119-\\u211D\\u2124\\u2126\\u2128\\u212A-\\u212D\\u212F-\\u2139\\u213C-\\u213F\\u2145-\\u2149\\u214E\\u2160-\\u2188\\u2C00-\\u2C2E\\u2C30-\\u2C5E\\u2C60-\\u2CE4\\u2CEB-\\u2CEE\\u2CF2\\u2CF3\\u2D00-\\u2D25\\u2D27\\u2D2D\\u2D30-\\u2D67\\u2D6F\\u2D80-\\u2D96\\u2DA0-\\u2DA6\\u2DA8-\\u2DAE\\u2DB0-\\u2DB6\\u2DB8-\\u2DBE\\u2DC0-\\u2DC6\\u2DC8-\\u2DCE\\u2DD0-\\u2DD6\\u2DD8-\\u2DDE\\u2E2F\\u3005-\\u3007\\u3021-\\u3029\\u3031-\\u3035\\u3038-\\u303C\\u3041-\\u3096\\u309D-\\u309F\\u30A1-\\u30FA\\u30FC-\\u30FF\\u3105-\\u312D\\u3131-\\u318E\\u31A0-\\u31BA\\u31F0-\\u31FF\\u3400-\\u4DB5\\u4E00-\\u9FCC\\uA000-\\uA48C\\uA4D0-\\uA4FD\\uA500-\\uA60C\\uA610-\\uA61F\\uA62A\\uA62B\\uA640-\\uA66E\\uA67F-\\uA69D\\uA6A0-\\uA6EF\\uA717-\\uA71F\\uA722-\\uA788\\uA78B-\\uA78E\\uA790-\\uA7AD\\uA7B0\\uA7B1\\uA7F7-\\uA801\\uA803-\\uA805\\uA807-\\uA80A\\uA80C-\\uA822\\uA840-\\uA873\\uA882-\\uA8B3\\uA8F2-\\uA8F7\\uA8FB\\uA90A-\\uA925\\uA930-\\uA946\\uA960-\\uA97C\\uA984-\\uA9B2\\uA9CF\\uA9E0-\\uA9E4\\uA9E6-\\uA9EF\\uA9FA-\\uA9FE\\uAA00-\\uAA28\\uAA40-\\uAA42\\uAA44-\\uAA4B\\uAA60-\\uAA76\\uAA7A\\uAA7E-\\uAAAF\\uAAB1\\uAAB5\\uAAB6\\uAAB9-\\uAABD\\uAAC0\\uAAC2\\uAADB-\\uAADD\\uAAE0-\\uAAEA\\uAAF2-\\uAAF4\\uAB01-\\uAB06\\uAB09-\\uAB0E\\uAB11-\\uAB16\\uAB20-\\uAB26\\uAB28-\\uAB2E\\uAB30-\\uAB5A\\uAB5C-\\uAB5F\\uAB64\\uAB65\\uABC0-\\uABE2\\uAC00-\\uD7A3\\uD7B0-\\uD7C6\\uD7CB-\\uD7FB\\uF900-\\uFA6D\\uFA70-\\uFAD9\\uFB00-\\uFB06\\uFB13-\\uFB17\\uFB1D\\uFB1F-\\uFB28\\uFB2A-\\uFB36\\uFB38-\\uFB3C\\uFB3E\\uFB40\\uFB41\\uFB43\\uFB44\\uFB46-\\uFBB1\\uFBD3-\\uFD3D\\uFD50-\\uFD8F\\uFD92-\\uFDC7\\uFDF0-\\uFDFB\\uFE70-\\uFE74\\uFE76-\\uFEFC\\uFF21-\\uFF3A\\uFF41-\\uFF5A\\uFF66-\\uFFBE\\uFFC2-\\uFFC7\\uFFCA-\\uFFCF\\uFFD2-\\uFFD7\\uFFDA-\\uFFDC]'),
  // eslint-disable-next-line no-misleading-character-class
  RegexNonAsciiIdentifierPart = new RegExp('[\\xAA\\xB5\\xBA\\xC0-\\xD6\\xD8-\\xF6\\xF8-\\u02C1\\u02C6-\\u02D1\\u02E0-\\u02E4\\u02EC\\u02EE\\u0300-\\u0374\\u0376\\u0377\\u037A-\\u037D\\u037F\\u0386\\u0388-\\u038A\\u038C\\u038E-\\u03A1\\u03A3-\\u03F5\\u03F7-\\u0481\\u0483-\\u0487\\u048A-\\u052F\\u0531-\\u0556\\u0559\\u0561-\\u0587\\u0591-\\u05BD\\u05BF\\u05C1\\u05C2\\u05C4\\u05C5\\u05C7\\u05D0-\\u05EA\\u05F0-\\u05F2\\u0610-\\u061A\\u0620-\\u0669\\u066E-\\u06D3\\u06D5-\\u06DC\\u06DF-\\u06E8\\u06EA-\\u06FC\\u06FF\\u0710-\\u074A\\u074D-\\u07B1\\u07C0-\\u07F5\\u07FA\\u0800-\\u082D\\u0840-\\u085B\\u08A0-\\u08B2\\u08E4-\\u0963\\u0966-\\u096F\\u0971-\\u0983\\u0985-\\u098C\\u098F\\u0990\\u0993-\\u09A8\\u09AA-\\u09B0\\u09B2\\u09B6-\\u09B9\\u09BC-\\u09C4\\u09C7\\u09C8\\u09CB-\\u09CE\\u09D7\\u09DC\\u09DD\\u09DF-\\u09E3\\u09E6-\\u09F1\\u0A01-\\u0A03\\u0A05-\\u0A0A\\u0A0F\\u0A10\\u0A13-\\u0A28\\u0A2A-\\u0A30\\u0A32\\u0A33\\u0A35\\u0A36\\u0A38\\u0A39\\u0A3C\\u0A3E-\\u0A42\\u0A47\\u0A48\\u0A4B-\\u0A4D\\u0A51\\u0A59-\\u0A5C\\u0A5E\\u0A66-\\u0A75\\u0A81-\\u0A83\\u0A85-\\u0A8D\\u0A8F-\\u0A91\\u0A93-\\u0AA8\\u0AAA-\\u0AB0\\u0AB2\\u0AB3\\u0AB5-\\u0AB9\\u0ABC-\\u0AC5\\u0AC7-\\u0AC9\\u0ACB-\\u0ACD\\u0AD0\\u0AE0-\\u0AE3\\u0AE6-\\u0AEF\\u0B01-\\u0B03\\u0B05-\\u0B0C\\u0B0F\\u0B10\\u0B13-\\u0B28\\u0B2A-\\u0B30\\u0B32\\u0B33\\u0B35-\\u0B39\\u0B3C-\\u0B44\\u0B47\\u0B48\\u0B4B-\\u0B4D\\u0B56\\u0B57\\u0B5C\\u0B5D\\u0B5F-\\u0B63\\u0B66-\\u0B6F\\u0B71\\u0B82\\u0B83\\u0B85-\\u0B8A\\u0B8E-\\u0B90\\u0B92-\\u0B95\\u0B99\\u0B9A\\u0B9C\\u0B9E\\u0B9F\\u0BA3\\u0BA4\\u0BA8-\\u0BAA\\u0BAE-\\u0BB9\\u0BBE-\\u0BC2\\u0BC6-\\u0BC8\\u0BCA-\\u0BCD\\u0BD0\\u0BD7\\u0BE6-\\u0BEF\\u0C00-\\u0C03\\u0C05-\\u0C0C\\u0C0E-\\u0C10\\u0C12-\\u0C28\\u0C2A-\\u0C39\\u0C3D-\\u0C44\\u0C46-\\u0C48\\u0C4A-\\u0C4D\\u0C55\\u0C56\\u0C58\\u0C59\\u0C60-\\u0C63\\u0C66-\\u0C6F\\u0C81-\\u0C83\\u0C85-\\u0C8C\\u0C8E-\\u0C90\\u0C92-\\u0CA8\\u0CAA-\\u0CB3\\u0CB5-\\u0CB9\\u0CBC-\\u0CC4\\u0CC6-\\u0CC8\\u0CCA-\\u0CCD\\u0CD5\\u0CD6\\u0CDE\\u0CE0-\\u0CE3\\u0CE6-\\u0CEF\\u0CF1\\u0CF2\\u0D01-\\u0D03\\u0D05-\\u0D0C\\u0D0E-\\u0D10\\u0D12-\\u0D3A\\u0D3D-\\u0D44\\u0D46-\\u0D48\\u0D4A-\\u0D4E\\u0D57\\u0D60-\\u0D63\\u0D66-\\u0D6F\\u0D7A-\\u0D7F\\u0D82\\u0D83\\u0D85-\\u0D96\\u0D9A-\\u0DB1\\u0DB3-\\u0DBB\\u0DBD\\u0DC0-\\u0DC6\\u0DCA\\u0DCF-\\u0DD4\\u0DD6\\u0DD8-\\u0DDF\\u0DE6-\\u0DEF\\u0DF2\\u0DF3\\u0E01-\\u0E3A\\u0E40-\\u0E4E\\u0E50-\\u0E59\\u0E81\\u0E82\\u0E84\\u0E87\\u0E88\\u0E8A\\u0E8D\\u0E94-\\u0E97\\u0E99-\\u0E9F\\u0EA1-\\u0EA3\\u0EA5\\u0EA7\\u0EAA\\u0EAB\\u0EAD-\\u0EB9\\u0EBB-\\u0EBD\\u0EC0-\\u0EC4\\u0EC6\\u0EC8-\\u0ECD\\u0ED0-\\u0ED9\\u0EDC-\\u0EDF\\u0F00\\u0F18\\u0F19\\u0F20-\\u0F29\\u0F35\\u0F37\\u0F39\\u0F3E-\\u0F47\\u0F49-\\u0F6C\\u0F71-\\u0F84\\u0F86-\\u0F97\\u0F99-\\u0FBC\\u0FC6\\u1000-\\u1049\\u1050-\\u109D\\u10A0-\\u10C5\\u10C7\\u10CD\\u10D0-\\u10FA\\u10FC-\\u1248\\u124A-\\u124D\\u1250-\\u1256\\u1258\\u125A-\\u125D\\u1260-\\u1288\\u128A-\\u128D\\u1290-\\u12B0\\u12B2-\\u12B5\\u12B8-\\u12BE\\u12C0\\u12C2-\\u12C5\\u12C8-\\u12D6\\u12D8-\\u1310\\u1312-\\u1315\\u1318-\\u135A\\u135D-\\u135F\\u1380-\\u138F\\u13A0-\\u13F4\\u1401-\\u166C\\u166F-\\u167F\\u1681-\\u169A\\u16A0-\\u16EA\\u16EE-\\u16F8\\u1700-\\u170C\\u170E-\\u1714\\u1720-\\u1734\\u1740-\\u1753\\u1760-\\u176C\\u176E-\\u1770\\u1772\\u1773\\u1780-\\u17D3\\u17D7\\u17DC\\u17DD\\u17E0-\\u17E9\\u180B-\\u180D\\u1810-\\u1819\\u1820-\\u1877\\u1880-\\u18AA\\u18B0-\\u18F5\\u1900-\\u191E\\u1920-\\u192B\\u1930-\\u193B\\u1946-\\u196D\\u1970-\\u1974\\u1980-\\u19AB\\u19B0-\\u19C9\\u19D0-\\u19D9\\u1A00-\\u1A1B\\u1A20-\\u1A5E\\u1A60-\\u1A7C\\u1A7F-\\u1A89\\u1A90-\\u1A99\\u1AA7\\u1AB0-\\u1ABD\\u1B00-\\u1B4B\\u1B50-\\u1B59\\u1B6B-\\u1B73\\u1B80-\\u1BF3\\u1C00-\\u1C37\\u1C40-\\u1C49\\u1C4D-\\u1C7D\\u1CD0-\\u1CD2\\u1CD4-\\u1CF6\\u1CF8\\u1CF9\\u1D00-\\u1DF5\\u1DFC-\\u1F15\\u1F18-\\u1F1D\\u1F20-\\u1F45\\u1F48-\\u1F4D\\u1F50-\\u1F57\\u1F59\\u1F5B\\u1F5D\\u1F5F-\\u1F7D\\u1F80-\\u1FB4\\u1FB6-\\u1FBC\\u1FBE\\u1FC2-\\u1FC4\\u1FC6-\\u1FCC\\u1FD0-\\u1FD3\\u1FD6-\\u1FDB\\u1FE0-\\u1FEC\\u1FF2-\\u1FF4\\u1FF6-\\u1FFC\\u200C\\u200D\\u203F\\u2040\\u2054\\u2071\\u207F\\u2090-\\u209C\\u20D0-\\u20DC\\u20E1\\u20E5-\\u20F0\\u2102\\u2107\\u210A-\\u2113\\u2115\\u2119-\\u211D\\u2124\\u2126\\u2128\\u212A-\\u212D\\u212F-\\u2139\\u213C-\\u213F\\u2145-\\u2149\\u214E\\u2160-\\u2188\\u2C00-\\u2C2E\\u2C30-\\u2C5E\\u2C60-\\u2CE4\\u2CEB-\\u2CF3\\u2D00-\\u2D25\\u2D27\\u2D2D\\u2D30-\\u2D67\\u2D6F\\u2D7F-\\u2D96\\u2DA0-\\u2DA6\\u2DA8-\\u2DAE\\u2DB0-\\u2DB6\\u2DB8-\\u2DBE\\u2DC0-\\u2DC6\\u2DC8-\\u2DCE\\u2DD0-\\u2DD6\\u2DD8-\\u2DDE\\u2DE0-\\u2DFF\\u2E2F\\u3005-\\u3007\\u3021-\\u302F\\u3031-\\u3035\\u3038-\\u303C\\u3041-\\u3096\\u3099\\u309A\\u309D-\\u309F\\u30A1-\\u30FA\\u30FC-\\u30FF\\u3105-\\u312D\\u3131-\\u318E\\u31A0-\\u31BA\\u31F0-\\u31FF\\u3400-\\u4DB5\\u4E00-\\u9FCC\\uA000-\\uA48C\\uA4D0-\\uA4FD\\uA500-\\uA60C\\uA610-\\uA62B\\uA640-\\uA66F\\uA674-\\uA67D\\uA67F-\\uA69D\\uA69F-\\uA6F1\\uA717-\\uA71F\\uA722-\\uA788\\uA78B-\\uA78E\\uA790-\\uA7AD\\uA7B0\\uA7B1\\uA7F7-\\uA827\\uA840-\\uA873\\uA880-\\uA8C4\\uA8D0-\\uA8D9\\uA8E0-\\uA8F7\\uA8FB\\uA900-\\uA92D\\uA930-\\uA953\\uA960-\\uA97C\\uA980-\\uA9C0\\uA9CF-\\uA9D9\\uA9E0-\\uA9FE\\uAA00-\\uAA36\\uAA40-\\uAA4D\\uAA50-\\uAA59\\uAA60-\\uAA76\\uAA7A-\\uAAC2\\uAADB-\\uAADD\\uAAE0-\\uAAEF\\uAAF2-\\uAAF6\\uAB01-\\uAB06\\uAB09-\\uAB0E\\uAB11-\\uAB16\\uAB20-\\uAB26\\uAB28-\\uAB2E\\uAB30-\\uAB5A\\uAB5C-\\uAB5F\\uAB64\\uAB65\\uABC0-\\uABEA\\uABEC\\uABED\\uABF0-\\uABF9\\uAC00-\\uD7A3\\uD7B0-\\uD7C6\\uD7CB-\\uD7FB\\uF900-\\uFA6D\\uFA70-\\uFAD9\\uFB00-\\uFB06\\uFB13-\\uFB17\\uFB1D-\\uFB28\\uFB2A-\\uFB36\\uFB38-\\uFB3C\\uFB3E\\uFB40\\uFB41\\uFB43\\uFB44\\uFB46-\\uFBB1\\uFBD3-\\uFD3D\\uFD50-\\uFD8F\\uFD92-\\uFDC7\\uFDF0-\\uFDFB\\uFE00-\\uFE0F\\uFE20-\\uFE2D\\uFE33\\uFE34\\uFE4D-\\uFE4F\\uFE70-\\uFE74\\uFE76-\\uFEFC\\uFF10-\\uFF19\\uFF21-\\uFF3A\\uFF3F\\uFF41-\\uFF5A\\uFF66-\\uFFBE\\uFFC2-\\uFFC7\\uFFCA-\\uFFCF\\uFFD2-\\uFFD7\\uFFDA-\\uFFDC]');

// Ensure the condition is true, otherwise throw an error.
// This is only to have a better contract semantic, i.e. another safety net
// to catch a logic error. The condition shall be fulfilled in normal case.
// Do NOT use this to enforce a certain condition on any user input.

function assert(condition, message) {
  /* istanbul ignore next */
  if (!condition) {
    throw new Error('ASSERT: ' + message);
  }
}
function isDecimalDigit(ch) {
  return ch >= 0x30 && ch <= 0x39; // 0..9
}
function isHexDigit(ch) {
  return '0123456789abcdefABCDEF'.includes(ch);
}
function isOctalDigit(ch) {
  return '01234567'.includes(ch);
}

// 7.2 White Space

function isWhiteSpace(ch) {
  return ch === 0x20 || ch === 0x09 || ch === 0x0B || ch === 0x0C || ch === 0xA0 || ch >= 0x1680 && [0x1680, 0x180E, 0x2000, 0x2001, 0x2002, 0x2003, 0x2004, 0x2005, 0x2006, 0x2007, 0x2008, 0x2009, 0x200A, 0x202F, 0x205F, 0x3000, 0xFEFF].includes(ch);
}

// 7.3 Line Terminators

function isLineTerminator(ch) {
  return ch === 0x0A || ch === 0x0D || ch === 0x2028 || ch === 0x2029;
}

// 7.6 Identifier Names and Identifiers

function isIdentifierStart(ch) {
  return ch === 0x24 || ch === 0x5F ||
  // $ (dollar) and _ (underscore)
  ch >= 0x41 && ch <= 0x5A ||
  // A..Z
  ch >= 0x61 && ch <= 0x7A ||
  // a..z
  ch === 0x5C ||
  // \ (backslash)
  ch >= 0x80 && RegexNonAsciiIdentifierStart.test(String.fromCharCode(ch));
}
function isIdentifierPart(ch) {
  return ch === 0x24 || ch === 0x5F ||
  // $ (dollar) and _ (underscore)
  ch >= 0x41 && ch <= 0x5A ||
  // A..Z
  ch >= 0x61 && ch <= 0x7A ||
  // a..z
  ch >= 0x30 && ch <= 0x39 ||
  // 0..9
  ch === 0x5C ||
  // \ (backslash)
  ch >= 0x80 && RegexNonAsciiIdentifierPart.test(String.fromCharCode(ch));
}

// 7.6.1.1 Keywords

const keywords = {
  'if': 1,
  'in': 1,
  'do': 1,
  'var': 1,
  'for': 1,
  'new': 1,
  'try': 1,
  'let': 1,
  'this': 1,
  'else': 1,
  'case': 1,
  'void': 1,
  'with': 1,
  'enum': 1,
  'while': 1,
  'break': 1,
  'catch': 1,
  'throw': 1,
  'const': 1,
  'yield': 1,
  'class': 1,
  'super': 1,
  'return': 1,
  'typeof': 1,
  'delete': 1,
  'switch': 1,
  'export': 1,
  'import': 1,
  'public': 1,
  'static': 1,
  'default': 1,
  'finally': 1,
  'extends': 1,
  'package': 1,
  'private': 1,
  'function': 1,
  'continue': 1,
  'debugger': 1,
  'interface': 1,
  'protected': 1,
  'instanceof': 1,
  'implements': 1
};
function skipComment() {
  while (index < length) {
    const ch = source.charCodeAt(index);
    if (isWhiteSpace(ch) || isLineTerminator(ch)) {
      ++index;
    } else {
      break;
    }
  }
}
function scanHexEscape(prefix) {
  var i,
    len,
    ch,
    code = 0;
  len = prefix === 'u' ? 4 : 2;
  for (i = 0; i < len; ++i) {
    if (index < length && isHexDigit(source[index])) {
      ch = source[index++];
      code = code * 16 + '0123456789abcdef'.indexOf(ch.toLowerCase());
    } else {
      throwError({}, MessageUnexpectedToken, ILLEGAL$1);
    }
  }
  return String.fromCharCode(code);
}
function scanUnicodeCodePointEscape() {
  var ch, code, cu1, cu2;
  ch = source[index];
  code = 0;

  // At least, one hex digit is required.
  if (ch === '}') {
    throwError({}, MessageUnexpectedToken, ILLEGAL$1);
  }
  while (index < length) {
    ch = source[index++];
    if (!isHexDigit(ch)) {
      break;
    }
    code = code * 16 + '0123456789abcdef'.indexOf(ch.toLowerCase());
  }
  if (code > 0x10FFFF || ch !== '}') {
    throwError({}, MessageUnexpectedToken, ILLEGAL$1);
  }

  // UTF-16 Encoding
  if (code <= 0xFFFF) {
    return String.fromCharCode(code);
  }
  cu1 = (code - 0x10000 >> 10) + 0xD800;
  cu2 = (code - 0x10000 & 1023) + 0xDC00;
  return String.fromCharCode(cu1, cu2);
}
function getEscapedIdentifier() {
  var ch, id;
  ch = source.charCodeAt(index++);
  id = String.fromCharCode(ch);

  // '\u' (U+005C, U+0075) denotes an escaped character.
  if (ch === 0x5C) {
    if (source.charCodeAt(index) !== 0x75) {
      throwError({}, MessageUnexpectedToken, ILLEGAL$1);
    }
    ++index;
    ch = scanHexEscape('u');
    if (!ch || ch === '\\' || !isIdentifierStart(ch.charCodeAt(0))) {
      throwError({}, MessageUnexpectedToken, ILLEGAL$1);
    }
    id = ch;
  }
  while (index < length) {
    ch = source.charCodeAt(index);
    if (!isIdentifierPart(ch)) {
      break;
    }
    ++index;
    id += String.fromCharCode(ch);

    // '\u' (U+005C, U+0075) denotes an escaped character.
    if (ch === 0x5C) {
      id = id.substr(0, id.length - 1);
      if (source.charCodeAt(index) !== 0x75) {
        throwError({}, MessageUnexpectedToken, ILLEGAL$1);
      }
      ++index;
      ch = scanHexEscape('u');
      if (!ch || ch === '\\' || !isIdentifierPart(ch.charCodeAt(0))) {
        throwError({}, MessageUnexpectedToken, ILLEGAL$1);
      }
      id += ch;
    }
  }
  return id;
}
function getIdentifier() {
  var start, ch;
  start = index++;
  while (index < length) {
    ch = source.charCodeAt(index);
    if (ch === 0x5C) {
      // Blackslash (U+005C) marks Unicode escape sequence.
      index = start;
      return getEscapedIdentifier();
    }
    if (isIdentifierPart(ch)) {
      ++index;
    } else {
      break;
    }
  }
  return source.slice(start, index);
}
function scanIdentifier() {
  var start, id, type;
  start = index;

  // Backslash (U+005C) starts an escaped character.
  id = source.charCodeAt(index) === 0x5C ? getEscapedIdentifier() : getIdentifier();

  // There is no keyword or literal with only one character.
  // Thus, it must be an identifier.
  if (id.length === 1) {
    type = TokenIdentifier;
  } else if (keywords.hasOwnProperty(id)) {
    // eslint-disable-line no-prototype-builtins
    type = TokenKeyword;
  } else if (id === 'null') {
    type = TokenNullLiteral;
  } else if (id === 'true' || id === 'false') {
    type = TokenBooleanLiteral;
  } else {
    type = TokenIdentifier;
  }
  return {
    type: type,
    value: id,
    start: start,
    end: index
  };
}

// 7.7 Punctuators

function scanPunctuator() {
  var start = index,
    code = source.charCodeAt(index),
    code2,
    ch1 = source[index],
    ch2,
    ch3,
    ch4;
  switch (code) {
    // Check for most common single-character punctuators.
    case 0x2E: // . dot
    case 0x28: // ( open bracket
    case 0x29: // ) close bracket
    case 0x3B: // ; semicolon
    case 0x2C: // , comma
    case 0x7B: // { open curly brace
    case 0x7D: // } close curly brace
    case 0x5B: // [
    case 0x5D: // ]
    case 0x3A: // :
    case 0x3F: // ?
    case 0x7E:
      // ~
      ++index;
      return {
        type: TokenPunctuator,
        value: String.fromCharCode(code),
        start: start,
        end: index
      };
    default:
      code2 = source.charCodeAt(index + 1);

      // '=' (U+003D) marks an assignment or comparison operator.
      if (code2 === 0x3D) {
        switch (code) {
          case 0x2B: // +
          case 0x2D: // -
          case 0x2F: // /
          case 0x3C: // <
          case 0x3E: // >
          case 0x5E: // ^
          case 0x7C: // |
          case 0x25: // %
          case 0x26: // &
          case 0x2A:
            // *
            index += 2;
            return {
              type: TokenPunctuator,
              value: String.fromCharCode(code) + String.fromCharCode(code2),
              start: start,
              end: index
            };
          case 0x21: // !
          case 0x3D:
            // =
            index += 2;

            // !== and ===
            if (source.charCodeAt(index) === 0x3D) {
              ++index;
            }
            return {
              type: TokenPunctuator,
              value: source.slice(start, index),
              start: start,
              end: index
            };
        }
      }
  }

  // 4-character punctuator: >>>=

  ch4 = source.substr(index, 4);
  if (ch4 === '>>>=') {
    index += 4;
    return {
      type: TokenPunctuator,
      value: ch4,
      start: start,
      end: index
    };
  }

  // 3-character punctuators: === !== >>> <<= >>=

  ch3 = ch4.substr(0, 3);
  if (ch3 === '>>>' || ch3 === '<<=' || ch3 === '>>=') {
    index += 3;
    return {
      type: TokenPunctuator,
      value: ch3,
      start: start,
      end: index
    };
  }

  // Other 2-character punctuators: ++ -- << >> && ||
  ch2 = ch3.substr(0, 2);
  if (ch1 === ch2[1] && '+-<>&|'.includes(ch1) || ch2 === '=>') {
    index += 2;
    return {
      type: TokenPunctuator,
      value: ch2,
      start: start,
      end: index
    };
  }
  if (ch2 === '//') {
    throwError({}, MessageUnexpectedToken, ILLEGAL$1);
  }

  // 1-character punctuators: < > = ! + - * % & | ^ /

  if ('<>=!+-*%&|^/'.includes(ch1)) {
    ++index;
    return {
      type: TokenPunctuator,
      value: ch1,
      start: start,
      end: index
    };
  }
  throwError({}, MessageUnexpectedToken, ILLEGAL$1);
}

// 7.8.3 Numeric Literals

function scanHexLiteral(start) {
  let number = '';
  while (index < length) {
    if (!isHexDigit(source[index])) {
      break;
    }
    number += source[index++];
  }
  if (number.length === 0) {
    throwError({}, MessageUnexpectedToken, ILLEGAL$1);
  }
  if (isIdentifierStart(source.charCodeAt(index))) {
    throwError({}, MessageUnexpectedToken, ILLEGAL$1);
  }
  return {
    type: TokenNumericLiteral,
    value: parseInt('0x' + number, 16),
    start: start,
    end: index
  };
}
function scanOctalLiteral(start) {
  let number = '0' + source[index++];
  while (index < length) {
    if (!isOctalDigit(source[index])) {
      break;
    }
    number += source[index++];
  }
  if (isIdentifierStart(source.charCodeAt(index)) || isDecimalDigit(source.charCodeAt(index))) {
    throwError({}, MessageUnexpectedToken, ILLEGAL$1);
  }
  return {
    type: TokenNumericLiteral,
    value: parseInt(number, 8),
    octal: true,
    start: start,
    end: index
  };
}
function scanNumericLiteral() {
  var number, start, ch;
  ch = source[index];
  assert(isDecimalDigit(ch.charCodeAt(0)) || ch === '.', 'Numeric literal must start with a decimal digit or a decimal point');
  start = index;
  number = '';
  if (ch !== '.') {
    number = source[index++];
    ch = source[index];

    // Hex number starts with '0x'.
    // Octal number starts with '0'.
    if (number === '0') {
      if (ch === 'x' || ch === 'X') {
        ++index;
        return scanHexLiteral(start);
      }
      if (isOctalDigit(ch)) {
        return scanOctalLiteral(start);
      }

      // decimal number starts with '0' such as '09' is illegal.
      if (ch && isDecimalDigit(ch.charCodeAt(0))) {
        throwError({}, MessageUnexpectedToken, ILLEGAL$1);
      }
    }
    while (isDecimalDigit(source.charCodeAt(index))) {
      number += source[index++];
    }
    ch = source[index];
  }
  if (ch === '.') {
    number += source[index++];
    while (isDecimalDigit(source.charCodeAt(index))) {
      number += source[index++];
    }
    ch = source[index];
  }
  if (ch === 'e' || ch === 'E') {
    number += source[index++];
    ch = source[index];
    if (ch === '+' || ch === '-') {
      number += source[index++];
    }
    if (isDecimalDigit(source.charCodeAt(index))) {
      while (isDecimalDigit(source.charCodeAt(index))) {
        number += source[index++];
      }
    } else {
      throwError({}, MessageUnexpectedToken, ILLEGAL$1);
    }
  }
  if (isIdentifierStart(source.charCodeAt(index))) {
    throwError({}, MessageUnexpectedToken, ILLEGAL$1);
  }
  return {
    type: TokenNumericLiteral,
    value: parseFloat(number),
    start: start,
    end: index
  };
}

// 7.8.4 String Literals

function scanStringLiteral() {
  var str = '',
    quote,
    start,
    ch,
    code,
    octal = false;
  quote = source[index];
  assert(quote === '\'' || quote === '"', 'String literal must starts with a quote');
  start = index;
  ++index;
  while (index < length) {
    ch = source[index++];
    if (ch === quote) {
      quote = '';
      break;
    } else if (ch === '\\') {
      ch = source[index++];
      if (!ch || !isLineTerminator(ch.charCodeAt(0))) {
        switch (ch) {
          case 'u':
          case 'x':
            if (source[index] === '{') {
              ++index;
              str += scanUnicodeCodePointEscape();
            } else {
              str += scanHexEscape(ch);
            }
            break;
          case 'n':
            str += '\n';
            break;
          case 'r':
            str += '\r';
            break;
          case 't':
            str += '\t';
            break;
          case 'b':
            str += '\b';
            break;
          case 'f':
            str += '\f';
            break;
          case 'v':
            str += '\x0B';
            break;
          default:
            if (isOctalDigit(ch)) {
              code = '01234567'.indexOf(ch);

              // \0 is not octal escape sequence
              if (code !== 0) {
                octal = true;
              }
              if (index < length && isOctalDigit(source[index])) {
                octal = true;
                code = code * 8 + '01234567'.indexOf(source[index++]);

                // 3 digits are only allowed when string starts
                // with 0, 1, 2, 3
                if ('0123'.includes(ch) && index < length && isOctalDigit(source[index])) {
                  code = code * 8 + '01234567'.indexOf(source[index++]);
                }
              }
              str += String.fromCharCode(code);
            } else {
              str += ch;
            }
            break;
        }
      } else {
        if (ch === '\r' && source[index] === '\n') {
          ++index;
        }
      }
    } else if (isLineTerminator(ch.charCodeAt(0))) {
      break;
    } else {
      str += ch;
    }
  }
  if (quote !== '') {
    throwError({}, MessageUnexpectedToken, ILLEGAL$1);
  }
  return {
    type: TokenStringLiteral,
    value: str,
    octal: octal,
    start: start,
    end: index
  };
}
function testRegExp(pattern, flags) {
  let tmp = pattern;
  if (flags.includes('u')) {
    // Replace each astral symbol and every Unicode code point
    // escape sequence with a single ASCII symbol to avoid throwing on
    // regular expressions that are only valid in combination with the
    // `/u` flag.
    // Note: replacing with the ASCII symbol `x` might cause false
    // negatives in unlikely scenarios. For example, `[\u{61}-b]` is a
    // perfectly valid pattern that is equivalent to `[a-b]`, but it
    // would be replaced by `[x-b]` which throws an error.
    tmp = tmp.replace(/\\u\{([0-9a-fA-F]+)\}/g, ($0, $1) => {
      if (parseInt($1, 16) <= 0x10FFFF) {
        return 'x';
      }
      throwError({}, MessageInvalidRegExp);
    }).replace(/[\uD800-\uDBFF][\uDC00-\uDFFF]/g, 'x');
  }

  // First, detect invalid regular expressions.
  try {
    new RegExp(tmp);
  } catch (e) {
    throwError({}, MessageInvalidRegExp);
  }

  // Return a regular expression object for this pattern-flag pair, or
  // `null` in case the current environment doesn't support the flags it
  // uses.
  try {
    return new RegExp(pattern, flags);
  } catch (exception) {
    return null;
  }
}
function scanRegExpBody() {
  var ch, str, classMarker, terminated, body;
  ch = source[index];
  assert(ch === '/', 'Regular expression literal must start with a slash');
  str = source[index++];
  classMarker = false;
  terminated = false;
  while (index < length) {
    ch = source[index++];
    str += ch;
    if (ch === '\\') {
      ch = source[index++];
      // ECMA-262 7.8.5
      if (isLineTerminator(ch.charCodeAt(0))) {
        throwError({}, MessageUnterminatedRegExp);
      }
      str += ch;
    } else if (isLineTerminator(ch.charCodeAt(0))) {
      throwError({}, MessageUnterminatedRegExp);
    } else if (classMarker) {
      if (ch === ']') {
        classMarker = false;
      }
    } else {
      if (ch === '/') {
        terminated = true;
        break;
      } else if (ch === '[') {
        classMarker = true;
      }
    }
  }
  if (!terminated) {
    throwError({}, MessageUnterminatedRegExp);
  }

  // Exclude leading and trailing slash.
  body = str.substr(1, str.length - 2);
  return {
    value: body,
    literal: str
  };
}
function scanRegExpFlags() {
  var ch, str, flags;
  str = '';
  flags = '';
  while (index < length) {
    ch = source[index];
    if (!isIdentifierPart(ch.charCodeAt(0))) {
      break;
    }
    ++index;
    if (ch === '\\' && index < length) {
      throwError({}, MessageUnexpectedToken, ILLEGAL$1);
    } else {
      flags += ch;
      str += ch;
    }
  }
  if (flags.search(/[^gimuy]/g) >= 0) {
    throwError({}, MessageInvalidRegExp, flags);
  }
  return {
    value: flags,
    literal: str
  };
}
function scanRegExp() {
  var start, body, flags, value;
  lookahead = null;
  skipComment();
  start = index;
  body = scanRegExpBody();
  flags = scanRegExpFlags();
  value = testRegExp(body.value, flags.value);
  return {
    literal: body.literal + flags.literal,
    value: value,
    regex: {
      pattern: body.value,
      flags: flags.value
    },
    start: start,
    end: index
  };
}
function isIdentifierName(token) {
  return token.type === TokenIdentifier || token.type === TokenKeyword || token.type === TokenBooleanLiteral || token.type === TokenNullLiteral;
}
function advance() {
  skipComment();
  if (index >= length) {
    return {
      type: TokenEOF,
      start: index,
      end: index
    };
  }
  const ch = source.charCodeAt(index);
  if (isIdentifierStart(ch)) {
    return scanIdentifier();
  }

  // Very common: ( and ) and ;
  if (ch === 0x28 || ch === 0x29 || ch === 0x3B) {
    return scanPunctuator();
  }

  // String literal starts with single quote (U+0027) or double quote (U+0022).
  if (ch === 0x27 || ch === 0x22) {
    return scanStringLiteral();
  }

  // Dot (.) U+002E can also start a floating-point number, hence the need
  // to check the next character.
  if (ch === 0x2E) {
    if (isDecimalDigit(source.charCodeAt(index + 1))) {
      return scanNumericLiteral();
    }
    return scanPunctuator();
  }
  if (isDecimalDigit(ch)) {
    return scanNumericLiteral();
  }
  return scanPunctuator();
}
function lex() {
  const token = lookahead;
  index = token.end;
  lookahead = advance();
  index = token.end;
  return token;
}
function peek() {
  const pos = index;
  lookahead = advance();
  index = pos;
}
function finishArrayExpression(elements) {
  const node = new ASTNode(SyntaxArrayExpression);
  node.elements = elements;
  return node;
}
function finishBinaryExpression(operator, left, right) {
  const node = new ASTNode(operator === '||' || operator === '&&' ? SyntaxLogicalExpression : SyntaxBinaryExpression);
  node.operator = operator;
  node.left = left;
  node.right = right;
  return node;
}
function finishCallExpression(callee, args) {
  const node = new ASTNode(SyntaxCallExpression);
  node.callee = callee;
  node.arguments = args;
  return node;
}
function finishConditionalExpression(test, consequent, alternate) {
  const node = new ASTNode(SyntaxConditionalExpression);
  node.test = test;
  node.consequent = consequent;
  node.alternate = alternate;
  return node;
}
function finishIdentifier(name) {
  const node = new ASTNode(SyntaxIdentifier);
  node.name = name;
  return node;
}
function finishLiteral(token) {
  const node = new ASTNode(SyntaxLiteral);
  node.value = token.value;
  node.raw = source.slice(token.start, token.end);
  if (token.regex) {
    if (node.raw === '//') {
      node.raw = '/(?:)/';
    }
    node.regex = token.regex;
  }
  return node;
}
function finishMemberExpression(accessor, object, property) {
  const node = new ASTNode(SyntaxMemberExpression);
  node.computed = accessor === '[';
  node.object = object;
  node.property = property;
  if (!node.computed) property.member = true;
  return node;
}
function finishObjectExpression(properties) {
  const node = new ASTNode(SyntaxObjectExpression);
  node.properties = properties;
  return node;
}
function finishProperty(kind, key, value) {
  const node = new ASTNode(SyntaxProperty);
  node.key = key;
  node.value = value;
  node.kind = kind;
  return node;
}
function finishUnaryExpression(operator, argument) {
  const node = new ASTNode(SyntaxUnaryExpression);
  node.operator = operator;
  node.argument = argument;
  node.prefix = true;
  return node;
}

// Throw an exception

function throwError(token, messageFormat) {
  var error,
    args = Array.prototype.slice.call(arguments, 2),
    msg = messageFormat.replace(/%(\d)/g, (whole, index) => {
      assert(index < args.length, 'Message reference must be in range');
      return args[index];
    });
  error = new Error(msg);
  error.index = index;
  error.description = msg;
  throw error;
}

// Throw an exception because of the token.

function throwUnexpected(token) {
  if (token.type === TokenEOF) {
    throwError(token, MessageUnexpectedEOS);
  }
  if (token.type === TokenNumericLiteral) {
    throwError(token, MessageUnexpectedNumber);
  }
  if (token.type === TokenStringLiteral) {
    throwError(token, MessageUnexpectedString);
  }
  if (token.type === TokenIdentifier) {
    throwError(token, MessageUnexpectedIdentifier);
  }
  if (token.type === TokenKeyword) {
    throwError(token, MessageUnexpectedReserved);
  }

  // BooleanLiteral, NullLiteral, or Punctuator.
  throwError(token, MessageUnexpectedToken, token.value);
}

// Expect the next token to match the specified punctuator.
// If not, an exception will be thrown.

function expect(value) {
  const token = lex();
  if (token.type !== TokenPunctuator || token.value !== value) {
    throwUnexpected(token);
  }
}

// Return true if the next token matches the specified punctuator.

function match(value) {
  return lookahead.type === TokenPunctuator && lookahead.value === value;
}

// Return true if the next token matches the specified keyword

function matchKeyword(keyword) {
  return lookahead.type === TokenKeyword && lookahead.value === keyword;
}

// 11.1.4 Array Initialiser

function parseArrayInitialiser() {
  const elements = [];
  index = lookahead.start;
  expect('[');
  while (!match(']')) {
    if (match(',')) {
      lex();
      elements.push(null);
    } else {
      elements.push(parseConditionalExpression());
      if (!match(']')) {
        expect(',');
      }
    }
  }
  lex();
  return finishArrayExpression(elements);
}

// 11.1.5 Object Initialiser

function parseObjectPropertyKey() {
  index = lookahead.start;
  const token = lex();

  // Note: This function is called only from parseObjectProperty(), where
  // EOF and Punctuator tokens are already filtered out.

  if (token.type === TokenStringLiteral || token.type === TokenNumericLiteral) {
    if (token.octal) {
      throwError(token, MessageStrictOctalLiteral);
    }
    return finishLiteral(token);
  }
  return finishIdentifier(token.value);
}
function parseObjectProperty() {
  var token, key, id, value;
  index = lookahead.start;
  token = lookahead;
  if (token.type === TokenIdentifier) {
    id = parseObjectPropertyKey();
    expect(':');
    value = parseConditionalExpression();
    return finishProperty('init', id, value);
  }
  if (token.type === TokenEOF || token.type === TokenPunctuator) {
    throwUnexpected(token);
  } else {
    key = parseObjectPropertyKey();
    expect(':');
    value = parseConditionalExpression();
    return finishProperty('init', key, value);
  }
}
function parseObjectInitialiser() {
  var properties = [],
    property,
    name,
    key,
    map = {},
    toString = String;
  index = lookahead.start;
  expect('{');
  while (!match('}')) {
    property = parseObjectProperty();
    if (property.key.type === SyntaxIdentifier) {
      name = property.key.name;
    } else {
      name = toString(property.key.value);
    }
    key = '$' + name;
    if (Object.prototype.hasOwnProperty.call(map, key)) {
      throwError({}, MessageStrictDuplicateProperty);
    } else {
      map[key] = true;
    }
    properties.push(property);
    if (!match('}')) {
      expect(',');
    }
  }
  expect('}');
  return finishObjectExpression(properties);
}

// 11.1.6 The Grouping Operator

function parseGroupExpression() {
  expect('(');
  const expr = parseExpression();
  expect(')');
  return expr;
}

// 11.1 Primary Expressions

const legalKeywords = {
  'if': 1
};
function parsePrimaryExpression() {
  var type, token, expr;
  if (match('(')) {
    return parseGroupExpression();
  }
  if (match('[')) {
    return parseArrayInitialiser();
  }
  if (match('{')) {
    return parseObjectInitialiser();
  }
  type = lookahead.type;
  index = lookahead.start;
  if (type === TokenIdentifier || legalKeywords[lookahead.value]) {
    expr = finishIdentifier(lex().value);
  } else if (type === TokenStringLiteral || type === TokenNumericLiteral) {
    if (lookahead.octal) {
      throwError(lookahead, MessageStrictOctalLiteral);
    }
    expr = finishLiteral(lex());
  } else if (type === TokenKeyword) {
    throw new Error(DISABLED);
  } else if (type === TokenBooleanLiteral) {
    token = lex();
    token.value = token.value === 'true';
    expr = finishLiteral(token);
  } else if (type === TokenNullLiteral) {
    token = lex();
    token.value = null;
    expr = finishLiteral(token);
  } else if (match('/') || match('/=')) {
    expr = finishLiteral(scanRegExp());
    peek();
  } else {
    throwUnexpected(lex());
  }
  return expr;
}

// 11.2 Left-Hand-Side Expressions

function parseArguments() {
  const args = [];
  expect('(');
  if (!match(')')) {
    while (index < length) {
      args.push(parseConditionalExpression());
      if (match(')')) {
        break;
      }
      expect(',');
    }
  }
  expect(')');
  return args;
}
function parseNonComputedProperty() {
  index = lookahead.start;
  const token = lex();
  if (!isIdentifierName(token)) {
    throwUnexpected(token);
  }
  return finishIdentifier(token.value);
}
function parseNonComputedMember() {
  expect('.');
  return parseNonComputedProperty();
}
function parseComputedMember() {
  expect('[');
  const expr = parseExpression();
  expect(']');
  return expr;
}
function parseLeftHandSideExpressionAllowCall() {
  var expr, args, property;
  expr = parsePrimaryExpression();
  for (;;) {
    if (match('.')) {
      property = parseNonComputedMember();
      expr = finishMemberExpression('.', expr, property);
    } else if (match('(')) {
      args = parseArguments();
      expr = finishCallExpression(expr, args);
    } else if (match('[')) {
      property = parseComputedMember();
      expr = finishMemberExpression('[', expr, property);
    } else {
      break;
    }
  }
  return expr;
}

// 11.3 Postfix Expressions

function parsePostfixExpression() {
  const expr = parseLeftHandSideExpressionAllowCall();
  if (lookahead.type === TokenPunctuator) {
    if (match('++') || match('--')) {
      throw new Error(DISABLED);
    }
  }
  return expr;
}

// 11.4 Unary Operators

function parseUnaryExpression() {
  var token, expr;
  if (lookahead.type !== TokenPunctuator && lookahead.type !== TokenKeyword) {
    expr = parsePostfixExpression();
  } else if (match('++') || match('--')) {
    throw new Error(DISABLED);
  } else if (match('+') || match('-') || match('~') || match('!')) {
    token = lex();
    expr = parseUnaryExpression();
    expr = finishUnaryExpression(token.value, expr);
  } else if (matchKeyword('delete') || matchKeyword('void') || matchKeyword('typeof')) {
    throw new Error(DISABLED);
  } else {
    expr = parsePostfixExpression();
  }
  return expr;
}
function binaryPrecedence(token) {
  let prec = 0;
  if (token.type !== TokenPunctuator && token.type !== TokenKeyword) {
    return 0;
  }
  switch (token.value) {
    case '||':
      prec = 1;
      break;
    case '&&':
      prec = 2;
      break;
    case '|':
      prec = 3;
      break;
    case '^':
      prec = 4;
      break;
    case '&':
      prec = 5;
      break;
    case '==':
    case '!=':
    case '===':
    case '!==':
      prec = 6;
      break;
    case '<':
    case '>':
    case '<=':
    case '>=':
    case 'instanceof':
    case 'in':
      prec = 7;
      break;
    case '<<':
    case '>>':
    case '>>>':
      prec = 8;
      break;
    case '+':
    case '-':
      prec = 9;
      break;
    case '*':
    case '/':
    case '%':
      prec = 11;
      break;
  }
  return prec;
}

// 11.5 Multiplicative Operators
// 11.6 Additive Operators
// 11.7 Bitwise Shift Operators
// 11.8 Relational Operators
// 11.9 Equality Operators
// 11.10 Binary Bitwise Operators
// 11.11 Binary Logical Operators

function parseBinaryExpression() {
  var marker, markers, expr, token, prec, stack, right, operator, left, i;
  marker = lookahead;
  left = parseUnaryExpression();
  token = lookahead;
  prec = binaryPrecedence(token);
  if (prec === 0) {
    return left;
  }
  token.prec = prec;
  lex();
  markers = [marker, lookahead];
  right = parseUnaryExpression();
  stack = [left, token, right];
  while ((prec = binaryPrecedence(lookahead)) > 0) {
    // Reduce: make a binary expression from the three topmost entries.
    while (stack.length > 2 && prec <= stack[stack.length - 2].prec) {
      right = stack.pop();
      operator = stack.pop().value;
      left = stack.pop();
      markers.pop();
      expr = finishBinaryExpression(operator, left, right);
      stack.push(expr);
    }

    // Shift.
    token = lex();
    token.prec = prec;
    stack.push(token);
    markers.push(lookahead);
    expr = parseUnaryExpression();
    stack.push(expr);
  }

  // Final reduce to clean-up the stack.
  i = stack.length - 1;
  expr = stack[i];
  markers.pop();
  while (i > 1) {
    markers.pop();
    expr = finishBinaryExpression(stack[i - 1].value, stack[i - 2], expr);
    i -= 2;
  }
  return expr;
}

// 11.12 Conditional Operator

function parseConditionalExpression() {
  var expr, consequent, alternate;
  expr = parseBinaryExpression();
  if (match('?')) {
    lex();
    consequent = parseConditionalExpression();
    expect(':');
    alternate = parseConditionalExpression();
    expr = finishConditionalExpression(expr, consequent, alternate);
  }
  return expr;
}

// 11.14 Comma Operator

function parseExpression() {
  const expr = parseConditionalExpression();
  if (match(',')) {
    throw new Error(DISABLED); // no sequence expressions
  }
  return expr;
}
function parser$1(code) {
  source = code;
  index = 0;
  length = source.length;
  lookahead = null;
  peek();
  const expr = parseExpression();
  if (lookahead.type !== TokenEOF) {
    throw new Error('Unexpect token after expression.');
  }
  return expr;
}
var Constants = {
  NaN: 'NaN',
  E: 'Math.E',
  LN2: 'Math.LN2',
  LN10: 'Math.LN10',
  LOG2E: 'Math.LOG2E',
  LOG10E: 'Math.LOG10E',
  PI: 'Math.PI',
  SQRT1_2: 'Math.SQRT1_2',
  SQRT2: 'Math.SQRT2',
  MIN_VALUE: 'Number.MIN_VALUE',
  MAX_VALUE: 'Number.MAX_VALUE'
};
function Functions(codegen) {
  function fncall(name, args, cast, type) {
    let obj = codegen(args[0]);
    if (cast) {
      obj = cast + '(' + obj + ')';
      if (cast.lastIndexOf('new ', 0) === 0) obj = '(' + obj + ')';
    }
    return obj + '.' + name + (type < 0 ? '' : type === 0 ? '()' : '(' + args.slice(1).map(codegen).join(',') + ')');
  }
  function fn(name, cast, type) {
    return args => fncall(name, args, cast, type);
  }
  const DATE = 'new Date',
    STRING = 'String',
    REGEXP = 'RegExp';
  return {
    // MATH functions
    isNaN: 'Number.isNaN',
    isFinite: 'Number.isFinite',
    abs: 'Math.abs',
    acos: 'Math.acos',
    asin: 'Math.asin',
    atan: 'Math.atan',
    atan2: 'Math.atan2',
    ceil: 'Math.ceil',
    cos: 'Math.cos',
    exp: 'Math.exp',
    floor: 'Math.floor',
    hypot: 'Math.hypot',
    log: 'Math.log',
    max: 'Math.max',
    min: 'Math.min',
    pow: 'Math.pow',
    random: 'Math.random',
    round: 'Math.round',
    sin: 'Math.sin',
    sqrt: 'Math.sqrt',
    tan: 'Math.tan',
    clamp: function (args) {
      if (args.length < 3) error('Missing arguments to clamp function.');
      if (args.length > 3) error('Too many arguments to clamp function.');
      const a = args.map(codegen);
      return 'Math.max(' + a[1] + ', Math.min(' + a[2] + ',' + a[0] + '))';
    },
    // DATE functions
    now: 'Date.now',
    utc: 'Date.UTC',
    datetime: DATE,
    date: fn('getDate', DATE, 0),
    day: fn('getDay', DATE, 0),
    year: fn('getFullYear', DATE, 0),
    month: fn('getMonth', DATE, 0),
    hours: fn('getHours', DATE, 0),
    minutes: fn('getMinutes', DATE, 0),
    seconds: fn('getSeconds', DATE, 0),
    milliseconds: fn('getMilliseconds', DATE, 0),
    time: fn('getTime', DATE, 0),
    timezoneoffset: fn('getTimezoneOffset', DATE, 0),
    utcdate: fn('getUTCDate', DATE, 0),
    utcday: fn('getUTCDay', DATE, 0),
    utcyear: fn('getUTCFullYear', DATE, 0),
    utcmonth: fn('getUTCMonth', DATE, 0),
    utchours: fn('getUTCHours', DATE, 0),
    utcminutes: fn('getUTCMinutes', DATE, 0),
    utcseconds: fn('getUTCSeconds', DATE, 0),
    utcmilliseconds: fn('getUTCMilliseconds', DATE, 0),
    // sequence functions
    length: fn('length', null, -1),
    // STRING functions
    parseFloat: 'parseFloat',
    parseInt: 'parseInt',
    upper: fn('toUpperCase', STRING, 0),
    lower: fn('toLowerCase', STRING, 0),
    substring: fn('substring', STRING),
    split: fn('split', STRING),
    trim: fn('trim', STRING, 0),
    // REGEXP functions
    regexp: REGEXP,
    test: fn('test', REGEXP),
    // Control Flow functions
    if: function (args) {
      if (args.length < 3) error('Missing arguments to if function.');
      if (args.length > 3) error('Too many arguments to if function.');
      const a = args.map(codegen);
      return '(' + a[0] + '?' + a[1] + ':' + a[2] + ')';
    }
  };
}
function stripQuotes(s) {
  const n = s && s.length - 1;
  return n && (s[0] === '"' && s[n] === '"' || s[0] === '\'' && s[n] === '\'') ? s.slice(1, -1) : s;
}
function codegen(opt) {
  opt = opt || {};
  const allowed = opt.allowed ? toSet(opt.allowed) : {},
    forbidden = opt.forbidden ? toSet(opt.forbidden) : {},
    constants = opt.constants || Constants,
    functions = (opt.functions || Functions)(visit),
    globalvar = opt.globalvar,
    fieldvar = opt.fieldvar,
    outputGlobal = isFunction(globalvar) ? globalvar : id => `${globalvar}["${id}"]`;
  let globals = {},
    fields = {},
    memberDepth = 0;
  function visit(ast) {
    if (isString(ast)) return ast;
    const generator = Generators[ast.type];
    if (generator == null) error('Unsupported type: ' + ast.type);
    return generator(ast);
  }
  const Generators = {
    Literal: n => n.raw,
    Identifier: n => {
      const id = n.name;
      if (memberDepth > 0) {
        return id;
      } else if (has$1(forbidden, id)) {
        return error('Illegal identifier: ' + id);
      } else if (has$1(constants, id)) {
        return constants[id];
      } else if (has$1(allowed, id)) {
        return id;
      } else {
        globals[id] = 1;
        return outputGlobal(id);
      }
    },
    MemberExpression: n => {
      const d = !n.computed,
        o = visit(n.object);
      if (d) memberDepth += 1;
      const p = visit(n.property);
      if (o === fieldvar) {
        // strip quotes to sanitize field name (#1653)
        fields[stripQuotes(p)] = 1;
      }
      if (d) memberDepth -= 1;
      return o + (d ? '.' + p : '[' + p + ']');
    },
    CallExpression: n => {
      if (n.callee.type !== 'Identifier') {
        error('Illegal callee type: ' + n.callee.type);
      }
      const callee = n.callee.name,
        args = n.arguments,
        fn = has$1(functions, callee) && functions[callee];
      if (!fn) error('Unrecognized function: ' + callee);
      return isFunction(fn) ? fn(args) : fn + '(' + args.map(visit).join(',') + ')';
    },
    ArrayExpression: n => '[' + n.elements.map(visit).join(',') + ']',
    BinaryExpression: n => '(' + visit(n.left) + ' ' + n.operator + ' ' + visit(n.right) + ')',
    UnaryExpression: n => '(' + n.operator + visit(n.argument) + ')',
    ConditionalExpression: n => '(' + visit(n.test) + '?' + visit(n.consequent) + ':' + visit(n.alternate) + ')',
    LogicalExpression: n => '(' + visit(n.left) + n.operator + visit(n.right) + ')',
    ObjectExpression: n => '{' + n.properties.map(visit).join(',') + '}',
    Property: n => {
      memberDepth += 1;
      const k = visit(n.key);
      memberDepth -= 1;
      return k + ':' + visit(n.value);
    }
  };
  function codegen(ast) {
    const result = {
      code: visit(ast),
      globals: Object.keys(globals),
      fields: Object.keys(fields)
    };
    globals = {};
    fields = {};
    return result;
  }
  codegen.functions = functions;
  codegen.constants = constants;
  return codegen;
}

// Registers vega-util field accessors to protect against XSS attacks
const SELECTION_GETTER = Symbol('vega_selection_getter');
function getter(f) {
  if (!f.getter || !f.getter[SELECTION_GETTER]) {
    f.getter = field$1(f.field);
    f.getter[SELECTION_GETTER] = true;
  }
  return f.getter;
}
const Intersect = 'intersect';
const Union = 'union';
const VlMulti = 'vlMulti';
const VlPoint = 'vlPoint';
const Or = 'or';
const And = 'and';
const SelectionId = '_vgsid_';
const $selectionId = field$1(SelectionId);
const TYPE_ENUM = 'E',
  TYPE_RANGE_INC = 'R',
  TYPE_RANGE_EXC = 'R-E',
  TYPE_RANGE_LE = 'R-LE',
  TYPE_RANGE_RE = 'R-RE',
  UNIT_INDEX = 'index:unit';

// TODO: revisit date coercion?
function testPoint(datum, entry) {
  var fields = entry.fields,
    values = entry.values,
    n = fields.length,
    i = 0,
    dval,
    f;
  for (; i < n; ++i) {
    f = fields[i];
    dval = getter(f)(datum);
    if (isDate$1(dval)) dval = toNumber(dval);
    if (isDate$1(values[i])) values[i] = toNumber(values[i]);
    if (isArray(values[i]) && isDate$1(values[i][0])) values[i] = values[i].map(toNumber);
    if (f.type === TYPE_ENUM) {
      // Enumerated fields can either specify individual values (single/multi selections)
      // or an array of values (interval selections).
      if (isArray(values[i]) ? values[i].indexOf(dval) < 0 : dval !== values[i]) {
        return false;
      }
    } else {
      if (f.type === TYPE_RANGE_INC) {
        if (!inrange(dval, values[i])) return false;
      } else if (f.type === TYPE_RANGE_RE) {
        // Discrete selection of bins test within the range [bin_start, bin_end).
        if (!inrange(dval, values[i], true, false)) return false;
      } else if (f.type === TYPE_RANGE_EXC) {
        // 'R-E'/'R-LE' included for completeness.
        if (!inrange(dval, values[i], false, false)) return false;
      } else if (f.type === TYPE_RANGE_LE) {
        if (!inrange(dval, values[i], false, true)) return false;
      }
    }
  }
  return true;
}

/**
 * Tests if a tuple is contained within an interactive selection.
 * @param {string} name - The name of the data set representing the selection.
 *  Tuples in the dataset are of the form
 *  {unit: string, fields: array<fielddef>, values: array<*>}.
 *  Fielddef is of the form
 *  {field: string, channel: string, type: 'E' | 'R'} where
 *  'type' identifies whether tuples in the dataset enumerate
 *  values for the field, or specify a continuous range.
 * @param {object} datum - The tuple to test for inclusion.
 * @param {string} op - The set operation for combining selections.
 *   One of 'intersect' or 'union' (default).
 * @return {boolean} - True if the datum is in the selection, false otherwise.
 */
function selectionTest(name, datum, op) {
  var data = this.context.data[name],
    entries = data ? data.values.value : [],
    unitIdx = data ? data[UNIT_INDEX] && data[UNIT_INDEX].value : undefined,
    intersect = op === Intersect,
    n = entries.length,
    i = 0,
    entry,
    miss,
    count,
    unit,
    b;
  for (; i < n; ++i) {
    entry = entries[i];
    if (unitIdx && intersect) {
      // multi selections union within the same unit and intersect across units.
      miss = miss || {};
      count = miss[unit = entry.unit] || 0;

      // if we've already matched this unit, skip.
      if (count === -1) continue;
      b = testPoint(datum, entry);
      miss[unit] = b ? -1 : ++count;

      // if we match and there are no other units return true
      // if we've missed against all tuples in this unit return false
      if (b && unitIdx.size === 1) return true;
      if (!b && count === unitIdx.get(unit).count) return false;
    } else {
      b = testPoint(datum, entry);

      // if we find a miss and we do require intersection return false
      // if we find a match and we don't require intersection return true
      if (intersect ^ b) return b;
    }
  }

  // if intersecting and we made it here, then we saw no misses
  // if not intersecting, then we saw no matches
  // if no active selections, return false
  return n && intersect;
}
const bisect = bisector($selectionId),
  bisectLeft = bisect.left,
  bisectRight = bisect.right;
function selectionIdTest(name, datum, op) {
  const data = this.context.data[name],
    entries = data ? data.values.value : [],
    unitIdx = data ? data[UNIT_INDEX] && data[UNIT_INDEX].value : undefined,
    intersect = op === Intersect,
    value = $selectionId(datum),
    index = bisectLeft(entries, value);
  if (index === entries.length) return false;
  if ($selectionId(entries[index]) !== value) return false;
  if (unitIdx && intersect) {
    if (unitIdx.size === 1) return true;
    if (bisectRight(entries, value) - index < unitIdx.size) return false;
  }
  return true;
}

/**
 * Maps an array of scene graph items to an array of selection tuples.
 * @param {string} name  - The name of the dataset representing the selection.
 * @param {string} base  - The base object that generated tuples extend.
 *
 * @returns {array} An array of selection entries for the given unit.
 */
function selectionTuples(array, base) {
  return array.map(x => extend$1(base.fields ? {
    values: base.fields.map(f => getter(f)(x.datum))
  } : {
    [SelectionId]: $selectionId(x.datum)
  }, base));
}

/**
 * Resolves selection for use as a scale domain or reads via the API.
 * @param {string} name - The name of the dataset representing the selection
 * @param {string} [op='union'] - The set operation for combining selections.
 *                 One of 'intersect' or 'union' (default).
 * @param {boolean} isMulti - Identifies a "multi" selection to perform more
 *                 expensive resolution computation.
 * @param {boolean} vl5 - With Vega-Lite v5, "multi" selections are now called "point"
 *                 selections, and thus the resolved tuple should reflect this name.
 *                 This parameter allows us to reflect this change without triggering
 *                 a major version bump for Vega.
 * @returns {object} An object of selected fields and values.
 */
function selectionResolve(name, op, isMulti, vl5) {
  var data = this.context.data[name],
    entries = data ? data.values.value : [],
    resolved = {},
    multiRes = {},
    types = {},
    entry,
    fields,
    values,
    unit,
    field,
    value,
    res,
    resUnit,
    type,
    union,
    n = entries.length,
    i = 0,
    j,
    m;

  // First union all entries within the same unit.
  for (; i < n; ++i) {
    entry = entries[i];
    unit = entry.unit;
    fields = entry.fields;
    values = entry.values;
    if (fields && values) {
      // Intentional selection stores
      for (j = 0, m = fields.length; j < m; ++j) {
        field = fields[j];
        res = resolved[field.field] || (resolved[field.field] = {});
        resUnit = res[unit] || (res[unit] = []);
        types[field.field] = type = field.type.charAt(0);
        union = ops[`${type}_union`];
        res[unit] = union(resUnit, array$5(values[j]));
      }

      // If the same multi-selection is repeated over views and projected over
      // an encoding, it may operate over different fields making it especially
      // tricky to reliably resolve it. At best, we can de-dupe identical entries
      // but doing so may be more computationally expensive than it is worth.
      // Instead, for now, we simply transform our store representation into
      // a more human-friendly one.
      if (isMulti) {
        resUnit = multiRes[unit] || (multiRes[unit] = []);
        resUnit.push(array$5(values).reduce((obj, curr, j) => (obj[fields[j].field] = curr, obj), {}));
      }
    } else {
      // Short circuit extensional selectionId stores which hold sorted IDs unique to each unit.
      field = SelectionId;
      value = $selectionId(entry);
      res = resolved[field] || (resolved[field] = {});
      resUnit = res[unit] || (res[unit] = []);
      resUnit.push(value);
      if (isMulti) {
        resUnit = multiRes[unit] || (multiRes[unit] = []);
        resUnit.push({
          [SelectionId]: value
        });
      }
    }
  }

  // Then resolve fields across units as per the op.
  op = op || Union;
  if (resolved[SelectionId]) {
    resolved[SelectionId] = ops[`${SelectionId}_${op}`](...Object.values(resolved[SelectionId]));
  } else {
    Object.keys(resolved).forEach(field => {
      resolved[field] = Object.keys(resolved[field]).map(unit => resolved[field][unit]).reduce((acc, curr) => acc === undefined ? curr : ops[`${types[field]}_${op}`](acc, curr));
    });
  }
  entries = Object.keys(multiRes);
  if (isMulti && entries.length) {
    const key = vl5 ? VlPoint : VlMulti;
    resolved[key] = op === Union ? {
      [Or]: entries.reduce((acc, k) => (acc.push(...multiRes[k]), acc), [])
    } : {
      [And]: entries.map(k => ({
        [Or]: multiRes[k]
      }))
    };
  }
  return resolved;
}
var ops = {
  [`${SelectionId}_union`]: union,
  [`${SelectionId}_intersect`]: intersection,
  E_union: function (base, value) {
    if (!base.length) return value;
    var i = 0,
      n = value.length;
    for (; i < n; ++i) if (base.indexOf(value[i]) < 0) base.push(value[i]);
    return base;
  },
  E_intersect: function (base, value) {
    return !base.length ? value : base.filter(v => value.indexOf(v) >= 0);
  },
  R_union: function (base, value) {
    var lo = toNumber(value[0]),
      hi = toNumber(value[1]);
    if (lo > hi) {
      lo = value[1];
      hi = value[0];
    }
    if (!base.length) return [lo, hi];
    if (base[0] > lo) base[0] = lo;
    if (base[1] < hi) base[1] = hi;
    return base;
  },
  R_intersect: function (base, value) {
    var lo = toNumber(value[0]),
      hi = toNumber(value[1]);
    if (lo > hi) {
      lo = value[1];
      hi = value[0];
    }
    if (!base.length) return [lo, hi];
    if (hi < base[0] || base[1] < lo) {
      return [];
    } else {
      if (base[0] < lo) base[0] = lo;
      if (base[1] > hi) base[1] = hi;
    }
    return base;
  }
};
const DataPrefix$1 = ':',
  IndexPrefix$1 = '@';
function selectionVisitor(name, args, scope, params) {
  if (args[0].type !== Literal) error('First argument to selection functions must be a string literal.');
  const data = args[0].value,
    op = args.length >= 2 && peek$1(args).value,
    field = 'unit',
    indexName = IndexPrefix$1 + field,
    dataName = DataPrefix$1 + data;

  // eslint-disable-next-line no-prototype-builtins
  if (op === Intersect && !has$1(params, indexName)) {
    params[indexName] = scope.getData(data).indataRef(scope, field);
  }

  // eslint-disable-next-line no-prototype-builtins
  if (!has$1(params, dataName)) {
    params[dataName] = scope.getData(data).tuplesRef();
  }
}

function data$1(name) {
  const data = this.context.data[name];
  return data ? data.values.value : [];
}
function indata(name, field, value) {
  const index = this.context.data[name]['index:' + field],
    entry = index ? index.value.get(value) : undefined;
  return entry ? entry.count : entry;
}
function setdata(name, tuples) {
  const df = this.context.dataflow,
    data = this.context.data[name],
    input = data.input;
  df.pulse(input, df.changeset().remove(truthy).insert(tuples));
  return 1;
}
function encode(item, name, retval) {
  if (item) {
    const df = this.context.dataflow,
      target = item.mark.source;
    df.pulse(target, df.changeset().encode(item, name));
  }
  return retval !== undefined ? retval : item;
}
const wrap = method => function (value, spec) {
  const locale = this.context.dataflow.locale();
  return value === null ? 'null' : locale[method](spec)(value);
};
const format = wrap('format');
const timeFormat = wrap('timeFormat');
const utcFormat = wrap('utcFormat');
const timeParse = wrap('timeParse');
const utcParse = wrap('utcParse');
const dateObj = new Date(2000, 0, 1);
function time(month, day, specifier) {
  if (!Number.isInteger(month) || !Number.isInteger(day)) return '';
  dateObj.setYear(2000);
  dateObj.setMonth(month);
  dateObj.setDate(day);
  return timeFormat.call(this, dateObj, specifier);
}
function monthFormat(month) {
  return time.call(this, month, 1, '%B');
}
function monthAbbrevFormat(month) {
  return time.call(this, month, 1, '%b');
}
function dayFormat(day) {
  return time.call(this, 0, 2 + day, '%A');
}
function dayAbbrevFormat(day) {
  return time.call(this, 0, 2 + day, '%a');
}
const DataPrefix = ':';
const IndexPrefix = '@';
const ScalePrefix = '%';
const SignalPrefix = '$';
function dataVisitor(name, args, scope, params) {
  if (args[0].type !== Literal) {
    error('First argument to data functions must be a string literal.');
  }
  const data = args[0].value,
    dataName = DataPrefix + data;
  if (!has$1(dataName, params)) {
    try {
      params[dataName] = scope.getData(data).tuplesRef();
    } catch (err) {
      // if data set does not exist, there's nothing to track
    }
  }
}
function indataVisitor(name, args, scope, params) {
  if (args[0].type !== Literal) error('First argument to indata must be a string literal.');
  if (args[1].type !== Literal) error('Second argument to indata must be a string literal.');
  const data = args[0].value,
    field = args[1].value,
    indexName = IndexPrefix + field;
  if (!has$1(indexName, params)) {
    params[indexName] = scope.getData(data).indataRef(scope, field);
  }
}
function scaleVisitor(name, args, scope, params) {
  if (args[0].type === Literal) {
    // add scale dependency
    addScaleDependency(scope, params, args[0].value);
  } else {
    // indirect scale lookup; add all scales as parameters
    for (name in scope.scales) {
      addScaleDependency(scope, params, name);
    }
  }
}
function addScaleDependency(scope, params, name) {
  const scaleName = ScalePrefix + name;
  if (!has$1(params, scaleName)) {
    try {
      params[scaleName] = scope.scaleRef(name);
    } catch (err) {
      // TODO: error handling? warning?
    }
  }
}
function getScale(nameOrFunction, ctx) {
  if (isFunction(nameOrFunction)) {
    return nameOrFunction;
  }
  if (isString(nameOrFunction)) {
    const maybeScale = ctx.scales[nameOrFunction];
    return maybeScale && isRegisteredScale(maybeScale.value) ? maybeScale.value : undefined;
  }
  return undefined;
}
function internalScaleFunctions(codegen, fnctx, visitors) {
  // add helper method to the 'this' expression function context
  fnctx.__bandwidth = s => s && s.bandwidth ? s.bandwidth() : 0;

  // register AST visitors for internal scale functions
  visitors._bandwidth = scaleVisitor;
  visitors._range = scaleVisitor;
  visitors._scale = scaleVisitor;

  // resolve scale reference directly to the signal hash argument
  const ref = arg => '_[' + (arg.type === Literal ? $(ScalePrefix + arg.value) : $(ScalePrefix) + '+' + codegen(arg)) + ']';

  // define and return internal scale function code generators
  // these internal functions are called by mark encoders
  return {
    _bandwidth: args => `this.__bandwidth(${ref(args[0])})`,
    _range: args => `${ref(args[0])}.range()`,
    _scale: args => `${ref(args[0])}(${codegen(args[1])})`
  };
}
function geoMethod(methodName, globalMethod) {
  return function (projection, geojson, group) {
    if (projection) {
      // projection defined, use it
      const p = getScale(projection, (group || this).context);
      return p && p.path[methodName](geojson);
    } else {
      // projection undefined, use global method
      return globalMethod(geojson);
    }
  };
}
const geoArea = geoMethod('area', geoArea$1);
const geoBounds = geoMethod('bounds', geoBounds$1);
const geoCentroid = geoMethod('centroid', geoCentroid$1);
function geoScale(projection, group) {
  const p = getScale(projection, (group || this).context);
  return p && p.scale();
}
function inScope(item) {
  const group = this.context.group;
  let value = false;
  if (group) while (item) {
    if (item === group) {
      value = true;
      break;
    }
    item = item.mark.group;
  }
  return value;
}
function log(df, method, args) {
  try {
    df[method].apply(df, ['EXPRESSION'].concat([].slice.call(args)));
  } catch (err) {
    df.warn(err);
  }
  return args[args.length - 1];
}
function warn() {
  return log(this.context.dataflow, 'warn', arguments);
}
function info() {
  return log(this.context.dataflow, 'info', arguments);
}
function debug() {
  return log(this.context.dataflow, 'debug', arguments);
}

// https://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
function channel_luminance_value(channelValue) {
  const val = channelValue / 255;
  if (val <= 0.03928) {
    return val / 12.92;
  }
  return Math.pow((val + 0.055) / 1.055, 2.4);
}
function luminance(color) {
  const c = rgb$1(color),
    r = channel_luminance_value(c.r),
    g = channel_luminance_value(c.g),
    b = channel_luminance_value(c.b);
  return 0.2126 * r + 0.7152 * g + 0.0722 * b;
}

// https://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef
function contrast(color1, color2) {
  const lum1 = luminance(color1),
    lum2 = luminance(color2),
    lumL = Math.max(lum1, lum2),
    lumD = Math.min(lum1, lum2);
  return (lumL + 0.05) / (lumD + 0.05);
}
function merge() {
  const args = [].slice.call(arguments);
  args.unshift({});
  return extend$1(...args);
}
function equal(a, b) {
  return a === b || a !== a && b !== b ? true : isArray(a) ? isArray(b) && a.length === b.length ? equalArray(a, b) : false : isObject(a) && isObject(b) ? equalObject(a, b) : false;
}
function equalArray(a, b) {
  for (let i = 0, n = a.length; i < n; ++i) {
    if (!equal(a[i], b[i])) return false;
  }
  return true;
}
function equalObject(a, b) {
  for (const key in a) {
    if (!equal(a[key], b[key])) return false;
  }
  return true;
}
function removePredicate(props) {
  return _ => equalObject(props, _);
}
function modify(name, insert, remove, toggle, modify, values) {
  const df = this.context.dataflow,
    data = this.context.data[name],
    input = data.input,
    stamp = df.stamp();
  let changes = data.changes,
    predicate,
    key;
  if (df._trigger === false || !(input.value.length || insert || toggle)) {
    // nothing to do!
    return 0;
  }
  if (!changes || changes.stamp < stamp) {
    data.changes = changes = df.changeset();
    changes.stamp = stamp;
    df.runAfter(() => {
      data.modified = true;
      df.pulse(input, changes).run();
    }, true, 1);
  }
  if (remove) {
    predicate = remove === true ? truthy : isArray(remove) || isTuple(remove) ? remove : removePredicate(remove);
    changes.remove(predicate);
  }
  if (insert) {
    changes.insert(insert);
  }
  if (toggle) {
    predicate = removePredicate(toggle);
    if (input.value.some(predicate)) {
      changes.remove(predicate);
    } else {
      changes.insert(toggle);
    }
  }
  if (modify) {
    for (key in values) {
      changes.modify(modify, key, values[key]);
    }
  }
  return 1;
}
function pinchDistance(event) {
  const t = event.touches,
    dx = t[0].clientX - t[1].clientX,
    dy = t[0].clientY - t[1].clientY;
  return Math.hypot(dx, dy);
}
function pinchAngle(event) {
  const t = event.touches;
  return Math.atan2(t[0].clientY - t[1].clientY, t[0].clientX - t[1].clientX);
}

// memoize accessor functions
const accessors = {};
function pluck(data, name) {
  const accessor = accessors[name] || (accessors[name] = field$1(name));
  return isArray(data) ? data.map(accessor) : accessor(data);
}
function array(seq) {
  return isArray(seq) || ArrayBuffer.isView(seq) ? seq : null;
}
function sequence(seq) {
  return array(seq) || (isString(seq) ? seq : null);
}
function join(seq) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }
  return array(seq).join(...args);
}
function indexof(seq) {
  for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    args[_key2 - 1] = arguments[_key2];
  }
  return sequence(seq).indexOf(...args);
}
function lastindexof(seq) {
  for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    args[_key3 - 1] = arguments[_key3];
  }
  return sequence(seq).lastIndexOf(...args);
}
function slice(seq) {
  for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
    args[_key4 - 1] = arguments[_key4];
  }
  return sequence(seq).slice(...args);
}
function replace(str, pattern, repl) {
  if (isFunction(repl)) error('Function argument passed to replace.');
  return String(str).replace(pattern, repl);
}
function reverse(seq) {
  return array(seq).slice().reverse();
}
function bandspace(count, paddingInner, paddingOuter) {
  return bandSpace(count || 0, paddingInner || 0, paddingOuter || 0);
}
function bandwidth(name, group) {
  const s = getScale(name, (group || this).context);
  return s && s.bandwidth ? s.bandwidth() : 0;
}
function copy(name, group) {
  const s = getScale(name, (group || this).context);
  return s ? s.copy() : undefined;
}
function domain(name, group) {
  const s = getScale(name, (group || this).context);
  return s ? s.domain() : [];
}
function invert(name, range, group) {
  const s = getScale(name, (group || this).context);
  return !s ? undefined : isArray(range) ? (s.invertRange || s.invert)(range) : (s.invert || s.invertExtent)(range);
}
function range$1(name, group) {
  const s = getScale(name, (group || this).context);
  return s && s.range ? s.range() : [];
}
function scale$2(name, value, group) {
  const s = getScale(name, (group || this).context);
  return s ? s(value) : undefined;
}
function scaleGradient(scale, p0, p1, count, group) {
  scale = getScale(scale, (group || this).context);
  const gradient = Gradient$1(p0, p1);
  let stops = scale.domain(),
    min = stops[0],
    max = peek$1(stops),
    fraction = identity$6;
  if (!(max - min)) {
    // expand scale if domain has zero span, fix #1479
    scale = (scale.interpolator ? scale$4('sequential')().interpolator(scale.interpolator()) : scale$4('linear')().interpolate(scale.interpolate()).range(scale.range())).domain([min = 0, max = 1]);
  } else {
    fraction = scaleFraction(scale, min, max);
  }
  if (scale.ticks) {
    stops = scale.ticks(+count || 15);
    if (min !== stops[0]) stops.unshift(min);
    if (max !== peek$1(stops)) stops.push(max);
  }
  stops.forEach(_ => gradient.stop(fraction(_), scale(_)));
  return gradient;
}
function geoShape(projection, geojson, group) {
  const p = getScale(projection, (group || this).context);
  return function (context) {
    return p ? p.path.context(context)(geojson) : '';
  };
}
function pathShape(path) {
  let p = null;
  return function (context) {
    return context ? pathRender(context, p = p || parse$3(path)) : path;
  };
}
const datum = d => d.data;
function treeNodes(name, context) {
  const tree = data$1.call(context, name);
  return tree.root && tree.root.lookup || {};
}
function treePath(name, source, target) {
  const nodes = treeNodes(name, this),
    s = nodes[source],
    t = nodes[target];
  return s && t ? s.path(t).map(datum) : undefined;
}
function treeAncestors(name, node) {
  const n = treeNodes(name, this)[node];
  return n ? n.ancestors().map(datum) : undefined;
}
const _window = () => typeof window !== 'undefined' && window || null;
function screen() {
  const w = _window();
  return w ? w.screen : {};
}
function windowSize() {
  const w = _window();
  return w ? [w.innerWidth, w.innerHeight] : [undefined, undefined];
}
function containerSize() {
  const view = this.context.dataflow,
    el = view.container && view.container();
  return el ? [el.clientWidth, el.clientHeight] : [undefined, undefined];
}
function intersect(b, opt, group) {
  if (!b) return [];
  const [u, v] = b,
    box = new Bounds().set(u[0], u[1], v[0], v[1]),
    scene = group || this.context.dataflow.scenegraph().root;
  return intersect$2(scene, box, filter(opt));
}
function filter(opt) {
  let p = null;
  if (opt) {
    const types = array$5(opt.marktype),
      names = array$5(opt.markname);
    p = _ => (!types.length || types.some(t => _.marktype === t)) && (!names.length || names.some(s => _.name === s));
  }
  return p;
}

/**
 * Appends a new point to the lasso
 *
 * @param {*} lasso the lasso in pixel space
 * @param {*} x the x coordinate in pixel space
 * @param {*} y the y coordinate in pixel space
 * @param {*} minDist the minimum distance, in pixels, that thenew point needs to be apart from the last point
 * @returns a new array containing the lasso with the new point
 */
function lassoAppend(lasso, x, y) {
  let minDist = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 5;
  lasso = array$5(lasso);
  const last = lasso[lasso.length - 1];

  // Add point to lasso if its the first point or distance to last point exceed minDist
  return last === undefined || Math.hypot(last[0] - x, last[1] - y) > minDist ? [...lasso, [x, y]] : lasso;
}

/**
 * Generates a svg path command which draws a lasso
 *
 * @param {*} lasso the lasso in pixel space in the form [[x,y], [x,y], ...]
 * @returns the svg path command that draws the lasso
 */
function lassoPath(lasso) {
  return array$5(lasso).reduce((svg, _ref, i) => {
    let [x, y] = _ref;
    return svg += i == 0 ? `M ${x},${y} ` : i === lasso.length - 1 ? ' Z' : `L ${x},${y} `;
  }, '');
}

/**
 * Inverts the lasso from pixel space to an array of vega scenegraph tuples
 *
 * @param {*} data the dataset
 * @param {*} pixelLasso the lasso in pixel space, [[x,y], [x,y], ...]
 * @param {*} unit the unit where the lasso is defined
 *
 * @returns an array of vega scenegraph tuples
 */
function intersectLasso(markname, pixelLasso, unit) {
  const {
    x,
    y,
    mark
  } = unit;
  const bb = new Bounds().set(Number.MAX_SAFE_INTEGER, Number.MAX_SAFE_INTEGER, Number.MIN_SAFE_INTEGER, Number.MIN_SAFE_INTEGER);

  // Get bounding box around lasso
  for (const [px, py] of pixelLasso) {
    if (px < bb.x1) bb.x1 = px;
    if (px > bb.x2) bb.x2 = px;
    if (py < bb.y1) bb.y1 = py;
    if (py > bb.y2) bb.y2 = py;
  }

  // Translate bb against unit coordinates
  bb.translate(x, y);
  const intersection = intersect([[bb.x1, bb.y1], [bb.x2, bb.y2]], markname, mark);

  // Check every point against the lasso
  return intersection.filter(tuple => pointInPolygon(tuple.x, tuple.y, pixelLasso));
}

/**
 * Performs a test if a point is inside a polygon based on the idea from
 * https://wrf.ecse.rpi.edu/Research/Short_Notes/pnpoly.html
 *
 * This method will not need the same start/end point since it wraps around the edges of the array
 *
 * @param {*} test a point to test against
 * @param {*} polygon a polygon in the form [[x,y], [x,y], ...]
 * @returns true if the point lies inside the polygon, false otherwise
 */
function pointInPolygon(testx, testy, polygon) {
  let intersections = 0;
  for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
    const [prevX, prevY] = polygon[j];
    const [x, y] = polygon[i];

    // count intersections
    if (y > testy != prevY > testy && testx < (prevX - x) * (testy - y) / (prevY - y) + x) {
      intersections++;
    }
  }

  // point is in polygon if intersection count is odd
  return intersections & 1;
}

// Expression function context object
const functionContext = {
  random() {
    return random();
  },
  // override default
  cumulativeNormal,
  cumulativeLogNormal,
  cumulativeUniform,
  densityNormal,
  densityLogNormal,
  densityUniform,
  quantileNormal,
  quantileLogNormal,
  quantileUniform,
  sampleNormal,
  sampleLogNormal,
  sampleUniform,
  isArray,
  isBoolean: isBoolean$1,
  isDate: isDate$1,
  isDefined(_) {
    return _ !== undefined;
  },
  isNumber: isNumber$1,
  isObject,
  isRegExp,
  isString,
  isTuple,
  isValid(_) {
    return _ != null && _ === _;
  },
  toBoolean,
  toDate(_) {
    return toDate(_);
  },
  // suppress extra arguments
  toNumber,
  toString,
  indexof,
  join,
  lastindexof,
  replace,
  reverse,
  slice,
  flush,
  lerp,
  merge,
  pad: pad$2,
  peek: peek$1,
  pluck,
  span,
  inrange,
  truncate: truncate$1,
  rgb: rgb$1,
  lab: lab$1,
  hcl: hcl$2,
  hsl: hsl$2,
  luminance,
  contrast,
  sequence: range$3,
  format,
  utcFormat,
  utcParse,
  utcOffset,
  utcSequence,
  timeFormat,
  timeParse,
  timeOffset,
  timeSequence,
  timeUnitSpecifier,
  monthFormat,
  monthAbbrevFormat,
  dayFormat,
  dayAbbrevFormat,
  quarter,
  utcquarter,
  week,
  utcweek,
  dayofyear,
  utcdayofyear,
  warn,
  info,
  debug,
  extent(_) {
    return extent(_);
  },
  // suppress extra arguments
  inScope,
  intersect,
  clampRange,
  pinchDistance,
  pinchAngle,
  screen,
  containerSize,
  windowSize,
  bandspace,
  setdata,
  pathShape,
  panLinear,
  panLog,
  panPow,
  panSymlog,
  zoomLinear,
  zoomLog,
  zoomPow,
  zoomSymlog,
  encode,
  modify,
  lassoAppend,
  lassoPath,
  intersectLasso
};
const eventFunctions = ['view', 'item', 'group', 'xy', 'x', 'y'],
  // event functions
  eventPrefix = 'event.vega.',
  // event function prefix
  thisPrefix = 'this.',
  // function context prefix
  astVisitors = {}; // AST visitors for dependency analysis

// export code generator parameters
const codegenParams = {
  forbidden: ['_'],
  allowed: ['datum', 'event', 'item'],
  fieldvar: 'datum',
  globalvar: id => `_[${$(SignalPrefix + id)}]`,
  functions: buildFunctions,
  constants: Constants,
  visitors: astVisitors
};

// export code generator
const codeGenerator = codegen(codegenParams);

// Build expression function registry
function buildFunctions(codegen) {
  const fn = Functions(codegen);
  eventFunctions.forEach(name => fn[name] = eventPrefix + name);
  for (const name in functionContext) {
    fn[name] = thisPrefix + name;
  }
  extend$1(fn, internalScaleFunctions(codegen, functionContext, astVisitors));
  return fn;
}

// Register an expression function
function expressionFunction(name, fn, visitor) {
  if (arguments.length === 1) {
    return functionContext[name];
  }

  // register with the functionContext
  functionContext[name] = fn;

  // if there is an astVisitor register that, too
  if (visitor) astVisitors[name] = visitor;

  // if the code generator has already been initialized,
  // we need to also register the function with it
  if (codeGenerator) codeGenerator.functions[name] = thisPrefix + name;
  return this;
}

// register expression functions with ast visitors
expressionFunction('bandwidth', bandwidth, scaleVisitor);
expressionFunction('copy', copy, scaleVisitor);
expressionFunction('domain', domain, scaleVisitor);
expressionFunction('range', range$1, scaleVisitor);
expressionFunction('invert', invert, scaleVisitor);
expressionFunction('scale', scale$2, scaleVisitor);
expressionFunction('gradient', scaleGradient, scaleVisitor);
expressionFunction('geoArea', geoArea, scaleVisitor);
expressionFunction('geoBounds', geoBounds, scaleVisitor);
expressionFunction('geoCentroid', geoCentroid, scaleVisitor);
expressionFunction('geoShape', geoShape, scaleVisitor);
expressionFunction('geoScale', geoScale, scaleVisitor);
expressionFunction('indata', indata, indataVisitor);
expressionFunction('data', data$1, dataVisitor);
expressionFunction('treePath', treePath, dataVisitor);
expressionFunction('treeAncestors', treeAncestors, dataVisitor);

// register Vega-Lite selection functions
expressionFunction('vlSelectionTest', selectionTest, selectionVisitor);
expressionFunction('vlSelectionIdTest', selectionIdTest, selectionVisitor);
expressionFunction('vlSelectionResolve', selectionResolve, selectionVisitor);
expressionFunction('vlSelectionTuples', selectionTuples);
function parser(expr, scope) {
  const params = {};

  // parse the expression to an abstract syntax tree (ast)
  let ast;
  try {
    expr = isString(expr) ? expr : $(expr) + '';
    ast = parser$1(expr);
  } catch (err) {
    error('Expression parse error: ' + expr);
  }

  // analyze ast function calls for dependencies
  ast.visit(node => {
    if (node.type !== CallExpression) return;
    const name = node.callee.name,
      visit = codegenParams.visitors[name];
    if (visit) visit(name, node.arguments, scope, params);
  });

  // perform code generation
  const gen = codeGenerator(ast);

  // collect signal dependencies
  gen.globals.forEach(name => {
    const signalName = SignalPrefix + name;
    if (!has$1(params, signalName) && scope.getSignal(name)) {
      params[signalName] = scope.signalRef(name);
    }
  });

  // return generated expression code and dependencies
  return {
    $expr: extend$1({
      code: gen.code
    }, scope.options.ast ? {
      ast
    } : null),
    $fields: gen.fields,
    $params: params
  };
}

/**
 * Parse a serialized dataflow specification.
 */
function parse$2(spec) {
  const ctx = this,
    operators = spec.operators || [];

  // parse background
  if (spec.background) {
    ctx.background = spec.background;
  }

  // parse event configuration
  if (spec.eventConfig) {
    ctx.eventConfig = spec.eventConfig;
  }

  // parse locale configuration
  if (spec.locale) {
    ctx.locale = spec.locale;
  }

  // parse operators
  operators.forEach(entry => ctx.parseOperator(entry));

  // parse operator parameters
  operators.forEach(entry => ctx.parseOperatorParameters(entry));

  // parse streams
  (spec.streams || []).forEach(entry => ctx.parseStream(entry));

  // parse updates
  (spec.updates || []).forEach(entry => ctx.parseUpdate(entry));
  return ctx.resolve();
}
const Skip$2 = toSet(['rule']),
  Swap = toSet(['group', 'image', 'rect']);
function adjustSpatial(encode, marktype) {
  let code = '';
  if (Skip$2[marktype]) return code;
  if (encode.x2) {
    if (encode.x) {
      if (Swap[marktype]) {
        code += 'if(o.x>o.x2)$=o.x,o.x=o.x2,o.x2=$;';
      }
      code += 'o.width=o.x2-o.x;';
    } else {
      code += 'o.x=o.x2-(o.width||0);';
    }
  }
  if (encode.xc) {
    code += 'o.x=o.xc-(o.width||0)/2;';
  }
  if (encode.y2) {
    if (encode.y) {
      if (Swap[marktype]) {
        code += 'if(o.y>o.y2)$=o.y,o.y=o.y2,o.y2=$;';
      }
      code += 'o.height=o.y2-o.y;';
    } else {
      code += 'o.y=o.y2-(o.height||0);';
    }
  }
  if (encode.yc) {
    code += 'o.y=o.yc-(o.height||0)/2;';
  }
  return code;
}
function canonicalType(type) {
  return (type + '').toLowerCase();
}
function isOperator(type) {
  return canonicalType(type) === 'operator';
}
function isCollect(type) {
  return canonicalType(type) === 'collect';
}
function expression(ctx, args, code) {
  // wrap code in return statement if expression does not terminate
  if (!code.endsWith(';')) {
    code = 'return(' + code + ');';
  }
  const fn = Function(...args.concat(code));
  return ctx && ctx.functions ? fn.bind(ctx.functions) : fn;
}

// generate code for comparing a single field
function _compare(u, v, lt, gt) {
  return `((u = ${u}) < (v = ${v}) || u == null) && v != null ? ${lt}
  : (u > v || v == null) && u != null ? ${gt}
  : ((v = v instanceof Date ? +v : v), (u = u instanceof Date ? +u : u)) !== u && v === v ? ${lt}
  : v !== v && u === u ? ${gt} : `;
}
var expressionCodegen = {
  /**
   * Parse an expression used to update an operator value.
   */
  operator: (ctx, expr) => expression(ctx, ['_'], expr.code),
  /**
   * Parse an expression provided as an operator parameter value.
   */
  parameter: (ctx, expr) => expression(ctx, ['datum', '_'], expr.code),
  /**
   * Parse an expression applied to an event stream.
   */
  event: (ctx, expr) => expression(ctx, ['event'], expr.code),
  /**
   * Parse an expression used to handle an event-driven operator update.
   */
  handler: (ctx, expr) => {
    const code = `var datum=event.item&&event.item.datum;return ${expr.code};`;
    return expression(ctx, ['_', 'event'], code);
  },
  /**
   * Parse an expression that performs visual encoding.
   */
  encode: (ctx, encode) => {
    const {
      marktype,
      channels
    } = encode;
    let code = 'var o=item,datum=o.datum,m=0,$;';
    for (const name in channels) {
      const o = 'o[' + $(name) + ']';
      code += `$=${channels[name].code};if(${o}!==$)${o}=$,m=1;`;
    }
    code += adjustSpatial(channels, marktype);
    code += 'return m;';
    return expression(ctx, ['item', '_'], code);
  },
  /**
   * Optimized code generators for access and comparison.
   */
  codegen: {
    get(path) {
      const ref = `[${path.map($).join('][')}]`;
      const get = Function('_', `return _${ref};`);
      get.path = ref;
      return get;
    },
    comparator(fields, orders) {
      let t;
      const map = (f, i) => {
        const o = orders[i];
        let u, v;
        if (f.path) {
          u = `a${f.path}`;
          v = `b${f.path}`;
        } else {
          (t = t || {})['f' + i] = f;
          u = `this.f${i}(a)`;
          v = `this.f${i}(b)`;
        }
        return _compare(u, v, -o, o);
      };
      const fn = Function('a', 'b', 'var u, v; return ' + fields.map(map).join('') + '0;');
      return t ? fn.bind(t) : fn;
    }
  }
};

/**
 * Parse a dataflow operator.
 */
function parseOperator(spec) {
  const ctx = this;
  if (isOperator(spec.type) || !spec.type) {
    ctx.operator(spec, spec.update ? ctx.operatorExpression(spec.update) : null);
  } else {
    ctx.transform(spec, spec.type);
  }
}

/**
 * Parse and assign operator parameters.
 */
function parseOperatorParameters(spec) {
  const ctx = this;
  if (spec.params) {
    const op = ctx.get(spec.id);
    if (!op) error('Invalid operator id: ' + spec.id);
    ctx.dataflow.connect(op, op.parameters(ctx.parseParameters(spec.params), spec.react, spec.initonly));
  }
}

/**
 * Parse a set of operator parameters.
 */
function parseParameters$1(spec, params) {
  params = params || {};
  const ctx = this;
  for (const key in spec) {
    const value = spec[key];
    params[key] = isArray(value) ? value.map(v => parseParameter$2(v, ctx, params)) : parseParameter$2(value, ctx, params);
  }
  return params;
}

/**
 * Parse a single parameter.
 */
function parseParameter$2(spec, ctx, params) {
  if (!spec || !isObject(spec)) return spec;
  for (let i = 0, n = PARSERS.length, p; i < n; ++i) {
    p = PARSERS[i];
    if (has$1(spec, p.key)) {
      return p.parse(spec, ctx, params);
    }
  }
  return spec;
}

/** Reference parsers. */
var PARSERS = [{
  key: '$ref',
  parse: getOperator
}, {
  key: '$key',
  parse: getKey
}, {
  key: '$expr',
  parse: getExpression
}, {
  key: '$field',
  parse: getField
}, {
  key: '$encode',
  parse: getEncode
}, {
  key: '$compare',
  parse: getCompare
}, {
  key: '$context',
  parse: getContext
}, {
  key: '$subflow',
  parse: getSubflow
}, {
  key: '$tupleid',
  parse: getTupleId
}];

/**
 * Resolve an operator reference.
 */
function getOperator(_, ctx) {
  return ctx.get(_.$ref) || error('Operator not defined: ' + _.$ref);
}

/**
 * Resolve an expression reference.
 */
function getExpression(_, ctx, params) {
  if (_.$params) {
    // parse expression parameters
    ctx.parseParameters(_.$params, params);
  }
  const k = 'e:' + _.$expr.code;
  return ctx.fn[k] || (ctx.fn[k] = accessor(ctx.parameterExpression(_.$expr), _.$fields));
}

/**
 * Resolve a key accessor reference.
 */
function getKey(_, ctx) {
  const k = 'k:' + _.$key + '_' + !!_.$flat;
  return ctx.fn[k] || (ctx.fn[k] = key(_.$key, _.$flat, ctx.expr.codegen));
}

/**
 * Resolve a field accessor reference.
 */
function getField(_, ctx) {
  if (!_.$field) return null;
  const k = 'f:' + _.$field + '_' + _.$name;
  return ctx.fn[k] || (ctx.fn[k] = field$1(_.$field, _.$name, ctx.expr.codegen));
}

/**
 * Resolve a comparator function reference.
 */
function getCompare(_, ctx) {
  // As of Vega 5.5.3, $tupleid sort is no longer used.
  // Keep here for now for backwards compatibility.
  const k = 'c:' + _.$compare + '_' + _.$order,
    c = array$5(_.$compare).map(_ => _ && _.$tupleid ? tupleid : _);
  return ctx.fn[k] || (ctx.fn[k] = compare$1(c, _.$order, ctx.expr.codegen));
}

/**
 * Resolve an encode operator reference.
 */
function getEncode(_, ctx) {
  const spec = _.$encode,
    encode = {};
  for (const name in spec) {
    const enc = spec[name];
    encode[name] = accessor(ctx.encodeExpression(enc.$expr), enc.$fields);
    encode[name].output = enc.$output;
  }
  return encode;
}

/**
 * Resolve a context reference.
 */
function getContext(_, ctx) {
  return ctx;
}

/**
 * Resolve a recursive subflow specification.
 */
function getSubflow(_, ctx) {
  const spec = _.$subflow;
  return function (dataflow, key, parent) {
    const subctx = ctx.fork().parse(spec),
      op = subctx.get(spec.operators[0].id),
      p = subctx.signals.parent;
    if (p) p.set(parent);
    op.detachSubflow = () => ctx.detach(subctx);
    return op;
  };
}

/**
 * Resolve a tuple id reference.
 */
function getTupleId() {
  return tupleid;
}

/**
 * Parse an event stream specification.
 */
function parseStream$2(spec) {
  var ctx = this,
    filter = spec.filter != null ? ctx.eventExpression(spec.filter) : undefined,
    stream = spec.stream != null ? ctx.get(spec.stream) : undefined,
    args;
  if (spec.source) {
    stream = ctx.events(spec.source, spec.type, filter);
  } else if (spec.merge) {
    args = spec.merge.map(_ => ctx.get(_));
    stream = args[0].merge.apply(args[0], args.slice(1));
  }
  if (spec.between) {
    args = spec.between.map(_ => ctx.get(_));
    stream = stream.between(args[0], args[1]);
  }
  if (spec.filter) {
    stream = stream.filter(filter);
  }
  if (spec.throttle != null) {
    stream = stream.throttle(+spec.throttle);
  }
  if (spec.debounce != null) {
    stream = stream.debounce(+spec.debounce);
  }
  if (stream == null) {
    error('Invalid stream definition: ' + JSON.stringify(spec));
  }
  if (spec.consume) stream.consume(true);
  ctx.stream(spec, stream);
}

/**
 * Parse an event-driven operator update.
 */
function parseUpdate$1(spec) {
  var ctx = this,
    srcid = isObject(srcid = spec.source) ? srcid.$ref : srcid,
    source = ctx.get(srcid),
    target = null,
    update = spec.update,
    params = undefined;
  if (!source) error('Source not defined: ' + spec.source);
  target = spec.target && spec.target.$expr ? ctx.eventExpression(spec.target.$expr) : ctx.get(spec.target);
  if (update && update.$expr) {
    if (update.$params) {
      params = ctx.parseParameters(update.$params);
    }
    update = ctx.handlerExpression(update.$expr);
  }
  ctx.update(spec, source, target, update, params);
}
const SKIP = {
  skip: true
};
function getState$1(options) {
  var ctx = this,
    state = {};
  if (options.signals) {
    var signals = state.signals = {};
    Object.keys(ctx.signals).forEach(key => {
      const op = ctx.signals[key];
      if (options.signals(key, op)) {
        signals[key] = op.value;
      }
    });
  }
  if (options.data) {
    var data = state.data = {};
    Object.keys(ctx.data).forEach(key => {
      const dataset = ctx.data[key];
      if (options.data(key, dataset)) {
        data[key] = dataset.input.value;
      }
    });
  }
  if (ctx.subcontext && options.recurse !== false) {
    state.subcontext = ctx.subcontext.map(ctx => ctx.getState(options));
  }
  return state;
}
function setState$1(state) {
  var ctx = this,
    df = ctx.dataflow,
    data = state.data,
    signals = state.signals;
  Object.keys(signals || {}).forEach(key => {
    df.update(ctx.signals[key], signals[key], SKIP);
  });
  Object.keys(data || {}).forEach(key => {
    df.pulse(ctx.data[key].input, df.changeset().remove(truthy).insert(data[key]));
  });
  (state.subcontext || []).forEach((substate, i) => {
    const subctx = ctx.subcontext[i];
    if (subctx) subctx.setState(substate);
  });
}

/**
 * Context objects store the current parse state.
 * Enables lookup of parsed operators, event streams, accessors, etc.
 * Provides a 'fork' method for creating child contexts for subflows.
 */
function context(df, transforms, functions, expr) {
  return new Context(df, transforms, functions, expr);
}
function Context(df, transforms, functions, expr) {
  this.dataflow = df;
  this.transforms = transforms;
  this.events = df.events.bind(df);
  this.expr = expr || expressionCodegen, this.signals = {};
  this.scales = {};
  this.nodes = {};
  this.data = {};
  this.fn = {};
  if (functions) {
    this.functions = Object.create(functions);
    this.functions.context = this;
  }
}
function Subcontext(ctx) {
  this.dataflow = ctx.dataflow;
  this.transforms = ctx.transforms;
  this.events = ctx.events;
  this.expr = ctx.expr;
  this.signals = Object.create(ctx.signals);
  this.scales = Object.create(ctx.scales);
  this.nodes = Object.create(ctx.nodes);
  this.data = Object.create(ctx.data);
  this.fn = Object.create(ctx.fn);
  if (ctx.functions) {
    this.functions = Object.create(ctx.functions);
    this.functions.context = this;
  }
}
Context.prototype = Subcontext.prototype = {
  fork() {
    const ctx = new Subcontext(this);
    (this.subcontext || (this.subcontext = [])).push(ctx);
    return ctx;
  },
  detach(ctx) {
    this.subcontext = this.subcontext.filter(c => c !== ctx);

    // disconnect all nodes in the subcontext
    // wipe out targets first for better efficiency
    const keys = Object.keys(ctx.nodes);
    for (const key of keys) ctx.nodes[key]._targets = null;
    for (const key of keys) ctx.nodes[key].detach();
    ctx.nodes = null;
  },
  get(id) {
    return this.nodes[id];
  },
  set(id, node) {
    return this.nodes[id] = node;
  },
  add(spec, op) {
    const ctx = this,
      df = ctx.dataflow,
      data = spec.value;
    ctx.set(spec.id, op);
    if (isCollect(spec.type) && data) {
      if (data.$ingest) {
        df.ingest(op, data.$ingest, data.$format);
      } else if (data.$request) {
        df.preload(op, data.$request, data.$format);
      } else {
        df.pulse(op, df.changeset().insert(data));
      }
    }
    if (spec.root) {
      ctx.root = op;
    }
    if (spec.parent) {
      let p = ctx.get(spec.parent.$ref);
      if (p) {
        df.connect(p, [op]);
        op.targets().add(p);
      } else {
        (ctx.unresolved = ctx.unresolved || []).push(() => {
          p = ctx.get(spec.parent.$ref);
          df.connect(p, [op]);
          op.targets().add(p);
        });
      }
    }
    if (spec.signal) {
      ctx.signals[spec.signal] = op;
    }
    if (spec.scale) {
      ctx.scales[spec.scale] = op;
    }
    if (spec.data) {
      for (const name in spec.data) {
        const data = ctx.data[name] || (ctx.data[name] = {});
        spec.data[name].forEach(role => data[role] = op);
      }
    }
  },
  resolve() {
    (this.unresolved || []).forEach(fn => fn());
    delete this.unresolved;
    return this;
  },
  operator(spec, update) {
    this.add(spec, this.dataflow.add(spec.value, update));
  },
  transform(spec, type) {
    this.add(spec, this.dataflow.add(this.transforms[canonicalType(type)]));
  },
  stream(spec, stream) {
    this.set(spec.id, stream);
  },
  update(spec, stream, target, update, params) {
    this.dataflow.on(stream, target, update, params, spec.options);
  },
  // expression parsing
  operatorExpression(expr) {
    return this.expr.operator(this, expr);
  },
  parameterExpression(expr) {
    return this.expr.parameter(this, expr);
  },
  eventExpression(expr) {
    return this.expr.event(this, expr);
  },
  handlerExpression(expr) {
    return this.expr.handler(this, expr);
  },
  encodeExpression(encode) {
    return this.expr.encode(this, encode);
  },
  // parse methods
  parse: parse$2,
  parseOperator,
  parseOperatorParameters,
  parseParameters: parseParameters$1,
  parseStream: parseStream$2,
  parseUpdate: parseUpdate$1,
  // state methods
  getState: getState$1,
  setState: setState$1
};

// initialize aria role and label attributes
function initializeAria(view) {
  const el = view.container();
  if (el) {
    el.setAttribute('role', 'graphics-document');
    el.setAttribute('aria-roleDescription', 'visualization');
    ariaLabel(el, view.description());
  }
}

// update aria-label if we have a DOM container element
function ariaLabel(el, desc) {
  if (el) desc == null ? el.removeAttribute('aria-label') : el.setAttribute('aria-label', desc);
}
function background(view) {
  // respond to background signal
  view.add(null, _ => {
    view._background = _.bg;
    view._resize = 1;
    return _.bg;
  }, {
    bg: view._signals.background
  });
}
const Default = 'default';
function cursor(view) {
  // get cursor signal, add to dataflow if needed
  const cursor = view._signals.cursor || (view._signals.cursor = view.add({
    user: Default,
    item: null
  }));

  // evaluate cursor on each pointermove event
  view.on(view.events('view', 'pointermove'), cursor, (_, event) => {
    const value = cursor.value,
      user = value ? isString(value) ? value : value.user : Default,
      item = event.item && event.item.cursor || null;
    return value && user === value.user && item == value.item ? value : {
      user: user,
      item: item
    };
  });

  // when cursor signal updates, set visible cursor
  view.add(null, function (_) {
    let user = _.cursor,
      item = this.value;
    if (!isString(user)) {
      item = user.item;
      user = user.user;
    }
    setCursor(view, user && user !== Default ? user : item || user);
    return item;
  }, {
    cursor: cursor
  });
}
function setCursor(view, cursor) {
  const el = view.globalCursor() ? typeof document !== 'undefined' && document.body : view.container();
  if (el) {
    return cursor == null ? el.style.removeProperty('cursor') : el.style.cursor = cursor;
  }
}
function dataref(view, name) {
  var data = view._runtime.data;
  if (!has$1(data, name)) {
    error('Unrecognized data set: ' + name);
  }
  return data[name];
}
function data(name, values) {
  return arguments.length < 2 ? dataref(this, name).values.value : change.call(this, name, changeset().remove(truthy).insert(values));
}
function change(name, changes) {
  if (!isChangeSet(changes)) {
    error('Second argument to changes must be a changeset.');
  }
  const dataset = dataref(this, name);
  dataset.modified = true;
  return this.pulse(dataset.input, changes);
}
function insert(name, _) {
  return change.call(this, name, changeset().insert(_));
}
function remove(name, _) {
  return change.call(this, name, changeset().remove(_));
}
function width(view) {
  var padding = view.padding();
  return Math.max(0, view._viewWidth + padding.left + padding.right);
}
function height(view) {
  var padding = view.padding();
  return Math.max(0, view._viewHeight + padding.top + padding.bottom);
}
function offset(view) {
  var padding = view.padding(),
    origin = view._origin;
  return [padding.left + origin[0], padding.top + origin[1]];
}
function resizeRenderer(view) {
  var origin = offset(view),
    w = width(view),
    h = height(view);
  view._renderer.background(view.background());
  view._renderer.resize(w, h, origin);
  view._handler.origin(origin);
  view._resizeListeners.forEach(handler => {
    try {
      handler(w, h);
    } catch (error) {
      view.error(error);
    }
  });
}

/**
 * Extend an event with additional view-specific methods.
 * Adds a new property ('vega') to an event that provides a number
 * of methods for querying information about the current interaction.
 * The vega object provides the following methods:
 *   view - Returns the backing View instance.
 *   item - Returns the currently active scenegraph item (if any).
 *   group - Returns the currently active scenegraph group (if any).
 *     This method accepts a single string-typed argument indicating the name
 *     of the desired parent group. The scenegraph will be traversed from
 *     the item up towards the root to search for a matching group. If no
 *     argument is provided the enclosing group for the active item is
 *     returned, unless the item it itself a group, in which case it is
 *     returned directly.
 *   xy - Returns a two-element array containing the x and y coordinates for
 *     mouse or touch events. For touch events, this is based on the first
 *     elements in the changedTouches array. This method accepts a single
 *     argument: either an item instance or mark name that should serve as
 *     the reference coordinate system. If no argument is provided the
 *     top-level view coordinate system is assumed.
 *   x - Returns the current x-coordinate, accepts the same arguments as xy.
 *   y - Returns the current y-coordinate, accepts the same arguments as xy.
 * @param {Event} event - The input event to extend.
 * @param {Item} item - The currently active scenegraph item (if any).
 * @return {Event} - The extended input event.
 */
function eventExtend(view, event, item) {
  var r = view._renderer,
    el = r && r.canvas(),
    p,
    e,
    translate;
  if (el) {
    translate = offset(view);
    e = event.changedTouches ? event.changedTouches[0] : event;
    p = point(e, el);
    p[0] -= translate[0];
    p[1] -= translate[1];
  }
  event.dataflow = view;
  event.item = item;
  event.vega = extension(view, item, p);
  return event;
}
function extension(view, item, point) {
  const itemGroup = item ? item.mark.marktype === 'group' ? item : item.mark.group : null;
  function group(name) {
    var g = itemGroup,
      i;
    if (name) for (i = item; i; i = i.mark.group) {
      if (i.mark.name === name) {
        g = i;
        break;
      }
    }
    return g && g.mark && g.mark.interactive ? g : {};
  }
  function xy(item) {
    if (!item) return point;
    if (isString(item)) item = group(item);
    const p = point.slice();
    while (item) {
      p[0] -= item.x || 0;
      p[1] -= item.y || 0;
      item = item.mark && item.mark.group;
    }
    return p;
  }
  return {
    view: constant$5(view),
    item: constant$5(item || {}),
    group: group,
    xy: xy,
    x: item => xy(item)[0],
    y: item => xy(item)[1]
  };
}
const VIEW$1 = 'view',
  TIMER = 'timer',
  WINDOW = 'window',
  NO_TRAP = {
    trap: false
  };

/**
 * Initialize event handling configuration.
 * @param {object} config - The configuration settings.
 * @return {object}
 */
function initializeEventConfig(config) {
  const events = extend$1({
    defaults: {}
  }, config);
  const unpack = (obj, keys) => {
    keys.forEach(k => {
      if (isArray(obj[k])) obj[k] = toSet(obj[k]);
    });
  };
  unpack(events.defaults, ['prevent', 'allow']);
  unpack(events, ['view', 'window', 'selector']);
  return events;
}
function trackEventListener(view, sources, type, handler) {
  view._eventListeners.push({
    type: type,
    sources: array$5(sources),
    handler: handler
  });
}
function prevent(view, type) {
  var def = view._eventConfig.defaults,
    prevent = def.prevent,
    allow = def.allow;
  return prevent === false || allow === true ? false : prevent === true || allow === false ? true : prevent ? prevent[type] : allow ? !allow[type] : view.preventDefault();
}
function permit(view, key, type) {
  const rule = view._eventConfig && view._eventConfig[key];
  if (rule === false || isObject(rule) && !rule[type]) {
    view.warn(`Blocked ${key} ${type} event listener.`);
    return false;
  }
  return true;
}

/**
 * Create a new event stream from an event source.
 * @param {object} source - The event source to monitor.
 * @param {string} type - The event type.
 * @param {function(object): boolean} [filter] - Event filter function.
 * @return {EventStream}
 */
function events(source, type, filter) {
  var view = this,
    s = new EventStream(filter),
    send = function (e, item) {
      view.runAsync(null, () => {
        if (source === VIEW$1 && prevent(view, type)) {
          e.preventDefault();
        }
        s.receive(eventExtend(view, e, item));
      });
    },
    sources;
  if (source === TIMER) {
    if (permit(view, 'timer', type)) {
      view.timer(send, type);
    }
  } else if (source === VIEW$1) {
    if (permit(view, 'view', type)) {
      // send traps errors, so use {trap: false} option
      view.addEventListener(type, send, NO_TRAP);
    }
  } else {
    if (source === WINDOW) {
      if (permit(view, 'window', type) && typeof window !== 'undefined') {
        sources = [window];
      }
    } else if (typeof document !== 'undefined') {
      if (permit(view, 'selector', type)) {
        sources = Array.from(document.querySelectorAll(source));
      }
    }
    if (!sources) {
      view.warn('Can not resolve event source: ' + source);
    } else {
      for (var i = 0, n = sources.length; i < n; ++i) {
        sources[i].addEventListener(type, send);
      }
      trackEventListener(view, sources, type, send);
    }
  }
  return s;
}
function itemFilter(event) {
  return event.item;
}
function markTarget(event) {
  // grab upstream collector feeding the mark operator
  return event.item.mark.source;
}
function invoke(name) {
  return function (_, event) {
    return event.vega.view().changeset().encode(event.item, name);
  };
}
function hover(hoverSet, leaveSet) {
  hoverSet = [hoverSet || 'hover'];
  leaveSet = [leaveSet || 'update', hoverSet[0]];

  // invoke hover set upon pointerover
  this.on(this.events('view', 'pointerover', itemFilter), markTarget, invoke(hoverSet));

  // invoke leave set upon pointerout
  this.on(this.events('view', 'pointerout', itemFilter), markTarget, invoke(leaveSet));
  return this;
}

/**
 * Finalize a View instance that is being removed.
 * Cancel any running timers.
 * Remove all external event listeners.
 * Remove any currently displayed tooltip.
 */
function finalize() {
  var tooltip = this._tooltip,
    timers = this._timers,
    handlers = this._handler.handlers(),
    listeners = this._eventListeners,
    n,
    m,
    e,
    h,
    t;
  n = timers.length;
  while (--n >= 0) {
    timers[n].stop();
  }
  n = listeners.length;
  while (--n >= 0) {
    e = listeners[n];
    m = e.sources.length;
    while (--m >= 0) {
      e.sources[m].removeEventListener(e.type, e.handler);
    }
  }
  if (tooltip) {
    tooltip.call(this, this._handler, null, null, null);
  }

  // turn off all registered handlers
  n = handlers.length;
  while (--n >= 0) {
    t = handlers[n].type;
    h = handlers[n].handler;
    this._handler.off(t, h);
  }
  return this;
}
function element(tag, attr, text) {
  const el = document.createElement(tag);
  for (const key in attr) el.setAttribute(key, attr[key]);
  if (text != null) el.textContent = text;
  return el;
}
const BindClass = 'vega-bind',
  NameClass = 'vega-bind-name',
  RadioClass = 'vega-bind-radio';

/**
 * Bind a signal to an external HTML input element. The resulting two-way
 * binding will propagate input changes to signals, and propagate signal
 * changes to the input element state. If this view instance has no parent
 * element, we assume the view is headless and no bindings are created.
 * @param {Element|string} el - The parent DOM element to which the input
 *   element should be appended as a child. If string-valued, this argument
 *   will be treated as a CSS selector. If null or undefined, the parent
 *   element of this view will be used as the element.
 * @param {object} param - The binding parameters which specify the signal
 *   to bind to, the input element type, and type-specific configuration.
 * @return {View} - This view instance.
 */
function bind(view, el, binding) {
  if (!el) return;
  const param = binding.param;
  let bind = binding.state;
  if (!bind) {
    bind = binding.state = {
      elements: null,
      active: false,
      set: null,
      update: value => {
        if (value != view.signal(param.signal)) {
          view.runAsync(null, () => {
            bind.source = true;
            view.signal(param.signal, value);
          });
        }
      }
    };
    if (param.debounce) {
      bind.update = debounce(param.debounce, bind.update);
    }
  }
  const create = param.input == null && param.element ? target : generate;
  create(bind, el, param, view);
  if (!bind.active) {
    view.on(view._signals[param.signal], null, () => {
      bind.source ? bind.source = false : bind.set(view.signal(param.signal));
    });
    bind.active = true;
  }
  return bind;
}

/**
 * Bind the signal to an external EventTarget.
 */
function target(bind, node, param, view) {
  const type = param.event || 'input';
  const handler = () => bind.update(node.value);

  // initialize signal value to external input value
  view.signal(param.signal, node.value);

  // listen for changes on the element
  node.addEventListener(type, handler);

  // register with view, so we can remove it upon finalization
  trackEventListener(view, node, type, handler);

  // propagate change to element
  bind.set = value => {
    node.value = value;
    node.dispatchEvent(event(type));
  };
}
function event(type) {
  return typeof Event !== 'undefined' ? new Event(type) : {
    type
  };
}

/**
 * Generate an HTML input form element and bind it to a signal.
 */
function generate(bind, el, param, view) {
  const value = view.signal(param.signal);
  const div = element('div', {
    'class': BindClass
  });
  const wrapper = param.input === 'radio' ? div : div.appendChild(element('label'));
  wrapper.appendChild(element('span', {
    'class': NameClass
  }, param.name || param.signal));
  el.appendChild(div);
  let input = form;
  switch (param.input) {
    case 'checkbox':
      input = checkbox;
      break;
    case 'select':
      input = select;
      break;
    case 'radio':
      input = radio;
      break;
    case 'range':
      input = range;
      break;
  }
  input(bind, wrapper, param, value);
}

/**
 * Generates an arbitrary input form element.
 * The input type is controlled via user-provided parameters.
 */
function form(bind, el, param, value) {
  const node = element('input');
  for (const key in param) {
    if (key !== 'signal' && key !== 'element') {
      node.setAttribute(key === 'input' ? 'type' : key, param[key]);
    }
  }
  node.setAttribute('name', param.signal);
  node.value = value;
  el.appendChild(node);
  node.addEventListener('input', () => bind.update(node.value));
  bind.elements = [node];
  bind.set = value => node.value = value;
}

/**
 * Generates a checkbox input element.
 */
function checkbox(bind, el, param, value) {
  const attr = {
    type: 'checkbox',
    name: param.signal
  };
  if (value) attr.checked = true;
  const node = element('input', attr);
  el.appendChild(node);
  node.addEventListener('change', () => bind.update(node.checked));
  bind.elements = [node];
  bind.set = value => node.checked = !!value || null;
}

/**
 * Generates a selection list input element.
 */
function select(bind, el, param, value) {
  const node = element('select', {
      name: param.signal
    }),
    labels = param.labels || [];
  param.options.forEach((option, i) => {
    const attr = {
      value: option
    };
    if (valuesEqual(option, value)) attr.selected = true;
    node.appendChild(element('option', attr, (labels[i] || option) + ''));
  });
  el.appendChild(node);
  node.addEventListener('change', () => {
    bind.update(param.options[node.selectedIndex]);
  });
  bind.elements = [node];
  bind.set = value => {
    for (let i = 0, n = param.options.length; i < n; ++i) {
      if (valuesEqual(param.options[i], value)) {
        node.selectedIndex = i;
        return;
      }
    }
  };
}

/**
 * Generates a radio button group.
 */
function radio(bind, el, param, value) {
  const group = element('span', {
      'class': RadioClass
    }),
    labels = param.labels || [];
  el.appendChild(group);
  bind.elements = param.options.map((option, i) => {
    const attr = {
      type: 'radio',
      name: param.signal,
      value: option
    };
    if (valuesEqual(option, value)) attr.checked = true;
    const input = element('input', attr);
    input.addEventListener('change', () => bind.update(option));
    const label = element('label', {}, (labels[i] || option) + '');
    label.prepend(input);
    group.appendChild(label);
    return input;
  });
  bind.set = value => {
    const nodes = bind.elements,
      n = nodes.length;
    for (let i = 0; i < n; ++i) {
      if (valuesEqual(nodes[i].value, value)) nodes[i].checked = true;
    }
  };
}

/**
 * Generates a slider input element.
 */
function range(bind, el, param, value) {
  value = value !== undefined ? value : (+param.max + +param.min) / 2;
  const max = param.max != null ? param.max : Math.max(100, +value) || 100,
    min = param.min || Math.min(0, max, +value) || 0,
    step = param.step || tickStep(min, max, 100);
  const node = element('input', {
    type: 'range',
    name: param.signal,
    min: min,
    max: max,
    step: step
  });
  node.value = value;
  const span = element('span', {}, +value);
  el.appendChild(node);
  el.appendChild(span);
  const update = () => {
    span.textContent = node.value;
    bind.update(+node.value);
  };

  // subscribe to both input and change
  node.addEventListener('input', update);
  node.addEventListener('change', update);
  bind.elements = [node];
  bind.set = value => {
    node.value = value;
    span.textContent = value;
  };
}
function valuesEqual(a, b) {
  return a === b || a + '' === b + '';
}
function initializeRenderer(view, r, el, constructor, scaleFactor, opt) {
  r = r || new constructor(view.loader());
  return r.initialize(el, width(view), height(view), offset(view), scaleFactor, opt).background(view.background());
}
function trap(view, fn) {
  return !fn ? null : function () {
    try {
      fn.apply(this, arguments);
    } catch (error) {
      view.error(error);
    }
  };
}
function initializeHandler(view, prevHandler, el, constructor) {
  // instantiate scenegraph handler
  const handler = new constructor(view.loader(), trap(view, view.tooltip())).scene(view.scenegraph().root).initialize(el, offset(view), view);

  // transfer event handlers
  if (prevHandler) {
    prevHandler.handlers().forEach(h => {
      handler.on(h.type, h.handler);
    });
  }
  return handler;
}
function initialize(el, elBind) {
  const view = this,
    type = view._renderType,
    config = view._eventConfig.bind,
    module = renderModule(type);

  // containing dom element
  el = view._el = el ? lookup$1(view, el, true) : null;

  // initialize aria attributes
  initializeAria(view);

  // select appropriate renderer & handler
  if (!module) view.error('Unrecognized renderer type: ' + type);
  const Handler = module.handler || CanvasHandler,
    Renderer = el ? module.renderer : module.headless;

  // initialize renderer and input handler
  view._renderer = !Renderer ? null : initializeRenderer(view, view._renderer, el, Renderer);
  view._handler = initializeHandler(view, view._handler, el, Handler);
  view._redraw = true;

  // initialize signal bindings
  if (el && config !== 'none') {
    elBind = elBind ? view._elBind = lookup$1(view, elBind, true) : el.appendChild(element('form', {
      'class': 'vega-bindings'
    }));
    view._bind.forEach(_ => {
      if (_.param.element && config !== 'container') {
        _.element = lookup$1(view, _.param.element, !!_.param.input);
      }
    });
    view._bind.forEach(_ => {
      bind(view, _.element || elBind, _);
    });
  }
  return view;
}
function lookup$1(view, el, clear) {
  if (typeof el === 'string') {
    if (typeof document !== 'undefined') {
      el = document.querySelector(el);
      if (!el) {
        view.error('Signal bind element not found: ' + el);
        return null;
      }
    } else {
      view.error('DOM document instance not found.');
      return null;
    }
  }
  if (el && clear) {
    try {
      el.textContent = '';
    } catch (e) {
      el = null;
      view.error(e);
    }
  }
  return el;
}
const number$1 = _ => +_ || 0;
const paddingObject$1 = _ => ({
  top: _,
  bottom: _,
  left: _,
  right: _
});
function padding(_) {
  return isObject(_) ? {
    top: number$1(_.top),
    bottom: number$1(_.bottom),
    left: number$1(_.left),
    right: number$1(_.right)
  } : paddingObject$1(number$1(_));
}

/**
 * Render the current scene in a headless fashion.
 * This method is asynchronous, returning a Promise instance.
 * @return {Promise} - A Promise that resolves to a renderer.
 */
async function renderHeadless(view, type, scaleFactor, opt) {
  const module = renderModule(type),
    ctr = module && module.headless;
  if (!ctr) error('Unrecognized renderer type: ' + type);
  await view.runAsync();
  return initializeRenderer(view, null, null, ctr, scaleFactor, opt).renderAsync(view._scenegraph.root);
}

/**
 * Produce an image URL for the visualization. Depending on the type
 * parameter, the generated URL contains data for either a PNG or SVG image.
 * The URL can be used (for example) to download images of the visualization.
 * This method is asynchronous, returning a Promise instance.
 * @param {string} type - The image type. One of 'svg', 'png' or 'canvas'.
 *   The 'canvas' and 'png' types are synonyms for a PNG image.
 * @return {Promise} - A promise that resolves to an image URL.
 */
async function renderToImageURL(type, scaleFactor) {
  if (type !== RenderType.Canvas && type !== RenderType.SVG && type !== RenderType.PNG) {
    error('Unrecognized image type: ' + type);
  }
  const r = await renderHeadless(this, type, scaleFactor);
  return type === RenderType.SVG ? toBlobURL(r.svg(), 'image/svg+xml') : r.canvas().toDataURL('image/png');
}
function toBlobURL(data, mime) {
  const blob = new Blob([data], {
    type: mime
  });
  return window.URL.createObjectURL(blob);
}

/**
 * Produce a Canvas instance containing a rendered visualization.
 * This method is asynchronous, returning a Promise instance.
 * @return {Promise} - A promise that resolves to a Canvas instance.
 */
async function renderToCanvas(scaleFactor, opt) {
  const r = await renderHeadless(this, RenderType.Canvas, scaleFactor, opt);
  return r.canvas();
}

/**
 * Produce a rendered SVG string of the visualization.
 * This method is asynchronous, returning a Promise instance.
 * @return {Promise} - A promise that resolves to an SVG string.
 */
async function renderToSVG(scaleFactor) {
  const r = await renderHeadless(this, RenderType.SVG, scaleFactor);
  return r.svg();
}
function runtime(view, spec, expr) {
  return context(view, transforms, functionContext, expr).parse(spec);
}
function scale$1(name) {
  var scales = this._runtime.scales;
  if (!has$1(scales, name)) {
    error('Unrecognized scale or projection: ' + name);
  }
  return scales[name].value;
}
var Width = 'width',
  Height = 'height',
  Padding = 'padding',
  Skip$1 = {
    skip: true
  };
function viewWidth(view, width) {
  var a = view.autosize(),
    p = view.padding();
  return width - (a && a.contains === Padding ? p.left + p.right : 0);
}
function viewHeight(view, height) {
  var a = view.autosize(),
    p = view.padding();
  return height - (a && a.contains === Padding ? p.top + p.bottom : 0);
}
function initializeResize(view) {
  var s = view._signals,
    w = s[Width],
    h = s[Height],
    p = s[Padding];
  function resetSize() {
    view._autosize = view._resize = 1;
  }

  // respond to width signal
  view._resizeWidth = view.add(null, _ => {
    view._width = _.size;
    view._viewWidth = viewWidth(view, _.size);
    resetSize();
  }, {
    size: w
  });

  // respond to height signal
  view._resizeHeight = view.add(null, _ => {
    view._height = _.size;
    view._viewHeight = viewHeight(view, _.size);
    resetSize();
  }, {
    size: h
  });

  // respond to padding signal
  const resizePadding = view.add(null, resetSize, {
    pad: p
  });

  // set rank to run immediately after source signal
  view._resizeWidth.rank = w.rank + 1;
  view._resizeHeight.rank = h.rank + 1;
  resizePadding.rank = p.rank + 1;
}
function resizeView(viewWidth, viewHeight, width, height, origin, auto) {
  this.runAfter(view => {
    let rerun = 0;

    // reset autosize flag
    view._autosize = 0;

    // width value changed: update signal, skip resize op
    if (view.width() !== width) {
      rerun = 1;
      view.signal(Width, width, Skip$1); // set width, skip update calc
      view._resizeWidth.skip(true); // skip width resize handler
    }

    // height value changed: update signal, skip resize op
    if (view.height() !== height) {
      rerun = 1;
      view.signal(Height, height, Skip$1); // set height, skip update calc
      view._resizeHeight.skip(true); // skip height resize handler
    }

    // view width changed: update view property, set resize flag
    if (view._viewWidth !== viewWidth) {
      view._resize = 1;
      view._viewWidth = viewWidth;
    }

    // view height changed: update view property, set resize flag
    if (view._viewHeight !== viewHeight) {
      view._resize = 1;
      view._viewHeight = viewHeight;
    }

    // origin changed: update view property, set resize flag
    if (view._origin[0] !== origin[0] || view._origin[1] !== origin[1]) {
      view._resize = 1;
      view._origin = origin;
    }

    // run dataflow on width/height signal change
    if (rerun) view.run('enter');
    if (auto) view.runAfter(v => v.resize());
  }, false, 1);
}

/**
 * Get the current view state, consisting of signal values and/or data sets.
 * @param {object} [options] - Options flags indicating which state to export.
 *   If unspecified, all signals and data sets will be exported.
 * @param {function(string, Operator):boolean} [options.signals] - Optional
 *   predicate function for testing if a signal should be included in the
 *   exported state. If unspecified, all signals will be included, except for
 *   those named 'parent' or those which refer to a Transform value.
 * @param {function(string, object):boolean} [options.data] - Optional
 *   predicate function for testing if a data set's input should be included
 *   in the exported state. If unspecified, all data sets that have been
 *   explicitly modified will be included.
 * @param {boolean} [options.recurse=true] - Flag indicating if the exported
 *   state should recursively include state from group mark sub-contexts.
 * @return {object} - An object containing the exported state values.
 */
function getState(options) {
  return this._runtime.getState(options || {
    data: dataTest,
    signals: signalTest,
    recurse: true
  });
}
function dataTest(name, data) {
  return data.modified && isArray(data.input.value) && !name.startsWith('_:vega:_');
}
function signalTest(name, op) {
  return !(name === 'parent' || op instanceof transforms.proxy);
}

/**
 * Sets the current view state and updates the view by invoking run.
 * @param {object} state - A state object containing signal and/or
 *   data set values, following the format used by the getState method.
 * @return {View} - This view instance.
 */
function setState(state) {
  this.runAsync(null, v => {
    v._trigger = false;
    v._runtime.setState(state);
  }, v => {
    v._trigger = true;
  });
  return this;
}
function timer(callback, delay) {
  function tick(elapsed) {
    callback({
      timestamp: Date.now(),
      elapsed: elapsed
    });
  }
  this._timers.push(interval(tick, delay));
}
function defaultTooltip(handler, event, item, value) {
  const el = handler.element();
  if (el) el.setAttribute('title', formatTooltip(value));
}
function formatTooltip(value) {
  return value == null ? '' : isArray(value) ? formatArray(value) : isObject(value) && !isDate$1(value) ? formatObject(value) : value + '';
}
function formatObject(obj) {
  return Object.keys(obj).map(key => {
    const v = obj[key];
    return key + ': ' + (isArray(v) ? formatArray(v) : formatValue(v));
  }).join('\n');
}
function formatArray(value) {
  return '[' + value.map(formatValue).join(', ') + ']';
}
function formatValue(value) {
  return isArray(value) ? '[\u2026]' : isObject(value) && !isDate$1(value) ? '{\u2026}' : value;
}
function watchPixelRatio() {
  // based on https://developer.mozilla.org/en-US/docs/Web/API/Window/devicePixelRatio#monitoring_screen_resolution_or_zoom_level_changes
  if (this.renderer() === 'canvas' && this._renderer._canvas) {
    let remove = null;
    const updatePixelRatio = () => {
      if (remove != null) {
        remove();
      }
      const media = matchMedia(`(resolution: ${window.devicePixelRatio}dppx)`);
      media.addEventListener('change', updatePixelRatio);
      remove = () => {
        media.removeEventListener('change', updatePixelRatio);
      };
      this._renderer._canvas.getContext('2d').pixelRatio = window.devicePixelRatio || 1;
      this._redraw = true;
      this._resize = 1;
      this.resize().runAsync();
    };
    updatePixelRatio();
  }
}

/**
 * Create a new View instance from a Vega dataflow runtime specification.
 * The generated View will not immediately be ready for display. Callers
 * should also invoke the initialize method (e.g., to set the parent
 * DOM element in browser-based deployment) and then invoke the run
 * method to evaluate the dataflow graph. Rendering will automatically
 * be performed upon dataflow runs.
 * @constructor
 * @param {object} spec - The Vega dataflow runtime specification.
 */
function View$1(spec, options) {
  const view = this;
  options = options || {};
  Dataflow.call(view);
  if (options.loader) view.loader(options.loader);
  if (options.logger) view.logger(options.logger);
  if (options.logLevel != null) view.logLevel(options.logLevel);
  if (options.locale || spec.locale) {
    const loc = extend$1({}, spec.locale, options.locale);
    view.locale(locale(loc.number, loc.time));
  }
  view._el = null;
  view._elBind = null;
  view._renderType = options.renderer || RenderType.Canvas;
  view._scenegraph = new Scenegraph();
  const root = view._scenegraph.root;

  // initialize renderer, handler and event management
  view._renderer = null;
  view._tooltip = options.tooltip || defaultTooltip, view._redraw = true;
  view._handler = new CanvasHandler().scene(root);
  view._globalCursor = false;
  view._preventDefault = false;
  view._timers = [];
  view._eventListeners = [];
  view._resizeListeners = [];

  // initialize event configuration
  view._eventConfig = initializeEventConfig(spec.eventConfig);
  view.globalCursor(view._eventConfig.globalCursor);

  // initialize dataflow graph
  const ctx = runtime(view, spec, options.expr);
  view._runtime = ctx;
  view._signals = ctx.signals;
  view._bind = (spec.bindings || []).map(_ => ({
    state: null,
    param: extend$1({}, _)
  }));

  // initialize scenegraph
  if (ctx.root) ctx.root.set(root);
  root.source = ctx.data.root.input;
  view.pulse(ctx.data.root.input, view.changeset().insert(root.items));

  // initialize view size
  view._width = view.width();
  view._height = view.height();
  view._viewWidth = viewWidth(view, view._width);
  view._viewHeight = viewHeight(view, view._height);
  view._origin = [0, 0];
  view._resize = 0;
  view._autosize = 1;
  initializeResize(view);

  // initialize background color
  background(view);

  // initialize cursor
  cursor(view);

  // initialize view description
  view.description(spec.description);

  // initialize hover proessing, if requested
  if (options.hover) view.hover();

  // initialize DOM container(s) and renderer
  if (options.container) view.initialize(options.container, options.bind);
  if (options.watchPixelRatio) view._watchPixelRatio();
}
function lookupSignal(view, name) {
  return has$1(view._signals, name) ? view._signals[name] : error('Unrecognized signal name: ' + $(name));
}
function findOperatorHandler(op, handler) {
  const h = (op._targets || []).filter(op => op._update && op._update.handler === handler);
  return h.length ? h[0] : null;
}
function addOperatorListener(view, name, op, handler) {
  let h = findOperatorHandler(op, handler);
  if (!h) {
    h = trap(view, () => handler(name, op.value));
    h.handler = handler;
    view.on(op, null, h);
  }
  return view;
}
function removeOperatorListener(view, op, handler) {
  const h = findOperatorHandler(op, handler);
  if (h) op._targets.remove(h);
  return view;
}
inherits(View$1, Dataflow, {
  // -- DATAFLOW / RENDERING ----

  async evaluate(encode, prerun, postrun) {
    // evaluate dataflow and prerun
    await Dataflow.prototype.evaluate.call(this, encode, prerun);

    // render as needed
    if (this._redraw || this._resize) {
      try {
        if (this._renderer) {
          if (this._resize) {
            this._resize = 0;
            resizeRenderer(this);
          }
          await this._renderer.renderAsync(this._scenegraph.root);
        }
        this._redraw = false;
      } catch (e) {
        this.error(e);
      }
    }

    // evaluate postrun
    if (postrun) asyncCallback(this, postrun);
    return this;
  },
  dirty(item) {
    this._redraw = true;
    this._renderer && this._renderer.dirty(item);
  },
  // -- GET / SET ----

  description(text) {
    if (arguments.length) {
      const desc = text != null ? text + '' : null;
      if (desc !== this._desc) ariaLabel(this._el, this._desc = desc);
      return this;
    }
    return this._desc;
  },
  container() {
    return this._el;
  },
  scenegraph() {
    return this._scenegraph;
  },
  origin() {
    return this._origin.slice();
  },
  signal(name, value, options) {
    const op = lookupSignal(this, name);
    return arguments.length === 1 ? op.value : this.update(op, value, options);
  },
  width(_) {
    return arguments.length ? this.signal('width', _) : this.signal('width');
  },
  height(_) {
    return arguments.length ? this.signal('height', _) : this.signal('height');
  },
  padding(_) {
    return arguments.length ? this.signal('padding', padding(_)) : padding(this.signal('padding'));
  },
  autosize(_) {
    return arguments.length ? this.signal('autosize', _) : this.signal('autosize');
  },
  background(_) {
    return arguments.length ? this.signal('background', _) : this.signal('background');
  },
  renderer(type) {
    if (!arguments.length) return this._renderType;
    if (!renderModule(type)) error('Unrecognized renderer type: ' + type);
    if (type !== this._renderType) {
      this._renderType = type;
      this._resetRenderer();
    }
    return this;
  },
  tooltip(handler) {
    if (!arguments.length) return this._tooltip;
    if (handler !== this._tooltip) {
      this._tooltip = handler;
      this._resetRenderer();
    }
    return this;
  },
  loader(loader) {
    if (!arguments.length) return this._loader;
    if (loader !== this._loader) {
      Dataflow.prototype.loader.call(this, loader);
      this._resetRenderer();
    }
    return this;
  },
  resize() {
    // set flag to perform autosize
    this._autosize = 1;
    // touch autosize signal to ensure top-level ViewLayout runs
    return this.touch(lookupSignal(this, 'autosize'));
  },
  _resetRenderer() {
    if (this._renderer) {
      this._renderer = null;
      this.initialize(this._el, this._elBind);
    }
  },
  // -- SIZING ----
  _resizeView: resizeView,
  // -- EVENT HANDLING ----

  addEventListener(type, handler, options) {
    let callback = handler;
    if (!(options && options.trap === false)) {
      // wrap callback in error handler
      callback = trap(this, handler);
      callback.raw = handler;
    }
    this._handler.on(type, callback);
    return this;
  },
  removeEventListener(type, handler) {
    var handlers = this._handler.handlers(type),
      i = handlers.length,
      h,
      t;

    // search registered handlers, remove if match found
    while (--i >= 0) {
      t = handlers[i].type;
      h = handlers[i].handler;
      if (type === t && (handler === h || handler === h.raw)) {
        this._handler.off(t, h);
        break;
      }
    }
    return this;
  },
  addResizeListener(handler) {
    const l = this._resizeListeners;
    if (!l.includes(handler)) {
      // add handler if it isn't already registered
      // note: error trapping handled elsewhere, so
      // no need to wrap handlers here
      l.push(handler);
    }
    return this;
  },
  removeResizeListener(handler) {
    var l = this._resizeListeners,
      i = l.indexOf(handler);
    if (i >= 0) {
      l.splice(i, 1);
    }
    return this;
  },
  addSignalListener(name, handler) {
    return addOperatorListener(this, name, lookupSignal(this, name), handler);
  },
  removeSignalListener(name, handler) {
    return removeOperatorListener(this, lookupSignal(this, name), handler);
  },
  addDataListener(name, handler) {
    return addOperatorListener(this, name, dataref(this, name).values, handler);
  },
  removeDataListener(name, handler) {
    return removeOperatorListener(this, dataref(this, name).values, handler);
  },
  globalCursor(_) {
    if (arguments.length) {
      if (this._globalCursor !== !!_) {
        const prev = setCursor(this, null); // clear previous cursor
        this._globalCursor = !!_;
        if (prev) setCursor(this, prev); // swap cursor
      }
      return this;
    } else {
      return this._globalCursor;
    }
  },
  preventDefault(_) {
    if (arguments.length) {
      this._preventDefault = _;
      return this;
    } else {
      return this._preventDefault;
    }
  },
  timer,
  events,
  finalize,
  hover,
  // -- DATA ----
  data,
  change,
  insert,
  remove,
  // -- SCALES --
  scale: scale$1,
  // -- INITIALIZATION ----
  initialize,
  // -- HEADLESS RENDERING ----
  toImageURL: renderToImageURL,
  toCanvas: renderToCanvas,
  toSVG: renderToSVG,
  // -- SAVE / RESTORE STATE ----
  getState,
  setState,
  // RE-RENDER ON ZOOM
  _watchPixelRatio: watchPixelRatio
});

const VIEW = 'view',
  LBRACK = '[',
  RBRACK = ']',
  LBRACE = '{',
  RBRACE = '}',
  COLON = ':',
  COMMA = ',',
  NAME = '@',
  GT = '>',
  ILLEGAL = /[[\]{}]/,
  DEFAULT_MARKS = {
    '*': 1,
    arc: 1,
    area: 1,
    group: 1,
    image: 1,
    line: 1,
    path: 1,
    rect: 1,
    rule: 1,
    shape: 1,
    symbol: 1,
    text: 1,
    trail: 1
  };
let DEFAULT_SOURCE, MARKS;

/**
 * Parse an event selector string.
 * Returns an array of event stream definitions.
 */
function eventSelector(selector, source, marks) {
  DEFAULT_SOURCE = source || VIEW;
  MARKS = DEFAULT_MARKS;
  return parseMerge(selector.trim()).map(parseSelector);
}
function isMarkType(type) {
  return MARKS[type];
}
function find(s, i, endChar, pushChar, popChar) {
  const n = s.length;
  let count = 0,
    c;
  for (; i < n; ++i) {
    c = s[i];
    if (!count && c === endChar) return i;else if (popChar && popChar.indexOf(c) >= 0) --count;else if (pushChar && pushChar.indexOf(c) >= 0) ++count;
  }
  return i;
}
function parseMerge(s) {
  const output = [],
    n = s.length;
  let start = 0,
    i = 0;
  while (i < n) {
    i = find(s, i, COMMA, LBRACK + LBRACE, RBRACK + RBRACE);
    output.push(s.substring(start, i).trim());
    start = ++i;
  }
  if (output.length === 0) {
    throw 'Empty event selector: ' + s;
  }
  return output;
}
function parseSelector(s) {
  return s[0] === '[' ? parseBetween(s) : parseStream$1(s);
}
function parseBetween(s) {
  const n = s.length;
  let i = 1,
    b;
  i = find(s, i, RBRACK, LBRACK, RBRACK);
  if (i === n) {
    throw 'Empty between selector: ' + s;
  }
  b = parseMerge(s.substring(1, i));
  if (b.length !== 2) {
    throw 'Between selector must have two elements: ' + s;
  }
  s = s.slice(i + 1).trim();
  if (s[0] !== GT) {
    throw 'Expected \'>\' after between selector: ' + s;
  }
  b = b.map(parseSelector);
  const stream = parseSelector(s.slice(1).trim());
  if (stream.between) {
    return {
      between: b,
      stream: stream
    };
  } else {
    stream.between = b;
  }
  return stream;
}
function parseStream$1(s) {
  const stream = {
      source: DEFAULT_SOURCE
    },
    source = [];
  let throttle = [0, 0],
    markname = 0,
    start = 0,
    n = s.length,
    i = 0,
    j,
    filter;

  // extract throttle from end
  if (s[n - 1] === RBRACE) {
    i = s.lastIndexOf(LBRACE);
    if (i >= 0) {
      try {
        throttle = parseThrottle(s.substring(i + 1, n - 1));
      } catch (e) {
        throw 'Invalid throttle specification: ' + s;
      }
      s = s.slice(0, i).trim();
      n = s.length;
    } else throw 'Unmatched right brace: ' + s;
    i = 0;
  }
  if (!n) throw s;

  // set name flag based on first char
  if (s[0] === NAME) markname = ++i;

  // extract first part of multi-part stream selector
  j = find(s, i, COLON);
  if (j < n) {
    source.push(s.substring(start, j).trim());
    start = i = ++j;
  }

  // extract remaining part of stream selector
  i = find(s, i, LBRACK);
  if (i === n) {
    source.push(s.substring(start, n).trim());
  } else {
    source.push(s.substring(start, i).trim());
    filter = [];
    start = ++i;
    if (start === n) throw 'Unmatched left bracket: ' + s;
  }

  // extract filters
  while (i < n) {
    i = find(s, i, RBRACK);
    if (i === n) throw 'Unmatched left bracket: ' + s;
    filter.push(s.substring(start, i).trim());
    if (i < n - 1 && s[++i] !== LBRACK) throw 'Expected left bracket: ' + s;
    start = ++i;
  }

  // marshall event stream specification
  if (!(n = source.length) || ILLEGAL.test(source[n - 1])) {
    throw 'Invalid event selector: ' + s;
  }
  if (n > 1) {
    stream.type = source[1];
    if (markname) {
      stream.markname = source[0].slice(1);
    } else if (isMarkType(source[0])) {
      stream.marktype = source[0];
    } else {
      stream.source = source[0];
    }
  } else {
    stream.type = source[0];
  }
  if (stream.type.slice(-1) === '!') {
    stream.consume = true;
    stream.type = stream.type.slice(0, -1);
  }
  if (filter != null) stream.filter = filter;
  if (throttle[0]) stream.throttle = throttle[0];
  if (throttle[1]) stream.debounce = throttle[1];
  return stream;
}
function parseThrottle(s) {
  const a = s.split(COMMA);
  if (!s.length || a.length > 2) throw s;
  return a.map(_ => {
    const x = +_;
    if (x !== x) throw s;
    return x;
  });
}

function parseAutosize(spec) {
  return isObject(spec) ? spec : {
    type: spec || 'pad'
  };
}
const number = _ => +_ || 0;
const paddingObject = _ => ({
  top: _,
  bottom: _,
  left: _,
  right: _
});
function parsePadding(spec) {
  return !isObject(spec) ? paddingObject(number(spec)) : spec.signal ? spec : {
    top: number(spec.top),
    bottom: number(spec.bottom),
    left: number(spec.left),
    right: number(spec.right)
  };
}
const encoder = _ => isObject(_) && !isArray(_) ? extend$1({}, _) : {
  value: _
};
function addEncode(object, name, value, set) {
  if (value != null) {
    const isEncoder = isObject(value) && !isArray(value) || isArray(value) && value.length && isObject(value[0]);

    // Always assign signal to update, even if the signal is from the enter block
    if (isEncoder) {
      object.update[name] = value;
    } else {
      object[set || 'enter'][name] = {
        value: value
      };
    }
    return 1;
  } else {
    return 0;
  }
}
function addEncoders(object, enter, update) {
  for (const name in enter) {
    addEncode(object, name, enter[name]);
  }
  for (const name in update) {
    addEncode(object, name, update[name], 'update');
  }
}
function extendEncode(encode, extra, skip) {
  for (const name in extra) {
    if (skip && has$1(skip, name)) continue;
    encode[name] = extend$1(encode[name] || {}, extra[name]);
  }
  return encode;
}
function has(key, encode) {
  return encode && (encode.enter && encode.enter[key] || encode.update && encode.update[key]);
}
const MarkRole = 'mark';
const FrameRole = 'frame';
const ScopeRole = 'scope';
const AxisRole = 'axis';
const AxisDomainRole = 'axis-domain';
const AxisGridRole = 'axis-grid';
const AxisLabelRole = 'axis-label';
const AxisTickRole = 'axis-tick';
const AxisTitleRole = 'axis-title';
const LegendRole = 'legend';
const LegendBandRole = 'legend-band';
const LegendEntryRole = 'legend-entry';
const LegendGradientRole = 'legend-gradient';
const LegendLabelRole = 'legend-label';
const LegendSymbolRole = 'legend-symbol';
const LegendTitleRole = 'legend-title';
const TitleRole = 'title';
const TitleTextRole = 'title-text';
const TitleSubtitleRole = 'title-subtitle';
function applyDefaults(encode, type, role, style, config) {
  const defaults = {},
    enter = {};
  let update, key, skip, props;

  // if text mark, apply global lineBreak settings (#2370)
  key = 'lineBreak';
  if (type === 'text' && config[key] != null && !has(key, encode)) {
    applyDefault(defaults, key, config[key]);
  }

  // ignore legend and axis roles
  if (role == 'legend' || String(role).startsWith('axis')) {
    role = null;
  }

  // resolve mark config
  props = role === FrameRole ? config.group : role === MarkRole ? extend$1({}, config.mark, config[type]) : null;
  for (key in props) {
    // do not apply defaults if relevant fields are defined
    skip = has(key, encode) || (key === 'fill' || key === 'stroke') && (has('fill', encode) || has('stroke', encode));
    if (!skip) applyDefault(defaults, key, props[key]);
  }

  // resolve styles, apply with increasing precedence
  array$5(style).forEach(name => {
    const props = config.style && config.style[name];
    for (const key in props) {
      if (!has(key, encode)) {
        applyDefault(defaults, key, props[key]);
      }
    }
  });
  encode = extend$1({}, encode); // defensive copy
  for (key in defaults) {
    props = defaults[key];
    if (props.signal) {
      (update = update || {})[key] = props;
    } else {
      enter[key] = props;
    }
  }
  encode.enter = extend$1(enter, encode.enter);
  if (update) encode.update = extend$1(update, encode.update);
  return encode;
}
function applyDefault(defaults, key, value) {
  defaults[key] = value && value.signal ? {
    signal: value.signal
  } : {
    value: value
  };
}
const scaleRef = scale => isString(scale) ? $(scale) : scale.signal ? `(${scale.signal})` : field(scale);
function entry$1(enc) {
  if (enc.gradient != null) {
    return gradient(enc);
  }
  let value = enc.signal ? `(${enc.signal})` : enc.color ? color(enc.color) : enc.field != null ? field(enc.field) : enc.value !== undefined ? $(enc.value) : undefined;
  if (enc.scale != null) {
    value = scale(enc, value);
  }
  if (value === undefined) {
    value = null;
  }
  if (enc.exponent != null) {
    value = `pow(${value},${property(enc.exponent)})`;
  }
  if (enc.mult != null) {
    value += `*${property(enc.mult)}`;
  }
  if (enc.offset != null) {
    value += `+${property(enc.offset)}`;
  }
  if (enc.round) {
    value = `round(${value})`;
  }
  return value;
}
const _color = (type, x, y, z) => `(${type}(${[x, y, z].map(entry$1).join(',')})+'')`;
function color(enc) {
  return enc.c ? _color('hcl', enc.h, enc.c, enc.l) : enc.h || enc.s ? _color('hsl', enc.h, enc.s, enc.l) : enc.l || enc.a ? _color('lab', enc.l, enc.a, enc.b) : enc.r || enc.g || enc.b ? _color('rgb', enc.r, enc.g, enc.b) : null;
}
function gradient(enc) {
  // map undefined to null; expression lang does not allow undefined
  const args = [enc.start, enc.stop, enc.count].map(_ => _ == null ? null : $(_));

  // trim null inputs from the end
  while (args.length && peek$1(args) == null) args.pop();
  args.unshift(scaleRef(enc.gradient));
  return `gradient(${args.join(',')})`;
}
function property(property) {
  return isObject(property) ? '(' + entry$1(property) + ')' : property;
}
function field(ref) {
  return resolveField(isObject(ref) ? ref : {
    datum: ref
  });
}
function resolveField(ref) {
  let object, level, field;
  if (ref.signal) {
    object = 'datum';
    field = ref.signal;
  } else if (ref.group || ref.parent) {
    level = Math.max(1, ref.level || 1);
    object = 'item';
    while (level-- > 0) {
      object += '.mark.group';
    }
    if (ref.parent) {
      field = ref.parent;
      object += '.datum';
    } else {
      field = ref.group;
    }
  } else if (ref.datum) {
    object = 'datum';
    field = ref.datum;
  } else {
    error('Invalid field reference: ' + $(ref));
  }
  if (!ref.signal) {
    field = isString(field) ? splitAccessPath(field).map($).join('][') : resolveField(field);
  }
  return object + '[' + field + ']';
}
function scale(enc, value) {
  const scale = scaleRef(enc.scale);
  if (enc.range != null) {
    // pull value from scale range
    value = `lerp(_range(${scale}), ${+enc.range})`;
  } else {
    // run value through scale and/or pull scale bandwidth
    if (value !== undefined) value = `_scale(${scale}, ${value})`;
    if (enc.band) {
      value = (value ? value + '+' : '') + `_bandwidth(${scale})` + (+enc.band === 1 ? '' : '*' + property(enc.band));
      if (enc.extra) {
        // include logic to handle extraneous elements
        value = `(datum.extra ? _scale(${scale}, datum.extra.value) : ${value})`;
      }
    }
    if (value == null) value = '0';
  }
  return value;
}
function rule(enc) {
  let code = '';
  enc.forEach(rule => {
    const value = entry$1(rule);
    code += rule.test ? `(${rule.test})?${value}:` : value;
  });

  // if no else clause, terminate with null (#1366)
  if (peek$1(code) === ':') {
    code += 'null';
  }
  return code;
}
function parseEncode(encode, type, role, style, scope, params) {
  const enc = {};
  params = params || {};
  params.encoders = {
    $encode: enc
  };
  encode = applyDefaults(encode, type, role, style, scope.config);
  for (const key in encode) {
    enc[key] = parseBlock(encode[key], type, params, scope);
  }
  return params;
}
function parseBlock(block, marktype, params, scope) {
  const channels = {},
    fields = {};
  for (const name in block) {
    if (block[name] != null) {
      // skip any null entries
      channels[name] = parse$1(expr(block[name]), scope, params, fields);
    }
  }
  return {
    $expr: {
      marktype,
      channels
    },
    $fields: Object.keys(fields),
    $output: Object.keys(block)
  };
}
function expr(enc) {
  return isArray(enc) ? rule(enc) : entry$1(enc);
}
function parse$1(code, scope, params, fields) {
  const expr = parser(code, scope);
  expr.$fields.forEach(name => fields[name] = 1);
  extend$1(params, expr.$params);
  return expr.$expr;
}
const OUTER = 'outer',
  OUTER_INVALID = ['value', 'update', 'init', 'react', 'bind'];
function outerError(prefix, name) {
  error(prefix + ' for "outer" push: ' + $(name));
}
function parseSignal(signal, scope) {
  const name = signal.name;
  if (signal.push === OUTER) {
    // signal must already be defined, raise error if not
    if (!scope.signals[name]) outerError('No prior signal definition', name);
    // signal push must not use properties reserved for standard definition
    OUTER_INVALID.forEach(prop => {
      if (signal[prop] !== undefined) outerError('Invalid property ', prop);
    });
  } else {
    // define a new signal in the current scope
    const op = scope.addSignal(name, signal.value);
    if (signal.react === false) op.react = false;
    if (signal.bind) scope.addBinding(name, signal.bind);
  }
}
function Entry(type, value, params, parent) {
  this.id = -1;
  this.type = type;
  this.value = value;
  this.params = params;
  if (parent) this.parent = parent;
}
function entry(type, value, params, parent) {
  return new Entry(type, value, params, parent);
}
function operator(value, params) {
  return entry('operator', value, params);
}

// -----

function ref(op) {
  const ref = {
    $ref: op.id
  };
  // if operator not yet registered, cache ref to resolve later
  if (op.id < 0) (op.refs = op.refs || []).push(ref);
  return ref;
}
function fieldRef$1(field, name) {
  return name ? {
    $field: field,
    $name: name
  } : {
    $field: field
  };
}
const keyFieldRef = fieldRef$1('key');
function compareRef(fields, orders) {
  return {
    $compare: fields,
    $order: orders
  };
}
function keyRef(fields, flat) {
  const ref = {
    $key: fields
  };
  if (flat) ref.$flat = true;
  return ref;
}

// -----

const Ascending = 'ascending';
const Descending = 'descending';
function sortKey(sort) {
  return !isObject(sort) ? '' : (sort.order === Descending ? '-' : '+') + aggrField(sort.op, sort.field);
}
function aggrField(op, field) {
  return (op && op.signal ? '$' + op.signal : op || '') + (op && field ? '_' : '') + (field && field.signal ? '$' + field.signal : field || '');
}

// -----

const Scope$1 = 'scope';
const View = 'view';
function isSignal(_) {
  return _ && _.signal;
}
function isExpr$1(_) {
  return _ && _.expr;
}
function hasSignal(_) {
  if (isSignal(_)) return true;
  if (isObject(_)) for (const key in _) {
    if (hasSignal(_[key])) return true;
  }
  return false;
}
function value(specValue, defaultValue) {
  return specValue != null ? specValue : defaultValue;
}
function deref(v) {
  return v && v.signal || v;
}
const Timer = 'timer';
function parseStream(stream, scope) {
  const method = stream.merge ? mergeStream : stream.stream ? nestedStream : stream.type ? eventStream : error('Invalid stream specification: ' + $(stream));
  return method(stream, scope);
}
function eventSource(source) {
  return source === Scope$1 ? View : source || View;
}
function mergeStream(stream, scope) {
  const list = stream.merge.map(s => parseStream(s, scope)),
    entry = streamParameters({
      merge: list
    }, stream, scope);
  return scope.addStream(entry).id;
}
function nestedStream(stream, scope) {
  const id = parseStream(stream.stream, scope),
    entry = streamParameters({
      stream: id
    }, stream, scope);
  return scope.addStream(entry).id;
}
function eventStream(stream, scope) {
  let id;
  if (stream.type === Timer) {
    id = scope.event(Timer, stream.throttle);
    stream = {
      between: stream.between,
      filter: stream.filter
    };
  } else {
    id = scope.event(eventSource(stream.source), stream.type);
  }
  const entry = streamParameters({
    stream: id
  }, stream, scope);
  return Object.keys(entry).length === 1 ? id : scope.addStream(entry).id;
}
function streamParameters(entry, stream, scope) {
  let param = stream.between;
  if (param) {
    if (param.length !== 2) {
      error('Stream "between" parameter must have 2 entries: ' + $(stream));
    }
    entry.between = [parseStream(param[0], scope), parseStream(param[1], scope)];
  }
  param = stream.filter ? [].concat(stream.filter) : [];
  if (stream.marktype || stream.markname || stream.markrole) {
    // add filter for mark type, name and/or role
    param.push(filterMark(stream.marktype, stream.markname, stream.markrole));
  }
  if (stream.source === Scope$1) {
    // add filter to limit events from sub-scope only
    param.push('inScope(event.item)');
  }
  if (param.length) {
    entry.filter = parser('(' + param.join(')&&(') + ')', scope).$expr;
  }
  if ((param = stream.throttle) != null) {
    entry.throttle = +param;
  }
  if ((param = stream.debounce) != null) {
    entry.debounce = +param;
  }
  if (stream.consume) {
    entry.consume = true;
  }
  return entry;
}
function filterMark(type, name, role) {
  const item = 'event.item';
  return item + (type && type !== '*' ? '&&' + item + '.mark.marktype===\'' + type + '\'' : '') + (role ? '&&' + item + '.mark.role===\'' + role + '\'' : '') + (name ? '&&' + item + '.mark.name===\'' + name + '\'' : '');
}

// bypass expression parser for internal operator references
const OP_VALUE_EXPR = {
  code: '_.$value',
  ast: {
    type: 'Identifier',
    value: 'value'
  }
};
function parseUpdate(spec, scope, target) {
  const encode = spec.encode,
    entry = {
      target: target
    };
  let events = spec.events,
    update = spec.update,
    sources = [];
  if (!events) {
    error('Signal update missing events specification.');
  }

  // interpret as an event selector string
  if (isString(events)) {
    events = eventSelector(events, scope.isSubscope() ? Scope$1 : View);
  }

  // separate event streams from signal updates
  events = array$5(events).filter(s => s.signal || s.scale ? (sources.push(s), 0) : 1);

  // merge internal operator listeners
  if (sources.length > 1) {
    sources = [mergeSources(sources)];
  }

  // merge event streams, include as source
  if (events.length) {
    sources.push(events.length > 1 ? {
      merge: events
    } : events[0]);
  }
  if (encode != null) {
    if (update) error('Signal encode and update are mutually exclusive.');
    update = 'encode(item(),' + $(encode) + ')';
  }

  // resolve update value
  entry.update = isString(update) ? parser(update, scope) : update.expr != null ? parser(update.expr, scope) : update.value != null ? update.value : update.signal != null ? {
    $expr: OP_VALUE_EXPR,
    $params: {
      $value: scope.signalRef(update.signal)
    }
  } : error('Invalid signal update specification.');
  if (spec.force) {
    entry.options = {
      force: true
    };
  }
  sources.forEach(source => scope.addUpdate(extend$1(streamSource(source, scope), entry)));
}
function streamSource(stream, scope) {
  return {
    source: stream.signal ? scope.signalRef(stream.signal) : stream.scale ? scope.scaleRef(stream.scale) : parseStream(stream, scope)
  };
}
function mergeSources(sources) {
  return {
    signal: '[' + sources.map(s => s.scale ? 'scale("' + s.scale + '")' : s.signal) + ']'
  };
}
function parseSignalUpdates(signal, scope) {
  const op = scope.getSignal(signal.name);
  let expr = signal.update;
  if (signal.init) {
    if (expr) {
      error('Signals can not include both init and update expressions.');
    } else {
      expr = signal.init;
      op.initonly = true;
    }
  }
  if (expr) {
    expr = parser(expr, scope);
    op.update = expr.$expr;
    op.params = expr.$params;
  }
  if (signal.on) {
    signal.on.forEach(_ => parseUpdate(_, scope, op.id));
  }
}
const transform = name => (params, value, parent) => entry(name, value, params || undefined, parent);
const Aggregate = transform('aggregate');
const AxisTicks = transform('axisticks');
const Bound = transform('bound');
const Collect = transform('collect');
const Compare = transform('compare');
const DataJoin = transform('datajoin');
const Encode = transform('encode');
const Expression = transform('expression');
const Facet = transform('facet');
const Field = transform('field');
const Key = transform('key');
const LegendEntries = transform('legendentries');
const Load = transform('load');
const Mark = transform('mark');
const MultiExtent = transform('multiextent');
const MultiValues = transform('multivalues');
const Overlap = transform('overlap');
const Params = transform('params');
const PreFacet = transform('prefacet');
const Projection = transform('projection');
const Proxy$1 = transform('proxy');
const Relay = transform('relay');
const Render = transform('render');
const Scale = transform('scale');
const Sieve = transform('sieve');
const SortItems = transform('sortitems');
const ViewLayout = transform('viewlayout');
const Values = transform('values');
let FIELD_REF_ID = 0;
const MULTIDOMAIN_SORT_OPS = {
  min: 'min',
  max: 'max',
  count: 'sum'
};
function initScale(spec, scope) {
  const type = spec.type || 'linear';
  if (!isValidScaleType(type)) {
    error('Unrecognized scale type: ' + $(type));
  }
  scope.addScale(spec.name, {
    type,
    domain: undefined
  });
}
function parseScale(spec, scope) {
  const params = scope.getScale(spec.name).params;
  let key;
  params.domain = parseScaleDomain(spec.domain, spec, scope);
  if (spec.range != null) {
    params.range = parseScaleRange(spec, scope, params);
  }
  if (spec.interpolate != null) {
    parseScaleInterpolate(spec.interpolate, params);
  }
  if (spec.nice != null) {
    params.nice = parseScaleNice(spec.nice, scope);
  }
  if (spec.bins != null) {
    params.bins = parseScaleBins(spec.bins, scope);
  }
  for (key in spec) {
    if (has$1(params, key) || key === 'name') continue;
    params[key] = parseLiteral(spec[key], scope);
  }
}
function parseLiteral(v, scope) {
  return !isObject(v) ? v : v.signal ? scope.signalRef(v.signal) : error('Unsupported object: ' + $(v));
}
function parseArray(v, scope) {
  return v.signal ? scope.signalRef(v.signal) : v.map(v => parseLiteral(v, scope));
}
function dataLookupError(name) {
  error('Can not find data set: ' + $(name));
}

// -- SCALE DOMAIN ----

function parseScaleDomain(domain, spec, scope) {
  if (!domain) {
    if (spec.domainMin != null || spec.domainMax != null) {
      error('No scale domain defined for domainMin/domainMax to override.');
    }
    return; // default domain
  }
  return domain.signal ? scope.signalRef(domain.signal) : (isArray(domain) ? explicitDomain : domain.fields ? multipleDomain : singularDomain)(domain, spec, scope);
}
function explicitDomain(domain, spec, scope) {
  return domain.map(v => parseLiteral(v, scope));
}
function singularDomain(domain, spec, scope) {
  const data = scope.getData(domain.data);
  if (!data) dataLookupError(domain.data);
  return isDiscrete(spec.type) ? data.valuesRef(scope, domain.field, parseSort(domain.sort, false)) : isQuantile(spec.type) ? data.domainRef(scope, domain.field) : data.extentRef(scope, domain.field);
}
function multipleDomain(domain, spec, scope) {
  const data = domain.data,
    fields = domain.fields.reduce((dom, d) => {
      d = isString(d) ? {
        data: data,
        field: d
      } : isArray(d) || d.signal ? fieldRef(d, scope) : d;
      dom.push(d);
      return dom;
    }, []);
  return (isDiscrete(spec.type) ? ordinalMultipleDomain : isQuantile(spec.type) ? quantileMultipleDomain : numericMultipleDomain)(domain, scope, fields);
}
function fieldRef(data, scope) {
  const name = '_:vega:_' + FIELD_REF_ID++,
    coll = Collect({});
  if (isArray(data)) {
    coll.value = {
      $ingest: data
    };
  } else if (data.signal) {
    const code = 'setdata(' + $(name) + ',' + data.signal + ')';
    coll.params.input = scope.signalRef(code);
  }
  scope.addDataPipeline(name, [coll, Sieve({})]);
  return {
    data: name,
    field: 'data'
  };
}
function ordinalMultipleDomain(domain, scope, fields) {
  const sort = parseSort(domain.sort, true);
  let a, v;

  // get value counts for each domain field
  const counts = fields.map(f => {
    const data = scope.getData(f.data);
    if (!data) dataLookupError(f.data);
    return data.countsRef(scope, f.field, sort);
  });

  // aggregate the results from each domain field
  const p = {
    groupby: keyFieldRef,
    pulse: counts
  };
  if (sort) {
    a = sort.op || 'count';
    v = sort.field ? aggrField(a, sort.field) : 'count';
    p.ops = [MULTIDOMAIN_SORT_OPS[a]];
    p.fields = [scope.fieldRef(v)];
    p.as = [v];
  }
  a = scope.add(Aggregate(p));

  // collect aggregate output
  const c = scope.add(Collect({
    pulse: ref(a)
  }));

  // extract values for combined domain
  v = scope.add(Values({
    field: keyFieldRef,
    sort: scope.sortRef(sort),
    pulse: ref(c)
  }));
  return ref(v);
}
function parseSort(sort, multidomain) {
  if (sort) {
    if (!sort.field && !sort.op) {
      if (isObject(sort)) sort.field = 'key';else sort = {
        field: 'key'
      };
    } else if (!sort.field && sort.op !== 'count') {
      error('No field provided for sort aggregate op: ' + sort.op);
    } else if (multidomain && sort.field) {
      if (sort.op && !MULTIDOMAIN_SORT_OPS[sort.op]) {
        error('Multiple domain scales can not be sorted using ' + sort.op);
      }
    }
  }
  return sort;
}
function quantileMultipleDomain(domain, scope, fields) {
  // get value arrays for each domain field
  const values = fields.map(f => {
    const data = scope.getData(f.data);
    if (!data) dataLookupError(f.data);
    return data.domainRef(scope, f.field);
  });

  // combine value arrays
  return ref(scope.add(MultiValues({
    values: values
  })));
}
function numericMultipleDomain(domain, scope, fields) {
  // get extents for each domain field
  const extents = fields.map(f => {
    const data = scope.getData(f.data);
    if (!data) dataLookupError(f.data);
    return data.extentRef(scope, f.field);
  });

  // combine extents
  return ref(scope.add(MultiExtent({
    extents: extents
  })));
}

// -- SCALE BINS -----

function parseScaleBins(v, scope) {
  return v.signal || isArray(v) ? parseArray(v, scope) : scope.objectProperty(v);
}

// -- SCALE NICE -----

function parseScaleNice(nice, scope) {
  return nice.signal ? scope.signalRef(nice.signal) : isObject(nice) ? {
    interval: parseLiteral(nice.interval),
    step: parseLiteral(nice.step)
  } : parseLiteral(nice);
}

// -- SCALE INTERPOLATION -----

function parseScaleInterpolate(interpolate, params) {
  params.interpolate = parseLiteral(interpolate.type || interpolate);
  if (interpolate.gamma != null) {
    params.interpolateGamma = parseLiteral(interpolate.gamma);
  }
}

// -- SCALE RANGE -----

function parseScaleRange(spec, scope, params) {
  const config = scope.config.range;
  let range = spec.range;
  if (range.signal) {
    return scope.signalRef(range.signal);
  } else if (isString(range)) {
    if (config && has$1(config, range)) {
      spec = extend$1({}, spec, {
        range: config[range]
      });
      return parseScaleRange(spec, scope, params);
    } else if (range === 'width') {
      range = [0, {
        signal: 'width'
      }];
    } else if (range === 'height') {
      range = isDiscrete(spec.type) ? [0, {
        signal: 'height'
      }] : [{
        signal: 'height'
      }, 0];
    } else {
      error('Unrecognized scale range value: ' + $(range));
    }
  } else if (range.scheme) {
    params.scheme = isArray(range.scheme) ? parseArray(range.scheme, scope) : parseLiteral(range.scheme, scope);
    if (range.extent) params.schemeExtent = parseArray(range.extent, scope);
    if (range.count) params.schemeCount = parseLiteral(range.count, scope);
    return;
  } else if (range.step) {
    params.rangeStep = parseLiteral(range.step, scope);
    return;
  } else if (isDiscrete(spec.type) && !isArray(range)) {
    return parseScaleDomain(range, spec, scope);
  } else if (!isArray(range)) {
    error('Unsupported range type: ' + $(range));
  }
  return range.map(v => (isArray(v) ? parseArray : parseLiteral)(v, scope));
}
function parseProjection(proj, scope) {
  const config = scope.config.projection || {},
    params = {};
  for (const name in proj) {
    if (name === 'name') continue;
    params[name] = parseParameter$1(proj[name], name, scope);
  }

  // apply projection defaults from config
  for (const name in config) {
    if (params[name] == null) {
      params[name] = parseParameter$1(config[name], name, scope);
    }
  }
  scope.addProjection(proj.name, params);
}
function parseParameter$1(_, name, scope) {
  return isArray(_) ? _.map(_ => parseParameter$1(_, name, scope)) : !isObject(_) ? _ : _.signal ? scope.signalRef(_.signal) : name === 'fit' ? _ : error('Unsupported parameter object: ' + $(_));
}
const Top = 'top';
const Left = 'left';
const Right = 'right';
const Bottom = 'bottom';
const Center = 'center';
const Vertical = 'vertical';
const Start = 'start';
const Middle = 'middle';
const End = 'end';
const Index = 'index';
const Label = 'label';
const Offset = 'offset';
const Perc = 'perc';
const Perc2 = 'perc2';
const Value = 'value';
const GuideLabelStyle = 'guide-label';
const GuideTitleStyle = 'guide-title';
const GroupTitleStyle = 'group-title';
const GroupSubtitleStyle = 'group-subtitle';
const Symbols = 'symbol';
const Gradient = 'gradient';
const Discrete = 'discrete';
const Size = 'size';
const Shape = 'shape';
const Fill = 'fill';
const Stroke = 'stroke';
const StrokeWidth = 'strokeWidth';
const StrokeDash = 'strokeDash';
const Opacity = 'opacity';

// Encoding channels supported by legends
// In priority order of 'canonical' scale
const LegendScales = [Size, Shape, Fill, Stroke, StrokeWidth, StrokeDash, Opacity];
const Skip = {
  name: 1,
  style: 1,
  interactive: 1
};
const zero = {
  value: 0
};
const one = {
  value: 1
};
const GroupMark = 'group';
const RectMark = 'rect';
const RuleMark = 'rule';
const SymbolMark = 'symbol';
const TextMark = 'text';
function guideGroup(mark) {
  mark.type = GroupMark;
  mark.interactive = mark.interactive || false;
  return mark;
}
function lookup(spec, config) {
  const _ = (name, dflt) => value(spec[name], value(config[name], dflt));
  _.isVertical = s => Vertical === value(spec.direction, config.direction || (s ? config.symbolDirection : config.gradientDirection));
  _.gradientLength = () => value(spec.gradientLength, config.gradientLength || config.gradientWidth);
  _.gradientThickness = () => value(spec.gradientThickness, config.gradientThickness || config.gradientHeight);
  _.entryColumns = () => value(spec.columns, value(config.columns, +_.isVertical(true)));
  return _;
}
function getEncoding(name, encode) {
  const v = encode && (encode.update && encode.update[name] || encode.enter && encode.enter[name]);
  return v && v.signal ? v : v ? v.value : null;
}
function getStyle(name, scope, style) {
  const s = scope.config.style[style];
  return s && s[name];
}
function anchorExpr(s, e, m) {
  return `item.anchor === '${Start}' ? ${s} : item.anchor === '${End}' ? ${e} : ${m}`;
}
const alignExpr$1 = anchorExpr($(Left), $(Right), $(Center));
function tickBand(_) {
  const v = _('tickBand');
  let offset = _('tickOffset'),
    band,
    extra;
  if (!v) {
    // if no tick band entry, fall back on other properties
    band = _('bandPosition');
    extra = _('tickExtra');
  } else if (v.signal) {
    // if signal, augment code to interpret values
    band = {
      signal: `(${v.signal}) === 'extent' ? 1 : 0.5`
    };
    extra = {
      signal: `(${v.signal}) === 'extent'`
    };
    if (!isObject(offset)) {
      offset = {
        signal: `(${v.signal}) === 'extent' ? 0 : ${offset}`
      };
    }
  } else if (v === 'extent') {
    // if constant, simply set values
    band = 1;
    extra = true;
    offset = 0;
  } else {
    band = 0.5;
    extra = false;
  }
  return {
    extra,
    band,
    offset
  };
}
function extendOffset(value, offset) {
  return !offset ? value : !value ? offset : !isObject(value) ? {
    value,
    offset
  } : Object.assign({}, value, {
    offset: extendOffset(value.offset, offset)
  });
}
function guideMark(mark, extras) {
  if (extras) {
    mark.name = extras.name;
    mark.style = extras.style || mark.style;
    mark.interactive = !!extras.interactive;
    mark.encode = extendEncode(mark.encode, extras, Skip);
  } else {
    mark.interactive = false;
  }
  return mark;
}
function legendGradient(spec, scale, config, userEncode) {
  const _ = lookup(spec, config),
    vertical = _.isVertical(),
    thickness = _.gradientThickness(),
    length = _.gradientLength();
  let enter, start, stop, width, height;
  if (vertical) {
    start = [0, 1];
    stop = [0, 0];
    width = thickness;
    height = length;
  } else {
    start = [0, 0];
    stop = [1, 0];
    width = length;
    height = thickness;
  }
  const encode = {
    enter: enter = {
      opacity: zero,
      x: zero,
      y: zero,
      width: encoder(width),
      height: encoder(height)
    },
    update: extend$1({}, enter, {
      opacity: one,
      fill: {
        gradient: scale,
        start: start,
        stop: stop
      }
    }),
    exit: {
      opacity: zero
    }
  };
  addEncoders(encode, {
    stroke: _('gradientStrokeColor'),
    strokeWidth: _('gradientStrokeWidth')
  }, {
    // update
    opacity: _('gradientOpacity')
  });
  return guideMark({
    type: RectMark,
    role: LegendGradientRole,
    encode
  }, userEncode);
}
function legendGradientDiscrete(spec, scale, config, userEncode, dataRef) {
  const _ = lookup(spec, config),
    vertical = _.isVertical(),
    thickness = _.gradientThickness(),
    length = _.gradientLength();
  let u,
    v,
    uu,
    vv,
    adjust = '';
  vertical ? (u = 'y', uu = 'y2', v = 'x', vv = 'width', adjust = '1-') : (u = 'x', uu = 'x2', v = 'y', vv = 'height');
  const enter = {
    opacity: zero,
    fill: {
      scale: scale,
      field: Value
    }
  };
  enter[u] = {
    signal: adjust + 'datum.' + Perc,
    mult: length
  };
  enter[v] = zero;
  enter[uu] = {
    signal: adjust + 'datum.' + Perc2,
    mult: length
  };
  enter[vv] = encoder(thickness);
  const encode = {
    enter: enter,
    update: extend$1({}, enter, {
      opacity: one
    }),
    exit: {
      opacity: zero
    }
  };
  addEncoders(encode, {
    stroke: _('gradientStrokeColor'),
    strokeWidth: _('gradientStrokeWidth')
  }, {
    // update
    opacity: _('gradientOpacity')
  });
  return guideMark({
    type: RectMark,
    role: LegendBandRole,
    key: Value,
    from: dataRef,
    encode
  }, userEncode);
}
const alignExpr = `datum.${Perc}<=0?"${Left}":datum.${Perc}>=1?"${Right}":"${Center}"`,
  baselineExpr = `datum.${Perc}<=0?"${Bottom}":datum.${Perc}>=1?"${Top}":"${Middle}"`;
function legendGradientLabels(spec, config, userEncode, dataRef) {
  const _ = lookup(spec, config),
    vertical = _.isVertical(),
    thickness = encoder(_.gradientThickness()),
    length = _.gradientLength();
  let overlap = _('labelOverlap'),
    enter,
    update,
    u,
    v,
    adjust = '';
  const encode = {
    enter: enter = {
      opacity: zero
    },
    update: update = {
      opacity: one,
      text: {
        field: Label
      }
    },
    exit: {
      opacity: zero
    }
  };
  addEncoders(encode, {
    fill: _('labelColor'),
    fillOpacity: _('labelOpacity'),
    font: _('labelFont'),
    fontSize: _('labelFontSize'),
    fontStyle: _('labelFontStyle'),
    fontWeight: _('labelFontWeight'),
    limit: value(spec.labelLimit, config.gradientLabelLimit)
  });
  if (vertical) {
    enter.align = {
      value: 'left'
    };
    enter.baseline = update.baseline = {
      signal: baselineExpr
    };
    u = 'y';
    v = 'x';
    adjust = '1-';
  } else {
    enter.align = update.align = {
      signal: alignExpr
    };
    enter.baseline = {
      value: 'top'
    };
    u = 'x';
    v = 'y';
  }
  enter[u] = update[u] = {
    signal: adjust + 'datum.' + Perc,
    mult: length
  };
  enter[v] = update[v] = thickness;
  thickness.offset = value(spec.labelOffset, config.gradientLabelOffset) || 0;
  overlap = overlap ? {
    separation: _('labelSeparation'),
    method: overlap,
    order: 'datum.' + Index
  } : undefined;

  // type, role, style, key, dataRef, encode, extras
  return guideMark({
    type: TextMark,
    role: LegendLabelRole,
    style: GuideLabelStyle,
    key: Value,
    from: dataRef,
    encode,
    overlap
  }, userEncode);
}

// userEncode is top-level, includes entries, symbols, labels
function legendSymbolGroups(spec, config, userEncode, dataRef, columns) {
  const _ = lookup(spec, config),
    entries = userEncode.entries,
    interactive = !!(entries && entries.interactive),
    name = entries ? entries.name : undefined,
    height = _('clipHeight'),
    symbolOffset = _('symbolOffset'),
    valueRef = {
      data: 'value'
    },
    xSignal = `(${columns}) ? datum.${Offset} : datum.${Size}`,
    yEncode = height ? encoder(height) : {
      field: Size
    },
    index = `datum.${Index}`,
    ncols = `max(1, ${columns})`;
  let encode, enter, update, nrows, sort;
  yEncode.mult = 0.5;

  // -- LEGEND SYMBOLS --
  encode = {
    enter: enter = {
      opacity: zero,
      x: {
        signal: xSignal,
        mult: 0.5,
        offset: symbolOffset
      },
      y: yEncode
    },
    update: update = {
      opacity: one,
      x: enter.x,
      y: enter.y
    },
    exit: {
      opacity: zero
    }
  };
  let baseFill = null,
    baseStroke = null;
  if (!spec.fill) {
    baseFill = config.symbolBaseFillColor;
    baseStroke = config.symbolBaseStrokeColor;
  }
  addEncoders(encode, {
    fill: _('symbolFillColor', baseFill),
    shape: _('symbolType'),
    size: _('symbolSize'),
    stroke: _('symbolStrokeColor', baseStroke),
    strokeDash: _('symbolDash'),
    strokeDashOffset: _('symbolDashOffset'),
    strokeWidth: _('symbolStrokeWidth')
  }, {
    // update
    opacity: _('symbolOpacity')
  });
  LegendScales.forEach(scale => {
    if (spec[scale]) {
      update[scale] = enter[scale] = {
        scale: spec[scale],
        field: Value
      };
    }
  });
  const symbols = guideMark({
    type: SymbolMark,
    role: LegendSymbolRole,
    key: Value,
    from: valueRef,
    clip: height ? true : undefined,
    encode
  }, userEncode.symbols);

  // -- LEGEND LABELS --
  const labelOffset = encoder(symbolOffset);
  labelOffset.offset = _('labelOffset');
  encode = {
    enter: enter = {
      opacity: zero,
      x: {
        signal: xSignal,
        offset: labelOffset
      },
      y: yEncode
    },
    update: update = {
      opacity: one,
      text: {
        field: Label
      },
      x: enter.x,
      y: enter.y
    },
    exit: {
      opacity: zero
    }
  };
  addEncoders(encode, {
    align: _('labelAlign'),
    baseline: _('labelBaseline'),
    fill: _('labelColor'),
    fillOpacity: _('labelOpacity'),
    font: _('labelFont'),
    fontSize: _('labelFontSize'),
    fontStyle: _('labelFontStyle'),
    fontWeight: _('labelFontWeight'),
    limit: _('labelLimit')
  });
  const labels = guideMark({
    type: TextMark,
    role: LegendLabelRole,
    style: GuideLabelStyle,
    key: Value,
    from: valueRef,
    encode
  }, userEncode.labels);

  // -- LEGEND ENTRY GROUPS --
  encode = {
    enter: {
      noBound: {
        value: !height
      },
      // ignore width/height in bounds calc
      width: zero,
      height: height ? encoder(height) : zero,
      opacity: zero
    },
    exit: {
      opacity: zero
    },
    update: update = {
      opacity: one,
      row: {
        signal: null
      },
      column: {
        signal: null
      }
    }
  };

  // annotate and sort groups to ensure correct ordering
  if (_.isVertical(true)) {
    nrows = `ceil(item.mark.items.length / ${ncols})`;
    update.row.signal = `${index}%${nrows}`;
    update.column.signal = `floor(${index} / ${nrows})`;
    sort = {
      field: ['row', index]
    };
  } else {
    update.row.signal = `floor(${index} / ${ncols})`;
    update.column.signal = `${index} % ${ncols}`;
    sort = {
      field: index
    };
  }
  // handle zero column case (implies infinite columns)
  update.column.signal = `(${columns})?${update.column.signal}:${index}`;

  // facet legend entries into sub-groups
  dataRef = {
    facet: {
      data: dataRef,
      name: 'value',
      groupby: Index
    }
  };
  return guideGroup({
    role: ScopeRole,
    from: dataRef,
    encode: extendEncode(encode, entries, Skip),
    marks: [symbols, labels],
    name,
    interactive,
    sort
  });
}
function legendSymbolLayout(spec, config) {
  const _ = lookup(spec, config);

  // layout parameters for legend entries
  return {
    align: _('gridAlign'),
    columns: _.entryColumns(),
    center: {
      row: true,
      column: false
    },
    padding: {
      row: _('rowPadding'),
      column: _('columnPadding')
    }
  };
}

// expression logic for align, anchor, angle, and baseline calculation
const isL = 'item.orient === "left"',
  isR = 'item.orient === "right"',
  isLR = `(${isL} || ${isR})`,
  isVG = `datum.vgrad && ${isLR}`,
  baseline = anchorExpr('"top"', '"bottom"', '"middle"'),
  alignFlip = anchorExpr('"right"', '"left"', '"center"'),
  exprAlign = `datum.vgrad && ${isR} ? (${alignFlip}) : (${isLR} && !(datum.vgrad && ${isL})) ? "left" : ${alignExpr$1}`,
  exprAnchor = `item._anchor || (${isLR} ? "middle" : "start")`,
  exprAngle = `${isVG} ? (${isL} ? -90 : 90) : 0`,
  exprBaseline = `${isLR} ? (datum.vgrad ? (${isR} ? "bottom" : "top") : ${baseline}) : "top"`;
function legendTitle(spec, config, userEncode, dataRef) {
  const _ = lookup(spec, config);
  const encode = {
    enter: {
      opacity: zero
    },
    update: {
      opacity: one,
      x: {
        field: {
          group: 'padding'
        }
      },
      y: {
        field: {
          group: 'padding'
        }
      }
    },
    exit: {
      opacity: zero
    }
  };
  addEncoders(encode, {
    orient: _('titleOrient'),
    _anchor: _('titleAnchor'),
    anchor: {
      signal: exprAnchor
    },
    angle: {
      signal: exprAngle
    },
    align: {
      signal: exprAlign
    },
    baseline: {
      signal: exprBaseline
    },
    text: spec.title,
    fill: _('titleColor'),
    fillOpacity: _('titleOpacity'),
    font: _('titleFont'),
    fontSize: _('titleFontSize'),
    fontStyle: _('titleFontStyle'),
    fontWeight: _('titleFontWeight'),
    limit: _('titleLimit'),
    lineHeight: _('titleLineHeight')
  }, {
    // require update
    align: _('titleAlign'),
    baseline: _('titleBaseline')
  });
  return guideMark({
    type: TextMark,
    role: LegendTitleRole,
    style: GuideTitleStyle,
    from: dataRef,
    encode
  }, userEncode);
}
function clip(clip, scope) {
  let expr;
  if (isObject(clip)) {
    if (clip.signal) {
      expr = clip.signal;
    } else if (clip.path) {
      expr = 'pathShape(' + param(clip.path) + ')';
    } else if (clip.sphere) {
      expr = 'geoShape(' + param(clip.sphere) + ', {type: "Sphere"})';
    }
  }
  return expr ? scope.signalRef(expr) : !!clip;
}
function param(value) {
  return isObject(value) && value.signal ? value.signal : $(value);
}
function getRole(spec) {
  const role = spec.role || '';
  return role.startsWith('axis') || role.startsWith('legend') || role.startsWith('title') ? role : spec.type === GroupMark ? ScopeRole : role || MarkRole;
}
function definition(spec) {
  return {
    marktype: spec.type,
    name: spec.name || undefined,
    role: spec.role || getRole(spec),
    zindex: +spec.zindex || undefined,
    aria: spec.aria,
    description: spec.description
  };
}
function interactive(spec, scope) {
  return spec && spec.signal ? scope.signalRef(spec.signal) : spec === false ? false : true;
}

/**
 * Parse a data transform specification.
 */
function parseTransform(spec, scope) {
  const def = definition$1(spec.type);
  if (!def) error('Unrecognized transform type: ' + $(spec.type));
  const t = entry(def.type.toLowerCase(), null, parseParameters(def, spec, scope));
  if (spec.signal) scope.addSignal(spec.signal, scope.proxy(t));
  t.metadata = def.metadata || {};
  return t;
}

/**
 * Parse all parameters of a data transform.
 */
function parseParameters(def, spec, scope) {
  const params = {},
    n = def.params.length;
  for (let i = 0; i < n; ++i) {
    const pdef = def.params[i];
    params[pdef.name] = parseParameter(pdef, spec, scope);
  }
  return params;
}

/**
 * Parse a data transform parameter.
 */
function parseParameter(def, spec, scope) {
  const type = def.type,
    value = spec[def.name];
  if (type === 'index') {
    return parseIndexParameter(def, spec, scope);
  } else if (value === undefined) {
    if (def.required) {
      error('Missing required ' + $(spec.type) + ' parameter: ' + $(def.name));
    }
    return;
  } else if (type === 'param') {
    return parseSubParameters(def, spec, scope);
  } else if (type === 'projection') {
    return scope.projectionRef(spec[def.name]);
  }
  return def.array && !isSignal(value) ? value.map(v => parameterValue(def, v, scope)) : parameterValue(def, value, scope);
}

/**
 * Parse a single parameter value.
 */
function parameterValue(def, value, scope) {
  const type = def.type;
  if (isSignal(value)) {
    return isExpr(type) ? error('Expression references can not be signals.') : isField(type) ? scope.fieldRef(value) : isCompare(type) ? scope.compareRef(value) : scope.signalRef(value.signal);
  } else {
    const expr = def.expr || isField(type);
    return expr && outerExpr(value) ? scope.exprRef(value.expr, value.as) : expr && outerField(value) ? fieldRef$1(value.field, value.as) : isExpr(type) ? parser(value, scope) : isData(type) ? ref(scope.getData(value).values) : isField(type) ? fieldRef$1(value) : isCompare(type) ? scope.compareRef(value) : value;
  }
}

/**
 * Parse parameter for accessing an index of another data set.
 */
function parseIndexParameter(def, spec, scope) {
  if (!isString(spec.from)) {
    error('Lookup "from" parameter must be a string literal.');
  }
  return scope.getData(spec.from).lookupRef(scope, spec.key);
}

/**
 * Parse a parameter that contains one or more sub-parameter objects.
 */
function parseSubParameters(def, spec, scope) {
  const value = spec[def.name];
  if (def.array) {
    if (!isArray(value)) {
      // signals not allowed!
      error('Expected an array of sub-parameters. Instead: ' + $(value));
    }
    return value.map(v => parseSubParameter(def, v, scope));
  } else {
    return parseSubParameter(def, value, scope);
  }
}

/**
 * Parse a sub-parameter object.
 */
function parseSubParameter(def, value, scope) {
  const n = def.params.length;
  let pdef;

  // loop over defs to find matching key
  for (let i = 0; i < n; ++i) {
    pdef = def.params[i];
    for (const k in pdef.key) {
      if (pdef.key[k] !== value[k]) {
        pdef = null;
        break;
      }
    }
    if (pdef) break;
  }
  // raise error if matching key not found
  if (!pdef) error('Unsupported parameter: ' + $(value));

  // parse params, create Params transform, return ref
  const params = extend$1(parseParameters(pdef, value, scope), pdef.key);
  return ref(scope.add(Params(params)));
}

// -- Utilities -----

const outerExpr = _ => _ && _.expr;
const outerField = _ => _ && _.field;
const isData = _ => _ === 'data';
const isExpr = _ => _ === 'expr';
const isField = _ => _ === 'field';
const isCompare = _ => _ === 'compare';
function parseData$1(from, group, scope) {
  let facet, key, op, dataRef, parent;

  // if no source data, generate singleton datum
  if (!from) {
    dataRef = ref(scope.add(Collect(null, [{}])));
  }

  // if faceted, process facet specification
  else if (facet = from.facet) {
    if (!group) error('Only group marks can be faceted.');

    // use pre-faceted source data, if available
    if (facet.field != null) {
      dataRef = parent = getDataRef(facet, scope);
    } else {
      // generate facet aggregates if no direct data specification
      if (!from.data) {
        op = parseTransform(extend$1({
          type: 'aggregate',
          groupby: array$5(facet.groupby)
        }, facet.aggregate), scope);
        op.params.key = scope.keyRef(facet.groupby);
        op.params.pulse = getDataRef(facet, scope);
        dataRef = parent = ref(scope.add(op));
      } else {
        parent = ref(scope.getData(from.data).aggregate);
      }
      key = scope.keyRef(facet.groupby, true);
    }
  }

  // if not yet defined, get source data reference
  if (!dataRef) {
    dataRef = getDataRef(from, scope);
  }
  return {
    key: key,
    pulse: dataRef,
    parent: parent
  };
}
function getDataRef(from, scope) {
  return from.$ref ? from : from.data && from.data.$ref ? from.data : ref(scope.getData(from.data).output);
}
function DataScope(scope, input, output, values, aggr) {
  this.scope = scope; // parent scope object
  this.input = input; // first operator in pipeline (tuple input)
  this.output = output; // last operator in pipeline (tuple output)
  this.values = values; // operator for accessing tuples (but not tuple flow)

  // last aggregate in transform pipeline
  this.aggregate = aggr;

  // lookup table of field indices
  this.index = {};
}
DataScope.fromEntries = function (scope, entries) {
  const n = entries.length,
    values = entries[n - 1],
    output = entries[n - 2];
  let input = entries[0],
    aggr = null,
    i = 1;
  if (input && input.type === 'load') {
    input = entries[1];
  }

  // add operator entries to this scope, wire up pulse chain
  scope.add(entries[0]);
  for (; i < n; ++i) {
    entries[i].params.pulse = ref(entries[i - 1]);
    scope.add(entries[i]);
    if (entries[i].type === 'aggregate') aggr = entries[i];
  }
  return new DataScope(scope, input, output, values, aggr);
};
function fieldKey(field) {
  return isString(field) ? field : null;
}
function addSortField(scope, p, sort) {
  const as = aggrField(sort.op, sort.field);
  let s;
  if (p.ops) {
    for (let i = 0, n = p.as.length; i < n; ++i) {
      if (p.as[i] === as) return;
    }
  } else {
    p.ops = ['count'];
    p.fields = [null];
    p.as = ['count'];
  }
  if (sort.op) {
    p.ops.push((s = sort.op.signal) ? scope.signalRef(s) : sort.op);
    p.fields.push(scope.fieldRef(sort.field));
    p.as.push(as);
  }
}
function cache(scope, ds, name, optype, field, counts, index) {
  const cache = ds[name] || (ds[name] = {}),
    sort = sortKey(counts);
  let k = fieldKey(field),
    v,
    op;
  if (k != null) {
    scope = ds.scope;
    k = k + (sort ? '|' + sort : '');
    v = cache[k];
  }
  if (!v) {
    const params = counts ? {
      field: keyFieldRef,
      pulse: ds.countsRef(scope, field, counts)
    } : {
      field: scope.fieldRef(field),
      pulse: ref(ds.output)
    };
    if (sort) params.sort = scope.sortRef(counts);
    op = scope.add(entry(optype, undefined, params));
    if (index) ds.index[field] = op;
    v = ref(op);
    if (k != null) cache[k] = v;
  }
  return v;
}
DataScope.prototype = {
  countsRef(scope, field, sort) {
    const ds = this,
      cache = ds.counts || (ds.counts = {}),
      k = fieldKey(field);
    let v, a, p;
    if (k != null) {
      scope = ds.scope;
      v = cache[k];
    }
    if (!v) {
      p = {
        groupby: scope.fieldRef(field, 'key'),
        pulse: ref(ds.output)
      };
      if (sort && sort.field) addSortField(scope, p, sort);
      a = scope.add(Aggregate(p));
      v = scope.add(Collect({
        pulse: ref(a)
      }));
      v = {
        agg: a,
        ref: ref(v)
      };
      if (k != null) cache[k] = v;
    } else if (sort && sort.field) {
      addSortField(scope, v.agg.params, sort);
    }
    return v.ref;
  },
  tuplesRef() {
    return ref(this.values);
  },
  extentRef(scope, field) {
    return cache(scope, this, 'extent', 'extent', field, false);
  },
  domainRef(scope, field) {
    return cache(scope, this, 'domain', 'values', field, false);
  },
  valuesRef(scope, field, sort) {
    return cache(scope, this, 'vals', 'values', field, sort || true);
  },
  lookupRef(scope, field) {
    return cache(scope, this, 'lookup', 'tupleindex', field, false);
  },
  indataRef(scope, field) {
    return cache(scope, this, 'indata', 'tupleindex', field, true, true);
  }
};
function parseFacet(spec, scope, group) {
  const facet = spec.from.facet,
    name = facet.name,
    data = getDataRef(facet, scope);
  let op;
  if (!facet.name) {
    error('Facet must have a name: ' + $(facet));
  }
  if (!facet.data) {
    error('Facet must reference a data set: ' + $(facet));
  }
  if (facet.field) {
    op = scope.add(PreFacet({
      field: scope.fieldRef(facet.field),
      pulse: data
    }));
  } else if (facet.groupby) {
    op = scope.add(Facet({
      key: scope.keyRef(facet.groupby),
      group: ref(scope.proxy(group.parent)),
      pulse: data
    }));
  } else {
    error('Facet must specify groupby or field: ' + $(facet));
  }

  // initialize facet subscope
  const subscope = scope.fork(),
    source = subscope.add(Collect()),
    values = subscope.add(Sieve({
      pulse: ref(source)
    }));
  subscope.addData(name, new DataScope(subscope, source, source, values));
  subscope.addSignal('parent', null);

  // parse faceted subflow
  op.params.subflow = {
    $subflow: subscope.parse(spec).toRuntime()
  };
}
function parseSubflow(spec, scope, input) {
  const op = scope.add(PreFacet({
      pulse: input.pulse
    })),
    subscope = scope.fork();
  subscope.add(Sieve());
  subscope.addSignal('parent', null);

  // parse group mark subflow
  op.params.subflow = {
    $subflow: subscope.parse(spec).toRuntime()
  };
}
function parseTrigger(spec, scope, name) {
  const remove = spec.remove,
    insert = spec.insert,
    toggle = spec.toggle,
    modify = spec.modify,
    values = spec.values,
    op = scope.add(operator());
  const update = 'if(' + spec.trigger + ',modify("' + name + '",' + [insert, remove, toggle, modify, values].map(_ => _ == null ? 'null' : _).join(',') + '),0)';
  const expr = parser(update, scope);
  op.update = expr.$expr;
  op.params = expr.$params;
}
function parseMark(spec, scope) {
  const role = getRole(spec),
    group = spec.type === GroupMark,
    facet = spec.from && spec.from.facet,
    overlap = spec.overlap;
  let layout = spec.layout || role === ScopeRole || role === FrameRole,
    ops,
    op,
    store,
    enc,
    name,
    layoutRef,
    boundRef;
  const nested = role === MarkRole || layout || facet;

  // resolve input data
  const input = parseData$1(spec.from, group, scope);

  // data join to map tuples to visual items
  op = scope.add(DataJoin({
    key: input.key || (spec.key ? fieldRef$1(spec.key) : undefined),
    pulse: input.pulse,
    clean: !group
  }));
  const joinRef = ref(op);

  // collect visual items
  op = store = scope.add(Collect({
    pulse: joinRef
  }));

  // connect visual items to scenegraph
  op = scope.add(Mark({
    markdef: definition(spec),
    interactive: interactive(spec.interactive, scope),
    clip: clip(spec.clip, scope),
    context: {
      $context: true
    },
    groups: scope.lookup(),
    parent: scope.signals.parent ? scope.signalRef('parent') : null,
    index: scope.markpath(),
    pulse: ref(op)
  }));
  const markRef = ref(op);

  // add visual encoders
  op = enc = scope.add(Encode(parseEncode(spec.encode, spec.type, role, spec.style, scope, {
    mod: false,
    pulse: markRef
  })));

  // monitor parent marks to propagate changes
  op.params.parent = scope.encode();

  // add post-encoding transforms, if defined
  if (spec.transform) {
    spec.transform.forEach(_ => {
      const tx = parseTransform(_, scope),
        md = tx.metadata;
      if (md.generates || md.changes) {
        error('Mark transforms should not generate new data.');
      }
      if (!md.nomod) enc.params.mod = true; // update encode mod handling
      tx.params.pulse = ref(op);
      scope.add(op = tx);
    });
  }

  // if item sort specified, perform post-encoding
  if (spec.sort) {
    op = scope.add(SortItems({
      sort: scope.compareRef(spec.sort),
      pulse: ref(op)
    }));
  }
  const encodeRef = ref(op);

  // add view layout operator if needed
  if (facet || layout) {
    layout = scope.add(ViewLayout({
      layout: scope.objectProperty(spec.layout),
      legends: scope.legends,
      mark: markRef,
      pulse: encodeRef
    }));
    layoutRef = ref(layout);
  }

  // compute bounding boxes
  const bound = scope.add(Bound({
    mark: markRef,
    pulse: layoutRef || encodeRef
  }));
  boundRef = ref(bound);

  // if group mark, recurse to parse nested content
  if (group) {
    // juggle layout & bounds to ensure they run *after* any faceting transforms
    if (nested) {
      ops = scope.operators;
      ops.pop();
      if (layout) ops.pop();
    }
    scope.pushState(encodeRef, layoutRef || boundRef, joinRef);
    facet ? parseFacet(spec, scope, input) // explicit facet
    : nested ? parseSubflow(spec, scope, input) // standard mark group
    : scope.parse(spec); // guide group, we can avoid nested scopes
    scope.popState();
    if (nested) {
      if (layout) ops.push(layout);
      ops.push(bound);
    }
  }

  // if requested, add overlap removal transform
  if (overlap) {
    boundRef = parseOverlap(overlap, boundRef, scope);
  }

  // render / sieve items
  const render = scope.add(Render({
      pulse: boundRef
    })),
    sieve = scope.add(Sieve({
      pulse: ref(render)
    }, undefined, scope.parent()));

  // if mark is named, make accessible as reactive geometry
  // add trigger updates if defined
  if (spec.name != null) {
    name = spec.name;
    scope.addData(name, new DataScope(scope, store, render, sieve));
    if (spec.on) spec.on.forEach(on => {
      if (on.insert || on.remove || on.toggle) {
        error('Marks only support modify triggers.');
      }
      parseTrigger(on, scope, name);
    });
  }
}
function parseOverlap(overlap, source, scope) {
  const method = overlap.method,
    bound = overlap.bound,
    sep = overlap.separation;
  const params = {
    separation: isSignal(sep) ? scope.signalRef(sep.signal) : sep,
    method: isSignal(method) ? scope.signalRef(method.signal) : method,
    pulse: source
  };
  if (overlap.order) {
    params.sort = scope.compareRef({
      field: overlap.order
    });
  }
  if (bound) {
    const tol = bound.tolerance;
    params.boundTolerance = isSignal(tol) ? scope.signalRef(tol.signal) : +tol;
    params.boundScale = scope.scaleRef(bound.scale);
    params.boundOrient = bound.orient;
  }
  return ref(scope.add(Overlap(params)));
}
function parseLegend(spec, scope) {
  const config = scope.config.legend,
    encode = spec.encode || {},
    _ = lookup(spec, config),
    legendEncode = encode.legend || {},
    name = legendEncode.name || undefined,
    interactive = legendEncode.interactive,
    style = legendEncode.style,
    scales = {};
  let scale = 0,
    entryLayout,
    params,
    children;

  // resolve scales and 'canonical' scale name
  LegendScales.forEach(s => spec[s] ? (scales[s] = spec[s], scale = scale || spec[s]) : 0);
  if (!scale) error('Missing valid scale for legend.');

  // resolve legend type (symbol, gradient, or discrete gradient)
  const type = legendType(spec, scope.scaleType(scale));

  // single-element data source for legend group
  const datum = {
    title: spec.title != null,
    scales: scales,
    type: type,
    vgrad: type !== 'symbol' && _.isVertical()
  };
  const dataRef = ref(scope.add(Collect(null, [datum])));

  // encoding properties for legend entry sub-group
  const entryEncode = {
    enter: {
      x: {
        value: 0
      },
      y: {
        value: 0
      }
    }
  };

  // data source for legend values
  const entryRef = ref(scope.add(LegendEntries(params = {
    type: type,
    scale: scope.scaleRef(scale),
    count: scope.objectProperty(_('tickCount')),
    limit: scope.property(_('symbolLimit')),
    values: scope.objectProperty(spec.values),
    minstep: scope.property(spec.tickMinStep),
    formatType: scope.property(spec.formatType),
    formatSpecifier: scope.property(spec.format)
  })));

  // continuous gradient legend
  if (type === Gradient) {
    children = [legendGradient(spec, scale, config, encode.gradient), legendGradientLabels(spec, config, encode.labels, entryRef)];
    // adjust default tick count based on the gradient length
    params.count = params.count || scope.signalRef(`max(2,2*floor((${deref(_.gradientLength())})/100))`);
  }

  // discrete gradient legend
  else if (type === Discrete) {
    children = [legendGradientDiscrete(spec, scale, config, encode.gradient, entryRef), legendGradientLabels(spec, config, encode.labels, entryRef)];
  }

  // symbol legend
  else {
    // determine legend symbol group layout
    entryLayout = legendSymbolLayout(spec, config);
    children = [legendSymbolGroups(spec, config, encode, entryRef, deref(entryLayout.columns))];
    // pass symbol size information to legend entry generator
    params.size = sizeExpression(spec, scope, children[0].marks);
  }

  // generate legend marks
  children = [guideGroup({
    role: LegendEntryRole,
    from: dataRef,
    encode: entryEncode,
    marks: children,
    layout: entryLayout,
    interactive
  })];

  // include legend title if defined
  if (datum.title) {
    children.push(legendTitle(spec, config, encode.title, dataRef));
  }

  // parse legend specification
  return parseMark(guideGroup({
    role: LegendRole,
    from: dataRef,
    encode: extendEncode(buildLegendEncode(_, spec, config), legendEncode, Skip),
    marks: children,
    aria: _('aria'),
    description: _('description'),
    zindex: _('zindex'),
    name,
    interactive,
    style
  }), scope);
}
function legendType(spec, scaleType) {
  let type = spec.type || Symbols;
  if (!spec.type && scaleCount(spec) === 1 && (spec.fill || spec.stroke)) {
    type = isContinuous(scaleType) ? Gradient : isDiscretizing(scaleType) ? Discrete : Symbols;
  }
  return type !== Gradient ? type : isDiscretizing(scaleType) ? Discrete : Gradient;
}
function scaleCount(spec) {
  return LegendScales.reduce((count, type) => count + (spec[type] ? 1 : 0), 0);
}
function buildLegendEncode(_, spec, config) {
  const encode = {
    enter: {},
    update: {}
  };
  addEncoders(encode, {
    orient: _('orient'),
    offset: _('offset'),
    padding: _('padding'),
    titlePadding: _('titlePadding'),
    cornerRadius: _('cornerRadius'),
    fill: _('fillColor'),
    stroke: _('strokeColor'),
    strokeWidth: config.strokeWidth,
    strokeDash: config.strokeDash,
    x: _('legendX'),
    y: _('legendY'),
    // accessibility support
    format: spec.format,
    formatType: spec.formatType
  });
  return encode;
}
function sizeExpression(spec, scope, marks) {
  const size = deref(getChannel('size', spec, marks)),
    strokeWidth = deref(getChannel('strokeWidth', spec, marks)),
    fontSize = deref(getFontSize(marks[1].encode, scope, GuideLabelStyle));
  return parser(`max(ceil(sqrt(${size})+${strokeWidth}),${fontSize})`, scope);
}
function getChannel(name, spec, marks) {
  return spec[name] ? `scale("${spec[name]}",datum)` : getEncoding(name, marks[0].encode);
}
function getFontSize(encode, scope, style) {
  return getEncoding('fontSize', encode) || getStyle('fontSize', scope, style);
}
const angleExpr = `item.orient==="${Left}"?-90:item.orient==="${Right}"?90:0`;
function parseTitle(spec, scope) {
  spec = isString(spec) ? {
    text: spec
  } : spec;
  const _ = lookup(spec, scope.config.title),
    encode = spec.encode || {},
    userEncode = encode.group || {},
    name = userEncode.name || undefined,
    interactive = userEncode.interactive,
    style = userEncode.style,
    children = [];

  // single-element data source for group title
  const datum = {},
    dataRef = ref(scope.add(Collect(null, [datum])));

  // include title text
  children.push(buildTitle(spec, _, titleEncode(spec), dataRef));

  // include subtitle text
  if (spec.subtitle) {
    children.push(buildSubTitle(spec, _, encode.subtitle, dataRef));
  }

  // parse title specification
  return parseMark(guideGroup({
    role: TitleRole,
    from: dataRef,
    encode: groupEncode(_, userEncode),
    marks: children,
    aria: _('aria'),
    description: _('description'),
    zindex: _('zindex'),
    name,
    interactive,
    style
  }), scope);
}

// provide backwards-compatibility for title custom encode;
// the top-level encode block has been *deprecated*.
function titleEncode(spec) {
  const encode = spec.encode;
  return encode && encode.title || extend$1({
    name: spec.name,
    interactive: spec.interactive,
    style: spec.style
  }, encode);
}
function groupEncode(_, userEncode) {
  const encode = {
    enter: {},
    update: {}
  };
  addEncoders(encode, {
    orient: _('orient'),
    anchor: _('anchor'),
    align: {
      signal: alignExpr$1
    },
    angle: {
      signal: angleExpr
    },
    limit: _('limit'),
    frame: _('frame'),
    offset: _('offset') || 0,
    padding: _('subtitlePadding')
  });
  return extendEncode(encode, userEncode, Skip);
}
function buildTitle(spec, _, userEncode, dataRef) {
  const zero = {
      value: 0
    },
    text = spec.text,
    encode = {
      enter: {
        opacity: zero
      },
      update: {
        opacity: {
          value: 1
        }
      },
      exit: {
        opacity: zero
      }
    };
  addEncoders(encode, {
    text: text,
    align: {
      signal: 'item.mark.group.align'
    },
    angle: {
      signal: 'item.mark.group.angle'
    },
    limit: {
      signal: 'item.mark.group.limit'
    },
    baseline: 'top',
    dx: _('dx'),
    dy: _('dy'),
    fill: _('color'),
    font: _('font'),
    fontSize: _('fontSize'),
    fontStyle: _('fontStyle'),
    fontWeight: _('fontWeight'),
    lineHeight: _('lineHeight')
  }, {
    // update
    align: _('align'),
    angle: _('angle'),
    baseline: _('baseline')
  });
  return guideMark({
    type: TextMark,
    role: TitleTextRole,
    style: GroupTitleStyle,
    from: dataRef,
    encode
  }, userEncode);
}
function buildSubTitle(spec, _, userEncode, dataRef) {
  const zero = {
      value: 0
    },
    text = spec.subtitle,
    encode = {
      enter: {
        opacity: zero
      },
      update: {
        opacity: {
          value: 1
        }
      },
      exit: {
        opacity: zero
      }
    };
  addEncoders(encode, {
    text: text,
    align: {
      signal: 'item.mark.group.align'
    },
    angle: {
      signal: 'item.mark.group.angle'
    },
    limit: {
      signal: 'item.mark.group.limit'
    },
    baseline: 'top',
    dx: _('dx'),
    dy: _('dy'),
    fill: _('subtitleColor'),
    font: _('subtitleFont'),
    fontSize: _('subtitleFontSize'),
    fontStyle: _('subtitleFontStyle'),
    fontWeight: _('subtitleFontWeight'),
    lineHeight: _('subtitleLineHeight')
  }, {
    // update
    align: _('align'),
    angle: _('angle'),
    baseline: _('baseline')
  });
  return guideMark({
    type: TextMark,
    role: TitleSubtitleRole,
    style: GroupSubtitleStyle,
    from: dataRef,
    encode
  }, userEncode);
}
function parseData(data, scope) {
  const transforms = [];
  if (data.transform) {
    data.transform.forEach(tx => {
      transforms.push(parseTransform(tx, scope));
    });
  }
  if (data.on) {
    data.on.forEach(on => {
      parseTrigger(on, scope, data.name);
    });
  }
  scope.addDataPipeline(data.name, analyze(data, scope, transforms));
}

/**
 * Analyze a data pipeline, add needed operators.
 */
function analyze(data, scope, ops) {
  const output = [];
  let source = null,
    modify = false,
    generate = false,
    upstream,
    i,
    n,
    t,
    m;
  if (data.values) {
    // hard-wired input data set
    if (isSignal(data.values) || hasSignal(data.format)) {
      // if either values is signal or format has signal, use dynamic loader
      output.push(load(scope, data));
      output.push(source = collect());
    } else {
      // otherwise, ingest upon dataflow init
      output.push(source = collect({
        $ingest: data.values,
        $format: data.format
      }));
    }
  } else if (data.url) {
    // load data from external source
    if (hasSignal(data.url) || hasSignal(data.format)) {
      // if either url or format has signal, use dynamic loader
      output.push(load(scope, data));
      output.push(source = collect());
    } else {
      // otherwise, request load upon dataflow init
      output.push(source = collect({
        $request: data.url,
        $format: data.format
      }));
    }
  } else if (data.source) {
    // derives from one or more other data sets
    source = upstream = array$5(data.source).map(d => ref(scope.getData(d).output));
    output.push(null); // populate later
  }

  // scan data transforms, add collectors as needed
  for (i = 0, n = ops.length; i < n; ++i) {
    t = ops[i];
    m = t.metadata;
    if (!source && !m.source) {
      output.push(source = collect());
    }
    output.push(t);
    if (m.generates) generate = true;
    if (m.modifies && !generate) modify = true;
    if (m.source) source = t;else if (m.changes) source = null;
  }
  if (upstream) {
    n = upstream.length - 1;
    output[0] = Relay({
      derive: modify,
      pulse: n ? upstream : upstream[0]
    });
    if (modify || n) {
      // collect derived and multi-pulse tuples
      output.splice(1, 0, collect());
    }
  }
  if (!source) output.push(collect());
  output.push(Sieve({}));
  return output;
}
function collect(values) {
  const s = Collect({}, values);
  s.metadata = {
    source: true
  };
  return s;
}
function load(scope, data) {
  return Load({
    url: data.url ? scope.property(data.url) : undefined,
    async: data.async ? scope.property(data.async) : undefined,
    values: data.values ? scope.property(data.values) : undefined,
    format: scope.objectProperty(data.format)
  });
}
const isX = orient => orient === Bottom || orient === Top;

// get sign coefficient based on axis orient
const getSign = (orient, a, b) => isSignal(orient) ? ifLeftTopExpr(orient.signal, a, b) : orient === Left || orient === Top ? a : b;

// condition on axis x-direction
const ifX = (orient, a, b) => isSignal(orient) ? ifXEnc(orient.signal, a, b) : isX(orient) ? a : b;

// condition on axis y-direction
const ifY = (orient, a, b) => isSignal(orient) ? ifYEnc(orient.signal, a, b) : isX(orient) ? b : a;
const ifTop = (orient, a, b) => isSignal(orient) ? ifTopExpr(orient.signal, a, b) : orient === Top ? {
  value: a
} : {
  value: b
};
const ifRight = (orient, a, b) => isSignal(orient) ? ifRightExpr(orient.signal, a, b) : orient === Right ? {
  value: a
} : {
  value: b
};
const ifXEnc = ($orient, a, b) => ifEnc(`${$orient} === '${Top}' || ${$orient} === '${Bottom}'`, a, b);
const ifYEnc = ($orient, a, b) => ifEnc(`${$orient} !== '${Top}' && ${$orient} !== '${Bottom}'`, a, b);
const ifLeftTopExpr = ($orient, a, b) => ifExpr(`${$orient} === '${Left}' || ${$orient} === '${Top}'`, a, b);
const ifTopExpr = ($orient, a, b) => ifExpr(`${$orient} === '${Top}'`, a, b);
const ifRightExpr = ($orient, a, b) => ifExpr(`${$orient} === '${Right}'`, a, b);
const ifEnc = (test, a, b) => {
  // ensure inputs are encoder objects (or null)
  a = a != null ? encoder(a) : a;
  b = b != null ? encoder(b) : b;
  if (isSimple(a) && isSimple(b)) {
    // if possible generate simple signal expression
    a = a ? a.signal || $(a.value) : null;
    b = b ? b.signal || $(b.value) : null;
    return {
      signal: `${test} ? (${a}) : (${b})`
    };
  } else {
    // otherwise generate rule set
    return [extend$1({
      test
    }, a)].concat(b || []);
  }
};
const isSimple = enc => enc == null || Object.keys(enc).length === 1;
const ifExpr = (test, a, b) => ({
  signal: `${test} ? (${toExpr(a)}) : (${toExpr(b)})`
});
const ifOrient = ($orient, t, b, l, r) => ({
  signal: (l != null ? `${$orient} === '${Left}' ? (${toExpr(l)}) : ` : '') + (b != null ? `${$orient} === '${Bottom}' ? (${toExpr(b)}) : ` : '') + (r != null ? `${$orient} === '${Right}' ? (${toExpr(r)}) : ` : '') + (t != null ? `${$orient} === '${Top}' ? (${toExpr(t)}) : ` : '') + '(null)'
});
const toExpr = v => isSignal(v) ? v.signal : v == null ? null : $(v);
const mult = (sign, value) => value === 0 ? 0 : isSignal(sign) ? {
  signal: `(${sign.signal}) * ${value}`
} : {
  value: sign * value
};
const patch = (value, base) => {
  const s = value.signal;
  return s && s.endsWith('(null)') ? {
    signal: s.slice(0, -6) + base.signal
  } : value;
};
function fallback(prop, config, axisConfig, style) {
  let styleProp;
  if (config && has$1(config, prop)) {
    return config[prop];
  } else if (has$1(axisConfig, prop)) {
    return axisConfig[prop];
  } else if (prop.startsWith('title')) {
    switch (prop) {
      case 'titleColor':
        styleProp = 'fill';
        break;
      case 'titleFont':
      case 'titleFontSize':
      case 'titleFontWeight':
        styleProp = prop[5].toLowerCase() + prop.slice(6);
    }
    return style[GuideTitleStyle][styleProp];
  } else if (prop.startsWith('label')) {
    switch (prop) {
      case 'labelColor':
        styleProp = 'fill';
        break;
      case 'labelFont':
      case 'labelFontSize':
        styleProp = prop[5].toLowerCase() + prop.slice(6);
    }
    return style[GuideLabelStyle][styleProp];
  }
  return null;
}
function keys(objects) {
  const map = {};
  for (const obj of objects) {
    if (!obj) continue;
    for (const key in obj) map[key] = 1;
  }
  return Object.keys(map);
}
function axisConfig(spec, scope) {
  var config = scope.config,
    style = config.style,
    axis = config.axis,
    band = scope.scaleType(spec.scale) === 'band' && config.axisBand,
    orient = spec.orient,
    xy,
    or,
    key;
  if (isSignal(orient)) {
    const xyKeys = keys([config.axisX, config.axisY]),
      orientKeys = keys([config.axisTop, config.axisBottom, config.axisLeft, config.axisRight]);
    xy = {};
    for (key of xyKeys) {
      xy[key] = ifX(orient, fallback(key, config.axisX, axis, style), fallback(key, config.axisY, axis, style));
    }
    or = {};
    for (key of orientKeys) {
      or[key] = ifOrient(orient.signal, fallback(key, config.axisTop, axis, style), fallback(key, config.axisBottom, axis, style), fallback(key, config.axisLeft, axis, style), fallback(key, config.axisRight, axis, style));
    }
  } else {
    xy = orient === Top || orient === Bottom ? config.axisX : config.axisY;
    or = config['axis' + orient[0].toUpperCase() + orient.slice(1)];
  }
  const result = xy || or || band ? extend$1({}, axis, xy, or, band) : axis;
  return result;
}
function axisDomain(spec, config, userEncode, dataRef) {
  const _ = lookup(spec, config),
    orient = spec.orient;
  let enter, update;
  const encode = {
    enter: enter = {
      opacity: zero
    },
    update: update = {
      opacity: one
    },
    exit: {
      opacity: zero
    }
  };
  addEncoders(encode, {
    stroke: _('domainColor'),
    strokeCap: _('domainCap'),
    strokeDash: _('domainDash'),
    strokeDashOffset: _('domainDashOffset'),
    strokeWidth: _('domainWidth'),
    strokeOpacity: _('domainOpacity')
  });
  const pos0 = position(spec, 0);
  const pos1 = position(spec, 1);
  enter.x = update.x = ifX(orient, pos0, zero);
  enter.x2 = update.x2 = ifX(orient, pos1);
  enter.y = update.y = ifY(orient, pos0, zero);
  enter.y2 = update.y2 = ifY(orient, pos1);
  return guideMark({
    type: RuleMark,
    role: AxisDomainRole,
    from: dataRef,
    encode
  }, userEncode);
}
function position(spec, pos) {
  return {
    scale: spec.scale,
    range: pos
  };
}
function axisGrid(spec, config, userEncode, dataRef, band) {
  const _ = lookup(spec, config),
    orient = spec.orient,
    vscale = spec.gridScale,
    sign = getSign(orient, 1, -1),
    offset = offsetValue(spec.offset, sign);
  let enter, exit, update;
  const encode = {
    enter: enter = {
      opacity: zero
    },
    update: update = {
      opacity: one
    },
    exit: exit = {
      opacity: zero
    }
  };
  addEncoders(encode, {
    stroke: _('gridColor'),
    strokeCap: _('gridCap'),
    strokeDash: _('gridDash'),
    strokeDashOffset: _('gridDashOffset'),
    strokeOpacity: _('gridOpacity'),
    strokeWidth: _('gridWidth')
  });
  const tickPos = {
    scale: spec.scale,
    field: Value,
    band: band.band,
    extra: band.extra,
    offset: band.offset,
    round: _('tickRound')
  };
  const sz = ifX(orient, {
    signal: 'height'
  }, {
    signal: 'width'
  });
  const gridStart = vscale ? {
    scale: vscale,
    range: 0,
    mult: sign,
    offset: offset
  } : {
    value: 0,
    offset: offset
  };
  const gridEnd = vscale ? {
    scale: vscale,
    range: 1,
    mult: sign,
    offset: offset
  } : extend$1(sz, {
    mult: sign,
    offset: offset
  });
  enter.x = update.x = ifX(orient, tickPos, gridStart);
  enter.y = update.y = ifY(orient, tickPos, gridStart);
  enter.x2 = update.x2 = ifY(orient, gridEnd);
  enter.y2 = update.y2 = ifX(orient, gridEnd);
  exit.x = ifX(orient, tickPos);
  exit.y = ifY(orient, tickPos);
  return guideMark({
    type: RuleMark,
    role: AxisGridRole,
    key: Value,
    from: dataRef,
    encode
  }, userEncode);
}
function offsetValue(offset, sign) {
  if (sign === 1) ;else if (!isObject(offset)) {
    offset = isSignal(sign) ? {
      signal: `(${sign.signal}) * (${offset || 0})`
    } : sign * (offset || 0);
  } else {
    let entry = offset = extend$1({}, offset);
    while (entry.mult != null) {
      if (!isObject(entry.mult)) {
        entry.mult = isSignal(sign) // no offset if sign === 1
        ? {
          signal: `(${entry.mult}) * (${sign.signal})`
        } : entry.mult * sign;
        return offset;
      } else {
        entry = entry.mult = extend$1({}, entry.mult);
      }
    }
    entry.mult = sign;
  }
  return offset;
}
function axisTicks(spec, config, userEncode, dataRef, size, band) {
  const _ = lookup(spec, config),
    orient = spec.orient,
    sign = getSign(orient, -1, 1);
  let enter, exit, update;
  const encode = {
    enter: enter = {
      opacity: zero
    },
    update: update = {
      opacity: one
    },
    exit: exit = {
      opacity: zero
    }
  };
  addEncoders(encode, {
    stroke: _('tickColor'),
    strokeCap: _('tickCap'),
    strokeDash: _('tickDash'),
    strokeDashOffset: _('tickDashOffset'),
    strokeOpacity: _('tickOpacity'),
    strokeWidth: _('tickWidth')
  });
  const tickSize = encoder(size);
  tickSize.mult = sign;
  const tickPos = {
    scale: spec.scale,
    field: Value,
    band: band.band,
    extra: band.extra,
    offset: band.offset,
    round: _('tickRound')
  };
  update.y = enter.y = ifX(orient, zero, tickPos);
  update.y2 = enter.y2 = ifX(orient, tickSize);
  exit.x = ifX(orient, tickPos);
  update.x = enter.x = ifY(orient, zero, tickPos);
  update.x2 = enter.x2 = ifY(orient, tickSize);
  exit.y = ifY(orient, tickPos);
  return guideMark({
    type: RuleMark,
    role: AxisTickRole,
    key: Value,
    from: dataRef,
    encode
  }, userEncode);
}
function flushExpr(scale, threshold, a, b, c) {
  return {
    signal: 'flush(range("' + scale + '"), ' + 'scale("' + scale + '", datum.value), ' + threshold + ',' + a + ',' + b + ',' + c + ')'
  };
}
function axisLabels(spec, config, userEncode, dataRef, size, band) {
  const _ = lookup(spec, config),
    orient = spec.orient,
    scale = spec.scale,
    sign = getSign(orient, -1, 1),
    flush = deref(_('labelFlush')),
    flushOffset = deref(_('labelFlushOffset')),
    labelAlign = _('labelAlign'),
    labelBaseline = _('labelBaseline');
  let flushOn = flush === 0 || !!flush,
    update;
  const tickSize = encoder(size);
  tickSize.mult = sign;
  tickSize.offset = encoder(_('labelPadding') || 0);
  tickSize.offset.mult = sign;
  const tickPos = {
    scale: scale,
    field: Value,
    band: 0.5,
    offset: extendOffset(band.offset, _('labelOffset'))
  };
  const align = ifX(orient, flushOn ? flushExpr(scale, flush, '"left"', '"right"', '"center"') : {
    value: 'center'
  }, ifRight(orient, 'left', 'right'));
  const baseline = ifX(orient, ifTop(orient, 'bottom', 'top'), flushOn ? flushExpr(scale, flush, '"top"', '"bottom"', '"middle"') : {
    value: 'middle'
  });
  const offsetExpr = flushExpr(scale, flush, `-(${flushOffset})`, flushOffset, 0);
  flushOn = flushOn && flushOffset;
  const enter = {
    opacity: zero,
    x: ifX(orient, tickPos, tickSize),
    y: ifY(orient, tickPos, tickSize)
  };
  const encode = {
    enter: enter,
    update: update = {
      opacity: one,
      text: {
        field: Label
      },
      x: enter.x,
      y: enter.y,
      align,
      baseline
    },
    exit: {
      opacity: zero,
      x: enter.x,
      y: enter.y
    }
  };
  addEncoders(encode, {
    dx: !labelAlign && flushOn ? ifX(orient, offsetExpr) : null,
    dy: !labelBaseline && flushOn ? ifY(orient, offsetExpr) : null
  });
  addEncoders(encode, {
    angle: _('labelAngle'),
    fill: _('labelColor'),
    fillOpacity: _('labelOpacity'),
    font: _('labelFont'),
    fontSize: _('labelFontSize'),
    fontWeight: _('labelFontWeight'),
    fontStyle: _('labelFontStyle'),
    limit: _('labelLimit'),
    lineHeight: _('labelLineHeight')
  }, {
    align: labelAlign,
    baseline: labelBaseline
  });
  const bound = _('labelBound');
  let overlap = _('labelOverlap');

  // if overlap method or bound defined, request label overlap removal
  overlap = overlap || bound ? {
    separation: _('labelSeparation'),
    method: overlap,
    order: 'datum.index',
    bound: bound ? {
      scale,
      orient,
      tolerance: bound
    } : null
  } : undefined;
  if (update.align !== align) {
    update.align = patch(update.align, align);
  }
  if (update.baseline !== baseline) {
    update.baseline = patch(update.baseline, baseline);
  }
  return guideMark({
    type: TextMark,
    role: AxisLabelRole,
    style: GuideLabelStyle,
    key: Value,
    from: dataRef,
    encode,
    overlap
  }, userEncode);
}
function axisTitle(spec, config, userEncode, dataRef) {
  const _ = lookup(spec, config),
    orient = spec.orient,
    sign = getSign(orient, -1, 1);
  let enter, update;
  const encode = {
    enter: enter = {
      opacity: zero,
      anchor: encoder(_('titleAnchor', null)),
      align: {
        signal: alignExpr$1
      }
    },
    update: update = extend$1({}, enter, {
      opacity: one,
      text: encoder(spec.title)
    }),
    exit: {
      opacity: zero
    }
  };
  const titlePos = {
    signal: `lerp(range("${spec.scale}"), ${anchorExpr(0, 1, 0.5)})`
  };
  update.x = ifX(orient, titlePos);
  update.y = ifY(orient, titlePos);
  enter.angle = ifX(orient, zero, mult(sign, 90));
  enter.baseline = ifX(orient, ifTop(orient, Bottom, Top), {
    value: Bottom
  });
  update.angle = enter.angle;
  update.baseline = enter.baseline;
  addEncoders(encode, {
    fill: _('titleColor'),
    fillOpacity: _('titleOpacity'),
    font: _('titleFont'),
    fontSize: _('titleFontSize'),
    fontStyle: _('titleFontStyle'),
    fontWeight: _('titleFontWeight'),
    limit: _('titleLimit'),
    lineHeight: _('titleLineHeight')
  }, {
    // require update
    align: _('titleAlign'),
    angle: _('titleAngle'),
    baseline: _('titleBaseline')
  });
  autoLayout(_, orient, encode, userEncode);
  encode.update.align = patch(encode.update.align, enter.align);
  encode.update.angle = patch(encode.update.angle, enter.angle);
  encode.update.baseline = patch(encode.update.baseline, enter.baseline);
  return guideMark({
    type: TextMark,
    role: AxisTitleRole,
    style: GuideTitleStyle,
    from: dataRef,
    encode
  }, userEncode);
}
function autoLayout(_, orient, encode, userEncode) {
  const auto = (value, dim) => value != null ? (encode.update[dim] = patch(encoder(value), encode.update[dim]), false) : !has(dim, userEncode) ? true : false;
  const autoY = auto(_('titleX'), 'x'),
    autoX = auto(_('titleY'), 'y');
  encode.enter.auto = autoX === autoY ? encoder(autoX) : ifX(orient, encoder(autoX), encoder(autoY));
}
function parseAxis(spec, scope) {
  const config = axisConfig(spec, scope),
    encode = spec.encode || {},
    axisEncode = encode.axis || {},
    name = axisEncode.name || undefined,
    interactive = axisEncode.interactive,
    style = axisEncode.style,
    _ = lookup(spec, config),
    band = tickBand(_);

  // single-element data source for axis group
  const datum = {
    scale: spec.scale,
    ticks: !!_('ticks'),
    labels: !!_('labels'),
    grid: !!_('grid'),
    domain: !!_('domain'),
    title: spec.title != null
  };
  const dataRef = ref(scope.add(Collect({}, [datum])));

  // data source for axis ticks
  const ticksRef = ref(scope.add(AxisTicks({
    scale: scope.scaleRef(spec.scale),
    extra: scope.property(band.extra),
    count: scope.objectProperty(spec.tickCount),
    values: scope.objectProperty(spec.values),
    minstep: scope.property(spec.tickMinStep),
    formatType: scope.property(spec.formatType),
    formatSpecifier: scope.property(spec.format)
  })));

  // generate axis marks
  const children = [];
  let size;

  // include axis gridlines if requested
  if (datum.grid) {
    children.push(axisGrid(spec, config, encode.grid, ticksRef, band));
  }

  // include axis ticks if requested
  if (datum.ticks) {
    size = _('tickSize');
    children.push(axisTicks(spec, config, encode.ticks, ticksRef, size, band));
  }

  // include axis labels if requested
  if (datum.labels) {
    size = datum.ticks ? size : 0;
    children.push(axisLabels(spec, config, encode.labels, ticksRef, size, band));
  }

  // include axis domain path if requested
  if (datum.domain) {
    children.push(axisDomain(spec, config, encode.domain, dataRef));
  }

  // include axis title if defined
  if (datum.title) {
    children.push(axisTitle(spec, config, encode.title, dataRef));
  }

  // parse axis specification
  return parseMark(guideGroup({
    role: AxisRole,
    from: dataRef,
    encode: extendEncode(buildAxisEncode(_, spec), axisEncode, Skip),
    marks: children,
    aria: _('aria'),
    description: _('description'),
    zindex: _('zindex'),
    name,
    interactive,
    style
  }), scope);
}
function buildAxisEncode(_, spec) {
  const encode = {
    enter: {},
    update: {}
  };
  addEncoders(encode, {
    orient: _('orient'),
    offset: _('offset') || 0,
    position: value(spec.position, 0),
    titlePadding: _('titlePadding'),
    minExtent: _('minExtent'),
    maxExtent: _('maxExtent'),
    range: {
      signal: `abs(span(range("${spec.scale}")))`
    },
    translate: _('translate'),
    // accessibility support
    format: spec.format,
    formatType: spec.formatType
  });
  return encode;
}
function parseScope(spec, scope, preprocessed) {
  const signals = array$5(spec.signals),
    scales = array$5(spec.scales);

  // parse signal definitions, if not already preprocessed
  if (!preprocessed) signals.forEach(_ => parseSignal(_, scope));

  // parse cartographic projection definitions
  array$5(spec.projections).forEach(_ => parseProjection(_, scope));

  // initialize scale references
  scales.forEach(_ => initScale(_, scope));

  // parse data sources
  array$5(spec.data).forEach(_ => parseData(_, scope));

  // parse scale definitions
  scales.forEach(_ => parseScale(_, scope));

  // parse signal updates
  (preprocessed || signals).forEach(_ => parseSignalUpdates(_, scope));

  // parse axis definitions
  array$5(spec.axes).forEach(_ => parseAxis(_, scope));

  // parse mark definitions
  array$5(spec.marks).forEach(_ => parseMark(_, scope));

  // parse legend definitions
  array$5(spec.legends).forEach(_ => parseLegend(_, scope));

  // parse title, if defined
  if (spec.title) parseTitle(spec.title, scope);

  // parse collected lambda (anonymous) expressions
  scope.parseLambdas();
  return scope;
}
const rootEncode = spec => extendEncode({
  enter: {
    x: {
      value: 0
    },
    y: {
      value: 0
    }
  },
  update: {
    width: {
      signal: 'width'
    },
    height: {
      signal: 'height'
    }
  }
}, spec);
function parseView(spec, scope) {
  const config = scope.config;

  // add scenegraph root
  const root = ref(scope.root = scope.add(operator()));

  // parse top-level signal definitions
  const signals = collectSignals(spec, config);
  signals.forEach(_ => parseSignal(_, scope));

  // assign description, event, legend, and locale configuration
  scope.description = spec.description || config.description;
  scope.eventConfig = config.events;
  scope.legends = scope.objectProperty(config.legend && config.legend.layout);
  scope.locale = config.locale;

  // store root group item
  const input = scope.add(Collect());

  // encode root group item
  const encode = scope.add(Encode(parseEncode(rootEncode(spec.encode), GroupMark, FrameRole, spec.style, scope, {
    pulse: ref(input)
  })));

  // perform view layout
  const parent = scope.add(ViewLayout({
    layout: scope.objectProperty(spec.layout),
    legends: scope.legends,
    autosize: scope.signalRef('autosize'),
    mark: root,
    pulse: ref(encode)
  }));
  scope.operators.pop();

  // parse remainder of specification
  scope.pushState(ref(encode), ref(parent), null);
  parseScope(spec, scope, signals);
  scope.operators.push(parent);

  // bound / render / sieve root item
  let op = scope.add(Bound({
    mark: root,
    pulse: ref(parent)
  }));
  op = scope.add(Render({
    pulse: ref(op)
  }));
  op = scope.add(Sieve({
    pulse: ref(op)
  }));

  // track metadata for root item
  scope.addData('root', new DataScope(scope, input, input, op));
  return scope;
}
function signalObject(name, value) {
  return value && value.signal ? {
    name,
    update: value.signal
  } : {
    name,
    value
  };
}

/**
 * Collect top-level signals, merging values as needed. Signals
 * defined in the config signals arrays are added only if that
 * signal is not explicitly defined in the specification.
 * Built-in signals (autosize, background, padding, width, height)
 * receive special treatment. They are initialized using the
 * top-level spec property, or, if undefined in the spec, using
 * the corresponding top-level config property. If this property
 * is a signal reference object, the signal expression maps to the
 * signal 'update' property. If the spec's top-level signal array
 * contains an entry that matches a built-in signal, that entry
 * will be merged with the built-in specification, potentially
 * overwriting existing 'value' or 'update' properties.
 */
function collectSignals(spec, config) {
  const _ = name => value(spec[name], config[name]),
    signals = [signalObject('background', _('background')), signalObject('autosize', parseAutosize(_('autosize'))), signalObject('padding', parsePadding(_('padding'))), signalObject('width', _('width') || 0), signalObject('height', _('height') || 0)],
    pre = signals.reduce((p, s) => (p[s.name] = s, p), {}),
    map = {};

  // add spec signal array
  array$5(spec.signals).forEach(s => {
    if (has$1(pre, s.name)) {
      // merge if built-in signal
      s = extend$1(pre[s.name], s);
    } else {
      // otherwise add to signal list
      signals.push(s);
    }
    map[s.name] = s;
  });

  // add config signal array
  array$5(config.signals).forEach(s => {
    if (!has$1(map, s.name) && !has$1(pre, s.name)) {
      // add to signal list if not already defined
      signals.push(s);
    }
  });
  return signals;
}
function Scope(config, options) {
  this.config = config || {};
  this.options = options || {};
  this.bindings = [];
  this.field = {};
  this.signals = {};
  this.lambdas = {};
  this.scales = {};
  this.events = {};
  this.data = {};
  this.streams = [];
  this.updates = [];
  this.operators = [];
  this.eventConfig = null;
  this.locale = null;
  this._id = 0;
  this._subid = 0;
  this._nextsub = [0];
  this._parent = [];
  this._encode = [];
  this._lookup = [];
  this._markpath = [];
}
function Subscope(scope) {
  this.config = scope.config;
  this.options = scope.options;
  this.legends = scope.legends;
  this.field = Object.create(scope.field);
  this.signals = Object.create(scope.signals);
  this.lambdas = Object.create(scope.lambdas);
  this.scales = Object.create(scope.scales);
  this.events = Object.create(scope.events);
  this.data = Object.create(scope.data);
  this.streams = [];
  this.updates = [];
  this.operators = [];
  this._id = 0;
  this._subid = ++scope._nextsub[0];
  this._nextsub = scope._nextsub;
  this._parent = scope._parent.slice();
  this._encode = scope._encode.slice();
  this._lookup = scope._lookup.slice();
  this._markpath = scope._markpath;
}
Scope.prototype = Subscope.prototype = {
  parse(spec) {
    return parseScope(spec, this);
  },
  fork() {
    return new Subscope(this);
  },
  isSubscope() {
    return this._subid > 0;
  },
  toRuntime() {
    this.finish();
    return {
      description: this.description,
      operators: this.operators,
      streams: this.streams,
      updates: this.updates,
      bindings: this.bindings,
      eventConfig: this.eventConfig,
      locale: this.locale
    };
  },
  id() {
    return (this._subid ? this._subid + ':' : 0) + this._id++;
  },
  add(op) {
    this.operators.push(op);
    op.id = this.id();
    // if pre-registration references exist, resolve them now
    if (op.refs) {
      op.refs.forEach(ref => {
        ref.$ref = op.id;
      });
      op.refs = null;
    }
    return op;
  },
  proxy(op) {
    const vref = op instanceof Entry ? ref(op) : op;
    return this.add(Proxy$1({
      value: vref
    }));
  },
  addStream(stream) {
    this.streams.push(stream);
    stream.id = this.id();
    return stream;
  },
  addUpdate(update) {
    this.updates.push(update);
    return update;
  },
  // Apply metadata
  finish() {
    let name, ds;

    // annotate root
    if (this.root) this.root.root = true;

    // annotate signals
    for (name in this.signals) {
      this.signals[name].signal = name;
    }

    // annotate scales
    for (name in this.scales) {
      this.scales[name].scale = name;
    }

    // annotate data sets
    function annotate(op, name, type) {
      let data, list;
      if (op) {
        data = op.data || (op.data = {});
        list = data[name] || (data[name] = []);
        list.push(type);
      }
    }
    for (name in this.data) {
      ds = this.data[name];
      annotate(ds.input, name, 'input');
      annotate(ds.output, name, 'output');
      annotate(ds.values, name, 'values');
      for (const field in ds.index) {
        annotate(ds.index[field], name, 'index:' + field);
      }
    }
    return this;
  },
  // ----

  pushState(encode, parent, lookup) {
    this._encode.push(ref(this.add(Sieve({
      pulse: encode
    }))));
    this._parent.push(parent);
    this._lookup.push(lookup ? ref(this.proxy(lookup)) : null);
    this._markpath.push(-1);
  },
  popState() {
    this._encode.pop();
    this._parent.pop();
    this._lookup.pop();
    this._markpath.pop();
  },
  parent() {
    return peek$1(this._parent);
  },
  encode() {
    return peek$1(this._encode);
  },
  lookup() {
    return peek$1(this._lookup);
  },
  markpath() {
    const p = this._markpath;
    return ++p[p.length - 1];
  },
  // ----

  fieldRef(field, name) {
    if (isString(field)) return fieldRef$1(field, name);
    if (!field.signal) {
      error('Unsupported field reference: ' + $(field));
    }
    const s = field.signal;
    let f = this.field[s];
    if (!f) {
      const params = {
        name: this.signalRef(s)
      };
      if (name) params.as = name;
      this.field[s] = f = ref(this.add(Field(params)));
    }
    return f;
  },
  compareRef(cmp) {
    let signal = false;
    const check = _ => isSignal(_) ? (signal = true, this.signalRef(_.signal)) : isExpr$1(_) ? (signal = true, this.exprRef(_.expr)) : _;
    const fields = array$5(cmp.field).map(check),
      orders = array$5(cmp.order).map(check);
    return signal ? ref(this.add(Compare({
      fields: fields,
      orders: orders
    }))) : compareRef(fields, orders);
  },
  keyRef(fields, flat) {
    let signal = false;
    const check = _ => isSignal(_) ? (signal = true, ref(sig[_.signal])) : _;
    const sig = this.signals;
    fields = array$5(fields).map(check);
    return signal ? ref(this.add(Key({
      fields: fields,
      flat: flat
    }))) : keyRef(fields, flat);
  },
  sortRef(sort) {
    if (!sort) return sort;

    // including id ensures stable sorting
    const a = aggrField(sort.op, sort.field),
      o = sort.order || Ascending;
    return o.signal ? ref(this.add(Compare({
      fields: a,
      orders: this.signalRef(o.signal)
    }))) : compareRef(a, o);
  },
  // ----

  event(source, type) {
    const key = source + ':' + type;
    if (!this.events[key]) {
      const id = this.id();
      this.streams.push({
        id: id,
        source: source,
        type: type
      });
      this.events[key] = id;
    }
    return this.events[key];
  },
  // ----

  hasOwnSignal(name) {
    return has$1(this.signals, name);
  },
  addSignal(name, value) {
    if (this.hasOwnSignal(name)) {
      error('Duplicate signal name: ' + $(name));
    }
    const op = value instanceof Entry ? value : this.add(operator(value));
    return this.signals[name] = op;
  },
  getSignal(name) {
    if (!this.signals[name]) {
      error('Unrecognized signal name: ' + $(name));
    }
    return this.signals[name];
  },
  signalRef(s) {
    if (this.signals[s]) {
      return ref(this.signals[s]);
    } else if (!has$1(this.lambdas, s)) {
      this.lambdas[s] = this.add(operator(null));
    }
    return ref(this.lambdas[s]);
  },
  parseLambdas() {
    const code = Object.keys(this.lambdas);
    for (let i = 0, n = code.length; i < n; ++i) {
      const s = code[i],
        e = parser(s, this),
        op = this.lambdas[s];
      op.params = e.$params;
      op.update = e.$expr;
    }
  },
  property(spec) {
    return spec && spec.signal ? this.signalRef(spec.signal) : spec;
  },
  objectProperty(spec) {
    return !spec || !isObject(spec) ? spec : this.signalRef(spec.signal || propertyLambda(spec));
  },
  exprRef(code, name) {
    const params = {
      expr: parser(code, this)
    };
    if (name) params.expr.$name = name;
    return ref(this.add(Expression(params)));
  },
  addBinding(name, bind) {
    if (!this.bindings) {
      error('Nested signals do not support binding: ' + $(name));
    }
    this.bindings.push(extend$1({
      signal: name
    }, bind));
  },
  // ----

  addScaleProj(name, transform) {
    if (has$1(this.scales, name)) {
      error('Duplicate scale or projection name: ' + $(name));
    }
    this.scales[name] = this.add(transform);
  },
  addScale(name, params) {
    this.addScaleProj(name, Scale(params));
  },
  addProjection(name, params) {
    this.addScaleProj(name, Projection(params));
  },
  getScale(name) {
    if (!this.scales[name]) {
      error('Unrecognized scale name: ' + $(name));
    }
    return this.scales[name];
  },
  scaleRef(name) {
    return ref(this.getScale(name));
  },
  scaleType(name) {
    return this.getScale(name).params.type;
  },
  projectionRef(name) {
    return this.scaleRef(name);
  },
  projectionType(name) {
    return this.scaleType(name);
  },
  // ----

  addData(name, dataScope) {
    if (has$1(this.data, name)) {
      error('Duplicate data set name: ' + $(name));
    }
    return this.data[name] = dataScope;
  },
  getData(name) {
    if (!this.data[name]) {
      error('Undefined data set name: ' + $(name));
    }
    return this.data[name];
  },
  addDataPipeline(name, entries) {
    if (has$1(this.data, name)) {
      error('Duplicate data set name: ' + $(name));
    }
    return this.addData(name, DataScope.fromEntries(this, entries));
  }
};
function propertyLambda(spec) {
  return (isArray(spec) ? arrayLambda : objectLambda)(spec);
}
function arrayLambda(array) {
  const n = array.length;
  let code = '[';
  for (let i = 0; i < n; ++i) {
    const value = array[i];
    code += (i > 0 ? ',' : '') + (isObject(value) ? value.signal || propertyLambda(value) : $(value));
  }
  return code + ']';
}
function objectLambda(obj) {
  let code = '{',
    i = 0,
    key,
    value;
  for (key in obj) {
    value = obj[key];
    code += (++i > 1 ? ',' : '') + $(key) + ':' + (isObject(value) ? value.signal || propertyLambda(value) : $(value));
  }
  return code + '}';
}

/**
 * Standard configuration defaults for Vega specification parsing.
 * Users can provide their own (sub-)set of these default values
 * by passing in a config object to the top-level parse method.
 */
function defaults() {
  const defaultFont = 'sans-serif',
    defaultSymbolSize = 30,
    defaultStrokeWidth = 2,
    defaultColor = '#4c78a8',
    black = '#000',
    gray = '#888',
    lightGray = '#ddd';
  return {
    // default visualization description
    description: 'Vega visualization',
    // default padding around visualization
    padding: 0,
    // default for automatic sizing; options: 'none', 'pad', 'fit'
    // or provide an object (e.g., {'type': 'pad', 'resize': true})
    autosize: 'pad',
    // default view background color
    // covers the entire view component
    background: null,
    // default event handling configuration
    // preventDefault for view-sourced event types except 'wheel'
    events: {
      defaults: {
        allow: ['wheel']
      }
    },
    // defaults for top-level group marks
    // accepts mark properties (fill, stroke, etc)
    // covers the data rectangle within group width/height
    group: null,
    // defaults for basic mark types
    // each subset accepts mark properties (fill, stroke, etc)
    mark: null,
    arc: {
      fill: defaultColor
    },
    area: {
      fill: defaultColor
    },
    image: null,
    line: {
      stroke: defaultColor,
      strokeWidth: defaultStrokeWidth
    },
    path: {
      stroke: defaultColor
    },
    rect: {
      fill: defaultColor
    },
    rule: {
      stroke: black
    },
    shape: {
      stroke: defaultColor
    },
    symbol: {
      fill: defaultColor,
      size: 64
    },
    text: {
      fill: black,
      font: defaultFont,
      fontSize: 11
    },
    trail: {
      fill: defaultColor,
      size: defaultStrokeWidth
    },
    // style definitions
    style: {
      // axis & legend labels
      'guide-label': {
        fill: black,
        font: defaultFont,
        fontSize: 10
      },
      // axis & legend titles
      'guide-title': {
        fill: black,
        font: defaultFont,
        fontSize: 11,
        fontWeight: 'bold'
      },
      // headers, including chart title
      'group-title': {
        fill: black,
        font: defaultFont,
        fontSize: 13,
        fontWeight: 'bold'
      },
      // chart subtitle
      'group-subtitle': {
        fill: black,
        font: defaultFont,
        fontSize: 12
      },
      // defaults for styled point marks in Vega-Lite
      point: {
        size: defaultSymbolSize,
        strokeWidth: defaultStrokeWidth,
        shape: 'circle'
      },
      circle: {
        size: defaultSymbolSize,
        strokeWidth: defaultStrokeWidth
      },
      square: {
        size: defaultSymbolSize,
        strokeWidth: defaultStrokeWidth,
        shape: 'square'
      },
      // defaults for styled group marks in Vega-Lite
      cell: {
        fill: 'transparent',
        stroke: lightGray
      },
      view: {
        fill: 'transparent'
      }
    },
    // defaults for title
    title: {
      orient: 'top',
      anchor: 'middle',
      offset: 4,
      subtitlePadding: 3
    },
    // defaults for axes
    axis: {
      minExtent: 0,
      maxExtent: 200,
      bandPosition: 0.5,
      domain: true,
      domainWidth: 1,
      domainColor: gray,
      grid: false,
      gridWidth: 1,
      gridColor: lightGray,
      labels: true,
      labelAngle: 0,
      labelLimit: 180,
      labelOffset: 0,
      labelPadding: 2,
      ticks: true,
      tickColor: gray,
      tickOffset: 0,
      tickRound: true,
      tickSize: 5,
      tickWidth: 1,
      titlePadding: 4
    },
    // correction for centering bias
    axisBand: {
      tickOffset: -0.5
    },
    // defaults for cartographic projection
    projection: {
      type: 'mercator'
    },
    // defaults for legends
    legend: {
      orient: 'right',
      padding: 0,
      gridAlign: 'each',
      columnPadding: 10,
      rowPadding: 2,
      symbolDirection: 'vertical',
      gradientDirection: 'vertical',
      gradientLength: 200,
      gradientThickness: 16,
      gradientStrokeColor: lightGray,
      gradientStrokeWidth: 0,
      gradientLabelOffset: 2,
      labelAlign: 'left',
      labelBaseline: 'middle',
      labelLimit: 160,
      labelOffset: 4,
      labelOverlap: true,
      symbolLimit: 30,
      symbolType: 'circle',
      symbolSize: 100,
      symbolOffset: 0,
      symbolStrokeWidth: 1.5,
      symbolBaseFillColor: 'transparent',
      symbolBaseStrokeColor: gray,
      titleLimit: 180,
      titleOrient: 'top',
      titlePadding: 5,
      layout: {
        offset: 18,
        direction: 'horizontal',
        left: {
          direction: 'vertical'
        },
        right: {
          direction: 'vertical'
        }
      }
    },
    // defaults for scale ranges
    range: {
      category: {
        scheme: 'tableau10'
      },
      ordinal: {
        scheme: 'blues'
      },
      heatmap: {
        scheme: 'yellowgreenblue'
      },
      ramp: {
        scheme: 'blues'
      },
      diverging: {
        scheme: 'blueorange',
        extent: [1, 0]
      },
      symbol: ['circle', 'square', 'triangle-up', 'cross', 'diamond', 'triangle-right', 'triangle-down', 'triangle-left']
    }
  };
}
function parse(spec, config, options) {
  if (!isObject(spec)) {
    error('Input Vega specification must be an object.');
  }
  config = mergeConfig(defaults(), config, spec.config);
  return parseView(spec, new Scope(config, options)).toRuntime();
}

// -- Transforms -----

extend$1(transforms, tx, vtx, encode$1, geo, force, label, tree, reg, voronoi, wordcloud, xf);

const HalfPi = Math.PI / 2;
const HalfSqrt3 = Math.sqrt(3) / 2;
const Tan30 = 0.5773502691896257;
const TEXT_ALIGN_MAP = {
    left: "start",
    center: "middle",
    right: "end",
};
// prettier-ignore
const INTERPOLATION_MAP = {
    "basis": { curve: curveBasis },
    "basis-closed": { curve: curveBasisClosed },
    "basis-open": { curve: curveBasisOpen },
    "bundle": { curve: curveBundle, tension: "beta", value: 0.85 },
    "cardinal": { curve: curveCardinal, tension: "tension", value: 0 },
    "cardinal-open": { curve: curveCardinalOpen, tension: "tension", value: 0 },
    "cardinal-closed": { curve: curveCardinalClosed, tension: "tension", value: 0 },
    "catmull-rom": { curve: curveCatmullRom, tension: "alpha", value: 0.5 },
    "catmull-rom-closed": { curve: curveCatmullRomClosed, tension: "alpha", value: 0.5 },
    "catmull-rom-open": { curve: curveCatmullRomOpen, tension: "alpha", value: 0.5 },
    "linear": { curve: curveLinear },
    "linear-closed": { curve: curveLinearClosed },
    "monotone": { horizontal: monotoneX, vertical: monotoneY },
    "natural": { curve: curveNatural },
    "step": { curve: curveStep },
    "step-after": { curve: stepAfter },
    "step-before": { curve: stepBefore },
};
function vegaToShape(spec) {
    const flow = parse(spec);
    const view = new View$1(flow);
    view.run();
    view.finalize();
    const scenegraph = view.scenegraph();
    const [dx, dy] = view.origin();
    const { top, left, bottom, right } = view.padding();
    const root = new Group$1();
    const bounds = scenegraph.root.bounds;
    const totalWidth = Math.ceil(bounds.x2 - bounds.x1 + left + right);
    const totalHeight = Math.ceil(bounds.y2 - bounds.y1 + top + bottom);
    const background = new Rect(0, 0, totalWidth, totalHeight);
    const viewBackground = view.background();
    background.fill = viewBackground ? Paint.parse(viewBackground) : Paint.white();
    root.add(background);
    const group = convertMarkDefinition(scenegraph.root);
    group.transform.translate(dx + left, dy + top);
    root.add(group);
    return root;
}
// From the docs:
// "The levels of the tree alternate between an enclosing mark definition and contained sets of mark instances called items."
// This means we have two functions: convertMarkDefinition and convertXXXInstance for specific instances.
function convertMarkDefinition(def) {
    const group = new Group$1();
    group.tags = [`mark-${def.marktype}`];
    switch (def.marktype) {
        case "arc":
            for (const item of def.items) {
                group.add(convertArcInstance(item));
            }
            break;
        case "area": {
            const path = convertArea(def);
            group.add(path);
            break;
        }
        case "group":
            if (def.role) {
                group.tags.push(`role-${def.role}`);
            }
            for (const item of def.items) {
                group.add(convertGroupInstance(item));
            }
            break;
        case "line": {
            const path = convertLine(def);
            group.add(path);
            break;
        }
        case "path":
            for (const item of def.items) {
                group.add(convertPathInstance(item));
            }
            break;
        case "rect":
            for (const item of def.items) {
                group.add(convertRectInstance(item));
            }
            break;
        case "rule":
            for (const item of def.items) {
                group.add(convertRuleInstance(item));
            }
            break;
        case "shape":
            for (const item of def.items) {
                group.add(convertShapeInstance(item));
            }
            break;
        case "symbol":
            for (const item of def.items) {
                group.add(convertSymbolInstance(item));
            }
            break;
        case "text":
            for (const item of def.items) {
                group.add(convertTextInstance(item));
            }
            break;
        default:
            console.warn(`Unknown marktype ${def.marktype}`);
    }
    return group;
}
function convertArcInstance(instance) {
    const path = new Path$2();
    path.complexArc(instance.x, instance.y, instance.innerRadius, instance.outerRadius, instance.startAngle, instance.endAngle);
    applyStyles(path, instance);
    return path;
}
function convertArea(def) {
    if (def.items.length < 2) {
        return new Path$2();
    }
    const firstItem = def.items[0];
    const [path, curve] = createCurve(firstItem.interpolate, firstItem.orient);
    const n = def.items.length;
    const isHorizontal = firstItem.orient === "horizontal";
    curve.areaStart();
    curve.lineStart();
    // Draw top line
    for (let i = 0; i < n; i++) {
        const instance = def.items[i];
        curve.point(instance.x, instance.y);
    }
    curve.lineEnd();
    // Draw bottom line in reverse
    curve.lineStart();
    for (let i = n - 1; i >= 0; i--) {
        const instance = def.items[i];
        const baseline = isHorizontal ? instance.x2 : instance.y2;
        curve.point(instance.x, baseline);
    }
    curve.lineEnd();
    curve.areaEnd();
    applyStyles(path, firstItem);
    return path;
}
function convertGroupInstance(instance) {
    const group = new Group$1();
    // Add background
    if (instance.fill) {
        const background = new Rect(0, 0, instance.width, instance.height);
        background.fill = Paint.parse(instance.fill);
        group.add(background);
    }
    let tx = instance.x || 0;
    let ty = instance.y || 0;
    if (tx || ty) {
        group.transform.translate(tx, ty);
    }
    if (instance.role) {
        group.tags = [instance.role];
    }
    if (instance.clip) {
        const clipRect = new Rect(0, 0, instance.width, instance.height);
        group.clip(clipRect);
    }
    for (const item of instance.items) {
        group.add(convertMarkDefinition(item));
    }
    return group;
}
function convertLine(def) {
    if (def.items.length < 2) {
        return new Path$2();
    }
    const firstItem = def.items[0];
    const [path, curve] = createCurve(firstItem.interpolate, firstItem.orient);
    curve.lineStart();
    for (let i = 0; i < def.items.length; i++) {
        const instance = def.items[i];
        curve.point(instance.x, instance.y);
    }
    curve.lineEnd();
    applyStyles(path, firstItem);
    return path;
}
function convertPathInstance(instance) {
    if (!instance.path)
        return new Path$2();
    const path = Path$2.fromPathData(instance.path);
    path.fill = Paint.none();
    let { x, y } = instance;
    if ((x ?? 0) !== 0 || (y ?? 0) !== 0) {
        path.transform.translate(x, y);
    }
    applyStyles(path, instance);
    return path;
}
function convertRectInstance(instance) {
    const rect = new Rect(instance.x, instance.y, instance.width, instance.height);
    return applyStyles(rect, instance);
}
function convertRuleInstance(instance) {
    let x2 = instance.x;
    let y2 = instance.y;
    if (typeof instance.x2 === "number")
        x2 = instance.x2;
    if (typeof instance.y2 === "number")
        y2 = instance.y2;
    const line = new Line(instance.x, instance.y, x2, y2);
    if (instance.stroke)
        line.stroke = Paint.parse(instance.stroke);
    if (instance.strokeWidth)
        line.strokeWidth = instance.strokeWidth;
    if (instance.opacity) {
        const stroke = line.stroke;
        if (stroke.type === "solid") {
            stroke.a = instance.opacity;
        }
    }
    return line;
}
function convertShapeInstance(instance) {
    const path = new Path$2();
    instance.shape.context(path)(instance);
    applyStyles(path, instance);
    return path;
}
function convertSymbolInstance(instance) {
    const size = instance.size;
    const shape = instance.shape || "circle";
    switch (shape) {
        case "circle": {
            const r = Math.sqrt(size) / 2;
            const circle = new Circle(0, 0, r);
            return applyStylesAndTransform(circle, instance);
        }
        case "cross": {
            const r = Math.sqrt(size) / 2;
            const s = r / 2.5;
            const path = new Path$2();
            path.moveTo(-r, -s);
            path.lineTo(-r, s);
            path.lineTo(-s, s);
            path.lineTo(-s, r);
            path.lineTo(s, r);
            path.lineTo(s, s);
            path.lineTo(r, s);
            path.lineTo(r, -s);
            path.lineTo(s, -s);
            path.lineTo(s, -r);
            path.lineTo(-s, -r);
            path.lineTo(-s, -s);
            path.close();
            return applyStylesAndTransform(path, instance);
        }
        case "diamond": {
            const r = Math.sqrt(size) / 2;
            const path = new Path$2();
            path.moveTo(-r, 0);
            path.lineTo(0, -r);
            path.lineTo(r, 0);
            path.lineTo(0, r);
            path.close();
            return applyStylesAndTransform(path, instance);
        }
        case "square": {
            const w = Math.sqrt(size);
            const x = -w / 2;
            const rect = new Rect(x, x, w, w);
            return applyStylesAndTransform(rect, instance);
        }
        case "arrow": {
            const r = Math.sqrt(size) / 2;
            const s = r / 7;
            const t = r / 2.5;
            const v = r / 8;
            const path = new Path$2();
            path.moveTo(-s, r);
            path.lineTo(s, r);
            path.lineTo(s, -v);
            path.lineTo(t, -v);
            path.lineTo(0, -r);
            path.lineTo(-t, -v);
            path.lineTo(-s, -v);
            path.close();
            return applyStylesAndTransform(path, instance);
        }
        case "wedge": {
            const r = Math.sqrt(size) / 2;
            const h = HalfSqrt3 * r;
            const o = h - r * Tan30;
            const b = r / 4;
            const path = new Path$2();
            path.moveTo(0, -h - o);
            path.lineTo(-b, h - o);
            path.lineTo(b, h - o);
            path.close();
            return applyStylesAndTransform(path, instance);
        }
        case "triangle": {
            const r = Math.sqrt(size) / 2;
            const h = HalfSqrt3 * r;
            const o = h - r * Tan30;
            const path = new Path$2();
            path.moveTo(0, -h - o);
            path.lineTo(-r, h - o);
            path.lineTo(r, h - o);
            path.close();
            return applyStylesAndTransform(path, instance);
        }
        case "triangle-up": {
            const r = Math.sqrt(size) / 2;
            const h = HalfSqrt3 * r;
            const path = new Path$2();
            path.moveTo(0, -h);
            path.lineTo(-r, h);
            path.lineTo(r, h);
            path.close();
            return applyStylesAndTransform(path, instance);
        }
        case "triangle-down": {
            const r = Math.sqrt(size) / 2;
            const h = HalfSqrt3 * r;
            const path = new Path$2();
            path.moveTo(0, h);
            path.lineTo(-r, -h);
            path.lineTo(r, -h);
            path.close();
            return applyStylesAndTransform(path, instance);
        }
        case "triangle-right": {
            const r = Math.sqrt(size) / 2;
            const h = HalfSqrt3 * r;
            const path = new Path$2();
            path.moveTo(h, 0);
            path.lineTo(-h, -r);
            path.lineTo(-h, r);
            path.close();
            return applyStylesAndTransform(path, instance);
        }
        case "triangle-left": {
            const r = Math.sqrt(size) / 2;
            const h = HalfSqrt3 * r;
            const path = new Path$2();
            path.moveTo(-h, 0);
            path.lineTo(h, -r);
            path.lineTo(h, r);
            path.close();
            return applyStylesAndTransform(path, instance);
        }
        case "stroke": {
            const r = Math.sqrt(size) / 2;
            const path = new Path$2();
            path.moveTo(-r, 0);
            path.lineTo(r, 0);
            return applyStylesAndTransform(path, instance);
        }
        default:
            const path = Path$2.fromPathData(shape);
            return applyStylesAndTransform(path, instance);
    }
}
function convertTextInstance(instance) {
    let x = instance.x || 0;
    let y = (instance.y || 0) + verticalOffset(instance);
    if (instance.dx)
        x += instance.dx;
    if (instance.dy)
        y += instance.dy;
    const r = instance.radius || 0;
    if (r) {
        const t = (instance.theta || 0) - HalfPi;
        x += r * Math.cos(t);
        y += r * Math.sin(t);
    }
    const text = new Text(instance.text, x, y, String(instance.fontSize), instance.font || "sans-serif");
    if (instance.fontWeight)
        text.fontWeight = instance.fontWeight;
    text.textAnchor = TEXT_ALIGN_MAP[instance.align];
    if (instance.angle) {
        text.transform.rotateDegrees(instance.angle, new Point$1(instance.x, instance.y));
    }
    applyStyles(text, instance);
    return text;
}
function createCurve(interpolate, orient) {
    const interp = INTERPOLATION_MAP[interpolate] || { curve: curveLinear };
    const path = new Path$2();
    const curveFn = "curve" in interp ? interp.curve : interp[orient || "horizontal"];
    const curve = curveFn(path);
    return [path, curve];
}
function verticalOffset(instance) {
    // This code comes from vega-scenegraph/src/util/text.js#offset
    const fontSize = instance.fontSize || 11;
    switch (instance.baseline) {
        case "top":
            return fontSize * 0.79;
        case "middle":
            return fontSize * 0.3;
        case "bottom":
            return fontSize * -0.21;
        case "line-top":
            return fontSize * 0.29 + 0.5 * (instance.lineHeight || fontSize + 2);
        case "line-bottom":
            return fontSize * 0.29 - 0.5 * (instance.lineHeight || fontSize + 2);
        default:
            return 0;
    }
}
function applyStylesAndTransform(shape, instance) {
    shape.transform.translate(instance.x, instance.y);
    return applyStyles(shape, instance);
}
function applyStyles(shape, instance) {
    // By default, shapes have no fill (this is different from SVG shapes)
    shape.fill = Paint.none();
    if (instance.fill)
        shape.fill = Paint.parse(instance.fill);
    if (instance.stroke)
        shape.stroke = Paint.parse(instance.stroke);
    if (instance.strokeWidth)
        shape.strokeWidth = instance.strokeWidth;
    if (instance.opacity != null)
        shape.opacity = instance.opacity;
    const fill = shape.fill;
    const stroke = shape.stroke;
    if (fill) {
        if (instance.fillOpacity != null)
            fill.a = instance.fillOpacity;
    }
    if (stroke) {
        if (instance.strokeOpacity != null)
            stroke.a = instance.strokeOpacity;
    }
    return shape;
}

// Figma blue: #0D99FF
const cornerSquareSize = 1;
const colorCenter = { fill: "none", stroke: "#1976D2", strokeWidth: 0.5 };
const colorLines = { stroke: "#1976D2", strokeWidth: 0.5, fill: "none" };
const colorPoints = { fill: "none", stroke: "#1976D2", strokeWidth: 0.5 };
function applyMatrixTransform(x, y, matrix) {
    const [a, b, c, d, e, f] = matrix;
    return {
        x: a * x + c * y + e,
        y: b * x + d * y + f,
    };
}
function getPivotPoints(shape, bounds, customPoints, key) {
    const matrix = new Transform$1().matrix; //shape.transform.matrix;
    const defaultPoints = [
        { x: bounds.left, y: bounds.bottom },
        { x: bounds.left, y: bounds.top },
        { x: bounds.right, y: bounds.top },
        { x: bounds.right, y: bounds.bottom },
    ];
    const points = defaultPoints;
    const center = [{ x: bounds.centerX, y: bounds.centerY }];
    const transformedPoints = points.map((point) => ({
        ...applyMatrixTransform(point.x, point.y, matrix),
    }));
    const transformedCenter = center.map((point) => ({
        ...applyMatrixTransform(point.x, point.y, matrix),
    }));
    const rectWidthHeight = cornerSquareSize + colorPoints.strokeWidth + colorLines.strokeWidth;
    const pointElements = transformedPoints.map((point, i) => createElement("rect", {
        key: `point-${i}`,
        x: point.x - rectWidthHeight / 2,
        y: point.y - rectWidthHeight / 2,
        width: rectWidthHeight,
        height: rectWidthHeight,
        ...colorPoints,
        "data-tag": "point-corner",
    }));
    const centerElements = transformedCenter.map((point, i) => createElement("circle", {
        key: `cpoint-${i}`,
        cx: point.x,
        cy: point.y,
        r: 1,
        ...colorCenter,
        "data-tag": "point-center",
    }));
    const lineElements = transformedPoints
        .map((point, i) => {
        const nextPoint = transformedPoints[(i + 1) % transformedPoints.length];
        const dx = nextPoint.x - point.x;
        const dy = nextPoint.y - point.y;
        const length = Math.hypot(dx, dy);
        if (length === 0) {
            return null;
        }
        const ux = dx / length;
        const uy = dy / length;
        const offsetDistance = rectWidthHeight / 2;
        const startX = point.x + ux * offsetDistance;
        const startY = point.y + uy * offsetDistance;
        const endX = nextPoint.x - ux * offsetDistance;
        const endY = nextPoint.y - uy * offsetDistance;
        return createElement("line", {
            key: `line-${i}`,
            x1: startX,
            y1: startY,
            x2: endX,
            y2: endY,
            ...colorLines,
            "data-tag": "line-corner",
        });
    })
        .filter((element) => element !== null);
    return createElement("g", { key }, ...lineElements, ...pointElements, ...centerElements);
}
function wrapShape(shape, element, key) {
    const bounds = shape.getBounds();
    return createElement("g", { key }, element, getPivotPoints(shape, bounds));
}
function renderShape(shape, context, key, showPoints = false, parentTransform = new Transform$1()) {
    if (shape.clipPath) {
        context?.clipPaths.push(shape.clipPath);
    }
    switch (shape.type) {
        case ShapeType.Circle: {
            const circle = shape;
            const element = createElement("circle", {
                key,
                id: circle.id,
                cx: circle.cx,
                cy: circle.cy,
                r: circle.radius,
                ...circle._getAttributes(context),
            });
            return showPoints ? wrapShape(circle, element, key) : element;
        }
        case ShapeType.Ellipse: {
            const ellipse = shape;
            const element = createElement("ellipse", {
                key,
                id: ellipse.id,
                cx: ellipse.cx,
                cy: ellipse.cy,
                rx: ellipse.rx,
                ry: ellipse.ry,
                ...ellipse._getAttributes(context),
            });
            return showPoints ? wrapShape(ellipse, element, key) : element;
        }
        case ShapeType.Group: {
            const groupShape = shape;
            parentTransform.combine(new Transform$1(groupShape.transform.matrix));
            const element = createElement("g", { key, id: groupShape.id, ...groupShape._getAttributes() }, groupShape.children.map((child, i) => renderShape(child, context, i, showPoints)));
            if (!showPoints)
                return element;
            const bounds = groupShape.getBounds();
            let commonPoints = [];
            if (shape["data-pivot-mode"]) {
                if (shape["data-pivot-mode"] === "on group") {
                    const temp = getPivotPoints(groupShape, bounds);
                    if (temp)
                        commonPoints = [temp];
                    showPoints = false;
                }
                if (shape["data-pivot-mode"] === "canvas") {
                    showPoints = false;
                }
            }
            return createElement("g", { key }, createElement("g", { ...groupShape._getAttributes(context) }, groupShape.children
                .filter((c) => c?.type)
                .map((child, i) => renderShape(child, context, i, showPoints))), ...commonPoints);
        }
        case ShapeType.Line: {
            const line = shape;
            const element = createElement("line", {
                key,
                id: line.id,
                x1: line.x1,
                y1: line.y1,
                x2: line.x2,
                y2: line.y2,
                ...line._getAttributes(context),
            });
            return showPoints ? wrapShape(line, element, key) : element;
        }
        case ShapeType.Path: {
            const path = shape;
            const element = createElement("path", {
                key,
                id: path.id,
                d: path.toPathData(),
                ...path._getAttributes(context),
            });
            return showPoints ? wrapShape(path, element, key) : element;
        }
        case ShapeType.Rect: {
            const rect = shape;
            const element = createElement("rect", {
                key,
                id: rect.id,
                x: rect.x,
                y: rect.y,
                width: rect.width,
                height: rect.height,
                ...rect._getAttributes(context),
            });
            return showPoints ? wrapShape(rect, element, key) : element;
        }
        case ShapeType.Text: {
            const text = shape;
            const element = createElement("text", {
                key,
                id: text.id,
                x: text.x,
                y: text.y,
                fontFamily: text.fontFamily,
                fontWeight: text.fontWeight,
                fontSize: text.fontSize,
                textAnchor: text.textAnchor,
                ...text._getAttributes(context),
            }, text.text);
            if (!showPoints)
                return element;
            const bounds = text.getBounds();
            // Define custom points including base points
            [
                { x: bounds.left, y: bounds.base },
                { x: bounds.left, y: bounds.top },
                { x: bounds.right, y: bounds.top },
                { x: bounds.right, y: bounds.base },
            ];
            return createElement("g", { key }, element, getPivotPoints(text, bounds));
        }
        default:
            throw new Error(`Unknown shape type: ${shape.type}`);
    }
}
function dimensionForRenderShape(shape, useMatrix = true, cumulBounds = { left: Infinity, right: -Infinity, top: Infinity, bottom: -Infinity, centerX: 0, centerY: 0 }) {
    switch (shape.type) {
        case ShapeType.Circle: {
            const circle = shape;
            const bounds = circle.getBounds();
            return bounds;
        }
        case ShapeType.Ellipse: {
            const ellipse = shape;
            const bounds = ellipse.getBounds();
            return bounds;
        }
        case ShapeType.Group: {
            const groupShape = shape;
            if (groupShape.height && groupShape.width) {
                // height and width determined with parseSVG.
                const bounds = {
                    left: Math.min(cumulBounds.left, 0),
                    right: Math.max(cumulBounds.right, groupShape.width),
                    top: Math.min(cumulBounds.top, 0),
                    bottom: Math.max(cumulBounds.bottom, groupShape.height),
                    centerX: (Math.min(cumulBounds.left, 0) + Math.max(cumulBounds.right, groupShape.width)) / 2,
                    centerY: (Math.min(cumulBounds.top, 0) + Math.max(cumulBounds.bottom, groupShape.height)) / 2,
                };
                return bounds;
            }
            else if (groupShape["data-pivot-mode"] === undefined ||
                (groupShape["data-pivot-mode"] &&
                    groupShape["data-pivot-mode"] === "per element")) {
                const groupBounds = groupShape.children.reduce((accBounds, child) => {
                    const childBounds = dimensionForRenderShape(child);
                    return {
                        left: Math.min(accBounds.left, childBounds.left),
                        right: Math.max(accBounds.right, childBounds.right),
                        top: Math.min(accBounds.top, childBounds.top),
                        bottom: Math.max(accBounds.bottom, childBounds.bottom),
                        centerX: (Math.min(accBounds.left, childBounds.left) + Math.max(accBounds.right, childBounds.right)) / 2,
                        centerY: (Math.min(accBounds.top, childBounds.top) + Math.max(accBounds.bottom, childBounds.bottom)) / 2,
                    };
                }, cumulBounds);
                cumulBounds = {
                    left: Math.min(cumulBounds.left, groupBounds.left),
                    right: Math.max(cumulBounds.right, groupBounds.right),
                    top: Math.min(cumulBounds.top, groupBounds.top),
                    bottom: Math.max(cumulBounds.bottom, groupBounds.bottom),
                    centerX: (Math.min(cumulBounds.left, groupBounds.left) + Math.max(cumulBounds.right, groupBounds.right)) / 2,
                    centerY: (Math.min(cumulBounds.top, groupBounds.top) + Math.max(cumulBounds.bottom, groupBounds.bottom)) / 2,
                };
                return cumulBounds;
            }
            else if (groupShape["data-pivot-mode"] === "on group") {
                // get the regular bounds of each element, apply group transformation
                const groupBounds = groupShape.children.reduce((accBounds, child) => {
                    const childBounds = dimensionForRenderShape(child, false);
                    return {
                        left: Math.min(accBounds.left, childBounds.left),
                        right: Math.max(accBounds.right, childBounds.right),
                        top: Math.min(accBounds.top, childBounds.top),
                        bottom: Math.max(accBounds.bottom, childBounds.bottom),
                        centerX: (Math.min(accBounds.left, childBounds.left) + Math.max(accBounds.right, childBounds.right)) / 2,
                        centerY: (Math.min(accBounds.top, childBounds.top) + Math.max(accBounds.bottom, childBounds.bottom)) / 2,
                    };
                }, cumulBounds);
                const matrix = groupShape.transform.matrix;
                const topLeft = Transform$1.applyMatrixTransform(groupBounds.left, groupBounds.top, matrix);
                const topRight = Transform$1.applyMatrixTransform(groupBounds.right, groupBounds.top, matrix);
                const bottomLeft = Transform$1.applyMatrixTransform(groupBounds.left, groupBounds.bottom, matrix);
                const bottomRight = Transform$1.applyMatrixTransform(groupBounds.right, groupBounds.bottom, matrix);
                // Find the min and max of the transformed corners for bounding box
                const left = Math.min(topLeft.x, topRight.x, bottomLeft.x, bottomRight.x);
                const right = Math.max(topLeft.x, topRight.x, bottomLeft.x, bottomRight.x);
                const top = Math.min(topLeft.y, topRight.y, bottomLeft.y, bottomRight.y);
                const bottom = Math.max(topLeft.y, topRight.y, bottomLeft.y, bottomRight.y);
                cumulBounds = {
                    left: Math.min(cumulBounds.left, left),
                    right: Math.max(cumulBounds.right, right),
                    top: Math.min(cumulBounds.top, top),
                    bottom: Math.max(cumulBounds.bottom, bottom),
                    centerX: (Math.min(cumulBounds.left, left) + Math.max(cumulBounds.right, right)) / 2,
                    centerY: (Math.min(cumulBounds.top, top) + Math.max(cumulBounds.bottom, bottom)) / 2,
                };
                return cumulBounds;
            }
        }
        case ShapeType.Line: {
            const line = shape;
            const bounds = line.getBounds();
            return bounds;
        }
        case ShapeType.Path: {
            const path = shape;
            const bounds = path.getBounds();
            return bounds;
        }
        case ShapeType.Rect: {
            const rect = shape;
            const bounds = rect.getBounds();
            return bounds;
        }
        case ShapeType.Text: {
            const text = shape;
            const bounds = text.getTransformedBounds(); // : text.getBounds();
            return bounds;
        }
        default:
            // throw new Error(`Unknown shape type: ${shape.type}`);
            return { left: 0, right: 0, top: 0, bottom: 0, centerX: 0, centerY: 0 };
    }
}
function renderVegaSpec(spec) {
    return vegaToShape(spec);
}
function renderDefs(context) {
    if (context.clipPaths.length === 0 && context.gradients.length === 0)
        return null;
    const clipPaths = context.clipPaths.map((clipPath) => createElement("clipPath", {
        id: clipPath.id,
    }, renderShape(clipPath.shape)));
    const gradients = context.gradients.map((gradient) => {
        const stops = gradient.stops.map((stop, index) => createElement("stop", {
            key: index,
            offset: `${stop.offset * 100}%`,
            stopColor: stop.color,
        }));
        const attrs = {};
        if (gradient.type === "linearGradient") {
            const linear = gradient;
            attrs.x1 = `${linear.x1 * 100}%`;
            attrs.y1 = `${linear.y1 * 100}%`;
            attrs.x2 = `${linear.x2 * 100}%`;
            attrs.y2 = `${linear.y2 * 100}%`;
        }
        else if (gradient.type === "radialGradient") {
            const radial = gradient;
            attrs.cx = `${radial.cx * 100}%`;
            attrs.cy = `${radial.cy * 100}%`;
            attrs.r = `${radial.r * 100}%`;
        }
        return createElement(gradient.type, {
            key: gradient.id,
            id: gradient.id,
            ...attrs,
        }, ...stops);
    });
    return createElement("defs", {}, ...clipPaths, ...gradients);
}

function findItemById(project, id) {
    return project.items.find((item) => item.id === id);
}
function findItemByName(project, name) {
    return project.items.find((item) => item.name === name);
}
function findNetworkItemById(network, id) {
    return network.children.find((item) => item.id === id);
}
function findNodeById(network, id) {
    return network.children.find((child) => child.type === "NODE" && child.id === id);
}
function findNodeByName(network, name) {
    return network.children.find((child) => child.type === "NODE" && child.name === name);
}
function findInputPort(cx, node, portName) {
    const fn = cx.lookupItemByName(node.fn);
    if (!fn)
        return undefined;
    const port = fn.inputPorts.find((p) => p.name === portName);
    return port;
}
function findOutputPort(cx, node, portName) {
    const fn = cx.lookupItemByName(node.fn);
    if (!fn)
        return undefined;
    const port = fn.outputPorts.find((p) => p.name === portName);
    return port;
}
function findParameter(cx, node, parameterName) {
    const fn = cx.lookupItemByName(node.fn);
    if (!fn)
        return undefined;
    const parameter = fn.parameters.find((p) => p.name === parameterName);
    return parameter;
}
function findInputConnection(network, inNode, inPort) {
    return network.connections.find((c) => (c.type === ConnectionType.InletToNode || c.type === ConnectionType.NodeToNode) &&
        c.inNode === inNode.id &&
        c.inPort === inPort);
}
function findOutputConnectionsForNode(network, outNode) {
    return network.connections.filter((c) => (c.type === ConnectionType.NodeToNode || c.type === ConnectionType.NodeToOutlet) && c.outNode === outNode.id);
}
function findOutputConnections(network, outNode, outPort) {
    return network.connections.filter((c) => (c.type === ConnectionType.NodeToNode || c.type === ConnectionType.NodeToOutlet) &&
        c.outNode === outNode.id &&
        c.outPort === outPort);
}
function findOutletConnection(network, outlet) {
    return network.connections.find((c) => c.type === ConnectionType.NodeToOutlet && c.outlet === outlet);
}
function findRenderedNodeOutputs(cx, network) {
    const renderedNode = network.children.find((node) => node.id === network.renderedNode);
    if (!renderedNode) {
        return new Map();
    }
    console.assert(renderedNode.type === "NODE");
    const runtimeNode = cx.runtimeNodes.get(renderedNode.id);
    const result = new Map();
    if (!runtimeNode) {
        return new Map();
    }
    runtimeNode.outputPorts.forEach((port) => {
        const portValue = cx.portValues.get(`${renderedNode.id}/${port.name}`);
        if (typeof portValue !== "undefined") {
            result.set(port.name, portValue);
        }
    });
    return result;
}
function getParameterValue(cx, node, parameterName) {
    const result = node.values?.[parameterName];
    if (typeof result !== "undefined") {
        return result;
    }
    const item = cx.lookupItemByName(node.fn);
    if (!item)
        return undefined;
    const parameter = item.parameters.find((p) => p.name === parameterName);
    if (!parameter) {
        throw new Error(`Parameter not found: ${parameterName}`);
    }
    return { type: "VALUE", value: parameter.defaultValue };
}
function getValue(cx, node, parameterName) {
    const result = node.values?.[parameterName];
    if (typeof result !== "undefined") {
        if (result.type === "VALUE") {
            return result.value;
        }
        else {
            throw new Error(`Expression evaluation not implemented`);
        }
    }
    const item = cx.lookupItemByName(node.fn);
    if (!item) {
        return undefined;
    }
    else {
        const parameter = item.parameters.find((p) => p.name === parameterName);
        if (!parameter) {
            throw new Error(`Parameter not found: ${parameterName}`);
        }
        return parameter.defaultValue;
    }
}
function getNetworkOutput(cx, network, portName) {
    const portValue = cx.portValues.get(`${network.id}/${portName}`);
    return portValue;
}

async function renderItem(cx, item, values) {
    const fqName = `self/self/${item.name}`;
    await evaluateItem(cx, fqName, item, values);
    if (item.type === "NETWORK") {
        const network = item;
        if (!network.outputPorts || network.outputPorts.length === 0) {
            const renderedNode = network.children.find((node) => node.id === network.renderedNode);
            if (!renderedNode) {
                const errorMessage = `No rendered node found in network ${network.name}.`;
                throw new Error(errorMessage);
            }
            const renderedNodeFn = cx.lookupItemByName(renderedNode.fn);
            if (renderedNodeFn) {
                const outputs = renderedNodeFn.outputPorts.map((port) => cx.portValues.get(`${renderedNode.id}/${port.name}`));
                if (outputs.length > 0)
                    return outputs[0];
            }
        }
        else {
            const outputs = network.outputPorts.map((port) => cx.portValues.get(`${network.id}/${port.name}`));
            if (outputs.length > 0)
                return outputs[0];
        }
    }
}
async function evaluateItem(cx, fqName, item, values) {
    if (item.type === "NETWORK") {
        return await evaluateNetwork(cx, item, values);
    }
    else if (item.type === "FUNCTION") {
        return await evaluateFunction(cx, fqName, values);
    }
    else {
        throw new Error(`Invalid item: ${item}`);
    }
}
async function evaluateNetwork(cx, network, values) {
    let toVisit = [];
    const renderedNode = network.children.find((node) => node.id === network.renderedNode);
    if (renderedNode) {
        toVisit.push(renderedNode);
        console.assert(renderedNode.type === "NODE");
    }
    if (Array.isArray(network.outputPorts)) {
        for (const outPort of network.outputPorts) {
            const conn = findOutletConnection(network, outPort.name);
            if (conn) {
                const outNode = network.children.find((n) => n.id === conn.outNode);
                if (outNode) {
                    toVisit.push(outNode);
                }
            }
        }
    }
    if (toVisit.length === 0) {
        return null;
    }
    const visitedNodes = new Set();
    const visitNode = async (node) => {
        const nodeFn = cx.lookupItemByName(node.fn);
        if (!nodeFn)
            return;
        if (visitedNodes.has(node.id)) {
            return;
        }
        visitedNodes.add(node.id);
        for (const port of nodeFn.inputPorts) {
            const conn = findInputConnection(network, node, port.name);
            if (!conn) {
                continue;
            }
            if (conn.type === ConnectionType.InletToNode) {
                const inlet = network.inputPorts.find((p) => p.name === conn.inlet);
                if (!inlet) {
                    throw new Error(`Inlet not found: ${conn.inlet}`);
                }
                // FIXME: What do we do here? Do we get the value from the calling network?
                throw new Error(`Unimplemented: Inlet value`);
            }
            else {
                const outNode = network.children.find((n) => n.id === conn.outNode);
                if (!outNode) {
                    throw new Error(`Output node not found: ${conn.outNode}`);
                }
                await visitNode(outNode);
                const portValue = cx.portValues.get(`${conn.outNode}/${conn.outPort}`);
                if (portValue) {
                    cx.portValues.set(`${node.id}/${port.name}`, portValue);
                }
            }
        }
        await evaluateNode(cx, node, createExpressionContext(cx, { network, values }));
    };
    for (const node of toVisit) {
        await visitNode(node);
    }
    if (Array.isArray(network.outputPorts)) {
        for (const outPort of network?.outputPorts) {
            const conn = findOutletConnection(network, outPort.name);
            if (!conn) {
                continue;
            }
            const portValue = cx.portValues.get(`${conn.outNode}/${conn.outPort}`);
            if (portValue) {
                cx.portValues.set(`${network.id}/${outPort.name}`, portValue);
            }
        }
    }
    if (renderedNode) {
        return cx.runtimeNodes.get(renderedNode.id);
    }
    else {
        return null;
    }
}
async function evaluateNode(cx, node, globals) {
    // The given node is the simple JSON-serialized node that just contains the node ID and values.
    // In order to run this node, we need an "initialized" node that contains the onRender function.
    // Let's check if we have that node by looking in the `cx.runtimeNodes` map.
    let runtimeNode = cx.runtimeNodes.get(node.id);
    if (!runtimeNode) {
        runtimeNode = await createRuntimeNodeForItem(cx, node.id, node.fn);
        if (runtimeNode !== undefined)
            cx.runtimeNodes.set(node.id, runtimeNode);
    }
    if (runtimeNode && runtimeNode.dirty) {
        runtimeNode.values = structuredClone(node.values || {});
        runtimeNode.globals = globals;
        await runtimeNode.onRender(cx);
        runtimeNode.dirty = runtimeNode.timeDependent ? true : false;
        runtimeNode.outputPorts.forEach((port) => {
            cx.portValues.set(`${node.id}/${port.name}`, port._value);
        });
    }
}
/**
 * Given a fully qualified item name (`userId/projectId/itemName`), create a runtime node for that item.
 * @param {Context cx The context object.
 * @param {string} nodeId The id of the node. Used for looking up port values in the context.
 * @param {string} fqName The fully qualified item name.
 * @returns {RuntimeNode} The runtime node for the given item.
 */
async function createRuntimeNodeForItem(cx, nodeId, fqName) {
    // We do this by looking up the function item in the project and then loading the module.
    const nodeFn = cx.lookupItemByName(fqName);
    if (!nodeFn)
        return undefined;
    if (nodeFn.type === "FUNCTION") {
        await loadItem(cx, nodeFn, fqName);
        const initializerFn = cx.initializers.get(fqName);
        if (!initializerFn) {
            throw new Error(`Function not found: ${fqName}`);
        }
        // Create a runtime node object.
        const runtimeNode = new RuntimeNode(cx, nodeId, nodeFn);
        // Run the initializer function on the node object to initialize the ports and parameters.
        initializerFn(runtimeNode);
        return runtimeNode;
    }
    else {
        const runtimeNode = new RuntimeNode(cx, nodeId, nodeFn);
        return runtimeNode;
    }
}
async function evaluateFunction(cx, fqName, values) {
    let runtimeNode = cx.runtimeNodes.get(fqName);
    if (!runtimeNode) {
        // We use the fully qualified name here twice, because we don't have a node ID.
        // This means that when we're executing this function in isolation, and looking up the value of an input port,
        // we will not find anything in the context, because the port value is stored as `nodeId/portName`.
        runtimeNode = await createRuntimeNodeForItem(cx, fqName, fqName);
        if (!runtimeNode)
            return undefined;
        cx.runtimeNodes.set(fqName, runtimeNode);
    }
    if (values) {
        runtimeNode.values = Object.fromEntries(Object.entries(values).map(([k, v]) => [k, { type: "VALUE", value: v }]));
    }
    await runtimeNode.onRender(cx);
    return runtimeNode;
}
async function evaluateRuntimeNode(runtimeNode, values) {
    if (values) {
        runtimeNode.values = structuredClone(values);
    }
    await runtimeNode.onRender(runtimeNode.cx);
}
async function sendChangeEvent(cx, nodeId, parameterName) {
    // FIXME: This needs to be changed once we're merging subnetworks, because we can't use
    // global node IDs anymore.
    const runtimeNode = cx.runtimeNodes.get(nodeId);
    if (!runtimeNode)
        return;
    runtimeNode.onChange(cx, parameterName);
}

/**
 * Mark this node, and all downstream nodes, dirty.
 * @param cx The context.
 * @param network The network.
 * @param node The node to mark dirty. If undefined, does nothing.
 */
function markDirty(cx, network, node) {
    if (!node)
        return;
    const runtimeNode = cx.runtimeNodes.get(node.id);
    if (runtimeNode) {
        runtimeNode.dirty = true;
    }
    const connections = findOutputConnectionsForNode(network, node);
    connections.forEach((c) => {
        if (c.type === ConnectionType.NodeToNode) {
            const node = findNodeById(network, c.inNode);
            if (node) {
                markDirty(cx, network, node);
            }
        }
    });
}
function markItemParameterDirty(cx, item, parameterName) {
    // Note that this doesn't set the value on the network!
    // This function is here to mark all nodes dirty that use this value from the network.
    if (item.type !== "NETWORK")
        return;
    const network = item;
    for (const item of network.children) {
        if (item.type !== "NODE")
            continue;
        const node = item;
        if (!node.values)
            continue;
        for (const value of Object.values(node.values)) {
            if (value.type === "EXPRESSION") {
                const expr = value;
                if (expr.expression.includes(`network.${parameterName}`)) {
                    markDirty(cx, network, node);
                    break;
                }
            }
        }
    }
}

function isVegaSpec$1(value) {
    return typeof value === "object" && value !== null && "$schema" in value;
}
const NodeBoxPlayer = ({ userId, projectId, version, item, values, apiRoot, publishedUrlTemplate, assetsUrlTemplate, libUrlTemplate, onProjectLoaded, onProjectError, }) => {
    const contextRef = useRef();
    const [activeItem, setActiveItem] = useState();
    const [result, setResult] = useState();
    useEffect(() => {
        (async () => {
            // Apply custom configuration values if provided
            if (apiRoot !== undefined)
                config.apiRoot = apiRoot;
            if (publishedUrlTemplate !== undefined)
                config.publishedUrlTemplate = publishedUrlTemplate;
            if (assetsUrlTemplate !== undefined)
                config.assetsUrlTemplate = assetsUrlTemplate;
            if (libUrlTemplate !== undefined)
                config.libUrlTemplate = libUrlTemplate;
            let cx;
            try {
                cx = await loadMainProject(userId, projectId, version || "published");
                contextRef.current = cx;
            }
            catch (e) {
                if (onProjectError) {
                    const errorMessage = e instanceof Error ? e.message : String(e);
                    onProjectError(errorMessage);
                    return;
                }
                else {
                    throw e;
                }
            }
            let projectItem;
            if (!item) {
                projectItem = cx.project.items[0];
            }
            else {
                projectItem = cx.project.items.find((i) => i.name === item);
            }
            if (!projectItem) {
                if (onProjectError) {
                    onProjectError(`Item not found: ${item}`);
                    return;
                }
                else {
                    throw new Error(`Item not found: ${item}`);
                }
            }
            setActiveItem(projectItem);
            if (onProjectLoaded) {
                onProjectLoaded(cx);
            }
        })();
    }, [userId, projectId, item, version, apiRoot, publishedUrlTemplate, assetsUrlTemplate, libUrlTemplate]);
    useEffect(() => {
        (async () => {
            const cx = contextRef.current;
            if (!cx || !activeItem)
                return;
            if (activeItem.type === "NETWORK") {
                const network = activeItem;
                if (values) {
                    for (const [key, value] of Object.entries(values)) {
                        markItemParameterDirty(cx, network, key);
                    }
                }
            }
            const fqId = `self/self/${item}`;
            await evaluateItem(cx, fqId, activeItem, values);
            if (activeItem.type === "NETWORK") {
                const network = activeItem;
                if (!network.outputPorts || network.outputPorts.length === 0) {
                    const renderedNode = network.children.find((node) => node.id === network.renderedNode);
                    if (!renderedNode) {
                        const errorMessage = `No rendered node found in network ${network.name}.`;
                        console.error(errorMessage);
                        onProjectError && onProjectError(errorMessage);
                        return;
                    }
                    const renderedNodeFn = cx.lookupItemByName(renderedNode.fn);
                    if (renderedNodeFn) {
                        const outputs = renderedNodeFn.outputPorts.map((port) => cx.portValues.get(`${renderedNode.id}/${port.name}`));
                        if (outputs.length > 0)
                            setResult(outputs[0]);
                    }
                }
                else {
                    const outputs = network.outputPorts.map((port) => cx.portValues.get(`${network.id}/${port.name}`));
                    if (outputs.length > 0)
                        setResult(outputs[0]);
                }
            }
        })();
    }, [activeItem, values, onProjectError]);
    let shape = null;
    let shapeElement = null;
    let defsElement = null;
    let graphicsContext = new Context$1();
    if (result) {
        shape = result;
        if (isVegaSpec$1(result)) {
            shape = vegaToShape(result);
        }
        else {
            shape = result;
        }
        try {
            shapeElement = renderShape(shape, graphicsContext);
            defsElement = renderDefs(graphicsContext);
        }
        catch (e) {
            console.error(e);
        }
    }
    if (!activeItem) {
        return React.createElement("div", {}, "loading....");
    }
    const style = {};
    if (activeItem.background) {
        style.backgroundColor = Paint.parse(activeItem.background).toString();
    }
    let width = activeItem.width ?? 1000;
    let height = activeItem.height ?? 1000;
    if (activeItem.canvasSize === "auto" && shape) {
        const bounds = shape.getBounds();
        width = bounds.right - bounds.left;
        height = bounds.bottom - bounds.top;
    }
    return React.createElement("div", { className: "ndbx-wrapper" }, React.createElement("svg", { width, height, style }, shapeElement, defsElement));
};

var server_browser = {};

var reactDomServerLegacy_browser_production_min = {};

/**
 * @license React
 * react-dom-server-legacy.browser.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactDomServerLegacy_browser_production_min;

function requireReactDomServerLegacy_browser_production_min () {
	if (hasRequiredReactDomServerLegacy_browser_production_min) return reactDomServerLegacy_browser_production_min;
	hasRequiredReactDomServerLegacy_browser_production_min = 1;

	var aa = React;
	function l(a) {
	  for (var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++) b += "&args[]=" + encodeURIComponent(arguments[c]);
	  return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
	}
	var p = Object.prototype.hasOwnProperty,
	  fa = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,
	  ha = {},
	  ia = {};
	function ja(a) {
	  if (p.call(ia, a)) return true;
	  if (p.call(ha, a)) return false;
	  if (fa.test(a)) return ia[a] = true;
	  ha[a] = true;
	  return false;
	}
	function r(a, b, c, d, f, e, g) {
	  this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
	  this.attributeName = d;
	  this.attributeNamespace = f;
	  this.mustUseProperty = c;
	  this.propertyName = a;
	  this.type = b;
	  this.sanitizeURL = e;
	  this.removeEmptyString = g;
	}
	var t = {};
	"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function (a) {
	  t[a] = new r(a, 0, false, a, null, false, false);
	});
	[["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function (a) {
	  var b = a[0];
	  t[b] = new r(b, 1, false, a[1], null, false, false);
	});
	["contentEditable", "draggable", "spellCheck", "value"].forEach(function (a) {
	  t[a] = new r(a, 2, false, a.toLowerCase(), null, false, false);
	});
	["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function (a) {
	  t[a] = new r(a, 2, false, a, null, false, false);
	});
	"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function (a) {
	  t[a] = new r(a, 3, false, a.toLowerCase(), null, false, false);
	});
	["checked", "multiple", "muted", "selected"].forEach(function (a) {
	  t[a] = new r(a, 3, true, a, null, false, false);
	});
	["capture", "download"].forEach(function (a) {
	  t[a] = new r(a, 4, false, a, null, false, false);
	});
	["cols", "rows", "size", "span"].forEach(function (a) {
	  t[a] = new r(a, 6, false, a, null, false, false);
	});
	["rowSpan", "start"].forEach(function (a) {
	  t[a] = new r(a, 5, false, a.toLowerCase(), null, false, false);
	});
	var ka = /[\-:]([a-z])/g;
	function la(a) {
	  return a[1].toUpperCase();
	}
	"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function (a) {
	  var b = a.replace(ka, la);
	  t[b] = new r(b, 1, false, a, null, false, false);
	});
	"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function (a) {
	  var b = a.replace(ka, la);
	  t[b] = new r(b, 1, false, a, "http://www.w3.org/1999/xlink", false, false);
	});
	["xml:base", "xml:lang", "xml:space"].forEach(function (a) {
	  var b = a.replace(ka, la);
	  t[b] = new r(b, 1, false, a, "http://www.w3.org/XML/1998/namespace", false, false);
	});
	["tabIndex", "crossOrigin"].forEach(function (a) {
	  t[a] = new r(a, 1, false, a.toLowerCase(), null, false, false);
	});
	t.xlinkHref = new r("xlinkHref", 1, false, "xlink:href", "http://www.w3.org/1999/xlink", true, false);
	["src", "href", "action", "formAction"].forEach(function (a) {
	  t[a] = new r(a, 1, false, a.toLowerCase(), null, true, true);
	});
	var u = {
	    animationIterationCount: true,
	    aspectRatio: true,
	    borderImageOutset: true,
	    borderImageSlice: true,
	    borderImageWidth: true,
	    boxFlex: true,
	    boxFlexGroup: true,
	    boxOrdinalGroup: true,
	    columnCount: true,
	    columns: true,
	    flex: true,
	    flexGrow: true,
	    flexPositive: true,
	    flexShrink: true,
	    flexNegative: true,
	    flexOrder: true,
	    gridArea: true,
	    gridRow: true,
	    gridRowEnd: true,
	    gridRowSpan: true,
	    gridRowStart: true,
	    gridColumn: true,
	    gridColumnEnd: true,
	    gridColumnSpan: true,
	    gridColumnStart: true,
	    fontWeight: true,
	    lineClamp: true,
	    lineHeight: true,
	    opacity: true,
	    order: true,
	    orphans: true,
	    tabSize: true,
	    widows: true,
	    zIndex: true,
	    zoom: true,
	    fillOpacity: true,
	    floodOpacity: true,
	    stopOpacity: true,
	    strokeDasharray: true,
	    strokeDashoffset: true,
	    strokeMiterlimit: true,
	    strokeOpacity: true,
	    strokeWidth: true
	  },
	  ma = ["Webkit", "ms", "Moz", "O"];
	Object.keys(u).forEach(function (a) {
	  ma.forEach(function (b) {
	    b = b + a.charAt(0).toUpperCase() + a.substring(1);
	    u[b] = u[a];
	  });
	});
	var na = /["'&<>]/;
	function v(a) {
	  if ("boolean" === typeof a || "number" === typeof a) return "" + a;
	  a = "" + a;
	  var b = na.exec(a);
	  if (b) {
	    var c = "",
	      d,
	      f = 0;
	    for (d = b.index; d < a.length; d++) {
	      switch (a.charCodeAt(d)) {
	        case 34:
	          b = "&quot;";
	          break;
	        case 38:
	          b = "&amp;";
	          break;
	        case 39:
	          b = "&#x27;";
	          break;
	        case 60:
	          b = "&lt;";
	          break;
	        case 62:
	          b = "&gt;";
	          break;
	        default:
	          continue;
	      }
	      f !== d && (c += a.substring(f, d));
	      f = d + 1;
	      c += b;
	    }
	    a = f !== d ? c + a.substring(f, d) : c;
	  }
	  return a;
	}
	var oa = /([A-Z])/g,
	  pa = /^ms-/,
	  qa = Array.isArray;
	function w(a, b) {
	  return {
	    insertionMode: a,
	    selectedValue: b
	  };
	}
	function ra(a, b, c) {
	  switch (b) {
	    case "select":
	      return w(1, null != c.value ? c.value : c.defaultValue);
	    case "svg":
	      return w(2, null);
	    case "math":
	      return w(3, null);
	    case "foreignObject":
	      return w(1, null);
	    case "table":
	      return w(4, null);
	    case "thead":
	    case "tbody":
	    case "tfoot":
	      return w(5, null);
	    case "colgroup":
	      return w(7, null);
	    case "tr":
	      return w(6, null);
	  }
	  return 4 <= a.insertionMode || 0 === a.insertionMode ? w(1, null) : a;
	}
	var sa = new Map();
	function ta(a, b, c) {
	  if ("object" !== typeof c) throw Error(l(62));
	  b = true;
	  for (var d in c) if (p.call(c, d)) {
	    var f = c[d];
	    if (null != f && "boolean" !== typeof f && "" !== f) {
	      if (0 === d.indexOf("--")) {
	        var e = v(d);
	        f = v(("" + f).trim());
	      } else {
	        e = d;
	        var g = sa.get(e);
	        void 0 !== g ? e = g : (g = v(e.replace(oa, "-$1").toLowerCase().replace(pa, "-ms-")), sa.set(e, g), e = g);
	        f = "number" === typeof f ? 0 === f || p.call(u, d) ? "" + f : f + "px" : v(("" + f).trim());
	      }
	      b ? (b = false, a.push(' style="', e, ":", f)) : a.push(";", e, ":", f);
	    }
	  }
	  b || a.push('"');
	}
	function x(a, b, c, d) {
	  switch (c) {
	    case "style":
	      ta(a, b, d);
	      return;
	    case "defaultValue":
	    case "defaultChecked":
	    case "innerHTML":
	    case "suppressContentEditableWarning":
	    case "suppressHydrationWarning":
	      return;
	  }
	  if (!(2 < c.length) || "o" !== c[0] && "O" !== c[0] || "n" !== c[1] && "N" !== c[1]) if (b = t.hasOwnProperty(c) ? t[c] : null, null !== b) {
	    switch (typeof d) {
	      case "function":
	      case "symbol":
	        return;
	      case "boolean":
	        if (!b.acceptsBooleans) return;
	    }
	    c = b.attributeName;
	    switch (b.type) {
	      case 3:
	        d && a.push(" ", c, '=""');
	        break;
	      case 4:
	        true === d ? a.push(" ", c, '=""') : false !== d && a.push(" ", c, '="', v(d), '"');
	        break;
	      case 5:
	        isNaN(d) || a.push(" ", c, '="', v(d), '"');
	        break;
	      case 6:
	        !isNaN(d) && 1 <= d && a.push(" ", c, '="', v(d), '"');
	        break;
	      default:
	        b.sanitizeURL && (d = "" + d), a.push(" ", c, '="', v(d), '"');
	    }
	  } else if (ja(c)) {
	    switch (typeof d) {
	      case "function":
	      case "symbol":
	        return;
	      case "boolean":
	        if (b = c.toLowerCase().slice(0, 5), "data-" !== b && "aria-" !== b) return;
	    }
	    a.push(" ", c, '="', v(d), '"');
	  }
	}
	function y(a, b, c) {
	  if (null != b) {
	    if (null != c) throw Error(l(60));
	    if ("object" !== typeof b || !("__html" in b)) throw Error(l(61));
	    b = b.__html;
	    null !== b && void 0 !== b && a.push("" + b);
	  }
	}
	function ua(a) {
	  var b = "";
	  aa.Children.forEach(a, function (a) {
	    null != a && (b += a);
	  });
	  return b;
	}
	function va(a, b, c, d) {
	  a.push(A(c));
	  var f = c = null,
	    e;
	  for (e in b) if (p.call(b, e)) {
	    var g = b[e];
	    if (null != g) switch (e) {
	      case "children":
	        c = g;
	        break;
	      case "dangerouslySetInnerHTML":
	        f = g;
	        break;
	      default:
	        x(a, d, e, g);
	    }
	  }
	  a.push(">");
	  y(a, f, c);
	  return "string" === typeof c ? (a.push(v(c)), null) : c;
	}
	var wa = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/,
	  xa = new Map();
	function A(a) {
	  var b = xa.get(a);
	  if (void 0 === b) {
	    if (!wa.test(a)) throw Error(l(65, a));
	    b = "<" + a;
	    xa.set(a, b);
	  }
	  return b;
	}
	function ya(a, b, c, d, f) {
	  switch (b) {
	    case "select":
	      a.push(A("select"));
	      var e = null,
	        g = null;
	      for (n in c) if (p.call(c, n)) {
	        var h = c[n];
	        if (null != h) switch (n) {
	          case "children":
	            e = h;
	            break;
	          case "dangerouslySetInnerHTML":
	            g = h;
	            break;
	          case "defaultValue":
	          case "value":
	            break;
	          default:
	            x(a, d, n, h);
	        }
	      }
	      a.push(">");
	      y(a, g, e);
	      return e;
	    case "option":
	      g = f.selectedValue;
	      a.push(A("option"));
	      var k = h = null,
	        m = null;
	      var n = null;
	      for (e in c) if (p.call(c, e)) {
	        var q = c[e];
	        if (null != q) switch (e) {
	          case "children":
	            h = q;
	            break;
	          case "selected":
	            m = q;
	            break;
	          case "dangerouslySetInnerHTML":
	            n = q;
	            break;
	          case "value":
	            k = q;
	          default:
	            x(a, d, e, q);
	        }
	      }
	      if (null != g) {
	        if (c = null !== k ? "" + k : ua(h), qa(g)) for (d = 0; d < g.length; d++) {
	          if ("" + g[d] === c) {
	            a.push(' selected=""');
	            break;
	          }
	        } else "" + g === c && a.push(' selected=""');
	      } else m && a.push(' selected=""');
	      a.push(">");
	      y(a, n, h);
	      return h;
	    case "textarea":
	      a.push(A("textarea"));
	      n = g = e = null;
	      for (h in c) if (p.call(c, h) && (k = c[h], null != k)) switch (h) {
	        case "children":
	          n = k;
	          break;
	        case "value":
	          e = k;
	          break;
	        case "defaultValue":
	          g = k;
	          break;
	        case "dangerouslySetInnerHTML":
	          throw Error(l(91));
	        default:
	          x(a, d, h, k);
	      }
	      null === e && null !== g && (e = g);
	      a.push(">");
	      if (null != n) {
	        if (null != e) throw Error(l(92));
	        if (qa(n) && 1 < n.length) throw Error(l(93));
	        e = "" + n;
	      }
	      "string" === typeof e && "\n" === e[0] && a.push("\n");
	      null !== e && a.push(v("" + e));
	      return null;
	    case "input":
	      a.push(A("input"));
	      k = n = h = e = null;
	      for (g in c) if (p.call(c, g) && (m = c[g], null != m)) switch (g) {
	        case "children":
	        case "dangerouslySetInnerHTML":
	          throw Error(l(399, "input"));
	        case "defaultChecked":
	          k = m;
	          break;
	        case "defaultValue":
	          h = m;
	          break;
	        case "checked":
	          n = m;
	          break;
	        case "value":
	          e = m;
	          break;
	        default:
	          x(a, d, g, m);
	      }
	      null !== n ? x(a, d, "checked", n) : null !== k && x(a, d, "checked", k);
	      null !== e ? x(a, d, "value", e) : null !== h && x(a, d, "value", h);
	      a.push("/>");
	      return null;
	    case "menuitem":
	      a.push(A("menuitem"));
	      for (var C in c) if (p.call(c, C) && (e = c[C], null != e)) switch (C) {
	        case "children":
	        case "dangerouslySetInnerHTML":
	          throw Error(l(400));
	        default:
	          x(a, d, C, e);
	      }
	      a.push(">");
	      return null;
	    case "title":
	      a.push(A("title"));
	      e = null;
	      for (q in c) if (p.call(c, q) && (g = c[q], null != g)) switch (q) {
	        case "children":
	          e = g;
	          break;
	        case "dangerouslySetInnerHTML":
	          throw Error(l(434));
	        default:
	          x(a, d, q, g);
	      }
	      a.push(">");
	      return e;
	    case "listing":
	    case "pre":
	      a.push(A(b));
	      g = e = null;
	      for (k in c) if (p.call(c, k) && (h = c[k], null != h)) switch (k) {
	        case "children":
	          e = h;
	          break;
	        case "dangerouslySetInnerHTML":
	          g = h;
	          break;
	        default:
	          x(a, d, k, h);
	      }
	      a.push(">");
	      if (null != g) {
	        if (null != e) throw Error(l(60));
	        if ("object" !== typeof g || !("__html" in g)) throw Error(l(61));
	        c = g.__html;
	        null !== c && void 0 !== c && ("string" === typeof c && 0 < c.length && "\n" === c[0] ? a.push("\n", c) : a.push("" + c));
	      }
	      "string" === typeof e && "\n" === e[0] && a.push("\n");
	      return e;
	    case "area":
	    case "base":
	    case "br":
	    case "col":
	    case "embed":
	    case "hr":
	    case "img":
	    case "keygen":
	    case "link":
	    case "meta":
	    case "param":
	    case "source":
	    case "track":
	    case "wbr":
	      a.push(A(b));
	      for (var D in c) if (p.call(c, D) && (e = c[D], null != e)) switch (D) {
	        case "children":
	        case "dangerouslySetInnerHTML":
	          throw Error(l(399, b));
	        default:
	          x(a, d, D, e);
	      }
	      a.push("/>");
	      return null;
	    case "annotation-xml":
	    case "color-profile":
	    case "font-face":
	    case "font-face-src":
	    case "font-face-uri":
	    case "font-face-format":
	    case "font-face-name":
	    case "missing-glyph":
	      return va(a, c, b, d);
	    case "html":
	      return 0 === f.insertionMode && a.push("<!DOCTYPE html>"), va(a, c, b, d);
	    default:
	      if (-1 === b.indexOf("-") && "string" !== typeof c.is) return va(a, c, b, d);
	      a.push(A(b));
	      g = e = null;
	      for (m in c) if (p.call(c, m) && (h = c[m], null != h)) switch (m) {
	        case "children":
	          e = h;
	          break;
	        case "dangerouslySetInnerHTML":
	          g = h;
	          break;
	        case "style":
	          ta(a, d, h);
	          break;
	        case "suppressContentEditableWarning":
	        case "suppressHydrationWarning":
	          break;
	        default:
	          ja(m) && "function" !== typeof h && "symbol" !== typeof h && a.push(" ", m, '="', v(h), '"');
	      }
	      a.push(">");
	      y(a, g, e);
	      return e;
	  }
	}
	function za(a, b, c) {
	  a.push('\x3c!--$?--\x3e<template id="');
	  if (null === c) throw Error(l(395));
	  a.push(c);
	  return a.push('"></template>');
	}
	function Aa(a, b, c, d) {
	  switch (c.insertionMode) {
	    case 0:
	    case 1:
	      return a.push('<div hidden id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
	    case 2:
	      return a.push('<svg aria-hidden="true" style="display:none" id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
	    case 3:
	      return a.push('<math aria-hidden="true" style="display:none" id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
	    case 4:
	      return a.push('<table hidden id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
	    case 5:
	      return a.push('<table hidden><tbody id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
	    case 6:
	      return a.push('<table hidden><tr id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
	    case 7:
	      return a.push('<table hidden><colgroup id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
	    default:
	      throw Error(l(397));
	  }
	}
	function Ba(a, b) {
	  switch (b.insertionMode) {
	    case 0:
	    case 1:
	      return a.push("</div>");
	    case 2:
	      return a.push("</svg>");
	    case 3:
	      return a.push("</math>");
	    case 4:
	      return a.push("</table>");
	    case 5:
	      return a.push("</tbody></table>");
	    case 6:
	      return a.push("</tr></table>");
	    case 7:
	      return a.push("</colgroup></table>");
	    default:
	      throw Error(l(397));
	  }
	}
	var Ca = /[<\u2028\u2029]/g;
	function Da(a) {
	  return JSON.stringify(a).replace(Ca, function (a) {
	    switch (a) {
	      case "<":
	        return "\\u003c";
	      case "\u2028":
	        return "\\u2028";
	      case "\u2029":
	        return "\\u2029";
	      default:
	        throw Error("escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
	    }
	  });
	}
	function Ea(a, b) {
	  b = void 0 === b ? "" : b;
	  return {
	    bootstrapChunks: [],
	    startInlineScript: "<script>",
	    placeholderPrefix: b + "P:",
	    segmentPrefix: b + "S:",
	    boundaryPrefix: b + "B:",
	    idPrefix: b,
	    nextSuspenseID: 0,
	    sentCompleteSegmentFunction: false,
	    sentCompleteBoundaryFunction: false,
	    sentClientRenderFunction: false,
	    generateStaticMarkup: a
	  };
	}
	function Fa(a, b, c, d) {
	  if (c.generateStaticMarkup) return a.push(v(b)), false;
	  "" === b ? a = d : (d && a.push("\x3c!-- --\x3e"), a.push(v(b)), a = true);
	  return a;
	}
	var B = Object.assign,
	  Ga = Symbol.for("react.element"),
	  Ha = Symbol.for("react.portal"),
	  Ia = Symbol.for("react.fragment"),
	  Ja = Symbol.for("react.strict_mode"),
	  Ka = Symbol.for("react.profiler"),
	  La = Symbol.for("react.provider"),
	  Ma = Symbol.for("react.context"),
	  Na = Symbol.for("react.forward_ref"),
	  Oa = Symbol.for("react.suspense"),
	  Pa = Symbol.for("react.suspense_list"),
	  Qa = Symbol.for("react.memo"),
	  Ra = Symbol.for("react.lazy"),
	  Sa = Symbol.for("react.scope"),
	  Ta = Symbol.for("react.debug_trace_mode"),
	  Ua = Symbol.for("react.legacy_hidden"),
	  Va = Symbol.for("react.default_value"),
	  Wa = Symbol.iterator;
	function Xa(a) {
	  if (null == a) return null;
	  if ("function" === typeof a) return a.displayName || a.name || null;
	  if ("string" === typeof a) return a;
	  switch (a) {
	    case Ia:
	      return "Fragment";
	    case Ha:
	      return "Portal";
	    case Ka:
	      return "Profiler";
	    case Ja:
	      return "StrictMode";
	    case Oa:
	      return "Suspense";
	    case Pa:
	      return "SuspenseList";
	  }
	  if ("object" === typeof a) switch (a.$$typeof) {
	    case Ma:
	      return (a.displayName || "Context") + ".Consumer";
	    case La:
	      return (a._context.displayName || "Context") + ".Provider";
	    case Na:
	      var b = a.render;
	      a = a.displayName;
	      a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
	      return a;
	    case Qa:
	      return b = a.displayName || null, null !== b ? b : Xa(a.type) || "Memo";
	    case Ra:
	      b = a._payload;
	      a = a._init;
	      try {
	        return Xa(a(b));
	      } catch (c) {}
	  }
	  return null;
	}
	var Ya = {};
	function Za(a, b) {
	  a = a.contextTypes;
	  if (!a) return Ya;
	  var c = {},
	    d;
	  for (d in a) c[d] = b[d];
	  return c;
	}
	var E = null;
	function F(a, b) {
	  if (a !== b) {
	    a.context._currentValue2 = a.parentValue;
	    a = a.parent;
	    var c = b.parent;
	    if (null === a) {
	      if (null !== c) throw Error(l(401));
	    } else {
	      if (null === c) throw Error(l(401));
	      F(a, c);
	    }
	    b.context._currentValue2 = b.value;
	  }
	}
	function $a(a) {
	  a.context._currentValue2 = a.parentValue;
	  a = a.parent;
	  null !== a && $a(a);
	}
	function ab(a) {
	  var b = a.parent;
	  null !== b && ab(b);
	  a.context._currentValue2 = a.value;
	}
	function bb(a, b) {
	  a.context._currentValue2 = a.parentValue;
	  a = a.parent;
	  if (null === a) throw Error(l(402));
	  a.depth === b.depth ? F(a, b) : bb(a, b);
	}
	function cb(a, b) {
	  var c = b.parent;
	  if (null === c) throw Error(l(402));
	  a.depth === c.depth ? F(a, c) : cb(a, c);
	  b.context._currentValue2 = b.value;
	}
	function G(a) {
	  var b = E;
	  b !== a && (null === b ? ab(a) : null === a ? $a(b) : b.depth === a.depth ? F(b, a) : b.depth > a.depth ? bb(b, a) : cb(b, a), E = a);
	}
	var db = {
	  isMounted: function () {
	    return false;
	  },
	  enqueueSetState: function (a, b) {
	    a = a._reactInternals;
	    null !== a.queue && a.queue.push(b);
	  },
	  enqueueReplaceState: function (a, b) {
	    a = a._reactInternals;
	    a.replace = true;
	    a.queue = [b];
	  },
	  enqueueForceUpdate: function () {}
	};
	function eb(a, b, c, d) {
	  var f = void 0 !== a.state ? a.state : null;
	  a.updater = db;
	  a.props = c;
	  a.state = f;
	  var e = {
	    queue: [],
	    replace: false
	  };
	  a._reactInternals = e;
	  var g = b.contextType;
	  a.context = "object" === typeof g && null !== g ? g._currentValue2 : d;
	  g = b.getDerivedStateFromProps;
	  "function" === typeof g && (g = g(c, f), f = null === g || void 0 === g ? f : B({}, f, g), a.state = f);
	  if ("function" !== typeof b.getDerivedStateFromProps && "function" !== typeof a.getSnapshotBeforeUpdate && ("function" === typeof a.UNSAFE_componentWillMount || "function" === typeof a.componentWillMount)) if (b = a.state, "function" === typeof a.componentWillMount && a.componentWillMount(), "function" === typeof a.UNSAFE_componentWillMount && a.UNSAFE_componentWillMount(), b !== a.state && db.enqueueReplaceState(a, a.state, null), null !== e.queue && 0 < e.queue.length) {
	    if (b = e.queue, g = e.replace, e.queue = null, e.replace = false, g && 1 === b.length) a.state = b[0];else {
	      e = g ? b[0] : a.state;
	      f = true;
	      for (g = g ? 1 : 0; g < b.length; g++) {
	        var h = b[g];
	        h = "function" === typeof h ? h.call(a, e, c, d) : h;
	        null != h && (f ? (f = false, e = B({}, e, h)) : B(e, h));
	      }
	      a.state = e;
	    }
	  } else e.queue = null;
	}
	var fb = {
	  id: 1,
	  overflow: ""
	};
	function gb(a, b, c) {
	  var d = a.id;
	  a = a.overflow;
	  var f = 32 - H(d) - 1;
	  d &= ~(1 << f);
	  c += 1;
	  var e = 32 - H(b) + f;
	  if (30 < e) {
	    var g = f - f % 5;
	    e = (d & (1 << g) - 1).toString(32);
	    d >>= g;
	    f -= g;
	    return {
	      id: 1 << 32 - H(b) + f | c << f | d,
	      overflow: e + a
	    };
	  }
	  return {
	    id: 1 << e | c << f | d,
	    overflow: a
	  };
	}
	var H = Math.clz32 ? Math.clz32 : hb,
	  ib = Math.log,
	  jb = Math.LN2;
	function hb(a) {
	  a >>>= 0;
	  return 0 === a ? 32 : 31 - (ib(a) / jb | 0) | 0;
	}
	function kb(a, b) {
	  return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
	}
	var lb = "function" === typeof Object.is ? Object.is : kb,
	  I = null,
	  ob = null,
	  J = null,
	  K = null,
	  L = false,
	  M = false,
	  N = 0,
	  O = null,
	  P = 0;
	function Q() {
	  if (null === I) throw Error(l(321));
	  return I;
	}
	function pb() {
	  if (0 < P) throw Error(l(312));
	  return {
	    memoizedState: null,
	    queue: null,
	    next: null
	  };
	}
	function qb() {
	  null === K ? null === J ? (L = false, J = K = pb()) : (L = true, K = J) : null === K.next ? (L = false, K = K.next = pb()) : (L = true, K = K.next);
	  return K;
	}
	function rb() {
	  ob = I = null;
	  M = false;
	  J = null;
	  P = 0;
	  K = O = null;
	}
	function sb(a, b) {
	  return "function" === typeof b ? b(a) : b;
	}
	function tb(a, b, c) {
	  I = Q();
	  K = qb();
	  if (L) {
	    var d = K.queue;
	    b = d.dispatch;
	    if (null !== O && (c = O.get(d), void 0 !== c)) {
	      O.delete(d);
	      d = K.memoizedState;
	      do d = a(d, c.action), c = c.next; while (null !== c);
	      K.memoizedState = d;
	      return [d, b];
	    }
	    return [K.memoizedState, b];
	  }
	  a = a === sb ? "function" === typeof b ? b() : b : void 0 !== c ? c(b) : b;
	  K.memoizedState = a;
	  a = K.queue = {
	    last: null,
	    dispatch: null
	  };
	  a = a.dispatch = ub.bind(null, I, a);
	  return [K.memoizedState, a];
	}
	function vb(a, b) {
	  I = Q();
	  K = qb();
	  b = void 0 === b ? null : b;
	  if (null !== K) {
	    var c = K.memoizedState;
	    if (null !== c && null !== b) {
	      var d = c[1];
	      a: if (null === d) d = false;else {
	        for (var f = 0; f < d.length && f < b.length; f++) if (!lb(b[f], d[f])) {
	          d = false;
	          break a;
	        }
	        d = true;
	      }
	      if (d) return c[0];
	    }
	  }
	  a = a();
	  K.memoizedState = [a, b];
	  return a;
	}
	function ub(a, b, c) {
	  if (25 <= P) throw Error(l(301));
	  if (a === I) if (M = true, a = {
	    action: c,
	    next: null
	  }, null === O && (O = new Map()), c = O.get(b), void 0 === c) O.set(b, a);else {
	    for (b = c; null !== b.next;) b = b.next;
	    b.next = a;
	  }
	}
	function wb() {
	  throw Error(l(394));
	}
	function R() {}
	var xb = {
	    readContext: function (a) {
	      return a._currentValue2;
	    },
	    useContext: function (a) {
	      Q();
	      return a._currentValue2;
	    },
	    useMemo: vb,
	    useReducer: tb,
	    useRef: function (a) {
	      I = Q();
	      K = qb();
	      var b = K.memoizedState;
	      return null === b ? (a = {
	        current: a
	      }, K.memoizedState = a) : b;
	    },
	    useState: function (a) {
	      return tb(sb, a);
	    },
	    useInsertionEffect: R,
	    useLayoutEffect: function () {},
	    useCallback: function (a, b) {
	      return vb(function () {
	        return a;
	      }, b);
	    },
	    useImperativeHandle: R,
	    useEffect: R,
	    useDebugValue: R,
	    useDeferredValue: function (a) {
	      Q();
	      return a;
	    },
	    useTransition: function () {
	      Q();
	      return [false, wb];
	    },
	    useId: function () {
	      var a = ob.treeContext;
	      var b = a.overflow;
	      a = a.id;
	      a = (a & ~(1 << 32 - H(a) - 1)).toString(32) + b;
	      var c = S;
	      if (null === c) throw Error(l(404));
	      b = N++;
	      a = ":" + c.idPrefix + "R" + a;
	      0 < b && (a += "H" + b.toString(32));
	      return a + ":";
	    },
	    useMutableSource: function (a, b) {
	      Q();
	      return b(a._source);
	    },
	    useSyncExternalStore: function (a, b, c) {
	      if (void 0 === c) throw Error(l(407));
	      return c();
	    }
	  },
	  S = null,
	  yb = aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentDispatcher;
	function zb(a) {
	  console.error(a);
	  return null;
	}
	function T() {}
	function Ab(a, b, c, d, f, e, g, h, k) {
	  var m = [],
	    n = new Set();
	  b = {
	    destination: null,
	    responseState: b,
	    progressiveChunkSize: void 0 === d ? 12800 : d,
	    status: 0,
	    fatalError: null,
	    nextSegmentId: 0,
	    allPendingTasks: 0,
	    pendingRootTasks: 0,
	    completedRootSegment: null,
	    abortableTasks: n,
	    pingedTasks: m,
	    clientRenderedBoundaries: [],
	    completedBoundaries: [],
	    partialBoundaries: [],
	    onError: void 0 === f ? zb : f,
	    onAllReady: T ,
	    onShellReady: void 0 === g ? T : g,
	    onShellError: T ,
	    onFatalError: T 
	  };
	  c = U(b, 0, null, c, false, false);
	  c.parentFlushed = true;
	  a = Bb(b, a, null, c, n, Ya, null, fb);
	  m.push(a);
	  return b;
	}
	function Bb(a, b, c, d, f, e, g, h) {
	  a.allPendingTasks++;
	  null === c ? a.pendingRootTasks++ : c.pendingTasks++;
	  var k = {
	    node: b,
	    ping: function () {
	      var b = a.pingedTasks;
	      b.push(k);
	      1 === b.length && Cb(a);
	    },
	    blockedBoundary: c,
	    blockedSegment: d,
	    abortSet: f,
	    legacyContext: e,
	    context: g,
	    treeContext: h
	  };
	  f.add(k);
	  return k;
	}
	function U(a, b, c, d, f, e) {
	  return {
	    status: 0,
	    id: -1,
	    index: b,
	    parentFlushed: false,
	    chunks: [],
	    children: [],
	    formatContext: d,
	    boundary: c,
	    lastPushedText: f,
	    textEmbedded: e
	  };
	}
	function V(a, b) {
	  a = a.onError(b);
	  if (null != a && "string" !== typeof a) throw Error('onError returned something with a type other than "string". onError should return a string and may return null or undefined but must not return anything else. It received something of type "' + typeof a + '" instead');
	  return a;
	}
	function W(a, b) {
	  var c = a.onShellError;
	  c(b);
	  c = a.onFatalError;
	  c(b);
	  null !== a.destination ? (a.status = 2, a.destination.destroy(b)) : (a.status = 1, a.fatalError = b);
	}
	function Db(a, b, c, d, f) {
	  I = {};
	  ob = b;
	  N = 0;
	  for (a = c(d, f); M;) M = false, N = 0, P += 1, K = null, a = c(d, f);
	  rb();
	  return a;
	}
	function Eb(a, b, c, d) {
	  var f = c.render(),
	    e = d.childContextTypes;
	  if (null !== e && void 0 !== e) {
	    var g = b.legacyContext;
	    if ("function" !== typeof c.getChildContext) d = g;else {
	      c = c.getChildContext();
	      for (var h in c) if (!(h in e)) throw Error(l(108, Xa(d) || "Unknown", h));
	      d = B({}, g, c);
	    }
	    b.legacyContext = d;
	    X(a, b, f);
	    b.legacyContext = g;
	  } else X(a, b, f);
	}
	function Fb(a, b) {
	  if (a && a.defaultProps) {
	    b = B({}, b);
	    a = a.defaultProps;
	    for (var c in a) void 0 === b[c] && (b[c] = a[c]);
	    return b;
	  }
	  return b;
	}
	function Gb(a, b, c, d, f) {
	  if ("function" === typeof c) {
	    if (c.prototype && c.prototype.isReactComponent) {
	      f = Za(c, b.legacyContext);
	      var e = c.contextType;
	      e = new c(d, "object" === typeof e && null !== e ? e._currentValue2 : f);
	      eb(e, c, d, f);
	      Eb(a, b, e, c);
	    } else {
	      e = Za(c, b.legacyContext);
	      f = Db(a, b, c, d, e);
	      var g = 0 !== N;
	      if ("object" === typeof f && null !== f && "function" === typeof f.render && void 0 === f.$$typeof) eb(f, c, d, e), Eb(a, b, f, c);else if (g) {
	        d = b.treeContext;
	        b.treeContext = gb(d, 1, 0);
	        try {
	          X(a, b, f);
	        } finally {
	          b.treeContext = d;
	        }
	      } else X(a, b, f);
	    }
	  } else if ("string" === typeof c) {
	    f = b.blockedSegment;
	    e = ya(f.chunks, c, d, a.responseState, f.formatContext);
	    f.lastPushedText = false;
	    g = f.formatContext;
	    f.formatContext = ra(g, c, d);
	    Hb(a, b, e);
	    f.formatContext = g;
	    switch (c) {
	      case "area":
	      case "base":
	      case "br":
	      case "col":
	      case "embed":
	      case "hr":
	      case "img":
	      case "input":
	      case "keygen":
	      case "link":
	      case "meta":
	      case "param":
	      case "source":
	      case "track":
	      case "wbr":
	        break;
	      default:
	        f.chunks.push("</", c, ">");
	    }
	    f.lastPushedText = false;
	  } else {
	    switch (c) {
	      case Ua:
	      case Ta:
	      case Ja:
	      case Ka:
	      case Ia:
	        X(a, b, d.children);
	        return;
	      case Pa:
	        X(a, b, d.children);
	        return;
	      case Sa:
	        throw Error(l(343));
	      case Oa:
	        a: {
	          c = b.blockedBoundary;
	          f = b.blockedSegment;
	          e = d.fallback;
	          d = d.children;
	          g = new Set();
	          var h = {
	              id: null,
	              rootSegmentID: -1,
	              parentFlushed: false,
	              pendingTasks: 0,
	              forceClientRender: false,
	              completedSegments: [],
	              byteSize: 0,
	              fallbackAbortableTasks: g,
	              errorDigest: null
	            },
	            k = U(a, f.chunks.length, h, f.formatContext, false, false);
	          f.children.push(k);
	          f.lastPushedText = false;
	          var m = U(a, 0, null, f.formatContext, false, false);
	          m.parentFlushed = true;
	          b.blockedBoundary = h;
	          b.blockedSegment = m;
	          try {
	            if (Hb(a, b, d), a.responseState.generateStaticMarkup || m.lastPushedText && m.textEmbedded && m.chunks.push("\x3c!-- --\x3e"), m.status = 1, Y(h, m), 0 === h.pendingTasks) break a;
	          } catch (n) {
	            m.status = 4, h.forceClientRender = true, h.errorDigest = V(a, n);
	          } finally {
	            b.blockedBoundary = c, b.blockedSegment = f;
	          }
	          b = Bb(a, e, c, k, g, b.legacyContext, b.context, b.treeContext);
	          a.pingedTasks.push(b);
	        }
	        return;
	    }
	    if ("object" === typeof c && null !== c) switch (c.$$typeof) {
	      case Na:
	        d = Db(a, b, c.render, d, f);
	        if (0 !== N) {
	          c = b.treeContext;
	          b.treeContext = gb(c, 1, 0);
	          try {
	            X(a, b, d);
	          } finally {
	            b.treeContext = c;
	          }
	        } else X(a, b, d);
	        return;
	      case Qa:
	        c = c.type;
	        d = Fb(c, d);
	        Gb(a, b, c, d, f);
	        return;
	      case La:
	        f = d.children;
	        c = c._context;
	        d = d.value;
	        e = c._currentValue2;
	        c._currentValue2 = d;
	        g = E;
	        E = d = {
	          parent: g,
	          depth: null === g ? 0 : g.depth + 1,
	          context: c,
	          parentValue: e,
	          value: d
	        };
	        b.context = d;
	        X(a, b, f);
	        a = E;
	        if (null === a) throw Error(l(403));
	        d = a.parentValue;
	        a.context._currentValue2 = d === Va ? a.context._defaultValue : d;
	        a = E = a.parent;
	        b.context = a;
	        return;
	      case Ma:
	        d = d.children;
	        d = d(c._currentValue2);
	        X(a, b, d);
	        return;
	      case Ra:
	        f = c._init;
	        c = f(c._payload);
	        d = Fb(c, d);
	        Gb(a, b, c, d, void 0);
	        return;
	    }
	    throw Error(l(130, null == c ? c : typeof c, ""));
	  }
	}
	function X(a, b, c) {
	  b.node = c;
	  if ("object" === typeof c && null !== c) {
	    switch (c.$$typeof) {
	      case Ga:
	        Gb(a, b, c.type, c.props, c.ref);
	        return;
	      case Ha:
	        throw Error(l(257));
	      case Ra:
	        var d = c._init;
	        c = d(c._payload);
	        X(a, b, c);
	        return;
	    }
	    if (qa(c)) {
	      Ib(a, b, c);
	      return;
	    }
	    null === c || "object" !== typeof c ? d = null : (d = Wa && c[Wa] || c["@@iterator"], d = "function" === typeof d ? d : null);
	    if (d && (d = d.call(c))) {
	      c = d.next();
	      if (!c.done) {
	        var f = [];
	        do f.push(c.value), c = d.next(); while (!c.done);
	        Ib(a, b, f);
	      }
	      return;
	    }
	    a = Object.prototype.toString.call(c);
	    throw Error(l(31, "[object Object]" === a ? "object with keys {" + Object.keys(c).join(", ") + "}" : a));
	  }
	  "string" === typeof c ? (d = b.blockedSegment, d.lastPushedText = Fa(b.blockedSegment.chunks, c, a.responseState, d.lastPushedText)) : "number" === typeof c && (d = b.blockedSegment, d.lastPushedText = Fa(b.blockedSegment.chunks, "" + c, a.responseState, d.lastPushedText));
	}
	function Ib(a, b, c) {
	  for (var d = c.length, f = 0; f < d; f++) {
	    var e = b.treeContext;
	    b.treeContext = gb(e, d, f);
	    try {
	      Hb(a, b, c[f]);
	    } finally {
	      b.treeContext = e;
	    }
	  }
	}
	function Hb(a, b, c) {
	  var d = b.blockedSegment.formatContext,
	    f = b.legacyContext,
	    e = b.context;
	  try {
	    return X(a, b, c);
	  } catch (k) {
	    if (rb(), "object" === typeof k && null !== k && "function" === typeof k.then) {
	      c = k;
	      var g = b.blockedSegment,
	        h = U(a, g.chunks.length, null, g.formatContext, g.lastPushedText, true);
	      g.children.push(h);
	      g.lastPushedText = false;
	      a = Bb(a, b.node, b.blockedBoundary, h, b.abortSet, b.legacyContext, b.context, b.treeContext).ping;
	      c.then(a, a);
	      b.blockedSegment.formatContext = d;
	      b.legacyContext = f;
	      b.context = e;
	      G(e);
	    } else throw b.blockedSegment.formatContext = d, b.legacyContext = f, b.context = e, G(e), k;
	  }
	}
	function Jb(a) {
	  var b = a.blockedBoundary;
	  a = a.blockedSegment;
	  a.status = 3;
	  Kb(this, b, a);
	}
	function Lb(a, b, c) {
	  var d = a.blockedBoundary;
	  a.blockedSegment.status = 3;
	  null === d ? (b.allPendingTasks--, 2 !== b.status && (b.status = 2, null !== b.destination && b.destination.push(null))) : (d.pendingTasks--, d.forceClientRender || (d.forceClientRender = true, a = void 0 === c ? Error(l(432)) : c, d.errorDigest = b.onError(a), d.parentFlushed && b.clientRenderedBoundaries.push(d)), d.fallbackAbortableTasks.forEach(function (a) {
	    return Lb(a, b, c);
	  }), d.fallbackAbortableTasks.clear(), b.allPendingTasks--, 0 === b.allPendingTasks && (d = b.onAllReady, d()));
	}
	function Y(a, b) {
	  if (0 === b.chunks.length && 1 === b.children.length && null === b.children[0].boundary) {
	    var c = b.children[0];
	    c.id = b.id;
	    c.parentFlushed = true;
	    1 === c.status && Y(a, c);
	  } else a.completedSegments.push(b);
	}
	function Kb(a, b, c) {
	  if (null === b) {
	    if (c.parentFlushed) {
	      if (null !== a.completedRootSegment) throw Error(l(389));
	      a.completedRootSegment = c;
	    }
	    a.pendingRootTasks--;
	    0 === a.pendingRootTasks && (a.onShellError = T, b = a.onShellReady, b());
	  } else b.pendingTasks--, b.forceClientRender || (0 === b.pendingTasks ? (c.parentFlushed && 1 === c.status && Y(b, c), b.parentFlushed && a.completedBoundaries.push(b), b.fallbackAbortableTasks.forEach(Jb, a), b.fallbackAbortableTasks.clear()) : c.parentFlushed && 1 === c.status && (Y(b, c), 1 === b.completedSegments.length && b.parentFlushed && a.partialBoundaries.push(b)));
	  a.allPendingTasks--;
	  0 === a.allPendingTasks && (a = a.onAllReady, a());
	}
	function Cb(a) {
	  if (2 !== a.status) {
	    var b = E,
	      c = yb.current;
	    yb.current = xb;
	    var d = S;
	    S = a.responseState;
	    try {
	      var f = a.pingedTasks,
	        e;
	      for (e = 0; e < f.length; e++) {
	        var g = f[e];
	        var h = a,
	          k = g.blockedSegment;
	        if (0 === k.status) {
	          G(g.context);
	          try {
	            X(h, g, g.node), h.responseState.generateStaticMarkup || k.lastPushedText && k.textEmbedded && k.chunks.push("\x3c!-- --\x3e"), g.abortSet.delete(g), k.status = 1, Kb(h, g.blockedBoundary, k);
	          } catch (z) {
	            if (rb(), "object" === typeof z && null !== z && "function" === typeof z.then) {
	              var m = g.ping;
	              z.then(m, m);
	            } else {
	              g.abortSet.delete(g);
	              k.status = 4;
	              var n = g.blockedBoundary,
	                q = z,
	                C = V(h, q);
	              null === n ? W(h, q) : (n.pendingTasks--, n.forceClientRender || (n.forceClientRender = !0, n.errorDigest = C, n.parentFlushed && h.clientRenderedBoundaries.push(n)));
	              h.allPendingTasks--;
	              if (0 === h.allPendingTasks) {
	                var D = h.onAllReady;
	                D();
	              }
	            }
	          } finally {}
	        }
	      }
	      f.splice(0, e);
	      null !== a.destination && Mb(a, a.destination);
	    } catch (z) {
	      V(a, z), W(a, z);
	    } finally {
	      S = d, yb.current = c, c === xb && G(b);
	    }
	  }
	}
	function Z(a, b, c) {
	  c.parentFlushed = true;
	  switch (c.status) {
	    case 0:
	      var d = c.id = a.nextSegmentId++;
	      c.lastPushedText = false;
	      c.textEmbedded = false;
	      a = a.responseState;
	      b.push('<template id="');
	      b.push(a.placeholderPrefix);
	      a = d.toString(16);
	      b.push(a);
	      return b.push('"></template>');
	    case 1:
	      c.status = 2;
	      var f = true;
	      d = c.chunks;
	      var e = 0;
	      c = c.children;
	      for (var g = 0; g < c.length; g++) {
	        for (f = c[g]; e < f.index; e++) b.push(d[e]);
	        f = Nb(a, b, f);
	      }
	      for (; e < d.length - 1; e++) b.push(d[e]);
	      e < d.length && (f = b.push(d[e]));
	      return f;
	    default:
	      throw Error(l(390));
	  }
	}
	function Nb(a, b, c) {
	  var d = c.boundary;
	  if (null === d) return Z(a, b, c);
	  d.parentFlushed = true;
	  if (d.forceClientRender) return a.responseState.generateStaticMarkup || (d = d.errorDigest, b.push("\x3c!--$!--\x3e"), b.push("<template"), d && (b.push(' data-dgst="'), d = v(d), b.push(d), b.push('"')), b.push("></template>")), Z(a, b, c), a = a.responseState.generateStaticMarkup ? true : b.push("\x3c!--/$--\x3e"), a;
	  if (0 < d.pendingTasks) {
	    d.rootSegmentID = a.nextSegmentId++;
	    0 < d.completedSegments.length && a.partialBoundaries.push(d);
	    var f = a.responseState;
	    var e = f.nextSuspenseID++;
	    f = f.boundaryPrefix + e.toString(16);
	    d = d.id = f;
	    za(b, a.responseState, d);
	    Z(a, b, c);
	    return b.push("\x3c!--/$--\x3e");
	  }
	  if (d.byteSize > a.progressiveChunkSize) return d.rootSegmentID = a.nextSegmentId++, a.completedBoundaries.push(d), za(b, a.responseState, d.id), Z(a, b, c), b.push("\x3c!--/$--\x3e");
	  a.responseState.generateStaticMarkup || b.push("\x3c!--$--\x3e");
	  c = d.completedSegments;
	  if (1 !== c.length) throw Error(l(391));
	  Nb(a, b, c[0]);
	  a = a.responseState.generateStaticMarkup ? true : b.push("\x3c!--/$--\x3e");
	  return a;
	}
	function Ob(a, b, c) {
	  Aa(b, a.responseState, c.formatContext, c.id);
	  Nb(a, b, c);
	  return Ba(b, c.formatContext);
	}
	function Pb(a, b, c) {
	  for (var d = c.completedSegments, f = 0; f < d.length; f++) Qb(a, b, c, d[f]);
	  d.length = 0;
	  a = a.responseState;
	  d = c.id;
	  c = c.rootSegmentID;
	  b.push(a.startInlineScript);
	  a.sentCompleteBoundaryFunction ? b.push('$RC("') : (a.sentCompleteBoundaryFunction = true, b.push('function $RC(a,b){a=document.getElementById(a);b=document.getElementById(b);b.parentNode.removeChild(b);if(a){a=a.previousSibling;var f=a.parentNode,c=a.nextSibling,e=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d)if(0===e)break;else e--;else"$"!==d&&"$?"!==d&&"$!"!==d||e++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;b.firstChild;)f.insertBefore(b.firstChild,c);a.data="$";a._reactRetry&&a._reactRetry()}};$RC("'));
	  if (null === d) throw Error(l(395));
	  c = c.toString(16);
	  b.push(d);
	  b.push('","');
	  b.push(a.segmentPrefix);
	  b.push(c);
	  return b.push('")\x3c/script>');
	}
	function Qb(a, b, c, d) {
	  if (2 === d.status) return true;
	  var f = d.id;
	  if (-1 === f) {
	    if (-1 === (d.id = c.rootSegmentID)) throw Error(l(392));
	    return Ob(a, b, d);
	  }
	  Ob(a, b, d);
	  a = a.responseState;
	  b.push(a.startInlineScript);
	  a.sentCompleteSegmentFunction ? b.push('$RS("') : (a.sentCompleteSegmentFunction = true, b.push('function $RS(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)};$RS("'));
	  b.push(a.segmentPrefix);
	  f = f.toString(16);
	  b.push(f);
	  b.push('","');
	  b.push(a.placeholderPrefix);
	  b.push(f);
	  return b.push('")\x3c/script>');
	}
	function Mb(a, b) {
	  try {
	    var c = a.completedRootSegment;
	    if (null !== c && 0 === a.pendingRootTasks) {
	      Nb(a, b, c);
	      a.completedRootSegment = null;
	      var d = a.responseState.bootstrapChunks;
	      for (c = 0; c < d.length - 1; c++) b.push(d[c]);
	      c < d.length && b.push(d[c]);
	    }
	    var f = a.clientRenderedBoundaries,
	      e;
	    for (e = 0; e < f.length; e++) {
	      var g = f[e];
	      d = b;
	      var h = a.responseState,
	        k = g.id,
	        m = g.errorDigest,
	        n = g.errorMessage,
	        q = g.errorComponentStack;
	      d.push(h.startInlineScript);
	      h.sentClientRenderFunction ? d.push('$RX("') : (h.sentClientRenderFunction = !0, d.push('function $RX(b,c,d,e){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),b._reactRetry&&b._reactRetry())};$RX("'));
	      if (null === k) throw Error(l(395));
	      d.push(k);
	      d.push('"');
	      if (m || n || q) {
	        d.push(",");
	        var C = Da(m || "");
	        d.push(C);
	      }
	      if (n || q) {
	        d.push(",");
	        var D = Da(n || "");
	        d.push(D);
	      }
	      if (q) {
	        d.push(",");
	        var z = Da(q);
	        d.push(z);
	      }
	      if (!d.push(")\x3c/script>")) {
	        a.destination = null;
	        e++;
	        f.splice(0, e);
	        return;
	      }
	    }
	    f.splice(0, e);
	    var ba = a.completedBoundaries;
	    for (e = 0; e < ba.length; e++) if (!Pb(a, b, ba[e])) {
	      a.destination = null;
	      e++;
	      ba.splice(0, e);
	      return;
	    }
	    ba.splice(0, e);
	    var ca = a.partialBoundaries;
	    for (e = 0; e < ca.length; e++) {
	      var mb = ca[e];
	      a: {
	        f = a;
	        g = b;
	        var da = mb.completedSegments;
	        for (h = 0; h < da.length; h++) if (!Qb(f, g, mb, da[h])) {
	          h++;
	          da.splice(0, h);
	          var nb = !1;
	          break a;
	        }
	        da.splice(0, h);
	        nb = !0;
	      }
	      if (!nb) {
	        a.destination = null;
	        e++;
	        ca.splice(0, e);
	        return;
	      }
	    }
	    ca.splice(0, e);
	    var ea = a.completedBoundaries;
	    for (e = 0; e < ea.length; e++) if (!Pb(a, b, ea[e])) {
	      a.destination = null;
	      e++;
	      ea.splice(0, e);
	      return;
	    }
	    ea.splice(0, e);
	  } finally {
	    0 === a.allPendingTasks && 0 === a.pingedTasks.length && 0 === a.clientRenderedBoundaries.length && 0 === a.completedBoundaries.length && b.push(null);
	  }
	}
	function Rb(a, b) {
	  try {
	    var c = a.abortableTasks;
	    c.forEach(function (c) {
	      return Lb(c, a, b);
	    });
	    c.clear();
	    null !== a.destination && Mb(a, a.destination);
	  } catch (d) {
	    V(a, d), W(a, d);
	  }
	}
	function Sb() {}
	function Tb(a, b, c, d) {
	  var f = false,
	    e = null,
	    g = "",
	    h = {
	      push: function (a) {
	        null !== a && (g += a);
	        return true;
	      },
	      destroy: function (a) {
	        f = true;
	        e = a;
	      }
	    },
	    k = false;
	  a = Ab(a, Ea(c, b ? b.identifierPrefix : void 0), {
	    insertionMode: 1,
	    selectedValue: null
	  }, Infinity, Sb, void 0, function () {
	    k = true;
	  });
	  Cb(a);
	  Rb(a, d);
	  if (1 === a.status) a.status = 2, h.destroy(a.fatalError);else if (2 !== a.status && null === a.destination) {
	    a.destination = h;
	    try {
	      Mb(a, h);
	    } catch (m) {
	      V(a, m), W(a, m);
	    }
	  }
	  if (f) throw e;
	  if (!k) throw Error(l(426));
	  return g;
	}
	reactDomServerLegacy_browser_production_min.renderToNodeStream = function () {
	  throw Error(l(207));
	};
	reactDomServerLegacy_browser_production_min.renderToStaticMarkup = function (a, b) {
	  return Tb(a, b, true, 'The server used "renderToStaticMarkup" which does not support Suspense. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server');
	};
	reactDomServerLegacy_browser_production_min.renderToStaticNodeStream = function () {
	  throw Error(l(208));
	};
	reactDomServerLegacy_browser_production_min.renderToString = function (a, b) {
	  return Tb(a, b, false, 'The server used "renderToString" which does not support Suspense. If you intended for this Suspense boundary to render the fallback content on the server consider throwing an Error somewhere within the Suspense boundary. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server');
	};
	reactDomServerLegacy_browser_production_min.version = "18.3.1";
	return reactDomServerLegacy_browser_production_min;
}

var reactDomServer_browser_production_min = {};

/**
 * @license React
 * react-dom-server.browser.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactDomServer_browser_production_min;

function requireReactDomServer_browser_production_min () {
	if (hasRequiredReactDomServer_browser_production_min) return reactDomServer_browser_production_min;
	hasRequiredReactDomServer_browser_production_min = 1;

	var aa = React;
	function k(a) {
	  for (var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++) b += "&args[]=" + encodeURIComponent(arguments[c]);
	  return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
	}
	var l = null,
	  n = 0;
	function p(a, b) {
	  if (0 !== b.length) if (512 < b.length) 0 < n && (a.enqueue(new Uint8Array(l.buffer, 0, n)), l = new Uint8Array(512), n = 0), a.enqueue(b);else {
	    var c = l.length - n;
	    c < b.length && (0 === c ? a.enqueue(l) : (l.set(b.subarray(0, c), n), a.enqueue(l), b = b.subarray(c)), l = new Uint8Array(512), n = 0);
	    l.set(b, n);
	    n += b.length;
	  }
	}
	function t(a, b) {
	  p(a, b);
	  return true;
	}
	function ba(a) {
	  l && 0 < n && (a.enqueue(new Uint8Array(l.buffer, 0, n)), l = null, n = 0);
	}
	var ca = new TextEncoder();
	function u(a) {
	  return ca.encode(a);
	}
	function w(a) {
	  return ca.encode(a);
	}
	function da(a, b) {
	  "function" === typeof a.error ? a.error(b) : a.close();
	}
	var x = Object.prototype.hasOwnProperty,
	  ea = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,
	  fa = {},
	  ha = {};
	function ia(a) {
	  if (x.call(ha, a)) return true;
	  if (x.call(fa, a)) return false;
	  if (ea.test(a)) return ha[a] = true;
	  fa[a] = true;
	  return false;
	}
	function y(a, b, c, d, f, e, g) {
	  this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
	  this.attributeName = d;
	  this.attributeNamespace = f;
	  this.mustUseProperty = c;
	  this.propertyName = a;
	  this.type = b;
	  this.sanitizeURL = e;
	  this.removeEmptyString = g;
	}
	var z = {};
	"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function (a) {
	  z[a] = new y(a, 0, false, a, null, false, false);
	});
	[["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function (a) {
	  var b = a[0];
	  z[b] = new y(b, 1, false, a[1], null, false, false);
	});
	["contentEditable", "draggable", "spellCheck", "value"].forEach(function (a) {
	  z[a] = new y(a, 2, false, a.toLowerCase(), null, false, false);
	});
	["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function (a) {
	  z[a] = new y(a, 2, false, a, null, false, false);
	});
	"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function (a) {
	  z[a] = new y(a, 3, false, a.toLowerCase(), null, false, false);
	});
	["checked", "multiple", "muted", "selected"].forEach(function (a) {
	  z[a] = new y(a, 3, true, a, null, false, false);
	});
	["capture", "download"].forEach(function (a) {
	  z[a] = new y(a, 4, false, a, null, false, false);
	});
	["cols", "rows", "size", "span"].forEach(function (a) {
	  z[a] = new y(a, 6, false, a, null, false, false);
	});
	["rowSpan", "start"].forEach(function (a) {
	  z[a] = new y(a, 5, false, a.toLowerCase(), null, false, false);
	});
	var ja = /[\-:]([a-z])/g;
	function ka(a) {
	  return a[1].toUpperCase();
	}
	"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function (a) {
	  var b = a.replace(ja, ka);
	  z[b] = new y(b, 1, false, a, null, false, false);
	});
	"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function (a) {
	  var b = a.replace(ja, ka);
	  z[b] = new y(b, 1, false, a, "http://www.w3.org/1999/xlink", false, false);
	});
	["xml:base", "xml:lang", "xml:space"].forEach(function (a) {
	  var b = a.replace(ja, ka);
	  z[b] = new y(b, 1, false, a, "http://www.w3.org/XML/1998/namespace", false, false);
	});
	["tabIndex", "crossOrigin"].forEach(function (a) {
	  z[a] = new y(a, 1, false, a.toLowerCase(), null, false, false);
	});
	z.xlinkHref = new y("xlinkHref", 1, false, "xlink:href", "http://www.w3.org/1999/xlink", true, false);
	["src", "href", "action", "formAction"].forEach(function (a) {
	  z[a] = new y(a, 1, false, a.toLowerCase(), null, true, true);
	});
	var B = {
	    animationIterationCount: true,
	    aspectRatio: true,
	    borderImageOutset: true,
	    borderImageSlice: true,
	    borderImageWidth: true,
	    boxFlex: true,
	    boxFlexGroup: true,
	    boxOrdinalGroup: true,
	    columnCount: true,
	    columns: true,
	    flex: true,
	    flexGrow: true,
	    flexPositive: true,
	    flexShrink: true,
	    flexNegative: true,
	    flexOrder: true,
	    gridArea: true,
	    gridRow: true,
	    gridRowEnd: true,
	    gridRowSpan: true,
	    gridRowStart: true,
	    gridColumn: true,
	    gridColumnEnd: true,
	    gridColumnSpan: true,
	    gridColumnStart: true,
	    fontWeight: true,
	    lineClamp: true,
	    lineHeight: true,
	    opacity: true,
	    order: true,
	    orphans: true,
	    tabSize: true,
	    widows: true,
	    zIndex: true,
	    zoom: true,
	    fillOpacity: true,
	    floodOpacity: true,
	    stopOpacity: true,
	    strokeDasharray: true,
	    strokeDashoffset: true,
	    strokeMiterlimit: true,
	    strokeOpacity: true,
	    strokeWidth: true
	  },
	  la = ["Webkit", "ms", "Moz", "O"];
	Object.keys(B).forEach(function (a) {
	  la.forEach(function (b) {
	    b = b + a.charAt(0).toUpperCase() + a.substring(1);
	    B[b] = B[a];
	  });
	});
	var oa = /["'&<>]/;
	function C(a) {
	  if ("boolean" === typeof a || "number" === typeof a) return "" + a;
	  a = "" + a;
	  var b = oa.exec(a);
	  if (b) {
	    var c = "",
	      d,
	      f = 0;
	    for (d = b.index; d < a.length; d++) {
	      switch (a.charCodeAt(d)) {
	        case 34:
	          b = "&quot;";
	          break;
	        case 38:
	          b = "&amp;";
	          break;
	        case 39:
	          b = "&#x27;";
	          break;
	        case 60:
	          b = "&lt;";
	          break;
	        case 62:
	          b = "&gt;";
	          break;
	        default:
	          continue;
	      }
	      f !== d && (c += a.substring(f, d));
	      f = d + 1;
	      c += b;
	    }
	    a = f !== d ? c + a.substring(f, d) : c;
	  }
	  return a;
	}
	var pa = /([A-Z])/g,
	  qa = /^ms-/,
	  ra = Array.isArray,
	  sa = w("<script>"),
	  ta = w("\x3c/script>"),
	  ua = w('<script src="'),
	  va = w('<script type="module" src="'),
	  wa = w('" async="">\x3c/script>'),
	  xa = /(<\/|<)(s)(cript)/gi;
	function ya(a, b, c, d) {
	  return "" + b + ("s" === c ? "\\u0073" : "\\u0053") + d;
	}
	function za(a, b, c, d, f) {
	  a = void 0 === a ? "" : a;
	  b = void 0 === b ? sa : w('<script nonce="' + C(b) + '">');
	  var e = [];
	  void 0 !== c && e.push(b, u(("" + c).replace(xa, ya)), ta);
	  if (void 0 !== d) for (c = 0; c < d.length; c++) e.push(ua, u(C(d[c])), wa);
	  if (void 0 !== f) for (d = 0; d < f.length; d++) e.push(va, u(C(f[d])), wa);
	  return {
	    bootstrapChunks: e,
	    startInlineScript: b,
	    placeholderPrefix: w(a + "P:"),
	    segmentPrefix: w(a + "S:"),
	    boundaryPrefix: a + "B:",
	    idPrefix: a,
	    nextSuspenseID: 0,
	    sentCompleteSegmentFunction: false,
	    sentCompleteBoundaryFunction: false,
	    sentClientRenderFunction: false
	  };
	}
	function D(a, b) {
	  return {
	    insertionMode: a,
	    selectedValue: b
	  };
	}
	function Aa(a) {
	  return D("http://www.w3.org/2000/svg" === a ? 2 : "http://www.w3.org/1998/Math/MathML" === a ? 3 : 0, null);
	}
	function Ba(a, b, c) {
	  switch (b) {
	    case "select":
	      return D(1, null != c.value ? c.value : c.defaultValue);
	    case "svg":
	      return D(2, null);
	    case "math":
	      return D(3, null);
	    case "foreignObject":
	      return D(1, null);
	    case "table":
	      return D(4, null);
	    case "thead":
	    case "tbody":
	    case "tfoot":
	      return D(5, null);
	    case "colgroup":
	      return D(7, null);
	    case "tr":
	      return D(6, null);
	  }
	  return 4 <= a.insertionMode || 0 === a.insertionMode ? D(1, null) : a;
	}
	var Ca = w("\x3c!-- --\x3e");
	function Da(a, b, c, d) {
	  if ("" === b) return d;
	  d && a.push(Ca);
	  a.push(u(C(b)));
	  return true;
	}
	var Ea = new Map(),
	  Fa = w(' style="'),
	  Ga = w(":"),
	  Ha = w(";");
	function Ia(a, b, c) {
	  if ("object" !== typeof c) throw Error(k(62));
	  b = true;
	  for (var d in c) if (x.call(c, d)) {
	    var f = c[d];
	    if (null != f && "boolean" !== typeof f && "" !== f) {
	      if (0 === d.indexOf("--")) {
	        var e = u(C(d));
	        f = u(C(("" + f).trim()));
	      } else {
	        e = d;
	        var g = Ea.get(e);
	        void 0 !== g ? e = g : (g = w(C(e.replace(pa, "-$1").toLowerCase().replace(qa, "-ms-"))), Ea.set(e, g), e = g);
	        f = "number" === typeof f ? 0 === f || x.call(B, d) ? u("" + f) : u(f + "px") : u(C(("" + f).trim()));
	      }
	      b ? (b = false, a.push(Fa, e, Ga, f)) : a.push(Ha, e, Ga, f);
	    }
	  }
	  b || a.push(E);
	}
	var H = w(" "),
	  I = w('="'),
	  E = w('"'),
	  Ja = w('=""');
	function J(a, b, c, d) {
	  switch (c) {
	    case "style":
	      Ia(a, b, d);
	      return;
	    case "defaultValue":
	    case "defaultChecked":
	    case "innerHTML":
	    case "suppressContentEditableWarning":
	    case "suppressHydrationWarning":
	      return;
	  }
	  if (!(2 < c.length) || "o" !== c[0] && "O" !== c[0] || "n" !== c[1] && "N" !== c[1]) if (b = z.hasOwnProperty(c) ? z[c] : null, null !== b) {
	    switch (typeof d) {
	      case "function":
	      case "symbol":
	        return;
	      case "boolean":
	        if (!b.acceptsBooleans) return;
	    }
	    c = u(b.attributeName);
	    switch (b.type) {
	      case 3:
	        d && a.push(H, c, Ja);
	        break;
	      case 4:
	        true === d ? a.push(H, c, Ja) : false !== d && a.push(H, c, I, u(C(d)), E);
	        break;
	      case 5:
	        isNaN(d) || a.push(H, c, I, u(C(d)), E);
	        break;
	      case 6:
	        !isNaN(d) && 1 <= d && a.push(H, c, I, u(C(d)), E);
	        break;
	      default:
	        b.sanitizeURL && (d = "" + d), a.push(H, c, I, u(C(d)), E);
	    }
	  } else if (ia(c)) {
	    switch (typeof d) {
	      case "function":
	      case "symbol":
	        return;
	      case "boolean":
	        if (b = c.toLowerCase().slice(0, 5), "data-" !== b && "aria-" !== b) return;
	    }
	    a.push(H, u(c), I, u(C(d)), E);
	  }
	}
	var K = w(">"),
	  Ka = w("/>");
	function L(a, b, c) {
	  if (null != b) {
	    if (null != c) throw Error(k(60));
	    if ("object" !== typeof b || !("__html" in b)) throw Error(k(61));
	    b = b.__html;
	    null !== b && void 0 !== b && a.push(u("" + b));
	  }
	}
	function La(a) {
	  var b = "";
	  aa.Children.forEach(a, function (a) {
	    null != a && (b += a);
	  });
	  return b;
	}
	var Ma = w(' selected=""');
	function Na(a, b, c, d) {
	  a.push(M(c));
	  var f = c = null,
	    e;
	  for (e in b) if (x.call(b, e)) {
	    var g = b[e];
	    if (null != g) switch (e) {
	      case "children":
	        c = g;
	        break;
	      case "dangerouslySetInnerHTML":
	        f = g;
	        break;
	      default:
	        J(a, d, e, g);
	    }
	  }
	  a.push(K);
	  L(a, f, c);
	  return "string" === typeof c ? (a.push(u(C(c))), null) : c;
	}
	var Oa = w("\n"),
	  Pa = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/,
	  Qa = new Map();
	function M(a) {
	  var b = Qa.get(a);
	  if (void 0 === b) {
	    if (!Pa.test(a)) throw Error(k(65, a));
	    b = w("<" + a);
	    Qa.set(a, b);
	  }
	  return b;
	}
	var Ra = w("<!DOCTYPE html>");
	function Sa(a, b, c, d, f) {
	  switch (b) {
	    case "select":
	      a.push(M("select"));
	      var e = null,
	        g = null;
	      for (r in c) if (x.call(c, r)) {
	        var h = c[r];
	        if (null != h) switch (r) {
	          case "children":
	            e = h;
	            break;
	          case "dangerouslySetInnerHTML":
	            g = h;
	            break;
	          case "defaultValue":
	          case "value":
	            break;
	          default:
	            J(a, d, r, h);
	        }
	      }
	      a.push(K);
	      L(a, g, e);
	      return e;
	    case "option":
	      g = f.selectedValue;
	      a.push(M("option"));
	      var m = h = null,
	        q = null;
	      var r = null;
	      for (e in c) if (x.call(c, e)) {
	        var v = c[e];
	        if (null != v) switch (e) {
	          case "children":
	            h = v;
	            break;
	          case "selected":
	            q = v;
	            break;
	          case "dangerouslySetInnerHTML":
	            r = v;
	            break;
	          case "value":
	            m = v;
	          default:
	            J(a, d, e, v);
	        }
	      }
	      if (null != g) {
	        if (c = null !== m ? "" + m : La(h), ra(g)) for (d = 0; d < g.length; d++) {
	          if ("" + g[d] === c) {
	            a.push(Ma);
	            break;
	          }
	        } else "" + g === c && a.push(Ma);
	      } else q && a.push(Ma);
	      a.push(K);
	      L(a, r, h);
	      return h;
	    case "textarea":
	      a.push(M("textarea"));
	      r = g = e = null;
	      for (h in c) if (x.call(c, h) && (m = c[h], null != m)) switch (h) {
	        case "children":
	          r = m;
	          break;
	        case "value":
	          e = m;
	          break;
	        case "defaultValue":
	          g = m;
	          break;
	        case "dangerouslySetInnerHTML":
	          throw Error(k(91));
	        default:
	          J(a, d, h, m);
	      }
	      null === e && null !== g && (e = g);
	      a.push(K);
	      if (null != r) {
	        if (null != e) throw Error(k(92));
	        if (ra(r) && 1 < r.length) throw Error(k(93));
	        e = "" + r;
	      }
	      "string" === typeof e && "\n" === e[0] && a.push(Oa);
	      null !== e && a.push(u(C("" + e)));
	      return null;
	    case "input":
	      a.push(M("input"));
	      m = r = h = e = null;
	      for (g in c) if (x.call(c, g) && (q = c[g], null != q)) switch (g) {
	        case "children":
	        case "dangerouslySetInnerHTML":
	          throw Error(k(399, "input"));
	        case "defaultChecked":
	          m = q;
	          break;
	        case "defaultValue":
	          h = q;
	          break;
	        case "checked":
	          r = q;
	          break;
	        case "value":
	          e = q;
	          break;
	        default:
	          J(a, d, g, q);
	      }
	      null !== r ? J(a, d, "checked", r) : null !== m && J(a, d, "checked", m);
	      null !== e ? J(a, d, "value", e) : null !== h && J(a, d, "value", h);
	      a.push(Ka);
	      return null;
	    case "menuitem":
	      a.push(M("menuitem"));
	      for (var A in c) if (x.call(c, A) && (e = c[A], null != e)) switch (A) {
	        case "children":
	        case "dangerouslySetInnerHTML":
	          throw Error(k(400));
	        default:
	          J(a, d, A, e);
	      }
	      a.push(K);
	      return null;
	    case "title":
	      a.push(M("title"));
	      e = null;
	      for (v in c) if (x.call(c, v) && (g = c[v], null != g)) switch (v) {
	        case "children":
	          e = g;
	          break;
	        case "dangerouslySetInnerHTML":
	          throw Error(k(434));
	        default:
	          J(a, d, v, g);
	      }
	      a.push(K);
	      return e;
	    case "listing":
	    case "pre":
	      a.push(M(b));
	      g = e = null;
	      for (m in c) if (x.call(c, m) && (h = c[m], null != h)) switch (m) {
	        case "children":
	          e = h;
	          break;
	        case "dangerouslySetInnerHTML":
	          g = h;
	          break;
	        default:
	          J(a, d, m, h);
	      }
	      a.push(K);
	      if (null != g) {
	        if (null != e) throw Error(k(60));
	        if ("object" !== typeof g || !("__html" in g)) throw Error(k(61));
	        c = g.__html;
	        null !== c && void 0 !== c && ("string" === typeof c && 0 < c.length && "\n" === c[0] ? a.push(Oa, u(c)) : a.push(u("" + c)));
	      }
	      "string" === typeof e && "\n" === e[0] && a.push(Oa);
	      return e;
	    case "area":
	    case "base":
	    case "br":
	    case "col":
	    case "embed":
	    case "hr":
	    case "img":
	    case "keygen":
	    case "link":
	    case "meta":
	    case "param":
	    case "source":
	    case "track":
	    case "wbr":
	      a.push(M(b));
	      for (var F in c) if (x.call(c, F) && (e = c[F], null != e)) switch (F) {
	        case "children":
	        case "dangerouslySetInnerHTML":
	          throw Error(k(399, b));
	        default:
	          J(a, d, F, e);
	      }
	      a.push(Ka);
	      return null;
	    case "annotation-xml":
	    case "color-profile":
	    case "font-face":
	    case "font-face-src":
	    case "font-face-uri":
	    case "font-face-format":
	    case "font-face-name":
	    case "missing-glyph":
	      return Na(a, c, b, d);
	    case "html":
	      return 0 === f.insertionMode && a.push(Ra), Na(a, c, b, d);
	    default:
	      if (-1 === b.indexOf("-") && "string" !== typeof c.is) return Na(a, c, b, d);
	      a.push(M(b));
	      g = e = null;
	      for (q in c) if (x.call(c, q) && (h = c[q], null != h)) switch (q) {
	        case "children":
	          e = h;
	          break;
	        case "dangerouslySetInnerHTML":
	          g = h;
	          break;
	        case "style":
	          Ia(a, d, h);
	          break;
	        case "suppressContentEditableWarning":
	        case "suppressHydrationWarning":
	          break;
	        default:
	          ia(q) && "function" !== typeof h && "symbol" !== typeof h && a.push(H, u(q), I, u(C(h)), E);
	      }
	      a.push(K);
	      L(a, g, e);
	      return e;
	  }
	}
	var Ta = w("</"),
	  Ua = w(">"),
	  Va = w('<template id="'),
	  Wa = w('"></template>'),
	  Xa = w("\x3c!--$--\x3e"),
	  Ya = w('\x3c!--$?--\x3e<template id="'),
	  Za = w('"></template>'),
	  $a = w("\x3c!--$!--\x3e"),
	  ab = w("\x3c!--/$--\x3e"),
	  bb = w("<template"),
	  cb = w('"'),
	  db = w(' data-dgst="');
	w(' data-msg="');
	w(' data-stck="');
	var eb = w("></template>");
	function fb(a, b, c) {
	  p(a, Ya);
	  if (null === c) throw Error(k(395));
	  p(a, c);
	  return t(a, Za);
	}
	var gb = w('<div hidden id="'),
	  hb = w('">'),
	  ib = w("</div>"),
	  jb = w('<svg aria-hidden="true" style="display:none" id="'),
	  kb = w('">'),
	  lb = w("</svg>"),
	  mb = w('<math aria-hidden="true" style="display:none" id="'),
	  nb = w('">'),
	  ob = w("</math>"),
	  pb = w('<table hidden id="'),
	  qb = w('">'),
	  rb = w("</table>"),
	  sb = w('<table hidden><tbody id="'),
	  tb = w('">'),
	  ub = w("</tbody></table>"),
	  vb = w('<table hidden><tr id="'),
	  wb = w('">'),
	  xb = w("</tr></table>"),
	  yb = w('<table hidden><colgroup id="'),
	  zb = w('">'),
	  Ab = w("</colgroup></table>");
	function Bb(a, b, c, d) {
	  switch (c.insertionMode) {
	    case 0:
	    case 1:
	      return p(a, gb), p(a, b.segmentPrefix), p(a, u(d.toString(16))), t(a, hb);
	    case 2:
	      return p(a, jb), p(a, b.segmentPrefix), p(a, u(d.toString(16))), t(a, kb);
	    case 3:
	      return p(a, mb), p(a, b.segmentPrefix), p(a, u(d.toString(16))), t(a, nb);
	    case 4:
	      return p(a, pb), p(a, b.segmentPrefix), p(a, u(d.toString(16))), t(a, qb);
	    case 5:
	      return p(a, sb), p(a, b.segmentPrefix), p(a, u(d.toString(16))), t(a, tb);
	    case 6:
	      return p(a, vb), p(a, b.segmentPrefix), p(a, u(d.toString(16))), t(a, wb);
	    case 7:
	      return p(a, yb), p(a, b.segmentPrefix), p(a, u(d.toString(16))), t(a, zb);
	    default:
	      throw Error(k(397));
	  }
	}
	function Cb(a, b) {
	  switch (b.insertionMode) {
	    case 0:
	    case 1:
	      return t(a, ib);
	    case 2:
	      return t(a, lb);
	    case 3:
	      return t(a, ob);
	    case 4:
	      return t(a, rb);
	    case 5:
	      return t(a, ub);
	    case 6:
	      return t(a, xb);
	    case 7:
	      return t(a, Ab);
	    default:
	      throw Error(k(397));
	  }
	}
	var Db = w('function $RS(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)};$RS("'),
	  Eb = w('$RS("'),
	  Gb = w('","'),
	  Hb = w('")\x3c/script>'),
	  Ib = w('function $RC(a,b){a=document.getElementById(a);b=document.getElementById(b);b.parentNode.removeChild(b);if(a){a=a.previousSibling;var f=a.parentNode,c=a.nextSibling,e=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d)if(0===e)break;else e--;else"$"!==d&&"$?"!==d&&"$!"!==d||e++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;b.firstChild;)f.insertBefore(b.firstChild,c);a.data="$";a._reactRetry&&a._reactRetry()}};$RC("'),
	  Jb = w('$RC("'),
	  Kb = w('","'),
	  Lb = w('")\x3c/script>'),
	  Mb = w('function $RX(b,c,d,e){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),b._reactRetry&&b._reactRetry())};$RX("'),
	  Nb = w('$RX("'),
	  Ob = w('"'),
	  Pb = w(")\x3c/script>"),
	  Qb = w(","),
	  Rb = /[<\u2028\u2029]/g;
	function Sb(a) {
	  return JSON.stringify(a).replace(Rb, function (a) {
	    switch (a) {
	      case "<":
	        return "\\u003c";
	      case "\u2028":
	        return "\\u2028";
	      case "\u2029":
	        return "\\u2029";
	      default:
	        throw Error("escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
	    }
	  });
	}
	var N = Object.assign,
	  Tb = Symbol.for("react.element"),
	  Ub = Symbol.for("react.portal"),
	  Vb = Symbol.for("react.fragment"),
	  Wb = Symbol.for("react.strict_mode"),
	  Xb = Symbol.for("react.profiler"),
	  Yb = Symbol.for("react.provider"),
	  Zb = Symbol.for("react.context"),
	  $b = Symbol.for("react.forward_ref"),
	  ac = Symbol.for("react.suspense"),
	  bc = Symbol.for("react.suspense_list"),
	  cc = Symbol.for("react.memo"),
	  dc = Symbol.for("react.lazy"),
	  ec = Symbol.for("react.scope"),
	  fc = Symbol.for("react.debug_trace_mode"),
	  gc = Symbol.for("react.legacy_hidden"),
	  hc = Symbol.for("react.default_value"),
	  ic = Symbol.iterator;
	function jc(a) {
	  if (null == a) return null;
	  if ("function" === typeof a) return a.displayName || a.name || null;
	  if ("string" === typeof a) return a;
	  switch (a) {
	    case Vb:
	      return "Fragment";
	    case Ub:
	      return "Portal";
	    case Xb:
	      return "Profiler";
	    case Wb:
	      return "StrictMode";
	    case ac:
	      return "Suspense";
	    case bc:
	      return "SuspenseList";
	  }
	  if ("object" === typeof a) switch (a.$$typeof) {
	    case Zb:
	      return (a.displayName || "Context") + ".Consumer";
	    case Yb:
	      return (a._context.displayName || "Context") + ".Provider";
	    case $b:
	      var b = a.render;
	      a = a.displayName;
	      a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
	      return a;
	    case cc:
	      return b = a.displayName || null, null !== b ? b : jc(a.type) || "Memo";
	    case dc:
	      b = a._payload;
	      a = a._init;
	      try {
	        return jc(a(b));
	      } catch (c) {}
	  }
	  return null;
	}
	var kc = {};
	function lc(a, b) {
	  a = a.contextTypes;
	  if (!a) return kc;
	  var c = {},
	    d;
	  for (d in a) c[d] = b[d];
	  return c;
	}
	var O = null;
	function P(a, b) {
	  if (a !== b) {
	    a.context._currentValue = a.parentValue;
	    a = a.parent;
	    var c = b.parent;
	    if (null === a) {
	      if (null !== c) throw Error(k(401));
	    } else {
	      if (null === c) throw Error(k(401));
	      P(a, c);
	    }
	    b.context._currentValue = b.value;
	  }
	}
	function mc(a) {
	  a.context._currentValue = a.parentValue;
	  a = a.parent;
	  null !== a && mc(a);
	}
	function nc(a) {
	  var b = a.parent;
	  null !== b && nc(b);
	  a.context._currentValue = a.value;
	}
	function oc(a, b) {
	  a.context._currentValue = a.parentValue;
	  a = a.parent;
	  if (null === a) throw Error(k(402));
	  a.depth === b.depth ? P(a, b) : oc(a, b);
	}
	function pc(a, b) {
	  var c = b.parent;
	  if (null === c) throw Error(k(402));
	  a.depth === c.depth ? P(a, c) : pc(a, c);
	  b.context._currentValue = b.value;
	}
	function Q(a) {
	  var b = O;
	  b !== a && (null === b ? nc(a) : null === a ? mc(b) : b.depth === a.depth ? P(b, a) : b.depth > a.depth ? oc(b, a) : pc(b, a), O = a);
	}
	var qc = {
	  isMounted: function () {
	    return false;
	  },
	  enqueueSetState: function (a, b) {
	    a = a._reactInternals;
	    null !== a.queue && a.queue.push(b);
	  },
	  enqueueReplaceState: function (a, b) {
	    a = a._reactInternals;
	    a.replace = true;
	    a.queue = [b];
	  },
	  enqueueForceUpdate: function () {}
	};
	function rc(a, b, c, d) {
	  var f = void 0 !== a.state ? a.state : null;
	  a.updater = qc;
	  a.props = c;
	  a.state = f;
	  var e = {
	    queue: [],
	    replace: false
	  };
	  a._reactInternals = e;
	  var g = b.contextType;
	  a.context = "object" === typeof g && null !== g ? g._currentValue : d;
	  g = b.getDerivedStateFromProps;
	  "function" === typeof g && (g = g(c, f), f = null === g || void 0 === g ? f : N({}, f, g), a.state = f);
	  if ("function" !== typeof b.getDerivedStateFromProps && "function" !== typeof a.getSnapshotBeforeUpdate && ("function" === typeof a.UNSAFE_componentWillMount || "function" === typeof a.componentWillMount)) if (b = a.state, "function" === typeof a.componentWillMount && a.componentWillMount(), "function" === typeof a.UNSAFE_componentWillMount && a.UNSAFE_componentWillMount(), b !== a.state && qc.enqueueReplaceState(a, a.state, null), null !== e.queue && 0 < e.queue.length) {
	    if (b = e.queue, g = e.replace, e.queue = null, e.replace = false, g && 1 === b.length) a.state = b[0];else {
	      e = g ? b[0] : a.state;
	      f = true;
	      for (g = g ? 1 : 0; g < b.length; g++) {
	        var h = b[g];
	        h = "function" === typeof h ? h.call(a, e, c, d) : h;
	        null != h && (f ? (f = false, e = N({}, e, h)) : N(e, h));
	      }
	      a.state = e;
	    }
	  } else e.queue = null;
	}
	var sc = {
	  id: 1,
	  overflow: ""
	};
	function tc(a, b, c) {
	  var d = a.id;
	  a = a.overflow;
	  var f = 32 - uc(d) - 1;
	  d &= ~(1 << f);
	  c += 1;
	  var e = 32 - uc(b) + f;
	  if (30 < e) {
	    var g = f - f % 5;
	    e = (d & (1 << g) - 1).toString(32);
	    d >>= g;
	    f -= g;
	    return {
	      id: 1 << 32 - uc(b) + f | c << f | d,
	      overflow: e + a
	    };
	  }
	  return {
	    id: 1 << e | c << f | d,
	    overflow: a
	  };
	}
	var uc = Math.clz32 ? Math.clz32 : vc,
	  wc = Math.log,
	  xc = Math.LN2;
	function vc(a) {
	  a >>>= 0;
	  return 0 === a ? 32 : 31 - (wc(a) / xc | 0) | 0;
	}
	function yc(a, b) {
	  return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
	}
	var zc = "function" === typeof Object.is ? Object.is : yc,
	  R = null,
	  Ac = null,
	  Bc = null,
	  S = null,
	  T = false,
	  Cc = false,
	  U = 0,
	  V = null,
	  Dc = 0;
	function W() {
	  if (null === R) throw Error(k(321));
	  return R;
	}
	function Ec() {
	  if (0 < Dc) throw Error(k(312));
	  return {
	    memoizedState: null,
	    queue: null,
	    next: null
	  };
	}
	function Fc() {
	  null === S ? null === Bc ? (T = false, Bc = S = Ec()) : (T = true, S = Bc) : null === S.next ? (T = false, S = S.next = Ec()) : (T = true, S = S.next);
	  return S;
	}
	function Gc() {
	  Ac = R = null;
	  Cc = false;
	  Bc = null;
	  Dc = 0;
	  S = V = null;
	}
	function Hc(a, b) {
	  return "function" === typeof b ? b(a) : b;
	}
	function Ic(a, b, c) {
	  R = W();
	  S = Fc();
	  if (T) {
	    var d = S.queue;
	    b = d.dispatch;
	    if (null !== V && (c = V.get(d), void 0 !== c)) {
	      V.delete(d);
	      d = S.memoizedState;
	      do d = a(d, c.action), c = c.next; while (null !== c);
	      S.memoizedState = d;
	      return [d, b];
	    }
	    return [S.memoizedState, b];
	  }
	  a = a === Hc ? "function" === typeof b ? b() : b : void 0 !== c ? c(b) : b;
	  S.memoizedState = a;
	  a = S.queue = {
	    last: null,
	    dispatch: null
	  };
	  a = a.dispatch = Jc.bind(null, R, a);
	  return [S.memoizedState, a];
	}
	function Kc(a, b) {
	  R = W();
	  S = Fc();
	  b = void 0 === b ? null : b;
	  if (null !== S) {
	    var c = S.memoizedState;
	    if (null !== c && null !== b) {
	      var d = c[1];
	      a: if (null === d) d = false;else {
	        for (var f = 0; f < d.length && f < b.length; f++) if (!zc(b[f], d[f])) {
	          d = false;
	          break a;
	        }
	        d = true;
	      }
	      if (d) return c[0];
	    }
	  }
	  a = a();
	  S.memoizedState = [a, b];
	  return a;
	}
	function Jc(a, b, c) {
	  if (25 <= Dc) throw Error(k(301));
	  if (a === R) if (Cc = true, a = {
	    action: c,
	    next: null
	  }, null === V && (V = new Map()), c = V.get(b), void 0 === c) V.set(b, a);else {
	    for (b = c; null !== b.next;) b = b.next;
	    b.next = a;
	  }
	}
	function Lc() {
	  throw Error(k(394));
	}
	function Mc() {}
	var Oc = {
	    readContext: function (a) {
	      return a._currentValue;
	    },
	    useContext: function (a) {
	      W();
	      return a._currentValue;
	    },
	    useMemo: Kc,
	    useReducer: Ic,
	    useRef: function (a) {
	      R = W();
	      S = Fc();
	      var b = S.memoizedState;
	      return null === b ? (a = {
	        current: a
	      }, S.memoizedState = a) : b;
	    },
	    useState: function (a) {
	      return Ic(Hc, a);
	    },
	    useInsertionEffect: Mc,
	    useLayoutEffect: function () {},
	    useCallback: function (a, b) {
	      return Kc(function () {
	        return a;
	      }, b);
	    },
	    useImperativeHandle: Mc,
	    useEffect: Mc,
	    useDebugValue: Mc,
	    useDeferredValue: function (a) {
	      W();
	      return a;
	    },
	    useTransition: function () {
	      W();
	      return [false, Lc];
	    },
	    useId: function () {
	      var a = Ac.treeContext;
	      var b = a.overflow;
	      a = a.id;
	      a = (a & ~(1 << 32 - uc(a) - 1)).toString(32) + b;
	      var c = Nc;
	      if (null === c) throw Error(k(404));
	      b = U++;
	      a = ":" + c.idPrefix + "R" + a;
	      0 < b && (a += "H" + b.toString(32));
	      return a + ":";
	    },
	    useMutableSource: function (a, b) {
	      W();
	      return b(a._source);
	    },
	    useSyncExternalStore: function (a, b, c) {
	      if (void 0 === c) throw Error(k(407));
	      return c();
	    }
	  },
	  Nc = null,
	  Pc = aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentDispatcher;
	function Qc(a) {
	  console.error(a);
	  return null;
	}
	function X() {}
	function Rc(a, b, c, d, f, e, g, h, m) {
	  var q = [],
	    r = new Set();
	  b = {
	    destination: null,
	    responseState: b,
	    progressiveChunkSize: void 0 === d ? 12800 : d,
	    status: 0,
	    fatalError: null,
	    nextSegmentId: 0,
	    allPendingTasks: 0,
	    pendingRootTasks: 0,
	    completedRootSegment: null,
	    abortableTasks: r,
	    pingedTasks: q,
	    clientRenderedBoundaries: [],
	    completedBoundaries: [],
	    partialBoundaries: [],
	    onError: void 0 === f ? Qc : f,
	    onAllReady: void 0 === e ? X : e,
	    onShellReady: void 0 === g ? X : g,
	    onShellError: void 0 === h ? X : h,
	    onFatalError: void 0 === m ? X : m
	  };
	  c = Sc(b, 0, null, c, false, false);
	  c.parentFlushed = true;
	  a = Tc(b, a, null, c, r, kc, null, sc);
	  q.push(a);
	  return b;
	}
	function Tc(a, b, c, d, f, e, g, h) {
	  a.allPendingTasks++;
	  null === c ? a.pendingRootTasks++ : c.pendingTasks++;
	  var m = {
	    node: b,
	    ping: function () {
	      var b = a.pingedTasks;
	      b.push(m);
	      1 === b.length && Uc(a);
	    },
	    blockedBoundary: c,
	    blockedSegment: d,
	    abortSet: f,
	    legacyContext: e,
	    context: g,
	    treeContext: h
	  };
	  f.add(m);
	  return m;
	}
	function Sc(a, b, c, d, f, e) {
	  return {
	    status: 0,
	    id: -1,
	    index: b,
	    parentFlushed: false,
	    chunks: [],
	    children: [],
	    formatContext: d,
	    boundary: c,
	    lastPushedText: f,
	    textEmbedded: e
	  };
	}
	function Y(a, b) {
	  a = a.onError(b);
	  if (null != a && "string" !== typeof a) throw Error('onError returned something with a type other than "string". onError should return a string and may return null or undefined but must not return anything else. It received something of type "' + typeof a + '" instead');
	  return a;
	}
	function Vc(a, b) {
	  var c = a.onShellError;
	  c(b);
	  c = a.onFatalError;
	  c(b);
	  null !== a.destination ? (a.status = 2, da(a.destination, b)) : (a.status = 1, a.fatalError = b);
	}
	function Wc(a, b, c, d, f) {
	  R = {};
	  Ac = b;
	  U = 0;
	  for (a = c(d, f); Cc;) Cc = false, U = 0, Dc += 1, S = null, a = c(d, f);
	  Gc();
	  return a;
	}
	function Xc(a, b, c, d) {
	  var f = c.render(),
	    e = d.childContextTypes;
	  if (null !== e && void 0 !== e) {
	    var g = b.legacyContext;
	    if ("function" !== typeof c.getChildContext) d = g;else {
	      c = c.getChildContext();
	      for (var h in c) if (!(h in e)) throw Error(k(108, jc(d) || "Unknown", h));
	      d = N({}, g, c);
	    }
	    b.legacyContext = d;
	    Z(a, b, f);
	    b.legacyContext = g;
	  } else Z(a, b, f);
	}
	function Yc(a, b) {
	  if (a && a.defaultProps) {
	    b = N({}, b);
	    a = a.defaultProps;
	    for (var c in a) void 0 === b[c] && (b[c] = a[c]);
	    return b;
	  }
	  return b;
	}
	function Zc(a, b, c, d, f) {
	  if ("function" === typeof c) {
	    if (c.prototype && c.prototype.isReactComponent) {
	      f = lc(c, b.legacyContext);
	      var e = c.contextType;
	      e = new c(d, "object" === typeof e && null !== e ? e._currentValue : f);
	      rc(e, c, d, f);
	      Xc(a, b, e, c);
	    } else {
	      e = lc(c, b.legacyContext);
	      f = Wc(a, b, c, d, e);
	      var g = 0 !== U;
	      if ("object" === typeof f && null !== f && "function" === typeof f.render && void 0 === f.$$typeof) rc(f, c, d, e), Xc(a, b, f, c);else if (g) {
	        d = b.treeContext;
	        b.treeContext = tc(d, 1, 0);
	        try {
	          Z(a, b, f);
	        } finally {
	          b.treeContext = d;
	        }
	      } else Z(a, b, f);
	    }
	  } else if ("string" === typeof c) {
	    f = b.blockedSegment;
	    e = Sa(f.chunks, c, d, a.responseState, f.formatContext);
	    f.lastPushedText = false;
	    g = f.formatContext;
	    f.formatContext = Ba(g, c, d);
	    $c(a, b, e);
	    f.formatContext = g;
	    switch (c) {
	      case "area":
	      case "base":
	      case "br":
	      case "col":
	      case "embed":
	      case "hr":
	      case "img":
	      case "input":
	      case "keygen":
	      case "link":
	      case "meta":
	      case "param":
	      case "source":
	      case "track":
	      case "wbr":
	        break;
	      default:
	        f.chunks.push(Ta, u(c), Ua);
	    }
	    f.lastPushedText = false;
	  } else {
	    switch (c) {
	      case gc:
	      case fc:
	      case Wb:
	      case Xb:
	      case Vb:
	        Z(a, b, d.children);
	        return;
	      case bc:
	        Z(a, b, d.children);
	        return;
	      case ec:
	        throw Error(k(343));
	      case ac:
	        a: {
	          c = b.blockedBoundary;
	          f = b.blockedSegment;
	          e = d.fallback;
	          d = d.children;
	          g = new Set();
	          var h = {
	              id: null,
	              rootSegmentID: -1,
	              parentFlushed: false,
	              pendingTasks: 0,
	              forceClientRender: false,
	              completedSegments: [],
	              byteSize: 0,
	              fallbackAbortableTasks: g,
	              errorDigest: null
	            },
	            m = Sc(a, f.chunks.length, h, f.formatContext, false, false);
	          f.children.push(m);
	          f.lastPushedText = false;
	          var q = Sc(a, 0, null, f.formatContext, false, false);
	          q.parentFlushed = true;
	          b.blockedBoundary = h;
	          b.blockedSegment = q;
	          try {
	            if ($c(a, b, d), q.lastPushedText && q.textEmbedded && q.chunks.push(Ca), q.status = 1, ad(h, q), 0 === h.pendingTasks) break a;
	          } catch (r) {
	            q.status = 4, h.forceClientRender = true, h.errorDigest = Y(a, r);
	          } finally {
	            b.blockedBoundary = c, b.blockedSegment = f;
	          }
	          b = Tc(a, e, c, m, g, b.legacyContext, b.context, b.treeContext);
	          a.pingedTasks.push(b);
	        }
	        return;
	    }
	    if ("object" === typeof c && null !== c) switch (c.$$typeof) {
	      case $b:
	        d = Wc(a, b, c.render, d, f);
	        if (0 !== U) {
	          c = b.treeContext;
	          b.treeContext = tc(c, 1, 0);
	          try {
	            Z(a, b, d);
	          } finally {
	            b.treeContext = c;
	          }
	        } else Z(a, b, d);
	        return;
	      case cc:
	        c = c.type;
	        d = Yc(c, d);
	        Zc(a, b, c, d, f);
	        return;
	      case Yb:
	        f = d.children;
	        c = c._context;
	        d = d.value;
	        e = c._currentValue;
	        c._currentValue = d;
	        g = O;
	        O = d = {
	          parent: g,
	          depth: null === g ? 0 : g.depth + 1,
	          context: c,
	          parentValue: e,
	          value: d
	        };
	        b.context = d;
	        Z(a, b, f);
	        a = O;
	        if (null === a) throw Error(k(403));
	        d = a.parentValue;
	        a.context._currentValue = d === hc ? a.context._defaultValue : d;
	        a = O = a.parent;
	        b.context = a;
	        return;
	      case Zb:
	        d = d.children;
	        d = d(c._currentValue);
	        Z(a, b, d);
	        return;
	      case dc:
	        f = c._init;
	        c = f(c._payload);
	        d = Yc(c, d);
	        Zc(a, b, c, d, void 0);
	        return;
	    }
	    throw Error(k(130, null == c ? c : typeof c, ""));
	  }
	}
	function Z(a, b, c) {
	  b.node = c;
	  if ("object" === typeof c && null !== c) {
	    switch (c.$$typeof) {
	      case Tb:
	        Zc(a, b, c.type, c.props, c.ref);
	        return;
	      case Ub:
	        throw Error(k(257));
	      case dc:
	        var d = c._init;
	        c = d(c._payload);
	        Z(a, b, c);
	        return;
	    }
	    if (ra(c)) {
	      bd(a, b, c);
	      return;
	    }
	    null === c || "object" !== typeof c ? d = null : (d = ic && c[ic] || c["@@iterator"], d = "function" === typeof d ? d : null);
	    if (d && (d = d.call(c))) {
	      c = d.next();
	      if (!c.done) {
	        var f = [];
	        do f.push(c.value), c = d.next(); while (!c.done);
	        bd(a, b, f);
	      }
	      return;
	    }
	    a = Object.prototype.toString.call(c);
	    throw Error(k(31, "[object Object]" === a ? "object with keys {" + Object.keys(c).join(", ") + "}" : a));
	  }
	  "string" === typeof c ? (d = b.blockedSegment, d.lastPushedText = Da(b.blockedSegment.chunks, c, a.responseState, d.lastPushedText)) : "number" === typeof c && (d = b.blockedSegment, d.lastPushedText = Da(b.blockedSegment.chunks, "" + c, a.responseState, d.lastPushedText));
	}
	function bd(a, b, c) {
	  for (var d = c.length, f = 0; f < d; f++) {
	    var e = b.treeContext;
	    b.treeContext = tc(e, d, f);
	    try {
	      $c(a, b, c[f]);
	    } finally {
	      b.treeContext = e;
	    }
	  }
	}
	function $c(a, b, c) {
	  var d = b.blockedSegment.formatContext,
	    f = b.legacyContext,
	    e = b.context;
	  try {
	    return Z(a, b, c);
	  } catch (m) {
	    if (Gc(), "object" === typeof m && null !== m && "function" === typeof m.then) {
	      c = m;
	      var g = b.blockedSegment,
	        h = Sc(a, g.chunks.length, null, g.formatContext, g.lastPushedText, true);
	      g.children.push(h);
	      g.lastPushedText = false;
	      a = Tc(a, b.node, b.blockedBoundary, h, b.abortSet, b.legacyContext, b.context, b.treeContext).ping;
	      c.then(a, a);
	      b.blockedSegment.formatContext = d;
	      b.legacyContext = f;
	      b.context = e;
	      Q(e);
	    } else throw b.blockedSegment.formatContext = d, b.legacyContext = f, b.context = e, Q(e), m;
	  }
	}
	function cd(a) {
	  var b = a.blockedBoundary;
	  a = a.blockedSegment;
	  a.status = 3;
	  dd(this, b, a);
	}
	function ed(a, b, c) {
	  var d = a.blockedBoundary;
	  a.blockedSegment.status = 3;
	  null === d ? (b.allPendingTasks--, 2 !== b.status && (b.status = 2, null !== b.destination && b.destination.close())) : (d.pendingTasks--, d.forceClientRender || (d.forceClientRender = true, a = void 0 === c ? Error(k(432)) : c, d.errorDigest = b.onError(a), d.parentFlushed && b.clientRenderedBoundaries.push(d)), d.fallbackAbortableTasks.forEach(function (a) {
	    return ed(a, b, c);
	  }), d.fallbackAbortableTasks.clear(), b.allPendingTasks--, 0 === b.allPendingTasks && (d = b.onAllReady, d()));
	}
	function ad(a, b) {
	  if (0 === b.chunks.length && 1 === b.children.length && null === b.children[0].boundary) {
	    var c = b.children[0];
	    c.id = b.id;
	    c.parentFlushed = true;
	    1 === c.status && ad(a, c);
	  } else a.completedSegments.push(b);
	}
	function dd(a, b, c) {
	  if (null === b) {
	    if (c.parentFlushed) {
	      if (null !== a.completedRootSegment) throw Error(k(389));
	      a.completedRootSegment = c;
	    }
	    a.pendingRootTasks--;
	    0 === a.pendingRootTasks && (a.onShellError = X, b = a.onShellReady, b());
	  } else b.pendingTasks--, b.forceClientRender || (0 === b.pendingTasks ? (c.parentFlushed && 1 === c.status && ad(b, c), b.parentFlushed && a.completedBoundaries.push(b), b.fallbackAbortableTasks.forEach(cd, a), b.fallbackAbortableTasks.clear()) : c.parentFlushed && 1 === c.status && (ad(b, c), 1 === b.completedSegments.length && b.parentFlushed && a.partialBoundaries.push(b)));
	  a.allPendingTasks--;
	  0 === a.allPendingTasks && (a = a.onAllReady, a());
	}
	function Uc(a) {
	  if (2 !== a.status) {
	    var b = O,
	      c = Pc.current;
	    Pc.current = Oc;
	    var d = Nc;
	    Nc = a.responseState;
	    try {
	      var f = a.pingedTasks,
	        e;
	      for (e = 0; e < f.length; e++) {
	        var g = f[e];
	        var h = a,
	          m = g.blockedSegment;
	        if (0 === m.status) {
	          Q(g.context);
	          try {
	            Z(h, g, g.node), m.lastPushedText && m.textEmbedded && m.chunks.push(Ca), g.abortSet.delete(g), m.status = 1, dd(h, g.blockedBoundary, m);
	          } catch (G) {
	            if (Gc(), "object" === typeof G && null !== G && "function" === typeof G.then) {
	              var q = g.ping;
	              G.then(q, q);
	            } else {
	              g.abortSet.delete(g);
	              m.status = 4;
	              var r = g.blockedBoundary,
	                v = G,
	                A = Y(h, v);
	              null === r ? Vc(h, v) : (r.pendingTasks--, r.forceClientRender || (r.forceClientRender = !0, r.errorDigest = A, r.parentFlushed && h.clientRenderedBoundaries.push(r)));
	              h.allPendingTasks--;
	              if (0 === h.allPendingTasks) {
	                var F = h.onAllReady;
	                F();
	              }
	            }
	          } finally {}
	        }
	      }
	      f.splice(0, e);
	      null !== a.destination && fd(a, a.destination);
	    } catch (G) {
	      Y(a, G), Vc(a, G);
	    } finally {
	      Nc = d, Pc.current = c, c === Oc && Q(b);
	    }
	  }
	}
	function gd(a, b, c) {
	  c.parentFlushed = true;
	  switch (c.status) {
	    case 0:
	      var d = c.id = a.nextSegmentId++;
	      c.lastPushedText = false;
	      c.textEmbedded = false;
	      a = a.responseState;
	      p(b, Va);
	      p(b, a.placeholderPrefix);
	      a = u(d.toString(16));
	      p(b, a);
	      return t(b, Wa);
	    case 1:
	      c.status = 2;
	      var f = true;
	      d = c.chunks;
	      var e = 0;
	      c = c.children;
	      for (var g = 0; g < c.length; g++) {
	        for (f = c[g]; e < f.index; e++) p(b, d[e]);
	        f = hd(a, b, f);
	      }
	      for (; e < d.length - 1; e++) p(b, d[e]);
	      e < d.length && (f = t(b, d[e]));
	      return f;
	    default:
	      throw Error(k(390));
	  }
	}
	function hd(a, b, c) {
	  var d = c.boundary;
	  if (null === d) return gd(a, b, c);
	  d.parentFlushed = true;
	  if (d.forceClientRender) d = d.errorDigest, t(b, $a), p(b, bb), d && (p(b, db), p(b, u(C(d))), p(b, cb)), t(b, eb), gd(a, b, c);else if (0 < d.pendingTasks) {
	    d.rootSegmentID = a.nextSegmentId++;
	    0 < d.completedSegments.length && a.partialBoundaries.push(d);
	    var f = a.responseState;
	    var e = f.nextSuspenseID++;
	    f = w(f.boundaryPrefix + e.toString(16));
	    d = d.id = f;
	    fb(b, a.responseState, d);
	    gd(a, b, c);
	  } else if (d.byteSize > a.progressiveChunkSize) d.rootSegmentID = a.nextSegmentId++, a.completedBoundaries.push(d), fb(b, a.responseState, d.id), gd(a, b, c);else {
	    t(b, Xa);
	    c = d.completedSegments;
	    if (1 !== c.length) throw Error(k(391));
	    hd(a, b, c[0]);
	  }
	  return t(b, ab);
	}
	function id(a, b, c) {
	  Bb(b, a.responseState, c.formatContext, c.id);
	  hd(a, b, c);
	  return Cb(b, c.formatContext);
	}
	function jd(a, b, c) {
	  for (var d = c.completedSegments, f = 0; f < d.length; f++) kd(a, b, c, d[f]);
	  d.length = 0;
	  a = a.responseState;
	  d = c.id;
	  c = c.rootSegmentID;
	  p(b, a.startInlineScript);
	  a.sentCompleteBoundaryFunction ? p(b, Jb) : (a.sentCompleteBoundaryFunction = true, p(b, Ib));
	  if (null === d) throw Error(k(395));
	  c = u(c.toString(16));
	  p(b, d);
	  p(b, Kb);
	  p(b, a.segmentPrefix);
	  p(b, c);
	  return t(b, Lb);
	}
	function kd(a, b, c, d) {
	  if (2 === d.status) return true;
	  var f = d.id;
	  if (-1 === f) {
	    if (-1 === (d.id = c.rootSegmentID)) throw Error(k(392));
	    return id(a, b, d);
	  }
	  id(a, b, d);
	  a = a.responseState;
	  p(b, a.startInlineScript);
	  a.sentCompleteSegmentFunction ? p(b, Eb) : (a.sentCompleteSegmentFunction = true, p(b, Db));
	  p(b, a.segmentPrefix);
	  f = u(f.toString(16));
	  p(b, f);
	  p(b, Gb);
	  p(b, a.placeholderPrefix);
	  p(b, f);
	  return t(b, Hb);
	}
	function fd(a, b) {
	  l = new Uint8Array(512);
	  n = 0;
	  try {
	    var c = a.completedRootSegment;
	    if (null !== c && 0 === a.pendingRootTasks) {
	      hd(a, b, c);
	      a.completedRootSegment = null;
	      var d = a.responseState.bootstrapChunks;
	      for (c = 0; c < d.length - 1; c++) p(b, d[c]);
	      c < d.length && t(b, d[c]);
	    }
	    var f = a.clientRenderedBoundaries,
	      e;
	    for (e = 0; e < f.length; e++) {
	      var g = f[e];
	      d = b;
	      var h = a.responseState,
	        m = g.id,
	        q = g.errorDigest,
	        r = g.errorMessage,
	        v = g.errorComponentStack;
	      p(d, h.startInlineScript);
	      h.sentClientRenderFunction ? p(d, Nb) : (h.sentClientRenderFunction = !0, p(d, Mb));
	      if (null === m) throw Error(k(395));
	      p(d, m);
	      p(d, Ob);
	      if (q || r || v) p(d, Qb), p(d, u(Sb(q || "")));
	      if (r || v) p(d, Qb), p(d, u(Sb(r || "")));
	      v && (p(d, Qb), p(d, u(Sb(v))));
	      if (!t(d, Pb)) ;
	    }
	    f.splice(0, e);
	    var A = a.completedBoundaries;
	    for (e = 0; e < A.length; e++) if (!jd(a, b, A[e])) ;
	    A.splice(0, e);
	    ba(b);
	    l = new Uint8Array(512);
	    n = 0;
	    var F = a.partialBoundaries;
	    for (e = 0; e < F.length; e++) {
	      var G = F[e];
	      a: {
	        f = a;
	        g = b;
	        var ma = G.completedSegments;
	        for (h = 0; h < ma.length; h++) if (!kd(f, g, G, ma[h])) {
	          h++;
	          ma.splice(0, h);
	          var Fb = !1;
	          break a;
	        }
	        ma.splice(0, h);
	        Fb = !0;
	      }
	      if (!Fb) {
	        a.destination = null;
	        e++;
	        F.splice(0, e);
	        return;
	      }
	    }
	    F.splice(0, e);
	    var na = a.completedBoundaries;
	    for (e = 0; e < na.length; e++) if (!jd(a, b, na[e])) ;
	    na.splice(0, e);
	  } finally {
	    ba(b), 0 === a.allPendingTasks && 0 === a.pingedTasks.length && 0 === a.clientRenderedBoundaries.length && 0 === a.completedBoundaries.length && b.close();
	  }
	}
	function ld(a, b) {
	  try {
	    var c = a.abortableTasks;
	    c.forEach(function (c) {
	      return ed(c, a, b);
	    });
	    c.clear();
	    null !== a.destination && fd(a, a.destination);
	  } catch (d) {
	    Y(a, d), Vc(a, d);
	  }
	}
	reactDomServer_browser_production_min.renderToReadableStream = function (a, b) {
	  return new Promise(function (c, d) {
	    var f,
	      e,
	      g = new Promise(function (a, b) {
	        e = a;
	        f = b;
	      }),
	      h = Rc(a, za(b ? b.identifierPrefix : void 0, b ? b.nonce : void 0, b ? b.bootstrapScriptContent : void 0, b ? b.bootstrapScripts : void 0, b ? b.bootstrapModules : void 0), Aa(b ? b.namespaceURI : void 0), b ? b.progressiveChunkSize : void 0, b ? b.onError : void 0, e, function () {
	        var a = new ReadableStream({
	          type: "bytes",
	          pull: function (a) {
	            if (1 === h.status) h.status = 2, da(a, h.fatalError);else if (2 !== h.status && null === h.destination) {
	              h.destination = a;
	              try {
	                fd(h, a);
	              } catch (A) {
	                Y(h, A), Vc(h, A);
	              }
	            }
	          },
	          cancel: function () {
	            ld(h);
	          }
	        }, {
	          highWaterMark: 0
	        });
	        a.allReady = g;
	        c(a);
	      }, function (a) {
	        g.catch(function () {});
	        d(a);
	      }, f);
	    if (b && b.signal) {
	      var m = b.signal,
	        q = function () {
	          ld(h, m.reason);
	          m.removeEventListener("abort", q);
	        };
	      m.addEventListener("abort", q);
	    }
	    Uc(h);
	  });
	};
	reactDomServer_browser_production_min.version = "18.3.1";
	return reactDomServer_browser_production_min;
}

var reactDomServerLegacy_browser_development = {};

/**
 * @license React
 * react-dom-server-legacy.browser.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactDomServerLegacy_browser_development;

function requireReactDomServerLegacy_browser_development () {
	if (hasRequiredReactDomServerLegacy_browser_development) return reactDomServerLegacy_browser_development;
	hasRequiredReactDomServerLegacy_browser_development = 1;

	if (process.env.NODE_ENV !== "production") {
	  (function () {

	    var React$1 = React;
	    var ReactVersion = '18.3.1';
	    var ReactSharedInternals = React$1.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;

	    // by calls to these methods by a Babel plugin.
	    //
	    // In PROD (or in packages without access to React internals),
	    // they are left as they are instead.

	    function warn(format) {
	      {
	        {
	          for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	            args[_key - 1] = arguments[_key];
	          }
	          printWarning('warn', format, args);
	        }
	      }
	    }
	    function error(format) {
	      {
	        {
	          for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	            args[_key2 - 1] = arguments[_key2];
	          }
	          printWarning('error', format, args);
	        }
	      }
	    }
	    function printWarning(level, format, args) {
	      // When changing this logic, you might want to also
	      // update consoleWithStackDev.www.js as well.
	      {
	        var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
	        var stack = ReactDebugCurrentFrame.getStackAddendum();
	        if (stack !== '') {
	          format += '%s';
	          args = args.concat([stack]);
	        } // eslint-disable-next-line react-internal/safe-string-coercion

	        var argsWithFormat = args.map(function (item) {
	          return String(item);
	        }); // Careful: RN currently depends on this prefix

	        argsWithFormat.unshift('Warning: ' + format); // We intentionally don't use spread (or .apply) directly because it
	        // breaks IE9: https://github.com/facebook/react/issues/13610
	        // eslint-disable-next-line react-internal/no-production-logging

	        Function.prototype.apply.call(console[level], console, argsWithFormat);
	      }
	    }
	    function scheduleWork(callback) {
	      callback();
	    }
	    function beginWriting(destination) {}
	    function writeChunk(destination, chunk) {
	      writeChunkAndReturn(destination, chunk);
	    }
	    function writeChunkAndReturn(destination, chunk) {
	      return destination.push(chunk);
	    }
	    function completeWriting(destination) {}
	    function close(destination) {
	      destination.push(null);
	    }
	    function stringToChunk(content) {
	      return content;
	    }
	    function stringToPrecomputedChunk(content) {
	      return content;
	    }
	    function closeWithError(destination, error) {
	      // $FlowFixMe: This is an Error object or the destination accepts other types.
	      destination.destroy(error);
	    }

	    /*
	     * The `'' + value` pattern (used in in perf-sensitive code) throws for Symbol
	     * and Temporal.* types. See https://github.com/facebook/react/pull/22064.
	     *
	     * The functions in this module will throw an easier-to-understand,
	     * easier-to-debug exception with a clear errors message message explaining the
	     * problem. (Instead of a confusing exception thrown inside the implementation
	     * of the `value` object).
	     */
	    // $FlowFixMe only called in DEV, so void return is not possible.
	    function typeName(value) {
	      {
	        // toStringTag is needed for namespaced types like Temporal.Instant
	        var hasToStringTag = typeof Symbol === 'function' && Symbol.toStringTag;
	        var type = hasToStringTag && value[Symbol.toStringTag] || value.constructor.name || 'Object';
	        return type;
	      }
	    } // $FlowFixMe only called in DEV, so void return is not possible.

	    function willCoercionThrow(value) {
	      {
	        try {
	          testStringCoercion(value);
	          return false;
	        } catch (e) {
	          return true;
	        }
	      }
	    }
	    function testStringCoercion(value) {
	      // If you ended up here by following an exception call stack, here's what's
	      // happened: you supplied an object or symbol value to React (as a prop, key,
	      // DOM attribute, CSS property, string ref, etc.) and when React tried to
	      // coerce it to a string using `'' + value`, an exception was thrown.
	      //
	      // The most common types that will cause this exception are `Symbol` instances
	      // and Temporal objects like `Temporal.Instant`. But any object that has a
	      // `valueOf` or `[Symbol.toPrimitive]` method that throws will also cause this
	      // exception. (Library authors do this to prevent users from using built-in
	      // numeric operators like `+` or comparison operators like `>=` because custom
	      // methods are needed to perform accurate arithmetic or comparison.)
	      //
	      // To fix the problem, coerce this object or symbol value to a string before
	      // passing it to React. The most reliable way is usually `String(value)`.
	      //
	      // To find which value is throwing, check the browser or debugger console.
	      // Before this exception was thrown, there should be `console.error` output
	      // that shows the type (Symbol, Temporal.PlainDate, etc.) that caused the
	      // problem and how that type was used: key, atrribute, input value prop, etc.
	      // In most cases, this console output also shows the component and its
	      // ancestor components where the exception happened.
	      //
	      // eslint-disable-next-line react-internal/safe-string-coercion
	      return '' + value;
	    }
	    function checkAttributeStringCoercion(value, attributeName) {
	      {
	        if (willCoercionThrow(value)) {
	          error('The provided `%s` attribute is an unsupported type %s.' + ' This value must be coerced to a string before before using it here.', attributeName, typeName(value));
	          return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
	        }
	      }
	    }
	    function checkCSSPropertyStringCoercion(value, propName) {
	      {
	        if (willCoercionThrow(value)) {
	          error('The provided `%s` CSS property is an unsupported type %s.' + ' This value must be coerced to a string before before using it here.', propName, typeName(value));
	          return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
	        }
	      }
	    }
	    function checkHtmlStringCoercion(value) {
	      {
	        if (willCoercionThrow(value)) {
	          error('The provided HTML markup uses a value of unsupported type %s.' + ' This value must be coerced to a string before before using it here.', typeName(value));
	          return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
	        }
	      }
	    }
	    var hasOwnProperty = Object.prototype.hasOwnProperty;

	    // A reserved attribute.
	    // It is handled by React separately and shouldn't be written to the DOM.
	    var RESERVED = 0; // A simple string attribute.
	    // Attributes that aren't in the filter are presumed to have this type.

	    var STRING = 1; // A string attribute that accepts booleans in React. In HTML, these are called
	    // "enumerated" attributes with "true" and "false" as possible values.
	    // When true, it should be set to a "true" string.
	    // When false, it should be set to a "false" string.

	    var BOOLEANISH_STRING = 2; // A real boolean attribute.
	    // When true, it should be present (set either to an empty string or its name).
	    // When false, it should be omitted.

	    var BOOLEAN = 3; // An attribute that can be used as a flag as well as with a value.
	    // When true, it should be present (set either to an empty string or its name).
	    // When false, it should be omitted.
	    // For any other value, should be present with that value.

	    var OVERLOADED_BOOLEAN = 4; // An attribute that must be numeric or parse as a numeric.
	    // When falsy, it should be removed.

	    var NUMERIC = 5; // An attribute that must be positive numeric or parse as a positive numeric.
	    // When falsy, it should be removed.

	    var POSITIVE_NUMERIC = 6;

	    /* eslint-disable max-len */
	    var ATTRIBUTE_NAME_START_CHAR = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD";
	    /* eslint-enable max-len */

	    var ATTRIBUTE_NAME_CHAR = ATTRIBUTE_NAME_START_CHAR + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040";
	    var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + ATTRIBUTE_NAME_START_CHAR + '][' + ATTRIBUTE_NAME_CHAR + ']*$');
	    var illegalAttributeNameCache = {};
	    var validatedAttributeNameCache = {};
	    function isAttributeNameSafe(attributeName) {
	      if (hasOwnProperty.call(validatedAttributeNameCache, attributeName)) {
	        return true;
	      }
	      if (hasOwnProperty.call(illegalAttributeNameCache, attributeName)) {
	        return false;
	      }
	      if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
	        validatedAttributeNameCache[attributeName] = true;
	        return true;
	      }
	      illegalAttributeNameCache[attributeName] = true;
	      {
	        error('Invalid attribute name: `%s`', attributeName);
	      }
	      return false;
	    }
	    function shouldRemoveAttributeWithWarning(name, value, propertyInfo, isCustomComponentTag) {
	      if (propertyInfo !== null && propertyInfo.type === RESERVED) {
	        return false;
	      }
	      switch (typeof value) {
	        case 'function': // $FlowIssue symbol is perfectly valid here

	        case 'symbol':
	          // eslint-disable-line
	          return true;
	        case 'boolean':
	          {
	            if (propertyInfo !== null) {
	              return !propertyInfo.acceptsBooleans;
	            } else {
	              var prefix = name.toLowerCase().slice(0, 5);
	              return prefix !== 'data-' && prefix !== 'aria-';
	            }
	          }
	        default:
	          return false;
	      }
	    }
	    function getPropertyInfo(name) {
	      return properties.hasOwnProperty(name) ? properties[name] : null;
	    }
	    function PropertyInfoRecord(name, type, mustUseProperty, attributeName, attributeNamespace, sanitizeURL, removeEmptyString) {
	      this.acceptsBooleans = type === BOOLEANISH_STRING || type === BOOLEAN || type === OVERLOADED_BOOLEAN;
	      this.attributeName = attributeName;
	      this.attributeNamespace = attributeNamespace;
	      this.mustUseProperty = mustUseProperty;
	      this.propertyName = name;
	      this.type = type;
	      this.sanitizeURL = sanitizeURL;
	      this.removeEmptyString = removeEmptyString;
	    } // When adding attributes to this list, be sure to also add them to
	    // the `possibleStandardNames` module to ensure casing and incorrect
	    // name warnings.

	    var properties = {}; // These props are reserved by React. They shouldn't be written to the DOM.

	    var reservedProps = ['children', 'dangerouslySetInnerHTML',
	    // TODO: This prevents the assignment of defaultValue to regular
	    // elements (not just inputs). Now that ReactDOMInput assigns to the
	    // defaultValue property -- do we need this?
	    'defaultValue', 'defaultChecked', 'innerHTML', 'suppressContentEditableWarning', 'suppressHydrationWarning', 'style'];
	    reservedProps.forEach(function (name) {
	      properties[name] = new PropertyInfoRecord(name, RESERVED, false,
	      // mustUseProperty
	      name,
	      // attributeName
	      null,
	      // attributeNamespace
	      false,
	      // sanitizeURL
	      false);
	    }); // A few React string attributes have a different name.
	    // This is a mapping from React prop names to the attribute names.

	    [['acceptCharset', 'accept-charset'], ['className', 'class'], ['htmlFor', 'for'], ['httpEquiv', 'http-equiv']].forEach(function (_ref) {
	      var name = _ref[0],
	        attributeName = _ref[1];
	      properties[name] = new PropertyInfoRecord(name, STRING, false,
	      // mustUseProperty
	      attributeName,
	      // attributeName
	      null,
	      // attributeNamespace
	      false,
	      // sanitizeURL
	      false);
	    }); // These are "enumerated" HTML attributes that accept "true" and "false".
	    // In React, we let users pass `true` and `false` even though technically
	    // these aren't boolean attributes (they are coerced to strings).

	    ['contentEditable', 'draggable', 'spellCheck', 'value'].forEach(function (name) {
	      properties[name] = new PropertyInfoRecord(name, BOOLEANISH_STRING, false,
	      // mustUseProperty
	      name.toLowerCase(),
	      // attributeName
	      null,
	      // attributeNamespace
	      false,
	      // sanitizeURL
	      false);
	    }); // These are "enumerated" SVG attributes that accept "true" and "false".
	    // In React, we let users pass `true` and `false` even though technically
	    // these aren't boolean attributes (they are coerced to strings).
	    // Since these are SVG attributes, their attribute names are case-sensitive.

	    ['autoReverse', 'externalResourcesRequired', 'focusable', 'preserveAlpha'].forEach(function (name) {
	      properties[name] = new PropertyInfoRecord(name, BOOLEANISH_STRING, false,
	      // mustUseProperty
	      name,
	      // attributeName
	      null,
	      // attributeNamespace
	      false,
	      // sanitizeURL
	      false);
	    }); // These are HTML boolean attributes.

	    ['allowFullScreen', 'async',
	    // Note: there is a special case that prevents it from being written to the DOM
	    // on the client side because the browsers are inconsistent. Instead we call focus().
	    'autoFocus', 'autoPlay', 'controls', 'default', 'defer', 'disabled', 'disablePictureInPicture', 'disableRemotePlayback', 'formNoValidate', 'hidden', 'loop', 'noModule', 'noValidate', 'open', 'playsInline', 'readOnly', 'required', 'reversed', 'scoped', 'seamless',
	    // Microdata
	    'itemScope'].forEach(function (name) {
	      properties[name] = new PropertyInfoRecord(name, BOOLEAN, false,
	      // mustUseProperty
	      name.toLowerCase(),
	      // attributeName
	      null,
	      // attributeNamespace
	      false,
	      // sanitizeURL
	      false);
	    }); // These are the few React props that we set as DOM properties
	    // rather than attributes. These are all booleans.

	    ['checked',
	    // Note: `option.selected` is not updated if `select.multiple` is
	    // disabled with `removeAttribute`. We have special logic for handling this.
	    'multiple', 'muted', 'selected' // NOTE: if you add a camelCased prop to this list,
	    // you'll need to set attributeName to name.toLowerCase()
	    // instead in the assignment below.
	    ].forEach(function (name) {
	      properties[name] = new PropertyInfoRecord(name, BOOLEAN, true,
	      // mustUseProperty
	      name,
	      // attributeName
	      null,
	      // attributeNamespace
	      false,
	      // sanitizeURL
	      false);
	    }); // These are HTML attributes that are "overloaded booleans": they behave like
	    // booleans, but can also accept a string value.

	    ['capture', 'download' // NOTE: if you add a camelCased prop to this list,
	    // you'll need to set attributeName to name.toLowerCase()
	    // instead in the assignment below.
	    ].forEach(function (name) {
	      properties[name] = new PropertyInfoRecord(name, OVERLOADED_BOOLEAN, false,
	      // mustUseProperty
	      name,
	      // attributeName
	      null,
	      // attributeNamespace
	      false,
	      // sanitizeURL
	      false);
	    }); // These are HTML attributes that must be positive numbers.

	    ['cols', 'rows', 'size', 'span' // NOTE: if you add a camelCased prop to this list,
	    // you'll need to set attributeName to name.toLowerCase()
	    // instead in the assignment below.
	    ].forEach(function (name) {
	      properties[name] = new PropertyInfoRecord(name, POSITIVE_NUMERIC, false,
	      // mustUseProperty
	      name,
	      // attributeName
	      null,
	      // attributeNamespace
	      false,
	      // sanitizeURL
	      false);
	    }); // These are HTML attributes that must be numbers.

	    ['rowSpan', 'start'].forEach(function (name) {
	      properties[name] = new PropertyInfoRecord(name, NUMERIC, false,
	      // mustUseProperty
	      name.toLowerCase(),
	      // attributeName
	      null,
	      // attributeNamespace
	      false,
	      // sanitizeURL
	      false);
	    });
	    var CAMELIZE = /[\-\:]([a-z])/g;
	    var capitalize = function (token) {
	      return token[1].toUpperCase();
	    }; // This is a list of all SVG attributes that need special casing, namespacing,
	    // or boolean value assignment. Regular attributes that just accept strings
	    // and have the same names are omitted, just like in the HTML attribute filter.
	    // Some of these attributes can be hard to find. This list was created by
	    // scraping the MDN documentation.

	    ['accent-height', 'alignment-baseline', 'arabic-form', 'baseline-shift', 'cap-height', 'clip-path', 'clip-rule', 'color-interpolation', 'color-interpolation-filters', 'color-profile', 'color-rendering', 'dominant-baseline', 'enable-background', 'fill-opacity', 'fill-rule', 'flood-color', 'flood-opacity', 'font-family', 'font-size', 'font-size-adjust', 'font-stretch', 'font-style', 'font-variant', 'font-weight', 'glyph-name', 'glyph-orientation-horizontal', 'glyph-orientation-vertical', 'horiz-adv-x', 'horiz-origin-x', 'image-rendering', 'letter-spacing', 'lighting-color', 'marker-end', 'marker-mid', 'marker-start', 'overline-position', 'overline-thickness', 'paint-order', 'panose-1', 'pointer-events', 'rendering-intent', 'shape-rendering', 'stop-color', 'stop-opacity', 'strikethrough-position', 'strikethrough-thickness', 'stroke-dasharray', 'stroke-dashoffset', 'stroke-linecap', 'stroke-linejoin', 'stroke-miterlimit', 'stroke-opacity', 'stroke-width', 'text-anchor', 'text-decoration', 'text-rendering', 'underline-position', 'underline-thickness', 'unicode-bidi', 'unicode-range', 'units-per-em', 'v-alphabetic', 'v-hanging', 'v-ideographic', 'v-mathematical', 'vector-effect', 'vert-adv-y', 'vert-origin-x', 'vert-origin-y', 'word-spacing', 'writing-mode', 'xmlns:xlink', 'x-height' // NOTE: if you add a camelCased prop to this list,
	    // you'll need to set attributeName to name.toLowerCase()
	    // instead in the assignment below.
	    ].forEach(function (attributeName) {
	      var name = attributeName.replace(CAMELIZE, capitalize);
	      properties[name] = new PropertyInfoRecord(name, STRING, false,
	      // mustUseProperty
	      attributeName, null,
	      // attributeNamespace
	      false,
	      // sanitizeURL
	      false);
	    }); // String SVG attributes with the xlink namespace.

	    ['xlink:actuate', 'xlink:arcrole', 'xlink:role', 'xlink:show', 'xlink:title', 'xlink:type' // NOTE: if you add a camelCased prop to this list,
	    // you'll need to set attributeName to name.toLowerCase()
	    // instead in the assignment below.
	    ].forEach(function (attributeName) {
	      var name = attributeName.replace(CAMELIZE, capitalize);
	      properties[name] = new PropertyInfoRecord(name, STRING, false,
	      // mustUseProperty
	      attributeName, 'http://www.w3.org/1999/xlink', false,
	      // sanitizeURL
	      false);
	    }); // String SVG attributes with the xml namespace.

	    ['xml:base', 'xml:lang', 'xml:space' // NOTE: if you add a camelCased prop to this list,
	    // you'll need to set attributeName to name.toLowerCase()
	    // instead in the assignment below.
	    ].forEach(function (attributeName) {
	      var name = attributeName.replace(CAMELIZE, capitalize);
	      properties[name] = new PropertyInfoRecord(name, STRING, false,
	      // mustUseProperty
	      attributeName, 'http://www.w3.org/XML/1998/namespace', false,
	      // sanitizeURL
	      false);
	    }); // These attribute exists both in HTML and SVG.
	    // The attribute name is case-sensitive in SVG so we can't just use
	    // the React name like we do for attributes that exist only in HTML.

	    ['tabIndex', 'crossOrigin'].forEach(function (attributeName) {
	      properties[attributeName] = new PropertyInfoRecord(attributeName, STRING, false,
	      // mustUseProperty
	      attributeName.toLowerCase(),
	      // attributeName
	      null,
	      // attributeNamespace
	      false,
	      // sanitizeURL
	      false);
	    }); // These attributes accept URLs. These must not allow javascript: URLS.
	    // These will also need to accept Trusted Types object in the future.

	    var xlinkHref = 'xlinkHref';
	    properties[xlinkHref] = new PropertyInfoRecord('xlinkHref', STRING, false,
	    // mustUseProperty
	    'xlink:href', 'http://www.w3.org/1999/xlink', true,
	    // sanitizeURL
	    false);
	    ['src', 'href', 'action', 'formAction'].forEach(function (attributeName) {
	      properties[attributeName] = new PropertyInfoRecord(attributeName, STRING, false,
	      // mustUseProperty
	      attributeName.toLowerCase(),
	      // attributeName
	      null,
	      // attributeNamespace
	      true,
	      // sanitizeURL
	      true);
	    });

	    /**
	     * CSS properties which accept numbers but are not in units of "px".
	     */
	    var isUnitlessNumber = {
	      animationIterationCount: true,
	      aspectRatio: true,
	      borderImageOutset: true,
	      borderImageSlice: true,
	      borderImageWidth: true,
	      boxFlex: true,
	      boxFlexGroup: true,
	      boxOrdinalGroup: true,
	      columnCount: true,
	      columns: true,
	      flex: true,
	      flexGrow: true,
	      flexPositive: true,
	      flexShrink: true,
	      flexNegative: true,
	      flexOrder: true,
	      gridArea: true,
	      gridRow: true,
	      gridRowEnd: true,
	      gridRowSpan: true,
	      gridRowStart: true,
	      gridColumn: true,
	      gridColumnEnd: true,
	      gridColumnSpan: true,
	      gridColumnStart: true,
	      fontWeight: true,
	      lineClamp: true,
	      lineHeight: true,
	      opacity: true,
	      order: true,
	      orphans: true,
	      tabSize: true,
	      widows: true,
	      zIndex: true,
	      zoom: true,
	      // SVG-related properties
	      fillOpacity: true,
	      floodOpacity: true,
	      stopOpacity: true,
	      strokeDasharray: true,
	      strokeDashoffset: true,
	      strokeMiterlimit: true,
	      strokeOpacity: true,
	      strokeWidth: true
	    };
	    /**
	     * @param {string} prefix vendor-specific prefix, eg: Webkit
	     * @param {string} key style name, eg: transitionDuration
	     * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	     * WebkitTransitionDuration
	     */

	    function prefixKey(prefix, key) {
	      return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	    }
	    /**
	     * Support style names that may come passed in prefixed by adding permutations
	     * of vendor prefixes.
	     */

	    var prefixes = ['Webkit', 'ms', 'Moz', 'O']; // Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	    // infinite loop, because it iterates over the newly added props too.

	    Object.keys(isUnitlessNumber).forEach(function (prop) {
	      prefixes.forEach(function (prefix) {
	        isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	      });
	    });
	    var hasReadOnlyValue = {
	      button: true,
	      checkbox: true,
	      image: true,
	      hidden: true,
	      radio: true,
	      reset: true,
	      submit: true
	    };
	    function checkControlledValueProps(tagName, props) {
	      {
	        if (!(hasReadOnlyValue[props.type] || props.onChange || props.onInput || props.readOnly || props.disabled || props.value == null)) {
	          error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	        }
	        if (!(props.onChange || props.readOnly || props.disabled || props.checked == null)) {
	          error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	        }
	      }
	    }
	    function isCustomComponent(tagName, props) {
	      if (tagName.indexOf('-') === -1) {
	        return typeof props.is === 'string';
	      }
	      switch (tagName) {
	        // These are reserved SVG and MathML elements.
	        // We don't mind this list too much because we expect it to never grow.
	        // The alternative is to track the namespace in a few places which is convoluted.
	        // https://w3c.github.io/webcomponents/spec/custom/#custom-elements-core-concepts
	        case 'annotation-xml':
	        case 'color-profile':
	        case 'font-face':
	        case 'font-face-src':
	        case 'font-face-uri':
	        case 'font-face-format':
	        case 'font-face-name':
	        case 'missing-glyph':
	          return false;
	        default:
	          return true;
	      }
	    }
	    var ariaProperties = {
	      'aria-current': 0,
	      // state
	      'aria-description': 0,
	      'aria-details': 0,
	      'aria-disabled': 0,
	      // state
	      'aria-hidden': 0,
	      // state
	      'aria-invalid': 0,
	      // state
	      'aria-keyshortcuts': 0,
	      'aria-label': 0,
	      'aria-roledescription': 0,
	      // Widget Attributes
	      'aria-autocomplete': 0,
	      'aria-checked': 0,
	      'aria-expanded': 0,
	      'aria-haspopup': 0,
	      'aria-level': 0,
	      'aria-modal': 0,
	      'aria-multiline': 0,
	      'aria-multiselectable': 0,
	      'aria-orientation': 0,
	      'aria-placeholder': 0,
	      'aria-pressed': 0,
	      'aria-readonly': 0,
	      'aria-required': 0,
	      'aria-selected': 0,
	      'aria-sort': 0,
	      'aria-valuemax': 0,
	      'aria-valuemin': 0,
	      'aria-valuenow': 0,
	      'aria-valuetext': 0,
	      // Live Region Attributes
	      'aria-atomic': 0,
	      'aria-busy': 0,
	      'aria-live': 0,
	      'aria-relevant': 0,
	      // Drag-and-Drop Attributes
	      'aria-dropeffect': 0,
	      'aria-grabbed': 0,
	      // Relationship Attributes
	      'aria-activedescendant': 0,
	      'aria-colcount': 0,
	      'aria-colindex': 0,
	      'aria-colspan': 0,
	      'aria-controls': 0,
	      'aria-describedby': 0,
	      'aria-errormessage': 0,
	      'aria-flowto': 0,
	      'aria-labelledby': 0,
	      'aria-owns': 0,
	      'aria-posinset': 0,
	      'aria-rowcount': 0,
	      'aria-rowindex': 0,
	      'aria-rowspan': 0,
	      'aria-setsize': 0
	    };
	    var warnedProperties = {};
	    var rARIA = new RegExp('^(aria)-[' + ATTRIBUTE_NAME_CHAR + ']*$');
	    var rARIACamel = new RegExp('^(aria)[A-Z][' + ATTRIBUTE_NAME_CHAR + ']*$');
	    function validateProperty(tagName, name) {
	      {
	        if (hasOwnProperty.call(warnedProperties, name) && warnedProperties[name]) {
	          return true;
	        }
	        if (rARIACamel.test(name)) {
	          var ariaName = 'aria-' + name.slice(4).toLowerCase();
	          var correctName = ariaProperties.hasOwnProperty(ariaName) ? ariaName : null; // If this is an aria-* attribute, but is not listed in the known DOM
	          // DOM properties, then it is an invalid aria-* attribute.

	          if (correctName == null) {
	            error('Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.', name);
	            warnedProperties[name] = true;
	            return true;
	          } // aria-* attributes should be lowercase; suggest the lowercase version.

	          if (name !== correctName) {
	            error('Invalid ARIA attribute `%s`. Did you mean `%s`?', name, correctName);
	            warnedProperties[name] = true;
	            return true;
	          }
	        }
	        if (rARIA.test(name)) {
	          var lowerCasedName = name.toLowerCase();
	          var standardName = ariaProperties.hasOwnProperty(lowerCasedName) ? lowerCasedName : null; // If this is an aria-* attribute, but is not listed in the known DOM
	          // DOM properties, then it is an invalid aria-* attribute.

	          if (standardName == null) {
	            warnedProperties[name] = true;
	            return false;
	          } // aria-* attributes should be lowercase; suggest the lowercase version.

	          if (name !== standardName) {
	            error('Unknown ARIA attribute `%s`. Did you mean `%s`?', name, standardName);
	            warnedProperties[name] = true;
	            return true;
	          }
	        }
	      }
	      return true;
	    }
	    function warnInvalidARIAProps(type, props) {
	      {
	        var invalidProps = [];
	        for (var key in props) {
	          var isValid = validateProperty(type, key);
	          if (!isValid) {
	            invalidProps.push(key);
	          }
	        }
	        var unknownPropString = invalidProps.map(function (prop) {
	          return '`' + prop + '`';
	        }).join(', ');
	        if (invalidProps.length === 1) {
	          error('Invalid aria prop %s on <%s> tag. ' + 'For details, see https://reactjs.org/link/invalid-aria-props', unknownPropString, type);
	        } else if (invalidProps.length > 1) {
	          error('Invalid aria props %s on <%s> tag. ' + 'For details, see https://reactjs.org/link/invalid-aria-props', unknownPropString, type);
	        }
	      }
	    }
	    function validateProperties(type, props) {
	      if (isCustomComponent(type, props)) {
	        return;
	      }
	      warnInvalidARIAProps(type, props);
	    }
	    var didWarnValueNull = false;
	    function validateProperties$1(type, props) {
	      {
	        if (type !== 'input' && type !== 'textarea' && type !== 'select') {
	          return;
	        }
	        if (props != null && props.value === null && !didWarnValueNull) {
	          didWarnValueNull = true;
	          if (type === 'select' && props.multiple) {
	            error('`value` prop on `%s` should not be null. ' + 'Consider using an empty array when `multiple` is set to `true` ' + 'to clear the component or `undefined` for uncontrolled components.', type);
	          } else {
	            error('`value` prop on `%s` should not be null. ' + 'Consider using an empty string to clear the component or `undefined` ' + 'for uncontrolled components.', type);
	          }
	        }
	      }
	    }

	    // When adding attributes to the HTML or SVG allowed attribute list, be sure to
	    // also add them to this module to ensure casing and incorrect name
	    // warnings.
	    var possibleStandardNames = {
	      // HTML
	      accept: 'accept',
	      acceptcharset: 'acceptCharset',
	      'accept-charset': 'acceptCharset',
	      accesskey: 'accessKey',
	      action: 'action',
	      allowfullscreen: 'allowFullScreen',
	      alt: 'alt',
	      as: 'as',
	      async: 'async',
	      autocapitalize: 'autoCapitalize',
	      autocomplete: 'autoComplete',
	      autocorrect: 'autoCorrect',
	      autofocus: 'autoFocus',
	      autoplay: 'autoPlay',
	      autosave: 'autoSave',
	      capture: 'capture',
	      cellpadding: 'cellPadding',
	      cellspacing: 'cellSpacing',
	      challenge: 'challenge',
	      charset: 'charSet',
	      checked: 'checked',
	      children: 'children',
	      cite: 'cite',
	      class: 'className',
	      classid: 'classID',
	      classname: 'className',
	      cols: 'cols',
	      colspan: 'colSpan',
	      content: 'content',
	      contenteditable: 'contentEditable',
	      contextmenu: 'contextMenu',
	      controls: 'controls',
	      controlslist: 'controlsList',
	      coords: 'coords',
	      crossorigin: 'crossOrigin',
	      dangerouslysetinnerhtml: 'dangerouslySetInnerHTML',
	      data: 'data',
	      datetime: 'dateTime',
	      default: 'default',
	      defaultchecked: 'defaultChecked',
	      defaultvalue: 'defaultValue',
	      defer: 'defer',
	      dir: 'dir',
	      disabled: 'disabled',
	      disablepictureinpicture: 'disablePictureInPicture',
	      disableremoteplayback: 'disableRemotePlayback',
	      download: 'download',
	      draggable: 'draggable',
	      enctype: 'encType',
	      enterkeyhint: 'enterKeyHint',
	      for: 'htmlFor',
	      form: 'form',
	      formmethod: 'formMethod',
	      formaction: 'formAction',
	      formenctype: 'formEncType',
	      formnovalidate: 'formNoValidate',
	      formtarget: 'formTarget',
	      frameborder: 'frameBorder',
	      headers: 'headers',
	      height: 'height',
	      hidden: 'hidden',
	      high: 'high',
	      href: 'href',
	      hreflang: 'hrefLang',
	      htmlfor: 'htmlFor',
	      httpequiv: 'httpEquiv',
	      'http-equiv': 'httpEquiv',
	      icon: 'icon',
	      id: 'id',
	      imagesizes: 'imageSizes',
	      imagesrcset: 'imageSrcSet',
	      innerhtml: 'innerHTML',
	      inputmode: 'inputMode',
	      integrity: 'integrity',
	      is: 'is',
	      itemid: 'itemID',
	      itemprop: 'itemProp',
	      itemref: 'itemRef',
	      itemscope: 'itemScope',
	      itemtype: 'itemType',
	      keyparams: 'keyParams',
	      keytype: 'keyType',
	      kind: 'kind',
	      label: 'label',
	      lang: 'lang',
	      list: 'list',
	      loop: 'loop',
	      low: 'low',
	      manifest: 'manifest',
	      marginwidth: 'marginWidth',
	      marginheight: 'marginHeight',
	      max: 'max',
	      maxlength: 'maxLength',
	      media: 'media',
	      mediagroup: 'mediaGroup',
	      method: 'method',
	      min: 'min',
	      minlength: 'minLength',
	      multiple: 'multiple',
	      muted: 'muted',
	      name: 'name',
	      nomodule: 'noModule',
	      nonce: 'nonce',
	      novalidate: 'noValidate',
	      open: 'open',
	      optimum: 'optimum',
	      pattern: 'pattern',
	      placeholder: 'placeholder',
	      playsinline: 'playsInline',
	      poster: 'poster',
	      preload: 'preload',
	      profile: 'profile',
	      radiogroup: 'radioGroup',
	      readonly: 'readOnly',
	      referrerpolicy: 'referrerPolicy',
	      rel: 'rel',
	      required: 'required',
	      reversed: 'reversed',
	      role: 'role',
	      rows: 'rows',
	      rowspan: 'rowSpan',
	      sandbox: 'sandbox',
	      scope: 'scope',
	      scoped: 'scoped',
	      scrolling: 'scrolling',
	      seamless: 'seamless',
	      selected: 'selected',
	      shape: 'shape',
	      size: 'size',
	      sizes: 'sizes',
	      span: 'span',
	      spellcheck: 'spellCheck',
	      src: 'src',
	      srcdoc: 'srcDoc',
	      srclang: 'srcLang',
	      srcset: 'srcSet',
	      start: 'start',
	      step: 'step',
	      style: 'style',
	      summary: 'summary',
	      tabindex: 'tabIndex',
	      target: 'target',
	      title: 'title',
	      type: 'type',
	      usemap: 'useMap',
	      value: 'value',
	      width: 'width',
	      wmode: 'wmode',
	      wrap: 'wrap',
	      // SVG
	      about: 'about',
	      accentheight: 'accentHeight',
	      'accent-height': 'accentHeight',
	      accumulate: 'accumulate',
	      additive: 'additive',
	      alignmentbaseline: 'alignmentBaseline',
	      'alignment-baseline': 'alignmentBaseline',
	      allowreorder: 'allowReorder',
	      alphabetic: 'alphabetic',
	      amplitude: 'amplitude',
	      arabicform: 'arabicForm',
	      'arabic-form': 'arabicForm',
	      ascent: 'ascent',
	      attributename: 'attributeName',
	      attributetype: 'attributeType',
	      autoreverse: 'autoReverse',
	      azimuth: 'azimuth',
	      basefrequency: 'baseFrequency',
	      baselineshift: 'baselineShift',
	      'baseline-shift': 'baselineShift',
	      baseprofile: 'baseProfile',
	      bbox: 'bbox',
	      begin: 'begin',
	      bias: 'bias',
	      by: 'by',
	      calcmode: 'calcMode',
	      capheight: 'capHeight',
	      'cap-height': 'capHeight',
	      clip: 'clip',
	      clippath: 'clipPath',
	      'clip-path': 'clipPath',
	      clippathunits: 'clipPathUnits',
	      cliprule: 'clipRule',
	      'clip-rule': 'clipRule',
	      color: 'color',
	      colorinterpolation: 'colorInterpolation',
	      'color-interpolation': 'colorInterpolation',
	      colorinterpolationfilters: 'colorInterpolationFilters',
	      'color-interpolation-filters': 'colorInterpolationFilters',
	      colorprofile: 'colorProfile',
	      'color-profile': 'colorProfile',
	      colorrendering: 'colorRendering',
	      'color-rendering': 'colorRendering',
	      contentscripttype: 'contentScriptType',
	      contentstyletype: 'contentStyleType',
	      cursor: 'cursor',
	      cx: 'cx',
	      cy: 'cy',
	      d: 'd',
	      datatype: 'datatype',
	      decelerate: 'decelerate',
	      descent: 'descent',
	      diffuseconstant: 'diffuseConstant',
	      direction: 'direction',
	      display: 'display',
	      divisor: 'divisor',
	      dominantbaseline: 'dominantBaseline',
	      'dominant-baseline': 'dominantBaseline',
	      dur: 'dur',
	      dx: 'dx',
	      dy: 'dy',
	      edgemode: 'edgeMode',
	      elevation: 'elevation',
	      enablebackground: 'enableBackground',
	      'enable-background': 'enableBackground',
	      end: 'end',
	      exponent: 'exponent',
	      externalresourcesrequired: 'externalResourcesRequired',
	      fill: 'fill',
	      fillopacity: 'fillOpacity',
	      'fill-opacity': 'fillOpacity',
	      fillrule: 'fillRule',
	      'fill-rule': 'fillRule',
	      filter: 'filter',
	      filterres: 'filterRes',
	      filterunits: 'filterUnits',
	      floodopacity: 'floodOpacity',
	      'flood-opacity': 'floodOpacity',
	      floodcolor: 'floodColor',
	      'flood-color': 'floodColor',
	      focusable: 'focusable',
	      fontfamily: 'fontFamily',
	      'font-family': 'fontFamily',
	      fontsize: 'fontSize',
	      'font-size': 'fontSize',
	      fontsizeadjust: 'fontSizeAdjust',
	      'font-size-adjust': 'fontSizeAdjust',
	      fontstretch: 'fontStretch',
	      'font-stretch': 'fontStretch',
	      fontstyle: 'fontStyle',
	      'font-style': 'fontStyle',
	      fontvariant: 'fontVariant',
	      'font-variant': 'fontVariant',
	      fontweight: 'fontWeight',
	      'font-weight': 'fontWeight',
	      format: 'format',
	      from: 'from',
	      fx: 'fx',
	      fy: 'fy',
	      g1: 'g1',
	      g2: 'g2',
	      glyphname: 'glyphName',
	      'glyph-name': 'glyphName',
	      glyphorientationhorizontal: 'glyphOrientationHorizontal',
	      'glyph-orientation-horizontal': 'glyphOrientationHorizontal',
	      glyphorientationvertical: 'glyphOrientationVertical',
	      'glyph-orientation-vertical': 'glyphOrientationVertical',
	      glyphref: 'glyphRef',
	      gradienttransform: 'gradientTransform',
	      gradientunits: 'gradientUnits',
	      hanging: 'hanging',
	      horizadvx: 'horizAdvX',
	      'horiz-adv-x': 'horizAdvX',
	      horizoriginx: 'horizOriginX',
	      'horiz-origin-x': 'horizOriginX',
	      ideographic: 'ideographic',
	      imagerendering: 'imageRendering',
	      'image-rendering': 'imageRendering',
	      in2: 'in2',
	      in: 'in',
	      inlist: 'inlist',
	      intercept: 'intercept',
	      k1: 'k1',
	      k2: 'k2',
	      k3: 'k3',
	      k4: 'k4',
	      k: 'k',
	      kernelmatrix: 'kernelMatrix',
	      kernelunitlength: 'kernelUnitLength',
	      kerning: 'kerning',
	      keypoints: 'keyPoints',
	      keysplines: 'keySplines',
	      keytimes: 'keyTimes',
	      lengthadjust: 'lengthAdjust',
	      letterspacing: 'letterSpacing',
	      'letter-spacing': 'letterSpacing',
	      lightingcolor: 'lightingColor',
	      'lighting-color': 'lightingColor',
	      limitingconeangle: 'limitingConeAngle',
	      local: 'local',
	      markerend: 'markerEnd',
	      'marker-end': 'markerEnd',
	      markerheight: 'markerHeight',
	      markermid: 'markerMid',
	      'marker-mid': 'markerMid',
	      markerstart: 'markerStart',
	      'marker-start': 'markerStart',
	      markerunits: 'markerUnits',
	      markerwidth: 'markerWidth',
	      mask: 'mask',
	      maskcontentunits: 'maskContentUnits',
	      maskunits: 'maskUnits',
	      mathematical: 'mathematical',
	      mode: 'mode',
	      numoctaves: 'numOctaves',
	      offset: 'offset',
	      opacity: 'opacity',
	      operator: 'operator',
	      order: 'order',
	      orient: 'orient',
	      orientation: 'orientation',
	      origin: 'origin',
	      overflow: 'overflow',
	      overlineposition: 'overlinePosition',
	      'overline-position': 'overlinePosition',
	      overlinethickness: 'overlineThickness',
	      'overline-thickness': 'overlineThickness',
	      paintorder: 'paintOrder',
	      'paint-order': 'paintOrder',
	      panose1: 'panose1',
	      'panose-1': 'panose1',
	      pathlength: 'pathLength',
	      patterncontentunits: 'patternContentUnits',
	      patterntransform: 'patternTransform',
	      patternunits: 'patternUnits',
	      pointerevents: 'pointerEvents',
	      'pointer-events': 'pointerEvents',
	      points: 'points',
	      pointsatx: 'pointsAtX',
	      pointsaty: 'pointsAtY',
	      pointsatz: 'pointsAtZ',
	      prefix: 'prefix',
	      preservealpha: 'preserveAlpha',
	      preserveaspectratio: 'preserveAspectRatio',
	      primitiveunits: 'primitiveUnits',
	      property: 'property',
	      r: 'r',
	      radius: 'radius',
	      refx: 'refX',
	      refy: 'refY',
	      renderingintent: 'renderingIntent',
	      'rendering-intent': 'renderingIntent',
	      repeatcount: 'repeatCount',
	      repeatdur: 'repeatDur',
	      requiredextensions: 'requiredExtensions',
	      requiredfeatures: 'requiredFeatures',
	      resource: 'resource',
	      restart: 'restart',
	      result: 'result',
	      results: 'results',
	      rotate: 'rotate',
	      rx: 'rx',
	      ry: 'ry',
	      scale: 'scale',
	      security: 'security',
	      seed: 'seed',
	      shaperendering: 'shapeRendering',
	      'shape-rendering': 'shapeRendering',
	      slope: 'slope',
	      spacing: 'spacing',
	      specularconstant: 'specularConstant',
	      specularexponent: 'specularExponent',
	      speed: 'speed',
	      spreadmethod: 'spreadMethod',
	      startoffset: 'startOffset',
	      stddeviation: 'stdDeviation',
	      stemh: 'stemh',
	      stemv: 'stemv',
	      stitchtiles: 'stitchTiles',
	      stopcolor: 'stopColor',
	      'stop-color': 'stopColor',
	      stopopacity: 'stopOpacity',
	      'stop-opacity': 'stopOpacity',
	      strikethroughposition: 'strikethroughPosition',
	      'strikethrough-position': 'strikethroughPosition',
	      strikethroughthickness: 'strikethroughThickness',
	      'strikethrough-thickness': 'strikethroughThickness',
	      string: 'string',
	      stroke: 'stroke',
	      strokedasharray: 'strokeDasharray',
	      'stroke-dasharray': 'strokeDasharray',
	      strokedashoffset: 'strokeDashoffset',
	      'stroke-dashoffset': 'strokeDashoffset',
	      strokelinecap: 'strokeLinecap',
	      'stroke-linecap': 'strokeLinecap',
	      strokelinejoin: 'strokeLinejoin',
	      'stroke-linejoin': 'strokeLinejoin',
	      strokemiterlimit: 'strokeMiterlimit',
	      'stroke-miterlimit': 'strokeMiterlimit',
	      strokewidth: 'strokeWidth',
	      'stroke-width': 'strokeWidth',
	      strokeopacity: 'strokeOpacity',
	      'stroke-opacity': 'strokeOpacity',
	      suppresscontenteditablewarning: 'suppressContentEditableWarning',
	      suppresshydrationwarning: 'suppressHydrationWarning',
	      surfacescale: 'surfaceScale',
	      systemlanguage: 'systemLanguage',
	      tablevalues: 'tableValues',
	      targetx: 'targetX',
	      targety: 'targetY',
	      textanchor: 'textAnchor',
	      'text-anchor': 'textAnchor',
	      textdecoration: 'textDecoration',
	      'text-decoration': 'textDecoration',
	      textlength: 'textLength',
	      textrendering: 'textRendering',
	      'text-rendering': 'textRendering',
	      to: 'to',
	      transform: 'transform',
	      typeof: 'typeof',
	      u1: 'u1',
	      u2: 'u2',
	      underlineposition: 'underlinePosition',
	      'underline-position': 'underlinePosition',
	      underlinethickness: 'underlineThickness',
	      'underline-thickness': 'underlineThickness',
	      unicode: 'unicode',
	      unicodebidi: 'unicodeBidi',
	      'unicode-bidi': 'unicodeBidi',
	      unicoderange: 'unicodeRange',
	      'unicode-range': 'unicodeRange',
	      unitsperem: 'unitsPerEm',
	      'units-per-em': 'unitsPerEm',
	      unselectable: 'unselectable',
	      valphabetic: 'vAlphabetic',
	      'v-alphabetic': 'vAlphabetic',
	      values: 'values',
	      vectoreffect: 'vectorEffect',
	      'vector-effect': 'vectorEffect',
	      version: 'version',
	      vertadvy: 'vertAdvY',
	      'vert-adv-y': 'vertAdvY',
	      vertoriginx: 'vertOriginX',
	      'vert-origin-x': 'vertOriginX',
	      vertoriginy: 'vertOriginY',
	      'vert-origin-y': 'vertOriginY',
	      vhanging: 'vHanging',
	      'v-hanging': 'vHanging',
	      videographic: 'vIdeographic',
	      'v-ideographic': 'vIdeographic',
	      viewbox: 'viewBox',
	      viewtarget: 'viewTarget',
	      visibility: 'visibility',
	      vmathematical: 'vMathematical',
	      'v-mathematical': 'vMathematical',
	      vocab: 'vocab',
	      widths: 'widths',
	      wordspacing: 'wordSpacing',
	      'word-spacing': 'wordSpacing',
	      writingmode: 'writingMode',
	      'writing-mode': 'writingMode',
	      x1: 'x1',
	      x2: 'x2',
	      x: 'x',
	      xchannelselector: 'xChannelSelector',
	      xheight: 'xHeight',
	      'x-height': 'xHeight',
	      xlinkactuate: 'xlinkActuate',
	      'xlink:actuate': 'xlinkActuate',
	      xlinkarcrole: 'xlinkArcrole',
	      'xlink:arcrole': 'xlinkArcrole',
	      xlinkhref: 'xlinkHref',
	      'xlink:href': 'xlinkHref',
	      xlinkrole: 'xlinkRole',
	      'xlink:role': 'xlinkRole',
	      xlinkshow: 'xlinkShow',
	      'xlink:show': 'xlinkShow',
	      xlinktitle: 'xlinkTitle',
	      'xlink:title': 'xlinkTitle',
	      xlinktype: 'xlinkType',
	      'xlink:type': 'xlinkType',
	      xmlbase: 'xmlBase',
	      'xml:base': 'xmlBase',
	      xmllang: 'xmlLang',
	      'xml:lang': 'xmlLang',
	      xmlns: 'xmlns',
	      'xml:space': 'xmlSpace',
	      xmlnsxlink: 'xmlnsXlink',
	      'xmlns:xlink': 'xmlnsXlink',
	      xmlspace: 'xmlSpace',
	      y1: 'y1',
	      y2: 'y2',
	      y: 'y',
	      ychannelselector: 'yChannelSelector',
	      z: 'z',
	      zoomandpan: 'zoomAndPan'
	    };
	    var validateProperty$1 = function () {};
	    {
	      var warnedProperties$1 = {};
	      var EVENT_NAME_REGEX = /^on./;
	      var INVALID_EVENT_NAME_REGEX = /^on[^A-Z]/;
	      var rARIA$1 = new RegExp('^(aria)-[' + ATTRIBUTE_NAME_CHAR + ']*$');
	      var rARIACamel$1 = new RegExp('^(aria)[A-Z][' + ATTRIBUTE_NAME_CHAR + ']*$');
	      validateProperty$1 = function (tagName, name, value, eventRegistry) {
	        if (hasOwnProperty.call(warnedProperties$1, name) && warnedProperties$1[name]) {
	          return true;
	        }
	        var lowerCasedName = name.toLowerCase();
	        if (lowerCasedName === 'onfocusin' || lowerCasedName === 'onfocusout') {
	          error('React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.');
	          warnedProperties$1[name] = true;
	          return true;
	        } // We can't rely on the event system being injected on the server.

	        if (eventRegistry != null) {
	          var registrationNameDependencies = eventRegistry.registrationNameDependencies,
	            possibleRegistrationNames = eventRegistry.possibleRegistrationNames;
	          if (registrationNameDependencies.hasOwnProperty(name)) {
	            return true;
	          }
	          var registrationName = possibleRegistrationNames.hasOwnProperty(lowerCasedName) ? possibleRegistrationNames[lowerCasedName] : null;
	          if (registrationName != null) {
	            error('Invalid event handler property `%s`. Did you mean `%s`?', name, registrationName);
	            warnedProperties$1[name] = true;
	            return true;
	          }
	          if (EVENT_NAME_REGEX.test(name)) {
	            error('Unknown event handler property `%s`. It will be ignored.', name);
	            warnedProperties$1[name] = true;
	            return true;
	          }
	        } else if (EVENT_NAME_REGEX.test(name)) {
	          // If no event plugins have been injected, we are in a server environment.
	          // So we can't tell if the event name is correct for sure, but we can filter
	          // out known bad ones like `onclick`. We can't suggest a specific replacement though.
	          if (INVALID_EVENT_NAME_REGEX.test(name)) {
	            error('Invalid event handler property `%s`. ' + 'React events use the camelCase naming convention, for example `onClick`.', name);
	          }
	          warnedProperties$1[name] = true;
	          return true;
	        } // Let the ARIA attribute hook validate ARIA attributes

	        if (rARIA$1.test(name) || rARIACamel$1.test(name)) {
	          return true;
	        }
	        if (lowerCasedName === 'innerhtml') {
	          error('Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.');
	          warnedProperties$1[name] = true;
	          return true;
	        }
	        if (lowerCasedName === 'aria') {
	          error('The `aria` attribute is reserved for future use in React. ' + 'Pass individual `aria-` attributes instead.');
	          warnedProperties$1[name] = true;
	          return true;
	        }
	        if (lowerCasedName === 'is' && value !== null && value !== undefined && typeof value !== 'string') {
	          error('Received a `%s` for a string attribute `is`. If this is expected, cast ' + 'the value to a string.', typeof value);
	          warnedProperties$1[name] = true;
	          return true;
	        }
	        if (typeof value === 'number' && isNaN(value)) {
	          error('Received NaN for the `%s` attribute. If this is expected, cast ' + 'the value to a string.', name);
	          warnedProperties$1[name] = true;
	          return true;
	        }
	        var propertyInfo = getPropertyInfo(name);
	        var isReserved = propertyInfo !== null && propertyInfo.type === RESERVED; // Known attributes should match the casing specified in the property config.

	        if (possibleStandardNames.hasOwnProperty(lowerCasedName)) {
	          var standardName = possibleStandardNames[lowerCasedName];
	          if (standardName !== name) {
	            error('Invalid DOM property `%s`. Did you mean `%s`?', name, standardName);
	            warnedProperties$1[name] = true;
	            return true;
	          }
	        } else if (!isReserved && name !== lowerCasedName) {
	          // Unknown attributes should have lowercase casing since that's how they
	          // will be cased anyway with server rendering.
	          error('React does not recognize the `%s` prop on a DOM element. If you ' + 'intentionally want it to appear in the DOM as a custom ' + 'attribute, spell it as lowercase `%s` instead. ' + 'If you accidentally passed it from a parent component, remove ' + 'it from the DOM element.', name, lowerCasedName);
	          warnedProperties$1[name] = true;
	          return true;
	        }
	        if (typeof value === 'boolean' && shouldRemoveAttributeWithWarning(name, value, propertyInfo)) {
	          if (value) {
	            error('Received `%s` for a non-boolean attribute `%s`.\n\n' + 'If you want to write it to the DOM, pass a string instead: ' + '%s="%s" or %s={value.toString()}.', value, name, name, value, name);
	          } else {
	            error('Received `%s` for a non-boolean attribute `%s`.\n\n' + 'If you want to write it to the DOM, pass a string instead: ' + '%s="%s" or %s={value.toString()}.\n\n' + 'If you used to conditionally omit it with %s={condition && value}, ' + 'pass %s={condition ? value : undefined} instead.', value, name, name, value, name, name, name);
	          }
	          warnedProperties$1[name] = true;
	          return true;
	        } // Now that we've validated casing, do not validate
	        // data types for reserved props

	        if (isReserved) {
	          return true;
	        } // Warn when a known attribute is a bad type

	        if (shouldRemoveAttributeWithWarning(name, value, propertyInfo)) {
	          warnedProperties$1[name] = true;
	          return false;
	        } // Warn when passing the strings 'false' or 'true' into a boolean prop

	        if ((value === 'false' || value === 'true') && propertyInfo !== null && propertyInfo.type === BOOLEAN) {
	          error('Received the string `%s` for the boolean attribute `%s`. ' + '%s ' + 'Did you mean %s={%s}?', value, name, value === 'false' ? 'The browser will interpret it as a truthy value.' : 'Although this works, it will not work as expected if you pass the string "false".', name, value);
	          warnedProperties$1[name] = true;
	          return true;
	        }
	        return true;
	      };
	    }
	    var warnUnknownProperties = function (type, props, eventRegistry) {
	      {
	        var unknownProps = [];
	        for (var key in props) {
	          var isValid = validateProperty$1(type, key, props[key], eventRegistry);
	          if (!isValid) {
	            unknownProps.push(key);
	          }
	        }
	        var unknownPropString = unknownProps.map(function (prop) {
	          return '`' + prop + '`';
	        }).join(', ');
	        if (unknownProps.length === 1) {
	          error('Invalid value for prop %s on <%s> tag. Either remove it from the element, ' + 'or pass a string or number value to keep it in the DOM. ' + 'For details, see https://reactjs.org/link/attribute-behavior ', unknownPropString, type);
	        } else if (unknownProps.length > 1) {
	          error('Invalid values for props %s on <%s> tag. Either remove them from the element, ' + 'or pass a string or number value to keep them in the DOM. ' + 'For details, see https://reactjs.org/link/attribute-behavior ', unknownPropString, type);
	        }
	      }
	    };
	    function validateProperties$2(type, props, eventRegistry) {
	      if (isCustomComponent(type, props)) {
	        return;
	      }
	      warnUnknownProperties(type, props, eventRegistry);
	    }
	    var warnValidStyle = function () {};
	    {
	      // 'msTransform' is correct, but the other prefixes should be capitalized
	      var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	      var msPattern = /^-ms-/;
	      var hyphenPattern = /-(.)/g; // style values shouldn't contain a semicolon

	      var badStyleValueWithSemicolonPattern = /;\s*$/;
	      var warnedStyleNames = {};
	      var warnedStyleValues = {};
	      var warnedForNaNValue = false;
	      var warnedForInfinityValue = false;
	      var camelize = function (string) {
	        return string.replace(hyphenPattern, function (_, character) {
	          return character.toUpperCase();
	        });
	      };
	      var warnHyphenatedStyleName = function (name) {
	        if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	          return;
	        }
	        warnedStyleNames[name] = true;
	        error('Unsupported style property %s. Did you mean %s?', name,
	        // As Andi Smith suggests
	        // (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
	        // is converted to lowercase `ms`.
	        camelize(name.replace(msPattern, 'ms-')));
	      };
	      var warnBadVendoredStyleName = function (name) {
	        if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	          return;
	        }
	        warnedStyleNames[name] = true;
	        error('Unsupported vendor-prefixed style property %s. Did you mean %s?', name, name.charAt(0).toUpperCase() + name.slice(1));
	      };
	      var warnStyleValueWithSemicolon = function (name, value) {
	        if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	          return;
	        }
	        warnedStyleValues[value] = true;
	        error("Style property values shouldn't contain a semicolon. " + 'Try "%s: %s" instead.', name, value.replace(badStyleValueWithSemicolonPattern, ''));
	      };
	      var warnStyleValueIsNaN = function (name, value) {
	        if (warnedForNaNValue) {
	          return;
	        }
	        warnedForNaNValue = true;
	        error('`NaN` is an invalid value for the `%s` css style property.', name);
	      };
	      var warnStyleValueIsInfinity = function (name, value) {
	        if (warnedForInfinityValue) {
	          return;
	        }
	        warnedForInfinityValue = true;
	        error('`Infinity` is an invalid value for the `%s` css style property.', name);
	      };
	      warnValidStyle = function (name, value) {
	        if (name.indexOf('-') > -1) {
	          warnHyphenatedStyleName(name);
	        } else if (badVendoredStyleNamePattern.test(name)) {
	          warnBadVendoredStyleName(name);
	        } else if (badStyleValueWithSemicolonPattern.test(value)) {
	          warnStyleValueWithSemicolon(name, value);
	        }
	        if (typeof value === 'number') {
	          if (isNaN(value)) {
	            warnStyleValueIsNaN(name, value);
	          } else if (!isFinite(value)) {
	            warnStyleValueIsInfinity(name, value);
	          }
	        }
	      };
	    }
	    var warnValidStyle$1 = warnValidStyle;

	    // code copied and modified from escape-html
	    var matchHtmlRegExp = /["'&<>]/;
	    /**
	     * Escapes special characters and HTML entities in a given html string.
	     *
	     * @param  {string} string HTML string to escape for later insertion
	     * @return {string}
	     * @public
	     */

	    function escapeHtml(string) {
	      {
	        checkHtmlStringCoercion(string);
	      }
	      var str = '' + string;
	      var match = matchHtmlRegExp.exec(str);
	      if (!match) {
	        return str;
	      }
	      var escape;
	      var html = '';
	      var index;
	      var lastIndex = 0;
	      for (index = match.index; index < str.length; index++) {
	        switch (str.charCodeAt(index)) {
	          case 34:
	            // "
	            escape = '&quot;';
	            break;
	          case 38:
	            // &
	            escape = '&amp;';
	            break;
	          case 39:
	            // '
	            escape = '&#x27;'; // modified from escape-html; used to be '&#39'

	            break;
	          case 60:
	            // <
	            escape = '&lt;';
	            break;
	          case 62:
	            // >
	            escape = '&gt;';
	            break;
	          default:
	            continue;
	        }
	        if (lastIndex !== index) {
	          html += str.substring(lastIndex, index);
	        }
	        lastIndex = index + 1;
	        html += escape;
	      }
	      return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
	    } // end code copied and modified from escape-html

	    /**
	     * Escapes text to prevent scripting attacks.
	     *
	     * @param {*} text Text value to escape.
	     * @return {string} An escaped string.
	     */

	    function escapeTextForBrowser(text) {
	      if (typeof text === 'boolean' || typeof text === 'number') {
	        // this shortcircuit helps perf for types that we know will never have
	        // special characters, especially given that this function is used often
	        // for numeric dom ids.
	        return '' + text;
	      }
	      return escapeHtml(text);
	    }
	    var uppercasePattern = /([A-Z])/g;
	    var msPattern$1 = /^ms-/;
	    /**
	     * Hyphenates a camelcased CSS property name, for example:
	     *
	     *   > hyphenateStyleName('backgroundColor')
	     *   < "background-color"
	     *   > hyphenateStyleName('MozTransition')
	     *   < "-moz-transition"
	     *   > hyphenateStyleName('msTransition')
	     *   < "-ms-transition"
	     *
	     * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	     * is converted to `-ms-`.
	     */

	    function hyphenateStyleName(name) {
	      return name.replace(uppercasePattern, '-$1').toLowerCase().replace(msPattern$1, '-ms-');
	    }

	    // and any newline or tab are filtered out as if they're not part of the URL.
	    // https://url.spec.whatwg.org/#url-parsing
	    // Tab or newline are defined as \r\n\t:
	    // https://infra.spec.whatwg.org/#ascii-tab-or-newline
	    // A C0 control is a code point in the range \u0000 NULL to \u001F
	    // INFORMATION SEPARATOR ONE, inclusive:
	    // https://infra.spec.whatwg.org/#c0-control-or-space

	    /* eslint-disable max-len */

	    var isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*\:/i;
	    var didWarn = false;
	    function sanitizeURL(url) {
	      {
	        if (!didWarn && isJavaScriptProtocol.test(url)) {
	          didWarn = true;
	          error('A future version of React will block javascript: URLs as a security precaution. ' + 'Use event handlers instead if you can. If you need to generate unsafe HTML try ' + 'using dangerouslySetInnerHTML instead. React was passed %s.', JSON.stringify(url));
	        }
	      }
	    }
	    var isArrayImpl = Array.isArray; // eslint-disable-next-line no-redeclare

	    function isArray(a) {
	      return isArrayImpl(a);
	    }
	    var startInlineScript = stringToPrecomputedChunk('<script>');

	    function createResponseState(identifierPrefix, nonce, bootstrapScriptContent, bootstrapScripts, bootstrapModules) {
	      var idPrefix = identifierPrefix === undefined ? '' : identifierPrefix;
	      var inlineScriptWithNonce = startInlineScript ;
	      var bootstrapChunks = [];
	      return {
	        bootstrapChunks: bootstrapChunks,
	        startInlineScript: inlineScriptWithNonce,
	        placeholderPrefix: stringToPrecomputedChunk(idPrefix + 'P:'),
	        segmentPrefix: stringToPrecomputedChunk(idPrefix + 'S:'),
	        boundaryPrefix: idPrefix + 'B:',
	        idPrefix: idPrefix,
	        nextSuspenseID: 0,
	        sentCompleteSegmentFunction: false,
	        sentCompleteBoundaryFunction: false,
	        sentClientRenderFunction: false
	      };
	    } // Constants for the insertion mode we're currently writing in. We don't encode all HTML5 insertion
	    // modes. We only include the variants as they matter for the sake of our purposes.
	    // We don't actually provide the namespace therefore we use constants instead of the string.

	    var ROOT_HTML_MODE = 0; // Used for the root most element tag.

	    var HTML_MODE = 1;
	    var SVG_MODE = 2;
	    var MATHML_MODE = 3;
	    var HTML_TABLE_MODE = 4;
	    var HTML_TABLE_BODY_MODE = 5;
	    var HTML_TABLE_ROW_MODE = 6;
	    var HTML_COLGROUP_MODE = 7; // We have a greater than HTML_TABLE_MODE check elsewhere. If you add more cases here, make sure it
	    // still makes sense

	    function createFormatContext(insertionMode, selectedValue) {
	      return {
	        insertionMode: insertionMode,
	        selectedValue: selectedValue
	      };
	    }
	    function getChildFormatContext(parentContext, type, props) {
	      switch (type) {
	        case 'select':
	          return createFormatContext(HTML_MODE, props.value != null ? props.value : props.defaultValue);
	        case 'svg':
	          return createFormatContext(SVG_MODE, null);
	        case 'math':
	          return createFormatContext(MATHML_MODE, null);
	        case 'foreignObject':
	          return createFormatContext(HTML_MODE, null);
	        // Table parents are special in that their children can only be created at all if they're
	        // wrapped in a table parent. So we need to encode that we're entering this mode.

	        case 'table':
	          return createFormatContext(HTML_TABLE_MODE, null);
	        case 'thead':
	        case 'tbody':
	        case 'tfoot':
	          return createFormatContext(HTML_TABLE_BODY_MODE, null);
	        case 'colgroup':
	          return createFormatContext(HTML_COLGROUP_MODE, null);
	        case 'tr':
	          return createFormatContext(HTML_TABLE_ROW_MODE, null);
	      }
	      if (parentContext.insertionMode >= HTML_TABLE_MODE) {
	        // Whatever tag this was, it wasn't a table parent or other special parent, so we must have
	        // entered plain HTML again.
	        return createFormatContext(HTML_MODE, null);
	      }
	      if (parentContext.insertionMode === ROOT_HTML_MODE) {
	        // We've emitted the root and is now in plain HTML mode.
	        return createFormatContext(HTML_MODE, null);
	      }
	      return parentContext;
	    }
	    var UNINITIALIZED_SUSPENSE_BOUNDARY_ID = null;
	    function assignSuspenseBoundaryID(responseState) {
	      var generatedID = responseState.nextSuspenseID++;
	      return stringToPrecomputedChunk(responseState.boundaryPrefix + generatedID.toString(16));
	    }
	    function makeId(responseState, treeId, localId) {
	      var idPrefix = responseState.idPrefix;
	      var id = ':' + idPrefix + 'R' + treeId; // Unless this is the first id at this level, append a number at the end
	      // that represents the position of this useId hook among all the useId
	      // hooks for this fiber.

	      if (localId > 0) {
	        id += 'H' + localId.toString(32);
	      }
	      return id + ':';
	    }
	    function encodeHTMLTextNode(text) {
	      return escapeTextForBrowser(text);
	    }
	    var textSeparator = stringToPrecomputedChunk('<!-- -->');
	    function pushTextInstance(target, text, responseState, textEmbedded) {
	      if (text === '') {
	        // Empty text doesn't have a DOM node representation and the hydration is aware of this.
	        return textEmbedded;
	      }
	      if (textEmbedded) {
	        target.push(textSeparator);
	      }
	      target.push(stringToChunk(encodeHTMLTextNode(text)));
	      return true;
	    } // Called when Fizz is done with a Segment. Currently the only purpose is to conditionally
	    // emit a text separator when we don't know for sure it is safe to omit

	    function pushSegmentFinale(target, responseState, lastPushedText, textEmbedded) {
	      if (lastPushedText && textEmbedded) {
	        target.push(textSeparator);
	      }
	    }
	    var styleNameCache = new Map();
	    function processStyleName(styleName) {
	      var chunk = styleNameCache.get(styleName);
	      if (chunk !== undefined) {
	        return chunk;
	      }
	      var result = stringToPrecomputedChunk(escapeTextForBrowser(hyphenateStyleName(styleName)));
	      styleNameCache.set(styleName, result);
	      return result;
	    }
	    var styleAttributeStart = stringToPrecomputedChunk(' style="');
	    var styleAssign = stringToPrecomputedChunk(':');
	    var styleSeparator = stringToPrecomputedChunk(';');
	    function pushStyle(target, responseState, style) {
	      if (typeof style !== 'object') {
	        throw new Error('The `style` prop expects a mapping from style properties to values, ' + "not a string. For example, style={{marginRight: spacing + 'em'}} when " + 'using JSX.');
	      }
	      var isFirst = true;
	      for (var styleName in style) {
	        if (!hasOwnProperty.call(style, styleName)) {
	          continue;
	        } // If you provide unsafe user data here they can inject arbitrary CSS
	        // which may be problematic (I couldn't repro this):
	        // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
	        // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
	        // This is not an XSS hole but instead a potential CSS injection issue
	        // which has lead to a greater discussion about how we're going to
	        // trust URLs moving forward. See #2115901

	        var styleValue = style[styleName];
	        if (styleValue == null || typeof styleValue === 'boolean' || styleValue === '') {
	          // TODO: We used to set empty string as a style with an empty value. Does that ever make sense?
	          continue;
	        }
	        var nameChunk = void 0;
	        var valueChunk = void 0;
	        var isCustomProperty = styleName.indexOf('--') === 0;
	        if (isCustomProperty) {
	          nameChunk = stringToChunk(escapeTextForBrowser(styleName));
	          {
	            checkCSSPropertyStringCoercion(styleValue, styleName);
	          }
	          valueChunk = stringToChunk(escapeTextForBrowser(('' + styleValue).trim()));
	        } else {
	          {
	            warnValidStyle$1(styleName, styleValue);
	          }
	          nameChunk = processStyleName(styleName);
	          if (typeof styleValue === 'number') {
	            if (styleValue !== 0 && !hasOwnProperty.call(isUnitlessNumber, styleName)) {
	              valueChunk = stringToChunk(styleValue + 'px'); // Presumes implicit 'px' suffix for unitless numbers
	            } else {
	              valueChunk = stringToChunk('' + styleValue);
	            }
	          } else {
	            {
	              checkCSSPropertyStringCoercion(styleValue, styleName);
	            }
	            valueChunk = stringToChunk(escapeTextForBrowser(('' + styleValue).trim()));
	          }
	        }
	        if (isFirst) {
	          isFirst = false; // If it's first, we don't need any separators prefixed.

	          target.push(styleAttributeStart, nameChunk, styleAssign, valueChunk);
	        } else {
	          target.push(styleSeparator, nameChunk, styleAssign, valueChunk);
	        }
	      }
	      if (!isFirst) {
	        target.push(attributeEnd);
	      }
	    }
	    var attributeSeparator = stringToPrecomputedChunk(' ');
	    var attributeAssign = stringToPrecomputedChunk('="');
	    var attributeEnd = stringToPrecomputedChunk('"');
	    var attributeEmptyString = stringToPrecomputedChunk('=""');
	    function pushAttribute(target, responseState, name, value) {
	      switch (name) {
	        case 'style':
	          {
	            pushStyle(target, responseState, value);
	            return;
	          }
	        case 'defaultValue':
	        case 'defaultChecked': // These shouldn't be set as attributes on generic HTML elements.

	        case 'innerHTML': // Must use dangerouslySetInnerHTML instead.

	        case 'suppressContentEditableWarning':
	        case 'suppressHydrationWarning':
	          // Ignored. These are built-in to React on the client.
	          return;
	      }
	      if (
	      // shouldIgnoreAttribute
	      // We have already filtered out null/undefined and reserved words.
	      name.length > 2 && (name[0] === 'o' || name[0] === 'O') && (name[1] === 'n' || name[1] === 'N')) {
	        return;
	      }
	      var propertyInfo = getPropertyInfo(name);
	      if (propertyInfo !== null) {
	        // shouldRemoveAttribute
	        switch (typeof value) {
	          case 'function': // $FlowIssue symbol is perfectly valid here

	          case 'symbol':
	            // eslint-disable-line
	            return;
	          case 'boolean':
	            {
	              if (!propertyInfo.acceptsBooleans) {
	                return;
	              }
	            }
	        }
	        var attributeName = propertyInfo.attributeName;
	        var attributeNameChunk = stringToChunk(attributeName); // TODO: If it's known we can cache the chunk.

	        switch (propertyInfo.type) {
	          case BOOLEAN:
	            if (value) {
	              target.push(attributeSeparator, attributeNameChunk, attributeEmptyString);
	            }
	            return;
	          case OVERLOADED_BOOLEAN:
	            if (value === true) {
	              target.push(attributeSeparator, attributeNameChunk, attributeEmptyString);
	            } else if (value === false) ;else {
	              target.push(attributeSeparator, attributeNameChunk, attributeAssign, stringToChunk(escapeTextForBrowser(value)), attributeEnd);
	            }
	            return;
	          case NUMERIC:
	            if (!isNaN(value)) {
	              target.push(attributeSeparator, attributeNameChunk, attributeAssign, stringToChunk(escapeTextForBrowser(value)), attributeEnd);
	            }
	            break;
	          case POSITIVE_NUMERIC:
	            if (!isNaN(value) && value >= 1) {
	              target.push(attributeSeparator, attributeNameChunk, attributeAssign, stringToChunk(escapeTextForBrowser(value)), attributeEnd);
	            }
	            break;
	          default:
	            if (propertyInfo.sanitizeURL) {
	              {
	                checkAttributeStringCoercion(value, attributeName);
	              }
	              value = '' + value;
	              sanitizeURL(value);
	            }
	            target.push(attributeSeparator, attributeNameChunk, attributeAssign, stringToChunk(escapeTextForBrowser(value)), attributeEnd);
	        }
	      } else if (isAttributeNameSafe(name)) {
	        // shouldRemoveAttribute
	        switch (typeof value) {
	          case 'function': // $FlowIssue symbol is perfectly valid here

	          case 'symbol':
	            // eslint-disable-line
	            return;
	          case 'boolean':
	            {
	              var prefix = name.toLowerCase().slice(0, 5);
	              if (prefix !== 'data-' && prefix !== 'aria-') {
	                return;
	              }
	            }
	        }
	        target.push(attributeSeparator, stringToChunk(name), attributeAssign, stringToChunk(escapeTextForBrowser(value)), attributeEnd);
	      }
	    }
	    var endOfStartTag = stringToPrecomputedChunk('>');
	    var endOfStartTagSelfClosing = stringToPrecomputedChunk('/>');
	    function pushInnerHTML(target, innerHTML, children) {
	      if (innerHTML != null) {
	        if (children != null) {
	          throw new Error('Can only set one of `children` or `props.dangerouslySetInnerHTML`.');
	        }
	        if (typeof innerHTML !== 'object' || !('__html' in innerHTML)) {
	          throw new Error('`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. ' + 'Please visit https://reactjs.org/link/dangerously-set-inner-html ' + 'for more information.');
	        }
	        var html = innerHTML.__html;
	        if (html !== null && html !== undefined) {
	          {
	            checkHtmlStringCoercion(html);
	          }
	          target.push(stringToChunk('' + html));
	        }
	      }
	    } // TODO: Move these to ResponseState so that we warn for every request.
	    // It would help debugging in stateful servers (e.g. service worker).

	    var didWarnDefaultInputValue = false;
	    var didWarnDefaultChecked = false;
	    var didWarnDefaultSelectValue = false;
	    var didWarnDefaultTextareaValue = false;
	    var didWarnInvalidOptionChildren = false;
	    var didWarnInvalidOptionInnerHTML = false;
	    var didWarnSelectedSetOnOption = false;
	    function checkSelectProp(props, propName) {
	      {
	        var value = props[propName];
	        if (value != null) {
	          var array = isArray(value);
	          if (props.multiple && !array) {
	            error('The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.', propName);
	          } else if (!props.multiple && array) {
	            error('The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.', propName);
	          }
	        }
	      }
	    }
	    function pushStartSelect(target, props, responseState) {
	      {
	        checkControlledValueProps('select', props);
	        checkSelectProp(props, 'value');
	        checkSelectProp(props, 'defaultValue');
	        if (props.value !== undefined && props.defaultValue !== undefined && !didWarnDefaultSelectValue) {
	          error('Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://reactjs.org/link/controlled-components');
	          didWarnDefaultSelectValue = true;
	        }
	      }
	      target.push(startChunkForTag('select'));
	      var children = null;
	      var innerHTML = null;
	      for (var propKey in props) {
	        if (hasOwnProperty.call(props, propKey)) {
	          var propValue = props[propKey];
	          if (propValue == null) {
	            continue;
	          }
	          switch (propKey) {
	            case 'children':
	              children = propValue;
	              break;
	            case 'dangerouslySetInnerHTML':
	              // TODO: This doesn't really make sense for select since it can't use the controlled
	              // value in the innerHTML.
	              innerHTML = propValue;
	              break;
	            case 'defaultValue':
	            case 'value':
	              // These are set on the Context instead and applied to the nested options.
	              break;
	            default:
	              pushAttribute(target, responseState, propKey, propValue);
	              break;
	          }
	        }
	      }
	      target.push(endOfStartTag);
	      pushInnerHTML(target, innerHTML, children);
	      return children;
	    }
	    function flattenOptionChildren(children) {
	      var content = ''; // Flatten children and warn if they aren't strings or numbers;
	      // invalid types are ignored.

	      React$1.Children.forEach(children, function (child) {
	        if (child == null) {
	          return;
	        }
	        content += child;
	        {
	          if (!didWarnInvalidOptionChildren && typeof child !== 'string' && typeof child !== 'number') {
	            didWarnInvalidOptionChildren = true;
	            error('Cannot infer the option value of complex children. ' + 'Pass a `value` prop or use a plain string as children to <option>.');
	          }
	        }
	      });
	      return content;
	    }
	    var selectedMarkerAttribute = stringToPrecomputedChunk(' selected=""');
	    function pushStartOption(target, props, responseState, formatContext) {
	      var selectedValue = formatContext.selectedValue;
	      target.push(startChunkForTag('option'));
	      var children = null;
	      var value = null;
	      var selected = null;
	      var innerHTML = null;
	      for (var propKey in props) {
	        if (hasOwnProperty.call(props, propKey)) {
	          var propValue = props[propKey];
	          if (propValue == null) {
	            continue;
	          }
	          switch (propKey) {
	            case 'children':
	              children = propValue;
	              break;
	            case 'selected':
	              // ignore
	              selected = propValue;
	              {
	                // TODO: Remove support for `selected` in <option>.
	                if (!didWarnSelectedSetOnOption) {
	                  error('Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.');
	                  didWarnSelectedSetOnOption = true;
	                }
	              }
	              break;
	            case 'dangerouslySetInnerHTML':
	              innerHTML = propValue;
	              break;
	            // eslint-disable-next-line-no-fallthrough

	            case 'value':
	              value = propValue;
	            // We intentionally fallthrough to also set the attribute on the node.
	            // eslint-disable-next-line-no-fallthrough

	            default:
	              pushAttribute(target, responseState, propKey, propValue);
	              break;
	          }
	        }
	      }
	      if (selectedValue != null) {
	        var stringValue;
	        if (value !== null) {
	          {
	            checkAttributeStringCoercion(value, 'value');
	          }
	          stringValue = '' + value;
	        } else {
	          {
	            if (innerHTML !== null) {
	              if (!didWarnInvalidOptionInnerHTML) {
	                didWarnInvalidOptionInnerHTML = true;
	                error('Pass a `value` prop if you set dangerouslyInnerHTML so React knows ' + 'which value should be selected.');
	              }
	            }
	          }
	          stringValue = flattenOptionChildren(children);
	        }
	        if (isArray(selectedValue)) {
	          // multiple
	          for (var i = 0; i < selectedValue.length; i++) {
	            {
	              checkAttributeStringCoercion(selectedValue[i], 'value');
	            }
	            var v = '' + selectedValue[i];
	            if (v === stringValue) {
	              target.push(selectedMarkerAttribute);
	              break;
	            }
	          }
	        } else {
	          {
	            checkAttributeStringCoercion(selectedValue, 'select.value');
	          }
	          if ('' + selectedValue === stringValue) {
	            target.push(selectedMarkerAttribute);
	          }
	        }
	      } else if (selected) {
	        target.push(selectedMarkerAttribute);
	      }
	      target.push(endOfStartTag);
	      pushInnerHTML(target, innerHTML, children);
	      return children;
	    }
	    function pushInput(target, props, responseState) {
	      {
	        checkControlledValueProps('input', props);
	        if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnDefaultChecked) {
	          error('%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://reactjs.org/link/controlled-components', 'A component', props.type);
	          didWarnDefaultChecked = true;
	        }
	        if (props.value !== undefined && props.defaultValue !== undefined && !didWarnDefaultInputValue) {
	          error('%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://reactjs.org/link/controlled-components', 'A component', props.type);
	          didWarnDefaultInputValue = true;
	        }
	      }
	      target.push(startChunkForTag('input'));
	      var value = null;
	      var defaultValue = null;
	      var checked = null;
	      var defaultChecked = null;
	      for (var propKey in props) {
	        if (hasOwnProperty.call(props, propKey)) {
	          var propValue = props[propKey];
	          if (propValue == null) {
	            continue;
	          }
	          switch (propKey) {
	            case 'children':
	            case 'dangerouslySetInnerHTML':
	              throw new Error('input' + " is a self-closing tag and must neither have `children` nor " + 'use `dangerouslySetInnerHTML`.');
	            // eslint-disable-next-line-no-fallthrough

	            case 'defaultChecked':
	              defaultChecked = propValue;
	              break;
	            case 'defaultValue':
	              defaultValue = propValue;
	              break;
	            case 'checked':
	              checked = propValue;
	              break;
	            case 'value':
	              value = propValue;
	              break;
	            default:
	              pushAttribute(target, responseState, propKey, propValue);
	              break;
	          }
	        }
	      }
	      if (checked !== null) {
	        pushAttribute(target, responseState, 'checked', checked);
	      } else if (defaultChecked !== null) {
	        pushAttribute(target, responseState, 'checked', defaultChecked);
	      }
	      if (value !== null) {
	        pushAttribute(target, responseState, 'value', value);
	      } else if (defaultValue !== null) {
	        pushAttribute(target, responseState, 'value', defaultValue);
	      }
	      target.push(endOfStartTagSelfClosing);
	      return null;
	    }
	    function pushStartTextArea(target, props, responseState) {
	      {
	        checkControlledValueProps('textarea', props);
	        if (props.value !== undefined && props.defaultValue !== undefined && !didWarnDefaultTextareaValue) {
	          error('Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://reactjs.org/link/controlled-components');
	          didWarnDefaultTextareaValue = true;
	        }
	      }
	      target.push(startChunkForTag('textarea'));
	      var value = null;
	      var defaultValue = null;
	      var children = null;
	      for (var propKey in props) {
	        if (hasOwnProperty.call(props, propKey)) {
	          var propValue = props[propKey];
	          if (propValue == null) {
	            continue;
	          }
	          switch (propKey) {
	            case 'children':
	              children = propValue;
	              break;
	            case 'value':
	              value = propValue;
	              break;
	            case 'defaultValue':
	              defaultValue = propValue;
	              break;
	            case 'dangerouslySetInnerHTML':
	              throw new Error('`dangerouslySetInnerHTML` does not make sense on <textarea>.');
	            // eslint-disable-next-line-no-fallthrough

	            default:
	              pushAttribute(target, responseState, propKey, propValue);
	              break;
	          }
	        }
	      }
	      if (value === null && defaultValue !== null) {
	        value = defaultValue;
	      }
	      target.push(endOfStartTag); // TODO (yungsters): Remove support for children content in <textarea>.

	      if (children != null) {
	        {
	          error('Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.');
	        }
	        if (value != null) {
	          throw new Error('If you supply `defaultValue` on a <textarea>, do not pass children.');
	        }
	        if (isArray(children)) {
	          if (children.length > 1) {
	            throw new Error('<textarea> can only have at most one child.');
	          } // TODO: remove the coercion and the DEV check below because it will
	          // always be overwritten by the coercion several lines below it. #22309

	          {
	            checkHtmlStringCoercion(children[0]);
	          }
	          value = '' + children[0];
	        }
	        {
	          checkHtmlStringCoercion(children);
	        }
	        value = '' + children;
	      }
	      if (typeof value === 'string' && value[0] === '\n') {
	        // text/html ignores the first character in these tags if it's a newline
	        // Prefer to break application/xml over text/html (for now) by adding
	        // a newline specifically to get eaten by the parser. (Alternately for
	        // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
	        // \r is normalized out by HTMLTextAreaElement#value.)
	        // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
	        // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
	        // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
	        // See: Parsing of "textarea" "listing" and "pre" elements
	        //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
	        target.push(leadingNewline);
	      } // ToString and push directly instead of recurse over children.
	      // We don't really support complex children in the value anyway.
	      // This also currently avoids a trailing comment node which breaks textarea.

	      if (value !== null) {
	        {
	          checkAttributeStringCoercion(value, 'value');
	        }
	        target.push(stringToChunk(encodeHTMLTextNode('' + value)));
	      }
	      return null;
	    }
	    function pushSelfClosing(target, props, tag, responseState) {
	      target.push(startChunkForTag(tag));
	      for (var propKey in props) {
	        if (hasOwnProperty.call(props, propKey)) {
	          var propValue = props[propKey];
	          if (propValue == null) {
	            continue;
	          }
	          switch (propKey) {
	            case 'children':
	            case 'dangerouslySetInnerHTML':
	              throw new Error(tag + " is a self-closing tag and must neither have `children` nor " + 'use `dangerouslySetInnerHTML`.');
	            // eslint-disable-next-line-no-fallthrough

	            default:
	              pushAttribute(target, responseState, propKey, propValue);
	              break;
	          }
	        }
	      }
	      target.push(endOfStartTagSelfClosing);
	      return null;
	    }
	    function pushStartMenuItem(target, props, responseState) {
	      target.push(startChunkForTag('menuitem'));
	      for (var propKey in props) {
	        if (hasOwnProperty.call(props, propKey)) {
	          var propValue = props[propKey];
	          if (propValue == null) {
	            continue;
	          }
	          switch (propKey) {
	            case 'children':
	            case 'dangerouslySetInnerHTML':
	              throw new Error('menuitems cannot have `children` nor `dangerouslySetInnerHTML`.');
	            // eslint-disable-next-line-no-fallthrough

	            default:
	              pushAttribute(target, responseState, propKey, propValue);
	              break;
	          }
	        }
	      }
	      target.push(endOfStartTag);
	      return null;
	    }
	    function pushStartTitle(target, props, responseState) {
	      target.push(startChunkForTag('title'));
	      var children = null;
	      for (var propKey in props) {
	        if (hasOwnProperty.call(props, propKey)) {
	          var propValue = props[propKey];
	          if (propValue == null) {
	            continue;
	          }
	          switch (propKey) {
	            case 'children':
	              children = propValue;
	              break;
	            case 'dangerouslySetInnerHTML':
	              throw new Error('`dangerouslySetInnerHTML` does not make sense on <title>.');
	            // eslint-disable-next-line-no-fallthrough

	            default:
	              pushAttribute(target, responseState, propKey, propValue);
	              break;
	          }
	        }
	      }
	      target.push(endOfStartTag);
	      {
	        var child = Array.isArray(children) && children.length < 2 ? children[0] || null : children;
	        if (Array.isArray(children) && children.length > 1) {
	          error('A title element received an array with more than 1 element as children. ' + 'In browsers title Elements can only have Text Nodes as children. If ' + 'the children being rendered output more than a single text node in aggregate the browser ' + 'will display markup and comments as text in the title and hydration will likely fail and ' + 'fall back to client rendering');
	        } else if (child != null && child.$$typeof != null) {
	          error('A title element received a React element for children. ' + 'In the browser title Elements can only have Text Nodes as children. If ' + 'the children being rendered output more than a single text node in aggregate the browser ' + 'will display markup and comments as text in the title and hydration will likely fail and ' + 'fall back to client rendering');
	        } else if (child != null && typeof child !== 'string' && typeof child !== 'number') {
	          error('A title element received a value that was not a string or number for children. ' + 'In the browser title Elements can only have Text Nodes as children. If ' + 'the children being rendered output more than a single text node in aggregate the browser ' + 'will display markup and comments as text in the title and hydration will likely fail and ' + 'fall back to client rendering');
	        }
	      }
	      return children;
	    }
	    function pushStartGenericElement(target, props, tag, responseState) {
	      target.push(startChunkForTag(tag));
	      var children = null;
	      var innerHTML = null;
	      for (var propKey in props) {
	        if (hasOwnProperty.call(props, propKey)) {
	          var propValue = props[propKey];
	          if (propValue == null) {
	            continue;
	          }
	          switch (propKey) {
	            case 'children':
	              children = propValue;
	              break;
	            case 'dangerouslySetInnerHTML':
	              innerHTML = propValue;
	              break;
	            default:
	              pushAttribute(target, responseState, propKey, propValue);
	              break;
	          }
	        }
	      }
	      target.push(endOfStartTag);
	      pushInnerHTML(target, innerHTML, children);
	      if (typeof children === 'string') {
	        // Special case children as a string to avoid the unnecessary comment.
	        // TODO: Remove this special case after the general optimization is in place.
	        target.push(stringToChunk(encodeHTMLTextNode(children)));
	        return null;
	      }
	      return children;
	    }
	    function pushStartCustomElement(target, props, tag, responseState) {
	      target.push(startChunkForTag(tag));
	      var children = null;
	      var innerHTML = null;
	      for (var propKey in props) {
	        if (hasOwnProperty.call(props, propKey)) {
	          var propValue = props[propKey];
	          if (propValue == null) {
	            continue;
	          }
	          switch (propKey) {
	            case 'children':
	              children = propValue;
	              break;
	            case 'dangerouslySetInnerHTML':
	              innerHTML = propValue;
	              break;
	            case 'style':
	              pushStyle(target, responseState, propValue);
	              break;
	            case 'suppressContentEditableWarning':
	            case 'suppressHydrationWarning':
	              // Ignored. These are built-in to React on the client.
	              break;
	            default:
	              if (isAttributeNameSafe(propKey) && typeof propValue !== 'function' && typeof propValue !== 'symbol') {
	                target.push(attributeSeparator, stringToChunk(propKey), attributeAssign, stringToChunk(escapeTextForBrowser(propValue)), attributeEnd);
	              }
	              break;
	          }
	        }
	      }
	      target.push(endOfStartTag);
	      pushInnerHTML(target, innerHTML, children);
	      return children;
	    }
	    var leadingNewline = stringToPrecomputedChunk('\n');
	    function pushStartPreformattedElement(target, props, tag, responseState) {
	      target.push(startChunkForTag(tag));
	      var children = null;
	      var innerHTML = null;
	      for (var propKey in props) {
	        if (hasOwnProperty.call(props, propKey)) {
	          var propValue = props[propKey];
	          if (propValue == null) {
	            continue;
	          }
	          switch (propKey) {
	            case 'children':
	              children = propValue;
	              break;
	            case 'dangerouslySetInnerHTML':
	              innerHTML = propValue;
	              break;
	            default:
	              pushAttribute(target, responseState, propKey, propValue);
	              break;
	          }
	        }
	      }
	      target.push(endOfStartTag); // text/html ignores the first character in these tags if it's a newline
	      // Prefer to break application/xml over text/html (for now) by adding
	      // a newline specifically to get eaten by the parser. (Alternately for
	      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
	      // \r is normalized out by HTMLTextAreaElement#value.)
	      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
	      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
	      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
	      // See: Parsing of "textarea" "listing" and "pre" elements
	      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
	      // TODO: This doesn't deal with the case where the child is an array
	      // or component that returns a string.

	      if (innerHTML != null) {
	        if (children != null) {
	          throw new Error('Can only set one of `children` or `props.dangerouslySetInnerHTML`.');
	        }
	        if (typeof innerHTML !== 'object' || !('__html' in innerHTML)) {
	          throw new Error('`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. ' + 'Please visit https://reactjs.org/link/dangerously-set-inner-html ' + 'for more information.');
	        }
	        var html = innerHTML.__html;
	        if (html !== null && html !== undefined) {
	          if (typeof html === 'string' && html.length > 0 && html[0] === '\n') {
	            target.push(leadingNewline, stringToChunk(html));
	          } else {
	            {
	              checkHtmlStringCoercion(html);
	            }
	            target.push(stringToChunk('' + html));
	          }
	        }
	      }
	      if (typeof children === 'string' && children[0] === '\n') {
	        target.push(leadingNewline);
	      }
	      return children;
	    } // We accept any tag to be rendered but since this gets injected into arbitrary
	    // HTML, we want to make sure that it's a safe tag.
	    // http://www.w3.org/TR/REC-xml/#NT-Name

	    var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset

	    var validatedTagCache = new Map();
	    function startChunkForTag(tag) {
	      var tagStartChunk = validatedTagCache.get(tag);
	      if (tagStartChunk === undefined) {
	        if (!VALID_TAG_REGEX.test(tag)) {
	          throw new Error("Invalid tag: " + tag);
	        }
	        tagStartChunk = stringToPrecomputedChunk('<' + tag);
	        validatedTagCache.set(tag, tagStartChunk);
	      }
	      return tagStartChunk;
	    }
	    var DOCTYPE = stringToPrecomputedChunk('<!DOCTYPE html>');
	    function pushStartInstance(target, type, props, responseState, formatContext) {
	      {
	        validateProperties(type, props);
	        validateProperties$1(type, props);
	        validateProperties$2(type, props, null);
	        if (!props.suppressContentEditableWarning && props.contentEditable && props.children != null) {
	          error('A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.');
	        }
	        if (formatContext.insertionMode !== SVG_MODE && formatContext.insertionMode !== MATHML_MODE) {
	          if (type.indexOf('-') === -1 && typeof props.is !== 'string' && type.toLowerCase() !== type) {
	            error('<%s /> is using incorrect casing. ' + 'Use PascalCase for React components, ' + 'or lowercase for HTML elements.', type);
	          }
	        }
	      }
	      switch (type) {
	        // Special tags
	        case 'select':
	          return pushStartSelect(target, props, responseState);
	        case 'option':
	          return pushStartOption(target, props, responseState, formatContext);
	        case 'textarea':
	          return pushStartTextArea(target, props, responseState);
	        case 'input':
	          return pushInput(target, props, responseState);
	        case 'menuitem':
	          return pushStartMenuItem(target, props, responseState);
	        case 'title':
	          return pushStartTitle(target, props, responseState);
	        // Newline eating tags

	        case 'listing':
	        case 'pre':
	          {
	            return pushStartPreformattedElement(target, props, type, responseState);
	          }
	        // Omitted close tags

	        case 'area':
	        case 'base':
	        case 'br':
	        case 'col':
	        case 'embed':
	        case 'hr':
	        case 'img':
	        case 'keygen':
	        case 'link':
	        case 'meta':
	        case 'param':
	        case 'source':
	        case 'track':
	        case 'wbr':
	          {
	            return pushSelfClosing(target, props, type, responseState);
	          }
	        // These are reserved SVG and MathML elements, that are never custom elements.
	        // https://w3c.github.io/webcomponents/spec/custom/#custom-elements-core-concepts

	        case 'annotation-xml':
	        case 'color-profile':
	        case 'font-face':
	        case 'font-face-src':
	        case 'font-face-uri':
	        case 'font-face-format':
	        case 'font-face-name':
	        case 'missing-glyph':
	          {
	            return pushStartGenericElement(target, props, type, responseState);
	          }
	        case 'html':
	          {
	            if (formatContext.insertionMode === ROOT_HTML_MODE) {
	              // If we're rendering the html tag and we're at the root (i.e. not in foreignObject)
	              // then we also emit the DOCTYPE as part of the root content as a convenience for
	              // rendering the whole document.
	              target.push(DOCTYPE);
	            }
	            return pushStartGenericElement(target, props, type, responseState);
	          }
	        default:
	          {
	            if (type.indexOf('-') === -1 && typeof props.is !== 'string') {
	              // Generic element
	              return pushStartGenericElement(target, props, type, responseState);
	            } else {
	              // Custom element
	              return pushStartCustomElement(target, props, type, responseState);
	            }
	          }
	      }
	    }
	    var endTag1 = stringToPrecomputedChunk('</');
	    var endTag2 = stringToPrecomputedChunk('>');
	    function pushEndInstance(target, type, props) {
	      switch (type) {
	        // Omitted close tags
	        // TODO: Instead of repeating this switch we could try to pass a flag from above.
	        // That would require returning a tuple. Which might be ok if it gets inlined.
	        case 'area':
	        case 'base':
	        case 'br':
	        case 'col':
	        case 'embed':
	        case 'hr':
	        case 'img':
	        case 'input':
	        case 'keygen':
	        case 'link':
	        case 'meta':
	        case 'param':
	        case 'source':
	        case 'track':
	        case 'wbr':
	          {
	            // No close tag needed.
	            break;
	          }
	        default:
	          {
	            target.push(endTag1, stringToChunk(type), endTag2);
	          }
	      }
	    }
	    function writeCompletedRoot(destination, responseState) {
	      var bootstrapChunks = responseState.bootstrapChunks;
	      var i = 0;
	      for (; i < bootstrapChunks.length - 1; i++) {
	        writeChunk(destination, bootstrapChunks[i]);
	      }
	      if (i < bootstrapChunks.length) {
	        return writeChunkAndReturn(destination, bootstrapChunks[i]);
	      }
	      return true;
	    } // Structural Nodes
	    // A placeholder is a node inside a hidden partial tree that can be filled in later, but before
	    // display. It's never visible to users. We use the template tag because it can be used in every
	    // type of parent. <script> tags also work in every other tag except <colgroup>.

	    var placeholder1 = stringToPrecomputedChunk('<template id="');
	    var placeholder2 = stringToPrecomputedChunk('"></template>');
	    function writePlaceholder(destination, responseState, id) {
	      writeChunk(destination, placeholder1);
	      writeChunk(destination, responseState.placeholderPrefix);
	      var formattedID = stringToChunk(id.toString(16));
	      writeChunk(destination, formattedID);
	      return writeChunkAndReturn(destination, placeholder2);
	    } // Suspense boundaries are encoded as comments.

	    var startCompletedSuspenseBoundary = stringToPrecomputedChunk('<!--$-->');
	    var startPendingSuspenseBoundary1 = stringToPrecomputedChunk('<!--$?--><template id="');
	    var startPendingSuspenseBoundary2 = stringToPrecomputedChunk('"></template>');
	    var startClientRenderedSuspenseBoundary = stringToPrecomputedChunk('<!--$!-->');
	    var endSuspenseBoundary = stringToPrecomputedChunk('<!--/$-->');
	    var clientRenderedSuspenseBoundaryError1 = stringToPrecomputedChunk('<template');
	    var clientRenderedSuspenseBoundaryErrorAttrInterstitial = stringToPrecomputedChunk('"');
	    var clientRenderedSuspenseBoundaryError1A = stringToPrecomputedChunk(' data-dgst="');
	    var clientRenderedSuspenseBoundaryError1B = stringToPrecomputedChunk(' data-msg="');
	    var clientRenderedSuspenseBoundaryError1C = stringToPrecomputedChunk(' data-stck="');
	    var clientRenderedSuspenseBoundaryError2 = stringToPrecomputedChunk('></template>');
	    function writeStartCompletedSuspenseBoundary(destination, responseState) {
	      return writeChunkAndReturn(destination, startCompletedSuspenseBoundary);
	    }
	    function writeStartPendingSuspenseBoundary(destination, responseState, id) {
	      writeChunk(destination, startPendingSuspenseBoundary1);
	      if (id === null) {
	        throw new Error('An ID must have been assigned before we can complete the boundary.');
	      }
	      writeChunk(destination, id);
	      return writeChunkAndReturn(destination, startPendingSuspenseBoundary2);
	    }
	    function writeStartClientRenderedSuspenseBoundary(destination, responseState, errorDigest, errorMesssage, errorComponentStack) {
	      var result;
	      result = writeChunkAndReturn(destination, startClientRenderedSuspenseBoundary);
	      writeChunk(destination, clientRenderedSuspenseBoundaryError1);
	      if (errorDigest) {
	        writeChunk(destination, clientRenderedSuspenseBoundaryError1A);
	        writeChunk(destination, stringToChunk(escapeTextForBrowser(errorDigest)));
	        writeChunk(destination, clientRenderedSuspenseBoundaryErrorAttrInterstitial);
	      }
	      {
	        if (errorMesssage) {
	          writeChunk(destination, clientRenderedSuspenseBoundaryError1B);
	          writeChunk(destination, stringToChunk(escapeTextForBrowser(errorMesssage)));
	          writeChunk(destination, clientRenderedSuspenseBoundaryErrorAttrInterstitial);
	        }
	        if (errorComponentStack) {
	          writeChunk(destination, clientRenderedSuspenseBoundaryError1C);
	          writeChunk(destination, stringToChunk(escapeTextForBrowser(errorComponentStack)));
	          writeChunk(destination, clientRenderedSuspenseBoundaryErrorAttrInterstitial);
	        }
	      }
	      result = writeChunkAndReturn(destination, clientRenderedSuspenseBoundaryError2);
	      return result;
	    }
	    function writeEndCompletedSuspenseBoundary(destination, responseState) {
	      return writeChunkAndReturn(destination, endSuspenseBoundary);
	    }
	    function writeEndPendingSuspenseBoundary(destination, responseState) {
	      return writeChunkAndReturn(destination, endSuspenseBoundary);
	    }
	    function writeEndClientRenderedSuspenseBoundary(destination, responseState) {
	      return writeChunkAndReturn(destination, endSuspenseBoundary);
	    }
	    var startSegmentHTML = stringToPrecomputedChunk('<div hidden id="');
	    var startSegmentHTML2 = stringToPrecomputedChunk('">');
	    var endSegmentHTML = stringToPrecomputedChunk('</div>');
	    var startSegmentSVG = stringToPrecomputedChunk('<svg aria-hidden="true" style="display:none" id="');
	    var startSegmentSVG2 = stringToPrecomputedChunk('">');
	    var endSegmentSVG = stringToPrecomputedChunk('</svg>');
	    var startSegmentMathML = stringToPrecomputedChunk('<math aria-hidden="true" style="display:none" id="');
	    var startSegmentMathML2 = stringToPrecomputedChunk('">');
	    var endSegmentMathML = stringToPrecomputedChunk('</math>');
	    var startSegmentTable = stringToPrecomputedChunk('<table hidden id="');
	    var startSegmentTable2 = stringToPrecomputedChunk('">');
	    var endSegmentTable = stringToPrecomputedChunk('</table>');
	    var startSegmentTableBody = stringToPrecomputedChunk('<table hidden><tbody id="');
	    var startSegmentTableBody2 = stringToPrecomputedChunk('">');
	    var endSegmentTableBody = stringToPrecomputedChunk('</tbody></table>');
	    var startSegmentTableRow = stringToPrecomputedChunk('<table hidden><tr id="');
	    var startSegmentTableRow2 = stringToPrecomputedChunk('">');
	    var endSegmentTableRow = stringToPrecomputedChunk('</tr></table>');
	    var startSegmentColGroup = stringToPrecomputedChunk('<table hidden><colgroup id="');
	    var startSegmentColGroup2 = stringToPrecomputedChunk('">');
	    var endSegmentColGroup = stringToPrecomputedChunk('</colgroup></table>');
	    function writeStartSegment(destination, responseState, formatContext, id) {
	      switch (formatContext.insertionMode) {
	        case ROOT_HTML_MODE:
	        case HTML_MODE:
	          {
	            writeChunk(destination, startSegmentHTML);
	            writeChunk(destination, responseState.segmentPrefix);
	            writeChunk(destination, stringToChunk(id.toString(16)));
	            return writeChunkAndReturn(destination, startSegmentHTML2);
	          }
	        case SVG_MODE:
	          {
	            writeChunk(destination, startSegmentSVG);
	            writeChunk(destination, responseState.segmentPrefix);
	            writeChunk(destination, stringToChunk(id.toString(16)));
	            return writeChunkAndReturn(destination, startSegmentSVG2);
	          }
	        case MATHML_MODE:
	          {
	            writeChunk(destination, startSegmentMathML);
	            writeChunk(destination, responseState.segmentPrefix);
	            writeChunk(destination, stringToChunk(id.toString(16)));
	            return writeChunkAndReturn(destination, startSegmentMathML2);
	          }
	        case HTML_TABLE_MODE:
	          {
	            writeChunk(destination, startSegmentTable);
	            writeChunk(destination, responseState.segmentPrefix);
	            writeChunk(destination, stringToChunk(id.toString(16)));
	            return writeChunkAndReturn(destination, startSegmentTable2);
	          }
	        // TODO: For the rest of these, there will be extra wrapper nodes that never
	        // get deleted from the document. We need to delete the table too as part
	        // of the injected scripts. They are invisible though so it's not too terrible
	        // and it's kind of an edge case to suspend in a table. Totally supported though.

	        case HTML_TABLE_BODY_MODE:
	          {
	            writeChunk(destination, startSegmentTableBody);
	            writeChunk(destination, responseState.segmentPrefix);
	            writeChunk(destination, stringToChunk(id.toString(16)));
	            return writeChunkAndReturn(destination, startSegmentTableBody2);
	          }
	        case HTML_TABLE_ROW_MODE:
	          {
	            writeChunk(destination, startSegmentTableRow);
	            writeChunk(destination, responseState.segmentPrefix);
	            writeChunk(destination, stringToChunk(id.toString(16)));
	            return writeChunkAndReturn(destination, startSegmentTableRow2);
	          }
	        case HTML_COLGROUP_MODE:
	          {
	            writeChunk(destination, startSegmentColGroup);
	            writeChunk(destination, responseState.segmentPrefix);
	            writeChunk(destination, stringToChunk(id.toString(16)));
	            return writeChunkAndReturn(destination, startSegmentColGroup2);
	          }
	        default:
	          {
	            throw new Error('Unknown insertion mode. This is a bug in React.');
	          }
	      }
	    }
	    function writeEndSegment(destination, formatContext) {
	      switch (formatContext.insertionMode) {
	        case ROOT_HTML_MODE:
	        case HTML_MODE:
	          {
	            return writeChunkAndReturn(destination, endSegmentHTML);
	          }
	        case SVG_MODE:
	          {
	            return writeChunkAndReturn(destination, endSegmentSVG);
	          }
	        case MATHML_MODE:
	          {
	            return writeChunkAndReturn(destination, endSegmentMathML);
	          }
	        case HTML_TABLE_MODE:
	          {
	            return writeChunkAndReturn(destination, endSegmentTable);
	          }
	        case HTML_TABLE_BODY_MODE:
	          {
	            return writeChunkAndReturn(destination, endSegmentTableBody);
	          }
	        case HTML_TABLE_ROW_MODE:
	          {
	            return writeChunkAndReturn(destination, endSegmentTableRow);
	          }
	        case HTML_COLGROUP_MODE:
	          {
	            return writeChunkAndReturn(destination, endSegmentColGroup);
	          }
	        default:
	          {
	            throw new Error('Unknown insertion mode. This is a bug in React.');
	          }
	      }
	    } // Instruction Set
	    // The following code is the source scripts that we then minify and inline below,
	    // with renamed function names that we hope don't collide:
	    // const COMMENT_NODE = 8;
	    // const SUSPENSE_START_DATA = '$';
	    // const SUSPENSE_END_DATA = '/$';
	    // const SUSPENSE_PENDING_START_DATA = '$?';
	    // const SUSPENSE_FALLBACK_START_DATA = '$!';
	    //
	    // function clientRenderBoundary(suspenseBoundaryID, errorDigest, errorMsg, errorComponentStack) {
	    //   // Find the fallback's first element.
	    //   const suspenseIdNode = document.getElementById(suspenseBoundaryID);
	    //   if (!suspenseIdNode) {
	    //     // The user must have already navigated away from this tree.
	    //     // E.g. because the parent was hydrated.
	    //     return;
	    //   }
	    //   // Find the boundary around the fallback. This is always the previous node.
	    //   const suspenseNode = suspenseIdNode.previousSibling;
	    //   // Tag it to be client rendered.
	    //   suspenseNode.data = SUSPENSE_FALLBACK_START_DATA;
	    //   // assign error metadata to first sibling
	    //   let dataset = suspenseIdNode.dataset;
	    //   if (errorDigest) dataset.dgst = errorDigest;
	    //   if (errorMsg) dataset.msg = errorMsg;
	    //   if (errorComponentStack) dataset.stck = errorComponentStack;
	    //   // Tell React to retry it if the parent already hydrated.
	    //   if (suspenseNode._reactRetry) {
	    //     suspenseNode._reactRetry();
	    //   }
	    // }
	    //
	    // function completeBoundary(suspenseBoundaryID, contentID) {
	    //   // Find the fallback's first element.
	    //   const suspenseIdNode = document.getElementById(suspenseBoundaryID);
	    //   const contentNode = document.getElementById(contentID);
	    //   // We'll detach the content node so that regardless of what happens next we don't leave in the tree.
	    //   // This might also help by not causing recalcing each time we move a child from here to the target.
	    //   contentNode.parentNode.removeChild(contentNode);
	    //   if (!suspenseIdNode) {
	    //     // The user must have already navigated away from this tree.
	    //     // E.g. because the parent was hydrated. That's fine there's nothing to do
	    //     // but we have to make sure that we already deleted the container node.
	    //     return;
	    //   }
	    //   // Find the boundary around the fallback. This is always the previous node.
	    //   const suspenseNode = suspenseIdNode.previousSibling;
	    //
	    //   // Clear all the existing children. This is complicated because
	    //   // there can be embedded Suspense boundaries in the fallback.
	    //   // This is similar to clearSuspenseBoundary in ReactDOMHostConfig.
	    //   // TODO: We could avoid this if we never emitted suspense boundaries in fallback trees.
	    //   // They never hydrate anyway. However, currently we support incrementally loading the fallback.
	    //   const parentInstance = suspenseNode.parentNode;
	    //   let node = suspenseNode.nextSibling;
	    //   let depth = 0;
	    //   do {
	    //     if (node && node.nodeType === COMMENT_NODE) {
	    //       const data = node.data;
	    //       if (data === SUSPENSE_END_DATA) {
	    //         if (depth === 0) {
	    //           break;
	    //         } else {
	    //           depth--;
	    //         }
	    //       } else if (
	    //         data === SUSPENSE_START_DATA ||
	    //         data === SUSPENSE_PENDING_START_DATA ||
	    //         data === SUSPENSE_FALLBACK_START_DATA
	    //       ) {
	    //         depth++;
	    //       }
	    //     }
	    //
	    //     const nextNode = node.nextSibling;
	    //     parentInstance.removeChild(node);
	    //     node = nextNode;
	    //   } while (node);
	    //
	    //   const endOfBoundary = node;
	    //
	    //   // Insert all the children from the contentNode between the start and end of suspense boundary.
	    //   while (contentNode.firstChild) {
	    //     parentInstance.insertBefore(contentNode.firstChild, endOfBoundary);
	    //   }
	    //   suspenseNode.data = SUSPENSE_START_DATA;
	    //   if (suspenseNode._reactRetry) {
	    //     suspenseNode._reactRetry();
	    //   }
	    // }
	    //
	    // function completeSegment(containerID, placeholderID) {
	    //   const segmentContainer = document.getElementById(containerID);
	    //   const placeholderNode = document.getElementById(placeholderID);
	    //   // We always expect both nodes to exist here because, while we might
	    //   // have navigated away from the main tree, we still expect the detached
	    //   // tree to exist.
	    //   segmentContainer.parentNode.removeChild(segmentContainer);
	    //   while (segmentContainer.firstChild) {
	    //     placeholderNode.parentNode.insertBefore(
	    //       segmentContainer.firstChild,
	    //       placeholderNode,
	    //     );
	    //   }
	    //   placeholderNode.parentNode.removeChild(placeholderNode);
	    // }

	    var completeSegmentFunction = 'function $RS(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)}';
	    var completeBoundaryFunction = 'function $RC(a,b){a=document.getElementById(a);b=document.getElementById(b);b.parentNode.removeChild(b);if(a){a=a.previousSibling;var f=a.parentNode,c=a.nextSibling,e=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d)if(0===e)break;else e--;else"$"!==d&&"$?"!==d&&"$!"!==d||e++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;b.firstChild;)f.insertBefore(b.firstChild,c);a.data="$";a._reactRetry&&a._reactRetry()}}';
	    var clientRenderFunction = 'function $RX(b,c,d,e){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),b._reactRetry&&b._reactRetry())}';
	    var completeSegmentScript1Full = stringToPrecomputedChunk(completeSegmentFunction + ';$RS("');
	    var completeSegmentScript1Partial = stringToPrecomputedChunk('$RS("');
	    var completeSegmentScript2 = stringToPrecomputedChunk('","');
	    var completeSegmentScript3 = stringToPrecomputedChunk('")</script>');
	    function writeCompletedSegmentInstruction(destination, responseState, contentSegmentID) {
	      writeChunk(destination, responseState.startInlineScript);
	      if (!responseState.sentCompleteSegmentFunction) {
	        // The first time we write this, we'll need to include the full implementation.
	        responseState.sentCompleteSegmentFunction = true;
	        writeChunk(destination, completeSegmentScript1Full);
	      } else {
	        // Future calls can just reuse the same function.
	        writeChunk(destination, completeSegmentScript1Partial);
	      }
	      writeChunk(destination, responseState.segmentPrefix);
	      var formattedID = stringToChunk(contentSegmentID.toString(16));
	      writeChunk(destination, formattedID);
	      writeChunk(destination, completeSegmentScript2);
	      writeChunk(destination, responseState.placeholderPrefix);
	      writeChunk(destination, formattedID);
	      return writeChunkAndReturn(destination, completeSegmentScript3);
	    }
	    var completeBoundaryScript1Full = stringToPrecomputedChunk(completeBoundaryFunction + ';$RC("');
	    var completeBoundaryScript1Partial = stringToPrecomputedChunk('$RC("');
	    var completeBoundaryScript2 = stringToPrecomputedChunk('","');
	    var completeBoundaryScript3 = stringToPrecomputedChunk('")</script>');
	    function writeCompletedBoundaryInstruction(destination, responseState, boundaryID, contentSegmentID) {
	      writeChunk(destination, responseState.startInlineScript);
	      if (!responseState.sentCompleteBoundaryFunction) {
	        // The first time we write this, we'll need to include the full implementation.
	        responseState.sentCompleteBoundaryFunction = true;
	        writeChunk(destination, completeBoundaryScript1Full);
	      } else {
	        // Future calls can just reuse the same function.
	        writeChunk(destination, completeBoundaryScript1Partial);
	      }
	      if (boundaryID === null) {
	        throw new Error('An ID must have been assigned before we can complete the boundary.');
	      }
	      var formattedContentID = stringToChunk(contentSegmentID.toString(16));
	      writeChunk(destination, boundaryID);
	      writeChunk(destination, completeBoundaryScript2);
	      writeChunk(destination, responseState.segmentPrefix);
	      writeChunk(destination, formattedContentID);
	      return writeChunkAndReturn(destination, completeBoundaryScript3);
	    }
	    var clientRenderScript1Full = stringToPrecomputedChunk(clientRenderFunction + ';$RX("');
	    var clientRenderScript1Partial = stringToPrecomputedChunk('$RX("');
	    var clientRenderScript1A = stringToPrecomputedChunk('"');
	    var clientRenderScript2 = stringToPrecomputedChunk(')</script>');
	    var clientRenderErrorScriptArgInterstitial = stringToPrecomputedChunk(',');
	    function writeClientRenderBoundaryInstruction(destination, responseState, boundaryID, errorDigest, errorMessage, errorComponentStack) {
	      writeChunk(destination, responseState.startInlineScript);
	      if (!responseState.sentClientRenderFunction) {
	        // The first time we write this, we'll need to include the full implementation.
	        responseState.sentClientRenderFunction = true;
	        writeChunk(destination, clientRenderScript1Full);
	      } else {
	        // Future calls can just reuse the same function.
	        writeChunk(destination, clientRenderScript1Partial);
	      }
	      if (boundaryID === null) {
	        throw new Error('An ID must have been assigned before we can complete the boundary.');
	      }
	      writeChunk(destination, boundaryID);
	      writeChunk(destination, clientRenderScript1A);
	      if (errorDigest || errorMessage || errorComponentStack) {
	        writeChunk(destination, clientRenderErrorScriptArgInterstitial);
	        writeChunk(destination, stringToChunk(escapeJSStringsForInstructionScripts(errorDigest || '')));
	      }
	      if (errorMessage || errorComponentStack) {
	        writeChunk(destination, clientRenderErrorScriptArgInterstitial);
	        writeChunk(destination, stringToChunk(escapeJSStringsForInstructionScripts(errorMessage || '')));
	      }
	      if (errorComponentStack) {
	        writeChunk(destination, clientRenderErrorScriptArgInterstitial);
	        writeChunk(destination, stringToChunk(escapeJSStringsForInstructionScripts(errorComponentStack)));
	      }
	      return writeChunkAndReturn(destination, clientRenderScript2);
	    }
	    var regexForJSStringsInScripts = /[<\u2028\u2029]/g;
	    function escapeJSStringsForInstructionScripts(input) {
	      var escaped = JSON.stringify(input);
	      return escaped.replace(regexForJSStringsInScripts, function (match) {
	        switch (match) {
	          // santizing breaking out of strings and script tags
	          case '<':
	            return "\\u003c";
	          case "\u2028":
	            return "\\u2028";
	          case "\u2029":
	            return "\\u2029";
	          default:
	            {
	              // eslint-disable-next-line react-internal/prod-error-codes
	              throw new Error('escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React');
	            }
	        }
	      });
	    }
	    function createResponseState$1(generateStaticMarkup, identifierPrefix) {
	      var responseState = createResponseState(identifierPrefix);
	      return {
	        // Keep this in sync with ReactDOMServerFormatConfig
	        bootstrapChunks: responseState.bootstrapChunks,
	        startInlineScript: responseState.startInlineScript,
	        placeholderPrefix: responseState.placeholderPrefix,
	        segmentPrefix: responseState.segmentPrefix,
	        boundaryPrefix: responseState.boundaryPrefix,
	        idPrefix: responseState.idPrefix,
	        nextSuspenseID: responseState.nextSuspenseID,
	        sentCompleteSegmentFunction: responseState.sentCompleteSegmentFunction,
	        sentCompleteBoundaryFunction: responseState.sentCompleteBoundaryFunction,
	        sentClientRenderFunction: responseState.sentClientRenderFunction,
	        // This is an extra field for the legacy renderer
	        generateStaticMarkup: generateStaticMarkup
	      };
	    }
	    function createRootFormatContext() {
	      return {
	        insertionMode: HTML_MODE,
	        // We skip the root mode because we don't want to emit the DOCTYPE in legacy mode.
	        selectedValue: null
	      };
	    }
	    function pushTextInstance$1(target, text, responseState, textEmbedded) {
	      if (responseState.generateStaticMarkup) {
	        target.push(stringToChunk(escapeTextForBrowser(text)));
	        return false;
	      } else {
	        return pushTextInstance(target, text, responseState, textEmbedded);
	      }
	    }
	    function pushSegmentFinale$1(target, responseState, lastPushedText, textEmbedded) {
	      if (responseState.generateStaticMarkup) {
	        return;
	      } else {
	        return pushSegmentFinale(target, responseState, lastPushedText, textEmbedded);
	      }
	    }
	    function writeStartCompletedSuspenseBoundary$1(destination, responseState) {
	      if (responseState.generateStaticMarkup) {
	        // A completed boundary is done and doesn't need a representation in the HTML
	        // if we're not going to be hydrating it.
	        return true;
	      }
	      return writeStartCompletedSuspenseBoundary(destination);
	    }
	    function writeStartClientRenderedSuspenseBoundary$1(destination, responseState,
	    // flushing these error arguments are not currently supported in this legacy streaming format.
	    errorDigest, errorMessage, errorComponentStack) {
	      if (responseState.generateStaticMarkup) {
	        // A client rendered boundary is done and doesn't need a representation in the HTML
	        // since we'll never hydrate it. This is arguably an error in static generation.
	        return true;
	      }
	      return writeStartClientRenderedSuspenseBoundary(destination, responseState, errorDigest, errorMessage, errorComponentStack);
	    }
	    function writeEndCompletedSuspenseBoundary$1(destination, responseState) {
	      if (responseState.generateStaticMarkup) {
	        return true;
	      }
	      return writeEndCompletedSuspenseBoundary(destination);
	    }
	    function writeEndClientRenderedSuspenseBoundary$1(destination, responseState) {
	      if (responseState.generateStaticMarkup) {
	        return true;
	      }
	      return writeEndClientRenderedSuspenseBoundary(destination);
	    }
	    var assign = Object.assign;

	    // ATTENTION
	    // When adding new symbols to this file,
	    // Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
	    // The Symbol used to tag the ReactElement-like types.
	    var REACT_ELEMENT_TYPE = Symbol.for('react.element');
	    var REACT_PORTAL_TYPE = Symbol.for('react.portal');
	    var REACT_FRAGMENT_TYPE = Symbol.for('react.fragment');
	    var REACT_STRICT_MODE_TYPE = Symbol.for('react.strict_mode');
	    var REACT_PROFILER_TYPE = Symbol.for('react.profiler');
	    var REACT_PROVIDER_TYPE = Symbol.for('react.provider');
	    var REACT_CONTEXT_TYPE = Symbol.for('react.context');
	    var REACT_FORWARD_REF_TYPE = Symbol.for('react.forward_ref');
	    var REACT_SUSPENSE_TYPE = Symbol.for('react.suspense');
	    var REACT_SUSPENSE_LIST_TYPE = Symbol.for('react.suspense_list');
	    var REACT_MEMO_TYPE = Symbol.for('react.memo');
	    var REACT_LAZY_TYPE = Symbol.for('react.lazy');
	    var REACT_SCOPE_TYPE = Symbol.for('react.scope');
	    var REACT_DEBUG_TRACING_MODE_TYPE = Symbol.for('react.debug_trace_mode');
	    var REACT_LEGACY_HIDDEN_TYPE = Symbol.for('react.legacy_hidden');
	    var REACT_SERVER_CONTEXT_DEFAULT_VALUE_NOT_LOADED = Symbol.for('react.default_value');
	    var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
	    var FAUX_ITERATOR_SYMBOL = '@@iterator';
	    function getIteratorFn(maybeIterable) {
	      if (maybeIterable === null || typeof maybeIterable !== 'object') {
	        return null;
	      }
	      var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];
	      if (typeof maybeIterator === 'function') {
	        return maybeIterator;
	      }
	      return null;
	    }
	    function getWrappedName(outerType, innerType, wrapperName) {
	      var displayName = outerType.displayName;
	      if (displayName) {
	        return displayName;
	      }
	      var functionName = innerType.displayName || innerType.name || '';
	      return functionName !== '' ? wrapperName + "(" + functionName + ")" : wrapperName;
	    } // Keep in sync with react-reconciler/getComponentNameFromFiber

	    function getContextName(type) {
	      return type.displayName || 'Context';
	    } // Note that the reconciler package should generally prefer to use getComponentNameFromFiber() instead.

	    function getComponentNameFromType(type) {
	      if (type == null) {
	        // Host root, text node or just invalid type.
	        return null;
	      }
	      {
	        if (typeof type.tag === 'number') {
	          error('Received an unexpected object in getComponentNameFromType(). ' + 'This is likely a bug in React. Please file an issue.');
	        }
	      }
	      if (typeof type === 'function') {
	        return type.displayName || type.name || null;
	      }
	      if (typeof type === 'string') {
	        return type;
	      }
	      switch (type) {
	        case REACT_FRAGMENT_TYPE:
	          return 'Fragment';
	        case REACT_PORTAL_TYPE:
	          return 'Portal';
	        case REACT_PROFILER_TYPE:
	          return 'Profiler';
	        case REACT_STRICT_MODE_TYPE:
	          return 'StrictMode';
	        case REACT_SUSPENSE_TYPE:
	          return 'Suspense';
	        case REACT_SUSPENSE_LIST_TYPE:
	          return 'SuspenseList';
	      }
	      if (typeof type === 'object') {
	        switch (type.$$typeof) {
	          case REACT_CONTEXT_TYPE:
	            var context = type;
	            return getContextName(context) + '.Consumer';
	          case REACT_PROVIDER_TYPE:
	            var provider = type;
	            return getContextName(provider._context) + '.Provider';
	          case REACT_FORWARD_REF_TYPE:
	            return getWrappedName(type, type.render, 'ForwardRef');
	          case REACT_MEMO_TYPE:
	            var outerName = type.displayName || null;
	            if (outerName !== null) {
	              return outerName;
	            }
	            return getComponentNameFromType(type.type) || 'Memo';
	          case REACT_LAZY_TYPE:
	            {
	              var lazyComponent = type;
	              var payload = lazyComponent._payload;
	              var init = lazyComponent._init;
	              try {
	                return getComponentNameFromType(init(payload));
	              } catch (x) {
	                return null;
	              }
	            }

	          // eslint-disable-next-line no-fallthrough
	        }
	      }
	      return null;
	    }

	    // Helpers to patch console.logs to avoid logging during side-effect free
	    // replaying on render function. This currently only patches the object
	    // lazily which won't cover if the log function was extracted eagerly.
	    // We could also eagerly patch the method.
	    var disabledDepth = 0;
	    var prevLog;
	    var prevInfo;
	    var prevWarn;
	    var prevError;
	    var prevGroup;
	    var prevGroupCollapsed;
	    var prevGroupEnd;
	    function disabledLog() {}
	    disabledLog.__reactDisabledLog = true;
	    function disableLogs() {
	      {
	        if (disabledDepth === 0) {
	          /* eslint-disable react-internal/no-production-logging */
	          prevLog = console.log;
	          prevInfo = console.info;
	          prevWarn = console.warn;
	          prevError = console.error;
	          prevGroup = console.group;
	          prevGroupCollapsed = console.groupCollapsed;
	          prevGroupEnd = console.groupEnd; // https://github.com/facebook/react/issues/19099

	          var props = {
	            configurable: true,
	            enumerable: true,
	            value: disabledLog,
	            writable: true
	          }; // $FlowFixMe Flow thinks console is immutable.

	          Object.defineProperties(console, {
	            info: props,
	            log: props,
	            warn: props,
	            error: props,
	            group: props,
	            groupCollapsed: props,
	            groupEnd: props
	          });
	          /* eslint-enable react-internal/no-production-logging */
	        }
	        disabledDepth++;
	      }
	    }
	    function reenableLogs() {
	      {
	        disabledDepth--;
	        if (disabledDepth === 0) {
	          /* eslint-disable react-internal/no-production-logging */
	          var props = {
	            configurable: true,
	            enumerable: true,
	            writable: true
	          }; // $FlowFixMe Flow thinks console is immutable.

	          Object.defineProperties(console, {
	            log: assign({}, props, {
	              value: prevLog
	            }),
	            info: assign({}, props, {
	              value: prevInfo
	            }),
	            warn: assign({}, props, {
	              value: prevWarn
	            }),
	            error: assign({}, props, {
	              value: prevError
	            }),
	            group: assign({}, props, {
	              value: prevGroup
	            }),
	            groupCollapsed: assign({}, props, {
	              value: prevGroupCollapsed
	            }),
	            groupEnd: assign({}, props, {
	              value: prevGroupEnd
	            })
	          });
	          /* eslint-enable react-internal/no-production-logging */
	        }
	        if (disabledDepth < 0) {
	          error('disabledDepth fell below zero. ' + 'This is a bug in React. Please file an issue.');
	        }
	      }
	    }
	    var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
	    var prefix;
	    function describeBuiltInComponentFrame(name, source, ownerFn) {
	      {
	        if (prefix === undefined) {
	          // Extract the VM specific prefix used by each line.
	          try {
	            throw Error();
	          } catch (x) {
	            var match = x.stack.trim().match(/\n( *(at )?)/);
	            prefix = match && match[1] || '';
	          }
	        } // We use the prefix to ensure our stacks line up with native stack frames.

	        return '\n' + prefix + name;
	      }
	    }
	    var reentry = false;
	    var componentFrameCache;
	    {
	      var PossiblyWeakMap = typeof WeakMap === 'function' ? WeakMap : Map;
	      componentFrameCache = new PossiblyWeakMap();
	    }
	    function describeNativeComponentFrame(fn, construct) {
	      // If something asked for a stack inside a fake render, it should get ignored.
	      if (!fn || reentry) {
	        return '';
	      }
	      {
	        var frame = componentFrameCache.get(fn);
	        if (frame !== undefined) {
	          return frame;
	        }
	      }
	      var control;
	      reentry = true;
	      var previousPrepareStackTrace = Error.prepareStackTrace; // $FlowFixMe It does accept undefined.

	      Error.prepareStackTrace = undefined;
	      var previousDispatcher;
	      {
	        previousDispatcher = ReactCurrentDispatcher.current; // Set the dispatcher in DEV because this might be call in the render function
	        // for warnings.

	        ReactCurrentDispatcher.current = null;
	        disableLogs();
	      }
	      try {
	        // This should throw.
	        if (construct) {
	          // Something should be setting the props in the constructor.
	          var Fake = function () {
	            throw Error();
	          }; // $FlowFixMe

	          Object.defineProperty(Fake.prototype, 'props', {
	            set: function () {
	              // We use a throwing setter instead of frozen or non-writable props
	              // because that won't throw in a non-strict mode function.
	              throw Error();
	            }
	          });
	          if (typeof Reflect === 'object' && Reflect.construct) {
	            // We construct a different control for this case to include any extra
	            // frames added by the construct call.
	            try {
	              Reflect.construct(Fake, []);
	            } catch (x) {
	              control = x;
	            }
	            Reflect.construct(fn, [], Fake);
	          } else {
	            try {
	              Fake.call();
	            } catch (x) {
	              control = x;
	            }
	            fn.call(Fake.prototype);
	          }
	        } else {
	          try {
	            throw Error();
	          } catch (x) {
	            control = x;
	          }
	          fn();
	        }
	      } catch (sample) {
	        // This is inlined manually because closure doesn't do it for us.
	        if (sample && control && typeof sample.stack === 'string') {
	          // This extracts the first frame from the sample that isn't also in the control.
	          // Skipping one frame that we assume is the frame that calls the two.
	          var sampleLines = sample.stack.split('\n');
	          var controlLines = control.stack.split('\n');
	          var s = sampleLines.length - 1;
	          var c = controlLines.length - 1;
	          while (s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c]) {
	            // We expect at least one stack frame to be shared.
	            // Typically this will be the root most one. However, stack frames may be
	            // cut off due to maximum stack limits. In this case, one maybe cut off
	            // earlier than the other. We assume that the sample is longer or the same
	            // and there for cut off earlier. So we should find the root most frame in
	            // the sample somewhere in the control.
	            c--;
	          }
	          for (; s >= 1 && c >= 0; s--, c--) {
	            // Next we find the first one that isn't the same which should be the
	            // frame that called our sample function and the control.
	            if (sampleLines[s] !== controlLines[c]) {
	              // In V8, the first line is describing the message but other VMs don't.
	              // If we're about to return the first line, and the control is also on the same
	              // line, that's a pretty good indicator that our sample threw at same line as
	              // the control. I.e. before we entered the sample frame. So we ignore this result.
	              // This can happen if you passed a class to function component, or non-function.
	              if (s !== 1 || c !== 1) {
	                do {
	                  s--;
	                  c--; // We may still have similar intermediate frames from the construct call.
	                  // The next one that isn't the same should be our match though.

	                  if (c < 0 || sampleLines[s] !== controlLines[c]) {
	                    // V8 adds a "new" prefix for native classes. Let's remove it to make it prettier.
	                    var _frame = '\n' + sampleLines[s].replace(' at new ', ' at '); // If our component frame is labeled "<anonymous>"
	                    // but we have a user-provided "displayName"
	                    // splice it in to make the stack more readable.

	                    if (fn.displayName && _frame.includes('<anonymous>')) {
	                      _frame = _frame.replace('<anonymous>', fn.displayName);
	                    }
	                    {
	                      if (typeof fn === 'function') {
	                        componentFrameCache.set(fn, _frame);
	                      }
	                    } // Return the line we found.

	                    return _frame;
	                  }
	                } while (s >= 1 && c >= 0);
	              }
	              break;
	            }
	          }
	        }
	      } finally {
	        reentry = false;
	        {
	          ReactCurrentDispatcher.current = previousDispatcher;
	          reenableLogs();
	        }
	        Error.prepareStackTrace = previousPrepareStackTrace;
	      } // Fallback to just using the name if we couldn't make it throw.

	      var name = fn ? fn.displayName || fn.name : '';
	      var syntheticFrame = name ? describeBuiltInComponentFrame(name) : '';
	      {
	        if (typeof fn === 'function') {
	          componentFrameCache.set(fn, syntheticFrame);
	        }
	      }
	      return syntheticFrame;
	    }
	    function describeClassComponentFrame(ctor, source, ownerFn) {
	      {
	        return describeNativeComponentFrame(ctor, true);
	      }
	    }
	    function describeFunctionComponentFrame(fn, source, ownerFn) {
	      {
	        return describeNativeComponentFrame(fn, false);
	      }
	    }
	    function shouldConstruct(Component) {
	      var prototype = Component.prototype;
	      return !!(prototype && prototype.isReactComponent);
	    }
	    function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {
	      if (type == null) {
	        return '';
	      }
	      if (typeof type === 'function') {
	        {
	          return describeNativeComponentFrame(type, shouldConstruct(type));
	        }
	      }
	      if (typeof type === 'string') {
	        return describeBuiltInComponentFrame(type);
	      }
	      switch (type) {
	        case REACT_SUSPENSE_TYPE:
	          return describeBuiltInComponentFrame('Suspense');
	        case REACT_SUSPENSE_LIST_TYPE:
	          return describeBuiltInComponentFrame('SuspenseList');
	      }
	      if (typeof type === 'object') {
	        switch (type.$$typeof) {
	          case REACT_FORWARD_REF_TYPE:
	            return describeFunctionComponentFrame(type.render);
	          case REACT_MEMO_TYPE:
	            // Memo may contain any component type so we recursively resolve it.
	            return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);
	          case REACT_LAZY_TYPE:
	            {
	              var lazyComponent = type;
	              var payload = lazyComponent._payload;
	              var init = lazyComponent._init;
	              try {
	                // Lazy may contain any component type so we recursively resolve it.
	                return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
	              } catch (x) {}
	            }
	        }
	      }
	      return '';
	    }
	    var loggedTypeFailures = {};
	    var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
	    function setCurrentlyValidatingElement(element) {
	      {
	        if (element) {
	          var owner = element._owner;
	          var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
	          ReactDebugCurrentFrame.setExtraStackFrame(stack);
	        } else {
	          ReactDebugCurrentFrame.setExtraStackFrame(null);
	        }
	      }
	    }
	    function checkPropTypes(typeSpecs, values, location, componentName, element) {
	      {
	        // $FlowFixMe This is okay but Flow doesn't know it.
	        var has = Function.call.bind(hasOwnProperty);
	        for (var typeSpecName in typeSpecs) {
	          if (has(typeSpecs, typeSpecName)) {
	            var error$1 = void 0; // Prop type validation may throw. In case they do, we don't want to
	            // fail the render phase where it didn't fail before. So we log it.
	            // After these have been cleaned up, we'll let them throw.

	            try {
	              // This is intentionally an invariant that gets caught. It's the same
	              // behavior as without this statement except with a better message.
	              if (typeof typeSpecs[typeSpecName] !== 'function') {
	                // eslint-disable-next-line react-internal/prod-error-codes
	                var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
	                err.name = 'Invariant Violation';
	                throw err;
	              }
	              error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED');
	            } catch (ex) {
	              error$1 = ex;
	            }
	            if (error$1 && !(error$1 instanceof Error)) {
	              setCurrentlyValidatingElement(element);
	              error('%s: type specification of %s' + ' `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error$1);
	              setCurrentlyValidatingElement(null);
	            }
	            if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
	              // Only monitor this failure once because there tends to be a lot of the
	              // same error.
	              loggedTypeFailures[error$1.message] = true;
	              setCurrentlyValidatingElement(element);
	              error('Failed %s type: %s', location, error$1.message);
	              setCurrentlyValidatingElement(null);
	            }
	          }
	        }
	      }
	    }
	    var warnedAboutMissingGetChildContext;
	    {
	      warnedAboutMissingGetChildContext = {};
	    }
	    var emptyContextObject = {};
	    {
	      Object.freeze(emptyContextObject);
	    }
	    function getMaskedContext(type, unmaskedContext) {
	      {
	        var contextTypes = type.contextTypes;
	        if (!contextTypes) {
	          return emptyContextObject;
	        }
	        var context = {};
	        for (var key in contextTypes) {
	          context[key] = unmaskedContext[key];
	        }
	        {
	          var name = getComponentNameFromType(type) || 'Unknown';
	          checkPropTypes(contextTypes, context, 'context', name);
	        }
	        return context;
	      }
	    }
	    function processChildContext(instance, type, parentContext, childContextTypes) {
	      {
	        // TODO (bvaughn) Replace this behavior with an invariant() in the future.
	        // It has only been added in Fiber to match the (unintentional) behavior in Stack.
	        if (typeof instance.getChildContext !== 'function') {
	          {
	            var componentName = getComponentNameFromType(type) || 'Unknown';
	            if (!warnedAboutMissingGetChildContext[componentName]) {
	              warnedAboutMissingGetChildContext[componentName] = true;
	              error('%s.childContextTypes is specified but there is no getChildContext() method ' + 'on the instance. You can either define getChildContext() on %s or remove ' + 'childContextTypes from it.', componentName, componentName);
	            }
	          }
	          return parentContext;
	        }
	        var childContext = instance.getChildContext();
	        for (var contextKey in childContext) {
	          if (!(contextKey in childContextTypes)) {
	            throw new Error((getComponentNameFromType(type) || 'Unknown') + ".getChildContext(): key \"" + contextKey + "\" is not defined in childContextTypes.");
	          }
	        }
	        {
	          var name = getComponentNameFromType(type) || 'Unknown';
	          checkPropTypes(childContextTypes, childContext, 'child context', name);
	        }
	        return assign({}, parentContext, childContext);
	      }
	    }
	    var rendererSigil;
	    {
	      // Use this to detect multiple renderers using the same context
	      rendererSigil = {};
	    } // Used to store the parent path of all context overrides in a shared linked list.
	    // Forming a reverse tree.

	    var rootContextSnapshot = null; // We assume that this runtime owns the "current" field on all ReactContext instances.
	    // This global (actually thread local) state represents what state all those "current",
	    // fields are currently in.

	    var currentActiveSnapshot = null;
	    function popNode(prev) {
	      {
	        prev.context._currentValue2 = prev.parentValue;
	      }
	    }
	    function pushNode(next) {
	      {
	        next.context._currentValue2 = next.value;
	      }
	    }
	    function popToNearestCommonAncestor(prev, next) {
	      if (prev === next) ;else {
	        popNode(prev);
	        var parentPrev = prev.parent;
	        var parentNext = next.parent;
	        if (parentPrev === null) {
	          if (parentNext !== null) {
	            throw new Error('The stacks must reach the root at the same time. This is a bug in React.');
	          }
	        } else {
	          if (parentNext === null) {
	            throw new Error('The stacks must reach the root at the same time. This is a bug in React.');
	          }
	          popToNearestCommonAncestor(parentPrev, parentNext);
	        } // On the way back, we push the new ones that weren't common.

	        pushNode(next);
	      }
	    }
	    function popAllPrevious(prev) {
	      popNode(prev);
	      var parentPrev = prev.parent;
	      if (parentPrev !== null) {
	        popAllPrevious(parentPrev);
	      }
	    }
	    function pushAllNext(next) {
	      var parentNext = next.parent;
	      if (parentNext !== null) {
	        pushAllNext(parentNext);
	      }
	      pushNode(next);
	    }
	    function popPreviousToCommonLevel(prev, next) {
	      popNode(prev);
	      var parentPrev = prev.parent;
	      if (parentPrev === null) {
	        throw new Error('The depth must equal at least at zero before reaching the root. This is a bug in React.');
	      }
	      if (parentPrev.depth === next.depth) {
	        // We found the same level. Now we just need to find a shared ancestor.
	        popToNearestCommonAncestor(parentPrev, next);
	      } else {
	        // We must still be deeper.
	        popPreviousToCommonLevel(parentPrev, next);
	      }
	    }
	    function popNextToCommonLevel(prev, next) {
	      var parentNext = next.parent;
	      if (parentNext === null) {
	        throw new Error('The depth must equal at least at zero before reaching the root. This is a bug in React.');
	      }
	      if (prev.depth === parentNext.depth) {
	        // We found the same level. Now we just need to find a shared ancestor.
	        popToNearestCommonAncestor(prev, parentNext);
	      } else {
	        // We must still be deeper.
	        popNextToCommonLevel(prev, parentNext);
	      }
	      pushNode(next);
	    } // Perform context switching to the new snapshot.
	    // To make it cheap to read many contexts, while not suspending, we make the switch eagerly by
	    // updating all the context's current values. That way reads, always just read the current value.
	    // At the cost of updating contexts even if they're never read by this subtree.

	    function switchContext(newSnapshot) {
	      // The basic algorithm we need to do is to pop back any contexts that are no longer on the stack.
	      // We also need to update any new contexts that are now on the stack with the deepest value.
	      // The easiest way to update new contexts is to just reapply them in reverse order from the
	      // perspective of the backpointers. To avoid allocating a lot when switching, we use the stack
	      // for that. Therefore this algorithm is recursive.
	      // 1) First we pop which ever snapshot tree was deepest. Popping old contexts as we go.
	      // 2) Then we find the nearest common ancestor from there. Popping old contexts as we go.
	      // 3) Then we reapply new contexts on the way back up the stack.
	      var prev = currentActiveSnapshot;
	      var next = newSnapshot;
	      if (prev !== next) {
	        if (prev === null) {
	          // $FlowFixMe: This has to be non-null since it's not equal to prev.
	          pushAllNext(next);
	        } else if (next === null) {
	          popAllPrevious(prev);
	        } else if (prev.depth === next.depth) {
	          popToNearestCommonAncestor(prev, next);
	        } else if (prev.depth > next.depth) {
	          popPreviousToCommonLevel(prev, next);
	        } else {
	          popNextToCommonLevel(prev, next);
	        }
	        currentActiveSnapshot = next;
	      }
	    }
	    function pushProvider(context, nextValue) {
	      var prevValue;
	      {
	        prevValue = context._currentValue2;
	        context._currentValue2 = nextValue;
	        {
	          if (context._currentRenderer2 !== undefined && context._currentRenderer2 !== null && context._currentRenderer2 !== rendererSigil) {
	            error('Detected multiple renderers concurrently rendering the ' + 'same context provider. This is currently unsupported.');
	          }
	          context._currentRenderer2 = rendererSigil;
	        }
	      }
	      var prevNode = currentActiveSnapshot;
	      var newNode = {
	        parent: prevNode,
	        depth: prevNode === null ? 0 : prevNode.depth + 1,
	        context: context,
	        parentValue: prevValue,
	        value: nextValue
	      };
	      currentActiveSnapshot = newNode;
	      return newNode;
	    }
	    function popProvider(context) {
	      var prevSnapshot = currentActiveSnapshot;
	      if (prevSnapshot === null) {
	        throw new Error('Tried to pop a Context at the root of the app. This is a bug in React.');
	      }
	      {
	        if (prevSnapshot.context !== context) {
	          error('The parent context is not the expected context. This is probably a bug in React.');
	        }
	      }
	      {
	        var _value = prevSnapshot.parentValue;
	        if (_value === REACT_SERVER_CONTEXT_DEFAULT_VALUE_NOT_LOADED) {
	          prevSnapshot.context._currentValue2 = prevSnapshot.context._defaultValue;
	        } else {
	          prevSnapshot.context._currentValue2 = _value;
	        }
	        {
	          if (context._currentRenderer2 !== undefined && context._currentRenderer2 !== null && context._currentRenderer2 !== rendererSigil) {
	            error('Detected multiple renderers concurrently rendering the ' + 'same context provider. This is currently unsupported.');
	          }
	          context._currentRenderer2 = rendererSigil;
	        }
	      }
	      return currentActiveSnapshot = prevSnapshot.parent;
	    }
	    function getActiveContext() {
	      return currentActiveSnapshot;
	    }
	    function readContext(context) {
	      var value = context._currentValue2;
	      return value;
	    }

	    /**
	     * `ReactInstanceMap` maintains a mapping from a public facing stateful
	     * instance (key) and the internal representation (value). This allows public
	     * methods to accept the user facing instance as an argument and map them back
	     * to internal methods.
	     *
	     * Note that this module is currently shared and assumed to be stateless.
	     * If this becomes an actual Map, that will break.
	     */
	    function get(key) {
	      return key._reactInternals;
	    }
	    function set(key, value) {
	      key._reactInternals = value;
	    }
	    var didWarnAboutNoopUpdateForComponent = {};
	    var didWarnAboutDeprecatedWillMount = {};
	    var didWarnAboutUninitializedState;
	    var didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate;
	    var didWarnAboutLegacyLifecyclesAndDerivedState;
	    var didWarnAboutUndefinedDerivedState;
	    var warnOnUndefinedDerivedState;
	    var warnOnInvalidCallback;
	    var didWarnAboutDirectlyAssigningPropsToState;
	    var didWarnAboutContextTypeAndContextTypes;
	    var didWarnAboutInvalidateContextType;
	    {
	      didWarnAboutUninitializedState = new Set();
	      didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate = new Set();
	      didWarnAboutLegacyLifecyclesAndDerivedState = new Set();
	      didWarnAboutDirectlyAssigningPropsToState = new Set();
	      didWarnAboutUndefinedDerivedState = new Set();
	      didWarnAboutContextTypeAndContextTypes = new Set();
	      didWarnAboutInvalidateContextType = new Set();
	      var didWarnOnInvalidCallback = new Set();
	      warnOnInvalidCallback = function (callback, callerName) {
	        if (callback === null || typeof callback === 'function') {
	          return;
	        }
	        var key = callerName + '_' + callback;
	        if (!didWarnOnInvalidCallback.has(key)) {
	          didWarnOnInvalidCallback.add(key);
	          error('%s(...): Expected the last optional `callback` argument to be a ' + 'function. Instead received: %s.', callerName, callback);
	        }
	      };
	      warnOnUndefinedDerivedState = function (type, partialState) {
	        if (partialState === undefined) {
	          var componentName = getComponentNameFromType(type) || 'Component';
	          if (!didWarnAboutUndefinedDerivedState.has(componentName)) {
	            didWarnAboutUndefinedDerivedState.add(componentName);
	            error('%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. ' + 'You have returned undefined.', componentName);
	          }
	        }
	      };
	    }
	    function warnNoop(publicInstance, callerName) {
	      {
	        var _constructor = publicInstance.constructor;
	        var componentName = _constructor && getComponentNameFromType(_constructor) || 'ReactClass';
	        var warningKey = componentName + '.' + callerName;
	        if (didWarnAboutNoopUpdateForComponent[warningKey]) {
	          return;
	        }
	        error('%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op.\n\nPlease check the code for the %s component.', callerName, callerName, componentName);
	        didWarnAboutNoopUpdateForComponent[warningKey] = true;
	      }
	    }
	    var classComponentUpdater = {
	      isMounted: function (inst) {
	        return false;
	      },
	      enqueueSetState: function (inst, payload, callback) {
	        var internals = get(inst);
	        if (internals.queue === null) {
	          warnNoop(inst, 'setState');
	        } else {
	          internals.queue.push(payload);
	          {
	            if (callback !== undefined && callback !== null) {
	              warnOnInvalidCallback(callback, 'setState');
	            }
	          }
	        }
	      },
	      enqueueReplaceState: function (inst, payload, callback) {
	        var internals = get(inst);
	        internals.replace = true;
	        internals.queue = [payload];
	        {
	          if (callback !== undefined && callback !== null) {
	            warnOnInvalidCallback(callback, 'setState');
	          }
	        }
	      },
	      enqueueForceUpdate: function (inst, callback) {
	        var internals = get(inst);
	        if (internals.queue === null) {
	          warnNoop(inst, 'forceUpdate');
	        } else {
	          {
	            if (callback !== undefined && callback !== null) {
	              warnOnInvalidCallback(callback, 'setState');
	            }
	          }
	        }
	      }
	    };
	    function applyDerivedStateFromProps(instance, ctor, getDerivedStateFromProps, prevState, nextProps) {
	      var partialState = getDerivedStateFromProps(nextProps, prevState);
	      {
	        warnOnUndefinedDerivedState(ctor, partialState);
	      } // Merge the partial state and the previous state.

	      var newState = partialState === null || partialState === undefined ? prevState : assign({}, prevState, partialState);
	      return newState;
	    }
	    function constructClassInstance(ctor, props, maskedLegacyContext) {
	      var context = emptyContextObject;
	      var contextType = ctor.contextType;
	      {
	        if ('contextType' in ctor) {
	          var isValid =
	          // Allow null for conditional declaration
	          contextType === null || contextType !== undefined && contextType.$$typeof === REACT_CONTEXT_TYPE && contextType._context === undefined; // Not a <Context.Consumer>

	          if (!isValid && !didWarnAboutInvalidateContextType.has(ctor)) {
	            didWarnAboutInvalidateContextType.add(ctor);
	            var addendum = '';
	            if (contextType === undefined) {
	              addendum = ' However, it is set to undefined. ' + 'This can be caused by a typo or by mixing up named and default imports. ' + 'This can also happen due to a circular dependency, so ' + 'try moving the createContext() call to a separate file.';
	            } else if (typeof contextType !== 'object') {
	              addendum = ' However, it is set to a ' + typeof contextType + '.';
	            } else if (contextType.$$typeof === REACT_PROVIDER_TYPE) {
	              addendum = ' Did you accidentally pass the Context.Provider instead?';
	            } else if (contextType._context !== undefined) {
	              // <Context.Consumer>
	              addendum = ' Did you accidentally pass the Context.Consumer instead?';
	            } else {
	              addendum = ' However, it is set to an object with keys {' + Object.keys(contextType).join(', ') + '}.';
	            }
	            error('%s defines an invalid contextType. ' + 'contextType should point to the Context object returned by React.createContext().%s', getComponentNameFromType(ctor) || 'Component', addendum);
	          }
	        }
	      }
	      if (typeof contextType === 'object' && contextType !== null) {
	        context = readContext(contextType);
	      } else {
	        context = maskedLegacyContext;
	      }
	      var instance = new ctor(props, context);
	      {
	        if (typeof ctor.getDerivedStateFromProps === 'function' && (instance.state === null || instance.state === undefined)) {
	          var componentName = getComponentNameFromType(ctor) || 'Component';
	          if (!didWarnAboutUninitializedState.has(componentName)) {
	            didWarnAboutUninitializedState.add(componentName);
	            error('`%s` uses `getDerivedStateFromProps` but its initial state is ' + '%s. This is not recommended. Instead, define the initial state by ' + 'assigning an object to `this.state` in the constructor of `%s`. ' + 'This ensures that `getDerivedStateFromProps` arguments have a consistent shape.', componentName, instance.state === null ? 'null' : 'undefined', componentName);
	          }
	        } // If new component APIs are defined, "unsafe" lifecycles won't be called.
	        // Warn about these lifecycles if they are present.
	        // Don't warn about react-lifecycles-compat polyfilled methods though.

	        if (typeof ctor.getDerivedStateFromProps === 'function' || typeof instance.getSnapshotBeforeUpdate === 'function') {
	          var foundWillMountName = null;
	          var foundWillReceivePropsName = null;
	          var foundWillUpdateName = null;
	          if (typeof instance.componentWillMount === 'function' && instance.componentWillMount.__suppressDeprecationWarning !== true) {
	            foundWillMountName = 'componentWillMount';
	          } else if (typeof instance.UNSAFE_componentWillMount === 'function') {
	            foundWillMountName = 'UNSAFE_componentWillMount';
	          }
	          if (typeof instance.componentWillReceiveProps === 'function' && instance.componentWillReceiveProps.__suppressDeprecationWarning !== true) {
	            foundWillReceivePropsName = 'componentWillReceiveProps';
	          } else if (typeof instance.UNSAFE_componentWillReceiveProps === 'function') {
	            foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
	          }
	          if (typeof instance.componentWillUpdate === 'function' && instance.componentWillUpdate.__suppressDeprecationWarning !== true) {
	            foundWillUpdateName = 'componentWillUpdate';
	          } else if (typeof instance.UNSAFE_componentWillUpdate === 'function') {
	            foundWillUpdateName = 'UNSAFE_componentWillUpdate';
	          }
	          if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
	            var _componentName = getComponentNameFromType(ctor) || 'Component';
	            var newApiName = typeof ctor.getDerivedStateFromProps === 'function' ? 'getDerivedStateFromProps()' : 'getSnapshotBeforeUpdate()';
	            if (!didWarnAboutLegacyLifecyclesAndDerivedState.has(_componentName)) {
	              didWarnAboutLegacyLifecyclesAndDerivedState.add(_componentName);
	              error('Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' + '%s uses %s but also contains the following legacy lifecycles:%s%s%s\n\n' + 'The above lifecycles should be removed. Learn more about this warning here:\n' + 'https://reactjs.org/link/unsafe-component-lifecycles', _componentName, newApiName, foundWillMountName !== null ? "\n  " + foundWillMountName : '', foundWillReceivePropsName !== null ? "\n  " + foundWillReceivePropsName : '', foundWillUpdateName !== null ? "\n  " + foundWillUpdateName : '');
	            }
	          }
	        }
	      }
	      return instance;
	    }
	    function checkClassInstance(instance, ctor, newProps) {
	      {
	        var name = getComponentNameFromType(ctor) || 'Component';
	        var renderPresent = instance.render;
	        if (!renderPresent) {
	          if (ctor.prototype && typeof ctor.prototype.render === 'function') {
	            error('%s(...): No `render` method found on the returned component ' + 'instance: did you accidentally return an object from the constructor?', name);
	          } else {
	            error('%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', name);
	          }
	        }
	        if (instance.getInitialState && !instance.getInitialState.isReactClassApproved && !instance.state) {
	          error('getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', name);
	        }
	        if (instance.getDefaultProps && !instance.getDefaultProps.isReactClassApproved) {
	          error('getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', name);
	        }
	        if (instance.propTypes) {
	          error('propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', name);
	        }
	        if (instance.contextType) {
	          error('contextType was defined as an instance property on %s. Use a static ' + 'property to define contextType instead.', name);
	        }
	        {
	          if (instance.contextTypes) {
	            error('contextTypes was defined as an instance property on %s. Use a static ' + 'property to define contextTypes instead.', name);
	          }
	          if (ctor.contextType && ctor.contextTypes && !didWarnAboutContextTypeAndContextTypes.has(ctor)) {
	            didWarnAboutContextTypeAndContextTypes.add(ctor);
	            error('%s declares both contextTypes and contextType static properties. ' + 'The legacy contextTypes property will be ignored.', name);
	          }
	        }
	        if (typeof instance.componentShouldUpdate === 'function') {
	          error('%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', name);
	        }
	        if (ctor.prototype && ctor.prototype.isPureReactComponent && typeof instance.shouldComponentUpdate !== 'undefined') {
	          error('%s has a method called shouldComponentUpdate(). ' + 'shouldComponentUpdate should not be used when extending React.PureComponent. ' + 'Please extend React.Component if shouldComponentUpdate is used.', getComponentNameFromType(ctor) || 'A pure component');
	        }
	        if (typeof instance.componentDidUnmount === 'function') {
	          error('%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', name);
	        }
	        if (typeof instance.componentDidReceiveProps === 'function') {
	          error('%s has a method called ' + 'componentDidReceiveProps(). But there is no such lifecycle method. ' + 'If you meant to update the state in response to changing props, ' + 'use componentWillReceiveProps(). If you meant to fetch data or ' + 'run side-effects or mutations after React has updated the UI, use componentDidUpdate().', name);
	        }
	        if (typeof instance.componentWillRecieveProps === 'function') {
	          error('%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', name);
	        }
	        if (typeof instance.UNSAFE_componentWillRecieveProps === 'function') {
	          error('%s has a method called ' + 'UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?', name);
	        }
	        var hasMutatedProps = instance.props !== newProps;
	        if (instance.props !== undefined && hasMutatedProps) {
	          error('%s(...): When calling super() in `%s`, make sure to pass ' + "up the same props that your component's constructor was passed.", name, name);
	        }
	        if (instance.defaultProps) {
	          error('Setting defaultProps as an instance property on %s is not supported and will be ignored.' + ' Instead, define defaultProps as a static property on %s.', name, name);
	        }
	        if (typeof instance.getSnapshotBeforeUpdate === 'function' && typeof instance.componentDidUpdate !== 'function' && !didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate.has(ctor)) {
	          didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate.add(ctor);
	          error('%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). ' + 'This component defines getSnapshotBeforeUpdate() only.', getComponentNameFromType(ctor));
	        }
	        if (typeof instance.getDerivedStateFromProps === 'function') {
	          error('%s: getDerivedStateFromProps() is defined as an instance method ' + 'and will be ignored. Instead, declare it as a static method.', name);
	        }
	        if (typeof instance.getDerivedStateFromError === 'function') {
	          error('%s: getDerivedStateFromError() is defined as an instance method ' + 'and will be ignored. Instead, declare it as a static method.', name);
	        }
	        if (typeof ctor.getSnapshotBeforeUpdate === 'function') {
	          error('%s: getSnapshotBeforeUpdate() is defined as a static method ' + 'and will be ignored. Instead, declare it as an instance method.', name);
	        }
	        var _state = instance.state;
	        if (_state && (typeof _state !== 'object' || isArray(_state))) {
	          error('%s.state: must be set to an object or null', name);
	        }
	        if (typeof instance.getChildContext === 'function' && typeof ctor.childContextTypes !== 'object') {
	          error('%s.getChildContext(): childContextTypes must be defined in order to ' + 'use getChildContext().', name);
	        }
	      }
	    }
	    function callComponentWillMount(type, instance) {
	      var oldState = instance.state;
	      if (typeof instance.componentWillMount === 'function') {
	        {
	          if (instance.componentWillMount.__suppressDeprecationWarning !== true) {
	            var componentName = getComponentNameFromType(type) || 'Unknown';
	            if (!didWarnAboutDeprecatedWillMount[componentName]) {
	              warn(
	              // keep this warning in sync with ReactStrictModeWarning.js
	              'componentWillMount has been renamed, and is not recommended for use. ' + 'See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n' + '* Move code from componentWillMount to componentDidMount (preferred in most cases) ' + 'or the constructor.\n' + '\nPlease update the following components: %s', componentName);
	              didWarnAboutDeprecatedWillMount[componentName] = true;
	            }
	          }
	        }
	        instance.componentWillMount();
	      }
	      if (typeof instance.UNSAFE_componentWillMount === 'function') {
	        instance.UNSAFE_componentWillMount();
	      }
	      if (oldState !== instance.state) {
	        {
	          error('%s.componentWillMount(): Assigning directly to this.state is ' + "deprecated (except inside a component's " + 'constructor). Use setState instead.', getComponentNameFromType(type) || 'Component');
	        }
	        classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
	      }
	    }
	    function processUpdateQueue(internalInstance, inst, props, maskedLegacyContext) {
	      if (internalInstance.queue !== null && internalInstance.queue.length > 0) {
	        var oldQueue = internalInstance.queue;
	        var oldReplace = internalInstance.replace;
	        internalInstance.queue = null;
	        internalInstance.replace = false;
	        if (oldReplace && oldQueue.length === 1) {
	          inst.state = oldQueue[0];
	        } else {
	          var nextState = oldReplace ? oldQueue[0] : inst.state;
	          var dontMutate = true;
	          for (var i = oldReplace ? 1 : 0; i < oldQueue.length; i++) {
	            var partial = oldQueue[i];
	            var partialState = typeof partial === 'function' ? partial.call(inst, nextState, props, maskedLegacyContext) : partial;
	            if (partialState != null) {
	              if (dontMutate) {
	                dontMutate = false;
	                nextState = assign({}, nextState, partialState);
	              } else {
	                assign(nextState, partialState);
	              }
	            }
	          }
	          inst.state = nextState;
	        }
	      } else {
	        internalInstance.queue = null;
	      }
	    } // Invokes the mount life-cycles on a previously never rendered instance.

	    function mountClassInstance(instance, ctor, newProps, maskedLegacyContext) {
	      {
	        checkClassInstance(instance, ctor, newProps);
	      }
	      var initialState = instance.state !== undefined ? instance.state : null;
	      instance.updater = classComponentUpdater;
	      instance.props = newProps;
	      instance.state = initialState; // We don't bother initializing the refs object on the server, since we're not going to resolve them anyway.
	      // The internal instance will be used to manage updates that happen during this mount.

	      var internalInstance = {
	        queue: [],
	        replace: false
	      };
	      set(instance, internalInstance);
	      var contextType = ctor.contextType;
	      if (typeof contextType === 'object' && contextType !== null) {
	        instance.context = readContext(contextType);
	      } else {
	        instance.context = maskedLegacyContext;
	      }
	      {
	        if (instance.state === newProps) {
	          var componentName = getComponentNameFromType(ctor) || 'Component';
	          if (!didWarnAboutDirectlyAssigningPropsToState.has(componentName)) {
	            didWarnAboutDirectlyAssigningPropsToState.add(componentName);
	            error('%s: It is not recommended to assign props directly to state ' + "because updates to props won't be reflected in state. " + 'In most cases, it is better to use props directly.', componentName);
	          }
	        }
	      }
	      var getDerivedStateFromProps = ctor.getDerivedStateFromProps;
	      if (typeof getDerivedStateFromProps === 'function') {
	        instance.state = applyDerivedStateFromProps(instance, ctor, getDerivedStateFromProps, initialState, newProps);
	      } // In order to support react-lifecycles-compat polyfilled components,
	      // Unsafe lifecycles should not be invoked for components using the new APIs.

	      if (typeof ctor.getDerivedStateFromProps !== 'function' && typeof instance.getSnapshotBeforeUpdate !== 'function' && (typeof instance.UNSAFE_componentWillMount === 'function' || typeof instance.componentWillMount === 'function')) {
	        callComponentWillMount(ctor, instance); // If we had additional state updates during this life-cycle, let's
	        // process them now.

	        processUpdateQueue(internalInstance, instance, newProps, maskedLegacyContext);
	      }
	    }

	    // Ids are base 32 strings whose binary representation corresponds to the
	    // position of a node in a tree.
	    // Every time the tree forks into multiple children, we add additional bits to
	    // the left of the sequence that represent the position of the child within the
	    // current level of children.
	    //
	    //      00101       00010001011010101
	    //      ╰─┬─╯       ╰───────┬───────╯
	    //   Fork 5 of 20       Parent id
	    //
	    // The leading 0s are important. In the above example, you only need 3 bits to
	    // represent slot 5. However, you need 5 bits to represent all the forks at
	    // the current level, so we must account for the empty bits at the end.
	    //
	    // For this same reason, slots are 1-indexed instead of 0-indexed. Otherwise,
	    // the zeroth id at a level would be indistinguishable from its parent.
	    //
	    // If a node has only one child, and does not materialize an id (i.e. does not
	    // contain a useId hook), then we don't need to allocate any space in the
	    // sequence. It's treated as a transparent indirection. For example, these two
	    // trees produce the same ids:
	    //
	    // <>                          <>
	    //   <Indirection>               <A />
	    //     <A />                     <B />
	    //   </Indirection>            </>
	    //   <B />
	    // </>
	    //
	    // However, we cannot skip any node that materializes an id. Otherwise, a parent
	    // id that does not fork would be indistinguishable from its child id. For
	    // example, this tree does not fork, but the parent and child must have
	    // different ids.
	    //
	    // <Parent>
	    //   <Child />
	    // </Parent>
	    //
	    // To handle this scenario, every time we materialize an id, we allocate a
	    // new level with a single slot. You can think of this as a fork with only one
	    // prong, or an array of children with length 1.
	    //
	    // It's possible for the size of the sequence to exceed 32 bits, the max
	    // size for bitwise operations. When this happens, we make more room by
	    // converting the right part of the id to a string and storing it in an overflow
	    // variable. We use a base 32 string representation, because 32 is the largest
	    // power of 2 that is supported by toString(). We want the base to be large so
	    // that the resulting ids are compact, and we want the base to be a power of 2
	    // because every log2(base) bits corresponds to a single character, i.e. every
	    // log2(32) = 5 bits. That means we can lop bits off the end 5 at a time without
	    // affecting the final result.
	    var emptyTreeContext = {
	      id: 1,
	      overflow: ''
	    };
	    function getTreeId(context) {
	      var overflow = context.overflow;
	      var idWithLeadingBit = context.id;
	      var id = idWithLeadingBit & ~getLeadingBit(idWithLeadingBit);
	      return id.toString(32) + overflow;
	    }
	    function pushTreeContext(baseContext, totalChildren, index) {
	      var baseIdWithLeadingBit = baseContext.id;
	      var baseOverflow = baseContext.overflow; // The leftmost 1 marks the end of the sequence, non-inclusive. It's not part
	      // of the id; we use it to account for leading 0s.

	      var baseLength = getBitLength(baseIdWithLeadingBit) - 1;
	      var baseId = baseIdWithLeadingBit & ~(1 << baseLength);
	      var slot = index + 1;
	      var length = getBitLength(totalChildren) + baseLength; // 30 is the max length we can store without overflowing, taking into
	      // consideration the leading 1 we use to mark the end of the sequence.

	      if (length > 30) {
	        // We overflowed the bitwise-safe range. Fall back to slower algorithm.
	        // This branch assumes the length of the base id is greater than 5; it won't
	        // work for smaller ids, because you need 5 bits per character.
	        //
	        // We encode the id in multiple steps: first the base id, then the
	        // remaining digits.
	        //
	        // Each 5 bit sequence corresponds to a single base 32 character. So for
	        // example, if the current id is 23 bits long, we can convert 20 of those
	        // bits into a string of 4 characters, with 3 bits left over.
	        //
	        // First calculate how many bits in the base id represent a complete
	        // sequence of characters.
	        var numberOfOverflowBits = baseLength - baseLength % 5; // Then create a bitmask that selects only those bits.

	        var newOverflowBits = (1 << numberOfOverflowBits) - 1; // Select the bits, and convert them to a base 32 string.

	        var newOverflow = (baseId & newOverflowBits).toString(32); // Now we can remove those bits from the base id.

	        var restOfBaseId = baseId >> numberOfOverflowBits;
	        var restOfBaseLength = baseLength - numberOfOverflowBits; // Finally, encode the rest of the bits using the normal algorithm. Because
	        // we made more room, this time it won't overflow.

	        var restOfLength = getBitLength(totalChildren) + restOfBaseLength;
	        var restOfNewBits = slot << restOfBaseLength;
	        var id = restOfNewBits | restOfBaseId;
	        var overflow = newOverflow + baseOverflow;
	        return {
	          id: 1 << restOfLength | id,
	          overflow: overflow
	        };
	      } else {
	        // Normal path
	        var newBits = slot << baseLength;
	        var _id = newBits | baseId;
	        var _overflow = baseOverflow;
	        return {
	          id: 1 << length | _id,
	          overflow: _overflow
	        };
	      }
	    }
	    function getBitLength(number) {
	      return 32 - clz32(number);
	    }
	    function getLeadingBit(id) {
	      return 1 << getBitLength(id) - 1;
	    } // TODO: Math.clz32 is supported in Node 12+. Maybe we can drop the fallback.

	    var clz32 = Math.clz32 ? Math.clz32 : clz32Fallback; // Count leading zeros.
	    // Based on:
	    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/clz32

	    var log = Math.log;
	    var LN2 = Math.LN2;
	    function clz32Fallback(x) {
	      var asUint = x >>> 0;
	      if (asUint === 0) {
	        return 32;
	      }
	      return 31 - (log(asUint) / LN2 | 0) | 0;
	    }

	    /**
	     * inlined Object.is polyfill to avoid requiring consumers ship their own
	     * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	     */
	    function is(x, y) {
	      return x === y && (x !== 0 || 1 / x === 1 / y) || x !== x && y !== y // eslint-disable-line no-self-compare
	      ;
	    }
	    var objectIs = typeof Object.is === 'function' ? Object.is : is;
	    var currentlyRenderingComponent = null;
	    var currentlyRenderingTask = null;
	    var firstWorkInProgressHook = null;
	    var workInProgressHook = null; // Whether the work-in-progress hook is a re-rendered hook

	    var isReRender = false; // Whether an update was scheduled during the currently executing render pass.

	    var didScheduleRenderPhaseUpdate = false; // Counts the number of useId hooks in this component

	    var localIdCounter = 0; // Lazily created map of render-phase updates

	    var renderPhaseUpdates = null; // Counter to prevent infinite loops.

	    var numberOfReRenders = 0;
	    var RE_RENDER_LIMIT = 25;
	    var isInHookUserCodeInDev = false; // In DEV, this is the name of the currently executing primitive hook

	    var currentHookNameInDev;
	    function resolveCurrentlyRenderingComponent() {
	      if (currentlyRenderingComponent === null) {
	        throw new Error('Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for' + ' one of the following reasons:\n' + '1. You might have mismatching versions of React and the renderer (such as React DOM)\n' + '2. You might be breaking the Rules of Hooks\n' + '3. You might have more than one copy of React in the same app\n' + 'See https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.');
	      }
	      {
	        if (isInHookUserCodeInDev) {
	          error('Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. ' + 'You can only call Hooks at the top level of your React function. ' + 'For more information, see ' + 'https://reactjs.org/link/rules-of-hooks');
	        }
	      }
	      return currentlyRenderingComponent;
	    }
	    function areHookInputsEqual(nextDeps, prevDeps) {
	      if (prevDeps === null) {
	        {
	          error('%s received a final argument during this render, but not during ' + 'the previous render. Even though the final argument is optional, ' + 'its type cannot change between renders.', currentHookNameInDev);
	        }
	        return false;
	      }
	      {
	        // Don't bother comparing lengths in prod because these arrays should be
	        // passed inline.
	        if (nextDeps.length !== prevDeps.length) {
	          error('The final argument passed to %s changed size between renders. The ' + 'order and size of this array must remain constant.\n\n' + 'Previous: %s\n' + 'Incoming: %s', currentHookNameInDev, "[" + nextDeps.join(', ') + "]", "[" + prevDeps.join(', ') + "]");
	        }
	      }
	      for (var i = 0; i < prevDeps.length && i < nextDeps.length; i++) {
	        if (objectIs(nextDeps[i], prevDeps[i])) {
	          continue;
	        }
	        return false;
	      }
	      return true;
	    }
	    function createHook() {
	      if (numberOfReRenders > 0) {
	        throw new Error('Rendered more hooks than during the previous render');
	      }
	      return {
	        memoizedState: null,
	        queue: null,
	        next: null
	      };
	    }
	    function createWorkInProgressHook() {
	      if (workInProgressHook === null) {
	        // This is the first hook in the list
	        if (firstWorkInProgressHook === null) {
	          isReRender = false;
	          firstWorkInProgressHook = workInProgressHook = createHook();
	        } else {
	          // There's already a work-in-progress. Reuse it.
	          isReRender = true;
	          workInProgressHook = firstWorkInProgressHook;
	        }
	      } else {
	        if (workInProgressHook.next === null) {
	          isReRender = false; // Append to the end of the list

	          workInProgressHook = workInProgressHook.next = createHook();
	        } else {
	          // There's already a work-in-progress. Reuse it.
	          isReRender = true;
	          workInProgressHook = workInProgressHook.next;
	        }
	      }
	      return workInProgressHook;
	    }
	    function prepareToUseHooks(task, componentIdentity) {
	      currentlyRenderingComponent = componentIdentity;
	      currentlyRenderingTask = task;
	      {
	        isInHookUserCodeInDev = false;
	      } // The following should have already been reset
	      // didScheduleRenderPhaseUpdate = false;
	      // localIdCounter = 0;
	      // firstWorkInProgressHook = null;
	      // numberOfReRenders = 0;
	      // renderPhaseUpdates = null;
	      // workInProgressHook = null;

	      localIdCounter = 0;
	    }
	    function finishHooks(Component, props, children, refOrContext) {
	      // This must be called after every function component to prevent hooks from
	      // being used in classes.
	      while (didScheduleRenderPhaseUpdate) {
	        // Updates were scheduled during the render phase. They are stored in
	        // the `renderPhaseUpdates` map. Call the component again, reusing the
	        // work-in-progress hooks and applying the additional updates on top. Keep
	        // restarting until no more updates are scheduled.
	        didScheduleRenderPhaseUpdate = false;
	        localIdCounter = 0;
	        numberOfReRenders += 1; // Start over from the beginning of the list

	        workInProgressHook = null;
	        children = Component(props, refOrContext);
	      }
	      resetHooksState();
	      return children;
	    }
	    function checkDidRenderIdHook() {
	      // This should be called immediately after every finishHooks call.
	      // Conceptually, it's part of the return value of finishHooks; it's only a
	      // separate function to avoid using an array tuple.
	      var didRenderIdHook = localIdCounter !== 0;
	      return didRenderIdHook;
	    } // Reset the internal hooks state if an error occurs while rendering a component

	    function resetHooksState() {
	      {
	        isInHookUserCodeInDev = false;
	      }
	      currentlyRenderingComponent = null;
	      currentlyRenderingTask = null;
	      didScheduleRenderPhaseUpdate = false;
	      firstWorkInProgressHook = null;
	      numberOfReRenders = 0;
	      renderPhaseUpdates = null;
	      workInProgressHook = null;
	    }
	    function readContext$1(context) {
	      {
	        if (isInHookUserCodeInDev) {
	          error('Context can only be read while React is rendering. ' + 'In classes, you can read it in the render method or getDerivedStateFromProps. ' + 'In function components, you can read it directly in the function body, but not ' + 'inside Hooks like useReducer() or useMemo().');
	        }
	      }
	      return readContext(context);
	    }
	    function useContext(context) {
	      {
	        currentHookNameInDev = 'useContext';
	      }
	      resolveCurrentlyRenderingComponent();
	      return readContext(context);
	    }
	    function basicStateReducer(state, action) {
	      // $FlowFixMe: Flow doesn't like mixed types
	      return typeof action === 'function' ? action(state) : action;
	    }
	    function useState(initialState) {
	      {
	        currentHookNameInDev = 'useState';
	      }
	      return useReducer(basicStateReducer,
	      // useReducer has a special case to support lazy useState initializers
	      initialState);
	    }
	    function useReducer(reducer, initialArg, init) {
	      {
	        if (reducer !== basicStateReducer) {
	          currentHookNameInDev = 'useReducer';
	        }
	      }
	      currentlyRenderingComponent = resolveCurrentlyRenderingComponent();
	      workInProgressHook = createWorkInProgressHook();
	      if (isReRender) {
	        // This is a re-render. Apply the new render phase updates to the previous
	        // current hook.
	        var queue = workInProgressHook.queue;
	        var dispatch = queue.dispatch;
	        if (renderPhaseUpdates !== null) {
	          // Render phase updates are stored in a map of queue -> linked list
	          var firstRenderPhaseUpdate = renderPhaseUpdates.get(queue);
	          if (firstRenderPhaseUpdate !== undefined) {
	            renderPhaseUpdates.delete(queue);
	            var newState = workInProgressHook.memoizedState;
	            var update = firstRenderPhaseUpdate;
	            do {
	              // Process this render phase update. We don't have to check the
	              // priority because it will always be the same as the current
	              // render's.
	              var action = update.action;
	              {
	                isInHookUserCodeInDev = true;
	              }
	              newState = reducer(newState, action);
	              {
	                isInHookUserCodeInDev = false;
	              }
	              update = update.next;
	            } while (update !== null);
	            workInProgressHook.memoizedState = newState;
	            return [newState, dispatch];
	          }
	        }
	        return [workInProgressHook.memoizedState, dispatch];
	      } else {
	        {
	          isInHookUserCodeInDev = true;
	        }
	        var initialState;
	        if (reducer === basicStateReducer) {
	          // Special case for `useState`.
	          initialState = typeof initialArg === 'function' ? initialArg() : initialArg;
	        } else {
	          initialState = init !== undefined ? init(initialArg) : initialArg;
	        }
	        {
	          isInHookUserCodeInDev = false;
	        }
	        workInProgressHook.memoizedState = initialState;
	        var _queue = workInProgressHook.queue = {
	          last: null,
	          dispatch: null
	        };
	        var _dispatch = _queue.dispatch = dispatchAction.bind(null, currentlyRenderingComponent, _queue);
	        return [workInProgressHook.memoizedState, _dispatch];
	      }
	    }
	    function useMemo(nextCreate, deps) {
	      currentlyRenderingComponent = resolveCurrentlyRenderingComponent();
	      workInProgressHook = createWorkInProgressHook();
	      var nextDeps = deps === undefined ? null : deps;
	      if (workInProgressHook !== null) {
	        var prevState = workInProgressHook.memoizedState;
	        if (prevState !== null) {
	          if (nextDeps !== null) {
	            var prevDeps = prevState[1];
	            if (areHookInputsEqual(nextDeps, prevDeps)) {
	              return prevState[0];
	            }
	          }
	        }
	      }
	      {
	        isInHookUserCodeInDev = true;
	      }
	      var nextValue = nextCreate();
	      {
	        isInHookUserCodeInDev = false;
	      }
	      workInProgressHook.memoizedState = [nextValue, nextDeps];
	      return nextValue;
	    }
	    function useRef(initialValue) {
	      currentlyRenderingComponent = resolveCurrentlyRenderingComponent();
	      workInProgressHook = createWorkInProgressHook();
	      var previousRef = workInProgressHook.memoizedState;
	      if (previousRef === null) {
	        var ref = {
	          current: initialValue
	        };
	        {
	          Object.seal(ref);
	        }
	        workInProgressHook.memoizedState = ref;
	        return ref;
	      } else {
	        return previousRef;
	      }
	    }
	    function useLayoutEffect(create, inputs) {
	      {
	        currentHookNameInDev = 'useLayoutEffect';
	        error('useLayoutEffect does nothing on the server, because its effect cannot ' + "be encoded into the server renderer's output format. This will lead " + 'to a mismatch between the initial, non-hydrated UI and the intended ' + 'UI. To avoid this, useLayoutEffect should only be used in ' + 'components that render exclusively on the client. ' + 'See https://reactjs.org/link/uselayouteffect-ssr for common fixes.');
	      }
	    }
	    function dispatchAction(componentIdentity, queue, action) {
	      if (numberOfReRenders >= RE_RENDER_LIMIT) {
	        throw new Error('Too many re-renders. React limits the number of renders to prevent ' + 'an infinite loop.');
	      }
	      if (componentIdentity === currentlyRenderingComponent) {
	        // This is a render phase update. Stash it in a lazily-created map of
	        // queue -> linked list of updates. After this render pass, we'll restart
	        // and apply the stashed updates on top of the work-in-progress hook.
	        didScheduleRenderPhaseUpdate = true;
	        var update = {
	          action: action,
	          next: null
	        };
	        if (renderPhaseUpdates === null) {
	          renderPhaseUpdates = new Map();
	        }
	        var firstRenderPhaseUpdate = renderPhaseUpdates.get(queue);
	        if (firstRenderPhaseUpdate === undefined) {
	          renderPhaseUpdates.set(queue, update);
	        } else {
	          // Append the update to the end of the list.
	          var lastRenderPhaseUpdate = firstRenderPhaseUpdate;
	          while (lastRenderPhaseUpdate.next !== null) {
	            lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
	          }
	          lastRenderPhaseUpdate.next = update;
	        }
	      }
	    }
	    function useCallback(callback, deps) {
	      return useMemo(function () {
	        return callback;
	      }, deps);
	    } // TODO Decide on how to implement this hook for server rendering.
	    // If a mutation occurs during render, consider triggering a Suspense boundary
	    // and falling back to client rendering.

	    function useMutableSource(source, getSnapshot, subscribe) {
	      resolveCurrentlyRenderingComponent();
	      return getSnapshot(source._source);
	    }
	    function useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
	      if (getServerSnapshot === undefined) {
	        throw new Error('Missing getServerSnapshot, which is required for ' + 'server-rendered content. Will revert to client rendering.');
	      }
	      return getServerSnapshot();
	    }
	    function useDeferredValue(value) {
	      resolveCurrentlyRenderingComponent();
	      return value;
	    }
	    function unsupportedStartTransition() {
	      throw new Error('startTransition cannot be called during server rendering.');
	    }
	    function useTransition() {
	      resolveCurrentlyRenderingComponent();
	      return [false, unsupportedStartTransition];
	    }
	    function useId() {
	      var task = currentlyRenderingTask;
	      var treeId = getTreeId(task.treeContext);
	      var responseState = currentResponseState;
	      if (responseState === null) {
	        throw new Error('Invalid hook call. Hooks can only be called inside of the body of a function component.');
	      }
	      var localId = localIdCounter++;
	      return makeId(responseState, treeId, localId);
	    }
	    function noop() {}
	    var Dispatcher = {
	      readContext: readContext$1,
	      useContext: useContext,
	      useMemo: useMemo,
	      useReducer: useReducer,
	      useRef: useRef,
	      useState: useState,
	      useInsertionEffect: noop,
	      useLayoutEffect: useLayoutEffect,
	      useCallback: useCallback,
	      // useImperativeHandle is not run in the server environment
	      useImperativeHandle: noop,
	      // Effects are not run in the server environment.
	      useEffect: noop,
	      // Debugging effect
	      useDebugValue: noop,
	      useDeferredValue: useDeferredValue,
	      useTransition: useTransition,
	      useId: useId,
	      // Subscriptions are not setup in a server environment.
	      useMutableSource: useMutableSource,
	      useSyncExternalStore: useSyncExternalStore
	    };
	    var currentResponseState = null;
	    function setCurrentResponseState(responseState) {
	      currentResponseState = responseState;
	    }
	    function getStackByComponentStackNode(componentStack) {
	      try {
	        var info = '';
	        var node = componentStack;
	        do {
	          switch (node.tag) {
	            case 0:
	              info += describeBuiltInComponentFrame(node.type, null, null);
	              break;
	            case 1:
	              info += describeFunctionComponentFrame(node.type, null, null);
	              break;
	            case 2:
	              info += describeClassComponentFrame(node.type, null, null);
	              break;
	          }
	          node = node.parent;
	        } while (node);
	        return info;
	      } catch (x) {
	        return '\nError generating stack: ' + x.message + '\n' + x.stack;
	      }
	    }
	    var ReactCurrentDispatcher$1 = ReactSharedInternals.ReactCurrentDispatcher;
	    var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;
	    var PENDING = 0;
	    var COMPLETED = 1;
	    var FLUSHED = 2;
	    var ABORTED = 3;
	    var ERRORED = 4;
	    var OPEN = 0;
	    var CLOSING = 1;
	    var CLOSED = 2;
	    // This is a default heuristic for how to split up the HTML content into progressive
	    // loading. Our goal is to be able to display additional new content about every 500ms.
	    // Faster than that is unnecessary and should be throttled on the client. It also
	    // adds unnecessary overhead to do more splits. We don't know if it's a higher or lower
	    // end device but higher end suffer less from the overhead than lower end does from
	    // not getting small enough pieces. We error on the side of low end.
	    // We base this on low end 3G speeds which is about 500kbits per second. We assume
	    // that there can be a reasonable drop off from max bandwidth which leaves you with
	    // as little as 80%. We can receive half of that each 500ms - at best. In practice,
	    // a little bandwidth is lost to processing and contention - e.g. CSS and images that
	    // are downloaded along with the main content. So we estimate about half of that to be
	    // the lower end throughput. In other words, we expect that you can at least show
	    // about 12.5kb of content per 500ms. Not counting starting latency for the first
	    // paint.
	    // 500 * 1024 / 8 * .8 * 0.5 / 2
	    var DEFAULT_PROGRESSIVE_CHUNK_SIZE = 12800;
	    function defaultErrorHandler(error) {
	      console['error'](error); // Don't transform to our wrapper

	      return null;
	    }
	    function noop$1() {}
	    function createRequest(children, responseState, rootFormatContext, progressiveChunkSize, onError, onAllReady, onShellReady, onShellError, onFatalError) {
	      var pingedTasks = [];
	      var abortSet = new Set();
	      var request = {
	        destination: null,
	        responseState: responseState,
	        progressiveChunkSize: progressiveChunkSize === undefined ? DEFAULT_PROGRESSIVE_CHUNK_SIZE : progressiveChunkSize,
	        status: OPEN,
	        fatalError: null,
	        nextSegmentId: 0,
	        allPendingTasks: 0,
	        pendingRootTasks: 0,
	        completedRootSegment: null,
	        abortableTasks: abortSet,
	        pingedTasks: pingedTasks,
	        clientRenderedBoundaries: [],
	        completedBoundaries: [],
	        partialBoundaries: [],
	        onError: onError === undefined ? defaultErrorHandler : onError,
	        onAllReady: noop$1 ,
	        onShellReady: onShellReady === undefined ? noop$1 : onShellReady,
	        onShellError: noop$1 ,
	        onFatalError: noop$1 
	      }; // This segment represents the root fallback.

	      var rootSegment = createPendingSegment(request, 0, null, rootFormatContext,
	      // Root segments are never embedded in Text on either edge
	      false, false); // There is no parent so conceptually, we're unblocked to flush this segment.

	      rootSegment.parentFlushed = true;
	      var rootTask = createTask(request, children, null, rootSegment, abortSet, emptyContextObject, rootContextSnapshot, emptyTreeContext);
	      pingedTasks.push(rootTask);
	      return request;
	    }
	    function pingTask(request, task) {
	      var pingedTasks = request.pingedTasks;
	      pingedTasks.push(task);
	      if (pingedTasks.length === 1) {
	        scheduleWork(function () {
	          return performWork(request);
	        });
	      }
	    }
	    function createSuspenseBoundary(request, fallbackAbortableTasks) {
	      return {
	        id: UNINITIALIZED_SUSPENSE_BOUNDARY_ID,
	        rootSegmentID: -1,
	        parentFlushed: false,
	        pendingTasks: 0,
	        forceClientRender: false,
	        completedSegments: [],
	        byteSize: 0,
	        fallbackAbortableTasks: fallbackAbortableTasks,
	        errorDigest: null
	      };
	    }
	    function createTask(request, node, blockedBoundary, blockedSegment, abortSet, legacyContext, context, treeContext) {
	      request.allPendingTasks++;
	      if (blockedBoundary === null) {
	        request.pendingRootTasks++;
	      } else {
	        blockedBoundary.pendingTasks++;
	      }
	      var task = {
	        node: node,
	        ping: function () {
	          return pingTask(request, task);
	        },
	        blockedBoundary: blockedBoundary,
	        blockedSegment: blockedSegment,
	        abortSet: abortSet,
	        legacyContext: legacyContext,
	        context: context,
	        treeContext: treeContext
	      };
	      {
	        task.componentStack = null;
	      }
	      abortSet.add(task);
	      return task;
	    }
	    function createPendingSegment(request, index, boundary, formatContext, lastPushedText, textEmbedded) {
	      return {
	        status: PENDING,
	        id: -1,
	        // lazily assigned later
	        index: index,
	        parentFlushed: false,
	        chunks: [],
	        children: [],
	        formatContext: formatContext,
	        boundary: boundary,
	        lastPushedText: lastPushedText,
	        textEmbedded: textEmbedded
	      };
	    } // DEV-only global reference to the currently executing task

	    var currentTaskInDEV = null;
	    function getCurrentStackInDEV() {
	      {
	        if (currentTaskInDEV === null || currentTaskInDEV.componentStack === null) {
	          return '';
	        }
	        return getStackByComponentStackNode(currentTaskInDEV.componentStack);
	      }
	    }
	    function pushBuiltInComponentStackInDEV(task, type) {
	      {
	        task.componentStack = {
	          tag: 0,
	          parent: task.componentStack,
	          type: type
	        };
	      }
	    }
	    function pushFunctionComponentStackInDEV(task, type) {
	      {
	        task.componentStack = {
	          tag: 1,
	          parent: task.componentStack,
	          type: type
	        };
	      }
	    }
	    function pushClassComponentStackInDEV(task, type) {
	      {
	        task.componentStack = {
	          tag: 2,
	          parent: task.componentStack,
	          type: type
	        };
	      }
	    }
	    function popComponentStackInDEV(task) {
	      {
	        if (task.componentStack === null) {
	          error('Unexpectedly popped too many stack frames. This is a bug in React.');
	        } else {
	          task.componentStack = task.componentStack.parent;
	        }
	      }
	    } // stash the component stack of an unwinding error until it is processed

	    var lastBoundaryErrorComponentStackDev = null;
	    function captureBoundaryErrorDetailsDev(boundary, error) {
	      {
	        var errorMessage;
	        if (typeof error === 'string') {
	          errorMessage = error;
	        } else if (error && typeof error.message === 'string') {
	          errorMessage = error.message;
	        } else {
	          // eslint-disable-next-line react-internal/safe-string-coercion
	          errorMessage = String(error);
	        }
	        var errorComponentStack = lastBoundaryErrorComponentStackDev || getCurrentStackInDEV();
	        lastBoundaryErrorComponentStackDev = null;
	        boundary.errorMessage = errorMessage;
	        boundary.errorComponentStack = errorComponentStack;
	      }
	    }
	    function logRecoverableError(request, error) {
	      // If this callback errors, we intentionally let that error bubble up to become a fatal error
	      // so that someone fixes the error reporting instead of hiding it.
	      var errorDigest = request.onError(error);
	      if (errorDigest != null && typeof errorDigest !== 'string') {
	        // eslint-disable-next-line react-internal/prod-error-codes
	        throw new Error("onError returned something with a type other than \"string\". onError should return a string and may return null or undefined but must not return anything else. It received something of type \"" + typeof errorDigest + "\" instead");
	      }
	      return errorDigest;
	    }
	    function fatalError(request, error) {
	      // This is called outside error handling code such as if the root errors outside
	      // a suspense boundary or if the root suspense boundary's fallback errors.
	      // It's also called if React itself or its host configs errors.
	      var onShellError = request.onShellError;
	      onShellError(error);
	      var onFatalError = request.onFatalError;
	      onFatalError(error);
	      if (request.destination !== null) {
	        request.status = CLOSED;
	        closeWithError(request.destination, error);
	      } else {
	        request.status = CLOSING;
	        request.fatalError = error;
	      }
	    }
	    function renderSuspenseBoundary(request, task, props) {
	      pushBuiltInComponentStackInDEV(task, 'Suspense');
	      var parentBoundary = task.blockedBoundary;
	      var parentSegment = task.blockedSegment; // Each time we enter a suspense boundary, we split out into a new segment for
	      // the fallback so that we can later replace that segment with the content.
	      // This also lets us split out the main content even if it doesn't suspend,
	      // in case it ends up generating a large subtree of content.

	      var fallback = props.fallback;
	      var content = props.children;
	      var fallbackAbortSet = new Set();
	      var newBoundary = createSuspenseBoundary(request, fallbackAbortSet);
	      var insertionIndex = parentSegment.chunks.length; // The children of the boundary segment is actually the fallback.

	      var boundarySegment = createPendingSegment(request, insertionIndex, newBoundary, parentSegment.formatContext,
	      // boundaries never require text embedding at their edges because comment nodes bound them
	      false, false);
	      parentSegment.children.push(boundarySegment); // The parentSegment has a child Segment at this index so we reset the lastPushedText marker on the parent

	      parentSegment.lastPushedText = false; // This segment is the actual child content. We can start rendering that immediately.

	      var contentRootSegment = createPendingSegment(request, 0, null, parentSegment.formatContext,
	      // boundaries never require text embedding at their edges because comment nodes bound them
	      false, false); // We mark the root segment as having its parent flushed. It's not really flushed but there is
	      // no parent segment so there's nothing to wait on.

	      contentRootSegment.parentFlushed = true; // Currently this is running synchronously. We could instead schedule this to pingedTasks.
	      // I suspect that there might be some efficiency benefits from not creating the suspended task
	      // and instead just using the stack if possible.
	      // TODO: Call this directly instead of messing with saving and restoring contexts.
	      // We can reuse the current context and task to render the content immediately without
	      // context switching. We just need to temporarily switch which boundary and which segment
	      // we're writing to. If something suspends, it'll spawn new suspended task with that context.

	      task.blockedBoundary = newBoundary;
	      task.blockedSegment = contentRootSegment;
	      try {
	        // We use the safe form because we don't handle suspending here. Only error handling.
	        renderNode(request, task, content);
	        pushSegmentFinale$1(contentRootSegment.chunks, request.responseState, contentRootSegment.lastPushedText, contentRootSegment.textEmbedded);
	        contentRootSegment.status = COMPLETED;
	        queueCompletedSegment(newBoundary, contentRootSegment);
	        if (newBoundary.pendingTasks === 0) {
	          // This must have been the last segment we were waiting on. This boundary is now complete.
	          // Therefore we won't need the fallback. We early return so that we don't have to create
	          // the fallback.
	          popComponentStackInDEV(task);
	          return;
	        }
	      } catch (error) {
	        contentRootSegment.status = ERRORED;
	        newBoundary.forceClientRender = true;
	        newBoundary.errorDigest = logRecoverableError(request, error);
	        {
	          captureBoundaryErrorDetailsDev(newBoundary, error);
	        } // We don't need to decrement any task numbers because we didn't spawn any new task.
	        // We don't need to schedule any task because we know the parent has written yet.
	        // We do need to fallthrough to create the fallback though.
	      } finally {
	        task.blockedBoundary = parentBoundary;
	        task.blockedSegment = parentSegment;
	      } // We create suspended task for the fallback because we don't want to actually work
	      // on it yet in case we finish the main content, so we queue for later.

	      var suspendedFallbackTask = createTask(request, fallback, parentBoundary, boundarySegment, fallbackAbortSet, task.legacyContext, task.context, task.treeContext);
	      {
	        suspendedFallbackTask.componentStack = task.componentStack;
	      } // TODO: This should be queued at a separate lower priority queue so that we only work
	      // on preparing fallbacks if we don't have any more main content to task on.

	      request.pingedTasks.push(suspendedFallbackTask);
	      popComponentStackInDEV(task);
	    }
	    function renderHostElement(request, task, type, props) {
	      pushBuiltInComponentStackInDEV(task, type);
	      var segment = task.blockedSegment;
	      var children = pushStartInstance(segment.chunks, type, props, request.responseState, segment.formatContext);
	      segment.lastPushedText = false;
	      var prevContext = segment.formatContext;
	      segment.formatContext = getChildFormatContext(prevContext, type, props); // We use the non-destructive form because if something suspends, we still
	      // need to pop back up and finish this subtree of HTML.

	      renderNode(request, task, children); // We expect that errors will fatal the whole task and that we don't need
	      // the correct context. Therefore this is not in a finally.

	      segment.formatContext = prevContext;
	      pushEndInstance(segment.chunks, type);
	      segment.lastPushedText = false;
	      popComponentStackInDEV(task);
	    }
	    function shouldConstruct$1(Component) {
	      return Component.prototype && Component.prototype.isReactComponent;
	    }
	    function renderWithHooks(request, task, Component, props, secondArg) {
	      var componentIdentity = {};
	      prepareToUseHooks(task, componentIdentity);
	      var result = Component(props, secondArg);
	      return finishHooks(Component, props, result, secondArg);
	    }
	    function finishClassComponent(request, task, instance, Component, props) {
	      var nextChildren = instance.render();
	      {
	        if (instance.props !== props) {
	          if (!didWarnAboutReassigningProps) {
	            error('It looks like %s is reassigning its own `this.props` while rendering. ' + 'This is not supported and can lead to confusing bugs.', getComponentNameFromType(Component) || 'a component');
	          }
	          didWarnAboutReassigningProps = true;
	        }
	      }
	      {
	        var childContextTypes = Component.childContextTypes;
	        if (childContextTypes !== null && childContextTypes !== undefined) {
	          var previousContext = task.legacyContext;
	          var mergedContext = processChildContext(instance, Component, previousContext, childContextTypes);
	          task.legacyContext = mergedContext;
	          renderNodeDestructive(request, task, nextChildren);
	          task.legacyContext = previousContext;
	          return;
	        }
	      }
	      renderNodeDestructive(request, task, nextChildren);
	    }
	    function renderClassComponent(request, task, Component, props) {
	      pushClassComponentStackInDEV(task, Component);
	      var maskedContext = getMaskedContext(Component, task.legacyContext);
	      var instance = constructClassInstance(Component, props, maskedContext);
	      mountClassInstance(instance, Component, props, maskedContext);
	      finishClassComponent(request, task, instance, Component, props);
	      popComponentStackInDEV(task);
	    }
	    var didWarnAboutBadClass = {};
	    var didWarnAboutModulePatternComponent = {};
	    var didWarnAboutContextTypeOnFunctionComponent = {};
	    var didWarnAboutGetDerivedStateOnFunctionComponent = {};
	    var didWarnAboutReassigningProps = false;
	    var didWarnAboutDefaultPropsOnFunctionComponent = {};
	    var didWarnAboutGenerators = false;
	    var didWarnAboutMaps = false;
	    var hasWarnedAboutUsingContextAsConsumer = false; // This would typically be a function component but we still support module pattern
	    // components for some reason.

	    function renderIndeterminateComponent(request, task, Component, props) {
	      var legacyContext;
	      {
	        legacyContext = getMaskedContext(Component, task.legacyContext);
	      }
	      pushFunctionComponentStackInDEV(task, Component);
	      {
	        if (Component.prototype && typeof Component.prototype.render === 'function') {
	          var componentName = getComponentNameFromType(Component) || 'Unknown';
	          if (!didWarnAboutBadClass[componentName]) {
	            error("The <%s /> component appears to have a render method, but doesn't extend React.Component. " + 'This is likely to cause errors. Change %s to extend React.Component instead.', componentName, componentName);
	            didWarnAboutBadClass[componentName] = true;
	          }
	        }
	      }
	      var value = renderWithHooks(request, task, Component, props, legacyContext);
	      var hasId = checkDidRenderIdHook();
	      {
	        // Support for module components is deprecated and is removed behind a flag.
	        // Whether or not it would crash later, we want to show a good message in DEV first.
	        if (typeof value === 'object' && value !== null && typeof value.render === 'function' && value.$$typeof === undefined) {
	          var _componentName = getComponentNameFromType(Component) || 'Unknown';
	          if (!didWarnAboutModulePatternComponent[_componentName]) {
	            error('The <%s /> component appears to be a function component that returns a class instance. ' + 'Change %s to a class that extends React.Component instead. ' + "If you can't use a class try assigning the prototype on the function as a workaround. " + "`%s.prototype = React.Component.prototype`. Don't use an arrow function since it " + 'cannot be called with `new` by React.', _componentName, _componentName, _componentName);
	            didWarnAboutModulePatternComponent[_componentName] = true;
	          }
	        }
	      }
	      if (
	      // Run these checks in production only if the flag is off.
	      // Eventually we'll delete this branch altogether.
	      typeof value === 'object' && value !== null && typeof value.render === 'function' && value.$$typeof === undefined) {
	        {
	          var _componentName2 = getComponentNameFromType(Component) || 'Unknown';
	          if (!didWarnAboutModulePatternComponent[_componentName2]) {
	            error('The <%s /> component appears to be a function component that returns a class instance. ' + 'Change %s to a class that extends React.Component instead. ' + "If you can't use a class try assigning the prototype on the function as a workaround. " + "`%s.prototype = React.Component.prototype`. Don't use an arrow function since it " + 'cannot be called with `new` by React.', _componentName2, _componentName2, _componentName2);
	            didWarnAboutModulePatternComponent[_componentName2] = true;
	          }
	        }
	        mountClassInstance(value, Component, props, legacyContext);
	        finishClassComponent(request, task, value, Component, props);
	      } else {
	        {
	          validateFunctionComponentInDev(Component);
	        } // We're now successfully past this task, and we don't have to pop back to
	        // the previous task every again, so we can use the destructive recursive form.

	        if (hasId) {
	          // This component materialized an id. We treat this as its own level, with
	          // a single "child" slot.
	          var prevTreeContext = task.treeContext;
	          var totalChildren = 1;
	          var index = 0;
	          task.treeContext = pushTreeContext(prevTreeContext, totalChildren, index);
	          try {
	            renderNodeDestructive(request, task, value);
	          } finally {
	            task.treeContext = prevTreeContext;
	          }
	        } else {
	          renderNodeDestructive(request, task, value);
	        }
	      }
	      popComponentStackInDEV(task);
	    }
	    function validateFunctionComponentInDev(Component) {
	      {
	        if (Component) {
	          if (Component.childContextTypes) {
	            error('%s(...): childContextTypes cannot be defined on a function component.', Component.displayName || Component.name || 'Component');
	          }
	        }
	        if (Component.defaultProps !== undefined) {
	          var componentName = getComponentNameFromType(Component) || 'Unknown';
	          if (!didWarnAboutDefaultPropsOnFunctionComponent[componentName]) {
	            error('%s: Support for defaultProps will be removed from function components ' + 'in a future major release. Use JavaScript default parameters instead.', componentName);
	            didWarnAboutDefaultPropsOnFunctionComponent[componentName] = true;
	          }
	        }
	        if (typeof Component.getDerivedStateFromProps === 'function') {
	          var _componentName3 = getComponentNameFromType(Component) || 'Unknown';
	          if (!didWarnAboutGetDerivedStateOnFunctionComponent[_componentName3]) {
	            error('%s: Function components do not support getDerivedStateFromProps.', _componentName3);
	            didWarnAboutGetDerivedStateOnFunctionComponent[_componentName3] = true;
	          }
	        }
	        if (typeof Component.contextType === 'object' && Component.contextType !== null) {
	          var _componentName4 = getComponentNameFromType(Component) || 'Unknown';
	          if (!didWarnAboutContextTypeOnFunctionComponent[_componentName4]) {
	            error('%s: Function components do not support contextType.', _componentName4);
	            didWarnAboutContextTypeOnFunctionComponent[_componentName4] = true;
	          }
	        }
	      }
	    }
	    function resolveDefaultProps(Component, baseProps) {
	      if (Component && Component.defaultProps) {
	        // Resolve default props. Taken from ReactElement
	        var props = assign({}, baseProps);
	        var defaultProps = Component.defaultProps;
	        for (var propName in defaultProps) {
	          if (props[propName] === undefined) {
	            props[propName] = defaultProps[propName];
	          }
	        }
	        return props;
	      }
	      return baseProps;
	    }
	    function renderForwardRef(request, task, type, props, ref) {
	      pushFunctionComponentStackInDEV(task, type.render);
	      var children = renderWithHooks(request, task, type.render, props, ref);
	      var hasId = checkDidRenderIdHook();
	      if (hasId) {
	        // This component materialized an id. We treat this as its own level, with
	        // a single "child" slot.
	        var prevTreeContext = task.treeContext;
	        var totalChildren = 1;
	        var index = 0;
	        task.treeContext = pushTreeContext(prevTreeContext, totalChildren, index);
	        try {
	          renderNodeDestructive(request, task, children);
	        } finally {
	          task.treeContext = prevTreeContext;
	        }
	      } else {
	        renderNodeDestructive(request, task, children);
	      }
	      popComponentStackInDEV(task);
	    }
	    function renderMemo(request, task, type, props, ref) {
	      var innerType = type.type;
	      var resolvedProps = resolveDefaultProps(innerType, props);
	      renderElement(request, task, innerType, resolvedProps, ref);
	    }
	    function renderContextConsumer(request, task, context, props) {
	      // The logic below for Context differs depending on PROD or DEV mode. In
	      // DEV mode, we create a separate object for Context.Consumer that acts
	      // like a proxy to Context. This proxy object adds unnecessary code in PROD
	      // so we use the old behaviour (Context.Consumer references Context) to
	      // reduce size and overhead. The separate object references context via
	      // a property called "_context", which also gives us the ability to check
	      // in DEV mode if this property exists or not and warn if it does not.
	      {
	        if (context._context === undefined) {
	          // This may be because it's a Context (rather than a Consumer).
	          // Or it may be because it's older React where they're the same thing.
	          // We only want to warn if we're sure it's a new React.
	          if (context !== context.Consumer) {
	            if (!hasWarnedAboutUsingContextAsConsumer) {
	              hasWarnedAboutUsingContextAsConsumer = true;
	              error('Rendering <Context> directly is not supported and will be removed in ' + 'a future major release. Did you mean to render <Context.Consumer> instead?');
	            }
	          }
	        } else {
	          context = context._context;
	        }
	      }
	      var render = props.children;
	      {
	        if (typeof render !== 'function') {
	          error('A context consumer was rendered with multiple children, or a child ' + "that isn't a function. A context consumer expects a single child " + 'that is a function. If you did pass a function, make sure there ' + 'is no trailing or leading whitespace around it.');
	        }
	      }
	      var newValue = readContext(context);
	      var newChildren = render(newValue);
	      renderNodeDestructive(request, task, newChildren);
	    }
	    function renderContextProvider(request, task, type, props) {
	      var context = type._context;
	      var value = props.value;
	      var children = props.children;
	      var prevSnapshot;
	      {
	        prevSnapshot = task.context;
	      }
	      task.context = pushProvider(context, value);
	      renderNodeDestructive(request, task, children);
	      task.context = popProvider(context);
	      {
	        if (prevSnapshot !== task.context) {
	          error('Popping the context provider did not return back to the original snapshot. This is a bug in React.');
	        }
	      }
	    }
	    function renderLazyComponent(request, task, lazyComponent, props, ref) {
	      pushBuiltInComponentStackInDEV(task, 'Lazy');
	      var payload = lazyComponent._payload;
	      var init = lazyComponent._init;
	      var Component = init(payload);
	      var resolvedProps = resolveDefaultProps(Component, props);
	      renderElement(request, task, Component, resolvedProps, ref);
	      popComponentStackInDEV(task);
	    }
	    function renderElement(request, task, type, props, ref) {
	      if (typeof type === 'function') {
	        if (shouldConstruct$1(type)) {
	          renderClassComponent(request, task, type, props);
	          return;
	        } else {
	          renderIndeterminateComponent(request, task, type, props);
	          return;
	        }
	      }
	      if (typeof type === 'string') {
	        renderHostElement(request, task, type, props);
	        return;
	      }
	      switch (type) {
	        // TODO: LegacyHidden acts the same as a fragment. This only works
	        // because we currently assume that every instance of LegacyHidden is
	        // accompanied by a host component wrapper. In the hidden mode, the host
	        // component is given a `hidden` attribute, which ensures that the
	        // initial HTML is not visible. To support the use of LegacyHidden as a
	        // true fragment, without an extra DOM node, we would have to hide the
	        // initial HTML in some other way.
	        // TODO: Add REACT_OFFSCREEN_TYPE here too with the same capability.
	        case REACT_LEGACY_HIDDEN_TYPE:
	        case REACT_DEBUG_TRACING_MODE_TYPE:
	        case REACT_STRICT_MODE_TYPE:
	        case REACT_PROFILER_TYPE:
	        case REACT_FRAGMENT_TYPE:
	          {
	            renderNodeDestructive(request, task, props.children);
	            return;
	          }
	        case REACT_SUSPENSE_LIST_TYPE:
	          {
	            pushBuiltInComponentStackInDEV(task, 'SuspenseList'); // TODO: SuspenseList should control the boundaries.

	            renderNodeDestructive(request, task, props.children);
	            popComponentStackInDEV(task);
	            return;
	          }
	        case REACT_SCOPE_TYPE:
	          {
	            throw new Error('ReactDOMServer does not yet support scope components.');
	          }
	        // eslint-disable-next-line-no-fallthrough

	        case REACT_SUSPENSE_TYPE:
	          {
	            {
	              renderSuspenseBoundary(request, task, props);
	            }
	            return;
	          }
	      }
	      if (typeof type === 'object' && type !== null) {
	        switch (type.$$typeof) {
	          case REACT_FORWARD_REF_TYPE:
	            {
	              renderForwardRef(request, task, type, props, ref);
	              return;
	            }
	          case REACT_MEMO_TYPE:
	            {
	              renderMemo(request, task, type, props, ref);
	              return;
	            }
	          case REACT_PROVIDER_TYPE:
	            {
	              renderContextProvider(request, task, type, props);
	              return;
	            }
	          case REACT_CONTEXT_TYPE:
	            {
	              renderContextConsumer(request, task, type, props);
	              return;
	            }
	          case REACT_LAZY_TYPE:
	            {
	              renderLazyComponent(request, task, type, props);
	              return;
	            }
	        }
	      }
	      var info = '';
	      {
	        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
	          info += ' You likely forgot to export your component from the file ' + "it's defined in, or you might have mixed up default and " + 'named imports.';
	        }
	      }
	      throw new Error('Element type is invalid: expected a string (for built-in ' + 'components) or a class/function (for composite components) ' + ("but got: " + (type == null ? type : typeof type) + "." + info));
	    }
	    function validateIterable(iterable, iteratorFn) {
	      {
	        // We don't support rendering Generators because it's a mutation.
	        // See https://github.com/facebook/react/issues/12995
	        if (typeof Symbol === 'function' &&
	        // $FlowFixMe Flow doesn't know about toStringTag
	        iterable[Symbol.toStringTag] === 'Generator') {
	          if (!didWarnAboutGenerators) {
	            error('Using Generators as children is unsupported and will likely yield ' + 'unexpected results because enumerating a generator mutates it. ' + 'You may convert it to an array with `Array.from()` or the ' + '`[...spread]` operator before rendering. Keep in mind ' + 'you might need to polyfill these features for older browsers.');
	          }
	          didWarnAboutGenerators = true;
	        } // Warn about using Maps as children

	        if (iterable.entries === iteratorFn) {
	          if (!didWarnAboutMaps) {
	            error('Using Maps as children is not supported. ' + 'Use an array of keyed ReactElements instead.');
	          }
	          didWarnAboutMaps = true;
	        }
	      }
	    }
	    function renderNodeDestructive(request, task, node) {
	      {
	        // In Dev we wrap renderNodeDestructiveImpl in a try / catch so we can capture
	        // a component stack at the right place in the tree. We don't do this in renderNode
	        // becuase it is not called at every layer of the tree and we may lose frames
	        try {
	          return renderNodeDestructiveImpl(request, task, node);
	        } catch (x) {
	          if (typeof x === 'object' && x !== null && typeof x.then === 'function') ;else {
	            // This is an error, stash the component stack if it is null.
	            lastBoundaryErrorComponentStackDev = lastBoundaryErrorComponentStackDev !== null ? lastBoundaryErrorComponentStackDev : getCurrentStackInDEV();
	          } // rethrow so normal suspense logic can handle thrown value accordingly

	          throw x;
	        }
	      }
	    } // This function by it self renders a node and consumes the task by mutating it
	    // to update the current execution state.

	    function renderNodeDestructiveImpl(request, task, node) {
	      // Stash the node we're working on. We'll pick up from this task in case
	      // something suspends.
	      task.node = node; // Handle object types

	      if (typeof node === 'object' && node !== null) {
	        switch (node.$$typeof) {
	          case REACT_ELEMENT_TYPE:
	            {
	              var element = node;
	              var type = element.type;
	              var props = element.props;
	              var ref = element.ref;
	              renderElement(request, task, type, props, ref);
	              return;
	            }
	          case REACT_PORTAL_TYPE:
	            throw new Error('Portals are not currently supported by the server renderer. ' + 'Render them conditionally so that they only appear on the client render.');
	          // eslint-disable-next-line-no-fallthrough

	          case REACT_LAZY_TYPE:
	            {
	              var lazyNode = node;
	              var payload = lazyNode._payload;
	              var init = lazyNode._init;
	              var resolvedNode;
	              {
	                try {
	                  resolvedNode = init(payload);
	                } catch (x) {
	                  if (typeof x === 'object' && x !== null && typeof x.then === 'function') {
	                    // this Lazy initializer is suspending. push a temporary frame onto the stack so it can be
	                    // popped off in spawnNewSuspendedTask. This aligns stack behavior between Lazy in element position
	                    // vs Component position. We do not want the frame for Errors so we exclusively do this in
	                    // the wakeable branch
	                    pushBuiltInComponentStackInDEV(task, 'Lazy');
	                  }
	                  throw x;
	                }
	              }
	              renderNodeDestructive(request, task, resolvedNode);
	              return;
	            }
	        }
	        if (isArray(node)) {
	          renderChildrenArray(request, task, node);
	          return;
	        }
	        var iteratorFn = getIteratorFn(node);
	        if (iteratorFn) {
	          {
	            validateIterable(node, iteratorFn);
	          }
	          var iterator = iteratorFn.call(node);
	          if (iterator) {
	            // We need to know how many total children are in this set, so that we
	            // can allocate enough id slots to acommodate them. So we must exhaust
	            // the iterator before we start recursively rendering the children.
	            // TODO: This is not great but I think it's inherent to the id
	            // generation algorithm.
	            var step = iterator.next(); // If there are not entries, we need to push an empty so we start by checking that.

	            if (!step.done) {
	              var children = [];
	              do {
	                children.push(step.value);
	                step = iterator.next();
	              } while (!step.done);
	              renderChildrenArray(request, task, children);
	              return;
	            }
	            return;
	          }
	        }
	        var childString = Object.prototype.toString.call(node);
	        throw new Error("Objects are not valid as a React child (found: " + (childString === '[object Object]' ? 'object with keys {' + Object.keys(node).join(', ') + '}' : childString) + "). " + 'If you meant to render a collection of children, use an array ' + 'instead.');
	      }
	      if (typeof node === 'string') {
	        var segment = task.blockedSegment;
	        segment.lastPushedText = pushTextInstance$1(task.blockedSegment.chunks, node, request.responseState, segment.lastPushedText);
	        return;
	      }
	      if (typeof node === 'number') {
	        var _segment = task.blockedSegment;
	        _segment.lastPushedText = pushTextInstance$1(task.blockedSegment.chunks, '' + node, request.responseState, _segment.lastPushedText);
	        return;
	      }
	      {
	        if (typeof node === 'function') {
	          error('Functions are not valid as a React child. This may happen if ' + 'you return a Component instead of <Component /> from render. ' + 'Or maybe you meant to call this function rather than return it.');
	        }
	      }
	    }
	    function renderChildrenArray(request, task, children) {
	      var totalChildren = children.length;
	      for (var i = 0; i < totalChildren; i++) {
	        var prevTreeContext = task.treeContext;
	        task.treeContext = pushTreeContext(prevTreeContext, totalChildren, i);
	        try {
	          // We need to use the non-destructive form so that we can safely pop back
	          // up and render the sibling if something suspends.
	          renderNode(request, task, children[i]);
	        } finally {
	          task.treeContext = prevTreeContext;
	        }
	      }
	    }
	    function spawnNewSuspendedTask(request, task, x) {
	      // Something suspended, we'll need to create a new segment and resolve it later.
	      var segment = task.blockedSegment;
	      var insertionIndex = segment.chunks.length;
	      var newSegment = createPendingSegment(request, insertionIndex, null, segment.formatContext,
	      // Adopt the parent segment's leading text embed
	      segment.lastPushedText,
	      // Assume we are text embedded at the trailing edge
	      true);
	      segment.children.push(newSegment); // Reset lastPushedText for current Segment since the new Segment "consumed" it

	      segment.lastPushedText = false;
	      var newTask = createTask(request, task.node, task.blockedBoundary, newSegment, task.abortSet, task.legacyContext, task.context, task.treeContext);
	      {
	        if (task.componentStack !== null) {
	          // We pop one task off the stack because the node that suspended will be tried again,
	          // which will add it back onto the stack.
	          newTask.componentStack = task.componentStack.parent;
	        }
	      }
	      var ping = newTask.ping;
	      x.then(ping, ping);
	    } // This is a non-destructive form of rendering a node. If it suspends it spawns
	    // a new task and restores the context of this task to what it was before.

	    function renderNode(request, task, node) {
	      // TODO: Store segment.children.length here and reset it in case something
	      // suspended partially through writing something.
	      // Snapshot the current context in case something throws to interrupt the
	      // process.
	      var previousFormatContext = task.blockedSegment.formatContext;
	      var previousLegacyContext = task.legacyContext;
	      var previousContext = task.context;
	      var previousComponentStack = null;
	      {
	        previousComponentStack = task.componentStack;
	      }
	      try {
	        return renderNodeDestructive(request, task, node);
	      } catch (x) {
	        resetHooksState();
	        if (typeof x === 'object' && x !== null && typeof x.then === 'function') {
	          spawnNewSuspendedTask(request, task, x); // Restore the context. We assume that this will be restored by the inner
	          // functions in case nothing throws so we don't use "finally" here.

	          task.blockedSegment.formatContext = previousFormatContext;
	          task.legacyContext = previousLegacyContext;
	          task.context = previousContext; // Restore all active ReactContexts to what they were before.

	          switchContext(previousContext);
	          {
	            task.componentStack = previousComponentStack;
	          }
	          return;
	        } else {
	          // Restore the context. We assume that this will be restored by the inner
	          // functions in case nothing throws so we don't use "finally" here.
	          task.blockedSegment.formatContext = previousFormatContext;
	          task.legacyContext = previousLegacyContext;
	          task.context = previousContext; // Restore all active ReactContexts to what they were before.

	          switchContext(previousContext);
	          {
	            task.componentStack = previousComponentStack;
	          } // We assume that we don't need the correct context.
	          // Let's terminate the rest of the tree and don't render any siblings.

	          throw x;
	        }
	      }
	    }
	    function erroredTask(request, boundary, segment, error) {
	      // Report the error to a global handler.
	      var errorDigest = logRecoverableError(request, error);
	      if (boundary === null) {
	        fatalError(request, error);
	      } else {
	        boundary.pendingTasks--;
	        if (!boundary.forceClientRender) {
	          boundary.forceClientRender = true;
	          boundary.errorDigest = errorDigest;
	          {
	            captureBoundaryErrorDetailsDev(boundary, error);
	          } // Regardless of what happens next, this boundary won't be displayed,
	          // so we can flush it, if the parent already flushed.

	          if (boundary.parentFlushed) {
	            // We don't have a preference where in the queue this goes since it's likely
	            // to error on the client anyway. However, intentionally client-rendered
	            // boundaries should be flushed earlier so that they can start on the client.
	            // We reuse the same queue for errors.
	            request.clientRenderedBoundaries.push(boundary);
	          }
	        }
	      }
	      request.allPendingTasks--;
	      if (request.allPendingTasks === 0) {
	        var onAllReady = request.onAllReady;
	        onAllReady();
	      }
	    }
	    function abortTaskSoft(task) {
	      // This aborts task without aborting the parent boundary that it blocks.
	      // It's used for when we didn't need this task to complete the tree.
	      // If task was needed, then it should use abortTask instead.
	      var request = this;
	      var boundary = task.blockedBoundary;
	      var segment = task.blockedSegment;
	      segment.status = ABORTED;
	      finishedTask(request, boundary, segment);
	    }
	    function abortTask(task, request, reason) {
	      // This aborts the task and aborts the parent that it blocks, putting it into
	      // client rendered mode.
	      var boundary = task.blockedBoundary;
	      var segment = task.blockedSegment;
	      segment.status = ABORTED;
	      if (boundary === null) {
	        request.allPendingTasks--; // We didn't complete the root so we have nothing to show. We can close
	        // the request;

	        if (request.status !== CLOSED) {
	          request.status = CLOSED;
	          if (request.destination !== null) {
	            close(request.destination);
	          }
	        }
	      } else {
	        boundary.pendingTasks--;
	        if (!boundary.forceClientRender) {
	          boundary.forceClientRender = true;
	          var _error = reason === undefined ? new Error('The render was aborted by the server without a reason.') : reason;
	          boundary.errorDigest = request.onError(_error);
	          {
	            var errorPrefix = 'The server did not finish this Suspense boundary: ';
	            if (_error && typeof _error.message === 'string') {
	              _error = errorPrefix + _error.message;
	            } else {
	              // eslint-disable-next-line react-internal/safe-string-coercion
	              _error = errorPrefix + String(_error);
	            }
	            var previousTaskInDev = currentTaskInDEV;
	            currentTaskInDEV = task;
	            try {
	              captureBoundaryErrorDetailsDev(boundary, _error);
	            } finally {
	              currentTaskInDEV = previousTaskInDev;
	            }
	          }
	          if (boundary.parentFlushed) {
	            request.clientRenderedBoundaries.push(boundary);
	          }
	        } // If this boundary was still pending then we haven't already cancelled its fallbacks.
	        // We'll need to abort the fallbacks, which will also error that parent boundary.

	        boundary.fallbackAbortableTasks.forEach(function (fallbackTask) {
	          return abortTask(fallbackTask, request, reason);
	        });
	        boundary.fallbackAbortableTasks.clear();
	        request.allPendingTasks--;
	        if (request.allPendingTasks === 0) {
	          var onAllReady = request.onAllReady;
	          onAllReady();
	        }
	      }
	    }
	    function queueCompletedSegment(boundary, segment) {
	      if (segment.chunks.length === 0 && segment.children.length === 1 && segment.children[0].boundary === null) {
	        // This is an empty segment. There's nothing to write, so we can instead transfer the ID
	        // to the child. That way any existing references point to the child.
	        var childSegment = segment.children[0];
	        childSegment.id = segment.id;
	        childSegment.parentFlushed = true;
	        if (childSegment.status === COMPLETED) {
	          queueCompletedSegment(boundary, childSegment);
	        }
	      } else {
	        var completedSegments = boundary.completedSegments;
	        completedSegments.push(segment);
	      }
	    }
	    function finishedTask(request, boundary, segment) {
	      if (boundary === null) {
	        if (segment.parentFlushed) {
	          if (request.completedRootSegment !== null) {
	            throw new Error('There can only be one root segment. This is a bug in React.');
	          }
	          request.completedRootSegment = segment;
	        }
	        request.pendingRootTasks--;
	        if (request.pendingRootTasks === 0) {
	          // We have completed the shell so the shell can't error anymore.
	          request.onShellError = noop$1;
	          var onShellReady = request.onShellReady;
	          onShellReady();
	        }
	      } else {
	        boundary.pendingTasks--;
	        if (boundary.forceClientRender) ;else if (boundary.pendingTasks === 0) {
	          // This must have been the last segment we were waiting on. This boundary is now complete.
	          if (segment.parentFlushed) {
	            // Our parent segment already flushed, so we need to schedule this segment to be emitted.
	            // If it is a segment that was aborted, we'll write other content instead so we don't need
	            // to emit it.
	            if (segment.status === COMPLETED) {
	              queueCompletedSegment(boundary, segment);
	            }
	          }
	          if (boundary.parentFlushed) {
	            // The segment might be part of a segment that didn't flush yet, but if the boundary's
	            // parent flushed, we need to schedule the boundary to be emitted.
	            request.completedBoundaries.push(boundary);
	          } // We can now cancel any pending task on the fallback since we won't need to show it anymore.
	          // This needs to happen after we read the parentFlushed flags because aborting can finish
	          // work which can trigger user code, which can start flushing, which can change those flags.

	          boundary.fallbackAbortableTasks.forEach(abortTaskSoft, request);
	          boundary.fallbackAbortableTasks.clear();
	        } else {
	          if (segment.parentFlushed) {
	            // Our parent already flushed, so we need to schedule this segment to be emitted.
	            // If it is a segment that was aborted, we'll write other content instead so we don't need
	            // to emit it.
	            if (segment.status === COMPLETED) {
	              queueCompletedSegment(boundary, segment);
	              var completedSegments = boundary.completedSegments;
	              if (completedSegments.length === 1) {
	                // This is the first time since we last flushed that we completed anything.
	                // We can schedule this boundary to emit its partially completed segments early
	                // in case the parent has already been flushed.
	                if (boundary.parentFlushed) {
	                  request.partialBoundaries.push(boundary);
	                }
	              }
	            }
	          }
	        }
	      }
	      request.allPendingTasks--;
	      if (request.allPendingTasks === 0) {
	        // This needs to be called at the very end so that we can synchronously write the result
	        // in the callback if needed.
	        var onAllReady = request.onAllReady;
	        onAllReady();
	      }
	    }
	    function retryTask(request, task) {
	      var segment = task.blockedSegment;
	      if (segment.status !== PENDING) {
	        // We completed this by other means before we had a chance to retry it.
	        return;
	      } // We restore the context to what it was when we suspended.
	      // We don't restore it after we leave because it's likely that we'll end up
	      // needing a very similar context soon again.

	      switchContext(task.context);
	      var prevTaskInDEV = null;
	      {
	        prevTaskInDEV = currentTaskInDEV;
	        currentTaskInDEV = task;
	      }
	      try {
	        // We call the destructive form that mutates this task. That way if something
	        // suspends again, we can reuse the same task instead of spawning a new one.
	        renderNodeDestructive(request, task, task.node);
	        pushSegmentFinale$1(segment.chunks, request.responseState, segment.lastPushedText, segment.textEmbedded);
	        task.abortSet.delete(task);
	        segment.status = COMPLETED;
	        finishedTask(request, task.blockedBoundary, segment);
	      } catch (x) {
	        resetHooksState();
	        if (typeof x === 'object' && x !== null && typeof x.then === 'function') {
	          // Something suspended again, let's pick it back up later.
	          var ping = task.ping;
	          x.then(ping, ping);
	        } else {
	          task.abortSet.delete(task);
	          segment.status = ERRORED;
	          erroredTask(request, task.blockedBoundary, segment, x);
	        }
	      } finally {
	        {
	          currentTaskInDEV = prevTaskInDEV;
	        }
	      }
	    }
	    function performWork(request) {
	      if (request.status === CLOSED) {
	        return;
	      }
	      var prevContext = getActiveContext();
	      var prevDispatcher = ReactCurrentDispatcher$1.current;
	      ReactCurrentDispatcher$1.current = Dispatcher;
	      var prevGetCurrentStackImpl;
	      {
	        prevGetCurrentStackImpl = ReactDebugCurrentFrame$1.getCurrentStack;
	        ReactDebugCurrentFrame$1.getCurrentStack = getCurrentStackInDEV;
	      }
	      var prevResponseState = currentResponseState;
	      setCurrentResponseState(request.responseState);
	      try {
	        var pingedTasks = request.pingedTasks;
	        var i;
	        for (i = 0; i < pingedTasks.length; i++) {
	          var task = pingedTasks[i];
	          retryTask(request, task);
	        }
	        pingedTasks.splice(0, i);
	        if (request.destination !== null) {
	          flushCompletedQueues(request, request.destination);
	        }
	      } catch (error) {
	        logRecoverableError(request, error);
	        fatalError(request, error);
	      } finally {
	        setCurrentResponseState(prevResponseState);
	        ReactCurrentDispatcher$1.current = prevDispatcher;
	        {
	          ReactDebugCurrentFrame$1.getCurrentStack = prevGetCurrentStackImpl;
	        }
	        if (prevDispatcher === Dispatcher) {
	          // This means that we were in a reentrant work loop. This could happen
	          // in a renderer that supports synchronous work like renderToString,
	          // when it's called from within another renderer.
	          // Normally we don't bother switching the contexts to their root/default
	          // values when leaving because we'll likely need the same or similar
	          // context again. However, when we're inside a synchronous loop like this
	          // we'll to restore the context to what it was before returning.
	          switchContext(prevContext);
	        }
	      }
	    }
	    function flushSubtree(request, destination, segment) {
	      segment.parentFlushed = true;
	      switch (segment.status) {
	        case PENDING:
	          {
	            // We're emitting a placeholder for this segment to be filled in later.
	            // Therefore we'll need to assign it an ID - to refer to it by.
	            var segmentID = segment.id = request.nextSegmentId++; // When this segment finally completes it won't be embedded in text since it will flush separately

	            segment.lastPushedText = false;
	            segment.textEmbedded = false;
	            return writePlaceholder(destination, request.responseState, segmentID);
	          }
	        case COMPLETED:
	          {
	            segment.status = FLUSHED;
	            var r = true;
	            var chunks = segment.chunks;
	            var chunkIdx = 0;
	            var children = segment.children;
	            for (var childIdx = 0; childIdx < children.length; childIdx++) {
	              var nextChild = children[childIdx]; // Write all the chunks up until the next child.

	              for (; chunkIdx < nextChild.index; chunkIdx++) {
	                writeChunk(destination, chunks[chunkIdx]);
	              }
	              r = flushSegment(request, destination, nextChild);
	            } // Finally just write all the remaining chunks

	            for (; chunkIdx < chunks.length - 1; chunkIdx++) {
	              writeChunk(destination, chunks[chunkIdx]);
	            }
	            if (chunkIdx < chunks.length) {
	              r = writeChunkAndReturn(destination, chunks[chunkIdx]);
	            }
	            return r;
	          }
	        default:
	          {
	            throw new Error('Aborted, errored or already flushed boundaries should not be flushed again. This is a bug in React.');
	          }
	      }
	    }
	    function flushSegment(request, destination, segment) {
	      var boundary = segment.boundary;
	      if (boundary === null) {
	        // Not a suspense boundary.
	        return flushSubtree(request, destination, segment);
	      }
	      boundary.parentFlushed = true; // This segment is a Suspense boundary. We need to decide whether to
	      // emit the content or the fallback now.

	      if (boundary.forceClientRender) {
	        // Emit a client rendered suspense boundary wrapper.
	        // We never queue the inner boundary so we'll never emit its content or partial segments.
	        writeStartClientRenderedSuspenseBoundary$1(destination, request.responseState, boundary.errorDigest, boundary.errorMessage, boundary.errorComponentStack); // Flush the fallback.

	        flushSubtree(request, destination, segment);
	        return writeEndClientRenderedSuspenseBoundary$1(destination, request.responseState);
	      } else if (boundary.pendingTasks > 0) {
	        // This boundary is still loading. Emit a pending suspense boundary wrapper.
	        // Assign an ID to refer to the future content by.
	        boundary.rootSegmentID = request.nextSegmentId++;
	        if (boundary.completedSegments.length > 0) {
	          // If this is at least partially complete, we can queue it to be partially emitted early.
	          request.partialBoundaries.push(boundary);
	        } /// This is the first time we should have referenced this ID.

	        var id = boundary.id = assignSuspenseBoundaryID(request.responseState);
	        writeStartPendingSuspenseBoundary(destination, request.responseState, id); // Flush the fallback.

	        flushSubtree(request, destination, segment);
	        return writeEndPendingSuspenseBoundary(destination, request.responseState);
	      } else if (boundary.byteSize > request.progressiveChunkSize) {
	        // This boundary is large and will be emitted separately so that we can progressively show
	        // other content. We add it to the queue during the flush because we have to ensure that
	        // the parent flushes first so that there's something to inject it into.
	        // We also have to make sure that it's emitted into the queue in a deterministic slot.
	        // I.e. we can't insert it here when it completes.
	        // Assign an ID to refer to the future content by.
	        boundary.rootSegmentID = request.nextSegmentId++;
	        request.completedBoundaries.push(boundary); // Emit a pending rendered suspense boundary wrapper.

	        writeStartPendingSuspenseBoundary(destination, request.responseState, boundary.id); // Flush the fallback.

	        flushSubtree(request, destination, segment);
	        return writeEndPendingSuspenseBoundary(destination, request.responseState);
	      } else {
	        // We can inline this boundary's content as a complete boundary.
	        writeStartCompletedSuspenseBoundary$1(destination, request.responseState);
	        var completedSegments = boundary.completedSegments;
	        if (completedSegments.length !== 1) {
	          throw new Error('A previously unvisited boundary must have exactly one root segment. This is a bug in React.');
	        }
	        var contentSegment = completedSegments[0];
	        flushSegment(request, destination, contentSegment);
	        return writeEndCompletedSuspenseBoundary$1(destination, request.responseState);
	      }
	    }
	    function flushClientRenderedBoundary(request, destination, boundary) {
	      return writeClientRenderBoundaryInstruction(destination, request.responseState, boundary.id, boundary.errorDigest, boundary.errorMessage, boundary.errorComponentStack);
	    }
	    function flushSegmentContainer(request, destination, segment) {
	      writeStartSegment(destination, request.responseState, segment.formatContext, segment.id);
	      flushSegment(request, destination, segment);
	      return writeEndSegment(destination, segment.formatContext);
	    }
	    function flushCompletedBoundary(request, destination, boundary) {
	      var completedSegments = boundary.completedSegments;
	      var i = 0;
	      for (; i < completedSegments.length; i++) {
	        var segment = completedSegments[i];
	        flushPartiallyCompletedSegment(request, destination, boundary, segment);
	      }
	      completedSegments.length = 0;
	      return writeCompletedBoundaryInstruction(destination, request.responseState, boundary.id, boundary.rootSegmentID);
	    }
	    function flushPartialBoundary(request, destination, boundary) {
	      var completedSegments = boundary.completedSegments;
	      var i = 0;
	      for (; i < completedSegments.length; i++) {
	        var segment = completedSegments[i];
	        if (!flushPartiallyCompletedSegment(request, destination, boundary, segment)) {
	          i++;
	          completedSegments.splice(0, i); // Only write as much as the buffer wants. Something higher priority
	          // might want to write later.

	          return false;
	        }
	      }
	      completedSegments.splice(0, i);
	      return true;
	    }
	    function flushPartiallyCompletedSegment(request, destination, boundary, segment) {
	      if (segment.status === FLUSHED) {
	        // We've already flushed this inline.
	        return true;
	      }
	      var segmentID = segment.id;
	      if (segmentID === -1) {
	        // This segment wasn't previously referred to. This happens at the root of
	        // a boundary. We make kind of a leap here and assume this is the root.
	        var rootSegmentID = segment.id = boundary.rootSegmentID;
	        if (rootSegmentID === -1) {
	          throw new Error('A root segment ID must have been assigned by now. This is a bug in React.');
	        }
	        return flushSegmentContainer(request, destination, segment);
	      } else {
	        flushSegmentContainer(request, destination, segment);
	        return writeCompletedSegmentInstruction(destination, request.responseState, segmentID);
	      }
	    }
	    function flushCompletedQueues(request, destination) {
	      try {
	        // The structure of this is to go through each queue one by one and write
	        // until the sink tells us to stop. When we should stop, we still finish writing
	        // that item fully and then yield. At that point we remove the already completed
	        // items up until the point we completed them.
	        // TODO: Emit preloading.
	        // TODO: It's kind of unfortunate to keep checking this array after we've already
	        // emitted the root.
	        var completedRootSegment = request.completedRootSegment;
	        if (completedRootSegment !== null && request.pendingRootTasks === 0) {
	          flushSegment(request, destination, completedRootSegment);
	          request.completedRootSegment = null;
	          writeCompletedRoot(destination, request.responseState);
	        } // We emit client rendering instructions for already emitted boundaries first.
	        // This is so that we can signal to the client to start client rendering them as
	        // soon as possible.

	        var clientRenderedBoundaries = request.clientRenderedBoundaries;
	        var i;
	        for (i = 0; i < clientRenderedBoundaries.length; i++) {
	          var boundary = clientRenderedBoundaries[i];
	          if (!flushClientRenderedBoundary(request, destination, boundary)) {
	            request.destination = null;
	            i++;
	            clientRenderedBoundaries.splice(0, i);
	            return;
	          }
	        }
	        clientRenderedBoundaries.splice(0, i); // Next we emit any complete boundaries. It's better to favor boundaries
	        // that are completely done since we can actually show them, than it is to emit
	        // any individual segments from a partially complete boundary.

	        var completedBoundaries = request.completedBoundaries;
	        for (i = 0; i < completedBoundaries.length; i++) {
	          var _boundary = completedBoundaries[i];
	          if (!flushCompletedBoundary(request, destination, _boundary)) {
	            request.destination = null;
	            i++;
	            completedBoundaries.splice(0, i);
	            return;
	          }
	        }
	        completedBoundaries.splice(0, i); // Allow anything written so far to flush to the underlying sink before
	        // we continue with lower priorities.

	        completeWriting(destination);
	        beginWriting(destination); // TODO: Here we'll emit data used by hydration.
	        // Next we emit any segments of any boundaries that are partially complete
	        // but not deeply complete.

	        var partialBoundaries = request.partialBoundaries;
	        for (i = 0; i < partialBoundaries.length; i++) {
	          var _boundary2 = partialBoundaries[i];
	          if (!flushPartialBoundary(request, destination, _boundary2)) {
	            request.destination = null;
	            i++;
	            partialBoundaries.splice(0, i);
	            return;
	          }
	        }
	        partialBoundaries.splice(0, i); // Next we check the completed boundaries again. This may have had
	        // boundaries added to it in case they were too larged to be inlined.
	        // New ones might be added in this loop.

	        var largeBoundaries = request.completedBoundaries;
	        for (i = 0; i < largeBoundaries.length; i++) {
	          var _boundary3 = largeBoundaries[i];
	          if (!flushCompletedBoundary(request, destination, _boundary3)) {
	            request.destination = null;
	            i++;
	            largeBoundaries.splice(0, i);
	            return;
	          }
	        }
	        largeBoundaries.splice(0, i);
	      } finally {
	        if (request.allPendingTasks === 0 && request.pingedTasks.length === 0 && request.clientRenderedBoundaries.length === 0 && request.completedBoundaries.length === 0 // We don't need to check any partially completed segments because
	        // either they have pending task or they're complete.
	        ) {
	          {
	            if (request.abortableTasks.size !== 0) {
	              error('There was still abortable task at the root when we closed. This is a bug in React.');
	            }
	          } // We're done.

	          close(destination);
	        }
	      }
	    }
	    function startWork(request) {
	      scheduleWork(function () {
	        return performWork(request);
	      });
	    }
	    function startFlowing(request, destination) {
	      if (request.status === CLOSING) {
	        request.status = CLOSED;
	        closeWithError(destination, request.fatalError);
	        return;
	      }
	      if (request.status === CLOSED) {
	        return;
	      }
	      if (request.destination !== null) {
	        // We're already flowing.
	        return;
	      }
	      request.destination = destination;
	      try {
	        flushCompletedQueues(request, destination);
	      } catch (error) {
	        logRecoverableError(request, error);
	        fatalError(request, error);
	      }
	    } // This is called to early terminate a request. It puts all pending boundaries in client rendered state.

	    function abort(request, reason) {
	      try {
	        var abortableTasks = request.abortableTasks;
	        abortableTasks.forEach(function (task) {
	          return abortTask(task, request, reason);
	        });
	        abortableTasks.clear();
	        if (request.destination !== null) {
	          flushCompletedQueues(request, request.destination);
	        }
	      } catch (error) {
	        logRecoverableError(request, error);
	        fatalError(request, error);
	      }
	    }
	    function onError() {// Non-fatal errors are ignored.
	    }
	    function renderToStringImpl(children, options, generateStaticMarkup, abortReason) {
	      var didFatal = false;
	      var fatalError = null;
	      var result = '';
	      var destination = {
	        push: function (chunk) {
	          if (chunk !== null) {
	            result += chunk;
	          }
	          return true;
	        },
	        destroy: function (error) {
	          didFatal = true;
	          fatalError = error;
	        }
	      };
	      var readyToStream = false;
	      function onShellReady() {
	        readyToStream = true;
	      }
	      var request = createRequest(children, createResponseState$1(generateStaticMarkup, options ? options.identifierPrefix : undefined), createRootFormatContext(), Infinity, onError, undefined, onShellReady);
	      startWork(request); // If anything suspended and is still pending, we'll abort it before writing.
	      // That way we write only client-rendered boundaries from the start.

	      abort(request, abortReason);
	      startFlowing(request, destination);
	      if (didFatal) {
	        throw fatalError;
	      }
	      if (!readyToStream) {
	        // Note: This error message is the one we use on the client. It doesn't
	        // really make sense here. But this is the legacy server renderer, anyway.
	        // We're going to delete it soon.
	        throw new Error('A component suspended while responding to synchronous input. This ' + 'will cause the UI to be replaced with a loading indicator. To fix, ' + 'updates that suspend should be wrapped with startTransition.');
	      }
	      return result;
	    }
	    function renderToString(children, options) {
	      return renderToStringImpl(children, options, false, 'The server used "renderToString" which does not support Suspense. If you intended for this Suspense boundary to render the fallback content on the server consider throwing an Error somewhere within the Suspense boundary. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server');
	    }
	    function renderToStaticMarkup(children, options) {
	      return renderToStringImpl(children, options, true, 'The server used "renderToStaticMarkup" which does not support Suspense. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server');
	    }
	    function renderToNodeStream() {
	      throw new Error('ReactDOMServer.renderToNodeStream(): The streaming API is not available ' + 'in the browser. Use ReactDOMServer.renderToString() instead.');
	    }
	    function renderToStaticNodeStream() {
	      throw new Error('ReactDOMServer.renderToStaticNodeStream(): The streaming API is not available ' + 'in the browser. Use ReactDOMServer.renderToStaticMarkup() instead.');
	    }
	    reactDomServerLegacy_browser_development.renderToNodeStream = renderToNodeStream;
	    reactDomServerLegacy_browser_development.renderToStaticMarkup = renderToStaticMarkup;
	    reactDomServerLegacy_browser_development.renderToStaticNodeStream = renderToStaticNodeStream;
	    reactDomServerLegacy_browser_development.renderToString = renderToString;
	    reactDomServerLegacy_browser_development.version = ReactVersion;
	  })();
	}
	return reactDomServerLegacy_browser_development;
}

var reactDomServer_browser_development = {};

/**
 * @license React
 * react-dom-server.browser.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactDomServer_browser_development;

function requireReactDomServer_browser_development () {
	if (hasRequiredReactDomServer_browser_development) return reactDomServer_browser_development;
	hasRequiredReactDomServer_browser_development = 1;

	if (process.env.NODE_ENV !== "production") {
	  (function () {

	    var React$1 = React;
	    var ReactVersion = '18.3.1';
	    var ReactSharedInternals = React$1.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;

	    // by calls to these methods by a Babel plugin.
	    //
	    // In PROD (or in packages without access to React internals),
	    // they are left as they are instead.

	    function warn(format) {
	      {
	        {
	          for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	            args[_key - 1] = arguments[_key];
	          }
	          printWarning('warn', format, args);
	        }
	      }
	    }
	    function error(format) {
	      {
	        {
	          for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	            args[_key2 - 1] = arguments[_key2];
	          }
	          printWarning('error', format, args);
	        }
	      }
	    }
	    function printWarning(level, format, args) {
	      // When changing this logic, you might want to also
	      // update consoleWithStackDev.www.js as well.
	      {
	        var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
	        var stack = ReactDebugCurrentFrame.getStackAddendum();
	        if (stack !== '') {
	          format += '%s';
	          args = args.concat([stack]);
	        } // eslint-disable-next-line react-internal/safe-string-coercion

	        var argsWithFormat = args.map(function (item) {
	          return String(item);
	        }); // Careful: RN currently depends on this prefix

	        argsWithFormat.unshift('Warning: ' + format); // We intentionally don't use spread (or .apply) directly because it
	        // breaks IE9: https://github.com/facebook/react/issues/13610
	        // eslint-disable-next-line react-internal/no-production-logging

	        Function.prototype.apply.call(console[level], console, argsWithFormat);
	      }
	    }
	    function scheduleWork(callback) {
	      callback();
	    }
	    var VIEW_SIZE = 512;
	    var currentView = null;
	    var writtenBytes = 0;
	    function beginWriting(destination) {
	      currentView = new Uint8Array(VIEW_SIZE);
	      writtenBytes = 0;
	    }
	    function writeChunk(destination, chunk) {
	      if (chunk.length === 0) {
	        return;
	      }
	      if (chunk.length > VIEW_SIZE) {
	        // this chunk may overflow a single view which implies it was not
	        // one that is cached by the streaming renderer. We will enqueu
	        // it directly and expect it is not re-used
	        if (writtenBytes > 0) {
	          destination.enqueue(new Uint8Array(currentView.buffer, 0, writtenBytes));
	          currentView = new Uint8Array(VIEW_SIZE);
	          writtenBytes = 0;
	        }
	        destination.enqueue(chunk);
	        return;
	      }
	      var bytesToWrite = chunk;
	      var allowableBytes = currentView.length - writtenBytes;
	      if (allowableBytes < bytesToWrite.length) {
	        // this chunk would overflow the current view. We enqueue a full view
	        // and start a new view with the remaining chunk
	        if (allowableBytes === 0) {
	          // the current view is already full, send it
	          destination.enqueue(currentView);
	        } else {
	          // fill up the current view and apply the remaining chunk bytes
	          // to a new view.
	          currentView.set(bytesToWrite.subarray(0, allowableBytes), writtenBytes); // writtenBytes += allowableBytes; // this can be skipped because we are going to immediately reset the view

	          destination.enqueue(currentView);
	          bytesToWrite = bytesToWrite.subarray(allowableBytes);
	        }
	        currentView = new Uint8Array(VIEW_SIZE);
	        writtenBytes = 0;
	      }
	      currentView.set(bytesToWrite, writtenBytes);
	      writtenBytes += bytesToWrite.length;
	    }
	    function writeChunkAndReturn(destination, chunk) {
	      writeChunk(destination, chunk); // in web streams there is no backpressure so we can alwas write more

	      return true;
	    }
	    function completeWriting(destination) {
	      if (currentView && writtenBytes > 0) {
	        destination.enqueue(new Uint8Array(currentView.buffer, 0, writtenBytes));
	        currentView = null;
	        writtenBytes = 0;
	      }
	    }
	    function close(destination) {
	      destination.close();
	    }
	    var textEncoder = new TextEncoder();
	    function stringToChunk(content) {
	      return textEncoder.encode(content);
	    }
	    function stringToPrecomputedChunk(content) {
	      return textEncoder.encode(content);
	    }
	    function closeWithError(destination, error) {
	      if (typeof destination.error === 'function') {
	        // $FlowFixMe: This is an Error object or the destination accepts other types.
	        destination.error(error);
	      } else {
	        // Earlier implementations doesn't support this method. In that environment you're
	        // supposed to throw from a promise returned but we don't return a promise in our
	        // approach. We could fork this implementation but this is environment is an edge
	        // case to begin with. It's even less common to run this in an older environment.
	        // Even then, this is not where errors are supposed to happen and they get reported
	        // to a global callback in addition to this anyway. So it's fine just to close this.
	        destination.close();
	      }
	    }

	    /*
	     * The `'' + value` pattern (used in in perf-sensitive code) throws for Symbol
	     * and Temporal.* types. See https://github.com/facebook/react/pull/22064.
	     *
	     * The functions in this module will throw an easier-to-understand,
	     * easier-to-debug exception with a clear errors message message explaining the
	     * problem. (Instead of a confusing exception thrown inside the implementation
	     * of the `value` object).
	     */
	    // $FlowFixMe only called in DEV, so void return is not possible.
	    function typeName(value) {
	      {
	        // toStringTag is needed for namespaced types like Temporal.Instant
	        var hasToStringTag = typeof Symbol === 'function' && Symbol.toStringTag;
	        var type = hasToStringTag && value[Symbol.toStringTag] || value.constructor.name || 'Object';
	        return type;
	      }
	    } // $FlowFixMe only called in DEV, so void return is not possible.

	    function willCoercionThrow(value) {
	      {
	        try {
	          testStringCoercion(value);
	          return false;
	        } catch (e) {
	          return true;
	        }
	      }
	    }
	    function testStringCoercion(value) {
	      // If you ended up here by following an exception call stack, here's what's
	      // happened: you supplied an object or symbol value to React (as a prop, key,
	      // DOM attribute, CSS property, string ref, etc.) and when React tried to
	      // coerce it to a string using `'' + value`, an exception was thrown.
	      //
	      // The most common types that will cause this exception are `Symbol` instances
	      // and Temporal objects like `Temporal.Instant`. But any object that has a
	      // `valueOf` or `[Symbol.toPrimitive]` method that throws will also cause this
	      // exception. (Library authors do this to prevent users from using built-in
	      // numeric operators like `+` or comparison operators like `>=` because custom
	      // methods are needed to perform accurate arithmetic or comparison.)
	      //
	      // To fix the problem, coerce this object or symbol value to a string before
	      // passing it to React. The most reliable way is usually `String(value)`.
	      //
	      // To find which value is throwing, check the browser or debugger console.
	      // Before this exception was thrown, there should be `console.error` output
	      // that shows the type (Symbol, Temporal.PlainDate, etc.) that caused the
	      // problem and how that type was used: key, atrribute, input value prop, etc.
	      // In most cases, this console output also shows the component and its
	      // ancestor components where the exception happened.
	      //
	      // eslint-disable-next-line react-internal/safe-string-coercion
	      return '' + value;
	    }
	    function checkAttributeStringCoercion(value, attributeName) {
	      {
	        if (willCoercionThrow(value)) {
	          error('The provided `%s` attribute is an unsupported type %s.' + ' This value must be coerced to a string before before using it here.', attributeName, typeName(value));
	          return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
	        }
	      }
	    }
	    function checkCSSPropertyStringCoercion(value, propName) {
	      {
	        if (willCoercionThrow(value)) {
	          error('The provided `%s` CSS property is an unsupported type %s.' + ' This value must be coerced to a string before before using it here.', propName, typeName(value));
	          return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
	        }
	      }
	    }
	    function checkHtmlStringCoercion(value) {
	      {
	        if (willCoercionThrow(value)) {
	          error('The provided HTML markup uses a value of unsupported type %s.' + ' This value must be coerced to a string before before using it here.', typeName(value));
	          return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
	        }
	      }
	    }
	    var hasOwnProperty = Object.prototype.hasOwnProperty;

	    // A reserved attribute.
	    // It is handled by React separately and shouldn't be written to the DOM.
	    var RESERVED = 0; // A simple string attribute.
	    // Attributes that aren't in the filter are presumed to have this type.

	    var STRING = 1; // A string attribute that accepts booleans in React. In HTML, these are called
	    // "enumerated" attributes with "true" and "false" as possible values.
	    // When true, it should be set to a "true" string.
	    // When false, it should be set to a "false" string.

	    var BOOLEANISH_STRING = 2; // A real boolean attribute.
	    // When true, it should be present (set either to an empty string or its name).
	    // When false, it should be omitted.

	    var BOOLEAN = 3; // An attribute that can be used as a flag as well as with a value.
	    // When true, it should be present (set either to an empty string or its name).
	    // When false, it should be omitted.
	    // For any other value, should be present with that value.

	    var OVERLOADED_BOOLEAN = 4; // An attribute that must be numeric or parse as a numeric.
	    // When falsy, it should be removed.

	    var NUMERIC = 5; // An attribute that must be positive numeric or parse as a positive numeric.
	    // When falsy, it should be removed.

	    var POSITIVE_NUMERIC = 6;

	    /* eslint-disable max-len */
	    var ATTRIBUTE_NAME_START_CHAR = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD";
	    /* eslint-enable max-len */

	    var ATTRIBUTE_NAME_CHAR = ATTRIBUTE_NAME_START_CHAR + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040";
	    var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + ATTRIBUTE_NAME_START_CHAR + '][' + ATTRIBUTE_NAME_CHAR + ']*$');
	    var illegalAttributeNameCache = {};
	    var validatedAttributeNameCache = {};
	    function isAttributeNameSafe(attributeName) {
	      if (hasOwnProperty.call(validatedAttributeNameCache, attributeName)) {
	        return true;
	      }
	      if (hasOwnProperty.call(illegalAttributeNameCache, attributeName)) {
	        return false;
	      }
	      if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
	        validatedAttributeNameCache[attributeName] = true;
	        return true;
	      }
	      illegalAttributeNameCache[attributeName] = true;
	      {
	        error('Invalid attribute name: `%s`', attributeName);
	      }
	      return false;
	    }
	    function shouldRemoveAttributeWithWarning(name, value, propertyInfo, isCustomComponentTag) {
	      if (propertyInfo !== null && propertyInfo.type === RESERVED) {
	        return false;
	      }
	      switch (typeof value) {
	        case 'function': // $FlowIssue symbol is perfectly valid here

	        case 'symbol':
	          // eslint-disable-line
	          return true;
	        case 'boolean':
	          {
	            if (propertyInfo !== null) {
	              return !propertyInfo.acceptsBooleans;
	            } else {
	              var prefix = name.toLowerCase().slice(0, 5);
	              return prefix !== 'data-' && prefix !== 'aria-';
	            }
	          }
	        default:
	          return false;
	      }
	    }
	    function getPropertyInfo(name) {
	      return properties.hasOwnProperty(name) ? properties[name] : null;
	    }
	    function PropertyInfoRecord(name, type, mustUseProperty, attributeName, attributeNamespace, sanitizeURL, removeEmptyString) {
	      this.acceptsBooleans = type === BOOLEANISH_STRING || type === BOOLEAN || type === OVERLOADED_BOOLEAN;
	      this.attributeName = attributeName;
	      this.attributeNamespace = attributeNamespace;
	      this.mustUseProperty = mustUseProperty;
	      this.propertyName = name;
	      this.type = type;
	      this.sanitizeURL = sanitizeURL;
	      this.removeEmptyString = removeEmptyString;
	    } // When adding attributes to this list, be sure to also add them to
	    // the `possibleStandardNames` module to ensure casing and incorrect
	    // name warnings.

	    var properties = {}; // These props are reserved by React. They shouldn't be written to the DOM.

	    var reservedProps = ['children', 'dangerouslySetInnerHTML',
	    // TODO: This prevents the assignment of defaultValue to regular
	    // elements (not just inputs). Now that ReactDOMInput assigns to the
	    // defaultValue property -- do we need this?
	    'defaultValue', 'defaultChecked', 'innerHTML', 'suppressContentEditableWarning', 'suppressHydrationWarning', 'style'];
	    reservedProps.forEach(function (name) {
	      properties[name] = new PropertyInfoRecord(name, RESERVED, false,
	      // mustUseProperty
	      name,
	      // attributeName
	      null,
	      // attributeNamespace
	      false,
	      // sanitizeURL
	      false);
	    }); // A few React string attributes have a different name.
	    // This is a mapping from React prop names to the attribute names.

	    [['acceptCharset', 'accept-charset'], ['className', 'class'], ['htmlFor', 'for'], ['httpEquiv', 'http-equiv']].forEach(function (_ref) {
	      var name = _ref[0],
	        attributeName = _ref[1];
	      properties[name] = new PropertyInfoRecord(name, STRING, false,
	      // mustUseProperty
	      attributeName,
	      // attributeName
	      null,
	      // attributeNamespace
	      false,
	      // sanitizeURL
	      false);
	    }); // These are "enumerated" HTML attributes that accept "true" and "false".
	    // In React, we let users pass `true` and `false` even though technically
	    // these aren't boolean attributes (they are coerced to strings).

	    ['contentEditable', 'draggable', 'spellCheck', 'value'].forEach(function (name) {
	      properties[name] = new PropertyInfoRecord(name, BOOLEANISH_STRING, false,
	      // mustUseProperty
	      name.toLowerCase(),
	      // attributeName
	      null,
	      // attributeNamespace
	      false,
	      // sanitizeURL
	      false);
	    }); // These are "enumerated" SVG attributes that accept "true" and "false".
	    // In React, we let users pass `true` and `false` even though technically
	    // these aren't boolean attributes (they are coerced to strings).
	    // Since these are SVG attributes, their attribute names are case-sensitive.

	    ['autoReverse', 'externalResourcesRequired', 'focusable', 'preserveAlpha'].forEach(function (name) {
	      properties[name] = new PropertyInfoRecord(name, BOOLEANISH_STRING, false,
	      // mustUseProperty
	      name,
	      // attributeName
	      null,
	      // attributeNamespace
	      false,
	      // sanitizeURL
	      false);
	    }); // These are HTML boolean attributes.

	    ['allowFullScreen', 'async',
	    // Note: there is a special case that prevents it from being written to the DOM
	    // on the client side because the browsers are inconsistent. Instead we call focus().
	    'autoFocus', 'autoPlay', 'controls', 'default', 'defer', 'disabled', 'disablePictureInPicture', 'disableRemotePlayback', 'formNoValidate', 'hidden', 'loop', 'noModule', 'noValidate', 'open', 'playsInline', 'readOnly', 'required', 'reversed', 'scoped', 'seamless',
	    // Microdata
	    'itemScope'].forEach(function (name) {
	      properties[name] = new PropertyInfoRecord(name, BOOLEAN, false,
	      // mustUseProperty
	      name.toLowerCase(),
	      // attributeName
	      null,
	      // attributeNamespace
	      false,
	      // sanitizeURL
	      false);
	    }); // These are the few React props that we set as DOM properties
	    // rather than attributes. These are all booleans.

	    ['checked',
	    // Note: `option.selected` is not updated if `select.multiple` is
	    // disabled with `removeAttribute`. We have special logic for handling this.
	    'multiple', 'muted', 'selected' // NOTE: if you add a camelCased prop to this list,
	    // you'll need to set attributeName to name.toLowerCase()
	    // instead in the assignment below.
	    ].forEach(function (name) {
	      properties[name] = new PropertyInfoRecord(name, BOOLEAN, true,
	      // mustUseProperty
	      name,
	      // attributeName
	      null,
	      // attributeNamespace
	      false,
	      // sanitizeURL
	      false);
	    }); // These are HTML attributes that are "overloaded booleans": they behave like
	    // booleans, but can also accept a string value.

	    ['capture', 'download' // NOTE: if you add a camelCased prop to this list,
	    // you'll need to set attributeName to name.toLowerCase()
	    // instead in the assignment below.
	    ].forEach(function (name) {
	      properties[name] = new PropertyInfoRecord(name, OVERLOADED_BOOLEAN, false,
	      // mustUseProperty
	      name,
	      // attributeName
	      null,
	      // attributeNamespace
	      false,
	      // sanitizeURL
	      false);
	    }); // These are HTML attributes that must be positive numbers.

	    ['cols', 'rows', 'size', 'span' // NOTE: if you add a camelCased prop to this list,
	    // you'll need to set attributeName to name.toLowerCase()
	    // instead in the assignment below.
	    ].forEach(function (name) {
	      properties[name] = new PropertyInfoRecord(name, POSITIVE_NUMERIC, false,
	      // mustUseProperty
	      name,
	      // attributeName
	      null,
	      // attributeNamespace
	      false,
	      // sanitizeURL
	      false);
	    }); // These are HTML attributes that must be numbers.

	    ['rowSpan', 'start'].forEach(function (name) {
	      properties[name] = new PropertyInfoRecord(name, NUMERIC, false,
	      // mustUseProperty
	      name.toLowerCase(),
	      // attributeName
	      null,
	      // attributeNamespace
	      false,
	      // sanitizeURL
	      false);
	    });
	    var CAMELIZE = /[\-\:]([a-z])/g;
	    var capitalize = function (token) {
	      return token[1].toUpperCase();
	    }; // This is a list of all SVG attributes that need special casing, namespacing,
	    // or boolean value assignment. Regular attributes that just accept strings
	    // and have the same names are omitted, just like in the HTML attribute filter.
	    // Some of these attributes can be hard to find. This list was created by
	    // scraping the MDN documentation.

	    ['accent-height', 'alignment-baseline', 'arabic-form', 'baseline-shift', 'cap-height', 'clip-path', 'clip-rule', 'color-interpolation', 'color-interpolation-filters', 'color-profile', 'color-rendering', 'dominant-baseline', 'enable-background', 'fill-opacity', 'fill-rule', 'flood-color', 'flood-opacity', 'font-family', 'font-size', 'font-size-adjust', 'font-stretch', 'font-style', 'font-variant', 'font-weight', 'glyph-name', 'glyph-orientation-horizontal', 'glyph-orientation-vertical', 'horiz-adv-x', 'horiz-origin-x', 'image-rendering', 'letter-spacing', 'lighting-color', 'marker-end', 'marker-mid', 'marker-start', 'overline-position', 'overline-thickness', 'paint-order', 'panose-1', 'pointer-events', 'rendering-intent', 'shape-rendering', 'stop-color', 'stop-opacity', 'strikethrough-position', 'strikethrough-thickness', 'stroke-dasharray', 'stroke-dashoffset', 'stroke-linecap', 'stroke-linejoin', 'stroke-miterlimit', 'stroke-opacity', 'stroke-width', 'text-anchor', 'text-decoration', 'text-rendering', 'underline-position', 'underline-thickness', 'unicode-bidi', 'unicode-range', 'units-per-em', 'v-alphabetic', 'v-hanging', 'v-ideographic', 'v-mathematical', 'vector-effect', 'vert-adv-y', 'vert-origin-x', 'vert-origin-y', 'word-spacing', 'writing-mode', 'xmlns:xlink', 'x-height' // NOTE: if you add a camelCased prop to this list,
	    // you'll need to set attributeName to name.toLowerCase()
	    // instead in the assignment below.
	    ].forEach(function (attributeName) {
	      var name = attributeName.replace(CAMELIZE, capitalize);
	      properties[name] = new PropertyInfoRecord(name, STRING, false,
	      // mustUseProperty
	      attributeName, null,
	      // attributeNamespace
	      false,
	      // sanitizeURL
	      false);
	    }); // String SVG attributes with the xlink namespace.

	    ['xlink:actuate', 'xlink:arcrole', 'xlink:role', 'xlink:show', 'xlink:title', 'xlink:type' // NOTE: if you add a camelCased prop to this list,
	    // you'll need to set attributeName to name.toLowerCase()
	    // instead in the assignment below.
	    ].forEach(function (attributeName) {
	      var name = attributeName.replace(CAMELIZE, capitalize);
	      properties[name] = new PropertyInfoRecord(name, STRING, false,
	      // mustUseProperty
	      attributeName, 'http://www.w3.org/1999/xlink', false,
	      // sanitizeURL
	      false);
	    }); // String SVG attributes with the xml namespace.

	    ['xml:base', 'xml:lang', 'xml:space' // NOTE: if you add a camelCased prop to this list,
	    // you'll need to set attributeName to name.toLowerCase()
	    // instead in the assignment below.
	    ].forEach(function (attributeName) {
	      var name = attributeName.replace(CAMELIZE, capitalize);
	      properties[name] = new PropertyInfoRecord(name, STRING, false,
	      // mustUseProperty
	      attributeName, 'http://www.w3.org/XML/1998/namespace', false,
	      // sanitizeURL
	      false);
	    }); // These attribute exists both in HTML and SVG.
	    // The attribute name is case-sensitive in SVG so we can't just use
	    // the React name like we do for attributes that exist only in HTML.

	    ['tabIndex', 'crossOrigin'].forEach(function (attributeName) {
	      properties[attributeName] = new PropertyInfoRecord(attributeName, STRING, false,
	      // mustUseProperty
	      attributeName.toLowerCase(),
	      // attributeName
	      null,
	      // attributeNamespace
	      false,
	      // sanitizeURL
	      false);
	    }); // These attributes accept URLs. These must not allow javascript: URLS.
	    // These will also need to accept Trusted Types object in the future.

	    var xlinkHref = 'xlinkHref';
	    properties[xlinkHref] = new PropertyInfoRecord('xlinkHref', STRING, false,
	    // mustUseProperty
	    'xlink:href', 'http://www.w3.org/1999/xlink', true,
	    // sanitizeURL
	    false);
	    ['src', 'href', 'action', 'formAction'].forEach(function (attributeName) {
	      properties[attributeName] = new PropertyInfoRecord(attributeName, STRING, false,
	      // mustUseProperty
	      attributeName.toLowerCase(),
	      // attributeName
	      null,
	      // attributeNamespace
	      true,
	      // sanitizeURL
	      true);
	    });

	    /**
	     * CSS properties which accept numbers but are not in units of "px".
	     */
	    var isUnitlessNumber = {
	      animationIterationCount: true,
	      aspectRatio: true,
	      borderImageOutset: true,
	      borderImageSlice: true,
	      borderImageWidth: true,
	      boxFlex: true,
	      boxFlexGroup: true,
	      boxOrdinalGroup: true,
	      columnCount: true,
	      columns: true,
	      flex: true,
	      flexGrow: true,
	      flexPositive: true,
	      flexShrink: true,
	      flexNegative: true,
	      flexOrder: true,
	      gridArea: true,
	      gridRow: true,
	      gridRowEnd: true,
	      gridRowSpan: true,
	      gridRowStart: true,
	      gridColumn: true,
	      gridColumnEnd: true,
	      gridColumnSpan: true,
	      gridColumnStart: true,
	      fontWeight: true,
	      lineClamp: true,
	      lineHeight: true,
	      opacity: true,
	      order: true,
	      orphans: true,
	      tabSize: true,
	      widows: true,
	      zIndex: true,
	      zoom: true,
	      // SVG-related properties
	      fillOpacity: true,
	      floodOpacity: true,
	      stopOpacity: true,
	      strokeDasharray: true,
	      strokeDashoffset: true,
	      strokeMiterlimit: true,
	      strokeOpacity: true,
	      strokeWidth: true
	    };
	    /**
	     * @param {string} prefix vendor-specific prefix, eg: Webkit
	     * @param {string} key style name, eg: transitionDuration
	     * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	     * WebkitTransitionDuration
	     */

	    function prefixKey(prefix, key) {
	      return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	    }
	    /**
	     * Support style names that may come passed in prefixed by adding permutations
	     * of vendor prefixes.
	     */

	    var prefixes = ['Webkit', 'ms', 'Moz', 'O']; // Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	    // infinite loop, because it iterates over the newly added props too.

	    Object.keys(isUnitlessNumber).forEach(function (prop) {
	      prefixes.forEach(function (prefix) {
	        isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	      });
	    });
	    var hasReadOnlyValue = {
	      button: true,
	      checkbox: true,
	      image: true,
	      hidden: true,
	      radio: true,
	      reset: true,
	      submit: true
	    };
	    function checkControlledValueProps(tagName, props) {
	      {
	        if (!(hasReadOnlyValue[props.type] || props.onChange || props.onInput || props.readOnly || props.disabled || props.value == null)) {
	          error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	        }
	        if (!(props.onChange || props.readOnly || props.disabled || props.checked == null)) {
	          error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	        }
	      }
	    }
	    function isCustomComponent(tagName, props) {
	      if (tagName.indexOf('-') === -1) {
	        return typeof props.is === 'string';
	      }
	      switch (tagName) {
	        // These are reserved SVG and MathML elements.
	        // We don't mind this list too much because we expect it to never grow.
	        // The alternative is to track the namespace in a few places which is convoluted.
	        // https://w3c.github.io/webcomponents/spec/custom/#custom-elements-core-concepts
	        case 'annotation-xml':
	        case 'color-profile':
	        case 'font-face':
	        case 'font-face-src':
	        case 'font-face-uri':
	        case 'font-face-format':
	        case 'font-face-name':
	        case 'missing-glyph':
	          return false;
	        default:
	          return true;
	      }
	    }
	    var ariaProperties = {
	      'aria-current': 0,
	      // state
	      'aria-description': 0,
	      'aria-details': 0,
	      'aria-disabled': 0,
	      // state
	      'aria-hidden': 0,
	      // state
	      'aria-invalid': 0,
	      // state
	      'aria-keyshortcuts': 0,
	      'aria-label': 0,
	      'aria-roledescription': 0,
	      // Widget Attributes
	      'aria-autocomplete': 0,
	      'aria-checked': 0,
	      'aria-expanded': 0,
	      'aria-haspopup': 0,
	      'aria-level': 0,
	      'aria-modal': 0,
	      'aria-multiline': 0,
	      'aria-multiselectable': 0,
	      'aria-orientation': 0,
	      'aria-placeholder': 0,
	      'aria-pressed': 0,
	      'aria-readonly': 0,
	      'aria-required': 0,
	      'aria-selected': 0,
	      'aria-sort': 0,
	      'aria-valuemax': 0,
	      'aria-valuemin': 0,
	      'aria-valuenow': 0,
	      'aria-valuetext': 0,
	      // Live Region Attributes
	      'aria-atomic': 0,
	      'aria-busy': 0,
	      'aria-live': 0,
	      'aria-relevant': 0,
	      // Drag-and-Drop Attributes
	      'aria-dropeffect': 0,
	      'aria-grabbed': 0,
	      // Relationship Attributes
	      'aria-activedescendant': 0,
	      'aria-colcount': 0,
	      'aria-colindex': 0,
	      'aria-colspan': 0,
	      'aria-controls': 0,
	      'aria-describedby': 0,
	      'aria-errormessage': 0,
	      'aria-flowto': 0,
	      'aria-labelledby': 0,
	      'aria-owns': 0,
	      'aria-posinset': 0,
	      'aria-rowcount': 0,
	      'aria-rowindex': 0,
	      'aria-rowspan': 0,
	      'aria-setsize': 0
	    };
	    var warnedProperties = {};
	    var rARIA = new RegExp('^(aria)-[' + ATTRIBUTE_NAME_CHAR + ']*$');
	    var rARIACamel = new RegExp('^(aria)[A-Z][' + ATTRIBUTE_NAME_CHAR + ']*$');
	    function validateProperty(tagName, name) {
	      {
	        if (hasOwnProperty.call(warnedProperties, name) && warnedProperties[name]) {
	          return true;
	        }
	        if (rARIACamel.test(name)) {
	          var ariaName = 'aria-' + name.slice(4).toLowerCase();
	          var correctName = ariaProperties.hasOwnProperty(ariaName) ? ariaName : null; // If this is an aria-* attribute, but is not listed in the known DOM
	          // DOM properties, then it is an invalid aria-* attribute.

	          if (correctName == null) {
	            error('Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.', name);
	            warnedProperties[name] = true;
	            return true;
	          } // aria-* attributes should be lowercase; suggest the lowercase version.

	          if (name !== correctName) {
	            error('Invalid ARIA attribute `%s`. Did you mean `%s`?', name, correctName);
	            warnedProperties[name] = true;
	            return true;
	          }
	        }
	        if (rARIA.test(name)) {
	          var lowerCasedName = name.toLowerCase();
	          var standardName = ariaProperties.hasOwnProperty(lowerCasedName) ? lowerCasedName : null; // If this is an aria-* attribute, but is not listed in the known DOM
	          // DOM properties, then it is an invalid aria-* attribute.

	          if (standardName == null) {
	            warnedProperties[name] = true;
	            return false;
	          } // aria-* attributes should be lowercase; suggest the lowercase version.

	          if (name !== standardName) {
	            error('Unknown ARIA attribute `%s`. Did you mean `%s`?', name, standardName);
	            warnedProperties[name] = true;
	            return true;
	          }
	        }
	      }
	      return true;
	    }
	    function warnInvalidARIAProps(type, props) {
	      {
	        var invalidProps = [];
	        for (var key in props) {
	          var isValid = validateProperty(type, key);
	          if (!isValid) {
	            invalidProps.push(key);
	          }
	        }
	        var unknownPropString = invalidProps.map(function (prop) {
	          return '`' + prop + '`';
	        }).join(', ');
	        if (invalidProps.length === 1) {
	          error('Invalid aria prop %s on <%s> tag. ' + 'For details, see https://reactjs.org/link/invalid-aria-props', unknownPropString, type);
	        } else if (invalidProps.length > 1) {
	          error('Invalid aria props %s on <%s> tag. ' + 'For details, see https://reactjs.org/link/invalid-aria-props', unknownPropString, type);
	        }
	      }
	    }
	    function validateProperties(type, props) {
	      if (isCustomComponent(type, props)) {
	        return;
	      }
	      warnInvalidARIAProps(type, props);
	    }
	    var didWarnValueNull = false;
	    function validateProperties$1(type, props) {
	      {
	        if (type !== 'input' && type !== 'textarea' && type !== 'select') {
	          return;
	        }
	        if (props != null && props.value === null && !didWarnValueNull) {
	          didWarnValueNull = true;
	          if (type === 'select' && props.multiple) {
	            error('`value` prop on `%s` should not be null. ' + 'Consider using an empty array when `multiple` is set to `true` ' + 'to clear the component or `undefined` for uncontrolled components.', type);
	          } else {
	            error('`value` prop on `%s` should not be null. ' + 'Consider using an empty string to clear the component or `undefined` ' + 'for uncontrolled components.', type);
	          }
	        }
	      }
	    }

	    // When adding attributes to the HTML or SVG allowed attribute list, be sure to
	    // also add them to this module to ensure casing and incorrect name
	    // warnings.
	    var possibleStandardNames = {
	      // HTML
	      accept: 'accept',
	      acceptcharset: 'acceptCharset',
	      'accept-charset': 'acceptCharset',
	      accesskey: 'accessKey',
	      action: 'action',
	      allowfullscreen: 'allowFullScreen',
	      alt: 'alt',
	      as: 'as',
	      async: 'async',
	      autocapitalize: 'autoCapitalize',
	      autocomplete: 'autoComplete',
	      autocorrect: 'autoCorrect',
	      autofocus: 'autoFocus',
	      autoplay: 'autoPlay',
	      autosave: 'autoSave',
	      capture: 'capture',
	      cellpadding: 'cellPadding',
	      cellspacing: 'cellSpacing',
	      challenge: 'challenge',
	      charset: 'charSet',
	      checked: 'checked',
	      children: 'children',
	      cite: 'cite',
	      class: 'className',
	      classid: 'classID',
	      classname: 'className',
	      cols: 'cols',
	      colspan: 'colSpan',
	      content: 'content',
	      contenteditable: 'contentEditable',
	      contextmenu: 'contextMenu',
	      controls: 'controls',
	      controlslist: 'controlsList',
	      coords: 'coords',
	      crossorigin: 'crossOrigin',
	      dangerouslysetinnerhtml: 'dangerouslySetInnerHTML',
	      data: 'data',
	      datetime: 'dateTime',
	      default: 'default',
	      defaultchecked: 'defaultChecked',
	      defaultvalue: 'defaultValue',
	      defer: 'defer',
	      dir: 'dir',
	      disabled: 'disabled',
	      disablepictureinpicture: 'disablePictureInPicture',
	      disableremoteplayback: 'disableRemotePlayback',
	      download: 'download',
	      draggable: 'draggable',
	      enctype: 'encType',
	      enterkeyhint: 'enterKeyHint',
	      for: 'htmlFor',
	      form: 'form',
	      formmethod: 'formMethod',
	      formaction: 'formAction',
	      formenctype: 'formEncType',
	      formnovalidate: 'formNoValidate',
	      formtarget: 'formTarget',
	      frameborder: 'frameBorder',
	      headers: 'headers',
	      height: 'height',
	      hidden: 'hidden',
	      high: 'high',
	      href: 'href',
	      hreflang: 'hrefLang',
	      htmlfor: 'htmlFor',
	      httpequiv: 'httpEquiv',
	      'http-equiv': 'httpEquiv',
	      icon: 'icon',
	      id: 'id',
	      imagesizes: 'imageSizes',
	      imagesrcset: 'imageSrcSet',
	      innerhtml: 'innerHTML',
	      inputmode: 'inputMode',
	      integrity: 'integrity',
	      is: 'is',
	      itemid: 'itemID',
	      itemprop: 'itemProp',
	      itemref: 'itemRef',
	      itemscope: 'itemScope',
	      itemtype: 'itemType',
	      keyparams: 'keyParams',
	      keytype: 'keyType',
	      kind: 'kind',
	      label: 'label',
	      lang: 'lang',
	      list: 'list',
	      loop: 'loop',
	      low: 'low',
	      manifest: 'manifest',
	      marginwidth: 'marginWidth',
	      marginheight: 'marginHeight',
	      max: 'max',
	      maxlength: 'maxLength',
	      media: 'media',
	      mediagroup: 'mediaGroup',
	      method: 'method',
	      min: 'min',
	      minlength: 'minLength',
	      multiple: 'multiple',
	      muted: 'muted',
	      name: 'name',
	      nomodule: 'noModule',
	      nonce: 'nonce',
	      novalidate: 'noValidate',
	      open: 'open',
	      optimum: 'optimum',
	      pattern: 'pattern',
	      placeholder: 'placeholder',
	      playsinline: 'playsInline',
	      poster: 'poster',
	      preload: 'preload',
	      profile: 'profile',
	      radiogroup: 'radioGroup',
	      readonly: 'readOnly',
	      referrerpolicy: 'referrerPolicy',
	      rel: 'rel',
	      required: 'required',
	      reversed: 'reversed',
	      role: 'role',
	      rows: 'rows',
	      rowspan: 'rowSpan',
	      sandbox: 'sandbox',
	      scope: 'scope',
	      scoped: 'scoped',
	      scrolling: 'scrolling',
	      seamless: 'seamless',
	      selected: 'selected',
	      shape: 'shape',
	      size: 'size',
	      sizes: 'sizes',
	      span: 'span',
	      spellcheck: 'spellCheck',
	      src: 'src',
	      srcdoc: 'srcDoc',
	      srclang: 'srcLang',
	      srcset: 'srcSet',
	      start: 'start',
	      step: 'step',
	      style: 'style',
	      summary: 'summary',
	      tabindex: 'tabIndex',
	      target: 'target',
	      title: 'title',
	      type: 'type',
	      usemap: 'useMap',
	      value: 'value',
	      width: 'width',
	      wmode: 'wmode',
	      wrap: 'wrap',
	      // SVG
	      about: 'about',
	      accentheight: 'accentHeight',
	      'accent-height': 'accentHeight',
	      accumulate: 'accumulate',
	      additive: 'additive',
	      alignmentbaseline: 'alignmentBaseline',
	      'alignment-baseline': 'alignmentBaseline',
	      allowreorder: 'allowReorder',
	      alphabetic: 'alphabetic',
	      amplitude: 'amplitude',
	      arabicform: 'arabicForm',
	      'arabic-form': 'arabicForm',
	      ascent: 'ascent',
	      attributename: 'attributeName',
	      attributetype: 'attributeType',
	      autoreverse: 'autoReverse',
	      azimuth: 'azimuth',
	      basefrequency: 'baseFrequency',
	      baselineshift: 'baselineShift',
	      'baseline-shift': 'baselineShift',
	      baseprofile: 'baseProfile',
	      bbox: 'bbox',
	      begin: 'begin',
	      bias: 'bias',
	      by: 'by',
	      calcmode: 'calcMode',
	      capheight: 'capHeight',
	      'cap-height': 'capHeight',
	      clip: 'clip',
	      clippath: 'clipPath',
	      'clip-path': 'clipPath',
	      clippathunits: 'clipPathUnits',
	      cliprule: 'clipRule',
	      'clip-rule': 'clipRule',
	      color: 'color',
	      colorinterpolation: 'colorInterpolation',
	      'color-interpolation': 'colorInterpolation',
	      colorinterpolationfilters: 'colorInterpolationFilters',
	      'color-interpolation-filters': 'colorInterpolationFilters',
	      colorprofile: 'colorProfile',
	      'color-profile': 'colorProfile',
	      colorrendering: 'colorRendering',
	      'color-rendering': 'colorRendering',
	      contentscripttype: 'contentScriptType',
	      contentstyletype: 'contentStyleType',
	      cursor: 'cursor',
	      cx: 'cx',
	      cy: 'cy',
	      d: 'd',
	      datatype: 'datatype',
	      decelerate: 'decelerate',
	      descent: 'descent',
	      diffuseconstant: 'diffuseConstant',
	      direction: 'direction',
	      display: 'display',
	      divisor: 'divisor',
	      dominantbaseline: 'dominantBaseline',
	      'dominant-baseline': 'dominantBaseline',
	      dur: 'dur',
	      dx: 'dx',
	      dy: 'dy',
	      edgemode: 'edgeMode',
	      elevation: 'elevation',
	      enablebackground: 'enableBackground',
	      'enable-background': 'enableBackground',
	      end: 'end',
	      exponent: 'exponent',
	      externalresourcesrequired: 'externalResourcesRequired',
	      fill: 'fill',
	      fillopacity: 'fillOpacity',
	      'fill-opacity': 'fillOpacity',
	      fillrule: 'fillRule',
	      'fill-rule': 'fillRule',
	      filter: 'filter',
	      filterres: 'filterRes',
	      filterunits: 'filterUnits',
	      floodopacity: 'floodOpacity',
	      'flood-opacity': 'floodOpacity',
	      floodcolor: 'floodColor',
	      'flood-color': 'floodColor',
	      focusable: 'focusable',
	      fontfamily: 'fontFamily',
	      'font-family': 'fontFamily',
	      fontsize: 'fontSize',
	      'font-size': 'fontSize',
	      fontsizeadjust: 'fontSizeAdjust',
	      'font-size-adjust': 'fontSizeAdjust',
	      fontstretch: 'fontStretch',
	      'font-stretch': 'fontStretch',
	      fontstyle: 'fontStyle',
	      'font-style': 'fontStyle',
	      fontvariant: 'fontVariant',
	      'font-variant': 'fontVariant',
	      fontweight: 'fontWeight',
	      'font-weight': 'fontWeight',
	      format: 'format',
	      from: 'from',
	      fx: 'fx',
	      fy: 'fy',
	      g1: 'g1',
	      g2: 'g2',
	      glyphname: 'glyphName',
	      'glyph-name': 'glyphName',
	      glyphorientationhorizontal: 'glyphOrientationHorizontal',
	      'glyph-orientation-horizontal': 'glyphOrientationHorizontal',
	      glyphorientationvertical: 'glyphOrientationVertical',
	      'glyph-orientation-vertical': 'glyphOrientationVertical',
	      glyphref: 'glyphRef',
	      gradienttransform: 'gradientTransform',
	      gradientunits: 'gradientUnits',
	      hanging: 'hanging',
	      horizadvx: 'horizAdvX',
	      'horiz-adv-x': 'horizAdvX',
	      horizoriginx: 'horizOriginX',
	      'horiz-origin-x': 'horizOriginX',
	      ideographic: 'ideographic',
	      imagerendering: 'imageRendering',
	      'image-rendering': 'imageRendering',
	      in2: 'in2',
	      in: 'in',
	      inlist: 'inlist',
	      intercept: 'intercept',
	      k1: 'k1',
	      k2: 'k2',
	      k3: 'k3',
	      k4: 'k4',
	      k: 'k',
	      kernelmatrix: 'kernelMatrix',
	      kernelunitlength: 'kernelUnitLength',
	      kerning: 'kerning',
	      keypoints: 'keyPoints',
	      keysplines: 'keySplines',
	      keytimes: 'keyTimes',
	      lengthadjust: 'lengthAdjust',
	      letterspacing: 'letterSpacing',
	      'letter-spacing': 'letterSpacing',
	      lightingcolor: 'lightingColor',
	      'lighting-color': 'lightingColor',
	      limitingconeangle: 'limitingConeAngle',
	      local: 'local',
	      markerend: 'markerEnd',
	      'marker-end': 'markerEnd',
	      markerheight: 'markerHeight',
	      markermid: 'markerMid',
	      'marker-mid': 'markerMid',
	      markerstart: 'markerStart',
	      'marker-start': 'markerStart',
	      markerunits: 'markerUnits',
	      markerwidth: 'markerWidth',
	      mask: 'mask',
	      maskcontentunits: 'maskContentUnits',
	      maskunits: 'maskUnits',
	      mathematical: 'mathematical',
	      mode: 'mode',
	      numoctaves: 'numOctaves',
	      offset: 'offset',
	      opacity: 'opacity',
	      operator: 'operator',
	      order: 'order',
	      orient: 'orient',
	      orientation: 'orientation',
	      origin: 'origin',
	      overflow: 'overflow',
	      overlineposition: 'overlinePosition',
	      'overline-position': 'overlinePosition',
	      overlinethickness: 'overlineThickness',
	      'overline-thickness': 'overlineThickness',
	      paintorder: 'paintOrder',
	      'paint-order': 'paintOrder',
	      panose1: 'panose1',
	      'panose-1': 'panose1',
	      pathlength: 'pathLength',
	      patterncontentunits: 'patternContentUnits',
	      patterntransform: 'patternTransform',
	      patternunits: 'patternUnits',
	      pointerevents: 'pointerEvents',
	      'pointer-events': 'pointerEvents',
	      points: 'points',
	      pointsatx: 'pointsAtX',
	      pointsaty: 'pointsAtY',
	      pointsatz: 'pointsAtZ',
	      prefix: 'prefix',
	      preservealpha: 'preserveAlpha',
	      preserveaspectratio: 'preserveAspectRatio',
	      primitiveunits: 'primitiveUnits',
	      property: 'property',
	      r: 'r',
	      radius: 'radius',
	      refx: 'refX',
	      refy: 'refY',
	      renderingintent: 'renderingIntent',
	      'rendering-intent': 'renderingIntent',
	      repeatcount: 'repeatCount',
	      repeatdur: 'repeatDur',
	      requiredextensions: 'requiredExtensions',
	      requiredfeatures: 'requiredFeatures',
	      resource: 'resource',
	      restart: 'restart',
	      result: 'result',
	      results: 'results',
	      rotate: 'rotate',
	      rx: 'rx',
	      ry: 'ry',
	      scale: 'scale',
	      security: 'security',
	      seed: 'seed',
	      shaperendering: 'shapeRendering',
	      'shape-rendering': 'shapeRendering',
	      slope: 'slope',
	      spacing: 'spacing',
	      specularconstant: 'specularConstant',
	      specularexponent: 'specularExponent',
	      speed: 'speed',
	      spreadmethod: 'spreadMethod',
	      startoffset: 'startOffset',
	      stddeviation: 'stdDeviation',
	      stemh: 'stemh',
	      stemv: 'stemv',
	      stitchtiles: 'stitchTiles',
	      stopcolor: 'stopColor',
	      'stop-color': 'stopColor',
	      stopopacity: 'stopOpacity',
	      'stop-opacity': 'stopOpacity',
	      strikethroughposition: 'strikethroughPosition',
	      'strikethrough-position': 'strikethroughPosition',
	      strikethroughthickness: 'strikethroughThickness',
	      'strikethrough-thickness': 'strikethroughThickness',
	      string: 'string',
	      stroke: 'stroke',
	      strokedasharray: 'strokeDasharray',
	      'stroke-dasharray': 'strokeDasharray',
	      strokedashoffset: 'strokeDashoffset',
	      'stroke-dashoffset': 'strokeDashoffset',
	      strokelinecap: 'strokeLinecap',
	      'stroke-linecap': 'strokeLinecap',
	      strokelinejoin: 'strokeLinejoin',
	      'stroke-linejoin': 'strokeLinejoin',
	      strokemiterlimit: 'strokeMiterlimit',
	      'stroke-miterlimit': 'strokeMiterlimit',
	      strokewidth: 'strokeWidth',
	      'stroke-width': 'strokeWidth',
	      strokeopacity: 'strokeOpacity',
	      'stroke-opacity': 'strokeOpacity',
	      suppresscontenteditablewarning: 'suppressContentEditableWarning',
	      suppresshydrationwarning: 'suppressHydrationWarning',
	      surfacescale: 'surfaceScale',
	      systemlanguage: 'systemLanguage',
	      tablevalues: 'tableValues',
	      targetx: 'targetX',
	      targety: 'targetY',
	      textanchor: 'textAnchor',
	      'text-anchor': 'textAnchor',
	      textdecoration: 'textDecoration',
	      'text-decoration': 'textDecoration',
	      textlength: 'textLength',
	      textrendering: 'textRendering',
	      'text-rendering': 'textRendering',
	      to: 'to',
	      transform: 'transform',
	      typeof: 'typeof',
	      u1: 'u1',
	      u2: 'u2',
	      underlineposition: 'underlinePosition',
	      'underline-position': 'underlinePosition',
	      underlinethickness: 'underlineThickness',
	      'underline-thickness': 'underlineThickness',
	      unicode: 'unicode',
	      unicodebidi: 'unicodeBidi',
	      'unicode-bidi': 'unicodeBidi',
	      unicoderange: 'unicodeRange',
	      'unicode-range': 'unicodeRange',
	      unitsperem: 'unitsPerEm',
	      'units-per-em': 'unitsPerEm',
	      unselectable: 'unselectable',
	      valphabetic: 'vAlphabetic',
	      'v-alphabetic': 'vAlphabetic',
	      values: 'values',
	      vectoreffect: 'vectorEffect',
	      'vector-effect': 'vectorEffect',
	      version: 'version',
	      vertadvy: 'vertAdvY',
	      'vert-adv-y': 'vertAdvY',
	      vertoriginx: 'vertOriginX',
	      'vert-origin-x': 'vertOriginX',
	      vertoriginy: 'vertOriginY',
	      'vert-origin-y': 'vertOriginY',
	      vhanging: 'vHanging',
	      'v-hanging': 'vHanging',
	      videographic: 'vIdeographic',
	      'v-ideographic': 'vIdeographic',
	      viewbox: 'viewBox',
	      viewtarget: 'viewTarget',
	      visibility: 'visibility',
	      vmathematical: 'vMathematical',
	      'v-mathematical': 'vMathematical',
	      vocab: 'vocab',
	      widths: 'widths',
	      wordspacing: 'wordSpacing',
	      'word-spacing': 'wordSpacing',
	      writingmode: 'writingMode',
	      'writing-mode': 'writingMode',
	      x1: 'x1',
	      x2: 'x2',
	      x: 'x',
	      xchannelselector: 'xChannelSelector',
	      xheight: 'xHeight',
	      'x-height': 'xHeight',
	      xlinkactuate: 'xlinkActuate',
	      'xlink:actuate': 'xlinkActuate',
	      xlinkarcrole: 'xlinkArcrole',
	      'xlink:arcrole': 'xlinkArcrole',
	      xlinkhref: 'xlinkHref',
	      'xlink:href': 'xlinkHref',
	      xlinkrole: 'xlinkRole',
	      'xlink:role': 'xlinkRole',
	      xlinkshow: 'xlinkShow',
	      'xlink:show': 'xlinkShow',
	      xlinktitle: 'xlinkTitle',
	      'xlink:title': 'xlinkTitle',
	      xlinktype: 'xlinkType',
	      'xlink:type': 'xlinkType',
	      xmlbase: 'xmlBase',
	      'xml:base': 'xmlBase',
	      xmllang: 'xmlLang',
	      'xml:lang': 'xmlLang',
	      xmlns: 'xmlns',
	      'xml:space': 'xmlSpace',
	      xmlnsxlink: 'xmlnsXlink',
	      'xmlns:xlink': 'xmlnsXlink',
	      xmlspace: 'xmlSpace',
	      y1: 'y1',
	      y2: 'y2',
	      y: 'y',
	      ychannelselector: 'yChannelSelector',
	      z: 'z',
	      zoomandpan: 'zoomAndPan'
	    };
	    var validateProperty$1 = function () {};
	    {
	      var warnedProperties$1 = {};
	      var EVENT_NAME_REGEX = /^on./;
	      var INVALID_EVENT_NAME_REGEX = /^on[^A-Z]/;
	      var rARIA$1 = new RegExp('^(aria)-[' + ATTRIBUTE_NAME_CHAR + ']*$');
	      var rARIACamel$1 = new RegExp('^(aria)[A-Z][' + ATTRIBUTE_NAME_CHAR + ']*$');
	      validateProperty$1 = function (tagName, name, value, eventRegistry) {
	        if (hasOwnProperty.call(warnedProperties$1, name) && warnedProperties$1[name]) {
	          return true;
	        }
	        var lowerCasedName = name.toLowerCase();
	        if (lowerCasedName === 'onfocusin' || lowerCasedName === 'onfocusout') {
	          error('React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.');
	          warnedProperties$1[name] = true;
	          return true;
	        } // We can't rely on the event system being injected on the server.

	        if (eventRegistry != null) {
	          var registrationNameDependencies = eventRegistry.registrationNameDependencies,
	            possibleRegistrationNames = eventRegistry.possibleRegistrationNames;
	          if (registrationNameDependencies.hasOwnProperty(name)) {
	            return true;
	          }
	          var registrationName = possibleRegistrationNames.hasOwnProperty(lowerCasedName) ? possibleRegistrationNames[lowerCasedName] : null;
	          if (registrationName != null) {
	            error('Invalid event handler property `%s`. Did you mean `%s`?', name, registrationName);
	            warnedProperties$1[name] = true;
	            return true;
	          }
	          if (EVENT_NAME_REGEX.test(name)) {
	            error('Unknown event handler property `%s`. It will be ignored.', name);
	            warnedProperties$1[name] = true;
	            return true;
	          }
	        } else if (EVENT_NAME_REGEX.test(name)) {
	          // If no event plugins have been injected, we are in a server environment.
	          // So we can't tell if the event name is correct for sure, but we can filter
	          // out known bad ones like `onclick`. We can't suggest a specific replacement though.
	          if (INVALID_EVENT_NAME_REGEX.test(name)) {
	            error('Invalid event handler property `%s`. ' + 'React events use the camelCase naming convention, for example `onClick`.', name);
	          }
	          warnedProperties$1[name] = true;
	          return true;
	        } // Let the ARIA attribute hook validate ARIA attributes

	        if (rARIA$1.test(name) || rARIACamel$1.test(name)) {
	          return true;
	        }
	        if (lowerCasedName === 'innerhtml') {
	          error('Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.');
	          warnedProperties$1[name] = true;
	          return true;
	        }
	        if (lowerCasedName === 'aria') {
	          error('The `aria` attribute is reserved for future use in React. ' + 'Pass individual `aria-` attributes instead.');
	          warnedProperties$1[name] = true;
	          return true;
	        }
	        if (lowerCasedName === 'is' && value !== null && value !== undefined && typeof value !== 'string') {
	          error('Received a `%s` for a string attribute `is`. If this is expected, cast ' + 'the value to a string.', typeof value);
	          warnedProperties$1[name] = true;
	          return true;
	        }
	        if (typeof value === 'number' && isNaN(value)) {
	          error('Received NaN for the `%s` attribute. If this is expected, cast ' + 'the value to a string.', name);
	          warnedProperties$1[name] = true;
	          return true;
	        }
	        var propertyInfo = getPropertyInfo(name);
	        var isReserved = propertyInfo !== null && propertyInfo.type === RESERVED; // Known attributes should match the casing specified in the property config.

	        if (possibleStandardNames.hasOwnProperty(lowerCasedName)) {
	          var standardName = possibleStandardNames[lowerCasedName];
	          if (standardName !== name) {
	            error('Invalid DOM property `%s`. Did you mean `%s`?', name, standardName);
	            warnedProperties$1[name] = true;
	            return true;
	          }
	        } else if (!isReserved && name !== lowerCasedName) {
	          // Unknown attributes should have lowercase casing since that's how they
	          // will be cased anyway with server rendering.
	          error('React does not recognize the `%s` prop on a DOM element. If you ' + 'intentionally want it to appear in the DOM as a custom ' + 'attribute, spell it as lowercase `%s` instead. ' + 'If you accidentally passed it from a parent component, remove ' + 'it from the DOM element.', name, lowerCasedName);
	          warnedProperties$1[name] = true;
	          return true;
	        }
	        if (typeof value === 'boolean' && shouldRemoveAttributeWithWarning(name, value, propertyInfo)) {
	          if (value) {
	            error('Received `%s` for a non-boolean attribute `%s`.\n\n' + 'If you want to write it to the DOM, pass a string instead: ' + '%s="%s" or %s={value.toString()}.', value, name, name, value, name);
	          } else {
	            error('Received `%s` for a non-boolean attribute `%s`.\n\n' + 'If you want to write it to the DOM, pass a string instead: ' + '%s="%s" or %s={value.toString()}.\n\n' + 'If you used to conditionally omit it with %s={condition && value}, ' + 'pass %s={condition ? value : undefined} instead.', value, name, name, value, name, name, name);
	          }
	          warnedProperties$1[name] = true;
	          return true;
	        } // Now that we've validated casing, do not validate
	        // data types for reserved props

	        if (isReserved) {
	          return true;
	        } // Warn when a known attribute is a bad type

	        if (shouldRemoveAttributeWithWarning(name, value, propertyInfo)) {
	          warnedProperties$1[name] = true;
	          return false;
	        } // Warn when passing the strings 'false' or 'true' into a boolean prop

	        if ((value === 'false' || value === 'true') && propertyInfo !== null && propertyInfo.type === BOOLEAN) {
	          error('Received the string `%s` for the boolean attribute `%s`. ' + '%s ' + 'Did you mean %s={%s}?', value, name, value === 'false' ? 'The browser will interpret it as a truthy value.' : 'Although this works, it will not work as expected if you pass the string "false".', name, value);
	          warnedProperties$1[name] = true;
	          return true;
	        }
	        return true;
	      };
	    }
	    var warnUnknownProperties = function (type, props, eventRegistry) {
	      {
	        var unknownProps = [];
	        for (var key in props) {
	          var isValid = validateProperty$1(type, key, props[key], eventRegistry);
	          if (!isValid) {
	            unknownProps.push(key);
	          }
	        }
	        var unknownPropString = unknownProps.map(function (prop) {
	          return '`' + prop + '`';
	        }).join(', ');
	        if (unknownProps.length === 1) {
	          error('Invalid value for prop %s on <%s> tag. Either remove it from the element, ' + 'or pass a string or number value to keep it in the DOM. ' + 'For details, see https://reactjs.org/link/attribute-behavior ', unknownPropString, type);
	        } else if (unknownProps.length > 1) {
	          error('Invalid values for props %s on <%s> tag. Either remove them from the element, ' + 'or pass a string or number value to keep them in the DOM. ' + 'For details, see https://reactjs.org/link/attribute-behavior ', unknownPropString, type);
	        }
	      }
	    };
	    function validateProperties$2(type, props, eventRegistry) {
	      if (isCustomComponent(type, props)) {
	        return;
	      }
	      warnUnknownProperties(type, props, eventRegistry);
	    }
	    var warnValidStyle = function () {};
	    {
	      // 'msTransform' is correct, but the other prefixes should be capitalized
	      var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	      var msPattern = /^-ms-/;
	      var hyphenPattern = /-(.)/g; // style values shouldn't contain a semicolon

	      var badStyleValueWithSemicolonPattern = /;\s*$/;
	      var warnedStyleNames = {};
	      var warnedStyleValues = {};
	      var warnedForNaNValue = false;
	      var warnedForInfinityValue = false;
	      var camelize = function (string) {
	        return string.replace(hyphenPattern, function (_, character) {
	          return character.toUpperCase();
	        });
	      };
	      var warnHyphenatedStyleName = function (name) {
	        if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	          return;
	        }
	        warnedStyleNames[name] = true;
	        error('Unsupported style property %s. Did you mean %s?', name,
	        // As Andi Smith suggests
	        // (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
	        // is converted to lowercase `ms`.
	        camelize(name.replace(msPattern, 'ms-')));
	      };
	      var warnBadVendoredStyleName = function (name) {
	        if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	          return;
	        }
	        warnedStyleNames[name] = true;
	        error('Unsupported vendor-prefixed style property %s. Did you mean %s?', name, name.charAt(0).toUpperCase() + name.slice(1));
	      };
	      var warnStyleValueWithSemicolon = function (name, value) {
	        if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	          return;
	        }
	        warnedStyleValues[value] = true;
	        error("Style property values shouldn't contain a semicolon. " + 'Try "%s: %s" instead.', name, value.replace(badStyleValueWithSemicolonPattern, ''));
	      };
	      var warnStyleValueIsNaN = function (name, value) {
	        if (warnedForNaNValue) {
	          return;
	        }
	        warnedForNaNValue = true;
	        error('`NaN` is an invalid value for the `%s` css style property.', name);
	      };
	      var warnStyleValueIsInfinity = function (name, value) {
	        if (warnedForInfinityValue) {
	          return;
	        }
	        warnedForInfinityValue = true;
	        error('`Infinity` is an invalid value for the `%s` css style property.', name);
	      };
	      warnValidStyle = function (name, value) {
	        if (name.indexOf('-') > -1) {
	          warnHyphenatedStyleName(name);
	        } else if (badVendoredStyleNamePattern.test(name)) {
	          warnBadVendoredStyleName(name);
	        } else if (badStyleValueWithSemicolonPattern.test(value)) {
	          warnStyleValueWithSemicolon(name, value);
	        }
	        if (typeof value === 'number') {
	          if (isNaN(value)) {
	            warnStyleValueIsNaN(name, value);
	          } else if (!isFinite(value)) {
	            warnStyleValueIsInfinity(name, value);
	          }
	        }
	      };
	    }
	    var warnValidStyle$1 = warnValidStyle;

	    // code copied and modified from escape-html
	    var matchHtmlRegExp = /["'&<>]/;
	    /**
	     * Escapes special characters and HTML entities in a given html string.
	     *
	     * @param  {string} string HTML string to escape for later insertion
	     * @return {string}
	     * @public
	     */

	    function escapeHtml(string) {
	      {
	        checkHtmlStringCoercion(string);
	      }
	      var str = '' + string;
	      var match = matchHtmlRegExp.exec(str);
	      if (!match) {
	        return str;
	      }
	      var escape;
	      var html = '';
	      var index;
	      var lastIndex = 0;
	      for (index = match.index; index < str.length; index++) {
	        switch (str.charCodeAt(index)) {
	          case 34:
	            // "
	            escape = '&quot;';
	            break;
	          case 38:
	            // &
	            escape = '&amp;';
	            break;
	          case 39:
	            // '
	            escape = '&#x27;'; // modified from escape-html; used to be '&#39'

	            break;
	          case 60:
	            // <
	            escape = '&lt;';
	            break;
	          case 62:
	            // >
	            escape = '&gt;';
	            break;
	          default:
	            continue;
	        }
	        if (lastIndex !== index) {
	          html += str.substring(lastIndex, index);
	        }
	        lastIndex = index + 1;
	        html += escape;
	      }
	      return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
	    } // end code copied and modified from escape-html

	    /**
	     * Escapes text to prevent scripting attacks.
	     *
	     * @param {*} text Text value to escape.
	     * @return {string} An escaped string.
	     */

	    function escapeTextForBrowser(text) {
	      if (typeof text === 'boolean' || typeof text === 'number') {
	        // this shortcircuit helps perf for types that we know will never have
	        // special characters, especially given that this function is used often
	        // for numeric dom ids.
	        return '' + text;
	      }
	      return escapeHtml(text);
	    }
	    var uppercasePattern = /([A-Z])/g;
	    var msPattern$1 = /^ms-/;
	    /**
	     * Hyphenates a camelcased CSS property name, for example:
	     *
	     *   > hyphenateStyleName('backgroundColor')
	     *   < "background-color"
	     *   > hyphenateStyleName('MozTransition')
	     *   < "-moz-transition"
	     *   > hyphenateStyleName('msTransition')
	     *   < "-ms-transition"
	     *
	     * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	     * is converted to `-ms-`.
	     */

	    function hyphenateStyleName(name) {
	      return name.replace(uppercasePattern, '-$1').toLowerCase().replace(msPattern$1, '-ms-');
	    }

	    // and any newline or tab are filtered out as if they're not part of the URL.
	    // https://url.spec.whatwg.org/#url-parsing
	    // Tab or newline are defined as \r\n\t:
	    // https://infra.spec.whatwg.org/#ascii-tab-or-newline
	    // A C0 control is a code point in the range \u0000 NULL to \u001F
	    // INFORMATION SEPARATOR ONE, inclusive:
	    // https://infra.spec.whatwg.org/#c0-control-or-space

	    /* eslint-disable max-len */

	    var isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*\:/i;
	    var didWarn = false;
	    function sanitizeURL(url) {
	      {
	        if (!didWarn && isJavaScriptProtocol.test(url)) {
	          didWarn = true;
	          error('A future version of React will block javascript: URLs as a security precaution. ' + 'Use event handlers instead if you can. If you need to generate unsafe HTML try ' + 'using dangerouslySetInnerHTML instead. React was passed %s.', JSON.stringify(url));
	        }
	      }
	    }
	    var isArrayImpl = Array.isArray; // eslint-disable-next-line no-redeclare

	    function isArray(a) {
	      return isArrayImpl(a);
	    }
	    var startInlineScript = stringToPrecomputedChunk('<script>');
	    var endInlineScript = stringToPrecomputedChunk('</script>');
	    var startScriptSrc = stringToPrecomputedChunk('<script src="');
	    var startModuleSrc = stringToPrecomputedChunk('<script type="module" src="');
	    var endAsyncScript = stringToPrecomputedChunk('" async=""></script>');
	    /**
	     * This escaping function is designed to work with bootstrapScriptContent only.
	     * because we know we are escaping the entire script. We can avoid for instance
	     * escaping html comment string sequences that are valid javascript as well because
	     * if there are no sebsequent <script sequences the html parser will never enter
	     * script data double escaped state (see: https://www.w3.org/TR/html53/syntax.html#script-data-double-escaped-state)
	     *
	     * While untrusted script content should be made safe before using this api it will
	     * ensure that the script cannot be early terminated or never terminated state
	     */

	    function escapeBootstrapScriptContent(scriptText) {
	      {
	        checkHtmlStringCoercion(scriptText);
	      }
	      return ('' + scriptText).replace(scriptRegex, scriptReplacer);
	    }
	    var scriptRegex = /(<\/|<)(s)(cript)/gi;
	    var scriptReplacer = function (match, prefix, s, suffix) {
	      return "" + prefix + (s === 's' ? "\\u0073" : "\\u0053") + suffix;
	    }; // Allows us to keep track of what we've already written so we can refer back to it.

	    function createResponseState(identifierPrefix, nonce, bootstrapScriptContent, bootstrapScripts, bootstrapModules) {
	      var idPrefix = identifierPrefix === undefined ? '' : identifierPrefix;
	      var inlineScriptWithNonce = nonce === undefined ? startInlineScript : stringToPrecomputedChunk('<script nonce="' + escapeTextForBrowser(nonce) + '">');
	      var bootstrapChunks = [];
	      if (bootstrapScriptContent !== undefined) {
	        bootstrapChunks.push(inlineScriptWithNonce, stringToChunk(escapeBootstrapScriptContent(bootstrapScriptContent)), endInlineScript);
	      }
	      if (bootstrapScripts !== undefined) {
	        for (var i = 0; i < bootstrapScripts.length; i++) {
	          bootstrapChunks.push(startScriptSrc, stringToChunk(escapeTextForBrowser(bootstrapScripts[i])), endAsyncScript);
	        }
	      }
	      if (bootstrapModules !== undefined) {
	        for (var _i = 0; _i < bootstrapModules.length; _i++) {
	          bootstrapChunks.push(startModuleSrc, stringToChunk(escapeTextForBrowser(bootstrapModules[_i])), endAsyncScript);
	        }
	      }
	      return {
	        bootstrapChunks: bootstrapChunks,
	        startInlineScript: inlineScriptWithNonce,
	        placeholderPrefix: stringToPrecomputedChunk(idPrefix + 'P:'),
	        segmentPrefix: stringToPrecomputedChunk(idPrefix + 'S:'),
	        boundaryPrefix: idPrefix + 'B:',
	        idPrefix: idPrefix,
	        nextSuspenseID: 0,
	        sentCompleteSegmentFunction: false,
	        sentCompleteBoundaryFunction: false,
	        sentClientRenderFunction: false
	      };
	    } // Constants for the insertion mode we're currently writing in. We don't encode all HTML5 insertion
	    // modes. We only include the variants as they matter for the sake of our purposes.
	    // We don't actually provide the namespace therefore we use constants instead of the string.

	    var ROOT_HTML_MODE = 0; // Used for the root most element tag.

	    var HTML_MODE = 1;
	    var SVG_MODE = 2;
	    var MATHML_MODE = 3;
	    var HTML_TABLE_MODE = 4;
	    var HTML_TABLE_BODY_MODE = 5;
	    var HTML_TABLE_ROW_MODE = 6;
	    var HTML_COLGROUP_MODE = 7; // We have a greater than HTML_TABLE_MODE check elsewhere. If you add more cases here, make sure it
	    // still makes sense

	    function createFormatContext(insertionMode, selectedValue) {
	      return {
	        insertionMode: insertionMode,
	        selectedValue: selectedValue
	      };
	    }
	    function createRootFormatContext(namespaceURI) {
	      var insertionMode = namespaceURI === 'http://www.w3.org/2000/svg' ? SVG_MODE : namespaceURI === 'http://www.w3.org/1998/Math/MathML' ? MATHML_MODE : ROOT_HTML_MODE;
	      return createFormatContext(insertionMode, null);
	    }
	    function getChildFormatContext(parentContext, type, props) {
	      switch (type) {
	        case 'select':
	          return createFormatContext(HTML_MODE, props.value != null ? props.value : props.defaultValue);
	        case 'svg':
	          return createFormatContext(SVG_MODE, null);
	        case 'math':
	          return createFormatContext(MATHML_MODE, null);
	        case 'foreignObject':
	          return createFormatContext(HTML_MODE, null);
	        // Table parents are special in that their children can only be created at all if they're
	        // wrapped in a table parent. So we need to encode that we're entering this mode.

	        case 'table':
	          return createFormatContext(HTML_TABLE_MODE, null);
	        case 'thead':
	        case 'tbody':
	        case 'tfoot':
	          return createFormatContext(HTML_TABLE_BODY_MODE, null);
	        case 'colgroup':
	          return createFormatContext(HTML_COLGROUP_MODE, null);
	        case 'tr':
	          return createFormatContext(HTML_TABLE_ROW_MODE, null);
	      }
	      if (parentContext.insertionMode >= HTML_TABLE_MODE) {
	        // Whatever tag this was, it wasn't a table parent or other special parent, so we must have
	        // entered plain HTML again.
	        return createFormatContext(HTML_MODE, null);
	      }
	      if (parentContext.insertionMode === ROOT_HTML_MODE) {
	        // We've emitted the root and is now in plain HTML mode.
	        return createFormatContext(HTML_MODE, null);
	      }
	      return parentContext;
	    }
	    var UNINITIALIZED_SUSPENSE_BOUNDARY_ID = null;
	    function assignSuspenseBoundaryID(responseState) {
	      var generatedID = responseState.nextSuspenseID++;
	      return stringToPrecomputedChunk(responseState.boundaryPrefix + generatedID.toString(16));
	    }
	    function makeId(responseState, treeId, localId) {
	      var idPrefix = responseState.idPrefix;
	      var id = ':' + idPrefix + 'R' + treeId; // Unless this is the first id at this level, append a number at the end
	      // that represents the position of this useId hook among all the useId
	      // hooks for this fiber.

	      if (localId > 0) {
	        id += 'H' + localId.toString(32);
	      }
	      return id + ':';
	    }
	    function encodeHTMLTextNode(text) {
	      return escapeTextForBrowser(text);
	    }
	    var textSeparator = stringToPrecomputedChunk('<!-- -->');
	    function pushTextInstance(target, text, responseState, textEmbedded) {
	      if (text === '') {
	        // Empty text doesn't have a DOM node representation and the hydration is aware of this.
	        return textEmbedded;
	      }
	      if (textEmbedded) {
	        target.push(textSeparator);
	      }
	      target.push(stringToChunk(encodeHTMLTextNode(text)));
	      return true;
	    } // Called when Fizz is done with a Segment. Currently the only purpose is to conditionally
	    // emit a text separator when we don't know for sure it is safe to omit

	    function pushSegmentFinale(target, responseState, lastPushedText, textEmbedded) {
	      if (lastPushedText && textEmbedded) {
	        target.push(textSeparator);
	      }
	    }
	    var styleNameCache = new Map();
	    function processStyleName(styleName) {
	      var chunk = styleNameCache.get(styleName);
	      if (chunk !== undefined) {
	        return chunk;
	      }
	      var result = stringToPrecomputedChunk(escapeTextForBrowser(hyphenateStyleName(styleName)));
	      styleNameCache.set(styleName, result);
	      return result;
	    }
	    var styleAttributeStart = stringToPrecomputedChunk(' style="');
	    var styleAssign = stringToPrecomputedChunk(':');
	    var styleSeparator = stringToPrecomputedChunk(';');
	    function pushStyle(target, responseState, style) {
	      if (typeof style !== 'object') {
	        throw new Error('The `style` prop expects a mapping from style properties to values, ' + "not a string. For example, style={{marginRight: spacing + 'em'}} when " + 'using JSX.');
	      }
	      var isFirst = true;
	      for (var styleName in style) {
	        if (!hasOwnProperty.call(style, styleName)) {
	          continue;
	        } // If you provide unsafe user data here they can inject arbitrary CSS
	        // which may be problematic (I couldn't repro this):
	        // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
	        // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
	        // This is not an XSS hole but instead a potential CSS injection issue
	        // which has lead to a greater discussion about how we're going to
	        // trust URLs moving forward. See #2115901

	        var styleValue = style[styleName];
	        if (styleValue == null || typeof styleValue === 'boolean' || styleValue === '') {
	          // TODO: We used to set empty string as a style with an empty value. Does that ever make sense?
	          continue;
	        }
	        var nameChunk = void 0;
	        var valueChunk = void 0;
	        var isCustomProperty = styleName.indexOf('--') === 0;
	        if (isCustomProperty) {
	          nameChunk = stringToChunk(escapeTextForBrowser(styleName));
	          {
	            checkCSSPropertyStringCoercion(styleValue, styleName);
	          }
	          valueChunk = stringToChunk(escapeTextForBrowser(('' + styleValue).trim()));
	        } else {
	          {
	            warnValidStyle$1(styleName, styleValue);
	          }
	          nameChunk = processStyleName(styleName);
	          if (typeof styleValue === 'number') {
	            if (styleValue !== 0 && !hasOwnProperty.call(isUnitlessNumber, styleName)) {
	              valueChunk = stringToChunk(styleValue + 'px'); // Presumes implicit 'px' suffix for unitless numbers
	            } else {
	              valueChunk = stringToChunk('' + styleValue);
	            }
	          } else {
	            {
	              checkCSSPropertyStringCoercion(styleValue, styleName);
	            }
	            valueChunk = stringToChunk(escapeTextForBrowser(('' + styleValue).trim()));
	          }
	        }
	        if (isFirst) {
	          isFirst = false; // If it's first, we don't need any separators prefixed.

	          target.push(styleAttributeStart, nameChunk, styleAssign, valueChunk);
	        } else {
	          target.push(styleSeparator, nameChunk, styleAssign, valueChunk);
	        }
	      }
	      if (!isFirst) {
	        target.push(attributeEnd);
	      }
	    }
	    var attributeSeparator = stringToPrecomputedChunk(' ');
	    var attributeAssign = stringToPrecomputedChunk('="');
	    var attributeEnd = stringToPrecomputedChunk('"');
	    var attributeEmptyString = stringToPrecomputedChunk('=""');
	    function pushAttribute(target, responseState, name, value) {
	      switch (name) {
	        case 'style':
	          {
	            pushStyle(target, responseState, value);
	            return;
	          }
	        case 'defaultValue':
	        case 'defaultChecked': // These shouldn't be set as attributes on generic HTML elements.

	        case 'innerHTML': // Must use dangerouslySetInnerHTML instead.

	        case 'suppressContentEditableWarning':
	        case 'suppressHydrationWarning':
	          // Ignored. These are built-in to React on the client.
	          return;
	      }
	      if (
	      // shouldIgnoreAttribute
	      // We have already filtered out null/undefined and reserved words.
	      name.length > 2 && (name[0] === 'o' || name[0] === 'O') && (name[1] === 'n' || name[1] === 'N')) {
	        return;
	      }
	      var propertyInfo = getPropertyInfo(name);
	      if (propertyInfo !== null) {
	        // shouldRemoveAttribute
	        switch (typeof value) {
	          case 'function': // $FlowIssue symbol is perfectly valid here

	          case 'symbol':
	            // eslint-disable-line
	            return;
	          case 'boolean':
	            {
	              if (!propertyInfo.acceptsBooleans) {
	                return;
	              }
	            }
	        }
	        var attributeName = propertyInfo.attributeName;
	        var attributeNameChunk = stringToChunk(attributeName); // TODO: If it's known we can cache the chunk.

	        switch (propertyInfo.type) {
	          case BOOLEAN:
	            if (value) {
	              target.push(attributeSeparator, attributeNameChunk, attributeEmptyString);
	            }
	            return;
	          case OVERLOADED_BOOLEAN:
	            if (value === true) {
	              target.push(attributeSeparator, attributeNameChunk, attributeEmptyString);
	            } else if (value === false) ;else {
	              target.push(attributeSeparator, attributeNameChunk, attributeAssign, stringToChunk(escapeTextForBrowser(value)), attributeEnd);
	            }
	            return;
	          case NUMERIC:
	            if (!isNaN(value)) {
	              target.push(attributeSeparator, attributeNameChunk, attributeAssign, stringToChunk(escapeTextForBrowser(value)), attributeEnd);
	            }
	            break;
	          case POSITIVE_NUMERIC:
	            if (!isNaN(value) && value >= 1) {
	              target.push(attributeSeparator, attributeNameChunk, attributeAssign, stringToChunk(escapeTextForBrowser(value)), attributeEnd);
	            }
	            break;
	          default:
	            if (propertyInfo.sanitizeURL) {
	              {
	                checkAttributeStringCoercion(value, attributeName);
	              }
	              value = '' + value;
	              sanitizeURL(value);
	            }
	            target.push(attributeSeparator, attributeNameChunk, attributeAssign, stringToChunk(escapeTextForBrowser(value)), attributeEnd);
	        }
	      } else if (isAttributeNameSafe(name)) {
	        // shouldRemoveAttribute
	        switch (typeof value) {
	          case 'function': // $FlowIssue symbol is perfectly valid here

	          case 'symbol':
	            // eslint-disable-line
	            return;
	          case 'boolean':
	            {
	              var prefix = name.toLowerCase().slice(0, 5);
	              if (prefix !== 'data-' && prefix !== 'aria-') {
	                return;
	              }
	            }
	        }
	        target.push(attributeSeparator, stringToChunk(name), attributeAssign, stringToChunk(escapeTextForBrowser(value)), attributeEnd);
	      }
	    }
	    var endOfStartTag = stringToPrecomputedChunk('>');
	    var endOfStartTagSelfClosing = stringToPrecomputedChunk('/>');
	    function pushInnerHTML(target, innerHTML, children) {
	      if (innerHTML != null) {
	        if (children != null) {
	          throw new Error('Can only set one of `children` or `props.dangerouslySetInnerHTML`.');
	        }
	        if (typeof innerHTML !== 'object' || !('__html' in innerHTML)) {
	          throw new Error('`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. ' + 'Please visit https://reactjs.org/link/dangerously-set-inner-html ' + 'for more information.');
	        }
	        var html = innerHTML.__html;
	        if (html !== null && html !== undefined) {
	          {
	            checkHtmlStringCoercion(html);
	          }
	          target.push(stringToChunk('' + html));
	        }
	      }
	    } // TODO: Move these to ResponseState so that we warn for every request.
	    // It would help debugging in stateful servers (e.g. service worker).

	    var didWarnDefaultInputValue = false;
	    var didWarnDefaultChecked = false;
	    var didWarnDefaultSelectValue = false;
	    var didWarnDefaultTextareaValue = false;
	    var didWarnInvalidOptionChildren = false;
	    var didWarnInvalidOptionInnerHTML = false;
	    var didWarnSelectedSetOnOption = false;
	    function checkSelectProp(props, propName) {
	      {
	        var value = props[propName];
	        if (value != null) {
	          var array = isArray(value);
	          if (props.multiple && !array) {
	            error('The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.', propName);
	          } else if (!props.multiple && array) {
	            error('The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.', propName);
	          }
	        }
	      }
	    }
	    function pushStartSelect(target, props, responseState) {
	      {
	        checkControlledValueProps('select', props);
	        checkSelectProp(props, 'value');
	        checkSelectProp(props, 'defaultValue');
	        if (props.value !== undefined && props.defaultValue !== undefined && !didWarnDefaultSelectValue) {
	          error('Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://reactjs.org/link/controlled-components');
	          didWarnDefaultSelectValue = true;
	        }
	      }
	      target.push(startChunkForTag('select'));
	      var children = null;
	      var innerHTML = null;
	      for (var propKey in props) {
	        if (hasOwnProperty.call(props, propKey)) {
	          var propValue = props[propKey];
	          if (propValue == null) {
	            continue;
	          }
	          switch (propKey) {
	            case 'children':
	              children = propValue;
	              break;
	            case 'dangerouslySetInnerHTML':
	              // TODO: This doesn't really make sense for select since it can't use the controlled
	              // value in the innerHTML.
	              innerHTML = propValue;
	              break;
	            case 'defaultValue':
	            case 'value':
	              // These are set on the Context instead and applied to the nested options.
	              break;
	            default:
	              pushAttribute(target, responseState, propKey, propValue);
	              break;
	          }
	        }
	      }
	      target.push(endOfStartTag);
	      pushInnerHTML(target, innerHTML, children);
	      return children;
	    }
	    function flattenOptionChildren(children) {
	      var content = ''; // Flatten children and warn if they aren't strings or numbers;
	      // invalid types are ignored.

	      React$1.Children.forEach(children, function (child) {
	        if (child == null) {
	          return;
	        }
	        content += child;
	        {
	          if (!didWarnInvalidOptionChildren && typeof child !== 'string' && typeof child !== 'number') {
	            didWarnInvalidOptionChildren = true;
	            error('Cannot infer the option value of complex children. ' + 'Pass a `value` prop or use a plain string as children to <option>.');
	          }
	        }
	      });
	      return content;
	    }
	    var selectedMarkerAttribute = stringToPrecomputedChunk(' selected=""');
	    function pushStartOption(target, props, responseState, formatContext) {
	      var selectedValue = formatContext.selectedValue;
	      target.push(startChunkForTag('option'));
	      var children = null;
	      var value = null;
	      var selected = null;
	      var innerHTML = null;
	      for (var propKey in props) {
	        if (hasOwnProperty.call(props, propKey)) {
	          var propValue = props[propKey];
	          if (propValue == null) {
	            continue;
	          }
	          switch (propKey) {
	            case 'children':
	              children = propValue;
	              break;
	            case 'selected':
	              // ignore
	              selected = propValue;
	              {
	                // TODO: Remove support for `selected` in <option>.
	                if (!didWarnSelectedSetOnOption) {
	                  error('Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.');
	                  didWarnSelectedSetOnOption = true;
	                }
	              }
	              break;
	            case 'dangerouslySetInnerHTML':
	              innerHTML = propValue;
	              break;
	            // eslint-disable-next-line-no-fallthrough

	            case 'value':
	              value = propValue;
	            // We intentionally fallthrough to also set the attribute on the node.
	            // eslint-disable-next-line-no-fallthrough

	            default:
	              pushAttribute(target, responseState, propKey, propValue);
	              break;
	          }
	        }
	      }
	      if (selectedValue != null) {
	        var stringValue;
	        if (value !== null) {
	          {
	            checkAttributeStringCoercion(value, 'value');
	          }
	          stringValue = '' + value;
	        } else {
	          {
	            if (innerHTML !== null) {
	              if (!didWarnInvalidOptionInnerHTML) {
	                didWarnInvalidOptionInnerHTML = true;
	                error('Pass a `value` prop if you set dangerouslyInnerHTML so React knows ' + 'which value should be selected.');
	              }
	            }
	          }
	          stringValue = flattenOptionChildren(children);
	        }
	        if (isArray(selectedValue)) {
	          // multiple
	          for (var i = 0; i < selectedValue.length; i++) {
	            {
	              checkAttributeStringCoercion(selectedValue[i], 'value');
	            }
	            var v = '' + selectedValue[i];
	            if (v === stringValue) {
	              target.push(selectedMarkerAttribute);
	              break;
	            }
	          }
	        } else {
	          {
	            checkAttributeStringCoercion(selectedValue, 'select.value');
	          }
	          if ('' + selectedValue === stringValue) {
	            target.push(selectedMarkerAttribute);
	          }
	        }
	      } else if (selected) {
	        target.push(selectedMarkerAttribute);
	      }
	      target.push(endOfStartTag);
	      pushInnerHTML(target, innerHTML, children);
	      return children;
	    }
	    function pushInput(target, props, responseState) {
	      {
	        checkControlledValueProps('input', props);
	        if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnDefaultChecked) {
	          error('%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://reactjs.org/link/controlled-components', 'A component', props.type);
	          didWarnDefaultChecked = true;
	        }
	        if (props.value !== undefined && props.defaultValue !== undefined && !didWarnDefaultInputValue) {
	          error('%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://reactjs.org/link/controlled-components', 'A component', props.type);
	          didWarnDefaultInputValue = true;
	        }
	      }
	      target.push(startChunkForTag('input'));
	      var value = null;
	      var defaultValue = null;
	      var checked = null;
	      var defaultChecked = null;
	      for (var propKey in props) {
	        if (hasOwnProperty.call(props, propKey)) {
	          var propValue = props[propKey];
	          if (propValue == null) {
	            continue;
	          }
	          switch (propKey) {
	            case 'children':
	            case 'dangerouslySetInnerHTML':
	              throw new Error('input' + " is a self-closing tag and must neither have `children` nor " + 'use `dangerouslySetInnerHTML`.');
	            // eslint-disable-next-line-no-fallthrough

	            case 'defaultChecked':
	              defaultChecked = propValue;
	              break;
	            case 'defaultValue':
	              defaultValue = propValue;
	              break;
	            case 'checked':
	              checked = propValue;
	              break;
	            case 'value':
	              value = propValue;
	              break;
	            default:
	              pushAttribute(target, responseState, propKey, propValue);
	              break;
	          }
	        }
	      }
	      if (checked !== null) {
	        pushAttribute(target, responseState, 'checked', checked);
	      } else if (defaultChecked !== null) {
	        pushAttribute(target, responseState, 'checked', defaultChecked);
	      }
	      if (value !== null) {
	        pushAttribute(target, responseState, 'value', value);
	      } else if (defaultValue !== null) {
	        pushAttribute(target, responseState, 'value', defaultValue);
	      }
	      target.push(endOfStartTagSelfClosing);
	      return null;
	    }
	    function pushStartTextArea(target, props, responseState) {
	      {
	        checkControlledValueProps('textarea', props);
	        if (props.value !== undefined && props.defaultValue !== undefined && !didWarnDefaultTextareaValue) {
	          error('Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://reactjs.org/link/controlled-components');
	          didWarnDefaultTextareaValue = true;
	        }
	      }
	      target.push(startChunkForTag('textarea'));
	      var value = null;
	      var defaultValue = null;
	      var children = null;
	      for (var propKey in props) {
	        if (hasOwnProperty.call(props, propKey)) {
	          var propValue = props[propKey];
	          if (propValue == null) {
	            continue;
	          }
	          switch (propKey) {
	            case 'children':
	              children = propValue;
	              break;
	            case 'value':
	              value = propValue;
	              break;
	            case 'defaultValue':
	              defaultValue = propValue;
	              break;
	            case 'dangerouslySetInnerHTML':
	              throw new Error('`dangerouslySetInnerHTML` does not make sense on <textarea>.');
	            // eslint-disable-next-line-no-fallthrough

	            default:
	              pushAttribute(target, responseState, propKey, propValue);
	              break;
	          }
	        }
	      }
	      if (value === null && defaultValue !== null) {
	        value = defaultValue;
	      }
	      target.push(endOfStartTag); // TODO (yungsters): Remove support for children content in <textarea>.

	      if (children != null) {
	        {
	          error('Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.');
	        }
	        if (value != null) {
	          throw new Error('If you supply `defaultValue` on a <textarea>, do not pass children.');
	        }
	        if (isArray(children)) {
	          if (children.length > 1) {
	            throw new Error('<textarea> can only have at most one child.');
	          } // TODO: remove the coercion and the DEV check below because it will
	          // always be overwritten by the coercion several lines below it. #22309

	          {
	            checkHtmlStringCoercion(children[0]);
	          }
	          value = '' + children[0];
	        }
	        {
	          checkHtmlStringCoercion(children);
	        }
	        value = '' + children;
	      }
	      if (typeof value === 'string' && value[0] === '\n') {
	        // text/html ignores the first character in these tags if it's a newline
	        // Prefer to break application/xml over text/html (for now) by adding
	        // a newline specifically to get eaten by the parser. (Alternately for
	        // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
	        // \r is normalized out by HTMLTextAreaElement#value.)
	        // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
	        // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
	        // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
	        // See: Parsing of "textarea" "listing" and "pre" elements
	        //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
	        target.push(leadingNewline);
	      } // ToString and push directly instead of recurse over children.
	      // We don't really support complex children in the value anyway.
	      // This also currently avoids a trailing comment node which breaks textarea.

	      if (value !== null) {
	        {
	          checkAttributeStringCoercion(value, 'value');
	        }
	        target.push(stringToChunk(encodeHTMLTextNode('' + value)));
	      }
	      return null;
	    }
	    function pushSelfClosing(target, props, tag, responseState) {
	      target.push(startChunkForTag(tag));
	      for (var propKey in props) {
	        if (hasOwnProperty.call(props, propKey)) {
	          var propValue = props[propKey];
	          if (propValue == null) {
	            continue;
	          }
	          switch (propKey) {
	            case 'children':
	            case 'dangerouslySetInnerHTML':
	              throw new Error(tag + " is a self-closing tag and must neither have `children` nor " + 'use `dangerouslySetInnerHTML`.');
	            // eslint-disable-next-line-no-fallthrough

	            default:
	              pushAttribute(target, responseState, propKey, propValue);
	              break;
	          }
	        }
	      }
	      target.push(endOfStartTagSelfClosing);
	      return null;
	    }
	    function pushStartMenuItem(target, props, responseState) {
	      target.push(startChunkForTag('menuitem'));
	      for (var propKey in props) {
	        if (hasOwnProperty.call(props, propKey)) {
	          var propValue = props[propKey];
	          if (propValue == null) {
	            continue;
	          }
	          switch (propKey) {
	            case 'children':
	            case 'dangerouslySetInnerHTML':
	              throw new Error('menuitems cannot have `children` nor `dangerouslySetInnerHTML`.');
	            // eslint-disable-next-line-no-fallthrough

	            default:
	              pushAttribute(target, responseState, propKey, propValue);
	              break;
	          }
	        }
	      }
	      target.push(endOfStartTag);
	      return null;
	    }
	    function pushStartTitle(target, props, responseState) {
	      target.push(startChunkForTag('title'));
	      var children = null;
	      for (var propKey in props) {
	        if (hasOwnProperty.call(props, propKey)) {
	          var propValue = props[propKey];
	          if (propValue == null) {
	            continue;
	          }
	          switch (propKey) {
	            case 'children':
	              children = propValue;
	              break;
	            case 'dangerouslySetInnerHTML':
	              throw new Error('`dangerouslySetInnerHTML` does not make sense on <title>.');
	            // eslint-disable-next-line-no-fallthrough

	            default:
	              pushAttribute(target, responseState, propKey, propValue);
	              break;
	          }
	        }
	      }
	      target.push(endOfStartTag);
	      {
	        var child = Array.isArray(children) && children.length < 2 ? children[0] || null : children;
	        if (Array.isArray(children) && children.length > 1) {
	          error('A title element received an array with more than 1 element as children. ' + 'In browsers title Elements can only have Text Nodes as children. If ' + 'the children being rendered output more than a single text node in aggregate the browser ' + 'will display markup and comments as text in the title and hydration will likely fail and ' + 'fall back to client rendering');
	        } else if (child != null && child.$$typeof != null) {
	          error('A title element received a React element for children. ' + 'In the browser title Elements can only have Text Nodes as children. If ' + 'the children being rendered output more than a single text node in aggregate the browser ' + 'will display markup and comments as text in the title and hydration will likely fail and ' + 'fall back to client rendering');
	        } else if (child != null && typeof child !== 'string' && typeof child !== 'number') {
	          error('A title element received a value that was not a string or number for children. ' + 'In the browser title Elements can only have Text Nodes as children. If ' + 'the children being rendered output more than a single text node in aggregate the browser ' + 'will display markup and comments as text in the title and hydration will likely fail and ' + 'fall back to client rendering');
	        }
	      }
	      return children;
	    }
	    function pushStartGenericElement(target, props, tag, responseState) {
	      target.push(startChunkForTag(tag));
	      var children = null;
	      var innerHTML = null;
	      for (var propKey in props) {
	        if (hasOwnProperty.call(props, propKey)) {
	          var propValue = props[propKey];
	          if (propValue == null) {
	            continue;
	          }
	          switch (propKey) {
	            case 'children':
	              children = propValue;
	              break;
	            case 'dangerouslySetInnerHTML':
	              innerHTML = propValue;
	              break;
	            default:
	              pushAttribute(target, responseState, propKey, propValue);
	              break;
	          }
	        }
	      }
	      target.push(endOfStartTag);
	      pushInnerHTML(target, innerHTML, children);
	      if (typeof children === 'string') {
	        // Special case children as a string to avoid the unnecessary comment.
	        // TODO: Remove this special case after the general optimization is in place.
	        target.push(stringToChunk(encodeHTMLTextNode(children)));
	        return null;
	      }
	      return children;
	    }
	    function pushStartCustomElement(target, props, tag, responseState) {
	      target.push(startChunkForTag(tag));
	      var children = null;
	      var innerHTML = null;
	      for (var propKey in props) {
	        if (hasOwnProperty.call(props, propKey)) {
	          var propValue = props[propKey];
	          if (propValue == null) {
	            continue;
	          }
	          switch (propKey) {
	            case 'children':
	              children = propValue;
	              break;
	            case 'dangerouslySetInnerHTML':
	              innerHTML = propValue;
	              break;
	            case 'style':
	              pushStyle(target, responseState, propValue);
	              break;
	            case 'suppressContentEditableWarning':
	            case 'suppressHydrationWarning':
	              // Ignored. These are built-in to React on the client.
	              break;
	            default:
	              if (isAttributeNameSafe(propKey) && typeof propValue !== 'function' && typeof propValue !== 'symbol') {
	                target.push(attributeSeparator, stringToChunk(propKey), attributeAssign, stringToChunk(escapeTextForBrowser(propValue)), attributeEnd);
	              }
	              break;
	          }
	        }
	      }
	      target.push(endOfStartTag);
	      pushInnerHTML(target, innerHTML, children);
	      return children;
	    }
	    var leadingNewline = stringToPrecomputedChunk('\n');
	    function pushStartPreformattedElement(target, props, tag, responseState) {
	      target.push(startChunkForTag(tag));
	      var children = null;
	      var innerHTML = null;
	      for (var propKey in props) {
	        if (hasOwnProperty.call(props, propKey)) {
	          var propValue = props[propKey];
	          if (propValue == null) {
	            continue;
	          }
	          switch (propKey) {
	            case 'children':
	              children = propValue;
	              break;
	            case 'dangerouslySetInnerHTML':
	              innerHTML = propValue;
	              break;
	            default:
	              pushAttribute(target, responseState, propKey, propValue);
	              break;
	          }
	        }
	      }
	      target.push(endOfStartTag); // text/html ignores the first character in these tags if it's a newline
	      // Prefer to break application/xml over text/html (for now) by adding
	      // a newline specifically to get eaten by the parser. (Alternately for
	      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
	      // \r is normalized out by HTMLTextAreaElement#value.)
	      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
	      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
	      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
	      // See: Parsing of "textarea" "listing" and "pre" elements
	      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
	      // TODO: This doesn't deal with the case where the child is an array
	      // or component that returns a string.

	      if (innerHTML != null) {
	        if (children != null) {
	          throw new Error('Can only set one of `children` or `props.dangerouslySetInnerHTML`.');
	        }
	        if (typeof innerHTML !== 'object' || !('__html' in innerHTML)) {
	          throw new Error('`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. ' + 'Please visit https://reactjs.org/link/dangerously-set-inner-html ' + 'for more information.');
	        }
	        var html = innerHTML.__html;
	        if (html !== null && html !== undefined) {
	          if (typeof html === 'string' && html.length > 0 && html[0] === '\n') {
	            target.push(leadingNewline, stringToChunk(html));
	          } else {
	            {
	              checkHtmlStringCoercion(html);
	            }
	            target.push(stringToChunk('' + html));
	          }
	        }
	      }
	      if (typeof children === 'string' && children[0] === '\n') {
	        target.push(leadingNewline);
	      }
	      return children;
	    } // We accept any tag to be rendered but since this gets injected into arbitrary
	    // HTML, we want to make sure that it's a safe tag.
	    // http://www.w3.org/TR/REC-xml/#NT-Name

	    var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset

	    var validatedTagCache = new Map();
	    function startChunkForTag(tag) {
	      var tagStartChunk = validatedTagCache.get(tag);
	      if (tagStartChunk === undefined) {
	        if (!VALID_TAG_REGEX.test(tag)) {
	          throw new Error("Invalid tag: " + tag);
	        }
	        tagStartChunk = stringToPrecomputedChunk('<' + tag);
	        validatedTagCache.set(tag, tagStartChunk);
	      }
	      return tagStartChunk;
	    }
	    var DOCTYPE = stringToPrecomputedChunk('<!DOCTYPE html>');
	    function pushStartInstance(target, type, props, responseState, formatContext) {
	      {
	        validateProperties(type, props);
	        validateProperties$1(type, props);
	        validateProperties$2(type, props, null);
	        if (!props.suppressContentEditableWarning && props.contentEditable && props.children != null) {
	          error('A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.');
	        }
	        if (formatContext.insertionMode !== SVG_MODE && formatContext.insertionMode !== MATHML_MODE) {
	          if (type.indexOf('-') === -1 && typeof props.is !== 'string' && type.toLowerCase() !== type) {
	            error('<%s /> is using incorrect casing. ' + 'Use PascalCase for React components, ' + 'or lowercase for HTML elements.', type);
	          }
	        }
	      }
	      switch (type) {
	        // Special tags
	        case 'select':
	          return pushStartSelect(target, props, responseState);
	        case 'option':
	          return pushStartOption(target, props, responseState, formatContext);
	        case 'textarea':
	          return pushStartTextArea(target, props, responseState);
	        case 'input':
	          return pushInput(target, props, responseState);
	        case 'menuitem':
	          return pushStartMenuItem(target, props, responseState);
	        case 'title':
	          return pushStartTitle(target, props, responseState);
	        // Newline eating tags

	        case 'listing':
	        case 'pre':
	          {
	            return pushStartPreformattedElement(target, props, type, responseState);
	          }
	        // Omitted close tags

	        case 'area':
	        case 'base':
	        case 'br':
	        case 'col':
	        case 'embed':
	        case 'hr':
	        case 'img':
	        case 'keygen':
	        case 'link':
	        case 'meta':
	        case 'param':
	        case 'source':
	        case 'track':
	        case 'wbr':
	          {
	            return pushSelfClosing(target, props, type, responseState);
	          }
	        // These are reserved SVG and MathML elements, that are never custom elements.
	        // https://w3c.github.io/webcomponents/spec/custom/#custom-elements-core-concepts

	        case 'annotation-xml':
	        case 'color-profile':
	        case 'font-face':
	        case 'font-face-src':
	        case 'font-face-uri':
	        case 'font-face-format':
	        case 'font-face-name':
	        case 'missing-glyph':
	          {
	            return pushStartGenericElement(target, props, type, responseState);
	          }
	        case 'html':
	          {
	            if (formatContext.insertionMode === ROOT_HTML_MODE) {
	              // If we're rendering the html tag and we're at the root (i.e. not in foreignObject)
	              // then we also emit the DOCTYPE as part of the root content as a convenience for
	              // rendering the whole document.
	              target.push(DOCTYPE);
	            }
	            return pushStartGenericElement(target, props, type, responseState);
	          }
	        default:
	          {
	            if (type.indexOf('-') === -1 && typeof props.is !== 'string') {
	              // Generic element
	              return pushStartGenericElement(target, props, type, responseState);
	            } else {
	              // Custom element
	              return pushStartCustomElement(target, props, type, responseState);
	            }
	          }
	      }
	    }
	    var endTag1 = stringToPrecomputedChunk('</');
	    var endTag2 = stringToPrecomputedChunk('>');
	    function pushEndInstance(target, type, props) {
	      switch (type) {
	        // Omitted close tags
	        // TODO: Instead of repeating this switch we could try to pass a flag from above.
	        // That would require returning a tuple. Which might be ok if it gets inlined.
	        case 'area':
	        case 'base':
	        case 'br':
	        case 'col':
	        case 'embed':
	        case 'hr':
	        case 'img':
	        case 'input':
	        case 'keygen':
	        case 'link':
	        case 'meta':
	        case 'param':
	        case 'source':
	        case 'track':
	        case 'wbr':
	          {
	            // No close tag needed.
	            break;
	          }
	        default:
	          {
	            target.push(endTag1, stringToChunk(type), endTag2);
	          }
	      }
	    }
	    function writeCompletedRoot(destination, responseState) {
	      var bootstrapChunks = responseState.bootstrapChunks;
	      var i = 0;
	      for (; i < bootstrapChunks.length - 1; i++) {
	        writeChunk(destination, bootstrapChunks[i]);
	      }
	      if (i < bootstrapChunks.length) {
	        return writeChunkAndReturn(destination, bootstrapChunks[i]);
	      }
	      return true;
	    } // Structural Nodes
	    // A placeholder is a node inside a hidden partial tree that can be filled in later, but before
	    // display. It's never visible to users. We use the template tag because it can be used in every
	    // type of parent. <script> tags also work in every other tag except <colgroup>.

	    var placeholder1 = stringToPrecomputedChunk('<template id="');
	    var placeholder2 = stringToPrecomputedChunk('"></template>');
	    function writePlaceholder(destination, responseState, id) {
	      writeChunk(destination, placeholder1);
	      writeChunk(destination, responseState.placeholderPrefix);
	      var formattedID = stringToChunk(id.toString(16));
	      writeChunk(destination, formattedID);
	      return writeChunkAndReturn(destination, placeholder2);
	    } // Suspense boundaries are encoded as comments.

	    var startCompletedSuspenseBoundary = stringToPrecomputedChunk('<!--$-->');
	    var startPendingSuspenseBoundary1 = stringToPrecomputedChunk('<!--$?--><template id="');
	    var startPendingSuspenseBoundary2 = stringToPrecomputedChunk('"></template>');
	    var startClientRenderedSuspenseBoundary = stringToPrecomputedChunk('<!--$!-->');
	    var endSuspenseBoundary = stringToPrecomputedChunk('<!--/$-->');
	    var clientRenderedSuspenseBoundaryError1 = stringToPrecomputedChunk('<template');
	    var clientRenderedSuspenseBoundaryErrorAttrInterstitial = stringToPrecomputedChunk('"');
	    var clientRenderedSuspenseBoundaryError1A = stringToPrecomputedChunk(' data-dgst="');
	    var clientRenderedSuspenseBoundaryError1B = stringToPrecomputedChunk(' data-msg="');
	    var clientRenderedSuspenseBoundaryError1C = stringToPrecomputedChunk(' data-stck="');
	    var clientRenderedSuspenseBoundaryError2 = stringToPrecomputedChunk('></template>');
	    function writeStartCompletedSuspenseBoundary(destination, responseState) {
	      return writeChunkAndReturn(destination, startCompletedSuspenseBoundary);
	    }
	    function writeStartPendingSuspenseBoundary(destination, responseState, id) {
	      writeChunk(destination, startPendingSuspenseBoundary1);
	      if (id === null) {
	        throw new Error('An ID must have been assigned before we can complete the boundary.');
	      }
	      writeChunk(destination, id);
	      return writeChunkAndReturn(destination, startPendingSuspenseBoundary2);
	    }
	    function writeStartClientRenderedSuspenseBoundary(destination, responseState, errorDigest, errorMesssage, errorComponentStack) {
	      var result;
	      result = writeChunkAndReturn(destination, startClientRenderedSuspenseBoundary);
	      writeChunk(destination, clientRenderedSuspenseBoundaryError1);
	      if (errorDigest) {
	        writeChunk(destination, clientRenderedSuspenseBoundaryError1A);
	        writeChunk(destination, stringToChunk(escapeTextForBrowser(errorDigest)));
	        writeChunk(destination, clientRenderedSuspenseBoundaryErrorAttrInterstitial);
	      }
	      {
	        if (errorMesssage) {
	          writeChunk(destination, clientRenderedSuspenseBoundaryError1B);
	          writeChunk(destination, stringToChunk(escapeTextForBrowser(errorMesssage)));
	          writeChunk(destination, clientRenderedSuspenseBoundaryErrorAttrInterstitial);
	        }
	        if (errorComponentStack) {
	          writeChunk(destination, clientRenderedSuspenseBoundaryError1C);
	          writeChunk(destination, stringToChunk(escapeTextForBrowser(errorComponentStack)));
	          writeChunk(destination, clientRenderedSuspenseBoundaryErrorAttrInterstitial);
	        }
	      }
	      result = writeChunkAndReturn(destination, clientRenderedSuspenseBoundaryError2);
	      return result;
	    }
	    function writeEndCompletedSuspenseBoundary(destination, responseState) {
	      return writeChunkAndReturn(destination, endSuspenseBoundary);
	    }
	    function writeEndPendingSuspenseBoundary(destination, responseState) {
	      return writeChunkAndReturn(destination, endSuspenseBoundary);
	    }
	    function writeEndClientRenderedSuspenseBoundary(destination, responseState) {
	      return writeChunkAndReturn(destination, endSuspenseBoundary);
	    }
	    var startSegmentHTML = stringToPrecomputedChunk('<div hidden id="');
	    var startSegmentHTML2 = stringToPrecomputedChunk('">');
	    var endSegmentHTML = stringToPrecomputedChunk('</div>');
	    var startSegmentSVG = stringToPrecomputedChunk('<svg aria-hidden="true" style="display:none" id="');
	    var startSegmentSVG2 = stringToPrecomputedChunk('">');
	    var endSegmentSVG = stringToPrecomputedChunk('</svg>');
	    var startSegmentMathML = stringToPrecomputedChunk('<math aria-hidden="true" style="display:none" id="');
	    var startSegmentMathML2 = stringToPrecomputedChunk('">');
	    var endSegmentMathML = stringToPrecomputedChunk('</math>');
	    var startSegmentTable = stringToPrecomputedChunk('<table hidden id="');
	    var startSegmentTable2 = stringToPrecomputedChunk('">');
	    var endSegmentTable = stringToPrecomputedChunk('</table>');
	    var startSegmentTableBody = stringToPrecomputedChunk('<table hidden><tbody id="');
	    var startSegmentTableBody2 = stringToPrecomputedChunk('">');
	    var endSegmentTableBody = stringToPrecomputedChunk('</tbody></table>');
	    var startSegmentTableRow = stringToPrecomputedChunk('<table hidden><tr id="');
	    var startSegmentTableRow2 = stringToPrecomputedChunk('">');
	    var endSegmentTableRow = stringToPrecomputedChunk('</tr></table>');
	    var startSegmentColGroup = stringToPrecomputedChunk('<table hidden><colgroup id="');
	    var startSegmentColGroup2 = stringToPrecomputedChunk('">');
	    var endSegmentColGroup = stringToPrecomputedChunk('</colgroup></table>');
	    function writeStartSegment(destination, responseState, formatContext, id) {
	      switch (formatContext.insertionMode) {
	        case ROOT_HTML_MODE:
	        case HTML_MODE:
	          {
	            writeChunk(destination, startSegmentHTML);
	            writeChunk(destination, responseState.segmentPrefix);
	            writeChunk(destination, stringToChunk(id.toString(16)));
	            return writeChunkAndReturn(destination, startSegmentHTML2);
	          }
	        case SVG_MODE:
	          {
	            writeChunk(destination, startSegmentSVG);
	            writeChunk(destination, responseState.segmentPrefix);
	            writeChunk(destination, stringToChunk(id.toString(16)));
	            return writeChunkAndReturn(destination, startSegmentSVG2);
	          }
	        case MATHML_MODE:
	          {
	            writeChunk(destination, startSegmentMathML);
	            writeChunk(destination, responseState.segmentPrefix);
	            writeChunk(destination, stringToChunk(id.toString(16)));
	            return writeChunkAndReturn(destination, startSegmentMathML2);
	          }
	        case HTML_TABLE_MODE:
	          {
	            writeChunk(destination, startSegmentTable);
	            writeChunk(destination, responseState.segmentPrefix);
	            writeChunk(destination, stringToChunk(id.toString(16)));
	            return writeChunkAndReturn(destination, startSegmentTable2);
	          }
	        // TODO: For the rest of these, there will be extra wrapper nodes that never
	        // get deleted from the document. We need to delete the table too as part
	        // of the injected scripts. They are invisible though so it's not too terrible
	        // and it's kind of an edge case to suspend in a table. Totally supported though.

	        case HTML_TABLE_BODY_MODE:
	          {
	            writeChunk(destination, startSegmentTableBody);
	            writeChunk(destination, responseState.segmentPrefix);
	            writeChunk(destination, stringToChunk(id.toString(16)));
	            return writeChunkAndReturn(destination, startSegmentTableBody2);
	          }
	        case HTML_TABLE_ROW_MODE:
	          {
	            writeChunk(destination, startSegmentTableRow);
	            writeChunk(destination, responseState.segmentPrefix);
	            writeChunk(destination, stringToChunk(id.toString(16)));
	            return writeChunkAndReturn(destination, startSegmentTableRow2);
	          }
	        case HTML_COLGROUP_MODE:
	          {
	            writeChunk(destination, startSegmentColGroup);
	            writeChunk(destination, responseState.segmentPrefix);
	            writeChunk(destination, stringToChunk(id.toString(16)));
	            return writeChunkAndReturn(destination, startSegmentColGroup2);
	          }
	        default:
	          {
	            throw new Error('Unknown insertion mode. This is a bug in React.');
	          }
	      }
	    }
	    function writeEndSegment(destination, formatContext) {
	      switch (formatContext.insertionMode) {
	        case ROOT_HTML_MODE:
	        case HTML_MODE:
	          {
	            return writeChunkAndReturn(destination, endSegmentHTML);
	          }
	        case SVG_MODE:
	          {
	            return writeChunkAndReturn(destination, endSegmentSVG);
	          }
	        case MATHML_MODE:
	          {
	            return writeChunkAndReturn(destination, endSegmentMathML);
	          }
	        case HTML_TABLE_MODE:
	          {
	            return writeChunkAndReturn(destination, endSegmentTable);
	          }
	        case HTML_TABLE_BODY_MODE:
	          {
	            return writeChunkAndReturn(destination, endSegmentTableBody);
	          }
	        case HTML_TABLE_ROW_MODE:
	          {
	            return writeChunkAndReturn(destination, endSegmentTableRow);
	          }
	        case HTML_COLGROUP_MODE:
	          {
	            return writeChunkAndReturn(destination, endSegmentColGroup);
	          }
	        default:
	          {
	            throw new Error('Unknown insertion mode. This is a bug in React.');
	          }
	      }
	    } // Instruction Set
	    // The following code is the source scripts that we then minify and inline below,
	    // with renamed function names that we hope don't collide:
	    // const COMMENT_NODE = 8;
	    // const SUSPENSE_START_DATA = '$';
	    // const SUSPENSE_END_DATA = '/$';
	    // const SUSPENSE_PENDING_START_DATA = '$?';
	    // const SUSPENSE_FALLBACK_START_DATA = '$!';
	    //
	    // function clientRenderBoundary(suspenseBoundaryID, errorDigest, errorMsg, errorComponentStack) {
	    //   // Find the fallback's first element.
	    //   const suspenseIdNode = document.getElementById(suspenseBoundaryID);
	    //   if (!suspenseIdNode) {
	    //     // The user must have already navigated away from this tree.
	    //     // E.g. because the parent was hydrated.
	    //     return;
	    //   }
	    //   // Find the boundary around the fallback. This is always the previous node.
	    //   const suspenseNode = suspenseIdNode.previousSibling;
	    //   // Tag it to be client rendered.
	    //   suspenseNode.data = SUSPENSE_FALLBACK_START_DATA;
	    //   // assign error metadata to first sibling
	    //   let dataset = suspenseIdNode.dataset;
	    //   if (errorDigest) dataset.dgst = errorDigest;
	    //   if (errorMsg) dataset.msg = errorMsg;
	    //   if (errorComponentStack) dataset.stck = errorComponentStack;
	    //   // Tell React to retry it if the parent already hydrated.
	    //   if (suspenseNode._reactRetry) {
	    //     suspenseNode._reactRetry();
	    //   }
	    // }
	    //
	    // function completeBoundary(suspenseBoundaryID, contentID) {
	    //   // Find the fallback's first element.
	    //   const suspenseIdNode = document.getElementById(suspenseBoundaryID);
	    //   const contentNode = document.getElementById(contentID);
	    //   // We'll detach the content node so that regardless of what happens next we don't leave in the tree.
	    //   // This might also help by not causing recalcing each time we move a child from here to the target.
	    //   contentNode.parentNode.removeChild(contentNode);
	    //   if (!suspenseIdNode) {
	    //     // The user must have already navigated away from this tree.
	    //     // E.g. because the parent was hydrated. That's fine there's nothing to do
	    //     // but we have to make sure that we already deleted the container node.
	    //     return;
	    //   }
	    //   // Find the boundary around the fallback. This is always the previous node.
	    //   const suspenseNode = suspenseIdNode.previousSibling;
	    //
	    //   // Clear all the existing children. This is complicated because
	    //   // there can be embedded Suspense boundaries in the fallback.
	    //   // This is similar to clearSuspenseBoundary in ReactDOMHostConfig.
	    //   // TODO: We could avoid this if we never emitted suspense boundaries in fallback trees.
	    //   // They never hydrate anyway. However, currently we support incrementally loading the fallback.
	    //   const parentInstance = suspenseNode.parentNode;
	    //   let node = suspenseNode.nextSibling;
	    //   let depth = 0;
	    //   do {
	    //     if (node && node.nodeType === COMMENT_NODE) {
	    //       const data = node.data;
	    //       if (data === SUSPENSE_END_DATA) {
	    //         if (depth === 0) {
	    //           break;
	    //         } else {
	    //           depth--;
	    //         }
	    //       } else if (
	    //         data === SUSPENSE_START_DATA ||
	    //         data === SUSPENSE_PENDING_START_DATA ||
	    //         data === SUSPENSE_FALLBACK_START_DATA
	    //       ) {
	    //         depth++;
	    //       }
	    //     }
	    //
	    //     const nextNode = node.nextSibling;
	    //     parentInstance.removeChild(node);
	    //     node = nextNode;
	    //   } while (node);
	    //
	    //   const endOfBoundary = node;
	    //
	    //   // Insert all the children from the contentNode between the start and end of suspense boundary.
	    //   while (contentNode.firstChild) {
	    //     parentInstance.insertBefore(contentNode.firstChild, endOfBoundary);
	    //   }
	    //   suspenseNode.data = SUSPENSE_START_DATA;
	    //   if (suspenseNode._reactRetry) {
	    //     suspenseNode._reactRetry();
	    //   }
	    // }
	    //
	    // function completeSegment(containerID, placeholderID) {
	    //   const segmentContainer = document.getElementById(containerID);
	    //   const placeholderNode = document.getElementById(placeholderID);
	    //   // We always expect both nodes to exist here because, while we might
	    //   // have navigated away from the main tree, we still expect the detached
	    //   // tree to exist.
	    //   segmentContainer.parentNode.removeChild(segmentContainer);
	    //   while (segmentContainer.firstChild) {
	    //     placeholderNode.parentNode.insertBefore(
	    //       segmentContainer.firstChild,
	    //       placeholderNode,
	    //     );
	    //   }
	    //   placeholderNode.parentNode.removeChild(placeholderNode);
	    // }

	    var completeSegmentFunction = 'function $RS(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)}';
	    var completeBoundaryFunction = 'function $RC(a,b){a=document.getElementById(a);b=document.getElementById(b);b.parentNode.removeChild(b);if(a){a=a.previousSibling;var f=a.parentNode,c=a.nextSibling,e=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d)if(0===e)break;else e--;else"$"!==d&&"$?"!==d&&"$!"!==d||e++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;b.firstChild;)f.insertBefore(b.firstChild,c);a.data="$";a._reactRetry&&a._reactRetry()}}';
	    var clientRenderFunction = 'function $RX(b,c,d,e){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),b._reactRetry&&b._reactRetry())}';
	    var completeSegmentScript1Full = stringToPrecomputedChunk(completeSegmentFunction + ';$RS("');
	    var completeSegmentScript1Partial = stringToPrecomputedChunk('$RS("');
	    var completeSegmentScript2 = stringToPrecomputedChunk('","');
	    var completeSegmentScript3 = stringToPrecomputedChunk('")</script>');
	    function writeCompletedSegmentInstruction(destination, responseState, contentSegmentID) {
	      writeChunk(destination, responseState.startInlineScript);
	      if (!responseState.sentCompleteSegmentFunction) {
	        // The first time we write this, we'll need to include the full implementation.
	        responseState.sentCompleteSegmentFunction = true;
	        writeChunk(destination, completeSegmentScript1Full);
	      } else {
	        // Future calls can just reuse the same function.
	        writeChunk(destination, completeSegmentScript1Partial);
	      }
	      writeChunk(destination, responseState.segmentPrefix);
	      var formattedID = stringToChunk(contentSegmentID.toString(16));
	      writeChunk(destination, formattedID);
	      writeChunk(destination, completeSegmentScript2);
	      writeChunk(destination, responseState.placeholderPrefix);
	      writeChunk(destination, formattedID);
	      return writeChunkAndReturn(destination, completeSegmentScript3);
	    }
	    var completeBoundaryScript1Full = stringToPrecomputedChunk(completeBoundaryFunction + ';$RC("');
	    var completeBoundaryScript1Partial = stringToPrecomputedChunk('$RC("');
	    var completeBoundaryScript2 = stringToPrecomputedChunk('","');
	    var completeBoundaryScript3 = stringToPrecomputedChunk('")</script>');
	    function writeCompletedBoundaryInstruction(destination, responseState, boundaryID, contentSegmentID) {
	      writeChunk(destination, responseState.startInlineScript);
	      if (!responseState.sentCompleteBoundaryFunction) {
	        // The first time we write this, we'll need to include the full implementation.
	        responseState.sentCompleteBoundaryFunction = true;
	        writeChunk(destination, completeBoundaryScript1Full);
	      } else {
	        // Future calls can just reuse the same function.
	        writeChunk(destination, completeBoundaryScript1Partial);
	      }
	      if (boundaryID === null) {
	        throw new Error('An ID must have been assigned before we can complete the boundary.');
	      }
	      var formattedContentID = stringToChunk(contentSegmentID.toString(16));
	      writeChunk(destination, boundaryID);
	      writeChunk(destination, completeBoundaryScript2);
	      writeChunk(destination, responseState.segmentPrefix);
	      writeChunk(destination, formattedContentID);
	      return writeChunkAndReturn(destination, completeBoundaryScript3);
	    }
	    var clientRenderScript1Full = stringToPrecomputedChunk(clientRenderFunction + ';$RX("');
	    var clientRenderScript1Partial = stringToPrecomputedChunk('$RX("');
	    var clientRenderScript1A = stringToPrecomputedChunk('"');
	    var clientRenderScript2 = stringToPrecomputedChunk(')</script>');
	    var clientRenderErrorScriptArgInterstitial = stringToPrecomputedChunk(',');
	    function writeClientRenderBoundaryInstruction(destination, responseState, boundaryID, errorDigest, errorMessage, errorComponentStack) {
	      writeChunk(destination, responseState.startInlineScript);
	      if (!responseState.sentClientRenderFunction) {
	        // The first time we write this, we'll need to include the full implementation.
	        responseState.sentClientRenderFunction = true;
	        writeChunk(destination, clientRenderScript1Full);
	      } else {
	        // Future calls can just reuse the same function.
	        writeChunk(destination, clientRenderScript1Partial);
	      }
	      if (boundaryID === null) {
	        throw new Error('An ID must have been assigned before we can complete the boundary.');
	      }
	      writeChunk(destination, boundaryID);
	      writeChunk(destination, clientRenderScript1A);
	      if (errorDigest || errorMessage || errorComponentStack) {
	        writeChunk(destination, clientRenderErrorScriptArgInterstitial);
	        writeChunk(destination, stringToChunk(escapeJSStringsForInstructionScripts(errorDigest || '')));
	      }
	      if (errorMessage || errorComponentStack) {
	        writeChunk(destination, clientRenderErrorScriptArgInterstitial);
	        writeChunk(destination, stringToChunk(escapeJSStringsForInstructionScripts(errorMessage || '')));
	      }
	      if (errorComponentStack) {
	        writeChunk(destination, clientRenderErrorScriptArgInterstitial);
	        writeChunk(destination, stringToChunk(escapeJSStringsForInstructionScripts(errorComponentStack)));
	      }
	      return writeChunkAndReturn(destination, clientRenderScript2);
	    }
	    var regexForJSStringsInScripts = /[<\u2028\u2029]/g;
	    function escapeJSStringsForInstructionScripts(input) {
	      var escaped = JSON.stringify(input);
	      return escaped.replace(regexForJSStringsInScripts, function (match) {
	        switch (match) {
	          // santizing breaking out of strings and script tags
	          case '<':
	            return "\\u003c";
	          case "\u2028":
	            return "\\u2028";
	          case "\u2029":
	            return "\\u2029";
	          default:
	            {
	              // eslint-disable-next-line react-internal/prod-error-codes
	              throw new Error('escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React');
	            }
	        }
	      });
	    }
	    var assign = Object.assign;

	    // ATTENTION
	    // When adding new symbols to this file,
	    // Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
	    // The Symbol used to tag the ReactElement-like types.
	    var REACT_ELEMENT_TYPE = Symbol.for('react.element');
	    var REACT_PORTAL_TYPE = Symbol.for('react.portal');
	    var REACT_FRAGMENT_TYPE = Symbol.for('react.fragment');
	    var REACT_STRICT_MODE_TYPE = Symbol.for('react.strict_mode');
	    var REACT_PROFILER_TYPE = Symbol.for('react.profiler');
	    var REACT_PROVIDER_TYPE = Symbol.for('react.provider');
	    var REACT_CONTEXT_TYPE = Symbol.for('react.context');
	    var REACT_FORWARD_REF_TYPE = Symbol.for('react.forward_ref');
	    var REACT_SUSPENSE_TYPE = Symbol.for('react.suspense');
	    var REACT_SUSPENSE_LIST_TYPE = Symbol.for('react.suspense_list');
	    var REACT_MEMO_TYPE = Symbol.for('react.memo');
	    var REACT_LAZY_TYPE = Symbol.for('react.lazy');
	    var REACT_SCOPE_TYPE = Symbol.for('react.scope');
	    var REACT_DEBUG_TRACING_MODE_TYPE = Symbol.for('react.debug_trace_mode');
	    var REACT_LEGACY_HIDDEN_TYPE = Symbol.for('react.legacy_hidden');
	    var REACT_SERVER_CONTEXT_DEFAULT_VALUE_NOT_LOADED = Symbol.for('react.default_value');
	    var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
	    var FAUX_ITERATOR_SYMBOL = '@@iterator';
	    function getIteratorFn(maybeIterable) {
	      if (maybeIterable === null || typeof maybeIterable !== 'object') {
	        return null;
	      }
	      var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];
	      if (typeof maybeIterator === 'function') {
	        return maybeIterator;
	      }
	      return null;
	    }
	    function getWrappedName(outerType, innerType, wrapperName) {
	      var displayName = outerType.displayName;
	      if (displayName) {
	        return displayName;
	      }
	      var functionName = innerType.displayName || innerType.name || '';
	      return functionName !== '' ? wrapperName + "(" + functionName + ")" : wrapperName;
	    } // Keep in sync with react-reconciler/getComponentNameFromFiber

	    function getContextName(type) {
	      return type.displayName || 'Context';
	    } // Note that the reconciler package should generally prefer to use getComponentNameFromFiber() instead.

	    function getComponentNameFromType(type) {
	      if (type == null) {
	        // Host root, text node or just invalid type.
	        return null;
	      }
	      {
	        if (typeof type.tag === 'number') {
	          error('Received an unexpected object in getComponentNameFromType(). ' + 'This is likely a bug in React. Please file an issue.');
	        }
	      }
	      if (typeof type === 'function') {
	        return type.displayName || type.name || null;
	      }
	      if (typeof type === 'string') {
	        return type;
	      }
	      switch (type) {
	        case REACT_FRAGMENT_TYPE:
	          return 'Fragment';
	        case REACT_PORTAL_TYPE:
	          return 'Portal';
	        case REACT_PROFILER_TYPE:
	          return 'Profiler';
	        case REACT_STRICT_MODE_TYPE:
	          return 'StrictMode';
	        case REACT_SUSPENSE_TYPE:
	          return 'Suspense';
	        case REACT_SUSPENSE_LIST_TYPE:
	          return 'SuspenseList';
	      }
	      if (typeof type === 'object') {
	        switch (type.$$typeof) {
	          case REACT_CONTEXT_TYPE:
	            var context = type;
	            return getContextName(context) + '.Consumer';
	          case REACT_PROVIDER_TYPE:
	            var provider = type;
	            return getContextName(provider._context) + '.Provider';
	          case REACT_FORWARD_REF_TYPE:
	            return getWrappedName(type, type.render, 'ForwardRef');
	          case REACT_MEMO_TYPE:
	            var outerName = type.displayName || null;
	            if (outerName !== null) {
	              return outerName;
	            }
	            return getComponentNameFromType(type.type) || 'Memo';
	          case REACT_LAZY_TYPE:
	            {
	              var lazyComponent = type;
	              var payload = lazyComponent._payload;
	              var init = lazyComponent._init;
	              try {
	                return getComponentNameFromType(init(payload));
	              } catch (x) {
	                return null;
	              }
	            }

	          // eslint-disable-next-line no-fallthrough
	        }
	      }
	      return null;
	    }

	    // Helpers to patch console.logs to avoid logging during side-effect free
	    // replaying on render function. This currently only patches the object
	    // lazily which won't cover if the log function was extracted eagerly.
	    // We could also eagerly patch the method.
	    var disabledDepth = 0;
	    var prevLog;
	    var prevInfo;
	    var prevWarn;
	    var prevError;
	    var prevGroup;
	    var prevGroupCollapsed;
	    var prevGroupEnd;
	    function disabledLog() {}
	    disabledLog.__reactDisabledLog = true;
	    function disableLogs() {
	      {
	        if (disabledDepth === 0) {
	          /* eslint-disable react-internal/no-production-logging */
	          prevLog = console.log;
	          prevInfo = console.info;
	          prevWarn = console.warn;
	          prevError = console.error;
	          prevGroup = console.group;
	          prevGroupCollapsed = console.groupCollapsed;
	          prevGroupEnd = console.groupEnd; // https://github.com/facebook/react/issues/19099

	          var props = {
	            configurable: true,
	            enumerable: true,
	            value: disabledLog,
	            writable: true
	          }; // $FlowFixMe Flow thinks console is immutable.

	          Object.defineProperties(console, {
	            info: props,
	            log: props,
	            warn: props,
	            error: props,
	            group: props,
	            groupCollapsed: props,
	            groupEnd: props
	          });
	          /* eslint-enable react-internal/no-production-logging */
	        }
	        disabledDepth++;
	      }
	    }
	    function reenableLogs() {
	      {
	        disabledDepth--;
	        if (disabledDepth === 0) {
	          /* eslint-disable react-internal/no-production-logging */
	          var props = {
	            configurable: true,
	            enumerable: true,
	            writable: true
	          }; // $FlowFixMe Flow thinks console is immutable.

	          Object.defineProperties(console, {
	            log: assign({}, props, {
	              value: prevLog
	            }),
	            info: assign({}, props, {
	              value: prevInfo
	            }),
	            warn: assign({}, props, {
	              value: prevWarn
	            }),
	            error: assign({}, props, {
	              value: prevError
	            }),
	            group: assign({}, props, {
	              value: prevGroup
	            }),
	            groupCollapsed: assign({}, props, {
	              value: prevGroupCollapsed
	            }),
	            groupEnd: assign({}, props, {
	              value: prevGroupEnd
	            })
	          });
	          /* eslint-enable react-internal/no-production-logging */
	        }
	        if (disabledDepth < 0) {
	          error('disabledDepth fell below zero. ' + 'This is a bug in React. Please file an issue.');
	        }
	      }
	    }
	    var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
	    var prefix;
	    function describeBuiltInComponentFrame(name, source, ownerFn) {
	      {
	        if (prefix === undefined) {
	          // Extract the VM specific prefix used by each line.
	          try {
	            throw Error();
	          } catch (x) {
	            var match = x.stack.trim().match(/\n( *(at )?)/);
	            prefix = match && match[1] || '';
	          }
	        } // We use the prefix to ensure our stacks line up with native stack frames.

	        return '\n' + prefix + name;
	      }
	    }
	    var reentry = false;
	    var componentFrameCache;
	    {
	      var PossiblyWeakMap = typeof WeakMap === 'function' ? WeakMap : Map;
	      componentFrameCache = new PossiblyWeakMap();
	    }
	    function describeNativeComponentFrame(fn, construct) {
	      // If something asked for a stack inside a fake render, it should get ignored.
	      if (!fn || reentry) {
	        return '';
	      }
	      {
	        var frame = componentFrameCache.get(fn);
	        if (frame !== undefined) {
	          return frame;
	        }
	      }
	      var control;
	      reentry = true;
	      var previousPrepareStackTrace = Error.prepareStackTrace; // $FlowFixMe It does accept undefined.

	      Error.prepareStackTrace = undefined;
	      var previousDispatcher;
	      {
	        previousDispatcher = ReactCurrentDispatcher.current; // Set the dispatcher in DEV because this might be call in the render function
	        // for warnings.

	        ReactCurrentDispatcher.current = null;
	        disableLogs();
	      }
	      try {
	        // This should throw.
	        if (construct) {
	          // Something should be setting the props in the constructor.
	          var Fake = function () {
	            throw Error();
	          }; // $FlowFixMe

	          Object.defineProperty(Fake.prototype, 'props', {
	            set: function () {
	              // We use a throwing setter instead of frozen or non-writable props
	              // because that won't throw in a non-strict mode function.
	              throw Error();
	            }
	          });
	          if (typeof Reflect === 'object' && Reflect.construct) {
	            // We construct a different control for this case to include any extra
	            // frames added by the construct call.
	            try {
	              Reflect.construct(Fake, []);
	            } catch (x) {
	              control = x;
	            }
	            Reflect.construct(fn, [], Fake);
	          } else {
	            try {
	              Fake.call();
	            } catch (x) {
	              control = x;
	            }
	            fn.call(Fake.prototype);
	          }
	        } else {
	          try {
	            throw Error();
	          } catch (x) {
	            control = x;
	          }
	          fn();
	        }
	      } catch (sample) {
	        // This is inlined manually because closure doesn't do it for us.
	        if (sample && control && typeof sample.stack === 'string') {
	          // This extracts the first frame from the sample that isn't also in the control.
	          // Skipping one frame that we assume is the frame that calls the two.
	          var sampleLines = sample.stack.split('\n');
	          var controlLines = control.stack.split('\n');
	          var s = sampleLines.length - 1;
	          var c = controlLines.length - 1;
	          while (s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c]) {
	            // We expect at least one stack frame to be shared.
	            // Typically this will be the root most one. However, stack frames may be
	            // cut off due to maximum stack limits. In this case, one maybe cut off
	            // earlier than the other. We assume that the sample is longer or the same
	            // and there for cut off earlier. So we should find the root most frame in
	            // the sample somewhere in the control.
	            c--;
	          }
	          for (; s >= 1 && c >= 0; s--, c--) {
	            // Next we find the first one that isn't the same which should be the
	            // frame that called our sample function and the control.
	            if (sampleLines[s] !== controlLines[c]) {
	              // In V8, the first line is describing the message but other VMs don't.
	              // If we're about to return the first line, and the control is also on the same
	              // line, that's a pretty good indicator that our sample threw at same line as
	              // the control. I.e. before we entered the sample frame. So we ignore this result.
	              // This can happen if you passed a class to function component, or non-function.
	              if (s !== 1 || c !== 1) {
	                do {
	                  s--;
	                  c--; // We may still have similar intermediate frames from the construct call.
	                  // The next one that isn't the same should be our match though.

	                  if (c < 0 || sampleLines[s] !== controlLines[c]) {
	                    // V8 adds a "new" prefix for native classes. Let's remove it to make it prettier.
	                    var _frame = '\n' + sampleLines[s].replace(' at new ', ' at '); // If our component frame is labeled "<anonymous>"
	                    // but we have a user-provided "displayName"
	                    // splice it in to make the stack more readable.

	                    if (fn.displayName && _frame.includes('<anonymous>')) {
	                      _frame = _frame.replace('<anonymous>', fn.displayName);
	                    }
	                    {
	                      if (typeof fn === 'function') {
	                        componentFrameCache.set(fn, _frame);
	                      }
	                    } // Return the line we found.

	                    return _frame;
	                  }
	                } while (s >= 1 && c >= 0);
	              }
	              break;
	            }
	          }
	        }
	      } finally {
	        reentry = false;
	        {
	          ReactCurrentDispatcher.current = previousDispatcher;
	          reenableLogs();
	        }
	        Error.prepareStackTrace = previousPrepareStackTrace;
	      } // Fallback to just using the name if we couldn't make it throw.

	      var name = fn ? fn.displayName || fn.name : '';
	      var syntheticFrame = name ? describeBuiltInComponentFrame(name) : '';
	      {
	        if (typeof fn === 'function') {
	          componentFrameCache.set(fn, syntheticFrame);
	        }
	      }
	      return syntheticFrame;
	    }
	    function describeClassComponentFrame(ctor, source, ownerFn) {
	      {
	        return describeNativeComponentFrame(ctor, true);
	      }
	    }
	    function describeFunctionComponentFrame(fn, source, ownerFn) {
	      {
	        return describeNativeComponentFrame(fn, false);
	      }
	    }
	    function shouldConstruct(Component) {
	      var prototype = Component.prototype;
	      return !!(prototype && prototype.isReactComponent);
	    }
	    function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {
	      if (type == null) {
	        return '';
	      }
	      if (typeof type === 'function') {
	        {
	          return describeNativeComponentFrame(type, shouldConstruct(type));
	        }
	      }
	      if (typeof type === 'string') {
	        return describeBuiltInComponentFrame(type);
	      }
	      switch (type) {
	        case REACT_SUSPENSE_TYPE:
	          return describeBuiltInComponentFrame('Suspense');
	        case REACT_SUSPENSE_LIST_TYPE:
	          return describeBuiltInComponentFrame('SuspenseList');
	      }
	      if (typeof type === 'object') {
	        switch (type.$$typeof) {
	          case REACT_FORWARD_REF_TYPE:
	            return describeFunctionComponentFrame(type.render);
	          case REACT_MEMO_TYPE:
	            // Memo may contain any component type so we recursively resolve it.
	            return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);
	          case REACT_LAZY_TYPE:
	            {
	              var lazyComponent = type;
	              var payload = lazyComponent._payload;
	              var init = lazyComponent._init;
	              try {
	                // Lazy may contain any component type so we recursively resolve it.
	                return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
	              } catch (x) {}
	            }
	        }
	      }
	      return '';
	    }
	    var loggedTypeFailures = {};
	    var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
	    function setCurrentlyValidatingElement(element) {
	      {
	        if (element) {
	          var owner = element._owner;
	          var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
	          ReactDebugCurrentFrame.setExtraStackFrame(stack);
	        } else {
	          ReactDebugCurrentFrame.setExtraStackFrame(null);
	        }
	      }
	    }
	    function checkPropTypes(typeSpecs, values, location, componentName, element) {
	      {
	        // $FlowFixMe This is okay but Flow doesn't know it.
	        var has = Function.call.bind(hasOwnProperty);
	        for (var typeSpecName in typeSpecs) {
	          if (has(typeSpecs, typeSpecName)) {
	            var error$1 = void 0; // Prop type validation may throw. In case they do, we don't want to
	            // fail the render phase where it didn't fail before. So we log it.
	            // After these have been cleaned up, we'll let them throw.

	            try {
	              // This is intentionally an invariant that gets caught. It's the same
	              // behavior as without this statement except with a better message.
	              if (typeof typeSpecs[typeSpecName] !== 'function') {
	                // eslint-disable-next-line react-internal/prod-error-codes
	                var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
	                err.name = 'Invariant Violation';
	                throw err;
	              }
	              error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED');
	            } catch (ex) {
	              error$1 = ex;
	            }
	            if (error$1 && !(error$1 instanceof Error)) {
	              setCurrentlyValidatingElement(element);
	              error('%s: type specification of %s' + ' `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error$1);
	              setCurrentlyValidatingElement(null);
	            }
	            if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
	              // Only monitor this failure once because there tends to be a lot of the
	              // same error.
	              loggedTypeFailures[error$1.message] = true;
	              setCurrentlyValidatingElement(element);
	              error('Failed %s type: %s', location, error$1.message);
	              setCurrentlyValidatingElement(null);
	            }
	          }
	        }
	      }
	    }
	    var warnedAboutMissingGetChildContext;
	    {
	      warnedAboutMissingGetChildContext = {};
	    }
	    var emptyContextObject = {};
	    {
	      Object.freeze(emptyContextObject);
	    }
	    function getMaskedContext(type, unmaskedContext) {
	      {
	        var contextTypes = type.contextTypes;
	        if (!contextTypes) {
	          return emptyContextObject;
	        }
	        var context = {};
	        for (var key in contextTypes) {
	          context[key] = unmaskedContext[key];
	        }
	        {
	          var name = getComponentNameFromType(type) || 'Unknown';
	          checkPropTypes(contextTypes, context, 'context', name);
	        }
	        return context;
	      }
	    }
	    function processChildContext(instance, type, parentContext, childContextTypes) {
	      {
	        // TODO (bvaughn) Replace this behavior with an invariant() in the future.
	        // It has only been added in Fiber to match the (unintentional) behavior in Stack.
	        if (typeof instance.getChildContext !== 'function') {
	          {
	            var componentName = getComponentNameFromType(type) || 'Unknown';
	            if (!warnedAboutMissingGetChildContext[componentName]) {
	              warnedAboutMissingGetChildContext[componentName] = true;
	              error('%s.childContextTypes is specified but there is no getChildContext() method ' + 'on the instance. You can either define getChildContext() on %s or remove ' + 'childContextTypes from it.', componentName, componentName);
	            }
	          }
	          return parentContext;
	        }
	        var childContext = instance.getChildContext();
	        for (var contextKey in childContext) {
	          if (!(contextKey in childContextTypes)) {
	            throw new Error((getComponentNameFromType(type) || 'Unknown') + ".getChildContext(): key \"" + contextKey + "\" is not defined in childContextTypes.");
	          }
	        }
	        {
	          var name = getComponentNameFromType(type) || 'Unknown';
	          checkPropTypes(childContextTypes, childContext, 'child context', name);
	        }
	        return assign({}, parentContext, childContext);
	      }
	    }
	    var rendererSigil;
	    {
	      // Use this to detect multiple renderers using the same context
	      rendererSigil = {};
	    } // Used to store the parent path of all context overrides in a shared linked list.
	    // Forming a reverse tree.

	    var rootContextSnapshot = null; // We assume that this runtime owns the "current" field on all ReactContext instances.
	    // This global (actually thread local) state represents what state all those "current",
	    // fields are currently in.

	    var currentActiveSnapshot = null;
	    function popNode(prev) {
	      {
	        prev.context._currentValue = prev.parentValue;
	      }
	    }
	    function pushNode(next) {
	      {
	        next.context._currentValue = next.value;
	      }
	    }
	    function popToNearestCommonAncestor(prev, next) {
	      if (prev === next) ;else {
	        popNode(prev);
	        var parentPrev = prev.parent;
	        var parentNext = next.parent;
	        if (parentPrev === null) {
	          if (parentNext !== null) {
	            throw new Error('The stacks must reach the root at the same time. This is a bug in React.');
	          }
	        } else {
	          if (parentNext === null) {
	            throw new Error('The stacks must reach the root at the same time. This is a bug in React.');
	          }
	          popToNearestCommonAncestor(parentPrev, parentNext);
	        } // On the way back, we push the new ones that weren't common.

	        pushNode(next);
	      }
	    }
	    function popAllPrevious(prev) {
	      popNode(prev);
	      var parentPrev = prev.parent;
	      if (parentPrev !== null) {
	        popAllPrevious(parentPrev);
	      }
	    }
	    function pushAllNext(next) {
	      var parentNext = next.parent;
	      if (parentNext !== null) {
	        pushAllNext(parentNext);
	      }
	      pushNode(next);
	    }
	    function popPreviousToCommonLevel(prev, next) {
	      popNode(prev);
	      var parentPrev = prev.parent;
	      if (parentPrev === null) {
	        throw new Error('The depth must equal at least at zero before reaching the root. This is a bug in React.');
	      }
	      if (parentPrev.depth === next.depth) {
	        // We found the same level. Now we just need to find a shared ancestor.
	        popToNearestCommonAncestor(parentPrev, next);
	      } else {
	        // We must still be deeper.
	        popPreviousToCommonLevel(parentPrev, next);
	      }
	    }
	    function popNextToCommonLevel(prev, next) {
	      var parentNext = next.parent;
	      if (parentNext === null) {
	        throw new Error('The depth must equal at least at zero before reaching the root. This is a bug in React.');
	      }
	      if (prev.depth === parentNext.depth) {
	        // We found the same level. Now we just need to find a shared ancestor.
	        popToNearestCommonAncestor(prev, parentNext);
	      } else {
	        // We must still be deeper.
	        popNextToCommonLevel(prev, parentNext);
	      }
	      pushNode(next);
	    } // Perform context switching to the new snapshot.
	    // To make it cheap to read many contexts, while not suspending, we make the switch eagerly by
	    // updating all the context's current values. That way reads, always just read the current value.
	    // At the cost of updating contexts even if they're never read by this subtree.

	    function switchContext(newSnapshot) {
	      // The basic algorithm we need to do is to pop back any contexts that are no longer on the stack.
	      // We also need to update any new contexts that are now on the stack with the deepest value.
	      // The easiest way to update new contexts is to just reapply them in reverse order from the
	      // perspective of the backpointers. To avoid allocating a lot when switching, we use the stack
	      // for that. Therefore this algorithm is recursive.
	      // 1) First we pop which ever snapshot tree was deepest. Popping old contexts as we go.
	      // 2) Then we find the nearest common ancestor from there. Popping old contexts as we go.
	      // 3) Then we reapply new contexts on the way back up the stack.
	      var prev = currentActiveSnapshot;
	      var next = newSnapshot;
	      if (prev !== next) {
	        if (prev === null) {
	          // $FlowFixMe: This has to be non-null since it's not equal to prev.
	          pushAllNext(next);
	        } else if (next === null) {
	          popAllPrevious(prev);
	        } else if (prev.depth === next.depth) {
	          popToNearestCommonAncestor(prev, next);
	        } else if (prev.depth > next.depth) {
	          popPreviousToCommonLevel(prev, next);
	        } else {
	          popNextToCommonLevel(prev, next);
	        }
	        currentActiveSnapshot = next;
	      }
	    }
	    function pushProvider(context, nextValue) {
	      var prevValue;
	      {
	        prevValue = context._currentValue;
	        context._currentValue = nextValue;
	        {
	          if (context._currentRenderer !== undefined && context._currentRenderer !== null && context._currentRenderer !== rendererSigil) {
	            error('Detected multiple renderers concurrently rendering the ' + 'same context provider. This is currently unsupported.');
	          }
	          context._currentRenderer = rendererSigil;
	        }
	      }
	      var prevNode = currentActiveSnapshot;
	      var newNode = {
	        parent: prevNode,
	        depth: prevNode === null ? 0 : prevNode.depth + 1,
	        context: context,
	        parentValue: prevValue,
	        value: nextValue
	      };
	      currentActiveSnapshot = newNode;
	      return newNode;
	    }
	    function popProvider(context) {
	      var prevSnapshot = currentActiveSnapshot;
	      if (prevSnapshot === null) {
	        throw new Error('Tried to pop a Context at the root of the app. This is a bug in React.');
	      }
	      {
	        if (prevSnapshot.context !== context) {
	          error('The parent context is not the expected context. This is probably a bug in React.');
	        }
	      }
	      {
	        var value = prevSnapshot.parentValue;
	        if (value === REACT_SERVER_CONTEXT_DEFAULT_VALUE_NOT_LOADED) {
	          prevSnapshot.context._currentValue = prevSnapshot.context._defaultValue;
	        } else {
	          prevSnapshot.context._currentValue = value;
	        }
	        {
	          if (context._currentRenderer !== undefined && context._currentRenderer !== null && context._currentRenderer !== rendererSigil) {
	            error('Detected multiple renderers concurrently rendering the ' + 'same context provider. This is currently unsupported.');
	          }
	          context._currentRenderer = rendererSigil;
	        }
	      }
	      return currentActiveSnapshot = prevSnapshot.parent;
	    }
	    function getActiveContext() {
	      return currentActiveSnapshot;
	    }
	    function readContext(context) {
	      var value = context._currentValue;
	      return value;
	    }

	    /**
	     * `ReactInstanceMap` maintains a mapping from a public facing stateful
	     * instance (key) and the internal representation (value). This allows public
	     * methods to accept the user facing instance as an argument and map them back
	     * to internal methods.
	     *
	     * Note that this module is currently shared and assumed to be stateless.
	     * If this becomes an actual Map, that will break.
	     */
	    function get(key) {
	      return key._reactInternals;
	    }
	    function set(key, value) {
	      key._reactInternals = value;
	    }
	    var didWarnAboutNoopUpdateForComponent = {};
	    var didWarnAboutDeprecatedWillMount = {};
	    var didWarnAboutUninitializedState;
	    var didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate;
	    var didWarnAboutLegacyLifecyclesAndDerivedState;
	    var didWarnAboutUndefinedDerivedState;
	    var warnOnUndefinedDerivedState;
	    var warnOnInvalidCallback;
	    var didWarnAboutDirectlyAssigningPropsToState;
	    var didWarnAboutContextTypeAndContextTypes;
	    var didWarnAboutInvalidateContextType;
	    {
	      didWarnAboutUninitializedState = new Set();
	      didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate = new Set();
	      didWarnAboutLegacyLifecyclesAndDerivedState = new Set();
	      didWarnAboutDirectlyAssigningPropsToState = new Set();
	      didWarnAboutUndefinedDerivedState = new Set();
	      didWarnAboutContextTypeAndContextTypes = new Set();
	      didWarnAboutInvalidateContextType = new Set();
	      var didWarnOnInvalidCallback = new Set();
	      warnOnInvalidCallback = function (callback, callerName) {
	        if (callback === null || typeof callback === 'function') {
	          return;
	        }
	        var key = callerName + '_' + callback;
	        if (!didWarnOnInvalidCallback.has(key)) {
	          didWarnOnInvalidCallback.add(key);
	          error('%s(...): Expected the last optional `callback` argument to be a ' + 'function. Instead received: %s.', callerName, callback);
	        }
	      };
	      warnOnUndefinedDerivedState = function (type, partialState) {
	        if (partialState === undefined) {
	          var componentName = getComponentNameFromType(type) || 'Component';
	          if (!didWarnAboutUndefinedDerivedState.has(componentName)) {
	            didWarnAboutUndefinedDerivedState.add(componentName);
	            error('%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. ' + 'You have returned undefined.', componentName);
	          }
	        }
	      };
	    }
	    function warnNoop(publicInstance, callerName) {
	      {
	        var _constructor = publicInstance.constructor;
	        var componentName = _constructor && getComponentNameFromType(_constructor) || 'ReactClass';
	        var warningKey = componentName + '.' + callerName;
	        if (didWarnAboutNoopUpdateForComponent[warningKey]) {
	          return;
	        }
	        error('%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op.\n\nPlease check the code for the %s component.', callerName, callerName, componentName);
	        didWarnAboutNoopUpdateForComponent[warningKey] = true;
	      }
	    }
	    var classComponentUpdater = {
	      isMounted: function (inst) {
	        return false;
	      },
	      enqueueSetState: function (inst, payload, callback) {
	        var internals = get(inst);
	        if (internals.queue === null) {
	          warnNoop(inst, 'setState');
	        } else {
	          internals.queue.push(payload);
	          {
	            if (callback !== undefined && callback !== null) {
	              warnOnInvalidCallback(callback, 'setState');
	            }
	          }
	        }
	      },
	      enqueueReplaceState: function (inst, payload, callback) {
	        var internals = get(inst);
	        internals.replace = true;
	        internals.queue = [payload];
	        {
	          if (callback !== undefined && callback !== null) {
	            warnOnInvalidCallback(callback, 'setState');
	          }
	        }
	      },
	      enqueueForceUpdate: function (inst, callback) {
	        var internals = get(inst);
	        if (internals.queue === null) {
	          warnNoop(inst, 'forceUpdate');
	        } else {
	          {
	            if (callback !== undefined && callback !== null) {
	              warnOnInvalidCallback(callback, 'setState');
	            }
	          }
	        }
	      }
	    };
	    function applyDerivedStateFromProps(instance, ctor, getDerivedStateFromProps, prevState, nextProps) {
	      var partialState = getDerivedStateFromProps(nextProps, prevState);
	      {
	        warnOnUndefinedDerivedState(ctor, partialState);
	      } // Merge the partial state and the previous state.

	      var newState = partialState === null || partialState === undefined ? prevState : assign({}, prevState, partialState);
	      return newState;
	    }
	    function constructClassInstance(ctor, props, maskedLegacyContext) {
	      var context = emptyContextObject;
	      var contextType = ctor.contextType;
	      {
	        if ('contextType' in ctor) {
	          var isValid =
	          // Allow null for conditional declaration
	          contextType === null || contextType !== undefined && contextType.$$typeof === REACT_CONTEXT_TYPE && contextType._context === undefined; // Not a <Context.Consumer>

	          if (!isValid && !didWarnAboutInvalidateContextType.has(ctor)) {
	            didWarnAboutInvalidateContextType.add(ctor);
	            var addendum = '';
	            if (contextType === undefined) {
	              addendum = ' However, it is set to undefined. ' + 'This can be caused by a typo or by mixing up named and default imports. ' + 'This can also happen due to a circular dependency, so ' + 'try moving the createContext() call to a separate file.';
	            } else if (typeof contextType !== 'object') {
	              addendum = ' However, it is set to a ' + typeof contextType + '.';
	            } else if (contextType.$$typeof === REACT_PROVIDER_TYPE) {
	              addendum = ' Did you accidentally pass the Context.Provider instead?';
	            } else if (contextType._context !== undefined) {
	              // <Context.Consumer>
	              addendum = ' Did you accidentally pass the Context.Consumer instead?';
	            } else {
	              addendum = ' However, it is set to an object with keys {' + Object.keys(contextType).join(', ') + '}.';
	            }
	            error('%s defines an invalid contextType. ' + 'contextType should point to the Context object returned by React.createContext().%s', getComponentNameFromType(ctor) || 'Component', addendum);
	          }
	        }
	      }
	      if (typeof contextType === 'object' && contextType !== null) {
	        context = readContext(contextType);
	      } else {
	        context = maskedLegacyContext;
	      }
	      var instance = new ctor(props, context);
	      {
	        if (typeof ctor.getDerivedStateFromProps === 'function' && (instance.state === null || instance.state === undefined)) {
	          var componentName = getComponentNameFromType(ctor) || 'Component';
	          if (!didWarnAboutUninitializedState.has(componentName)) {
	            didWarnAboutUninitializedState.add(componentName);
	            error('`%s` uses `getDerivedStateFromProps` but its initial state is ' + '%s. This is not recommended. Instead, define the initial state by ' + 'assigning an object to `this.state` in the constructor of `%s`. ' + 'This ensures that `getDerivedStateFromProps` arguments have a consistent shape.', componentName, instance.state === null ? 'null' : 'undefined', componentName);
	          }
	        } // If new component APIs are defined, "unsafe" lifecycles won't be called.
	        // Warn about these lifecycles if they are present.
	        // Don't warn about react-lifecycles-compat polyfilled methods though.

	        if (typeof ctor.getDerivedStateFromProps === 'function' || typeof instance.getSnapshotBeforeUpdate === 'function') {
	          var foundWillMountName = null;
	          var foundWillReceivePropsName = null;
	          var foundWillUpdateName = null;
	          if (typeof instance.componentWillMount === 'function' && instance.componentWillMount.__suppressDeprecationWarning !== true) {
	            foundWillMountName = 'componentWillMount';
	          } else if (typeof instance.UNSAFE_componentWillMount === 'function') {
	            foundWillMountName = 'UNSAFE_componentWillMount';
	          }
	          if (typeof instance.componentWillReceiveProps === 'function' && instance.componentWillReceiveProps.__suppressDeprecationWarning !== true) {
	            foundWillReceivePropsName = 'componentWillReceiveProps';
	          } else if (typeof instance.UNSAFE_componentWillReceiveProps === 'function') {
	            foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
	          }
	          if (typeof instance.componentWillUpdate === 'function' && instance.componentWillUpdate.__suppressDeprecationWarning !== true) {
	            foundWillUpdateName = 'componentWillUpdate';
	          } else if (typeof instance.UNSAFE_componentWillUpdate === 'function') {
	            foundWillUpdateName = 'UNSAFE_componentWillUpdate';
	          }
	          if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
	            var _componentName = getComponentNameFromType(ctor) || 'Component';
	            var newApiName = typeof ctor.getDerivedStateFromProps === 'function' ? 'getDerivedStateFromProps()' : 'getSnapshotBeforeUpdate()';
	            if (!didWarnAboutLegacyLifecyclesAndDerivedState.has(_componentName)) {
	              didWarnAboutLegacyLifecyclesAndDerivedState.add(_componentName);
	              error('Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' + '%s uses %s but also contains the following legacy lifecycles:%s%s%s\n\n' + 'The above lifecycles should be removed. Learn more about this warning here:\n' + 'https://reactjs.org/link/unsafe-component-lifecycles', _componentName, newApiName, foundWillMountName !== null ? "\n  " + foundWillMountName : '', foundWillReceivePropsName !== null ? "\n  " + foundWillReceivePropsName : '', foundWillUpdateName !== null ? "\n  " + foundWillUpdateName : '');
	            }
	          }
	        }
	      }
	      return instance;
	    }
	    function checkClassInstance(instance, ctor, newProps) {
	      {
	        var name = getComponentNameFromType(ctor) || 'Component';
	        var renderPresent = instance.render;
	        if (!renderPresent) {
	          if (ctor.prototype && typeof ctor.prototype.render === 'function') {
	            error('%s(...): No `render` method found on the returned component ' + 'instance: did you accidentally return an object from the constructor?', name);
	          } else {
	            error('%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', name);
	          }
	        }
	        if (instance.getInitialState && !instance.getInitialState.isReactClassApproved && !instance.state) {
	          error('getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', name);
	        }
	        if (instance.getDefaultProps && !instance.getDefaultProps.isReactClassApproved) {
	          error('getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', name);
	        }
	        if (instance.propTypes) {
	          error('propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', name);
	        }
	        if (instance.contextType) {
	          error('contextType was defined as an instance property on %s. Use a static ' + 'property to define contextType instead.', name);
	        }
	        {
	          if (instance.contextTypes) {
	            error('contextTypes was defined as an instance property on %s. Use a static ' + 'property to define contextTypes instead.', name);
	          }
	          if (ctor.contextType && ctor.contextTypes && !didWarnAboutContextTypeAndContextTypes.has(ctor)) {
	            didWarnAboutContextTypeAndContextTypes.add(ctor);
	            error('%s declares both contextTypes and contextType static properties. ' + 'The legacy contextTypes property will be ignored.', name);
	          }
	        }
	        if (typeof instance.componentShouldUpdate === 'function') {
	          error('%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', name);
	        }
	        if (ctor.prototype && ctor.prototype.isPureReactComponent && typeof instance.shouldComponentUpdate !== 'undefined') {
	          error('%s has a method called shouldComponentUpdate(). ' + 'shouldComponentUpdate should not be used when extending React.PureComponent. ' + 'Please extend React.Component if shouldComponentUpdate is used.', getComponentNameFromType(ctor) || 'A pure component');
	        }
	        if (typeof instance.componentDidUnmount === 'function') {
	          error('%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', name);
	        }
	        if (typeof instance.componentDidReceiveProps === 'function') {
	          error('%s has a method called ' + 'componentDidReceiveProps(). But there is no such lifecycle method. ' + 'If you meant to update the state in response to changing props, ' + 'use componentWillReceiveProps(). If you meant to fetch data or ' + 'run side-effects or mutations after React has updated the UI, use componentDidUpdate().', name);
	        }
	        if (typeof instance.componentWillRecieveProps === 'function') {
	          error('%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', name);
	        }
	        if (typeof instance.UNSAFE_componentWillRecieveProps === 'function') {
	          error('%s has a method called ' + 'UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?', name);
	        }
	        var hasMutatedProps = instance.props !== newProps;
	        if (instance.props !== undefined && hasMutatedProps) {
	          error('%s(...): When calling super() in `%s`, make sure to pass ' + "up the same props that your component's constructor was passed.", name, name);
	        }
	        if (instance.defaultProps) {
	          error('Setting defaultProps as an instance property on %s is not supported and will be ignored.' + ' Instead, define defaultProps as a static property on %s.', name, name);
	        }
	        if (typeof instance.getSnapshotBeforeUpdate === 'function' && typeof instance.componentDidUpdate !== 'function' && !didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate.has(ctor)) {
	          didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate.add(ctor);
	          error('%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). ' + 'This component defines getSnapshotBeforeUpdate() only.', getComponentNameFromType(ctor));
	        }
	        if (typeof instance.getDerivedStateFromProps === 'function') {
	          error('%s: getDerivedStateFromProps() is defined as an instance method ' + 'and will be ignored. Instead, declare it as a static method.', name);
	        }
	        if (typeof instance.getDerivedStateFromError === 'function') {
	          error('%s: getDerivedStateFromError() is defined as an instance method ' + 'and will be ignored. Instead, declare it as a static method.', name);
	        }
	        if (typeof ctor.getSnapshotBeforeUpdate === 'function') {
	          error('%s: getSnapshotBeforeUpdate() is defined as a static method ' + 'and will be ignored. Instead, declare it as an instance method.', name);
	        }
	        var _state = instance.state;
	        if (_state && (typeof _state !== 'object' || isArray(_state))) {
	          error('%s.state: must be set to an object or null', name);
	        }
	        if (typeof instance.getChildContext === 'function' && typeof ctor.childContextTypes !== 'object') {
	          error('%s.getChildContext(): childContextTypes must be defined in order to ' + 'use getChildContext().', name);
	        }
	      }
	    }
	    function callComponentWillMount(type, instance) {
	      var oldState = instance.state;
	      if (typeof instance.componentWillMount === 'function') {
	        {
	          if (instance.componentWillMount.__suppressDeprecationWarning !== true) {
	            var componentName = getComponentNameFromType(type) || 'Unknown';
	            if (!didWarnAboutDeprecatedWillMount[componentName]) {
	              warn(
	              // keep this warning in sync with ReactStrictModeWarning.js
	              'componentWillMount has been renamed, and is not recommended for use. ' + 'See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n' + '* Move code from componentWillMount to componentDidMount (preferred in most cases) ' + 'or the constructor.\n' + '\nPlease update the following components: %s', componentName);
	              didWarnAboutDeprecatedWillMount[componentName] = true;
	            }
	          }
	        }
	        instance.componentWillMount();
	      }
	      if (typeof instance.UNSAFE_componentWillMount === 'function') {
	        instance.UNSAFE_componentWillMount();
	      }
	      if (oldState !== instance.state) {
	        {
	          error('%s.componentWillMount(): Assigning directly to this.state is ' + "deprecated (except inside a component's " + 'constructor). Use setState instead.', getComponentNameFromType(type) || 'Component');
	        }
	        classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
	      }
	    }
	    function processUpdateQueue(internalInstance, inst, props, maskedLegacyContext) {
	      if (internalInstance.queue !== null && internalInstance.queue.length > 0) {
	        var oldQueue = internalInstance.queue;
	        var oldReplace = internalInstance.replace;
	        internalInstance.queue = null;
	        internalInstance.replace = false;
	        if (oldReplace && oldQueue.length === 1) {
	          inst.state = oldQueue[0];
	        } else {
	          var nextState = oldReplace ? oldQueue[0] : inst.state;
	          var dontMutate = true;
	          for (var i = oldReplace ? 1 : 0; i < oldQueue.length; i++) {
	            var partial = oldQueue[i];
	            var partialState = typeof partial === 'function' ? partial.call(inst, nextState, props, maskedLegacyContext) : partial;
	            if (partialState != null) {
	              if (dontMutate) {
	                dontMutate = false;
	                nextState = assign({}, nextState, partialState);
	              } else {
	                assign(nextState, partialState);
	              }
	            }
	          }
	          inst.state = nextState;
	        }
	      } else {
	        internalInstance.queue = null;
	      }
	    } // Invokes the mount life-cycles on a previously never rendered instance.

	    function mountClassInstance(instance, ctor, newProps, maskedLegacyContext) {
	      {
	        checkClassInstance(instance, ctor, newProps);
	      }
	      var initialState = instance.state !== undefined ? instance.state : null;
	      instance.updater = classComponentUpdater;
	      instance.props = newProps;
	      instance.state = initialState; // We don't bother initializing the refs object on the server, since we're not going to resolve them anyway.
	      // The internal instance will be used to manage updates that happen during this mount.

	      var internalInstance = {
	        queue: [],
	        replace: false
	      };
	      set(instance, internalInstance);
	      var contextType = ctor.contextType;
	      if (typeof contextType === 'object' && contextType !== null) {
	        instance.context = readContext(contextType);
	      } else {
	        instance.context = maskedLegacyContext;
	      }
	      {
	        if (instance.state === newProps) {
	          var componentName = getComponentNameFromType(ctor) || 'Component';
	          if (!didWarnAboutDirectlyAssigningPropsToState.has(componentName)) {
	            didWarnAboutDirectlyAssigningPropsToState.add(componentName);
	            error('%s: It is not recommended to assign props directly to state ' + "because updates to props won't be reflected in state. " + 'In most cases, it is better to use props directly.', componentName);
	          }
	        }
	      }
	      var getDerivedStateFromProps = ctor.getDerivedStateFromProps;
	      if (typeof getDerivedStateFromProps === 'function') {
	        instance.state = applyDerivedStateFromProps(instance, ctor, getDerivedStateFromProps, initialState, newProps);
	      } // In order to support react-lifecycles-compat polyfilled components,
	      // Unsafe lifecycles should not be invoked for components using the new APIs.

	      if (typeof ctor.getDerivedStateFromProps !== 'function' && typeof instance.getSnapshotBeforeUpdate !== 'function' && (typeof instance.UNSAFE_componentWillMount === 'function' || typeof instance.componentWillMount === 'function')) {
	        callComponentWillMount(ctor, instance); // If we had additional state updates during this life-cycle, let's
	        // process them now.

	        processUpdateQueue(internalInstance, instance, newProps, maskedLegacyContext);
	      }
	    }

	    // Ids are base 32 strings whose binary representation corresponds to the
	    // position of a node in a tree.
	    // Every time the tree forks into multiple children, we add additional bits to
	    // the left of the sequence that represent the position of the child within the
	    // current level of children.
	    //
	    //      00101       00010001011010101
	    //      ╰─┬─╯       ╰───────┬───────╯
	    //   Fork 5 of 20       Parent id
	    //
	    // The leading 0s are important. In the above example, you only need 3 bits to
	    // represent slot 5. However, you need 5 bits to represent all the forks at
	    // the current level, so we must account for the empty bits at the end.
	    //
	    // For this same reason, slots are 1-indexed instead of 0-indexed. Otherwise,
	    // the zeroth id at a level would be indistinguishable from its parent.
	    //
	    // If a node has only one child, and does not materialize an id (i.e. does not
	    // contain a useId hook), then we don't need to allocate any space in the
	    // sequence. It's treated as a transparent indirection. For example, these two
	    // trees produce the same ids:
	    //
	    // <>                          <>
	    //   <Indirection>               <A />
	    //     <A />                     <B />
	    //   </Indirection>            </>
	    //   <B />
	    // </>
	    //
	    // However, we cannot skip any node that materializes an id. Otherwise, a parent
	    // id that does not fork would be indistinguishable from its child id. For
	    // example, this tree does not fork, but the parent and child must have
	    // different ids.
	    //
	    // <Parent>
	    //   <Child />
	    // </Parent>
	    //
	    // To handle this scenario, every time we materialize an id, we allocate a
	    // new level with a single slot. You can think of this as a fork with only one
	    // prong, or an array of children with length 1.
	    //
	    // It's possible for the size of the sequence to exceed 32 bits, the max
	    // size for bitwise operations. When this happens, we make more room by
	    // converting the right part of the id to a string and storing it in an overflow
	    // variable. We use a base 32 string representation, because 32 is the largest
	    // power of 2 that is supported by toString(). We want the base to be large so
	    // that the resulting ids are compact, and we want the base to be a power of 2
	    // because every log2(base) bits corresponds to a single character, i.e. every
	    // log2(32) = 5 bits. That means we can lop bits off the end 5 at a time without
	    // affecting the final result.
	    var emptyTreeContext = {
	      id: 1,
	      overflow: ''
	    };
	    function getTreeId(context) {
	      var overflow = context.overflow;
	      var idWithLeadingBit = context.id;
	      var id = idWithLeadingBit & ~getLeadingBit(idWithLeadingBit);
	      return id.toString(32) + overflow;
	    }
	    function pushTreeContext(baseContext, totalChildren, index) {
	      var baseIdWithLeadingBit = baseContext.id;
	      var baseOverflow = baseContext.overflow; // The leftmost 1 marks the end of the sequence, non-inclusive. It's not part
	      // of the id; we use it to account for leading 0s.

	      var baseLength = getBitLength(baseIdWithLeadingBit) - 1;
	      var baseId = baseIdWithLeadingBit & ~(1 << baseLength);
	      var slot = index + 1;
	      var length = getBitLength(totalChildren) + baseLength; // 30 is the max length we can store without overflowing, taking into
	      // consideration the leading 1 we use to mark the end of the sequence.

	      if (length > 30) {
	        // We overflowed the bitwise-safe range. Fall back to slower algorithm.
	        // This branch assumes the length of the base id is greater than 5; it won't
	        // work for smaller ids, because you need 5 bits per character.
	        //
	        // We encode the id in multiple steps: first the base id, then the
	        // remaining digits.
	        //
	        // Each 5 bit sequence corresponds to a single base 32 character. So for
	        // example, if the current id is 23 bits long, we can convert 20 of those
	        // bits into a string of 4 characters, with 3 bits left over.
	        //
	        // First calculate how many bits in the base id represent a complete
	        // sequence of characters.
	        var numberOfOverflowBits = baseLength - baseLength % 5; // Then create a bitmask that selects only those bits.

	        var newOverflowBits = (1 << numberOfOverflowBits) - 1; // Select the bits, and convert them to a base 32 string.

	        var newOverflow = (baseId & newOverflowBits).toString(32); // Now we can remove those bits from the base id.

	        var restOfBaseId = baseId >> numberOfOverflowBits;
	        var restOfBaseLength = baseLength - numberOfOverflowBits; // Finally, encode the rest of the bits using the normal algorithm. Because
	        // we made more room, this time it won't overflow.

	        var restOfLength = getBitLength(totalChildren) + restOfBaseLength;
	        var restOfNewBits = slot << restOfBaseLength;
	        var id = restOfNewBits | restOfBaseId;
	        var overflow = newOverflow + baseOverflow;
	        return {
	          id: 1 << restOfLength | id,
	          overflow: overflow
	        };
	      } else {
	        // Normal path
	        var newBits = slot << baseLength;
	        var _id = newBits | baseId;
	        var _overflow = baseOverflow;
	        return {
	          id: 1 << length | _id,
	          overflow: _overflow
	        };
	      }
	    }
	    function getBitLength(number) {
	      return 32 - clz32(number);
	    }
	    function getLeadingBit(id) {
	      return 1 << getBitLength(id) - 1;
	    } // TODO: Math.clz32 is supported in Node 12+. Maybe we can drop the fallback.

	    var clz32 = Math.clz32 ? Math.clz32 : clz32Fallback; // Count leading zeros.
	    // Based on:
	    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/clz32

	    var log = Math.log;
	    var LN2 = Math.LN2;
	    function clz32Fallback(x) {
	      var asUint = x >>> 0;
	      if (asUint === 0) {
	        return 32;
	      }
	      return 31 - (log(asUint) / LN2 | 0) | 0;
	    }

	    /**
	     * inlined Object.is polyfill to avoid requiring consumers ship their own
	     * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	     */
	    function is(x, y) {
	      return x === y && (x !== 0 || 1 / x === 1 / y) || x !== x && y !== y // eslint-disable-line no-self-compare
	      ;
	    }
	    var objectIs = typeof Object.is === 'function' ? Object.is : is;
	    var currentlyRenderingComponent = null;
	    var currentlyRenderingTask = null;
	    var firstWorkInProgressHook = null;
	    var workInProgressHook = null; // Whether the work-in-progress hook is a re-rendered hook

	    var isReRender = false; // Whether an update was scheduled during the currently executing render pass.

	    var didScheduleRenderPhaseUpdate = false; // Counts the number of useId hooks in this component

	    var localIdCounter = 0; // Lazily created map of render-phase updates

	    var renderPhaseUpdates = null; // Counter to prevent infinite loops.

	    var numberOfReRenders = 0;
	    var RE_RENDER_LIMIT = 25;
	    var isInHookUserCodeInDev = false; // In DEV, this is the name of the currently executing primitive hook

	    var currentHookNameInDev;
	    function resolveCurrentlyRenderingComponent() {
	      if (currentlyRenderingComponent === null) {
	        throw new Error('Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for' + ' one of the following reasons:\n' + '1. You might have mismatching versions of React and the renderer (such as React DOM)\n' + '2. You might be breaking the Rules of Hooks\n' + '3. You might have more than one copy of React in the same app\n' + 'See https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.');
	      }
	      {
	        if (isInHookUserCodeInDev) {
	          error('Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. ' + 'You can only call Hooks at the top level of your React function. ' + 'For more information, see ' + 'https://reactjs.org/link/rules-of-hooks');
	        }
	      }
	      return currentlyRenderingComponent;
	    }
	    function areHookInputsEqual(nextDeps, prevDeps) {
	      if (prevDeps === null) {
	        {
	          error('%s received a final argument during this render, but not during ' + 'the previous render. Even though the final argument is optional, ' + 'its type cannot change between renders.', currentHookNameInDev);
	        }
	        return false;
	      }
	      {
	        // Don't bother comparing lengths in prod because these arrays should be
	        // passed inline.
	        if (nextDeps.length !== prevDeps.length) {
	          error('The final argument passed to %s changed size between renders. The ' + 'order and size of this array must remain constant.\n\n' + 'Previous: %s\n' + 'Incoming: %s', currentHookNameInDev, "[" + nextDeps.join(', ') + "]", "[" + prevDeps.join(', ') + "]");
	        }
	      }
	      for (var i = 0; i < prevDeps.length && i < nextDeps.length; i++) {
	        if (objectIs(nextDeps[i], prevDeps[i])) {
	          continue;
	        }
	        return false;
	      }
	      return true;
	    }
	    function createHook() {
	      if (numberOfReRenders > 0) {
	        throw new Error('Rendered more hooks than during the previous render');
	      }
	      return {
	        memoizedState: null,
	        queue: null,
	        next: null
	      };
	    }
	    function createWorkInProgressHook() {
	      if (workInProgressHook === null) {
	        // This is the first hook in the list
	        if (firstWorkInProgressHook === null) {
	          isReRender = false;
	          firstWorkInProgressHook = workInProgressHook = createHook();
	        } else {
	          // There's already a work-in-progress. Reuse it.
	          isReRender = true;
	          workInProgressHook = firstWorkInProgressHook;
	        }
	      } else {
	        if (workInProgressHook.next === null) {
	          isReRender = false; // Append to the end of the list

	          workInProgressHook = workInProgressHook.next = createHook();
	        } else {
	          // There's already a work-in-progress. Reuse it.
	          isReRender = true;
	          workInProgressHook = workInProgressHook.next;
	        }
	      }
	      return workInProgressHook;
	    }
	    function prepareToUseHooks(task, componentIdentity) {
	      currentlyRenderingComponent = componentIdentity;
	      currentlyRenderingTask = task;
	      {
	        isInHookUserCodeInDev = false;
	      } // The following should have already been reset
	      // didScheduleRenderPhaseUpdate = false;
	      // localIdCounter = 0;
	      // firstWorkInProgressHook = null;
	      // numberOfReRenders = 0;
	      // renderPhaseUpdates = null;
	      // workInProgressHook = null;

	      localIdCounter = 0;
	    }
	    function finishHooks(Component, props, children, refOrContext) {
	      // This must be called after every function component to prevent hooks from
	      // being used in classes.
	      while (didScheduleRenderPhaseUpdate) {
	        // Updates were scheduled during the render phase. They are stored in
	        // the `renderPhaseUpdates` map. Call the component again, reusing the
	        // work-in-progress hooks and applying the additional updates on top. Keep
	        // restarting until no more updates are scheduled.
	        didScheduleRenderPhaseUpdate = false;
	        localIdCounter = 0;
	        numberOfReRenders += 1; // Start over from the beginning of the list

	        workInProgressHook = null;
	        children = Component(props, refOrContext);
	      }
	      resetHooksState();
	      return children;
	    }
	    function checkDidRenderIdHook() {
	      // This should be called immediately after every finishHooks call.
	      // Conceptually, it's part of the return value of finishHooks; it's only a
	      // separate function to avoid using an array tuple.
	      var didRenderIdHook = localIdCounter !== 0;
	      return didRenderIdHook;
	    } // Reset the internal hooks state if an error occurs while rendering a component

	    function resetHooksState() {
	      {
	        isInHookUserCodeInDev = false;
	      }
	      currentlyRenderingComponent = null;
	      currentlyRenderingTask = null;
	      didScheduleRenderPhaseUpdate = false;
	      firstWorkInProgressHook = null;
	      numberOfReRenders = 0;
	      renderPhaseUpdates = null;
	      workInProgressHook = null;
	    }
	    function readContext$1(context) {
	      {
	        if (isInHookUserCodeInDev) {
	          error('Context can only be read while React is rendering. ' + 'In classes, you can read it in the render method or getDerivedStateFromProps. ' + 'In function components, you can read it directly in the function body, but not ' + 'inside Hooks like useReducer() or useMemo().');
	        }
	      }
	      return readContext(context);
	    }
	    function useContext(context) {
	      {
	        currentHookNameInDev = 'useContext';
	      }
	      resolveCurrentlyRenderingComponent();
	      return readContext(context);
	    }
	    function basicStateReducer(state, action) {
	      // $FlowFixMe: Flow doesn't like mixed types
	      return typeof action === 'function' ? action(state) : action;
	    }
	    function useState(initialState) {
	      {
	        currentHookNameInDev = 'useState';
	      }
	      return useReducer(basicStateReducer,
	      // useReducer has a special case to support lazy useState initializers
	      initialState);
	    }
	    function useReducer(reducer, initialArg, init) {
	      {
	        if (reducer !== basicStateReducer) {
	          currentHookNameInDev = 'useReducer';
	        }
	      }
	      currentlyRenderingComponent = resolveCurrentlyRenderingComponent();
	      workInProgressHook = createWorkInProgressHook();
	      if (isReRender) {
	        // This is a re-render. Apply the new render phase updates to the previous
	        // current hook.
	        var queue = workInProgressHook.queue;
	        var dispatch = queue.dispatch;
	        if (renderPhaseUpdates !== null) {
	          // Render phase updates are stored in a map of queue -> linked list
	          var firstRenderPhaseUpdate = renderPhaseUpdates.get(queue);
	          if (firstRenderPhaseUpdate !== undefined) {
	            renderPhaseUpdates.delete(queue);
	            var newState = workInProgressHook.memoizedState;
	            var update = firstRenderPhaseUpdate;
	            do {
	              // Process this render phase update. We don't have to check the
	              // priority because it will always be the same as the current
	              // render's.
	              var action = update.action;
	              {
	                isInHookUserCodeInDev = true;
	              }
	              newState = reducer(newState, action);
	              {
	                isInHookUserCodeInDev = false;
	              }
	              update = update.next;
	            } while (update !== null);
	            workInProgressHook.memoizedState = newState;
	            return [newState, dispatch];
	          }
	        }
	        return [workInProgressHook.memoizedState, dispatch];
	      } else {
	        {
	          isInHookUserCodeInDev = true;
	        }
	        var initialState;
	        if (reducer === basicStateReducer) {
	          // Special case for `useState`.
	          initialState = typeof initialArg === 'function' ? initialArg() : initialArg;
	        } else {
	          initialState = init !== undefined ? init(initialArg) : initialArg;
	        }
	        {
	          isInHookUserCodeInDev = false;
	        }
	        workInProgressHook.memoizedState = initialState;
	        var _queue = workInProgressHook.queue = {
	          last: null,
	          dispatch: null
	        };
	        var _dispatch = _queue.dispatch = dispatchAction.bind(null, currentlyRenderingComponent, _queue);
	        return [workInProgressHook.memoizedState, _dispatch];
	      }
	    }
	    function useMemo(nextCreate, deps) {
	      currentlyRenderingComponent = resolveCurrentlyRenderingComponent();
	      workInProgressHook = createWorkInProgressHook();
	      var nextDeps = deps === undefined ? null : deps;
	      if (workInProgressHook !== null) {
	        var prevState = workInProgressHook.memoizedState;
	        if (prevState !== null) {
	          if (nextDeps !== null) {
	            var prevDeps = prevState[1];
	            if (areHookInputsEqual(nextDeps, prevDeps)) {
	              return prevState[0];
	            }
	          }
	        }
	      }
	      {
	        isInHookUserCodeInDev = true;
	      }
	      var nextValue = nextCreate();
	      {
	        isInHookUserCodeInDev = false;
	      }
	      workInProgressHook.memoizedState = [nextValue, nextDeps];
	      return nextValue;
	    }
	    function useRef(initialValue) {
	      currentlyRenderingComponent = resolveCurrentlyRenderingComponent();
	      workInProgressHook = createWorkInProgressHook();
	      var previousRef = workInProgressHook.memoizedState;
	      if (previousRef === null) {
	        var ref = {
	          current: initialValue
	        };
	        {
	          Object.seal(ref);
	        }
	        workInProgressHook.memoizedState = ref;
	        return ref;
	      } else {
	        return previousRef;
	      }
	    }
	    function useLayoutEffect(create, inputs) {
	      {
	        currentHookNameInDev = 'useLayoutEffect';
	        error('useLayoutEffect does nothing on the server, because its effect cannot ' + "be encoded into the server renderer's output format. This will lead " + 'to a mismatch between the initial, non-hydrated UI and the intended ' + 'UI. To avoid this, useLayoutEffect should only be used in ' + 'components that render exclusively on the client. ' + 'See https://reactjs.org/link/uselayouteffect-ssr for common fixes.');
	      }
	    }
	    function dispatchAction(componentIdentity, queue, action) {
	      if (numberOfReRenders >= RE_RENDER_LIMIT) {
	        throw new Error('Too many re-renders. React limits the number of renders to prevent ' + 'an infinite loop.');
	      }
	      if (componentIdentity === currentlyRenderingComponent) {
	        // This is a render phase update. Stash it in a lazily-created map of
	        // queue -> linked list of updates. After this render pass, we'll restart
	        // and apply the stashed updates on top of the work-in-progress hook.
	        didScheduleRenderPhaseUpdate = true;
	        var update = {
	          action: action,
	          next: null
	        };
	        if (renderPhaseUpdates === null) {
	          renderPhaseUpdates = new Map();
	        }
	        var firstRenderPhaseUpdate = renderPhaseUpdates.get(queue);
	        if (firstRenderPhaseUpdate === undefined) {
	          renderPhaseUpdates.set(queue, update);
	        } else {
	          // Append the update to the end of the list.
	          var lastRenderPhaseUpdate = firstRenderPhaseUpdate;
	          while (lastRenderPhaseUpdate.next !== null) {
	            lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
	          }
	          lastRenderPhaseUpdate.next = update;
	        }
	      }
	    }
	    function useCallback(callback, deps) {
	      return useMemo(function () {
	        return callback;
	      }, deps);
	    } // TODO Decide on how to implement this hook for server rendering.
	    // If a mutation occurs during render, consider triggering a Suspense boundary
	    // and falling back to client rendering.

	    function useMutableSource(source, getSnapshot, subscribe) {
	      resolveCurrentlyRenderingComponent();
	      return getSnapshot(source._source);
	    }
	    function useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
	      if (getServerSnapshot === undefined) {
	        throw new Error('Missing getServerSnapshot, which is required for ' + 'server-rendered content. Will revert to client rendering.');
	      }
	      return getServerSnapshot();
	    }
	    function useDeferredValue(value) {
	      resolveCurrentlyRenderingComponent();
	      return value;
	    }
	    function unsupportedStartTransition() {
	      throw new Error('startTransition cannot be called during server rendering.');
	    }
	    function useTransition() {
	      resolveCurrentlyRenderingComponent();
	      return [false, unsupportedStartTransition];
	    }
	    function useId() {
	      var task = currentlyRenderingTask;
	      var treeId = getTreeId(task.treeContext);
	      var responseState = currentResponseState;
	      if (responseState === null) {
	        throw new Error('Invalid hook call. Hooks can only be called inside of the body of a function component.');
	      }
	      var localId = localIdCounter++;
	      return makeId(responseState, treeId, localId);
	    }
	    function noop() {}
	    var Dispatcher = {
	      readContext: readContext$1,
	      useContext: useContext,
	      useMemo: useMemo,
	      useReducer: useReducer,
	      useRef: useRef,
	      useState: useState,
	      useInsertionEffect: noop,
	      useLayoutEffect: useLayoutEffect,
	      useCallback: useCallback,
	      // useImperativeHandle is not run in the server environment
	      useImperativeHandle: noop,
	      // Effects are not run in the server environment.
	      useEffect: noop,
	      // Debugging effect
	      useDebugValue: noop,
	      useDeferredValue: useDeferredValue,
	      useTransition: useTransition,
	      useId: useId,
	      // Subscriptions are not setup in a server environment.
	      useMutableSource: useMutableSource,
	      useSyncExternalStore: useSyncExternalStore
	    };
	    var currentResponseState = null;
	    function setCurrentResponseState(responseState) {
	      currentResponseState = responseState;
	    }
	    function getStackByComponentStackNode(componentStack) {
	      try {
	        var info = '';
	        var node = componentStack;
	        do {
	          switch (node.tag) {
	            case 0:
	              info += describeBuiltInComponentFrame(node.type, null, null);
	              break;
	            case 1:
	              info += describeFunctionComponentFrame(node.type, null, null);
	              break;
	            case 2:
	              info += describeClassComponentFrame(node.type, null, null);
	              break;
	          }
	          node = node.parent;
	        } while (node);
	        return info;
	      } catch (x) {
	        return '\nError generating stack: ' + x.message + '\n' + x.stack;
	      }
	    }
	    var ReactCurrentDispatcher$1 = ReactSharedInternals.ReactCurrentDispatcher;
	    var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;
	    var PENDING = 0;
	    var COMPLETED = 1;
	    var FLUSHED = 2;
	    var ABORTED = 3;
	    var ERRORED = 4;
	    var OPEN = 0;
	    var CLOSING = 1;
	    var CLOSED = 2;
	    // This is a default heuristic for how to split up the HTML content into progressive
	    // loading. Our goal is to be able to display additional new content about every 500ms.
	    // Faster than that is unnecessary and should be throttled on the client. It also
	    // adds unnecessary overhead to do more splits. We don't know if it's a higher or lower
	    // end device but higher end suffer less from the overhead than lower end does from
	    // not getting small enough pieces. We error on the side of low end.
	    // We base this on low end 3G speeds which is about 500kbits per second. We assume
	    // that there can be a reasonable drop off from max bandwidth which leaves you with
	    // as little as 80%. We can receive half of that each 500ms - at best. In practice,
	    // a little bandwidth is lost to processing and contention - e.g. CSS and images that
	    // are downloaded along with the main content. So we estimate about half of that to be
	    // the lower end throughput. In other words, we expect that you can at least show
	    // about 12.5kb of content per 500ms. Not counting starting latency for the first
	    // paint.
	    // 500 * 1024 / 8 * .8 * 0.5 / 2
	    var DEFAULT_PROGRESSIVE_CHUNK_SIZE = 12800;
	    function defaultErrorHandler(error) {
	      console['error'](error); // Don't transform to our wrapper

	      return null;
	    }
	    function noop$1() {}
	    function createRequest(children, responseState, rootFormatContext, progressiveChunkSize, onError, onAllReady, onShellReady, onShellError, onFatalError) {
	      var pingedTasks = [];
	      var abortSet = new Set();
	      var request = {
	        destination: null,
	        responseState: responseState,
	        progressiveChunkSize: progressiveChunkSize === undefined ? DEFAULT_PROGRESSIVE_CHUNK_SIZE : progressiveChunkSize,
	        status: OPEN,
	        fatalError: null,
	        nextSegmentId: 0,
	        allPendingTasks: 0,
	        pendingRootTasks: 0,
	        completedRootSegment: null,
	        abortableTasks: abortSet,
	        pingedTasks: pingedTasks,
	        clientRenderedBoundaries: [],
	        completedBoundaries: [],
	        partialBoundaries: [],
	        onError: onError === undefined ? defaultErrorHandler : onError,
	        onAllReady: onAllReady === undefined ? noop$1 : onAllReady,
	        onShellReady: onShellReady === undefined ? noop$1 : onShellReady,
	        onShellError: onShellError === undefined ? noop$1 : onShellError,
	        onFatalError: onFatalError === undefined ? noop$1 : onFatalError
	      }; // This segment represents the root fallback.

	      var rootSegment = createPendingSegment(request, 0, null, rootFormatContext,
	      // Root segments are never embedded in Text on either edge
	      false, false); // There is no parent so conceptually, we're unblocked to flush this segment.

	      rootSegment.parentFlushed = true;
	      var rootTask = createTask(request, children, null, rootSegment, abortSet, emptyContextObject, rootContextSnapshot, emptyTreeContext);
	      pingedTasks.push(rootTask);
	      return request;
	    }
	    function pingTask(request, task) {
	      var pingedTasks = request.pingedTasks;
	      pingedTasks.push(task);
	      if (pingedTasks.length === 1) {
	        scheduleWork(function () {
	          return performWork(request);
	        });
	      }
	    }
	    function createSuspenseBoundary(request, fallbackAbortableTasks) {
	      return {
	        id: UNINITIALIZED_SUSPENSE_BOUNDARY_ID,
	        rootSegmentID: -1,
	        parentFlushed: false,
	        pendingTasks: 0,
	        forceClientRender: false,
	        completedSegments: [],
	        byteSize: 0,
	        fallbackAbortableTasks: fallbackAbortableTasks,
	        errorDigest: null
	      };
	    }
	    function createTask(request, node, blockedBoundary, blockedSegment, abortSet, legacyContext, context, treeContext) {
	      request.allPendingTasks++;
	      if (blockedBoundary === null) {
	        request.pendingRootTasks++;
	      } else {
	        blockedBoundary.pendingTasks++;
	      }
	      var task = {
	        node: node,
	        ping: function () {
	          return pingTask(request, task);
	        },
	        blockedBoundary: blockedBoundary,
	        blockedSegment: blockedSegment,
	        abortSet: abortSet,
	        legacyContext: legacyContext,
	        context: context,
	        treeContext: treeContext
	      };
	      {
	        task.componentStack = null;
	      }
	      abortSet.add(task);
	      return task;
	    }
	    function createPendingSegment(request, index, boundary, formatContext, lastPushedText, textEmbedded) {
	      return {
	        status: PENDING,
	        id: -1,
	        // lazily assigned later
	        index: index,
	        parentFlushed: false,
	        chunks: [],
	        children: [],
	        formatContext: formatContext,
	        boundary: boundary,
	        lastPushedText: lastPushedText,
	        textEmbedded: textEmbedded
	      };
	    } // DEV-only global reference to the currently executing task

	    var currentTaskInDEV = null;
	    function getCurrentStackInDEV() {
	      {
	        if (currentTaskInDEV === null || currentTaskInDEV.componentStack === null) {
	          return '';
	        }
	        return getStackByComponentStackNode(currentTaskInDEV.componentStack);
	      }
	    }
	    function pushBuiltInComponentStackInDEV(task, type) {
	      {
	        task.componentStack = {
	          tag: 0,
	          parent: task.componentStack,
	          type: type
	        };
	      }
	    }
	    function pushFunctionComponentStackInDEV(task, type) {
	      {
	        task.componentStack = {
	          tag: 1,
	          parent: task.componentStack,
	          type: type
	        };
	      }
	    }
	    function pushClassComponentStackInDEV(task, type) {
	      {
	        task.componentStack = {
	          tag: 2,
	          parent: task.componentStack,
	          type: type
	        };
	      }
	    }
	    function popComponentStackInDEV(task) {
	      {
	        if (task.componentStack === null) {
	          error('Unexpectedly popped too many stack frames. This is a bug in React.');
	        } else {
	          task.componentStack = task.componentStack.parent;
	        }
	      }
	    } // stash the component stack of an unwinding error until it is processed

	    var lastBoundaryErrorComponentStackDev = null;
	    function captureBoundaryErrorDetailsDev(boundary, error) {
	      {
	        var errorMessage;
	        if (typeof error === 'string') {
	          errorMessage = error;
	        } else if (error && typeof error.message === 'string') {
	          errorMessage = error.message;
	        } else {
	          // eslint-disable-next-line react-internal/safe-string-coercion
	          errorMessage = String(error);
	        }
	        var errorComponentStack = lastBoundaryErrorComponentStackDev || getCurrentStackInDEV();
	        lastBoundaryErrorComponentStackDev = null;
	        boundary.errorMessage = errorMessage;
	        boundary.errorComponentStack = errorComponentStack;
	      }
	    }
	    function logRecoverableError(request, error) {
	      // If this callback errors, we intentionally let that error bubble up to become a fatal error
	      // so that someone fixes the error reporting instead of hiding it.
	      var errorDigest = request.onError(error);
	      if (errorDigest != null && typeof errorDigest !== 'string') {
	        // eslint-disable-next-line react-internal/prod-error-codes
	        throw new Error("onError returned something with a type other than \"string\". onError should return a string and may return null or undefined but must not return anything else. It received something of type \"" + typeof errorDigest + "\" instead");
	      }
	      return errorDigest;
	    }
	    function fatalError(request, error) {
	      // This is called outside error handling code such as if the root errors outside
	      // a suspense boundary or if the root suspense boundary's fallback errors.
	      // It's also called if React itself or its host configs errors.
	      var onShellError = request.onShellError;
	      onShellError(error);
	      var onFatalError = request.onFatalError;
	      onFatalError(error);
	      if (request.destination !== null) {
	        request.status = CLOSED;
	        closeWithError(request.destination, error);
	      } else {
	        request.status = CLOSING;
	        request.fatalError = error;
	      }
	    }
	    function renderSuspenseBoundary(request, task, props) {
	      pushBuiltInComponentStackInDEV(task, 'Suspense');
	      var parentBoundary = task.blockedBoundary;
	      var parentSegment = task.blockedSegment; // Each time we enter a suspense boundary, we split out into a new segment for
	      // the fallback so that we can later replace that segment with the content.
	      // This also lets us split out the main content even if it doesn't suspend,
	      // in case it ends up generating a large subtree of content.

	      var fallback = props.fallback;
	      var content = props.children;
	      var fallbackAbortSet = new Set();
	      var newBoundary = createSuspenseBoundary(request, fallbackAbortSet);
	      var insertionIndex = parentSegment.chunks.length; // The children of the boundary segment is actually the fallback.

	      var boundarySegment = createPendingSegment(request, insertionIndex, newBoundary, parentSegment.formatContext,
	      // boundaries never require text embedding at their edges because comment nodes bound them
	      false, false);
	      parentSegment.children.push(boundarySegment); // The parentSegment has a child Segment at this index so we reset the lastPushedText marker on the parent

	      parentSegment.lastPushedText = false; // This segment is the actual child content. We can start rendering that immediately.

	      var contentRootSegment = createPendingSegment(request, 0, null, parentSegment.formatContext,
	      // boundaries never require text embedding at their edges because comment nodes bound them
	      false, false); // We mark the root segment as having its parent flushed. It's not really flushed but there is
	      // no parent segment so there's nothing to wait on.

	      contentRootSegment.parentFlushed = true; // Currently this is running synchronously. We could instead schedule this to pingedTasks.
	      // I suspect that there might be some efficiency benefits from not creating the suspended task
	      // and instead just using the stack if possible.
	      // TODO: Call this directly instead of messing with saving and restoring contexts.
	      // We can reuse the current context and task to render the content immediately without
	      // context switching. We just need to temporarily switch which boundary and which segment
	      // we're writing to. If something suspends, it'll spawn new suspended task with that context.

	      task.blockedBoundary = newBoundary;
	      task.blockedSegment = contentRootSegment;
	      try {
	        // We use the safe form because we don't handle suspending here. Only error handling.
	        renderNode(request, task, content);
	        pushSegmentFinale(contentRootSegment.chunks, request.responseState, contentRootSegment.lastPushedText, contentRootSegment.textEmbedded);
	        contentRootSegment.status = COMPLETED;
	        queueCompletedSegment(newBoundary, contentRootSegment);
	        if (newBoundary.pendingTasks === 0) {
	          // This must have been the last segment we were waiting on. This boundary is now complete.
	          // Therefore we won't need the fallback. We early return so that we don't have to create
	          // the fallback.
	          popComponentStackInDEV(task);
	          return;
	        }
	      } catch (error) {
	        contentRootSegment.status = ERRORED;
	        newBoundary.forceClientRender = true;
	        newBoundary.errorDigest = logRecoverableError(request, error);
	        {
	          captureBoundaryErrorDetailsDev(newBoundary, error);
	        } // We don't need to decrement any task numbers because we didn't spawn any new task.
	        // We don't need to schedule any task because we know the parent has written yet.
	        // We do need to fallthrough to create the fallback though.
	      } finally {
	        task.blockedBoundary = parentBoundary;
	        task.blockedSegment = parentSegment;
	      } // We create suspended task for the fallback because we don't want to actually work
	      // on it yet in case we finish the main content, so we queue for later.

	      var suspendedFallbackTask = createTask(request, fallback, parentBoundary, boundarySegment, fallbackAbortSet, task.legacyContext, task.context, task.treeContext);
	      {
	        suspendedFallbackTask.componentStack = task.componentStack;
	      } // TODO: This should be queued at a separate lower priority queue so that we only work
	      // on preparing fallbacks if we don't have any more main content to task on.

	      request.pingedTasks.push(suspendedFallbackTask);
	      popComponentStackInDEV(task);
	    }
	    function renderHostElement(request, task, type, props) {
	      pushBuiltInComponentStackInDEV(task, type);
	      var segment = task.blockedSegment;
	      var children = pushStartInstance(segment.chunks, type, props, request.responseState, segment.formatContext);
	      segment.lastPushedText = false;
	      var prevContext = segment.formatContext;
	      segment.formatContext = getChildFormatContext(prevContext, type, props); // We use the non-destructive form because if something suspends, we still
	      // need to pop back up and finish this subtree of HTML.

	      renderNode(request, task, children); // We expect that errors will fatal the whole task and that we don't need
	      // the correct context. Therefore this is not in a finally.

	      segment.formatContext = prevContext;
	      pushEndInstance(segment.chunks, type);
	      segment.lastPushedText = false;
	      popComponentStackInDEV(task);
	    }
	    function shouldConstruct$1(Component) {
	      return Component.prototype && Component.prototype.isReactComponent;
	    }
	    function renderWithHooks(request, task, Component, props, secondArg) {
	      var componentIdentity = {};
	      prepareToUseHooks(task, componentIdentity);
	      var result = Component(props, secondArg);
	      return finishHooks(Component, props, result, secondArg);
	    }
	    function finishClassComponent(request, task, instance, Component, props) {
	      var nextChildren = instance.render();
	      {
	        if (instance.props !== props) {
	          if (!didWarnAboutReassigningProps) {
	            error('It looks like %s is reassigning its own `this.props` while rendering. ' + 'This is not supported and can lead to confusing bugs.', getComponentNameFromType(Component) || 'a component');
	          }
	          didWarnAboutReassigningProps = true;
	        }
	      }
	      {
	        var childContextTypes = Component.childContextTypes;
	        if (childContextTypes !== null && childContextTypes !== undefined) {
	          var previousContext = task.legacyContext;
	          var mergedContext = processChildContext(instance, Component, previousContext, childContextTypes);
	          task.legacyContext = mergedContext;
	          renderNodeDestructive(request, task, nextChildren);
	          task.legacyContext = previousContext;
	          return;
	        }
	      }
	      renderNodeDestructive(request, task, nextChildren);
	    }
	    function renderClassComponent(request, task, Component, props) {
	      pushClassComponentStackInDEV(task, Component);
	      var maskedContext = getMaskedContext(Component, task.legacyContext);
	      var instance = constructClassInstance(Component, props, maskedContext);
	      mountClassInstance(instance, Component, props, maskedContext);
	      finishClassComponent(request, task, instance, Component, props);
	      popComponentStackInDEV(task);
	    }
	    var didWarnAboutBadClass = {};
	    var didWarnAboutModulePatternComponent = {};
	    var didWarnAboutContextTypeOnFunctionComponent = {};
	    var didWarnAboutGetDerivedStateOnFunctionComponent = {};
	    var didWarnAboutReassigningProps = false;
	    var didWarnAboutDefaultPropsOnFunctionComponent = {};
	    var didWarnAboutGenerators = false;
	    var didWarnAboutMaps = false;
	    var hasWarnedAboutUsingContextAsConsumer = false; // This would typically be a function component but we still support module pattern
	    // components for some reason.

	    function renderIndeterminateComponent(request, task, Component, props) {
	      var legacyContext;
	      {
	        legacyContext = getMaskedContext(Component, task.legacyContext);
	      }
	      pushFunctionComponentStackInDEV(task, Component);
	      {
	        if (Component.prototype && typeof Component.prototype.render === 'function') {
	          var componentName = getComponentNameFromType(Component) || 'Unknown';
	          if (!didWarnAboutBadClass[componentName]) {
	            error("The <%s /> component appears to have a render method, but doesn't extend React.Component. " + 'This is likely to cause errors. Change %s to extend React.Component instead.', componentName, componentName);
	            didWarnAboutBadClass[componentName] = true;
	          }
	        }
	      }
	      var value = renderWithHooks(request, task, Component, props, legacyContext);
	      var hasId = checkDidRenderIdHook();
	      {
	        // Support for module components is deprecated and is removed behind a flag.
	        // Whether or not it would crash later, we want to show a good message in DEV first.
	        if (typeof value === 'object' && value !== null && typeof value.render === 'function' && value.$$typeof === undefined) {
	          var _componentName = getComponentNameFromType(Component) || 'Unknown';
	          if (!didWarnAboutModulePatternComponent[_componentName]) {
	            error('The <%s /> component appears to be a function component that returns a class instance. ' + 'Change %s to a class that extends React.Component instead. ' + "If you can't use a class try assigning the prototype on the function as a workaround. " + "`%s.prototype = React.Component.prototype`. Don't use an arrow function since it " + 'cannot be called with `new` by React.', _componentName, _componentName, _componentName);
	            didWarnAboutModulePatternComponent[_componentName] = true;
	          }
	        }
	      }
	      if (
	      // Run these checks in production only if the flag is off.
	      // Eventually we'll delete this branch altogether.
	      typeof value === 'object' && value !== null && typeof value.render === 'function' && value.$$typeof === undefined) {
	        {
	          var _componentName2 = getComponentNameFromType(Component) || 'Unknown';
	          if (!didWarnAboutModulePatternComponent[_componentName2]) {
	            error('The <%s /> component appears to be a function component that returns a class instance. ' + 'Change %s to a class that extends React.Component instead. ' + "If you can't use a class try assigning the prototype on the function as a workaround. " + "`%s.prototype = React.Component.prototype`. Don't use an arrow function since it " + 'cannot be called with `new` by React.', _componentName2, _componentName2, _componentName2);
	            didWarnAboutModulePatternComponent[_componentName2] = true;
	          }
	        }
	        mountClassInstance(value, Component, props, legacyContext);
	        finishClassComponent(request, task, value, Component, props);
	      } else {
	        {
	          validateFunctionComponentInDev(Component);
	        } // We're now successfully past this task, and we don't have to pop back to
	        // the previous task every again, so we can use the destructive recursive form.

	        if (hasId) {
	          // This component materialized an id. We treat this as its own level, with
	          // a single "child" slot.
	          var prevTreeContext = task.treeContext;
	          var totalChildren = 1;
	          var index = 0;
	          task.treeContext = pushTreeContext(prevTreeContext, totalChildren, index);
	          try {
	            renderNodeDestructive(request, task, value);
	          } finally {
	            task.treeContext = prevTreeContext;
	          }
	        } else {
	          renderNodeDestructive(request, task, value);
	        }
	      }
	      popComponentStackInDEV(task);
	    }
	    function validateFunctionComponentInDev(Component) {
	      {
	        if (Component) {
	          if (Component.childContextTypes) {
	            error('%s(...): childContextTypes cannot be defined on a function component.', Component.displayName || Component.name || 'Component');
	          }
	        }
	        if (Component.defaultProps !== undefined) {
	          var componentName = getComponentNameFromType(Component) || 'Unknown';
	          if (!didWarnAboutDefaultPropsOnFunctionComponent[componentName]) {
	            error('%s: Support for defaultProps will be removed from function components ' + 'in a future major release. Use JavaScript default parameters instead.', componentName);
	            didWarnAboutDefaultPropsOnFunctionComponent[componentName] = true;
	          }
	        }
	        if (typeof Component.getDerivedStateFromProps === 'function') {
	          var _componentName3 = getComponentNameFromType(Component) || 'Unknown';
	          if (!didWarnAboutGetDerivedStateOnFunctionComponent[_componentName3]) {
	            error('%s: Function components do not support getDerivedStateFromProps.', _componentName3);
	            didWarnAboutGetDerivedStateOnFunctionComponent[_componentName3] = true;
	          }
	        }
	        if (typeof Component.contextType === 'object' && Component.contextType !== null) {
	          var _componentName4 = getComponentNameFromType(Component) || 'Unknown';
	          if (!didWarnAboutContextTypeOnFunctionComponent[_componentName4]) {
	            error('%s: Function components do not support contextType.', _componentName4);
	            didWarnAboutContextTypeOnFunctionComponent[_componentName4] = true;
	          }
	        }
	      }
	    }
	    function resolveDefaultProps(Component, baseProps) {
	      if (Component && Component.defaultProps) {
	        // Resolve default props. Taken from ReactElement
	        var props = assign({}, baseProps);
	        var defaultProps = Component.defaultProps;
	        for (var propName in defaultProps) {
	          if (props[propName] === undefined) {
	            props[propName] = defaultProps[propName];
	          }
	        }
	        return props;
	      }
	      return baseProps;
	    }
	    function renderForwardRef(request, task, type, props, ref) {
	      pushFunctionComponentStackInDEV(task, type.render);
	      var children = renderWithHooks(request, task, type.render, props, ref);
	      var hasId = checkDidRenderIdHook();
	      if (hasId) {
	        // This component materialized an id. We treat this as its own level, with
	        // a single "child" slot.
	        var prevTreeContext = task.treeContext;
	        var totalChildren = 1;
	        var index = 0;
	        task.treeContext = pushTreeContext(prevTreeContext, totalChildren, index);
	        try {
	          renderNodeDestructive(request, task, children);
	        } finally {
	          task.treeContext = prevTreeContext;
	        }
	      } else {
	        renderNodeDestructive(request, task, children);
	      }
	      popComponentStackInDEV(task);
	    }
	    function renderMemo(request, task, type, props, ref) {
	      var innerType = type.type;
	      var resolvedProps = resolveDefaultProps(innerType, props);
	      renderElement(request, task, innerType, resolvedProps, ref);
	    }
	    function renderContextConsumer(request, task, context, props) {
	      // The logic below for Context differs depending on PROD or DEV mode. In
	      // DEV mode, we create a separate object for Context.Consumer that acts
	      // like a proxy to Context. This proxy object adds unnecessary code in PROD
	      // so we use the old behaviour (Context.Consumer references Context) to
	      // reduce size and overhead. The separate object references context via
	      // a property called "_context", which also gives us the ability to check
	      // in DEV mode if this property exists or not and warn if it does not.
	      {
	        if (context._context === undefined) {
	          // This may be because it's a Context (rather than a Consumer).
	          // Or it may be because it's older React where they're the same thing.
	          // We only want to warn if we're sure it's a new React.
	          if (context !== context.Consumer) {
	            if (!hasWarnedAboutUsingContextAsConsumer) {
	              hasWarnedAboutUsingContextAsConsumer = true;
	              error('Rendering <Context> directly is not supported and will be removed in ' + 'a future major release. Did you mean to render <Context.Consumer> instead?');
	            }
	          }
	        } else {
	          context = context._context;
	        }
	      }
	      var render = props.children;
	      {
	        if (typeof render !== 'function') {
	          error('A context consumer was rendered with multiple children, or a child ' + "that isn't a function. A context consumer expects a single child " + 'that is a function. If you did pass a function, make sure there ' + 'is no trailing or leading whitespace around it.');
	        }
	      }
	      var newValue = readContext(context);
	      var newChildren = render(newValue);
	      renderNodeDestructive(request, task, newChildren);
	    }
	    function renderContextProvider(request, task, type, props) {
	      var context = type._context;
	      var value = props.value;
	      var children = props.children;
	      var prevSnapshot;
	      {
	        prevSnapshot = task.context;
	      }
	      task.context = pushProvider(context, value);
	      renderNodeDestructive(request, task, children);
	      task.context = popProvider(context);
	      {
	        if (prevSnapshot !== task.context) {
	          error('Popping the context provider did not return back to the original snapshot. This is a bug in React.');
	        }
	      }
	    }
	    function renderLazyComponent(request, task, lazyComponent, props, ref) {
	      pushBuiltInComponentStackInDEV(task, 'Lazy');
	      var payload = lazyComponent._payload;
	      var init = lazyComponent._init;
	      var Component = init(payload);
	      var resolvedProps = resolveDefaultProps(Component, props);
	      renderElement(request, task, Component, resolvedProps, ref);
	      popComponentStackInDEV(task);
	    }
	    function renderElement(request, task, type, props, ref) {
	      if (typeof type === 'function') {
	        if (shouldConstruct$1(type)) {
	          renderClassComponent(request, task, type, props);
	          return;
	        } else {
	          renderIndeterminateComponent(request, task, type, props);
	          return;
	        }
	      }
	      if (typeof type === 'string') {
	        renderHostElement(request, task, type, props);
	        return;
	      }
	      switch (type) {
	        // TODO: LegacyHidden acts the same as a fragment. This only works
	        // because we currently assume that every instance of LegacyHidden is
	        // accompanied by a host component wrapper. In the hidden mode, the host
	        // component is given a `hidden` attribute, which ensures that the
	        // initial HTML is not visible. To support the use of LegacyHidden as a
	        // true fragment, without an extra DOM node, we would have to hide the
	        // initial HTML in some other way.
	        // TODO: Add REACT_OFFSCREEN_TYPE here too with the same capability.
	        case REACT_LEGACY_HIDDEN_TYPE:
	        case REACT_DEBUG_TRACING_MODE_TYPE:
	        case REACT_STRICT_MODE_TYPE:
	        case REACT_PROFILER_TYPE:
	        case REACT_FRAGMENT_TYPE:
	          {
	            renderNodeDestructive(request, task, props.children);
	            return;
	          }
	        case REACT_SUSPENSE_LIST_TYPE:
	          {
	            pushBuiltInComponentStackInDEV(task, 'SuspenseList'); // TODO: SuspenseList should control the boundaries.

	            renderNodeDestructive(request, task, props.children);
	            popComponentStackInDEV(task);
	            return;
	          }
	        case REACT_SCOPE_TYPE:
	          {
	            throw new Error('ReactDOMServer does not yet support scope components.');
	          }
	        // eslint-disable-next-line-no-fallthrough

	        case REACT_SUSPENSE_TYPE:
	          {
	            {
	              renderSuspenseBoundary(request, task, props);
	            }
	            return;
	          }
	      }
	      if (typeof type === 'object' && type !== null) {
	        switch (type.$$typeof) {
	          case REACT_FORWARD_REF_TYPE:
	            {
	              renderForwardRef(request, task, type, props, ref);
	              return;
	            }
	          case REACT_MEMO_TYPE:
	            {
	              renderMemo(request, task, type, props, ref);
	              return;
	            }
	          case REACT_PROVIDER_TYPE:
	            {
	              renderContextProvider(request, task, type, props);
	              return;
	            }
	          case REACT_CONTEXT_TYPE:
	            {
	              renderContextConsumer(request, task, type, props);
	              return;
	            }
	          case REACT_LAZY_TYPE:
	            {
	              renderLazyComponent(request, task, type, props);
	              return;
	            }
	        }
	      }
	      var info = '';
	      {
	        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
	          info += ' You likely forgot to export your component from the file ' + "it's defined in, or you might have mixed up default and " + 'named imports.';
	        }
	      }
	      throw new Error('Element type is invalid: expected a string (for built-in ' + 'components) or a class/function (for composite components) ' + ("but got: " + (type == null ? type : typeof type) + "." + info));
	    }
	    function validateIterable(iterable, iteratorFn) {
	      {
	        // We don't support rendering Generators because it's a mutation.
	        // See https://github.com/facebook/react/issues/12995
	        if (typeof Symbol === 'function' &&
	        // $FlowFixMe Flow doesn't know about toStringTag
	        iterable[Symbol.toStringTag] === 'Generator') {
	          if (!didWarnAboutGenerators) {
	            error('Using Generators as children is unsupported and will likely yield ' + 'unexpected results because enumerating a generator mutates it. ' + 'You may convert it to an array with `Array.from()` or the ' + '`[...spread]` operator before rendering. Keep in mind ' + 'you might need to polyfill these features for older browsers.');
	          }
	          didWarnAboutGenerators = true;
	        } // Warn about using Maps as children

	        if (iterable.entries === iteratorFn) {
	          if (!didWarnAboutMaps) {
	            error('Using Maps as children is not supported. ' + 'Use an array of keyed ReactElements instead.');
	          }
	          didWarnAboutMaps = true;
	        }
	      }
	    }
	    function renderNodeDestructive(request, task, node) {
	      {
	        // In Dev we wrap renderNodeDestructiveImpl in a try / catch so we can capture
	        // a component stack at the right place in the tree. We don't do this in renderNode
	        // becuase it is not called at every layer of the tree and we may lose frames
	        try {
	          return renderNodeDestructiveImpl(request, task, node);
	        } catch (x) {
	          if (typeof x === 'object' && x !== null && typeof x.then === 'function') ;else {
	            // This is an error, stash the component stack if it is null.
	            lastBoundaryErrorComponentStackDev = lastBoundaryErrorComponentStackDev !== null ? lastBoundaryErrorComponentStackDev : getCurrentStackInDEV();
	          } // rethrow so normal suspense logic can handle thrown value accordingly

	          throw x;
	        }
	      }
	    } // This function by it self renders a node and consumes the task by mutating it
	    // to update the current execution state.

	    function renderNodeDestructiveImpl(request, task, node) {
	      // Stash the node we're working on. We'll pick up from this task in case
	      // something suspends.
	      task.node = node; // Handle object types

	      if (typeof node === 'object' && node !== null) {
	        switch (node.$$typeof) {
	          case REACT_ELEMENT_TYPE:
	            {
	              var element = node;
	              var type = element.type;
	              var props = element.props;
	              var ref = element.ref;
	              renderElement(request, task, type, props, ref);
	              return;
	            }
	          case REACT_PORTAL_TYPE:
	            throw new Error('Portals are not currently supported by the server renderer. ' + 'Render them conditionally so that they only appear on the client render.');
	          // eslint-disable-next-line-no-fallthrough

	          case REACT_LAZY_TYPE:
	            {
	              var lazyNode = node;
	              var payload = lazyNode._payload;
	              var init = lazyNode._init;
	              var resolvedNode;
	              {
	                try {
	                  resolvedNode = init(payload);
	                } catch (x) {
	                  if (typeof x === 'object' && x !== null && typeof x.then === 'function') {
	                    // this Lazy initializer is suspending. push a temporary frame onto the stack so it can be
	                    // popped off in spawnNewSuspendedTask. This aligns stack behavior between Lazy in element position
	                    // vs Component position. We do not want the frame for Errors so we exclusively do this in
	                    // the wakeable branch
	                    pushBuiltInComponentStackInDEV(task, 'Lazy');
	                  }
	                  throw x;
	                }
	              }
	              renderNodeDestructive(request, task, resolvedNode);
	              return;
	            }
	        }
	        if (isArray(node)) {
	          renderChildrenArray(request, task, node);
	          return;
	        }
	        var iteratorFn = getIteratorFn(node);
	        if (iteratorFn) {
	          {
	            validateIterable(node, iteratorFn);
	          }
	          var iterator = iteratorFn.call(node);
	          if (iterator) {
	            // We need to know how many total children are in this set, so that we
	            // can allocate enough id slots to acommodate them. So we must exhaust
	            // the iterator before we start recursively rendering the children.
	            // TODO: This is not great but I think it's inherent to the id
	            // generation algorithm.
	            var step = iterator.next(); // If there are not entries, we need to push an empty so we start by checking that.

	            if (!step.done) {
	              var children = [];
	              do {
	                children.push(step.value);
	                step = iterator.next();
	              } while (!step.done);
	              renderChildrenArray(request, task, children);
	              return;
	            }
	            return;
	          }
	        }
	        var childString = Object.prototype.toString.call(node);
	        throw new Error("Objects are not valid as a React child (found: " + (childString === '[object Object]' ? 'object with keys {' + Object.keys(node).join(', ') + '}' : childString) + "). " + 'If you meant to render a collection of children, use an array ' + 'instead.');
	      }
	      if (typeof node === 'string') {
	        var segment = task.blockedSegment;
	        segment.lastPushedText = pushTextInstance(task.blockedSegment.chunks, node, request.responseState, segment.lastPushedText);
	        return;
	      }
	      if (typeof node === 'number') {
	        var _segment = task.blockedSegment;
	        _segment.lastPushedText = pushTextInstance(task.blockedSegment.chunks, '' + node, request.responseState, _segment.lastPushedText);
	        return;
	      }
	      {
	        if (typeof node === 'function') {
	          error('Functions are not valid as a React child. This may happen if ' + 'you return a Component instead of <Component /> from render. ' + 'Or maybe you meant to call this function rather than return it.');
	        }
	      }
	    }
	    function renderChildrenArray(request, task, children) {
	      var totalChildren = children.length;
	      for (var i = 0; i < totalChildren; i++) {
	        var prevTreeContext = task.treeContext;
	        task.treeContext = pushTreeContext(prevTreeContext, totalChildren, i);
	        try {
	          // We need to use the non-destructive form so that we can safely pop back
	          // up and render the sibling if something suspends.
	          renderNode(request, task, children[i]);
	        } finally {
	          task.treeContext = prevTreeContext;
	        }
	      }
	    }
	    function spawnNewSuspendedTask(request, task, x) {
	      // Something suspended, we'll need to create a new segment and resolve it later.
	      var segment = task.blockedSegment;
	      var insertionIndex = segment.chunks.length;
	      var newSegment = createPendingSegment(request, insertionIndex, null, segment.formatContext,
	      // Adopt the parent segment's leading text embed
	      segment.lastPushedText,
	      // Assume we are text embedded at the trailing edge
	      true);
	      segment.children.push(newSegment); // Reset lastPushedText for current Segment since the new Segment "consumed" it

	      segment.lastPushedText = false;
	      var newTask = createTask(request, task.node, task.blockedBoundary, newSegment, task.abortSet, task.legacyContext, task.context, task.treeContext);
	      {
	        if (task.componentStack !== null) {
	          // We pop one task off the stack because the node that suspended will be tried again,
	          // which will add it back onto the stack.
	          newTask.componentStack = task.componentStack.parent;
	        }
	      }
	      var ping = newTask.ping;
	      x.then(ping, ping);
	    } // This is a non-destructive form of rendering a node. If it suspends it spawns
	    // a new task and restores the context of this task to what it was before.

	    function renderNode(request, task, node) {
	      // TODO: Store segment.children.length here and reset it in case something
	      // suspended partially through writing something.
	      // Snapshot the current context in case something throws to interrupt the
	      // process.
	      var previousFormatContext = task.blockedSegment.formatContext;
	      var previousLegacyContext = task.legacyContext;
	      var previousContext = task.context;
	      var previousComponentStack = null;
	      {
	        previousComponentStack = task.componentStack;
	      }
	      try {
	        return renderNodeDestructive(request, task, node);
	      } catch (x) {
	        resetHooksState();
	        if (typeof x === 'object' && x !== null && typeof x.then === 'function') {
	          spawnNewSuspendedTask(request, task, x); // Restore the context. We assume that this will be restored by the inner
	          // functions in case nothing throws so we don't use "finally" here.

	          task.blockedSegment.formatContext = previousFormatContext;
	          task.legacyContext = previousLegacyContext;
	          task.context = previousContext; // Restore all active ReactContexts to what they were before.

	          switchContext(previousContext);
	          {
	            task.componentStack = previousComponentStack;
	          }
	          return;
	        } else {
	          // Restore the context. We assume that this will be restored by the inner
	          // functions in case nothing throws so we don't use "finally" here.
	          task.blockedSegment.formatContext = previousFormatContext;
	          task.legacyContext = previousLegacyContext;
	          task.context = previousContext; // Restore all active ReactContexts to what they were before.

	          switchContext(previousContext);
	          {
	            task.componentStack = previousComponentStack;
	          } // We assume that we don't need the correct context.
	          // Let's terminate the rest of the tree and don't render any siblings.

	          throw x;
	        }
	      }
	    }
	    function erroredTask(request, boundary, segment, error) {
	      // Report the error to a global handler.
	      var errorDigest = logRecoverableError(request, error);
	      if (boundary === null) {
	        fatalError(request, error);
	      } else {
	        boundary.pendingTasks--;
	        if (!boundary.forceClientRender) {
	          boundary.forceClientRender = true;
	          boundary.errorDigest = errorDigest;
	          {
	            captureBoundaryErrorDetailsDev(boundary, error);
	          } // Regardless of what happens next, this boundary won't be displayed,
	          // so we can flush it, if the parent already flushed.

	          if (boundary.parentFlushed) {
	            // We don't have a preference where in the queue this goes since it's likely
	            // to error on the client anyway. However, intentionally client-rendered
	            // boundaries should be flushed earlier so that they can start on the client.
	            // We reuse the same queue for errors.
	            request.clientRenderedBoundaries.push(boundary);
	          }
	        }
	      }
	      request.allPendingTasks--;
	      if (request.allPendingTasks === 0) {
	        var onAllReady = request.onAllReady;
	        onAllReady();
	      }
	    }
	    function abortTaskSoft(task) {
	      // This aborts task without aborting the parent boundary that it blocks.
	      // It's used for when we didn't need this task to complete the tree.
	      // If task was needed, then it should use abortTask instead.
	      var request = this;
	      var boundary = task.blockedBoundary;
	      var segment = task.blockedSegment;
	      segment.status = ABORTED;
	      finishedTask(request, boundary, segment);
	    }
	    function abortTask(task, request, reason) {
	      // This aborts the task and aborts the parent that it blocks, putting it into
	      // client rendered mode.
	      var boundary = task.blockedBoundary;
	      var segment = task.blockedSegment;
	      segment.status = ABORTED;
	      if (boundary === null) {
	        request.allPendingTasks--; // We didn't complete the root so we have nothing to show. We can close
	        // the request;

	        if (request.status !== CLOSED) {
	          request.status = CLOSED;
	          if (request.destination !== null) {
	            close(request.destination);
	          }
	        }
	      } else {
	        boundary.pendingTasks--;
	        if (!boundary.forceClientRender) {
	          boundary.forceClientRender = true;
	          var _error = reason === undefined ? new Error('The render was aborted by the server without a reason.') : reason;
	          boundary.errorDigest = request.onError(_error);
	          {
	            var errorPrefix = 'The server did not finish this Suspense boundary: ';
	            if (_error && typeof _error.message === 'string') {
	              _error = errorPrefix + _error.message;
	            } else {
	              // eslint-disable-next-line react-internal/safe-string-coercion
	              _error = errorPrefix + String(_error);
	            }
	            var previousTaskInDev = currentTaskInDEV;
	            currentTaskInDEV = task;
	            try {
	              captureBoundaryErrorDetailsDev(boundary, _error);
	            } finally {
	              currentTaskInDEV = previousTaskInDev;
	            }
	          }
	          if (boundary.parentFlushed) {
	            request.clientRenderedBoundaries.push(boundary);
	          }
	        } // If this boundary was still pending then we haven't already cancelled its fallbacks.
	        // We'll need to abort the fallbacks, which will also error that parent boundary.

	        boundary.fallbackAbortableTasks.forEach(function (fallbackTask) {
	          return abortTask(fallbackTask, request, reason);
	        });
	        boundary.fallbackAbortableTasks.clear();
	        request.allPendingTasks--;
	        if (request.allPendingTasks === 0) {
	          var onAllReady = request.onAllReady;
	          onAllReady();
	        }
	      }
	    }
	    function queueCompletedSegment(boundary, segment) {
	      if (segment.chunks.length === 0 && segment.children.length === 1 && segment.children[0].boundary === null) {
	        // This is an empty segment. There's nothing to write, so we can instead transfer the ID
	        // to the child. That way any existing references point to the child.
	        var childSegment = segment.children[0];
	        childSegment.id = segment.id;
	        childSegment.parentFlushed = true;
	        if (childSegment.status === COMPLETED) {
	          queueCompletedSegment(boundary, childSegment);
	        }
	      } else {
	        var completedSegments = boundary.completedSegments;
	        completedSegments.push(segment);
	      }
	    }
	    function finishedTask(request, boundary, segment) {
	      if (boundary === null) {
	        if (segment.parentFlushed) {
	          if (request.completedRootSegment !== null) {
	            throw new Error('There can only be one root segment. This is a bug in React.');
	          }
	          request.completedRootSegment = segment;
	        }
	        request.pendingRootTasks--;
	        if (request.pendingRootTasks === 0) {
	          // We have completed the shell so the shell can't error anymore.
	          request.onShellError = noop$1;
	          var onShellReady = request.onShellReady;
	          onShellReady();
	        }
	      } else {
	        boundary.pendingTasks--;
	        if (boundary.forceClientRender) ;else if (boundary.pendingTasks === 0) {
	          // This must have been the last segment we were waiting on. This boundary is now complete.
	          if (segment.parentFlushed) {
	            // Our parent segment already flushed, so we need to schedule this segment to be emitted.
	            // If it is a segment that was aborted, we'll write other content instead so we don't need
	            // to emit it.
	            if (segment.status === COMPLETED) {
	              queueCompletedSegment(boundary, segment);
	            }
	          }
	          if (boundary.parentFlushed) {
	            // The segment might be part of a segment that didn't flush yet, but if the boundary's
	            // parent flushed, we need to schedule the boundary to be emitted.
	            request.completedBoundaries.push(boundary);
	          } // We can now cancel any pending task on the fallback since we won't need to show it anymore.
	          // This needs to happen after we read the parentFlushed flags because aborting can finish
	          // work which can trigger user code, which can start flushing, which can change those flags.

	          boundary.fallbackAbortableTasks.forEach(abortTaskSoft, request);
	          boundary.fallbackAbortableTasks.clear();
	        } else {
	          if (segment.parentFlushed) {
	            // Our parent already flushed, so we need to schedule this segment to be emitted.
	            // If it is a segment that was aborted, we'll write other content instead so we don't need
	            // to emit it.
	            if (segment.status === COMPLETED) {
	              queueCompletedSegment(boundary, segment);
	              var completedSegments = boundary.completedSegments;
	              if (completedSegments.length === 1) {
	                // This is the first time since we last flushed that we completed anything.
	                // We can schedule this boundary to emit its partially completed segments early
	                // in case the parent has already been flushed.
	                if (boundary.parentFlushed) {
	                  request.partialBoundaries.push(boundary);
	                }
	              }
	            }
	          }
	        }
	      }
	      request.allPendingTasks--;
	      if (request.allPendingTasks === 0) {
	        // This needs to be called at the very end so that we can synchronously write the result
	        // in the callback if needed.
	        var onAllReady = request.onAllReady;
	        onAllReady();
	      }
	    }
	    function retryTask(request, task) {
	      var segment = task.blockedSegment;
	      if (segment.status !== PENDING) {
	        // We completed this by other means before we had a chance to retry it.
	        return;
	      } // We restore the context to what it was when we suspended.
	      // We don't restore it after we leave because it's likely that we'll end up
	      // needing a very similar context soon again.

	      switchContext(task.context);
	      var prevTaskInDEV = null;
	      {
	        prevTaskInDEV = currentTaskInDEV;
	        currentTaskInDEV = task;
	      }
	      try {
	        // We call the destructive form that mutates this task. That way if something
	        // suspends again, we can reuse the same task instead of spawning a new one.
	        renderNodeDestructive(request, task, task.node);
	        pushSegmentFinale(segment.chunks, request.responseState, segment.lastPushedText, segment.textEmbedded);
	        task.abortSet.delete(task);
	        segment.status = COMPLETED;
	        finishedTask(request, task.blockedBoundary, segment);
	      } catch (x) {
	        resetHooksState();
	        if (typeof x === 'object' && x !== null && typeof x.then === 'function') {
	          // Something suspended again, let's pick it back up later.
	          var ping = task.ping;
	          x.then(ping, ping);
	        } else {
	          task.abortSet.delete(task);
	          segment.status = ERRORED;
	          erroredTask(request, task.blockedBoundary, segment, x);
	        }
	      } finally {
	        {
	          currentTaskInDEV = prevTaskInDEV;
	        }
	      }
	    }
	    function performWork(request) {
	      if (request.status === CLOSED) {
	        return;
	      }
	      var prevContext = getActiveContext();
	      var prevDispatcher = ReactCurrentDispatcher$1.current;
	      ReactCurrentDispatcher$1.current = Dispatcher;
	      var prevGetCurrentStackImpl;
	      {
	        prevGetCurrentStackImpl = ReactDebugCurrentFrame$1.getCurrentStack;
	        ReactDebugCurrentFrame$1.getCurrentStack = getCurrentStackInDEV;
	      }
	      var prevResponseState = currentResponseState;
	      setCurrentResponseState(request.responseState);
	      try {
	        var pingedTasks = request.pingedTasks;
	        var i;
	        for (i = 0; i < pingedTasks.length; i++) {
	          var task = pingedTasks[i];
	          retryTask(request, task);
	        }
	        pingedTasks.splice(0, i);
	        if (request.destination !== null) {
	          flushCompletedQueues(request, request.destination);
	        }
	      } catch (error) {
	        logRecoverableError(request, error);
	        fatalError(request, error);
	      } finally {
	        setCurrentResponseState(prevResponseState);
	        ReactCurrentDispatcher$1.current = prevDispatcher;
	        {
	          ReactDebugCurrentFrame$1.getCurrentStack = prevGetCurrentStackImpl;
	        }
	        if (prevDispatcher === Dispatcher) {
	          // This means that we were in a reentrant work loop. This could happen
	          // in a renderer that supports synchronous work like renderToString,
	          // when it's called from within another renderer.
	          // Normally we don't bother switching the contexts to their root/default
	          // values when leaving because we'll likely need the same or similar
	          // context again. However, when we're inside a synchronous loop like this
	          // we'll to restore the context to what it was before returning.
	          switchContext(prevContext);
	        }
	      }
	    }
	    function flushSubtree(request, destination, segment) {
	      segment.parentFlushed = true;
	      switch (segment.status) {
	        case PENDING:
	          {
	            // We're emitting a placeholder for this segment to be filled in later.
	            // Therefore we'll need to assign it an ID - to refer to it by.
	            var segmentID = segment.id = request.nextSegmentId++; // When this segment finally completes it won't be embedded in text since it will flush separately

	            segment.lastPushedText = false;
	            segment.textEmbedded = false;
	            return writePlaceholder(destination, request.responseState, segmentID);
	          }
	        case COMPLETED:
	          {
	            segment.status = FLUSHED;
	            var r = true;
	            var chunks = segment.chunks;
	            var chunkIdx = 0;
	            var children = segment.children;
	            for (var childIdx = 0; childIdx < children.length; childIdx++) {
	              var nextChild = children[childIdx]; // Write all the chunks up until the next child.

	              for (; chunkIdx < nextChild.index; chunkIdx++) {
	                writeChunk(destination, chunks[chunkIdx]);
	              }
	              r = flushSegment(request, destination, nextChild);
	            } // Finally just write all the remaining chunks

	            for (; chunkIdx < chunks.length - 1; chunkIdx++) {
	              writeChunk(destination, chunks[chunkIdx]);
	            }
	            if (chunkIdx < chunks.length) {
	              r = writeChunkAndReturn(destination, chunks[chunkIdx]);
	            }
	            return r;
	          }
	        default:
	          {
	            throw new Error('Aborted, errored or already flushed boundaries should not be flushed again. This is a bug in React.');
	          }
	      }
	    }
	    function flushSegment(request, destination, segment) {
	      var boundary = segment.boundary;
	      if (boundary === null) {
	        // Not a suspense boundary.
	        return flushSubtree(request, destination, segment);
	      }
	      boundary.parentFlushed = true; // This segment is a Suspense boundary. We need to decide whether to
	      // emit the content or the fallback now.

	      if (boundary.forceClientRender) {
	        // Emit a client rendered suspense boundary wrapper.
	        // We never queue the inner boundary so we'll never emit its content or partial segments.
	        writeStartClientRenderedSuspenseBoundary(destination, request.responseState, boundary.errorDigest, boundary.errorMessage, boundary.errorComponentStack); // Flush the fallback.

	        flushSubtree(request, destination, segment);
	        return writeEndClientRenderedSuspenseBoundary(destination, request.responseState);
	      } else if (boundary.pendingTasks > 0) {
	        // This boundary is still loading. Emit a pending suspense boundary wrapper.
	        // Assign an ID to refer to the future content by.
	        boundary.rootSegmentID = request.nextSegmentId++;
	        if (boundary.completedSegments.length > 0) {
	          // If this is at least partially complete, we can queue it to be partially emitted early.
	          request.partialBoundaries.push(boundary);
	        } /// This is the first time we should have referenced this ID.

	        var id = boundary.id = assignSuspenseBoundaryID(request.responseState);
	        writeStartPendingSuspenseBoundary(destination, request.responseState, id); // Flush the fallback.

	        flushSubtree(request, destination, segment);
	        return writeEndPendingSuspenseBoundary(destination, request.responseState);
	      } else if (boundary.byteSize > request.progressiveChunkSize) {
	        // This boundary is large and will be emitted separately so that we can progressively show
	        // other content. We add it to the queue during the flush because we have to ensure that
	        // the parent flushes first so that there's something to inject it into.
	        // We also have to make sure that it's emitted into the queue in a deterministic slot.
	        // I.e. we can't insert it here when it completes.
	        // Assign an ID to refer to the future content by.
	        boundary.rootSegmentID = request.nextSegmentId++;
	        request.completedBoundaries.push(boundary); // Emit a pending rendered suspense boundary wrapper.

	        writeStartPendingSuspenseBoundary(destination, request.responseState, boundary.id); // Flush the fallback.

	        flushSubtree(request, destination, segment);
	        return writeEndPendingSuspenseBoundary(destination, request.responseState);
	      } else {
	        // We can inline this boundary's content as a complete boundary.
	        writeStartCompletedSuspenseBoundary(destination, request.responseState);
	        var completedSegments = boundary.completedSegments;
	        if (completedSegments.length !== 1) {
	          throw new Error('A previously unvisited boundary must have exactly one root segment. This is a bug in React.');
	        }
	        var contentSegment = completedSegments[0];
	        flushSegment(request, destination, contentSegment);
	        return writeEndCompletedSuspenseBoundary(destination, request.responseState);
	      }
	    }
	    function flushClientRenderedBoundary(request, destination, boundary) {
	      return writeClientRenderBoundaryInstruction(destination, request.responseState, boundary.id, boundary.errorDigest, boundary.errorMessage, boundary.errorComponentStack);
	    }
	    function flushSegmentContainer(request, destination, segment) {
	      writeStartSegment(destination, request.responseState, segment.formatContext, segment.id);
	      flushSegment(request, destination, segment);
	      return writeEndSegment(destination, segment.formatContext);
	    }
	    function flushCompletedBoundary(request, destination, boundary) {
	      var completedSegments = boundary.completedSegments;
	      var i = 0;
	      for (; i < completedSegments.length; i++) {
	        var segment = completedSegments[i];
	        flushPartiallyCompletedSegment(request, destination, boundary, segment);
	      }
	      completedSegments.length = 0;
	      return writeCompletedBoundaryInstruction(destination, request.responseState, boundary.id, boundary.rootSegmentID);
	    }
	    function flushPartialBoundary(request, destination, boundary) {
	      var completedSegments = boundary.completedSegments;
	      var i = 0;
	      for (; i < completedSegments.length; i++) {
	        var segment = completedSegments[i];
	        if (!flushPartiallyCompletedSegment(request, destination, boundary, segment)) {
	          i++;
	          completedSegments.splice(0, i); // Only write as much as the buffer wants. Something higher priority
	          // might want to write later.

	          return false;
	        }
	      }
	      completedSegments.splice(0, i);
	      return true;
	    }
	    function flushPartiallyCompletedSegment(request, destination, boundary, segment) {
	      if (segment.status === FLUSHED) {
	        // We've already flushed this inline.
	        return true;
	      }
	      var segmentID = segment.id;
	      if (segmentID === -1) {
	        // This segment wasn't previously referred to. This happens at the root of
	        // a boundary. We make kind of a leap here and assume this is the root.
	        var rootSegmentID = segment.id = boundary.rootSegmentID;
	        if (rootSegmentID === -1) {
	          throw new Error('A root segment ID must have been assigned by now. This is a bug in React.');
	        }
	        return flushSegmentContainer(request, destination, segment);
	      } else {
	        flushSegmentContainer(request, destination, segment);
	        return writeCompletedSegmentInstruction(destination, request.responseState, segmentID);
	      }
	    }
	    function flushCompletedQueues(request, destination) {
	      beginWriting();
	      try {
	        // The structure of this is to go through each queue one by one and write
	        // until the sink tells us to stop. When we should stop, we still finish writing
	        // that item fully and then yield. At that point we remove the already completed
	        // items up until the point we completed them.
	        // TODO: Emit preloading.
	        // TODO: It's kind of unfortunate to keep checking this array after we've already
	        // emitted the root.
	        var completedRootSegment = request.completedRootSegment;
	        if (completedRootSegment !== null && request.pendingRootTasks === 0) {
	          flushSegment(request, destination, completedRootSegment);
	          request.completedRootSegment = null;
	          writeCompletedRoot(destination, request.responseState);
	        } // We emit client rendering instructions for already emitted boundaries first.
	        // This is so that we can signal to the client to start client rendering them as
	        // soon as possible.

	        var clientRenderedBoundaries = request.clientRenderedBoundaries;
	        var i;
	        for (i = 0; i < clientRenderedBoundaries.length; i++) {
	          var boundary = clientRenderedBoundaries[i];
	          if (!flushClientRenderedBoundary(request, destination, boundary)) ;
	        }
	        clientRenderedBoundaries.splice(0, i); // Next we emit any complete boundaries. It's better to favor boundaries
	        // that are completely done since we can actually show them, than it is to emit
	        // any individual segments from a partially complete boundary.

	        var completedBoundaries = request.completedBoundaries;
	        for (i = 0; i < completedBoundaries.length; i++) {
	          var _boundary = completedBoundaries[i];
	          if (!flushCompletedBoundary(request, destination, _boundary)) ;
	        }
	        completedBoundaries.splice(0, i); // Allow anything written so far to flush to the underlying sink before
	        // we continue with lower priorities.

	        completeWriting(destination);
	        beginWriting(destination); // TODO: Here we'll emit data used by hydration.
	        // Next we emit any segments of any boundaries that are partially complete
	        // but not deeply complete.

	        var partialBoundaries = request.partialBoundaries;
	        for (i = 0; i < partialBoundaries.length; i++) {
	          var _boundary2 = partialBoundaries[i];
	          if (!flushPartialBoundary(request, destination, _boundary2)) {
	            request.destination = null;
	            i++;
	            partialBoundaries.splice(0, i);
	            return;
	          }
	        }
	        partialBoundaries.splice(0, i); // Next we check the completed boundaries again. This may have had
	        // boundaries added to it in case they were too larged to be inlined.
	        // New ones might be added in this loop.

	        var largeBoundaries = request.completedBoundaries;
	        for (i = 0; i < largeBoundaries.length; i++) {
	          var _boundary3 = largeBoundaries[i];
	          if (!flushCompletedBoundary(request, destination, _boundary3)) ;
	        }
	        largeBoundaries.splice(0, i);
	      } finally {
	        completeWriting(destination);
	        if (request.allPendingTasks === 0 && request.pingedTasks.length === 0 && request.clientRenderedBoundaries.length === 0 && request.completedBoundaries.length === 0 // We don't need to check any partially completed segments because
	        // either they have pending task or they're complete.
	        ) {
	          {
	            if (request.abortableTasks.size !== 0) {
	              error('There was still abortable task at the root when we closed. This is a bug in React.');
	            }
	          } // We're done.

	          close(destination);
	        }
	      }
	    }
	    function startWork(request) {
	      scheduleWork(function () {
	        return performWork(request);
	      });
	    }
	    function startFlowing(request, destination) {
	      if (request.status === CLOSING) {
	        request.status = CLOSED;
	        closeWithError(destination, request.fatalError);
	        return;
	      }
	      if (request.status === CLOSED) {
	        return;
	      }
	      if (request.destination !== null) {
	        // We're already flowing.
	        return;
	      }
	      request.destination = destination;
	      try {
	        flushCompletedQueues(request, destination);
	      } catch (error) {
	        logRecoverableError(request, error);
	        fatalError(request, error);
	      }
	    } // This is called to early terminate a request. It puts all pending boundaries in client rendered state.

	    function abort(request, reason) {
	      try {
	        var abortableTasks = request.abortableTasks;
	        abortableTasks.forEach(function (task) {
	          return abortTask(task, request, reason);
	        });
	        abortableTasks.clear();
	        if (request.destination !== null) {
	          flushCompletedQueues(request, request.destination);
	        }
	      } catch (error) {
	        logRecoverableError(request, error);
	        fatalError(request, error);
	      }
	    }
	    function renderToReadableStream(children, options) {
	      return new Promise(function (resolve, reject) {
	        var onFatalError;
	        var onAllReady;
	        var allReady = new Promise(function (res, rej) {
	          onAllReady = res;
	          onFatalError = rej;
	        });
	        function onShellReady() {
	          var stream = new ReadableStream({
	            type: 'bytes',
	            pull: function (controller) {
	              startFlowing(request, controller);
	            },
	            cancel: function (reason) {
	              abort(request);
	            }
	          },
	          // $FlowFixMe size() methods are not allowed on byte streams.
	          {
	            highWaterMark: 0
	          }); // TODO: Move to sub-classing ReadableStream.

	          stream.allReady = allReady;
	          resolve(stream);
	        }
	        function onShellError(error) {
	          // If the shell errors the caller of `renderToReadableStream` won't have access to `allReady`.
	          // However, `allReady` will be rejected by `onFatalError` as well.
	          // So we need to catch the duplicate, uncatchable fatal error in `allReady` to prevent a `UnhandledPromiseRejection`.
	          allReady.catch(function () {});
	          reject(error);
	        }
	        var request = createRequest(children, createResponseState(options ? options.identifierPrefix : undefined, options ? options.nonce : undefined, options ? options.bootstrapScriptContent : undefined, options ? options.bootstrapScripts : undefined, options ? options.bootstrapModules : undefined), createRootFormatContext(options ? options.namespaceURI : undefined), options ? options.progressiveChunkSize : undefined, options ? options.onError : undefined, onAllReady, onShellReady, onShellError, onFatalError);
	        if (options && options.signal) {
	          var signal = options.signal;
	          var listener = function () {
	            abort(request, signal.reason);
	            signal.removeEventListener('abort', listener);
	          };
	          signal.addEventListener('abort', listener);
	        }
	        startWork(request);
	      });
	    }
	    reactDomServer_browser_development.renderToReadableStream = renderToReadableStream;
	    reactDomServer_browser_development.version = ReactVersion;
	  })();
	}
	return reactDomServer_browser_development;
}

var hasRequiredServer_browser;

function requireServer_browser () {
	if (hasRequiredServer_browser) return server_browser;
	hasRequiredServer_browser = 1;

	var l, s;
	if (process.env.NODE_ENV === 'production') {
	  l = requireReactDomServerLegacy_browser_production_min();
	  s = requireReactDomServer_browser_production_min();
	} else {
	  l = requireReactDomServerLegacy_browser_development();
	  s = requireReactDomServer_browser_development();
	}
	server_browser.version = l.version;
	server_browser.renderToString = l.renderToString;
	server_browser.renderToStaticMarkup = l.renderToStaticMarkup;
	server_browser.renderToNodeStream = l.renderToNodeStream;
	server_browser.renderToStaticNodeStream = l.renderToStaticNodeStream;
	server_browser.renderToReadableStream = s.renderToReadableStream;
	return server_browser;
}

var server_browserExports = requireServer_browser();
var ReactDOMServer = /*@__PURE__*/getDefaultExportFromCjs(server_browserExports);

function isVegaSpec(value) {
    return typeof value === "object" && value !== null && "$schema" in value;
}
function colorToCss(color) {
    const r = (v) => Math.round(v * 255);
    return color.a === 1
        ? `rgb(${r(color.r)} ${r(color.g)} ${r(color.b)})`
        : `rgb(${r(color.r)} ${r(color.g)} ${r(color.b)} / ${color.a})`;
}
function colorIsTransparent(color) {
    if (!color || typeof color.a !== "number")
        return true;
    return color.a === 0;
}
function renderItemToSvgElement(item, resultValue, options = {}) {
    const includeBackground = options.includeBackground ?? true;
    // Normalize the result to a drawable shape or React element
    let shapeOrElement = resultValue;
    if (isVegaSpec(resultValue)) {
        shapeOrElement = renderVegaSpec(resultValue);
    }
    const graphicsContext = new Context$1();
    let shapeElement = null;
    let defsElement = null;
    try {
        if (shapeOrElement && (shapeOrElement.type || React.isValidElement(shapeOrElement))) {
            if (React.isValidElement(shapeOrElement)) {
                shapeElement = shapeOrElement;
            }
            else {
                shapeElement = renderShape(shapeOrElement, graphicsContext, undefined, !!options.drawPoints);
            }
            const defs = renderDefs(graphicsContext);
            defsElement = defs;
        }
    }
    catch (e) {
        console.error("renderItemToSvgElement: render error", e);
        return undefined;
    }
    if (!shapeElement)
        return undefined;
    // Determine SVG size and origin
    let left = 0, top = 0, width = (item.width ?? 1000), height = (item.height ?? 1000);
    const maybeNetwork = item;
    if (typeof shapeOrElement?.getBounds === "function" && maybeNetwork.canvasSize === "auto") {
        const auto = shapeOrElement.getBounds();
        left = auto.left;
        top = auto.top;
        width = auto.right - auto.left;
        height = auto.bottom - auto.top;
    }
    const backgroundColor = item.background;
    const svg = React.createElement("svg", { width, height, xmlns: "http://www.w3.org/2000/svg" }, React.createElement("defs", {}, React.createElement("clipPath", { id: "frame" }, React.createElement("rect", { x: left, y: top, width, height }))), React.createElement("g", {
        clipPath: "url(#frame)",
        transform: `translate(${-left}, ${-top})`,
    }, includeBackground && !colorIsTransparent(backgroundColor)
        ? React.createElement("rect", {
            x: left,
            y: top,
            width,
            height,
            fill: colorToCss(backgroundColor),
        })
        : null, shapeElement, defsElement));
    return svg;
}
function renderItemToSvgString(item, resultValue, options = {}) {
    const element = renderItemToSvgElement(item, resultValue, options);
    if (!element)
        return undefined;
    return ReactDOMServer.renderToStaticMarkup(element);
}
async function svgStringToPngBlob(svgString, width, height, options = {}) {
    const scale = options.scale ?? 2;
    return new Promise((resolve, reject) => {
        try {
            const img = new Image();
            const svgBlob = new Blob([svgString], { type: "image/svg+xml" });
            const svgUrl = URL.createObjectURL(svgBlob);
            img.onload = () => {
                try {
                    const canvas = document.createElement("canvas");
                    canvas.width = Math.max(1, Math.round(width * scale));
                    canvas.height = Math.max(1, Math.round(height * scale));
                    const ctx = canvas.getContext("2d");
                    if (!ctx)
                        throw new Error("2D context not available");
                    ctx.scale(scale, scale);
                    ctx.drawImage(img, 0, 0);
                    canvas.toBlob((blob) => {
                        URL.revokeObjectURL(svgUrl);
                        if (!blob)
                            return reject(new Error("PNG blob creation failed"));
                        resolve(blob);
                    }, "image/png");
                }
                catch (err) {
                    URL.revokeObjectURL(svgUrl);
                    reject(err);
                }
            };
            img.onerror = (e) => {
                URL.revokeObjectURL(svgUrl);
                reject(new Error("Failed to load SVG into image"));
            };
            img.src = svgUrl;
        }
        catch (e) {
            reject(e);
        }
    });
}
async function renderItemToPngBlob(item, resultValue, options = {}) {
    // First, render to SVG and capture final dimensions
    const maybeNetwork = item;
    let width = (item.width ?? 1000), height = (item.height ?? 1000);
    let shapeOrElement = resultValue;
    if (isVegaSpec(resultValue)) {
        shapeOrElement = renderVegaSpec(resultValue);
    }
    if (typeof shapeOrElement?.getBounds === "function" && maybeNetwork.canvasSize === "auto") {
        const auto = shapeOrElement.getBounds();
        auto.left;
        auto.top;
        width = auto.right - auto.left;
        height = auto.bottom - auto.top;
    }
    const svg = renderItemToSvgString(item, resultValue, options);
    if (!svg)
        return undefined;
    return svgStringToPngBlob(svg, width, height, options);
}

export { ConnectionType, Context$2 as Context, NodeBoxPlayer, ParameterType, PortType, WidgetType, config, createExpressionContext, createRuntimeNodeForItem, defaultValueForType, defaultWidgetForType, dimensionForRenderShape, evaluateExpression, evaluateFunction, evaluateItem, evaluateNetwork, evaluateRuntimeNode, findInputConnection, findInputPort, findItemById, findItemByName, findNetworkItemById, findNodeById, findNodeByName, findOutletConnection, findOutputConnections, findOutputConnectionsForNode, findOutputPort, findParameter, findRenderedNodeOutputs, getNetworkOutput, getParameterValue, getValue, item_isFunctionItem, item_isNetwork, loadAsset, loadMainProject, parseChoices$1 as parseChoices, parseExpression$1 as parseExpression, renderDefs, renderItem, renderItemToPngBlob, renderItemToSvgElement, renderItemToSvgString, renderShape, renderVegaSpec, sendChangeEvent, svgStringToPngBlob };
//# sourceMappingURL=ndbx.esm.js.map
